webpackJsonp([2],{

/***/ "++4z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_orderMenu__ = __webpack_require__("KEgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__ = __webpack_require__("O0G5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Tradekeyboard_TradeKeyboard_vue__ = __webpack_require__("WhMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_components_TargetKeyboard_TargetKeyboard_vue__ = __webpack_require__("moUf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TradeSearch_TradeSearch_vue__ = __webpack_require__("I6UT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_OrderSearch_OrderSearch_vue__ = __webpack_require__("7fja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CheckFullStop_CheckFullStop__ = __webpack_require__("A/Xy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_utils__ = __webpack_require__("7C6s");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    orderMenu: __WEBPACK_IMPORTED_MODULE_3__components_common_orderMenu__["a" /* default */],
    vButton: __WEBPACK_IMPORTED_MODULE_4_mint_ui__["Button"],
    TradeKeyboard: __WEBPACK_IMPORTED_MODULE_7__components_Tradekeyboard_TradeKeyboard_vue__["a" /* default */],
    TargetKeyboard: __WEBPACK_IMPORTED_MODULE_8__views_components_TargetKeyboard_TargetKeyboard_vue__["a" /* default */],
    TradeSearch: __WEBPACK_IMPORTED_MODULE_9__components_TradeSearch_TradeSearch_vue__["a" /* default */],
    OrderSearch: __WEBPACK_IMPORTED_MODULE_10__components_OrderSearch_OrderSearch_vue__["a" /* default */],
    CheckFullStop: __WEBPACK_IMPORTED_MODULE_11__components_CheckFullStop_CheckFullStop__["a" /* default */]
  },
  data: function data() {
    return {
      name: "trade-detail",
      flage: false,
      orderButton: [{
        price: "--",
        text: "买多",
        color: "background-color: #EF544F;"
      }, {
        price: "--",
        text: "卖空",
        color: "background-color: #2BCE99;"
      }, {
        price: "",
        text: "平仓",
        color: "background-color: #808080;"
      }],
      store_name: "",
      store_type: "",
      store_money: "",
      store_num1: "",
      store_num2: "",
      data_cx: false,
      all_cx: false,
      all_pc: false,
      num: "",
      sureOrder: false,
      orderIndex: "",
      deal: ["买", "卖"],
      sele_deal: "",
      auto_flage: false,
      closing: "开仓",
      mon_req: true,
      flage2: false,
      warning: "",
      price_type: ["排队价", "对手价", "最新价", "市价", "超价"],
      // 按数值大小取小数位数
      fmtDouble: function fmtDouble(value) {
        if (value > 10000) {
          return Math.round(value);
        } else if (value > 1000) {
          return Math.round(value * 10) / 10;
        } else if (value > 100) {
          return Math.round(value * 100) / 100;
        }
        return Math.round(value * 1000) / 1000;
      },
      currentProductId: "ag",
      sumExchangeName: ["上期所", "上期能源", "大商所", "郑商所", "中金所", "广期所"],
      contractData: [],
      pageData: {
        account: { title: "账号", value: "" },
        rights: {
          title: "权益",
          value: ""
        },
        usable: {
          title: "可用",
          value: ""
        },
        profitAloss: {
          title: "盈亏",
          value: "-880.00"
        },
        desirable: {
          title: "可取",
          value: "0.00"
        }
      },
      order1: ["买", "卖"],
      order2: ["开仓", "平今", "平仓"],
      checkedTab: 0,
      menuTilte: ["合约", "多空", "手数", "可平", "开仓均价", "浮动盈亏"],
      menuValue: [],
      //menuValue: [["TA809", "买", 32, 32, 5682.25, 280],["TA809", "买", 32, 32, 5682.25, 280],],
      orderMenuValue: [], //查询-报单
      tradeMenuValue: [], //查询-成交
      isActive: "",
      buttonTitleLeft: "成交查询",
      buttonTitleRight: "报单查询",
      buttonSearch: false,
      searchCheckedState: 0,
      menuData: [{
        tobarLink: "/home/order",
        tobarIcon: "&#xe624;",
        tobarContent: "下单"
      }, {
        tobarLink: "/home/store",
        tobarIcon: "&#xe7b9;",
        tobarContent: "持仓"
      }, {
        tobarLink: "/home/cancel",
        tobarIcon: "&#xe609;",
        tobarContent: "撤单"
      }, {
        tobarLink: "/home/capital",
        tobarIcon: "&#xe60a;",
        tobarContent: "资金"
      }, {
        tobarLink: "/home/query",
        tobarIcon: "&#xe603;",
        tobarContent: "查询"
      }],
      buttonTitle: "",
      money: {},
      tbState: false,

      // 下单页面 XXXXXX
      insertPage: {
        tick: {},
        posSelect: 0,
        posSelects: 0,
        inputPrice: "",
        inputPriceHolder: "输入价格",
        price: "",
        volume: "",
        targetId: ""
      },
      // 传入键盘加号 按选中的价格类型开始加减
      boardPrice: '',
      cancelOrderValue: [],
      orderTick: {},
      temporaryTick: {},
      orderTicks: {},
      buyVol: '--',
      sellVol: '--',

      // 提示框款判断事件
      eventflage: '',
      eventItem: '',
      // 止盈止损
      checkFullStopFlage: false,
      checkFullStopData: '',
      checkFullStopTitle: '',
      checkFullStopVolume: '',
      selectTids: '',
      checkFullStopList: {
        direction: '',
        targetId: ''
      },
      /**快捷操作手数不安输入框里的手数来 */
      quickHandle: null,
      quickFlage: false
    };
  },

  methods: {
    handleTouchStart: function handleTouchStart(index, item) {
      switch (index) {
        case 0:
          item.color = "background-color: #772826; color: #aaa";
          break;
        case 1:
          item.color = "background-color: #18644b; color: #aaa";
          break;
        case 2:
          item.color = "background-color: #464545; color: #aaa";
          break;
      }
    },
    handleTouchEnd: function handleTouchEnd(index, item) {
      switch (index) {
        case 0:
          item.color = "background-color: #EF544F; color: #fff";
          break;
        case 1:
          item.color = "background-color: #2BCE99; color: #fff";
          break;
        case 2:
          item.color = "background-color: #808080; color: #fff";
          break;
      }
    },

    // 快捷反手
    quickBackhand: function quickBackhand(item) {
      if (item.closeOut == 0 || item.vol > item.closeOut) {
        this.show_hint('本持仓有冻结单, 不能进行快捷反手');
        return;
      }
      if (localStorage.flage === "true") {
        this.sureOrder = true;
        this.eventflage = 'shortcut_fs';
        this.eventItem = item;
        this.quickHandle = item.vol;
        this.quickFlage = true;
      } else {
        this.shortcutCloseOut(item);
        this.shortcutPosition(item.vol);
      }
      var pos = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array[this.insertPage.posSelect];
      this.sele_deal = item.type == '卖' ? '买' : '卖';
      this.closing = '开仓';
      if (pos.direction == __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].pos_direct_short) {
        var price = this.insertPage.tick.highStopPrice;
      } else {
        var price = this.insertPage.tick.lowStopPrice;
      }
      this.insertPage.price = price;
    },


    // 快捷锁仓提示框判断
    shortcutPositions: function shortcutPositions(item) {
      var pos = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array[this.insertPage.posSelect];
      if (localStorage.flage === "true") {
        this.sureOrder = true;
        this.eventflage = 'shortcut_sc';
        this.quickHandle = item.vol;
        this.quickFlage = true;
      } else {
        this.shortcutPosition(item.vol);
      }
      this.sele_deal = pos.direction == __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].pos_direct_short ? '买' : '卖';
      this.closing = '开仓';
      if (pos.direction == __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].pos_direct_short) {
        var price = this.insertPage.tick.highStopPrice;
      } else {
        var price = this.insertPage.tick.lowStopPrice;
      }
      this.insertPage.price = price;
    },


    // 快捷锁仓
    shortcutPosition: function shortcutPosition() {
      var vol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var pos = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array[this.insertPage.posSelect];
      if (pos.direction == __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].pos_direct_short) {
        this.orderIndex = 0;
        // this.insertPage.price = this.insertPage.tick.askPrice1;
        this.insertPage.price = this.insertPage.tick.highStopPrice;
      } else {
        this.orderIndex = 1;
        // this.insertPage.price = this.insertPage.tick.bidPrice1;
        this.insertPage.price = this.insertPage.tick.lowStopPrice;
      }
      this.purchaseOrder(vol);
    },


    // 快捷平仓提示框
    shortcutCloseOuts: function shortcutCloseOuts(item) {
      this.quickHandle = item.vol;
      this.quickFlage = true;
      if (localStorage.flage === "true") {
        this.sureOrder = true;
        this.eventflage = 'shortcut_pc';
        this.eventItem = item;
      } else {
        this.shortcutCloseOut(item);
      }
      this.sele_deal = item.type == '卖' ? '买' : '卖';
      var pos = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array[this.insertPage.posSelect];
      if (pos.direction == __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].pos_direct_short) {
        var price = this.insertPage.tick.highStopPrice;
      } else {
        var price = this.insertPage.tick.lowStopPrice;
      }
      this.insertPage.price = price;
      this.closing = '平仓';
    },

    // 快捷平仓
    shortcutCloseOut: function shortcutCloseOut(item) {
      var _this = this;

      var that = this;
      var orderSet = [];
      // if (volume === undefined) volume = that.insertPage.volume;
      var volume = item.closeOut;
      if (volume == 0) {
        this.show_hint('可平手数为0');
      } else {
        var pos = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array[that.insertPage.posSelect];
        if (pos.direction == __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].pos_direct_short) {
          var price = that.insertPage.tick.highStopPrice;
        } else {
          var price = that.insertPage.tick.lowStopPrice;
        }
        __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].getCloseOrderSet(orderSet, pos, volume, price);

        // 调用前置机委托下单。
        for (var i = 0; i < orderSet.length; ++i) {
          var order = orderSet[i];
          __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].insertOrder(order, function (rsp) {}, function (error) {
            _this.show_hint(error.message);
          });
        }
      }
      this.sureOrder = false;
    },

    // 云条件单
    condition: function condition(item) {
      this.$router.push({
        path: "/home/condition",
        query: { targetId: item.targetId,
          type: item.type,
          closeOut: item.closeOut,
          money: this.insertPage.tick.latestPrice,
          // priceTicks: this.priceTicks.priceTick,
          Num: 2
        }
      });
    },

    // 止盈止损
    checkFullStop: function checkFullStop(item, index) {
      // 网络断开时下单提示
      // if (this.linkLoad) {
      //   utils.toast(this.$store.state.language.v14k11);
      //   return;
      // }
      var pos = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array[index];
      // 获取持仓可用数量
      this.checkFullStopVolume = __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].getPositionVailable(pos);
      this.checkFullStopList.direction = pos.direction;
      this.checkFullStopList.targetId = pos.targetId;
      if (this.checkFullStopVolume == 0) {
        __WEBPACK_IMPORTED_MODULE_12__utils_utils__["f" /* toast */]('可平手数为0,不能设置止盈止损单');
        return;
      }
      this.selectTids = pos.targetId;
      // console.log(front.targetIdMap);
      // var targetArr = front.targetIdMap[a];
      // this.selectTids = targetArr['targetSet'][0]['tid'];

      this.checkFullStopFlage = true;
      this.checkFullStopData = item;
      this.checkFullStopTitle = item.targetId;
      // this.$store.commit('changeView', item.targetId.code);
    },

    // 关闭止盈止损页面
    handleHiddenPage: function handleHiddenPage(e) {
      // e.stopPropagation();
      this.checkFullStopFlage = false;
    },
    handleCloseKey: function handleCloseKey() {
      this.$refs.xxxx.blur();
      this.flage = false;
    },
    handleCloseKey2: function handleCloseKey2() {
      this.$refs.yyyy.blur();
      this.flage2 = false;
    },

    // #.更新资金信息
    onUpdateCapital: function onUpdateCapital(capital) {
      if (capital === undefined) {
        return;
      }
      // 交易顶部信息
      this.pageData.rights.value = Number(capital["balance"]).toFixed(2);
      this.pageData.usable.value = Number(capital["available"]).toFixed(2);
      this.pageData.account.value = capital["account"];
      // 资金列表
      this.$set(this.money, "权益", Number(capital["balance"]).toFixed(2));
      this.$set(this.money, "可用资金", Number(capital["available"]).toFixed(2));
      this.$set(this.money, "盈亏", (Number(capital["positionProfit"]) + Number(capital["closeProfit"])).toFixed(2));
      this.$set(this.money, "可取资金", Number(capital["withdrawQuota"]).toFixed(2));
      this.$set(this.money, "平仓盈亏", Number(capital["closeProfit"]).toFixed(2));
      this.$set(this.money, "持仓盈亏", Number(capital["positionProfit"]).toFixed(2));
      this.$set(this.money, "保证金", Number(capital["currMargin"]).toFixed(2));
      this.$set(this.money, "冻结保证金", Number(capital["frozenMargin"]).toFixed(2));
      this.$set(this.money, "手续费", Number(capital["commission"]).toFixed(2));
      this.$set(this.money, "冻结手续费", Number(capital["frozenCommission"]).toFixed(2));
      this.$set(this.money, "今日出金", Number(capital["withdraw"]).toFixed(2));
      this.$set(this.money, "今日入金", Number(capital["deposit"]).toFixed(2));
    },


    // #.加载持仓信息
    onLoadPosition: function onLoadPosition(posSet) {
      this.menuValue = [];
      if (posSet === undefined) return;
      for (var i = 0; i < posSet.length; ++i) {
        var pos = posSet[i];
        var volume = pos.todayVolume + pos.lastVolume;
        this.menuValue.push({
          targetId: pos.targetId,
          type: __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].textPositionDirection(pos.direction),
          vol: volume,
          closeOut: volume - pos.frozenVolume,
          money: this.fmtDouble(pos.cost / volume / pos.multiple),
          loss: this.fmtDouble(pos.positionProfit),
          id: pos.id
        });
      }
      if (posSet.length <= this.insertPage.posSelect) {
        this.insertPage.posSelect = posSet.length - 1;
      }
      if (this.insertPage.posSelect != -1) {
        this.orderImfor(this.insertPage.posSelect);
      }
    },


    // #.更新持仓列表
    onUpdatePosition: function onUpdatePosition(pos, index) {
      var _this2 = this;

      if (pos === undefined) {
        this.menuValue = [];
        return;
      }
      var volume = pos.todayVolume + pos.lastVolume;
      var ui = {
        targetId: pos.targetId,
        type: __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].textPositionDirection(pos.direction),
        vol: volume,
        closeOut: volume - pos.frozenVolume,
        money: this.fmtDouble(pos.cost / volume / pos.multiple),
        loss: this.fmtDouble(pos.positionProfit),
        id: pos.id
      };
      if (index == this.menuValue.length) {
        this.menuValue.push(ui);
      } else {
        this.menuValue[index] = ui;
      }
      if (this.checkFullStopList.targetId) {
        if (pos.targetId === this.checkFullStopList.targetId && pos.direction === this.checkFullStopList.direction) {
          this.checkFullStopVolume = pos.todayVolume + pos.lastVolume;
        }
        var flage = false;
        flage = this.menuValue.some(function (item) {
          if (item.targetId == _this2.checkFullStopList.targetId && item.type == __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].textPositionDirection(_this2.checkFullStopList.direction)) {
            return true;
          }
        });
        if (!flage) {
          this.checkFullStopVolume = '0';
        }
      }
    },


    // #.更新委托列表
    onUpdateOrder: function onUpdateOrder(order, index) {
      if (order === undefined) {
        this.orderMenuValue = [];
        return;
      }
      // console.log(order);
      var ui = {
        id: order.id,
        targetId: order.targetId,
        offset: __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].textDirectionOffSet(order.direction, order.offset),
        price: this.fmtDouble(order.price),
        volume: order.volume,
        unvolume: order.volume - order.tradedVolume,
        insertTime: order.insertTime,
        state: __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].textOrderState(order.state),
        orderId: order.orderId
      };
      if (this.orderMenuValue.length == index) {
        this.orderMenuValue.push(ui);
      } else {
        this.orderMenuValue[index] = ui;
      }
    },


    // #.更新撤单列表
    onUpdateCancelOrder: function onUpdateCancelOrder(order, index) {
      if (order === undefined) {
        this.cancelOrderValue = [];
        return;
      }
      var ui = [order.targetId, __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].textDirectionOffSet(order.direction, order.offset), order.price, order.volume, order.volume - order.tradedVolume];
      if (this.cancelOrderValue.length <= index) {
        this.cancelOrderValue.push(ui);
      } else {
        this.cancelOrderValue[index] = ui;
      }
    },


    // #.更新撤单列表
    onRemoveCancelOrder: function onRemoveCancelOrder(order, index) {
      this.cancelOrderValue.splice(index, 1);
    },


    // #.更新成交列表
    onUpdateTrade: function onUpdateTrade(trade, index) {
      if (trade === undefined) {
        this.tradeMenuValue = [];
        return;
      }
      var price = (trade.price * 1000).toFixed(0) / 1000;
      var ui = {
        targetId: trade.targetId,
        offset: __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].textDirectionOffSet(trade.direction, trade.offset),
        price: price,
        tradedVolume: trade.volume,
        insertTime: trade.tradeTime,
        tradeId: trade.tradeId,
        orderId: trade.orderId
      };
      //this.tradeMenuValue.unshift(ui);
      this.tradeMenuValue.push(ui);
    },


    // 清空行情价格信息
    clearTickPrice: function clearTickPrice() {
      this.insertPage.tick.latestPrice = "--";
      this.insertPage.tick.askPrice1 = "--";
      this.insertPage.tick.bidPrice1 = "--";
      this.insertPage.tick.askVolume1 = "--";
      this.insertPage.tick.bidVolume1 = "--";
      this.insertPage.inputPrice = "";
    },


    // 计算下单面板上的价格：根据价格类型
    updateButtonPrice: function updateButtonPrice() {
      // 计算下单面板上的价格：手动输入价格
      if (this.insertPage.inputPrice != "") {
        this.orderButton[0].price = this.insertPage.inputPrice;
        this.orderButton[1].price = this.insertPage.inputPrice;
        this.orderButton[2].price = this.insertPage.inputPrice;
        this.boardPrice = this.insertPage.inputPrice;
        return;
      }
      if (this.insertPage.priceMode == __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.latest_price_mode) {
        this.boardPrice = this.orderButton[0].price = this.insertPage.tick.latestPrice;
        this.orderButton[1].price = this.insertPage.tick.latestPrice;
      } else if (this.insertPage.priceMode == __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.queue_price_mode) {
        this.boardPrice = this.orderButton[0].price = this.insertPage.tick.bidPrice1;
        this.orderButton[1].price = this.insertPage.tick.askPrice1;
      } else if (this.insertPage.priceMode == __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.match_price_mode) {
        this.boardPrice = this.orderButton[0].price = this.insertPage.tick.askPrice1;
        this.orderButton[1].price = this.insertPage.tick.bidPrice1;
      } else if (this.insertPage.priceMode == __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.market_price_mode) {
        this.boardPrice = this.orderButton[0].price = this.insertPage.tick.highStopPrice;
        this.orderButton[1].price = this.insertPage.tick.lowStopPrice;
      } else if (this.insertPage.priceMode == __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.extend_price_mode) {
        this.boardPrice = this.orderButton[0].price = this.insertPage.tick.askPrice1;
        this.orderButton[1].price = this.insertPage.tick.bidPrice1;
      }
      // 1.手动选择合约，持仓价格不显示；2.平仓价格由价格类型决定。
      if (this.insertPage.posSelect == -1 || this.insertPage.posSelect >= __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array.length) {
        this.orderButton[2].price = "";
      } else {
        var pos = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array[this.insertPage.posSelect];
        if (pos.direction == __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].pos_direct_long) {
          this.orderButton[2].price = this.orderButton[1].price;
        } else {
          this.orderButton[2].price = this.orderButton[0].price;
        }
      }
    },


    // 全部平仓：将所有仓位全部平掉。
    onCloseAllPosition: function onCloseAllPosition() {
      //model.trader.position.closeAll();
    },


    //下单提示信息
    show_hint: function show_hint(text) {
      var _this3 = this;

      this.warning = text;
      this.auto_flage = true;
      setTimeout(function () {
        _this3.auto_flage = false;
      }, 3000);
      return false;
    },
    show_cx: function show_cx(item, index) {
      this.store_name = item[0];
      this.store_type = item[1];
      this.store_num2 = item[2];
      this.store_num1 = item[3];
      this.store_money = item[4];
      this.data_cx = true;
      this.num = index;
    },
    sure_cd: function sure_cd() {
      var _this4 = this;

      this.data_cx = false;
      var corder = new proto.ctpfront.proto.CancelOrder();
      corder.setOrderRef(__WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].cancelOrderSet.array[this.num].orderRef);
      corder.setOrderId(__WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].cancelOrderSet.array[this.num].orderId);
      corder.setExchangeId(__WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].cancelOrderSet.array[this.num].exchangeId);
      __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].cancelOrder(corder, function (rsp) {}, function (error) {
        _this4.show_hint(error.message);
      });
    },
    all_cd: function all_cd() {
      var _this5 = this;

      var corder = new proto.ctpfront.proto.CancelOrder();
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].cancelOrderSet.array.length; i++) {
        corder.setOrderRef(__WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].cancelOrderSet.array[i].orderRef);
        corder.setOrderId(__WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].cancelOrderSet.array[i].orderId);
        corder.setExchangeId(__WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].cancelOrderSet.array[i].exchangeId);
        __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].cancelOrder(corder, function (rsp) {}, function (error) {
          _this5.show_hint(error.message);
        });
      }
      this.all_cx = false;
    },
    all_pcs: function all_pcs() {
      var _this6 = this;

      var all = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.position.closeAll();
      // 调用前置机委托下单。
      for (var i = 0; i < all.length; ++i) {
        var order = all[i];
        __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].insertOrder(order, function (rsp) {}, function (error) {
          _this6.show_hint(error.message);
          console.log(error);
          _this6.all_pc = false;
        });
      }
      this.all_pc = false;
    },
    goBack: function goBack() {
      // footerIndex = 2;
      window.history.back();
    },


    //下单事件
    orderClick: function orderClick(index, item) {
      this.quickHandle = null;
      this.quickFlage = false;
      this.insertPage.price = item.price;
      if (this.insertPage.price == "") {
        return; // 无价格则不显示下单确认界面。
      }
      this.orderIndex = index;
      if (this.insertPage.posSelect != -1) {
        var pos = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array[this.insertPage.posSelect];
        if (index == 2) {
          // if (this.$store.state.setPage.shortcutOpen) {
          //   this.purchaseOrder()
          // } else {
          //   this.sureOrder = true;
          // }
          if (localStorage.flage === "true") {
            this.sureOrder = true;
            this.eventflage = 'common';
          } else {
            this.purchaseOrder();
          }
          this.sele_deal = pos.direction == __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].pos_direct_short ? "买" : "卖";
          this.closing = "平仓";
        } else {
          this.sele_deal = this.deal[index];
          if (localStorage.flage === "true") {
            this.sureOrder = true;
            this.eventflage = 'common';
          } else {
            this.purchaseOrder();
          }
          this.closing = "开仓";
        }
      } else {
        if (this.insertPage.targetId) {
          if (index < 2) {
            this.sele_deal = this.deal[index];
            if (localStorage.flage === "true") {
              this.sureOrder = true;
              this.eventflage = 'common';
            } else {
              this.purchaseOrder();
            }
            this.closing = "开仓";
          }
        } else {
          this.show_hint("请选择合约");
        }
      }
    },


    // 提示框不同事件
    clickEvent: function clickEvent() {
      if (this.eventflage == 'shortcut_pc') {
        this.shortcutCloseOut(this.eventItem);
      } else if (this.eventflage == 'shortcut_fs') {
        this.shortcutCloseOut(this.eventItem);
        this.shortcutPosition(this.quickHandle);
      } else if (this.eventflage == 'shortcut_sc') {
        this.shortcutPosition(this.quickHandle);
      } else if (this.eventflage == 'common') {
        this.purchaseOrder();
      }
    },
    purchaseOrder: function purchaseOrder() {
      var _this7 = this;

      var vol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var that = this;
      var orderSet = [];
      var volume;
      if (vol) {
        volume = vol;
      } else {
        volume = that.insertPage.volume;
      }
      if (volume === undefined) volume = that.insertPage.volume;
      var price = that.insertPage.price;
      if (price === undefined) price = that.insertPage.price;
      var num = (this.insertPage.tick.priceTick * 10000000).toFixed(0) / 10000000;
      if ((price * 10000000).toFixed(0) % (num * 10000000).toFixed(0) != 0) {
        this.show_hint("下单价格不符合该合约的最小变动价");
        return;
      }
      if (that.orderIndex == 0) {
        // 买开
        orderSet.push(__WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].makeOrder(that.insertPage.targetId, __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].direct_buy, __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].offset_open, volume, price));
      } else if (that.orderIndex == 1) {
        // 卖开
        orderSet.push(__WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].makeOrder(that.insertPage.targetId, __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].direct_sell, __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].offset_open, volume, price));
      } else if (that.orderIndex == 2) {
        // 平仓
        var pos = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array[that.insertPage.posSelect];
        __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].getCloseOrderSet(orderSet, pos, volume, price);
      }

      // 调用前置机委托下单。
      for (var i = 0; i < orderSet.length; ++i) {
        var order = orderSet[i];
        __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].insertOrder(order, function (rsp) {}, function (error) {
          _this7.show_hint(error.message);
        });
      }

      that.sureOrder = false;
    },

    //点击持仓数据
    orderImfor: function orderImfor(index) {
      var _this8 = this;

      if (this.insertPage.posSelects == this.insertPage.posSelect && index == this.insertPage.posSelects) {
        this.insertPage.posSelect = '-1';
      } else {
        this.insertPage.posSelect = index;
        this.insertPage.posSelects = this.insertPage.posSelect;
      }
      // console.log(this.menuValue[index]);
      if (!this.menuValue[index]) return;
      var targetIds = this.menuValue[index].targetId;
      __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].getMaxOrderVolume({ targetId: targetIds, direct: __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].direct_buy }, function (resolve) {
        _this8.buyVol = resolve.maxVolume;
      });
      __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].getMaxOrderVolume({ targetId: targetIds, direct: __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].direct_sell }, function (resolve) {
        _this8.sellVol = resolve.maxVolume;
      });
      var pos = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.array[index];
      // this.insertPage.posSelect = index;
      this.insertPage.inputPrice = "";
      this.insertPage.priceMode = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.match_price_mode;
      this.insertPage.inputPriceHolder = this.price_type[__WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.match_price_mode];
      // 获取持仓可用数量
      this.insertPage.volume = __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].getPositionVailable(pos);

      // 重新订阅合约
      var oldTargetId = this.insertPage.targetId;
      this.insertPage.targetId = pos.targetId;
      this.orderTick = __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].subTick(pos.targetId, this.name);
      this.temporaryTick = __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */]['targetSet'][pos.targetId];
      this.orderTicks = this.temporaryTick;
      this.$store.commit('priceTick/changePriceT', this.orderTicks.priceTick);
      if (oldTargetId !== pos.targetId) {
        __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].unsubTick(oldTargetId, this.name);
      }
      this.insertPage.inputPriceHolder = "对手价";
    },
    isActiveValue: function isActiveValue() {
      this.isActive = this.$route.params.tableId;
      this.link(this.isActive);
    },
    link: function link(index) {
      this.auto_flage = false;
      this.isActive = index;
      var that = this;
      if (index == 1) {
        this.menuTilte = ["合约", "多空", "手数", "可平", "开仓均价", "浮盈"];
        that.buttonTitle = "全部平仓";
      } else if (index == 2) {
        this.menuTilte = ["合约", "类型", "委托价", "委托量", "挂单量"];
        this.buttonTitle = "全部撤单";
      } else if (index == 3) {
        that.buttonTitle = "银行转账";
      } else if (index == 4) {
        if (this.searchCheckedState == 0) {
          this.buttonSearch = true;
          this.menuTilte = ["合约", "开平", "成交价格", "成交手数", "成交时间"];
        } else {
          this.buttonSearch = false;
          this.menuTilte = ["合约", "开平", "报单价格", "报单手数", "未成交数", "报单时间", "报单状态"];
        }
        this.buttonTitle = "成交查询";
        this.buttonTitle = "报单查询";

        // console.log(this.menuValue);
      } else if (index == 0) {
        this.menuTilte = ["合约", "多空", "手数", "可平", "开仓均价", "浮盈"];
      }
    },
    loader_key: function loader_key() {
      var that = this;
      that.contractData = __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].targetList;
    },

    //键盘选择合约时触发事件
    choiceTargetId: function choiceTargetId(targetId) {
      var _this9 = this;

      this.$store.commit('keyBoard/changePriceFlage', false);
      this.insertPage.inputPrice = '';
      __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].getMaxOrderVolume({ targetId: targetId, direct: __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].direct_buy }, function (resolve) {
        _this9.buyVol = resolve.maxVolume;
      });
      __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].getMaxOrderVolume({ targetId: targetId, direct: __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].direct_sell }, function (resolve) {
        _this9.sellVol = resolve.maxVolume;
      });
      var oldTargetId = this.insertPage.targetId;
      this.insertPage.targetId = targetId;
      this.insertPage.posSelect = -1;
      this.insertPage.volume = 1;
      this.insertPage.priceMode = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.match_price_mode;
      this.insertPage.inputPriceHolder = this.price_type[__WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.match_price_mode];
      this.orderTick = __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].subTick(targetId, this.name);
      this.temporaryTick = __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */]['targetSet'][targetId];
      // this.orderTicks = this.temporaryTick;
      this.$store.commit('priceTick/changePriceT', this.temporaryTick.priceTick);
      // console.log(art.digit(this.orderTick.priceTick))
      if (oldTargetId !== targetId) {
        __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].unsubTick(oldTargetId, this.name);
      }
    },
    searchButLink: function searchButLink(i) {
      this.searchCheckedState = i;
      if (i == 0) {
        this.menuTilte = ["合约", "开平", "成交价格", "成交手数", "成交时间"];
        this.buttonSearch = true;
      } else if (i == 1) {
        this.menuTilte = ["合约", "开平", "报单价格", "报单手数", "未成交数", "报单时间", "报单状态"];
        this.buttonSearch = false;
      }
    },
    load: function load(onFail) {
      if (onFail instanceof Function) {
        this.$router.push({ path: "/home/trade" });
        this.$refs.CheckFullStop.subTickData();
      }
    }
  },
  deactivated: function deactivated() {
    this.checkFullStopFlage = false;
    beferFooterIndex = 2;
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.queryCapital.stop();
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.position.unsubTick();
    __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].unsubTick(this.insertPage.targetId, this.name);
  },

  //初始化事件
  activated: function activated() {
    __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].autoMount(__WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.load));
    // 初始化数据
    this.clearTickPrice();
    // 资金视图
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].capital.attach(this.name, __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.onUpdateCapital));
    // 持仓视图
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.attach(this.name, __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.onUpdatePosition), __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.onLoadPosition));
    // 委托视图
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].orderSet.attach(this.name, __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.onUpdateOrder));
    // 撤单视图
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].cancelOrderSet.attach(this.name, __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.onUpdateCancelOrder), undefined, __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.onRemoveCancelOrder));
    // 成交视图
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].tradeSet.attach(this.name, __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.onUpdateTrade));
    // 设定错误显示
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].notify = __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.show_hint);

    // 设置页面默认值
    this.isActiveValue();
    this.loader_key();
    if (localStorage.contractorNo) {
      var localFlage = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.menuValue), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          if (i.targetId == localStorage.contractorNo) {
            this.orderImfor(i.id);
            localFlage = false;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (localFlage) {
        var contractorNo = localStorage.contractorNo;
        this.choiceTargetId(contractorNo);
      }
    } else {
      this.orderImfor(0);
    }
    localStorage.removeItem("contractorNo");

    // 订阅合约行情
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.queryCapital.start();
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].trader.position.subTick();
    if (this.insertPage.targetId != "") {
      this.orderTick = __WEBPACK_IMPORTED_MODULE_6__static_js_proto_CtpFront_js__["a" /* default */].subTick(this.insertPage.targetId, this.name);
    }
  },

  computed: {
    buttonClass: function buttonClass(item) {}
  },
  watch: {
    // 委托下单视图
    orderTick: {
      handler: function handler(tick, old) {
        if (!tick.has) {
          this.clearTickPrice();
        } else {
          this.insertPage.tick = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tick));
        }
        this.updateButtonPrice();
      },
      deep: true
    },
    menuValue: {
      handler: function handler(news, old) {
        if (news.length == 0) {
          this.checkFullStopVolume = '0';
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].capital.detach(this.name);
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].positionSet.detach(this.name);
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].orderSet.detach(this.name);
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].cancelOrderSet.detach(this.name);
    __WEBPACK_IMPORTED_MODULE_5__static_js_proto_Model_js__["a" /* default */].tradeSet.detach(this.name);
  }
});

/***/ }),

/***/ "/1YE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/5SE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_marketDetail_vue__ = __webpack_require__("Ynm1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3215d426_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_marketDetail_vue__ = __webpack_require__("uOF0");
function injectStyle (ssrContext) {
  __webpack_require__("hK71")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3215d426"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_marketDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3215d426_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_marketDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/ocq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("muBx"))(2);

/***/ }),

/***/ "0Dlj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WebSocketProtocol;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CustomWebSocket_js__ = __webpack_require__("fhqW");




//##############################################################################
//##############################################################################
// Protocol协议实现：消息头 + 消息元数据 + 消息。
var protocol = {};

// protocol category.
protocol.category_message = 0x01;
protocol.category_heartbeat = 0x02;
protocol.category_authority = 0x04;
protocol.category_checksum = 0x08;
protocol.category_encrypted = 0x10;
protocol.category_sync_mode = 0x20;
// protocol model.
protocol.model_topic_type = 0x01;
protocol.model_topic_prop = 0x02;
protocol.model_topic_value = 0x04;
protocol.model_topic_str = 0x08;
// protocol option.
protocol.option_last = 0x01;
protocol.option_type = 0x02;
protocol.option_req4 = 0x04;
protocol.option_req8 = 0x08;
protocol.option_req1 = 0x10;
protocol.option_req2 = 0x20;
// protocol member size.
protocol.size_version = 1;
protocol.size_category = 1;
protocol.size_model = 1;
protocol.size_option = 1;
protocol.size_type = 2;
protocol.size_req1 = 1;
protocol.size_req2 = 2;
protocol.size_req4 = 4;
protocol.size_req8 = 8;

////////////////////////////////////////////////////////////////////////////////
// 消息元数据构造函数
function MessageMeta() {
    this.m_category = protocol.category_message;
    this.m_model = 0;
    this.m_option = 0;
    this.m_type = 0;
    this.m_request_data = 0;
}
// 设置32位请求ID
MessageMeta.prototype.setReq4 = function (value) {
    this.m_option |= protocol.option_req4;
    this.m_request_data = value;
};
// 设置32位请求ID
MessageMeta.prototype.last = function () {
    return __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(this.m_option, protocol.option_last);
};

////////////////////////////////////////////////////////////////////////////////
// 获取元数据大小
protocol.getMetaSize = function (meta) {
    var size = protocol.size_version;
    size += protocol.size_category;
    size += protocol.size_model;
    size += protocol.size_option;
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_type)) {
        size += protocol.size_type;
    }
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req1)) size += protocol.size_req1;
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req2)) size += protocol.size_req2;
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req4)) size += protocol.size_req4;
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req8)) size += protocol.size_req8;
    return size;
};
// 获取协议版本信息
protocol.getVersion = function () {
    return 1;
};

////////////////////////////////////////////////////////////////////////////////
// 将Protobuf消息序列化为字节数组
protocol.encode = function (msg, meta) {
    if (!(msg instanceof Object)) {
        console.error("message is not a protobuf.");
        return;
    }
    var msg_bytes = msg.serializeBinary();
    var byte_size = protocol.getMetaSize(meta);
    byte_size += msg_bytes.byteLength;
    var bytes = new ArrayBuffer(byte_size);

    // write message meta to bytes array.
    var pos = 0;
    pos = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].setBytes(bytes, pos, 1, protocol.getVersion());
    pos = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].setBytes(bytes, pos, 1, meta.m_category);
    pos = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].setBytes(bytes, pos, 1, meta.m_model);
    pos = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].setBytes(bytes, pos, 1, meta.m_option);
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_type)) {
        pos = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].setBytes(bytes, pos, 2, meta.m_type);
    }
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req1)) pos = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].setBytes(bytes, pos, 1, meta.m_request_data);
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req2)) pos = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].setBytes(bytes, pos, 2, meta.m_request_data);
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req4)) pos = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].setBytes(bytes, pos, 4, meta.m_request_data);
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req8)) pos = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].setBytes(bytes, pos, 8, meta.m_request_data);

    // write message bytes to bytes array.
    pos = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].copyBytes(bytes, pos, msg_bytes);
    return bytes;
};

////////////////////////////////////////////////////////////////////////////////
// 将字节数组解析为Protobuf消息
protocol.decode = function (meta, buff) {
    var view = new DataView(buff);

    // parse message meta.
    var pos = 1; // version.
    meta.m_category = view.getUint8(pos++);
    meta.m_model = view.getUint8(pos++);
    meta.m_option = view.getUint8(pos++);
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_type)) {
        meta.m_type = view.getUint16(pos);
        pos += 2;
    }
    if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req1)) {
        meta.m_request_data = view.getUint8(pos++);
    } else if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req2)) {
        meta.m_request_data = view.getUint16(pos);
        pos += 2;
    } else if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req4)) {
        meta.m_request_data = view.getUint32(pos);
        pos += 4;
    } else if (__WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].hasValue(meta.m_option, protocol.option_req8)) {
        meta.m_request_data = view.getFloat64(pos);
        pos += 8;
    }
    // parse message object.
    return pos;
};

//##############################################################################
//##############################################################################
// 基于WebSocket的协议构造函数，详见eco.WebSocketProtocol。
function WebSocketProtocol() {
    this.address = ""; // 未带端口的IP地址
    this.addressCur = -1; // 当前地址
    this.addressEnd = -1; // 开始地址
    this.addressSet = null; // 服务器地址集合
    this.requestId = 0; // 请求ID
    this.requestMap = {}; // 请求ID与回调函数
    this.publishMap = {}; // 发布ID与回调函数

    this.socket = null; // 网络连接WebSocket
    // 网络关闭状态，保证自动断开只调用一次。连接成功后，才=true。
    this.firstClose = false;
    // 异常断开将自动重连，而主动断开必须主动连接。
    this.flow = new __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].Flow(1500); // 流量控制
    this.flow.start();
    this.autoMount = null; // 自动加载/主动断开（见activeClose）
    this.mounted = false; // 自动恢复页面成功
}
WebSocketProtocol.e_timeout = -3; // 网络超时
WebSocketProtocol.e_send_fail = -4; // 发送失败
WebSocketProtocol.e_network = -5; // 连接失败

////////////////////////////////////////////////////////////////////////////////
// 设置网络地址
WebSocketProtocol.prototype.setAddress = function (address, addressSet) {
    if (this.address != address) {
        this.address = address;
        this.addressSet = addressSet;
        return true;
    }
    return false;
};

////////////////////////////////////////////////////////////////////////////////
WebSocketProtocol.prototype.onClear = function () {};
// 通知事件：自动重连数据恢复成功
WebSocketProtocol.prototype.onOpen = function () {};
// 通知事件：网络异常断开(active=false)；网络手动关闭(active=true)
WebSocketProtocol.prototype.onClose = function (active) {};
WebSocketProtocol.prototype.setEvent = function (onOpen, onClose, onClear) {
    this.onOpen = onOpen;
    this.onClose = onClose;
    this.onClear = onClear;
};

////////////////////////////////////////////////////////////////////////////////
// 手动关闭网络连接
WebSocketProtocol.prototype.close = function () {
    this.activeClose(true);
    this.onClear(); // 清理数据
    if (this.socket != null) {
        this.socket.close();
        this.socket = null;
        this.onClose(true);
        this.firstClose = false;
    }
};
// 关键数据查询出错，关闭网络等待重连。
WebSocketProtocol.prototype.reopen = function () {
    this.onClear(); // 清理数据
    if (this.socket != null) {
        this.socket.close();
    }
};

////////////////////////////////////////////////////////////////////////////////
/* 设置手动关闭模式；返回当前是否为手动关闭。
autoMount状态值如下：
1.null-主动断开(默认)，同时主动断开表示不自动重连。
2.undefined-非主动断开
3.function-自动重连函数
*/
WebSocketProtocol.prototype.getActiveClose = function () {
    return this.autoMount == null; // 返回手动关闭状态
};
WebSocketProtocol.prototype.activeClose = function (active) {
    // 设置手动关闭状态
    if (active) {
        this.autoMount = null;
        return;
    }

    // 设置非主动断开
    if (this.autoMount == null) {
        this.autoMount = undefined;
    }
    // 自动重连函数
    //else if (this.autoMount instanceof Function) {}
};

////////////////////////////////////////////////////////////////////////////////
WebSocketProtocol.prototype.mountInit = function (pageMount, login, ready) {
    var that = this;
    that.autoMount = function () {
        if (that.mounted) return; // 正在恢复数据
        that.mounted = true;

        // #.自动恢复页面数据失败，继续恢复
        var reject = function reject() {
            that.mounted = false;
            that.resume();
        };

        // 2.加载页面数据：成功-通知自动重连成功；失败-继续恢复。
        var mount = function mount() {
            pageMount(reject);
            if (that.mounted) that.onOpen();
        };

        // 1.登录系统并初始化
        if (!ready()) {
            login(mount, reject);
            return;
        }
        mount();
    };
};

////////////////////////////////////////////////////////////////////////////////
// 程序异常断开时，自动恢复当前页面数据。
WebSocketProtocol.prototype.mount = function (pageMount, login, ready) {
    if (!(pageMount instanceof Function)) return;
    /*
    #.自动恢复页面数据过程：
    1.登录系统与初始化全局数据。(login -> ready)
    2.恢复当前页面数据。（pageMount -> this.mounted）
    注意：为保证能成功地自动恢复页面数据，并允许每个过程失败，则需跟踪每个过程的状态。
    如：login->ready登录初始化的状态，pageMount->mounted页面数据恢复状态。
    */
    this.mountInit(pageMount, login, ready);

    // 客户端调用mount方法时，将加载一次“页面数据”
    pageMount();
};

////////////////////////////////////////////////////////////////////////////////
WebSocketProtocol.prototype.resume = function () {
    var that = this;

    // 1.网络自动连接后恢复页面数据，需要接口提供获取数据的autoMount方法。
    // 2.主动断开：会将that.autoMount置空。
    if (!(that.autoMount instanceof Function)) {
        return;
    }

    // 已连接则直接恢复数据；未连接则定时恢复数据（3秒）
    if (that.opened()) {
        that.autoMount();
    } else {
        setTimeout(function () {
            return that.run("autoMount", that.autoMount);
        }, 3000);
    }
};

////////////////////////////////////////////////////////////////////////////////
WebSocketProtocol.prototype.run = function (name, work, reject) {
    var that = this;
    // 1.Socket未创建，则创建Socket；
    if (!that.opened()) that.init(true);

    // 2.Socket连接成功，则调用方法。
    var waitWork = function waitWork(times) {
        if (that.opened()) {
            work();
            return;
        }
        // 3.等待Socket连接成功。
        if (times < 100) {
            // 等待10秒
            setTimeout(function () {
                return waitWork(++times);
            }, 100);
            return;
        }
        // 4.网络连接超时
        console.error("网络连接超时：" + name);
        if (reject instanceof Function) {
            var msg = "网络连接超时，请检查网络是否打开。";
            reject({ id: WebSocketProtocol.e_network, message: msg });
        }
    };
    waitWork(0);
};

////////////////////////////////////////////////////////////////////////////////
// 连接网络
WebSocketProtocol.prototype.init = function (restart) {
    var _this = this;

    var that = this;
    if (that.socket) return; // 正在连接

    // -------------------------------------------------------------------------
    /* #.负载均衡算法
    1.第一次连接服务器，在地址集合随机选择。
    2.服务器断开后连接服务器，则进行轮训。
    */
    if (restart) {
        that.addressCur = __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].random(0, that.addressSet.length - 1);
        that.addressEnd = (that.addressCur - 1 + that.addressSet.length) % that.addressSet.length;
    } else {
        that.addressCur = ++that.addressCur % that.addressSet.length;
    }
    var address = that.addressSet[that.addressCur];

    // 连接服务器地址，设置超时。
    if (false) console.log("connect: " + address);
    that.socket = new __WEBPACK_IMPORTED_MODULE_1__CustomWebSocket_js__["a" /* default */](address);
    var socketTimeout = that.socket;
    setTimeout(function () {
        if (socketTimeout.readyState != __WEBPACK_IMPORTED_MODULE_1__CustomWebSocket_js__["a" /* default */].OPEN) {
            socketTimeout.close();
        }
    }, 3000);

    // -------------------------------------------------------------------------
    /* #.自动重连方案
    1.断开事件监控：网络正常关闭onclose；网络异常关闭onerror；系统网络设置监控（TODO）
    2.网络连接不上有可能是因为用户未设置Wifi与移动网络导致，应监控网络连接设置，成功后
    马上自动重连。
    3.若异常断开（如网络异常断开或者服务器宕机），则轮询连接下个服务器地址。
    4.服务器连接成功后，调用autoMount恢复当前页面的数据。
    */
    that.socket.onopen = function (evt) {
        if (false) console.log("websocket open");
        that.firstClose = true;
        that.activeClose(false);
        that.resume();
    };
    that.socket.onclose = function (evt) {
        if (false) console.log("websocket close(" + evt.code + ")");
        _this.onClear(); // 清理数据

        // 异常断开只通知第一次，自动重连的断开将不再通知。
        if (that.socket) {
            that.socket = null;
            that.mounted = false;
            if (that.firstClose) {
                that.onClose(that.getActiveClose());
                that.firstClose = false;
            }

            if (that.addressCur != that.addressEnd) {
                // 若连接失败，则继续连接下一个。
                that.init(false);
            } else {
                // 所有连接都已尝试，则等待一段时间再重连
                that.resume();
            }
        }
    };
    // 3.连接服务器错误
    that.socket.onerror = function (evt) {};

    // -------------------------------------------------------------------------
    /* #.接收服务回报消息
    1.请求回报：给请求设定唯一标识发送到服务端，服务端发送回报会携带该标识。
    2.订阅发布：注册该发布消息的回调函数。
    */
    that.socket.onmessage = function (evt) {
        if (!evt.data instanceof Blob) {
            console.error("websocket message is not blob.");
            return;
        }

        // 读取二进制数据
        var reader = new FileReader();
        reader.readAsArrayBuffer(evt.data);
        reader.onloadend = function (evt) {
            if (false) console.log("onmessage");
            // 解析元数据与消息体
            var buff = evt.target.result;
            var meta = new MessageMeta();
            var start = protocol.decode(meta, buff);
            var bytes = new Uint8Array(buff, start);
            // 1.订阅/发布-根据消息ID调用回报方法
            var onPub = that.publishMap[meta.m_type];
            if (onPub) {
                onPub(bytes, meta.m_request_data);
                return;
            }
            // 2.请求/回报-根据ReqId获取回报方法
            var onRsp = that.requestMap[meta.m_request_data];
            if (onRsp !== undefined) {
                onRsp(bytes, meta.last()); // 清除异步请求
                if (meta.last()) delete that.requestMap[meta.m_request_data];
            }
        };
    }; // onmessage
};
// 连接网络成功
WebSocketProtocol.prototype.opened = function () {
    return this.socket && this.socket.readyState == __WEBPACK_IMPORTED_MODULE_1__CustomWebSocket_js__["a" /* default */].OPEN;
};

////////////////////////////////////////////////////////////////////////////////
// 注册发布消息与对应的回调函数
WebSocketProtocol.prototype.subscribe = function (msgType, Type, onPub) {
    this.publishMap[msgType] = function (bytes, last) {
        var pub = Type.deserializeBinary(bytes).toObject();
        var remove = pub.stamp == __WEBPACK_IMPORTED_MODULE_0__Art_js__["a" /* default */].meta.stamp_remove;
        onPub(pub, last, remove);
    };
};
// 取消注册发布消息与对应的回调函数
WebSocketProtocol.prototype.unsubscribe = function (msgType) {
    this.publishMap[msgType] = undefined;
};

////////////////////////////////////////////////////////////////////////////////
WebSocketProtocol.prototype.send = function (req, Rsp, option) {
    var that = this;
    // #1.回调函数定义。
    var onReject = function onReject(error) {
        if (option && option.reject instanceof Function) option.reject(error);
    };
    var onResolve = function onResolve(data, last) {
        if (option && option.resolve instanceof Function) option.resolve(data, last);
    };
    var work = function work() {
        try {
            // #2.填写请求ID/元数据
            if (++that.requestId == 0) ++that.requestId;
            var req_id = that.requestId;
            var meta = new MessageMeta();
            meta.m_type = req.reqType;
            meta.m_option = protocol.option_type;
            meta.setReq4(req_id);

            // #3.接口超时处理
            var timeout = 13000;
            var timeoutClose = false;
            if (option && option.timeout !== undefined) timeout = option.timeout;
            if (option && option.timeoutClose) {
                timeoutClose = true;
            }
            if (timeout != 0) {
                // timeout==0，则不处理超时
                var timer = setTimeout(function () {
                    delete that.requestMap[req_id];
                    // 关键数据无回报则断开连接。
                    if (timeoutClose) {
                        that.reopen();
                    }
                    onReject({
                        id: WebSocketProtocol.e_timeout,
                        message: "请求服务数据超时。"
                    });
                    console.error("timeout " + meta.m_type);
                }, timeout);
            }

            // #4.接口回报处理
            // 发送消息前，缓存请求ID，便于接收消息时调用回报。
            that.requestMap[req_id] = function (bytes, last) {
                if (timer !== undefined) clearTimeout(timer);
                // 1.错误回报
                var rsp = Rsp.deserializeBinary(bytes);
                if (rsp.hasError()) {
                    onReject(rsp.getError().toObject());
                }
                // 2.正确数据回报：单个
                else if (rsp.getData !== undefined) {
                        if (rsp.hasData()) var data = rsp.getData().toObject();
                        onResolve(data, last);
                    }
                    // 3.正确数据回报：列表
                    else if (rsp.getDataList !== undefined) {
                            onResolve(rsp.toObject().dataList);
                        }
            };
            // #5.发送数据
            that.socket.send(protocol.encode(req, meta));
        } catch (e) {
            // #6.发送数据异常处理
            var msg = "发送消息错误(" + req.reqType + ")" + e.message;
            console.error(msg);
            onReject({ id: WebSocketProtocol.e_send_fail, message: msg });
        }
    };

    // #7.流量控制
    if (option && option.control) {
        var workFlow = function workFlow() {
            that.flow.run(work, option.control.taskName, option.control.discard, option.control.interval);
        };
        that.run(req.reqType, workFlow, onReject);
        return;
    }
    that.run(req.reqType, work, onReject);
};

/***/ }),

/***/ "0L1t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0zjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"header"},[_c('span',{on:{"click":_vm.goback}},[_c('i',{staticClass:"icon iconfont left"},[_vm._v("")]),_vm._v("\n      返回\n    ")]),_vm._v("\n    充值记录")]),_vm._v(" "),_c('div',{staticClass:"not-trigger"},[_vm._m(0),_vm._v(" "),_c('div',{ref:"wrapper",staticClass:"content"},[_c('ul',{ref:"list"},[_c('li',{ref:"fristD",staticClass:"positionImg positionImgs"},[(_vm.refer == '正在刷新.....')?_c('img',{attrs:{"src":_vm.load,"alt":""}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.refer))])]),_vm._v(" "),_vm._l((_vm.datas),function(item,index){return _c('li',{key:index,staticClass:"list",on:{"click":function($event){_vm.handleMessage(item, index)}}},[_c('span',[_vm._v(_vm._s(item.Indate))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.TotalMoney))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.realMoney(item)))])])}),_vm._v(" "),(_vm.listLength >= 15)?_c('li',{ref:"lastD",staticClass:"positionImg"},[(_vm.UpLoad == '正在加载.....')?_c('img',{attrs:{"src":_vm.load,"alt":""}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.UpLoad))])]):_vm._e()],2),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":_vm.load,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('p',{class:['msg', {msgs:_vm.msgShow}]},[_vm._v(_vm._s(_vm.referMeg))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"title"},[_c('li',[_vm._v("时间")]),_vm._v(" "),_c('li',[_vm._v("充值金额")]),_vm._v(" "),_c('li',[_vm._v("实际到账")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "133K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "162o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("muBx"))(13);

/***/ }),

/***/ "2Ip2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Vtt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var RadioButton = (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioButton.prototype.handleClick = function (item) {
        this.$emit('input', item.value);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], RadioButton.prototype, "arr", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], RadioButton.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], RadioButton.prototype, "value", void 0);
    RadioButton = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], RadioButton);
    return RadioButton;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (RadioButton);


/***/ }),

/***/ "2ZJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_pb__ = __webpack_require__("NNz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_pb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_pb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConditionData__ = __webpack_require__("hEAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectButton_SelectButton_vue__ = __webpack_require__("b1B+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TargetSelectedKeyboard_TargetSelectedKeyboard_vue__ = __webpack_require__("3/UL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_TargetKeyboard_TargetKeyboard_vue__ = __webpack_require__("moUf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderPriceKeyboard_OrderPriceKeyboard_vue__ = __webpack_require__("IhYp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_utils__ = __webpack_require__("7C6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_property_decorator__ = __webpack_require__("443i");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











var ConditionInsert = (function (_super) {
    __extends(ConditionInsert, _super);
    function ConditionInsert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.newPrice = '';
        _this.latestPrice = '--';
        _this.oldTargetId = '';
        _this.smallPrice = '';
        _this.f_red = false;
        _this.f_green = false;
        _this.f_grey = true;
        _this.arrOperation = __WEBPACK_IMPORTED_MODULE_4__ConditionData__["c" /* con_operation */];
        _this.arrOffset = __WEBPACK_IMPORTED_MODULE_4__ConditionData__["j" /* offset */];
        _this.arrDirect = __WEBPACK_IMPORTED_MODULE_4__ConditionData__["d" /* direct */];
        _this.arrValidTime = __WEBPACK_IMPORTED_MODULE_4__ConditionData__["k" /* validTime */];
        _this.showTargetSelectedKeyboard = false;
        _this.showTargetKeyboard = false;
        _this.showPriceKeyboard = false;
        _this.showVolumeKeyboard = false;
        _this.showOrderPriceKeyboard = false;
        _this.boardPrice = '';
        _this.formData = {
            operationType: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_operation_lt,
            price: '',
            offset: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].offset_open,
            direction: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].direct_buy,
            targetId: '',
            volume: '',
            validTime: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_validity_gfd,
            orderPrice: '',
            orderPriceType: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_limit_price,
        };
        _this.priceValue = '';
        _this.checkedOperationNum = -1;
        return _this;
    }
    Object.defineProperty(ConditionInsert.prototype, "orderPrice", {
        get: function () {
            if (this.formData.orderPriceType === __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_limit_price) {
                return this.formData.orderPrice;
            }
            return __WEBPACK_IMPORTED_MODULE_4__ConditionData__["i" /* getText */](__WEBPACK_IMPORTED_MODULE_4__ConditionData__["a" /* con */], this.formData.orderPriceType);
        },
        enumerable: true,
        configurable: true
    });
    ConditionInsert.prototype.latestPrices = function (tick, old) {
        if (tick.latestPrice === tick.lastSettlementPrice) {
            this.f_red = false;
            this.f_green = false;
            this.f_grey = true;
        }
        else if (tick.latestPrice > tick.lastSettlementPrice) {
            this.f_red = true;
            this.f_green = false;
            this.f_grey = false;
        }
        else if (tick.latestPrice < tick.lastSettlementPrice) {
            this.f_red = false;
            this.f_green = true;
            this.f_grey = false;
        }
        this.$store.commit('priceTick/changePriceT', tick.priceTick);
        this.latestPrice = tick.latestPrice;
        this.smallPrice = Number((tick.priceTick * 10000).toFixed(0)) / 10000;
        this.changeBoardPrice();
    };
    ConditionInsert.prototype.changePriceType = function (news, old) {
        this.changeBoardPrice();
    };
    ConditionInsert.prototype.changeDirection = function (news, old) {
        this.changeBoardPrice();
    };
    ConditionInsert.prototype.changeBoardPrice = function () {
        this.boardPrice = 0;
        if (!this.newPrice) {
            return;
        }
        if (this.formData.direction === 1) {
            switch (this.formData.orderPriceType) {
                case 16:
                    this.boardPrice =
                        this.newPrice.askPrice1 ? this.newPrice.askPrice1 : 0;
                    break;
                case 4:
                    this.boardPrice =
                        this.newPrice.latestPrice ? this.newPrice.latestPrice : 0;
                    break;
                case 17:
                    this.boardPrice =
                        this.newPrice.highStopPrice ? this.newPrice.highStopPrice : 0;
                    break;
                case 18:
                    this.boardPrice =
                        this.newPrice.bidPrice1 ? this.newPrice.bidPrice1 : 0;
                    break;
            }
        }
        else if (this.formData.direction === 2) {
            switch (this.formData.orderPriceType) {
                case 16:
                    this.boardPrice =
                        this.newPrice.bidPrice1 ? this.newPrice.bidPrice1 : 0;
                    break;
                case 4:
                    this.boardPrice =
                        this.newPrice.latestPrice ? this.newPrice.latestPrice : 0;
                    break;
                case 17:
                    this.boardPrice =
                        this.newPrice.lowStopPrice ? this.newPrice.lowStopPrice : 0;
                    break;
                case 18:
                    this.boardPrice =
                        this.newPrice.askPrice1 ? this.newPrice.askPrice1 : 0;
                    break;
            }
        }
    };
    ConditionInsert.prototype.mounted = function () {
        this.setDefault();
    };
    ConditionInsert.prototype.deactivated = function () {
        this.formData.orderPrice = '';
        this.newPrice = '';
        __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].unsubTick(this.targentId, 'conditionInsert');
        this.latestPrice = '--';
    };
    ConditionInsert.prototype.activated = function () {
        this.formData.targetId = this.targentId;
        if (this.type === '买') {
            this.formData.direction = 2;
        }
        else {
            this.formData.direction = 1;
        }
        if (this.$route.query.Num) {
            this.formData.offset = 2;
        }
        else {
            this.formData.offset = 1;
        }
        this.formData.volume = this.closeOut;
        this.formData.price = this.money;
        this.getLatestPrice();
    };
    ConditionInsert.prototype.setDefault = function () {
        this.formData = {
            operationType: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_operation_lt,
            price: '',
            offset: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].offset_open,
            direction: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].direct_buy,
            targetId: '',
            volume: '',
            validTime: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_validity_gfd,
            orderPrice: '',
            orderPriceType: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_opponent_price,
        };
    };
    ConditionInsert.prototype.addCondition = function () {
        var cond = new __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_pb__["OrderConditional"]();
        var data = this.formData;
        if (!this.formData.targetId) {
            __WEBPACK_IMPORTED_MODULE_9__utils_utils__["f" /* toast */]('请选择合约');
            return;
        }
        if (!this.formData.price) {
            __WEBPACK_IMPORTED_MODULE_9__utils_utils__["f" /* toast */]('请输入价格');
            return;
        }
        if (!this.formData.volume) {
            __WEBPACK_IMPORTED_MODULE_9__utils_utils__["f" /* toast */]('请输入手数');
            return;
        }
        if (this.formData.orderPriceType === __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_limit_price
            && __WEBPACK_IMPORTED_MODULE_9__utils_utils__["e" /* isZero */](this.formData.orderPrice)) {
            __WEBPACK_IMPORTED_MODULE_9__utils_utils__["f" /* toast */]('请输入报单价');
            return;
        }
        if (this.formData.orderPriceType === 2 &&
            (Number(this.formData.orderPrice) * 1000000).toFixed(0) %
                (this.smallPrice * 1000000).toFixed(0) !== 0) {
            __WEBPACK_IMPORTED_MODULE_9__utils_utils__["f" /* toast */]('下单价格不符合该合约的最小变动价位');
            return;
        }
        if ((Number(this.formData.price) * 1000000).toFixed(0) %
            (this.smallPrice * 1000000).toFixed(0) !== 0) {
            __WEBPACK_IMPORTED_MODULE_9__utils_utils__["f" /* toast */]('下单价格不符合该合约的最小变动价位');
            return;
        }
        cond.setTargetId(data.targetId);
        cond.setPrice(data.price);
        cond.setConditionPriceType(__WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_last_price);
        cond.setOperationType(data.operationType);
        cond.setVolume(data.volume);
        cond.setDirection(data.direction);
        cond.setOffset(data.offset);
        cond.setValidTime(data.validTime);
        cond.setState(0);
        cond.setOrderPrice(data.orderPrice);
        cond.setOrderPriceType(data.orderPriceType);
        __WEBPACK_IMPORTED_MODULE_9__utils_utils__["c" /* indicator */]('正在处理...');
        __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].conditionOrderSave(cond, function (resolve) {
            __WEBPACK_IMPORTED_MODULE_9__utils_utils__["a" /* closeIndicator */]();
            __WEBPACK_IMPORTED_MODULE_9__utils_utils__["f" /* toast */]('添加成功');
            console.log(resolve);
        }, function (reject) {
            console.error(reject);
            __WEBPACK_IMPORTED_MODULE_9__utils_utils__["f" /* toast */]('失败: ' + reject.message);
            __WEBPACK_IMPORTED_MODULE_9__utils_utils__["a" /* closeIndicator */]();
        });
    };
    ConditionInsert.prototype.handleCancel = function () {
        this.setDefault();
    };
    ConditionInsert.prototype.choiceTargetId = function (targetId) {
        if (this.oldTargetId) {
            __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].unsubTick(this.oldTargetId, 'conditionInsert');
            this.latestPrice = '--';
        }
        this.setDefault();
        this.formData.targetId = targetId;
        this.oldTargetId = targetId;
        this.newPrice = __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].subTick(targetId, 'conditionInsert');
    };
    ConditionInsert.prototype.getLatestPrice = function () {
        if (this.targentId) {
            this.oldTargetId = this.targentId;
            this.newPrice = __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].subTick(this.targentId, 'conditionInsert');
        }
        else {
            this.latestPrice = '--';
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_10_vue_property_decorator__["a" /* Prop */])()
    ], ConditionInsert.prototype, "targentId", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_10_vue_property_decorator__["a" /* Prop */])()
    ], ConditionInsert.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_10_vue_property_decorator__["a" /* Prop */])()
    ], ConditionInsert.prototype, "closeOut", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_10_vue_property_decorator__["a" /* Prop */])()
    ], ConditionInsert.prototype, "money", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_10_vue_property_decorator__["b" /* Watch */])('newPrice', { deep: true })
    ], ConditionInsert.prototype, "latestPrices", null);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_10_vue_property_decorator__["b" /* Watch */])('formData.orderPriceType', { deep: true })
    ], ConditionInsert.prototype, "changePriceType", null);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_10_vue_property_decorator__["b" /* Watch */])('formData.direction', { deep: true })
    ], ConditionInsert.prototype, "changeDirection", null);
    ConditionInsert = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            components: {
                SelectButton: __WEBPACK_IMPORTED_MODULE_5__SelectButton_SelectButton_vue__["a" /* default */],
                TargetSelectedKeyboard: __WEBPACK_IMPORTED_MODULE_6__TargetSelectedKeyboard_TargetSelectedKeyboard_vue__["a" /* default */],
                TargetKeyboard: __WEBPACK_IMPORTED_MODULE_7__views_components_TargetKeyboard_TargetKeyboard_vue__["a" /* default */],
                OrderPriceKeyboard: __WEBPACK_IMPORTED_MODULE_8__OrderPriceKeyboard_OrderPriceKeyboard_vue__["a" /* default */],
            },
        })
    ], ConditionInsert);
    return ConditionInsert;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (ConditionInsert);


/***/ }),

/***/ "2aQn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3/UL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_TargetSelectedKeyboard_ts__ = __webpack_require__("n2GC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229991bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TargetSelectedKeyboard_vue__ = __webpack_require__("nl0P");
function injectStyle (ssrContext) {
  __webpack_require__("tEWD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-229991bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_TargetSelectedKeyboard_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229991bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TargetSelectedKeyboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "396W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3P7H":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3ZfC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3hyP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tradeList_vue__ = __webpack_require__("xu5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750f83d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tradeList_vue__ = __webpack_require__("VnZ4");
function injectStyle (ssrContext) {
  __webpack_require__("x8Zw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-750f83d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tradeList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750f83d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tradeList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3n4W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3quM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dyfooter__ = __webpack_require__("9esV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_yjheader__ = __webpack_require__("eR8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_yj_login__ = __webpack_require__("y59h");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  components: {
    dyfooter: __WEBPACK_IMPORTED_MODULE_0__components_common_dyfooter__["a" /* default */],
    yjheader: __WEBPACK_IMPORTED_MODULE_1__components_common_yjheader__["a" /* default */],
    login: __WEBPACK_IMPORTED_MODULE_2__components_yj_login__["a" /* default */]
  },
  data: function data() {
    return {
      // loginStateParents: true,
      // loginStateP: true,
    };
  },

  methods: {
    // chaildData(data) {
    //   this.loginStateP = false;
    // }
  }
});

/***/ }),

/***/ "45ek":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhenshuang.5c843b7.png";

/***/ }),

/***/ "4AwN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4J9r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4YSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__("7C6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_velocity_animate__ = __webpack_require__("9qgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_velocity_animate__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var globalKeyboard;
var BaseKeyboard = (function (_super) {
    __extends(BaseKeyboard, _super);
    function BaseKeyboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fnBodyClick = undefined;
        return _this;
    }
    BaseKeyboard.prototype.mounted = function () {
        var _this = this;
        if (globalKeyboard) {
            globalKeyboard.handleClose();
        }
        globalKeyboard = this;
        this.fnBodyClick = function (e) {
            if (!__WEBPACK_IMPORTED_MODULE_3__utils_utils__["d" /* isParentOfEventElement */](_this.$refs.basekeyboard, e)) {
                var isExclude = false;
                var target = e.target;
                if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(_this.exclude)) {
                    isExclude = _this.exclude.includes(target);
                }
                else if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isFunction(_this.exclude)) {
                    isExclude = _this.exclude(target);
                }
                else if (_this.exclude === target) {
                    isExclude = true;
                }
                if (!isExclude) {
                    _this.handleClose();
                }
            }
        };
        document.body.addEventListener('touchstart', this.fnBodyClick, true);
    };
    BaseKeyboard.prototype.destroyed = function () {
        if (this.fnBodyClick) {
            document.body.removeEventListener('touchstart', this.fnBodyClick, true);
        }
    };
    BaseKeyboard.prototype.handleClose = function () {
        this.$emit('close');
    };
    BaseKeyboard.prototype.enter = function (el, done) {
        el.style['max-height'] = '0px';
        __WEBPACK_IMPORTED_MODULE_5_velocity_animate___default()(el, {
            'max-height': '100%',
        }, {
            duration: 200,
            complete: done,
        });
    };
    BaseKeyboard.prototype.leave = function (el, done) {
        el.style['max-height'] = '100%';
        __WEBPACK_IMPORTED_MODULE_5_velocity_animate___default()(el, {
            'max-height': '0px',
        }, {
            duration: 100,
            complete: function () {
                done();
            },
        });
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], BaseKeyboard.prototype, "title", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], BaseKeyboard.prototype, "exclude", void 0);
    BaseKeyboard = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], BaseKeyboard);
    return BaseKeyboard;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (BaseKeyboard);


/***/ }),

/***/ "4jC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "yjheader",
  props: ["leftIcon", "title", "rightIcon", "selfRightIcon1", "selfRightIcon2", "selfChoiceHeader"],
  data: function data() {
    return {
      selfRightIcon2Value: true,
      selfChoiceHeader2: ""
    };
  },

  methods: {
    // appAlrClose:function () {
    //
    //
    // },

    goBack: function goBack() {
      window.history.back();
    },
    order: function order() {
      this.$router.push({ path: "/tradeDetail/0" });
      localStorage.contractorNo = this.title;
    },

    //添加自选股
    select: function select(item) {
      var _this = this;

      if (this.selfChoiceHeader == "&#xe63c;" || this.selfChoiceHeader2 == "&#xe63c;") {
        __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront_js__["a" /* default */].selectedTargetAdd(item, function (resolve) {
          _this.selfRightIcon2Value = false;
          _this.selfChoiceHeader2 = "&#xe617;";
          // console.log(resolve);
          // alert(1)
        }, function (reject) {
          // console.log(reject);
          // alert(2)
          _this.selfRightIcon2Value = false;
          _this.selfChoiceHeader2 = "&#xe617;";
        });
      } else if (this.selfChoiceHeader == "&#xe617;" || this.selfChoiceHeader2 == "&#xe617;") {
        __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront_js__["a" /* default */].selectedTargetRemove(item, function (resolve) {
          _this.selfRightIcon2Value = false;
          _this.selfChoiceHeader2 = "&#xe63c;";
          // console.log(resolve);
          // alert(3)
        }, function (reject) {
          // console.log(reject);
          _this.selfRightIcon2Value = false;
          _this.selfChoiceHeader2 = "&#xe63c;";
          // alert(4)
        });
      }
    }
  }
});

/***/ }),

/***/ "571A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var FixedTable = (function (_super) {
    __extends(FixedTable, _super);
    function FixedTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeIndex = '';
        _this.isTouchTitle = false;
        _this.scrollLeft = 0;
        return _this;
    }
    Object.defineProperty(FixedTable.prototype, "commonTitle", {
        get: function () {
            return this.title.slice(1);
        },
        enumerable: true,
        configurable: true
    });
    FixedTable.prototype.mounted = function () {
    };
    FixedTable.prototype.handleScrollContent = function () {
        if (!this.isTouchTitle) {
            this.$refs.scrollTit.scrollLeft = this.$refs.scrollContent.scrollLeft;
            this.scrollLeft = this.$refs.scrollTit.scrollLeft;
        }
    };
    FixedTable.prototype.handleScrollTitle = function () {
        if (this.isTouchTitle) {
            this.$refs.scrollContent.scrollLeft = this.$refs.scrollTit.scrollLeft;
            this.scrollLeft = this.$refs.scrollTit.scrollLeft;
        }
    };
    FixedTable.prototype.handleTouchContent = function (e) {
        this.isTouchTitle = false;
        e.stopPropagation();
    };
    FixedTable.prototype.handleTouchTitle = function (e) {
        this.isTouchTitle = true;
    };
    FixedTable.prototype.handleActive = function (item, index) {
        if (this.activeIndex === item[this.dataKey]) {
            this.activeIndex = '';
        }
        else if (this.isOp) {
            this.activeIndex = item[this.dataKey];
        }
    };
    FixedTable.prototype.isActive = function (key) {
        if (!this.isOp) {
            return false;
        }
        return this.activeIndex === key;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], FixedTable.prototype, "title", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], FixedTable.prototype, "tableData", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])({ default: false })
    ], FixedTable.prototype, "isOp", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], FixedTable.prototype, "dataKey", void 0);
    FixedTable = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], FixedTable);
    return FixedTable;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (FixedTable);


/***/ }),

/***/ "5G3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"header"},[_c('span',{on:{"click":_vm.handleGoBack}},[_c('i',{staticClass:"iconfont",staticStyle:{"color":"#fff"}},[_vm._v("")]),_vm._v("\n      返回\n    ")]),_vm._v(" "),_c('p',[_vm._v("合约详情日志")])]),_vm._v(" "),_c('div',{staticClass:"listConent"},[_c('FixedTable',{staticClass:"container2",attrs:{"title":_vm.tableTitle,"isOp":false,"dataKey":"id","tableData":_vm.data}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "67t3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "681v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseKeyboard',{attrs:{"title":"选择合约","exclude":_vm.exclude},on:{"close":_vm.handleClose}},[_c('div',{staticClass:"targetkeyboard-container"},[(!_vm.selectFage)?_c('ul',{staticClass:"selectTarget"},_vm._l((_vm.selectTarget),function(item,index){return _c('li',{directives:[{name:"tap",rawName:"v-tap"}],key:index,on:{"tap":function($event){_vm.choiceTargetId(item.targetId)}}},[_vm._v(_vm._s(item.targetId))])})):_vm._e(),_vm._v(" "),(_vm.selectFage)?_c('div',{staticClass:"numb_box"},[_c('div',{staticClass:"xiaq_tb"}),_vm._v(" "),_c('ul',{staticClass:"nub_ggg"},_vm._l((_vm._.uniqBy(_vm.contractData,'productId')),function(item,index){return (item.exchangeName == _vm.currentExchangeName)?_c('li',{directives:[{name:"tap",rawName:"v-tap"}],key:index,class:{numbActive:_vm.currentProductId==item.productId},on:{"tap":function($event){_vm.choiceProduceId(item.productId)}}},[_vm._v(_vm._s(item.productId))]):_vm._e()}))]):_vm._e(),_vm._v(" "),(_vm.selectFage)?_c('div',{staticClass:"numb_box2"},[_c('ul',_vm._l((_vm.contractData),function(item,index){return (item.productId == _vm.currentProductId)?_c('li',{directives:[{name:"tap",rawName:"v-tap"}],key:index,on:{"tap":function($event){_vm.choiceTargetId(item.targetId)}}},[_vm._v(_vm._s(item.targetId))]):_vm._e()}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"numb_box3"},[_c('ul',_vm._l((_vm.sumExchangeName),function(item,index){return _c('li',{directives:[{name:"tap",rawName:"v-tap"}],key:index,class:{numbActive:_vm.currentExchangeName==item},on:{"tap":function($event){_vm.choiceExchangeName(item)}}},[_vm._v(_vm._s(item=="上期能源"?"能源":item.substring(0,2)))])}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Cg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_targetSelected_vue__ = __webpack_require__("b8US");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9950f7f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_targetSelected_vue__ = __webpack_require__("nBw5");
function injectStyle (ssrContext) {
  __webpack_require__("8/UU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9950f7f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_targetSelected_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9950f7f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_targetSelected_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Oe5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6hYj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_NumKeyboard_ts__ = __webpack_require__("Q29T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7357cf3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NumKeyboard_vue__ = __webpack_require__("qXIy");
function injectStyle (ssrContext) {
  __webpack_require__("xpwS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7357cf3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_NumKeyboard_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7357cf3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NumKeyboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6kIr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("7C6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_Model_js__ = __webpack_require__("O0G5");



var subFuns = {
    conditionNotTriggerList: function conditionNotTriggerList(list) {
        var publish = function publish(order) {
            console.log('publish conditionNotTriggerList.', order);
            __WEBPACK_IMPORTED_MODULE_1__utils_utils__["g" /* updArrayById */](order, list);
        };
        __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].conditionOrderSub({
            suberId: 'condition_order',
            publish: publish,
            reject: function reject(err) {
                return console.error(err);
            }
        });
    },
    capital: function capital(obj) {
        __WEBPACK_IMPORTED_MODULE_2__static_js_proto_Model_js__["a" /* default */].capital.attach('trade', function (capital) {
            if (capital === undefined) {
                obj.rights = 0.0;
                obj.usable = 0.0;
                obj.profitAloss = 0.0;
                obj.desirable = 0.0;
                obj.account = 0.0;
                return;
            }
            obj.rights = capital.balance;
            obj.usable = capital.available;
            obj.profitAloss = capital.positionProfit;
            obj.desirable = capital.withdrawQuota;
            obj.account = capital.account;
        });
        __WEBPACK_IMPORTED_MODULE_2__static_js_proto_Model_js__["a" /* default */].trader.queryCapital.start();
    }
};
/* harmony default export */ __webpack_exports__["a"] = (subFuns);

/***/ }),

/***/ "6uOh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tmi_Tmi_js__ = __webpack_require__("jAd7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__ = __webpack_require__("GIBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Object_pb_js__ = __webpack_require__("zSVF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Object_pb_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Object_pb_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Market_pb_js__ = __webpack_require__("cdwa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Market_pb_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js__ = __webpack_require__("NNz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__art_WebSocketProtocol_js__ = __webpack_require__("0Dlj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Model_js__ = __webpack_require__("O0G5");











////////////////////////////////////////////////////////////////////////////////
// 前置机客户端：构造函数
function Front() {
  // 登录信息
  this.websocket = new __WEBPACK_IMPORTED_MODULE_6__art_WebSocketProtocol_js__["a" /* default */]();
  this.user = null;
  this.init = false;
  this.loginReq = null;

  // 行情Tick数据
  this.tick = new __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].ObjectTopic();
  this.kbar = new __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].ObjectTopic();
  this.flash = new __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].ObjectTopic();
  this.selected = new __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].ObjectTopic();
  this.dominant = new __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].ObjectTopic();
  this.condition = new __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].ObjectTopic();

  // 合约列表
  this.targetList; // 合约列表数组
  this.targetSet; // 合约列表集合
  this.exchangeSet; // 交易所集合
  this.productSet; // 品种集合
}
var impl = {};

////////////////////////////////////////////////////////////////////////////////
// 设置合约列表
impl.setTargetList = function (front, targetList) {
  front.targetSet = {};
  front.exchangeSet = {};
  front.productSet = {};
  for (var i = 0; i < targetList.length; ++i) {
    var target = targetList[i];
    front.targetSet[target.targetId] = target;
    // 商品列表
    var product = front.productSet[target.productId];
    if (product === undefined) {
      front.productSet[target.productId] = product = {};
      product.targetSet = [];
      product.id = target.productId;
      product.name = target.productName;
    }
    product.targetSet.push({
      id: target.targetId,
      name: target.targetName
    });
    // 交易所列表
    var exchange = front.exchangeSet[target.exchangeId];
    if (exchange === undefined) {
      front.exchangeSet[target.exchangeId] = exchange = {};
      exchange.productSet = [];
      exchange.id = target.exchangeId;
      exchange.name = target.exchangeName;
    }
    exchange.productSet.push({
      id: target.productId,
      name: target.productName
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
// 接口消息ID
Front.proto_login_req = 10001, Front.proto_login_rsp = 10002, Front.proto_insert_order_req = 10003, Front.proto_insert_order_rsp = 10004, Front.proto_cancel_order_req = 10005, Front.proto_cancel_order_rsp = 10006, Front.proto_order_pub = 10007, Front.proto_trade_pub = 10008, Front.proto_capital_req = 10011, Front.proto_capital_rsp = 10012, Front.proto_position_req = 10013, Front.proto_position_rsp = 10014, Front.proto_position_detail_req = 10015, Front.proto_position_detail_rsp = 10016, Front.proto_max_order_volume_req = 10017, Front.proto_max_order_volume_rsp = 10018, Front.proto_insinfo_req = 10019, Front.proto_insinfo_rsp = 10020, Front.proto_kbar_req = 10021, Front.proto_kbar_rsp = 10022, Front.proto_lstquote_req = 10023, Front.proto_lstquote_rsp = 10024, Front.proto_alltickquote_req = 10025, Front.proto_alltickquote_rsp = 10026,
// 订阅行情快照（行情列表）
Front.proto_tick_sub_req = 10030, Front.proto_tick_sub_rsp = 10031, Front.proto_tick_unsub_req = 10032, Front.proto_tick_unsub_rsp = 10033, Front.proto_tick_pub = 10034,
// 订阅行情K线（1分钟/5分钟）
Front.proto_kbar_sub_req = 10040, Front.proto_kbar_sub_rsp = 10041, Front.proto_kbar_unsub_req = 10042, Front.proto_kbar_unsub_rsp = 10043, Front.proto_kbar_pub = 10044,
// 订阅行情分时图（1分钟）
Front.proto_time_seq_req = 10055, Front.proto_time_seq_rsp = 10056,
// 自选股
Front.proto_target_selected_sub_req = 10060, Front.proto_target_selected_sub_rsp = 10061, Front.proto_target_selected_unsub_req = 10062, Front.proto_target_selected_unsub_rsp = 10063, Front.proto_target_selected_add_req = 10064, Front.proto_target_selected_add_rsp = 10065, Front.proto_target_selected_remove_req = 10066, Front.proto_target_selected_remove_rsp = 10067, Front.proto_target_selected_pub = 10068,
// 主力合约
Front.proto_target_dominant_sub_req = 10070, Front.proto_target_dominant_sub_rsp = 10071, Front.proto_target_dominant_unsub_req = 10072, Front.proto_target_dominant_unsub_rsp = 10073, Front.proto_target_dominant_pub = 10074,
// 条件单
Front.proto_order_conditional_sub_req = 10080, Front.proto_order_conditional_sub_rsp = 10081, Front.proto_order_conditional_unsub_req = 10082, Front.proto_order_conditional_unsub_rsp = 10083, Front.proto_order_conditional_save_req = 10084, Front.proto_order_conditional_save_rsp = 10085, Front.proto_order_conditional_remove_req = 10086, Front.proto_order_conditional_remove_rsp = 10087, Front.proto_order_conditional_pub = 10088, Front.proto_order_conditional_get_req = 10089, Front.proto_order_conditional_get_rsp = 10090,

// 修改密码
Front.proto_user_passwd_update_req = 10093, Front.proto_user_passwd_update_rsp = 10094,

////////////////////////////////////////////////////////////////////////////////
// 错误ID
Front.prototype.e_network = -5, // 网络错误
Front.prototype.e_selected_not_exist = 10001, // 自选股合约不存在
Front.prototype.e_selected_repeated = 10002, // 自选股重复添加
Front.prototype.e_selected_removed = 10003, // 自选股重复删除
Front.prototype.e_unknown = 10004, // 未知错误
Front.prototype.e_account_invalid = 11, // 用户名不正确
Front.prototype.e_password_invalid = 2001, // 用户密码不正确

////////////////////////////////////////////////////////////////////////////////
// 买卖
Front.prototype.direct_buy = 1; // 买（多头）
Front.prototype.direct_sell = 2; // 卖（空头）
// 持仓方向
Front.prototype.pos_direct_long = 1, // 多头
Front.prototype.pos_direct_short = 2, // 空头
Front.prototype.pos_direct_net = 3, // 净持仓
// 开平
Front.prototype.offset_open = 1; // 开仓
Front.prototype.offset_close = 2; // 平仓
Front.prototype.offset_close_today = 3; // 平今
Front.prototype.offset_close_last = 4; // 平昨
// 投机套利
Front.prototype.hedge_speculation = 1, // 投机
Front.prototype.hedge_arbitrage = 2, // 套利
Front.prototype.hedge_hedge = 3, // 套保

// 国内股票交易所
Front.prototype.exchange_sse = 1, // 上交所（股票）
Front.prototype.exchange_sze = 2, // 深交所（股票）
// 国内期货交易所
Front.prototype.exchange_shfe = 3, // 上期所（期货）
Front.prototype.exchange_cffex = 4, // 中金所（期货）
Front.prototype.exchange_dce = 5, // 大商所（期货）
Front.prototype.exchange_czce = 6, // 郑商所（期货）
Front.prototype.exchange_ine = 7, // 上海国际能源（期货）
Front.prototype.exchange_gfex = 8, // 广期所

// 委托状态：股票\期货
Front.prototype.order_init = 101, // 就绪
Front.prototype.order_sended = 102, // 已发送
Front.prototype.order_accepted = 104, // 未成交（已报单）
Front.prototype.order_cancel_sended = 106, // 撤单已发
Front.prototype.order_cancel_accepted = 105, // 撤单已报
Front.prototype.order_part_canceled = 107, // 部分撤单
Front.prototype.order_all_canceled = 108, // 全部撤单
Front.prototype.order_part_traded = 110, // 部分成交
Front.prototype.order_all_traded = 111, // 全部成交
Front.prototype.order_error = 113, // 错单

// 行情K线类型
Front.prototype.ktype_tick = 1, // Tick
Front.prototype.ktype_second = 2, // 秒
Front.prototype.ktype_minute = 3, // 分
Front.prototype.ktype_hour = 4, // 小时
Front.prototype.ktype_day = 5, // 天
Front.prototype.ktype_week = 6, // 周
Front.prototype.ktype_month = 7, // 月
Front.prototype.ktype_season = 8, // 月
Front.prototype.ktype_year = 9, // 年

// 行情K线查询模式
Front.prototype.kquery_time = 1; // 按时间查询
Front.prototype.kquery_size = 2; // 按K线数查询
Front.prototype.kquery_days = 3; // 按交易日查询

////////////////////////////////////////////////////////////////////////////////
// 条件单类型
Front.prototype.con_no_active = 0, //未触发
Front.prototype.con_active = 1, //已触发

// 条件单 价格类型
Front.prototype.con_limit_price = 2, //限价
Front.prototype.con_opponent_price = 16, //对手价
Front.prototype.con_last_price = 4, //最新价
Front.prototype.con_market_price = 17, //市价
Front.prototype.con_plusone_tick_price = 18, //超一价

// 条件单 有效期类型
Front.prototype.con_validity_gfd = 0, //当日有效
Front.prototype.con_validity_all = 1, //永久有效

// 条件单运行状态
Front.prototype.con_order_run = 1, //运行中
Front.prototype.con_order_stop = 2, //暂停
Front.prototype.con_order_trigger = 3, //已触发
Front.prototype.con_order_delete = 4, //已删除
Front.prototype.con_order_settlement = 5, //已结算

// Front.prototype.con_state_run               = 1,    //运行中
// Front.prototype.con_state_stop              = 2,    //停止
// Front.prototype.con_state_trigger           = 3,    //暂停

// 条件单 操作
Front.prototype.con_operation2_add = 0, //增加
Front.prototype.con_operation2_update = 1, //更新
Front.prototype.con_operation2_delete = 2, //删除

// 条件单 运算符
Front.prototype.con_operation_gt = 0, //大于
Front.prototype.con_operation_lt = 1, //小于
Front.prototype.con_operation_ge = 2, //大于等于
Front.prototype.con_operation_le = 3, //小于等于


////////////////////////////////////////////////////////////////////////////////
// 买卖方向
Front.prototype.textDirection = function (direct) {
  var text = direct == Front.prototype.direct_buy ? "买" : "卖";
  return text;
};
// 开平方向
Front.prototype.textOffSet = function (offset) {
  var text = offset == Front.prototype.offset_open ? "开" : "平";
  return text;
};
// 买卖开平
Front.prototype.textDirectionOffSet = function (direct, offset) {
  var text = direct == Front.prototype.direct_buy ? "买" : "卖";
  text += offset == Front.prototype.offset_open ? "开" : "平";
  return text;
};
// 持仓方向
Front.prototype.textPositionDirection = function (direct) {
  var text = direct == Front.prototype.pos_direct_long ? "买" : "卖";
  return text;
};

////////////////////////////////////////////////////////////////////////////////
// 委托状态
Front.prototype.textOrderState = function (state) {
  switch (state) {
    case Front.prototype.order_accepted:
      return "未成交";
    case Front.prototype.order_all_traded:
      return "全部成交";
    case Front.prototype.order_all_canceled:
      return "已撤单";
    case Front.prototype.order_error:
      return "已撤单";
    case Front.prototype.order_part_canceled:
      return "部分撤单";
    case Front.prototype.order_part_traded:
      return "部分成交";
  }
  return "";
};

////////////////////////////////////////////////////////////////////////////////
// 套利
Front.prototype.textHedge = function (hedge) {
  switch (hedge) {
    case Front.prototype.hedge_speculation:
      return "投机";
    case Front.prototype.hedge_arbitrage:
      return "套利";
    case Front.prototype.hedge_hedge:
      return "套保";
  }
  return "";
};

////////////////////////////////////////////////////////////////////////////////
// 获取持仓的平仓方向
Front.prototype.getCloseOrderDirection = function (pos_direct) {
  switch (pos_direct) {
    case Front.prototype.pos_direct_long:
      return Front.prototype.direct_sell;
    case Front.prototype.pos_direct_short:
      return Front.prototype.direct_buy;
    case Front.prototype.pos_direct_net:
      return Front.prototype.direct_sell;
  }
  return 0;
};
// 获取持仓的平仓方向
Front.prototype.getPositionDirection = function (order_direct) {
  switch (order_direct) {
    case Front.prototype.direct_sell:
      return Front.prototype.pos_direct_short;
    case Front.prototype.direct_buy:
      return Front.prototype.pos_direct_long;
  }
  return 0;
};
// 获取委托方向取反
Front.prototype.getReverseDirection = function (direct) {
  switch (direct) {
    case Front.prototype.direct_sell:
      return Front.prototype.direct_buy;
    case Front.prototype.direct_buy:
      return Front.prototype.direct_sell;
  }
  return 0;
};

//
Front.prototype.getConditionOrderActive = function (state) {
  switch (state) {
    case Front.prototype.con_state_run:
    case Front.prototype.con_state_stop:
      return Front.prototype.con_no_active;
    case Front.prototype.con_state_trigger:
      return Front.prototype.con_active;
  }
  return 0;
};

////////////////////////////////////////////////////////////////////////////////
// 获取持仓的可用数量
Front.prototype.getPositionVailable = function (pos) {
  return pos.lastVolume + pos.todayVolume - pos.frozenVolume;
};

////////////////////////////////////////////////////////////////////////////////
// 获取持仓的平仓方向
Front.prototype.getCloseOrderSet = function (orderSet, pos, volume, price) {
  if (this.getPositionVailable(pos) < volume) {
    return; // 下单数量超出持仓数量
  }

  var that = this;
  // 计算除去冻结仓位的今仓与昨仓。
  var frozenLastVolume = pos.frozenVolume - pos.frozenTodayVolume;
  var lastVolume = pos.lastVolume - frozenLastVolume;
  var tdayVolume = pos.todayVolume - pos.frozenTodayVolume;

  // 计算今仓与昨仓的平仓数量。
  var left = volume - lastVolume;
  var direct = that.getCloseOrderDirection(pos.direction);
  if (left <= 0) {
    orderSet.push(that.makeOrder(pos.targetId, direct, that.offset_close_last, volume, price));
  } else {
    // 平完昨仓平今仓
    if (lastVolume > 0) {
      orderSet.push(that.makeOrder(pos.targetId, direct, that.offset_close_last, lastVolume, price));
    }
    orderSet.push(that.makeOrder(pos.targetId, direct, that.offset_close_today, left, price));
  }
};

////////////////////////////////////////////////////////////////////////////////
Front.prototype.makeOrder = function (targetId, direct, offset, volume, price) {
  var order = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Order();
  order.setOrderRef(this.getNextOrderRef());
  order.setTargetId(targetId);
  order.setVolume(volume);
  order.setPrice(price);
  order.setOffset(offset);
  order.setDirection(direct);
  return order;
};

////////////////////////////////////////////////////////////////////////////////
// 格式化各个信息
Front.prototype.formatTick = function (quote) {
  quote.priceTick = Math.round(quote.priceTick * 1000000) / 1000000;
  var bit = __WEBPACK_IMPORTED_MODULE_1__art_Art_js__["a" /* default */].digit(quote.priceTick);
  quote.latestPrice = quote.latestPrice.toFixed(bit);
  quote.askPrice1 = quote.askPrice1.toFixed(bit);
  quote.bidPrice1 = quote.bidPrice1.toFixed(bit);
  quote.highPrice = quote.highPrice.toFixed(bit);
  quote.highStopPrice = quote.highStopPrice.toFixed(bit);
  quote.lastClosePrice = quote.lastClosePrice.toFixed(bit);
  quote.lastSettlementPrice = quote.lastSettlementPrice.toFixed(bit);
  quote.lowPrice = quote.lowPrice.toFixed(bit);
  quote.lowStopPrice = quote.lowStopPrice.toFixed(bit);
  quote.openPrice = quote.openPrice.toFixed(bit);
  quote.settlementPrice = quote.settlementPrice.toFixed(bit);
};

////////////////////////////////////////////////////////////////////////////////
// 清理数据。
impl.clear = function (front) {
  front.user = null;
  front.init = false;
  front.tick.clear();
  front.kbar.clear();
  front.flash.clear();
  front.selected.clear();
  front.condition.clear();
  front.dominant.clear();
  __WEBPACK_IMPORTED_MODULE_1__art_Art_js__["a" /* default */].clear(front.targetList);
  __WEBPACK_IMPORTED_MODULE_1__art_Art_js__["a" /* default */].clear(front.targetSet);
  __WEBPACK_IMPORTED_MODULE_1__art_Art_js__["a" /* default */].clear(front.exchangeSet);
  __WEBPACK_IMPORTED_MODULE_1__art_Art_js__["a" /* default */].clear(front.productSet);
  __WEBPACK_IMPORTED_MODULE_7__Model_js__["a" /* default */].release();
};

////////////////////////////////////////////////////////////////////////////////
// 网络断开通知。
// @onClose.activeClose：是否主动断开连接。
Front.prototype.setEvent = function (onOpen, onClose) {
  var _this = this;

  this.websocket.setEvent(onOpen, function (active) {
    return onClose(active);
  }, function () {
    return impl.clear(_this);
  });
};
Front.prototype.close = function () {
  this.websocket.close();
};
Front.prototype.opened = function () {
  this.websocket.opened();
};

////////////////////////////////////////////////////////////////////////////////
// 程序异常断开时，自动加载当前页面数据。
Front.prototype.autoMount = function (pageMount) {
  var that = this;
  var login = function login(_resolve, reject) {
    var option = {
      upgrade: function upgrade(user) {
        return false;
      },
      resolve: function resolve(user) {
        _resolve();
      },
      loginReject: function loginReject(error) {
        reject();
      }
    };
    that.login_do(that.loginReq.getAccount(), that.loginReq.getPassword(), option);
  };
  that.websocket.mount(pageMount, login, __WEBPACK_IMPORTED_MODULE_1__art_Art_js__["a" /* default */].bind(that, that.ready));
};

////////////////////////////////////////////////////////////////////////////////
// 初始化就绪
Front.prototype.ready = function () {
  var that = this;
  return that.user != null && that.init;
};

////////////////////////////////////////////////////////////////////////////////
// 前置机登录：手动登录。
Front.prototype.login = function (address, account, password, option) {
  var that = this;
  var addressSet = [];
  that.close();
  /*
  if (process.env.NODE_ENV === 'development')
    console.log('env:' + process.env.NODE_ENV);
  addressSet.push("ws://" + address + ":42205");
  // if(process.env.NODE_ENV === 'production'){
  addressSet.push("ws://" + address + ":42206");
  addressSet.push("ws://" + address + ":42207");
  addressSet.push("ws://" + address + ":42208");
  addressSet.push("ws://" + address + ":42209");
  // }
  */

  addressSet.push("ws://" + address + ":43205");
  addressSet.push("ws://" + address + ":43206");
  that.websocket.setAddress(address, addressSet);

  // 手动登录失败，需断开连接（避免登录前断开服务端会有断开延迟，导致登录）
  option.loginReject = function (error) {
    option.reject(error);
    that.close();
  };
  that.login_do(account, password, option);
};

Front.prototype.regReconnect = function (fun) {
  this._regreconnect = fun;
};

////////////////////////////////////////////////////////////////////////////////
// 前置机登录
Front.prototype.login_do = function (account, password, option) {
  var that = this;
  if (false) console.log('login_do');
  // #1.登录初始化：查询持仓列表。
  var init_position = function init_position() {
    __WEBPACK_IMPORTED_MODULE_7__Model_js__["a" /* default */].trader.position.query(function () {
      that.init = true;
      if (false) console.log("init position ok");
      option.resolve(that.user);
    }, function (error) {
      option.loginReject(error);
    }, 13000);
  };

  // #2.登录初始化：查询合约列表。
  var init_target = function init_target() {
    that.queryTarget("", function (dataList) {
      that.targetList = dataList;
      impl.setTargetList(that, that.targetList);
      if (false) console.log("init target ok");
      init_position();
    }, function (error) {
      option.loginReject(error);
    });
    if (that._regreconnect) {
      that._regreconnect();
    }
  };

  // #3.登录初始化：委托与成交数据。
  that.websocket.subscribe(Front.proto_order_pub, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Order, function (pub) {
    __WEBPACK_IMPORTED_MODULE_7__Model_js__["a" /* default */].trader.onOrder(pub);
  });
  that.websocket.subscribe(Front.proto_trade_pub, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Trade, function (pub) {
    __WEBPACK_IMPORTED_MODULE_7__Model_js__["a" /* default */].trader.onTrade(pub, that.init);
  });
  // #4.登录系统
  impl.clear(that);
  that.loginReq = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.LoginReq();
  that.loginReq.setAccount(account);
  that.loginReq.setPassword(password);
  that.loginReq.reqType = Front.proto_login_req;
  that.websocket.send(that.loginReq, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.LoginRsp, {
    timeout: 10000,
    resolve: function resolve(user) {
      that.user = user;
      if (false) console.log("init login ok");
      // 自动升级
      if (option.upgrade(user)) return;
      init_target();
    },
    reject: function reject(error) {
      option.loginReject(error);
    }
  });
};

////////////////////////////////////////////////////////////////////////////////
/**
 * 修改账户密码
 * @param {String} pwd_old 旧密码。
 * @param {String} pwd_new 新密码。
 */
Front.prototype.updatePassword = function (pwd_old, pwd_new, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.UserPasswdUpdateReq();
    req.setOldPasswd(pwd_old);
    req.setNewPasswd(pwd_new);
    req.setBroker(that.user.broker);
    req.setUserId(that.user.account);
    req.reqType = Front.proto_user_passwd_update_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.UserPasswdUpdateRsp, {
      resolve: resolve,
      reject: reject
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
// 查询资金。
Front.prototype.queryCapital = function (onRsp) {
  var that = this;
  if (that.ready()) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.CapitalReq();
    req.reqType = Front.proto_capital_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.CapitalRsp, {
      control: {
        discard: true,
        interval: 2000
      },
      resolve: function resolve(data) {
        onRsp(data);
      },
      reject: function reject(error) {
        onRsp(undefined, error);
      }
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
// 获取报单引用
Front.prototype.getNextOrderRef = function () {
  var that = this;
  if (!that.ready()) {
    return;
  }
  // OrderRef的生成算法参照：ctp::get_order_ref().
  var order_ref = ++that.user.maxOrderRef;
  var result = "#";
  result += that.user.frontId;
  result += "#";
  result += that.user.sessionId;
  result += "#";
  result += order_ref;
  return result;
};

////////////////////////////////////////////////////////////////////////////////
// 查询持仓信息。
Front.prototype.queryPosition = function (target_id, resolve, reject, millsec) {
  var that = this;
  if (that.user != null) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.PositionReq();
    req.setTargetId(target_id);
    req.reqType = Front.proto_position_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.PositionRsp, {
      reject: reject,
      resolve: resolve,
      control: {
        discard: false,
        taskName: "position"
      },
      // 获取持仓失败，则强制断开。
      timeout: millsec,
      timeoutClose: true
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
// 委托下单。
Front.prototype.insertOrder = function (order, resolve, reject) {
  var that = this;
  if (that.ready()) {
    order.reqType = Front.proto_insert_order_req;
    that.websocket.send(order, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.InsertOrderRsp, {
      resolve: resolve,
      reject: reject,
      timeout: 0
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
// 取消订单。
Front.prototype.cancelOrder = function (corder, resolve, reject) {
  var that = this;
  if (that.ready()) {
    corder.reqType = Front.proto_cancel_order_req;
    that.websocket.send(corder, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.CancelOrderRsp, {
      resolve: resolve,
      reject: reject,
      timeout: 0
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
// 查询合约列表。
Front.prototype.productTarget = function (productId) {
  var ids = [];
  var list = this.productSet[productId];
  if (list !== undefined) {
    for (var i = 0; i < list.targetSet.length; ++i) {
      var target = list.targetSet[i];
      ids.push(target.id);
    }
  }
  return ids;
};

////////////////////////////////////////////////////////////////////////////////
// 查询合约列表。
Front.prototype.queryTarget = function (target_id, resolve, reject) {
  var that = this;
  if (that.user != null) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.TargetReq();
    req.setTargetId(target_id);
    req.reqType = Front.proto_insinfo_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.TargetRsp, {
      control: {
        discard: false,
        taskName: "target"
      },
      resolve: resolve,
      reject: reject
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
/**
 * 查询最大开仓数量
 * @param {String} req.targetId 合约代码rb1805。
 * @param {Front.prototype.direct} req.direct 买卖方向
 */
Front.prototype.getMaxOrderVolume = function (req, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req_pb = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.MaxOrderVolume();
    req_pb.setTargetId(req.targetId);
    req_pb.setDirection(req.direct);
    req_pb.reqType = Front.proto_max_order_volume_req;
    that.websocket.send(req_pb, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.MaxOrderVolumeRsp, {
      timeout: 3000,
      resolve: resolve,
      reject: reject
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
/*@订阅行情Tick：交易界面；行情界面。
* @para.targetId：合约ID或者品种ID。
* @para.suber: 订阅者ID，或者订阅者。

* @案例：
1.按单个合约订阅。
subTick("rbn805", "trade_page");
2.按品种订阅。
subTick("rb", {
    suberId: "trade_page",
    publish: function(tick) {}
});
*/
Front.prototype.subTick = function (targetId, suber) {
  var that = this;
  if (!that.ready()) {
    return;
  }

  // 本地订阅发布管理
  var option = __WEBPACK_IMPORTED_MODULE_0__tmi_Tmi_js__["a" /* default */].isProduct(targetId) ? {
    suber: suber,
    topicId: targetId,
    topicType: __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].SetTopic,
    topicSelect: that.productTarget(targetId),
    topicGroup: {
      groupId: "product",
      topicId: function topicId(tick) {
        return __WEBPACK_IMPORTED_MODULE_0__tmi_Tmi_js__["a" /* default */].productId(tick.targetId);
      }
    }
  } : {
    suber: suber,
    topicId: targetId,
    topicType: __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].OneTopic,
    topicGroup: {
      groupId: "target",
      topicId: function topicId(tick) {
        return tick.targetId;
      }
    }
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.tick.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(Front.proto_tick_pub, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Quote, function (pub) {
      that.formatTick(pub);
      that.tick.publish(pub, pub.targetId);
    });
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.SubTickReq();
    req.reqType = Front.proto_tick_sub_req;
    req.setTargetList(result.sub);
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.SubTickRsp, {
      resolve: suber === undefined ? suber : suber.resolve,
      reject: suber === undefined ? that.onError : suber.reject
    });
  }
  return result.subject;
};

////////////////////////////////////////////////////////////////////////////////
// 取消订阅Tick行情
Front.prototype.unsubTick = function (targetId, suberId) {
  var that = this;
  if (!that.ready()) {
    return;
  }
  // 从主题中移除订阅者
  // 若主题不存在订阅者，则取消服务器端的订阅。
  var unsubs = this.tick.unsubscribe(targetId, suberId);
  if (unsubs) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.SubTickReq();
    req.reqType = Front.proto_tick_unsub_req;
    req.setTargetList(unsubs);
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.SubTickRsp, {
      timeout: 0
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
// 关闭API，关闭网络。
impl.getTopicId = function (targetId, ktype, kunit) {
  return targetId + "#" + ktype + "#" + kunit;
};

////////////////////////////////////////////////////////////////////////////////
/*@订阅行情数据Kbar
 * @targetId：合约ID（如rb1805）
 * @ktype：K线类型，参见Front.prototype.ktype
 * @kunit：K线单位。
 */
Front.prototype.subKbar = function (targetId, ktype, kunit, suber) {
  var that = this;
  if (!that.ready()) {
    return;
  }

  // 本地订阅发布管理
  var option = {
    suber: suber,
    topicId: impl.getTopicId(targetId, ktype, kunit),
    topicType: __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].SeqTopic,
    topicGroup: {
      groupId: "kbar",
      topicId: function topicId(kbar) {
        if (false) console.log(kbar);
        return impl.getTopicId(kbar.targetId, kbar.ktype, kbar.kunit);
      }
    }
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.kbar.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(Front.proto_kbar_pub, __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.Kbar, function (pub, snap) {
      return that.kbar.publish(pub, undefined, snap);
    });
    var req = new __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.SubKbar();
    req.reqType = Front.proto_kbar_sub_req;
    req.setTargetId(targetId);
    req.setKtype(ktype);
    req.setKunit(kunit);
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.SubKbarRsp, {
      resolve: suber === undefined ? suber : suber.resolve,
      reject: suber === undefined ? that.onError : suber.reject
    });
  }
  return result.subject;
};
// 取消订阅行情K线
Front.prototype.unsubKbar = function (targetId, ktype, kunit, suberId) {
  var that = this;
  if (!that.ready()) {
    return;
  }
  // 从主题中移除订阅者
  // 若主题不存在订阅者，则取消服务器端的订阅。
  var topicId = impl.getTopicId(targetId, ktype, kunit);
  if (false) console.log("unsubKbar" + topicId);
  var unsubs = this.kbar.unsubscribe(topicId, suberId);
  if (unsubs) {
    var req = new __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.SubKbar();
    req.reqType = Front.proto_kbar_unsub_req;
    req.setTargetId(targetId);
    req.setKtype(ktype);
    req.setKunit(kunit);
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.SubKbarRsp);
  }
};

////////////////////////////////////////////////////////////////////////////////
// 查询合约时间序列。
Front.prototype.getKbarTimeSeq = function (targetId, ktype, kunit, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.TimeSeqReq();
    req.setTargetId(targetId);
    req.setKtype(ktype);
    req.setKunit(kunit);
    req.reqType = Front.proto_time_seq_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.TimeSeqRsp, {
      resolve: resolve,
      reject: reject
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
/* @添加自选股*/
Front.prototype.selectedTargetAdd = function (targetId, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.TargetSelected();
    req.setTargetId(targetId);
    req.reqType = Front.proto_target_selected_add_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.TargetSelectedRsp, {
      resolve: resolve,
      reject: reject
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
/* @删除自选股*/
Front.prototype.selectedTargetRemove = function (targetId, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.TargetSelectedReq();
    req.setTargetId(targetId);
    req.reqType = Front.proto_target_selected_remove_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.TargetSelectedRsp, {
      resolve: resolve,
      reject: reject
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
/* @订阅自选股*/
Front.prototype.selectedTargetSub = function (suber) {
  var that = this;
  if (!that.ready()) {
    return;
  }

  // 本地订阅发布管理
  var option = {
    suber: suber,
    topicId: that.user.account,
    topicType: __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].SetTopic,
    topicSelect: function topicSelect(pub) {
      return true;
    },
    topicGroup: {
      groupId: "selected",
      topicId: function topicId(pub) {
        return that.user.account;
      }
    }
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.selected.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(Front.proto_target_selected_pub, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.TargetSelected, function (pub, snap, remove) {
      return that.selected.publish(pub, pub.targetId, snap, remove);
    });
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Subscribe();
    req.reqType = Front.proto_target_selected_sub_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Response, {
      resolve: suber === undefined ? suber : suber.resolve,
      reject: suber === undefined ? that.onError : suber.reject
    });
  }
  return result.subject;
};

////////////////////////////////////////////////////////////////////////////////
/* @取消订阅自选股*/
Front.prototype.selectedTargetUnsub = function (suberId) {
  var that = this;
  if (that.ready() && this.selected.unsubscribe(that.user.account, suberId)) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Subscribe();
    req.reqType = Front.proto_target_selected_unsub_req;
    that.websocket.send(req);
  }
};

////////////////////////////////////////////////////////////////////////////////
/* @订阅主力合约
 */
Front.prototype.dominantTargetSub = function (suber) {
  var that = this;
  if (!that.ready()) {
    return;
  }

  // 本地订阅发布管理
  var option = {
    suber: suber,
    topicId: that.user.account,
    topicType: __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].SetTopic,
    topicGroup: {
      groupId: "dominant",
      topicId: function topicId(d) {
        return that.user.account;
      }
    }
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.dominant.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(Front.proto_target_dominant_pub, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Dominant, function (pub, snap) {
      return that.dominant.publish(pub, pub.targetId, snap);
    });
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Subscribe();
    req.reqType = Front.proto_target_dominant_sub_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Response, {
      resolve: suber === undefined ? suber : suber.resolve,
      reject: suber === undefined ? that.onError : suber.reject
    });
  }
  return result.subject;
};

////////////////////////////////////////////////////////////////////////////////
/* @取消订阅主力合约
 */
Front.prototype.dominantTargetUnsub = function (suberId) {
  var that = this;
  if (that.ready() && this.dominant.unsubscribe(that.user.account, suberId)) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Subscribe();
    req.reqType = Front.proto_target_dominant_unsub_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Response);
  }
};

////////////////////////////////////////////////////////////////////////////////
/* @ 添加与修改条件单
 */
Front.prototype.conditionOrderSave = function (conditionOrder, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = conditionOrder;
    req.reqType = Front.proto_order_conditional_save_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.OrderConditionalRsp, {
      resolve: resolve,
      reject: reject
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
/* @ 删除条件单
 */
Front.prototype.conditionOrderRemove = function (broker, account, id, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.OrderConditionalReq();
    req.setBroker(broker);
    req.setAccount(account);
    req.setId(id);
    req.reqType = Front.proto_order_conditional_remove_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.OrderConditionalRsp, {
      resolve: resolve,
      reject: reject
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
/* @ 订阅条件单
 */
Front.prototype.conditionOrderSub = function (suber) {
  var that = this;
  if (!that.ready()) {
    return;
  }

  // 本地订阅发布管理
  var option = {
    suber: suber,
    topicId: that.user.account,
    topicType: __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].SetTopic,
    topicSelect: function topicSelect(pub) {
      return true;
    },
    topicGroup: {
      groupId: "condition_order",
      topicId: function topicId(pub) {
        return that.user.account;
      }
    }
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.condition.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(Front.proto_order_conditional_pub, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.OrderConditional, function (pub, snap, remove) {
      return that.condition.publish(pub, pub.id, snap, remove);
    });
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Subscribe();
    req.reqType = Front.proto_order_conditional_sub_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Response, {
      resolve: suber === undefined ? suber : suber.resolve,
      reject: suber === undefined ? that.onError : suber.reject
    });
  }
  return result.subject;
};

////////////////////////////////////////////////////////////////////////////////
/* @ 取消订阅条件单
 */
Front.prototype.conditionOrderUnsub = function (suberId) {
  var that = this;
  if (that.ready() && this.condition.unsubscribe(that.user.account, suberId)) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Subscribe();
    req.reqType = Front.proto_order_conditional_unsub_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.Response);
  }
};

////////////////////////////////////////////////////////////////////////////////
/* @ 查询(已触发)条件单
 */
Front.prototype.conditionOrderQry = function (broker, account, start, end, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.OrderConditionGetReq();
    req.setBroker(broker);
    req.setAccount(account);
    req.setStartTime(start);
    req.setLastTime(end);

    req.reqType = Front.proto_order_conditional_get_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_5__CtpFront_pb_js___default.a.OrderConditionGetRsp, {
      resolve: resolve,
      reject: reject
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
// 接口消息ID
// 订阅行情K线（1分钟/5分钟）
impl.kbar_sub_req = 1050;
impl.kbar_sub_rsp = 1051;
impl.kbar_unsub_req = 1052;
impl.kbar_unsub_rsp = 1053;
impl.kbar_pub = 1054;
impl.kbar_get_req = 1055;
impl.kbar_get_rsp = 1056;
// 订阅行情分时图（1分钟）
impl.kbar_time_seq_req = 1057;
impl.kbar_time_seq_rsp = 1058;

////////////////////////////////////////////////////////////////////////////////
Front.getTopicId = function (targetId, ktype, kunit) {
  return targetId + "#" + ktype + "#" + kunit;
};

////////////////////////////////////////////////////////////////////////////////
// 获取合约的价格精度
Front.prototype.getTargetPrecision = function (targetId) {
  var target = this.targetSet[targetId];
  if (target === undefined) return 0;
  return __WEBPACK_IMPORTED_MODULE_1__art_Art_js__["a" /* default */].digit(target.priceTick);
};
// 格式化各个信息
Front.prototype.formatKbar = function (kbar) {
  var target = this.targetSet[kbar.targetId];
  if (target === undefined) return;
  var bit = __WEBPACK_IMPORTED_MODULE_1__art_Art_js__["a" /* default */].digit(target.priceTick);
  kbar.priceOpen = kbar.priceOpen.toFixed(bit);
  kbar.priceClose = kbar.priceClose.toFixed(bit);
  kbar.priceLow = kbar.priceLow.toFixed(bit);
  kbar.priceHigh = kbar.priceHigh.toFixed(bit);
  kbar.priceAverage = kbar.priceAverage.toFixed(bit);
};

////////////////////////////////////////////////////////////////////////////////
/**
 * 订阅行情数据Kbar与分时图数据。
 * @param {String} kReq.targetId 合约代码rb1805。
 * @param {Front.prototype.ktype} kReq.ktype K线类型
 * @param {number} kReq.kunit  K线单位数。
 * @param {Front.prototype.kopt} kReq.koption K线合成选项。
 * @param {Front.prototype.kquery} kReq.kquery K线查询模式。
 * @param {String} kReq.endTime 查询截止的时间单位。
 * @param {String} kReq.startTime 开始时间单元。
 * @param {number} kReq.ksize 查询K线个数/K线天数。
 * @param {Object} suber 订阅者视图
 */
Front.prototype.subKbar2 = function (kReq, suber) {
  var that = this;
  if (!that.ready()) {
    return;
  }
  if (kReq.kquery != Front.prototype.kquery_size && kReq.kquery != Front.prototype.kquery_days && kReq.kquery != Front.prototype.kquery_time) {
    throw new Error("[subkbar] kReq.kquery invalid.");
  }

  // 本地订阅发布管理
  var option = {
    suber: suber,
    topicId: Front.getTopicId(kReq.targetId, kReq.ktype, kReq.kunit),
    topicType: __WEBPACK_IMPORTED_MODULE_2__art_Topic_js__["a" /* default */].SeqTopic,
    topicGroup: {
      groupId: "kbar",
      topicId: function topicId(kbar) {
        return Front.getTopicId(kbar.targetId, kbar.ktype, kbar.kunit);
      }
    }
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.kbar.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(impl.kbar_pub, __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.Kbar, function (pub, snap) {
      that.formatKbar(pub);
      that.kbar.publish(pub, undefined, snap);
    });

    // 构建请求数据
    var req = new __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.SubKbar();
    req.reqType = impl.kbar_sub_req;
    req.setTargetId(kReq.targetId);
    req.setKtype(kReq.ktype);
    req.setKunit(kReq.kunit);
    req.setKoption(kReq.koption);
    req.setKquery(kReq.kquery);
    req.setKsize(kReq.ksize);
    req.setEndTime(kReq.endTime);
    req.setStartTime(kReq.startTime);

    // 发送请求数据
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.SubKbarRsp, {
      resolve: suber === undefined ? suber : suber.resolve,
      reject: suber === undefined ? that.onError : suber.reject
    });
  }
  return result.subject;
};

////////////////////////////////////////////////////////////////////////////////
/**
 * 取消订阅行情K线
 * @param {String} kReq.targetId 合约代码rb1805。
 * @param {Front.prototype.ktype} kReq.ktype K线类型
 * @param {number} kReq.kunit  K线单位数。
 * @param {Object} suberId 订阅者视图ID
 */
Front.prototype.unsubKbar2 = function (kReq, suberId) {
  var that = this;
  if (!that.ready()) {
    return;
  }
  // 从主题中移除订阅者
  // 若主题不存在订阅者，则取消服务器端的订阅。
  var topicId = Front.getTopicId(kReq.targetId, kReq.ktype, kReq.kunit);
  var unsubs = this.kbar.unsubscribe(topicId, suberId);
  if (unsubs) {
    var req = new __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.SubKbar();
    req.reqType = impl.kbar_unsub_req;
    req.setTargetId(kReq.targetId);
    req.setKtype(kReq.ktype);
    req.setKunit(kReq.kunit);
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.SubKbarRsp);
  }
};

////////////////////////////////////////////////////////////////////////////////
/**
 * 查询合约时间序列。
 * @param {String} kreq.targetId 合约代码rb1805。
 * @param {Front.prototype.ktype} kreq.ktype K线类型
 * @param {number} kreq.kunit  K线单位数。
 * @param {Front.prototype.kopt} kreq.resolve K线合成选项。
 * @param {Front.prototype.kquery} kreq.reject K线查询模式。
 */
Front.prototype.getKbarTimeSeq2 = function (kreq) {
  var that = this;
  if (that.ready()) {
    var req = new __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.TimeSeqReq();
    req.setTargetId(kreq.targetId);
    req.setKtype(kreq.ktype);
    req.setKunit(kreq.kunit);
    req.reqType = impl.kbar_time_seq_req;
    that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.TimeSeqRsp, {
      resolve: kreq.resolve,
      reject: kreq.reject
    });
  }
};

////////////////////////////////////////////////////////////////////////////////
/**
 * 订阅行情数据Kbar与分时图数据。
 * @param {String} kReq.targetId 合约代码rb1805。
 * @param {Front.prototype.ktype} kReq.ktype K线类型
 * @param {number} kReq.kunit  K线单位数。
 * @param {Front.prototype.kopt} kReq.koption K线合成选项。
 * @param {Front.prototype.kquery} kReq.kquery K线查询模式。
 * @param {String} kReq.endTime 查询截止的时间单位。
 * @param {String} kReq.startTime 开始时间单元。
 * @param {number} kReq.ksize 查询K线个数/K线天数。
 * @param {Object} suber 订阅者视图
 */
Front.prototype.getKbar2 = function (kReq, on_resolve, on_reject) {
  var that = this;
  if (!that.ready()) {
    return;
  }

  // 构建请求数据
  var req = new __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.SubKbar();
  req.reqType = impl.kbar_get_req;
  req.setTargetId(kReq.targetId);
  req.setKtype(kReq.ktype);
  req.setKunit(kReq.kunit);
  req.setKoption(kReq.koption);
  req.setKquery(kReq.kquery);
  req.setKsize(kReq.ksize);
  req.setEndTime(kReq.endTime);
  req.setStartTime(kReq.startTime);

  // 发送请求数据
  var kbar_set = new Array();
  that.websocket.send(req, __WEBPACK_IMPORTED_MODULE_4__Market_pb_js___default.a.GetKbarRsp, {
    resolve: function resolve(kbar, last) {
      if (kbar) kbar_set.push(kbar);
      if (last) on_resolve(kbar_set);
    },
    reject: function reject(error) {
      on_reject(error);
    }
  });
};
////////////////////////////////////////////////////////////////////////////////
/* harmony default export */ __webpack_exports__["a"] = (new Front());

/***/ }),

/***/ "7C6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = updArrayById;
/* unused harmony export clearArr */
/* harmony export (immutable) */ __webpack_exports__["e"] = isZero;
/* harmony export (immutable) */ __webpack_exports__["d"] = isParentOfEventElement;
/* harmony export (immutable) */ __webpack_exports__["f"] = toast;
/* harmony export (immutable) */ __webpack_exports__["c"] = indicator;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeIndicator;
/* harmony export (immutable) */ __webpack_exports__["b"] = confirm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_proto_art_Art__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);




function updArrayById(data, array) {
    var index = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(array, function (r) {
        return r.id === data.id;
    });
    if (data.stamp === __WEBPACK_IMPORTED_MODULE_0__static_js_proto_art_Art__["a" /* default */].meta.stamp_remove) {
        if (index !== -1) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(array, index);
        }
        return;
    }
    if (index === -1) {
        array.push(data);
    } else {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(array, index, data);
    }
}
function clearArr(arr) {
    for (var i = arr.length - 1; i >= 0; i--) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(arr, i);
    }
}
function isZero(n) {
    var k;
    if (typeof n === 'string') {
        k = parseFloat(n);
    } else {
        k = n;
    }
    if (k === 0 || isNaN(k)) {
        return true;
    }
    return false;
}
function isParentOfEventElement(parent, event) {
    var e = event;
    var path = e.path || e.composedPath && e.composedPath();
    if (path) {
        return path.includes(parent);
    } else {
        var ele = event.target;
        while (ele) {
            if (ele === parent) {
                return true;
            }
            ele = ele.parentNode;
        }
        return false;
    }
}
function toast(message) {
    Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
        message: message,
        position: 'bottom',
        duration: 3000
    });
}
function indicator(msg) {
    __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Indicator"].open(msg);
}
function closeIndicator() {
    __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Indicator"].close();
}
function confirm(messages, titles, confirmButtonTexts, cancelButtonTexts) {
    return __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"].confirm('', {
        message: messages,
        title: titles,
        confirmButtonText: confirmButtonTexts,
        cancelButtonText: cancelButtonTexts,
        showCancelButton: true
    });
}

/***/ }),

/***/ "7S4n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7fja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_OrderSearch_ts__ = __webpack_require__("kGcR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a57d1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSearch_vue__ = __webpack_require__("KF17");
function injectStyle (ssrContext) {
  __webpack_require__("gSyU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13a57d1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_OrderSearch_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a57d1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8/UU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "802T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"header"},[_c('span',{on:{"click":_vm.goback}},[_c('i',{staticClass:"icon iconfont left"},[_vm._v("")]),_vm._v("\n      返回\n    ")]),_vm._v("\n    提款记录")]),_vm._v(" "),_c('div',{staticClass:"not-trigger"},[_vm._m(0),_vm._v(" "),_c('div',{ref:"wrapper",staticClass:"content"},[_c('ul',{ref:"list"},[_c('li',{ref:"fristD",staticClass:"positionImg positionImgs"},[(_vm.refer == '正在刷新.....')?_c('img',{attrs:{"src":_vm.load,"alt":""}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.refer))])]),_vm._v(" "),_vm._l((_vm.datas),function(item,index){return _c('li',{key:index,staticClass:"list",on:{"click":function($event){_vm.handleMessage(item, index)}}},[_c('span',[_vm._v(_vm._s(item.Indate))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.TotalMoney))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.realMoney(item)))])])}),_vm._v(" "),(_vm.listLength >= 20)?_c('li',{ref:"lastD",staticClass:"positionImg"},[(_vm.UpLoad == '正在加载.....')?_c('img',{attrs:{"src":_vm.load,"alt":""}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.UpLoad))])]):_vm._e()],2),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":_vm.load,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('p',{class:['msg', {msgs:_vm.msgShow}]},[_vm._v(_vm._s(_vm.referMeg))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"title"},[_c('li',[_vm._v("时间")]),_vm._v(" "),_c('li',[_vm._v("提款金额")]),_vm._v(" "),_c('li',[_vm._v("实际到账")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8XM0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isPc() {
    var uaInfo = navigator.userAgent;
    var agents = ['Android', 'iPhone', 'Windows Phone', 'iPad', 'iPod'];
    var flag = true;
    for (var _i = 0, agents_1 = agents; _i < agents_1.length; _i++) {
        var item = agents_1[_i];
        if (uaInfo.indexOf(item) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}
function emit(vnode, name) {
    var _a;
    var data = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        data[_i - 2] = arguments[_i];
    }
    var handlers = vnode.data && vnode.data.on || vnode.componentOptions && vnode.componentOptions.listeners;
    if (handlers && handlers[name]) {
        (_a = handlers[name]).fns.apply(_a, data);
    }
}
var Helper = function () {
    function Helper() {
        this.tapObj = {
            pageX: 0,
            pageY: 0,
            clientX: 0,
            clientY: 0,
            distanceX: 0,
            distanceY: 0
        };
    }
    Helper.prototype.isTap = function (self) {
        if (self.disabled) {
            return false;
        }
        var tapObj = this.tapObj;
        return this.time < 300 && Math.abs(tapObj.distanceX) < 10 && Math.abs(tapObj.distanceY) < 10;
    };
    Helper.prototype.setMethod = function (el, binding, vnode) {
        var me = this;
        this.handler = function (e, isPcFlag) {
            if (el.href && !binding.modifiers.prevent) {
                return window.location = el.href;
            }
            var tagName = e.target.tagName.toLocaleLowerCase();
            if (tagName === 'input' || tagName === 'textarea') {
                return e.target.focus();
            }
            emit(vnode, 'tap', e, me.tapObj);
        };
        if (isPc()) {
            this.click = function (e) {
                if (binding.modifiers.stop) {
                    e.stopPropagation();
                }
                if (binding.modifiers.prevent) {
                    e.preventDefault();
                }
                me.handler(e, true);
            };
        } else {
            this.touchstart = function (e) {
                if (binding.modifiers.stop) {
                    e.stopPropagation();
                }
                if (binding.modifiers.prevent) {
                    e.preventDefault();
                }
                var touches = e.touches[0];
                var tapObj = me.tapObj;
                tapObj.pageX = touches.pageX;
                tapObj.pageY = touches.pageY;
                tapObj.clientX = touches.clientX;
                tapObj.clientY = touches.clientY;
                me.time = +new Date();
            };
            this.touchend = function (e) {
                var touches = e.changedTouches[0];
                var tapObj = me.tapObj;
                me.time = +new Date() - me.time;
                tapObj.distanceX = tapObj.pageX - touches.pageX;
                tapObj.distanceY = tapObj.pageY - touches.pageY;
                if (e.cancelable !== false) {
                    e.preventDefault();
                }
                if (!me.isTap(self)) {
                    return;
                }
                me.handler(e);
            };
        }
    };
    Helper.prototype.addListener = function (el) {
        if (isPc()) {
            el.addEventListener('click', this.click, false);
        } else {
            el.addEventListener('touchstart', this.touchstart, false);
            el.addEventListener('touchend', this.touchend, false);
        }
    };
    Helper.prototype.removeListener = function (el) {
        if (isPc()) {
            if (this.click) {
                el.removeEventListener('click', this.click, false);
            }
        } else {
            if (this.touchstart) {
                el.removeEventListener('touchstart', this.touchstart, false);
            }
            if (this.touchend) {
                el.removeEventListener('touchend', this.touchend, false);
            }
        }
    };
    return Helper;
}();
var tap = {
    bind: function bind(el, binding, vnode) {
        var helper = new Helper();
        helper.setMethod(el, binding, vnode);
        helper.addListener(el);
        el.vTapHelper = helper;
    },
    componentUpdated: function componentUpdated(el, binding, vnode) {
        var helper = el.vTapHelper;
        helper.tapObj = {};
        helper.handler = function (e) {
            if (el.href && !binding.modifiers.prevent) {
                return window.location = el.href;
            }
            emit(vnode, 'tap', e, el.tapObj);
        };
    },
    unbind: function unbind(el) {
        var helper = el.vTapHelper;
        helper.removeListener(el);
        helper.handler = function () {};
    }
};
var vueTap = {
    install: function install(Vue) {
        Vue.directive('tap', tap);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (vueTap);

/***/ }),

/***/ "8wi4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var priceTick = {
    namespaced: true,
    state: {
        priceTick: ''
    },
    mutations: {
        changePriceT: function changePriceT(state, val) {
            state.priceTick = val;
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (priceTick);

/***/ }),

/***/ "9AAL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TradeDetail_vue__ = __webpack_require__("++4z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06977f94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TradeDetail_vue__ = __webpack_require__("Qqht");
function injectStyle (ssrContext) {
  __webpack_require__("Kl8b")
  __webpack_require__("3n4W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06977f94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TradeDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06977f94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TradeDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9LER":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhuli.087b6d5.png";

/***/ }),

/***/ "9a+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[(_vm.flage)?_c('iframe',{staticClass:"inter",attrs:{"src":"","frameborder":"0"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"headerWrapper"},[_c('span',{staticClass:"install",on:{"click":_vm.goBack}},[_c('i',{staticClass:"icon iconfont"},[_vm._v("")]),_vm._v("\n      返回\n    ")]),_vm._v("\n    设置\n  ")]),_vm._v(" "),_c('ul',{staticClass:"setConent"},[_c('li',[_c('span',[_vm._v("当前版本号")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#ccc"}},[_vm._v(_vm._s(_vm.versions))])]),_vm._v(" "),_c('li',{on:{"click":_vm.changeword}},[_c('span',[_vm._v("修改密码")])]),_vm._v(" "),_c('li',{staticStyle:{"margin-top":"0.3rem"}},[_c('span',[_vm._v("下单,撤单,反手确认")]),_vm._v(" "),_c('span',[_c('onoff')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9esV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dyfooter_vue__ = __webpack_require__("RicZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da6a3cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dyfooter_vue__ = __webpack_require__("JF6L");
function injectStyle (ssrContext) {
  __webpack_require__("a7nu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5da6a3cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dyfooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da6a3cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dyfooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A/Xy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_CheckFullStop_ts__ = __webpack_require__("tKjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9c2180e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckFullStop_vue__ = __webpack_require__("pID5");
function injectStyle (ssrContext) {
  __webpack_require__("4AwN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c9c2180e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_CheckFullStop_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9c2180e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckFullStop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A96H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"header"},[_c('span',{on:{"click":_vm.goback}},[_c('i',{staticClass:"icon iconfont left"},[_vm._v("")]),_vm._v("\n      返回\n    ")]),_vm._v("\n    充值中心")]),_vm._v(" "),_c('div',{staticClass:"payType"},[_c('span',[_vm._v("充值金额:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],attrs:{"type":"number","pattern":"[0-9]*"},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}})]),_vm._v(" "),_c('ul',{staticClass:"moneySele"},_vm._l((_vm.moneyList),function(item,index){return _c('li',{key:index,class:{'liBg':index == _vm.selectMoney},on:{"click":function($event){_vm.handleSelect(item, index)}}},[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('div',{staticClass:"topUpWay"},[_c('p',[_vm._v("充值方式")]),_vm._v(" "),_c('ul',{staticClass:"rechargeWay"},_vm._l((_vm.rechargeWay),function(item,index){return _c('li',{key:item.ChannelId+item.ChannelSubId,on:{"click":function($event){_vm.handleWay(item, index)}}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.getImgPath(item.Img),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ChannelSubName))]),_vm._v(" "),(_vm.selectRecharge != index)?_c('i',{staticClass:"icon iconfont left"},[_vm._v("")]):_c('i',{staticClass:"icon iconfont left"},[_vm._v("")])])})),_vm._v(" "),(_vm.payLoad)?_c('div',{staticClass:"loading loadings"},[_c('img',{attrs:{"src":_vm.load,"alt":""}})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"recharge",on:{"click":_vm.handleEnter}},[_vm._v("立即充值")]),_vm._v(" "),(_vm.hintMsg)?_c('div',{staticClass:"errMsg"},[_vm._v("请输入正确金额")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hintImg),expression:"hintImg"}],staticClass:"qrCodeBox"},[_c('canvas',{ref:"codes",attrs:{"hidden":""}}),_vm._v(" "),_c('div',{staticClass:"hintMassage"},[_vm._v(_vm._s(_vm.downLoadMessage))]),_vm._v(" "),_c('img',{staticClass:"code",attrs:{"src":_vm.downloadUrl,"alt":""}}),_vm._v(" "),(_vm.downLoadFlage)?_c('button',{staticClass:"hintImg",on:{"click":_vm.handleCloseQr}},[_vm._v("关闭")]):_c('div',{staticClass:"hintImgs"},[_c('button',{on:{"click":_vm.handleDownload}},[_vm._v("下载图片")]),_vm._v(" "),_c('button',{on:{"click":_vm.handleCloseQr}},[_vm._v("关闭")])]),_vm._v(" "),(_vm.saveSuccess)?_c('div',{staticClass:"hintMessage"},[_vm._v("保存成功")]):_vm._e()]),_vm._v(" "),(_vm.qrLoad)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":_vm.load,"alt":""}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Au9i":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("muBx"))(11);

/***/ }),

/***/ "BXlS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-trigger"},[_c('FixedTable',{staticClass:"container2",attrs:{"title":_vm.tableTitle,"isOp":false,"dataKey":"orderId","tableData":_vm.tableData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bfqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_Person_ts__ = __webpack_require__("vL01");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3403b6ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Person_vue__ = __webpack_require__("szfJ");
function injectStyle (ssrContext) {
  __webpack_require__("Yblz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3403b6ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_Person_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3403b6ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Person_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C3Fm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('div',{ref:"basekeyboard",staticClass:"basekeyboard"},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('i',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"icon iconfont reduce",on:{"tap":_vm.handleClose}},[_vm._v("")])]),_vm._v(" "),_c('div',{staticClass:"main"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C84v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_RadioButton_ts__ = __webpack_require__("2Vtt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33ded23c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioButton_vue__ = __webpack_require__("mUAu");
function injectStyle (ssrContext) {
  __webpack_require__("/1YE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33ded23c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_RadioButton_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33ded23c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CVC6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('yjheader',{attrs:{"leftIcon":"true","rightIcon":"false","title":"当前版本"}}),_vm._v(" "),_c('div',{staticClass:"homeBox"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"paragraph"},[_vm._v(_vm._s('版本号(version): '+_vm.version2))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dswc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Art_js__ = __webpack_require__("WvhM");




////////////////////////////////////////////////////////////////////////////////
// [MVC模型视图控制器，用于数据模型与视图的交互]
var me = {};
var he = {};
/* harmony default export */ __webpack_exports__["a"] = (me);

////////////////////////////////////////////////////////////////////////////////
/*@ 视图接口 */
me.View = function (view, onUpdate, onLoad, onRemove) {
    this.view = view;
    this.load = onLoad;
    this.update = onUpdate;
    this.remove = onRemove;
};

/*@ 视图模型 
* @ this.subject: 当前模型的主题对象。用于一个视图显示可切换显示不同数据对象，而每个视
图都对应了一个模型，模型中的数据通过load重新加载（切换）
*/
me.Model = function () {
    this.views = [];
    this.subject = undefined;
};
/*@ 加载数据 */
me.Model.prototype.mount = function (view, set) {
    // 优先使用load，若load未定义，再使用update。
    if (view.load instanceof Function) {
        view.load(set);
    } else if (view.update instanceof Function) {
        // 使用update：数组对象与单个对象
        if (set instanceof Array) {
            view.update(); // 清空视图
            for (var i = 0; i < set.length; ++i) {
                view.update(set[i], i);
            }
        } else {
            var obj = set;
            view.update(obj);
        }
    }
};
/*@ 重新加载对象集合，若无参数则清空对象。
* @ para.set：参数是数组Array，视图应重新加载对象——删除旧数据加载新数据。
*/
me.Model.prototype.load = function (set, subject) {
    this.subject = subject;
    for (var i = 0; i < this.views.length; ++i) {
        me.Model.prototype.mount(this.views[i], set);
    }
};
/*@ 插入/更新*/
me.Model.prototype.update = function (obj, index, subject) {
    if (this.subject == subject) {
        for (var i = 0; i < this.views.length; ++i) {
            if (this.views[i].update instanceof Function) {
                this.views[i].update(obj, index);
            }
        }
    }
};
/*@ 删除对象。*/
me.Model.prototype.remove = function (obj, index, subject) {
    if (this.subject == subject) {
        for (var i = 0; i < this.views.length; ++i) {
            if (this.views[i].remove instanceof Function) {
                this.views[i].remove(obj, index);
            }
        }
    }
};

////////////////////////////////////////////////////////////////////////////////
/*@ 绑定视图。
* @ view-key模式：参数为view的标识与其对应的数据操作函数。
* attach("view_order", onUpdate, onLoad, onRemove);
*
* @ view-obj模式：参数为view组件以及组件的成员方法。
* attach(page, page.onUpdate, page.onLoad, page.onRemove);
*/
me.Model.prototype.attach = function (view, onUpdate, onLoad, onRemove) {
    var type = typeof view === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(view);
    if (type == "string" || type == "number") {
        // view-key
        var viewer = new me.View(view, onUpdate, onLoad, onRemove);
    } else {
        // view-obj
        var viewer = new me.View(view, __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].bind(view, onUpdate), __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].bind(view, onLoad), __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].bind(view, onRemove));
    }
    // 视图存在则更新，否则新增。
    var index = this.findView(view);
    if (index != -1) {
        this.views[index] = viewer;
    } else {
        this.views.push(viewer);
    }
    return viewer;
};

////////////////////////////////////////////////////////////////////////////////
/*@ 解绑视图。*/
me.Model.prototype.detach = function (view) {
    var index = this.findView(view);
    if (index != -1) {
        this.views.splice(index, 1);
    }
};
me.Model.prototype.reset = function () {
    this.views = [];
};
/*@ 查找视图。*/
me.Model.prototype.findView = function (view) {
    for (var i = 0; i < this.views.length; ++i) {
        if (this.views[i].view == view) return i;
    }
    return -1;
};

//##############################################################################
/* 模型：只包含一个对象。
*/
me.OneModel = function () {
    this.object = undefined;
    me.Model.call(this);
};
__WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].extend(me.OneModel, me.Model);

/*@ 获取对象数据*/
me.OneModel.prototype.get = function () {
    return this.object;
};
/*@ 重新加载对象*/
me.OneModel.prototype.load = function (obj, subject) {
    this.object = obj;
    me.Model.prototype.load.call(this, obj, subject);
};
/*@ 插入/更新/重新加载/删除对象*/
me.OneModel.prototype.update = function (obj, subject) {
    if (this.subject == subject) {
        this.object = obj;
        me.Model.prototype.update.call(this, obj, undefined, subject);
    }
};
/*@ 绑定视图。
* @ para.onUpdate: 无参数时清空视图，否则新增或更新视图。
*/
me.OneModel.prototype.attach = function (view, onUpdate, onLoad) {
    var viewer = me.Model.prototype.attach.call(this, view, onUpdate, onLoad);
    me.Model.prototype.mount(viewer, this.object);
};
// 清空内容与视图
me.OneModel.prototype.reset = function () {
    this.object = undefined;
    me.Model.prototype.reset.call(this);
};

////////////////////////////////////////////////////////////////////////////////
/* 模型：包含一个对象集合。
*/
me.SetModel = function () {
    this.array = [];
    me.Model.call(this); // 继承
};
__WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].extend(me.SetModel, me.Model); // 继承
/*@ 获取对象*/
me.SetModel.prototype.get = function (id, Func) {
    var index = this.find(id);
    if (index == -1 && Func instanceof Function) {
        var obj = new Func();
        obj.id = id;
        this.array.push(obj);
        return obj;
    }
    return index == -1 ? undefined : this.array[index];
};
/*@ 查找对象的数组下标*/
me.SetModel.prototype.find = function (key, value) {
    if (arguments.length == 1) {
        value = key; // 对象ID
        key = "id";
    }
    for (var i = 0; i < this.array.length; ++i) {
        if (value == this.array[i][key]) return i;
    }
    return -1;
};
/*@ 重新加载对象*/
me.SetModel.prototype.load = function (set, subject) {
    this.array = set;
    me.Model.prototype.load.call(this, set, subject);
};
/*@ 插入/更新/重新加载
1.重新加载: (obj==Array) (obj===undefined)
*/
me.SetModel.prototype.update = function (obj, subject) {
    if (obj === undefined) obj = [];
    if (obj instanceof Array) {
        this.load(obj, subject); // 重新加载集合
        return;
    }
    if (this.subject == subject) {
        var index = this.find(obj.id);
        if (index == -1) {
            this.array.push(obj);
            index = this.array.length - 1;
        } else {
            this.array[index] = obj;
        }
        me.Model.prototype.update.call(this, obj, index, subject);
    }
};
/*@ 删除对象。*/
me.SetModel.prototype.remove = function (id, subject) {
    if (this.subject == subject) {
        var index = this.find(id);
        if (index != -1) {
            var obj = this.array[index];
            this.array.splice(index, 1);
            me.Model.prototype.remove.call(this, obj, index, subject);
        }
    }
};
/*@ 绑定视图。
* @ para.onUpdate: 无参数时清空视图，否则新增或更新视图。
*/
me.SetModel.prototype.attach = function (view, onUpdate, onLoad, onRemove) {
    var viewer = me.Model.prototype.attach.call(this, view, onUpdate, onLoad, onRemove);
    me.Model.prototype.mount(viewer, this.array);
};
// 清空内容与视图
me.SetModel.prototype.reset = function () {
    this.array = [];
    me.Model.prototype.reset.call(this);
};

////////////////////////////////////////////////////////////////////////////////
/* 模型：包含一个对象集合。
*/
me.SeqModel = function () {
    this.array = [];
    me.Model.call(this); // 继承
};
__WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].extend(me.SeqModel, me.Model); // 继承
/*@ 重新加载对象*/
me.SeqModel.prototype.load = function (set, subject) {
    this.array = set;
    me.Model.prototype.load.call(this, set, subject);
};
/*@ 插入/更新/重新加载
1.重新加载: (obj==Array) (obj===undefined)
*/
me.SeqModel.prototype.update = function (obj, subject) {
    if (obj === undefined) obj = [];
    if (obj instanceof Array) {
        this.load(obj, subject); // 重新加载集合
        return;
    }
    if (this.subject == subject) {
        this.array.push(obj);
        var index = this.array.length - 1;
        me.Model.prototype.update.call(this, obj, index, subject);
    }
};
/*@ 绑定视图。
* @ para.onUpdate: 无参数时清空视图，否则新增视图。
*/
me.SeqModel.prototype.attach = function (view, onUpdate, onLoad) {
    var viewer = me.Model.prototype.attach.call(this, view, onUpdate, onLoad);
    me.Model.prototype.mount(viewer, this.array);
};
// 清空内容与视图
me.SeqModel.prototype.reset = function () {
    this.array = [];
    me.Model.prototype.reset.call(this);
};

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("muBx"))(0);

/***/ }),

/***/ "EBaY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_better_scroll__ = __webpack_require__("GQaK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif__ = __webpack_require__("SBPU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_CrmHttp__ = __webpack_require__("n20g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_crm_enums__ = __webpack_require__("Xo8I");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var DrawMoneyRecord = (function (_super) {
    __extends(DrawMoneyRecord, _super);
    function DrawMoneyRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.refer = '下拉刷新';
        _this.referMeg = '已刷新';
        _this.msgShow = false;
        _this.UpLoad = '上拉加载更多';
        _this.uploadHint = true;
        _this.referHint = true;
        _this.listLength = '0';
        _this.load = __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif___default.a;
        _this.flage = true;
        _this.datas = [];
        return _this;
    }
    DrawMoneyRecord.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2];
            });
        });
    };
    DrawMoneyRecord.prototype.getData = function (start, end, flage) {
        return __awaiter(this, void 0, void 0, function () {
            var data, _i, _a, i, obj, a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_4__utils_CrmHttp__["a" /* postForm */])('/api/transfer-out/query', {
                                Start: start,
                                Limit: end,
                            })];
                    case 1:
                        data = _b.sent();
                        if (flage) {
                            this.datas = [];
                        }
                        if (!data.Data.length) {
                            this.UpLoad = '没有更多数据';
                            return [2];
                        }
                        for (_i = 0, _a = data.Data; _i < _a.length; _i++) {
                            i = _a[_i];
                            obj = {};
                            for (a in i) {
                                obj[a] = i[a];
                            }
                            this.datas.push(obj);
                        }
                        this.listLength = this.datas.length;
                        this.referMeg = '已刷新';
                        return [3, 3];
                    case 2:
                        e_1 = _b.sent();
                        this.referMeg = '刷新失败';
                        console.error(e_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    DrawMoneyRecord.prototype.activated = function () {
        var _this = this;
        this.refer = '下拉刷新';
        this.loading = true;
        this.datas = [];
        this.getData(0, 20, true)
            .then(function () { return _this.loading = false; })
            .catch(function () { return _this.loading = false; });
        this.$nextTick(function () {
            if (!_this.scroll) {
                var wrapper = _this.$refs.wrapper;
                var heig_1 = _this.$refs.fristD.offsetHeight;
                var heig2_1 = _this.$refs.wrapper.offsetHeight -
                    _this.$refs.list.offsetHeight;
                _this.scroll = new __WEBPACK_IMPORTED_MODULE_2_better_scroll__["a" /* default */](wrapper, {
                    startY: -heig_1,
                    click: true,
                    scrollY: true,
                    probeType: 3,
                });
                _this.scroll.on('scroll', function (req) {
                    if (req.y > -heig_1 - 5 || req.y < heig2_1) {
                        if (_this.flage) {
                            _this.scroll.stop();
                            _this.flage = false;
                        }
                    }
                    else {
                        _this.flage = true;
                        _this.refer = '下拉刷新';
                        _this.UpLoad = '上拉加载更多记录';
                    }
                    if (req.y - 20 > 0) {
                        if (_this.referHint) {
                            _this.refer = '松开立即刷新';
                        }
                    }
                    else if (req.y < heig2_1 - 20 && heig2_1 < 0) {
                        if (_this.uploadHint) {
                            _this.UpLoad = '松开立即加载';
                        }
                    }
                });
                _this.scroll.on('touchEnd', function (req) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(req.y > 0)) return [3, 2];
                                this.referHint = false;
                                this.refer = '正在刷新.....';
                                this.flage = true;
                                this.scroll.scrollTo(0, 0, 100);
                                return [4, this.getData(0, 20, true)];
                            case 1:
                                _a.sent();
                                this.flage = false;
                                this.msgShow = true;
                                setTimeout(function () {
                                    _this.msgShow = false;
                                }, 2000);
                                this.refer = '下拉刷新';
                                this.referHint = true;
                                setTimeout(function () {
                                    _this.scroll.scrollTo(0, -heig_1, 100);
                                }, 1);
                                return [3, 5];
                            case 2:
                                if (!(req.y > -heig_1 && req.y < 0)) return [3, 3];
                                setTimeout(function () {
                                    _this.scroll.scrollTo(0, -heig_1, 100);
                                }, 1);
                                return [3, 5];
                            case 3:
                                if (!(req.y < heig2_1 - 20 && heig2_1 < 0)) return [3, 5];
                                this.uploadHint = false;
                                this.UpLoad = '正在加载.....';
                                this.flage = true;
                                this.scroll.scrollTo(0, heig2_1, 100);
                                return [4, this.getData(this.listLength, 10, false)];
                            case 4:
                                _a.sent();
                                if (this.UpLoad != '没有更多数据') {
                                    this.UpLoad = '上拉加载更多记录';
                                }
                                this.uploadHint = true;
                                this.scroll.refresh();
                                _a.label = 5;
                            case 5:
                                heig_1 = this.$refs.fristD.offsetHeight;
                                heig2_1 = this.$refs.wrapper.offsetHeight -
                                    this.$refs.list.offsetHeight;
                                this.scroll.stop();
                                return [2];
                        }
                    });
                }); });
            }
            else {
                _this.scroll.refresh();
            }
        });
    };
    DrawMoneyRecord.prototype.handleMessage = function (item, index) {
        this.$router.push({
            path: '/details',
            name: 'details',
            params: Object.assign({}, item),
        });
    };
    DrawMoneyRecord.prototype.goback = function () {
        this.$router.go(-1);
    };
    DrawMoneyRecord.prototype.realMoney = function (item) {
        switch (item.State) {
            case __WEBPACK_IMPORTED_MODULE_5__types_crm_enums__["e" /* TransferOutStateEnum */].Accept:
                return item.Money;
            default:
                return item.StateStr;
        }
    };
    DrawMoneyRecord = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], DrawMoneyRecord);
    return DrawMoneyRecord;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (DrawMoneyRecord);


/***/ }),

/***/ "EsUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "k-line",
  data: function data() {
    return {
      arr: [],
      props: ['option'],
      option1: {
        xAxis: {
          type: 'category',
          data: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        series: [{
          //data: [3320, 3332, 3391, 3334, 33290, 33330, 3520,3560, 3572, 3591, 3634, 3690, 3130, 3120,3310, 3532, 3691, 3634, 3290, 3730, 3320,3920, 3632, 3891],
          data: [1023, 3233, 2422, 6012, 3290, 3521, 3967, 3631, 3234, 3167, 2583, 2822, 2931, 5463, 1759, 3637, 2615, 2736, 3315, 3291, 2534, 2479, 2333, 1215],
          type: 'line'
        }]
      }

    };
  },
  mounted: function mounted() {

    // console.log(this.option);
    // console.log(this.option1);
    // // 绘制图表。
    echarts.init(document.getElementById('main')).setOption(this.option1);
    //这是1到11的

  }
});

/***/ }),

/***/ "F7NO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.77c3549.gif";

/***/ }),

/***/ "FBY2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("3quM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a75558_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("tx1i");
function injectStyle (ssrContext) {
  __webpack_require__("ljv1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08a75558"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a75558_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FbIn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_proto_Model__ = __webpack_require__("O0G5");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var TradeKeyboard = (function (_super) {
    __extends(TradeKeyboard, _super);
    function TradeKeyboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.falge = true;
        _this.list = [
            {
                text: '排队价',
                value: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_Model__["a" /* default */].trader.queue_price_mode,
            },
            {
                text: '对手价',
                value: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_Model__["a" /* default */].trader.match_price_mode,
            },
            {
                text: '最新价',
                value: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_Model__["a" /* default */].trader.latest_price_mode,
            },
            {
                text: '市价',
                value: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_Model__["a" /* default */].trader.market_price_mode,
            },
            {
                text: '超价',
                value: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_Model__["a" /* default */].trader.extend_price_mode,
            },
        ];
        return _this;
    }
    TradeKeyboard.prototype.handleClose = function () {
        this.$emit('close');
    };
    TradeKeyboard.prototype.handlePriceType = function (item) {
        var _this = this;
        this.$emit('update:priceType', item.value);
        this.$emit('update:priceHolder', item.text);
        this.$store.commit('keyBoard/changePriceFlage', false);
        this.$emit('update:price', '');
        this.$nextTick(function () {
            _this.$emit('change');
        });
    };
    TradeKeyboard.prototype.onPriceChange = function (v) {
        var _this = this;
        this.$emit('update:price', v);
        this.$nextTick(function () {
            _this.$emit('change');
        });
        if (!v) {
            this.$store.commit('keyBoard/changePriceFlage', false);
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], TradeKeyboard.prototype, "price", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], TradeKeyboard.prototype, "priceType", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], TradeKeyboard.prototype, "priceHolder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], TradeKeyboard.prototype, "exclude", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], TradeKeyboard.prototype, "title", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], TradeKeyboard.prototype, "boardPrice", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])({ default: {} })
    ], TradeKeyboard.prototype, "tick", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], TradeKeyboard.prototype, "priceTicks", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])({ default: true })
    ], TradeKeyboard.prototype, "showPriceType", void 0);
    TradeKeyboard = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'TradeKeyboard',
        })
    ], TradeKeyboard);
    return TradeKeyboard;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (TradeKeyboard);


/***/ }),

/***/ "FcK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = sub;
/* harmony export (immutable) */ __webpack_exports__["b"] = reSub;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearAll;
/* unused harmony export unSub */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sub_utils_subfuns__ = __webpack_require__("6kIr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sub_utils_unsubfuns__ = __webpack_require__("cdCi");




var cache = {};
function sub(name, params) {
    if (cache[name]) {
        return;
    }
    if (__WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].user) {
        cache[name] = {
            params: params,
            isSub: true
        };
        __WEBPACK_IMPORTED_MODULE_2__sub_utils_subfuns__["a" /* default */][name](params);
        console.log('sub ' + name);
        return;
    }
    cache[name] = {
        params: params,
        isSub: false
    };
}
function reSub() {
    for (var key in cache) {
        if (cache.hasOwnProperty(key)) {
            if (!cache[key].isSub) {
                cache[key].isSub = true;
                var params = cache[key].params;
                console.log('sub ' + key);
                __WEBPACK_IMPORTED_MODULE_2__sub_utils_subfuns__["a" /* default */][key](params);
            }
        }
    }
}
function clearAll() {
    for (var key in cache) {
        if (cache.hasOwnProperty(key)) {
            if (__WEBPACK_IMPORTED_MODULE_3__sub_utils_unsubfuns__["a" /* default */][key]) {
                __WEBPACK_IMPORTED_MODULE_3__sub_utils_unsubfuns__["a" /* default */][key](cache[key].params);
            }
        }
    }
    cache = {};
    __WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].commit('Params/clearAll');
}
__WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].regReconnect(function () {
    for (var key in cache) {
        if (cache.hasOwnProperty(key)) {
            if (__WEBPACK_IMPORTED_MODULE_3__sub_utils_unsubfuns__["a" /* default */][key]) {
                __WEBPACK_IMPORTED_MODULE_3__sub_utils_unsubfuns__["a" /* default */][key](cache[key].params);
            }
            cache[key].isSub = false;
        }
    }
    reSub();
});
function unSub(name) {
    if (__WEBPACK_IMPORTED_MODULE_3__sub_utils_unsubfuns__["a" /* default */][name]) {
        __WEBPACK_IMPORTED_MODULE_3__sub_utils_unsubfuns__["a" /* default */][name](cache[name].params);
    }
    delete cache[name];
}

/***/ }),

/***/ "FirM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = toDoubleDigits;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* unused harmony export formatDateTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayjs__ = __webpack_require__("oqQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayjs__);

function toDoubleDigits(money) {
    if (typeof money === 'string') {
        money = parseFloat(money);
        if (isNaN(money)) {
            money = 0;
        }
    }
    return money.toFixed(2).replace(/\.?0+$/, '');
}
function formatDate(date) {
    return __WEBPACK_IMPORTED_MODULE_0_dayjs___default()(date).format('YYYY-MM-DD');
}
function formatDateTime(date) {
    return __WEBPACK_IMPORTED_MODULE_0_dayjs___default()(date).format('YYYY-MM-DD HH:mm:ss');
}

/***/ }),

/***/ "G5+T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"triggered-container"},[_c('div',{staticClass:"find"},[_c('div',{staticClass:"item"},[_c('span',{staticClass:"label"},[_vm._v("日期")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.findStart),expression:"findStart"}],staticClass:"date",attrs:{"readonly":"true","type":"text"},domProps:{"value":(_vm.findStart)},on:{"focus":function($event){_vm.$refs.findStart.open()},"input":function($event){if($event.target.composing){ return; }_vm.findStart=$event.target.value}}}),_vm._v(" "),_c('mt-datetime-picker',{ref:"findStart",attrs:{"type":"date","year-format":"{value} 年","month-format":"{value} 月","date-format":"{value} 日"},model:{value:(_vm.formFind.start),callback:function ($$v) {_vm.$set(_vm.formFind, "start", $$v)},expression:"formFind.start"}}),_vm._v(" "),_c('span',{staticClass:"middle"},[_vm._v("-")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.findEnd),expression:"findEnd"}],staticClass:"date",attrs:{"readonly":"true","type":"text"},domProps:{"value":(_vm.findEnd)},on:{"focus":function($event){_vm.$refs.findEnd.open()},"input":function($event){if($event.target.composing){ return; }_vm.findEnd=$event.target.value}}}),_vm._v(" "),_c('mt-datetime-picker',{ref:"findEnd",attrs:{"type":"date","year-format":"{value} 年","month-format":"{value} 月","date-format":"{value} 日"},model:{value:(_vm.formFind.end),callback:function ($$v) {_vm.$set(_vm.formFind, "end", $$v)},expression:"formFind.end"}}),_vm._v(" "),_c('input',{staticClass:"btn",attrs:{"type":"button","value":"查询"},on:{"touchstart":_vm.handleQuery}}),_vm._v(" "),_c('div',{staticClass:"typeBox"},[_c('span',{staticClass:"label"},[_vm._v("类型")]),_vm._v(" "),_c('ul',{staticClass:"typeOption"},_vm._l((_vm.actionData),function(item,index){return _c('li',{key:index,on:{"click":function($event){_vm.handleSelectType(index)}}},[(_vm.selectIndex == index)?_c('i',{staticClass:"iconfont",domProps:{"innerHTML":_vm._s(item.font02)}}):_c('i',{staticClass:"iconfont",domProps:{"innerHTML":_vm._s(item.font)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])}))])],1)]),_vm._v(" "),_c('FixedTable',{staticClass:"container2",attrs:{"title":_vm.tableTitle,"isOp":false,"dataKey":"id","tableData":_vm.tableData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GIBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");





////////////////////////////////////////////////////////////////////////////////
// Topic订阅与发布
var me = {};
var he = {};
/* harmony default export */ __webpack_exports__["a"] = (me);

//##############################################################################
//##############################################################################
// 主题信息
me.Topic = function () {
    this.topicId = undefined;
    this.groupId = undefined;
    this.subject = undefined;
    this.suber = {};
    this.suberSize = 0;
};
// 主题订阅
me.Topic.prototype.subscribe = function (suberId, onpub) {
    if (suberId !== undefined && this.suber[suberId] === undefined) {
        this.suber[suberId] = onpub ? onpub : null;
        ++this.suberSize;
        //console.log(this.topicId + " +suber=" + this.suberSize);
        return true;
    }
    return false;
};
// 取消订阅
me.Topic.prototype.unsubscribe = function (suberId) {
    if (suberId !== undefined && this.suber[suberId] !== undefined) {
        delete this.suber[suberId];
        --this.suberSize;
        //console.log(this.topicId + " -suber=" + this.suberSize);
        return true;
    }
    return false;
};
// 发布给回调函数
me.Topic.prototype.publish = function (content, type) {
    for (var suberId in this.suber) {
        var onpub = this.suber[suberId];
        if (!onpub) continue;
        onpub(content, type);
    } // end for
};

//##############################################################################
//##############################################################################
// 单对象主题
me.OneTopic = function () {
    me.Topic.call(this);
    this.subject = { has: 0 };
};
__WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].extend(me.OneTopic, me.Topic);

// 主题发布
me.OneTopic.prototype.publish = function (content, id, type) {
    // 通过改变has的值，来触发vue.watch.
    if (content) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.subject, content);
        if (++this.subject.has == 0) ++this.subject.has;
    } else {
        this.subject.has = 0;
    }
    me.Topic.prototype.publish.call(this, this.subject, type);
};
// 主题快照发布
me.OneTopic.prototype.publishSnap = function (publish) {
    if (this.subject.has != 0) {
        publish(this.subject, __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_head | __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_last | __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_snap);
    }
};

// 获取需要订阅的对象
me.OneTopic.prototype.getSub = function () {
    // 已经订阅则不需要重复订阅。
    if (this.suberSize == 1) return [this.topicId];
};
// 获取需要取消订阅的对象
me.OneTopic.prototype.getUnsub = function () {
    if (this.suberSize == 0) return [this.topicId];
};

//##############################################################################
//##############################################################################
/* 集合对象主题
1.集合订阅模式：订阅一次推送所有对象，如主力合约，主题domiant->对象all。
@select: Function函数。

2.对象订阅模式：需要依次订阅所有对象，如Tick行情的品种，主题rb->对象rb1805/rb1806/...
@select: undefined。
*/
me.SetTopic = function () {
    me.Topic.call(this);
    this.subject = {};
    this.select = undefined;
};
__WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].extend(me.SetTopic, me.Topic);

////////////////////////////////////////////////////////////////////////////////
// 主题发布
me.SetTopic.prototype.publish = function (content, id, type) {
    var data = undefined;
    if (this.select instanceof Function) {
        if (this.select(content)) {
            data = this.subject[id] = content;
        }
    } else if (this.subject[id] !== undefined) {
        data = this.subject[id] = content;
    }
    if (data !== undefined) {
        me.Topic.prototype.publish.call(this, data, type);
    }
};
me.SetTopic.prototype.remove = function (id, type) {
    var data = this.subject[id];
    if (data !== undefined) {
        delete this.subject[id];
        data.stamp = __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].meta.stamp_remove;
        me.Topic.prototype.publish.call(this, data, type);
    }
};

// 主题快照发布
me.SetTopic.prototype.publishSnap = function (publish) {
    var curr = 0;
    var size = __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].propertySize(this.subject);
    var type = __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_snap | __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_head;
    for (var id in this.subject) {
        if (++curr == size) type |= __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_last;
        if (this.subject[id] != null) {
            publish(this.subject[id], type);
        }
        if (++curr == 1) type &= ~__WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_last;
    }
};

////////////////////////////////////////////////////////////////////////////////
/* 添加主题发布的对象ID列表，获取需要新订阅的对象ID。
 * @select=选择函数，则对象必须通过函数检查才能发布。
 * @select=发布的对象ID列表，返回新订阅的对象ID列表。
*/
me.SetTopic.prototype.getSub = function (select) {
    if (select instanceof Function) {
        this.select = select;
        return this.suberSize == 1;
    }
    // 新订阅的对象ID列表：若已经订阅过则不需要重复订阅。
    if (select instanceof Array) {
        var subs = undefined;
        for (var i = 0; i < select.length; ++i) {
            var id = select[i];
            if (this.subject[id] === undefined) {
                this.subject[id] = null;
                if (subs === undefined) subs = [];
                subs.push(id);
            }
        }
        return subs;
    }
    // 无订阅列表：如主力合约。
    this.select = function (pub) {
        return true;
    };
    return this.suberSize == 1;
};

////////////////////////////////////////////////////////////////////////////////
// 获取需要取消订阅的对象ID列表
me.SetTopic.prototype.getUnsub = function () {
    if (this.suberSize == 0) {
        if (this.select instanceof Function) {
            return true;
        }
        var unsubs = [];
        for (var id in this.subject) {
            unsubs.push(id);
        }
        if (unsubs.length > 0) return unsubs;
    }
};

//##############################################################################
//##############################################################################
// 序列对象主题
me.SeqTopic = function () {
    me.Topic.call(this);
    this.subject = [];
};
__WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].extend(me.SeqTopic, me.Topic);

// 主题发布
me.SeqTopic.prototype.publish = function (content, id, type) {
    this.subject.push(content);
    me.Topic.prototype.publish.call(this, content, type);
};

// 主题快照发布
me.SeqTopic.prototype.publishSnap = function (publish) {
    var len = this.subject.length;
    var type = __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_snap | __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_head;
    for (var i = 0; i < len; ++i) {
        if (i == len - 1) type |= __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_last;
        publish(this.subject[i], type);
        if (i == 0) type &= ~__WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].content_last;
    }
};

// 获取需要订阅的对象
me.SeqTopic.prototype.getSub = function () {
    // 已经订阅则不需要重复订阅。
    return this.suberSize == 1;
};
// 获取需要取消订阅的对象
me.SeqTopic.prototype.getUnsub = function () {
    return this.suberSize == 0;
};

//##############################################################################
//##############################################################################
// 主题订阅
me.ObjectTopic = function () {
    this.topicMap = {};
    this.topicGroup = [];
    this.serverTopic = {};
};

////////////////////////////////////////////////////////////////////////////////
// 订阅内容：增加引用计数
me.ObjectTopic.prototype.addRef = function (id) {
    if (id === undefined) return;
    // 增加引用计数
    var that = this;
    var func = function func(id, subs) {
        if (that.serverTopic[id] === undefined) {
            that.serverTopic[id] = { ref: 0, subject: null };
            subs.push(id);
        }
        ++that.serverTopic[id].ref;
        //console.log(id + " +ref=" + that.serverTopic[id].ref);
    };
    // 支持多个订阅
    var subs = [];
    if (id instanceof Array) {
        for (var i = 0; i < id.length; ++i) {
            func(id[i], subs);
        }
    } else {
        func(id, subs);
    }
    if (subs.length > 0) return subs;
};

////////////////////////////////////////////////////////////////////////////////
// 订阅内容：减少引用计数
me.ObjectTopic.prototype.delRef = function (id) {
    if (id === undefined) return;
    // 减少引用计数
    var that = this;
    var func = function func(id, unsubs) {
        var topic = that.serverTopic[id];
        if (topic !== undefined) {
            if (--topic.ref == 0) {
                delete that.serverTopic[id];
                unsubs.push(id);
            }
        }
        //console.log(id + " -ref=" + topic.ref);
    };
    // 支持多个订阅
    var unsubs = [];
    if (id instanceof Array) {
        for (var i = 0; i < id.length; ++i) {
            func(id[i], unsubs);
        }
    } else {
        func(id, unsubs);
    }
    if (unsubs.length > 0) return unsubs;
};

////////////////////////////////////////////////////////////////////////////////
// 发布内容
me.ObjectTopic.prototype.publishRef = function (content, id, is_remove) {
    if (id !== undefined) {
        var topic = this.serverTopic[id];
        if (topic) topic.subject = content;
    }
};

////////////////////////////////////////////////////////////////////////////////
// 查找主题
me.ObjectTopic.prototype.hasTopic = function (topidId) {
    return this.topicMap[topidId] === undefined;
};

////////////////////////////////////////////////////////////////////////////////
// 查找主题组
me.ObjectTopic.prototype.findGroup = function (groupId) {
    for (var i = 0; i < this.topicGroup.length; ++i) {
        if (this.topicGroup[i].groupId === groupId) return i;
    }
    return -1;
};

////////////////////////////////////////////////////////////////////////////////
// 获取主题组
me.ObjectTopic.prototype.getGroup = function (group) {
    var i = this.findGroup(group.groupId);
    if (i == -1) {
        var item = {
            groupId: group.groupId,
            topicId: group.topicId,
            topicMap: {}
        };
        this.topicGroup.push(item);
        return item.topicMap;
    }
    return this.topicGroup[i].topicMap;
};

////////////////////////////////////////////////////////////////////////////////
// 获取主题
me.ObjectTopic.prototype.getTopic = function (topicId, topicType, group) {
    var topic = this.topicMap[topicId];
    if (topic === undefined && topicType instanceof Function) {
        // 创建主题
        topic = new topicType();
        topic.topicId = topicId;
        topic.groupId = group.groupId;
        this.topicMap[topicId] = topic;
        // 主题组
        var topicMap = this.getGroup(group);
        topicMap[topicId] = topic;
    }
    return topic;
};

////////////////////////////////////////////////////////////////////////////////
// 删除主题
me.ObjectTopic.prototype.removeTopic = function (topicId, groupId) {
    // 删除主题与主题组
    delete this.topicMap[topicId];
    var i = this.findGroup(groupId);
    var topicMap = this.topicGroup[i].topicMap;
    delete topicMap[topicId];
    if (__WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].empty(topicMap)) {
        this.topicGroup.splice(i, 1);
    }
};

////////////////////////////////////////////////////////////////////////////////
// 订阅主题，返回主题。
me.ObjectTopic.prototype.subscribe = function (option) {
    // 主题订阅者ID
    var suberId = option.suber;
    if (option.suber instanceof Object) {
        var suberId = option.suber.suberId;
        var publish = option.suber.publish;
    }
    if (suberId === undefined) {
        throw new Error("[subscribe] option.suber can't be undefined.");
    }

    // 在主题中添加订阅者
    var topic = this.getTopic(option.topicId, option.topicType, option.topicGroup);
    if (topic.subscribe(suberId, publish)) {
        // 引用计数：当前Topic
        var subs = topic.getSub(option.topicSelect);
        // 引用计数：全局引用
        if (subs instanceof Array) {
            for (var i = 0; i < subs.length; ++i) {
                var id = subs[i];
                var temp = this.serverTopic[id];
                if (temp && temp.subject !== null) {
                    topic.publish(temp.subject, id);
                }
            }
            subs = this.addRef(subs);
        }
        /*if (subs) console.log("sub"); console.log(subs); */
        if (publish) topic.publishSnap(publish);
    }
    return { sub: subs, subject: topic.subject };
};

////////////////////////////////////////////////////////////////////////////////
// 取消订阅主题。若该主题已无其他订阅者则返回内容ID。
me.ObjectTopic.prototype.unsubscribe = function (topicId, suber) {
    var suberId = suber instanceof Object ? suber.id : suber;
    if (suberId === undefined) {
        throw new Error("[unsubscribe] suberId can't be undefined.");
    }

    var topic = this.topicMap[topicId];
    if (topic && topic.unsubscribe(suberId) && topic.suberSize == 0) {
        this.removeTopic(topicId, topic.groupId);
        var unsubs = topic.getUnsub();
        if (unsubs instanceof Array) {
            unsubs = this.delRef(unsubs);
        }
        /*if (unsubs) console.log("unsub"); console.log(unsubs);*/
        return unsubs;
    }
};

////////////////////////////////////////////////////////////////////////////////
// 发布主题元素
me.ObjectTopic.prototype.publish = function (content, id, type, is_remove) {
    for (var i = 0; i < this.topicGroup.length; ++i) {
        var group = this.topicGroup[i];
        var topicId = group.topicId(content);
        var topic = group.topicMap[topicId];
        if (topic) {
            // 发布给响应对象
            this.publishRef(content, id, is_remove);
            if (is_remove) {
                topic.remove(id, type);
            } else {
                topic.publish(content, id, type);
            }
        }
    }
};

////////////////////////////////////////////////////////////////////////////////
// 将主题置空，但不重置对象。
me.ObjectTopic.prototype.clear = function () {
    __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].clear(this.topicMap);
    __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].clear(this.topicGroup);
    __WEBPACK_IMPORTED_MODULE_1__Art_js__["a" /* default */].clear(this.serverTopic);
};

/***/ }),

/***/ "GOPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_BaseKeyboard_ts__ = __webpack_require__("4YSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358583e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseKeyboard_vue__ = __webpack_require__("C3Fm");
function injectStyle (ssrContext) {
  __webpack_require__("PdHo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-358583e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_BaseKeyboard_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358583e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseKeyboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H2+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_pb__ = __webpack_require__("NNz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_pb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_pb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConditionData__ = __webpack_require__("hEAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectButton_SelectButton_vue__ = __webpack_require__("b1B+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__("443i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TargetSelectedKeyboard_TargetSelectedKeyboard_vue__ = __webpack_require__("3/UL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_components_TargetKeyboard_TargetKeyboard_vue__ = __webpack_require__("moUf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrderPriceKeyboard_OrderPriceKeyboard_vue__ = __webpack_require__("IhYp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_utils__ = __webpack_require__("7C6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_format__ = __webpack_require__("FirM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_velocity_animate__ = __webpack_require__("9qgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};














var ConditionUpdate = (function (_super) {
    __extends(ConditionUpdate, _super);
    function ConditionUpdate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.arrOperation = __WEBPACK_IMPORTED_MODULE_4__ConditionData__["c" /* con_operation */];
        _this.arrOffset = __WEBPACK_IMPORTED_MODULE_4__ConditionData__["j" /* offset */];
        _this.arrDirect = __WEBPACK_IMPORTED_MODULE_4__ConditionData__["d" /* direct */];
        _this.arrValidTime = __WEBPACK_IMPORTED_MODULE_4__ConditionData__["k" /* validTime */];
        _this.showTargetSelectedKeyboard = false;
        _this.showTargetKeyboard = false;
        _this.showPriceKeyboard = false;
        _this.showVolumeKeyboard = false;
        _this.showOrderPriceKeyboard = false;
        _this.boardPrice = '';
        _this.tikData = '';
        _this.formData = {
            operationType: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_operation_lt,
            price: '',
            offset: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].offset_open,
            direction: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].direct_buy,
            targetId: '',
            volume: '',
            validTime: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_validity_gfd,
            orderPrice: '',
            orderPriceType: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_limit_price,
            id: '',
            triggerDate: '',
            triggerTime: '',
            conditionPriceType: '',
            state: 0,
            contract: '',
        };
        _this.priceValue = '';
        return _this;
    }
    Object.defineProperty(ConditionUpdate.prototype, "orderPrice", {
        get: function () {
            if (this.formData.orderPriceType === __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_limit_price) {
                return this.formData.orderPrice;
            }
            return __WEBPACK_IMPORTED_MODULE_4__ConditionData__["i" /* getText */](__WEBPACK_IMPORTED_MODULE_4__ConditionData__["a" /* con */], this.formData.orderPriceType);
        },
        enumerable: true,
        configurable: true
    });
    ConditionUpdate.prototype.changeT = function (news, old) {
        this.changeBoardPrice();
    };
    ConditionUpdate.prototype.changePriceType = function (news, old) {
        this.changeBoardPrice();
    };
    ConditionUpdate.prototype.changeDirection = function (news, old) {
        this.changeBoardPrice();
    };
    ConditionUpdate.prototype.changeBoardPrice = function () {
        this.boardPrice = 0;
        if (!this.tikData) {
            return;
        }
        if (this.formData.direction === 1) {
            switch (this.formData.orderPriceType) {
                case 16:
                    this.boardPrice =
                        this.tikData.askPrice1 ? this.tikData.askPrice1 : 0;
                    break;
                case 4:
                    this.boardPrice =
                        this.tikData.latestPrice ? this.tikData.latestPrice : 0;
                    break;
                case 17:
                    this.boardPrice =
                        this.tikData.highStopPrice ? this.tikData.highStopPrice : 0;
                    break;
                case 18:
                    this.boardPrice =
                        this.tikData.bidPrice1 ? this.tikData.bidPrice1 : 0;
                    break;
            }
        }
        else if (this.formData.direction === 2) {
            switch (this.formData.orderPriceType) {
                case 16:
                    this.boardPrice =
                        this.tikData.bidPrice1 ? this.tikData.bidPrice1 : 0;
                    break;
                case 4:
                    this.boardPrice =
                        this.tikData.latestPrice ? this.tikData.latestPrice : 0;
                    break;
                case 17:
                    this.boardPrice =
                        this.tikData.lowStopPrice ? this.tikData.lowStopPrice : 0;
                    break;
                case 18:
                    this.boardPrice =
                        this.tikData.askPrice1 ? this.tikData.askPrice1 : 0;
                    break;
            }
        }
        console.log(this.tikData);
    };
    ConditionUpdate.prototype.mounted = function () {
        this.tikData = __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].subTick(this.condition.targetId, 'conditionInsert');
        __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.assign(this.formData, this.condition);
        this.formData.price = __WEBPACK_IMPORTED_MODULE_11__utils_format__["b" /* toDoubleDigits */](this.formData.price);
        this.formData.orderPrice = __WEBPACK_IMPORTED_MODULE_11__utils_format__["b" /* toDoubleDigits */](this.formData.orderPrice);
    };
    ConditionUpdate.prototype.addCondition = function () {
        var _this = this;
        if (!this.formData.targetId) {
            __WEBPACK_IMPORTED_MODULE_10__utils_utils__["f" /* toast */]('请选择合约');
            return;
        }
        if (!this.formData.price) {
            __WEBPACK_IMPORTED_MODULE_10__utils_utils__["f" /* toast */]('请输入价格');
            return;
        }
        if (!this.formData.volume) {
            __WEBPACK_IMPORTED_MODULE_10__utils_utils__["f" /* toast */]('请输入手数');
            return;
        }
        if (this.formData.orderPriceType === __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_limit_price
            && __WEBPACK_IMPORTED_MODULE_10__utils_utils__["e" /* isZero */](this.formData.orderPrice)) {
            __WEBPACK_IMPORTED_MODULE_10__utils_utils__["f" /* toast */]('请输入报单价');
            return;
        }
        if (this.formData.orderPriceType === 2 &&
            (Number(this.formData.orderPrice) * 1000000).toFixed(0) %
                (this.priceTicks * 1000000).toFixed(0) !== 0) {
            __WEBPACK_IMPORTED_MODULE_10__utils_utils__["f" /* toast */]('下单价格不符合该合约的最小变动价位');
            return;
        }
        if ((Number(this.formData.price) * 1000000).toFixed(0) %
            (this.priceTicks * 1000000).toFixed(0) !== 0) {
            __WEBPACK_IMPORTED_MODULE_10__utils_utils__["f" /* toast */]('下单价格不符合该合约的最小变动价位');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].unsubTick(this.condition.targetId, 'conditionInsert');
        var cond = new __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_pb__["OrderConditional"]();
        var data = this.formData;
        cond.setId(data.id);
        cond.setTargetId(data.targetId);
        cond.setPrice(parseFloat(data.price));
        cond.setConditionPriceType(__WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_last_price);
        cond.setOperationType(data.operationType);
        cond.setVolume(data.volume);
        cond.setDirection(data.direction);
        cond.setOffset(data.offset);
        cond.setValidTime(data.validTime);
        cond.setOrderPrice(parseFloat(data.orderPrice));
        cond.setOrderPriceType(data.orderPriceType);
        cond.setState(data.state);
        console.log('修改条件单', cond);
        __WEBPACK_IMPORTED_MODULE_10__utils_utils__["c" /* indicator */]('正在处理...');
        __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].conditionOrderSave(cond, function (resolve) {
            __WEBPACK_IMPORTED_MODULE_10__utils_utils__["a" /* closeIndicator */]();
            __WEBPACK_IMPORTED_MODULE_10__utils_utils__["f" /* toast */]('修改成功');
            console.log(resolve);
            _this.$emit('close');
        }, function (reject) {
            console.error(reject);
            __WEBPACK_IMPORTED_MODULE_10__utils_utils__["f" /* toast */]('失败: ' + reject.message);
            __WEBPACK_IMPORTED_MODULE_10__utils_utils__["a" /* closeIndicator */]();
        });
    };
    ConditionUpdate.prototype.handleCancel = function () {
        __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].unsubTick(this.condition.targetId, 'conditionInsert');
        this.$emit('close');
    };
    ConditionUpdate.prototype.enter = function (el, done) {
        el.style.opacity = '0';
        __WEBPACK_IMPORTED_MODULE_12_velocity_animate___default()(el, {
            opacity: '1',
        }, {
            duration: 200,
            complete: done,
        });
    };
    ConditionUpdate.prototype.leave = function (el, done) {
        el.style.opacity = '1';
        __WEBPACK_IMPORTED_MODULE_12_velocity_animate___default()(el, {
            opacity: '0',
        }, {
            duration: 200,
            complete: function () {
                done();
            },
        });
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["a" /* Prop */])()
    ], ConditionUpdate.prototype, "condition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["a" /* Prop */])()
    ], ConditionUpdate.prototype, "priceTicks", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["b" /* Watch */])('tikData', { deep: true })
    ], ConditionUpdate.prototype, "changeT", null);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["b" /* Watch */])('formData.orderPriceType', { deep: true })
    ], ConditionUpdate.prototype, "changePriceType", null);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["b" /* Watch */])('formData.direction', { deep: true })
    ], ConditionUpdate.prototype, "changeDirection", null);
    ConditionUpdate = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            components: {
                SelectButton: __WEBPACK_IMPORTED_MODULE_5__SelectButton_SelectButton_vue__["a" /* default */],
                TargetSelectedKeyboard: __WEBPACK_IMPORTED_MODULE_7__TargetSelectedKeyboard_TargetSelectedKeyboard_vue__["a" /* default */],
                TargetKeyboard: __WEBPACK_IMPORTED_MODULE_8__views_components_TargetKeyboard_TargetKeyboard_vue__["a" /* default */],
                OrderPriceKeyboard: __WEBPACK_IMPORTED_MODULE_9__OrderPriceKeyboard_OrderPriceKeyboard_vue__["a" /* default */],
            },
        })
    ], ConditionUpdate);
    return ConditionUpdate;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (ConditionUpdate);


/***/ }),

/***/ "HWOL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Hnga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__ = __webpack_require__("n20g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif__ = __webpack_require__("SBPU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Draw__ = __webpack_require__("MrG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_crm_enums__ = __webpack_require__("Xo8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__("7C6s");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var Recharge = (function (_super) {
    __extends(Recharge, _super);
    function Recharge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.load = __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif___default.a;
        _this.payLoad = false;
        _this.qrLoad = false;
        _this.moneyList = ['200', '500', '1000', '10000'];
        _this.amount = '200';
        _this.selectMoney = '0';
        _this.hintMsg = false;
        _this.rechargeWay = [];
        _this.downLoadMessage = '请长按选择保存到相册,然后用微信扫一扫打开';
        _this.downLoadFlage = true;
        _this.saveSuccess = false;
        _this.channelId = '';
        _this.channelSubId = '';
        _this.channelSubName = '';
        _this.activeItem = {};
        _this.payType = 0;
        _this.method = '';
        _this.selectRecharge = '0';
        _this.downloadUrl = '';
        _this.imgUrl = '';
        _this.hintImg = false;
        return _this;
    }
    Recharge.prototype.activated = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.selectRecharge = '0';
                this.amount = '200';
                this.loadChannel();
                if (window.platform.name) {
                    this.downLoadMessage = '请点击下载,保存到相册,然后用微信扫一扫打开';
                    this.downLoadFlage = false;
                }
                else {
                    this.downLoadMessage = '请长按选择保存到相册,然后用微信扫一扫打开';
                    this.downLoadFlage = true;
                }
                return [2];
            });
        });
    };
    Recharge.prototype.handleDownload = function () {
        var that = this;
        var permissions = cordova.plugins.permissions;
        permissions.hasPermission(permissions.WRITE_EXTERNAL_STORAGE, function (status) {
            if (status.hasPermission) {
                cordova.base64ToGallery(that.$refs.codes.toDataURL(), {
                    prefix: 'img_',
                    mediaScanner: true,
                }, function (path) {
                    that.saveSuccess = true;
                    setTimeout(function () {
                        that.saveSuccess = false;
                    }, 2000);
                }, function (err) {
                    alert('保存失败,请重试');
                });
            }
            else {
                permissions.requestPermission(permissions.WRITE_EXTERNAL_STORAGE, function (state) {
                    if (state.hasPermission) {
                        alert('获取权限成功,请重新点击下载图片');
                    }
                    else {
                        alert('获取权限失败');
                    }
                }, function (err) {
                    alert(err);
                });
            }
        });
    };
    Recharge.prototype.getImgPath = function (path) {
        return crmAddress + '/img/pay/' + path;
    };
    Recharge.prototype.loadChannel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.payLoad = true;
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__["a" /* postForm */])('/api/online-pay/query-mobile-channels', {})];
                    case 1:
                        data = _a.sent();
                        this.rechargeWay = data;
                        if (false)
                            console.log(this.rechargeWay);
                        if (this.rechargeWay.length) {
                            this.channelId = this.rechargeWay[0].ChannelId;
                            this.channelSubId = this.rechargeWay[0].ChannelSubId;
                            this.channelSubName = this.rechargeWay[0].ChannelSubName;
                            this.activeItem = this.rechargeWay[0];
                            this.payType = this.rechargeWay[0].PayType;
                            this.method = this.rechargeWay[0].Method;
                        }
                        else {
                            Object(__WEBPACK_IMPORTED_MODULE_6__utils_utils__["f" /* toast */])('没有支付渠道');
                        }
                        this.payLoad = false;
                        return [2];
                }
            });
        });
    };
    Recharge.prototype.handleSelect = function (item, index) {
        this.selectMoney = index;
        this.amount = item;
    };
    Recharge.prototype.handleWay = function (item, index) {
        this.selectRecharge = index;
        if (false)
            console.log(item);
        this.channelId = item.ChannelId;
        this.channelSubId = item.ChannelSubId;
        this.channelSubName = item.ChannelSubName;
        this.activeItem = item;
        this.payType = item.PayType;
        this.method = item.Method;
        this.imgUrl = item.Img;
    };
    Recharge.prototype.handleEnter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!Number(this.amount)) return [3, 1];
                        this.hintMsg = true;
                        setTimeout(function () {
                            _this.hintMsg = false;
                        }, 1500);
                        return [2];
                    case 1: return [4, Object(__WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__["a" /* postForm */])('/api/online-pay/' + this.method, {
                            ChannelId: this.channelId,
                            ConfigId: this.activeItem.ConfigId,
                            ChannelSubId: this.channelSubId,
                            ChannelSubName: this.channelSubName,
                            Money: this.amount,
                            PayType: this.payType,
                        })];
                    case 2:
                        data = _a.sent();
                        if (false)
                            console.log(data);
                        this.qrLoad = false;
                        switch (this.payType) {
                            case __WEBPACK_IMPORTED_MODULE_5__types_crm_enums__["b" /* PayTypeEnum */].Qr:
                            case __WEBPACK_IMPORTED_MODULE_5__types_crm_enums__["b" /* PayTypeEnum */].WeixinPublic:
                                this.drawQr(data.OnlinePayUrl);
                                break;
                            case __WEBPACK_IMPORTED_MODULE_5__types_crm_enums__["b" /* PayTypeEnum */].AliCall:
                            case __WEBPACK_IMPORTED_MODULE_5__types_crm_enums__["b" /* PayTypeEnum */].OpenUrl:
                                this.openPayUrl(data.OnlinePayUrl);
                                break;
                        }
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    Recharge.prototype.drawQr = function (payUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_4__utils_Draw__["a" /* draw */])(this.$refs.codes, this.channelSubName, payUrl, crmAddress + '/img/pay/' + this.imgUrl, this.channelSubName, this.amount)];
                    case 1:
                        _a.sent();
                        this.hintImg = true;
                        this.downloadUrl = this.$refs.codes.toDataURL();
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Recharge.prototype.openPayUrl = function (payUrl) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (window.platform.name) {
                    cordova.InAppBrowser.open(payUrl, '_system');
                }
                else {
                    window.location.href = payUrl;
                }
                return [2];
            });
        });
    };
    Recharge.prototype.handleCloseQr = function () {
        this.hintImg = false;
        this.goback();
    };
    Recharge.prototype.goback = function () {
        this.$router.go(-1);
    };
    Recharge = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], Recharge);
    return Recharge;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Recharge);


/***/ }),

/***/ "I6UT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_TradeSearch_ts__ = __webpack_require__("ScpD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_261c9d9f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TradeSearch_vue__ = __webpack_require__("BXlS");
function injectStyle (ssrContext) {
  __webpack_require__("u9e+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-261c9d9f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_TradeSearch_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_261c9d9f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TradeSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IUrU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IYy8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IbXa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guangqi.dd742ae.png";

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Params__ = __webpack_require__("nymR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__setPage_setPage__ = __webpack_require__("sKYB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__priceTick_priceTick__ = __webpack_require__("8wi4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keyBoard_keyBoard__ = __webpack_require__("Jcms");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);






////////////////////////////////////////////////////////////////////////////////
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  modules: {
    Params: __WEBPACK_IMPORTED_MODULE_3__modules_Params__["a" /* default */],
    setPage: __WEBPACK_IMPORTED_MODULE_4__setPage_setPage__["a" /* default */],
    priceTick: __WEBPACK_IMPORTED_MODULE_5__priceTick_priceTick__["a" /* default */],
    keyBoard: __WEBPACK_IMPORTED_MODULE_6__keyBoard_keyBoard__["a" /* default */]
  },
  state: {
    autoClosed: false, // 网络自动断开
    targetSelected: {}, // 自选合约列表
    bottomIndex: 0,
    selectTargets: [] // 自选列表
  },

  getters: {},

  mutations: {
    // 网络自动断开：set
    autoClose: function autoClose(state, autoClosed) {
      state.autoClosed = autoClosed;
    },


    // 自选合约列表：加载数据/添加/删除
    selectLoad: function selectLoad(state, value) {
      if (value === undefined) {
        __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].clear(state.targetSelected);
        return;
      }
      state.targetSelected = value;
    },
    selectInsert: function selectInsert(state, targetId) {
      state.targetSelected[targetId] = true;
    },
    selectRemove: function selectRemove(state, targetId) {
      delete state.targetSelected[targetId];
    },
    selectIndex: function selectIndex(state, index) {
      state.bottomIndex = index;
    },
    upDataSelect: function upDataSelect(state, context) {
      state.selectTargets = context;
    }
  }
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IhYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_OrderPriceKeyboard_ts__ = __webpack_require__("f4w4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41786f5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderPriceKeyboard_vue__ = __webpack_require__("zTqT");
function injectStyle (ssrContext) {
  __webpack_require__("396W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41786f5f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_OrderPriceKeyboard_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41786f5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderPriceKeyboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ikte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConditionData__ = __webpack_require__("hEAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_pb__ = __webpack_require__("NNz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_pb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_pb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__("7C6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConditionUpdate_ConditionUpdate_vue__ = __webpack_require__("dntY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};









var ConditionNotTrigger = (function (_super) {
    __extends(ConditionNotTrigger, _super);
    function ConditionNotTrigger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isShowUpdate = false;
        _this.currentSelect = {};
        _this.typeArr = [];
        _this.tableTitle = [
            {
                text: '合约',
                width: '2rem',
                name: 'contract',
            },
            {
                text: '状态',
                width: '1.5rem',
                name: 'state',
            },
            {
                text: '条件',
                width: '1.5rem',
                name: 'condition',
            },
            {
                text: '下单',
                width: '3rem',
                name: 'order',
            },
            {
                text: '有效期',
                width: '2rem',
                name: 'effective',
            },
            {
                text: 'ID',
                width: '6rem',
                name: 'id',
            }
        ];
        return _this;
    }
    Object.defineProperty(ConditionNotTrigger.prototype, "priceTickN", {
        get: function () {
            return this.typeArr.priceTick;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionNotTrigger.prototype, "tableData", {
        get: function () {
            var arr = [];
            for (var _i = 0, _a = this.conditionNotTriggerList; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.orderType === 0) {
                    arr.push({
                        contract: item.targetId,
                        state: __WEBPACK_IMPORTED_MODULE_3__ConditionData__["h" /* getState */](item),
                        condition: __WEBPACK_IMPORTED_MODULE_3__ConditionData__["e" /* getCondition */](item),
                        order: __WEBPACK_IMPORTED_MODULE_3__ConditionData__["g" /* getOrder */](item),
                        effective: __WEBPACK_IMPORTED_MODULE_3__ConditionData__["i" /* getText */](__WEBPACK_IMPORTED_MODULE_3__ConditionData__["k" /* validTime */], item.validTime),
                        id: item.id,
                        stopText: item.state === __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].con_order_run ? '暂停' : '启动',
                    });
                }
            }
            return arr;
        },
        enumerable: true,
        configurable: true
    });
    ConditionNotTrigger.prototype.destroyed = function () {
    };
    ConditionNotTrigger.prototype.deactivated = function () {
    };
    ConditionNotTrigger.prototype.handleStop = function (item) {
        console.log(item);
        var cond = new __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_pb__["OrderConditional"]();
        var data = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.find(this.conditionNotTriggerList, function (r) { return r.id === item.id; });
        cond.setId(data.id);
        cond.setTargetId(data.targetId);
        cond.setPrice(data.price);
        cond.setConditionPriceType(__WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].con_last_price);
        cond.setOperationType(data.operationType);
        cond.setVolume(data.volume);
        cond.setDirection(data.direction);
        cond.setOffset(data.offset);
        cond.setValidTime(data.validTime);
        cond.setOrderPrice(data.orderPrice);
        cond.setOrderPriceType(data.orderPriceType);
        if (data.state === __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].con_order_run) {
            cond.setState(__WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].con_order_stop);
        }
        else {
            cond.setState(__WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].con_order_run);
        }
        __WEBPACK_IMPORTED_MODULE_6__utils_utils__["c" /* indicator */]('正在处理...');
        __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].conditionOrderSave(cond, function (resolve) {
            __WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* closeIndicator */]();
            __WEBPACK_IMPORTED_MODULE_6__utils_utils__["f" /* toast */]('操作成功');
            console.log(resolve);
        }, function (reject) {
            console.error(reject);
            __WEBPACK_IMPORTED_MODULE_6__utils_utils__["f" /* toast */]('失败: ' + reject.message);
            __WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* closeIndicator */]();
        });
    };
    ConditionNotTrigger.prototype.handleDel = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, __WEBPACK_IMPORTED_MODULE_6__utils_utils__["b" /* confirm */]('确认删除此条件单吗？', '删除？', '确定', '取消')];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [2];
                    case 3:
                        __WEBPACK_IMPORTED_MODULE_6__utils_utils__["c" /* indicator */]('正在处理...');
                        __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].conditionOrderRemove('', '', item.id, function (resolve) {
                            __WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* closeIndicator */]();
                            __WEBPACK_IMPORTED_MODULE_6__utils_utils__["f" /* toast */]('删除成功');
                        }, function (reject) {
                            __WEBPACK_IMPORTED_MODULE_6__utils_utils__["f" /* toast */]('失败: ' + reject.message);
                            __WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* closeIndicator */]();
                        });
                        return [2];
                }
            });
        });
    };
    ConditionNotTrigger.prototype.handleUpdate = function (item) {
        this.typeArr = __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */]['targetSet'][item.contract];
        this.$store.commit('priceTick/changePriceT', this.typeArr.priceTick);
        this.currentSelect = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.find(this.conditionNotTriggerList, function (r) { return r.id === item.id; });
        this.isShowUpdate = true;
    };
    ConditionNotTrigger = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            components: {
                ConditionUpdate: __WEBPACK_IMPORTED_MODULE_7__ConditionUpdate_ConditionUpdate_vue__["a" /* default */],
            },
            computed: __assign({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapGetters"])({
                conditionNotTriggerList: 'Params/conditionNotTriggerList',
            })),
        })
    ], ConditionNotTrigger);
    return ConditionNotTrigger;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (ConditionNotTrigger);


/***/ }),

/***/ "JF6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"include_footer"},[_c('ul',_vm._l((_vm.footerTobarData),function(item,index){return _c('li',{directives:[{name:"tap",rawName:"v-tap"}],key:index,class:{liActive:_vm.isActive==index},on:{"tap":function($event){_vm.toLink(item.tobarLink,index)}}},[_c('i',{staticClass:"icon iconfont",domProps:{"innerHTML":_vm._s(item.tobarIcon)}}),_c('br'),_vm._v(_vm._s(item.tobarContent)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jcms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var keyBoard = {
    namespaced: true,
    state: {
        priceFlage: true
    },
    mutations: {
        changePriceFlage: function changePriceFlage(state, context) {
            state.priceFlage = context;
        }
    },
    actions: {}
};
/* harmony default export */ __webpack_exports__["a"] = (keyBoard);

/***/ }),

/***/ "JcpO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dashuang.53156ec.png";

/***/ }),

/***/ "K6os":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

var ipcode = {
  "A": ".xyz",
  "B": ".ren",
  "C": ".fun",
  "D": ".net",
  "E": ".com",
  "F": ".cn",
  "G": ".cc",
  "H": ".c",
  "I": ".top",
  "J": ".art",
  "K": "",
  "L": "",
  "M": "",
  "N": "",
  "O": "",
  "P": "",
  "Q": "",
  "R": ""
};
var ipZero = {
  "!": "0",
  "#": "00",
  "$": "000",
  "%": "0000",
  "&": "00000"
};
var postfix = '';
var prefix = '';

function decoder(str, scale) {
  var flage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  //   const scale = '0123456789abcdefghijklmnopqrstuvwxyz';
  var scaleLen = scale.length;
  var ip = 0;
  var base = 1;

  // code -> int value
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(str), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var i = _step.value;

      var v = scale.indexOf(i);
      ip += v * base;
      base *= scaleLen;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (flage) {
    return prefix + ip + postfix;
  }

  var result = '';
  while (ip > 0) {
    var left = ip % 256;
    ip = Math.floor(ip / 256, 10);
    result += left + '.';
  }
  return result.replace(/\.$/, '');
}

function getIp(code) {
  postfix = '';
  prefix = '';
  var scale = '';
  if (code.indexOf('.') > 0) {
    return code;
  }
  if (code[code.length - 1] > 'A' && code[code.length - 1] < 'Z') {
    postfix = ipcode[code[code.length - 1]];
    if (ipZero[code[0]]) {
      prefix = ipZero[code[0]];
      code = code.slice(1, code.length);
    }
    code = code.slice(0, code.length - 1);
    scale = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return decoder(code, scale, true);
  }
  scale = '0123456789abcdefghijklmnopqrstuvwxyz';
  return decoder(code, scale);
}

/***/ }),

/***/ "KEgV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderMenu_vue__ = __webpack_require__("irye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da80a804_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderMenu_vue__ = __webpack_require__("Wbkn");
function injectStyle (ssrContext) {
  __webpack_require__("YSrX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da80a804"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da80a804_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KF17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-trigger"},[_c('FixedTable',{staticClass:"container2",attrs:{"title":_vm.tableTitle,"isOp":false,"dataKey":"id","tableData":_vm.tableData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kl8b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LMP+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_yjheader_vue__ = __webpack_require__("eR8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ConditionInsert_ConditionInsert__ = __webpack_require__("jbfd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ConditionNotTrigger_ConditionNotTrigger__ = __webpack_require__("qqZH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ConditionTriggered_ConditionTriggered__ = __webpack_require__("o+Lj");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var Condition = (function (_super) {
    __extends(Condition, _super);
    function Condition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'condition';
        _this.targentId = '';
        _this.spanState = '3';
        _this.contractValue = '';
        return _this;
    }
    Condition.prototype.goback = function () {
        this.$router.go(-1);
    };
    Condition.prototype.activated = function () {
        this.$store.commit('selectIndex', 3);
        this.targentId = this.$route.query.targetId;
    };
    Condition.prototype.deactivated = function () {
        this.spanState = '3';
    };
    Condition = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            components: {
                yjheader: __WEBPACK_IMPORTED_MODULE_2__components_common_yjheader_vue__["a" /* default */],
                ConditionInsert: __WEBPACK_IMPORTED_MODULE_3__components_ConditionInsert_ConditionInsert__["a" /* default */],
                ConditionNotTrigger: __WEBPACK_IMPORTED_MODULE_4__components_ConditionNotTrigger_ConditionNotTrigger__["a" /* default */],
                ConditionTriggered: __WEBPACK_IMPORTED_MODULE_5__components_ConditionTriggered_ConditionTriggered__["a" /* default */],
            },
        })
    ], Condition);
    return Condition;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Condition);


/***/ }),

/***/ "Le4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"header"},[_c('span',{on:{"click":_vm.goback}},[_c('i',{staticClass:"icon iconfont left"},[_vm._v("")]),_vm._v("\n      返回\n    ")]),_vm._v("\n    提现")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',{staticClass:"myCar",on:{"click":_vm.handleBankCar}},[_vm._v("我的银行卡")]),_vm._v(" "),_c('ul',{staticClass:"filloutMsg"},[_c('li',[_c('span',[_vm._v("选择银行卡：")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectBackCar),expression:"selectBackCar"}],staticClass:"bankCarType",attrs:{"name":"","id":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectBackCar=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.handleSelect()}],"click":_vm.handleClickBank}},[_c('option',{staticStyle:{"display":"none"},attrs:{"value":"","disabled":"","selected":""}},[_vm._v(_vm._s('请选择银行卡'))]),_vm._v(" "),_vm._l((_vm.bankCardArr),function(item,index){return _c('option',{key:index,domProps:{"value":item}},[_vm._v(_vm._s(item.cont))])})],2)]),_vm._v(" "),_c('li',[_c('span',[_vm._v("提现金额：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.money),expression:"formData.money"}],attrs:{"type":"number","pattern":"[0-9]*","placeholder":"请输入提现金额"},domProps:{"value":(_vm.formData.money)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "money", $event.target.value)}}})])]),_vm._v(" "),_c('p',{staticClass:"moneyMsg"},[_vm._v("可提现金额 "),_c('span',[_vm._v(_vm._s(_vm.availablemoney))]),_vm._v(" 元")]),_vm._v(" "),_c('div',{staticClass:"rata"},[_c('span',[_vm._v("费率:  "+_vm._s(_vm.serviceCharge))]),_vm._v(" "),_c('span',[_vm._v("提现手续费:   "+_vm._s(_vm.serviceChargeMoney)+"元")])]),_vm._v(" "),_c('button',{staticClass:"drawMoney",on:{"click":_vm.handleSubmit}},[_vm._v("提现")]),_vm._v(" "),_c('ul',{staticClass:"hint",domProps:{"innerHTML":_vm._s(_vm.setting.TransferOutTips)}})]),_vm._v(" "),(_vm.hintMsg)?_c('div',{staticClass:"errMsg"},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lgiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var UpgradeApp = (function (_super) {
    __extends(UpgradeApp, _super);
    function UpgradeApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.progress = 0;
        _this.platformName = '';
        return _this;
    }
    UpgradeApp.prototype.mounted = function () {
        this.platformName = window.platform.name;
    };
    UpgradeApp.prototype.handleUpdateVersion = function () {
        if (window.platform.name === 'android') {
            this.updateAndroid(this.upgrade.address);
        }
        else if (window.platform.name === 'ios') {
            location.href =
                'itms-apps://itunes.apple.com/cn/app/%E5%8D%9A%E6%AF%85/id1448458716?mt=8';
        }
        else {
            cordova.InAppBrowser.open(this.upgrade.address, '_system');
        }
    };
    UpgradeApp.prototype.updateAndroid = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        window.AppUpdate.install(function (msg) {
                            console.log(msg);
                            resolve(msg);
                        }, function (error) {
                            reject(error);
                            console.log(error);
                        }, url);
                    })];
            });
        });
    };
    UpgradeApp.prototype.handleLaterUp = function () {
        this.$emit('laterUp');
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], UpgradeApp.prototype, "upgrade", void 0);
    UpgradeApp = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], UpgradeApp);
    return UpgradeApp;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (UpgradeApp);


/***/ }),

/***/ "LkVE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_Condition_ts__ = __webpack_require__("LMP+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c093dafc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_condition_vue__ = __webpack_require__("xruU");
function injectStyle (ssrContext) {
  __webpack_require__("UG9+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c093dafc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_Condition_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c093dafc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_condition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LkYP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("muBx"))(6);

/***/ }),

/***/ "Lm3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var SelectButton = (function (_super) {
    __extends(SelectButton, _super);
    function SelectButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectButton.prototype.handleChange = function () {
        var _this = this;
        var currentIndex = __WEBPACK_IMPORTED_MODULE_3_lodash__["findIndex"](this.arr, function (r) { return r.value === _this.value; });
        currentIndex = (currentIndex + 1) % (this.arr.length);
        this.$emit('input', this.arr[currentIndex].value);
    };
    Object.defineProperty(SelectButton.prototype, "current", {
        get: function () {
            var _this = this;
            var currentIndex = __WEBPACK_IMPORTED_MODULE_3_lodash__["findIndex"](this.arr, function (r) { return r.value === _this.value; });
            return this.arr[currentIndex];
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], SelectButton.prototype, "arr", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])({ default: 0 })
    ], SelectButton.prototype, "value", void 0);
    SelectButton = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], SelectButton);
    return SelectButton;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (SelectButton);


/***/ }),

/***/ "Ly19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"header"},[_c('span',{on:{"click":_vm.goback}},[_c('i',{staticClass:"icon iconfont left"},[_vm._v("")]),_vm._v("\n      返回\n    ")]),_vm._v("\n    我的银行卡"),_c('span',{on:{"click":_vm.addCar}},[_c('i',{staticClass:"icon iconfont"},[_vm._v("")]),_vm._v("添加")])]),_vm._v(" "),_c('div',[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"bankCarList"},_vm._l((_vm.bankCarList),function(item,index){return _c('li',{key:index},[_c('span',{on:{"click":function($event){_vm.editCar(item)}}},[_vm._v(_vm._s(item.bankName))]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.editCar(item)}}},[_vm._v(_vm._s(item.logNo))]),_vm._v(" "),_c('span',{staticClass:"operation"},[_c('i',{staticClass:"icon iconfont",on:{"click":function($event){_vm.deleData(item.id)}}},[_vm._v("")])])])}))]),_vm._v(" "),(_vm.showPopup)?_c('div',{staticClass:"popup"},[_c('ul',{staticClass:"filloutMsg"},[_c('li',{staticClass:"headline"},[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('li',[_c('span',[_vm._v("持卡人：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],attrs:{"type":"text","placeholder":"请输入持卡人姓名","disabled":_vm.flage},domProps:{"value":(_vm.formData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}})]),_vm._v(" "),_c('li',[_c('span',[_vm._v("开户行：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.bank),expression:"formData.bank"}],attrs:{"type":"text","placeholder":"中国银行","disabled":_vm.flage},domProps:{"value":(_vm.formData.bank)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "bank", $event.target.value)}}})]),_vm._v(" "),_c('li',[_c('span',[_vm._v("支行：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.bankBranch),expression:"formData.bankBranch"}],attrs:{"type":"text","placeholder":"xx省xx市xx支行","disabled":_vm.flage},domProps:{"value":(_vm.formData.bankBranch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "bankBranch", $event.target.value)}}})]),_vm._v(" "),_c('li',[_c('span',[_vm._v("银行卡号：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.bankNo),expression:"formData.bankNo"}],attrs:{"type":"number","pattern":"","placeholder":"请输入银行卡号","disabled":_vm.flage},domProps:{"value":(_vm.formData.bankNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "bankNo", $event.target.value)}}})]),_vm._v(" "),(!_vm.flage)?_c('li',{staticClass:"but"},[_c('button',{on:{"click":_vm.enterAddCar}},[_vm._v("确定")]),_vm._v(" "),_c('button',{on:{"click":_vm.cancelP}},[_vm._v("取消")])]):_c('li',{staticClass:"but"},[_c('button',{staticClass:"enters",on:{"click":_vm.closeP}},[_vm._v("确定")])])])]):_vm._e(),_vm._v(" "),(_vm.hintMsg)?_c('div',{staticClass:"errMsg"},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e(),_vm._v(" "),(_vm.loadFlage)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":_vm.load,"alt":""}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("银行卡")]),_vm._v(" "),_c('span',[_vm._v("卡号尾号")]),_vm._v(" "),_c('span',[_vm._v("操作")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M4fF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("muBx"))(4);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad49406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("pTVg");
function injectStyle (ssrContext) {
  __webpack_require__("RMXP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad49406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MTI1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MrG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = draw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcode__ = __webpack_require__("71e1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qrcode__);



var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && (g[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [0, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function draw(canvas, companyName, qrcode, imgUrl, channelName, totalMoney) {
    return __awaiter(this, void 0, void 0, function () {
        var qrImgDataUrl, qrImg, size, ctx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [4, __WEBPACK_IMPORTED_MODULE_3_qrcode___default.a.toDataURL(qrcode)];
                case 1:
                    qrImgDataUrl = _a.sent();
                    return [4, getImg(qrImgDataUrl)];
                case 2:
                    qrImg = _a.sent();
                    size = {
                        width: qrImg.width + 160,
                        height: qrImg.height + 260
                    };
                    canvas.width = size.width;
                    canvas.height = size.height;
                    ctx = canvas.getContext('2d');
                    ctx.fillStyle = 'rgb(247, 71, 73)';
                    ctx.fillRect(0, 0, size.width, size.height - 90);
                    ctx.font = '20px Arial';
                    ctx.fillStyle = 'white';
                    ctx.textAlign = 'center';
                    ctx.fillText(companyName, size.width / 2, 50);
                    ctx.strokeStyle = 'white';
                    ctx.beginPath();
                    ctx.setLineDash([5]);
                    ctx.moveTo(0, 70);
                    ctx.lineTo(size.width, 70);
                    ctx.stroke();
                    ctx.fillStyle = 'white';
                    ctx.fillRect(50, 100, size.width - 100, size.height - 220);
                    ctx.fillRect(0, size.height - 90, size.width, 70);
                    ctx.font = '14px Arial';
                    ctx.fillStyle = 'black';
                    ctx.textAlign = 'center';
                    ctx.fillText(totalMoney + '元', size.width / 2, 125);
                    ctx.drawImage(qrImg, 80, 130);
                    return [4, drawChannel(ctx, imgUrl, size.width, size.height - 80, channelName)];
                case 3:
                    _a.sent();
                    return [2, size];
            }
        });
    });
}
function drawChannel(ctx, src, totalWidth, y, channelName) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        var img1 = new Image();
        img1.setAttribute('crossOrigin', 'anonymous');
        img1.src = src;
        img1.onload = function () {
            var channelNameWidth = channelName.length * 20 + 20;
            var imgX = (totalWidth - channelNameWidth - img1.width) / 2;
            ctx.drawImage(img1, imgX, y);
            ctx.font = '20px Arial';
            ctx.fillStyle = 'black';
            ctx.textAlign = 'left';
            ctx.textBaseline = 'middle';
            console.log(y, img1.height);
            ctx.fillText(channelName, imgX + img1.width, y + img1.height / 2);
            resolve();
        };
    });
}
function getImg(src) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        var img1 = new Image();
        img1.setAttribute('crossOrigin', 'anonymous');
        img1.src = src;
        img1.onload = function () {
            resolve(img1);
        };
    });
}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_style_css__ = __webpack_require__("d8/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_v_tap_ts__ = __webpack_require__("8XM0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_log__ = __webpack_require__("vblW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_main_scss__ = __webpack_require__("67t3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_reg__ = __webpack_require__("sV0S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_common_css__ = __webpack_require__("t+Gu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_css_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_iconfonts_iconfont_css__ = __webpack_require__("zLbt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_iconfonts_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_iconfonts_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_index__ = __webpack_require__("IcnI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




window._ = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype._ = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_mint_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__assets_js_v_tap_ts__["a" /* default */]);


window.Log = __WEBPACK_IMPORTED_MODULE_5__utils_log__["a" /* default */];





 //引入全局css



window.beferFooterIndex = 0;
window.footerIndex = 0;
window.crmAddress = '';
window.helpAddress = '';

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_12__store_index__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */]
  }
});

// var attachFastClick = require('@/assets/js/fastclick.js');
// attachFastClick(document.body);

/***/ }),

/***/ "NNz/":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */// GENERATED CODE -- DO NOT EDIT!
var jspb=__webpack_require__("LkYP");var goog=jspb;var global=Function('return this')();var Object_pb=__webpack_require__("zSVF");goog.exportSymbol('proto.ctpfront.proto.CancelOrder',null,global);goog.exportSymbol('proto.ctpfront.proto.CancelOrderRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.Capital',null,global);goog.exportSymbol('proto.ctpfront.proto.CapitalReq',null,global);goog.exportSymbol('proto.ctpfront.proto.CapitalRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.ConditionOrderRecord',null,global);goog.exportSymbol('proto.ctpfront.proto.ConditionOrderRecordGetReq',null,global);goog.exportSymbol('proto.ctpfront.proto.ConditionOrderRecordGetRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.Dictionary',null,global);goog.exportSymbol('proto.ctpfront.proto.Dominant',null,global);goog.exportSymbol('proto.ctpfront.proto.GetLangLicenseRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.GetLangReq',null,global);goog.exportSymbol('proto.ctpfront.proto.GetLangRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.InsertOrderRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.LangPack',null,global);goog.exportSymbol('proto.ctpfront.proto.License',null,global);goog.exportSymbol('proto.ctpfront.proto.Login',null,global);goog.exportSymbol('proto.ctpfront.proto.LoginReq',null,global);goog.exportSymbol('proto.ctpfront.proto.LoginRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.MaxOrderVolume',null,global);goog.exportSymbol('proto.ctpfront.proto.MaxOrderVolumeRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.Order',null,global);goog.exportSymbol('proto.ctpfront.proto.OrderConditionGetReq',null,global);goog.exportSymbol('proto.ctpfront.proto.OrderConditionGetRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.OrderConditional',null,global);goog.exportSymbol('proto.ctpfront.proto.OrderConditionalReq',null,global);goog.exportSymbol('proto.ctpfront.proto.OrderConditionalRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.Position',null,global);goog.exportSymbol('proto.ctpfront.proto.PositionDetail',null,global);goog.exportSymbol('proto.ctpfront.proto.PositionDetailReq',null,global);goog.exportSymbol('proto.ctpfront.proto.PositionDetailRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.PositionReq',null,global);goog.exportSymbol('proto.ctpfront.proto.PositionRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.Quote',null,global);goog.exportSymbol('proto.ctpfront.proto.QuoteReq',null,global);goog.exportSymbol('proto.ctpfront.proto.QuoteRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.Response',null,global);goog.exportSymbol('proto.ctpfront.proto.Settlement',null,global);goog.exportSymbol('proto.ctpfront.proto.SettlementRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.SubConditionList',null,global);goog.exportSymbol('proto.ctpfront.proto.SubConditionListRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.SubData',null,global);goog.exportSymbol('proto.ctpfront.proto.SubDataRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.SubTickReq',null,global);goog.exportSymbol('proto.ctpfront.proto.SubTickRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.Subscribe',null,global);goog.exportSymbol('proto.ctpfront.proto.Target',null,global);goog.exportSymbol('proto.ctpfront.proto.TargetReq',null,global);goog.exportSymbol('proto.ctpfront.proto.TargetRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.TargetSelected',null,global);goog.exportSymbol('proto.ctpfront.proto.TargetSelectedReq',null,global);goog.exportSymbol('proto.ctpfront.proto.TargetSelectedRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.Trade',null,global);goog.exportSymbol('proto.ctpfront.proto.TradeAccountPasswdUpdateReq',null,global);goog.exportSymbol('proto.ctpfront.proto.TradeAccountPasswdUpdateRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.UserPasswdUpdateReq',null,global);goog.exportSymbol('proto.ctpfront.proto.UserPasswdUpdateRsp',null,global);goog.exportSymbol('proto.ctpfront.proto.Word',null,global);/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.LoginReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.LoginReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.LoginReq.displayName='proto.ctpfront.proto.LoginReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.LoginReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.LoginReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.LoginReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.LoginReq.toObject=function(includeInstance,msg){var f,obj={broker:jspb.Message.getFieldWithDefault(msg,1,""),account:jspb.Message.getFieldWithDefault(msg,2,""),password:jspb.Message.getFieldWithDefault(msg,3,""),module:jspb.Message.getFieldWithDefault(msg,4,""),lang:jspb.Message.getFieldWithDefault(msg,5,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.LoginReq}
 */proto.ctpfront.proto.LoginReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.LoginReq();return proto.ctpfront.proto.LoginReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.LoginReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.LoginReq}
 */proto.ctpfront.proto.LoginReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setPassword(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setModule(value);break;case 5:var value=/** @type {string} */reader.readString();msg.setLang(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.LoginReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.LoginReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.LoginReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.LoginReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getBroker();if(f.length>0){writer.writeString(1,f);}f=message.getAccount();if(f.length>0){writer.writeString(2,f);}f=message.getPassword();if(f.length>0){writer.writeString(3,f);}f=message.getModule();if(f.length>0){writer.writeString(4,f);}f=message.getLang();if(f.length>0){writer.writeString(5,f);}};/**
 * optional string broker = 1;
 * @return {string}
 */proto.ctpfront.proto.LoginReq.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.LoginReq.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string account = 2;
 * @return {string}
 */proto.ctpfront.proto.LoginReq.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.LoginReq.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string password = 3;
 * @return {string}
 */proto.ctpfront.proto.LoginReq.prototype.getPassword=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.LoginReq.prototype.setPassword=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional string module = 4;
 * @return {string}
 */proto.ctpfront.proto.LoginReq.prototype.getModule=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.LoginReq.prototype.setModule=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * optional string lang = 5;
 * @return {string}
 */proto.ctpfront.proto.LoginReq.prototype.getLang=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,5,""));};/** @param {string} value */proto.ctpfront.proto.LoginReq.prototype.setLang=function(value){jspb.Message.setProto3StringField(this,5,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Login=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Login,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Login.displayName='proto.ctpfront.proto.Login';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Login.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Login.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Login} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Login.toObject=function(includeInstance,msg){var f,obj={broker:jspb.Message.getFieldWithDefault(msg,10,""),account:jspb.Message.getFieldWithDefault(msg,11,""),password:jspb.Message.getFieldWithDefault(msg,12,""),tradingDay:jspb.Message.getFieldWithDefault(msg,13,""),systemName:jspb.Message.getFieldWithDefault(msg,14,""),loginTime:jspb.Message.getFieldWithDefault(msg,15,""),maxOrderRef:jspb.Message.getFieldWithDefault(msg,16,0),frontId:jspb.Message.getFieldWithDefault(msg,17,0),sessionId:jspb.Message.getFieldWithDefault(msg,18,0),version:jspb.Message.getFieldWithDefault(msg,19,""),address:jspb.Message.getFieldWithDefault(msg,20,""),content:jspb.Message.getFieldWithDefault(msg,21,""),addressIos:jspb.Message.getFieldWithDefault(msg,22,""),versionIos:jspb.Message.getFieldWithDefault(msg,23,""),contentIos:jspb.Message.getFieldWithDefault(msg,24,""),crmAddress:jspb.Message.getFieldWithDefault(msg,25,""),langTs:jspb.Message.getFieldWithDefault(msg,27,""),licenseTs:jspb.Message.getFieldWithDefault(msg,28,""),module:jspb.Message.getFieldWithDefault(msg,29,""),lang:jspb.Message.getFieldWithDefault(msg,30,""),userName:jspb.Message.getFieldWithDefault(msg,31,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Login}
 */proto.ctpfront.proto.Login.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Login();return proto.ctpfront.proto.Login.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Login} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Login}
 */proto.ctpfront.proto.Login.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 10:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 11:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 12:var value=/** @type {string} */reader.readString();msg.setPassword(value);break;case 13:var value=/** @type {string} */reader.readString();msg.setTradingDay(value);break;case 14:var value=/** @type {string} */reader.readString();msg.setSystemName(value);break;case 15:var value=/** @type {string} */reader.readString();msg.setLoginTime(value);break;case 16:var value=/** @type {number} */reader.readUint32();msg.setMaxOrderRef(value);break;case 17:var value=/** @type {number} */reader.readInt32();msg.setFrontId(value);break;case 18:var value=/** @type {number} */reader.readInt32();msg.setSessionId(value);break;case 19:var value=/** @type {string} */reader.readString();msg.setVersion(value);break;case 20:var value=/** @type {string} */reader.readString();msg.setAddress(value);break;case 21:var value=/** @type {string} */reader.readString();msg.setContent(value);break;case 22:var value=/** @type {string} */reader.readString();msg.setAddressIos(value);break;case 23:var value=/** @type {string} */reader.readString();msg.setVersionIos(value);break;case 24:var value=/** @type {string} */reader.readString();msg.setContentIos(value);break;case 25:var value=/** @type {string} */reader.readString();msg.setCrmAddress(value);break;case 27:var value=/** @type {string} */reader.readString();msg.setLangTs(value);break;case 28:var value=/** @type {string} */reader.readString();msg.setLicenseTs(value);break;case 29:var value=/** @type {string} */reader.readString();msg.setModule(value);break;case 30:var value=/** @type {string} */reader.readString();msg.setLang(value);break;case 31:var value=/** @type {string} */reader.readString();msg.setUserName(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Login.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Login.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Login} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Login.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getBroker();if(f.length>0){writer.writeString(10,f);}f=message.getAccount();if(f.length>0){writer.writeString(11,f);}f=message.getPassword();if(f.length>0){writer.writeString(12,f);}f=message.getTradingDay();if(f.length>0){writer.writeString(13,f);}f=message.getSystemName();if(f.length>0){writer.writeString(14,f);}f=message.getLoginTime();if(f.length>0){writer.writeString(15,f);}f=message.getMaxOrderRef();if(f!==0){writer.writeUint32(16,f);}f=message.getFrontId();if(f!==0){writer.writeInt32(17,f);}f=message.getSessionId();if(f!==0){writer.writeInt32(18,f);}f=message.getVersion();if(f.length>0){writer.writeString(19,f);}f=message.getAddress();if(f.length>0){writer.writeString(20,f);}f=message.getContent();if(f.length>0){writer.writeString(21,f);}f=message.getAddressIos();if(f.length>0){writer.writeString(22,f);}f=message.getVersionIos();if(f.length>0){writer.writeString(23,f);}f=message.getContentIos();if(f.length>0){writer.writeString(24,f);}f=message.getCrmAddress();if(f.length>0){writer.writeString(25,f);}f=message.getLangTs();if(f.length>0){writer.writeString(27,f);}f=message.getLicenseTs();if(f.length>0){writer.writeString(28,f);}f=message.getModule();if(f.length>0){writer.writeString(29,f);}f=message.getLang();if(f.length>0){writer.writeString(30,f);}f=message.getUserName();if(f.length>0){writer.writeString(31,f);}};/**
 * optional string broker = 10;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,10,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,10,value);};/**
 * optional string account = 11;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,11,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,11,value);};/**
 * optional string password = 12;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getPassword=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,12,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setPassword=function(value){jspb.Message.setProto3StringField(this,12,value);};/**
 * optional string trading_day = 13;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getTradingDay=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,13,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setTradingDay=function(value){jspb.Message.setProto3StringField(this,13,value);};/**
 * optional string system_name = 14;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getSystemName=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,14,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setSystemName=function(value){jspb.Message.setProto3StringField(this,14,value);};/**
 * optional string login_time = 15;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getLoginTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,15,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setLoginTime=function(value){jspb.Message.setProto3StringField(this,15,value);};/**
 * optional uint32 max_order_ref = 16;
 * @return {number}
 */proto.ctpfront.proto.Login.prototype.getMaxOrderRef=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,16,0));};/** @param {number} value */proto.ctpfront.proto.Login.prototype.setMaxOrderRef=function(value){jspb.Message.setProto3IntField(this,16,value);};/**
 * optional int32 front_id = 17;
 * @return {number}
 */proto.ctpfront.proto.Login.prototype.getFrontId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,17,0));};/** @param {number} value */proto.ctpfront.proto.Login.prototype.setFrontId=function(value){jspb.Message.setProto3IntField(this,17,value);};/**
 * optional int32 session_id = 18;
 * @return {number}
 */proto.ctpfront.proto.Login.prototype.getSessionId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,18,0));};/** @param {number} value */proto.ctpfront.proto.Login.prototype.setSessionId=function(value){jspb.Message.setProto3IntField(this,18,value);};/**
 * optional string version = 19;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getVersion=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,19,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setVersion=function(value){jspb.Message.setProto3StringField(this,19,value);};/**
 * optional string address = 20;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getAddress=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,20,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setAddress=function(value){jspb.Message.setProto3StringField(this,20,value);};/**
 * optional string content = 21;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getContent=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,21,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setContent=function(value){jspb.Message.setProto3StringField(this,21,value);};/**
 * optional string address_ios = 22;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getAddressIos=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,22,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setAddressIos=function(value){jspb.Message.setProto3StringField(this,22,value);};/**
 * optional string version_ios = 23;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getVersionIos=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,23,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setVersionIos=function(value){jspb.Message.setProto3StringField(this,23,value);};/**
 * optional string content_ios = 24;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getContentIos=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,24,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setContentIos=function(value){jspb.Message.setProto3StringField(this,24,value);};/**
 * optional string crm_address = 25;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getCrmAddress=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,25,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setCrmAddress=function(value){jspb.Message.setProto3StringField(this,25,value);};/**
 * optional string lang_ts = 27;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getLangTs=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,27,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setLangTs=function(value){jspb.Message.setProto3StringField(this,27,value);};/**
 * optional string license_ts = 28;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getLicenseTs=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,28,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setLicenseTs=function(value){jspb.Message.setProto3StringField(this,28,value);};/**
 * optional string module = 29;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getModule=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,29,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setModule=function(value){jspb.Message.setProto3StringField(this,29,value);};/**
 * optional string lang = 30;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getLang=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,30,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setLang=function(value){jspb.Message.setProto3StringField(this,30,value);};/**
 * optional string user_name = 31;
 * @return {string}
 */proto.ctpfront.proto.Login.prototype.getUserName=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,31,""));};/** @param {string} value */proto.ctpfront.proto.Login.prototype.setUserName=function(value){jspb.Message.setProto3StringField(this,31,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.LoginRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.LoginRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.LoginRsp.displayName='proto.ctpfront.proto.LoginRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.LoginRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.LoginRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.LoginRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.LoginRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.Login.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.LoginRsp}
 */proto.ctpfront.proto.LoginRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.LoginRsp();return proto.ctpfront.proto.LoginRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.LoginRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.LoginRsp}
 */proto.ctpfront.proto.LoginRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 10:var value=new proto.ctpfront.proto.Login();reader.readMessage(value,proto.ctpfront.proto.Login.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.LoginRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.LoginRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.LoginRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.LoginRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(10,f,proto.ctpfront.proto.Login.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.LoginRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.LoginRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.LoginRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.LoginRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional Login data = 10;
 * @return {?proto.ctpfront.proto.Login}
 */proto.ctpfront.proto.LoginRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.Login} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.Login,10));};/** @param {?proto.ctpfront.proto.Login|undefined} value */proto.ctpfront.proto.LoginRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,10,value);};proto.ctpfront.proto.LoginRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.LoginRsp.prototype.hasData=function(){return jspb.Message.getField(this,10)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.MaxOrderVolume=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.MaxOrderVolume,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.MaxOrderVolume.displayName='proto.ctpfront.proto.MaxOrderVolume';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.MaxOrderVolume.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.MaxOrderVolume.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.MaxOrderVolume} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.MaxOrderVolume.toObject=function(includeInstance,msg){var f,obj={account:jspb.Message.getFieldWithDefault(msg,1,""),targetId:jspb.Message.getFieldWithDefault(msg,2,""),direction:jspb.Message.getFieldWithDefault(msg,3,0),offset:jspb.Message.getFieldWithDefault(msg,4,0),hedge:jspb.Message.getFieldWithDefault(msg,5,0),maxVolume:jspb.Message.getFieldWithDefault(msg,6,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.MaxOrderVolume}
 */proto.ctpfront.proto.MaxOrderVolume.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.MaxOrderVolume();return proto.ctpfront.proto.MaxOrderVolume.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.MaxOrderVolume} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.MaxOrderVolume}
 */proto.ctpfront.proto.MaxOrderVolume.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 3:var value=/** @type {number} */reader.readInt32();msg.setDirection(value);break;case 4:var value=/** @type {number} */reader.readInt32();msg.setOffset(value);break;case 5:var value=/** @type {number} */reader.readInt32();msg.setHedge(value);break;case 6:var value=/** @type {number} */reader.readInt32();msg.setMaxVolume(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.MaxOrderVolume.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.MaxOrderVolume.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.MaxOrderVolume} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.MaxOrderVolume.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getAccount();if(f.length>0){writer.writeString(1,f);}f=message.getTargetId();if(f.length>0){writer.writeString(2,f);}f=message.getDirection();if(f!==0){writer.writeInt32(3,f);}f=message.getOffset();if(f!==0){writer.writeInt32(4,f);}f=message.getHedge();if(f!==0){writer.writeInt32(5,f);}f=message.getMaxVolume();if(f!==0){writer.writeInt32(6,f);}};/**
 * optional string account = 1;
 * @return {string}
 */proto.ctpfront.proto.MaxOrderVolume.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.MaxOrderVolume.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string target_id = 2;
 * @return {string}
 */proto.ctpfront.proto.MaxOrderVolume.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.MaxOrderVolume.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional int32 direction = 3;
 * @return {number}
 */proto.ctpfront.proto.MaxOrderVolume.prototype.getDirection=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,3,0));};/** @param {number} value */proto.ctpfront.proto.MaxOrderVolume.prototype.setDirection=function(value){jspb.Message.setProto3IntField(this,3,value);};/**
 * optional int32 offset = 4;
 * @return {number}
 */proto.ctpfront.proto.MaxOrderVolume.prototype.getOffset=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,4,0));};/** @param {number} value */proto.ctpfront.proto.MaxOrderVolume.prototype.setOffset=function(value){jspb.Message.setProto3IntField(this,4,value);};/**
 * optional int32 hedge = 5;
 * @return {number}
 */proto.ctpfront.proto.MaxOrderVolume.prototype.getHedge=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,5,0));};/** @param {number} value */proto.ctpfront.proto.MaxOrderVolume.prototype.setHedge=function(value){jspb.Message.setProto3IntField(this,5,value);};/**
 * optional int32 max_volume = 6;
 * @return {number}
 */proto.ctpfront.proto.MaxOrderVolume.prototype.getMaxVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,6,0));};/** @param {number} value */proto.ctpfront.proto.MaxOrderVolume.prototype.setMaxVolume=function(value){jspb.Message.setProto3IntField(this,6,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.MaxOrderVolumeRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.MaxOrderVolumeRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.MaxOrderVolumeRsp.displayName='proto.ctpfront.proto.MaxOrderVolumeRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.MaxOrderVolumeRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.MaxOrderVolumeRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.MaxOrderVolumeRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.MaxOrderVolume.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.MaxOrderVolumeRsp}
 */proto.ctpfront.proto.MaxOrderVolumeRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.MaxOrderVolumeRsp();return proto.ctpfront.proto.MaxOrderVolumeRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.MaxOrderVolumeRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.MaxOrderVolumeRsp}
 */proto.ctpfront.proto.MaxOrderVolumeRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 10:var value=new proto.ctpfront.proto.MaxOrderVolume();reader.readMessage(value,proto.ctpfront.proto.MaxOrderVolume.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.MaxOrderVolumeRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.MaxOrderVolumeRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.MaxOrderVolumeRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(10,f,proto.ctpfront.proto.MaxOrderVolume.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional MaxOrderVolume data = 10;
 * @return {?proto.ctpfront.proto.MaxOrderVolume}
 */proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.MaxOrderVolume} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.MaxOrderVolume,10));};/** @param {?proto.ctpfront.proto.MaxOrderVolume|undefined} value */proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,10,value);};proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.MaxOrderVolumeRsp.prototype.hasData=function(){return jspb.Message.getField(this,10)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.SubData=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.SubData,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.SubData.displayName='proto.ctpfront.proto.SubData';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.SubData.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.SubData.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubData} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.SubData.toObject=function(includeInstance,msg){var f,obj={data:jspb.Message.getFieldWithDefault(msg,1,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubData}
 */proto.ctpfront.proto.SubData.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.SubData();return proto.ctpfront.proto.SubData.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubData}
 */proto.ctpfront.proto.SubData.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {number} */reader.readUint32();msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.SubData.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.SubData.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.SubData.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getData();if(f!==0){writer.writeUint32(1,f);}};/**
 * optional uint32 data = 1;
 * @return {number}
 */proto.ctpfront.proto.SubData.prototype.getData=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,1,0));};/** @param {number} value */proto.ctpfront.proto.SubData.prototype.setData=function(value){jspb.Message.setProto3IntField(this,1,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.SubDataRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.SubDataRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.SubDataRsp.displayName='proto.ctpfront.proto.SubDataRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.SubDataRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.SubDataRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubDataRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.SubDataRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:jspb.Message.getFieldWithDefault(msg,10,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubDataRsp}
 */proto.ctpfront.proto.SubDataRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.SubDataRsp();return proto.ctpfront.proto.SubDataRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubDataRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubDataRsp}
 */proto.ctpfront.proto.SubDataRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 10:var value=/** @type {number} */reader.readUint32();msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.SubDataRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.SubDataRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubDataRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.SubDataRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!==0){writer.writeUint32(10,f);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.SubDataRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.SubDataRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.SubDataRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.SubDataRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional uint32 data = 10;
 * @return {number}
 */proto.ctpfront.proto.SubDataRsp.prototype.getData=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,10,0));};/** @param {number} value */proto.ctpfront.proto.SubDataRsp.prototype.setData=function(value){jspb.Message.setProto3IntField(this,10,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Order=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Order,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Order.displayName='proto.ctpfront.proto.Order';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Order.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Order.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Order} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Order.toObject=function(includeInstance,msg){var f,obj={orderRef:jspb.Message.getFieldWithDefault(msg,1,""),targetId:jspb.Message.getFieldWithDefault(msg,2,""),broker:jspb.Message.getFieldWithDefault(msg,3,""),account:jspb.Message.getFieldWithDefault(msg,4,""),price:+jspb.Message.getFieldWithDefault(msg,7,0.0),exchangeId:jspb.Message.getFieldWithDefault(msg,20,0),priceType:jspb.Message.getFieldWithDefault(msg,21,0),volume:jspb.Message.getFieldWithDefault(msg,23,0),direction:jspb.Message.getFieldWithDefault(msg,24,0),offset:jspb.Message.getFieldWithDefault(msg,25,0),hedge:jspb.Message.getFieldWithDefault(msg,26,0),minVolume:jspb.Message.getFieldWithDefault(msg,27,0),volumeType:jspb.Message.getFieldWithDefault(msg,28,0),validTimeType:jspb.Message.getFieldWithDefault(msg,29,0),orderId:jspb.Message.getFieldWithDefault(msg,40,""),tradingDay:jspb.Message.getFieldWithDefault(msg,41,""),stateDetail:jspb.Message.getFieldWithDefault(msg,42,""),insertTime:jspb.Message.getFieldWithDefault(msg,43,""),state:jspb.Message.getFieldWithDefault(msg,44,0),tradedVolume:jspb.Message.getFieldWithDefault(msg,45,0),cancelTime:jspb.Message.getFieldWithDefault(msg,46,""),orderSeq:jspb.Message.getFieldWithDefault(msg,47,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Order}
 */proto.ctpfront.proto.Order.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Order();return proto.ctpfront.proto.Order.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Order} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Order}
 */proto.ctpfront.proto.Order.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setOrderRef(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 7:var value=/** @type {number} */reader.readDouble();msg.setPrice(value);break;case 20:var value=/** @type {number} */reader.readUint32();msg.setExchangeId(value);break;case 21:var value=/** @type {number} */reader.readUint32();msg.setPriceType(value);break;case 23:var value=/** @type {number} */reader.readUint32();msg.setVolume(value);break;case 24:var value=/** @type {number} */reader.readUint32();msg.setDirection(value);break;case 25:var value=/** @type {number} */reader.readUint32();msg.setOffset(value);break;case 26:var value=/** @type {number} */reader.readUint32();msg.setHedge(value);break;case 27:var value=/** @type {number} */reader.readUint32();msg.setMinVolume(value);break;case 28:var value=/** @type {number} */reader.readUint32();msg.setVolumeType(value);break;case 29:var value=/** @type {number} */reader.readUint32();msg.setValidTimeType(value);break;case 40:var value=/** @type {string} */reader.readString();msg.setOrderId(value);break;case 41:var value=/** @type {string} */reader.readString();msg.setTradingDay(value);break;case 42:var value=/** @type {string} */reader.readString();msg.setStateDetail(value);break;case 43:var value=/** @type {string} */reader.readString();msg.setInsertTime(value);break;case 44:var value=/** @type {number} */reader.readUint32();msg.setState(value);break;case 45:var value=/** @type {number} */reader.readUint32();msg.setTradedVolume(value);break;case 46:var value=/** @type {string} */reader.readString();msg.setCancelTime(value);break;case 47:var value=/** @type {string} */reader.readString();msg.setOrderSeq(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Order.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Order.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Order} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Order.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getOrderRef();if(f.length>0){writer.writeString(1,f);}f=message.getTargetId();if(f.length>0){writer.writeString(2,f);}f=message.getBroker();if(f.length>0){writer.writeString(3,f);}f=message.getAccount();if(f.length>0){writer.writeString(4,f);}f=message.getPrice();if(f!==0.0){writer.writeDouble(7,f);}f=message.getExchangeId();if(f!==0){writer.writeUint32(20,f);}f=message.getPriceType();if(f!==0){writer.writeUint32(21,f);}f=message.getVolume();if(f!==0){writer.writeUint32(23,f);}f=message.getDirection();if(f!==0){writer.writeUint32(24,f);}f=message.getOffset();if(f!==0){writer.writeUint32(25,f);}f=message.getHedge();if(f!==0){writer.writeUint32(26,f);}f=message.getMinVolume();if(f!==0){writer.writeUint32(27,f);}f=message.getVolumeType();if(f!==0){writer.writeUint32(28,f);}f=message.getValidTimeType();if(f!==0){writer.writeUint32(29,f);}f=message.getOrderId();if(f.length>0){writer.writeString(40,f);}f=message.getTradingDay();if(f.length>0){writer.writeString(41,f);}f=message.getStateDetail();if(f.length>0){writer.writeString(42,f);}f=message.getInsertTime();if(f.length>0){writer.writeString(43,f);}f=message.getState();if(f!==0){writer.writeUint32(44,f);}f=message.getTradedVolume();if(f!==0){writer.writeUint32(45,f);}f=message.getCancelTime();if(f.length>0){writer.writeString(46,f);}f=message.getOrderSeq();if(f.length>0){writer.writeString(47,f);}};/**
 * optional string order_ref = 1;
 * @return {string}
 */proto.ctpfront.proto.Order.prototype.getOrderRef=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.Order.prototype.setOrderRef=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string target_id = 2;
 * @return {string}
 */proto.ctpfront.proto.Order.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.Order.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string broker = 3;
 * @return {string}
 */proto.ctpfront.proto.Order.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.Order.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional string account = 4;
 * @return {string}
 */proto.ctpfront.proto.Order.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.Order.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * optional double price = 7;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,7,0.0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setPrice=function(value){jspb.Message.setProto3FloatField(this,7,value);};/**
 * optional uint32 exchange_id = 20;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getExchangeId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,20,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setExchangeId=function(value){jspb.Message.setProto3IntField(this,20,value);};/**
 * optional uint32 price_type = 21;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getPriceType=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,21,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setPriceType=function(value){jspb.Message.setProto3IntField(this,21,value);};/**
 * optional uint32 volume = 23;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,23,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setVolume=function(value){jspb.Message.setProto3IntField(this,23,value);};/**
 * optional uint32 direction = 24;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getDirection=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,24,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setDirection=function(value){jspb.Message.setProto3IntField(this,24,value);};/**
 * optional uint32 offset = 25;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getOffset=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,25,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setOffset=function(value){jspb.Message.setProto3IntField(this,25,value);};/**
 * optional uint32 hedge = 26;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getHedge=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,26,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setHedge=function(value){jspb.Message.setProto3IntField(this,26,value);};/**
 * optional uint32 min_volume = 27;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getMinVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,27,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setMinVolume=function(value){jspb.Message.setProto3IntField(this,27,value);};/**
 * optional uint32 volume_type = 28;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getVolumeType=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,28,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setVolumeType=function(value){jspb.Message.setProto3IntField(this,28,value);};/**
 * optional uint32 valid_time_type = 29;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getValidTimeType=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,29,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setValidTimeType=function(value){jspb.Message.setProto3IntField(this,29,value);};/**
 * optional string order_id = 40;
 * @return {string}
 */proto.ctpfront.proto.Order.prototype.getOrderId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,40,""));};/** @param {string} value */proto.ctpfront.proto.Order.prototype.setOrderId=function(value){jspb.Message.setProto3StringField(this,40,value);};/**
 * optional string trading_day = 41;
 * @return {string}
 */proto.ctpfront.proto.Order.prototype.getTradingDay=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,41,""));};/** @param {string} value */proto.ctpfront.proto.Order.prototype.setTradingDay=function(value){jspb.Message.setProto3StringField(this,41,value);};/**
 * optional string state_detail = 42;
 * @return {string}
 */proto.ctpfront.proto.Order.prototype.getStateDetail=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,42,""));};/** @param {string} value */proto.ctpfront.proto.Order.prototype.setStateDetail=function(value){jspb.Message.setProto3StringField(this,42,value);};/**
 * optional string insert_time = 43;
 * @return {string}
 */proto.ctpfront.proto.Order.prototype.getInsertTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,43,""));};/** @param {string} value */proto.ctpfront.proto.Order.prototype.setInsertTime=function(value){jspb.Message.setProto3StringField(this,43,value);};/**
 * optional uint32 state = 44;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getState=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,44,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setState=function(value){jspb.Message.setProto3IntField(this,44,value);};/**
 * optional uint32 traded_volume = 45;
 * @return {number}
 */proto.ctpfront.proto.Order.prototype.getTradedVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,45,0));};/** @param {number} value */proto.ctpfront.proto.Order.prototype.setTradedVolume=function(value){jspb.Message.setProto3IntField(this,45,value);};/**
 * optional string cancel_time = 46;
 * @return {string}
 */proto.ctpfront.proto.Order.prototype.getCancelTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,46,""));};/** @param {string} value */proto.ctpfront.proto.Order.prototype.setCancelTime=function(value){jspb.Message.setProto3StringField(this,46,value);};/**
 * optional string order_seq = 47;
 * @return {string}
 */proto.ctpfront.proto.Order.prototype.getOrderSeq=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,47,""));};/** @param {string} value */proto.ctpfront.proto.Order.prototype.setOrderSeq=function(value){jspb.Message.setProto3StringField(this,47,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Trade=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Trade,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Trade.displayName='proto.ctpfront.proto.Trade';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Trade.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Trade.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Trade} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Trade.toObject=function(includeInstance,msg){var f,obj={orderRef:jspb.Message.getFieldWithDefault(msg,1,""),orderId:jspb.Message.getFieldWithDefault(msg,2,""),tradeId:jspb.Message.getFieldWithDefault(msg,3,""),broker:jspb.Message.getFieldWithDefault(msg,4,""),account:jspb.Message.getFieldWithDefault(msg,5,""),targetId:jspb.Message.getFieldWithDefault(msg,6,""),tradeTime:jspb.Message.getFieldWithDefault(msg,7,""),tradingDay:jspb.Message.getFieldWithDefault(msg,8,""),price:+jspb.Message.getFieldWithDefault(msg,9,0.0),exchangeId:jspb.Message.getFieldWithDefault(msg,11,0),volume:jspb.Message.getFieldWithDefault(msg,12,0),direction:jspb.Message.getFieldWithDefault(msg,13,0),offset:jspb.Message.getFieldWithDefault(msg,14,0),hedge:jspb.Message.getFieldWithDefault(msg,15,0),orderSeq:jspb.Message.getFieldWithDefault(msg,16,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Trade}
 */proto.ctpfront.proto.Trade.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Trade();return proto.ctpfront.proto.Trade.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Trade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Trade}
 */proto.ctpfront.proto.Trade.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setOrderRef(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setOrderId(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setTradeId(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 5:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 6:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 7:var value=/** @type {string} */reader.readString();msg.setTradeTime(value);break;case 8:var value=/** @type {string} */reader.readString();msg.setTradingDay(value);break;case 9:var value=/** @type {number} */reader.readDouble();msg.setPrice(value);break;case 11:var value=/** @type {number} */reader.readUint32();msg.setExchangeId(value);break;case 12:var value=/** @type {number} */reader.readUint32();msg.setVolume(value);break;case 13:var value=/** @type {number} */reader.readUint32();msg.setDirection(value);break;case 14:var value=/** @type {number} */reader.readUint32();msg.setOffset(value);break;case 15:var value=/** @type {number} */reader.readUint32();msg.setHedge(value);break;case 16:var value=/** @type {string} */reader.readString();msg.setOrderSeq(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Trade.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Trade.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Trade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Trade.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getOrderRef();if(f.length>0){writer.writeString(1,f);}f=message.getOrderId();if(f.length>0){writer.writeString(2,f);}f=message.getTradeId();if(f.length>0){writer.writeString(3,f);}f=message.getBroker();if(f.length>0){writer.writeString(4,f);}f=message.getAccount();if(f.length>0){writer.writeString(5,f);}f=message.getTargetId();if(f.length>0){writer.writeString(6,f);}f=message.getTradeTime();if(f.length>0){writer.writeString(7,f);}f=message.getTradingDay();if(f.length>0){writer.writeString(8,f);}f=message.getPrice();if(f!==0.0){writer.writeDouble(9,f);}f=message.getExchangeId();if(f!==0){writer.writeUint32(11,f);}f=message.getVolume();if(f!==0){writer.writeUint32(12,f);}f=message.getDirection();if(f!==0){writer.writeUint32(13,f);}f=message.getOffset();if(f!==0){writer.writeUint32(14,f);}f=message.getHedge();if(f!==0){writer.writeUint32(15,f);}f=message.getOrderSeq();if(f.length>0){writer.writeString(16,f);}};/**
 * optional string order_ref = 1;
 * @return {string}
 */proto.ctpfront.proto.Trade.prototype.getOrderRef=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.Trade.prototype.setOrderRef=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string order_id = 2;
 * @return {string}
 */proto.ctpfront.proto.Trade.prototype.getOrderId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.Trade.prototype.setOrderId=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string trade_id = 3;
 * @return {string}
 */proto.ctpfront.proto.Trade.prototype.getTradeId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.Trade.prototype.setTradeId=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional string broker = 4;
 * @return {string}
 */proto.ctpfront.proto.Trade.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.Trade.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * optional string account = 5;
 * @return {string}
 */proto.ctpfront.proto.Trade.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,5,""));};/** @param {string} value */proto.ctpfront.proto.Trade.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,5,value);};/**
 * optional string target_id = 6;
 * @return {string}
 */proto.ctpfront.proto.Trade.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,6,""));};/** @param {string} value */proto.ctpfront.proto.Trade.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,6,value);};/**
 * optional string trade_time = 7;
 * @return {string}
 */proto.ctpfront.proto.Trade.prototype.getTradeTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,7,""));};/** @param {string} value */proto.ctpfront.proto.Trade.prototype.setTradeTime=function(value){jspb.Message.setProto3StringField(this,7,value);};/**
 * optional string trading_day = 8;
 * @return {string}
 */proto.ctpfront.proto.Trade.prototype.getTradingDay=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,8,""));};/** @param {string} value */proto.ctpfront.proto.Trade.prototype.setTradingDay=function(value){jspb.Message.setProto3StringField(this,8,value);};/**
 * optional double price = 9;
 * @return {number}
 */proto.ctpfront.proto.Trade.prototype.getPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,9,0.0));};/** @param {number} value */proto.ctpfront.proto.Trade.prototype.setPrice=function(value){jspb.Message.setProto3FloatField(this,9,value);};/**
 * optional uint32 exchange_id = 11;
 * @return {number}
 */proto.ctpfront.proto.Trade.prototype.getExchangeId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,11,0));};/** @param {number} value */proto.ctpfront.proto.Trade.prototype.setExchangeId=function(value){jspb.Message.setProto3IntField(this,11,value);};/**
 * optional uint32 volume = 12;
 * @return {number}
 */proto.ctpfront.proto.Trade.prototype.getVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,12,0));};/** @param {number} value */proto.ctpfront.proto.Trade.prototype.setVolume=function(value){jspb.Message.setProto3IntField(this,12,value);};/**
 * optional uint32 direction = 13;
 * @return {number}
 */proto.ctpfront.proto.Trade.prototype.getDirection=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,13,0));};/** @param {number} value */proto.ctpfront.proto.Trade.prototype.setDirection=function(value){jspb.Message.setProto3IntField(this,13,value);};/**
 * optional uint32 offset = 14;
 * @return {number}
 */proto.ctpfront.proto.Trade.prototype.getOffset=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,14,0));};/** @param {number} value */proto.ctpfront.proto.Trade.prototype.setOffset=function(value){jspb.Message.setProto3IntField(this,14,value);};/**
 * optional uint32 hedge = 15;
 * @return {number}
 */proto.ctpfront.proto.Trade.prototype.getHedge=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,15,0));};/** @param {number} value */proto.ctpfront.proto.Trade.prototype.setHedge=function(value){jspb.Message.setProto3IntField(this,15,value);};/**
 * optional string order_seq = 16;
 * @return {string}
 */proto.ctpfront.proto.Trade.prototype.getOrderSeq=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,16,""));};/** @param {string} value */proto.ctpfront.proto.Trade.prototype.setOrderSeq=function(value){jspb.Message.setProto3StringField(this,16,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.CancelOrder=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.CancelOrder,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.CancelOrder.displayName='proto.ctpfront.proto.CancelOrder';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.CancelOrder.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.CancelOrder.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.CancelOrder} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.CancelOrder.toObject=function(includeInstance,msg){var f,obj={orderRef:jspb.Message.getFieldWithDefault(msg,1,""),orderId:jspb.Message.getFieldWithDefault(msg,2,""),broker:jspb.Message.getFieldWithDefault(msg,3,""),account:jspb.Message.getFieldWithDefault(msg,4,""),exchangeId:jspb.Message.getFieldWithDefault(msg,6,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.CancelOrder}
 */proto.ctpfront.proto.CancelOrder.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.CancelOrder();return proto.ctpfront.proto.CancelOrder.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.CancelOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.CancelOrder}
 */proto.ctpfront.proto.CancelOrder.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setOrderRef(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setOrderId(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 6:var value=/** @type {number} */reader.readUint32();msg.setExchangeId(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.CancelOrder.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.CancelOrder.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.CancelOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.CancelOrder.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getOrderRef();if(f.length>0){writer.writeString(1,f);}f=message.getOrderId();if(f.length>0){writer.writeString(2,f);}f=message.getBroker();if(f.length>0){writer.writeString(3,f);}f=message.getAccount();if(f.length>0){writer.writeString(4,f);}f=message.getExchangeId();if(f!==0){writer.writeUint32(6,f);}};/**
 * optional string order_ref = 1;
 * @return {string}
 */proto.ctpfront.proto.CancelOrder.prototype.getOrderRef=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.CancelOrder.prototype.setOrderRef=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string order_id = 2;
 * @return {string}
 */proto.ctpfront.proto.CancelOrder.prototype.getOrderId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.CancelOrder.prototype.setOrderId=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string broker = 3;
 * @return {string}
 */proto.ctpfront.proto.CancelOrder.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.CancelOrder.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional string account = 4;
 * @return {string}
 */proto.ctpfront.proto.CancelOrder.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.CancelOrder.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * optional uint32 exchange_id = 6;
 * @return {number}
 */proto.ctpfront.proto.CancelOrder.prototype.getExchangeId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,6,0));};/** @param {number} value */proto.ctpfront.proto.CancelOrder.prototype.setExchangeId=function(value){jspb.Message.setProto3IntField(this,6,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.InsertOrderRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.InsertOrderRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.InsertOrderRsp.displayName='proto.ctpfront.proto.InsertOrderRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.InsertOrderRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.InsertOrderRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.InsertOrderRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.InsertOrderRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.Order.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.InsertOrderRsp}
 */proto.ctpfront.proto.InsertOrderRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.InsertOrderRsp();return proto.ctpfront.proto.InsertOrderRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.InsertOrderRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.InsertOrderRsp}
 */proto.ctpfront.proto.InsertOrderRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 2:var value=new proto.ctpfront.proto.Order();reader.readMessage(value,proto.ctpfront.proto.Order.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.InsertOrderRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.InsertOrderRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.InsertOrderRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.InsertOrderRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(2,f,proto.ctpfront.proto.Order.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.InsertOrderRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.InsertOrderRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.InsertOrderRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.InsertOrderRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional Order data = 2;
 * @return {?proto.ctpfront.proto.Order}
 */proto.ctpfront.proto.InsertOrderRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.Order} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.Order,2));};/** @param {?proto.ctpfront.proto.Order|undefined} value */proto.ctpfront.proto.InsertOrderRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.InsertOrderRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.InsertOrderRsp.prototype.hasData=function(){return jspb.Message.getField(this,2)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.CancelOrderRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.CancelOrderRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.CancelOrderRsp.displayName='proto.ctpfront.proto.CancelOrderRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.CancelOrderRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.CancelOrderRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.CancelOrderRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.CancelOrderRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.CancelOrder.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.CancelOrderRsp}
 */proto.ctpfront.proto.CancelOrderRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.CancelOrderRsp();return proto.ctpfront.proto.CancelOrderRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.CancelOrderRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.CancelOrderRsp}
 */proto.ctpfront.proto.CancelOrderRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 2:var value=new proto.ctpfront.proto.CancelOrder();reader.readMessage(value,proto.ctpfront.proto.CancelOrder.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.CancelOrderRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.CancelOrderRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.CancelOrderRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.CancelOrderRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(2,f,proto.ctpfront.proto.CancelOrder.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.CancelOrderRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.CancelOrderRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.CancelOrderRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.CancelOrderRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional CancelOrder data = 2;
 * @return {?proto.ctpfront.proto.CancelOrder}
 */proto.ctpfront.proto.CancelOrderRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.CancelOrder} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.CancelOrder,2));};/** @param {?proto.ctpfront.proto.CancelOrder|undefined} value */proto.ctpfront.proto.CancelOrderRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.CancelOrderRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.CancelOrderRsp.prototype.hasData=function(){return jspb.Message.getField(this,2)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.CapitalReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.CapitalReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.CapitalReq.displayName='proto.ctpfront.proto.CapitalReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.CapitalReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.CapitalReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.CapitalReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.CapitalReq.toObject=function(includeInstance,msg){var f,obj={account:jspb.Message.getFieldWithDefault(msg,1,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.CapitalReq}
 */proto.ctpfront.proto.CapitalReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.CapitalReq();return proto.ctpfront.proto.CapitalReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.CapitalReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.CapitalReq}
 */proto.ctpfront.proto.CapitalReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.CapitalReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.CapitalReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.CapitalReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.CapitalReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getAccount();if(f.length>0){writer.writeString(1,f);}};/**
 * optional string account = 1;
 * @return {string}
 */proto.ctpfront.proto.CapitalReq.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.CapitalReq.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Capital=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Capital,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Capital.displayName='proto.ctpfront.proto.Capital';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Capital.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Capital.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Capital} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Capital.toObject=function(includeInstance,msg){var f,obj={available:+jspb.Message.getFieldWithDefault(msg,1,0.0),balance:+jspb.Message.getFieldWithDefault(msg,2,0.0),cashIn:+jspb.Message.getFieldWithDefault(msg,3,0.0),account:jspb.Message.getFieldWithDefault(msg,5,""),closeProfit:+jspb.Message.getFieldWithDefault(msg,6,0.0),commission:+jspb.Message.getFieldWithDefault(msg,7,0.0),credit:+jspb.Message.getFieldWithDefault(msg,8,0.0),currMargin:+jspb.Message.getFieldWithDefault(msg,9,0.0),deposit:+jspb.Message.getFieldWithDefault(msg,10,0.0),frozenCommission:+jspb.Message.getFieldWithDefault(msg,13,0.0),frozenMargin:+jspb.Message.getFieldWithDefault(msg,14,0.0),interest:+jspb.Message.getFieldWithDefault(msg,15,0.0),interestBase:+jspb.Message.getFieldWithDefault(msg,16,0.0),frozenCash:+jspb.Message.getFieldWithDefault(msg,17,0.0),positionProfit:+jspb.Message.getFieldWithDefault(msg,18,0.0),preBalance:+jspb.Message.getFieldWithDefault(msg,19,0.0),withdraw:+jspb.Message.getFieldWithDefault(msg,20,0.0),withdrawQuota:+jspb.Message.getFieldWithDefault(msg,21,0.0),currencyId:jspb.Message.getFieldWithDefault(msg,22,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Capital}
 */proto.ctpfront.proto.Capital.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Capital();return proto.ctpfront.proto.Capital.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Capital} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Capital}
 */proto.ctpfront.proto.Capital.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {number} */reader.readDouble();msg.setAvailable(value);break;case 2:var value=/** @type {number} */reader.readDouble();msg.setBalance(value);break;case 3:var value=/** @type {number} */reader.readDouble();msg.setCashIn(value);break;case 5:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 6:var value=/** @type {number} */reader.readDouble();msg.setCloseProfit(value);break;case 7:var value=/** @type {number} */reader.readDouble();msg.setCommission(value);break;case 8:var value=/** @type {number} */reader.readDouble();msg.setCredit(value);break;case 9:var value=/** @type {number} */reader.readDouble();msg.setCurrMargin(value);break;case 10:var value=/** @type {number} */reader.readDouble();msg.setDeposit(value);break;case 13:var value=/** @type {number} */reader.readDouble();msg.setFrozenCommission(value);break;case 14:var value=/** @type {number} */reader.readDouble();msg.setFrozenMargin(value);break;case 15:var value=/** @type {number} */reader.readDouble();msg.setInterest(value);break;case 16:var value=/** @type {number} */reader.readDouble();msg.setInterestBase(value);break;case 17:var value=/** @type {number} */reader.readDouble();msg.setFrozenCash(value);break;case 18:var value=/** @type {number} */reader.readDouble();msg.setPositionProfit(value);break;case 19:var value=/** @type {number} */reader.readDouble();msg.setPreBalance(value);break;case 20:var value=/** @type {number} */reader.readDouble();msg.setWithdraw(value);break;case 21:var value=/** @type {number} */reader.readDouble();msg.setWithdrawQuota(value);break;case 22:var value=/** @type {number} */reader.readUint32();msg.setCurrencyId(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Capital.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Capital.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Capital} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Capital.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getAvailable();if(f!==0.0){writer.writeDouble(1,f);}f=message.getBalance();if(f!==0.0){writer.writeDouble(2,f);}f=message.getCashIn();if(f!==0.0){writer.writeDouble(3,f);}f=message.getAccount();if(f.length>0){writer.writeString(5,f);}f=message.getCloseProfit();if(f!==0.0){writer.writeDouble(6,f);}f=message.getCommission();if(f!==0.0){writer.writeDouble(7,f);}f=message.getCredit();if(f!==0.0){writer.writeDouble(8,f);}f=message.getCurrMargin();if(f!==0.0){writer.writeDouble(9,f);}f=message.getDeposit();if(f!==0.0){writer.writeDouble(10,f);}f=message.getFrozenCommission();if(f!==0.0){writer.writeDouble(13,f);}f=message.getFrozenMargin();if(f!==0.0){writer.writeDouble(14,f);}f=message.getInterest();if(f!==0.0){writer.writeDouble(15,f);}f=message.getInterestBase();if(f!==0.0){writer.writeDouble(16,f);}f=message.getFrozenCash();if(f!==0.0){writer.writeDouble(17,f);}f=message.getPositionProfit();if(f!==0.0){writer.writeDouble(18,f);}f=message.getPreBalance();if(f!==0.0){writer.writeDouble(19,f);}f=message.getWithdraw();if(f!==0.0){writer.writeDouble(20,f);}f=message.getWithdrawQuota();if(f!==0.0){writer.writeDouble(21,f);}f=message.getCurrencyId();if(f!==0){writer.writeUint32(22,f);}};/**
 * optional double available = 1;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getAvailable=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,1,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setAvailable=function(value){jspb.Message.setProto3FloatField(this,1,value);};/**
 * optional double balance = 2;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getBalance=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,2,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setBalance=function(value){jspb.Message.setProto3FloatField(this,2,value);};/**
 * optional double cash_in = 3;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getCashIn=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,3,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setCashIn=function(value){jspb.Message.setProto3FloatField(this,3,value);};/**
 * optional string account = 5;
 * @return {string}
 */proto.ctpfront.proto.Capital.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,5,""));};/** @param {string} value */proto.ctpfront.proto.Capital.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,5,value);};/**
 * optional double close_profit = 6;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getCloseProfit=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,6,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setCloseProfit=function(value){jspb.Message.setProto3FloatField(this,6,value);};/**
 * optional double commission = 7;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getCommission=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,7,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setCommission=function(value){jspb.Message.setProto3FloatField(this,7,value);};/**
 * optional double credit = 8;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getCredit=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,8,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setCredit=function(value){jspb.Message.setProto3FloatField(this,8,value);};/**
 * optional double curr_margin = 9;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getCurrMargin=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,9,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setCurrMargin=function(value){jspb.Message.setProto3FloatField(this,9,value);};/**
 * optional double deposit = 10;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getDeposit=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,10,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setDeposit=function(value){jspb.Message.setProto3FloatField(this,10,value);};/**
 * optional double frozen_commission = 13;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getFrozenCommission=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,13,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setFrozenCommission=function(value){jspb.Message.setProto3FloatField(this,13,value);};/**
 * optional double frozen_margin = 14;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getFrozenMargin=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,14,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setFrozenMargin=function(value){jspb.Message.setProto3FloatField(this,14,value);};/**
 * optional double interest = 15;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getInterest=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,15,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setInterest=function(value){jspb.Message.setProto3FloatField(this,15,value);};/**
 * optional double interest_base = 16;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getInterestBase=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,16,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setInterestBase=function(value){jspb.Message.setProto3FloatField(this,16,value);};/**
 * optional double frozen_cash = 17;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getFrozenCash=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,17,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setFrozenCash=function(value){jspb.Message.setProto3FloatField(this,17,value);};/**
 * optional double position_profit = 18;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getPositionProfit=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,18,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setPositionProfit=function(value){jspb.Message.setProto3FloatField(this,18,value);};/**
 * optional double pre_balance = 19;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getPreBalance=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,19,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setPreBalance=function(value){jspb.Message.setProto3FloatField(this,19,value);};/**
 * optional double withdraw = 20;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getWithdraw=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,20,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setWithdraw=function(value){jspb.Message.setProto3FloatField(this,20,value);};/**
 * optional double withdraw_quota = 21;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getWithdrawQuota=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,21,0.0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setWithdrawQuota=function(value){jspb.Message.setProto3FloatField(this,21,value);};/**
 * optional uint32 currency_id = 22;
 * @return {number}
 */proto.ctpfront.proto.Capital.prototype.getCurrencyId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,22,0));};/** @param {number} value */proto.ctpfront.proto.Capital.prototype.setCurrencyId=function(value){jspb.Message.setProto3IntField(this,22,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.CapitalRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.CapitalRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.CapitalRsp.displayName='proto.ctpfront.proto.CapitalRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.CapitalRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.CapitalRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.CapitalRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.CapitalRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.Capital.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.CapitalRsp}
 */proto.ctpfront.proto.CapitalRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.CapitalRsp();return proto.ctpfront.proto.CapitalRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.CapitalRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.CapitalRsp}
 */proto.ctpfront.proto.CapitalRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 10:var value=new proto.ctpfront.proto.Capital();reader.readMessage(value,proto.ctpfront.proto.Capital.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.CapitalRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.CapitalRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.CapitalRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.CapitalRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(10,f,proto.ctpfront.proto.Capital.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.CapitalRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.CapitalRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.CapitalRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.CapitalRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional Capital data = 10;
 * @return {?proto.ctpfront.proto.Capital}
 */proto.ctpfront.proto.CapitalRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.Capital} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.Capital,10));};/** @param {?proto.ctpfront.proto.Capital|undefined} value */proto.ctpfront.proto.CapitalRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,10,value);};proto.ctpfront.proto.CapitalRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.CapitalRsp.prototype.hasData=function(){return jspb.Message.getField(this,10)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Settlement=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Settlement,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Settlement.displayName='proto.ctpfront.proto.Settlement';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Settlement.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Settlement.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Settlement} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Settlement.toObject=function(includeInstance,msg){var f,obj={account:jspb.Message.getFieldWithDefault(msg,1,""),tradingDay:jspb.Message.getFieldWithDefault(msg,2,""),settlementId:jspb.Message.getFieldWithDefault(msg,3,0),broker:jspb.Message.getFieldWithDefault(msg,4,""),content:jspb.Message.getFieldWithDefault(msg,5,""),currencyId:jspb.Message.getFieldWithDefault(msg,6,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Settlement}
 */proto.ctpfront.proto.Settlement.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Settlement();return proto.ctpfront.proto.Settlement.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Settlement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Settlement}
 */proto.ctpfront.proto.Settlement.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setTradingDay(value);break;case 3:var value=/** @type {number} */reader.readUint32();msg.setSettlementId(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 5:var value=/** @type {string} */reader.readString();msg.setContent(value);break;case 6:var value=/** @type {number} */reader.readUint32();msg.setCurrencyId(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Settlement.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Settlement.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Settlement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Settlement.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getAccount();if(f.length>0){writer.writeString(1,f);}f=message.getTradingDay();if(f.length>0){writer.writeString(2,f);}f=message.getSettlementId();if(f!==0){writer.writeUint32(3,f);}f=message.getBroker();if(f.length>0){writer.writeString(4,f);}f=message.getContent();if(f.length>0){writer.writeString(5,f);}f=message.getCurrencyId();if(f!==0){writer.writeUint32(6,f);}};/**
 * optional string account = 1;
 * @return {string}
 */proto.ctpfront.proto.Settlement.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.Settlement.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string trading_day = 2;
 * @return {string}
 */proto.ctpfront.proto.Settlement.prototype.getTradingDay=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.Settlement.prototype.setTradingDay=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional uint32 settlement_id = 3;
 * @return {number}
 */proto.ctpfront.proto.Settlement.prototype.getSettlementId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,3,0));};/** @param {number} value */proto.ctpfront.proto.Settlement.prototype.setSettlementId=function(value){jspb.Message.setProto3IntField(this,3,value);};/**
 * optional string broker = 4;
 * @return {string}
 */proto.ctpfront.proto.Settlement.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.Settlement.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * optional string content = 5;
 * @return {string}
 */proto.ctpfront.proto.Settlement.prototype.getContent=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,5,""));};/** @param {string} value */proto.ctpfront.proto.Settlement.prototype.setContent=function(value){jspb.Message.setProto3StringField(this,5,value);};/**
 * optional uint32 currency_id = 6;
 * @return {number}
 */proto.ctpfront.proto.Settlement.prototype.getCurrencyId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,6,0));};/** @param {number} value */proto.ctpfront.proto.Settlement.prototype.setCurrencyId=function(value){jspb.Message.setProto3IntField(this,6,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.SettlementRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.SettlementRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.SettlementRsp.displayName='proto.ctpfront.proto.SettlementRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.SettlementRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.SettlementRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SettlementRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.SettlementRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.Settlement.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SettlementRsp}
 */proto.ctpfront.proto.SettlementRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.SettlementRsp();return proto.ctpfront.proto.SettlementRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SettlementRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SettlementRsp}
 */proto.ctpfront.proto.SettlementRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 10:var value=new proto.ctpfront.proto.Settlement();reader.readMessage(value,proto.ctpfront.proto.Settlement.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.SettlementRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.SettlementRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SettlementRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.SettlementRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(10,f,proto.ctpfront.proto.Settlement.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.SettlementRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.SettlementRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.SettlementRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.SettlementRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional Settlement data = 10;
 * @return {?proto.ctpfront.proto.Settlement}
 */proto.ctpfront.proto.SettlementRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.Settlement} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.Settlement,10));};/** @param {?proto.ctpfront.proto.Settlement|undefined} value */proto.ctpfront.proto.SettlementRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,10,value);};proto.ctpfront.proto.SettlementRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.SettlementRsp.prototype.hasData=function(){return jspb.Message.getField(this,10)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.PositionReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.PositionReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.PositionReq.displayName='proto.ctpfront.proto.PositionReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.PositionReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.PositionReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.PositionReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.PositionReq.toObject=function(includeInstance,msg){var f,obj={account:jspb.Message.getFieldWithDefault(msg,1,""),targetId:jspb.Message.getFieldWithDefault(msg,2,""),exchangeId:jspb.Message.getFieldWithDefault(msg,3,0),investUnitId:jspb.Message.getFieldWithDefault(msg,4,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.PositionReq}
 */proto.ctpfront.proto.PositionReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.PositionReq();return proto.ctpfront.proto.PositionReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.PositionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.PositionReq}
 */proto.ctpfront.proto.PositionReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 3:var value=/** @type {number} */reader.readUint32();msg.setExchangeId(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setInvestUnitId(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.PositionReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.PositionReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.PositionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.PositionReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getAccount();if(f.length>0){writer.writeString(1,f);}f=message.getTargetId();if(f.length>0){writer.writeString(2,f);}f=message.getExchangeId();if(f!==0){writer.writeUint32(3,f);}f=message.getInvestUnitId();if(f.length>0){writer.writeString(4,f);}};/**
 * optional string account = 1;
 * @return {string}
 */proto.ctpfront.proto.PositionReq.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.PositionReq.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string target_id = 2;
 * @return {string}
 */proto.ctpfront.proto.PositionReq.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.PositionReq.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional uint32 exchange_id = 3;
 * @return {number}
 */proto.ctpfront.proto.PositionReq.prototype.getExchangeId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,3,0));};/** @param {number} value */proto.ctpfront.proto.PositionReq.prototype.setExchangeId=function(value){jspb.Message.setProto3IntField(this,3,value);};/**
 * optional string invest_unit_id = 4;
 * @return {string}
 */proto.ctpfront.proto.PositionReq.prototype.getInvestUnitId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.PositionReq.prototype.setInvestUnitId=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Position=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Position,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Position.displayName='proto.ctpfront.proto.Position';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Position.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Position.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Position} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Position.toObject=function(includeInstance,msg){var f,obj={accountId:jspb.Message.getFieldWithDefault(msg,1,0),account:jspb.Message.getFieldWithDefault(msg,2,""),targetId:jspb.Message.getFieldWithDefault(msg,3,""),direction:+jspb.Message.getFieldWithDefault(msg,4,0.0),exchangeId:jspb.Message.getFieldWithDefault(msg,5,0),hedge:jspb.Message.getFieldWithDefault(msg,6,0),commission:+jspb.Message.getFieldWithDefault(msg,7,0.0),margin:+jspb.Message.getFieldWithDefault(msg,8,0.0),lastMargin:+jspb.Message.getFieldWithDefault(msg,9,0.0),cost:+jspb.Message.getFieldWithDefault(msg,10,0.0),amount:+jspb.Message.getFieldWithDefault(msg,20,0.0),todayVolume:jspb.Message.getFieldWithDefault(msg,21,0),lastVolume:jspb.Message.getFieldWithDefault(msg,22,0),frozenVolume:jspb.Message.getFieldWithDefault(msg,23,0),closeProfit:+jspb.Message.getFieldWithDefault(msg,24,0.0),positionProfit:+jspb.Message.getFieldWithDefault(msg,25,0.0),frozenCommission:+jspb.Message.getFieldWithDefault(msg,26,0.0),frozenMargin:+jspb.Message.getFieldWithDefault(msg,27,0.0),frozen:+jspb.Message.getFieldWithDefault(msg,28,0.0),tradingDay:jspb.Message.getFieldWithDefault(msg,29,""),settlementPrice:+jspb.Message.getFieldWithDefault(msg,30,0.0),lastSettlementPrice:+jspb.Message.getFieldWithDefault(msg,40,0.0),multiple:jspb.Message.getFieldWithDefault(msg,41,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Position}
 */proto.ctpfront.proto.Position.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Position();return proto.ctpfront.proto.Position.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Position} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Position}
 */proto.ctpfront.proto.Position.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {number} */reader.readUint64();msg.setAccountId(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 4:var value=/** @type {number} */reader.readDouble();msg.setDirection(value);break;case 5:var value=/** @type {number} */reader.readUint32();msg.setExchangeId(value);break;case 6:var value=/** @type {number} */reader.readUint32();msg.setHedge(value);break;case 7:var value=/** @type {number} */reader.readDouble();msg.setCommission(value);break;case 8:var value=/** @type {number} */reader.readDouble();msg.setMargin(value);break;case 9:var value=/** @type {number} */reader.readDouble();msg.setLastMargin(value);break;case 10:var value=/** @type {number} */reader.readDouble();msg.setCost(value);break;case 20:var value=/** @type {number} */reader.readDouble();msg.setAmount(value);break;case 21:var value=/** @type {number} */reader.readUint32();msg.setTodayVolume(value);break;case 22:var value=/** @type {number} */reader.readUint32();msg.setLastVolume(value);break;case 23:var value=/** @type {number} */reader.readUint32();msg.setFrozenVolume(value);break;case 24:var value=/** @type {number} */reader.readDouble();msg.setCloseProfit(value);break;case 25:var value=/** @type {number} */reader.readDouble();msg.setPositionProfit(value);break;case 26:var value=/** @type {number} */reader.readDouble();msg.setFrozenCommission(value);break;case 27:var value=/** @type {number} */reader.readDouble();msg.setFrozenMargin(value);break;case 28:var value=/** @type {number} */reader.readDouble();msg.setFrozen(value);break;case 29:var value=/** @type {string} */reader.readString();msg.setTradingDay(value);break;case 30:var value=/** @type {number} */reader.readDouble();msg.setSettlementPrice(value);break;case 40:var value=/** @type {number} */reader.readDouble();msg.setLastSettlementPrice(value);break;case 41:var value=/** @type {number} */reader.readUint32();msg.setMultiple(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Position.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Position.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Position} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Position.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getAccountId();if(f!==0){writer.writeUint64(1,f);}f=message.getAccount();if(f.length>0){writer.writeString(2,f);}f=message.getTargetId();if(f.length>0){writer.writeString(3,f);}f=message.getDirection();if(f!==0.0){writer.writeDouble(4,f);}f=message.getExchangeId();if(f!==0){writer.writeUint32(5,f);}f=message.getHedge();if(f!==0){writer.writeUint32(6,f);}f=message.getCommission();if(f!==0.0){writer.writeDouble(7,f);}f=message.getMargin();if(f!==0.0){writer.writeDouble(8,f);}f=message.getLastMargin();if(f!==0.0){writer.writeDouble(9,f);}f=message.getCost();if(f!==0.0){writer.writeDouble(10,f);}f=message.getAmount();if(f!==0.0){writer.writeDouble(20,f);}f=message.getTodayVolume();if(f!==0){writer.writeUint32(21,f);}f=message.getLastVolume();if(f!==0){writer.writeUint32(22,f);}f=message.getFrozenVolume();if(f!==0){writer.writeUint32(23,f);}f=message.getCloseProfit();if(f!==0.0){writer.writeDouble(24,f);}f=message.getPositionProfit();if(f!==0.0){writer.writeDouble(25,f);}f=message.getFrozenCommission();if(f!==0.0){writer.writeDouble(26,f);}f=message.getFrozenMargin();if(f!==0.0){writer.writeDouble(27,f);}f=message.getFrozen();if(f!==0.0){writer.writeDouble(28,f);}f=message.getTradingDay();if(f.length>0){writer.writeString(29,f);}f=message.getSettlementPrice();if(f!==0.0){writer.writeDouble(30,f);}f=message.getLastSettlementPrice();if(f!==0.0){writer.writeDouble(40,f);}f=message.getMultiple();if(f!==0){writer.writeUint32(41,f);}};/**
 * optional uint64 account_id = 1;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getAccountId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,1,0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setAccountId=function(value){jspb.Message.setProto3IntField(this,1,value);};/**
 * optional string account = 2;
 * @return {string}
 */proto.ctpfront.proto.Position.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.Position.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string target_id = 3;
 * @return {string}
 */proto.ctpfront.proto.Position.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.Position.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional double direction = 4;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getDirection=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,4,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setDirection=function(value){jspb.Message.setProto3FloatField(this,4,value);};/**
 * optional uint32 exchange_id = 5;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getExchangeId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,5,0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setExchangeId=function(value){jspb.Message.setProto3IntField(this,5,value);};/**
 * optional uint32 hedge = 6;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getHedge=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,6,0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setHedge=function(value){jspb.Message.setProto3IntField(this,6,value);};/**
 * optional double commission = 7;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getCommission=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,7,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setCommission=function(value){jspb.Message.setProto3FloatField(this,7,value);};/**
 * optional double margin = 8;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getMargin=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,8,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setMargin=function(value){jspb.Message.setProto3FloatField(this,8,value);};/**
 * optional double last_margin = 9;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getLastMargin=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,9,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setLastMargin=function(value){jspb.Message.setProto3FloatField(this,9,value);};/**
 * optional double cost = 10;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getCost=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,10,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setCost=function(value){jspb.Message.setProto3FloatField(this,10,value);};/**
 * optional double amount = 20;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getAmount=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,20,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setAmount=function(value){jspb.Message.setProto3FloatField(this,20,value);};/**
 * optional uint32 today_volume = 21;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getTodayVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,21,0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setTodayVolume=function(value){jspb.Message.setProto3IntField(this,21,value);};/**
 * optional uint32 last_volume = 22;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getLastVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,22,0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setLastVolume=function(value){jspb.Message.setProto3IntField(this,22,value);};/**
 * optional uint32 frozen_volume = 23;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getFrozenVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,23,0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setFrozenVolume=function(value){jspb.Message.setProto3IntField(this,23,value);};/**
 * optional double close_profit = 24;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getCloseProfit=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,24,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setCloseProfit=function(value){jspb.Message.setProto3FloatField(this,24,value);};/**
 * optional double position_profit = 25;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getPositionProfit=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,25,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setPositionProfit=function(value){jspb.Message.setProto3FloatField(this,25,value);};/**
 * optional double frozen_commission = 26;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getFrozenCommission=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,26,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setFrozenCommission=function(value){jspb.Message.setProto3FloatField(this,26,value);};/**
 * optional double frozen_margin = 27;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getFrozenMargin=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,27,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setFrozenMargin=function(value){jspb.Message.setProto3FloatField(this,27,value);};/**
 * optional double frozen = 28;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getFrozen=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,28,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setFrozen=function(value){jspb.Message.setProto3FloatField(this,28,value);};/**
 * optional string trading_day = 29;
 * @return {string}
 */proto.ctpfront.proto.Position.prototype.getTradingDay=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,29,""));};/** @param {string} value */proto.ctpfront.proto.Position.prototype.setTradingDay=function(value){jspb.Message.setProto3StringField(this,29,value);};/**
 * optional double settlement_price = 30;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getSettlementPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,30,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setSettlementPrice=function(value){jspb.Message.setProto3FloatField(this,30,value);};/**
 * optional double last_settlement_price = 40;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getLastSettlementPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,40,0.0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setLastSettlementPrice=function(value){jspb.Message.setProto3FloatField(this,40,value);};/**
 * optional uint32 multiple = 41;
 * @return {number}
 */proto.ctpfront.proto.Position.prototype.getMultiple=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,41,0));};/** @param {number} value */proto.ctpfront.proto.Position.prototype.setMultiple=function(value){jspb.Message.setProto3IntField(this,41,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.PositionRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.PositionRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.PositionRsp.displayName='proto.ctpfront.proto.PositionRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.PositionRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.PositionRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.PositionRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.PositionRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.Position.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.PositionRsp}
 */proto.ctpfront.proto.PositionRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.PositionRsp();return proto.ctpfront.proto.PositionRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.PositionRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.PositionRsp}
 */proto.ctpfront.proto.PositionRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 10:var value=new proto.ctpfront.proto.Position();reader.readMessage(value,proto.ctpfront.proto.Position.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.PositionRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.PositionRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.PositionRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.PositionRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(10,f,proto.ctpfront.proto.Position.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.PositionRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.PositionRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.PositionRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.PositionRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional Position data = 10;
 * @return {?proto.ctpfront.proto.Position}
 */proto.ctpfront.proto.PositionRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.Position} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.Position,10));};/** @param {?proto.ctpfront.proto.Position|undefined} value */proto.ctpfront.proto.PositionRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,10,value);};proto.ctpfront.proto.PositionRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.PositionRsp.prototype.hasData=function(){return jspb.Message.getField(this,10)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.PositionDetailReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.PositionDetailReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.PositionDetailReq.displayName='proto.ctpfront.proto.PositionDetailReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.PositionDetailReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.PositionDetailReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.PositionDetailReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.PositionDetailReq.toObject=function(includeInstance,msg){var f,obj={account:jspb.Message.getFieldWithDefault(msg,1,""),targetId:jspb.Message.getFieldWithDefault(msg,2,""),exchangeId:jspb.Message.getFieldWithDefault(msg,3,0),investUnitId:jspb.Message.getFieldWithDefault(msg,4,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.PositionDetailReq}
 */proto.ctpfront.proto.PositionDetailReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.PositionDetailReq();return proto.ctpfront.proto.PositionDetailReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.PositionDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.PositionDetailReq}
 */proto.ctpfront.proto.PositionDetailReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 3:var value=/** @type {number} */reader.readUint32();msg.setExchangeId(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setInvestUnitId(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.PositionDetailReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.PositionDetailReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.PositionDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.PositionDetailReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getAccount();if(f.length>0){writer.writeString(1,f);}f=message.getTargetId();if(f.length>0){writer.writeString(2,f);}f=message.getExchangeId();if(f!==0){writer.writeUint32(3,f);}f=message.getInvestUnitId();if(f.length>0){writer.writeString(4,f);}};/**
 * optional string account = 1;
 * @return {string}
 */proto.ctpfront.proto.PositionDetailReq.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.PositionDetailReq.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string target_id = 2;
 * @return {string}
 */proto.ctpfront.proto.PositionDetailReq.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.PositionDetailReq.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional uint32 exchange_id = 3;
 * @return {number}
 */proto.ctpfront.proto.PositionDetailReq.prototype.getExchangeId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,3,0));};/** @param {number} value */proto.ctpfront.proto.PositionDetailReq.prototype.setExchangeId=function(value){jspb.Message.setProto3IntField(this,3,value);};/**
 * optional string invest_unit_id = 4;
 * @return {string}
 */proto.ctpfront.proto.PositionDetailReq.prototype.getInvestUnitId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.PositionDetailReq.prototype.setInvestUnitId=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.PositionDetail=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.PositionDetail,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.PositionDetail.displayName='proto.ctpfront.proto.PositionDetail';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.PositionDetail.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.PositionDetail.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.PositionDetail} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.PositionDetail.toObject=function(includeInstance,msg){var f,obj={account:jspb.Message.getFieldWithDefault(msg,1,""),closeAmount:+jspb.Message.getFieldWithDefault(msg,4,0.0),closeProfitByDate:+jspb.Message.getFieldWithDefault(msg,5,0.0),closeProfitByTrade:+jspb.Message.getFieldWithDefault(msg,6,0.0),direction:jspb.Message.getFieldWithDefault(msg,8,0),exchangeId:jspb.Message.getFieldWithDefault(msg,9,0),hedge:jspb.Message.getFieldWithDefault(msg,10,0),targetId:jspb.Message.getFieldWithDefault(msg,11,""),marginRateByMoney:+jspb.Message.getFieldWithDefault(msg,12,0.0),marginRateByVolume:+jspb.Message.getFieldWithDefault(msg,13,0.0),positionProfitByDate:+jspb.Message.getFieldWithDefault(msg,17,0.0),positionProfitByTrade:+jspb.Message.getFieldWithDefault(msg,18,0.0),lastSettlementPrice:+jspb.Message.getFieldWithDefault(msg,19,0.0),settlementPrice:+jspb.Message.getFieldWithDefault(msg,20,0.0),tradingDay:jspb.Message.getFieldWithDefault(msg,21,""),openPrice:+jspb.Message.getFieldWithDefault(msg,22,0.0),openDate:jspb.Message.getFieldWithDefault(msg,24,""),volume:jspb.Message.getFieldWithDefault(msg,27,0),closeVolume:jspb.Message.getFieldWithDefault(msg,28,0),margin:+jspb.Message.getFieldWithDefault(msg,29,0.0),exchmargin:+jspb.Message.getFieldWithDefault(msg,30,0.0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.PositionDetail}
 */proto.ctpfront.proto.PositionDetail.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.PositionDetail();return proto.ctpfront.proto.PositionDetail.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.PositionDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.PositionDetail}
 */proto.ctpfront.proto.PositionDetail.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 4:var value=/** @type {number} */reader.readDouble();msg.setCloseAmount(value);break;case 5:var value=/** @type {number} */reader.readDouble();msg.setCloseProfitByDate(value);break;case 6:var value=/** @type {number} */reader.readDouble();msg.setCloseProfitByTrade(value);break;case 8:var value=/** @type {number} */reader.readInt32();msg.setDirection(value);break;case 9:var value=/** @type {number} */reader.readInt32();msg.setExchangeId(value);break;case 10:var value=/** @type {number} */reader.readInt32();msg.setHedge(value);break;case 11:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 12:var value=/** @type {number} */reader.readDouble();msg.setMarginRateByMoney(value);break;case 13:var value=/** @type {number} */reader.readDouble();msg.setMarginRateByVolume(value);break;case 17:var value=/** @type {number} */reader.readDouble();msg.setPositionProfitByDate(value);break;case 18:var value=/** @type {number} */reader.readDouble();msg.setPositionProfitByTrade(value);break;case 19:var value=/** @type {number} */reader.readDouble();msg.setLastSettlementPrice(value);break;case 20:var value=/** @type {number} */reader.readDouble();msg.setSettlementPrice(value);break;case 21:var value=/** @type {string} */reader.readString();msg.setTradingDay(value);break;case 22:var value=/** @type {number} */reader.readDouble();msg.setOpenPrice(value);break;case 24:var value=/** @type {string} */reader.readString();msg.setOpenDate(value);break;case 27:var value=/** @type {number} */reader.readInt32();msg.setVolume(value);break;case 28:var value=/** @type {number} */reader.readInt32();msg.setCloseVolume(value);break;case 29:var value=/** @type {number} */reader.readDouble();msg.setMargin(value);break;case 30:var value=/** @type {number} */reader.readDouble();msg.setExchmargin(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.PositionDetail.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.PositionDetail.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.PositionDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.PositionDetail.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getAccount();if(f.length>0){writer.writeString(1,f);}f=message.getCloseAmount();if(f!==0.0){writer.writeDouble(4,f);}f=message.getCloseProfitByDate();if(f!==0.0){writer.writeDouble(5,f);}f=message.getCloseProfitByTrade();if(f!==0.0){writer.writeDouble(6,f);}f=message.getDirection();if(f!==0){writer.writeInt32(8,f);}f=message.getExchangeId();if(f!==0){writer.writeInt32(9,f);}f=message.getHedge();if(f!==0){writer.writeInt32(10,f);}f=message.getTargetId();if(f.length>0){writer.writeString(11,f);}f=message.getMarginRateByMoney();if(f!==0.0){writer.writeDouble(12,f);}f=message.getMarginRateByVolume();if(f!==0.0){writer.writeDouble(13,f);}f=message.getPositionProfitByDate();if(f!==0.0){writer.writeDouble(17,f);}f=message.getPositionProfitByTrade();if(f!==0.0){writer.writeDouble(18,f);}f=message.getLastSettlementPrice();if(f!==0.0){writer.writeDouble(19,f);}f=message.getSettlementPrice();if(f!==0.0){writer.writeDouble(20,f);}f=message.getTradingDay();if(f.length>0){writer.writeString(21,f);}f=message.getOpenPrice();if(f!==0.0){writer.writeDouble(22,f);}f=message.getOpenDate();if(f.length>0){writer.writeString(24,f);}f=message.getVolume();if(f!==0){writer.writeInt32(27,f);}f=message.getCloseVolume();if(f!==0){writer.writeInt32(28,f);}f=message.getMargin();if(f!==0.0){writer.writeDouble(29,f);}f=message.getExchmargin();if(f!==0.0){writer.writeDouble(30,f);}};/**
 * optional string account = 1;
 * @return {string}
 */proto.ctpfront.proto.PositionDetail.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.PositionDetail.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional double close_amount = 4;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getCloseAmount=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,4,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setCloseAmount=function(value){jspb.Message.setProto3FloatField(this,4,value);};/**
 * optional double close_profit_by_date = 5;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getCloseProfitByDate=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,5,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setCloseProfitByDate=function(value){jspb.Message.setProto3FloatField(this,5,value);};/**
 * optional double close_profit_by_trade = 6;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getCloseProfitByTrade=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,6,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setCloseProfitByTrade=function(value){jspb.Message.setProto3FloatField(this,6,value);};/**
 * optional int32 direction = 8;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getDirection=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,8,0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setDirection=function(value){jspb.Message.setProto3IntField(this,8,value);};/**
 * optional int32 exchange_id = 9;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getExchangeId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,9,0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setExchangeId=function(value){jspb.Message.setProto3IntField(this,9,value);};/**
 * optional int32 hedge = 10;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getHedge=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,10,0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setHedge=function(value){jspb.Message.setProto3IntField(this,10,value);};/**
 * optional string target_id = 11;
 * @return {string}
 */proto.ctpfront.proto.PositionDetail.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,11,""));};/** @param {string} value */proto.ctpfront.proto.PositionDetail.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,11,value);};/**
 * optional double margin_rate_by_money = 12;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getMarginRateByMoney=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,12,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setMarginRateByMoney=function(value){jspb.Message.setProto3FloatField(this,12,value);};/**
 * optional double margin_rate_by_volume = 13;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getMarginRateByVolume=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,13,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setMarginRateByVolume=function(value){jspb.Message.setProto3FloatField(this,13,value);};/**
 * optional double position_profit_by_date = 17;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getPositionProfitByDate=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,17,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setPositionProfitByDate=function(value){jspb.Message.setProto3FloatField(this,17,value);};/**
 * optional double position_profit_by_trade = 18;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getPositionProfitByTrade=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,18,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setPositionProfitByTrade=function(value){jspb.Message.setProto3FloatField(this,18,value);};/**
 * optional double last_settlement_price = 19;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getLastSettlementPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,19,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setLastSettlementPrice=function(value){jspb.Message.setProto3FloatField(this,19,value);};/**
 * optional double settlement_price = 20;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getSettlementPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,20,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setSettlementPrice=function(value){jspb.Message.setProto3FloatField(this,20,value);};/**
 * optional string trading_day = 21;
 * @return {string}
 */proto.ctpfront.proto.PositionDetail.prototype.getTradingDay=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,21,""));};/** @param {string} value */proto.ctpfront.proto.PositionDetail.prototype.setTradingDay=function(value){jspb.Message.setProto3StringField(this,21,value);};/**
 * optional double open_price = 22;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getOpenPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,22,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setOpenPrice=function(value){jspb.Message.setProto3FloatField(this,22,value);};/**
 * optional string open_date = 24;
 * @return {string}
 */proto.ctpfront.proto.PositionDetail.prototype.getOpenDate=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,24,""));};/** @param {string} value */proto.ctpfront.proto.PositionDetail.prototype.setOpenDate=function(value){jspb.Message.setProto3StringField(this,24,value);};/**
 * optional int32 volume = 27;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,27,0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setVolume=function(value){jspb.Message.setProto3IntField(this,27,value);};/**
 * optional int32 close_volume = 28;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getCloseVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,28,0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setCloseVolume=function(value){jspb.Message.setProto3IntField(this,28,value);};/**
 * optional double margin = 29;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getMargin=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,29,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setMargin=function(value){jspb.Message.setProto3FloatField(this,29,value);};/**
 * optional double exchmargin = 30;
 * @return {number}
 */proto.ctpfront.proto.PositionDetail.prototype.getExchmargin=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,30,0.0));};/** @param {number} value */proto.ctpfront.proto.PositionDetail.prototype.setExchmargin=function(value){jspb.Message.setProto3FloatField(this,30,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.PositionDetailRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.PositionDetailRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.PositionDetailRsp.displayName='proto.ctpfront.proto.PositionDetailRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.PositionDetailRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.PositionDetailRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.PositionDetailRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.PositionDetailRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.PositionDetail.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.PositionDetailRsp}
 */proto.ctpfront.proto.PositionDetailRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.PositionDetailRsp();return proto.ctpfront.proto.PositionDetailRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.PositionDetailRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.PositionDetailRsp}
 */proto.ctpfront.proto.PositionDetailRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 10:var value=new proto.ctpfront.proto.PositionDetail();reader.readMessage(value,proto.ctpfront.proto.PositionDetail.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.PositionDetailRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.PositionDetailRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.PositionDetailRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.PositionDetailRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(10,f,proto.ctpfront.proto.PositionDetail.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.PositionDetailRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.PositionDetailRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.PositionDetailRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.PositionDetailRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional PositionDetail data = 10;
 * @return {?proto.ctpfront.proto.PositionDetail}
 */proto.ctpfront.proto.PositionDetailRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.PositionDetail} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.PositionDetail,10));};/** @param {?proto.ctpfront.proto.PositionDetail|undefined} value */proto.ctpfront.proto.PositionDetailRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,10,value);};proto.ctpfront.proto.PositionDetailRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.PositionDetailRsp.prototype.hasData=function(){return jspb.Message.getField(this,10)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Quote=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Quote,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Quote.displayName='proto.ctpfront.proto.Quote';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Quote.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Quote.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Quote} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Quote.toObject=function(includeInstance,msg){var f,obj={askPrice1:+jspb.Message.getFieldWithDefault(msg,1,0.0),askVolume1:jspb.Message.getFieldWithDefault(msg,6,0),averagePrice:+jspb.Message.getFieldWithDefault(msg,11,0.0),bidPrice1:+jspb.Message.getFieldWithDefault(msg,12,0.0),bidVolume1:jspb.Message.getFieldWithDefault(msg,17,0),closePrice:+jspb.Message.getFieldWithDefault(msg,22,0.0),targetId:jspb.Message.getFieldWithDefault(msg,23,""),exchangeId:jspb.Message.getFieldWithDefault(msg,24,0),lowPrice:+jspb.Message.getFieldWithDefault(msg,25,0.0),highPrice:+jspb.Message.getFieldWithDefault(msg,26,0.0),latestPrice:+jspb.Message.getFieldWithDefault(msg,28,0.0),lowStopPrice:+jspb.Message.getFieldWithDefault(msg,29,0.0),highStopPrice:+jspb.Message.getFieldWithDefault(msg,30,0.0),openPrice:+jspb.Message.getFieldWithDefault(msg,32,0.0),lastClosePrice:+jspb.Message.getFieldWithDefault(msg,33,0.0),lastSettlementPrice:+jspb.Message.getFieldWithDefault(msg,36,0.0),settlementPrice:+jspb.Message.getFieldWithDefault(msg,37,0.0),tradingDay:jspb.Message.getFieldWithDefault(msg,38,""),turnover:+jspb.Message.getFieldWithDefault(msg,39,0.0),updateMill:jspb.Message.getFieldWithDefault(msg,40,0),updateTime:jspb.Message.getFieldWithDefault(msg,41,""),volume:jspb.Message.getFieldWithDefault(msg,43,0),priceTick:+jspb.Message.getFieldWithDefault(msg,44,0.0),position:jspb.Message.getFieldWithDefault(msg,45,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Quote}
 */proto.ctpfront.proto.Quote.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Quote();return proto.ctpfront.proto.Quote.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Quote} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Quote}
 */proto.ctpfront.proto.Quote.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {number} */reader.readDouble();msg.setAskPrice1(value);break;case 6:var value=/** @type {number} */reader.readInt32();msg.setAskVolume1(value);break;case 11:var value=/** @type {number} */reader.readDouble();msg.setAveragePrice(value);break;case 12:var value=/** @type {number} */reader.readDouble();msg.setBidPrice1(value);break;case 17:var value=/** @type {number} */reader.readInt32();msg.setBidVolume1(value);break;case 22:var value=/** @type {number} */reader.readDouble();msg.setClosePrice(value);break;case 23:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 24:var value=/** @type {number} */reader.readInt32();msg.setExchangeId(value);break;case 25:var value=/** @type {number} */reader.readDouble();msg.setLowPrice(value);break;case 26:var value=/** @type {number} */reader.readDouble();msg.setHighPrice(value);break;case 28:var value=/** @type {number} */reader.readDouble();msg.setLatestPrice(value);break;case 29:var value=/** @type {number} */reader.readDouble();msg.setLowStopPrice(value);break;case 30:var value=/** @type {number} */reader.readDouble();msg.setHighStopPrice(value);break;case 32:var value=/** @type {number} */reader.readDouble();msg.setOpenPrice(value);break;case 33:var value=/** @type {number} */reader.readDouble();msg.setLastClosePrice(value);break;case 36:var value=/** @type {number} */reader.readDouble();msg.setLastSettlementPrice(value);break;case 37:var value=/** @type {number} */reader.readDouble();msg.setSettlementPrice(value);break;case 38:var value=/** @type {string} */reader.readString();msg.setTradingDay(value);break;case 39:var value=/** @type {number} */reader.readDouble();msg.setTurnover(value);break;case 40:var value=/** @type {number} */reader.readInt32();msg.setUpdateMill(value);break;case 41:var value=/** @type {string} */reader.readString();msg.setUpdateTime(value);break;case 43:var value=/** @type {number} */reader.readInt32();msg.setVolume(value);break;case 44:var value=/** @type {number} */reader.readDouble();msg.setPriceTick(value);break;case 45:var value=/** @type {number} */reader.readInt32();msg.setPosition(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Quote.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Quote.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Quote} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Quote.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getAskPrice1();if(f!==0.0){writer.writeDouble(1,f);}f=message.getAskVolume1();if(f!==0){writer.writeInt32(6,f);}f=message.getAveragePrice();if(f!==0.0){writer.writeDouble(11,f);}f=message.getBidPrice1();if(f!==0.0){writer.writeDouble(12,f);}f=message.getBidVolume1();if(f!==0){writer.writeInt32(17,f);}f=message.getClosePrice();if(f!==0.0){writer.writeDouble(22,f);}f=message.getTargetId();if(f.length>0){writer.writeString(23,f);}f=message.getExchangeId();if(f!==0){writer.writeInt32(24,f);}f=message.getLowPrice();if(f!==0.0){writer.writeDouble(25,f);}f=message.getHighPrice();if(f!==0.0){writer.writeDouble(26,f);}f=message.getLatestPrice();if(f!==0.0){writer.writeDouble(28,f);}f=message.getLowStopPrice();if(f!==0.0){writer.writeDouble(29,f);}f=message.getHighStopPrice();if(f!==0.0){writer.writeDouble(30,f);}f=message.getOpenPrice();if(f!==0.0){writer.writeDouble(32,f);}f=message.getLastClosePrice();if(f!==0.0){writer.writeDouble(33,f);}f=message.getLastSettlementPrice();if(f!==0.0){writer.writeDouble(36,f);}f=message.getSettlementPrice();if(f!==0.0){writer.writeDouble(37,f);}f=message.getTradingDay();if(f.length>0){writer.writeString(38,f);}f=message.getTurnover();if(f!==0.0){writer.writeDouble(39,f);}f=message.getUpdateMill();if(f!==0){writer.writeInt32(40,f);}f=message.getUpdateTime();if(f.length>0){writer.writeString(41,f);}f=message.getVolume();if(f!==0){writer.writeInt32(43,f);}f=message.getPriceTick();if(f!==0.0){writer.writeDouble(44,f);}f=message.getPosition();if(f!==0){writer.writeInt32(45,f);}};/**
 * optional double ask_price1 = 1;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getAskPrice1=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,1,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setAskPrice1=function(value){jspb.Message.setProto3FloatField(this,1,value);};/**
 * optional int32 ask_volume1 = 6;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getAskVolume1=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,6,0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setAskVolume1=function(value){jspb.Message.setProto3IntField(this,6,value);};/**
 * optional double average_price = 11;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getAveragePrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,11,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setAveragePrice=function(value){jspb.Message.setProto3FloatField(this,11,value);};/**
 * optional double bid_price1 = 12;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getBidPrice1=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,12,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setBidPrice1=function(value){jspb.Message.setProto3FloatField(this,12,value);};/**
 * optional int32 bid_volume1 = 17;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getBidVolume1=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,17,0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setBidVolume1=function(value){jspb.Message.setProto3IntField(this,17,value);};/**
 * optional double close_price = 22;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getClosePrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,22,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setClosePrice=function(value){jspb.Message.setProto3FloatField(this,22,value);};/**
 * optional string target_id = 23;
 * @return {string}
 */proto.ctpfront.proto.Quote.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,23,""));};/** @param {string} value */proto.ctpfront.proto.Quote.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,23,value);};/**
 * optional int32 exchange_id = 24;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getExchangeId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,24,0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setExchangeId=function(value){jspb.Message.setProto3IntField(this,24,value);};/**
 * optional double low_price = 25;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getLowPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,25,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setLowPrice=function(value){jspb.Message.setProto3FloatField(this,25,value);};/**
 * optional double high_price = 26;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getHighPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,26,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setHighPrice=function(value){jspb.Message.setProto3FloatField(this,26,value);};/**
 * optional double latest_price = 28;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getLatestPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,28,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setLatestPrice=function(value){jspb.Message.setProto3FloatField(this,28,value);};/**
 * optional double low_stop_price = 29;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getLowStopPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,29,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setLowStopPrice=function(value){jspb.Message.setProto3FloatField(this,29,value);};/**
 * optional double high_stop_price = 30;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getHighStopPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,30,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setHighStopPrice=function(value){jspb.Message.setProto3FloatField(this,30,value);};/**
 * optional double open_price = 32;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getOpenPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,32,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setOpenPrice=function(value){jspb.Message.setProto3FloatField(this,32,value);};/**
 * optional double last_close_price = 33;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getLastClosePrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,33,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setLastClosePrice=function(value){jspb.Message.setProto3FloatField(this,33,value);};/**
 * optional double last_settlement_price = 36;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getLastSettlementPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,36,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setLastSettlementPrice=function(value){jspb.Message.setProto3FloatField(this,36,value);};/**
 * optional double settlement_price = 37;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getSettlementPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,37,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setSettlementPrice=function(value){jspb.Message.setProto3FloatField(this,37,value);};/**
 * optional string trading_day = 38;
 * @return {string}
 */proto.ctpfront.proto.Quote.prototype.getTradingDay=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,38,""));};/** @param {string} value */proto.ctpfront.proto.Quote.prototype.setTradingDay=function(value){jspb.Message.setProto3StringField(this,38,value);};/**
 * optional double turnover = 39;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getTurnover=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,39,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setTurnover=function(value){jspb.Message.setProto3FloatField(this,39,value);};/**
 * optional int32 update_mill = 40;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getUpdateMill=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,40,0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setUpdateMill=function(value){jspb.Message.setProto3IntField(this,40,value);};/**
 * optional string update_time = 41;
 * @return {string}
 */proto.ctpfront.proto.Quote.prototype.getUpdateTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,41,""));};/** @param {string} value */proto.ctpfront.proto.Quote.prototype.setUpdateTime=function(value){jspb.Message.setProto3StringField(this,41,value);};/**
 * optional int32 volume = 43;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,43,0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setVolume=function(value){jspb.Message.setProto3IntField(this,43,value);};/**
 * optional double price_tick = 44;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getPriceTick=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,44,0.0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setPriceTick=function(value){jspb.Message.setProto3FloatField(this,44,value);};/**
 * optional int32 position = 45;
 * @return {number}
 */proto.ctpfront.proto.Quote.prototype.getPosition=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,45,0));};/** @param {number} value */proto.ctpfront.proto.Quote.prototype.setPosition=function(value){jspb.Message.setProto3IntField(this,45,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.QuoteReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.QuoteReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.QuoteReq.displayName='proto.ctpfront.proto.QuoteReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.QuoteReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.QuoteReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.QuoteReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.QuoteReq.toObject=function(includeInstance,msg){var f,obj={targetId:jspb.Message.getFieldWithDefault(msg,1,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.QuoteReq}
 */proto.ctpfront.proto.QuoteReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.QuoteReq();return proto.ctpfront.proto.QuoteReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.QuoteReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.QuoteReq}
 */proto.ctpfront.proto.QuoteReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.QuoteReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.QuoteReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.QuoteReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.QuoteReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getTargetId();if(f.length>0){writer.writeString(1,f);}};/**
 * optional string target_id = 1;
 * @return {string}
 */proto.ctpfront.proto.QuoteReq.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.QuoteReq.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.QuoteRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.QuoteRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.QuoteRsp.displayName='proto.ctpfront.proto.QuoteRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.QuoteRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.QuoteRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.QuoteRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.QuoteRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.Quote.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.QuoteRsp}
 */proto.ctpfront.proto.QuoteRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.QuoteRsp();return proto.ctpfront.proto.QuoteRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.QuoteRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.QuoteRsp}
 */proto.ctpfront.proto.QuoteRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 10:var value=new proto.ctpfront.proto.Quote();reader.readMessage(value,proto.ctpfront.proto.Quote.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.QuoteRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.QuoteRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.QuoteRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.QuoteRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(10,f,proto.ctpfront.proto.Quote.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.QuoteRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.QuoteRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.QuoteRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.QuoteRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional Quote data = 10;
 * @return {?proto.ctpfront.proto.Quote}
 */proto.ctpfront.proto.QuoteRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.Quote} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.Quote,10));};/** @param {?proto.ctpfront.proto.Quote|undefined} value */proto.ctpfront.proto.QuoteRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,10,value);};proto.ctpfront.proto.QuoteRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.QuoteRsp.prototype.hasData=function(){return jspb.Message.getField(this,10)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.TargetReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.TargetReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.TargetReq.displayName='proto.ctpfront.proto.TargetReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.TargetReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.TargetReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TargetReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.TargetReq.toObject=function(includeInstance,msg){var f,obj={targetId:jspb.Message.getFieldWithDefault(msg,1,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TargetReq}
 */proto.ctpfront.proto.TargetReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.TargetReq();return proto.ctpfront.proto.TargetReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TargetReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TargetReq}
 */proto.ctpfront.proto.TargetReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.TargetReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.TargetReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TargetReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.TargetReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getTargetId();if(f.length>0){writer.writeString(1,f);}};/**
 * optional string target_id = 1;
 * @return {string}
 */proto.ctpfront.proto.TargetReq.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.TargetReq.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Target=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Target,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Target.displayName='proto.ctpfront.proto.Target';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Target.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Target.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Target} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Target.toObject=function(includeInstance,msg){var f,obj={targetId:jspb.Message.getFieldWithDefault(msg,1,""),targetName:jspb.Message.getFieldWithDefault(msg,2,""),productId:jspb.Message.getFieldWithDefault(msg,3,""),exchangeId:jspb.Message.getFieldWithDefault(msg,4,0),productName:jspb.Message.getFieldWithDefault(msg,5,""),exchangeName:jspb.Message.getFieldWithDefault(msg,6,""),multiple:jspb.Message.getFieldWithDefault(msg,7,0),priceTick:+jspb.Message.getFieldWithDefault(msg,8,0.0),productClass:jspb.Message.getFieldWithDefault(msg,9,0),targetCode:jspb.Message.getFieldWithDefault(msg,10,""),deliveryMonth:jspb.Message.getFieldWithDefault(msg,11,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Target}
 */proto.ctpfront.proto.Target.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Target();return proto.ctpfront.proto.Target.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Target} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Target}
 */proto.ctpfront.proto.Target.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setTargetName(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setProductId(value);break;case 4:var value=/** @type {number} */reader.readUint32();msg.setExchangeId(value);break;case 5:var value=/** @type {string} */reader.readString();msg.setProductName(value);break;case 6:var value=/** @type {string} */reader.readString();msg.setExchangeName(value);break;case 7:var value=/** @type {number} */reader.readUint32();msg.setMultiple(value);break;case 8:var value=/** @type {number} */reader.readDouble();msg.setPriceTick(value);break;case 9:var value=/** @type {number} */reader.readUint32();msg.setProductClass(value);break;case 10:var value=/** @type {string} */reader.readString();msg.setTargetCode(value);break;case 11:var value=/** @type {number} */reader.readUint32();msg.setDeliveryMonth(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Target.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Target.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Target} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Target.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getTargetId();if(f.length>0){writer.writeString(1,f);}f=message.getTargetName();if(f.length>0){writer.writeString(2,f);}f=message.getProductId();if(f.length>0){writer.writeString(3,f);}f=message.getExchangeId();if(f!==0){writer.writeUint32(4,f);}f=message.getProductName();if(f.length>0){writer.writeString(5,f);}f=message.getExchangeName();if(f.length>0){writer.writeString(6,f);}f=message.getMultiple();if(f!==0){writer.writeUint32(7,f);}f=message.getPriceTick();if(f!==0.0){writer.writeDouble(8,f);}f=message.getProductClass();if(f!==0){writer.writeUint32(9,f);}f=message.getTargetCode();if(f.length>0){writer.writeString(10,f);}f=message.getDeliveryMonth();if(f!==0){writer.writeUint32(11,f);}};/**
 * optional string target_id = 1;
 * @return {string}
 */proto.ctpfront.proto.Target.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.Target.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string target_name = 2;
 * @return {string}
 */proto.ctpfront.proto.Target.prototype.getTargetName=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.Target.prototype.setTargetName=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string product_id = 3;
 * @return {string}
 */proto.ctpfront.proto.Target.prototype.getProductId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.Target.prototype.setProductId=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional uint32 exchange_id = 4;
 * @return {number}
 */proto.ctpfront.proto.Target.prototype.getExchangeId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,4,0));};/** @param {number} value */proto.ctpfront.proto.Target.prototype.setExchangeId=function(value){jspb.Message.setProto3IntField(this,4,value);};/**
 * optional string product_name = 5;
 * @return {string}
 */proto.ctpfront.proto.Target.prototype.getProductName=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,5,""));};/** @param {string} value */proto.ctpfront.proto.Target.prototype.setProductName=function(value){jspb.Message.setProto3StringField(this,5,value);};/**
 * optional string exchange_name = 6;
 * @return {string}
 */proto.ctpfront.proto.Target.prototype.getExchangeName=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,6,""));};/** @param {string} value */proto.ctpfront.proto.Target.prototype.setExchangeName=function(value){jspb.Message.setProto3StringField(this,6,value);};/**
 * optional uint32 multiple = 7;
 * @return {number}
 */proto.ctpfront.proto.Target.prototype.getMultiple=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,7,0));};/** @param {number} value */proto.ctpfront.proto.Target.prototype.setMultiple=function(value){jspb.Message.setProto3IntField(this,7,value);};/**
 * optional double price_tick = 8;
 * @return {number}
 */proto.ctpfront.proto.Target.prototype.getPriceTick=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,8,0.0));};/** @param {number} value */proto.ctpfront.proto.Target.prototype.setPriceTick=function(value){jspb.Message.setProto3FloatField(this,8,value);};/**
 * optional uint32 product_class = 9;
 * @return {number}
 */proto.ctpfront.proto.Target.prototype.getProductClass=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,9,0));};/** @param {number} value */proto.ctpfront.proto.Target.prototype.setProductClass=function(value){jspb.Message.setProto3IntField(this,9,value);};/**
 * optional string target_code = 10;
 * @return {string}
 */proto.ctpfront.proto.Target.prototype.getTargetCode=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,10,""));};/** @param {string} value */proto.ctpfront.proto.Target.prototype.setTargetCode=function(value){jspb.Message.setProto3StringField(this,10,value);};/**
 * optional uint32 delivery_month = 11;
 * @return {number}
 */proto.ctpfront.proto.Target.prototype.getDeliveryMonth=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,11,0));};/** @param {number} value */proto.ctpfront.proto.Target.prototype.setDeliveryMonth=function(value){jspb.Message.setProto3IntField(this,11,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.TargetRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,proto.ctpfront.proto.TargetRsp.repeatedFields_,null);};goog.inherits(proto.ctpfront.proto.TargetRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.TargetRsp.displayName='proto.ctpfront.proto.TargetRsp';}/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */proto.ctpfront.proto.TargetRsp.repeatedFields_=[10];if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.TargetRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.TargetRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TargetRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.TargetRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),dataList:jspb.Message.toObjectList(msg.getDataList(),proto.ctpfront.proto.Target.toObject,includeInstance)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TargetRsp}
 */proto.ctpfront.proto.TargetRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.TargetRsp();return proto.ctpfront.proto.TargetRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TargetRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TargetRsp}
 */proto.ctpfront.proto.TargetRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 10:var value=new proto.ctpfront.proto.Target();reader.readMessage(value,proto.ctpfront.proto.Target.deserializeBinaryFromReader);msg.addData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.TargetRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.TargetRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TargetRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.TargetRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getDataList();if(f.length>0){writer.writeRepeatedMessage(10,f,proto.ctpfront.proto.Target.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.TargetRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.TargetRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.TargetRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.TargetRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * repeated Target data = 10;
 * @return {!Array.<!proto.ctpfront.proto.Target>}
 */proto.ctpfront.proto.TargetRsp.prototype.getDataList=function(){return(/** @type{!Array.<!proto.ctpfront.proto.Target>} */jspb.Message.getRepeatedWrapperField(this,proto.ctpfront.proto.Target,10));};/** @param {!Array.<!proto.ctpfront.proto.Target>} value */proto.ctpfront.proto.TargetRsp.prototype.setDataList=function(value){jspb.Message.setRepeatedWrapperField(this,10,value);};/**
 * @param {!proto.ctpfront.proto.Target=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ctpfront.proto.Target}
 */proto.ctpfront.proto.TargetRsp.prototype.addData=function(opt_value,opt_index){return jspb.Message.addToRepeatedWrapperField(this,10,opt_value,proto.ctpfront.proto.Target,opt_index);};proto.ctpfront.proto.TargetRsp.prototype.clearDataList=function(){this.setDataList([]);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.SubTickReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,proto.ctpfront.proto.SubTickReq.repeatedFields_,null);};goog.inherits(proto.ctpfront.proto.SubTickReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.SubTickReq.displayName='proto.ctpfront.proto.SubTickReq';}/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */proto.ctpfront.proto.SubTickReq.repeatedFields_=[1];if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.SubTickReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.SubTickReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubTickReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.SubTickReq.toObject=function(includeInstance,msg){var f,obj={targetList:jspb.Message.getRepeatedField(msg,1)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubTickReq}
 */proto.ctpfront.proto.SubTickReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.SubTickReq();return proto.ctpfront.proto.SubTickReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubTickReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubTickReq}
 */proto.ctpfront.proto.SubTickReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.addTarget(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.SubTickReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.SubTickReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubTickReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.SubTickReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getTargetList();if(f.length>0){writer.writeRepeatedString(1,f);}};/**
 * repeated string target = 1;
 * @return {!Array.<string>}
 */proto.ctpfront.proto.SubTickReq.prototype.getTargetList=function(){return(/** @type {!Array.<string>} */jspb.Message.getRepeatedField(this,1));};/** @param {!Array.<string>} value */proto.ctpfront.proto.SubTickReq.prototype.setTargetList=function(value){jspb.Message.setField(this,1,value||[]);};/**
 * @param {!string} value
 * @param {number=} opt_index
 */proto.ctpfront.proto.SubTickReq.prototype.addTarget=function(value,opt_index){jspb.Message.addToRepeatedField(this,1,value,opt_index);};proto.ctpfront.proto.SubTickReq.prototype.clearTargetList=function(){this.setTargetList([]);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.SubTickRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.SubTickRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.SubTickRsp.displayName='proto.ctpfront.proto.SubTickRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.SubTickRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.SubTickRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubTickRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.SubTickRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.SubTickReq.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubTickRsp}
 */proto.ctpfront.proto.SubTickRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.SubTickRsp();return proto.ctpfront.proto.SubTickRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubTickRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubTickRsp}
 */proto.ctpfront.proto.SubTickRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 10:var value=new proto.ctpfront.proto.SubTickReq();reader.readMessage(value,proto.ctpfront.proto.SubTickReq.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.SubTickRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.SubTickRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubTickRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.SubTickRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(10,f,proto.ctpfront.proto.SubTickReq.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.SubTickRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.SubTickRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.SubTickRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.SubTickRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional SubTickReq data = 10;
 * @return {?proto.ctpfront.proto.SubTickReq}
 */proto.ctpfront.proto.SubTickRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.SubTickReq} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.SubTickReq,10));};/** @param {?proto.ctpfront.proto.SubTickReq|undefined} value */proto.ctpfront.proto.SubTickRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,10,value);};proto.ctpfront.proto.SubTickRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.SubTickRsp.prototype.hasData=function(){return jspb.Message.getField(this,10)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Subscribe=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Subscribe,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Subscribe.displayName='proto.ctpfront.proto.Subscribe';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Subscribe.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Subscribe.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Subscribe} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Subscribe.toObject=function(includeInstance,msg){var f,obj={broker:jspb.Message.getFieldWithDefault(msg,1,""),account:jspb.Message.getFieldWithDefault(msg,2,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Subscribe}
 */proto.ctpfront.proto.Subscribe.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Subscribe();return proto.ctpfront.proto.Subscribe.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Subscribe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Subscribe}
 */proto.ctpfront.proto.Subscribe.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Subscribe.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Subscribe.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Subscribe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Subscribe.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getBroker();if(f.length>0){writer.writeString(1,f);}f=message.getAccount();if(f.length>0){writer.writeString(2,f);}};/**
 * optional string broker = 1;
 * @return {string}
 */proto.ctpfront.proto.Subscribe.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.Subscribe.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string account = 2;
 * @return {string}
 */proto.ctpfront.proto.Subscribe.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.Subscribe.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Response=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Response,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Response.displayName='proto.ctpfront.proto.Response';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Response.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Response.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Response} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Response.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.Subscribe.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Response}
 */proto.ctpfront.proto.Response.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Response();return proto.ctpfront.proto.Response.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Response}
 */proto.ctpfront.proto.Response.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 2:var value=new proto.ctpfront.proto.Subscribe();reader.readMessage(value,proto.ctpfront.proto.Subscribe.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Response.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Response.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Response.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(2,f,proto.ctpfront.proto.Subscribe.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.Response.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.Response.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.Response.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.Response.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional Subscribe data = 2;
 * @return {?proto.ctpfront.proto.Subscribe}
 */proto.ctpfront.proto.Response.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.Subscribe} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.Subscribe,2));};/** @param {?proto.ctpfront.proto.Subscribe|undefined} value */proto.ctpfront.proto.Response.prototype.setData=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.Response.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.Response.prototype.hasData=function(){return jspb.Message.getField(this,2)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.TargetSelected=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.TargetSelected,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.TargetSelected.displayName='proto.ctpfront.proto.TargetSelected';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.TargetSelected.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.TargetSelected.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TargetSelected} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.TargetSelected.toObject=function(includeInstance,msg){var f,obj={targetId:jspb.Message.getFieldWithDefault(msg,1,""),broker:jspb.Message.getFieldWithDefault(msg,3,""),account:jspb.Message.getFieldWithDefault(msg,4,""),stamp:jspb.Message.getFieldWithDefault(msg,5,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TargetSelected}
 */proto.ctpfront.proto.TargetSelected.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.TargetSelected();return proto.ctpfront.proto.TargetSelected.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TargetSelected} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TargetSelected}
 */proto.ctpfront.proto.TargetSelected.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 5:var value=/** @type {number} */reader.readUint32();msg.setStamp(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.TargetSelected.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.TargetSelected.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TargetSelected} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.TargetSelected.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getTargetId();if(f.length>0){writer.writeString(1,f);}f=message.getBroker();if(f.length>0){writer.writeString(3,f);}f=message.getAccount();if(f.length>0){writer.writeString(4,f);}f=message.getStamp();if(f!==0){writer.writeUint32(5,f);}};/**
 * optional string target_id = 1;
 * @return {string}
 */proto.ctpfront.proto.TargetSelected.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.TargetSelected.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string broker = 3;
 * @return {string}
 */proto.ctpfront.proto.TargetSelected.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.TargetSelected.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional string account = 4;
 * @return {string}
 */proto.ctpfront.proto.TargetSelected.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.TargetSelected.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * optional uint32 stamp = 5;
 * @return {number}
 */proto.ctpfront.proto.TargetSelected.prototype.getStamp=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,5,0));};/** @param {number} value */proto.ctpfront.proto.TargetSelected.prototype.setStamp=function(value){jspb.Message.setProto3IntField(this,5,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.TargetSelectedReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.TargetSelectedReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.TargetSelectedReq.displayName='proto.ctpfront.proto.TargetSelectedReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.TargetSelectedReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.TargetSelectedReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TargetSelectedReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.TargetSelectedReq.toObject=function(includeInstance,msg){var f,obj={broker:jspb.Message.getFieldWithDefault(msg,1,""),account:jspb.Message.getFieldWithDefault(msg,2,""),targetId:jspb.Message.getFieldWithDefault(msg,3,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TargetSelectedReq}
 */proto.ctpfront.proto.TargetSelectedReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.TargetSelectedReq();return proto.ctpfront.proto.TargetSelectedReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TargetSelectedReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TargetSelectedReq}
 */proto.ctpfront.proto.TargetSelectedReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.TargetSelectedReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.TargetSelectedReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TargetSelectedReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.TargetSelectedReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getBroker();if(f.length>0){writer.writeString(1,f);}f=message.getAccount();if(f.length>0){writer.writeString(2,f);}f=message.getTargetId();if(f.length>0){writer.writeString(3,f);}};/**
 * optional string broker = 1;
 * @return {string}
 */proto.ctpfront.proto.TargetSelectedReq.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.TargetSelectedReq.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string account = 2;
 * @return {string}
 */proto.ctpfront.proto.TargetSelectedReq.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.TargetSelectedReq.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string target_id = 3;
 * @return {string}
 */proto.ctpfront.proto.TargetSelectedReq.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.TargetSelectedReq.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.TargetSelectedRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.TargetSelectedRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.TargetSelectedRsp.displayName='proto.ctpfront.proto.TargetSelectedRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.TargetSelectedRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.TargetSelectedRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TargetSelectedRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.TargetSelectedRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.TargetSelectedReq.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TargetSelectedRsp}
 */proto.ctpfront.proto.TargetSelectedRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.TargetSelectedRsp();return proto.ctpfront.proto.TargetSelectedRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TargetSelectedRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TargetSelectedRsp}
 */proto.ctpfront.proto.TargetSelectedRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 2:var value=new proto.ctpfront.proto.TargetSelectedReq();reader.readMessage(value,proto.ctpfront.proto.TargetSelectedReq.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.TargetSelectedRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.TargetSelectedRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TargetSelectedRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.TargetSelectedRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(2,f,proto.ctpfront.proto.TargetSelectedReq.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.TargetSelectedRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.TargetSelectedRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.TargetSelectedRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.TargetSelectedRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional TargetSelectedReq data = 2;
 * @return {?proto.ctpfront.proto.TargetSelectedReq}
 */proto.ctpfront.proto.TargetSelectedRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.TargetSelectedReq} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.TargetSelectedReq,2));};/** @param {?proto.ctpfront.proto.TargetSelectedReq|undefined} value */proto.ctpfront.proto.TargetSelectedRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.TargetSelectedRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.TargetSelectedRsp.prototype.hasData=function(){return jspb.Message.getField(this,2)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Dominant=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Dominant,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Dominant.displayName='proto.ctpfront.proto.Dominant';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Dominant.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Dominant.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Dominant} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Dominant.toObject=function(includeInstance,msg){var f,obj={productId:jspb.Message.getFieldWithDefault(msg,1,""),targetId:jspb.Message.getFieldWithDefault(msg,2,""),exchangeId:jspb.Message.getFieldWithDefault(msg,3,0),volume:jspb.Message.getFieldWithDefault(msg,4,0),position:jspb.Message.getFieldWithDefault(msg,5,0),productName:jspb.Message.getFieldWithDefault(msg,6,""),exchangeName:jspb.Message.getFieldWithDefault(msg,7,""),stamp:jspb.Message.getFieldWithDefault(msg,8,0)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Dominant}
 */proto.ctpfront.proto.Dominant.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Dominant();return proto.ctpfront.proto.Dominant.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Dominant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Dominant}
 */proto.ctpfront.proto.Dominant.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setProductId(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 3:var value=/** @type {number} */reader.readUint32();msg.setExchangeId(value);break;case 4:var value=/** @type {number} */reader.readUint32();msg.setVolume(value);break;case 5:var value=/** @type {number} */reader.readUint32();msg.setPosition(value);break;case 6:var value=/** @type {string} */reader.readString();msg.setProductName(value);break;case 7:var value=/** @type {string} */reader.readString();msg.setExchangeName(value);break;case 8:var value=/** @type {number} */reader.readUint32();msg.setStamp(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Dominant.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Dominant.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Dominant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Dominant.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getProductId();if(f.length>0){writer.writeString(1,f);}f=message.getTargetId();if(f.length>0){writer.writeString(2,f);}f=message.getExchangeId();if(f!==0){writer.writeUint32(3,f);}f=message.getVolume();if(f!==0){writer.writeUint32(4,f);}f=message.getPosition();if(f!==0){writer.writeUint32(5,f);}f=message.getProductName();if(f.length>0){writer.writeString(6,f);}f=message.getExchangeName();if(f.length>0){writer.writeString(7,f);}f=message.getStamp();if(f!==0){writer.writeUint32(8,f);}};/**
 * optional string product_id = 1;
 * @return {string}
 */proto.ctpfront.proto.Dominant.prototype.getProductId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.Dominant.prototype.setProductId=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string target_id = 2;
 * @return {string}
 */proto.ctpfront.proto.Dominant.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.Dominant.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional uint32 exchange_id = 3;
 * @return {number}
 */proto.ctpfront.proto.Dominant.prototype.getExchangeId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,3,0));};/** @param {number} value */proto.ctpfront.proto.Dominant.prototype.setExchangeId=function(value){jspb.Message.setProto3IntField(this,3,value);};/**
 * optional uint32 volume = 4;
 * @return {number}
 */proto.ctpfront.proto.Dominant.prototype.getVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,4,0));};/** @param {number} value */proto.ctpfront.proto.Dominant.prototype.setVolume=function(value){jspb.Message.setProto3IntField(this,4,value);};/**
 * optional uint32 position = 5;
 * @return {number}
 */proto.ctpfront.proto.Dominant.prototype.getPosition=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,5,0));};/** @param {number} value */proto.ctpfront.proto.Dominant.prototype.setPosition=function(value){jspb.Message.setProto3IntField(this,5,value);};/**
 * optional string product_name = 6;
 * @return {string}
 */proto.ctpfront.proto.Dominant.prototype.getProductName=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,6,""));};/** @param {string} value */proto.ctpfront.proto.Dominant.prototype.setProductName=function(value){jspb.Message.setProto3StringField(this,6,value);};/**
 * optional string exchange_name = 7;
 * @return {string}
 */proto.ctpfront.proto.Dominant.prototype.getExchangeName=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,7,""));};/** @param {string} value */proto.ctpfront.proto.Dominant.prototype.setExchangeName=function(value){jspb.Message.setProto3StringField(this,7,value);};/**
 * optional uint32 stamp = 8;
 * @return {number}
 */proto.ctpfront.proto.Dominant.prototype.getStamp=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,8,0));};/** @param {number} value */proto.ctpfront.proto.Dominant.prototype.setStamp=function(value){jspb.Message.setProto3IntField(this,8,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.OrderConditional=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.OrderConditional,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.OrderConditional.displayName='proto.ctpfront.proto.OrderConditional';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.OrderConditional.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.OrderConditional.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.OrderConditional} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.OrderConditional.toObject=function(includeInstance,msg){var f,obj={id:jspb.Message.getFieldWithDefault(msg,1,""),targetId:jspb.Message.getFieldWithDefault(msg,2,""),insertDate:jspb.Message.getFieldWithDefault(msg,3,""),insertTime:jspb.Message.getFieldWithDefault(msg,4,""),price:+jspb.Message.getFieldWithDefault(msg,5,0.0),conditionPriceType:jspb.Message.getFieldWithDefault(msg,6,0),volume:jspb.Message.getFieldWithDefault(msg,7,0),direction:jspb.Message.getFieldWithDefault(msg,8,0),offset:jspb.Message.getFieldWithDefault(msg,9,0),validTime:jspb.Message.getFieldWithDefault(msg,10,0),state:jspb.Message.getFieldWithDefault(msg,11,0),stateDetail:jspb.Message.getFieldWithDefault(msg,12,""),broker:jspb.Message.getFieldWithDefault(msg,20,""),account:jspb.Message.getFieldWithDefault(msg,21,""),stamp:jspb.Message.getFieldWithDefault(msg,22,0),operationType:jspb.Message.getFieldWithDefault(msg,23,0),orderPriceType:jspb.Message.getFieldWithDefault(msg,24,0),orderPrice:+jspb.Message.getFieldWithDefault(msg,25,0.0),orderType:jspb.Message.getFieldWithDefault(msg,27,0),slPrice:+jspb.Message.getFieldWithDefault(msg,28,0.0),tpPrice:+jspb.Message.getFieldWithDefault(msg,29,0.0),posDirection:jspb.Message.getFieldWithDefault(msg,30,0),updateDate:jspb.Message.getFieldWithDefault(msg,31,""),updateTime:jspb.Message.getFieldWithDefault(msg,32,""),priceTypeMarket:jspb.Message.getFieldWithDefault(msg,33,false)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.OrderConditional}
 */proto.ctpfront.proto.OrderConditional.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.OrderConditional();return proto.ctpfront.proto.OrderConditional.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.OrderConditional} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.OrderConditional}
 */proto.ctpfront.proto.OrderConditional.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setId(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setTargetId(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setInsertDate(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setInsertTime(value);break;case 5:var value=/** @type {number} */reader.readDouble();msg.setPrice(value);break;case 6:var value=/** @type {number} */reader.readUint32();msg.setConditionPriceType(value);break;case 7:var value=/** @type {number} */reader.readUint32();msg.setVolume(value);break;case 8:var value=/** @type {number} */reader.readUint32();msg.setDirection(value);break;case 9:var value=/** @type {number} */reader.readUint32();msg.setOffset(value);break;case 10:var value=/** @type {number} */reader.readUint32();msg.setValidTime(value);break;case 11:var value=/** @type {number} */reader.readUint32();msg.setState(value);break;case 12:var value=/** @type {string} */reader.readString();msg.setStateDetail(value);break;case 20:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 21:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 22:var value=/** @type {number} */reader.readUint32();msg.setStamp(value);break;case 23:var value=/** @type {number} */reader.readUint32();msg.setOperationType(value);break;case 24:var value=/** @type {number} */reader.readUint32();msg.setOrderPriceType(value);break;case 25:var value=/** @type {number} */reader.readDouble();msg.setOrderPrice(value);break;case 27:var value=/** @type {number} */reader.readUint32();msg.setOrderType(value);break;case 28:var value=/** @type {number} */reader.readDouble();msg.setSlPrice(value);break;case 29:var value=/** @type {number} */reader.readDouble();msg.setTpPrice(value);break;case 30:var value=/** @type {number} */reader.readInt32();msg.setPosDirection(value);break;case 31:var value=/** @type {string} */reader.readString();msg.setUpdateDate(value);break;case 32:var value=/** @type {string} */reader.readString();msg.setUpdateTime(value);break;case 33:var value=/** @type {boolean} */reader.readBool();msg.setPriceTypeMarket(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.OrderConditional.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.OrderConditional.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.OrderConditional} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.OrderConditional.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getId();if(f.length>0){writer.writeString(1,f);}f=message.getTargetId();if(f.length>0){writer.writeString(2,f);}f=message.getInsertDate();if(f.length>0){writer.writeString(3,f);}f=message.getInsertTime();if(f.length>0){writer.writeString(4,f);}f=message.getPrice();if(f!==0.0){writer.writeDouble(5,f);}f=message.getConditionPriceType();if(f!==0){writer.writeUint32(6,f);}f=message.getVolume();if(f!==0){writer.writeUint32(7,f);}f=message.getDirection();if(f!==0){writer.writeUint32(8,f);}f=message.getOffset();if(f!==0){writer.writeUint32(9,f);}f=message.getValidTime();if(f!==0){writer.writeUint32(10,f);}f=message.getState();if(f!==0){writer.writeUint32(11,f);}f=message.getStateDetail();if(f.length>0){writer.writeString(12,f);}f=message.getBroker();if(f.length>0){writer.writeString(20,f);}f=message.getAccount();if(f.length>0){writer.writeString(21,f);}f=message.getStamp();if(f!==0){writer.writeUint32(22,f);}f=message.getOperationType();if(f!==0){writer.writeUint32(23,f);}f=message.getOrderPriceType();if(f!==0){writer.writeUint32(24,f);}f=message.getOrderPrice();if(f!==0.0){writer.writeDouble(25,f);}f=message.getOrderType();if(f!==0){writer.writeUint32(27,f);}f=message.getSlPrice();if(f!==0.0){writer.writeDouble(28,f);}f=message.getTpPrice();if(f!==0.0){writer.writeDouble(29,f);}f=message.getPosDirection();if(f!==0){writer.writeInt32(30,f);}f=message.getUpdateDate();if(f.length>0){writer.writeString(31,f);}f=message.getUpdateTime();if(f.length>0){writer.writeString(32,f);}f=message.getPriceTypeMarket();if(f){writer.writeBool(33,f);}};/**
 * optional string id = 1;
 * @return {string}
 */proto.ctpfront.proto.OrderConditional.prototype.getId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditional.prototype.setId=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string target_id = 2;
 * @return {string}
 */proto.ctpfront.proto.OrderConditional.prototype.getTargetId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditional.prototype.setTargetId=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string insert_date = 3;
 * @return {string}
 */proto.ctpfront.proto.OrderConditional.prototype.getInsertDate=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditional.prototype.setInsertDate=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional string insert_time = 4;
 * @return {string}
 */proto.ctpfront.proto.OrderConditional.prototype.getInsertTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditional.prototype.setInsertTime=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * optional double price = 5;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,5,0.0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setPrice=function(value){jspb.Message.setProto3FloatField(this,5,value);};/**
 * optional uint32 condition_price_type = 6;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getConditionPriceType=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,6,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setConditionPriceType=function(value){jspb.Message.setProto3IntField(this,6,value);};/**
 * optional uint32 volume = 7;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getVolume=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,7,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setVolume=function(value){jspb.Message.setProto3IntField(this,7,value);};/**
 * optional uint32 direction = 8;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getDirection=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,8,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setDirection=function(value){jspb.Message.setProto3IntField(this,8,value);};/**
 * optional uint32 offset = 9;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getOffset=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,9,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setOffset=function(value){jspb.Message.setProto3IntField(this,9,value);};/**
 * optional uint32 valid_time = 10;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getValidTime=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,10,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setValidTime=function(value){jspb.Message.setProto3IntField(this,10,value);};/**
 * optional uint32 state = 11;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getState=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,11,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setState=function(value){jspb.Message.setProto3IntField(this,11,value);};/**
 * optional string state_detail = 12;
 * @return {string}
 */proto.ctpfront.proto.OrderConditional.prototype.getStateDetail=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,12,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditional.prototype.setStateDetail=function(value){jspb.Message.setProto3StringField(this,12,value);};/**
 * optional string broker = 20;
 * @return {string}
 */proto.ctpfront.proto.OrderConditional.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,20,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditional.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,20,value);};/**
 * optional string account = 21;
 * @return {string}
 */proto.ctpfront.proto.OrderConditional.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,21,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditional.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,21,value);};/**
 * optional uint32 stamp = 22;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getStamp=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,22,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setStamp=function(value){jspb.Message.setProto3IntField(this,22,value);};/**
 * optional uint32 operation_type = 23;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getOperationType=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,23,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setOperationType=function(value){jspb.Message.setProto3IntField(this,23,value);};/**
 * optional uint32 order_price_type = 24;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getOrderPriceType=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,24,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setOrderPriceType=function(value){jspb.Message.setProto3IntField(this,24,value);};/**
 * optional double order_price = 25;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getOrderPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,25,0.0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setOrderPrice=function(value){jspb.Message.setProto3FloatField(this,25,value);};/**
 * optional uint32 order_type = 27;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getOrderType=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,27,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setOrderType=function(value){jspb.Message.setProto3IntField(this,27,value);};/**
 * optional double sl_price = 28;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getSlPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,28,0.0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setSlPrice=function(value){jspb.Message.setProto3FloatField(this,28,value);};/**
 * optional double tp_price = 29;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getTpPrice=function(){return(/** @type {number} */+jspb.Message.getFieldWithDefault(this,29,0.0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setTpPrice=function(value){jspb.Message.setProto3FloatField(this,29,value);};/**
 * optional int32 pos_direction = 30;
 * @return {number}
 */proto.ctpfront.proto.OrderConditional.prototype.getPosDirection=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,30,0));};/** @param {number} value */proto.ctpfront.proto.OrderConditional.prototype.setPosDirection=function(value){jspb.Message.setProto3IntField(this,30,value);};/**
 * optional string update_date = 31;
 * @return {string}
 */proto.ctpfront.proto.OrderConditional.prototype.getUpdateDate=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,31,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditional.prototype.setUpdateDate=function(value){jspb.Message.setProto3StringField(this,31,value);};/**
 * optional string update_time = 32;
 * @return {string}
 */proto.ctpfront.proto.OrderConditional.prototype.getUpdateTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,32,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditional.prototype.setUpdateTime=function(value){jspb.Message.setProto3StringField(this,32,value);};/**
 * optional bool price_type_market = 33;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */proto.ctpfront.proto.OrderConditional.prototype.getPriceTypeMarket=function(){return(/** @type {boolean} */jspb.Message.getFieldWithDefault(this,33,false));};/** @param {boolean} value */proto.ctpfront.proto.OrderConditional.prototype.setPriceTypeMarket=function(value){jspb.Message.setProto3BooleanField(this,33,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.OrderConditionalReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.OrderConditionalReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.OrderConditionalReq.displayName='proto.ctpfront.proto.OrderConditionalReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.OrderConditionalReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.OrderConditionalReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.OrderConditionalReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.OrderConditionalReq.toObject=function(includeInstance,msg){var f,obj={broker:jspb.Message.getFieldWithDefault(msg,1,""),account:jspb.Message.getFieldWithDefault(msg,2,""),id:jspb.Message.getFieldWithDefault(msg,3,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.OrderConditionalReq}
 */proto.ctpfront.proto.OrderConditionalReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.OrderConditionalReq();return proto.ctpfront.proto.OrderConditionalReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.OrderConditionalReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.OrderConditionalReq}
 */proto.ctpfront.proto.OrderConditionalReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setId(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.OrderConditionalReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.OrderConditionalReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.OrderConditionalReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.OrderConditionalReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getBroker();if(f.length>0){writer.writeString(1,f);}f=message.getAccount();if(f.length>0){writer.writeString(2,f);}f=message.getId();if(f.length>0){writer.writeString(3,f);}};/**
 * optional string broker = 1;
 * @return {string}
 */proto.ctpfront.proto.OrderConditionalReq.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditionalReq.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string account = 2;
 * @return {string}
 */proto.ctpfront.proto.OrderConditionalReq.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditionalReq.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string id = 3;
 * @return {string}
 */proto.ctpfront.proto.OrderConditionalReq.prototype.getId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditionalReq.prototype.setId=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.OrderConditionalRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.OrderConditionalRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.OrderConditionalRsp.displayName='proto.ctpfront.proto.OrderConditionalRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.OrderConditionalRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.OrderConditionalRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.OrderConditionalRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.OrderConditionalRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.OrderConditionalReq.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.OrderConditionalRsp}
 */proto.ctpfront.proto.OrderConditionalRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.OrderConditionalRsp();return proto.ctpfront.proto.OrderConditionalRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.OrderConditionalRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.OrderConditionalRsp}
 */proto.ctpfront.proto.OrderConditionalRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 2:var value=new proto.ctpfront.proto.OrderConditionalReq();reader.readMessage(value,proto.ctpfront.proto.OrderConditionalReq.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.OrderConditionalRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.OrderConditionalRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.OrderConditionalRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.OrderConditionalRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(2,f,proto.ctpfront.proto.OrderConditionalReq.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.OrderConditionalRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.OrderConditionalRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.OrderConditionalRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.OrderConditionalRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional OrderConditionalReq data = 2;
 * @return {?proto.ctpfront.proto.OrderConditionalReq}
 */proto.ctpfront.proto.OrderConditionalRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.OrderConditionalReq} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.OrderConditionalReq,2));};/** @param {?proto.ctpfront.proto.OrderConditionalReq|undefined} value */proto.ctpfront.proto.OrderConditionalRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.OrderConditionalRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.OrderConditionalRsp.prototype.hasData=function(){return jspb.Message.getField(this,2)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.OrderConditionGetReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.OrderConditionGetReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.OrderConditionGetReq.displayName='proto.ctpfront.proto.OrderConditionGetReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.OrderConditionGetReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.OrderConditionGetReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.OrderConditionGetReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.OrderConditionGetReq.toObject=function(includeInstance,msg){var f,obj={broker:jspb.Message.getFieldWithDefault(msg,1,""),account:jspb.Message.getFieldWithDefault(msg,2,""),startTime:jspb.Message.getFieldWithDefault(msg,3,""),lastTime:jspb.Message.getFieldWithDefault(msg,4,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.OrderConditionGetReq}
 */proto.ctpfront.proto.OrderConditionGetReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.OrderConditionGetReq();return proto.ctpfront.proto.OrderConditionGetReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.OrderConditionGetReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.OrderConditionGetReq}
 */proto.ctpfront.proto.OrderConditionGetReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setStartTime(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setLastTime(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.OrderConditionGetReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.OrderConditionGetReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.OrderConditionGetReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.OrderConditionGetReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getBroker();if(f.length>0){writer.writeString(1,f);}f=message.getAccount();if(f.length>0){writer.writeString(2,f);}f=message.getStartTime();if(f.length>0){writer.writeString(3,f);}f=message.getLastTime();if(f.length>0){writer.writeString(4,f);}};/**
 * optional string broker = 1;
 * @return {string}
 */proto.ctpfront.proto.OrderConditionGetReq.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditionGetReq.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string account = 2;
 * @return {string}
 */proto.ctpfront.proto.OrderConditionGetReq.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditionGetReq.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string start_time = 3;
 * @return {string}
 */proto.ctpfront.proto.OrderConditionGetReq.prototype.getStartTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditionGetReq.prototype.setStartTime=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional string last_time = 4;
 * @return {string}
 */proto.ctpfront.proto.OrderConditionGetReq.prototype.getLastTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.OrderConditionGetReq.prototype.setLastTime=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.OrderConditionGetRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.OrderConditionGetRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.OrderConditionGetRsp.displayName='proto.ctpfront.proto.OrderConditionGetRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.OrderConditionGetRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.OrderConditionGetRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.OrderConditionGetRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.OrderConditionGetRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.OrderConditional.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.OrderConditionGetRsp}
 */proto.ctpfront.proto.OrderConditionGetRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.OrderConditionGetRsp();return proto.ctpfront.proto.OrderConditionGetRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.OrderConditionGetRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.OrderConditionGetRsp}
 */proto.ctpfront.proto.OrderConditionGetRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 2:var value=new proto.ctpfront.proto.OrderConditional();reader.readMessage(value,proto.ctpfront.proto.OrderConditional.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.OrderConditionGetRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.OrderConditionGetRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.OrderConditionGetRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.OrderConditionGetRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(2,f,proto.ctpfront.proto.OrderConditional.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.OrderConditionGetRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.OrderConditionGetRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.OrderConditionGetRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.OrderConditionGetRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional OrderConditional data = 2;
 * @return {?proto.ctpfront.proto.OrderConditional}
 */proto.ctpfront.proto.OrderConditionGetRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.OrderConditional} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.OrderConditional,2));};/** @param {?proto.ctpfront.proto.OrderConditional|undefined} value */proto.ctpfront.proto.OrderConditionGetRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.OrderConditionGetRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.OrderConditionGetRsp.prototype.hasData=function(){return jspb.Message.getField(this,2)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.SubConditionList=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.SubConditionList,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.SubConditionList.displayName='proto.ctpfront.proto.SubConditionList';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.SubConditionList.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.SubConditionList.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubConditionList} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.SubConditionList.toObject=function(includeInstance,msg){var f,obj={broker:jspb.Message.getFieldWithDefault(msg,1,""),account:jspb.Message.getFieldWithDefault(msg,2,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubConditionList}
 */proto.ctpfront.proto.SubConditionList.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.SubConditionList();return proto.ctpfront.proto.SubConditionList.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubConditionList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubConditionList}
 */proto.ctpfront.proto.SubConditionList.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.SubConditionList.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.SubConditionList.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubConditionList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.SubConditionList.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getBroker();if(f.length>0){writer.writeString(1,f);}f=message.getAccount();if(f.length>0){writer.writeString(2,f);}};/**
 * optional string broker = 1;
 * @return {string}
 */proto.ctpfront.proto.SubConditionList.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.SubConditionList.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string account = 2;
 * @return {string}
 */proto.ctpfront.proto.SubConditionList.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.SubConditionList.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.SubConditionListRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.SubConditionListRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.SubConditionListRsp.displayName='proto.ctpfront.proto.SubConditionListRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.SubConditionListRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.SubConditionListRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.SubConditionListRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.SubConditionListRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.SubConditionList.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.SubConditionListRsp}
 */proto.ctpfront.proto.SubConditionListRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.SubConditionListRsp();return proto.ctpfront.proto.SubConditionListRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.SubConditionListRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.SubConditionListRsp}
 */proto.ctpfront.proto.SubConditionListRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 2:var value=new proto.ctpfront.proto.SubConditionList();reader.readMessage(value,proto.ctpfront.proto.SubConditionList.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.SubConditionListRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.SubConditionListRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.SubConditionListRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.SubConditionListRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(2,f,proto.ctpfront.proto.SubConditionList.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.SubConditionListRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.SubConditionListRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.SubConditionListRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.SubConditionListRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional SubConditionList data = 2;
 * @return {?proto.ctpfront.proto.SubConditionList}
 */proto.ctpfront.proto.SubConditionListRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.SubConditionList} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.SubConditionList,2));};/** @param {?proto.ctpfront.proto.SubConditionList|undefined} value */proto.ctpfront.proto.SubConditionListRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.SubConditionListRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.SubConditionListRsp.prototype.hasData=function(){return jspb.Message.getField(this,2)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.ConditionOrderRecordGetReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.ConditionOrderRecordGetReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.ConditionOrderRecordGetReq.displayName='proto.ctpfront.proto.ConditionOrderRecordGetReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.ConditionOrderRecordGetReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.ConditionOrderRecordGetReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.ConditionOrderRecordGetReq.toObject=function(includeInstance,msg){var f,obj={chdaccountid:jspb.Message.getFieldWithDefault(msg,2,""),conId:jspb.Message.getFieldWithDefault(msg,3,""),startTime:jspb.Message.getFieldWithDefault(msg,4,""),endTime:jspb.Message.getFieldWithDefault(msg,5,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.ConditionOrderRecordGetReq}
 */proto.ctpfront.proto.ConditionOrderRecordGetReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.ConditionOrderRecordGetReq();return proto.ctpfront.proto.ConditionOrderRecordGetReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.ConditionOrderRecordGetReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.ConditionOrderRecordGetReq}
 */proto.ctpfront.proto.ConditionOrderRecordGetReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 2:var value=/** @type {string} */reader.readString();msg.setChdaccountid(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setConId(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setStartTime(value);break;case 5:var value=/** @type {string} */reader.readString();msg.setEndTime(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.ConditionOrderRecordGetReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.ConditionOrderRecordGetReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.ConditionOrderRecordGetReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getChdaccountid();if(f.length>0){writer.writeString(2,f);}f=message.getConId();if(f.length>0){writer.writeString(3,f);}f=message.getStartTime();if(f.length>0){writer.writeString(4,f);}f=message.getEndTime();if(f.length>0){writer.writeString(5,f);}};/**
 * optional string chdaccountid = 2;
 * @return {string}
 */proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.getChdaccountid=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.setChdaccountid=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string con_id = 3;
 * @return {string}
 */proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.getConId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.setConId=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional string start_time = 4;
 * @return {string}
 */proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.getStartTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.setStartTime=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * optional string end_time = 5;
 * @return {string}
 */proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.getEndTime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,5,""));};/** @param {string} value */proto.ctpfront.proto.ConditionOrderRecordGetReq.prototype.setEndTime=function(value){jspb.Message.setProto3StringField(this,5,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.ConditionOrderRecord=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.ConditionOrderRecord,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.ConditionOrderRecord.displayName='proto.ctpfront.proto.ConditionOrderRecord';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.ConditionOrderRecord.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.ConditionOrderRecord.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.ConditionOrderRecord} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.ConditionOrderRecord.toObject=function(includeInstance,msg){var f,obj={id:jspb.Message.getFieldWithDefault(msg,1,0),conId:jspb.Message.getFieldWithDefault(msg,2,""),operation:jspb.Message.getFieldWithDefault(msg,3,0),state:jspb.Message.getFieldWithDefault(msg,4,0),updateip:jspb.Message.getFieldWithDefault(msg,6,""),updatemac:jspb.Message.getFieldWithDefault(msg,7,""),datetime:jspb.Message.getFieldWithDefault(msg,8,""),description:jspb.Message.getFieldWithDefault(msg,9,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.ConditionOrderRecord}
 */proto.ctpfront.proto.ConditionOrderRecord.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.ConditionOrderRecord();return proto.ctpfront.proto.ConditionOrderRecord.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.ConditionOrderRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.ConditionOrderRecord}
 */proto.ctpfront.proto.ConditionOrderRecord.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {number} */reader.readInt32();msg.setId(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setConId(value);break;case 3:var value=/** @type {number} */reader.readInt32();msg.setOperation(value);break;case 4:var value=/** @type {number} */reader.readInt32();msg.setState(value);break;case 6:var value=/** @type {string} */reader.readString();msg.setUpdateip(value);break;case 7:var value=/** @type {string} */reader.readString();msg.setUpdatemac(value);break;case 8:var value=/** @type {string} */reader.readString();msg.setDatetime(value);break;case 9:var value=/** @type {string} */reader.readString();msg.setDescription(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.ConditionOrderRecord.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.ConditionOrderRecord.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.ConditionOrderRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.ConditionOrderRecord.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getId();if(f!==0){writer.writeInt32(1,f);}f=message.getConId();if(f.length>0){writer.writeString(2,f);}f=message.getOperation();if(f!==0){writer.writeInt32(3,f);}f=message.getState();if(f!==0){writer.writeInt32(4,f);}f=message.getUpdateip();if(f.length>0){writer.writeString(6,f);}f=message.getUpdatemac();if(f.length>0){writer.writeString(7,f);}f=message.getDatetime();if(f.length>0){writer.writeString(8,f);}f=message.getDescription();if(f.length>0){writer.writeString(9,f);}};/**
 * optional int32 id = 1;
 * @return {number}
 */proto.ctpfront.proto.ConditionOrderRecord.prototype.getId=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,1,0));};/** @param {number} value */proto.ctpfront.proto.ConditionOrderRecord.prototype.setId=function(value){jspb.Message.setProto3IntField(this,1,value);};/**
 * optional string con_id = 2;
 * @return {string}
 */proto.ctpfront.proto.ConditionOrderRecord.prototype.getConId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.ConditionOrderRecord.prototype.setConId=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional int32 operation = 3;
 * @return {number}
 */proto.ctpfront.proto.ConditionOrderRecord.prototype.getOperation=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,3,0));};/** @param {number} value */proto.ctpfront.proto.ConditionOrderRecord.prototype.setOperation=function(value){jspb.Message.setProto3IntField(this,3,value);};/**
 * optional int32 state = 4;
 * @return {number}
 */proto.ctpfront.proto.ConditionOrderRecord.prototype.getState=function(){return(/** @type {number} */jspb.Message.getFieldWithDefault(this,4,0));};/** @param {number} value */proto.ctpfront.proto.ConditionOrderRecord.prototype.setState=function(value){jspb.Message.setProto3IntField(this,4,value);};/**
 * optional string updateip = 6;
 * @return {string}
 */proto.ctpfront.proto.ConditionOrderRecord.prototype.getUpdateip=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,6,""));};/** @param {string} value */proto.ctpfront.proto.ConditionOrderRecord.prototype.setUpdateip=function(value){jspb.Message.setProto3StringField(this,6,value);};/**
 * optional string updatemac = 7;
 * @return {string}
 */proto.ctpfront.proto.ConditionOrderRecord.prototype.getUpdatemac=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,7,""));};/** @param {string} value */proto.ctpfront.proto.ConditionOrderRecord.prototype.setUpdatemac=function(value){jspb.Message.setProto3StringField(this,7,value);};/**
 * optional string datetime = 8;
 * @return {string}
 */proto.ctpfront.proto.ConditionOrderRecord.prototype.getDatetime=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,8,""));};/** @param {string} value */proto.ctpfront.proto.ConditionOrderRecord.prototype.setDatetime=function(value){jspb.Message.setProto3StringField(this,8,value);};/**
 * optional string description = 9;
 * @return {string}
 */proto.ctpfront.proto.ConditionOrderRecord.prototype.getDescription=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,9,""));};/** @param {string} value */proto.ctpfront.proto.ConditionOrderRecord.prototype.setDescription=function(value){jspb.Message.setProto3StringField(this,9,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.ConditionOrderRecordGetRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.ConditionOrderRecordGetRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.ConditionOrderRecordGetRsp.displayName='proto.ctpfront.proto.ConditionOrderRecordGetRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.ConditionOrderRecordGetRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.ConditionOrderRecordGetRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.ConditionOrderRecordGetRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.ConditionOrderRecord.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.ConditionOrderRecordGetRsp}
 */proto.ctpfront.proto.ConditionOrderRecordGetRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.ConditionOrderRecordGetRsp();return proto.ctpfront.proto.ConditionOrderRecordGetRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.ConditionOrderRecordGetRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.ConditionOrderRecordGetRsp}
 */proto.ctpfront.proto.ConditionOrderRecordGetRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 2:var value=new proto.ctpfront.proto.ConditionOrderRecord();reader.readMessage(value,proto.ctpfront.proto.ConditionOrderRecord.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.ConditionOrderRecordGetRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.ConditionOrderRecordGetRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.ConditionOrderRecordGetRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(2,f,proto.ctpfront.proto.ConditionOrderRecord.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional ConditionOrderRecord data = 2;
 * @return {?proto.ctpfront.proto.ConditionOrderRecord}
 */proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.ConditionOrderRecord} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.ConditionOrderRecord,2));};/** @param {?proto.ctpfront.proto.ConditionOrderRecord|undefined} value */proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.ConditionOrderRecordGetRsp.prototype.hasData=function(){return jspb.Message.getField(this,2)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.TradeAccountPasswdUpdateReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.TradeAccountPasswdUpdateReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.TradeAccountPasswdUpdateReq.displayName='proto.ctpfront.proto.TradeAccountPasswdUpdateReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.TradeAccountPasswdUpdateReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.toObject=function(includeInstance,msg){var f,obj={broker:jspb.Message.getFieldWithDefault(msg,1,""),account:jspb.Message.getFieldWithDefault(msg,2,""),oldPasswd:jspb.Message.getFieldWithDefault(msg,3,""),newPasswd:jspb.Message.getFieldWithDefault(msg,4,""),currencyId:jspb.Message.getFieldWithDefault(msg,5,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TradeAccountPasswdUpdateReq}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.TradeAccountPasswdUpdateReq();return proto.ctpfront.proto.TradeAccountPasswdUpdateReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TradeAccountPasswdUpdateReq}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setAccount(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setOldPasswd(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setNewPasswd(value);break;case 5:var value=/** @type {string} */reader.readString();msg.setCurrencyId(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.TradeAccountPasswdUpdateReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getBroker();if(f.length>0){writer.writeString(1,f);}f=message.getAccount();if(f.length>0){writer.writeString(2,f);}f=message.getOldPasswd();if(f.length>0){writer.writeString(3,f);}f=message.getNewPasswd();if(f.length>0){writer.writeString(4,f);}f=message.getCurrencyId();if(f.length>0){writer.writeString(5,f);}};/**
 * optional string broker = 1;
 * @return {string}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string account = 2;
 * @return {string}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.getAccount=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.setAccount=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string old_passwd = 3;
 * @return {string}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.getOldPasswd=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.setOldPasswd=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional string new_passwd = 4;
 * @return {string}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.getNewPasswd=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.setNewPasswd=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * optional string currency_id = 5;
 * @return {string}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.getCurrencyId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,5,""));};/** @param {string} value */proto.ctpfront.proto.TradeAccountPasswdUpdateReq.prototype.setCurrencyId=function(value){jspb.Message.setProto3StringField(this,5,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.TradeAccountPasswdUpdateRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.displayName='proto.ctpfront.proto.TradeAccountPasswdUpdateRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.TradeAccountPasswdUpdateReq.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.TradeAccountPasswdUpdateRsp}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.TradeAccountPasswdUpdateRsp();return proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.TradeAccountPasswdUpdateRsp}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 2:var value=new proto.ctpfront.proto.TradeAccountPasswdUpdateReq();reader.readMessage(value,proto.ctpfront.proto.TradeAccountPasswdUpdateReq.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.TradeAccountPasswdUpdateRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(2,f,proto.ctpfront.proto.TradeAccountPasswdUpdateReq.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional TradeAccountPasswdUpdateReq data = 2;
 * @return {?proto.ctpfront.proto.TradeAccountPasswdUpdateReq}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.TradeAccountPasswdUpdateReq} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.TradeAccountPasswdUpdateReq,2));};/** @param {?proto.ctpfront.proto.TradeAccountPasswdUpdateReq|undefined} value */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.TradeAccountPasswdUpdateRsp.prototype.hasData=function(){return jspb.Message.getField(this,2)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.UserPasswdUpdateReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.UserPasswdUpdateReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.UserPasswdUpdateReq.displayName='proto.ctpfront.proto.UserPasswdUpdateReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.UserPasswdUpdateReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.UserPasswdUpdateReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.UserPasswdUpdateReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.UserPasswdUpdateReq.toObject=function(includeInstance,msg){var f,obj={broker:jspb.Message.getFieldWithDefault(msg,1,""),userId:jspb.Message.getFieldWithDefault(msg,2,""),oldPasswd:jspb.Message.getFieldWithDefault(msg,3,""),newPasswd:jspb.Message.getFieldWithDefault(msg,4,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.UserPasswdUpdateReq}
 */proto.ctpfront.proto.UserPasswdUpdateReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.UserPasswdUpdateReq();return proto.ctpfront.proto.UserPasswdUpdateReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.UserPasswdUpdateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.UserPasswdUpdateReq}
 */proto.ctpfront.proto.UserPasswdUpdateReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setBroker(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setUserId(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setOldPasswd(value);break;case 4:var value=/** @type {string} */reader.readString();msg.setNewPasswd(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.UserPasswdUpdateReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.UserPasswdUpdateReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.UserPasswdUpdateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.UserPasswdUpdateReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getBroker();if(f.length>0){writer.writeString(1,f);}f=message.getUserId();if(f.length>0){writer.writeString(2,f);}f=message.getOldPasswd();if(f.length>0){writer.writeString(3,f);}f=message.getNewPasswd();if(f.length>0){writer.writeString(4,f);}};/**
 * optional string broker = 1;
 * @return {string}
 */proto.ctpfront.proto.UserPasswdUpdateReq.prototype.getBroker=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.UserPasswdUpdateReq.prototype.setBroker=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string user_id = 2;
 * @return {string}
 */proto.ctpfront.proto.UserPasswdUpdateReq.prototype.getUserId=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.UserPasswdUpdateReq.prototype.setUserId=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string old_passwd = 3;
 * @return {string}
 */proto.ctpfront.proto.UserPasswdUpdateReq.prototype.getOldPasswd=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.UserPasswdUpdateReq.prototype.setOldPasswd=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * optional string new_passwd = 4;
 * @return {string}
 */proto.ctpfront.proto.UserPasswdUpdateReq.prototype.getNewPasswd=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,4,""));};/** @param {string} value */proto.ctpfront.proto.UserPasswdUpdateReq.prototype.setNewPasswd=function(value){jspb.Message.setProto3StringField(this,4,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.UserPasswdUpdateRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.UserPasswdUpdateRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.UserPasswdUpdateRsp.displayName='proto.ctpfront.proto.UserPasswdUpdateRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.UserPasswdUpdateRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.UserPasswdUpdateRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.UserPasswdUpdateRsp.toObject=function(includeInstance,msg){var f,obj={error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.UserPasswdUpdateReq.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.UserPasswdUpdateRsp}
 */proto.ctpfront.proto.UserPasswdUpdateRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.UserPasswdUpdateRsp();return proto.ctpfront.proto.UserPasswdUpdateRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.UserPasswdUpdateRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.UserPasswdUpdateRsp}
 */proto.ctpfront.proto.UserPasswdUpdateRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 2:var value=new proto.ctpfront.proto.UserPasswdUpdateReq();reader.readMessage(value,proto.ctpfront.proto.UserPasswdUpdateReq.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.UserPasswdUpdateRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.UserPasswdUpdateRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.UserPasswdUpdateRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getError();if(f!=null){writer.writeMessage(1,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(2,f,proto.ctpfront.proto.UserPasswdUpdateReq.serializeBinaryToWriter);}};/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,1));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.hasError=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional UserPasswdUpdateReq data = 2;
 * @return {?proto.ctpfront.proto.UserPasswdUpdateReq}
 */proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.UserPasswdUpdateReq} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.UserPasswdUpdateReq,2));};/** @param {?proto.ctpfront.proto.UserPasswdUpdateReq|undefined} value */proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.UserPasswdUpdateRsp.prototype.hasData=function(){return jspb.Message.getField(this,2)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Word=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.Word,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Word.displayName='proto.ctpfront.proto.Word';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Word.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Word.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Word} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Word.toObject=function(includeInstance,msg){var f,obj={word:jspb.Message.getFieldWithDefault(msg,1,""),lang:jspb.Message.getFieldWithDefault(msg,2,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Word}
 */proto.ctpfront.proto.Word.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Word();return proto.ctpfront.proto.Word.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Word} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Word}
 */proto.ctpfront.proto.Word.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setWord(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setLang(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Word.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Word.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Word} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Word.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getWord();if(f.length>0){writer.writeString(1,f);}f=message.getLang();if(f.length>0){writer.writeString(2,f);}};/**
 * optional string word = 1;
 * @return {string}
 */proto.ctpfront.proto.Word.prototype.getWord=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.Word.prototype.setWord=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string lang = 2;
 * @return {string}
 */proto.ctpfront.proto.Word.prototype.getLang=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.Word.prototype.setLang=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.Dictionary=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,proto.ctpfront.proto.Dictionary.repeatedFields_,null);};goog.inherits(proto.ctpfront.proto.Dictionary,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.Dictionary.displayName='proto.ctpfront.proto.Dictionary';}/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */proto.ctpfront.proto.Dictionary.repeatedFields_=[1];if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.Dictionary.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.Dictionary.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.Dictionary} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.Dictionary.toObject=function(includeInstance,msg){var f,obj={dataList:jspb.Message.toObjectList(msg.getDataList(),proto.ctpfront.proto.Word.toObject,includeInstance)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.Dictionary}
 */proto.ctpfront.proto.Dictionary.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.Dictionary();return proto.ctpfront.proto.Dictionary.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.Dictionary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.Dictionary}
 */proto.ctpfront.proto.Dictionary.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new proto.ctpfront.proto.Word();reader.readMessage(value,proto.ctpfront.proto.Word.deserializeBinaryFromReader);msg.addData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.Dictionary.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.Dictionary.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.Dictionary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.Dictionary.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getDataList();if(f.length>0){writer.writeRepeatedMessage(1,f,proto.ctpfront.proto.Word.serializeBinaryToWriter);}};/**
 * repeated Word data = 1;
 * @return {!Array.<!proto.ctpfront.proto.Word>}
 */proto.ctpfront.proto.Dictionary.prototype.getDataList=function(){return(/** @type{!Array.<!proto.ctpfront.proto.Word>} */jspb.Message.getRepeatedWrapperField(this,proto.ctpfront.proto.Word,1));};/** @param {!Array.<!proto.ctpfront.proto.Word>} value */proto.ctpfront.proto.Dictionary.prototype.setDataList=function(value){jspb.Message.setRepeatedWrapperField(this,1,value);};/**
 * @param {!proto.ctpfront.proto.Word=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ctpfront.proto.Word}
 */proto.ctpfront.proto.Dictionary.prototype.addData=function(opt_value,opt_index){return jspb.Message.addToRepeatedWrapperField(this,1,opt_value,proto.ctpfront.proto.Word,opt_index);};proto.ctpfront.proto.Dictionary.prototype.clearDataList=function(){this.setDataList([]);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.LangPack=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.LangPack,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.LangPack.displayName='proto.ctpfront.proto.LangPack';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.LangPack.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.LangPack.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.LangPack} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.LangPack.toObject=function(includeInstance,msg){var f,obj={dictionary:(f=msg.getDictionary())&&proto.ctpfront.proto.Dictionary.toObject(includeInstance,f),manualSite:jspb.Message.getFieldWithDefault(msg,2,""),timestamp:jspb.Message.getFieldWithDefault(msg,3,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.LangPack}
 */proto.ctpfront.proto.LangPack.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.LangPack();return proto.ctpfront.proto.LangPack.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.LangPack} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.LangPack}
 */proto.ctpfront.proto.LangPack.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new proto.ctpfront.proto.Dictionary();reader.readMessage(value,proto.ctpfront.proto.Dictionary.deserializeBinaryFromReader);msg.setDictionary(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setManualSite(value);break;case 3:var value=/** @type {string} */reader.readString();msg.setTimestamp(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.LangPack.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.LangPack.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.LangPack} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.LangPack.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getDictionary();if(f!=null){writer.writeMessage(1,f,proto.ctpfront.proto.Dictionary.serializeBinaryToWriter);}f=message.getManualSite();if(f.length>0){writer.writeString(2,f);}f=message.getTimestamp();if(f.length>0){writer.writeString(3,f);}};/**
 * optional Dictionary dictionary = 1;
 * @return {?proto.ctpfront.proto.Dictionary}
 */proto.ctpfront.proto.LangPack.prototype.getDictionary=function(){return(/** @type{?proto.ctpfront.proto.Dictionary} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.Dictionary,1));};/** @param {?proto.ctpfront.proto.Dictionary|undefined} value */proto.ctpfront.proto.LangPack.prototype.setDictionary=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.LangPack.prototype.clearDictionary=function(){this.setDictionary(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.LangPack.prototype.hasDictionary=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional string manual_site = 2;
 * @return {string}
 */proto.ctpfront.proto.LangPack.prototype.getManualSite=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.LangPack.prototype.setManualSite=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * optional string timestamp = 3;
 * @return {string}
 */proto.ctpfront.proto.LangPack.prototype.getTimestamp=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,3,""));};/** @param {string} value */proto.ctpfront.proto.LangPack.prototype.setTimestamp=function(value){jspb.Message.setProto3StringField(this,3,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.GetLangReq=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.GetLangReq,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.GetLangReq.displayName='proto.ctpfront.proto.GetLangReq';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.GetLangReq.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.GetLangReq.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.GetLangReq} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.GetLangReq.toObject=function(includeInstance,msg){var f,obj={module:jspb.Message.getFieldWithDefault(msg,1,""),lang:jspb.Message.getFieldWithDefault(msg,2,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.GetLangReq}
 */proto.ctpfront.proto.GetLangReq.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.GetLangReq();return proto.ctpfront.proto.GetLangReq.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.GetLangReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.GetLangReq}
 */proto.ctpfront.proto.GetLangReq.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setModule(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setLang(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.GetLangReq.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.GetLangReq.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.GetLangReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.GetLangReq.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getModule();if(f.length>0){writer.writeString(1,f);}f=message.getLang();if(f.length>0){writer.writeString(2,f);}};/**
 * optional string module = 1;
 * @return {string}
 */proto.ctpfront.proto.GetLangReq.prototype.getModule=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.GetLangReq.prototype.setModule=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string lang = 2;
 * @return {string}
 */proto.ctpfront.proto.GetLangReq.prototype.getLang=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.GetLangReq.prototype.setLang=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.GetLangRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.GetLangRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.GetLangRsp.displayName='proto.ctpfront.proto.GetLangRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.GetLangRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.GetLangRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.GetLangRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.GetLangRsp.toObject=function(includeInstance,msg){var f,obj={request:(f=msg.getRequest())&&proto.ctpfront.proto.GetLangReq.toObject(includeInstance,f),error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.LangPack.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.GetLangRsp}
 */proto.ctpfront.proto.GetLangRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.GetLangRsp();return proto.ctpfront.proto.GetLangRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.GetLangRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.GetLangRsp}
 */proto.ctpfront.proto.GetLangRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new proto.ctpfront.proto.GetLangReq();reader.readMessage(value,proto.ctpfront.proto.GetLangReq.deserializeBinaryFromReader);msg.setRequest(value);break;case 2:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 3:var value=new proto.ctpfront.proto.LangPack();reader.readMessage(value,proto.ctpfront.proto.LangPack.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.GetLangRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.GetLangRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.GetLangRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.GetLangRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getRequest();if(f!=null){writer.writeMessage(1,f,proto.ctpfront.proto.GetLangReq.serializeBinaryToWriter);}f=message.getError();if(f!=null){writer.writeMessage(2,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(3,f,proto.ctpfront.proto.LangPack.serializeBinaryToWriter);}};/**
 * optional GetLangReq request = 1;
 * @return {?proto.ctpfront.proto.GetLangReq}
 */proto.ctpfront.proto.GetLangRsp.prototype.getRequest=function(){return(/** @type{?proto.ctpfront.proto.GetLangReq} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.GetLangReq,1));};/** @param {?proto.ctpfront.proto.GetLangReq|undefined} value */proto.ctpfront.proto.GetLangRsp.prototype.setRequest=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.GetLangRsp.prototype.clearRequest=function(){this.setRequest(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.GetLangRsp.prototype.hasRequest=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.GetLangRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,2));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.GetLangRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.GetLangRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.GetLangRsp.prototype.hasError=function(){return jspb.Message.getField(this,2)!=null;};/**
 * optional LangPack data = 3;
 * @return {?proto.ctpfront.proto.LangPack}
 */proto.ctpfront.proto.GetLangRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.LangPack} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.LangPack,3));};/** @param {?proto.ctpfront.proto.LangPack|undefined} value */proto.ctpfront.proto.GetLangRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,3,value);};proto.ctpfront.proto.GetLangRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.GetLangRsp.prototype.hasData=function(){return jspb.Message.getField(this,3)!=null;};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.License=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.License,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.License.displayName='proto.ctpfront.proto.License';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.License.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.License.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.License} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.License.toObject=function(includeInstance,msg){var f,obj={license:jspb.Message.getFieldWithDefault(msg,1,""),timestamp:jspb.Message.getFieldWithDefault(msg,2,"")};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.License}
 */proto.ctpfront.proto.License.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.License();return proto.ctpfront.proto.License.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.License} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.License}
 */proto.ctpfront.proto.License.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=/** @type {string} */reader.readString();msg.setLicense(value);break;case 2:var value=/** @type {string} */reader.readString();msg.setTimestamp(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.License.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.License.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.License} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.License.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getLicense();if(f.length>0){writer.writeString(1,f);}f=message.getTimestamp();if(f.length>0){writer.writeString(2,f);}};/**
 * optional string license = 1;
 * @return {string}
 */proto.ctpfront.proto.License.prototype.getLicense=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,1,""));};/** @param {string} value */proto.ctpfront.proto.License.prototype.setLicense=function(value){jspb.Message.setProto3StringField(this,1,value);};/**
 * optional string timestamp = 2;
 * @return {string}
 */proto.ctpfront.proto.License.prototype.getTimestamp=function(){return(/** @type {string} */jspb.Message.getFieldWithDefault(this,2,""));};/** @param {string} value */proto.ctpfront.proto.License.prototype.setTimestamp=function(value){jspb.Message.setProto3StringField(this,2,value);};/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */proto.ctpfront.proto.GetLangLicenseRsp=function(opt_data){jspb.Message.initialize(this,opt_data,0,-1,null,null);};goog.inherits(proto.ctpfront.proto.GetLangLicenseRsp,jspb.Message);if(goog.DEBUG&&!COMPILED){proto.ctpfront.proto.GetLangLicenseRsp.displayName='proto.ctpfront.proto.GetLangLicenseRsp';}if(jspb.Message.GENERATE_TO_OBJECT){/**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */proto.ctpfront.proto.GetLangLicenseRsp.prototype.toObject=function(opt_includeInstance){return proto.ctpfront.proto.GetLangLicenseRsp.toObject(opt_includeInstance,this);};/**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ctpfront.proto.GetLangLicenseRsp} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */proto.ctpfront.proto.GetLangLicenseRsp.toObject=function(includeInstance,msg){var f,obj={request:(f=msg.getRequest())&&proto.ctpfront.proto.GetLangReq.toObject(includeInstance,f),error:(f=msg.getError())&&Object_pb.Error.toObject(includeInstance,f),data:(f=msg.getData())&&proto.ctpfront.proto.License.toObject(includeInstance,f)};if(includeInstance){obj.$jspbMessageInstance=msg;}return obj;};}/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ctpfront.proto.GetLangLicenseRsp}
 */proto.ctpfront.proto.GetLangLicenseRsp.deserializeBinary=function(bytes){var reader=new jspb.BinaryReader(bytes);var msg=new proto.ctpfront.proto.GetLangLicenseRsp();return proto.ctpfront.proto.GetLangLicenseRsp.deserializeBinaryFromReader(msg,reader);};/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ctpfront.proto.GetLangLicenseRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ctpfront.proto.GetLangLicenseRsp}
 */proto.ctpfront.proto.GetLangLicenseRsp.deserializeBinaryFromReader=function(msg,reader){while(reader.nextField()){if(reader.isEndGroup()){break;}var field=reader.getFieldNumber();switch(field){case 1:var value=new proto.ctpfront.proto.GetLangReq();reader.readMessage(value,proto.ctpfront.proto.GetLangReq.deserializeBinaryFromReader);msg.setRequest(value);break;case 2:var value=new Object_pb.Error();reader.readMessage(value,Object_pb.Error.deserializeBinaryFromReader);msg.setError(value);break;case 3:var value=new proto.ctpfront.proto.License();reader.readMessage(value,proto.ctpfront.proto.License.deserializeBinaryFromReader);msg.setData(value);break;default:reader.skipField();break;}}return msg;};/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */proto.ctpfront.proto.GetLangLicenseRsp.prototype.serializeBinary=function(){var writer=new jspb.BinaryWriter();proto.ctpfront.proto.GetLangLicenseRsp.serializeBinaryToWriter(this,writer);return writer.getResultBuffer();};/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ctpfront.proto.GetLangLicenseRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */proto.ctpfront.proto.GetLangLicenseRsp.serializeBinaryToWriter=function(message,writer){var f=undefined;f=message.getRequest();if(f!=null){writer.writeMessage(1,f,proto.ctpfront.proto.GetLangReq.serializeBinaryToWriter);}f=message.getError();if(f!=null){writer.writeMessage(2,f,Object_pb.Error.serializeBinaryToWriter);}f=message.getData();if(f!=null){writer.writeMessage(3,f,proto.ctpfront.proto.License.serializeBinaryToWriter);}};/**
 * optional GetLangReq request = 1;
 * @return {?proto.ctpfront.proto.GetLangReq}
 */proto.ctpfront.proto.GetLangLicenseRsp.prototype.getRequest=function(){return(/** @type{?proto.ctpfront.proto.GetLangReq} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.GetLangReq,1));};/** @param {?proto.ctpfront.proto.GetLangReq|undefined} value */proto.ctpfront.proto.GetLangLicenseRsp.prototype.setRequest=function(value){jspb.Message.setWrapperField(this,1,value);};proto.ctpfront.proto.GetLangLicenseRsp.prototype.clearRequest=function(){this.setRequest(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.GetLangLicenseRsp.prototype.hasRequest=function(){return jspb.Message.getField(this,1)!=null;};/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */proto.ctpfront.proto.GetLangLicenseRsp.prototype.getError=function(){return(/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this,Object_pb.Error,2));};/** @param {?proto.proto.Error|undefined} value */proto.ctpfront.proto.GetLangLicenseRsp.prototype.setError=function(value){jspb.Message.setWrapperField(this,2,value);};proto.ctpfront.proto.GetLangLicenseRsp.prototype.clearError=function(){this.setError(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.GetLangLicenseRsp.prototype.hasError=function(){return jspb.Message.getField(this,2)!=null;};/**
 * optional License data = 3;
 * @return {?proto.ctpfront.proto.License}
 */proto.ctpfront.proto.GetLangLicenseRsp.prototype.getData=function(){return(/** @type{?proto.ctpfront.proto.License} */jspb.Message.getWrapperField(this,proto.ctpfront.proto.License,3));};/** @param {?proto.ctpfront.proto.License|undefined} value */proto.ctpfront.proto.GetLangLicenseRsp.prototype.setData=function(value){jspb.Message.setWrapperField(this,3,value);};proto.ctpfront.proto.GetLangLicenseRsp.prototype.clearData=function(){this.setData(undefined);};/**
 * Returns whether this field is set.
 * @return {!boolean}
 */proto.ctpfront.proto.GetLangLicenseRsp.prototype.hasData=function(){return jspb.Message.getField(this,3)!=null;};goog.object.extend(exports,proto.ctpfront.proto);

/***/ }),

/***/ "NYxO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("muBx"))(3);

/***/ }),

/***/ "O0G5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__art_Model_js__ = __webpack_require__("Dswc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__ = __webpack_require__("6uOh");




////////////////////////////////////////////////////////////////////////////////
// 模型：业务数据模型，用于业务逻辑处理，并为视图提供数据。
var model = {}; // 导出
model.task = {}; // 任务管理
model.capital = new __WEBPACK_IMPORTED_MODULE_1__art_Model_js__["a" /* default */].OneModel(); // 资金信息
model.orderSet = new __WEBPACK_IMPORTED_MODULE_1__art_Model_js__["a" /* default */].SetModel(); // 委托信息
model.cancelOrderSet = new __WEBPACK_IMPORTED_MODULE_1__art_Model_js__["a" /* default */].SetModel(); // 撤单信息
model.tradeSet = new __WEBPACK_IMPORTED_MODULE_1__art_Model_js__["a" /* default */].SeqModel(); // 成交信息
model.positionSet = new __WEBPACK_IMPORTED_MODULE_1__art_Model_js__["a" /* default */].SetModel(); // 持仓信息
model.dominantSet = null; // 主力合约
model.onError = null;
/* harmony default export */ __webpack_exports__["a"] = (model);

////////////////////////////////////////////////////////////////////////////////
var inner = {}; // 私有数据


////////////////////////////////////////////////////////////////////////////////
model.error = function (e) {
    if (model.onError instanceof Function) {
        model.onError(e);
    }
};
model.onRsp = function (data, error) {
    model.error(error);
};

// 登录后清空数据模型信息，需要重新获取。
model.release = function () {
    model.capital.reset();
    model.orderSet.reset();
    model.cancelOrderSet.reset();
    model.tradeSet.reset();
    model.positionSet.reset();
    model.onError = null;
    model.dominantSet = null;
    model.trader.release();
    if (false) console.log("model.release");
};

////////////////////////////////////////////////////////////////////////////////
model.trader = {};
model.trader.queue_price_mode = 0; // 挂单价
model.trader.match_price_mode = 1; // 对手价
model.trader.latest_price_mode = 2; // 最新价
model.trader.market_price_mode = 3; // 市价
model.trader.extend_price_mode = 4; // 超价
// 数据信息
inner.trader = {};
inner.trader.todayPosition = [];
inner.trader.todayOrder = {};

// 交易.初始化
model.trader.init = function (onError) {
    model.onError = onError;
    model.trader.queryCapital.start();
    model.trader.position.subTick();
};
// 交易.释放
model.trader.release = function () {
    inner.trader.todayOrder = {};
    inner.trader.todayPosition = [];
    model.trader.queryCapital.stop();
    model.trader.position.unsubTick();
};

//##############################################################################
////////////////////////////////////////////////////////////////////////////////
// 开始定时任务-每2秒查询查询资金账户。
model.trader.queryCapital = {};
model.trader.queryCapital.interval = 3000;
model.trader.queryCapital.start = function () {
    if (!model.trader.queryCapital.state) {
        var run = function run() {
            __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].queryCapital(function (capital, error) {
                if (error !== undefined) {
                    console.error(error.message);
                } else {
                    model.capital.update(capital);
                }
            });
        };
        run(); // 先查询一次，再循环定时器。
        model.trader.queryCapital.timer = setInterval(run, model.trader.queryCapital.interval);
        model.trader.queryCapital.state = true;
    }
};
// 停止定时任务
model.trader.queryCapital.stop = function () {
    if (model.trader.queryCapital.timer !== undefined) {
        clearInterval(model.trader.queryCapital.timer);
    }
    model.trader.queryCapital.state = false;
};

//##############################################################################
////////////////////////////////////////////////////////////////////////////////
// 交易.委托持仓，用于计算保存委托今日持仓。
inner.trader.TodayPosition = function (targetId, direct) {
    this.targetId = targetId;
    this.direction = direct;
    this.frozenLastVolume = 0;
    this.frozenTodayVolume = 0;
};

////////////////////////////////////////////////////////////////////////////////
// 交易.发布委托。
inner.trader.matchTodayPosition = function (targetId, direct, offset) {
    for (var i = 0; i < inner.trader.todayPosition.length; ++i) {
        var pos = inner.trader.todayPosition[i];
        if (pos.targetId == targetId) {
            if (pos.direction == direct && offset == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].offset_open || pos.direction != direct && offset != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].offset_open) {
                return pos;
            }
        }
    }
};

////////////////////////////////////////////////////////////////////////////////
// 交易.发布委托。
inner.trader.findTodayPosition = function (targetId, direct) {
    for (var i = 0; i < inner.trader.todayPosition.length; ++i) {
        var pos = inner.trader.todayPosition[i];
        if (pos.targetId == targetId && pos.direction == direct) {
            return pos;
        }
    }
};

////////////////////////////////////////////////////////////////////////////////
// 交易.发布委托。
model.trader.onOrder = function (order) {
    // 统计今日平仓信息，过滤错单等非法状态的委托
    if (order.state != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_accepted && order.state != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_part_canceled && order.state != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_all_canceled && order.state != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_part_traded && order.state != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_all_traded && order.state != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_error) {
        return;
    }
    order.id = order.orderRef + "#" + order.orderId;
    model.orderSet.update(order);
    if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_accepted || order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_part_traded) {
        model.cancelOrderSet.update(order);
    }
    if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_part_canceled || order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_all_canceled || order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_all_traded || order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_error) {
        model.cancelOrderSet.remove(order.id);
    }

    // 显示反馈信息
    if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_error) {
        var text = __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].textOrderState(order.state) + " " + order.targetId + " " + order.stateDetail;
    } else {
        var text = __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].textOrderState(order.state) + " " + __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].textDirectionOffSet(order.direction, order.offset) + " " + order.targetId + " " + order.volume + "手 " + order.price.toFixed(1);
    }
    if (model.notify instanceof Function) {
        model.notify(text);
    }

    // 根据状态计算冻结持仓。
    var frozenChange = 0;
    var old = inner.trader.todayOrder[order.id];
    if (old === undefined) {
        // 委托不存在
        if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_accepted) {
            // 未成交
            frozenChange = order.volume;
        } else if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_part_traded) {
            // 部分成交
            frozenChange = order.volume - order.tradedVolume;
        } else if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_all_traded) {
            // 全部成交
            frozenChange = 0;
        }
    }
    // 避免委托重复推送导致的错误：1.检测旧单子是否已完成。
    else if (old.state != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_all_canceled && old.state != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_all_traded && old.state != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_part_canceled && old.state != __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_error) {
            if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_part_traded) {
                // 部分成交
                frozenChange = order.tradedVolume - old.tradedVolume;
            } else if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_all_traded) {
                // 全部成交
                frozenChange = order.tradedVolume - old.tradedVolume;
            } else if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_part_canceled) {
                // 部分撤单
                frozenChange = order.volume - old.tradedVolume;
            } else if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_all_canceled) {
                // 全部撤单
                frozenChange = order.volume;
            } else if (order.state == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].order_error) {
                // 错单（场景：易盛先接收再错单）
                frozenChange = order.volume;
            }
            frozenChange *= -1;
        }
    if (frozenChange == 0) {
        // 忽略未变化
        return;
    }
    inner.trader.todayOrder[order.id] = order;

    // 统计今日持仓
    if (order.offset == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].offset_close || order.offset == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].offset_close_last || order.offset == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].offset_close_today) {
        // 注意平仓委托的方向与其冻结持仓的方向相反。
        var rdirect = __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].getReverseDirection(order.direction);
        var posDirect = __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].getPositionDirection(rdirect);
        var pos = inner.trader.findTodayPosition(order.targetId, posDirect);
        if (pos === undefined) {
            pos = new inner.trader.TodayPosition(order.targetId, posDirect);
            inner.trader.todayPosition.push(pos);
        }
        if (order.offset == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].offset_close_last) {
            pos.frozenLastVolume += frozenChange;
        } else {
            pos.frozenTodayVolume += frozenChange;
        }
        model.trader.position.computeByTodayPosition(pos); // 更新持仓信息
    }
};

////////////////////////////////////////////////////////////////////////////////
// 交易.发布成交。
model.trader.onTrade = function (trade, query_position) {
    model.tradeSet.update(trade);
    // 页面加载持仓后再查询，避免频闪。
    // 延迟500毫秒发送，因为后台持仓数据会晚于成交推送。
    if (query_position) {
        setTimeout(function () {
            model.trader.position.query(undefined, undefined, 3000);
        }, 200);
    }

    // 显示反馈信息
    var text = "[成交] " + __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].textDirectionOffSet(trade.direction, trade.offset) + " " + trade.targetId + " " + trade.volume + "手 " + trade.price.toFixed(1);
    if (model.notify instanceof Function) {
        model.notify(text);
    }
};

//##############################################################################
////////////////////////////////////////////////////////////////////////////////
// 交易.查询持仓信息。
model.trader.position = {};
model.trader.position.tickSet = {};
model.trader.position.state = false;
model.trader.position.query = function (resolve, reject, millsec) {
    var positionSet = [];
    __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].queryPosition("", function (pos, last) {
        if (pos) {
            var volume = pos.todayVolume + pos.lastVolume;
            if (volume > 0) {
                // 过滤数量为空的持仓
                pos.id = positionSet.length;
                positionSet.push(pos);
            }
        }
        if (last) {
            model.trader.position.computePosition(positionSet);
            model.trader.position.subTick(true);
            if (resolve instanceof Function) resolve();
            if (false) console.log("position ok");
        }
    }, function (error) {
        if (resolve instanceof Function) reject(error);
    }, millsec);
};

////////////////////////////////////////////////////////////////////////////////
// 订阅持仓合约，用于实时计算持仓。
model.trader.position.subTick = function (sub_by_state) {
    if (sub_by_state && !model.trader.position.state) {
        return;
    }
    model.trader.position.state = true;
    for (var i = 0; i < model.positionSet.array.length; ++i) {
        var pos = model.positionSet.array[i];
        __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].subTick(pos.targetId, {
            suberId: "position",
            reject: model.onRsp,
            resovle: model.onRsp,
            publish: function publish(tick) {
                model.trader.position.tickSet[tick.targetId] = tick;
                model.trader.position.computeByMarket(tick);
            }
        });
    }
};
model.trader.position.unsubTick = function () {
    for (var i = 0; i < model.positionSet.array.length; ++i) {
        var pos = model.positionSet.array[i];
        __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].unsubTick(pos.targetId, "position");
    }
    model.trader.position.state = false;
};

////////////////////////////////////////////////////////////////////////////////
// 交易.全部平仓
model.trader.position.closeAll = function () {
    // 平掉全部仓位
    var orders = [];
    for (var i = 0; i < model.positionSet.array.length; ++i) {
        var pos = model.positionSet.array[i];
        var volume = pos.todayVolume + pos.lastVolume;
        // 检查所有行情，若有值以市价平仓
        var tick = model.trader.position.tickSet[pos.targetId];
        if (tick) {
            var price = __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].getCloseOrderDirection(pos.direction) == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].direct_sell ? tick.lowStopPrice : tick.highStopPrice;
            __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].getCloseOrderSet(orders, pos, volume, price);
        }
    }
    return orders;
};

////////////////////////////////////////////////////////////////////////////////
// 交易.查找持仓信息。
model.trader.position.find = function (targetId, direct) {
    for (var i = 0; i < model.positionSet.array.length; ++i) {
        var pos = model.positionSet.array[i];
        if (pos.targetId == targetId && pos.direction == direct) {
            return pos;
        }
    }
};

////////////////////////////////////////////////////////////////////////////////
// 交易.计算持仓信息：今仓冻结/可用数量。
model.trader.position.computePosition = function (positionSet) {
    for (var i = 0; i < positionSet.length; ++i) {
        var pos = positionSet[i];
        // 冻结/可用数量
        pos.frozenTodayVolume = 0;
        var todayPos = inner.trader.findTodayPosition(pos.targetId, pos.direction);
        if (todayPos !== undefined) {
            model.trader.position.updatePositionVolume(pos, todayPos);
        }
        // 计算持仓盈亏
        var tick = model.trader.position.tickSet[pos.targetId];
        if (tick !== undefined) {
            model.trader.position.updatePositionProfit(pos, tick);
        }
    }
    model.positionSet.load(positionSet);
};
// 交易.计算持仓信息：今仓冻结/总冻结/可用数量。
model.trader.position.updatePositionVolume = function (pos, todayPos) {
    pos.frozenVolume = todayPos.frozenTodayVolume + todayPos.frozenLastVolume;
    pos.frozenTodayVolume = todayPos.frozenTodayVolume;
};
model.trader.position.computeByTodayPosition = function (todayPos) {
    var pos = model.trader.position.find(todayPos.targetId, todayPos.direction);
    if (pos !== undefined) {
        model.trader.position.updatePositionVolume(pos, todayPos);
        model.positionSet.update(pos);
    }
};
// 交易.计算持仓信息：持仓盈亏。
model.trader.position.updatePositionProfit = function (pos, tick) {
    var volume = pos.todayVolume + pos.lastVolume;
    var value = pos.multiple * volume * tick.latestPrice;
    if (pos.direction == __WEBPACK_IMPORTED_MODULE_2__CtpFront_js__["a" /* default */].pos_direct_short) {
        pos.positionProfit = pos.cost - value;
    } else {
        pos.positionProfit = value - pos.cost;
    }
};
model.trader.position.computeByMarket = function (tick) {
    for (var i = 0; i < model.positionSet.array.length; ++i) {
        var pos = model.positionSet.array[i];
        if (pos.targetId == tick.targetId) {
            model.trader.position.updatePositionProfit(pos, tick);
            model.positionSet.update(pos);
        }
    }
};

/***/ }),

/***/ "PdHo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PeJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_RechargeRecord_ts__ = __webpack_require__("btb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_384683ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RechargeRecord_vue__ = __webpack_require__("0zjJ");
function injectStyle (ssrContext) {
  __webpack_require__("MTI1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-384683ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_RechargeRecord_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_384683ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RechargeRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q1OM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var TargetKeyboard = (function (_super) {
    __extends(TargetKeyboard, _super);
    function TargetKeyboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sumExchangeName = ['自选', '上期所', '上期能源', '大商所', '郑商所', '中金所', '广期所'];
        _this.contractData = [];
        _this.currentExchangeName = '自选';
        _this.currentProductId = '';
        _this.selectFage = true;
        return _this;
    }
    Object.defineProperty(TargetKeyboard.prototype, "selectTarget", {
        get: function () {
            return this.$store.state.selectTargets;
        },
        enumerable: true,
        configurable: true
    });
    TargetKeyboard.prototype.mounted = function () {
        this.loader_key();
    };
    TargetKeyboard.prototype.choiceProduceId = function (productId) {
        this.currentProductId = productId;
    };
    TargetKeyboard.prototype.choiceTargetId = function (targetId) {
        this.passValueToP(targetId);
    };
    TargetKeyboard.prototype.choiceExchangeName = function (item) {
        this.currentExchangeName = item;
        if (item === '上期所') {
            this.selectFage = true;
            this.currentProductId = 'ag';
        }
        else if (item === '大商所') {
            this.selectFage = true;
            this.currentProductId = 'a';
        }
        else if (item === '郑商所') {
            this.selectFage = true;
            this.currentProductId = 'AP';
        }
        else if (item === '中金所') {
            this.selectFage = true;
            this.currentProductId = 'IC';
        }
        else if (item === '上期能源') {
            this.selectFage = true;
            this.currentProductId = 'sc';
        }
        else if (item === '广期所') {
            this.selectFage = true;
            this.currentProductId = 'si';
        }
        else if (item === '自选') {
            this.selectFage = false;
            this.currentProductId = '';
        }
    };
    TargetKeyboard.prototype.loader_key = function () {
        this.contractData = __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].targetList;
        this.selectFage = false;
    };
    TargetKeyboard.prototype.handleClose = function () {
        this.$emit('close');
    };
    TargetKeyboard.prototype.passValueToP = function (targetId) {
        this.$emit('submit', targetId);
        this.$emit('close');
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], TargetKeyboard.prototype, "exclude", void 0);
    TargetKeyboard = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'TargetKeyboard',
        })
    ], TargetKeyboard);
    return TargetKeyboard;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (TargetKeyboard);


/***/ }),

/***/ "Q29T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__ = __webpack_require__("WvhM");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var NumKeyboard = (function (_super) {
    __extends(NumKeyboard, _super);
    function NumKeyboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.price = '';
        _this.priceTickss = '';
        _this.decimalsBoolean = false;
        _this.decimals = '';
        return _this;
    }
    Object.defineProperty(NumKeyboard.prototype, "priceT", {
        get: function () {
            return this.$store.state.priceTick.priceTick;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumKeyboard.prototype, "priceFlage", {
        get: function () {
            return this.$store.state.keyBoard.priceFlage;
        },
        enumerable: true,
        configurable: true
    });
    NumKeyboard.prototype.changePrice = function (tick, old) {
        this.priceTickss = tick;
        this.decimals = __WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__["a" /* default */].digit(this.priceTickss);
        if (this.decimals === 0) {
            this.decimalsBoolean = true;
        }
        else {
            this.decimalsBoolean = false;
        }
    };
    NumKeyboard.prototype.selectPriceType = function (news, old) {
        this.price = news;
    };
    NumKeyboard.prototype.inputPrice = function (news, old) {
        this.price = news;
    };
    NumKeyboard.prototype.setValue = function (v) {
        if (typeof v === 'number') {
            v = v.toFixed(this.decimals);
        }
        if (this.isInteger) {
            v = v.replace(/\..*/, '');
        }
        this.$emit('input', v);
    };
    NumKeyboard.prototype.getValue = function () {
        if (Number(this.price)) {
            return this.price + '';
        }
        else {
            return '0';
        }
    };
    NumKeyboard.prototype.mounted = function () {
        this.price = this.value;
        this.priceTickss = this.priceT;
        this.decimals = __WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__["a" /* default */].digit(this.priceTickss);
        if (this.decimals === 0) {
            this.decimalsBoolean = true;
        }
        else {
            this.decimalsBoolean = false;
        }
    };
    NumKeyboard.prototype.handleClose = function () {
        this.$emit('close');
    };
    NumKeyboard.prototype.handleClick = function (targetId) {
        this.$emit('submit', targetId);
        this.$emit('close');
    };
    NumKeyboard.prototype.orderInput = function (num) {
        switch (String(num)) {
            case '.':
                this._handleDecimalPoint();
                break;
            case 'add':
                this._handleAddKey();
                break;
            case 'reduce':
                this._handleReduceKey();
                break;
            case 'delete':
                this._handleDeleteKey();
                break;
            default:
                this._handleNumberKey(num);
                break;
        }
    };
    NumKeyboard.prototype._handleDecimalPoint = function () {
        var value = this.getValue();
        if (this.decimalsBoolean) {
            return;
        }
        if (value.indexOf('.') > -1) {
            return false;
        }
        if (!value.length) {
            value = '0.';
        }
        else {
            value = value + '.';
        }
        this.setValue(value);
    };
    NumKeyboard.prototype._handleAddKey = function () {
        this.priceTickss = this.priceTickss ? this.priceTickss : 1;
        var value = 0;
        if (!this.isInteger) {
            if (parseFloat(this.getValue())) {
                value = parseFloat(this.getValue()) + Number(this.priceTickss);
                if (isNaN(value)) {
                    value = 1;
                }
            }
            else {
                value =
                    Number(this.boardPrice) + Number(this.priceTickss);
            }
        }
        else {
            if (!this.value && Number(this.value) !== 0) {
                value = 1;
            }
            else {
                if (parseFloat(this.getValue()) || parseFloat(this.getValue()) === 0) {
                    value = parseFloat(this.getValue()) + 1;
                }
                else {
                    value = Number(this.boardPrice) + 1;
                }
            }
        }
        this.setValue(value);
    };
    NumKeyboard.prototype._handleReduceKey = function () {
        this.priceTickss = this.priceTickss ? this.priceTickss : 1;
        var value = 0;
        if (!this.isInteger) {
            value = parseFloat(this.getValue()) ?
                parseFloat(this.getValue()) - Number(this.priceTickss) :
                Number(this.boardPrice) - Number(this.priceTickss);
        }
        else {
            value = parseFloat(this.getValue()) ?
                parseFloat(this.getValue()) - 1 :
                Number(this.boardPrice) - 1;
        }
        if (isNaN(value)) {
            value = 0;
        }
        if (value < 0) {
            value = 0;
        }
        this.setValue(value);
    };
    NumKeyboard.prototype._handleDeleteKey = function () {
        if (!this.value) {
            return;
        }
        var S = this.getValue();
        if (!S.length) {
            return false;
        }
        var value = S.substring(0, S.length - 1);
        this.setValue(value);
    };
    NumKeyboard.prototype._handleClearKey = function () {
        this.setValue('');
    };
    NumKeyboard.prototype._handleNumberKey = function (num) {
        var S = this.getValue();
        var value = S;
        if (S.indexOf('.') > -1 && S.substring(S.indexOf('.') + 1).length < this.decimals) {
            value = S + num;
        }
        if ((S.indexOf('.') === -1)) {
            if (num == 0 && S.length == 0) {
                value = '';
            }
            else {
                value = S.replace(/^0+/, '') + num;
            }
        }
        if (value.length > 13) {
            value = value.slice(0, 13);
        }
        if (!this.priceFlage) {
            value = num + '';
            this.$store.commit('keyBoard/changePriceFlage', true);
        }
        this.setValue(value);
    };
    NumKeyboard.prototype._handleConfirmKey = function () {
        this.$emit('close');
        var S = this.getValue();
        if (!S.length) {
            return false;
        }
        if (S.indexOf('.') > -1 && S.indexOf('.') === (S.length - 1)) {
            S = Number(S.substring(0, S.length - 1)).toFixed(this.decimals);
        }
        S = Number(S).toFixed(this.decimals);
        this.setValue(S);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])({ default: '' })
    ], NumKeyboard.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], NumKeyboard.prototype, "boardPrice", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], NumKeyboard.prototype, "title", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], NumKeyboard.prototype, "exclude", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])({ default: false })
    ], NumKeyboard.prototype, "isInteger", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])({ default: true })
    ], NumKeyboard.prototype, "showPriceType", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["b" /* Watch */])('priceT', { deep: true })
    ], NumKeyboard.prototype, "changePrice", null);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["b" /* Watch */])('boardPrice', { deep: true })
    ], NumKeyboard.prototype, "selectPriceType", null);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["b" /* Watch */])('value', { deep: true })
    ], NumKeyboard.prototype, "inputPrice", null);
    NumKeyboard = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], NumKeyboard);
    return NumKeyboard;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (NumKeyboard);


/***/ }),

/***/ "QcJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_yjheader__ = __webpack_require__("eR8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_proto_art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_Model_js__ = __webpack_require__("O0G5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_SubUtils__ = __webpack_require__("FcK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Condition_components_OnOff_OnOff__ = __webpack_require__("gGAs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__version_js__ = __webpack_require__("kB8h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "setPage",
  components: {
    yjheader: __WEBPACK_IMPORTED_MODULE_0__components_common_yjheader__["a" /* default */],
    onoff: __WEBPACK_IMPORTED_MODULE_5__views_Condition_components_OnOff_OnOff__["a" /* default */]
  },
  data: function data() {
    return {
      versions: '',
      flage: false,
      helpAddress: ''
    };
  },


  methods: {
    goBack: function goBack() {
      this.$router.push({ path: "/home/trade" });
    },
    lookHelp: function lookHelp() {
      this.flage = true;
    },
    changeword: function changeword() {
      this.$router.push('/ChangeWord');
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.versions = __WEBPACK_IMPORTED_MODULE_6__version_js__["b" /* version */];
    window.addEventListener('message', function (e) {
      // console.log(e.data);
      _this.flage = e.data;
    });
  },
  activated: function activated() {
    this.helpAddress = helpAddress;
  }
});

/***/ }),

/***/ "Qqht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trade-detail"},[_c('div',{staticClass:"headerWrapper"},[_c('div',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"goBack",on:{"tap":_vm.goBack}}),_vm._v(" "),_c('i',{staticClass:"icon iconfont left"},[_vm._v("")]),_vm._v(" "),_c('div',{staticClass:"right-wrapper"},[_c('div',{staticClass:"title-left fl"},[_c('span',[_vm._v(_vm._s(_vm.pageData.account.title))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"span-value"},[_vm._v(_vm._s(_vm.pageData.account.value))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"title-rigth fr"},[_c('span',[_vm._v(_vm._s(_vm.pageData.usable.title))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"span-value"},[_vm._v(_vm._s(_vm.pageData.usable.value))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"title-center"},[_c('span',[_vm._v(_vm._s(_vm.pageData.rights.title))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"span-value"},[_vm._v(_vm._s(_vm.pageData.rights.value))]),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('ul',_vm._l((_vm.menuData),function(item,index){return _c('li',{directives:[{name:"tap",rawName:"v-tap"}],key:index,on:{"tap":function($event){_vm.link(index)}}},[_c('i',{staticClass:"icon iconfont",domProps:{"innerHTML":_vm._s(item.tobarIcon)}}),_c('br'),_vm._v(" "),_c('span',{class:{tobarContent:_vm.isActive==index}},[_vm._v(_vm._s(item.tobarContent))])])}))]),_vm._v(" "),(_vm.isActive==0)?_c('div',{staticClass:"order-w-1"},[_c('div',{staticClass:"price-wrapper"},[_c('div',{directives:[{name:"tap",rawName:"v-tap"}],ref:"tbState",staticClass:"price-left",on:{"tap":function($event){_vm.tbState=true}}},[(!_vm.insertPage.targetId)?_c('span',[_c('i',{staticClass:"icon iconfont price-left-icon"},[_vm._v("")]),_vm._v("合约")]):_vm._e(),_vm._v(" "),(_vm.tbState||_vm.insertPage.targetId)?_c('span',[_vm._v(_vm._s(_vm.insertPage.targetId))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"icon iconfont price-c-1"},[_vm._v("")])]),_vm._v(" "),_c('span',[_vm._v("最新价"),_c('br'),_vm._v(" "),_c('i',{staticClass:"proces"},[_vm._v(_vm._s(_vm.insertPage.tick.latestPrice))])]),_vm._v(" "),_c('span',[_vm._v("买一"),_c('br'),_vm._v(" "),_c('i',{staticClass:"proces buy"},[_vm._v(_vm._s(_vm.insertPage.tick.bidPrice1))]),_c('br'),_vm._v(" "),_c('i',{staticClass:"proces buy"},[_vm._v(_vm._s(_vm.insertPage.tick.bidVolume1))])]),_vm._v(" "),_c('span',[_vm._v("卖一"),_c('br'),_vm._v(" "),_c('i',{staticClass:"proces selt"},[_vm._v(_vm._s(_vm.insertPage.tick.askPrice1))]),_c('br'),_vm._v(" "),_c('i',{staticClass:"proces selt"},[_vm._v(_vm._s(_vm.insertPage.tick.askVolume1))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"input-wrapper"},[_c('span',{staticClass:"imput"},[_c('i',{staticClass:"icon iconfont reduce"},[_vm._v("")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.insertPage.volume),expression:"insertPage.volume"}],ref:"xxxx",staticClass:"value",attrs:{"type":"text","placeholder":"请输入手数","readonly":"readonly","maxlength":"10"},domProps:{"value":(_vm.insertPage.volume)},on:{"focus":function($event){_vm.flage=true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.insertPage, "volume", $event.target.value)}}})]),_vm._v(" "),_c('span',{staticClass:"imput"},[_c('i',{staticClass:"icon iconfont reduce"},[_vm._v("")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.insertPage.inputPrice),expression:"insertPage.inputPrice"}],ref:"yyyy",staticClass:"value",attrs:{"type":"text","placeholder":_vm.insertPage.inputPriceHolder,"readonly":"readonly","maxlength":"13"},domProps:{"value":(_vm.insertPage.inputPrice)},on:{"focus":function($event){_vm.flage2=true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.insertPage, "inputPrice", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"input-wrapper place_wrapper"},_vm._l((_vm.orderButton),function(item,index){return _c('div',{key:index,staticClass:"place_oreder",style:(item.color),on:{"click":function($event){_vm.orderClick(index,item)},"touchstart":function($event){_vm.handleTouchStart(index, item)},"touchend":function($event){_vm.handleTouchEnd(index, item)}}},[_c('p',{ref:"changes",refInFor:true},[_vm._v(_vm._s(item.price))]),_vm._v(" "),_c('span'),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.text))])])})),_vm._v(" "),(_vm.sureOrder)?_c('div',{staticClass:"store-cx"},[_c('div',{staticClass:"store-cx-con"},[_c('h3',{staticClass:"tit"},[_vm._v("确认要下单吗？")]),_vm._v(" "),_c('hr',{staticStyle:{"background-color":"#26a2ff","height":"1px"}}),_vm._v(" "),_c('p',{staticClass:"store-con"},[_vm._v("\n            "+_vm._s(_vm.insertPage.targetId)+",\n            "+_vm._s(_vm.sele_deal)+",\n            "+_vm._s(_vm.closing)+",\n            价格"+_vm._s(_vm.insertPage.price)+",\n            手数"),(!_vm.quickFlage)?_c('span',[_vm._v(_vm._s(_vm.insertPage.volume))]):_c('span',[_vm._v(_vm._s(_vm.quickHandle))])]),_vm._v(" "),_c('div',{staticClass:"store-click"},[_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"store-cancel",on:{"tap":function($event){_vm.sureOrder=false}}},[_vm._v("取消")]),_vm._v(" "),_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"store-enter",on:{"tap":_vm.clickEvent}},[_vm._v("确定")])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"store-c-1"},_vm._l((_vm.menuTilte),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('div',{staticClass:"order_content"},_vm._l((_vm.menuValue),function(item,index){return _c('div',{key:index},[_c('div',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"store-c-2",class:{'sele_bg':_vm.insertPage.posSelect==item.id},on:{"tap":function($event){_vm.orderImfor(item.id)}}},[_c('span',[_vm._v(_vm._s(item.targetId))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.vol))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.closeOut))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.money))]),_vm._v(" "),_c('span',{class:{'or_color': item.loss >= 0,'green_color':item.loss<0}},[_vm._v(_vm._s(item.loss))])]),_vm._v(" "),_c('div',{class:['options',{showOptions: item.id == _vm.insertPage.posSelect}]},[_c('span',{on:{"click":function($event){_vm.quickBackhand(item)}}},[_vm._v("快捷反手")]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.shortcutPositions(item)}}},[_vm._v("快捷锁仓")]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.shortcutCloseOuts(item)}}},[_vm._v("快捷平仓")]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.condition(item)}}},[_vm._v("云条件单")]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.checkFullStop(item, index)}}},[_vm._v("止盈止损")])])])})),_vm._v(" "),(_vm.flage)?_c('NumKeyboard',{attrs:{"title":"最大可买手数:"+_vm.buyVol+"　　最大可卖手数:"+_vm.sellVol,"exclude":[_vm.$refs.xxxx],"isInteger":true},on:{"close":_vm.handleCloseKey},model:{value:(_vm.insertPage.volume),callback:function ($$v) {_vm.$set(_vm.insertPage, "volume", $$v)},expression:"insertPage.volume"}}):_vm._e(),_vm._v(" "),(_vm.flage2)?_c('TradeKeyboard',{attrs:{"tick":_vm.insertPage.tick,"exclude":[_vm.$refs.yyyy],"isInteger":false,"price":_vm.insertPage.inputPrice,"boardPrice":_vm.boardPrice,"priceType":_vm.insertPage.priceMode,"priceHolder":_vm.insertPage.inputPriceHolder},on:{"update:price":function($event){_vm.$set(_vm.insertPage, "inputPrice", $event)},"update:priceType":function($event){_vm.$set(_vm.insertPage, "priceMode", $event)},"update:priceHolder":function($event){_vm.$set(_vm.insertPage, "inputPriceHolder", $event)},"change":_vm.updateButtonPrice,"close":_vm.handleCloseKey2}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.isActive==1)?_c('div',{staticClass:"store-w-1"},[_c('div',{staticClass:"store-c-1"},_vm._l((_vm.menuTilte),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('div',{staticClass:"shadow2"},[_vm._l((_vm.menuValue),function(item,index){return _c('div',{key:index,staticClass:"store-c-2"},[_c('span',[_vm._v(_vm._s(item.targetId))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.vol))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.closeOut))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.money))]),_vm._v(" "),_c('span',{class:{'or_color': item.loss >= 0,'green_color':item.loss<0}},[_vm._v(_vm._s(item.loss))])])}),_vm._v(" "),(_vm.all_pc)?_c('div',{staticClass:"store-cx"},[_c('div',{staticClass:"store-cx-con"},[_c('h3',{staticClass:"all_tit"},[_vm._v("确认全部平仓吗？")]),_vm._v(" "),_c('div',{staticClass:"store-click"},[_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"store-cancel",on:{"tap":function($event){_vm.all_pc=false}}},[_vm._v("取消")]),_vm._v(" "),_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"store-enter",on:{"tap":_vm.all_pcs}},[_vm._v("确定")])],1)])]):_vm._e()],2),_vm._v(" "),_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"order",attrs:{"type":"primary"},on:{"tap":function($event){_vm.all_pc=true}}},[_vm._v(_vm._s(_vm.buttonTitle))])],1):_vm._e(),_vm._v(" "),(_vm.isActive==2)?_c('div',{staticClass:"store-w-1"},[_c('div',{staticClass:"store-c-1"},_vm._l((_vm.menuTilte),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('div',{staticClass:"cancel-order-wrapper"},_vm._l((_vm.cancelOrderValue),function(item,index){return _c('div',{directives:[{name:"tap",rawName:"v-tap"}],key:index,staticClass:"store-c-2",on:{"tap":function($event){_vm.show_cx(item,index)}}},[_vm._l((item),function(item2,index2){return _c('span',{key:index2},[_vm._v(_vm._s(item2))])}),_c('br')],2)})),_vm._v(" "),(_vm.data_cx)?_c('div',{staticClass:"store-cx"},[_c('div',{staticClass:"store-cx-con"},[_c('h3',{staticClass:"tit"},[_vm._v("确认撤单吗？")]),_vm._v(" "),_c('hr',{staticStyle:{"background-color":"#26a2ff","height":"1px"}}),_vm._v(" "),_c('p',{staticClass:"store-con"},[_vm._v(_vm._s(_vm.store_name)+","+_vm._s(_vm.store_type)+",委托价"+_vm._s(_vm.store_num2)),_c('br'),_vm._v("委托量"+_vm._s(_vm.store_num1)+",挂单量"+_vm._s(_vm.store_money)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"store-click"},[_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"store-cancel",on:{"tap":function($event){_vm.data_cx=false}}},[_vm._v("取消")]),_vm._v(" "),_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"store-enter",on:{"tap":_vm.sure_cd}},[_vm._v("确定")])],1)])]):_vm._e(),_vm._v(" "),(_vm.all_cx)?_c('div',{staticClass:"store-cx"},[_c('div',{staticClass:"store-cx-con"},[_c('h3',{staticClass:"all_tit"},[_vm._v("确认全部撤单吗？")]),_vm._v(" "),_c('div',{staticClass:"store-click"},[_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"store-cancel",on:{"tap":function($event){_vm.all_cx=false}}},[_vm._v("取消")]),_vm._v(" "),_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"store-enter",on:{"tap":_vm.all_cd}},[_vm._v("确定")])],1)])]):_vm._e(),_vm._v(" "),_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"order",attrs:{"type":"primary"},on:{"tap":function($event){_vm.all_cx=true}}},[_vm._v(_vm._s(_vm.buttonTitle))])],1):_vm._e(),_vm._v(" "),(_vm.isActive==3)?_c('div',{staticClass:"clearfix"},_vm._l((_vm.money),function(item,index){return _c('div',{key:index,staticClass:"money-w-1"},[_c('div',{staticClass:"money-c-1"},[_c('span',{staticClass:"money-c-2"},[_vm._v(_vm._s(index))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"money-c-value"},[_vm._v(_vm._s(item))])])])})):_vm._e(),_vm._v(" "),(_vm.isActive==4)?_c('div',{staticClass:"search"},[_c('div',{staticClass:"vessel"},[(_vm.buttonSearch)?_c('TradeSearch',{attrs:{"tableData":_vm.tradeMenuValue}}):_c('OrderSearch',{attrs:{"tableData":_vm.orderMenuValue}})],1),_vm._v(" "),_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"order-left",class:{'search-checked':_vm.searchCheckedState==0},on:{"tap":function($event){_vm.searchButLink(0)}}},[_vm._v("\n      "+_vm._s(_vm.buttonTitleLeft)+"\n    ")]),_vm._v(" "),_c('vButton',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"order-right",class:{'search-checked':_vm.searchCheckedState==1},on:{"tap":function($event){_vm.searchButLink(1)}}},[_vm._v("\n      "+_vm._s(_vm.buttonTitleRight)+"\n    ")])],1):_vm._e(),_vm._v(" "),(_vm.tbState)?_c('TargetKeyboard',{attrs:{"exclude":[_vm.$refs.tbState]},on:{"submit":function (value){ return _vm.choiceTargetId(value); },"close":function($event){_vm.tbState=false}}}):_vm._e(),_vm._v(" "),_c('div',{class:["CheckFullStop", {showPage: _vm.checkFullStopFlage}]},[_c('CheckFullStop',{ref:"CheckFullStop",attrs:{"datas":_vm.checkFullStopData,"positions":_vm.checkFullStopVolume,"tids":_vm.selectTids,"titles":_vm.checkFullStopTitle,"showFlage":_vm.checkFullStopFlage,"tick":_vm.insertPage.tick,"priceTicks":_vm.insertPage.tick.priceTick,"priceType":_vm.insertPage.priceMode,"priceData":_vm.insertPage},on:{"update:positions":function($event){_vm.checkFullStopVolume=$event},"update:priceType":function($event){_vm.$set(_vm.insertPage, "priceMode", $event)},"update:priceData":function($event){_vm.insertPage=$event},"hiddenPage":_vm.handleHiddenPage}})],1),_vm._v(" "),(_vm.auto_flage)?_c('h2',{staticClass:"alert_imfor"},[_vm._v(_vm._s(_vm.warning))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "REf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerWrapper"},[(_vm.leftIcon)?_c('i',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"icon iconfont left",on:{"tap":function($event){_vm.goBack()}}},[_vm._v("")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),(_vm.rightIcon)?_c('i',{staticClass:"icon iconfont right"},[_vm._v("")]):_vm._e(),_vm._v(" "),(_vm.selfRightIcon1)?_c('i',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"icon iconfont right",domProps:{"innerHTML":_vm._s(_vm.selfRightIcon1)},on:{"tap":_vm.order}}):_vm._e(),_vm._v(" "),(_vm.selfRightIcon2&&_vm.selfRightIcon2Value)?_c('i',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"icon iconfont right2",domProps:{"innerHTML":_vm._s(_vm.selfChoiceHeader)},on:{"tap":function($event){_vm.select(_vm.title)}}}):_vm._e(),_vm._v(" "),(_vm.selfRightIcon2&&!_vm.selfRightIcon2Value)?_c('i',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"icon iconfont right2",domProps:{"innerHTML":_vm._s(_vm.selfChoiceHeader2)},on:{"tap":function($event){_vm.select(_vm.title)}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RGDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_yjheader__ = __webpack_require__("eR8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__version_js__ = __webpack_require__("kB8h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "user-protocol",
  data: function data() {
    return {
      version2: __WEBPACK_IMPORTED_MODULE_1__version_js__["b" /* version */]
    };
  },

  components: {
    yjheader: __WEBPACK_IMPORTED_MODULE_0__components_common_yjheader__["a" /* default */]
  }
});

/***/ }),

/***/ "RIHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__ = __webpack_require__("n20g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif__ = __webpack_require__("SBPU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var BankCar = (function (_super) {
    __extends(BankCar, _super);
    function BankCar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            name: '',
            bank: '',
            bankBranch: '',
            bankNo: '',
        };
        _this.load = __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif___default.a;
        _this.loadFlage = false;
        _this.bankCarList = [];
        _this.errorMsg = '';
        _this.hintMsg = false;
        _this.flage = true;
        _this.headline = '添加银行卡';
        _this.showPopup = false;
        return _this;
    }
    BankCar.prototype.addCar = function () {
        if (this.loadFlage) {
            return;
        }
        this.flage = false;
        this.headline = '添加银行卡';
        this.showPopup = true;
    };
    BankCar.prototype.cancelP = function () {
        this.showPopup = false;
        this.clearData();
    };
    BankCar.prototype.editCar = function (item) {
        this.flage = true;
        this.headline = '银行卡信息';
        this.formData.name = item.name;
        this.formData.bank = item.bankName;
        this.formData.bankBranch = item.branchName;
        this.formData.bankNo = item.bankNo;
        this.showPopup = true;
    };
    BankCar.prototype.closeP = function () {
        this.showPopup = false;
        this.clearData();
    };
    BankCar.prototype.activated = function () {
        this.clearData();
        this.getList();
    };
    BankCar.prototype.enterAddCar = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.formData.name) {
                            this.errorMsg = '请正确填写持卡人姓名';
                            this.hintMsg = true;
                            this.vanish();
                            return [2, false];
                        }
                        else if (!this.formData.bankNo) {
                            this.errorMsg = '请正确填写银行卡号';
                            this.hintMsg = true;
                            this.vanish();
                            return [2, false];
                        }
                        else if (!/^\d{15,19}$/.test(this.formData.bankNo)) {
                            this.errorMsg = '银行卡号错误';
                            this.hintMsg = true;
                            this.vanish();
                            return [2, false];
                        }
                        else if (!this.formData.bank) {
                            this.errorMsg = '请正确填写开户行';
                            this.hintMsg = true;
                            this.vanish();
                            return [2, false];
                        }
                        else if (!this.formData.bankBranch) {
                            this.errorMsg = '请正确填写分行信息';
                            this.hintMsg = true;
                            this.vanish();
                            return [2, false];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.loadFlage = true;
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__["a" /* postForm */])('/api/user-bank/add', {
                                Name: this.formData.name,
                                BankNo: this.formData.bankNo,
                                BankName: this.formData.bank,
                                BranchName: this.formData.bankBranch,
                            })];
                    case 2:
                        _a.sent();
                        this.errorMsg = '添加成功';
                        this.hintMsg = true;
                        this.getList();
                        this.clearData();
                        this.showPopup = false;
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.errorMsg = '添加失败';
                        this.hintMsg = true;
                        return [3, 4];
                    case 4:
                        this.loadFlage = false;
                        this.hintMsg = true;
                        this.vanish();
                        return [2];
                }
            });
        });
    };
    BankCar.prototype.deleData = function (index) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadFlage = true;
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__["a" /* postForm */])('/api/user-bank/del', {
                                id: index,
                            })];
                    case 1:
                        _a.sent();
                        this.errorMsg = '删除成功';
                        this.hintMsg = true;
                        this.vanish();
                        this.getList();
                        this.loadFlage = false;
                        return [2];
                }
            });
        });
    };
    BankCar.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, _i, data_1, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadFlage = true;
                        this.bankCarList = [];
                        if (false)
                            console.log('data');
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__["a" /* postForm */])('/api/user-bank/query')];
                    case 1:
                        data = _a.sent();
                        for (_i = 0, data_1 = data; _i < data_1.length; _i++) {
                            i = data_1[_i];
                            this.bankCarList.push({
                                id: i.Id,
                                name: i.Name,
                                bankNo: i.BankNo,
                                branchName: i.BranchName,
                                bankName: i.BankName,
                                logNo: '**' + i.BankNo.substr(i.BankNo.length - 4),
                            });
                        }
                        this.loadFlage = false;
                        this.vanish();
                        if (false)
                            console.log(this.bankCarList);
                        return [2];
                }
            });
        });
    };
    BankCar.prototype.goback = function () {
        this.$router.go(-1);
    };
    BankCar.prototype.vanish = function () {
        var _this = this;
        setTimeout(function () {
            _this.hintMsg = false;
        }, 1500);
    };
    BankCar.prototype.clearData = function () {
        this.formData.name = '';
        this.formData.bank = '';
        this.formData.bankBranch = '';
        this.formData.bankNo = '';
    };
    BankCar = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            components: {},
        })
    ], BankCar);
    return BankCar;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (BankCar);


/***/ }),

/***/ "RMXP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RftC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NumKeyboard',{attrs:{"title":_vm.title,"exclude":_vm.exclude,"value":_vm.price,"showPriceType":_vm.showPriceType,"boardPrice":_vm.boardPrice},on:{"input":_vm.onPriceChange,"close":_vm.handleClose}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title-item"},[_vm._v("涨停价: "+_vm._s(_vm.tick.highStopPrice))]),_vm._v(" "),_c('span',{staticClass:"title-item"},[_vm._v("跌停价: "+_vm._s(_vm.tick.lowStopPrice))]),_vm._v(" "),_c('span',{staticClass:"title-item"},[_vm._v("最小变动价: "+_vm._s(_vm.tick.priceTick))])]),_vm._v(" "),_c('template',{slot:"header"},[_c('tr',[_c('th',{staticClass:"price-type-wrapper",attrs:{"colspan":"4"}},_vm._l((_vm.list),function(item){return _c('p',{key:item.value,staticClass:"price-type",on:{"touchstart":function($event){_vm.handlePriceType(item)}}},[_vm._v(_vm._s(item.text))])}))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RicZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dyfooter",
  data: function data() {
    return {
      footerTobarData: []
      // isActive: 0
    };
  },
  activated: function activated() {
    this.$store.commit("selectIndex", footerIndex);
    this.footerTobarData = this.getFooter();
  },

  methods: {
    getFooter: function getFooter() {
      console.log("getfooter");
      var arr = [{
        tobarLink: "/home/select",
        tobarIcon: "&#xe656",
        tobarContent: "自选"
      }, {
        tobarLink: "/home/market",
        tobarIcon: "&#xe66d;",
        tobarContent: "行情"
      }, {
        tobarLink: "/home/trade",
        tobarIcon: "&#xe6ba;",
        tobarContent: "交易"
      }, {
        tobarLink: "/home/condition",
        tobarIcon: "&#xe60b;",
        tobarContent: "云条件单"
      }];
      if (crmAddress) {
        arr.push({
          tobarLink: "/home/person",
          tobarIcon: "&#xe6b3;",
          tobarContent: "个人中心"
        });
      }
      return arr;
    },
    toLink: function toLink(tobarLink, index) {
      footerIndex = index;
      this.$store.commit("selectIndex", index);
      // this.isActive = index;
      this.$router.push({
        path: tobarLink
      });
    }
  },
  computed: {
    isActive: function isActive() {
      return this.$store.state.bottomIndex;
    }
  }
});

/***/ }),

/***/ "SBPU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/upLoading.34cc62d.gif";

/***/ }),

/***/ "SEXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
(function(global,factory){(typeof exports==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(exports))==='object'&&typeof module!=='undefined'?factory(exports):typeof define==='function'&&__webpack_require__("nErl")?define(['exports'],factory):factory(global.echarts={});})(this,function(exports){'use strict';/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// (1) The code `if (__DEV__) ...` can be removed by build tool.
// (2) If intend to use `__DEV__`, this module should be imported. Use a global
// variable `__DEV__` may cause that miss the declaration (see #6535), or the
// declaration is behind of the using position (for example in `Model.extent`,
// And tools like rollup can not analysis the dependency if not import).
/**
 * zrender: 生成唯一id
 *
 * @author errorrik (errorrik@gmail.com)
 */var idStart=0x0907;var guid=function guid(){return idStart++;};/**
 * echarts设备环境识别
 *
 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
 * @author firede[firede@firede.us]
 * @desc thanks zepto.
 */var env={};if((typeof wx==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(wx))==='object'&&typeof wx.getSystemInfoSync==='function'){// In Weixin Application
env={browser:{},os:{},node:false,wxa:true,// Weixin Application
canvasSupported:true,svgSupported:false,touchEventsSupported:true};}else if(typeof document==='undefined'&&typeof self!=='undefined'){// In worker
env={browser:{},os:{},node:false,worker:true,canvasSupported:true};}else if(typeof navigator==='undefined'){// In node
env={browser:{},os:{},node:true,worker:false,// Assume canvas is supported
canvasSupported:true,svgSupported:true};}else{env=detect(navigator.userAgent);}var env$1=env;// Zepto.js
// (c) 2010-2013 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
function detect(ua){var os={};var browser={};// var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
// var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
// var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
// var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
// var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
// var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
// var touchpad = webos && ua.match(/TouchPad/);
// var kindle = ua.match(/Kindle\/([\d.]+)/);
// var silk = ua.match(/Silk\/([\d._]+)/);
// var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
// var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
// var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
// var playbook = ua.match(/PlayBook/);
// var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
var firefox=ua.match(/Firefox\/([\d.]+)/);// var safari = webkit && ua.match(/Mobile\//) && !chrome;
// var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;
var ie=ua.match(/MSIE\s([\d.]+)/)// IE 11 Trident/7.0; rv:11.0
||ua.match(/Trident\/.+?rv:(([\d.]+))/);var edge=ua.match(/Edge\/([\d.]+)/);// IE 12 and 12+
var weChat=/micromessenger/i.test(ua);// Todo: clean this up with a better OS/browser seperation:
// - discern (more) between multiple browsers on android
// - decide if kindle fire in silk mode is android or not
// - Firefox on Android doesn't specify the Android version
// - possibly devide in os, device and browser hashes
// if (browser.webkit = !!webkit) browser.version = webkit[1];
// if (android) os.android = true, os.version = android[2];
// if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
// if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
// if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
// if (webos) os.webos = true, os.version = webos[2];
// if (touchpad) os.touchpad = true;
// if (blackberry) os.blackberry = true, os.version = blackberry[2];
// if (bb10) os.bb10 = true, os.version = bb10[2];
// if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
// if (playbook) browser.playbook = true;
// if (kindle) os.kindle = true, os.version = kindle[1];
// if (silk) browser.silk = true, browser.version = silk[1];
// if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
// if (chrome) browser.chrome = true, browser.version = chrome[1];
if(firefox){browser.firefox=true;browser.version=firefox[1];}// if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
// if (webview) browser.webview = true;
if(ie){browser.ie=true;browser.version=ie[1];}if(edge){browser.edge=true;browser.version=edge[1];}// It is difficult to detect WeChat in Win Phone precisely, because ua can
// not be set on win phone. So we do not consider Win Phone.
if(weChat){browser.weChat=true;}// os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
//     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
// os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
//     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
//     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));
return{browser:browser,os:os,node:false,// 原生canvas支持，改极端点了
// canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
canvasSupported:!!document.createElement('canvas').getContext,svgSupported:typeof SVGRect!=='undefined',// works on most browsers
// IE10/11 does not support touch event, and MS Edge supports them but not by
// default, so we dont check navigator.maxTouchPoints for them here.
touchEventsSupported:'ontouchstart'in window&&!browser.ie&&!browser.edge,// <http://caniuse.com/#search=pointer%20event>.
pointerEventsSupported:'onpointerdown'in window// Firefox supports pointer but not by default, only MS browsers are reliable on pointer
// events currently. So we dont use that on other browsers unless tested sufficiently.
// Although IE 10 supports pointer event, it use old style and is different from the
// standard. So we exclude that. (IE 10 is hardly used on touch device)
&&(browser.edge||browser.ie&&browser.version>=11)// passiveSupported: detectPassiveSupport()
};}// See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
// function detectPassiveSupport() {
//     // Test via a getter in the options object to see if the passive property is accessed
//     var supportsPassive = false;
//     try {
//         var opts = Object.defineProperty({}, 'passive', {
//             get: function() {
//                 supportsPassive = true;
//             }
//         });
//         window.addEventListener('testPassive', function() {}, opts);
//     } catch (e) {
//     }
//     return supportsPassive;
// }
/**
 * @module zrender/core/util
 */// 用于处理merge时无法遍历Date等对象的问题
var BUILTIN_OBJECT={'[object Function]':1,'[object RegExp]':1,'[object Date]':1,'[object Error]':1,'[object CanvasGradient]':1,'[object CanvasPattern]':1,// For node-canvas
'[object Image]':1,'[object Canvas]':1};var TYPED_ARRAY={'[object Int8Array]':1,'[object Uint8Array]':1,'[object Uint8ClampedArray]':1,'[object Int16Array]':1,'[object Uint16Array]':1,'[object Int32Array]':1,'[object Uint32Array]':1,'[object Float32Array]':1,'[object Float64Array]':1};var objToString=Object.prototype.toString;var arrayProto=Array.prototype;var nativeForEach=arrayProto.forEach;var nativeFilter=arrayProto.filter;var nativeSlice=arrayProto.slice;var nativeMap=arrayProto.map;var nativeReduce=arrayProto.reduce;// Avoid assign to an exported variable, for transforming to cjs.
var methods={};function $override(name,fn){// Clear ctx instance for different environment
if(name==='createCanvas'){_ctx=null;}methods[name]=fn;}/**
 * Those data types can be cloned:
 *     Plain object, Array, TypedArray, number, string, null, undefined.
 * Those data types will be assgined using the orginal data:
 *     BUILTIN_OBJECT
 * Instance of user defined class will be cloned to a plain object, without
 * properties in prototype.
 * Other data types is not supported (not sure what will happen).
 *
 * Caution: do not support clone Date, for performance consideration.
 * (There might be a large number of date in `series.data`).
 * So date should not be modified in and out of echarts.
 *
 * @param {*} source
 * @return {*} new
 */function _clone(source){if(source==null||(typeof source==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(source))!='object'){return source;}var result=source;var typeStr=objToString.call(source);if(typeStr==='[object Array]'){if(!isPrimitive(source)){result=[];for(var i=0,len=source.length;i<len;i++){result[i]=_clone(source[i]);}}}else if(TYPED_ARRAY[typeStr]){if(!isPrimitive(source)){var Ctor=source.constructor;if(source.constructor.from){result=Ctor.from(source);}else{result=new Ctor(source.length);for(var i=0,len=source.length;i<len;i++){result[i]=_clone(source[i]);}}}}else if(!BUILTIN_OBJECT[typeStr]&&!isPrimitive(source)&&!isDom(source)){result={};for(var key in source){if(source.hasOwnProperty(key)){result[key]=_clone(source[key]);}}}return result;}/**
 * @memberOf module:zrender/core/util
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overwrite=false]
 */function merge(target,source,overwrite){// We should escapse that source is string
// and enter for ... in ...
if(!isObject$1(source)||!isObject$1(target)){return overwrite?_clone(source):target;}for(var key in source){if(source.hasOwnProperty(key)){var targetProp=target[key];var sourceProp=source[key];if(isObject$1(sourceProp)&&isObject$1(targetProp)&&!isArray(sourceProp)&&!isArray(targetProp)&&!isDom(sourceProp)&&!isDom(targetProp)&&!isBuiltInObject(sourceProp)&&!isBuiltInObject(targetProp)&&!isPrimitive(sourceProp)&&!isPrimitive(targetProp)){// 如果需要递归覆盖，就递归调用merge
merge(targetProp,sourceProp,overwrite);}else if(overwrite||!(key in target)){// 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
// NOTE，在 target[key] 不存在的时候也是直接覆盖
target[key]=_clone(source[key],true);}}}return target;}/**
 * @param {Array} targetAndSources The first item is target, and the rests are source.
 * @param {boolean} [overwrite=false]
 * @return {*} target
 */function mergeAll(targetAndSources,overwrite){var result=targetAndSources[0];for(var i=1,len=targetAndSources.length;i<len;i++){result=merge(result,targetAndSources[i],overwrite);}return result;}/**
 * @param {*} target
 * @param {*} source
 * @memberOf module:zrender/core/util
 */function extend(target,source){for(var key in source){if(source.hasOwnProperty(key)){target[key]=source[key];}}return target;}/**
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overlay=false]
 * @memberOf module:zrender/core/util
 */function defaults(target,source,overlay){for(var key in source){if(source.hasOwnProperty(key)&&(overlay?source[key]!=null:target[key]==null)){target[key]=source[key];}}return target;}var createCanvas=function createCanvas(){return methods.createCanvas();};methods.createCanvas=function(){return document.createElement('canvas');};// FIXME
var _ctx;function getContext(){if(!_ctx){// Use util.createCanvas instead of createCanvas
// because createCanvas may be overwritten in different environment
_ctx=createCanvas().getContext('2d');}return _ctx;}/**
 * 查询数组中元素的index
 * @memberOf module:zrender/core/util
 */function indexOf(array,value){if(array){if(array.indexOf){return array.indexOf(value);}for(var i=0,len=array.length;i<len;i++){if(array[i]===value){return i;}}}return-1;}/**
 * 构造类继承关系
 *
 * @memberOf module:zrender/core/util
 * @param {Function} clazz 源类
 * @param {Function} baseClazz 基类
 */function inherits(clazz,baseClazz){var clazzPrototype=clazz.prototype;function F(){}F.prototype=baseClazz.prototype;clazz.prototype=new F();for(var prop in clazzPrototype){clazz.prototype[prop]=clazzPrototype[prop];}clazz.prototype.constructor=clazz;clazz.superClass=baseClazz;}/**
 * @memberOf module:zrender/core/util
 * @param {Object|Function} target
 * @param {Object|Function} sorce
 * @param {boolean} overlay
 */function mixin(target,source,overlay){target='prototype'in target?target.prototype:target;source='prototype'in source?source.prototype:source;defaults(target,source,overlay);}/**
 * Consider typed array.
 * @param {Array|TypedArray} data
 */function isArrayLike(data){if(!data){return;}if(typeof data=='string'){return false;}return typeof data.length=='number';}/**
 * 数组或对象遍历
 * @memberOf module:zrender/core/util
 * @param {Object|Array} obj
 * @param {Function} cb
 * @param {*} [context]
 */function each$1(obj,cb,context){if(!(obj&&cb)){return;}if(obj.forEach&&obj.forEach===nativeForEach){obj.forEach(cb,context);}else if(obj.length===+obj.length){for(var i=0,len=obj.length;i<len;i++){cb.call(context,obj[i],i,obj);}}else{for(var key in obj){if(obj.hasOwnProperty(key)){cb.call(context,obj[key],key,obj);}}}}/**
 * 数组映射
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */function map(obj,cb,context){if(!(obj&&cb)){return;}if(obj.map&&obj.map===nativeMap){return obj.map(cb,context);}else{var result=[];for(var i=0,len=obj.length;i<len;i++){result.push(cb.call(context,obj[i],i,obj));}return result;}}/**
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {Object} [memo]
 * @param {*} [context]
 * @return {Array}
 */function reduce(obj,cb,memo,context){if(!(obj&&cb)){return;}if(obj.reduce&&obj.reduce===nativeReduce){return obj.reduce(cb,memo,context);}else{for(var i=0,len=obj.length;i<len;i++){memo=cb.call(context,memo,obj[i],i,obj);}return memo;}}/**
 * 数组过滤
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */function filter(obj,cb,context){if(!(obj&&cb)){return;}if(obj.filter&&obj.filter===nativeFilter){return obj.filter(cb,context);}else{var result=[];for(var i=0,len=obj.length;i<len;i++){if(cb.call(context,obj[i],i,obj)){result.push(obj[i]);}}return result;}}/**
 * 数组项查找
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {*}
 */function find(obj,cb,context){if(!(obj&&cb)){return;}for(var i=0,len=obj.length;i<len;i++){if(cb.call(context,obj[i],i,obj)){return obj[i];}}}/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @param {*} context
 * @return {Function}
 */function bind(func,context){var args=nativeSlice.call(arguments,2);return function(){return func.apply(context,args.concat(nativeSlice.call(arguments)));};}/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @return {Function}
 */function curry(func){var args=nativeSlice.call(arguments,1);return function(){return func.apply(this,args.concat(nativeSlice.call(arguments)));};}/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */function isArray(value){return objToString.call(value)==='[object Array]';}/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */function isFunction$1(value){return typeof value==='function';}/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */function isString(value){return objToString.call(value)==='[object String]';}/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */function isObject$1(value){// Avoid a V8 JIT bug in Chrome 19-20.
// See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
var type=typeof value==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value);return type==='function'||!!value&&type=='object';}/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */function isBuiltInObject(value){return!!BUILTIN_OBJECT[objToString.call(value)];}/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */function isTypedArray(value){return!!TYPED_ARRAY[objToString.call(value)];}/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */function isDom(value){return(typeof value==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value))==='object'&&typeof value.nodeType==='number'&&__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value.ownerDocument)==='object';}/**
 * Whether is exactly NaN. Notice isNaN('a') returns true.
 * @param {*} value
 * @return {boolean}
 */function eqNaN(value){return value!==value;}/**
 * If value1 is not null, then return value1, otherwise judget rest of values.
 * Low performance.
 * @memberOf module:zrender/core/util
 * @return {*} Final value
 */function retrieve(values){for(var i=0,len=arguments.length;i<len;i++){if(arguments[i]!=null){return arguments[i];}}}function retrieve2(value0,value1){return value0!=null?value0:value1;}function retrieve3(value0,value1,value2){return value0!=null?value0:value1!=null?value1:value2;}/**
 * @memberOf module:zrender/core/util
 * @param {Array} arr
 * @param {number} startIndex
 * @param {number} endIndex
 * @return {Array}
 */function slice(){return Function.call.apply(nativeSlice,arguments);}/**
 * Normalize css liked array configuration
 * e.g.
 *  3 => [3, 3, 3, 3]
 *  [4, 2] => [4, 2, 4, 2]
 *  [4, 3, 2] => [4, 3, 2, 3]
 * @param {number|Array.<number>} val
 * @return {Array.<number>}
 */function normalizeCssArray(val){if(typeof val==='number'){return[val,val,val,val];}var len=val.length;if(len===2){// vertical | horizontal
return[val[0],val[1],val[0],val[1]];}else if(len===3){// top | horizontal | bottom
return[val[0],val[1],val[2],val[1]];}return val;}/**
 * @memberOf module:zrender/core/util
 * @param {boolean} condition
 * @param {string} message
 */function assert$1(condition,message){if(!condition){throw new Error(message);}}/**
 * @memberOf module:zrender/core/util
 * @param {string} str string to be trimed
 * @return {string} trimed string
 */function trim(str){if(str==null){return null;}else if(typeof str.trim==='function'){return str.trim();}else{return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,'');}}var primitiveKey='__ec_primitive__';/**
 * Set an object as primitive to be ignored traversing children in clone or merge
 */function setAsPrimitive(obj){obj[primitiveKey]=true;}function isPrimitive(obj){return obj[primitiveKey];}/**
 * @constructor
 * @param {Object} obj Only apply `ownProperty`.
 */function HashMap(obj){var isArr=isArray(obj);var thisMap=this;obj instanceof HashMap?obj.each(visit):obj&&each$1(obj,visit);function visit(value,key){isArr?thisMap.set(value,key):thisMap.set(key,value);}}// Add prefix to avoid conflict with Object.prototype.
HashMap.prototype={constructor:HashMap,// Do not provide `has` method to avoid defining what is `has`.
// (We usually treat `null` and `undefined` as the same, different
// from ES6 Map).
get:function get(key){return this.hasOwnProperty(key)?this[key]:null;},set:function set(key,value){// Comparing with invocation chaining, `return value` is more commonly
// used in this case: `var someVal = map.set('a', genVal());`
return this[key]=value;},// Although util.each can be performed on this hashMap directly, user
// should not use the exposed keys, who are prefixed.
each:function each(cb,context){context!==void 0&&(cb=bind(cb,context));for(var key in this){this.hasOwnProperty(key)&&cb(this[key],key);}},// Do not use this method if performance sensitive.
removeKey:function removeKey(key){delete this[key];}};function createHashMap(obj){return new HashMap(obj);}function concatArray(a,b){var newArray=new a.constructor(a.length+b.length);for(var i=0;i<a.length;i++){newArray[i]=a[i];}var offset=a.length;for(i=0;i<b.length;i++){newArray[i+offset]=b[i];}return newArray;}function noop(){}var zrUtil=(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a||Object)({$override:$override,clone:_clone,merge:merge,mergeAll:mergeAll,extend:extend,defaults:defaults,createCanvas:createCanvas,getContext:getContext,indexOf:indexOf,inherits:inherits,mixin:mixin,isArrayLike:isArrayLike,each:each$1,map:map,reduce:reduce,filter:filter,find:find,bind:bind,curry:curry,isArray:isArray,isFunction:isFunction$1,isString:isString,isObject:isObject$1,isBuiltInObject:isBuiltInObject,isTypedArray:isTypedArray,isDom:isDom,eqNaN:eqNaN,retrieve:retrieve,retrieve2:retrieve2,retrieve3:retrieve3,slice:slice,normalizeCssArray:normalizeCssArray,assert:assert$1,trim:trim,setAsPrimitive:setAsPrimitive,isPrimitive:isPrimitive,createHashMap:createHashMap,concatArray:concatArray,noop:noop});var ArrayCtor=typeof Float32Array==='undefined'?Array:Float32Array;/**
 * 创建一个向量
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @return {Vector2}
 */function create(x,y){var out=new ArrayCtor(2);if(x==null){x=0;}if(y==null){y=0;}out[0]=x;out[1]=y;return out;}/**
 * 复制向量数据
 * @param {Vector2} out
 * @param {Vector2} v
 * @return {Vector2}
 */function copy(out,v){out[0]=v[0];out[1]=v[1];return out;}/**
 * 克隆一个向量
 * @param {Vector2} v
 * @return {Vector2}
 */function clone$1(v){var out=new ArrayCtor(2);out[0]=v[0];out[1]=v[1];return out;}/**
 * 设置向量的两个项
 * @param {Vector2} out
 * @param {number} a
 * @param {number} b
 * @return {Vector2} 结果
 */function set(out,a,b){out[0]=a;out[1]=b;return out;}/**
 * 向量相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */function add(out,v1,v2){out[0]=v1[0]+v2[0];out[1]=v1[1]+v2[1];return out;}/**
 * 向量缩放后相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} a
 */function scaleAndAdd(out,v1,v2,a){out[0]=v1[0]+v2[0]*a;out[1]=v1[1]+v2[1]*a;return out;}/**
 * 向量相减
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */function sub(out,v1,v2){out[0]=v1[0]-v2[0];out[1]=v1[1]-v2[1];return out;}/**
 * 向量长度
 * @param {Vector2} v
 * @return {number}
 */function len(v){return Math.sqrt(lenSquare(v));}var length=len;// jshint ignore:line
/**
 * 向量长度平方
 * @param {Vector2} v
 * @return {number}
 */function lenSquare(v){return v[0]*v[0]+v[1]*v[1];}var lengthSquare=lenSquare;/**
 * 向量乘法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */function mul(out,v1,v2){out[0]=v1[0]*v2[0];out[1]=v1[1]*v2[1];return out;}/**
 * 向量除法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */function div(out,v1,v2){out[0]=v1[0]/v2[0];out[1]=v1[1]/v2[1];return out;}/**
 * 向量点乘
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */function dot(v1,v2){return v1[0]*v2[0]+v1[1]*v2[1];}/**
 * 向量缩放
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {number} s
 */function scale(out,v,s){out[0]=v[0]*s;out[1]=v[1]*s;return out;}/**
 * 向量归一化
 * @param {Vector2} out
 * @param {Vector2} v
 */function normalize(out,v){var d=len(v);if(d===0){out[0]=0;out[1]=0;}else{out[0]=v[0]/d;out[1]=v[1]/d;}return out;}/**
 * 计算向量间距离
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */function distance(v1,v2){return Math.sqrt((v1[0]-v2[0])*(v1[0]-v2[0])+(v1[1]-v2[1])*(v1[1]-v2[1]));}var dist=distance;/**
 * 向量距离平方
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */function distanceSquare(v1,v2){return(v1[0]-v2[0])*(v1[0]-v2[0])+(v1[1]-v2[1])*(v1[1]-v2[1]);}var distSquare=distanceSquare;/**
 * 求负向量
 * @param {Vector2} out
 * @param {Vector2} v
 */function negate(out,v){out[0]=-v[0];out[1]=-v[1];return out;}/**
 * 插值两个点
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} t
 */function lerp(out,v1,v2,t){out[0]=v1[0]+t*(v2[0]-v1[0]);out[1]=v1[1]+t*(v2[1]-v1[1]);return out;}/**
 * 矩阵左乘向量
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {Vector2} m
 */function applyTransform(out,v,m){var x=v[0];var y=v[1];out[0]=m[0]*x+m[2]*y+m[4];out[1]=m[1]*x+m[3]*y+m[5];return out;}/**
 * 求两个向量最小值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */function min(out,v1,v2){out[0]=Math.min(v1[0],v2[0]);out[1]=Math.min(v1[1],v2[1]);return out;}/**
 * 求两个向量最大值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */function max(out,v1,v2){out[0]=Math.max(v1[0],v2[0]);out[1]=Math.max(v1[1],v2[1]);return out;}var vector=(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a||Object)({create:create,copy:copy,clone:clone$1,set:set,add:add,scaleAndAdd:scaleAndAdd,sub:sub,len:len,length:length,lenSquare:lenSquare,lengthSquare:lengthSquare,mul:mul,div:div,dot:dot,scale:scale,normalize:normalize,distance:distance,dist:dist,distanceSquare:distanceSquare,distSquare:distSquare,negate:negate,lerp:lerp,applyTransform:applyTransform,min:min,max:max});// TODO Draggable for group
// FIXME Draggable on element which has parent rotation or scale
function Draggable(){this.on('mousedown',this._dragStart,this);this.on('mousemove',this._drag,this);this.on('mouseup',this._dragEnd,this);this.on('globalout',this._dragEnd,this);// this._dropTarget = null;
// this._draggingTarget = null;
// this._x = 0;
// this._y = 0;
}Draggable.prototype={constructor:Draggable,_dragStart:function _dragStart(e){var draggingTarget=e.target;if(draggingTarget&&draggingTarget.draggable){this._draggingTarget=draggingTarget;draggingTarget.dragging=true;this._x=e.offsetX;this._y=e.offsetY;this.dispatchToElement(param(draggingTarget,e),'dragstart',e.event);}},_drag:function _drag(e){var draggingTarget=this._draggingTarget;if(draggingTarget){var x=e.offsetX;var y=e.offsetY;var dx=x-this._x;var dy=y-this._y;this._x=x;this._y=y;draggingTarget.drift(dx,dy,e);this.dispatchToElement(param(draggingTarget,e),'drag',e.event);var dropTarget=this.findHover(x,y,draggingTarget).target;var lastDropTarget=this._dropTarget;this._dropTarget=dropTarget;if(draggingTarget!==dropTarget){if(lastDropTarget&&dropTarget!==lastDropTarget){this.dispatchToElement(param(lastDropTarget,e),'dragleave',e.event);}if(dropTarget&&dropTarget!==lastDropTarget){this.dispatchToElement(param(dropTarget,e),'dragenter',e.event);}}}},_dragEnd:function _dragEnd(e){var draggingTarget=this._draggingTarget;if(draggingTarget){draggingTarget.dragging=false;}this.dispatchToElement(param(draggingTarget,e),'dragend',e.event);if(this._dropTarget){this.dispatchToElement(param(this._dropTarget,e),'drop',e.event);}this._draggingTarget=null;this._dropTarget=null;}};function param(target,e){return{target:target,topTarget:e&&e.topTarget};}/**
 * 事件扩展
 * @module zrender/mixin/Eventful
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         pissang (https://www.github.com/pissang)
 */var arrySlice=Array.prototype.slice;/**
 * 事件分发器
 * @alias module:zrender/mixin/Eventful
 * @constructor
 */var Eventful=function Eventful(){this._$handlers={};};Eventful.prototype={constructor:Eventful,/**
   * 单次触发绑定，trigger后销毁
   *
   * @param {string} event 事件名
   * @param {Function} handler 响应函数
   * @param {Object} context
   */one:function one(event,handler,context){var _h=this._$handlers;if(!handler||!event){return this;}if(!_h[event]){_h[event]=[];}for(var i=0;i<_h[event].length;i++){if(_h[event][i].h===handler){return this;}}_h[event].push({h:handler,one:true,ctx:context||this});return this;},/**
   * 绑定事件
   * @param {string} event 事件名
   * @param {Function} handler 事件处理函数
   * @param {Object} [context]
   */on:function on(event,handler,context){var _h=this._$handlers;if(!handler||!event){return this;}if(!_h[event]){_h[event]=[];}for(var i=0;i<_h[event].length;i++){if(_h[event][i].h===handler){return this;}}_h[event].push({h:handler,one:false,ctx:context||this});return this;},/**
   * 是否绑定了事件
   * @param  {string}  event
   * @return {boolean}
   */isSilent:function isSilent(event){var _h=this._$handlers;return _h[event]&&_h[event].length;},/**
   * 解绑事件
   * @param {string} event 事件名
   * @param {Function} [handler] 事件处理函数
   */off:function off(event,handler){var _h=this._$handlers;if(!event){this._$handlers={};return this;}if(handler){if(_h[event]){var newList=[];for(var i=0,l=_h[event].length;i<l;i++){if(_h[event][i]['h']!=handler){newList.push(_h[event][i]);}}_h[event]=newList;}if(_h[event]&&_h[event].length===0){delete _h[event];}}else{delete _h[event];}return this;},/**
   * 事件分发
   *
   * @param {string} type 事件类型
   */trigger:function trigger(type){if(this._$handlers[type]){var args=arguments;var argLen=args.length;if(argLen>3){args=arrySlice.call(args,1);}var _h=this._$handlers[type];var len=_h.length;for(var i=0;i<len;){// Optimize advise from backbone
switch(argLen){case 1:_h[i]['h'].call(_h[i]['ctx']);break;case 2:_h[i]['h'].call(_h[i]['ctx'],args[1]);break;case 3:_h[i]['h'].call(_h[i]['ctx'],args[1],args[2]);break;default:// have more than 2 given arguments
_h[i]['h'].apply(_h[i]['ctx'],args);break;}if(_h[i]['one']){_h.splice(i,1);len--;}else{i++;}}}return this;},/**
   * 带有context的事件分发, 最后一个参数是事件回调的context
   * @param {string} type 事件类型
   */triggerWithContext:function triggerWithContext(type){if(this._$handlers[type]){var args=arguments;var argLen=args.length;if(argLen>4){args=arrySlice.call(args,1,args.length-1);}var ctx=args[args.length-1];var _h=this._$handlers[type];var len=_h.length;for(var i=0;i<len;){// Optimize advise from backbone
switch(argLen){case 1:_h[i]['h'].call(ctx);break;case 2:_h[i]['h'].call(ctx,args[1]);break;case 3:_h[i]['h'].call(ctx,args[1],args[2]);break;default:// have more than 2 given arguments
_h[i]['h'].apply(ctx,args);break;}if(_h[i]['one']){_h.splice(i,1);len--;}else{i++;}}}return this;}};// 对象可以通过 onxxxx 绑定事件
var SILENT='silent';function makeEventPacket(eveType,targetInfo,event){return{type:eveType,event:event,// target can only be an element that is not silent.
target:targetInfo.target,// topTarget can be a silent element.
topTarget:targetInfo.topTarget,cancelBubble:false,offsetX:event.zrX,offsetY:event.zrY,gestureEvent:event.gestureEvent,pinchX:event.pinchX,pinchY:event.pinchY,pinchScale:event.pinchScale,wheelDelta:event.zrDelta,zrByTouch:event.zrByTouch,which:event.which};}function EmptyProxy(){}EmptyProxy.prototype.dispose=function(){};var handlerNames=['click','dblclick','mousewheel','mouseout','mouseup','mousedown','mousemove','contextmenu'];/**
 * @alias module:zrender/Handler
 * @constructor
 * @extends module:zrender/mixin/Eventful
 * @param {module:zrender/Storage} storage Storage instance.
 * @param {module:zrender/Painter} painter Painter instance.
 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
 */var Handler=function Handler(storage,painter,proxy,painterRoot){Eventful.call(this);this.storage=storage;this.painter=painter;this.painterRoot=painterRoot;proxy=proxy||new EmptyProxy();/**
   * Proxy of event. can be Dom, WebGLSurface, etc.
   */this.proxy=null;/**
   * {target, topTarget, x, y}
   * @private
   * @type {Object}
   */this._hovered={};/**
   * @private
   * @type {Date}
   */this._lastTouchMoment;/**
   * @private
   * @type {number}
   */this._lastX;/**
   * @private
   * @type {number}
   */this._lastY;Draggable.call(this);this.setHandlerProxy(proxy);};Handler.prototype={constructor:Handler,setHandlerProxy:function setHandlerProxy(proxy){if(this.proxy){this.proxy.dispose();}if(proxy){each$1(handlerNames,function(name){proxy.on&&proxy.on(name,this[name],this);},this);// Attach handler
proxy.handler=this;}this.proxy=proxy;},mousemove:function mousemove(event){var x=event.zrX;var y=event.zrY;var lastHovered=this._hovered;var lastHoveredTarget=lastHovered.target;// If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
// (like 'setOption' or 'dispatchAction') in event handlers, we should find
// lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
// See #6198.
if(lastHoveredTarget&&!lastHoveredTarget.__zr){lastHovered=this.findHover(lastHovered.x,lastHovered.y);lastHoveredTarget=lastHovered.target;}var hovered=this._hovered=this.findHover(x,y);var hoveredTarget=hovered.target;var proxy=this.proxy;proxy.setCursor&&proxy.setCursor(hoveredTarget?hoveredTarget.cursor:'default');// Mouse out on previous hovered element
if(lastHoveredTarget&&hoveredTarget!==lastHoveredTarget){this.dispatchToElement(lastHovered,'mouseout',event);}// Mouse moving on one element
this.dispatchToElement(hovered,'mousemove',event);// Mouse over on a new element
if(hoveredTarget&&hoveredTarget!==lastHoveredTarget){this.dispatchToElement(hovered,'mouseover',event);}},mouseout:function mouseout(event){this.dispatchToElement(this._hovered,'mouseout',event);// There might be some doms created by upper layer application
// at the same level of painter.getViewportRoot() (e.g., tooltip
// dom created by echarts), where 'globalout' event should not
// be triggered when mouse enters these doms. (But 'mouseout'
// should be triggered at the original hovered element as usual).
var element=event.toElement||event.relatedTarget;var innerDom;do{element=element&&element.parentNode;}while(element&&element.nodeType!=9&&!(innerDom=element===this.painterRoot));!innerDom&&this.trigger('globalout',{event:event});},/**
   * Resize
   */resize:function resize(event){this._hovered={};},/**
   * Dispatch event
   * @param {string} eventName
   * @param {event=} eventArgs
   */dispatch:function dispatch(eventName,eventArgs){var handler=this[eventName];handler&&handler.call(this,eventArgs);},/**
   * Dispose
   */dispose:function dispose(){this.proxy.dispose();this.storage=this.proxy=this.painter=null;},/**
   * 设置默认的cursor style
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */setCursorStyle:function setCursorStyle(cursorStyle){var proxy=this.proxy;proxy.setCursor&&proxy.setCursor(cursorStyle);},/**
   * 事件分发代理
   *
   * @private
   * @param {Object} targetInfo {target, topTarget} 目标图形元素
   * @param {string} eventName 事件名称
   * @param {Object} event 事件对象
   */dispatchToElement:function dispatchToElement(targetInfo,eventName,event){targetInfo=targetInfo||{};var el=targetInfo.target;if(el&&el.silent){return;}var eventHandler='on'+eventName;var eventPacket=makeEventPacket(eventName,targetInfo,event);while(el){el[eventHandler]&&(eventPacket.cancelBubble=el[eventHandler].call(el,eventPacket));el.trigger(eventName,eventPacket);el=el.parent;if(eventPacket.cancelBubble){break;}}if(!eventPacket.cancelBubble){// 冒泡到顶级 zrender 对象
this.trigger(eventName,eventPacket);// 分发事件到用户自定义层
// 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在
this.painter&&this.painter.eachOtherLayer(function(layer){if(typeof layer[eventHandler]=='function'){layer[eventHandler].call(layer,eventPacket);}if(layer.trigger){layer.trigger(eventName,eventPacket);}});}},/**
   * @private
   * @param {number} x
   * @param {number} y
   * @param {module:zrender/graphic/Displayable} exclude
   * @return {model:zrender/Element}
   * @method
   */findHover:function findHover(x,y,exclude){var list=this.storage.getDisplayList();var out={x:x,y:y};for(var i=list.length-1;i>=0;i--){var hoverCheckResult;if(list[i]!==exclude// getDisplayList may include ignored item in VML mode
&&!list[i].ignore&&(hoverCheckResult=isHover(list[i],x,y))){!out.topTarget&&(out.topTarget=list[i]);if(hoverCheckResult!==SILENT){out.target=list[i];break;}}}return out;}};// Common handlers
each$1(['click','mousedown','mouseup','mousewheel','dblclick','contextmenu'],function(name){Handler.prototype[name]=function(event){// Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
var hovered=this.findHover(event.zrX,event.zrY);var hoveredTarget=hovered.target;if(name==='mousedown'){this._downEl=hoveredTarget;this._downPoint=[event.zrX,event.zrY];// In case click triggered before mouseup
this._upEl=hoveredTarget;}else if(name==='mouseup'){this._upEl=hoveredTarget;}else if(name==='click'){if(this._downEl!==this._upEl// Original click event is triggered on the whole canvas element,
// including the case that `mousedown` - `mousemove` - `mouseup`,
// which should be filtered, otherwise it will bring trouble to
// pan and zoom.
||!this._downPoint// Arbitrary value
||dist(this._downPoint,[event.zrX,event.zrY])>4){return;}this._downPoint=null;}this.dispatchToElement(hovered,name,event);};});function isHover(displayable,x,y){if(displayable[displayable.rectHover?'rectContain':'contain'](x,y)){var el=displayable;var isSilent;while(el){// If clipped by ancestor.
// FIXME: If clipPath has neither stroke nor fill,
// el.clipPath.contain(x, y) will always return false.
if(el.clipPath&&!el.clipPath.contain(x,y)){return false;}if(el.silent){isSilent=true;}el=el.parent;}return isSilent?SILENT:true;}return false;}mixin(Handler,Eventful);mixin(Handler,Draggable);/**
 * 3x2矩阵操作类
 * @exports zrender/tool/matrix
 */var ArrayCtor$1=typeof Float32Array==='undefined'?Array:Float32Array;/**
 * Create a identity matrix.
 * @return {Float32Array|Array.<number>}
 */function create$1(){var out=new ArrayCtor$1(6);identity(out);return out;}/**
 * 设置矩阵为单位矩阵
 * @param {Float32Array|Array.<number>} out
 */function identity(out){out[0]=1;out[1]=0;out[2]=0;out[3]=1;out[4]=0;out[5]=0;return out;}/**
 * 复制矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m
 */function copy$1(out,m){out[0]=m[0];out[1]=m[1];out[2]=m[2];out[3]=m[3];out[4]=m[4];out[5]=m[5];return out;}/**
 * 矩阵相乘
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m1
 * @param {Float32Array|Array.<number>} m2
 */function mul$1(out,m1,m2){// Consider matrix.mul(m, m2, m);
// where out is the same as m2.
// So use temp variable to escape error.
var out0=m1[0]*m2[0]+m1[2]*m2[1];var out1=m1[1]*m2[0]+m1[3]*m2[1];var out2=m1[0]*m2[2]+m1[2]*m2[3];var out3=m1[1]*m2[2]+m1[3]*m2[3];var out4=m1[0]*m2[4]+m1[2]*m2[5]+m1[4];var out5=m1[1]*m2[4]+m1[3]*m2[5]+m1[5];out[0]=out0;out[1]=out1;out[2]=out2;out[3]=out3;out[4]=out4;out[5]=out5;return out;}/**
 * 平移变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */function translate(out,a,v){out[0]=a[0];out[1]=a[1];out[2]=a[2];out[3]=a[3];out[4]=a[4]+v[0];out[5]=a[5]+v[1];return out;}/**
 * 旋转变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {number} rad
 */function rotate(out,a,rad){var aa=a[0];var ac=a[2];var atx=a[4];var ab=a[1];var ad=a[3];var aty=a[5];var st=Math.sin(rad);var ct=Math.cos(rad);out[0]=aa*ct+ab*st;out[1]=-aa*st+ab*ct;out[2]=ac*ct+ad*st;out[3]=-ac*st+ct*ad;out[4]=ct*atx+st*aty;out[5]=ct*aty-st*atx;return out;}/**
 * 缩放变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */function scale$1(out,a,v){var vx=v[0];var vy=v[1];out[0]=a[0]*vx;out[1]=a[1]*vy;out[2]=a[2]*vx;out[3]=a[3]*vy;out[4]=a[4]*vx;out[5]=a[5]*vy;return out;}/**
 * 求逆矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 */function invert(out,a){var aa=a[0];var ac=a[2];var atx=a[4];var ab=a[1];var ad=a[3];var aty=a[5];var det=aa*ad-ab*ac;if(!det){return null;}det=1.0/det;out[0]=ad*det;out[1]=-ab*det;out[2]=-ac*det;out[3]=aa*det;out[4]=(ac*aty-ad*atx)*det;out[5]=(ab*atx-aa*aty)*det;return out;}/**
 * Clone a new matrix.
 * @param {Float32Array|Array.<number>} a
 */function clone$2(a){var b=create$1();copy$1(b,a);return b;}var matrix=(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a||Object)({create:create$1,identity:identity,copy:copy$1,mul:mul$1,translate:translate,rotate:rotate,scale:scale$1,invert:invert,clone:clone$2});/**
 * 提供变换扩展
 * @module zrender/mixin/Transformable
 * @author pissang (https://www.github.com/pissang)
 */var mIdentity=identity;var EPSILON=5e-5;function isNotAroundZero(val){return val>EPSILON||val<-EPSILON;}/**
 * @alias module:zrender/mixin/Transformable
 * @constructor
 */var Transformable=function Transformable(opts){opts=opts||{};// If there are no given position, rotation, scale
if(!opts.position){/**
     * 平移
     * @type {Array.<number>}
     * @default [0, 0]
     */this.position=[0,0];}if(opts.rotation==null){/**
     * 旋转
     * @type {Array.<number>}
     * @default 0
     */this.rotation=0;}if(!opts.scale){/**
     * 缩放
     * @type {Array.<number>}
     * @default [1, 1]
     */this.scale=[1,1];}/**
   * 旋转和缩放的原点
   * @type {Array.<number>}
   * @default null
   */this.origin=this.origin||null;};var transformableProto=Transformable.prototype;transformableProto.transform=null;/**
 * 判断是否需要有坐标变换
 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
 */transformableProto.needLocalTransform=function(){return isNotAroundZero(this.rotation)||isNotAroundZero(this.position[0])||isNotAroundZero(this.position[1])||isNotAroundZero(this.scale[0]-1)||isNotAroundZero(this.scale[1]-1);};transformableProto.updateTransform=function(){var parent=this.parent;var parentHasTransform=parent&&parent.transform;var needLocalTransform=this.needLocalTransform();var m=this.transform;if(!(needLocalTransform||parentHasTransform)){m&&mIdentity(m);return;}m=m||create$1();if(needLocalTransform){this.getLocalTransform(m);}else{mIdentity(m);}// 应用父节点变换
if(parentHasTransform){if(needLocalTransform){mul$1(m,parent.transform,m);}else{copy$1(m,parent.transform);}}// 保存这个变换矩阵
this.transform=m;this.invTransform=this.invTransform||create$1();invert(this.invTransform,m);};transformableProto.getLocalTransform=function(m){return Transformable.getLocalTransform(this,m);};/**
 * 将自己的transform应用到context上
 * @param {CanvasRenderingContext2D} ctx
 */transformableProto.setTransform=function(ctx){var m=this.transform;var dpr=ctx.dpr||1;if(m){ctx.setTransform(dpr*m[0],dpr*m[1],dpr*m[2],dpr*m[3],dpr*m[4],dpr*m[5]);}else{ctx.setTransform(dpr,0,0,dpr,0,0);}};transformableProto.restoreTransform=function(ctx){var dpr=ctx.dpr||1;ctx.setTransform(dpr,0,0,dpr,0,0);};var tmpTransform=[];/**
 * 分解`transform`矩阵到`position`, `rotation`, `scale`
 */transformableProto.decomposeTransform=function(){if(!this.transform){return;}var parent=this.parent;var m=this.transform;if(parent&&parent.transform){// Get local transform and decompose them to position, scale, rotation
mul$1(tmpTransform,parent.invTransform,m);m=tmpTransform;}var sx=m[0]*m[0]+m[1]*m[1];var sy=m[2]*m[2]+m[3]*m[3];var position=this.position;var scale$$1=this.scale;if(isNotAroundZero(sx-1)){sx=Math.sqrt(sx);}if(isNotAroundZero(sy-1)){sy=Math.sqrt(sy);}if(m[0]<0){sx=-sx;}if(m[3]<0){sy=-sy;}position[0]=m[4];position[1]=m[5];scale$$1[0]=sx;scale$$1[1]=sy;this.rotation=Math.atan2(-m[1]/sy,m[0]/sx);};/**
 * Get global scale
 * @return {Array.<number>}
 */transformableProto.getGlobalScale=function(){var m=this.transform;if(!m){return[1,1];}var sx=Math.sqrt(m[0]*m[0]+m[1]*m[1]);var sy=Math.sqrt(m[2]*m[2]+m[3]*m[3]);if(m[0]<0){sx=-sx;}if(m[3]<0){sy=-sy;}return[sx,sy];};/**
 * 变换坐标位置到 shape 的局部坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */transformableProto.transformCoordToLocal=function(x,y){var v2=[x,y];var invTransform=this.invTransform;if(invTransform){applyTransform(v2,v2,invTransform);}return v2;};/**
 * 变换局部坐标位置到全局坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */transformableProto.transformCoordToGlobal=function(x,y){var v2=[x,y];var transform=this.transform;if(transform){applyTransform(v2,v2,transform);}return v2;};/**
 * @static
 * @param {Object} target
 * @param {Array.<number>} target.origin
 * @param {number} target.rotation
 * @param {Array.<number>} target.position
 * @param {Array.<number>} [m]
 */Transformable.getLocalTransform=function(target,m){m=m||[];mIdentity(m);var origin=target.origin;var scale$$1=target.scale||[1,1];var rotation=target.rotation||0;var position=target.position||[0,0];if(origin){// Translate to origin
m[4]-=origin[0];m[5]-=origin[1];}scale$1(m,m,scale$$1);if(rotation){rotate(m,m,rotation);}if(origin){// Translate back from origin
m[4]+=origin[0];m[5]+=origin[1];}m[4]+=position[0];m[5]+=position[1];return m;};/**
 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
 * @see http://sole.github.io/tween.js/examples/03_graphs.html
 * @exports zrender/animation/easing
 */var easing={/**
  * @param {number} k
  * @return {number}
  */linear:function linear(k){return k;},/**
  * @param {number} k
  * @return {number}
  */quadraticIn:function quadraticIn(k){return k*k;},/**
  * @param {number} k
  * @return {number}
  */quadraticOut:function quadraticOut(k){return k*(2-k);},/**
  * @param {number} k
  * @return {number}
  */quadraticInOut:function quadraticInOut(k){if((k*=2)<1){return 0.5*k*k;}return-0.5*(--k*(k-2)-1);},// 三次方的缓动（t^3）
/**
  * @param {number} k
  * @return {number}
  */cubicIn:function cubicIn(k){return k*k*k;},/**
  * @param {number} k
  * @return {number}
  */cubicOut:function cubicOut(k){return--k*k*k+1;},/**
  * @param {number} k
  * @return {number}
  */cubicInOut:function cubicInOut(k){if((k*=2)<1){return 0.5*k*k*k;}return 0.5*((k-=2)*k*k+2);},// 四次方的缓动（t^4）
/**
  * @param {number} k
  * @return {number}
  */quarticIn:function quarticIn(k){return k*k*k*k;},/**
  * @param {number} k
  * @return {number}
  */quarticOut:function quarticOut(k){return 1- --k*k*k*k;},/**
  * @param {number} k
  * @return {number}
  */quarticInOut:function quarticInOut(k){if((k*=2)<1){return 0.5*k*k*k*k;}return-0.5*((k-=2)*k*k*k-2);},// 五次方的缓动（t^5）
/**
  * @param {number} k
  * @return {number}
  */quinticIn:function quinticIn(k){return k*k*k*k*k;},/**
  * @param {number} k
  * @return {number}
  */quinticOut:function quinticOut(k){return--k*k*k*k*k+1;},/**
  * @param {number} k
  * @return {number}
  */quinticInOut:function quinticInOut(k){if((k*=2)<1){return 0.5*k*k*k*k*k;}return 0.5*((k-=2)*k*k*k*k+2);},// 正弦曲线的缓动（sin(t)）
/**
  * @param {number} k
  * @return {number}
  */sinusoidalIn:function sinusoidalIn(k){return 1-Math.cos(k*Math.PI/2);},/**
  * @param {number} k
  * @return {number}
  */sinusoidalOut:function sinusoidalOut(k){return Math.sin(k*Math.PI/2);},/**
  * @param {number} k
  * @return {number}
  */sinusoidalInOut:function sinusoidalInOut(k){return 0.5*(1-Math.cos(Math.PI*k));},// 指数曲线的缓动（2^t）
/**
  * @param {number} k
  * @return {number}
  */exponentialIn:function exponentialIn(k){return k===0?0:Math.pow(1024,k-1);},/**
  * @param {number} k
  * @return {number}
  */exponentialOut:function exponentialOut(k){return k===1?1:1-Math.pow(2,-10*k);},/**
  * @param {number} k
  * @return {number}
  */exponentialInOut:function exponentialInOut(k){if(k===0){return 0;}if(k===1){return 1;}if((k*=2)<1){return 0.5*Math.pow(1024,k-1);}return 0.5*(-Math.pow(2,-10*(k-1))+2);},// 圆形曲线的缓动（sqrt(1-t^2)）
/**
  * @param {number} k
  * @return {number}
  */circularIn:function circularIn(k){return 1-Math.sqrt(1-k*k);},/**
  * @param {number} k
  * @return {number}
  */circularOut:function circularOut(k){return Math.sqrt(1- --k*k);},/**
  * @param {number} k
  * @return {number}
  */circularInOut:function circularInOut(k){if((k*=2)<1){return-0.5*(Math.sqrt(1-k*k)-1);}return 0.5*(Math.sqrt(1-(k-=2)*k)+1);},// 创建类似于弹簧在停止前来回振荡的动画
/**
  * @param {number} k
  * @return {number}
  */elasticIn:function elasticIn(k){var s;var a=0.1;var p=0.4;if(k===0){return 0;}if(k===1){return 1;}if(!a||a<1){a=1;s=p/4;}else{s=p*Math.asin(1/a)/(2*Math.PI);}return-(a*Math.pow(2,10*(k-=1))*Math.sin((k-s)*(2*Math.PI)/p));},/**
  * @param {number} k
  * @return {number}
  */elasticOut:function elasticOut(k){var s;var a=0.1;var p=0.4;if(k===0){return 0;}if(k===1){return 1;}if(!a||a<1){a=1;s=p/4;}else{s=p*Math.asin(1/a)/(2*Math.PI);}return a*Math.pow(2,-10*k)*Math.sin((k-s)*(2*Math.PI)/p)+1;},/**
  * @param {number} k
  * @return {number}
  */elasticInOut:function elasticInOut(k){var s;var a=0.1;var p=0.4;if(k===0){return 0;}if(k===1){return 1;}if(!a||a<1){a=1;s=p/4;}else{s=p*Math.asin(1/a)/(2*Math.PI);}if((k*=2)<1){return-0.5*(a*Math.pow(2,10*(k-=1))*Math.sin((k-s)*(2*Math.PI)/p));}return a*Math.pow(2,-10*(k-=1))*Math.sin((k-s)*(2*Math.PI)/p)*0.5+1;},// 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动
/**
  * @param {number} k
  * @return {number}
  */backIn:function backIn(k){var s=1.70158;return k*k*((s+1)*k-s);},/**
  * @param {number} k
  * @return {number}
  */backOut:function backOut(k){var s=1.70158;return--k*k*((s+1)*k+s)+1;},/**
  * @param {number} k
  * @return {number}
  */backInOut:function backInOut(k){var s=1.70158*1.525;if((k*=2)<1){return 0.5*(k*k*((s+1)*k-s));}return 0.5*((k-=2)*k*((s+1)*k+s)+2);},// 创建弹跳效果
/**
  * @param {number} k
  * @return {number}
  */bounceIn:function bounceIn(k){return 1-easing.bounceOut(1-k);},/**
  * @param {number} k
  * @return {number}
  */bounceOut:function bounceOut(k){if(k<1/2.75){return 7.5625*k*k;}else if(k<2/2.75){return 7.5625*(k-=1.5/2.75)*k+0.75;}else if(k<2.5/2.75){return 7.5625*(k-=2.25/2.75)*k+0.9375;}else{return 7.5625*(k-=2.625/2.75)*k+0.984375;}},/**
  * @param {number} k
  * @return {number}
  */bounceInOut:function bounceInOut(k){if(k<0.5){return easing.bounceIn(k*2)*0.5;}return easing.bounceOut(k*2-1)*0.5+0.5;}};/**
 * 动画主控制器
 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
 * @config life(1000) 动画时长
 * @config delay(0) 动画延迟时间
 * @config loop(true)
 * @config gap(0) 循环的间隔时间
 * @config onframe
 * @config easing(optional)
 * @config ondestroy(optional)
 * @config onrestart(optional)
 *
 * TODO pause
 */function Clip(options){this._target=options.target;// 生命周期
this._life=options.life||1000;// 延时
this._delay=options.delay||0;// 开始时间
// this._startTime = new Date().getTime() + this._delay;// 单位毫秒
this._initialized=false;// 是否循环
this.loop=options.loop==null?false:options.loop;this.gap=options.gap||0;this.easing=options.easing||'Linear';this.onframe=options.onframe;this.ondestroy=options.ondestroy;this.onrestart=options.onrestart;this._pausedTime=0;this._paused=false;}Clip.prototype={constructor:Clip,step:function step(globalTime,deltaTime){// Set startTime on first step, or _startTime may has milleseconds different between clips
// PENDING
if(!this._initialized){this._startTime=globalTime+this._delay;this._initialized=true;}if(this._paused){this._pausedTime+=deltaTime;return;}var percent=(globalTime-this._startTime-this._pausedTime)/this._life;// 还没开始
if(percent<0){return;}percent=Math.min(percent,1);var easing$$1=this.easing;var easingFunc=typeof easing$$1=='string'?easing[easing$$1]:easing$$1;var schedule=typeof easingFunc==='function'?easingFunc(percent):percent;this.fire('frame',schedule);// 结束
if(percent==1){if(this.loop){this.restart(globalTime);// 重新开始周期
// 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件
return'restart';}// 动画完成将这个控制器标识为待删除
// 在Animation.update中进行批量删除
this._needsRemove=true;return'destroy';}return null;},restart:function restart(globalTime){var remainder=(globalTime-this._startTime-this._pausedTime)%this._life;this._startTime=globalTime-remainder+this.gap;this._pausedTime=0;this._needsRemove=false;},fire:function fire(eventType,arg){eventType='on'+eventType;if(this[eventType]){this[eventType](this._target,arg);}},pause:function pause(){this._paused=true;},resume:function resume(){this._paused=false;}};// Simple LRU cache use doubly linked list
// @module zrender/core/LRU
/**
 * Simple double linked list. Compared with array, it has O(1) remove operation.
 * @constructor
 */var LinkedList=function LinkedList(){/**
   * @type {module:zrender/core/LRU~Entry}
   */this.head=null;/**
   * @type {module:zrender/core/LRU~Entry}
   */this.tail=null;this._len=0;};var linkedListProto=LinkedList.prototype;/**
 * Insert a new value at the tail
 * @param  {} val
 * @return {module:zrender/core/LRU~Entry}
 */linkedListProto.insert=function(val){var entry=new Entry(val);this.insertEntry(entry);return entry;};/**
 * Insert an entry at the tail
 * @param  {module:zrender/core/LRU~Entry} entry
 */linkedListProto.insertEntry=function(entry){if(!this.head){this.head=this.tail=entry;}else{this.tail.next=entry;entry.prev=this.tail;entry.next=null;this.tail=entry;}this._len++;};/**
 * Remove entry.
 * @param  {module:zrender/core/LRU~Entry} entry
 */linkedListProto.remove=function(entry){var prev=entry.prev;var next=entry.next;if(prev){prev.next=next;}else{// Is head
this.head=next;}if(next){next.prev=prev;}else{// Is tail
this.tail=prev;}entry.next=entry.prev=null;this._len--;};/**
 * @return {number}
 */linkedListProto.len=function(){return this._len;};/**
 * Clear list
 */linkedListProto.clear=function(){this.head=this.tail=null;this._len=0;};/**
 * @constructor
 * @param {} val
 */var Entry=function Entry(val){/**
   * @type {}
   */this.value=val;/**
   * @type {module:zrender/core/LRU~Entry}
   */this.next;/**
   * @type {module:zrender/core/LRU~Entry}
   */this.prev;};/**
 * LRU Cache
 * @constructor
 * @alias module:zrender/core/LRU
 */var LRU=function LRU(maxSize){this._list=new LinkedList();this._map={};this._maxSize=maxSize||10;this._lastRemovedEntry=null;};var LRUProto=LRU.prototype;/**
 * @param  {string} key
 * @param  {} value
 * @return {} Removed value
 */LRUProto.put=function(key,value){var list=this._list;var map=this._map;var removed=null;if(map[key]==null){var len=list.len();// Reuse last removed entry
var entry=this._lastRemovedEntry;if(len>=this._maxSize&&len>0){// Remove the least recently used
var leastUsedEntry=list.head;list.remove(leastUsedEntry);delete map[leastUsedEntry.key];removed=leastUsedEntry.value;this._lastRemovedEntry=leastUsedEntry;}if(entry){entry.value=value;}else{entry=new Entry(value);}entry.key=key;list.insertEntry(entry);map[key]=entry;}return removed;};/**
 * @param  {string} key
 * @return {}
 */LRUProto.get=function(key){var entry=this._map[key];var list=this._list;if(entry!=null){// Put the latest used entry in the tail
if(entry!==list.tail){list.remove(entry);list.insertEntry(entry);}return entry.value;}};/**
 * Clear the cache
 */LRUProto.clear=function(){this._list.clear();this._map={};};var kCSSColorTable={'transparent':[0,0,0,0],'aliceblue':[240,248,255,1],'antiquewhite':[250,235,215,1],'aqua':[0,255,255,1],'aquamarine':[127,255,212,1],'azure':[240,255,255,1],'beige':[245,245,220,1],'bisque':[255,228,196,1],'black':[0,0,0,1],'blanchedalmond':[255,235,205,1],'blue':[0,0,255,1],'blueviolet':[138,43,226,1],'brown':[165,42,42,1],'burlywood':[222,184,135,1],'cadetblue':[95,158,160,1],'chartreuse':[127,255,0,1],'chocolate':[210,105,30,1],'coral':[255,127,80,1],'cornflowerblue':[100,149,237,1],'cornsilk':[255,248,220,1],'crimson':[220,20,60,1],'cyan':[0,255,255,1],'darkblue':[0,0,139,1],'darkcyan':[0,139,139,1],'darkgoldenrod':[184,134,11,1],'darkgray':[169,169,169,1],'darkgreen':[0,100,0,1],'darkgrey':[169,169,169,1],'darkkhaki':[189,183,107,1],'darkmagenta':[139,0,139,1],'darkolivegreen':[85,107,47,1],'darkorange':[255,140,0,1],'darkorchid':[153,50,204,1],'darkred':[139,0,0,1],'darksalmon':[233,150,122,1],'darkseagreen':[143,188,143,1],'darkslateblue':[72,61,139,1],'darkslategray':[47,79,79,1],'darkslategrey':[47,79,79,1],'darkturquoise':[0,206,209,1],'darkviolet':[148,0,211,1],'deeppink':[255,20,147,1],'deepskyblue':[0,191,255,1],'dimgray':[105,105,105,1],'dimgrey':[105,105,105,1],'dodgerblue':[30,144,255,1],'firebrick':[178,34,34,1],'floralwhite':[255,250,240,1],'forestgreen':[34,139,34,1],'fuchsia':[255,0,255,1],'gainsboro':[220,220,220,1],'ghostwhite':[248,248,255,1],'gold':[255,215,0,1],'goldenrod':[218,165,32,1],'gray':[128,128,128,1],'green':[0,128,0,1],'greenyellow':[173,255,47,1],'grey':[128,128,128,1],'honeydew':[240,255,240,1],'hotpink':[255,105,180,1],'indianred':[205,92,92,1],'indigo':[75,0,130,1],'ivory':[255,255,240,1],'khaki':[240,230,140,1],'lavender':[230,230,250,1],'lavenderblush':[255,240,245,1],'lawngreen':[124,252,0,1],'lemonchiffon':[255,250,205,1],'lightblue':[173,216,230,1],'lightcoral':[240,128,128,1],'lightcyan':[224,255,255,1],'lightgoldenrodyellow':[250,250,210,1],'lightgray':[211,211,211,1],'lightgreen':[144,238,144,1],'lightgrey':[211,211,211,1],'lightpink':[255,182,193,1],'lightsalmon':[255,160,122,1],'lightseagreen':[32,178,170,1],'lightskyblue':[135,206,250,1],'lightslategray':[119,136,153,1],'lightslategrey':[119,136,153,1],'lightsteelblue':[176,196,222,1],'lightyellow':[255,255,224,1],'lime':[0,255,0,1],'limegreen':[50,205,50,1],'linen':[250,240,230,1],'magenta':[255,0,255,1],'maroon':[128,0,0,1],'mediumaquamarine':[102,205,170,1],'mediumblue':[0,0,205,1],'mediumorchid':[186,85,211,1],'mediumpurple':[147,112,219,1],'mediumseagreen':[60,179,113,1],'mediumslateblue':[123,104,238,1],'mediumspringgreen':[0,250,154,1],'mediumturquoise':[72,209,204,1],'mediumvioletred':[199,21,133,1],'midnightblue':[25,25,112,1],'mintcream':[245,255,250,1],'mistyrose':[255,228,225,1],'moccasin':[255,228,181,1],'navajowhite':[255,222,173,1],'navy':[0,0,128,1],'oldlace':[253,245,230,1],'olive':[128,128,0,1],'olivedrab':[107,142,35,1],'orange':[255,165,0,1],'orangered':[255,69,0,1],'orchid':[218,112,214,1],'palegoldenrod':[238,232,170,1],'palegreen':[152,251,152,1],'paleturquoise':[175,238,238,1],'palevioletred':[219,112,147,1],'papayawhip':[255,239,213,1],'peachpuff':[255,218,185,1],'peru':[205,133,63,1],'pink':[255,192,203,1],'plum':[221,160,221,1],'powderblue':[176,224,230,1],'purple':[128,0,128,1],'red':[255,0,0,1],'rosybrown':[188,143,143,1],'royalblue':[65,105,225,1],'saddlebrown':[139,69,19,1],'salmon':[250,128,114,1],'sandybrown':[244,164,96,1],'seagreen':[46,139,87,1],'seashell':[255,245,238,1],'sienna':[160,82,45,1],'silver':[192,192,192,1],'skyblue':[135,206,235,1],'slateblue':[106,90,205,1],'slategray':[112,128,144,1],'slategrey':[112,128,144,1],'snow':[255,250,250,1],'springgreen':[0,255,127,1],'steelblue':[70,130,180,1],'tan':[210,180,140,1],'teal':[0,128,128,1],'thistle':[216,191,216,1],'tomato':[255,99,71,1],'turquoise':[64,224,208,1],'violet':[238,130,238,1],'wheat':[245,222,179,1],'white':[255,255,255,1],'whitesmoke':[245,245,245,1],'yellow':[255,255,0,1],'yellowgreen':[154,205,50,1]};function clampCssByte(i){// Clamp to integer 0 .. 255.
i=Math.round(i);// Seems to be what Chrome does (vs truncation).
return i<0?0:i>255?255:i;}function clampCssAngle(i){// Clamp to integer 0 .. 360.
i=Math.round(i);// Seems to be what Chrome does (vs truncation).
return i<0?0:i>360?360:i;}function clampCssFloat(f){// Clamp to float 0.0 .. 1.0.
return f<0?0:f>1?1:f;}function parseCssInt(str){// int or percentage.
if(str.length&&str.charAt(str.length-1)==='%'){return clampCssByte(parseFloat(str)/100*255);}return clampCssByte(parseInt(str,10));}function parseCssFloat(str){// float or percentage.
if(str.length&&str.charAt(str.length-1)==='%'){return clampCssFloat(parseFloat(str)/100);}return clampCssFloat(parseFloat(str));}function cssHueToRgb(m1,m2,h){if(h<0){h+=1;}else if(h>1){h-=1;}if(h*6<1){return m1+(m2-m1)*h*6;}if(h*2<1){return m2;}if(h*3<2){return m1+(m2-m1)*(2/3-h)*6;}return m1;}function lerpNumber(a,b,p){return a+(b-a)*p;}function setRgba(out,r,g,b,a){out[0]=r;out[1]=g;out[2]=b;out[3]=a;return out;}function copyRgba(out,a){out[0]=a[0];out[1]=a[1];out[2]=a[2];out[3]=a[3];return out;}var colorCache=new LRU(20);var lastRemovedArr=null;function putToCache(colorStr,rgbaArr){// Reuse removed array
if(lastRemovedArr){copyRgba(lastRemovedArr,rgbaArr);}lastRemovedArr=colorCache.put(colorStr,lastRemovedArr||rgbaArr.slice());}/**
 * @param {string} colorStr
 * @param {Array.<number>} out
 * @return {Array.<number>}
 * @memberOf module:zrender/util/color
 */function parse(colorStr,rgbaArr){if(!colorStr){return;}rgbaArr=rgbaArr||[];var cached=colorCache.get(colorStr);if(cached){return copyRgba(rgbaArr,cached);}// colorStr may be not string
colorStr=colorStr+'';// Remove all whitespace, not compliant, but should just be more accepting.
var str=colorStr.replace(/ /g,'').toLowerCase();// Color keywords (and transparent) lookup.
if(str in kCSSColorTable){copyRgba(rgbaArr,kCSSColorTable[str]);putToCache(colorStr,rgbaArr);return rgbaArr;}// #abc and #abc123 syntax.
if(str.charAt(0)==='#'){if(str.length===4){var iv=parseInt(str.substr(1),16);// TODO(deanm): Stricter parsing.
if(!(iv>=0&&iv<=0xfff)){setRgba(rgbaArr,0,0,0,1);return;// Covers NaN.
}setRgba(rgbaArr,(iv&0xf00)>>4|(iv&0xf00)>>8,iv&0xf0|(iv&0xf0)>>4,iv&0xf|(iv&0xf)<<4,1);putToCache(colorStr,rgbaArr);return rgbaArr;}else if(str.length===7){var iv=parseInt(str.substr(1),16);// TODO(deanm): Stricter parsing.
if(!(iv>=0&&iv<=0xffffff)){setRgba(rgbaArr,0,0,0,1);return;// Covers NaN.
}setRgba(rgbaArr,(iv&0xff0000)>>16,(iv&0xff00)>>8,iv&0xff,1);putToCache(colorStr,rgbaArr);return rgbaArr;}return;}var op=str.indexOf('('),ep=str.indexOf(')');if(op!==-1&&ep+1===str.length){var fname=str.substr(0,op);var params=str.substr(op+1,ep-(op+1)).split(',');var alpha=1;// To allow case fallthrough.
switch(fname){case'rgba':if(params.length!==4){setRgba(rgbaArr,0,0,0,1);return;}alpha=parseCssFloat(params.pop());// jshint ignore:line
// Fall through.
case'rgb':if(params.length!==3){setRgba(rgbaArr,0,0,0,1);return;}setRgba(rgbaArr,parseCssInt(params[0]),parseCssInt(params[1]),parseCssInt(params[2]),alpha);putToCache(colorStr,rgbaArr);return rgbaArr;case'hsla':if(params.length!==4){setRgba(rgbaArr,0,0,0,1);return;}params[3]=parseCssFloat(params[3]);hsla2rgba(params,rgbaArr);putToCache(colorStr,rgbaArr);return rgbaArr;case'hsl':if(params.length!==3){setRgba(rgbaArr,0,0,0,1);return;}hsla2rgba(params,rgbaArr);putToCache(colorStr,rgbaArr);return rgbaArr;default:return;}}setRgba(rgbaArr,0,0,0,1);return;}/**
 * @param {Array.<number>} hsla
 * @param {Array.<number>} rgba
 * @return {Array.<number>} rgba
 */function hsla2rgba(hsla,rgba){var h=(parseFloat(hsla[0])%360+360)%360/360;// 0 .. 1
// NOTE(deanm): According to the CSS spec s/l should only be
// percentages, but we don't bother and let float or percentage.
var s=parseCssFloat(hsla[1]);var l=parseCssFloat(hsla[2]);var m2=l<=0.5?l*(s+1):l+s-l*s;var m1=l*2-m2;rgba=rgba||[];setRgba(rgba,clampCssByte(cssHueToRgb(m1,m2,h+1/3)*255),clampCssByte(cssHueToRgb(m1,m2,h)*255),clampCssByte(cssHueToRgb(m1,m2,h-1/3)*255),1);if(hsla.length===4){rgba[3]=hsla[3];}return rgba;}/**
 * @param {Array.<number>} rgba
 * @return {Array.<number>} hsla
 */function rgba2hsla(rgba){if(!rgba){return;}// RGB from 0 to 255
var R=rgba[0]/255;var G=rgba[1]/255;var B=rgba[2]/255;var vMin=Math.min(R,G,B);// Min. value of RGB
var vMax=Math.max(R,G,B);// Max. value of RGB
var delta=vMax-vMin;// Delta RGB value
var L=(vMax+vMin)/2;var H;var S;// HSL results from 0 to 1
if(delta===0){H=0;S=0;}else{if(L<0.5){S=delta/(vMax+vMin);}else{S=delta/(2-vMax-vMin);}var deltaR=((vMax-R)/6+delta/2)/delta;var deltaG=((vMax-G)/6+delta/2)/delta;var deltaB=((vMax-B)/6+delta/2)/delta;if(R===vMax){H=deltaB-deltaG;}else if(G===vMax){H=1/3+deltaR-deltaB;}else if(B===vMax){H=2/3+deltaG-deltaR;}if(H<0){H+=1;}if(H>1){H-=1;}}var hsla=[H*360,S,L];if(rgba[3]!=null){hsla.push(rgba[3]);}return hsla;}/**
 * @param {string} color
 * @param {number} level
 * @return {string}
 * @memberOf module:zrender/util/color
 */function lift(color,level){var colorArr=parse(color);if(colorArr){for(var i=0;i<3;i++){if(level<0){colorArr[i]=colorArr[i]*(1-level)|0;}else{colorArr[i]=(255-colorArr[i])*level+colorArr[i]|0;}if(colorArr[i]>255){colorArr[i]=255;}else if(color[i]<0){colorArr[i]=0;}}return stringify(colorArr,colorArr.length===4?'rgba':'rgb');}}/**
 * @param {string} color
 * @return {string}
 * @memberOf module:zrender/util/color
 */function toHex(color){var colorArr=parse(color);if(colorArr){return((1<<24)+(colorArr[0]<<16)+(colorArr[1]<<8)+ +colorArr[2]).toString(16).slice(1);}}/**
 * Map value to color. Faster than lerp methods because color is represented by rgba array.
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<Array.<number>>} colors List of rgba color array
 * @param {Array.<number>} [out] Mapped gba color array
 * @return {Array.<number>} will be null/undefined if input illegal.
 */function fastLerp(normalizedValue,colors,out){if(!(colors&&colors.length)||!(normalizedValue>=0&&normalizedValue<=1)){return;}out=out||[];var value=normalizedValue*(colors.length-1);var leftIndex=Math.floor(value);var rightIndex=Math.ceil(value);var leftColor=colors[leftIndex];var rightColor=colors[rightIndex];var dv=value-leftIndex;out[0]=clampCssByte(lerpNumber(leftColor[0],rightColor[0],dv));out[1]=clampCssByte(lerpNumber(leftColor[1],rightColor[1],dv));out[2]=clampCssByte(lerpNumber(leftColor[2],rightColor[2],dv));out[3]=clampCssFloat(lerpNumber(leftColor[3],rightColor[3],dv));return out;}/**
 * @deprecated
 */var fastMapToColor=fastLerp;/**
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<string>} colors Color list.
 * @param {boolean=} fullOutput Default false.
 * @return {(string|Object)} Result color. If fullOutput,
 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
 * @memberOf module:zrender/util/color
 */function lerp$1(normalizedValue,colors,fullOutput){if(!(colors&&colors.length)||!(normalizedValue>=0&&normalizedValue<=1)){return;}var value=normalizedValue*(colors.length-1);var leftIndex=Math.floor(value);var rightIndex=Math.ceil(value);var leftColor=parse(colors[leftIndex]);var rightColor=parse(colors[rightIndex]);var dv=value-leftIndex;var color=stringify([clampCssByte(lerpNumber(leftColor[0],rightColor[0],dv)),clampCssByte(lerpNumber(leftColor[1],rightColor[1],dv)),clampCssByte(lerpNumber(leftColor[2],rightColor[2],dv)),clampCssFloat(lerpNumber(leftColor[3],rightColor[3],dv))],'rgba');return fullOutput?{color:color,leftIndex:leftIndex,rightIndex:rightIndex,value:value}:color;}/**
 * @deprecated
 */var mapToColor=lerp$1;/**
 * @param {string} color
 * @param {number=} h 0 ~ 360, ignore when null.
 * @param {number=} s 0 ~ 1, ignore when null.
 * @param {number=} l 0 ~ 1, ignore when null.
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */function modifyHSL(color,h,s,l){color=parse(color);if(color){color=rgba2hsla(color);h!=null&&(color[0]=clampCssAngle(h));s!=null&&(color[1]=parseCssFloat(s));l!=null&&(color[2]=parseCssFloat(l));return stringify(hsla2rgba(color),'rgba');}}/**
 * @param {string} color
 * @param {number=} alpha 0 ~ 1
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */function modifyAlpha(color,alpha){color=parse(color);if(color&&alpha!=null){color[3]=clampCssFloat(alpha);return stringify(color,'rgba');}}/**
 * @param {Array.<number>} arrColor like [12,33,44,0.4]
 * @param {string} type 'rgba', 'hsva', ...
 * @return {string} Result color. (If input illegal, return undefined).
 */function stringify(arrColor,type){if(!arrColor||!arrColor.length){return;}var colorStr=arrColor[0]+','+arrColor[1]+','+arrColor[2];if(type==='rgba'||type==='hsva'||type==='hsla'){colorStr+=','+arrColor[3];}return type+'('+colorStr+')';}var color=(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a||Object)({parse:parse,lift:lift,toHex:toHex,fastLerp:fastLerp,fastMapToColor:fastMapToColor,lerp:lerp$1,mapToColor:mapToColor,modifyHSL:modifyHSL,modifyAlpha:modifyAlpha,stringify:stringify});/**
 * @module echarts/animation/Animator
 */var arraySlice=Array.prototype.slice;function defaultGetter(target,key){return target[key];}function defaultSetter(target,key,value){target[key]=value;}/**
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} percent
 * @return {number}
 */function interpolateNumber(p0,p1,percent){return(p1-p0)*percent+p0;}/**
 * @param  {string} p0
 * @param  {string} p1
 * @param  {number} percent
 * @return {string}
 */function interpolateString(p0,p1,percent){return percent>0.5?p1:p0;}/**
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {number} percent
 * @param  {Array} out
 * @param  {number} arrDim
 */function interpolateArray(p0,p1,percent,out,arrDim){var len=p0.length;if(arrDim==1){for(var i=0;i<len;i++){out[i]=interpolateNumber(p0[i],p1[i],percent);}}else{var len2=len&&p0[0].length;for(var i=0;i<len;i++){for(var j=0;j<len2;j++){out[i][j]=interpolateNumber(p0[i][j],p1[i][j],percent);}}}}// arr0 is source array, arr1 is target array.
// Do some preprocess to avoid error happened when interpolating from arr0 to arr1
function fillArr(arr0,arr1,arrDim){var arr0Len=arr0.length;var arr1Len=arr1.length;if(arr0Len!==arr1Len){// FIXME Not work for TypedArray
var isPreviousLarger=arr0Len>arr1Len;if(isPreviousLarger){// Cut the previous
arr0.length=arr1Len;}else{// Fill the previous
for(var i=arr0Len;i<arr1Len;i++){arr0.push(arrDim===1?arr1[i]:arraySlice.call(arr1[i]));}}}// Handling NaN value
var len2=arr0[0]&&arr0[0].length;for(var i=0;i<arr0.length;i++){if(arrDim===1){if(isNaN(arr0[i])){arr0[i]=arr1[i];}}else{for(var j=0;j<len2;j++){if(isNaN(arr0[i][j])){arr0[i][j]=arr1[i][j];}}}}}/**
 * @param  {Array} arr0
 * @param  {Array} arr1
 * @param  {number} arrDim
 * @return {boolean}
 */function isArraySame(arr0,arr1,arrDim){if(arr0===arr1){return true;}var len=arr0.length;if(len!==arr1.length){return false;}if(arrDim===1){for(var i=0;i<len;i++){if(arr0[i]!==arr1[i]){return false;}}}else{var len2=arr0[0].length;for(var i=0;i<len;i++){for(var j=0;j<len2;j++){if(arr0[i][j]!==arr1[i][j]){return false;}}}}return true;}/**
 * Catmull Rom interpolate array
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @param  {Array} out
 * @param  {number} arrDim
 */function catmullRomInterpolateArray(p0,p1,p2,p3,t,t2,t3,out,arrDim){var len=p0.length;if(arrDim==1){for(var i=0;i<len;i++){out[i]=catmullRomInterpolate(p0[i],p1[i],p2[i],p3[i],t,t2,t3);}}else{var len2=p0[0].length;for(var i=0;i<len;i++){for(var j=0;j<len2;j++){out[i][j]=catmullRomInterpolate(p0[i][j],p1[i][j],p2[i][j],p3[i][j],t,t2,t3);}}}}/**
 * Catmull Rom interpolate number
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @return {number}
 */function catmullRomInterpolate(p0,p1,p2,p3,t,t2,t3){var v0=(p2-p0)*0.5;var v1=(p3-p1)*0.5;return(2*(p1-p2)+v0+v1)*t3+(-3*(p1-p2)-2*v0-v1)*t2+v0*t+p1;}function cloneValue(value){if(isArrayLike(value)){var len=value.length;if(isArrayLike(value[0])){var ret=[];for(var i=0;i<len;i++){ret.push(arraySlice.call(value[i]));}return ret;}return arraySlice.call(value);}return value;}function rgba2String(rgba){rgba[0]=Math.floor(rgba[0]);rgba[1]=Math.floor(rgba[1]);rgba[2]=Math.floor(rgba[2]);return'rgba('+rgba.join(',')+')';}function getArrayDim(keyframes){var lastValue=keyframes[keyframes.length-1].value;return isArrayLike(lastValue&&lastValue[0])?2:1;}function createTrackClip(animator,easing,oneTrackDone,keyframes,propName,forceAnimate){var getter=animator._getter;var setter=animator._setter;var useSpline=easing==='spline';var trackLen=keyframes.length;if(!trackLen){return;}// Guess data type
var firstVal=keyframes[0].value;var isValueArray=isArrayLike(firstVal);var isValueColor=false;var isValueString=false;// For vertices morphing
var arrDim=isValueArray?getArrayDim(keyframes):0;var trackMaxTime;// Sort keyframe as ascending
keyframes.sort(function(a,b){return a.time-b.time;});trackMaxTime=keyframes[trackLen-1].time;// Percents of each keyframe
var kfPercents=[];// Value of each keyframe
var kfValues=[];var prevValue=keyframes[0].value;var isAllValueEqual=true;for(var i=0;i<trackLen;i++){kfPercents.push(keyframes[i].time/trackMaxTime);// Assume value is a color when it is a string
var value=keyframes[i].value;// Check if value is equal, deep check if value is array
if(!(isValueArray&&isArraySame(value,prevValue,arrDim)||!isValueArray&&value===prevValue)){isAllValueEqual=false;}prevValue=value;// Try converting a string to a color array
if(typeof value=='string'){var colorArray=parse(value);if(colorArray){value=colorArray;isValueColor=true;}else{isValueString=true;}}kfValues.push(value);}if(!forceAnimate&&isAllValueEqual){return;}var lastValue=kfValues[trackLen-1];// Polyfill array and NaN value
for(var i=0;i<trackLen-1;i++){if(isValueArray){fillArr(kfValues[i],lastValue,arrDim);}else{if(isNaN(kfValues[i])&&!isNaN(lastValue)&&!isValueString&&!isValueColor){kfValues[i]=lastValue;}}}isValueArray&&fillArr(getter(animator._target,propName),lastValue,arrDim);// Cache the key of last frame to speed up when
// animation playback is sequency
var lastFrame=0;var lastFramePercent=0;var start;var w;var p0;var p1;var p2;var p3;if(isValueColor){var rgba=[0,0,0,0];}var onframe=function onframe(target,percent){// Find the range keyframes
// kf1-----kf2---------current--------kf3
// find kf2 and kf3 and do interpolation
var frame;// In the easing function like elasticOut, percent may less than 0
if(percent<0){frame=0;}else if(percent<lastFramePercent){// Start from next key
// PENDING start from lastFrame ?
start=Math.min(lastFrame+1,trackLen-1);for(frame=start;frame>=0;frame--){if(kfPercents[frame]<=percent){break;}}// PENDING really need to do this ?
frame=Math.min(frame,trackLen-2);}else{for(frame=lastFrame;frame<trackLen;frame++){if(kfPercents[frame]>percent){break;}}frame=Math.min(frame-1,trackLen-2);}lastFrame=frame;lastFramePercent=percent;var range=kfPercents[frame+1]-kfPercents[frame];if(range===0){return;}else{w=(percent-kfPercents[frame])/range;}if(useSpline){p1=kfValues[frame];p0=kfValues[frame===0?frame:frame-1];p2=kfValues[frame>trackLen-2?trackLen-1:frame+1];p3=kfValues[frame>trackLen-3?trackLen-1:frame+2];if(isValueArray){catmullRomInterpolateArray(p0,p1,p2,p3,w,w*w,w*w*w,getter(target,propName),arrDim);}else{var value;if(isValueColor){value=catmullRomInterpolateArray(p0,p1,p2,p3,w,w*w,w*w*w,rgba,1);value=rgba2String(rgba);}else if(isValueString){// String is step(0.5)
return interpolateString(p1,p2,w);}else{value=catmullRomInterpolate(p0,p1,p2,p3,w,w*w,w*w*w);}setter(target,propName,value);}}else{if(isValueArray){interpolateArray(kfValues[frame],kfValues[frame+1],w,getter(target,propName),arrDim);}else{var value;if(isValueColor){interpolateArray(kfValues[frame],kfValues[frame+1],w,rgba,1);value=rgba2String(rgba);}else if(isValueString){// String is step(0.5)
return interpolateString(kfValues[frame],kfValues[frame+1],w);}else{value=interpolateNumber(kfValues[frame],kfValues[frame+1],w);}setter(target,propName,value);}}};var clip=new Clip({target:animator._target,life:trackMaxTime,loop:animator._loop,delay:animator._delay,onframe:onframe,ondestroy:oneTrackDone});if(easing&&easing!=='spline'){clip.easing=easing;}return clip;}/**
 * @alias module:zrender/animation/Animator
 * @constructor
 * @param {Object} target
 * @param {boolean} loop
 * @param {Function} getter
 * @param {Function} setter
 */var Animator=function Animator(target,loop,getter,setter){this._tracks={};this._target=target;this._loop=loop||false;this._getter=getter||defaultGetter;this._setter=setter||defaultSetter;this._clipCount=0;this._delay=0;this._doneList=[];this._onframeList=[];this._clipList=[];};Animator.prototype={/**
   * 设置动画关键帧
   * @param  {number} time 关键帧时间，单位是ms
   * @param  {Object} props 关键帧的属性值，key-value表示
   * @return {module:zrender/animation/Animator}
   */when:function when(time/* ms */,props){var tracks=this._tracks;for(var propName in props){if(!props.hasOwnProperty(propName)){continue;}if(!tracks[propName]){tracks[propName]=[];// Invalid value
var value=this._getter(this._target,propName);if(value==null){// zrLog('Invalid property ' + propName);
continue;}// If time is 0
//  Then props is given initialize value
// Else
//  Initialize value from current prop value
if(time!==0){tracks[propName].push({time:0,value:cloneValue(value)});}}tracks[propName].push({time:time,value:props[propName]});}return this;},/**
   * 添加动画每一帧的回调函数
   * @param  {Function} callback
   * @return {module:zrender/animation/Animator}
   */during:function during(callback){this._onframeList.push(callback);return this;},pause:function pause(){for(var i=0;i<this._clipList.length;i++){this._clipList[i].pause();}this._paused=true;},resume:function resume(){for(var i=0;i<this._clipList.length;i++){this._clipList[i].resume();}this._paused=false;},isPaused:function isPaused(){return!!this._paused;},_doneCallback:function _doneCallback(){// Clear all tracks
this._tracks={};// Clear all clips
this._clipList.length=0;var doneList=this._doneList;var len=doneList.length;for(var i=0;i<len;i++){doneList[i].call(this);}},/**
   * 开始执行动画
   * @param  {string|Function} [easing]
   *         动画缓动函数，详见{@link module:zrender/animation/easing}
   * @param  {boolean} forceAnimate
   * @return {module:zrender/animation/Animator}
   */start:function start(easing,forceAnimate){var self=this;var clipCount=0;var oneTrackDone=function oneTrackDone(){clipCount--;if(!clipCount){self._doneCallback();}};var lastClip;for(var propName in this._tracks){if(!this._tracks.hasOwnProperty(propName)){continue;}var clip=createTrackClip(this,easing,oneTrackDone,this._tracks[propName],propName,forceAnimate);if(clip){this._clipList.push(clip);clipCount++;// If start after added to animation
if(this.animation){this.animation.addClip(clip);}lastClip=clip;}}// Add during callback on the last clip
if(lastClip){var oldOnFrame=lastClip.onframe;lastClip.onframe=function(target,percent){oldOnFrame(target,percent);for(var i=0;i<self._onframeList.length;i++){self._onframeList[i](target,percent);}};}// This optimization will help the case that in the upper application
// the view may be refreshed frequently, where animation will be
// called repeatly but nothing changed.
if(!clipCount){this._doneCallback();}return this;},/**
   * 停止动画
   * @param {boolean} forwardToLast If move to last frame before stop
   */stop:function stop(forwardToLast){var clipList=this._clipList;var animation=this.animation;for(var i=0;i<clipList.length;i++){var clip=clipList[i];if(forwardToLast){// Move to last frame before stop
clip.onframe(this._target,1);}animation&&animation.removeClip(clip);}clipList.length=0;},/**
   * 设置动画延迟开始的时间
   * @param  {number} time 单位ms
   * @return {module:zrender/animation/Animator}
   */delay:function delay(time){this._delay=time;return this;},/**
   * 添加动画结束的回调
   * @param  {Function} cb
   * @return {module:zrender/animation/Animator}
   */done:function done(cb){if(cb){this._doneList.push(cb);}return this;},/**
   * @return {Array.<module:zrender/animation/Clip>}
   */getClips:function getClips(){return this._clipList;}};var dpr=1;// If in browser environment
if(typeof window!=='undefined'){dpr=Math.max(window.devicePixelRatio||1,1);}/**
 * config默认配置项
 * @exports zrender/config
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *//**
 * debug日志选项：catchBrushException为true下有效
 * 0 : 不生成debug数据，发布用
 * 1 : 异常抛出，调试用
 * 2 : 控制台输出，调试用
 */var debugMode=0;// retina 屏幕优化
var devicePixelRatio=dpr;var log=function log(){};if(debugMode===1){log=function log(){for(var k in arguments){throw new Error(arguments[k]);}};}else if(debugMode>1){log=function log(){for(var k in arguments){console.log(arguments[k]);}};}var zrLog=log;/**
 * @alias modue:zrender/mixin/Animatable
 * @constructor
 */var Animatable=function Animatable(){/**
   * @type {Array.<module:zrender/animation/Animator>}
   * @readOnly
   */this.animators=[];};Animatable.prototype={constructor:Animatable,/**
   * 动画
   *
   * @param {string} path The path to fetch value from object, like 'a.b.c'.
   * @param {boolean} [loop] Whether to loop animation.
   * @return {module:zrender/animation/Animator}
   * @example:
   *     el.animate('style', false)
   *         .when(1000, {x: 10} )
   *         .done(function(){ // Animation done })
   *         .start()
   */animate:function animate(path,loop){var target;var animatingShape=false;var el=this;var zr=this.__zr;if(path){var pathSplitted=path.split('.');var prop=el;// If animating shape
animatingShape=pathSplitted[0]==='shape';for(var i=0,l=pathSplitted.length;i<l;i++){if(!prop){continue;}prop=prop[pathSplitted[i]];}if(prop){target=prop;}}else{target=el;}if(!target){zrLog('Property "'+path+'" is not existed in element '+el.id);return;}var animators=el.animators;var animator=new Animator(target,loop);animator.during(function(target){el.dirty(animatingShape);}).done(function(){// FIXME Animator will not be removed if use `Animator#stop` to stop animation
animators.splice(indexOf(animators,animator),1);});animators.push(animator);// If animate after added to the zrender
if(zr){zr.animation.addAnimator(animator);}return animator;},/**
   * 停止动画
   * @param {boolean} forwardToLast If move to last frame before stop
   */stopAnimation:function stopAnimation(forwardToLast){var animators=this.animators;var len=animators.length;for(var i=0;i<len;i++){animators[i].stop(forwardToLast);}animators.length=0;return this;},/**
   * Caution: this method will stop previous animation.
   * So do not use this method to one element twice before
   * animation starts, unless you know what you are doing.
   * @param {Object} target
   * @param {number} [time=500] Time in ms
   * @param {string} [easing='linear']
   * @param {number} [delay=0]
   * @param {Function} [callback]
   * @param {Function} [forceAnimate] Prevent stop animation and callback
   *        immediently when target values are the same as current values.
   *
   * @example
   *  // Animate position
   *  el.animateTo({
   *      position: [10, 10]
   *  }, function () { // done })
   *
   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
   *  el.animateTo({
   *      shape: {
   *          width: 500
   *      },
   *      style: {
   *          fill: 'red'
   *      }
   *      position: [10, 10]
   *  }, 100, 100, 'cubicOut', function () { // done })
   */// TODO Return animation key
animateTo:function animateTo(target,time,delay,easing,callback,forceAnimate){// animateTo(target, time, easing, callback);
if(isString(delay)){callback=easing;easing=delay;delay=0;}// animateTo(target, time, delay, callback);
else if(isFunction$1(easing)){callback=easing;easing='linear';delay=0;}// animateTo(target, time, callback);
else if(isFunction$1(delay)){callback=delay;delay=0;}// animateTo(target, callback)
else if(isFunction$1(time)){callback=time;time=500;}// animateTo(target)
else if(!time){time=500;}// Stop all previous animations
this.stopAnimation();this._animateToShallow('',this,target,time,delay);// Animators may be removed immediately after start
// if there is nothing to animate
var animators=this.animators.slice();var count=animators.length;function done(){count--;if(!count){callback&&callback();}}// No animators. This should be checked before animators[i].start(),
// because 'done' may be executed immediately if no need to animate.
if(!count){callback&&callback();}// Start after all animators created
// Incase any animator is done immediately when all animation properties are not changed
for(var i=0;i<animators.length;i++){animators[i].done(done).start(easing,forceAnimate);}},/**
   * @private
   * @param {string} path=''
   * @param {Object} source=this
   * @param {Object} target
   * @param {number} [time=500]
   * @param {number} [delay=0]
   *
   * @example
   *  // Animate position
   *  el._animateToShallow({
   *      position: [10, 10]
   *  })
   *
   *  // Animate shape, style and position in 100ms, delayed 100ms
   *  el._animateToShallow({
   *      shape: {
   *          width: 500
   *      },
   *      style: {
   *          fill: 'red'
   *      }
   *      position: [10, 10]
   *  }, 100, 100)
   */_animateToShallow:function _animateToShallow(path,source,target,time,delay){var objShallow={};var propertyCount=0;for(var name in target){if(!target.hasOwnProperty(name)){continue;}if(source[name]!=null){if(isObject$1(target[name])&&!isArrayLike(target[name])){this._animateToShallow(path?path+'.'+name:name,source[name],target[name],time,delay);}else{objShallow[name]=target[name];propertyCount++;}}else if(target[name]!=null){// Attr directly if not has property
// FIXME, if some property not needed for element ?
if(!path){this.attr(name,target[name]);}else{// Shape or style
var props={};props[path]={};props[path][name]=target[name];this.attr(props);}}}if(propertyCount>0){this.animate(path,false).when(time==null?500:time,objShallow).delay(delay||0);}return this;}};/**
 * @alias module:zrender/Element
 * @constructor
 * @extends {module:zrender/mixin/Animatable}
 * @extends {module:zrender/mixin/Transformable}
 * @extends {module:zrender/mixin/Eventful}
 */var Element=function Element(opts){// jshint ignore:line
Transformable.call(this,opts);Eventful.call(this,opts);Animatable.call(this,opts);/**
   * 画布元素ID
   * @type {string}
   */this.id=opts.id||guid();};Element.prototype={/**
   * 元素类型
   * Element type
   * @type {string}
   */type:'element',/**
   * 元素名字
   * Element name
   * @type {string}
   */name:'',/**
   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
   * ZRender instance will be assigned when element is associated with zrender
   * @name module:/zrender/Element#__zr
   * @type {module:zrender/ZRender}
   */__zr:null,/**
   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
   * If ignore drawing and events of the element object
   * @name module:/zrender/Element#ignore
   * @type {boolean}
   * @default false
   */ignore:false,/**
   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
   * 该路径会继承被裁减对象的变换
   * @type {module:zrender/graphic/Path}
   * @see http://www.w3.org/TR/2dcontext/#clipping-region
   * @readOnly
   */clipPath:null,/**
   * 是否是 Group
   * @type {boolean}
   */isGroup:false,/**
   * Drift element
   * @param  {number} dx dx on the global space
   * @param  {number} dy dy on the global space
   */drift:function drift(dx,dy){switch(this.draggable){case'horizontal':dy=0;break;case'vertical':dx=0;break;}var m=this.transform;if(!m){m=this.transform=[1,0,0,1,0,0];}m[4]+=dx;m[5]+=dy;this.decomposeTransform();this.dirty(false);},/**
   * Hook before update
   */beforeUpdate:function beforeUpdate(){},/**
   * Hook after update
   */afterUpdate:function afterUpdate(){},/**
   * Update each frame
   */update:function update(){this.updateTransform();},/**
   * @param  {Function} cb
   * @param  {}   context
   */traverse:function traverse(cb,context){},/**
   * @protected
   */attrKV:function attrKV(key,value){if(key==='position'||key==='scale'||key==='origin'){// Copy the array
if(value){var target=this[key];if(!target){target=this[key]=[];}target[0]=value[0];target[1]=value[1];}}else{this[key]=value;}},/**
   * Hide the element
   */hide:function hide(){this.ignore=true;this.__zr&&this.__zr.refresh();},/**
   * Show the element
   */show:function show(){this.ignore=false;this.__zr&&this.__zr.refresh();},/**
   * @param {string|Object} key
   * @param {*} value
   */attr:function attr(key,value){if(typeof key==='string'){this.attrKV(key,value);}else if(isObject$1(key)){for(var name in key){if(key.hasOwnProperty(name)){this.attrKV(name,key[name]);}}}this.dirty(false);return this;},/**
   * @param {module:zrender/graphic/Path} clipPath
   */setClipPath:function setClipPath(clipPath){var zr=this.__zr;if(zr){clipPath.addSelfToZr(zr);}// Remove previous clip path
if(this.clipPath&&this.clipPath!==clipPath){this.removeClipPath();}this.clipPath=clipPath;clipPath.__zr=zr;clipPath.__clipTarget=this;this.dirty(false);},/**
   */removeClipPath:function removeClipPath(){var clipPath=this.clipPath;if(clipPath){if(clipPath.__zr){clipPath.removeSelfFromZr(clipPath.__zr);}clipPath.__zr=null;clipPath.__clipTarget=null;this.clipPath=null;this.dirty(false);}},/**
   * Add self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */addSelfToZr:function addSelfToZr(zr){this.__zr=zr;// 添加动画
var animators=this.animators;if(animators){for(var i=0;i<animators.length;i++){zr.animation.addAnimator(animators[i]);}}if(this.clipPath){this.clipPath.addSelfToZr(zr);}},/**
   * Remove self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */removeSelfFromZr:function removeSelfFromZr(zr){this.__zr=null;// 移除动画
var animators=this.animators;if(animators){for(var i=0;i<animators.length;i++){zr.animation.removeAnimator(animators[i]);}}if(this.clipPath){this.clipPath.removeSelfFromZr(zr);}}};mixin(Element,Animatable);mixin(Element,Transformable);mixin(Element,Eventful);/**
 * @module echarts/core/BoundingRect
 */var v2ApplyTransform=applyTransform;var mathMin=Math.min;var mathMax=Math.max;/**
 * @alias module:echarts/core/BoundingRect
 */function BoundingRect(x,y,width,height){if(width<0){x=x+width;width=-width;}if(height<0){y=y+height;height=-height;}/**
   * @type {number}
   */this.x=x;/**
   * @type {number}
   */this.y=y;/**
   * @type {number}
   */this.width=width;/**
   * @type {number}
   */this.height=height;}BoundingRect.prototype={constructor:BoundingRect,/**
   * @param {module:echarts/core/BoundingRect} other
   */union:function union(other){var x=mathMin(other.x,this.x);var y=mathMin(other.y,this.y);this.width=mathMax(other.x+other.width,this.x+this.width)-x;this.height=mathMax(other.y+other.height,this.y+this.height)-y;this.x=x;this.y=y;},/**
   * @param {Array.<number>} m
   * @methods
   */applyTransform:function(){var lt=[];var rb=[];var lb=[];var rt=[];return function(m){// In case usage like this
// el.getBoundingRect().applyTransform(el.transform)
// And element has no transform
if(!m){return;}lt[0]=lb[0]=this.x;lt[1]=rt[1]=this.y;rb[0]=rt[0]=this.x+this.width;rb[1]=lb[1]=this.y+this.height;v2ApplyTransform(lt,lt,m);v2ApplyTransform(rb,rb,m);v2ApplyTransform(lb,lb,m);v2ApplyTransform(rt,rt,m);this.x=mathMin(lt[0],rb[0],lb[0],rt[0]);this.y=mathMin(lt[1],rb[1],lb[1],rt[1]);var maxX=mathMax(lt[0],rb[0],lb[0],rt[0]);var maxY=mathMax(lt[1],rb[1],lb[1],rt[1]);this.width=maxX-this.x;this.height=maxY-this.y;};}(),/**
   * Calculate matrix of transforming from self to target rect
   * @param  {module:zrender/core/BoundingRect} b
   * @return {Array.<number>}
   */calculateTransform:function calculateTransform(b){var a=this;var sx=b.width/a.width;var sy=b.height/a.height;var m=create$1();// 矩阵右乘
translate(m,m,[-a.x,-a.y]);scale$1(m,m,[sx,sy]);translate(m,m,[b.x,b.y]);return m;},/**
   * @param {(module:echarts/core/BoundingRect|Object)} b
   * @return {boolean}
   */intersect:function intersect(b){if(!b){return false;}if(!(b instanceof BoundingRect)){// Normalize negative width/height.
b=BoundingRect.create(b);}var a=this;var ax0=a.x;var ax1=a.x+a.width;var ay0=a.y;var ay1=a.y+a.height;var bx0=b.x;var bx1=b.x+b.width;var by0=b.y;var by1=b.y+b.height;return!(ax1<bx0||bx1<ax0||ay1<by0||by1<ay0);},contain:function contain(x,y){var rect=this;return x>=rect.x&&x<=rect.x+rect.width&&y>=rect.y&&y<=rect.y+rect.height;},/**
   * @return {module:echarts/core/BoundingRect}
   */clone:function clone(){return new BoundingRect(this.x,this.y,this.width,this.height);},/**
   * Copy from another rect
   */copy:function copy(other){this.x=other.x;this.y=other.y;this.width=other.width;this.height=other.height;},plain:function plain(){return{x:this.x,y:this.y,width:this.width,height:this.height};}};/**
 * @param {Object|module:zrender/core/BoundingRect} rect
 * @param {number} rect.x
 * @param {number} rect.y
 * @param {number} rect.width
 * @param {number} rect.height
 * @return {module:zrender/core/BoundingRect}
 */BoundingRect.create=function(rect){return new BoundingRect(rect.x,rect.y,rect.width,rect.height);};/**
 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
 * @module zrender/graphic/Group
 * @example
 *     var Group = require('zrender/container/Group');
 *     var Circle = require('zrender/graphic/shape/Circle');
 *     var g = new Group();
 *     g.position[0] = 100;
 *     g.position[1] = 100;
 *     g.add(new Circle({
 *         style: {
 *             x: 100,
 *             y: 100,
 *             r: 20,
 *         }
 *     }));
 *     zr.add(g);
 *//**
 * @alias module:zrender/graphic/Group
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @extends module:zrender/mixin/Eventful
 */var Group=function Group(opts){opts=opts||{};Element.call(this,opts);for(var key in opts){if(opts.hasOwnProperty(key)){this[key]=opts[key];}}this._children=[];this.__storage=null;this.__dirty=true;};Group.prototype={constructor:Group,isGroup:true,/**
   * @type {string}
   */type:'group',/**
   * 所有子孙元素是否响应鼠标事件
   * @name module:/zrender/container/Group#silent
   * @type {boolean}
   * @default false
   */silent:false,/**
   * @return {Array.<module:zrender/Element>}
   */children:function children(){return this._children.slice();},/**
   * 获取指定 index 的儿子节点
   * @param  {number} idx
   * @return {module:zrender/Element}
   */childAt:function childAt(idx){return this._children[idx];},/**
   * 获取指定名字的儿子节点
   * @param  {string} name
   * @return {module:zrender/Element}
   */childOfName:function childOfName(name){var children=this._children;for(var i=0;i<children.length;i++){if(children[i].name===name){return children[i];}}},/**
   * @return {number}
   */childCount:function childCount(){return this._children.length;},/**
   * 添加子节点到最后
   * @param {module:zrender/Element} child
   */add:function add(child){if(child&&child!==this&&child.parent!==this){this._children.push(child);this._doAdd(child);}return this;},/**
   * 添加子节点在 nextSibling 之前
   * @param {module:zrender/Element} child
   * @param {module:zrender/Element} nextSibling
   */addBefore:function addBefore(child,nextSibling){if(child&&child!==this&&child.parent!==this&&nextSibling&&nextSibling.parent===this){var children=this._children;var idx=children.indexOf(nextSibling);if(idx>=0){children.splice(idx,0,child);this._doAdd(child);}}return this;},_doAdd:function _doAdd(child){if(child.parent){child.parent.remove(child);}child.parent=this;var storage=this.__storage;var zr=this.__zr;if(storage&&storage!==child.__storage){storage.addToStorage(child);if(child instanceof Group){child.addChildrenToStorage(storage);}}zr&&zr.refresh();},/**
   * 移除子节点
   * @param {module:zrender/Element} child
   */remove:function remove(child){var zr=this.__zr;var storage=this.__storage;var children=this._children;var idx=indexOf(children,child);if(idx<0){return this;}children.splice(idx,1);child.parent=null;if(storage){storage.delFromStorage(child);if(child instanceof Group){child.delChildrenFromStorage(storage);}}zr&&zr.refresh();return this;},/**
   * 移除所有子节点
   */removeAll:function removeAll(){var children=this._children;var storage=this.__storage;var child;var i;for(i=0;i<children.length;i++){child=children[i];if(storage){storage.delFromStorage(child);if(child instanceof Group){child.delChildrenFromStorage(storage);}}child.parent=null;}children.length=0;return this;},/**
   * 遍历所有子节点
   * @param  {Function} cb
   * @param  {}   context
   */eachChild:function eachChild(cb,context){var children=this._children;for(var i=0;i<children.length;i++){var child=children[i];cb.call(context,child,i);}return this;},/**
   * 深度优先遍历所有子孙节点
   * @param  {Function} cb
   * @param  {}   context
   */traverse:function traverse(cb,context){for(var i=0;i<this._children.length;i++){var child=this._children[i];cb.call(context,child);if(child.type==='group'){child.traverse(cb,context);}}return this;},addChildrenToStorage:function addChildrenToStorage(storage){for(var i=0;i<this._children.length;i++){var child=this._children[i];storage.addToStorage(child);if(child instanceof Group){child.addChildrenToStorage(storage);}}},delChildrenFromStorage:function delChildrenFromStorage(storage){for(var i=0;i<this._children.length;i++){var child=this._children[i];storage.delFromStorage(child);if(child instanceof Group){child.delChildrenFromStorage(storage);}}},dirty:function dirty(){this.__dirty=true;this.__zr&&this.__zr.refresh();return this;},/**
   * @return {module:zrender/core/BoundingRect}
   */getBoundingRect:function getBoundingRect(includeChildren){// TODO Caching
var rect=null;var tmpRect=new BoundingRect(0,0,0,0);var children=includeChildren||this._children;var tmpMat=[];for(var i=0;i<children.length;i++){var child=children[i];if(child.ignore||child.invisible){continue;}var childRect=child.getBoundingRect();var transform=child.getLocalTransform(tmpMat);// TODO
// The boundingRect cacluated by transforming original
// rect may be bigger than the actual bundingRect when rotation
// is used. (Consider a circle rotated aginst its center, where
// the actual boundingRect should be the same as that not be
// rotated.) But we can not find better approach to calculate
// actual boundingRect yet, considering performance.
if(transform){tmpRect.copy(childRect);tmpRect.applyTransform(transform);rect=rect||tmpRect.clone();rect.union(tmpRect);}else{rect=rect||childRect.clone();rect.union(childRect);}}return rect||tmpRect;}};inherits(Group,Element);// https://github.com/mziccard/node-timsort
var DEFAULT_MIN_MERGE=32;var DEFAULT_MIN_GALLOPING=7;function minRunLength(n){var r=0;while(n>=DEFAULT_MIN_MERGE){r|=n&1;n>>=1;}return n+r;}function makeAscendingRun(array,lo,hi,compare){var runHi=lo+1;if(runHi===hi){return 1;}if(compare(array[runHi++],array[lo])<0){while(runHi<hi&&compare(array[runHi],array[runHi-1])<0){runHi++;}reverseRun(array,lo,runHi);}else{while(runHi<hi&&compare(array[runHi],array[runHi-1])>=0){runHi++;}}return runHi-lo;}function reverseRun(array,lo,hi){hi--;while(lo<hi){var t=array[lo];array[lo++]=array[hi];array[hi--]=t;}}function binaryInsertionSort(array,lo,hi,start,compare){if(start===lo){start++;}for(;start<hi;start++){var pivot=array[start];var left=lo;var right=start;var mid;while(left<right){mid=left+right>>>1;if(compare(pivot,array[mid])<0){right=mid;}else{left=mid+1;}}var n=start-left;switch(n){case 3:array[left+3]=array[left+2];case 2:array[left+2]=array[left+1];case 1:array[left+1]=array[left];break;default:while(n>0){array[left+n]=array[left+n-1];n--;}}array[left]=pivot;}}function gallopLeft(value,array,start,length,hint,compare){var lastOffset=0;var maxOffset=0;var offset=1;if(compare(value,array[start+hint])>0){maxOffset=length-hint;while(offset<maxOffset&&compare(value,array[start+hint+offset])>0){lastOffset=offset;offset=(offset<<1)+1;if(offset<=0){offset=maxOffset;}}if(offset>maxOffset){offset=maxOffset;}lastOffset+=hint;offset+=hint;}else{maxOffset=hint+1;while(offset<maxOffset&&compare(value,array[start+hint-offset])<=0){lastOffset=offset;offset=(offset<<1)+1;if(offset<=0){offset=maxOffset;}}if(offset>maxOffset){offset=maxOffset;}var tmp=lastOffset;lastOffset=hint-offset;offset=hint-tmp;}lastOffset++;while(lastOffset<offset){var m=lastOffset+(offset-lastOffset>>>1);if(compare(value,array[start+m])>0){lastOffset=m+1;}else{offset=m;}}return offset;}function gallopRight(value,array,start,length,hint,compare){var lastOffset=0;var maxOffset=0;var offset=1;if(compare(value,array[start+hint])<0){maxOffset=hint+1;while(offset<maxOffset&&compare(value,array[start+hint-offset])<0){lastOffset=offset;offset=(offset<<1)+1;if(offset<=0){offset=maxOffset;}}if(offset>maxOffset){offset=maxOffset;}var tmp=lastOffset;lastOffset=hint-offset;offset=hint-tmp;}else{maxOffset=length-hint;while(offset<maxOffset&&compare(value,array[start+hint+offset])>=0){lastOffset=offset;offset=(offset<<1)+1;if(offset<=0){offset=maxOffset;}}if(offset>maxOffset){offset=maxOffset;}lastOffset+=hint;offset+=hint;}lastOffset++;while(lastOffset<offset){var m=lastOffset+(offset-lastOffset>>>1);if(compare(value,array[start+m])<0){offset=m;}else{lastOffset=m+1;}}return offset;}function TimSort(array,compare){var minGallop=DEFAULT_MIN_GALLOPING;var runStart;var runLength;var stackSize=0;var tmp=[];runStart=[];runLength=[];function pushRun(_runStart,_runLength){runStart[stackSize]=_runStart;runLength[stackSize]=_runLength;stackSize+=1;}function mergeRuns(){while(stackSize>1){var n=stackSize-2;if(n>=1&&runLength[n-1]<=runLength[n]+runLength[n+1]||n>=2&&runLength[n-2]<=runLength[n]+runLength[n-1]){if(runLength[n-1]<runLength[n+1]){n--;}}else if(runLength[n]>runLength[n+1]){break;}mergeAt(n);}}function forceMergeRuns(){while(stackSize>1){var n=stackSize-2;if(n>0&&runLength[n-1]<runLength[n+1]){n--;}mergeAt(n);}}function mergeAt(i){var start1=runStart[i];var length1=runLength[i];var start2=runStart[i+1];var length2=runLength[i+1];runLength[i]=length1+length2;if(i===stackSize-3){runStart[i+1]=runStart[i+2];runLength[i+1]=runLength[i+2];}stackSize--;var k=gallopRight(array[start2],array,start1,length1,0,compare);start1+=k;length1-=k;if(length1===0){return;}length2=gallopLeft(array[start1+length1-1],array,start2,length2,length2-1,compare);if(length2===0){return;}if(length1<=length2){mergeLow(start1,length1,start2,length2);}else{mergeHigh(start1,length1,start2,length2);}}function mergeLow(start1,length1,start2,length2){var i=0;for(i=0;i<length1;i++){tmp[i]=array[start1+i];}var cursor1=0;var cursor2=start2;var dest=start1;array[dest++]=array[cursor2++];if(--length2===0){for(i=0;i<length1;i++){array[dest+i]=tmp[cursor1+i];}return;}if(length1===1){for(i=0;i<length2;i++){array[dest+i]=array[cursor2+i];}array[dest+length2]=tmp[cursor1];return;}var _minGallop=minGallop;var count1,count2,exit;while(1){count1=0;count2=0;exit=false;do{if(compare(array[cursor2],tmp[cursor1])<0){array[dest++]=array[cursor2++];count2++;count1=0;if(--length2===0){exit=true;break;}}else{array[dest++]=tmp[cursor1++];count1++;count2=0;if(--length1===1){exit=true;break;}}}while((count1|count2)<_minGallop);if(exit){break;}do{count1=gallopRight(array[cursor2],tmp,cursor1,length1,0,compare);if(count1!==0){for(i=0;i<count1;i++){array[dest+i]=tmp[cursor1+i];}dest+=count1;cursor1+=count1;length1-=count1;if(length1<=1){exit=true;break;}}array[dest++]=array[cursor2++];if(--length2===0){exit=true;break;}count2=gallopLeft(tmp[cursor1],array,cursor2,length2,0,compare);if(count2!==0){for(i=0;i<count2;i++){array[dest+i]=array[cursor2+i];}dest+=count2;cursor2+=count2;length2-=count2;if(length2===0){exit=true;break;}}array[dest++]=tmp[cursor1++];if(--length1===1){exit=true;break;}_minGallop--;}while(count1>=DEFAULT_MIN_GALLOPING||count2>=DEFAULT_MIN_GALLOPING);if(exit){break;}if(_minGallop<0){_minGallop=0;}_minGallop+=2;}minGallop=_minGallop;minGallop<1&&(minGallop=1);if(length1===1){for(i=0;i<length2;i++){array[dest+i]=array[cursor2+i];}array[dest+length2]=tmp[cursor1];}else if(length1===0){throw new Error();// throw new Error('mergeLow preconditions were not respected');
}else{for(i=0;i<length1;i++){array[dest+i]=tmp[cursor1+i];}}}function mergeHigh(start1,length1,start2,length2){var i=0;for(i=0;i<length2;i++){tmp[i]=array[start2+i];}var cursor1=start1+length1-1;var cursor2=length2-1;var dest=start2+length2-1;var customCursor=0;var customDest=0;array[dest--]=array[cursor1--];if(--length1===0){customCursor=dest-(length2-1);for(i=0;i<length2;i++){array[customCursor+i]=tmp[i];}return;}if(length2===1){dest-=length1;cursor1-=length1;customDest=dest+1;customCursor=cursor1+1;for(i=length1-1;i>=0;i--){array[customDest+i]=array[customCursor+i];}array[dest]=tmp[cursor2];return;}var _minGallop=minGallop;while(true){var count1=0;var count2=0;var exit=false;do{if(compare(tmp[cursor2],array[cursor1])<0){array[dest--]=array[cursor1--];count1++;count2=0;if(--length1===0){exit=true;break;}}else{array[dest--]=tmp[cursor2--];count2++;count1=0;if(--length2===1){exit=true;break;}}}while((count1|count2)<_minGallop);if(exit){break;}do{count1=length1-gallopRight(tmp[cursor2],array,start1,length1,length1-1,compare);if(count1!==0){dest-=count1;cursor1-=count1;length1-=count1;customDest=dest+1;customCursor=cursor1+1;for(i=count1-1;i>=0;i--){array[customDest+i]=array[customCursor+i];}if(length1===0){exit=true;break;}}array[dest--]=tmp[cursor2--];if(--length2===1){exit=true;break;}count2=length2-gallopLeft(array[cursor1],tmp,0,length2,length2-1,compare);if(count2!==0){dest-=count2;cursor2-=count2;length2-=count2;customDest=dest+1;customCursor=cursor2+1;for(i=0;i<count2;i++){array[customDest+i]=tmp[customCursor+i];}if(length2<=1){exit=true;break;}}array[dest--]=array[cursor1--];if(--length1===0){exit=true;break;}_minGallop--;}while(count1>=DEFAULT_MIN_GALLOPING||count2>=DEFAULT_MIN_GALLOPING);if(exit){break;}if(_minGallop<0){_minGallop=0;}_minGallop+=2;}minGallop=_minGallop;if(minGallop<1){minGallop=1;}if(length2===1){dest-=length1;cursor1-=length1;customDest=dest+1;customCursor=cursor1+1;for(i=length1-1;i>=0;i--){array[customDest+i]=array[customCursor+i];}array[dest]=tmp[cursor2];}else if(length2===0){throw new Error();// throw new Error('mergeHigh preconditions were not respected');
}else{customCursor=dest-(length2-1);for(i=0;i<length2;i++){array[customCursor+i]=tmp[i];}}}this.mergeRuns=mergeRuns;this.forceMergeRuns=forceMergeRuns;this.pushRun=pushRun;}function sort(array,compare,lo,hi){if(!lo){lo=0;}if(!hi){hi=array.length;}var remaining=hi-lo;if(remaining<2){return;}var runLength=0;if(remaining<DEFAULT_MIN_MERGE){runLength=makeAscendingRun(array,lo,hi,compare);binaryInsertionSort(array,lo,hi,lo+runLength,compare);return;}var ts=new TimSort(array,compare);var minRun=minRunLength(remaining);do{runLength=makeAscendingRun(array,lo,hi,compare);if(runLength<minRun){var force=remaining;if(force>minRun){force=minRun;}binaryInsertionSort(array,lo,lo+force,lo+runLength,compare);runLength=force;}ts.pushRun(lo,runLength);ts.mergeRuns();remaining-=runLength;lo+=runLength;}while(remaining!==0);ts.forceMergeRuns();}// https://jsfiddle.net/pissang/jr4x7mdm/8/
function shapeCompareFunc(a,b){if(a.zlevel===b.zlevel){if(a.z===b.z){// if (a.z2 === b.z2) {
//     // FIXME Slow has renderidx compare
//     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
//     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
//     return a.__renderidx - b.__renderidx;
// }
return a.z2-b.z2;}return a.z-b.z;}return a.zlevel-b.zlevel;}/**
 * 内容仓库 (M)
 * @alias module:zrender/Storage
 * @constructor
 */var Storage=function Storage(){// jshint ignore:line
this._roots=[];this._displayList=[];this._displayListLen=0;};Storage.prototype={constructor:Storage,/**
   * @param  {Function} cb
   *
   */traverse:function traverse(cb,context){for(var i=0;i<this._roots.length;i++){this._roots[i].traverse(cb,context);}},/**
   * 返回所有图形的绘制队列
   * @param {boolean} [update=false] 是否在返回前更新该数组
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
   *
   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
   * @return {Array.<module:zrender/graphic/Displayable>}
   */getDisplayList:function getDisplayList(update,includeIgnore){includeIgnore=includeIgnore||false;if(update){this.updateDisplayList(includeIgnore);}return this._displayList;},/**
   * 更新图形的绘制队列。
   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
   */updateDisplayList:function updateDisplayList(includeIgnore){this._displayListLen=0;var roots=this._roots;var displayList=this._displayList;for(var i=0,len=roots.length;i<len;i++){this._updateAndAddDisplayable(roots[i],null,includeIgnore);}displayList.length=this._displayListLen;env$1.canvasSupported&&sort(displayList,shapeCompareFunc);},_updateAndAddDisplayable:function _updateAndAddDisplayable(el,clipPaths,includeIgnore){if(el.ignore&&!includeIgnore){return;}el.beforeUpdate();if(el.__dirty){el.update();}el.afterUpdate();var userSetClipPath=el.clipPath;if(userSetClipPath){// FIXME 效率影响
if(clipPaths){clipPaths=clipPaths.slice();}else{clipPaths=[];}var currentClipPath=userSetClipPath;var parentClipPath=el;// Recursively add clip path
while(currentClipPath){// clipPath 的变换是基于使用这个 clipPath 的元素
currentClipPath.parent=parentClipPath;currentClipPath.updateTransform();clipPaths.push(currentClipPath);parentClipPath=currentClipPath;currentClipPath=currentClipPath.clipPath;}}if(el.isGroup){var children=el._children;for(var i=0;i<children.length;i++){var child=children[i];// Force to mark as dirty if group is dirty
// FIXME __dirtyPath ?
if(el.__dirty){child.__dirty=true;}this._updateAndAddDisplayable(child,clipPaths,includeIgnore);}// Mark group clean here
el.__dirty=false;}else{el.__clipPaths=clipPaths;this._displayList[this._displayListLen++]=el;}},/**
   * 添加图形(Shape)或者组(Group)到根节点
   * @param {module:zrender/Element} el
   */addRoot:function addRoot(el){if(el.__storage===this){return;}if(el instanceof Group){el.addChildrenToStorage(this);}this.addToStorage(el);this._roots.push(el);},/**
   * 删除指定的图形(Shape)或者组(Group)
   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
   */delRoot:function delRoot(el){if(el==null){// 不指定el清空
for(var i=0;i<this._roots.length;i++){var root=this._roots[i];if(root instanceof Group){root.delChildrenFromStorage(this);}}this._roots=[];this._displayList=[];this._displayListLen=0;return;}if(el instanceof Array){for(var i=0,l=el.length;i<l;i++){this.delRoot(el[i]);}return;}var idx=indexOf(this._roots,el);if(idx>=0){this.delFromStorage(el);this._roots.splice(idx,1);if(el instanceof Group){el.delChildrenFromStorage(this);}}},addToStorage:function addToStorage(el){if(el){el.__storage=this;el.dirty(false);}return this;},delFromStorage:function delFromStorage(el){if(el){el.__storage=null;}return this;},/**
   * 清空并且释放Storage
   */dispose:function dispose(){this._renderList=this._roots=null;},displayableSortFunc:shapeCompareFunc};var SHADOW_PROPS={'shadowBlur':1,'shadowOffsetX':1,'shadowOffsetY':1,'textShadowBlur':1,'textShadowOffsetX':1,'textShadowOffsetY':1,'textBoxShadowBlur':1,'textBoxShadowOffsetX':1,'textBoxShadowOffsetY':1};var fixShadow=function fixShadow(ctx,propName,value){if(SHADOW_PROPS.hasOwnProperty(propName)){return value*=ctx.dpr;}return value;};var STYLE_COMMON_PROPS=[['shadowBlur',0],['shadowOffsetX',0],['shadowOffsetY',0],['shadowColor','#000'],['lineCap','butt'],['lineJoin','miter'],['miterLimit',10]];// var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);
var Style=function Style(opts,host){this.extendFrom(opts,false);this.host=host;};function createLinearGradient(ctx,obj,rect){var x=obj.x==null?0:obj.x;var x2=obj.x2==null?1:obj.x2;var y=obj.y==null?0:obj.y;var y2=obj.y2==null?0:obj.y2;if(!obj.global){x=x*rect.width+rect.x;x2=x2*rect.width+rect.x;y=y*rect.height+rect.y;y2=y2*rect.height+rect.y;}// Fix NaN when rect is Infinity
x=isNaN(x)?0:x;x2=isNaN(x2)?1:x2;y=isNaN(y)?0:y;y2=isNaN(y2)?0:y2;var canvasGradient=ctx.createLinearGradient(x,y,x2,y2);return canvasGradient;}function createRadialGradient(ctx,obj,rect){var width=rect.width;var height=rect.height;var min=Math.min(width,height);var x=obj.x==null?0.5:obj.x;var y=obj.y==null?0.5:obj.y;var r=obj.r==null?0.5:obj.r;if(!obj.global){x=x*width+rect.x;y=y*height+rect.y;r=r*min;}var canvasGradient=ctx.createRadialGradient(x,y,0,x,y,r);return canvasGradient;}Style.prototype={constructor:Style,/**
   * @type {module:zrender/graphic/Displayable}
   */host:null,/**
   * @type {string}
   */fill:'#000',/**
   * @type {string}
   */stroke:null,/**
   * @type {number}
   */opacity:1,/**
   * @type {Array.<number>}
   */lineDash:null,/**
   * @type {number}
   */lineDashOffset:0,/**
   * @type {number}
   */shadowBlur:0,/**
   * @type {number}
   */shadowOffsetX:0,/**
   * @type {number}
   */shadowOffsetY:0,/**
   * @type {number}
   */lineWidth:1,/**
   * If stroke ignore scale
   * @type {Boolean}
   */strokeNoScale:false,// Bounding rect text configuration
// Not affected by element transform
/**
   * @type {string}
   */text:null,/**
   * If `fontSize` or `fontFamily` exists, `font` will be reset by
   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
   * So do not visit it directly in upper application (like echarts),
   * but use `contain/text#makeFont` instead.
   * @type {string}
   */font:null,/**
   * The same as font. Use font please.
   * @deprecated
   * @type {string}
   */textFont:null,/**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */fontStyle:null,/**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */fontWeight:null,/**
   * It helps merging respectively, rather than parsing an entire font string.
   * Should be 12 but not '12px'.
   * @type {number}
   */fontSize:null,/**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */fontFamily:null,/**
   * Reserved for special functinality, like 'hr'.
   * @type {string}
   */textTag:null,/**
   * @type {string}
   */textFill:'#000',/**
   * @type {string}
   */textStroke:null,/**
   * @type {number}
   */textWidth:null,/**
   * Only for textBackground.
   * @type {number}
   */textHeight:null,/**
   * textStroke may be set as some color as a default
   * value in upper applicaion, where the default value
   * of textStrokeWidth should be 0 to make sure that
   * user can choose to do not use text stroke.
   * @type {number}
   */textStrokeWidth:0,/**
   * @type {number}
   */textLineHeight:null,/**
   * 'inside', 'left', 'right', 'top', 'bottom'
   * [x, y]
   * Based on x, y of rect.
   * @type {string|Array.<number>}
   * @default 'inside'
   */textPosition:'inside',/**
   * If not specified, use the boundingRect of a `displayable`.
   * @type {Object}
   */textRect:null,/**
   * [x, y]
   * @type {Array.<number>}
   */textOffset:null,/**
   * @type {string}
   */textAlign:null,/**
   * @type {string}
   */textVerticalAlign:null,/**
   * @type {number}
   */textDistance:5,/**
   * @type {string}
   */textShadowColor:'transparent',/**
   * @type {number}
   */textShadowBlur:0,/**
   * @type {number}
   */textShadowOffsetX:0,/**
   * @type {number}
   */textShadowOffsetY:0,/**
   * @type {string}
   */textBoxShadowColor:'transparent',/**
   * @type {number}
   */textBoxShadowBlur:0,/**
   * @type {number}
   */textBoxShadowOffsetX:0,/**
   * @type {number}
   */textBoxShadowOffsetY:0,/**
   * Whether transform text.
   * Only useful in Path and Image element
   * @type {boolean}
   */transformText:false,/**
   * Text rotate around position of Path or Image
   * Only useful in Path and Image element and transformText is false.
   */textRotation:0,/**
   * Text origin of text rotation, like [10, 40].
   * Based on x, y of rect.
   * Useful in label rotation of circular symbol.
   * By default, this origin is textPosition.
   * Can be 'center'.
   * @type {string|Array.<number>}
   */textOrigin:null,/**
   * @type {string}
   */textBackgroundColor:null,/**
   * @type {string}
   */textBorderColor:null,/**
   * @type {number}
   */textBorderWidth:0,/**
   * @type {number}
   */textBorderRadius:0,/**
   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
   * @type {number|Array.<number>}
   */textPadding:null,/**
   * Text styles for rich text.
   * @type {Object}
   */rich:null,/**
   * {outerWidth, outerHeight, ellipsis, placeholder}
   * @type {Object}
   */truncate:null,/**
   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
   * @type {string}
   */blend:null,/**
   * @param {CanvasRenderingContext2D} ctx
   */bind:function bind(ctx,el,prevEl){var style=this;var prevStyle=prevEl&&prevEl.style;var firstDraw=!prevStyle;for(var i=0;i<STYLE_COMMON_PROPS.length;i++){var prop=STYLE_COMMON_PROPS[i];var styleName=prop[0];if(firstDraw||style[styleName]!==prevStyle[styleName]){// FIXME Invalid property value will cause style leak from previous element.
ctx[styleName]=fixShadow(ctx,styleName,style[styleName]||prop[1]);}}if(firstDraw||style.fill!==prevStyle.fill){ctx.fillStyle=style.fill;}if(firstDraw||style.stroke!==prevStyle.stroke){ctx.strokeStyle=style.stroke;}if(firstDraw||style.opacity!==prevStyle.opacity){ctx.globalAlpha=style.opacity==null?1:style.opacity;}if(firstDraw||style.blend!==prevStyle.blend){ctx.globalCompositeOperation=style.blend||'source-over';}if(this.hasStroke()){var lineWidth=style.lineWidth;ctx.lineWidth=lineWidth/(this.strokeNoScale&&el&&el.getLineScale?el.getLineScale():1);}},hasFill:function hasFill(){var fill=this.fill;return fill!=null&&fill!=='none';},hasStroke:function hasStroke(){var stroke=this.stroke;return stroke!=null&&stroke!=='none'&&this.lineWidth>0;},/**
   * Extend from other style
   * @param {zrender/graphic/Style} otherStyle
   * @param {boolean} overwrite true: overwrirte any way.
   *                            false: overwrite only when !target.hasOwnProperty
   *                            others: overwrite when property is not null/undefined.
   */extendFrom:function extendFrom(otherStyle,overwrite){if(otherStyle){for(var name in otherStyle){if(otherStyle.hasOwnProperty(name)&&(overwrite===true||(overwrite===false?!this.hasOwnProperty(name):otherStyle[name]!=null))){this[name]=otherStyle[name];}}}},/**
   * Batch setting style with a given object
   * @param {Object|string} obj
   * @param {*} [obj]
   */set:function set(obj,value){if(typeof obj==='string'){this[obj]=value;}else{this.extendFrom(obj,true);}},/**
   * Clone
   * @return {zrender/graphic/Style} [description]
   */clone:function clone(){var newStyle=new this.constructor();newStyle.extendFrom(this,true);return newStyle;},getGradient:function getGradient(ctx,obj,rect){var method=obj.type==='radial'?createRadialGradient:createLinearGradient;var canvasGradient=method(ctx,obj,rect);var colorStops=obj.colorStops;for(var i=0;i<colorStops.length;i++){canvasGradient.addColorStop(colorStops[i].offset,colorStops[i].color);}return canvasGradient;}};var styleProto=Style.prototype;for(var i=0;i<STYLE_COMMON_PROPS.length;i++){var prop=STYLE_COMMON_PROPS[i];if(!(prop[0]in styleProto)){styleProto[prop[0]]=prop[1];}}// Provide for others
Style.getGradient=styleProto.getGradient;var Pattern=function Pattern(image,repeat){// Should do nothing more in this constructor. Because gradient can be
// declard by `color: {image: ...}`, where this constructor will not be called.
this.image=image;this.repeat=repeat;// Can be cloned
this.type='pattern';};Pattern.prototype.getCanvasPattern=function(ctx){return ctx.createPattern(this.image,this.repeat||'repeat');};/**
 * @module zrender/Layer
 * @author pissang(https://www.github.com/pissang)
 */function returnFalse(){return false;}/**
 * 创建dom
 *
 * @inner
 * @param {string} id dom id 待用
 * @param {Painter} painter painter instance
 * @param {number} number
 */function createDom(id,painter,dpr){var newDom=createCanvas();var width=painter.getWidth();var height=painter.getHeight();var newDomStyle=newDom.style;if(newDomStyle){// In node or some other non-browser environment
newDomStyle.position='absolute';newDomStyle.left=0;newDomStyle.top=0;newDomStyle.width=width+'px';newDomStyle.height=height+'px';newDom.setAttribute('data-zr-dom-id',id);}newDom.width=width*dpr;newDom.height=height*dpr;return newDom;}/**
 * @alias module:zrender/Layer
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @param {string} id
 * @param {module:zrender/Painter} painter
 * @param {number} [dpr]
 */var Layer=function Layer(id,painter,dpr){var dom;dpr=dpr||devicePixelRatio;if(typeof id==='string'){dom=createDom(id,painter,dpr);}// Not using isDom because in node it will return false
else if(isObject$1(id)){dom=id;id=dom.id;}this.id=id;this.dom=dom;var domStyle=dom.style;if(domStyle){// Not in node
dom.onselectstart=returnFalse;// 避免页面选中的尴尬
domStyle['-webkit-user-select']='none';domStyle['user-select']='none';domStyle['-webkit-touch-callout']='none';domStyle['-webkit-tap-highlight-color']='rgba(0,0,0,0)';domStyle['padding']=0;domStyle['margin']=0;domStyle['border-width']=0;}this.domBack=null;this.ctxBack=null;this.painter=painter;this.config=null;// Configs
/**
   * 每次清空画布的颜色
   * @type {string}
   * @default 0
   */this.clearColor=0;/**
   * 是否开启动态模糊
   * @type {boolean}
   * @default false
   */this.motionBlur=false;/**
   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   * @type {number}
   * @default 0.7
   */this.lastFrameAlpha=0.7;/**
   * Layer dpr
   * @type {number}
   */this.dpr=dpr;};Layer.prototype={constructor:Layer,__dirty:true,__used:false,__drawIndex:0,__startIndex:0,__endIndex:0,incremental:false,getElementCount:function getElementCount(){return this.__endIndex-this.__startIndex;},initContext:function initContext(){this.ctx=this.dom.getContext('2d');this.ctx.dpr=this.dpr;},createBackBuffer:function createBackBuffer(){var dpr=this.dpr;this.domBack=createDom('back-'+this.id,this.painter,dpr);this.ctxBack=this.domBack.getContext('2d');if(dpr!=1){this.ctxBack.scale(dpr,dpr);}},/**
   * @param  {number} width
   * @param  {number} height
   */resize:function resize(width,height){var dpr=this.dpr;var dom=this.dom;var domStyle=dom.style;var domBack=this.domBack;if(domStyle){domStyle.width=width+'px';domStyle.height=height+'px';}dom.width=width*dpr;dom.height=height*dpr;if(domBack){domBack.width=width*dpr;domBack.height=height*dpr;if(dpr!=1){this.ctxBack.scale(dpr,dpr);}}},/**
   * 清空该层画布
   * @param {boolean} [clearAll]=false Clear all with out motion blur
   * @param {Color} [clearColor]
   */clear:function clear(clearAll,clearColor){var dom=this.dom;var ctx=this.ctx;var width=dom.width;var height=dom.height;var clearColor=clearColor||this.clearColor;var haveMotionBLur=this.motionBlur&&!clearAll;var lastFrameAlpha=this.lastFrameAlpha;var dpr=this.dpr;if(haveMotionBLur){if(!this.domBack){this.createBackBuffer();}this.ctxBack.globalCompositeOperation='copy';this.ctxBack.drawImage(dom,0,0,width/dpr,height/dpr);}ctx.clearRect(0,0,width,height);if(clearColor&&clearColor!=='transparent'){var clearColorGradientOrPattern;// Gradient
if(clearColor.colorStops){// Cache canvas gradient
clearColorGradientOrPattern=clearColor.__canvasGradient||Style.getGradient(ctx,clearColor,{x:0,y:0,width:width,height:height});clearColor.__canvasGradient=clearColorGradientOrPattern;}// Pattern
else if(clearColor.image){clearColorGradientOrPattern=Pattern.prototype.getCanvasPattern.call(clearColor,ctx);}ctx.save();ctx.fillStyle=clearColorGradientOrPattern||clearColor;ctx.fillRect(0,0,width,height);ctx.restore();}if(haveMotionBLur){var domBack=this.domBack;ctx.save();ctx.globalAlpha=lastFrameAlpha;ctx.drawImage(domBack,0,0,width,height);ctx.restore();}}};var requestAnimationFrame=typeof window!=='undefined'&&(window.requestAnimationFrame&&window.requestAnimationFrame.bind(window)||// https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
window.msRequestAnimationFrame&&window.msRequestAnimationFrame.bind(window)||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame)||function(func){setTimeout(func,16);};var globalImageCache=new LRU(50);/**
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */function findExistImage(newImageOrSrc){if(typeof newImageOrSrc==='string'){var cachedImgObj=globalImageCache.get(newImageOrSrc);return cachedImgObj&&cachedImgObj.image;}else{return newImageOrSrc;}}/**
 * Caution: User should cache loaded images, but not just count on LRU.
 * Consider if required images more than LRU size, will dead loop occur?
 *
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
 * @param {Function} [cb] params: (image, cbPayload)
 * @param {Object} [cbPayload] Payload on cb calling.
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */function createOrUpdateImage(newImageOrSrc,image,hostEl,cb,cbPayload){if(!newImageOrSrc){return image;}else if(typeof newImageOrSrc==='string'){// Image should not be loaded repeatly.
if(image&&image.__zrImageSrc===newImageOrSrc||!hostEl){return image;}// Only when there is no existent image or existent image src
// is different, this method is responsible for load.
var cachedImgObj=globalImageCache.get(newImageOrSrc);var pendingWrap={hostEl:hostEl,cb:cb,cbPayload:cbPayload};if(cachedImgObj){image=cachedImgObj.image;!isImageReady(image)&&cachedImgObj.pending.push(pendingWrap);}else{!image&&(image=new Image());image.onload=imageOnLoad;globalImageCache.put(newImageOrSrc,image.__cachedImgObj={image:image,pending:[pendingWrap]});image.src=image.__zrImageSrc=newImageOrSrc;}return image;}// newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
else{return newImageOrSrc;}}function imageOnLoad(){var cachedImgObj=this.__cachedImgObj;this.onload=this.__cachedImgObj=null;for(var i=0;i<cachedImgObj.pending.length;i++){var pendingWrap=cachedImgObj.pending[i];var cb=pendingWrap.cb;cb&&cb(this,pendingWrap.cbPayload);pendingWrap.hostEl.dirty();}cachedImgObj.pending.length=0;}function isImageReady(image){return image&&image.width&&image.height;}var textWidthCache={};var textWidthCacheCounter=0;var TEXT_CACHE_MAX=5000;var STYLE_REG=/\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;var DEFAULT_FONT='12px sans-serif';// Avoid assign to an exported variable, for transforming to cjs.
var methods$1={};/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {number} width
 */function getWidth(text,font){font=font||DEFAULT_FONT;var key=text+':'+font;if(textWidthCache[key]){return textWidthCache[key];}var textLines=(text+'').split('\n');var width=0;for(var i=0,l=textLines.length;i<l;i++){// textContain.measureText may be overrided in SVG or VML
width=Math.max(measureText(textLines[i],font).width,width);}if(textWidthCacheCounter>TEXT_CACHE_MAX){textWidthCacheCounter=0;textWidthCache={};}textWidthCacheCounter++;textWidthCache[key]=width;return width;}/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {string} [textAlign='left']
 * @param {string} [textVerticalAlign='top']
 * @param {Array.<number>} [textPadding]
 * @param {Object} [rich]
 * @param {Object} [truncate]
 * @return {Object} {x, y, width, height, lineHeight}
 */function _getBoundingRect(text,font,textAlign,textVerticalAlign,textPadding,rich,truncate){return rich?getRichTextRect(text,font,textAlign,textVerticalAlign,textPadding,rich,truncate):getPlainTextRect(text,font,textAlign,textVerticalAlign,textPadding,truncate);}function getPlainTextRect(text,font,textAlign,textVerticalAlign,textPadding,truncate){var contentBlock=parsePlainText(text,font,textPadding,truncate);var outerWidth=getWidth(text,font);if(textPadding){outerWidth+=textPadding[1]+textPadding[3];}var outerHeight=contentBlock.outerHeight;var x=adjustTextX(0,outerWidth,textAlign);var y=adjustTextY(0,outerHeight,textVerticalAlign);var rect=new BoundingRect(x,y,outerWidth,outerHeight);rect.lineHeight=contentBlock.lineHeight;return rect;}function getRichTextRect(text,font,textAlign,textVerticalAlign,textPadding,rich,truncate){var contentBlock=parseRichText(text,{rich:rich,truncate:truncate,font:font,textAlign:textAlign,textPadding:textPadding});var outerWidth=contentBlock.outerWidth;var outerHeight=contentBlock.outerHeight;var x=adjustTextX(0,outerWidth,textAlign);var y=adjustTextY(0,outerHeight,textVerticalAlign);return new BoundingRect(x,y,outerWidth,outerHeight);}/**
 * @public
 * @param {number} x
 * @param {number} width
 * @param {string} [textAlign='left']
 * @return {number} Adjusted x.
 */function adjustTextX(x,width,textAlign){// FIXME Right to left language
if(textAlign==='right'){x-=width;}else if(textAlign==='center'){x-=width/2;}return x;}/**
 * @public
 * @param {number} y
 * @param {number} height
 * @param {string} [textVerticalAlign='top']
 * @return {number} Adjusted y.
 */function adjustTextY(y,height,textVerticalAlign){if(textVerticalAlign==='middle'){y-=height/2;}else if(textVerticalAlign==='bottom'){y-=height;}return y;}/**
 * @public
 * @param {stirng} textPosition
 * @param {Object} rect {x, y, width, height}
 * @param {number} distance
 * @return {Object} {x, y, textAlign, textVerticalAlign}
 */function adjustTextPositionOnRect(textPosition,rect,distance){var x=rect.x;var y=rect.y;var height=rect.height;var width=rect.width;var halfHeight=height/2;var textAlign='left';var textVerticalAlign='top';switch(textPosition){case'left':x-=distance;y+=halfHeight;textAlign='right';textVerticalAlign='middle';break;case'right':x+=distance+width;y+=halfHeight;textVerticalAlign='middle';break;case'top':x+=width/2;y-=distance;textAlign='center';textVerticalAlign='bottom';break;case'bottom':x+=width/2;y+=height+distance;textAlign='center';break;case'inside':x+=width/2;y+=halfHeight;textAlign='center';textVerticalAlign='middle';break;case'insideLeft':x+=distance;y+=halfHeight;textVerticalAlign='middle';break;case'insideRight':x+=width-distance;y+=halfHeight;textAlign='right';textVerticalAlign='middle';break;case'insideTop':x+=width/2;y+=distance;textAlign='center';break;case'insideBottom':x+=width/2;y+=height-distance;textAlign='center';textVerticalAlign='bottom';break;case'insideTopLeft':x+=distance;y+=distance;break;case'insideTopRight':x+=width-distance;y+=distance;textAlign='right';break;case'insideBottomLeft':x+=distance;y+=height-distance;textVerticalAlign='bottom';break;case'insideBottomRight':x+=width-distance;y+=height-distance;textAlign='right';textVerticalAlign='bottom';break;}return{x:x,y:y,textAlign:textAlign,textVerticalAlign:textVerticalAlign};}/**
 * Show ellipsis if overflow.
 *
 * @public
 * @param  {string} text
 * @param  {string} containerWidth
 * @param  {string} font
 * @param  {number} [ellipsis='...']
 * @param  {Object} [options]
 * @param  {number} [options.maxIterations=3]
 * @param  {number} [options.minChar=0] If truncate result are less
 *                  then minChar, ellipsis will not show, which is
 *                  better for user hint in some cases.
 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
 * @return {string}
 */function truncateText(text,containerWidth,font,ellipsis,options){if(!containerWidth){return'';}var textLines=(text+'').split('\n');options=prepareTruncateOptions(containerWidth,font,ellipsis,options);// FIXME
// It is not appropriate that every line has '...' when truncate multiple lines.
for(var i=0,len=textLines.length;i<len;i++){textLines[i]=truncateSingleLine(textLines[i],options);}return textLines.join('\n');}function prepareTruncateOptions(containerWidth,font,ellipsis,options){options=extend({},options);options.font=font;var ellipsis=retrieve2(ellipsis,'...');options.maxIterations=retrieve2(options.maxIterations,2);var minChar=options.minChar=retrieve2(options.minChar,0);// FIXME
// Other languages?
options.cnCharWidth=getWidth('国',font);// FIXME
// Consider proportional font?
var ascCharWidth=options.ascCharWidth=getWidth('a',font);options.placeholder=retrieve2(options.placeholder,'');// Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
// Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.
var contentWidth=containerWidth=Math.max(0,containerWidth-1);// Reserve some gap.
for(var i=0;i<minChar&&contentWidth>=ascCharWidth;i++){contentWidth-=ascCharWidth;}var ellipsisWidth=getWidth(ellipsis);if(ellipsisWidth>contentWidth){ellipsis='';ellipsisWidth=0;}contentWidth=containerWidth-ellipsisWidth;options.ellipsis=ellipsis;options.ellipsisWidth=ellipsisWidth;options.contentWidth=contentWidth;options.containerWidth=containerWidth;return options;}function truncateSingleLine(textLine,options){var containerWidth=options.containerWidth;var font=options.font;var contentWidth=options.contentWidth;if(!containerWidth){return'';}var lineWidth=getWidth(textLine,font);if(lineWidth<=containerWidth){return textLine;}for(var j=0;;j++){if(lineWidth<=contentWidth||j>=options.maxIterations){textLine+=options.ellipsis;break;}var subLength=j===0?estimateLength(textLine,contentWidth,options.ascCharWidth,options.cnCharWidth):lineWidth>0?Math.floor(textLine.length*contentWidth/lineWidth):0;textLine=textLine.substr(0,subLength);lineWidth=getWidth(textLine,font);}if(textLine===''){textLine=options.placeholder;}return textLine;}function estimateLength(text,contentWidth,ascCharWidth,cnCharWidth){var width=0;var i=0;for(var len=text.length;i<len&&width<contentWidth;i++){var charCode=text.charCodeAt(i);width+=0<=charCode&&charCode<=127?ascCharWidth:cnCharWidth;}return i;}/**
 * @public
 * @param {string} font
 * @return {number} line height
 */function getLineHeight(font){// FIXME A rough approach.
return getWidth('国',font);}/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {Object} width
 */function measureText(text,font){return methods$1.measureText(text,font);}// Avoid assign to an exported variable, for transforming to cjs.
methods$1.measureText=function(text,font){var ctx=getContext();ctx.font=font||DEFAULT_FONT;return ctx.measureText(text);};/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {Object} [truncate]
 * @return {Object} block: {lineHeight, lines, height, outerHeight}
 *  Notice: for performance, do not calculate outerWidth util needed.
 */function parsePlainText(text,font,padding,truncate){text!=null&&(text+='');var lineHeight=getLineHeight(font);var lines=text?text.split('\n'):[];var height=lines.length*lineHeight;var outerHeight=height;if(padding){outerHeight+=padding[0]+padding[2];}if(text&&truncate){var truncOuterHeight=truncate.outerHeight;var truncOuterWidth=truncate.outerWidth;if(truncOuterHeight!=null&&outerHeight>truncOuterHeight){text='';lines=[];}else if(truncOuterWidth!=null){var options=prepareTruncateOptions(truncOuterWidth-(padding?padding[1]+padding[3]:0),font,truncate.ellipsis,{minChar:truncate.minChar,placeholder:truncate.placeholder});// FIXME
// It is not appropriate that every line has '...' when truncate multiple lines.
for(var i=0,len=lines.length;i<len;i++){lines[i]=truncateSingleLine(lines[i],options);}}}return{lines:lines,height:height,outerHeight:outerHeight,lineHeight:lineHeight};}/**
 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
 *
 * @public
 * @param {string} text
 * @param {Object} style
 * @return {Object} block
 * {
 *      width,
 *      height,
 *      lines: [{
 *          lineHeight,
 *          width,
 *          tokens: [[{
 *              styleName,
 *              text,
 *              width,      // include textPadding
 *              height,     // include textPadding
 *              textWidth, // pure text width
 *              textHeight, // pure text height
 *              lineHeihgt,
 *              font,
 *              textAlign,
 *              textVerticalAlign
 *          }], [...], ...]
 *      }, ...]
 * }
 * If styleName is undefined, it is plain text.
 */function parseRichText(text,style){var contentBlock={lines:[],width:0,height:0};text!=null&&(text+='');if(!text){return contentBlock;}var lastIndex=STYLE_REG.lastIndex=0;var result;while((result=STYLE_REG.exec(text))!=null){var matchedIndex=result.index;if(matchedIndex>lastIndex){pushTokens(contentBlock,text.substring(lastIndex,matchedIndex));}pushTokens(contentBlock,result[2],result[1]);lastIndex=STYLE_REG.lastIndex;}if(lastIndex<text.length){pushTokens(contentBlock,text.substring(lastIndex,text.length));}var lines=contentBlock.lines;var contentHeight=0;var contentWidth=0;// For `textWidth: 100%`
var pendingList=[];var stlPadding=style.textPadding;var truncate=style.truncate;var truncateWidth=truncate&&truncate.outerWidth;var truncateHeight=truncate&&truncate.outerHeight;if(stlPadding){truncateWidth!=null&&(truncateWidth-=stlPadding[1]+stlPadding[3]);truncateHeight!=null&&(truncateHeight-=stlPadding[0]+stlPadding[2]);}// Calculate layout info of tokens.
for(var i=0;i<lines.length;i++){var line=lines[i];var lineHeight=0;var lineWidth=0;for(var j=0;j<line.tokens.length;j++){var token=line.tokens[j];var tokenStyle=token.styleName&&style.rich[token.styleName]||{};// textPadding should not inherit from style.
var textPadding=token.textPadding=tokenStyle.textPadding;// textFont has been asigned to font by `normalizeStyle`.
var font=token.font=tokenStyle.font||style.font;// textHeight can be used when textVerticalAlign is specified in token.
var tokenHeight=token.textHeight=retrieve2(// textHeight should not be inherited, consider it can be specified
// as box height of the block.
tokenStyle.textHeight,getLineHeight(font));textPadding&&(tokenHeight+=textPadding[0]+textPadding[2]);token.height=tokenHeight;token.lineHeight=retrieve3(tokenStyle.textLineHeight,style.textLineHeight,tokenHeight);token.textAlign=tokenStyle&&tokenStyle.textAlign||style.textAlign;token.textVerticalAlign=tokenStyle&&tokenStyle.textVerticalAlign||'middle';if(truncateHeight!=null&&contentHeight+token.lineHeight>truncateHeight){return{lines:[],width:0,height:0};}token.textWidth=getWidth(token.text,font);var tokenWidth=tokenStyle.textWidth;var tokenWidthNotSpecified=tokenWidth==null||tokenWidth==='auto';// Percent width, can be `100%`, can be used in drawing separate
// line when box width is needed to be auto.
if(typeof tokenWidth==='string'&&tokenWidth.charAt(tokenWidth.length-1)==='%'){token.percentWidth=tokenWidth;pendingList.push(token);tokenWidth=0;// Do not truncate in this case, because there is no user case
// and it is too complicated.
}else{if(tokenWidthNotSpecified){tokenWidth=token.textWidth;// FIXME: If image is not loaded and textWidth is not specified, calling
// `getBoundingRect()` will not get correct result.
var textBackgroundColor=tokenStyle.textBackgroundColor;var bgImg=textBackgroundColor&&textBackgroundColor.image;// Use cases:
// (1) If image is not loaded, it will be loaded at render phase and call
// `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
// image, and then the right size will be calculated here at the next tick.
// See `graphic/helper/text.js`.
// (2) If image loaded, and `textBackgroundColor.image` is image src string,
// use `imageHelper.findExistImage` to find cached image.
// `imageHelper.findExistImage` will always be called here before
// `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
// which ensures that image will not be rendered before correct size calcualted.
if(bgImg){bgImg=findExistImage(bgImg);if(isImageReady(bgImg)){tokenWidth=Math.max(tokenWidth,bgImg.width*tokenHeight/bgImg.height);}}}var paddingW=textPadding?textPadding[1]+textPadding[3]:0;tokenWidth+=paddingW;var remianTruncWidth=truncateWidth!=null?truncateWidth-lineWidth:null;if(remianTruncWidth!=null&&remianTruncWidth<tokenWidth){if(!tokenWidthNotSpecified||remianTruncWidth<paddingW){token.text='';token.textWidth=tokenWidth=0;}else{token.text=truncateText(token.text,remianTruncWidth-paddingW,font,truncate.ellipsis,{minChar:truncate.minChar});token.textWidth=getWidth(token.text,font);tokenWidth=token.textWidth+paddingW;}}}lineWidth+=token.width=tokenWidth;tokenStyle&&(lineHeight=Math.max(lineHeight,token.lineHeight));}line.width=lineWidth;line.lineHeight=lineHeight;contentHeight+=lineHeight;contentWidth=Math.max(contentWidth,lineWidth);}contentBlock.outerWidth=contentBlock.width=retrieve2(style.textWidth,contentWidth);contentBlock.outerHeight=contentBlock.height=retrieve2(style.textHeight,contentHeight);if(stlPadding){contentBlock.outerWidth+=stlPadding[1]+stlPadding[3];contentBlock.outerHeight+=stlPadding[0]+stlPadding[2];}for(var i=0;i<pendingList.length;i++){var token=pendingList[i];var percentWidth=token.percentWidth;// Should not base on outerWidth, because token can not be placed out of padding.
token.width=parseInt(percentWidth,10)/100*contentWidth;}return contentBlock;}function pushTokens(block,str,styleName){var isEmptyStr=str==='';var strs=str.split('\n');var lines=block.lines;for(var i=0;i<strs.length;i++){var text=strs[i];var token={styleName:styleName,text:text,isLineHolder:!text&&!isEmptyStr};// The first token should be appended to the last line.
if(!i){var tokens=(lines[lines.length-1]||(lines[0]={tokens:[]})).tokens;// Consider cases:
// (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
// (which is a placeholder) should be replaced by new token.
// (2) A image backage, where token likes {a|}.
// (3) A redundant '' will affect textAlign in line.
// (4) tokens with the same tplName should not be merged, because
// they should be displayed in different box (with border and padding).
var tokensLen=tokens.length;tokensLen===1&&tokens[0].isLineHolder?tokens[0]=token:// Consider text is '', only insert when it is the "lineHolder" or
// "emptyStr". Otherwise a redundant '' will affect textAlign in line.
(text||!tokensLen||isEmptyStr)&&tokens.push(token);}// Other tokens always start a new line.
else{// If there is '', insert it as a placeholder.
lines.push({tokens:[token]});}}}function makeFont(style){// FIXME in node-canvas fontWeight is before fontStyle
// Use `fontSize` `fontFamily` to check whether font properties are defined.
var font=(style.fontSize||style.fontFamily)&&[style.fontStyle,style.fontWeight,(style.fontSize||12)+'px',// If font properties are defined, `fontFamily` should not be ignored.
style.fontFamily||'sans-serif'].join(' ');return font&&trim(font)||style.textFont||style.font;}function _buildPath(ctx,shape){var x=shape.x;var y=shape.y;var width=shape.width;var height=shape.height;var r=shape.r;var r1;var r2;var r3;var r4;// Convert width and height to positive for better borderRadius
if(width<0){x=x+width;width=-width;}if(height<0){y=y+height;height=-height;}if(typeof r==='number'){r1=r2=r3=r4=r;}else if(r instanceof Array){if(r.length===1){r1=r2=r3=r4=r[0];}else if(r.length===2){r1=r3=r[0];r2=r4=r[1];}else if(r.length===3){r1=r[0];r2=r4=r[1];r3=r[2];}else{r1=r[0];r2=r[1];r3=r[2];r4=r[3];}}else{r1=r2=r3=r4=0;}var total;if(r1+r2>width){total=r1+r2;r1*=width/total;r2*=width/total;}if(r3+r4>width){total=r3+r4;r3*=width/total;r4*=width/total;}if(r2+r3>height){total=r2+r3;r2*=height/total;r3*=height/total;}if(r1+r4>height){total=r1+r4;r1*=height/total;r4*=height/total;}ctx.moveTo(x+r1,y);ctx.lineTo(x+width-r2,y);r2!==0&&ctx.arc(x+width-r2,y+r2,r2,-Math.PI/2,0);ctx.lineTo(x+width,y+height-r3);r3!==0&&ctx.arc(x+width-r3,y+height-r3,r3,0,Math.PI/2);ctx.lineTo(x+r4,y+height);r4!==0&&ctx.arc(x+r4,y+height-r4,r4,Math.PI/2,Math.PI);ctx.lineTo(x,y+r1);r1!==0&&ctx.arc(x+r1,y+r1,r1,Math.PI,Math.PI*1.5);}var VALID_TEXT_ALIGN={left:1,right:1,center:1};var VALID_TEXT_VERTICAL_ALIGN={top:1,bottom:1,middle:1};/**
 * @param {module:zrender/graphic/Style} style
 * @return {module:zrender/graphic/Style} The input style.
 */function normalizeTextStyle(style){normalizeStyle(style);each$1(style.rich,normalizeStyle);return style;}function normalizeStyle(style){if(style){style.font=makeFont(style);var textAlign=style.textAlign;textAlign==='middle'&&(textAlign='center');style.textAlign=textAlign==null||VALID_TEXT_ALIGN[textAlign]?textAlign:'left';// Compatible with textBaseline.
var textVerticalAlign=style.textVerticalAlign||style.textBaseline;textVerticalAlign==='center'&&(textVerticalAlign='middle');style.textVerticalAlign=textVerticalAlign==null||VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign]?textVerticalAlign:'top';var textPadding=style.textPadding;if(textPadding){style.textPadding=normalizeCssArray(style.textPadding);}}}/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {string} text
 * @param {module:zrender/graphic/Style} style
 * @param {Object|boolean} [rect] {x, y, width, height}
 *                  If set false, rect text is not used.
 */function renderText(hostEl,ctx,text,style,rect){style.rich?renderRichText(hostEl,ctx,text,style,rect):renderPlainText(hostEl,ctx,text,style,rect);}function renderPlainText(hostEl,ctx,text,style,rect){var font=setCtx(ctx,'font',style.font||DEFAULT_FONT);var textPadding=style.textPadding;var contentBlock=hostEl.__textCotentBlock;if(!contentBlock||hostEl.__dirty){contentBlock=hostEl.__textCotentBlock=parsePlainText(text,font,textPadding,style.truncate);}var outerHeight=contentBlock.outerHeight;var textLines=contentBlock.lines;var lineHeight=contentBlock.lineHeight;var boxPos=getBoxPosition(outerHeight,style,rect);var baseX=boxPos.baseX;var baseY=boxPos.baseY;var textAlign=boxPos.textAlign;var textVerticalAlign=boxPos.textVerticalAlign;// Origin of textRotation should be the base point of text drawing.
applyTextRotation(ctx,style,rect,baseX,baseY);var boxY=adjustTextY(baseY,outerHeight,textVerticalAlign);var textX=baseX;var textY=boxY;var needDrawBg=needDrawBackground(style);if(needDrawBg||textPadding){// Consider performance, do not call getTextWidth util necessary.
var textWidth=getWidth(text,font);var outerWidth=textWidth;textPadding&&(outerWidth+=textPadding[1]+textPadding[3]);var boxX=adjustTextX(baseX,outerWidth,textAlign);needDrawBg&&drawBackground(hostEl,ctx,style,boxX,boxY,outerWidth,outerHeight);if(textPadding){textX=getTextXForPadding(baseX,textAlign,textPadding);textY+=textPadding[0];}}setCtx(ctx,'textAlign',textAlign||'left');// Force baseline to be "middle". Otherwise, if using "top", the
// text will offset downward a little bit in font "Microsoft YaHei".
setCtx(ctx,'textBaseline','middle');// Always set shadowBlur and shadowOffset to avoid leak from displayable.
setCtx(ctx,'shadowBlur',style.textShadowBlur||0);setCtx(ctx,'shadowColor',style.textShadowColor||'transparent');setCtx(ctx,'shadowOffsetX',style.textShadowOffsetX||0);setCtx(ctx,'shadowOffsetY',style.textShadowOffsetY||0);// `textBaseline` is set as 'middle'.
textY+=lineHeight/2;var textStrokeWidth=style.textStrokeWidth;var textStroke=getStroke(style.textStroke,textStrokeWidth);var textFill=getFill(style.textFill);if(textStroke){setCtx(ctx,'lineWidth',textStrokeWidth);setCtx(ctx,'strokeStyle',textStroke);}if(textFill){setCtx(ctx,'fillStyle',textFill);}for(var i=0;i<textLines.length;i++){// Fill after stroke so the outline will not cover the main part.
textStroke&&ctx.strokeText(textLines[i],textX,textY);textFill&&ctx.fillText(textLines[i],textX,textY);textY+=lineHeight;}}function renderRichText(hostEl,ctx,text,style,rect){var contentBlock=hostEl.__textCotentBlock;if(!contentBlock||hostEl.__dirty){contentBlock=hostEl.__textCotentBlock=parseRichText(text,style);}drawRichText(hostEl,ctx,contentBlock,style,rect);}function drawRichText(hostEl,ctx,contentBlock,style,rect){var contentWidth=contentBlock.width;var outerWidth=contentBlock.outerWidth;var outerHeight=contentBlock.outerHeight;var textPadding=style.textPadding;var boxPos=getBoxPosition(outerHeight,style,rect);var baseX=boxPos.baseX;var baseY=boxPos.baseY;var textAlign=boxPos.textAlign;var textVerticalAlign=boxPos.textVerticalAlign;// Origin of textRotation should be the base point of text drawing.
applyTextRotation(ctx,style,rect,baseX,baseY);var boxX=adjustTextX(baseX,outerWidth,textAlign);var boxY=adjustTextY(baseY,outerHeight,textVerticalAlign);var xLeft=boxX;var lineTop=boxY;if(textPadding){xLeft+=textPadding[3];lineTop+=textPadding[0];}var xRight=xLeft+contentWidth;needDrawBackground(style)&&drawBackground(hostEl,ctx,style,boxX,boxY,outerWidth,outerHeight);for(var i=0;i<contentBlock.lines.length;i++){var line=contentBlock.lines[i];var tokens=line.tokens;var tokenCount=tokens.length;var lineHeight=line.lineHeight;var usedWidth=line.width;var leftIndex=0;var lineXLeft=xLeft;var lineXRight=xRight;var rightIndex=tokenCount-1;var token;while(leftIndex<tokenCount&&(token=tokens[leftIndex],!token.textAlign||token.textAlign==='left')){placeToken(hostEl,ctx,token,style,lineHeight,lineTop,lineXLeft,'left');usedWidth-=token.width;lineXLeft+=token.width;leftIndex++;}while(rightIndex>=0&&(token=tokens[rightIndex],token.textAlign==='right')){placeToken(hostEl,ctx,token,style,lineHeight,lineTop,lineXRight,'right');usedWidth-=token.width;lineXRight-=token.width;rightIndex--;}// The other tokens are placed as textAlign 'center' if there is enough space.
lineXLeft+=(contentWidth-(lineXLeft-xLeft)-(xRight-lineXRight)-usedWidth)/2;while(leftIndex<=rightIndex){token=tokens[leftIndex];// Consider width specified by user, use 'center' rather than 'left'.
placeToken(hostEl,ctx,token,style,lineHeight,lineTop,lineXLeft+token.width/2,'center');lineXLeft+=token.width;leftIndex++;}lineTop+=lineHeight;}}function applyTextRotation(ctx,style,rect,x,y){// textRotation only apply in RectText.
if(rect&&style.textRotation){var origin=style.textOrigin;if(origin==='center'){x=rect.width/2+rect.x;y=rect.height/2+rect.y;}else if(origin){x=origin[0]+rect.x;y=origin[1]+rect.y;}ctx.translate(x,y);// Positive: anticlockwise
ctx.rotate(-style.textRotation);ctx.translate(-x,-y);}}function placeToken(hostEl,ctx,token,style,lineHeight,lineTop,x,textAlign){var tokenStyle=style.rich[token.styleName]||{};// 'ctx.textBaseline' is always set as 'middle', for sake of
// the bias of "Microsoft YaHei".
var textVerticalAlign=token.textVerticalAlign;var y=lineTop+lineHeight/2;if(textVerticalAlign==='top'){y=lineTop+token.height/2;}else if(textVerticalAlign==='bottom'){y=lineTop+lineHeight-token.height/2;}!token.isLineHolder&&needDrawBackground(tokenStyle)&&drawBackground(hostEl,ctx,tokenStyle,textAlign==='right'?x-token.width:textAlign==='center'?x-token.width/2:x,y-token.height/2,token.width,token.height);var textPadding=token.textPadding;if(textPadding){x=getTextXForPadding(x,textAlign,textPadding);y-=token.height/2-textPadding[2]-token.textHeight/2;}setCtx(ctx,'shadowBlur',retrieve3(tokenStyle.textShadowBlur,style.textShadowBlur,0));setCtx(ctx,'shadowColor',tokenStyle.textShadowColor||style.textShadowColor||'transparent');setCtx(ctx,'shadowOffsetX',retrieve3(tokenStyle.textShadowOffsetX,style.textShadowOffsetX,0));setCtx(ctx,'shadowOffsetY',retrieve3(tokenStyle.textShadowOffsetY,style.textShadowOffsetY,0));setCtx(ctx,'textAlign',textAlign);// Force baseline to be "middle". Otherwise, if using "top", the
// text will offset downward a little bit in font "Microsoft YaHei".
setCtx(ctx,'textBaseline','middle');setCtx(ctx,'font',token.font||DEFAULT_FONT);var textStroke=getStroke(tokenStyle.textStroke||style.textStroke,textStrokeWidth);var textFill=getFill(tokenStyle.textFill||style.textFill);var textStrokeWidth=retrieve2(tokenStyle.textStrokeWidth,style.textStrokeWidth);// Fill after stroke so the outline will not cover the main part.
if(textStroke){setCtx(ctx,'lineWidth',textStrokeWidth);setCtx(ctx,'strokeStyle',textStroke);ctx.strokeText(token.text,x,y);}if(textFill){setCtx(ctx,'fillStyle',textFill);ctx.fillText(token.text,x,y);}}function needDrawBackground(style){return style.textBackgroundColor||style.textBorderWidth&&style.textBorderColor;}// style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius}
// shape: {x, y, width, height}
function drawBackground(hostEl,ctx,style,x,y,width,height){var textBackgroundColor=style.textBackgroundColor;var textBorderWidth=style.textBorderWidth;var textBorderColor=style.textBorderColor;var isPlainBg=isString(textBackgroundColor);setCtx(ctx,'shadowBlur',style.textBoxShadowBlur||0);setCtx(ctx,'shadowColor',style.textBoxShadowColor||'transparent');setCtx(ctx,'shadowOffsetX',style.textBoxShadowOffsetX||0);setCtx(ctx,'shadowOffsetY',style.textBoxShadowOffsetY||0);if(isPlainBg||textBorderWidth&&textBorderColor){ctx.beginPath();var textBorderRadius=style.textBorderRadius;if(!textBorderRadius){ctx.rect(x,y,width,height);}else{_buildPath(ctx,{x:x,y:y,width:width,height:height,r:textBorderRadius});}ctx.closePath();}if(isPlainBg){setCtx(ctx,'fillStyle',textBackgroundColor);ctx.fill();}else if(isObject$1(textBackgroundColor)){var image=textBackgroundColor.image;image=createOrUpdateImage(image,null,hostEl,onBgImageLoaded,textBackgroundColor);if(image&&isImageReady(image)){ctx.drawImage(image,x,y,width,height);}}if(textBorderWidth&&textBorderColor){setCtx(ctx,'lineWidth',textBorderWidth);setCtx(ctx,'strokeStyle',textBorderColor);ctx.stroke();}}function onBgImageLoaded(image,textBackgroundColor){// Replace image, so that `contain/text.js#parseRichText`
// will get correct result in next tick.
textBackgroundColor.image=image;}function getBoxPosition(blockHeiht,style,rect){var baseX=style.x||0;var baseY=style.y||0;var textAlign=style.textAlign;var textVerticalAlign=style.textVerticalAlign;// Text position represented by coord
if(rect){var textPosition=style.textPosition;if(textPosition instanceof Array){// Percent
baseX=rect.x+parsePercent(textPosition[0],rect.width);baseY=rect.y+parsePercent(textPosition[1],rect.height);}else{var res=adjustTextPositionOnRect(textPosition,rect,style.textDistance);baseX=res.x;baseY=res.y;// Default align and baseline when has textPosition
textAlign=textAlign||res.textAlign;textVerticalAlign=textVerticalAlign||res.textVerticalAlign;}// textOffset is only support in RectText, otherwise
// we have to adjust boundingRect for textOffset.
var textOffset=style.textOffset;if(textOffset){baseX+=textOffset[0];baseY+=textOffset[1];}}return{baseX:baseX,baseY:baseY,textAlign:textAlign,textVerticalAlign:textVerticalAlign};}function setCtx(ctx,prop,value){ctx[prop]=fixShadow(ctx,prop,value);return ctx[prop];}/**
 * @param {string} [stroke] If specified, do not check style.textStroke.
 * @param {string} [lineWidth] If specified, do not check style.textStroke.
 * @param {number} style
 */function getStroke(stroke,lineWidth){return stroke==null||lineWidth<=0||stroke==='transparent'||stroke==='none'?null// TODO pattern and gradient?
:stroke.image||stroke.colorStops?'#000':stroke;}function getFill(fill){return fill==null||fill==='none'?null// TODO pattern and gradient?
:fill.image||fill.colorStops?'#000':fill;}function parsePercent(value,maxValue){if(typeof value==='string'){if(value.lastIndexOf('%')>=0){return parseFloat(value)/100*maxValue;}return parseFloat(value);}return value;}function getTextXForPadding(x,textAlign,textPadding){return textAlign==='right'?x-textPadding[1]:textAlign==='center'?x+textPadding[3]/2-textPadding[1]/2:x+textPadding[3];}/**
 * @param {string} text
 * @param {module:zrender/Style} style
 * @return {boolean}
 */function needDrawText(text,style){return text!=null&&(text||style.textBackgroundColor||style.textBorderWidth&&style.textBorderColor||style.textPadding);}/**
 * Mixin for drawing text in a element bounding rect
 * @module zrender/mixin/RectText
 */var tmpRect$1=new BoundingRect();var RectText=function RectText(){};RectText.prototype={constructor:RectText,/**
   * Draw text in a rect with specified position.
   * @param  {CanvasRenderingContext2D} ctx
   * @param  {Object} rect Displayable rect
   */drawRectText:function drawRectText(ctx,rect){var style=this.style;rect=style.textRect||rect;// Optimize, avoid normalize every time.
this.__dirty&&normalizeTextStyle(style,true);var text=style.text;// Convert to string
text!=null&&(text+='');if(!needDrawText(text,style)){return;}// FIXME
ctx.save();// Transform rect to view space
var transform=this.transform;if(!style.transformText){if(transform){tmpRect$1.copy(rect);tmpRect$1.applyTransform(transform);rect=tmpRect$1;}}else{this.setTransform(ctx);}// transformText and textRotation can not be used at the same time.
renderText(this,ctx,text,style,rect);ctx.restore();}};/**
 * 可绘制的图形基类
 * Base class of all displayable graphic objects
 * @module zrender/graphic/Displayable
 *//**
 * @alias module:zrender/graphic/Displayable
 * @extends module:zrender/Element
 * @extends module:zrender/graphic/mixin/RectText
 */function Displayable(opts){opts=opts||{};Element.call(this,opts);// Extend properties
for(var name in opts){if(opts.hasOwnProperty(name)&&name!=='style'){this[name]=opts[name];}}/**
   * @type {module:zrender/graphic/Style}
   */this.style=new Style(opts.style,this);this._rect=null;// Shapes for cascade clipping.
this.__clipPaths=[];// FIXME Stateful must be mixined after style is setted
// Stateful.call(this, opts);
}Displayable.prototype={constructor:Displayable,type:'displayable',/**
   * Displayable 是否为脏，Painter 中会根据该标记判断是否需要是否需要重新绘制
   * Dirty flag. From which painter will determine if this displayable object needs brush
   * @name module:zrender/graphic/Displayable#__dirty
   * @type {boolean}
   */__dirty:true,/**
   * 图形是否可见，为true时不绘制图形，但是仍能触发鼠标事件
   * If ignore drawing of the displayable object. Mouse event will still be triggered
   * @name module:/zrender/graphic/Displayable#invisible
   * @type {boolean}
   * @default false
   */invisible:false,/**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */z:0,/**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */z2:0,/**
   * z层level，决定绘画在哪层canvas中
   * @name module:/zrender/graphic/Displayable#zlevel
   * @type {number}
   * @default 0
   */zlevel:0,/**
   * 是否可拖拽
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */draggable:false,/**
   * 是否正在拖拽
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */dragging:false,/**
   * 是否相应鼠标事件
   * @name module:/zrender/graphic/Displayable#silent
   * @type {boolean}
   * @default false
   */silent:false,/**
   * If enable culling
   * @type {boolean}
   * @default false
   */culling:false,/**
   * Mouse cursor when hovered
   * @name module:/zrender/graphic/Displayable#cursor
   * @type {string}
   */cursor:'pointer',/**
   * If hover area is bounding rect
   * @name module:/zrender/graphic/Displayable#rectHover
   * @type {string}
   */rectHover:false,/**
   * Render the element progressively when the value >= 0,
   * usefull for large data.
   * @type {boolean}
   */progressive:false,/**
   * @type {boolean}
   */incremental:false,// inplace is used with incremental
inplace:false,beforeBrush:function beforeBrush(ctx){},afterBrush:function afterBrush(ctx){},/**
   * 图形绘制方法
   * @param {CanvasRenderingContext2D} ctx
   */// Interface
brush:function brush(ctx,prevEl){},/**
   * 获取最小包围盒
   * @return {module:zrender/core/BoundingRect}
   */// Interface
getBoundingRect:function getBoundingRect(){},/**
   * 判断坐标 x, y 是否在图形上
   * If displayable element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */contain:function contain(x,y){return this.rectContain(x,y);},/**
   * @param  {Function} cb
   * @param  {}   context
   */traverse:function traverse(cb,context){cb.call(context,this);},/**
   * 判断坐标 x, y 是否在图形的包围盒上
   * If bounding rect of element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */rectContain:function rectContain(x,y){var coord=this.transformCoordToLocal(x,y);var rect=this.getBoundingRect();return rect.contain(coord[0],coord[1]);},/**
   * 标记图形元素为脏，并且在下一帧重绘
   * Mark displayable element dirty and refresh next frame
   */dirty:function dirty(){this.__dirty=true;this._rect=null;this.__zr&&this.__zr.refresh();},/**
   * 图形是否会触发事件
   * If displayable object binded any event
   * @return {boolean}
   */// TODO, 通过 bind 绑定的事件
// isSilent: function () {
//     return !(
//         this.hoverable || this.draggable
//         || this.onmousemove || this.onmouseover || this.onmouseout
//         || this.onmousedown || this.onmouseup || this.onclick
//         || this.ondragenter || this.ondragover || this.ondragleave
//         || this.ondrop
//     );
// },
/**
   * Alias for animate('style')
   * @param {boolean} loop
   */animateStyle:function animateStyle(loop){return this.animate('style',loop);},attrKV:function attrKV(key,value){if(key!=='style'){Element.prototype.attrKV.call(this,key,value);}else{this.style.set(value);}},/**
   * @param {Object|string} key
   * @param {*} value
   */setStyle:function setStyle(key,value){this.style.set(key,value);this.dirty(false);return this;},/**
   * Use given style object
   * @param  {Object} obj
   */useStyle:function useStyle(obj){this.style=new Style(obj,this);this.dirty(false);return this;}};inherits(Displayable,Element);mixin(Displayable,RectText);// zrUtil.mixin(Displayable, Stateful);
/**
 * @alias zrender/graphic/Image
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */function ZImage(opts){Displayable.call(this,opts);}ZImage.prototype={constructor:ZImage,type:'image',brush:function brush(ctx,prevEl){var style=this.style;var src=style.image;// Must bind each time
style.bind(ctx,this,prevEl);var image=this._image=createOrUpdateImage(src,this._image,this,this.onload);if(!image||!isImageReady(image)){return;}// 图片已经加载完成
// if (image.nodeName.toUpperCase() == 'IMG') {
//     if (!image.complete) {
//         return;
//     }
// }
// Else is canvas
var x=style.x||0;var y=style.y||0;var width=style.width;var height=style.height;var aspect=image.width/image.height;if(width==null&&height!=null){// Keep image/height ratio
width=height*aspect;}else if(height==null&&width!=null){height=width/aspect;}else if(width==null&&height==null){width=image.width;height=image.height;}// 设置transform
this.setTransform(ctx);if(style.sWidth&&style.sHeight){var sx=style.sx||0;var sy=style.sy||0;ctx.drawImage(image,sx,sy,style.sWidth,style.sHeight,x,y,width,height);}else if(style.sx&&style.sy){var sx=style.sx;var sy=style.sy;var sWidth=width-sx;var sHeight=height-sy;ctx.drawImage(image,sx,sy,sWidth,sHeight,x,y,width,height);}else{ctx.drawImage(image,x,y,width,height);}// Draw rect text
if(style.text!=null){// Only restore transform when needs draw text.
this.restoreTransform(ctx);this.drawRectText(ctx,this.getBoundingRect());}},getBoundingRect:function getBoundingRect(){var style=this.style;if(!this._rect){this._rect=new BoundingRect(style.x||0,style.y||0,style.width||0,style.height||0);}return this._rect;}};inherits(ZImage,Displayable);var HOVER_LAYER_ZLEVEL=1e5;var CANVAS_ZLEVEL=314159;var EL_AFTER_INCREMENTAL_INC=0.01;var INCREMENTAL_INC=0.001;function parseInt10(val){return parseInt(val,10);}function isLayerValid(layer){if(!layer){return false;}if(layer.__builtin__){return true;}if(typeof layer.resize!=='function'||typeof layer.refresh!=='function'){return false;}return true;}var tmpRect=new BoundingRect(0,0,0,0);var viewRect=new BoundingRect(0,0,0,0);function isDisplayableCulled(el,width,height){tmpRect.copy(el.getBoundingRect());if(el.transform){tmpRect.applyTransform(el.transform);}viewRect.width=width;viewRect.height=height;return!tmpRect.intersect(viewRect);}function isClipPathChanged(clipPaths,prevClipPaths){if(clipPaths==prevClipPaths){// Can both be null or undefined
return false;}if(!clipPaths||!prevClipPaths||clipPaths.length!==prevClipPaths.length){return true;}for(var i=0;i<clipPaths.length;i++){if(clipPaths[i]!==prevClipPaths[i]){return true;}}}function doClip(clipPaths,ctx){for(var i=0;i<clipPaths.length;i++){var clipPath=clipPaths[i];clipPath.setTransform(ctx);ctx.beginPath();clipPath.buildPath(ctx,clipPath.shape);ctx.clip();// Transform back
clipPath.restoreTransform(ctx);}}function createRoot(width,height){var domRoot=document.createElement('div');// domRoot.onselectstart = returnFalse; // 避免页面选中的尴尬
domRoot.style.cssText=['position:relative','overflow:hidden','width:'+width+'px','height:'+height+'px','padding:0','margin:0','border-width:0'].join(';')+';';return domRoot;}/**
 * @alias module:zrender/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */var Painter=function Painter(root,storage,opts){this.type='canvas';// In node environment using node-canvas
var singleCanvas=!root.nodeName// In node ?
||root.nodeName.toUpperCase()==='CANVAS';this._opts=opts=extend({},opts||{});/**
   * @type {number}
   */this.dpr=opts.devicePixelRatio||devicePixelRatio;/**
   * @type {boolean}
   * @private
   */this._singleCanvas=singleCanvas;/**
   * 绘图容器
   * @type {HTMLElement}
   */this.root=root;var rootStyle=root.style;if(rootStyle){rootStyle['-webkit-tap-highlight-color']='transparent';rootStyle['-webkit-user-select']=rootStyle['user-select']=rootStyle['-webkit-touch-callout']='none';root.innerHTML='';}/**
   * @type {module:zrender/Storage}
   */this.storage=storage;/**
   * @type {Array.<number>}
   * @private
   */var zlevelList=this._zlevelList=[];/**
   * @type {Object.<string, module:zrender/Layer>}
   * @private
   */var layers=this._layers={};/**
   * @type {Object.<string, Object>}
   * @private
   */this._layerConfig={};/**
   * zrender will do compositing when root is a canvas and have multiple zlevels.
   */this._needsManuallyCompositing=false;if(!singleCanvas){this._width=this._getSize(0);this._height=this._getSize(1);var domRoot=this._domRoot=createRoot(this._width,this._height);root.appendChild(domRoot);}else{var width=root.width;var height=root.height;if(opts.width!=null){width=opts.width;}if(opts.height!=null){height=opts.height;}this.dpr=opts.devicePixelRatio||1;// Use canvas width and height directly
root.width=width*this.dpr;root.height=height*this.dpr;this._width=width;this._height=height;// Create layer if only one given canvas
// Device can be specified to create a high dpi image.
var mainLayer=new Layer(root,this,this.dpr);mainLayer.__builtin__=true;mainLayer.initContext();// FIXME Use canvas width and height
// mainLayer.resize(width, height);
layers[CANVAS_ZLEVEL]=mainLayer;mainLayer.zlevel=CANVAS_ZLEVEL;// Not use common zlevel.
zlevelList.push(CANVAS_ZLEVEL);this._domRoot=root;}/**
   * @type {module:zrender/Layer}
   * @private
   */this._hoverlayer=null;this._hoverElements=[];};Painter.prototype={constructor:Painter,getType:function getType(){return'canvas';},/**
   * If painter use a single canvas
   * @return {boolean}
   */isSingleCanvas:function isSingleCanvas(){return this._singleCanvas;},/**
   * @return {HTMLDivElement}
   */getViewportRoot:function getViewportRoot(){return this._domRoot;},getViewportRootOffset:function getViewportRootOffset(){var viewportRoot=this.getViewportRoot();if(viewportRoot){return{offsetLeft:viewportRoot.offsetLeft||0,offsetTop:viewportRoot.offsetTop||0};}},/**
   * 刷新
   * @param {boolean} [paintAll=false] 强制绘制所有displayable
   */refresh:function refresh(paintAll){var list=this.storage.getDisplayList(true);var zlevelList=this._zlevelList;this._redrawId=Math.random();this._paintList(list,paintAll,this._redrawId);// Paint custum layers
for(var i=0;i<zlevelList.length;i++){var z=zlevelList[i];var layer=this._layers[z];if(!layer.__builtin__&&layer.refresh){var clearColor=i===0?this._backgroundColor:null;layer.refresh(clearColor);}}this.refreshHover();return this;},addHover:function addHover(el,hoverStyle){if(el.__hoverMir){return;}var elMirror=new el.constructor({style:el.style,shape:el.shape});elMirror.__from=el;el.__hoverMir=elMirror;elMirror.setStyle(hoverStyle);this._hoverElements.push(elMirror);},removeHover:function removeHover(el){var elMirror=el.__hoverMir;var hoverElements=this._hoverElements;var idx=indexOf(hoverElements,elMirror);if(idx>=0){hoverElements.splice(idx,1);}el.__hoverMir=null;},clearHover:function clearHover(el){var hoverElements=this._hoverElements;for(var i=0;i<hoverElements.length;i++){var from=hoverElements[i].__from;if(from){from.__hoverMir=null;}}hoverElements.length=0;},refreshHover:function refreshHover(){var hoverElements=this._hoverElements;var len=hoverElements.length;var hoverLayer=this._hoverlayer;hoverLayer&&hoverLayer.clear();if(!len){return;}sort(hoverElements,this.storage.displayableSortFunc);// Use a extream large zlevel
// FIXME?
if(!hoverLayer){hoverLayer=this._hoverlayer=this.getLayer(HOVER_LAYER_ZLEVEL);}var scope={};hoverLayer.ctx.save();for(var i=0;i<len;){var el=hoverElements[i];var originalEl=el.__from;// Original el is removed
// PENDING
if(!(originalEl&&originalEl.__zr)){hoverElements.splice(i,1);originalEl.__hoverMir=null;len--;continue;}i++;// Use transform
// FIXME style and shape ?
if(!originalEl.invisible){el.transform=originalEl.transform;el.invTransform=originalEl.invTransform;el.__clipPaths=originalEl.__clipPaths;// el.
this._doPaintEl(el,hoverLayer,true,scope);}}hoverLayer.ctx.restore();},getHoverLayer:function getHoverLayer(){return this.getLayer(HOVER_LAYER_ZLEVEL);},_paintList:function _paintList(list,paintAll,redrawId){if(this._redrawId!==redrawId){return;}paintAll=paintAll||false;this._updateLayerStatus(list);var finished=this._doPaintList(list,paintAll);if(this._needsManuallyCompositing){this._compositeManually();}if(!finished){var self=this;requestAnimationFrame(function(){self._paintList(list,paintAll,redrawId);});}},_compositeManually:function _compositeManually(){var ctx=this.getLayer(CANVAS_ZLEVEL).ctx;var width=this._domRoot.width;var height=this._domRoot.height;ctx.clearRect(0,0,width,height);// PENDING, If only builtin layer?
this.eachBuiltinLayer(function(layer){if(layer.virtual){ctx.drawImage(layer.dom,0,0,width,height);}});},_doPaintList:function _doPaintList(list,paintAll){var layerList=[];for(var zi=0;zi<this._zlevelList.length;zi++){var zlevel=this._zlevelList[zi];var layer=this._layers[zlevel];if(layer.__builtin__&&layer!==this._hoverlayer&&(layer.__dirty||paintAll)){layerList.push(layer);}}var finished=true;for(var k=0;k<layerList.length;k++){var layer=layerList[k];var ctx=layer.ctx;var scope={};ctx.save();var start=paintAll?layer.__startIndex:layer.__drawIndex;var useTimer=!paintAll&&layer.incremental&&Date.now;var startTime=useTimer&&Date.now();var clearColor=layer.zlevel===this._zlevelList[0]?this._backgroundColor:null;// All elements in this layer are cleared.
if(layer.__startIndex===layer.__endIndex){layer.clear(false,clearColor);}else if(start===layer.__startIndex){var firstEl=list[start];if(!firstEl.incremental||!firstEl.notClear||paintAll){layer.clear(false,clearColor);}}if(start===-1){console.error('For some unknown reason. drawIndex is -1');start=layer.__startIndex;}for(var i=start;i<layer.__endIndex;i++){var el=list[i];this._doPaintEl(el,layer,paintAll,scope);el.__dirty=false;if(useTimer){// Date.now can be executed in 13,025,305 ops/second.
var dTime=Date.now()-startTime;// Give 15 millisecond to draw.
// The rest elements will be drawn in the next frame.
if(dTime>15){break;}}}layer.__drawIndex=i;if(layer.__drawIndex<layer.__endIndex){finished=false;}if(scope.prevElClipPaths){// Needs restore the state. If last drawn element is in the clipping area.
ctx.restore();}ctx.restore();}if(env$1.wxa){// Flush for weixin application
each$1(this._layers,function(layer){if(layer&&layer.ctx&&layer.ctx.draw){layer.ctx.draw();}});}return finished;},_doPaintEl:function _doPaintEl(el,currentLayer,forcePaint,scope){var ctx=currentLayer.ctx;var m=el.transform;if((currentLayer.__dirty||forcePaint)&&// Ignore invisible element
!el.invisible// Ignore transparent element
&&el.style.opacity!==0// Ignore scale 0 element, in some environment like node-canvas
// Draw a scale 0 element can cause all following draw wrong
// And setTransform with scale 0 will cause set back transform failed.
&&!(m&&!m[0]&&!m[3])// Ignore culled element
&&!(el.culling&&isDisplayableCulled(el,this._width,this._height))){var clipPaths=el.__clipPaths;// Optimize when clipping on group with several elements
if(!scope.prevElClipPaths||isClipPathChanged(clipPaths,scope.prevElClipPaths)){// If has previous clipping state, restore from it
if(scope.prevElClipPaths){currentLayer.ctx.restore();scope.prevElClipPaths=null;// Reset prevEl since context has been restored
scope.prevEl=null;}// New clipping state
if(clipPaths){ctx.save();doClip(clipPaths,ctx);scope.prevElClipPaths=clipPaths;}}el.beforeBrush&&el.beforeBrush(ctx);el.brush(ctx,scope.prevEl||null);scope.prevEl=el;el.afterBrush&&el.afterBrush(ctx);}},/**
   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
   * @param {number} zlevel
   * @param {boolean} virtual Virtual layer will not be inserted into dom.
   * @return {module:zrender/Layer}
   */getLayer:function getLayer(zlevel,virtual){if(this._singleCanvas&&!this._needsManuallyCompositing){zlevel=CANVAS_ZLEVEL;}var layer=this._layers[zlevel];if(!layer){// Create a new layer
layer=new Layer('zr_'+zlevel,this,this.dpr);layer.zlevel=zlevel;layer.__builtin__=true;if(this._layerConfig[zlevel]){merge(layer,this._layerConfig[zlevel],true);}if(virtual){layer.virtual=virtual;}this.insertLayer(zlevel,layer);// Context is created after dom inserted to document
// Or excanvas will get 0px clientWidth and clientHeight
layer.initContext();}return layer;},insertLayer:function insertLayer(zlevel,layer){var layersMap=this._layers;var zlevelList=this._zlevelList;var len=zlevelList.length;var prevLayer=null;var i=-1;var domRoot=this._domRoot;if(layersMap[zlevel]){zrLog('ZLevel '+zlevel+' has been used already');return;}// Check if is a valid layer
if(!isLayerValid(layer)){zrLog('Layer of zlevel '+zlevel+' is not valid');return;}if(len>0&&zlevel>zlevelList[0]){for(i=0;i<len-1;i++){if(zlevelList[i]<zlevel&&zlevelList[i+1]>zlevel){break;}}prevLayer=layersMap[zlevelList[i]];}zlevelList.splice(i+1,0,zlevel);layersMap[zlevel]=layer;// Vitual layer will not directly show on the screen.
// (It can be a WebGL layer and assigned to a ZImage element)
// But it still under management of zrender.
if(!layer.virtual){if(prevLayer){var prevDom=prevLayer.dom;if(prevDom.nextSibling){domRoot.insertBefore(layer.dom,prevDom.nextSibling);}else{domRoot.appendChild(layer.dom);}}else{if(domRoot.firstChild){domRoot.insertBefore(layer.dom,domRoot.firstChild);}else{domRoot.appendChild(layer.dom);}}}},// Iterate each layer
eachLayer:function eachLayer(cb,context){var zlevelList=this._zlevelList;var z;var i;for(i=0;i<zlevelList.length;i++){z=zlevelList[i];cb.call(context,this._layers[z],z);}},// Iterate each buildin layer
eachBuiltinLayer:function eachBuiltinLayer(cb,context){var zlevelList=this._zlevelList;var layer;var z;var i;for(i=0;i<zlevelList.length;i++){z=zlevelList[i];layer=this._layers[z];if(layer.__builtin__){cb.call(context,layer,z);}}},// Iterate each other layer except buildin layer
eachOtherLayer:function eachOtherLayer(cb,context){var zlevelList=this._zlevelList;var layer;var z;var i;for(i=0;i<zlevelList.length;i++){z=zlevelList[i];layer=this._layers[z];if(!layer.__builtin__){cb.call(context,layer,z);}}},/**
   * 获取所有已创建的层
   * @param {Array.<module:zrender/Layer>} [prevLayer]
   */getLayers:function getLayers(){return this._layers;},_updateLayerStatus:function _updateLayerStatus(list){this.eachBuiltinLayer(function(layer,z){layer.__dirty=layer.__used=false;});function updatePrevLayer(idx){if(prevLayer){if(prevLayer.__endIndex!==idx){prevLayer.__dirty=true;}prevLayer.__endIndex=idx;}}if(this._singleCanvas){for(var i=1;i<list.length;i++){var el=list[i];if(el.zlevel!==list[i-1].zlevel||el.incremental){this._needsManuallyCompositing=true;break;}}}var prevLayer=null;var incrementalLayerCount=0;for(var i=0;i<list.length;i++){var el=list[i];var zlevel=el.zlevel;var layer;// PENDING If change one incremental element style ?
// TODO Where there are non-incremental elements between incremental elements.
if(el.incremental){layer=this.getLayer(zlevel+INCREMENTAL_INC,this._needsManuallyCompositing);layer.incremental=true;incrementalLayerCount=1;}else{layer=this.getLayer(zlevel+(incrementalLayerCount>0?EL_AFTER_INCREMENTAL_INC:0),this._needsManuallyCompositing);}if(!layer.__builtin__){zrLog('ZLevel '+zlevel+' has been used by unkown layer '+layer.id);}if(layer!==prevLayer){layer.__used=true;if(layer.__startIndex!==i){layer.__dirty=true;}layer.__startIndex=i;if(!layer.incremental){layer.__drawIndex=i;}else{// Mark layer draw index needs to update.
layer.__drawIndex=-1;}updatePrevLayer(i);prevLayer=layer;}if(el.__dirty){layer.__dirty=true;if(layer.incremental&&layer.__drawIndex<0){// Start draw from the first dirty element.
layer.__drawIndex=i;}}}updatePrevLayer(i);this.eachBuiltinLayer(function(layer,z){// Used in last frame but not in this frame. Needs clear
if(!layer.__used&&layer.getElementCount()>0){layer.__dirty=true;layer.__startIndex=layer.__endIndex=layer.__drawIndex=0;}// For incremental layer. In case start index changed and no elements are dirty.
if(layer.__dirty&&layer.__drawIndex<0){layer.__drawIndex=layer.__startIndex;}});},/**
   * 清除hover层外所有内容
   */clear:function clear(){this.eachBuiltinLayer(this._clearLayer);return this;},_clearLayer:function _clearLayer(layer){layer.clear();},setBackgroundColor:function setBackgroundColor(backgroundColor){this._backgroundColor=backgroundColor;},/**
   * 修改指定zlevel的绘制参数
   *
   * @param {string} zlevel
   * @param {Object} config 配置对象
   * @param {string} [config.clearColor=0] 每次清空画布的颜色
   * @param {string} [config.motionBlur=false] 是否开启动态模糊
   * @param {number} [config.lastFrameAlpha=0.7]
   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   */configLayer:function configLayer(zlevel,config){if(config){var layerConfig=this._layerConfig;if(!layerConfig[zlevel]){layerConfig[zlevel]=config;}else{merge(layerConfig[zlevel],config,true);}for(var i=0;i<this._zlevelList.length;i++){var _zlevel=this._zlevelList[i];if(_zlevel===zlevel||_zlevel===zlevel+EL_AFTER_INCREMENTAL_INC){var layer=this._layers[_zlevel];merge(layer,layerConfig[zlevel],true);}}}},/**
   * 删除指定层
   * @param {number} zlevel 层所在的zlevel
   */delLayer:function delLayer(zlevel){var layers=this._layers;var zlevelList=this._zlevelList;var layer=layers[zlevel];if(!layer){return;}layer.dom.parentNode.removeChild(layer.dom);delete layers[zlevel];zlevelList.splice(indexOf(zlevelList,zlevel),1);},/**
   * 区域大小变化后重绘
   */resize:function resize(width,height){if(!this._domRoot.style){// Maybe in node or worker
if(width==null||height==null){return;}this._width=width;this._height=height;this.getLayer(CANVAS_ZLEVEL).resize(width,height);}else{var domRoot=this._domRoot;// FIXME Why ?
domRoot.style.display='none';// Save input w/h
var opts=this._opts;width!=null&&(opts.width=width);height!=null&&(opts.height=height);width=this._getSize(0);height=this._getSize(1);domRoot.style.display='';// 优化没有实际改变的resize
if(this._width!=width||height!=this._height){domRoot.style.width=width+'px';domRoot.style.height=height+'px';for(var id in this._layers){if(this._layers.hasOwnProperty(id)){this._layers[id].resize(width,height);}}each$1(this._progressiveLayers,function(layer){layer.resize(width,height);});this.refresh(true);}this._width=width;this._height=height;}return this;},/**
   * 清除单独的一个层
   * @param {number} zlevel
   */clearLayer:function clearLayer(zlevel){var layer=this._layers[zlevel];if(layer){layer.clear();}},/**
   * 释放
   */dispose:function dispose(){this.root.innerHTML='';this.root=this.storage=this._domRoot=this._layers=null;},/**
   * Get canvas which has all thing rendered
   * @param {Object} opts
   * @param {string} [opts.backgroundColor]
   * @param {number} [opts.pixelRatio]
   */getRenderedCanvas:function getRenderedCanvas(opts){opts=opts||{};if(this._singleCanvas&&!this._compositeManually){return this._layers[CANVAS_ZLEVEL].dom;}var imageLayer=new Layer('image',this,opts.pixelRatio||this.dpr);imageLayer.initContext();imageLayer.clear(false,opts.backgroundColor||this._backgroundColor);if(opts.pixelRatio<=this.dpr){this.refresh();var width=imageLayer.dom.width;var height=imageLayer.dom.height;var ctx=imageLayer.ctx;this.eachLayer(function(layer){if(layer.__builtin__){ctx.drawImage(layer.dom,0,0,width,height);}else if(layer.renderToCanvas){imageLayer.ctx.save();layer.renderToCanvas(imageLayer.ctx);imageLayer.ctx.restore();}});}else{// PENDING, echarts-gl and incremental rendering.
var scope={};var displayList=this.storage.getDisplayList(true);for(var i=0;i<displayList.length;i++){var el=displayList[i];this._doPaintEl(el,imageLayer,true,scope);}}return imageLayer.dom;},/**
   * 获取绘图区域宽度
   */getWidth:function getWidth(){return this._width;},/**
   * 获取绘图区域高度
   */getHeight:function getHeight(){return this._height;},_getSize:function _getSize(whIdx){var opts=this._opts;var wh=['width','height'][whIdx];var cwh=['clientWidth','clientHeight'][whIdx];var plt=['paddingLeft','paddingTop'][whIdx];var prb=['paddingRight','paddingBottom'][whIdx];if(opts[wh]!=null&&opts[wh]!=='auto'){return parseFloat(opts[wh]);}var root=this.root;// IE8 does not support getComputedStyle, but it use VML.
var stl=document.defaultView.getComputedStyle(root);return(root[cwh]||parseInt10(stl[wh])||parseInt10(root.style[wh]))-(parseInt10(stl[plt])||0)-(parseInt10(stl[prb])||0)|0;},pathToImage:function pathToImage(path,dpr){dpr=dpr||this.dpr;var canvas=document.createElement('canvas');var ctx=canvas.getContext('2d');var rect=path.getBoundingRect();var style=path.style;var shadowBlurSize=style.shadowBlur*dpr;var shadowOffsetX=style.shadowOffsetX*dpr;var shadowOffsetY=style.shadowOffsetY*dpr;var lineWidth=style.hasStroke()?style.lineWidth:0;var leftMargin=Math.max(lineWidth/2,-shadowOffsetX+shadowBlurSize);var rightMargin=Math.max(lineWidth/2,shadowOffsetX+shadowBlurSize);var topMargin=Math.max(lineWidth/2,-shadowOffsetY+shadowBlurSize);var bottomMargin=Math.max(lineWidth/2,shadowOffsetY+shadowBlurSize);var width=rect.width+leftMargin+rightMargin;var height=rect.height+topMargin+bottomMargin;canvas.width=width*dpr;canvas.height=height*dpr;ctx.scale(dpr,dpr);ctx.clearRect(0,0,width,height);ctx.dpr=dpr;var pathTransform={position:path.position,rotation:path.rotation,scale:path.scale};path.position=[leftMargin-rect.x,topMargin-rect.y];path.rotation=0;path.scale=[1,1];path.updateTransform();if(path){path.brush(ctx);}var ImageShape=ZImage;var imgShape=new ImageShape({style:{x:0,y:0,image:canvas}});if(pathTransform.position!=null){imgShape.position=path.position=pathTransform.position;}if(pathTransform.rotation!=null){imgShape.rotation=path.rotation=pathTransform.rotation;}if(pathTransform.scale!=null){imgShape.scale=path.scale=pathTransform.scale;}return imgShape;}};/**
 * 事件辅助类
 * @module zrender/core/event
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 */var isDomLevel2=typeof window!=='undefined'&&!!window.addEventListener;var MOUSE_EVENT_REG=/^(?:mouse|pointer|contextmenu|drag|drop)|click/;function getBoundingClientRect(el){// BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect
return el.getBoundingClientRect?el.getBoundingClientRect():{left:0,top:0};}// `calculate` is optional, default false
function clientToLocal(el,e,out,calculate){out=out||{};// According to the W3C Working Draft, offsetX and offsetY should be relative
// to the padding edge of the target element. The only browser using this convention
// is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
// not support the properties.
// (see http://www.jacklmoore.com/notes/mouse-position/)
// In zr painter.dom, padding edge equals to border edge.
// FIXME
// When mousemove event triggered on ec tooltip, target is not zr painter.dom, and
// offsetX/Y is relative to e.target, where the calculation of zrX/Y via offsetX/Y
// is too complex. So css-transfrom dont support in this case temporarily.
if(calculate||!env$1.canvasSupported){defaultGetZrXY(el,e,out);}// Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
// ancestor element, so we should make sure el is positioned (e.g., not position:static).
// BTW1, Webkit don't return the same results as FF in non-simple cases (like add
// zoom-factor, overflow / opacity layers, transforms ...)
// BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
// <https://bugs.jquery.com/ticket/8523#comment:14>
// BTW3, In ff, offsetX/offsetY is always 0.
else if(env$1.browser.firefox&&e.layerX!=null&&e.layerX!==e.offsetX){out.zrX=e.layerX;out.zrY=e.layerY;}// For IE6+, chrome, safari, opera. (When will ff support offsetX?)
else if(e.offsetX!=null){out.zrX=e.offsetX;out.zrY=e.offsetY;}// For some other device, e.g., IOS safari.
else{defaultGetZrXY(el,e,out);}return out;}function defaultGetZrXY(el,e,out){// This well-known method below does not support css transform.
var box=getBoundingClientRect(el);out.zrX=e.clientX-box.left;out.zrY=e.clientY-box.top;}/**
 * 如果存在第三方嵌入的一些dom触发的事件，或touch事件，需要转换一下事件坐标.
 * `calculate` is optional, default false.
 */function normalizeEvent(el,e,calculate){e=e||window.event;if(e.zrX!=null){return e;}var eventType=e.type;var isTouch=eventType&&eventType.indexOf('touch')>=0;if(!isTouch){clientToLocal(el,e,e,calculate);e.zrDelta=e.wheelDelta?e.wheelDelta/120:-(e.detail||0)/3;}else{var touch=eventType!='touchend'?e.targetTouches[0]:e.changedTouches[0];touch&&clientToLocal(el,touch,e,calculate);}// Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
// See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
// If e.which has been defined, if may be readonly,
// see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which
var button=e.button;if(e.which==null&&button!==undefined&&MOUSE_EVENT_REG.test(e.type)){e.which=button&1?1:button&2?3:button&4?2:0;}return e;}/**
 * @param {HTMLElement} el
 * @param {string} name
 * @param {Function} handler
 */function addEventListener(el,name,handler){if(isDomLevel2){// Reproduct the console warning:
// [Violation] Added non-passive event listener to a scroll-blocking <some> event.
// Consider marking event handler as 'passive' to make the page more responsive.
// Just set console log level: verbose in chrome dev tool.
// then the warning log will be printed when addEventListener called.
// See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
// We have not yet found a neat way to using passive. Because in zrender the dom event
// listener delegate all of the upper events of element. Some of those events need
// to prevent default. For example, the feature `preventDefaultMouseMove` of echarts.
// Before passive can be adopted, these issues should be considered:
// (1) Whether and how a zrender user specifies an event listener passive. And by default,
// passive or not.
// (2) How to tread that some zrender event listener is passive, and some is not. If
// we use other way but not preventDefault of mousewheel and touchmove, browser
// compatibility should be handled.
// var opts = (env.passiveSupported && name === 'mousewheel')
//     ? {passive: true}
//     // By default, the third param of el.addEventListener is `capture: false`.
//     : void 0;
// el.addEventListener(name, handler /* , opts */);
el.addEventListener(name,handler);}else{el.attachEvent('on'+name,handler);}}function removeEventListener(el,name,handler){if(isDomLevel2){el.removeEventListener(name,handler);}else{el.detachEvent('on'+name,handler);}}/**
 * preventDefault and stopPropagation.
 * Notice: do not do that in zrender. Upper application
 * do that if necessary.
 *
 * @memberOf module:zrender/core/event
 * @method
 * @param {Event} e : event对象
 */var stop=isDomLevel2?function(e){e.preventDefault();e.stopPropagation();e.cancelBubble=true;}:function(e){e.returnValue=false;e.cancelBubble=true;};function notLeftMouse(e){// If e.which is undefined, considered as left mouse event.
return e.which>1;}// 做向上兼容
/**
 * 动画主类, 调度和管理所有动画控制器
 *
 * @module zrender/animation/Animation
 * @author pissang(https://github.com/pissang)
 */// TODO Additive animation
// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
// https://developer.apple.com/videos/wwdc2014/#236
/**
 * @typedef {Object} IZRenderStage
 * @property {Function} update
 *//**
 * @alias module:zrender/animation/Animation
 * @constructor
 * @param {Object} [options]
 * @param {Function} [options.onframe]
 * @param {IZRenderStage} [options.stage]
 * @example
 *     var animation = new Animation();
 *     var obj = {
 *         x: 100,
 *         y: 100
 *     };
 *     animation.animate(node.position)
 *         .when(1000, {
 *             x: 500,
 *             y: 500
 *         })
 *         .when(2000, {
 *             x: 100,
 *             y: 100
 *         })
 *         .start('spline');
 */var Animation=function Animation(options){options=options||{};this.stage=options.stage||{};this.onframe=options.onframe||function(){};// private properties
this._clips=[];this._running=false;this._time;this._pausedTime;this._pauseStart;this._paused=false;Eventful.call(this);};Animation.prototype={constructor:Animation,/**
   * 添加 clip
   * @param {module:zrender/animation/Clip} clip
   */addClip:function addClip(clip){this._clips.push(clip);},/**
   * 添加 animator
   * @param {module:zrender/animation/Animator} animator
   */addAnimator:function addAnimator(animator){animator.animation=this;var clips=animator.getClips();for(var i=0;i<clips.length;i++){this.addClip(clips[i]);}},/**
   * 删除动画片段
   * @param {module:zrender/animation/Clip} clip
   */removeClip:function removeClip(clip){var idx=indexOf(this._clips,clip);if(idx>=0){this._clips.splice(idx,1);}},/**
   * 删除动画片段
   * @param {module:zrender/animation/Animator} animator
   */removeAnimator:function removeAnimator(animator){var clips=animator.getClips();for(var i=0;i<clips.length;i++){this.removeClip(clips[i]);}animator.animation=null;},_update:function _update(){var time=new Date().getTime()-this._pausedTime;var delta=time-this._time;var clips=this._clips;var len=clips.length;var deferredEvents=[];var deferredClips=[];for(var i=0;i<len;i++){var clip=clips[i];var e=clip.step(time,delta);// Throw out the events need to be called after
// stage.update, like destroy
if(e){deferredEvents.push(e);deferredClips.push(clip);}}// Remove the finished clip
for(var i=0;i<len;){if(clips[i]._needsRemove){clips[i]=clips[len-1];clips.pop();len--;}else{i++;}}len=deferredEvents.length;for(var i=0;i<len;i++){deferredClips[i].fire(deferredEvents[i]);}this._time=time;this.onframe(delta);// 'frame' should be triggered before stage, because upper application
// depends on the sequence (e.g., echarts-stream and finish
// event judge)
this.trigger('frame',delta);if(this.stage.update){this.stage.update();}},_startLoop:function _startLoop(){var self=this;this._running=true;function step(){if(self._running){requestAnimationFrame(step);!self._paused&&self._update();}}requestAnimationFrame(step);},/**
   * Start animation.
   */start:function start(){this._time=new Date().getTime();this._pausedTime=0;this._startLoop();},/**
   * Stop animation.
   */stop:function stop(){this._running=false;},/**
   * Pause animation.
   */pause:function pause(){if(!this._paused){this._pauseStart=new Date().getTime();this._paused=true;}},/**
   * Resume animation.
   */resume:function resume(){if(this._paused){this._pausedTime+=new Date().getTime()-this._pauseStart;this._paused=false;}},/**
   * Clear animation.
   */clear:function clear(){this._clips=[];},/**
   * Whether animation finished.
   */isFinished:function isFinished(){return!this._clips.length;},/**
   * Creat animator for a target, whose props can be animated.
   *
   * @param  {Object} target
   * @param  {Object} options
   * @param  {boolean} [options.loop=false] Whether loop animation.
   * @param  {Function} [options.getter=null] Get value from target.
   * @param  {Function} [options.setter=null] Set value to target.
   * @return {module:zrender/animation/Animation~Animator}
   */// TODO Gap
animate:function animate(target,options){options=options||{};var animator=new Animator(target,options.loop,options.getter,options.setter);this.addAnimator(animator);return animator;}};mixin(Animation,Eventful);/**
 * Only implements needed gestures for mobile.
 */var GestureMgr=function GestureMgr(){/**
   * @private
   * @type {Array.<Object>}
   */this._track=[];};GestureMgr.prototype={constructor:GestureMgr,recognize:function recognize(event,target,root){this._doTrack(event,target,root);return this._recognize(event);},clear:function clear(){this._track.length=0;return this;},_doTrack:function _doTrack(event,target,root){var touches=event.touches;if(!touches){return;}var trackItem={points:[],touches:[],target:target,event:event};for(var i=0,len=touches.length;i<len;i++){var touch=touches[i];var pos=clientToLocal(root,touch,{});trackItem.points.push([pos.zrX,pos.zrY]);trackItem.touches.push(touch);}this._track.push(trackItem);},_recognize:function _recognize(event){for(var eventName in recognizers){if(recognizers.hasOwnProperty(eventName)){var gestureInfo=recognizers[eventName](this._track,event);if(gestureInfo){return gestureInfo;}}}}};function dist$1(pointPair){var dx=pointPair[1][0]-pointPair[0][0];var dy=pointPair[1][1]-pointPair[0][1];return Math.sqrt(dx*dx+dy*dy);}function center(pointPair){return[(pointPair[0][0]+pointPair[1][0])/2,(pointPair[0][1]+pointPair[1][1])/2];}var recognizers={pinch:function pinch(track,event){var trackLen=track.length;if(!trackLen){return;}var pinchEnd=(track[trackLen-1]||{}).points;var pinchPre=(track[trackLen-2]||{}).points||pinchEnd;if(pinchPre&&pinchPre.length>1&&pinchEnd&&pinchEnd.length>1){var pinchScale=dist$1(pinchEnd)/dist$1(pinchPre);!isFinite(pinchScale)&&(pinchScale=1);event.pinchScale=pinchScale;var pinchCenter=center(pinchEnd);event.pinchX=pinchCenter[0];event.pinchY=pinchCenter[1];return{type:'pinch',target:track[0].target,event:event};}}// Only pinch currently.
};var TOUCH_CLICK_DELAY=300;var mouseHandlerNames=['click','dblclick','mousewheel','mouseout','mouseup','mousedown','mousemove','contextmenu'];var touchHandlerNames=['touchstart','touchend','touchmove'];var pointerEventNames={pointerdown:1,pointerup:1,pointermove:1,pointerout:1};var pointerHandlerNames=map(mouseHandlerNames,function(name){var nm=name.replace('mouse','pointer');return pointerEventNames[nm]?nm:name;});function eventNameFix(name){return name==='mousewheel'&&env$1.browser.firefox?'DOMMouseScroll':name;}function processGesture(proxy,event,stage){var gestureMgr=proxy._gestureMgr;stage==='start'&&gestureMgr.clear();var gestureInfo=gestureMgr.recognize(event,proxy.handler.findHover(event.zrX,event.zrY,null).target,proxy.dom);stage==='end'&&gestureMgr.clear();// Do not do any preventDefault here. Upper application do that if necessary.
if(gestureInfo){var type=gestureInfo.type;event.gestureEvent=type;proxy.handler.dispatchToElement({target:gestureInfo.target},type,gestureInfo.event);}}// function onMSGestureChange(proxy, event) {
//     if (event.translationX || event.translationY) {
//         // mousemove is carried by MSGesture to reduce the sensitivity.
//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
//     }
//     if (event.scale !== 1) {
//         event.pinchX = event.offsetX;
//         event.pinchY = event.offsetY;
//         event.pinchScale = event.scale;
//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
//     }
// }
/**
 * Prevent mouse event from being dispatched after Touch Events action
 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
 * Result: Blocking Mouse Events for 700ms.
 */function setTouchTimer(instance){instance._touching=true;clearTimeout(instance._touchTimer);instance._touchTimer=setTimeout(function(){instance._touching=false;},700);}var domHandlers={/**
   * Mouse move handler
   * @inner
   * @param {Event} event
   */mousemove:function mousemove(event){event=normalizeEvent(this.dom,event);this.trigger('mousemove',event);},/**
   * Mouse out handler
   * @inner
   * @param {Event} event
   */mouseout:function mouseout(event){event=normalizeEvent(this.dom,event);var element=event.toElement||event.relatedTarget;if(element!=this.dom){while(element&&element.nodeType!=9){// 忽略包含在root中的dom引起的mouseOut
if(element===this.dom){return;}element=element.parentNode;}}this.trigger('mouseout',event);},/**
   * Touch开始响应函数
   * @inner
   * @param {Event} event
   */touchstart:function touchstart(event){// Default mouse behaviour should not be disabled here.
// For example, page may needs to be slided.
event=normalizeEvent(this.dom,event);// Mark touch, which is useful in distinguish touch and
// mouse event in upper applicatoin.
event.zrByTouch=true;this._lastTouchMoment=new Date();processGesture(this,event,'start');// In touch device, trigger `mousemove`(`mouseover`) should
// be triggered, and must before `mousedown` triggered.
domHandlers.mousemove.call(this,event);domHandlers.mousedown.call(this,event);setTouchTimer(this);},/**
   * Touch移动响应函数
   * @inner
   * @param {Event} event
   */touchmove:function touchmove(event){event=normalizeEvent(this.dom,event);// Mark touch, which is useful in distinguish touch and
// mouse event in upper applicatoin.
event.zrByTouch=true;processGesture(this,event,'change');// Mouse move should always be triggered no matter whether
// there is gestrue event, because mouse move and pinch may
// be used at the same time.
domHandlers.mousemove.call(this,event);setTouchTimer(this);},/**
   * Touch结束响应函数
   * @inner
   * @param {Event} event
   */touchend:function touchend(event){event=normalizeEvent(this.dom,event);// Mark touch, which is useful in distinguish touch and
// mouse event in upper applicatoin.
event.zrByTouch=true;processGesture(this,event,'end');domHandlers.mouseup.call(this,event);// Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
// triggered in `touchstart`. This seems to be illogical, but by this mechanism,
// we can conveniently implement "hover style" in both PC and touch device just
// by listening to `mouseover` to add "hover style" and listening to `mouseout`
// to remove "hover style" on an element, without any additional code for
// compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
// style" will remain for user view)
// click event should always be triggered no matter whether
// there is gestrue event. System click can not be prevented.
if(+new Date()-this._lastTouchMoment<TOUCH_CLICK_DELAY){domHandlers.click.call(this,event);}setTouchTimer(this);},pointerdown:function pointerdown(event){domHandlers.mousedown.call(this,event);// if (useMSGuesture(this, event)) {
//     this._msGesture.addPointer(event.pointerId);
// }
},pointermove:function pointermove(event){// FIXME
// pointermove is so sensitive that it always triggered when
// tap(click) on touch screen, which affect some judgement in
// upper application. So, we dont support mousemove on MS touch
// device yet.
if(!isPointerFromTouch(event)){domHandlers.mousemove.call(this,event);}},pointerup:function pointerup(event){domHandlers.mouseup.call(this,event);},pointerout:function pointerout(event){// pointerout will be triggered when tap on touch screen
// (IE11+/Edge on MS Surface) after click event triggered,
// which is inconsistent with the mousout behavior we defined
// in touchend. So we unify them.
// (check domHandlers.touchend for detailed explanation)
if(!isPointerFromTouch(event)){domHandlers.mouseout.call(this,event);}}};function isPointerFromTouch(event){var pointerType=event.pointerType;return pointerType==='pen'||pointerType==='touch';}// function useMSGuesture(handlerProxy, event) {
//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
// }
// Common handlers
each$1(['click','mousedown','mouseup','mousewheel','dblclick','contextmenu'],function(name){domHandlers[name]=function(event){event=normalizeEvent(this.dom,event);this.trigger(name,event);};});/**
 * 为控制类实例初始化dom 事件处理函数
 *
 * @inner
 * @param {module:zrender/Handler} instance 控制类实例
 */function initDomHandler(instance){each$1(touchHandlerNames,function(name){instance._handlers[name]=bind(domHandlers[name],instance);});each$1(pointerHandlerNames,function(name){instance._handlers[name]=bind(domHandlers[name],instance);});each$1(mouseHandlerNames,function(name){instance._handlers[name]=makeMouseHandler(domHandlers[name],instance);});function makeMouseHandler(fn,instance){return function(){if(instance._touching){return;}return fn.apply(instance,arguments);};}}function HandlerDomProxy(dom){Eventful.call(this);this.dom=dom;/**
   * @private
   * @type {boolean}
   */this._touching=false;/**
   * @private
   * @type {number}
   */this._touchTimer;/**
   * @private
   * @type {module:zrender/core/GestureMgr}
   */this._gestureMgr=new GestureMgr();this._handlers={};initDomHandler(this);if(env$1.pointerEventsSupported){// Only IE11+/Edge
// 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
// IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
// at the same time.
// 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
// screen, which do not occurs in pointer event.
// So we use pointer event to both detect touch gesture and mouse behavior.
mountHandlers(pointerHandlerNames,this);// FIXME
// Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
// which does not prevent defuault behavior occasionally (which may cause view port
// zoomed in but use can not zoom it back). And event.preventDefault() does not work.
// So we have to not to use MSGesture and not to support touchmove and pinch on MS
// touch screen. And we only support click behavior on MS touch screen now.
// MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
// We dont support touch on IE on win7.
// See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
// if (typeof MSGesture === 'function') {
//     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
//     dom.addEventListener('MSGestureChange', onMSGestureChange);
// }
}else{if(env$1.touchEventsSupported){mountHandlers(touchHandlerNames,this);// Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
// addEventListener(root, 'mouseout', this._mouseoutHandler);
}// 1. Considering some devices that both enable touch and mouse event (like on MS Surface
// and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
// mouse event can not be handle in those devices.
// 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
// mouseevent after touch event triggered, see `setTouchTimer`.
mountHandlers(mouseHandlerNames,this);}function mountHandlers(handlerNames,instance){each$1(handlerNames,function(name){addEventListener(dom,eventNameFix(name),instance._handlers[name]);},instance);}}var handlerDomProxyProto=HandlerDomProxy.prototype;handlerDomProxyProto.dispose=function(){var handlerNames=mouseHandlerNames.concat(touchHandlerNames);for(var i=0;i<handlerNames.length;i++){var name=handlerNames[i];removeEventListener(this.dom,eventNameFix(name),this._handlers[name]);}};handlerDomProxyProto.setCursor=function(cursorStyle){this.dom.style&&(this.dom.style.cursor=cursorStyle||'default');};mixin(HandlerDomProxy,Eventful);/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/var useVML=!env$1.canvasSupported;var painterCtors={canvas:Painter};var instances$1={};// ZRender实例map索引
/**
 * @type {string}
 */var version$1='4.0.4';/**
 * Initializing a zrender instance
 * @param {HTMLElement} dom
 * @param {Object} opts
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
 * @return {module:zrender/ZRender}
 */function init$1(dom,opts){var zr=new ZRender(guid(),dom,opts);instances$1[zr.id]=zr;return zr;}/**
 * Dispose zrender instance
 * @param {module:zrender/ZRender} zr
 */function dispose$1(zr){if(zr){zr.dispose();}else{for(var key in instances$1){if(instances$1.hasOwnProperty(key)){instances$1[key].dispose();}}instances$1={};}return this;}/**
 * Get zrender instance by id
 * @param {string} id zrender instance id
 * @return {module:zrender/ZRender}
 */function getInstance(id){return instances$1[id];}function registerPainter(name,Ctor){painterCtors[name]=Ctor;}function delInstance(id){delete instances$1[id];}/**
 * @module zrender/ZRender
 *//**
 * @constructor
 * @alias module:zrender/ZRender
 * @param {string} id
 * @param {HTMLElement} dom
 * @param {Object} opts
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 */var ZRender=function ZRender(id,dom,opts){opts=opts||{};/**
   * @type {HTMLDomElement}
   */this.dom=dom;/**
   * @type {string}
   */this.id=id;var self=this;var storage=new Storage();var rendererType=opts.renderer;// TODO WebGL
if(useVML){if(!painterCtors.vml){throw new Error('You need to require \'zrender/vml/vml\' to support IE8');}rendererType='vml';}else if(!rendererType||!painterCtors[rendererType]){rendererType='canvas';}var painter=new painterCtors[rendererType](dom,storage,opts,id);this.storage=storage;this.painter=painter;var handerProxy=!env$1.node&&!env$1.worker?new HandlerDomProxy(painter.getViewportRoot()):null;this.handler=new Handler(storage,painter,handerProxy,painter.root);/**
   * @type {module:zrender/animation/Animation}
   */this.animation=new Animation({stage:{update:bind(this.flush,this)}});this.animation.start();/**
   * @type {boolean}
   * @private
   */this._needsRefresh;// 修改 storage.delFromStorage, 每次删除元素之前删除动画
// FIXME 有点ugly
var oldDelFromStorage=storage.delFromStorage;var oldAddToStorage=storage.addToStorage;storage.delFromStorage=function(el){oldDelFromStorage.call(storage,el);el&&el.removeSelfFromZr(self);};storage.addToStorage=function(el){oldAddToStorage.call(storage,el);el.addSelfToZr(self);};};ZRender.prototype={constructor:ZRender,/**
   * 获取实例唯一标识
   * @return {string}
   */getId:function getId(){return this.id;},/**
   * 添加元素
   * @param  {module:zrender/Element} el
   */add:function add(el){this.storage.addRoot(el);this._needsRefresh=true;},/**
   * 删除元素
   * @param  {module:zrender/Element} el
   */remove:function remove(el){this.storage.delRoot(el);this._needsRefresh=true;},/**
   * Change configuration of layer
   * @param {string} zLevel
   * @param {Object} config
   * @param {string} [config.clearColor=0] Clear color
   * @param {string} [config.motionBlur=false] If enable motion blur
   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
  */configLayer:function configLayer(zLevel,config){if(this.painter.configLayer){this.painter.configLayer(zLevel,config);}this._needsRefresh=true;},/**
   * Set background color
   * @param {string} backgroundColor
   */setBackgroundColor:function setBackgroundColor(backgroundColor){if(this.painter.setBackgroundColor){this.painter.setBackgroundColor(backgroundColor);}this._needsRefresh=true;},/**
   * Repaint the canvas immediately
   */refreshImmediately:function refreshImmediately(){// var start = new Date();
// Clear needsRefresh ahead to avoid something wrong happens in refresh
// Or it will cause zrender refreshes again and again.
this._needsRefresh=false;this.painter.refresh();/**
     * Avoid trigger zr.refresh in Element#beforeUpdate hook
     */this._needsRefresh=false;// var end = new Date();
// var log = document.getElementById('log');
// if (log) {
//     log.innerHTML = log.innerHTML + '<br>' + (end - start);
// }
},/**
   * Mark and repaint the canvas in the next frame of browser
   */refresh:function refresh(){this._needsRefresh=true;},/**
   * Perform all refresh
   */flush:function flush(){var triggerRendered;if(this._needsRefresh){triggerRendered=true;this.refreshImmediately();}if(this._needsRefreshHover){triggerRendered=true;this.refreshHoverImmediately();}triggerRendered&&this.trigger('rendered');},/**
   * Add element to hover layer
   * @param  {module:zrender/Element} el
   * @param {Object} style
   */addHover:function addHover(el,style){if(this.painter.addHover){this.painter.addHover(el,style);this.refreshHover();}},/**
   * Add element from hover layer
   * @param  {module:zrender/Element} el
   */removeHover:function removeHover(el){if(this.painter.removeHover){this.painter.removeHover(el);this.refreshHover();}},/**
   * Clear all hover elements in hover layer
   * @param  {module:zrender/Element} el
   */clearHover:function clearHover(){if(this.painter.clearHover){this.painter.clearHover();this.refreshHover();}},/**
   * Refresh hover in next frame
   */refreshHover:function refreshHover(){this._needsRefreshHover=true;},/**
   * Refresh hover immediately
   */refreshHoverImmediately:function refreshHoverImmediately(){this._needsRefreshHover=false;this.painter.refreshHover&&this.painter.refreshHover();},/**
   * Resize the canvas.
   * Should be invoked when container size is changed
   * @param {Object} [opts]
   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
   */resize:function resize(opts){opts=opts||{};this.painter.resize(opts.width,opts.height);this.handler.resize();},/**
   * Stop and clear all animation immediately
   */clearAnimation:function clearAnimation(){this.animation.clear();},/**
   * Get container width
   */getWidth:function getWidth(){return this.painter.getWidth();},/**
   * Get container height
   */getHeight:function getHeight(){return this.painter.getHeight();},/**
   * Export the canvas as Base64 URL
   * @param {string} type
   * @param {string} [backgroundColor='#fff']
   * @return {string} Base64 URL
   */// toDataURL: function(type, backgroundColor) {
//     return this.painter.getRenderedCanvas({
//         backgroundColor: backgroundColor
//     }).toDataURL(type);
// },
/**
   * Converting a path to image.
   * It has much better performance of drawing image rather than drawing a vector path.
   * @param {module:zrender/graphic/Path} e
   * @param {number} width
   * @param {number} height
   */pathToImage:function pathToImage(e,dpr){return this.painter.pathToImage(e,dpr);},/**
   * Set default cursor
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */setCursorStyle:function setCursorStyle(cursorStyle){this.handler.setCursorStyle(cursorStyle);},/**
   * Find hovered element
   * @param {number} x
   * @param {number} y
   * @return {Object} {target, topTarget}
   */findHover:function findHover(x,y){return this.handler.findHover(x,y);},/**
   * Bind event
   *
   * @param {string} eventName Event name
   * @param {Function} eventHandler Handler function
   * @param {Object} [context] Context object
   */on:function on(eventName,eventHandler,context){this.handler.on(eventName,eventHandler,context);},/**
   * Unbind event
   * @param {string} eventName Event name
   * @param {Function} [eventHandler] Handler function
   */off:function off(eventName,eventHandler){this.handler.off(eventName,eventHandler);},/**
   * Trigger event manually
   *
   * @param {string} eventName Event name
   * @param {event=} event Event object
   */trigger:function trigger(eventName,event){this.handler.trigger(eventName,event);},/**
   * Clear all objects and the canvas.
   */clear:function clear(){this.storage.delRoot();this.painter.clear();},/**
   * Dispose self.
   */dispose:function dispose(){this.animation.stop();this.clear();this.storage.dispose();this.painter.dispose();this.handler.dispose();this.animation=this.storage=this.painter=this.handler=null;delInstance(this.id);}};var zrender=(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a||Object)({version:version$1,init:init$1,dispose:dispose$1,getInstance:getInstance,registerPainter:registerPainter});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var each$2=each$1;var isObject$2=isObject$1;var isArray$1=isArray;/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */var DUMMY_COMPONENT_NAME_PREFIX='series\0';/**
 * If value is not array, then translate it to array.
 * @param  {*} value
 * @return {Array} [value] or value
 */function normalizeToArray(value){return value instanceof Array?value:value==null?[]:[value];}/**
 * Sync default option between normal and emphasis like `position` and `show`
 * In case some one will write code like
 *     label: {
 *          show: false,
 *          position: 'outside',
 *          fontSize: 18
 *     },
 *     emphasis: {
 *          label: { show: true }
 *     }
 * @param {Object} opt
 * @param {string} key
 * @param {Array.<string>} subOpts
 */function defaultEmphasis(opt,key,subOpts){// Caution: performance sensitive.
if(opt){opt[key]=opt[key]||{};opt.emphasis=opt.emphasis||{};opt.emphasis[key]=opt.emphasis[key]||{};// Default emphasis option from normal
for(var i=0,len=subOpts.length;i<len;i++){var subOptName=subOpts[i];if(!opt.emphasis[key].hasOwnProperty(subOptName)&&opt[key].hasOwnProperty(subOptName)){opt.emphasis[key][subOptName]=opt[key][subOptName];}}}}var TEXT_STYLE_OPTIONS=['fontStyle','fontWeight','fontSize','fontFamily','rich','tag','color','textBorderColor','textBorderWidth','width','height','lineHeight','align','verticalAlign','baseline','shadowColor','shadowBlur','shadowOffsetX','shadowOffsetY','textShadowColor','textShadowBlur','textShadowOffsetX','textShadowOffsetY','backgroundColor','borderColor','borderWidth','borderRadius','padding'];// modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
//     // FIXME: deprecated, check and remove it.
//     'textStyle'
// ]);
/**
 * The method do not ensure performance.
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method retieves value from data.
 * @param {string|number|Date|Array|Object} dataItem
 * @return {number|string|Date|Array.<number|string|Date>}
 */function getDataItemValue(dataItem){return isObject$2(dataItem)&&!isArray$1(dataItem)&&!(dataItem instanceof Date)?dataItem.value:dataItem;}/**
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method determine if dataItem has extra option besides value
 * @param {string|number|Date|Array|Object} dataItem
 */function isDataItemOption(dataItem){return isObject$2(dataItem)&&!(dataItem instanceof Array);// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}/**
 * Mapping to exists for merge.
 *
 * @public
 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
 * @param {Object|Array.<Object>} newCptOptions
 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          index of which is the same as exists.
 */function mappingToExists(exists,newCptOptions){// Mapping by the order by original option (but not order of
// new option) in merge mode. Because we should ensure
// some specified index (like xAxisIndex) is consistent with
// original option, which is easy to understand, espatially in
// media query. And in most case, merge option is used to
// update partial option but not be expected to change order.
newCptOptions=(newCptOptions||[]).slice();var result=map(exists||[],function(obj,index){return{exist:obj};});// Mapping by id or name if specified.
each$2(newCptOptions,function(cptOption,index){if(!isObject$2(cptOption)){return;}// id has highest priority.
for(var i=0;i<result.length;i++){if(!result[i].option// Consider name: two map to one.
&&cptOption.id!=null&&result[i].exist.id===cptOption.id+''){result[i].option=cptOption;newCptOptions[index]=null;return;}}for(var i=0;i<result.length;i++){var exist=result[i].exist;if(!result[i].option// Consider name: two map to one.
// Can not match when both ids exist but different.
&&(exist.id==null||cptOption.id==null)&&cptOption.name!=null&&!isIdInner(cptOption)&&!isIdInner(exist)&&exist.name===cptOption.name+''){result[i].option=cptOption;newCptOptions[index]=null;return;}}});// Otherwise mapping by index.
each$2(newCptOptions,function(cptOption,index){if(!isObject$2(cptOption)){return;}var i=0;for(;i<result.length;i++){var exist=result[i].exist;if(!result[i].option// Existing model that already has id should be able to
// mapped to (because after mapping performed model may
// be assigned with a id, whish should not affect next
// mapping), except those has inner id.
&&!isIdInner(exist)// Caution:
// Do not overwrite id. But name can be overwritten,
// because axis use name as 'show label text'.
// 'exist' always has id and name and we dont
// need to check it.
&&cptOption.id==null){result[i].option=cptOption;break;}}if(i>=result.length){result.push({option:cptOption});}});return result;}/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 *
 * @public
 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          which order is the same as exists.
 * @return {Array.<Object>} The input.
 */function makeIdAndName(mapResult){// We use this id to hash component models and view instances
// in echarts. id can be specified by user, or auto generated.
// The id generation rule ensures new view instance are able
// to mapped to old instance when setOption are called in
// no-merge mode. So we generate model id by name and plus
// type in view id.
// name can be duplicated among components, which is convenient
// to specify multi components (like series) by one name.
// Ensure that each id is distinct.
var idMap=createHashMap();each$2(mapResult,function(item,index){var existCpt=item.exist;existCpt&&idMap.set(existCpt.id,item);});each$2(mapResult,function(item,index){var opt=item.option;assert$1(!opt||opt.id==null||!idMap.get(opt.id)||idMap.get(opt.id)===item,'id duplicates: '+(opt&&opt.id));opt&&opt.id!=null&&idMap.set(opt.id,item);!item.keyInfo&&(item.keyInfo={});});// Make name and id.
each$2(mapResult,function(item,index){var existCpt=item.exist;var opt=item.option;var keyInfo=item.keyInfo;if(!isObject$2(opt)){return;}// name can be overwitten. Consider case: axis.name = '20km'.
// But id generated by name will not be changed, which affect
// only in that case: setOption with 'not merge mode' and view
// instance will be recreated, which can be accepted.
keyInfo.name=opt.name!=null?opt.name+'':existCpt?existCpt.name// Avoid diffferent series has the same name,
// because name may be used like in color pallet.
:DUMMY_COMPONENT_NAME_PREFIX+index;if(existCpt){keyInfo.id=existCpt.id;}else if(opt.id!=null){keyInfo.id=opt.id+'';}else{// Consider this situatoin:
//  optionA: [{name: 'a'}, {name: 'a'}, {..}]
//  optionB [{..}, {name: 'a'}, {name: 'a'}]
// Series with the same name between optionA and optionB
// should be mapped.
var idNum=0;do{keyInfo.id='\0'+keyInfo.name+'\0'+idNum++;}while(idMap.get(keyInfo.id));}idMap.set(keyInfo.id,item);});}function isNameSpecified(componentModel){var name=componentModel.name;// Is specified when `indexOf` get -1 or > 0.
return!!(name&&name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));}/**
 * @public
 * @param {Object} cptOption
 * @return {boolean}
 */function isIdInner(cptOption){return isObject$2(cptOption)&&cptOption.id&&(cptOption.id+'').indexOf('\0_ec_\0')===0;}/**
 * A helper for removing duplicate items between batchA and batchB,
 * and in themselves, and categorize by series.
 *
 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
 */function compressBatches(batchA,batchB){var mapA={};var mapB={};makeMap(batchA||[],mapA);makeMap(batchB||[],mapB,mapA);return[mapToArray(mapA),mapToArray(mapB)];function makeMap(sourceBatch,map$$1,otherMap){for(var i=0,len=sourceBatch.length;i<len;i++){var seriesId=sourceBatch[i].seriesId;var dataIndices=normalizeToArray(sourceBatch[i].dataIndex);var otherDataIndices=otherMap&&otherMap[seriesId];for(var j=0,lenj=dataIndices.length;j<lenj;j++){var dataIndex=dataIndices[j];if(otherDataIndices&&otherDataIndices[dataIndex]){otherDataIndices[dataIndex]=null;}else{(map$$1[seriesId]||(map$$1[seriesId]={}))[dataIndex]=1;}}}}function mapToArray(map$$1,isData){var result=[];for(var i in map$$1){if(map$$1.hasOwnProperty(i)&&map$$1[i]!=null){if(isData){result.push(+i);}else{var dataIndices=mapToArray(map$$1[i],true);dataIndices.length&&result.push({seriesId:i,dataIndex:dataIndices});}}}return result;}}/**
 * @param {module:echarts/data/List} data
 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
 *                         each of which can be Array or primary type.
 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
 */function queryDataIndex(data,payload){if(payload.dataIndexInside!=null){return payload.dataIndexInside;}else if(payload.dataIndex!=null){return isArray(payload.dataIndex)?map(payload.dataIndex,function(value){return data.indexOfRawIndex(value);}):data.indexOfRawIndex(payload.dataIndex);}else if(payload.name!=null){return isArray(payload.name)?map(payload.name,function(value){return data.indexOfName(value);}):data.indexOfName(payload.name);}}/**
 * Enable property storage to any host object.
 * Notice: Serialization is not supported.
 *
 * For example:
 * var inner = zrUitl.makeInner();
 *
 * function some1(hostObj) {
 *      inner(hostObj).someProperty = 1212;
 *      ...
 * }
 * function some2() {
 *      var fields = inner(this);
 *      fields.someProperty1 = 1212;
 *      fields.someProperty2 = 'xx';
 *      ...
 * }
 *
 * @return {Function}
 */function makeInner(){// Consider different scope by es module import.
var key='__\0ec_inner_'+innerUniqueIndex++ +'_'+Math.random().toFixed(5);return function(hostObj){return hostObj[key]||(hostObj[key]={});};}var innerUniqueIndex=0;/**
 * @param {module:echarts/model/Global} ecModel
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex, seriesId, seriesName,
 *            geoIndex, geoId, geoName,
 *            bmapIndex, bmapId, bmapName,
 *            xAxisIndex, xAxisId, xAxisName,
 *            yAxisIndex, yAxisId, yAxisName,
 *            gridIndex, gridId, gridName,
 *            ... (can be extended)
 *        }
 *        Each properties can be number|string|Array.<number>|Array.<string>
 *        For example, a finder could be
 *        {
 *            seriesIndex: 3,
 *            geoId: ['aa', 'cc'],
 *            gridName: ['xx', 'rr']
 *        }
 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
 *        If nothing or null/undefined specified, return nothing.
 * @param {Object} [opt]
 * @param {string} [opt.defaultMainType]
 * @param {Array.<string>} [opt.includeMainTypes]
 * @return {Object} result like:
 *        {
 *            seriesModels: [seriesModel1, seriesModel2],
 *            seriesModel: seriesModel1, // The first model
 *            geoModels: [geoModel1, geoModel2],
 *            geoModel: geoModel1, // The first model
 *            ...
 *        }
 */function parseFinder(ecModel,finder,opt){if(isString(finder)){var obj={};obj[finder+'Index']=0;finder=obj;}var defaultMainType=opt&&opt.defaultMainType;if(defaultMainType&&!has(finder,defaultMainType+'Index')&&!has(finder,defaultMainType+'Id')&&!has(finder,defaultMainType+'Name')){finder[defaultMainType+'Index']=0;}var result={};each$2(finder,function(value,key){var value=finder[key];// Exclude 'dataIndex' and other illgal keys.
if(key==='dataIndex'||key==='dataIndexInside'){result[key]=value;return;}var parsedKey=key.match(/^(\w+)(Index|Id|Name)$/)||[];var mainType=parsedKey[1];var queryType=(parsedKey[2]||'').toLowerCase();if(!mainType||!queryType||value==null||queryType==='index'&&value==='none'||opt&&opt.includeMainTypes&&indexOf(opt.includeMainTypes,mainType)<0){return;}var queryParam={mainType:mainType};if(queryType!=='index'||value!=='all'){queryParam[queryType]=value;}var models=ecModel.queryComponents(queryParam);result[mainType+'Models']=models;result[mainType+'Model']=models[0];});return result;}function has(obj,prop){return obj&&obj.hasOwnProperty(prop);}function setAttribute(dom,key,value){dom.setAttribute?dom.setAttribute(key,value):dom[key]=value;}function getAttribute(dom,key){return dom.getAttribute?dom.getAttribute(key):dom[key];}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var TYPE_DELIMITER='.';var IS_CONTAINER='___EC__COMPONENT__CONTAINER___';/**
 * Notice, parseClassType('') should returns {main: '', sub: ''}
 * @public
 */function parseClassType$1(componentType){var ret={main:'',sub:''};if(componentType){componentType=componentType.split(TYPE_DELIMITER);ret.main=componentType[0]||'';ret.sub=componentType[1]||'';}return ret;}/**
 * @public
 */function checkClassType(componentType){assert$1(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType),'componentType "'+componentType+'" illegal');}/**
 * @public
 */function enableClassExtend(RootClass,mandatoryMethods){RootClass.$constructor=RootClass;RootClass.extend=function(proto){var superClass=this;var ExtendedClass=function ExtendedClass(){if(!proto.$constructor){superClass.apply(this,arguments);}else{proto.$constructor.apply(this,arguments);}};extend(ExtendedClass.prototype,proto);ExtendedClass.extend=this.extend;ExtendedClass.superCall=superCall;ExtendedClass.superApply=superApply;inherits(ExtendedClass,this);ExtendedClass.superClass=superClass;return ExtendedClass;};}var classBase=0;/**
 * Can not use instanceof, consider different scope by
 * cross domain or es module import in ec extensions.
 * Mount a method "isInstance()" to Clz.
 */function enableClassCheck(Clz){var classAttr=['__\0is_clz',classBase++,Math.random().toFixed(3)].join('_');Clz.prototype[classAttr]=true;Clz.isInstance=function(obj){return!!(obj&&obj[classAttr]);};}// superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.
function superCall(context,methodName){var args=slice(arguments,2);return this.superClass.prototype[methodName].apply(context,args);}function superApply(context,methodName,args){return this.superClass.prototype[methodName].apply(context,args);}/**
 * @param {Object} entity
 * @param {Object} options
 * @param {boolean} [options.registerWhenExtend]
 * @public
 */function enableClassManagement(entity,options){options=options||{};/**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   * @type {Object}
   */var storage={};entity.registerClass=function(Clazz,componentType){if(componentType){checkClassType(componentType);componentType=parseClassType$1(componentType);if(!componentType.sub){storage[componentType.main]=Clazz;}else if(componentType.sub!==IS_CONTAINER){var container=makeContainer(componentType);container[componentType.sub]=Clazz;}}return Clazz;};entity.getClass=function(componentMainType,subType,throwWhenNotFound){var Clazz=storage[componentMainType];if(Clazz&&Clazz[IS_CONTAINER]){Clazz=subType?Clazz[subType]:null;}if(throwWhenNotFound&&!Clazz){throw new Error(!subType?componentMainType+'.'+'type should be specified.':'Component '+componentMainType+'.'+(subType||'')+' not exists. Load it first.');}return Clazz;};entity.getClassesByMainType=function(componentType){componentType=parseClassType$1(componentType);var result=[];var obj=storage[componentType.main];if(obj&&obj[IS_CONTAINER]){each$1(obj,function(o,type){type!==IS_CONTAINER&&result.push(o);});}else{result.push(obj);}return result;};entity.hasClass=function(componentType){// Just consider componentType.main.
componentType=parseClassType$1(componentType);return!!storage[componentType.main];};/**
   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
   */entity.getAllClassMainTypes=function(){var types=[];each$1(storage,function(obj,type){types.push(type);});return types;};/**
   * If a main type is container and has sub types
   * @param  {string}  mainType
   * @return {boolean}
   */entity.hasSubTypes=function(componentType){componentType=parseClassType$1(componentType);var obj=storage[componentType.main];return obj&&obj[IS_CONTAINER];};entity.parseClassType=parseClassType$1;function makeContainer(componentType){var container=storage[componentType.main];if(!container||!container[IS_CONTAINER]){container=storage[componentType.main]={};container[IS_CONTAINER]=true;}return container;}if(options.registerWhenExtend){var originalExtend=entity.extend;if(originalExtend){entity.extend=function(proto){var ExtendedClass=originalExtend.call(this,proto);return entity.registerClass(ExtendedClass,proto.type);};}}return entity;}/**
 * @param {string|Array.<string>} properties
 *//*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// TODO Parse shadow style
// TODO Only shallow path support
var makeStyleMapper=function makeStyleMapper(properties){// Normalize
for(var i=0;i<properties.length;i++){if(!properties[i][1]){properties[i][1]=properties[i][0];}}return function(model,excludes,includes){var style={};for(var i=0;i<properties.length;i++){var propName=properties[i][1];if(excludes&&indexOf(excludes,propName)>=0||includes&&indexOf(includes,propName)<0){continue;}var val=model.getShallow(propName);if(val!=null){style[properties[i][0]]=val;}}return style;};};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var _getLineStyle=makeStyleMapper([['lineWidth','width'],['stroke','color'],['opacity'],['shadowBlur'],['shadowOffsetX'],['shadowOffsetY'],['shadowColor']]);var lineStyleMixin={getLineStyle:function getLineStyle(excludes){var style=_getLineStyle(this,excludes);var lineDash=this.getLineDash(style.lineWidth);lineDash&&(style.lineDash=lineDash);return style;},getLineDash:function getLineDash(lineWidth){if(lineWidth==null){lineWidth=1;}var lineType=this.get('type');var dotSize=Math.max(lineWidth,2);var dashSize=lineWidth*4;return lineType==='solid'||lineType==null?null:lineType==='dashed'?[dashSize,dashSize]:[dotSize,dotSize];}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var _getAreaStyle=makeStyleMapper([['fill','color'],['shadowBlur'],['shadowOffsetX'],['shadowOffsetY'],['opacity'],['shadowColor']]);var areaStyleMixin={getAreaStyle:function getAreaStyle(excludes,includes){return _getAreaStyle(this,excludes,includes);}};/**
 * 曲线辅助模块
 * @module zrender/core/curve
 * @author pissang(https://www.github.com/pissang)
 */var mathPow=Math.pow;var mathSqrt$2=Math.sqrt;var EPSILON$1=1e-8;var EPSILON_NUMERIC=1e-4;var THREE_SQRT=mathSqrt$2(3);var ONE_THIRD=1/3;// 临时变量
var _v0=create();var _v1=create();var _v2=create();function isAroundZero(val){return val>-EPSILON$1&&val<EPSILON$1;}function isNotAroundZero$1(val){return val>EPSILON$1||val<-EPSILON$1;}/**
 * 计算三次贝塞尔值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */function cubicAt(p0,p1,p2,p3,t){var onet=1-t;return onet*onet*(onet*p0+3*t*p1)+t*t*(t*p3+3*onet*p2);}/**
 * 计算三次贝塞尔导数值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */function cubicDerivativeAt(p0,p1,p2,p3,t){var onet=1-t;return 3*(((p1-p0)*onet+2*(p2-p1)*t)*onet+(p3-p2)*t*t);}/**
 * 计算三次贝塞尔方程根，使用盛金公式
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} val
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */function cubicRootAt(p0,p1,p2,p3,val,roots){// Evaluate roots of cubic functions
var a=p3+3*(p1-p2)-p0;var b=3*(p2-p1*2+p0);var c=3*(p1-p0);var d=p0-val;var A=b*b-3*a*c;var B=b*c-9*a*d;var C=c*c-3*b*d;var n=0;if(isAroundZero(A)&&isAroundZero(B)){if(isAroundZero(b)){roots[0]=0;}else{var t1=-c/b;//t1, t2, t3, b is not zero
if(t1>=0&&t1<=1){roots[n++]=t1;}}}else{var disc=B*B-4*A*C;if(isAroundZero(disc)){var K=B/A;var t1=-b/a+K;// t1, a is not zero
var t2=-K/2;// t2, t3
if(t1>=0&&t1<=1){roots[n++]=t1;}if(t2>=0&&t2<=1){roots[n++]=t2;}}else if(disc>0){var discSqrt=mathSqrt$2(disc);var Y1=A*b+1.5*a*(-B+discSqrt);var Y2=A*b+1.5*a*(-B-discSqrt);if(Y1<0){Y1=-mathPow(-Y1,ONE_THIRD);}else{Y1=mathPow(Y1,ONE_THIRD);}if(Y2<0){Y2=-mathPow(-Y2,ONE_THIRD);}else{Y2=mathPow(Y2,ONE_THIRD);}var t1=(-b-(Y1+Y2))/(3*a);if(t1>=0&&t1<=1){roots[n++]=t1;}}else{var T=(2*A*b-3*a*B)/(2*mathSqrt$2(A*A*A));var theta=Math.acos(T)/3;var ASqrt=mathSqrt$2(A);var tmp=Math.cos(theta);var t1=(-b-2*ASqrt*tmp)/(3*a);var t2=(-b+ASqrt*(tmp+THREE_SQRT*Math.sin(theta)))/(3*a);var t3=(-b+ASqrt*(tmp-THREE_SQRT*Math.sin(theta)))/(3*a);if(t1>=0&&t1<=1){roots[n++]=t1;}if(t2>=0&&t2<=1){roots[n++]=t2;}if(t3>=0&&t3<=1){roots[n++]=t3;}}}return n;}/**
 * 计算三次贝塞尔方程极限值的位置
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {Array.<number>} extrema
 * @return {number} 有效数目
 */function cubicExtrema(p0,p1,p2,p3,extrema){var b=6*p2-12*p1+6*p0;var a=9*p1+3*p3-3*p0-9*p2;var c=3*p1-3*p0;var n=0;if(isAroundZero(a)){if(isNotAroundZero$1(b)){var t1=-c/b;if(t1>=0&&t1<=1){extrema[n++]=t1;}}}else{var disc=b*b-4*a*c;if(isAroundZero(disc)){extrema[0]=-b/(2*a);}else if(disc>0){var discSqrt=mathSqrt$2(disc);var t1=(-b+discSqrt)/(2*a);var t2=(-b-discSqrt)/(2*a);if(t1>=0&&t1<=1){extrema[n++]=t1;}if(t2>=0&&t2<=1){extrema[n++]=t2;}}}return n;}/**
 * 细分三次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {Array.<number>} out
 */function cubicSubdivide(p0,p1,p2,p3,t,out){var p01=(p1-p0)*t+p0;var p12=(p2-p1)*t+p1;var p23=(p3-p2)*t+p2;var p012=(p12-p01)*t+p01;var p123=(p23-p12)*t+p12;var p0123=(p123-p012)*t+p012;// Seg0
out[0]=p0;out[1]=p01;out[2]=p012;out[3]=p0123;// Seg1
out[4]=p0123;out[5]=p123;out[6]=p23;out[7]=p3;}/**
 * 投射点到三次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} [out] 投射点
 * @return {number}
 */function cubicProjectPoint(x0,y0,x1,y1,x2,y2,x3,y3,x,y,out){// http://pomax.github.io/bezierinfo/#projections
var t;var interval=0.005;var d=Infinity;var prev;var next;var d1;var d2;_v0[0]=x;_v0[1]=y;// 先粗略估计一下可能的最小距离的 t 值
// PENDING
for(var _t=0;_t<1;_t+=0.05){_v1[0]=cubicAt(x0,x1,x2,x3,_t);_v1[1]=cubicAt(y0,y1,y2,y3,_t);d1=distSquare(_v0,_v1);if(d1<d){t=_t;d=d1;}}d=Infinity;// At most 32 iteration
for(var i=0;i<32;i++){if(interval<EPSILON_NUMERIC){break;}prev=t-interval;next=t+interval;// t - interval
_v1[0]=cubicAt(x0,x1,x2,x3,prev);_v1[1]=cubicAt(y0,y1,y2,y3,prev);d1=distSquare(_v1,_v0);if(prev>=0&&d1<d){t=prev;d=d1;}else{// t + interval
_v2[0]=cubicAt(x0,x1,x2,x3,next);_v2[1]=cubicAt(y0,y1,y2,y3,next);d2=distSquare(_v2,_v0);if(next<=1&&d2<d){t=next;d=d2;}else{interval*=0.5;}}}// t
if(out){out[0]=cubicAt(x0,x1,x2,x3,t);out[1]=cubicAt(y0,y1,y2,y3,t);}// console.log(interval, i);
return mathSqrt$2(d);}/**
 * 计算二次方贝塞尔值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */function quadraticAt(p0,p1,p2,t){var onet=1-t;return onet*(onet*p0+2*t*p1)+t*t*p2;}/**
 * 计算二次方贝塞尔导数值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */function quadraticDerivativeAt(p0,p1,p2,t){return 2*((1-t)*(p1-p0)+t*(p2-p1));}/**
 * 计算二次方贝塞尔方程根
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */function quadraticRootAt(p0,p1,p2,val,roots){var a=p0-2*p1+p2;var b=2*(p1-p0);var c=p0-val;var n=0;if(isAroundZero(a)){if(isNotAroundZero$1(b)){var t1=-c/b;if(t1>=0&&t1<=1){roots[n++]=t1;}}}else{var disc=b*b-4*a*c;if(isAroundZero(disc)){var t1=-b/(2*a);if(t1>=0&&t1<=1){roots[n++]=t1;}}else if(disc>0){var discSqrt=mathSqrt$2(disc);var t1=(-b+discSqrt)/(2*a);var t2=(-b-discSqrt)/(2*a);if(t1>=0&&t1<=1){roots[n++]=t1;}if(t2>=0&&t2<=1){roots[n++]=t2;}}}return n;}/**
 * 计算二次贝塞尔方程极限值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @return {number}
 */function quadraticExtremum(p0,p1,p2){var divider=p0+p2-2*p1;if(divider===0){// p1 is center of p0 and p2
return 0.5;}else{return(p0-p1)/divider;}}/**
 * 细分二次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} out
 */function quadraticSubdivide(p0,p1,p2,t,out){var p01=(p1-p0)*t+p0;var p12=(p2-p1)*t+p1;var p012=(p12-p01)*t+p01;// Seg0
out[0]=p0;out[1]=p01;out[2]=p012;// Seg1
out[3]=p012;out[4]=p12;out[5]=p2;}/**
 * 投射点到二次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} out 投射点
 * @return {number}
 */function quadraticProjectPoint(x0,y0,x1,y1,x2,y2,x,y,out){// http://pomax.github.io/bezierinfo/#projections
var t;var interval=0.005;var d=Infinity;_v0[0]=x;_v0[1]=y;// 先粗略估计一下可能的最小距离的 t 值
// PENDING
for(var _t=0;_t<1;_t+=0.05){_v1[0]=quadraticAt(x0,x1,x2,_t);_v1[1]=quadraticAt(y0,y1,y2,_t);var d1=distSquare(_v0,_v1);if(d1<d){t=_t;d=d1;}}d=Infinity;// At most 32 iteration
for(var i=0;i<32;i++){if(interval<EPSILON_NUMERIC){break;}var prev=t-interval;var next=t+interval;// t - interval
_v1[0]=quadraticAt(x0,x1,x2,prev);_v1[1]=quadraticAt(y0,y1,y2,prev);var d1=distSquare(_v1,_v0);if(prev>=0&&d1<d){t=prev;d=d1;}else{// t + interval
_v2[0]=quadraticAt(x0,x1,x2,next);_v2[1]=quadraticAt(y0,y1,y2,next);var d2=distSquare(_v2,_v0);if(next<=1&&d2<d){t=next;d=d2;}else{interval*=0.5;}}}// t
if(out){out[0]=quadraticAt(x0,x1,x2,t);out[1]=quadraticAt(y0,y1,y2,t);}// console.log(interval, i);
return mathSqrt$2(d);}/**
 * @author Yi Shen(https://github.com/pissang)
 */var mathMin$3=Math.min;var mathMax$3=Math.max;var mathSin$2=Math.sin;var mathCos$2=Math.cos;var PI2=Math.PI*2;var start=create();var end=create();var extremity=create();/**
 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
 * @module zrender/core/bbox
 * @param {Array<Object>} points 顶点数组
 * @param {number} min
 * @param {number} max
 */function fromPoints(points,min$$1,max$$1){if(points.length===0){return;}var p=points[0];var left=p[0];var right=p[0];var top=p[1];var bottom=p[1];var i;for(i=1;i<points.length;i++){p=points[i];left=mathMin$3(left,p[0]);right=mathMax$3(right,p[0]);top=mathMin$3(top,p[1]);bottom=mathMax$3(bottom,p[1]);}min$$1[0]=left;min$$1[1]=top;max$$1[0]=right;max$$1[1]=bottom;}/**
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */function fromLine(x0,y0,x1,y1,min$$1,max$$1){min$$1[0]=mathMin$3(x0,x1);min$$1[1]=mathMin$3(y0,y1);max$$1[0]=mathMax$3(x0,x1);max$$1[1]=mathMax$3(y0,y1);}var xDim=[];var yDim=[];/**
 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */function fromCubic(x0,y0,x1,y1,x2,y2,x3,y3,min$$1,max$$1){var cubicExtrema$$1=cubicExtrema;var cubicAt$$1=cubicAt;var i;var n=cubicExtrema$$1(x0,x1,x2,x3,xDim);min$$1[0]=Infinity;min$$1[1]=Infinity;max$$1[0]=-Infinity;max$$1[1]=-Infinity;for(i=0;i<n;i++){var x=cubicAt$$1(x0,x1,x2,x3,xDim[i]);min$$1[0]=mathMin$3(x,min$$1[0]);max$$1[0]=mathMax$3(x,max$$1[0]);}n=cubicExtrema$$1(y0,y1,y2,y3,yDim);for(i=0;i<n;i++){var y=cubicAt$$1(y0,y1,y2,y3,yDim[i]);min$$1[1]=mathMin$3(y,min$$1[1]);max$$1[1]=mathMax$3(y,max$$1[1]);}min$$1[0]=mathMin$3(x0,min$$1[0]);max$$1[0]=mathMax$3(x0,max$$1[0]);min$$1[0]=mathMin$3(x3,min$$1[0]);max$$1[0]=mathMax$3(x3,max$$1[0]);min$$1[1]=mathMin$3(y0,min$$1[1]);max$$1[1]=mathMax$3(y0,max$$1[1]);min$$1[1]=mathMin$3(y3,min$$1[1]);max$$1[1]=mathMax$3(y3,max$$1[1]);}/**
 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */function fromQuadratic(x0,y0,x1,y1,x2,y2,min$$1,max$$1){var quadraticExtremum$$1=quadraticExtremum;var quadraticAt$$1=quadraticAt;// Find extremities, where derivative in x dim or y dim is zero
var tx=mathMax$3(mathMin$3(quadraticExtremum$$1(x0,x1,x2),1),0);var ty=mathMax$3(mathMin$3(quadraticExtremum$$1(y0,y1,y2),1),0);var x=quadraticAt$$1(x0,x1,x2,tx);var y=quadraticAt$$1(y0,y1,y2,ty);min$$1[0]=mathMin$3(x0,x2,x);min$$1[1]=mathMin$3(y0,y2,y);max$$1[0]=mathMax$3(x0,x2,x);max$$1[1]=mathMax$3(y0,y2,y);}/**
 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
 * @method
 * @memberOf module:zrender/core/bbox
 * @param {number} x
 * @param {number} y
 * @param {number} rx
 * @param {number} ry
 * @param {number} startAngle
 * @param {number} endAngle
 * @param {number} anticlockwise
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */function fromArc(x,y,rx,ry,startAngle,endAngle,anticlockwise,min$$1,max$$1){var vec2Min=min;var vec2Max=max;var diff=Math.abs(startAngle-endAngle);if(diff%PI2<1e-4&&diff>1e-4){// Is a circle
min$$1[0]=x-rx;min$$1[1]=y-ry;max$$1[0]=x+rx;max$$1[1]=y+ry;return;}start[0]=mathCos$2(startAngle)*rx+x;start[1]=mathSin$2(startAngle)*ry+y;end[0]=mathCos$2(endAngle)*rx+x;end[1]=mathSin$2(endAngle)*ry+y;vec2Min(min$$1,start,end);vec2Max(max$$1,start,end);// Thresh to [0, Math.PI * 2]
startAngle=startAngle%PI2;if(startAngle<0){startAngle=startAngle+PI2;}endAngle=endAngle%PI2;if(endAngle<0){endAngle=endAngle+PI2;}if(startAngle>endAngle&&!anticlockwise){endAngle+=PI2;}else if(startAngle<endAngle&&anticlockwise){startAngle+=PI2;}if(anticlockwise){var tmp=endAngle;endAngle=startAngle;startAngle=tmp;}// var number = 0;
// var step = (anticlockwise ? -Math.PI : Math.PI) / 2;
for(var angle=0;angle<endAngle;angle+=Math.PI/2){if(angle>startAngle){extremity[0]=mathCos$2(angle)*rx+x;extremity[1]=mathSin$2(angle)*ry+y;vec2Min(min$$1,extremity,min$$1);vec2Max(max$$1,extremity,max$$1);}}}/**
 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
 * 可以用于 isInsidePath 判断以及获取boundingRect
 *
 * @module zrender/core/PathProxy
 * @author Yi Shen (http://www.github.com/pissang)
 */// TODO getTotalLength, getPointAtLength
var CMD={M:1,L:2,C:3,Q:4,A:5,Z:6,// Rect
R:7};// var CMD_MEM_SIZE = {
//     M: 3,
//     L: 3,
//     C: 7,
//     Q: 5,
//     A: 9,
//     R: 5,
//     Z: 1
// };
var min$1=[];var max$1=[];var min2=[];var max2=[];var mathMin$2=Math.min;var mathMax$2=Math.max;var mathCos$1=Math.cos;var mathSin$1=Math.sin;var mathSqrt$1=Math.sqrt;var mathAbs=Math.abs;var hasTypedArray=typeof Float32Array!='undefined';/**
 * @alias module:zrender/core/PathProxy
 * @constructor
 */var PathProxy=function PathProxy(notSaveData){this._saveData=!(notSaveData||false);if(this._saveData){/**
     * Path data. Stored as flat array
     * @type {Array.<Object>}
     */this.data=[];}this._ctx=null;};/**
 * 快速计算Path包围盒（并不是最小包围盒）
 * @return {Object}
 */PathProxy.prototype={constructor:PathProxy,_xi:0,_yi:0,_x0:0,_y0:0,// Unit x, Unit y. Provide for avoiding drawing that too short line segment
_ux:0,_uy:0,_len:0,_lineDash:null,_dashOffset:0,_dashIdx:0,_dashSum:0,/**
   * @readOnly
   */setScale:function setScale(sx,sy){this._ux=mathAbs(1/devicePixelRatio/sx)||0;this._uy=mathAbs(1/devicePixelRatio/sy)||0;},getContext:function getContext(){return this._ctx;},/**
   * @param  {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */beginPath:function beginPath(ctx){this._ctx=ctx;ctx&&ctx.beginPath();ctx&&(this.dpr=ctx.dpr);// Reset
if(this._saveData){this._len=0;}if(this._lineDash){this._lineDash=null;this._dashOffset=0;}return this;},/**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */moveTo:function moveTo(x,y){this.addData(CMD.M,x,y);this._ctx&&this._ctx.moveTo(x,y);// x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
// xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
// 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
// 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持
this._x0=x;this._y0=y;this._xi=x;this._yi=y;return this;},/**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */lineTo:function lineTo(x,y){var exceedUnit=mathAbs(x-this._xi)>this._ux||mathAbs(y-this._yi)>this._uy// Force draw the first segment
||this._len<5;this.addData(CMD.L,x,y);if(this._ctx&&exceedUnit){this._needsDash()?this._dashedLineTo(x,y):this._ctx.lineTo(x,y);}if(exceedUnit){this._xi=x;this._yi=y;}return this;},/**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @param  {number} x3
   * @param  {number} y3
   * @return {module:zrender/core/PathProxy}
   */bezierCurveTo:function bezierCurveTo(x1,y1,x2,y2,x3,y3){this.addData(CMD.C,x1,y1,x2,y2,x3,y3);if(this._ctx){this._needsDash()?this._dashedBezierTo(x1,y1,x2,y2,x3,y3):this._ctx.bezierCurveTo(x1,y1,x2,y2,x3,y3);}this._xi=x3;this._yi=y3;return this;},/**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @return {module:zrender/core/PathProxy}
   */quadraticCurveTo:function quadraticCurveTo(x1,y1,x2,y2){this.addData(CMD.Q,x1,y1,x2,y2);if(this._ctx){this._needsDash()?this._dashedQuadraticTo(x1,y1,x2,y2):this._ctx.quadraticCurveTo(x1,y1,x2,y2);}this._xi=x2;this._yi=y2;return this;},/**
   * @param  {number} cx
   * @param  {number} cy
   * @param  {number} r
   * @param  {number} startAngle
   * @param  {number} endAngle
   * @param  {boolean} anticlockwise
   * @return {module:zrender/core/PathProxy}
   */arc:function arc(cx,cy,r,startAngle,endAngle,anticlockwise){this.addData(CMD.A,cx,cy,r,r,startAngle,endAngle-startAngle,0,anticlockwise?0:1);this._ctx&&this._ctx.arc(cx,cy,r,startAngle,endAngle,anticlockwise);this._xi=mathCos$1(endAngle)*r+cx;this._yi=mathSin$1(endAngle)*r+cx;return this;},// TODO
arcTo:function arcTo(x1,y1,x2,y2,radius){if(this._ctx){this._ctx.arcTo(x1,y1,x2,y2,radius);}return this;},// TODO
rect:function rect(x,y,w,h){this._ctx&&this._ctx.rect(x,y,w,h);this.addData(CMD.R,x,y,w,h);return this;},/**
   * @return {module:zrender/core/PathProxy}
   */closePath:function closePath(){this.addData(CMD.Z);var ctx=this._ctx;var x0=this._x0;var y0=this._y0;if(ctx){this._needsDash()&&this._dashedLineTo(x0,y0);ctx.closePath();}this._xi=x0;this._yi=y0;return this;},/**
   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
   * stroke 同样
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */fill:function fill(ctx){ctx&&ctx.fill();this.toStatic();},/**
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */stroke:function stroke(ctx){ctx&&ctx.stroke();this.toStatic();},/**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */setLineDash:function setLineDash(lineDash){if(lineDash instanceof Array){this._lineDash=lineDash;this._dashIdx=0;var lineDashSum=0;for(var i=0;i<lineDash.length;i++){lineDashSum+=lineDash[i];}this._dashSum=lineDashSum;}return this;},/**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */setLineDashOffset:function setLineDashOffset(offset){this._dashOffset=offset;return this;},/**
   *
   * @return {boolean}
   */len:function len(){return this._len;},/**
   * 直接设置 Path 数据
   */setData:function setData(data){var len$$1=data.length;if(!(this.data&&this.data.length==len$$1)&&hasTypedArray){this.data=new Float32Array(len$$1);}for(var i=0;i<len$$1;i++){this.data[i]=data[i];}this._len=len$$1;},/**
   * 添加子路径
   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
   */appendPath:function appendPath(path){if(!(path instanceof Array)){path=[path];}var len$$1=path.length;var appendSize=0;var offset=this._len;for(var i=0;i<len$$1;i++){appendSize+=path[i].len();}if(hasTypedArray&&this.data instanceof Float32Array){this.data=new Float32Array(offset+appendSize);}for(var i=0;i<len$$1;i++){var appendPathData=path[i].data;for(var k=0;k<appendPathData.length;k++){this.data[offset++]=appendPathData[k];}}this._len=offset;},/**
   * 填充 Path 数据。
   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
   */addData:function addData(cmd){if(!this._saveData){return;}var data=this.data;if(this._len+arguments.length>data.length){// 因为之前的数组已经转换成静态的 Float32Array
// 所以不够用时需要扩展一个新的动态数组
this._expandData();data=this.data;}for(var i=0;i<arguments.length;i++){data[this._len++]=arguments[i];}this._prevCmd=cmd;},_expandData:function _expandData(){// Only if data is Float32Array
if(!(this.data instanceof Array)){var newData=[];for(var i=0;i<this._len;i++){newData[i]=this.data[i];}this.data=newData;}},/**
   * If needs js implemented dashed line
   * @return {boolean}
   * @private
   */_needsDash:function _needsDash(){return this._lineDash;},_dashedLineTo:function _dashedLineTo(x1,y1){var dashSum=this._dashSum;var offset=this._dashOffset;var lineDash=this._lineDash;var ctx=this._ctx;var x0=this._xi;var y0=this._yi;var dx=x1-x0;var dy=y1-y0;var dist$$1=mathSqrt$1(dx*dx+dy*dy);var x=x0;var y=y0;var dash;var nDash=lineDash.length;var idx;dx/=dist$$1;dy/=dist$$1;if(offset<0){// Convert to positive offset
offset=dashSum+offset;}offset%=dashSum;x-=offset*dx;y-=offset*dy;while(dx>0&&x<=x1||dx<0&&x>=x1||dx==0&&(dy>0&&y<=y1||dy<0&&y>=y1)){idx=this._dashIdx;dash=lineDash[idx];x+=dx*dash;y+=dy*dash;this._dashIdx=(idx+1)%nDash;// Skip positive offset
if(dx>0&&x<x0||dx<0&&x>x0||dy>0&&y<y0||dy<0&&y>y0){continue;}ctx[idx%2?'moveTo':'lineTo'](dx>=0?mathMin$2(x,x1):mathMax$2(x,x1),dy>=0?mathMin$2(y,y1):mathMax$2(y,y1));}// Offset for next lineTo
dx=x-x1;dy=y-y1;this._dashOffset=-mathSqrt$1(dx*dx+dy*dy);},// Not accurate dashed line to
_dashedBezierTo:function _dashedBezierTo(x1,y1,x2,y2,x3,y3){var dashSum=this._dashSum;var offset=this._dashOffset;var lineDash=this._lineDash;var ctx=this._ctx;var x0=this._xi;var y0=this._yi;var t;var dx;var dy;var cubicAt$$1=cubicAt;var bezierLen=0;var idx=this._dashIdx;var nDash=lineDash.length;var x;var y;var tmpLen=0;if(offset<0){// Convert to positive offset
offset=dashSum+offset;}offset%=dashSum;// Bezier approx length
for(t=0;t<1;t+=0.1){dx=cubicAt$$1(x0,x1,x2,x3,t+0.1)-cubicAt$$1(x0,x1,x2,x3,t);dy=cubicAt$$1(y0,y1,y2,y3,t+0.1)-cubicAt$$1(y0,y1,y2,y3,t);bezierLen+=mathSqrt$1(dx*dx+dy*dy);}// Find idx after add offset
for(;idx<nDash;idx++){tmpLen+=lineDash[idx];if(tmpLen>offset){break;}}t=(tmpLen-offset)/bezierLen;while(t<=1){x=cubicAt$$1(x0,x1,x2,x3,t);y=cubicAt$$1(y0,y1,y2,y3,t);// Use line to approximate dashed bezier
// Bad result if dash is long
idx%2?ctx.moveTo(x,y):ctx.lineTo(x,y);t+=lineDash[idx]/bezierLen;idx=(idx+1)%nDash;}// Finish the last segment and calculate the new offset
idx%2!==0&&ctx.lineTo(x3,y3);dx=x3-x;dy=y3-y;this._dashOffset=-mathSqrt$1(dx*dx+dy*dy);},_dashedQuadraticTo:function _dashedQuadraticTo(x1,y1,x2,y2){// Convert quadratic to cubic using degree elevation
var x3=x2;var y3=y2;x2=(x2+2*x1)/3;y2=(y2+2*y1)/3;x1=(this._xi+2*x1)/3;y1=(this._yi+2*y1)/3;this._dashedBezierTo(x1,y1,x2,y2,x3,y3);},/**
   * 转成静态的 Float32Array 减少堆内存占用
   * Convert dynamic array to static Float32Array
   */toStatic:function toStatic(){var data=this.data;if(data instanceof Array){data.length=this._len;if(hasTypedArray){this.data=new Float32Array(data);}}},/**
   * @return {module:zrender/core/BoundingRect}
   */getBoundingRect:function getBoundingRect(){min$1[0]=min$1[1]=min2[0]=min2[1]=Number.MAX_VALUE;max$1[0]=max$1[1]=max2[0]=max2[1]=-Number.MAX_VALUE;var data=this.data;var xi=0;var yi=0;var x0=0;var y0=0;for(var i=0;i<data.length;){var cmd=data[i++];if(i==1){// 如果第一个命令是 L, C, Q
// 则 previous point 同绘制命令的第一个 point
//
// 第一个命令为 Arc 的情况下会在后面特殊处理
xi=data[i];yi=data[i+1];x0=xi;y0=yi;}switch(cmd){case CMD.M:// moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
// 在 closePath 的时候使用
x0=data[i++];y0=data[i++];xi=x0;yi=y0;min2[0]=x0;min2[1]=y0;max2[0]=x0;max2[1]=y0;break;case CMD.L:fromLine(xi,yi,data[i],data[i+1],min2,max2);xi=data[i++];yi=data[i++];break;case CMD.C:fromCubic(xi,yi,data[i++],data[i++],data[i++],data[i++],data[i],data[i+1],min2,max2);xi=data[i++];yi=data[i++];break;case CMD.Q:fromQuadratic(xi,yi,data[i++],data[i++],data[i],data[i+1],min2,max2);xi=data[i++];yi=data[i++];break;case CMD.A:// TODO Arc 判断的开销比较大
var cx=data[i++];var cy=data[i++];var rx=data[i++];var ry=data[i++];var startAngle=data[i++];var endAngle=data[i++]+startAngle;// TODO Arc 旋转
var psi=data[i++];var anticlockwise=1-data[i++];if(i==1){// 直接使用 arc 命令
// 第一个命令起点还未定义
x0=mathCos$1(startAngle)*rx+cx;y0=mathSin$1(startAngle)*ry+cy;}fromArc(cx,cy,rx,ry,startAngle,endAngle,anticlockwise,min2,max2);xi=mathCos$1(endAngle)*rx+cx;yi=mathSin$1(endAngle)*ry+cy;break;case CMD.R:x0=xi=data[i++];y0=yi=data[i++];var width=data[i++];var height=data[i++];// Use fromLine
fromLine(x0,y0,x0+width,y0+height,min2,max2);break;case CMD.Z:xi=x0;yi=y0;break;}// Union
min(min$1,min$1,min2);max(max$1,max$1,max2);}// No data
if(i===0){min$1[0]=min$1[1]=max$1[0]=max$1[1]=0;}return new BoundingRect(min$1[0],min$1[1],max$1[0]-min$1[0],max$1[1]-min$1[1]);},/**
   * Rebuild path from current data
   * Rebuild path will not consider javascript implemented line dash.
   * @param {CanvasRenderingContext2D} ctx
   */rebuildPath:function rebuildPath(ctx){var d=this.data;var x0,y0;var xi,yi;var x,y;var ux=this._ux;var uy=this._uy;var len$$1=this._len;for(var i=0;i<len$$1;){var cmd=d[i++];if(i==1){// 如果第一个命令是 L, C, Q
// 则 previous point 同绘制命令的第一个 point
//
// 第一个命令为 Arc 的情况下会在后面特殊处理
xi=d[i];yi=d[i+1];x0=xi;y0=yi;}switch(cmd){case CMD.M:x0=xi=d[i++];y0=yi=d[i++];ctx.moveTo(xi,yi);break;case CMD.L:x=d[i++];y=d[i++];// Not draw too small seg between
if(mathAbs(x-xi)>ux||mathAbs(y-yi)>uy||i===len$$1-1){ctx.lineTo(x,y);xi=x;yi=y;}break;case CMD.C:ctx.bezierCurveTo(d[i++],d[i++],d[i++],d[i++],d[i++],d[i++]);xi=d[i-2];yi=d[i-1];break;case CMD.Q:ctx.quadraticCurveTo(d[i++],d[i++],d[i++],d[i++]);xi=d[i-2];yi=d[i-1];break;case CMD.A:var cx=d[i++];var cy=d[i++];var rx=d[i++];var ry=d[i++];var theta=d[i++];var dTheta=d[i++];var psi=d[i++];var fs=d[i++];var r=rx>ry?rx:ry;var scaleX=rx>ry?1:rx/ry;var scaleY=rx>ry?ry/rx:1;var isEllipse=Math.abs(rx-ry)>1e-3;var endAngle=theta+dTheta;if(isEllipse){ctx.translate(cx,cy);ctx.rotate(psi);ctx.scale(scaleX,scaleY);ctx.arc(0,0,r,theta,endAngle,1-fs);ctx.scale(1/scaleX,1/scaleY);ctx.rotate(-psi);ctx.translate(-cx,-cy);}else{ctx.arc(cx,cy,r,theta,endAngle,1-fs);}if(i==1){// 直接使用 arc 命令
// 第一个命令起点还未定义
x0=mathCos$1(theta)*rx+cx;y0=mathSin$1(theta)*ry+cy;}xi=mathCos$1(endAngle)*rx+cx;yi=mathSin$1(endAngle)*ry+cy;break;case CMD.R:x0=xi=d[i];y0=yi=d[i+1];ctx.rect(d[i++],d[i++],d[i++],d[i++]);break;case CMD.Z:ctx.closePath();xi=x0;yi=y0;}}}};PathProxy.CMD=CMD;/**
 * 线段包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */function containStroke$1(x0,y0,x1,y1,lineWidth,x,y){if(lineWidth===0){return false;}var _l=lineWidth;var _a=0;var _b=x0;// Quick reject
if(y>y0+_l&&y>y1+_l||y<y0-_l&&y<y1-_l||x>x0+_l&&x>x1+_l||x<x0-_l&&x<x1-_l){return false;}if(x0!==x1){_a=(y0-y1)/(x0-x1);_b=(x0*y1-x1*y0)/(x0-x1);}else{return Math.abs(x-x0)<=_l/2;}var tmp=_a*x-y+_b;var _s=tmp*tmp/(_a*_a+1);return _s<=_l/2*_l/2;}/**
 * 三次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  x3
 * @param  {number}  y3
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */function containStroke$2(x0,y0,x1,y1,x2,y2,x3,y3,lineWidth,x,y){if(lineWidth===0){return false;}var _l=lineWidth;// Quick reject
if(y>y0+_l&&y>y1+_l&&y>y2+_l&&y>y3+_l||y<y0-_l&&y<y1-_l&&y<y2-_l&&y<y3-_l||x>x0+_l&&x>x1+_l&&x>x2+_l&&x>x3+_l||x<x0-_l&&x<x1-_l&&x<x2-_l&&x<x3-_l){return false;}var d=cubicProjectPoint(x0,y0,x1,y1,x2,y2,x3,y3,x,y,null);return d<=_l/2;}/**
 * 二次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */function containStroke$3(x0,y0,x1,y1,x2,y2,lineWidth,x,y){if(lineWidth===0){return false;}var _l=lineWidth;// Quick reject
if(y>y0+_l&&y>y1+_l&&y>y2+_l||y<y0-_l&&y<y1-_l&&y<y2-_l||x>x0+_l&&x>x1+_l&&x>x2+_l||x<x0-_l&&x<x1-_l&&x<x2-_l){return false;}var d=quadraticProjectPoint(x0,y0,x1,y1,x2,y2,x,y,null);return d<=_l/2;}var PI2$3=Math.PI*2;function normalizeRadian(angle){angle%=PI2$3;if(angle<0){angle+=PI2$3;}return angle;}var PI2$2=Math.PI*2;/**
 * 圆弧描边包含判断
 * @param  {number}  cx
 * @param  {number}  cy
 * @param  {number}  r
 * @param  {number}  startAngle
 * @param  {number}  endAngle
 * @param  {boolean}  anticlockwise
 * @param  {number} lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {Boolean}
 */function containStroke$4(cx,cy,r,startAngle,endAngle,anticlockwise,lineWidth,x,y){if(lineWidth===0){return false;}var _l=lineWidth;x-=cx;y-=cy;var d=Math.sqrt(x*x+y*y);if(d-_l>r||d+_l<r){return false;}if(Math.abs(startAngle-endAngle)%PI2$2<1e-4){// Is a circle
return true;}if(anticlockwise){var tmp=startAngle;startAngle=normalizeRadian(endAngle);endAngle=normalizeRadian(tmp);}else{startAngle=normalizeRadian(startAngle);endAngle=normalizeRadian(endAngle);}if(startAngle>endAngle){endAngle+=PI2$2;}var angle=Math.atan2(y,x);if(angle<0){angle+=PI2$2;}return angle>=startAngle&&angle<=endAngle||angle+PI2$2>=startAngle&&angle+PI2$2<=endAngle;}function windingLine(x0,y0,x1,y1,x,y){if(y>y0&&y>y1||y<y0&&y<y1){return 0;}// Ignore horizontal line
if(y1===y0){return 0;}var dir=y1<y0?1:-1;var t=(y-y0)/(y1-y0);// Avoid winding error when intersection point is the connect point of two line of polygon
if(t===1||t===0){dir=y1<y0?0.5:-0.5;}var x_=t*(x1-x0)+x0;// If (x, y) on the line, considered as "contain".
return x_===x?Infinity:x_>x?dir:0;}var CMD$1=PathProxy.CMD;var PI2$1=Math.PI*2;var EPSILON$2=1e-4;function isAroundEqual(a,b){return Math.abs(a-b)<EPSILON$2;}// 临时数组
var roots=[-1,-1,-1];var extrema=[-1,-1];function swapExtrema(){var tmp=extrema[0];extrema[0]=extrema[1];extrema[1]=tmp;}function windingCubic(x0,y0,x1,y1,x2,y2,x3,y3,x,y){// Quick reject
if(y>y0&&y>y1&&y>y2&&y>y3||y<y0&&y<y1&&y<y2&&y<y3){return 0;}var nRoots=cubicRootAt(y0,y1,y2,y3,y,roots);if(nRoots===0){return 0;}else{var w=0;var nExtrema=-1;var y0_,y1_;for(var i=0;i<nRoots;i++){var t=roots[i];// Avoid winding error when intersection point is the connect point of two line of polygon
var unit=t===0||t===1?0.5:1;var x_=cubicAt(x0,x1,x2,x3,t);if(x_<x){// Quick reject
continue;}if(nExtrema<0){nExtrema=cubicExtrema(y0,y1,y2,y3,extrema);if(extrema[1]<extrema[0]&&nExtrema>1){swapExtrema();}y0_=cubicAt(y0,y1,y2,y3,extrema[0]);if(nExtrema>1){y1_=cubicAt(y0,y1,y2,y3,extrema[1]);}}if(nExtrema==2){// 分成三段单调函数
if(t<extrema[0]){w+=y0_<y0?unit:-unit;}else if(t<extrema[1]){w+=y1_<y0_?unit:-unit;}else{w+=y3<y1_?unit:-unit;}}else{// 分成两段单调函数
if(t<extrema[0]){w+=y0_<y0?unit:-unit;}else{w+=y3<y0_?unit:-unit;}}}return w;}}function windingQuadratic(x0,y0,x1,y1,x2,y2,x,y){// Quick reject
if(y>y0&&y>y1&&y>y2||y<y0&&y<y1&&y<y2){return 0;}var nRoots=quadraticRootAt(y0,y1,y2,y,roots);if(nRoots===0){return 0;}else{var t=quadraticExtremum(y0,y1,y2);if(t>=0&&t<=1){var w=0;var y_=quadraticAt(y0,y1,y2,t);for(var i=0;i<nRoots;i++){// Remove one endpoint.
var unit=roots[i]===0||roots[i]===1?0.5:1;var x_=quadraticAt(x0,x1,x2,roots[i]);if(x_<x){// Quick reject
continue;}if(roots[i]<t){w+=y_<y0?unit:-unit;}else{w+=y2<y_?unit:-unit;}}return w;}else{// Remove one endpoint.
var unit=roots[0]===0||roots[0]===1?0.5:1;var x_=quadraticAt(x0,x1,x2,roots[0]);if(x_<x){// Quick reject
return 0;}return y2<y0?unit:-unit;}}}// TODO
// Arc 旋转
function windingArc(cx,cy,r,startAngle,endAngle,anticlockwise,x,y){y-=cy;if(y>r||y<-r){return 0;}var tmp=Math.sqrt(r*r-y*y);roots[0]=-tmp;roots[1]=tmp;var diff=Math.abs(startAngle-endAngle);if(diff<1e-4){return 0;}if(diff%PI2$1<1e-4){// Is a circle
startAngle=0;endAngle=PI2$1;var dir=anticlockwise?1:-1;if(x>=roots[0]+cx&&x<=roots[1]+cx){return dir;}else{return 0;}}if(anticlockwise){var tmp=startAngle;startAngle=normalizeRadian(endAngle);endAngle=normalizeRadian(tmp);}else{startAngle=normalizeRadian(startAngle);endAngle=normalizeRadian(endAngle);}if(startAngle>endAngle){endAngle+=PI2$1;}var w=0;for(var i=0;i<2;i++){var x_=roots[i];if(x_+cx>x){var angle=Math.atan2(y,x_);var dir=anticlockwise?1:-1;if(angle<0){angle=PI2$1+angle;}if(angle>=startAngle&&angle<=endAngle||angle+PI2$1>=startAngle&&angle+PI2$1<=endAngle){if(angle>Math.PI/2&&angle<Math.PI*1.5){dir=-dir;}w+=dir;}}}return w;}function containPath(data,lineWidth,isStroke,x,y){var w=0;var xi=0;var yi=0;var x0=0;var y0=0;for(var i=0;i<data.length;){var cmd=data[i++];// Begin a new subpath
if(cmd===CMD$1.M&&i>1){// Close previous subpath
if(!isStroke){w+=windingLine(xi,yi,x0,y0,x,y);}// 如果被任何一个 subpath 包含
// if (w !== 0) {
//     return true;
// }
}if(i==1){// 如果第一个命令是 L, C, Q
// 则 previous point 同绘制命令的第一个 point
//
// 第一个命令为 Arc 的情况下会在后面特殊处理
xi=data[i];yi=data[i+1];x0=xi;y0=yi;}switch(cmd){case CMD$1.M:// moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
// 在 closePath 的时候使用
x0=data[i++];y0=data[i++];xi=x0;yi=y0;break;case CMD$1.L:if(isStroke){if(containStroke$1(xi,yi,data[i],data[i+1],lineWidth,x,y)){return true;}}else{// NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
w+=windingLine(xi,yi,data[i],data[i+1],x,y)||0;}xi=data[i++];yi=data[i++];break;case CMD$1.C:if(isStroke){if(containStroke$2(xi,yi,data[i++],data[i++],data[i++],data[i++],data[i],data[i+1],lineWidth,x,y)){return true;}}else{w+=windingCubic(xi,yi,data[i++],data[i++],data[i++],data[i++],data[i],data[i+1],x,y)||0;}xi=data[i++];yi=data[i++];break;case CMD$1.Q:if(isStroke){if(containStroke$3(xi,yi,data[i++],data[i++],data[i],data[i+1],lineWidth,x,y)){return true;}}else{w+=windingQuadratic(xi,yi,data[i++],data[i++],data[i],data[i+1],x,y)||0;}xi=data[i++];yi=data[i++];break;case CMD$1.A:// TODO Arc 判断的开销比较大
var cx=data[i++];var cy=data[i++];var rx=data[i++];var ry=data[i++];var theta=data[i++];var dTheta=data[i++];// TODO Arc 旋转
var psi=data[i++];var anticlockwise=1-data[i++];var x1=Math.cos(theta)*rx+cx;var y1=Math.sin(theta)*ry+cy;// 不是直接使用 arc 命令
if(i>1){w+=windingLine(xi,yi,x1,y1,x,y);}else{// 第一个命令起点还未定义
x0=x1;y0=y1;}// zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
var _x=(x-cx)*ry/rx+cx;if(isStroke){if(containStroke$4(cx,cy,ry,theta,theta+dTheta,anticlockwise,lineWidth,_x,y)){return true;}}else{w+=windingArc(cx,cy,ry,theta,theta+dTheta,anticlockwise,_x,y);}xi=Math.cos(theta+dTheta)*rx+cx;yi=Math.sin(theta+dTheta)*ry+cy;break;case CMD$1.R:x0=xi=data[i++];y0=yi=data[i++];var width=data[i++];var height=data[i++];var x1=x0+width;var y1=y0+height;if(isStroke){if(containStroke$1(x0,y0,x1,y0,lineWidth,x,y)||containStroke$1(x1,y0,x1,y1,lineWidth,x,y)||containStroke$1(x1,y1,x0,y1,lineWidth,x,y)||containStroke$1(x0,y1,x0,y0,lineWidth,x,y)){return true;}}else{// FIXME Clockwise ?
w+=windingLine(x1,y0,x1,y1,x,y);w+=windingLine(x0,y1,x0,y0,x,y);}break;case CMD$1.Z:if(isStroke){if(containStroke$1(xi,yi,x0,y0,lineWidth,x,y)){return true;}}else{// Close a subpath
w+=windingLine(xi,yi,x0,y0,x,y);// 如果被任何一个 subpath 包含
// FIXME subpaths may overlap
// if (w !== 0) {
//     return true;
// }
}xi=x0;yi=y0;break;}}if(!isStroke&&!isAroundEqual(yi,y0)){w+=windingLine(xi,yi,x0,y0,x,y)||0;}return w!==0;}function _contain(pathData,x,y){return containPath(pathData,0,false,x,y);}function containStroke(pathData,lineWidth,x,y){return containPath(pathData,lineWidth,true,x,y);}var getCanvasPattern=Pattern.prototype.getCanvasPattern;var abs=Math.abs;var pathProxyForDraw=new PathProxy(true);/**
 * @alias module:zrender/graphic/Path
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */function Path(opts){Displayable.call(this,opts);/**
   * @type {module:zrender/core/PathProxy}
   * @readOnly
   */this.path=null;}Path.prototype={constructor:Path,type:'path',__dirtyPath:true,strokeContainThreshold:5,brush:function brush(ctx,prevEl){var style=this.style;var path=this.path||pathProxyForDraw;var hasStroke=style.hasStroke();var hasFill=style.hasFill();var fill=style.fill;var stroke=style.stroke;var hasFillGradient=hasFill&&!!fill.colorStops;var hasStrokeGradient=hasStroke&&!!stroke.colorStops;var hasFillPattern=hasFill&&!!fill.image;var hasStrokePattern=hasStroke&&!!stroke.image;style.bind(ctx,this,prevEl);this.setTransform(ctx);if(this.__dirty){var rect;// Update gradient because bounding rect may changed
if(hasFillGradient){rect=rect||this.getBoundingRect();this._fillGradient=style.getGradient(ctx,fill,rect);}if(hasStrokeGradient){rect=rect||this.getBoundingRect();this._strokeGradient=style.getGradient(ctx,stroke,rect);}}// Use the gradient or pattern
if(hasFillGradient){// PENDING If may have affect the state
ctx.fillStyle=this._fillGradient;}else if(hasFillPattern){ctx.fillStyle=getCanvasPattern.call(fill,ctx);}if(hasStrokeGradient){ctx.strokeStyle=this._strokeGradient;}else if(hasStrokePattern){ctx.strokeStyle=getCanvasPattern.call(stroke,ctx);}var lineDash=style.lineDash;var lineDashOffset=style.lineDashOffset;var ctxLineDash=!!ctx.setLineDash;// Update path sx, sy
var scale=this.getGlobalScale();path.setScale(scale[0],scale[1]);// Proxy context
// Rebuild path in following 2 cases
// 1. Path is dirty
// 2. Path needs javascript implemented lineDash stroking.
//    In this case, lineDash information will not be saved in PathProxy
if(this.__dirtyPath||lineDash&&!ctxLineDash&&hasStroke){path.beginPath(ctx);// Setting line dash before build path
if(lineDash&&!ctxLineDash){path.setLineDash(lineDash);path.setLineDashOffset(lineDashOffset);}this.buildPath(path,this.shape,false);// Clear path dirty flag
if(this.path){this.__dirtyPath=false;}}else{// Replay path building
ctx.beginPath();this.path.rebuildPath(ctx);}hasFill&&path.fill(ctx);if(lineDash&&ctxLineDash){ctx.setLineDash(lineDash);ctx.lineDashOffset=lineDashOffset;}hasStroke&&path.stroke(ctx);if(lineDash&&ctxLineDash){// PENDING
// Remove lineDash
ctx.setLineDash([]);}// Draw rect text
if(style.text!=null){// Only restore transform when needs draw text.
this.restoreTransform(ctx);this.drawRectText(ctx,this.getBoundingRect());}},// When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
// Like in circle
buildPath:function buildPath(ctx,shapeCfg,inBundle){},createPathProxy:function createPathProxy(){this.path=new PathProxy();},getBoundingRect:function getBoundingRect(){var rect=this._rect;var style=this.style;var needsUpdateRect=!rect;if(needsUpdateRect){var path=this.path;if(!path){// Create path on demand.
path=this.path=new PathProxy();}if(this.__dirtyPath){path.beginPath();this.buildPath(path,this.shape,false);}rect=path.getBoundingRect();}this._rect=rect;if(style.hasStroke()){// Needs update rect with stroke lineWidth when
// 1. Element changes scale or lineWidth
// 2. Shape is changed
var rectWithStroke=this._rectWithStroke||(this._rectWithStroke=rect.clone());if(this.__dirty||needsUpdateRect){rectWithStroke.copy(rect);// FIXME Must after updateTransform
var w=style.lineWidth;// PENDING, Min line width is needed when line is horizontal or vertical
var lineScale=style.strokeNoScale?this.getLineScale():1;// Only add extra hover lineWidth when there are no fill
if(!style.hasFill()){w=Math.max(w,this.strokeContainThreshold||4);}// Consider line width
// Line scale can't be 0;
if(lineScale>1e-10){rectWithStroke.width+=w/lineScale;rectWithStroke.height+=w/lineScale;rectWithStroke.x-=w/lineScale/2;rectWithStroke.y-=w/lineScale/2;}}// Return rect with stroke
return rectWithStroke;}return rect;},contain:function contain(x,y){var localPos=this.transformCoordToLocal(x,y);var rect=this.getBoundingRect();var style=this.style;x=localPos[0];y=localPos[1];if(rect.contain(x,y)){var pathData=this.path.data;if(style.hasStroke()){var lineWidth=style.lineWidth;var lineScale=style.strokeNoScale?this.getLineScale():1;// Line scale can't be 0;
if(lineScale>1e-10){// Only add extra hover lineWidth when there are no fill
if(!style.hasFill()){lineWidth=Math.max(lineWidth,this.strokeContainThreshold);}if(containStroke(pathData,lineWidth/lineScale,x,y)){return true;}}}if(style.hasFill()){return _contain(pathData,x,y);}}return false;},/**
   * @param  {boolean} dirtyPath
   */dirty:function dirty(dirtyPath){if(dirtyPath==null){dirtyPath=true;}// Only mark dirty, not mark clean
if(dirtyPath){this.__dirtyPath=dirtyPath;this._rect=null;}this.__dirty=true;this.__zr&&this.__zr.refresh();// Used as a clipping path
if(this.__clipTarget){this.__clipTarget.dirty();}},/**
   * Alias for animate('shape')
   * @param {boolean} loop
   */animateShape:function animateShape(loop){return this.animate('shape',loop);},// Overwrite attrKV
attrKV:function attrKV(key,value){// FIXME
if(key==='shape'){this.setShape(value);this.__dirtyPath=true;this._rect=null;}else{Displayable.prototype.attrKV.call(this,key,value);}},/**
   * @param {Object|string} key
   * @param {*} value
   */setShape:function setShape(key,value){var shape=this.shape;// Path from string may not have shape
if(shape){if(isObject$1(key)){for(var name in key){if(key.hasOwnProperty(name)){shape[name]=key[name];}}}else{shape[key]=value;}this.dirty(true);}return this;},getLineScale:function getLineScale(){var m=this.transform;// Get the line scale.
// Determinant of `m` means how much the area is enlarged by the
// transformation. So its square root can be used as a scale factor
// for width.
return m&&abs(m[0]-1)>1e-10&&abs(m[3]-1)>1e-10?Math.sqrt(abs(m[0]*m[3]-m[2]*m[1])):1;}};/**
 * 扩展一个 Path element, 比如星形，圆等。
 * Extend a path element
 * @param {Object} props
 * @param {string} props.type Path type
 * @param {Function} props.init Initialize
 * @param {Function} props.buildPath Overwrite buildPath method
 * @param {Object} [props.style] Extended default style config
 * @param {Object} [props.shape] Extended default shape config
 */Path.extend=function(defaults$$1){var Sub=function Sub(opts){Path.call(this,opts);if(defaults$$1.style){// Extend default style
this.style.extendFrom(defaults$$1.style,false);}// Extend default shape
var defaultShape=defaults$$1.shape;if(defaultShape){this.shape=this.shape||{};var thisShape=this.shape;for(var name in defaultShape){if(!thisShape.hasOwnProperty(name)&&defaultShape.hasOwnProperty(name)){thisShape[name]=defaultShape[name];}}}defaults$$1.init&&defaults$$1.init.call(this,opts);};inherits(Sub,Path);// FIXME 不能 extend position, rotation 等引用对象
for(var name in defaults$$1){// Extending prototype values and methods
if(name!=='style'&&name!=='shape'){Sub.prototype[name]=defaults$$1[name];}}return Sub;};inherits(Path,Displayable);var CMD$2=PathProxy.CMD;var points=[[],[],[]];var mathSqrt$3=Math.sqrt;var mathAtan2=Math.atan2;var transformPath=function transformPath(path,m){var data=path.data;var cmd;var nPoint;var i;var j;var k;var p;var M=CMD$2.M;var C=CMD$2.C;var L=CMD$2.L;var R=CMD$2.R;var A=CMD$2.A;var Q=CMD$2.Q;for(i=0,j=0;i<data.length;){cmd=data[i++];j=i;nPoint=0;switch(cmd){case M:nPoint=1;break;case L:nPoint=1;break;case C:nPoint=3;break;case Q:nPoint=2;break;case A:var x=m[4];var y=m[5];var sx=mathSqrt$3(m[0]*m[0]+m[1]*m[1]);var sy=mathSqrt$3(m[2]*m[2]+m[3]*m[3]);var angle=mathAtan2(-m[1]/sy,m[0]/sx);// cx
data[i]*=sx;data[i++]+=x;// cy
data[i]*=sy;data[i++]+=y;// Scale rx and ry
// FIXME Assume psi is 0 here
data[i++]*=sx;data[i++]*=sy;// Start angle
data[i++]+=angle;// end angle
data[i++]+=angle;// FIXME psi
i+=2;j=i;break;case R:// x0, y0
p[0]=data[i++];p[1]=data[i++];applyTransform(p,p,m);data[j++]=p[0];data[j++]=p[1];// x1, y1
p[0]+=data[i++];p[1]+=data[i++];applyTransform(p,p,m);data[j++]=p[0];data[j++]=p[1];}for(k=0;k<nPoint;k++){var p=points[k];p[0]=data[i++];p[1]=data[i++];applyTransform(p,p,m);// Write back
data[j++]=p[0];data[j++]=p[1];}}};var cc=['m','M','l','L','v','V','h','H','z','Z','c','C','q','Q','t','T','s','S','a','A'];var mathSqrt=Math.sqrt;var mathSin=Math.sin;var mathCos=Math.cos;var PI=Math.PI;var vMag=function vMag(v){return Math.sqrt(v[0]*v[0]+v[1]*v[1]);};var vRatio=function vRatio(u,v){return(u[0]*v[0]+u[1]*v[1])/(vMag(u)*vMag(v));};var vAngle=function vAngle(u,v){return(u[0]*v[1]<u[1]*v[0]?-1:1)*Math.acos(vRatio(u,v));};function processArc(x1,y1,x2,y2,fa,fs,rx,ry,psiDeg,cmd,path){var psi=psiDeg*(PI/180.0);var xp=mathCos(psi)*(x1-x2)/2.0+mathSin(psi)*(y1-y2)/2.0;var yp=-1*mathSin(psi)*(x1-x2)/2.0+mathCos(psi)*(y1-y2)/2.0;var lambda=xp*xp/(rx*rx)+yp*yp/(ry*ry);if(lambda>1){rx*=mathSqrt(lambda);ry*=mathSqrt(lambda);}var f=(fa===fs?-1:1)*mathSqrt((rx*rx*(ry*ry)-rx*rx*(yp*yp)-ry*ry*(xp*xp))/(rx*rx*(yp*yp)+ry*ry*(xp*xp)))||0;var cxp=f*rx*yp/ry;var cyp=f*-ry*xp/rx;var cx=(x1+x2)/2.0+mathCos(psi)*cxp-mathSin(psi)*cyp;var cy=(y1+y2)/2.0+mathSin(psi)*cxp+mathCos(psi)*cyp;var theta=vAngle([1,0],[(xp-cxp)/rx,(yp-cyp)/ry]);var u=[(xp-cxp)/rx,(yp-cyp)/ry];var v=[(-1*xp-cxp)/rx,(-1*yp-cyp)/ry];var dTheta=vAngle(u,v);if(vRatio(u,v)<=-1){dTheta=PI;}if(vRatio(u,v)>=1){dTheta=0;}if(fs===0&&dTheta>0){dTheta=dTheta-2*PI;}if(fs===1&&dTheta<0){dTheta=dTheta+2*PI;}path.addData(cmd,cx,cy,rx,ry,theta,dTheta,psi,fs);}function createPathProxyFromString(data){if(!data){return[];}// command string
var cs=data.replace(/-/g,' -').replace(/  /g,' ').replace(/ /g,',').replace(/,,/g,',');var n;// create pipes so that we can split the data
for(n=0;n<cc.length;n++){cs=cs.replace(new RegExp(cc[n],'g'),'|'+cc[n]);}// create array
var arr=cs.split('|');// init context point
var cpx=0;var cpy=0;var path=new PathProxy();var CMD=PathProxy.CMD;var prevCmd;for(n=1;n<arr.length;n++){var str=arr[n];var c=str.charAt(0);var off=0;var p=str.slice(1).replace(/e,-/g,'e-').split(',');var cmd;if(p.length>0&&p[0]===''){p.shift();}for(var i=0;i<p.length;i++){p[i]=parseFloat(p[i]);}while(off<p.length&&!isNaN(p[off])){if(isNaN(p[0])){break;}var ctlPtx;var ctlPty;var rx;var ry;var psi;var fa;var fs;var x1=cpx;var y1=cpy;// convert l, H, h, V, and v to L
switch(c){case'l':cpx+=p[off++];cpy+=p[off++];cmd=CMD.L;path.addData(cmd,cpx,cpy);break;case'L':cpx=p[off++];cpy=p[off++];cmd=CMD.L;path.addData(cmd,cpx,cpy);break;case'm':cpx+=p[off++];cpy+=p[off++];cmd=CMD.M;path.addData(cmd,cpx,cpy);c='l';break;case'M':cpx=p[off++];cpy=p[off++];cmd=CMD.M;path.addData(cmd,cpx,cpy);c='L';break;case'h':cpx+=p[off++];cmd=CMD.L;path.addData(cmd,cpx,cpy);break;case'H':cpx=p[off++];cmd=CMD.L;path.addData(cmd,cpx,cpy);break;case'v':cpy+=p[off++];cmd=CMD.L;path.addData(cmd,cpx,cpy);break;case'V':cpy=p[off++];cmd=CMD.L;path.addData(cmd,cpx,cpy);break;case'C':cmd=CMD.C;path.addData(cmd,p[off++],p[off++],p[off++],p[off++],p[off++],p[off++]);cpx=p[off-2];cpy=p[off-1];break;case'c':cmd=CMD.C;path.addData(cmd,p[off++]+cpx,p[off++]+cpy,p[off++]+cpx,p[off++]+cpy,p[off++]+cpx,p[off++]+cpy);cpx+=p[off-2];cpy+=p[off-1];break;case'S':ctlPtx=cpx;ctlPty=cpy;var len=path.len();var pathData=path.data;if(prevCmd===CMD.C){ctlPtx+=cpx-pathData[len-4];ctlPty+=cpy-pathData[len-3];}cmd=CMD.C;x1=p[off++];y1=p[off++];cpx=p[off++];cpy=p[off++];path.addData(cmd,ctlPtx,ctlPty,x1,y1,cpx,cpy);break;case's':ctlPtx=cpx;ctlPty=cpy;var len=path.len();var pathData=path.data;if(prevCmd===CMD.C){ctlPtx+=cpx-pathData[len-4];ctlPty+=cpy-pathData[len-3];}cmd=CMD.C;x1=cpx+p[off++];y1=cpy+p[off++];cpx+=p[off++];cpy+=p[off++];path.addData(cmd,ctlPtx,ctlPty,x1,y1,cpx,cpy);break;case'Q':x1=p[off++];y1=p[off++];cpx=p[off++];cpy=p[off++];cmd=CMD.Q;path.addData(cmd,x1,y1,cpx,cpy);break;case'q':x1=p[off++]+cpx;y1=p[off++]+cpy;cpx+=p[off++];cpy+=p[off++];cmd=CMD.Q;path.addData(cmd,x1,y1,cpx,cpy);break;case'T':ctlPtx=cpx;ctlPty=cpy;var len=path.len();var pathData=path.data;if(prevCmd===CMD.Q){ctlPtx+=cpx-pathData[len-4];ctlPty+=cpy-pathData[len-3];}cpx=p[off++];cpy=p[off++];cmd=CMD.Q;path.addData(cmd,ctlPtx,ctlPty,cpx,cpy);break;case't':ctlPtx=cpx;ctlPty=cpy;var len=path.len();var pathData=path.data;if(prevCmd===CMD.Q){ctlPtx+=cpx-pathData[len-4];ctlPty+=cpy-pathData[len-3];}cpx+=p[off++];cpy+=p[off++];cmd=CMD.Q;path.addData(cmd,ctlPtx,ctlPty,cpx,cpy);break;case'A':rx=p[off++];ry=p[off++];psi=p[off++];fa=p[off++];fs=p[off++];x1=cpx,y1=cpy;cpx=p[off++];cpy=p[off++];cmd=CMD.A;processArc(x1,y1,cpx,cpy,fa,fs,rx,ry,psi,cmd,path);break;case'a':rx=p[off++];ry=p[off++];psi=p[off++];fa=p[off++];fs=p[off++];x1=cpx,y1=cpy;cpx+=p[off++];cpy+=p[off++];cmd=CMD.A;processArc(x1,y1,cpx,cpy,fa,fs,rx,ry,psi,cmd,path);break;}}if(c==='z'||c==='Z'){cmd=CMD.Z;path.addData(cmd);}prevCmd=cmd;}path.toStatic();return path;}// TODO Optimize double memory cost problem
function createPathOptions(str,opts){var pathProxy=createPathProxyFromString(str);opts=opts||{};opts.buildPath=function(path){if(path.setData){path.setData(pathProxy.data);// Svg and vml renderer don't have context
var ctx=path.getContext();if(ctx){path.rebuildPath(ctx);}}else{var ctx=path;pathProxy.rebuildPath(ctx);}};opts.applyTransform=function(m){transformPath(pathProxy,m);this.dirty(true);};return opts;}/**
 * Create a Path object from path string data
 * http://www.w3.org/TR/SVG/paths.html#PathData
 * @param  {Object} opts Other options
 */function createFromString(str,opts){return new Path(createPathOptions(str,opts));}/**
 * Create a Path class from path string data
 * @param  {string} str
 * @param  {Object} opts Other options
 */function extendFromString(str,opts){return Path.extend(createPathOptions(str,opts));}/**
 * Merge multiple paths
 */// TODO Apply transform
// TODO stroke dash
// TODO Optimize double memory cost problem
function mergePath$1(pathEls,opts){var pathList=[];var len=pathEls.length;for(var i=0;i<len;i++){var pathEl=pathEls[i];if(!pathEl.path){pathEl.createPathProxy();}if(pathEl.__dirtyPath){pathEl.buildPath(pathEl.path,pathEl.shape,true);}pathList.push(pathEl.path);}var pathBundle=new Path(opts);// Need path proxy.
pathBundle.createPathProxy();pathBundle.buildPath=function(path){path.appendPath(pathList);// Svg and vml renderer don't have context
var ctx=path.getContext();if(ctx){path.rebuildPath(ctx);}};return pathBundle;}/**
 * @alias zrender/graphic/Text
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */var Text=function Text(opts){// jshint ignore:line
Displayable.call(this,opts);};Text.prototype={constructor:Text,type:'text',brush:function brush(ctx,prevEl){var style=this.style;// Optimize, avoid normalize every time.
this.__dirty&&normalizeTextStyle(style,true);// Use props with prefix 'text'.
style.fill=style.stroke=style.shadowBlur=style.shadowColor=style.shadowOffsetX=style.shadowOffsetY=null;var text=style.text;// Convert to string
text!=null&&(text+='');// Always bind style
style.bind(ctx,this,prevEl);if(!needDrawText(text,style)){return;}this.setTransform(ctx);renderText(this,ctx,text,style);this.restoreTransform(ctx);},getBoundingRect:function getBoundingRect(){var style=this.style;// Optimize, avoid normalize every time.
this.__dirty&&normalizeTextStyle(style,true);if(!this._rect){var text=style.text;text!=null?text+='':text='';var rect=_getBoundingRect(style.text+'',style.font,style.textAlign,style.textVerticalAlign,style.textPadding,style.rich);rect.x+=style.x||0;rect.y+=style.y||0;if(getStroke(style.textStroke,style.textStrokeWidth)){var w=style.textStrokeWidth;rect.x-=w/2;rect.y-=w/2;rect.width+=w;rect.height+=w;}this._rect=rect;}return this._rect;}};inherits(Text,Displayable);/**
 * 圆形
 * @module zrender/shape/Circle
 */var Circle=Path.extend({type:'circle',shape:{cx:0,cy:0,r:0},buildPath:function buildPath(ctx,shape,inBundle){// Better stroking in ShapeBundle
// Always do it may have performence issue ( fill may be 2x more cost)
if(inBundle){ctx.moveTo(shape.cx+shape.r,shape.cy);}// else {
//     if (ctx.allocate && !ctx.data.length) {
//         ctx.allocate(ctx.CMD_MEM_SIZE.A);
//     }
// }
// Better stroking in ShapeBundle
// ctx.moveTo(shape.cx + shape.r, shape.cy);
ctx.arc(shape.cx,shape.cy,shape.r,0,Math.PI*2,true);}});// where exception "unexpected call to method or property access"
// might be thrown when calling ctx.fill or ctx.stroke after a path
// whose area size is zero is drawn and ctx.clip() is called and
// shadowBlur is set. See #4572, #3112, #5777.
// (e.g.,
//  ctx.moveTo(10, 10);
//  ctx.lineTo(20, 10);
//  ctx.closePath();
//  ctx.clip();
//  ctx.shadowBlur = 10;
//  ...
//  ctx.fill();
// )
var shadowTemp=[['shadowBlur',0],['shadowColor','#000'],['shadowOffsetX',0],['shadowOffsetY',0]];var fixClipWithShadow=function fixClipWithShadow(orignalBrush){// version string can be: '11.0'
return env$1.browser.ie&&env$1.browser.version>=11?function(){var clipPaths=this.__clipPaths;var style=this.style;var modified;if(clipPaths){for(var i=0;i<clipPaths.length;i++){var clipPath=clipPaths[i];var shape=clipPath&&clipPath.shape;var type=clipPath&&clipPath.type;if(shape&&(type==='sector'&&shape.startAngle===shape.endAngle||type==='rect'&&(!shape.width||!shape.height))){for(var j=0;j<shadowTemp.length;j++){// It is save to put shadowTemp static, because shadowTemp
// will be all modified each item brush called.
shadowTemp[j][2]=style[shadowTemp[j][0]];style[shadowTemp[j][0]]=shadowTemp[j][1];}modified=true;break;}}}orignalBrush.apply(this,arguments);if(modified){for(var j=0;j<shadowTemp.length;j++){style[shadowTemp[j][0]]=shadowTemp[j][2];}}}:orignalBrush;};/**
 * 扇形
 * @module zrender/graphic/shape/Sector
 */var Sector=Path.extend({type:'sector',shape:{cx:0,cy:0,r0:0,r:0,startAngle:0,endAngle:Math.PI*2,clockwise:true},brush:fixClipWithShadow(Path.prototype.brush),buildPath:function buildPath(ctx,shape){var x=shape.cx;var y=shape.cy;var r0=Math.max(shape.r0||0,0);var r=Math.max(shape.r,0);var startAngle=shape.startAngle;var endAngle=shape.endAngle;var clockwise=shape.clockwise;var unitX=Math.cos(startAngle);var unitY=Math.sin(startAngle);ctx.moveTo(unitX*r0+x,unitY*r0+y);ctx.lineTo(unitX*r+x,unitY*r+y);ctx.arc(x,y,r,startAngle,endAngle,!clockwise);ctx.lineTo(Math.cos(endAngle)*r0+x,Math.sin(endAngle)*r0+y);if(r0!==0){ctx.arc(x,y,r0,endAngle,startAngle,clockwise);}ctx.closePath();}});/**
 * 圆环
 * @module zrender/graphic/shape/Ring
 */var Ring=Path.extend({type:'ring',shape:{cx:0,cy:0,r:0,r0:0},buildPath:function buildPath(ctx,shape){var x=shape.cx;var y=shape.cy;var PI2=Math.PI*2;ctx.moveTo(x+shape.r,y);ctx.arc(x,y,shape.r,0,PI2,false);ctx.moveTo(x+shape.r0,y);ctx.arc(x,y,shape.r0,0,PI2,true);}});/**
 * Catmull-Rom spline 插值折线
 * @module zrender/shape/util/smoothSpline
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 *//**
 * @inner
 */function interpolate(p0,p1,p2,p3,t,t2,t3){var v0=(p2-p0)*0.5;var v1=(p3-p1)*0.5;return(2*(p1-p2)+v0+v1)*t3+(-3*(p1-p2)-2*v0-v1)*t2+v0*t+p1;}/**
 * @alias module:zrender/shape/util/smoothSpline
 * @param {Array} points 线段顶点数组
 * @param {boolean} isLoop
 * @return {Array}
 */var smoothSpline=function smoothSpline(points,isLoop){var len$$1=points.length;var ret=[];var distance$$1=0;for(var i=1;i<len$$1;i++){distance$$1+=distance(points[i-1],points[i]);}var segs=distance$$1/2;segs=segs<len$$1?len$$1:segs;for(var i=0;i<segs;i++){var pos=i/(segs-1)*(isLoop?len$$1:len$$1-1);var idx=Math.floor(pos);var w=pos-idx;var p0;var p1=points[idx%len$$1];var p2;var p3;if(!isLoop){p0=points[idx===0?idx:idx-1];p2=points[idx>len$$1-2?len$$1-1:idx+1];p3=points[idx>len$$1-3?len$$1-1:idx+2];}else{p0=points[(idx-1+len$$1)%len$$1];p2=points[(idx+1)%len$$1];p3=points[(idx+2)%len$$1];}var w2=w*w;var w3=w*w2;ret.push([interpolate(p0[0],p1[0],p2[0],p3[0],w,w2,w3),interpolate(p0[1],p1[1],p2[1],p3[1],w,w2,w3)]);}return ret;};/**
 * 贝塞尔平滑曲线
 * @module zrender/shape/util/smoothBezier
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 *//**
 * 贝塞尔平滑曲线
 * @alias module:zrender/shape/util/smoothBezier
 * @param {Array} points 线段顶点数组
 * @param {number} smooth 平滑等级, 0-1
 * @param {boolean} isLoop
 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
 *                           整个折线的包围盒做一个并集用来约束控制点。
 * @param {Array} 计算出来的控制点数组
 */var smoothBezier=function smoothBezier(points,smooth,isLoop,constraint){var cps=[];var v=[];var v1=[];var v2=[];var prevPoint;var nextPoint;var min$$1,max$$1;if(constraint){min$$1=[Infinity,Infinity];max$$1=[-Infinity,-Infinity];for(var i=0,len$$1=points.length;i<len$$1;i++){min(min$$1,min$$1,points[i]);max(max$$1,max$$1,points[i]);}// 与指定的包围盒做并集
min(min$$1,min$$1,constraint[0]);max(max$$1,max$$1,constraint[1]);}for(var i=0,len$$1=points.length;i<len$$1;i++){var point=points[i];if(isLoop){prevPoint=points[i?i-1:len$$1-1];nextPoint=points[(i+1)%len$$1];}else{if(i===0||i===len$$1-1){cps.push(clone$1(points[i]));continue;}else{prevPoint=points[i-1];nextPoint=points[i+1];}}sub(v,nextPoint,prevPoint);// use degree to scale the handle length
scale(v,v,smooth);var d0=distance(point,prevPoint);var d1=distance(point,nextPoint);var sum=d0+d1;if(sum!==0){d0/=sum;d1/=sum;}scale(v1,v,-d0);scale(v2,v,d1);var cp0=add([],point,v1);var cp1=add([],point,v2);if(constraint){max(cp0,cp0,min$$1);min(cp0,cp0,max$$1);max(cp1,cp1,min$$1);min(cp1,cp1,max$$1);}cps.push(cp0);cps.push(cp1);}if(isLoop){cps.push(cps.shift());}return cps;};function buildPath$1(ctx,shape,closePath){var points=shape.points;var smooth=shape.smooth;if(points&&points.length>=2){if(smooth&&smooth!=='spline'){var controlPoints=smoothBezier(points,smooth,closePath,shape.smoothConstraint);ctx.moveTo(points[0][0],points[0][1]);var len=points.length;for(var i=0;i<(closePath?len:len-1);i++){var cp1=controlPoints[i*2];var cp2=controlPoints[i*2+1];var p=points[(i+1)%len];ctx.bezierCurveTo(cp1[0],cp1[1],cp2[0],cp2[1],p[0],p[1]);}}else{if(smooth==='spline'){points=smoothSpline(points,closePath);}ctx.moveTo(points[0][0],points[0][1]);for(var i=1,l=points.length;i<l;i++){ctx.lineTo(points[i][0],points[i][1]);}}closePath&&ctx.closePath();}}/**
 * 多边形
 * @module zrender/shape/Polygon
 */var Polygon=Path.extend({type:'polygon',shape:{points:null,smooth:false,smoothConstraint:null},buildPath:function buildPath(ctx,shape){buildPath$1(ctx,shape,true);}});/**
 * @module zrender/graphic/shape/Polyline
 */var Polyline=Path.extend({type:'polyline',shape:{points:null,smooth:false,smoothConstraint:null},style:{stroke:'#000',fill:null},buildPath:function buildPath(ctx,shape){buildPath$1(ctx,shape,false);}});/**
 * 矩形
 * @module zrender/graphic/shape/Rect
 */var Rect=Path.extend({type:'rect',shape:{// 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
// r缩写为1         相当于 [1, 1, 1, 1]
// r缩写为[1]       相当于 [1, 1, 1, 1]
// r缩写为[1, 2]    相当于 [1, 2, 1, 2]
// r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
r:0,x:0,y:0,width:0,height:0},buildPath:function buildPath(ctx,shape){var x=shape.x;var y=shape.y;var width=shape.width;var height=shape.height;if(!shape.r){ctx.rect(x,y,width,height);}else{_buildPath(ctx,shape);}ctx.closePath();return;}});/**
 * 直线
 * @module zrender/graphic/shape/Line
 */var Line=Path.extend({type:'line',shape:{// Start point
x1:0,y1:0,// End point
x2:0,y2:0,percent:1},style:{stroke:'#000',fill:null},buildPath:function buildPath(ctx,shape){var x1=shape.x1;var y1=shape.y1;var x2=shape.x2;var y2=shape.y2;var percent=shape.percent;if(percent===0){return;}ctx.moveTo(x1,y1);if(percent<1){x2=x1*(1-percent)+x2*percent;y2=y1*(1-percent)+y2*percent;}ctx.lineTo(x2,y2);},/**
   * Get point at percent
   * @param  {number} percent
   * @return {Array.<number>}
   */pointAt:function pointAt(p){var shape=this.shape;return[shape.x1*(1-p)+shape.x2*p,shape.y1*(1-p)+shape.y2*p];}});/**
 * 贝塞尔曲线
 * @module zrender/shape/BezierCurve
 */var out=[];function someVectorAt(shape,t,isTangent){var cpx2=shape.cpx2;var cpy2=shape.cpy2;if(cpx2===null||cpy2===null){return[(isTangent?cubicDerivativeAt:cubicAt)(shape.x1,shape.cpx1,shape.cpx2,shape.x2,t),(isTangent?cubicDerivativeAt:cubicAt)(shape.y1,shape.cpy1,shape.cpy2,shape.y2,t)];}else{return[(isTangent?quadraticDerivativeAt:quadraticAt)(shape.x1,shape.cpx1,shape.x2,t),(isTangent?quadraticDerivativeAt:quadraticAt)(shape.y1,shape.cpy1,shape.y2,t)];}}var BezierCurve=Path.extend({type:'bezier-curve',shape:{x1:0,y1:0,x2:0,y2:0,cpx1:0,cpy1:0,// cpx2: 0,
// cpy2: 0
// Curve show percent, for animating
percent:1},style:{stroke:'#000',fill:null},buildPath:function buildPath(ctx,shape){var x1=shape.x1;var y1=shape.y1;var x2=shape.x2;var y2=shape.y2;var cpx1=shape.cpx1;var cpy1=shape.cpy1;var cpx2=shape.cpx2;var cpy2=shape.cpy2;var percent=shape.percent;if(percent===0){return;}ctx.moveTo(x1,y1);if(cpx2==null||cpy2==null){if(percent<1){quadraticSubdivide(x1,cpx1,x2,percent,out);cpx1=out[1];x2=out[2];quadraticSubdivide(y1,cpy1,y2,percent,out);cpy1=out[1];y2=out[2];}ctx.quadraticCurveTo(cpx1,cpy1,x2,y2);}else{if(percent<1){cubicSubdivide(x1,cpx1,cpx2,x2,percent,out);cpx1=out[1];cpx2=out[2];x2=out[3];cubicSubdivide(y1,cpy1,cpy2,y2,percent,out);cpy1=out[1];cpy2=out[2];y2=out[3];}ctx.bezierCurveTo(cpx1,cpy1,cpx2,cpy2,x2,y2);}},/**
   * Get point at percent
   * @param  {number} t
   * @return {Array.<number>}
   */pointAt:function pointAt(t){return someVectorAt(this.shape,t,false);},/**
   * Get tangent at percent
   * @param  {number} t
   * @return {Array.<number>}
   */tangentAt:function tangentAt(t){var p=someVectorAt(this.shape,t,true);return normalize(p,p);}});/**
 * 圆弧
 * @module zrender/graphic/shape/Arc
 */var Arc=Path.extend({type:'arc',shape:{cx:0,cy:0,r:0,startAngle:0,endAngle:Math.PI*2,clockwise:true},style:{stroke:'#000',fill:null},buildPath:function buildPath(ctx,shape){var x=shape.cx;var y=shape.cy;var r=Math.max(shape.r,0);var startAngle=shape.startAngle;var endAngle=shape.endAngle;var clockwise=shape.clockwise;var unitX=Math.cos(startAngle);var unitY=Math.sin(startAngle);ctx.moveTo(unitX*r+x,unitY*r+y);ctx.arc(x,y,r,startAngle,endAngle,!clockwise);}});// CompoundPath to improve performance
var CompoundPath=Path.extend({type:'compound',shape:{paths:null},_updatePathDirty:function _updatePathDirty(){var dirtyPath=this.__dirtyPath;var paths=this.shape.paths;for(var i=0;i<paths.length;i++){// Mark as dirty if any subpath is dirty
dirtyPath=dirtyPath||paths[i].__dirtyPath;}this.__dirtyPath=dirtyPath;this.__dirty=this.__dirty||dirtyPath;},beforeBrush:function beforeBrush(){this._updatePathDirty();var paths=this.shape.paths||[];var scale=this.getGlobalScale();// Update path scale
for(var i=0;i<paths.length;i++){if(!paths[i].path){paths[i].createPathProxy();}paths[i].path.setScale(scale[0],scale[1]);}},buildPath:function buildPath(ctx,shape){var paths=shape.paths||[];for(var i=0;i<paths.length;i++){paths[i].buildPath(ctx,paths[i].shape,true);}},afterBrush:function afterBrush(){var paths=this.shape.paths||[];for(var i=0;i<paths.length;i++){paths[i].__dirtyPath=false;}},getBoundingRect:function getBoundingRect(){this._updatePathDirty();return Path.prototype.getBoundingRect.call(this);}});/**
 * @param {Array.<Object>} colorStops
 */var Gradient=function Gradient(colorStops){this.colorStops=colorStops||[];};Gradient.prototype={constructor:Gradient,addColorStop:function addColorStop(offset,color){this.colorStops.push({offset:offset,color:color});}};/**
 * x, y, x2, y2 are all percent from 0 to 1
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @param {number} [x2=1]
 * @param {number} [y2=0]
 * @param {Array.<Object>} colorStops
 * @param {boolean} [globalCoord=false]
 */var LinearGradient=function LinearGradient(x,y,x2,y2,colorStops,globalCoord){// Should do nothing more in this constructor. Because gradient can be
// declard by `color: {type: 'linear', colorStops: ...}`, where
// this constructor will not be called.
this.x=x==null?0:x;this.y=y==null?0:y;this.x2=x2==null?1:x2;this.y2=y2==null?0:y2;// Can be cloned
this.type='linear';// If use global coord
this.global=globalCoord||false;Gradient.call(this,colorStops);};LinearGradient.prototype={constructor:LinearGradient};inherits(LinearGradient,Gradient);/**
 * x, y, r are all percent from 0 to 1
 * @param {number} [x=0.5]
 * @param {number} [y=0.5]
 * @param {number} [r=0.5]
 * @param {Array.<Object>} [colorStops]
 * @param {boolean} [globalCoord=false]
 */var RadialGradient=function RadialGradient(x,y,r,colorStops,globalCoord){// Should do nothing more in this constructor. Because gradient can be
// declard by `color: {type: 'radial', colorStops: ...}`, where
// this constructor will not be called.
this.x=x==null?0.5:x;this.y=y==null?0.5:y;this.r=r==null?0.5:r;// Can be cloned
this.type='radial';// If use global coord
this.global=globalCoord||false;Gradient.call(this,colorStops);};RadialGradient.prototype={constructor:RadialGradient};inherits(RadialGradient,Gradient);/**
 * Displayable for incremental rendering. It will be rendered in a separate layer
 * IncrementalDisplay have too main methods. `clearDisplayables` and `addDisplayables`
 * addDisplayables will render the added displayables incremetally.
 *
 * It use a not clearFlag to tell the painter don't clear the layer if it's the first element.
 */function IncrementalDisplayble(opts){Displayable.call(this,opts);this._displayables=[];this._temporaryDisplayables=[];this._cursor=0;this.notClear=true;}IncrementalDisplayble.prototype.incremental=true;IncrementalDisplayble.prototype.clearDisplaybles=function(){this._displayables=[];this._temporaryDisplayables=[];this._cursor=0;this.dirty();this.notClear=false;};IncrementalDisplayble.prototype.addDisplayable=function(displayable,notPersistent){if(notPersistent){this._temporaryDisplayables.push(displayable);}else{this._displayables.push(displayable);}this.dirty();};IncrementalDisplayble.prototype.addDisplayables=function(displayables,notPersistent){notPersistent=notPersistent||false;for(var i=0;i<displayables.length;i++){this.addDisplayable(displayables[i],notPersistent);}};IncrementalDisplayble.prototype.eachPendingDisplayable=function(cb){for(var i=this._cursor;i<this._displayables.length;i++){cb&&cb(this._displayables[i]);}for(var i=0;i<this._temporaryDisplayables.length;i++){cb&&cb(this._temporaryDisplayables[i]);}};IncrementalDisplayble.prototype.update=function(){this.updateTransform();for(var i=this._cursor;i<this._displayables.length;i++){var displayable=this._displayables[i];// PENDING
displayable.parent=this;displayable.update();displayable.parent=null;}for(var i=0;i<this._temporaryDisplayables.length;i++){var displayable=this._temporaryDisplayables[i];// PENDING
displayable.parent=this;displayable.update();displayable.parent=null;}};IncrementalDisplayble.prototype.brush=function(ctx,prevEl){// Render persistant displayables.
for(var i=this._cursor;i<this._displayables.length;i++){var displayable=this._displayables[i];displayable.beforeBrush&&displayable.beforeBrush(ctx);displayable.brush(ctx,i===this._cursor?null:this._displayables[i-1]);displayable.afterBrush&&displayable.afterBrush(ctx);}this._cursor=i;// Render temporary displayables.
for(var i=0;i<this._temporaryDisplayables.length;i++){var displayable=this._temporaryDisplayables[i];displayable.beforeBrush&&displayable.beforeBrush(ctx);displayable.brush(ctx,i===0?null:this._temporaryDisplayables[i-1]);displayable.afterBrush&&displayable.afterBrush(ctx);}this._temporaryDisplayables=[];this.notClear=true;};var m=[];IncrementalDisplayble.prototype.getBoundingRect=function(){if(!this._rect){var rect=new BoundingRect(Infinity,Infinity,-Infinity,-Infinity);for(var i=0;i<this._displayables.length;i++){var displayable=this._displayables[i];var childRect=displayable.getBoundingRect().clone();if(displayable.needLocalTransform()){childRect.applyTransform(displayable.getLocalTransform(m));}rect.union(childRect);}this._rect=rect;}return this._rect;};IncrementalDisplayble.prototype.contain=function(x,y){var localPos=this.transformCoordToLocal(x,y);var rect=this.getBoundingRect();if(rect.contain(localPos[0],localPos[1])){for(var i=0;i<this._displayables.length;i++){var displayable=this._displayables[i];if(displayable.contain(x,y)){return true;}}}return false;};inherits(IncrementalDisplayble,Displayable);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var round=Math.round;var mathMax$1=Math.max;var mathMin$1=Math.min;var EMPTY_OBJ={};/**
 * Extend shape with parameters
 */function extendShape(opts){return Path.extend(opts);}/**
 * Extend path
 */function extendPath(pathData,opts){return extendFromString(pathData,opts);}/**
 * Create a path element from path data string
 * @param {string} pathData
 * @param {Object} opts
 * @param {module:zrender/core/BoundingRect} rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */function makePath(pathData,opts,rect,layout){var path=createFromString(pathData,opts);var boundingRect=path.getBoundingRect();if(rect){if(layout==='center'){rect=centerGraphic(rect,boundingRect);}resizePath(path,rect);}return path;}/**
 * Create a image element from image url
 * @param {string} imageUrl image url
 * @param {Object} opts options
 * @param {module:zrender/core/BoundingRect} rect constrain rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */function makeImage(imageUrl,rect,layout){var path=new ZImage({style:{image:imageUrl,x:rect.x,y:rect.y,width:rect.width,height:rect.height},onload:function onload(img){if(layout==='center'){var boundingRect={width:img.width,height:img.height};path.setStyle(centerGraphic(rect,boundingRect));}}});return path;}/**
 * Get position of centered element in bounding box.
 *
 * @param  {Object} rect         element local bounding box
 * @param  {Object} boundingRect constraint bounding box
 * @return {Object} element position containing x, y, width, and height
 */function centerGraphic(rect,boundingRect){// Set rect to center, keep width / height ratio.
var aspect=boundingRect.width/boundingRect.height;var width=rect.height*aspect;var height;if(width<=rect.width){height=rect.height;}else{width=rect.width;height=width/aspect;}var cx=rect.x+rect.width/2;var cy=rect.y+rect.height/2;return{x:cx-width/2,y:cy-height/2,width:width,height:height};}var mergePath=mergePath$1;/**
 * Resize a path to fit the rect
 * @param {module:zrender/graphic/Path} path
 * @param {Object} rect
 */function resizePath(path,rect){if(!path.applyTransform){return;}var pathRect=path.getBoundingRect();var m=pathRect.calculateTransform(rect);path.applyTransform(m);}/**
 * Sub pixel optimize line for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x1]
 * @param {number} [param.shape.y1]
 * @param {number} [param.shape.x2]
 * @param {number} [param.shape.y2]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */function subPixelOptimizeLine(param){var shape=param.shape;var lineWidth=param.style.lineWidth;if(round(shape.x1*2)===round(shape.x2*2)){shape.x1=shape.x2=subPixelOptimize(shape.x1,lineWidth,true);}if(round(shape.y1*2)===round(shape.y2*2)){shape.y1=shape.y2=subPixelOptimize(shape.y1,lineWidth,true);}return param;}/**
 * Sub pixel optimize rect for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x]
 * @param {number} [param.shape.y]
 * @param {number} [param.shape.width]
 * @param {number} [param.shape.height]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */function subPixelOptimizeRect(param){var shape=param.shape;var lineWidth=param.style.lineWidth;var originX=shape.x;var originY=shape.y;var originWidth=shape.width;var originHeight=shape.height;shape.x=subPixelOptimize(shape.x,lineWidth,true);shape.y=subPixelOptimize(shape.y,lineWidth,true);shape.width=Math.max(subPixelOptimize(originX+originWidth,lineWidth,false)-shape.x,originWidth===0?0:1);shape.height=Math.max(subPixelOptimize(originY+originHeight,lineWidth,false)-shape.y,originHeight===0?0:1);return param;}/**
 * Sub pixel optimize for canvas
 *
 * @param {number} position Coordinate, such as x, y
 * @param {number} lineWidth Should be nonnegative integer.
 * @param {boolean=} positiveOrNegative Default false (negative).
 * @return {number} Optimized position.
 */function subPixelOptimize(position,lineWidth,positiveOrNegative){// Assure that (position + lineWidth / 2) is near integer edge,
// otherwise line will be fuzzy in canvas.
var doubledPosition=round(position*2);return(doubledPosition+round(lineWidth))%2===0?doubledPosition/2:(doubledPosition+(positiveOrNegative?1:-1))/2;}function hasFillOrStroke(fillOrStroke){return fillOrStroke!=null&&fillOrStroke!='none';}function liftColor(color){return typeof color==='string'?lift(color,-0.1):color;}/**
 * @private
 */function cacheElementStl(el){if(el.__hoverStlDirty){var stroke=el.style.stroke;var fill=el.style.fill;// Create hoverStyle on mouseover
var hoverStyle=el.__hoverStl;hoverStyle.fill=hoverStyle.fill||(hasFillOrStroke(fill)?liftColor(fill):null);hoverStyle.stroke=hoverStyle.stroke||(hasFillOrStroke(stroke)?liftColor(stroke):null);var normalStyle={};for(var name in hoverStyle){// See comment in `doSingleEnterHover`.
if(hoverStyle[name]!=null){normalStyle[name]=el.style[name];}}el.__normalStl=normalStyle;el.__hoverStlDirty=false;}}/**
 * @private
 */function doSingleEnterHover(el){if(el.__isHover){return;}cacheElementStl(el);if(el.useHoverLayer){el.__zr&&el.__zr.addHover(el,el.__hoverStl);}else{var style=el.style;var insideRollbackOpt=style.insideRollbackOpt;// Consider case: only `position: 'top'` is set on emphasis, then text
// color should be returned to `autoColor`, rather than remain '#fff'.
// So we should rollback then apply again after style merging.
insideRollbackOpt&&rollbackInsideStyle(style);// styles can be:
// {
//    label: {
//        show: false,
//        position: 'outside',
//        fontSize: 18
//    },
//    emphasis: {
//        label: {
//            show: true
//        }
//    }
// },
// where properties of `emphasis` may not appear in `normal`. We previously use
// module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
// But consider rich text and setOption in merge mode, it is impossible to cover
// all properties in merge. So we use merge mode when setting style here, where
// only properties that is not `null/undefined` can be set. The disadventage:
// null/undefined can not be used to remove style any more in `emphasis`.
style.extendFrom(el.__hoverStl);// Do not save `insideRollback`.
if(insideRollbackOpt){applyInsideStyle(style,style.insideOriginalTextPosition,insideRollbackOpt);// textFill may be rollbacked to null.
if(style.textFill==null){style.textFill=insideRollbackOpt.autoColor;}}el.dirty(false);el.z2+=1;}el.__isHover=true;}/**
 * @inner
 */function doSingleLeaveHover(el){if(!el.__isHover){return;}var normalStl=el.__normalStl;if(el.useHoverLayer){el.__zr&&el.__zr.removeHover(el);}else{// Consider null/undefined value, should use
// `setStyle` but not `extendFrom(stl, true)`.
normalStl&&el.setStyle(normalStl);el.z2-=1;}el.__isHover=false;}/**
 * @inner
 */function doEnterHover(el){el.type==='group'?el.traverse(function(child){if(child.type!=='group'){doSingleEnterHover(child);}}):doSingleEnterHover(el);}function doLeaveHover(el){el.type==='group'?el.traverse(function(child){if(child.type!=='group'){doSingleLeaveHover(child);}}):doSingleLeaveHover(el);}/**
 * @inner
 */function setElementHoverStl(el,hoverStl){// If element has sepcified hoverStyle, then use it instead of given hoverStyle
// Often used when item group has a label element and it's hoverStyle is different
el.__hoverStl=el.hoverStyle||hoverStl||{};el.__hoverStlDirty=true;if(el.__isHover){cacheElementStl(el);}}/**
 * @inner
 */function onElementMouseOver(e){if(this.__hoverSilentOnTouch&&e.zrByTouch){return;}// Only if element is not in emphasis status
!this.__isEmphasis&&doEnterHover(this);}/**
 * @inner
 */function onElementMouseOut(e){if(this.__hoverSilentOnTouch&&e.zrByTouch){return;}// Only if element is not in emphasis status
!this.__isEmphasis&&doLeaveHover(this);}/**
 * @inner
 */function enterEmphasis(){this.__isEmphasis=true;doEnterHover(this);}/**
 * @inner
 */function leaveEmphasis(){this.__isEmphasis=false;doLeaveHover(this);}/**
 * Set hover style of element.
 * This method can be called repeatly without side-effects.
 * @param {module:zrender/Element} el
 * @param {Object} [hoverStyle]
 * @param {Object} [opt]
 * @param {boolean} [opt.hoverSilentOnTouch=false]
 *        In touch device, mouseover event will be trigger on touchstart event
 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
 *        conviniently use hoverStyle when tap on touch screen without additional
 *        code for compatibility.
 *        But if the chart/component has select feature, which usually also use
 *        hoverStyle, there might be conflict between 'select-highlight' and
 *        'hover-highlight' especially when roam is enabled (see geo for example).
 *        In this case, hoverSilentOnTouch should be used to disable hover-highlight
 *        on touch device.
 */function setHoverStyle(el,hoverStyle,opt){el.__hoverSilentOnTouch=opt&&opt.hoverSilentOnTouch;el.type==='group'?el.traverse(function(child){if(child.type!=='group'){setElementHoverStl(child,hoverStyle);}}):setElementHoverStl(el,hoverStyle);// Duplicated function will be auto-ignored, see Eventful.js.
el.on('mouseover',onElementMouseOver).on('mouseout',onElementMouseOut);// Emphasis, normal can be triggered manually
el.on('emphasis',enterEmphasis).on('normal',leaveEmphasis);}/**
 * @param {Object|module:zrender/graphic/Style} normalStyle
 * @param {Object} emphasisStyle
 * @param {module:echarts/model/Model} normalModel
 * @param {module:echarts/model/Model} emphasisModel
 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
 * @param {string|Function} [opt.defaultText]
 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {module:echarts/model/Model} [opt.labelDataIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {module:echarts/model/Model} [opt.labelDimIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {Object} [normalSpecified]
 * @param {Object} [emphasisSpecified]
 */function setLabelStyle(normalStyle,emphasisStyle,normalModel,emphasisModel,opt,normalSpecified,emphasisSpecified){opt=opt||EMPTY_OBJ;var labelFetcher=opt.labelFetcher;var labelDataIndex=opt.labelDataIndex;var labelDimIndex=opt.labelDimIndex;// This scenario, `label.normal.show = true; label.emphasis.show = false`,
// is not supported util someone requests.
var showNormal=normalModel.getShallow('show');var showEmphasis=emphasisModel.getShallow('show');// Consider performance, only fetch label when necessary.
// If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
// label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.
var baseText;if(showNormal||showEmphasis){if(labelFetcher){baseText=labelFetcher.getFormattedLabel(labelDataIndex,'normal',null,labelDimIndex);}if(baseText==null){baseText=isFunction$1(opt.defaultText)?opt.defaultText(labelDataIndex,opt):opt.defaultText;}}var normalStyleText=showNormal?baseText:null;var emphasisStyleText=showEmphasis?retrieve2(labelFetcher?labelFetcher.getFormattedLabel(labelDataIndex,'emphasis',null,labelDimIndex):null,baseText):null;// Optimize: If style.text is null, text will not be drawn.
if(normalStyleText!=null||emphasisStyleText!=null){// Always set `textStyle` even if `normalStyle.text` is null, because default
// values have to be set on `normalStyle`.
// If we set default values on `emphasisStyle`, consider case:
// Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
// Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
// Then the 'red' will not work on emphasis.
setTextStyle(normalStyle,normalModel,normalSpecified,opt);setTextStyle(emphasisStyle,emphasisModel,emphasisSpecified,opt,true);}normalStyle.text=normalStyleText;emphasisStyle.text=emphasisStyleText;}/**
 * Set basic textStyle properties.
 * @param {Object|module:zrender/graphic/Style} textStyle
 * @param {module:echarts/model/Model} model
 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
 * @param {boolean} [isEmphasis]
 */function setTextStyle(textStyle,textStyleModel,specifiedTextStyle,opt,isEmphasis){setTextStyleCommon(textStyle,textStyleModel,opt,isEmphasis);specifiedTextStyle&&extend(textStyle,specifiedTextStyle);textStyle.host&&textStyle.host.dirty&&textStyle.host.dirty(false);return textStyle;}/**
 * Set text option in the style.
 * @deprecated
 * @param {Object} textStyle
 * @param {module:echarts/model/Model} labelModel
 * @param {string|boolean} defaultColor Default text color.
 *        If set as false, it will be processed as a emphasis style.
 */function setText(textStyle,labelModel,defaultColor){var opt={isRectText:true};var isEmphasis;if(defaultColor===false){isEmphasis=true;}else{// Support setting color as 'auto' to get visual color.
opt.autoColor=defaultColor;}setTextStyleCommon(textStyle,labelModel,opt,isEmphasis);textStyle.host&&textStyle.host.dirty&&textStyle.host.dirty(false);}/**
 * {
 *      disableBox: boolean, Whether diable drawing box of block (outer most).
 *      isRectText: boolean,
 *      autoColor: string, specify a color when color is 'auto',
 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
 *              If autoColor specified, it is used as default textFill.
 *      useInsideStyle:
 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
 *                  if `textFill` is not specified.
 *              `false`: Do not use inside style.
 *              `null/undefined`: use inside style if `isRectText` is true and
 *                  `textFill` is not specified and textPosition contains `'inside'`.
 *      forceRich: boolean
 * }
 */function setTextStyleCommon(textStyle,textStyleModel,opt,isEmphasis){// Consider there will be abnormal when merge hover style to normal style if given default value.
opt=opt||EMPTY_OBJ;if(opt.isRectText){var textPosition=textStyleModel.getShallow('position')||(isEmphasis?null:'inside');// 'outside' is not a valid zr textPostion value, but used
// in bar series, and magric type should be considered.
textPosition==='outside'&&(textPosition='top');textStyle.textPosition=textPosition;textStyle.textOffset=textStyleModel.getShallow('offset');var labelRotate=textStyleModel.getShallow('rotate');labelRotate!=null&&(labelRotate*=Math.PI/180);textStyle.textRotation=labelRotate;textStyle.textDistance=retrieve2(textStyleModel.getShallow('distance'),isEmphasis?null:5);}var ecModel=textStyleModel.ecModel;var globalTextStyle=ecModel&&ecModel.option.textStyle;// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
var richItemNames=getRichItemNames(textStyleModel);var richResult;if(richItemNames){richResult={};for(var name in richItemNames){if(richItemNames.hasOwnProperty(name)){// Cascade is supported in rich.
var richTextStyle=textStyleModel.getModel(['rich',name]);// In rich, never `disableBox`.
setTokenTextStyle(richResult[name]={},richTextStyle,globalTextStyle,opt,isEmphasis);}}}textStyle.rich=richResult;setTokenTextStyle(textStyle,textStyleModel,globalTextStyle,opt,isEmphasis,true);if(opt.forceRich&&!opt.textStyle){opt.textStyle={};}return textStyle;}// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
function getRichItemNames(textStyleModel){// Use object to remove duplicated names.
var richItemNameMap;while(textStyleModel&&textStyleModel!==textStyleModel.ecModel){var rich=(textStyleModel.option||EMPTY_OBJ).rich;if(rich){richItemNameMap=richItemNameMap||{};for(var name in rich){if(rich.hasOwnProperty(name)){richItemNameMap[name]=1;}}}textStyleModel=textStyleModel.parentModel;}return richItemNameMap;}function setTokenTextStyle(textStyle,textStyleModel,globalTextStyle,opt,isEmphasis,isBlock){// In merge mode, default value should not be given.
globalTextStyle=!isEmphasis&&globalTextStyle||EMPTY_OBJ;textStyle.textFill=getAutoColor(textStyleModel.getShallow('color'),opt)||globalTextStyle.color;textStyle.textStroke=getAutoColor(textStyleModel.getShallow('textBorderColor'),opt)||globalTextStyle.textBorderColor;textStyle.textStrokeWidth=retrieve2(textStyleModel.getShallow('textBorderWidth'),globalTextStyle.textBorderWidth);if(!isEmphasis){if(isBlock){// Always set `insideRollback`, for clearing previous.
var originalTextPosition=textStyle.textPosition;textStyle.insideRollback=applyInsideStyle(textStyle,originalTextPosition,opt);// Save original textPosition, because style.textPosition will be repalced by
// real location (like [10, 30]) in zrender.
textStyle.insideOriginalTextPosition=originalTextPosition;textStyle.insideRollbackOpt=opt;}// Set default finally.
if(textStyle.textFill==null){textStyle.textFill=opt.autoColor;}}// Do not use `getFont` here, because merge should be supported, where
// part of these properties may be changed in emphasis style, and the
// others should remain their original value got from normal style.
textStyle.fontStyle=textStyleModel.getShallow('fontStyle')||globalTextStyle.fontStyle;textStyle.fontWeight=textStyleModel.getShallow('fontWeight')||globalTextStyle.fontWeight;textStyle.fontSize=textStyleModel.getShallow('fontSize')||globalTextStyle.fontSize;textStyle.fontFamily=textStyleModel.getShallow('fontFamily')||globalTextStyle.fontFamily;textStyle.textAlign=textStyleModel.getShallow('align');textStyle.textVerticalAlign=textStyleModel.getShallow('verticalAlign')||textStyleModel.getShallow('baseline');textStyle.textLineHeight=textStyleModel.getShallow('lineHeight');textStyle.textWidth=textStyleModel.getShallow('width');textStyle.textHeight=textStyleModel.getShallow('height');textStyle.textTag=textStyleModel.getShallow('tag');if(!isBlock||!opt.disableBox){textStyle.textBackgroundColor=getAutoColor(textStyleModel.getShallow('backgroundColor'),opt);textStyle.textPadding=textStyleModel.getShallow('padding');textStyle.textBorderColor=getAutoColor(textStyleModel.getShallow('borderColor'),opt);textStyle.textBorderWidth=textStyleModel.getShallow('borderWidth');textStyle.textBorderRadius=textStyleModel.getShallow('borderRadius');textStyle.textBoxShadowColor=textStyleModel.getShallow('shadowColor');textStyle.textBoxShadowBlur=textStyleModel.getShallow('shadowBlur');textStyle.textBoxShadowOffsetX=textStyleModel.getShallow('shadowOffsetX');textStyle.textBoxShadowOffsetY=textStyleModel.getShallow('shadowOffsetY');}textStyle.textShadowColor=textStyleModel.getShallow('textShadowColor')||globalTextStyle.textShadowColor;textStyle.textShadowBlur=textStyleModel.getShallow('textShadowBlur')||globalTextStyle.textShadowBlur;textStyle.textShadowOffsetX=textStyleModel.getShallow('textShadowOffsetX')||globalTextStyle.textShadowOffsetX;textStyle.textShadowOffsetY=textStyleModel.getShallow('textShadowOffsetY')||globalTextStyle.textShadowOffsetY;}function getAutoColor(color,opt){return color!=='auto'?color:opt&&opt.autoColor?opt.autoColor:null;}function applyInsideStyle(textStyle,textPosition,opt){var useInsideStyle=opt.useInsideStyle;var insideRollback;if(textStyle.textFill==null&&useInsideStyle!==false&&(useInsideStyle===true||opt.isRectText&&textPosition// textPosition can be [10, 30]
&&typeof textPosition==='string'&&textPosition.indexOf('inside')>=0)){insideRollback={textFill:null,textStroke:textStyle.textStroke,textStrokeWidth:textStyle.textStrokeWidth};textStyle.textFill='#fff';// Consider text with #fff overflow its container.
if(textStyle.textStroke==null){textStyle.textStroke=opt.autoColor;textStyle.textStrokeWidth==null&&(textStyle.textStrokeWidth=2);}}return insideRollback;}function rollbackInsideStyle(style){var insideRollback=style.insideRollback;if(insideRollback){style.textFill=insideRollback.textFill;style.textStroke=insideRollback.textStroke;style.textStrokeWidth=insideRollback.textStrokeWidth;}}function _getFont(opt,ecModel){// ecModel or default text style model.
var gTextStyleModel=ecModel||ecModel.getModel('textStyle');return trim([// FIXME in node-canvas fontWeight is before fontStyle
opt.fontStyle||gTextStyleModel&&gTextStyleModel.getShallow('fontStyle')||'',opt.fontWeight||gTextStyleModel&&gTextStyleModel.getShallow('fontWeight')||'',(opt.fontSize||gTextStyleModel&&gTextStyleModel.getShallow('fontSize')||12)+'px',opt.fontFamily||gTextStyleModel&&gTextStyleModel.getShallow('fontFamily')||'sans-serif'].join(' '));}function animateOrSetProps(isUpdate,el,props,animatableModel,dataIndex,cb){if(typeof dataIndex==='function'){cb=dataIndex;dataIndex=null;}// Do not check 'animation' property directly here. Consider this case:
// animation model is an `itemModel`, whose does not have `isAnimationEnabled`
// but its parent model (`seriesModel`) does.
var animationEnabled=animatableModel&&animatableModel.isAnimationEnabled();if(animationEnabled){var postfix=isUpdate?'Update':'';var duration=animatableModel.getShallow('animationDuration'+postfix);var animationEasing=animatableModel.getShallow('animationEasing'+postfix);var animationDelay=animatableModel.getShallow('animationDelay'+postfix);if(typeof animationDelay==='function'){animationDelay=animationDelay(dataIndex,animatableModel.getAnimationDelayParams?animatableModel.getAnimationDelayParams(el,dataIndex):null);}if(typeof duration==='function'){duration=duration(dataIndex);}duration>0?el.animateTo(props,duration,animationDelay||0,animationEasing,cb,!!cb):(el.stopAnimation(),el.attr(props),cb&&cb());}else{el.stopAnimation();el.attr(props);cb&&cb();}}/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So if do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} [cb]
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */function updateProps(el,props,animatableModel,dataIndex,cb){animateOrSetProps(true,el,props,animatableModel,dataIndex,cb);}/**
 * Init graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So if do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} cb
 */function initProps(el,props,animatableModel,dataIndex,cb){animateOrSetProps(false,el,props,animatableModel,dataIndex,cb);}/**
 * Get transform matrix of target (param target),
 * in coordinate of its ancestor (param ancestor)
 *
 * @param {module:zrender/mixin/Transformable} target
 * @param {module:zrender/mixin/Transformable} [ancestor]
 */function getTransform(target,ancestor){var mat=identity([]);while(target&&target!==ancestor){mul$1(mat,target.getLocalTransform(),mat);target=target.parent;}return mat;}/**
 * Apply transform to an vertex.
 * @param {Array.<number>} target [x, y]
 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
 * @param {boolean=} invert Whether use invert matrix.
 * @return {Array.<number>} [x, y]
 */function applyTransform$1(target,transform,invert$$1){if(transform&&!isArrayLike(transform)){transform=Transformable.getLocalTransform(transform);}if(invert$$1){transform=invert([],transform);}return applyTransform([],target,transform);}/**
 * @param {string} direction 'left' 'right' 'top' 'bottom'
 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
 * @param {boolean=} invert Whether use invert matrix.
 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
 */function transformDirection(direction,transform,invert$$1){// Pick a base, ensure that transform result will not be (0, 0).
var hBase=transform[4]===0||transform[5]===0||transform[0]===0?1:Math.abs(2*transform[4]/transform[0]);var vBase=transform[4]===0||transform[5]===0||transform[2]===0?1:Math.abs(2*transform[4]/transform[2]);var vertex=[direction==='left'?-hBase:direction==='right'?hBase:0,direction==='top'?-vBase:direction==='bottom'?vBase:0];vertex=applyTransform$1(vertex,transform,invert$$1);return Math.abs(vertex[0])>Math.abs(vertex[1])?vertex[0]>0?'right':'left':vertex[1]>0?'bottom':'top';}/**
 * Apply group transition animation from g1 to g2.
 * If no animatableModel, no animation.
 */function groupTransition(g1,g2,animatableModel,cb){if(!g1||!g2){return;}function getElMap(g){var elMap={};g.traverse(function(el){if(!el.isGroup&&el.anid){elMap[el.anid]=el;}});return elMap;}function getAnimatableProps(el){var obj={position:clone$1(el.position),rotation:el.rotation};if(el.shape){obj.shape=extend({},el.shape);}return obj;}var elMap1=getElMap(g1);g2.traverse(function(el){if(!el.isGroup&&el.anid){var oldEl=elMap1[el.anid];if(oldEl){var newProp=getAnimatableProps(el);el.attr(getAnimatableProps(oldEl));updateProps(el,newProp,animatableModel,el.dataIndex);}// else {
//     if (el.previousProps) {
//         graphic.updateProps
//     }
// }
}});}/**
 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
 * @param {Object} rect {x, y, width, height}
 * @return {Array.<Array.<number>>} A new clipped points.
 */function clipPointsByRect(points,rect){return map(points,function(point){var x=point[0];x=mathMax$1(x,rect.x);x=mathMin$1(x,rect.x+rect.width);var y=point[1];y=mathMax$1(y,rect.y);y=mathMin$1(y,rect.y+rect.height);return[x,y];});}/**
 * @param {Object} targetRect {x, y, width, height}
 * @param {Object} rect {x, y, width, height}
 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
 */function clipRectByRect(targetRect,rect){var x=mathMax$1(targetRect.x,rect.x);var x2=mathMin$1(targetRect.x+targetRect.width,rect.x+rect.width);var y=mathMax$1(targetRect.y,rect.y);var y2=mathMin$1(targetRect.y+targetRect.height,rect.y+rect.height);if(x2>=x&&y2>=y){return{x:x,y:y,width:x2-x,height:y2-y};}}/**
 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
 * @param {Object} [rect] {x, y, width, height}
 * @return {module:zrender/Element} Icon path or image element.
 */function createIcon(iconStr,opt,rect){opt=extend({rectHover:true},opt);var style=opt.style={strokeNoScale:true};rect=rect||{x:-1,y:-1,width:2,height:2};if(iconStr){return iconStr.indexOf('image://')===0?(style.image=iconStr.slice(8),defaults(style,rect),new ZImage(opt)):makePath(iconStr.replace('path://',''),opt,rect,'center');}}var graphic=(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a||Object)({extendShape:extendShape,extendPath:extendPath,makePath:makePath,makeImage:makeImage,mergePath:mergePath,resizePath:resizePath,subPixelOptimizeLine:subPixelOptimizeLine,subPixelOptimizeRect:subPixelOptimizeRect,subPixelOptimize:subPixelOptimize,setHoverStyle:setHoverStyle,setLabelStyle:setLabelStyle,setTextStyle:setTextStyle,setText:setText,getFont:_getFont,updateProps:updateProps,initProps:initProps,getTransform:getTransform,applyTransform:applyTransform$1,transformDirection:transformDirection,groupTransition:groupTransition,clipPointsByRect:clipPointsByRect,clipRectByRect:clipRectByRect,createIcon:createIcon,Group:Group,Image:ZImage,Text:Text,Circle:Circle,Sector:Sector,Ring:Ring,Polygon:Polygon,Polyline:Polyline,Rect:Rect,Line:Line,BezierCurve:BezierCurve,Arc:Arc,IncrementalDisplayable:IncrementalDisplayble,CompoundPath:CompoundPath,LinearGradient:LinearGradient,RadialGradient:RadialGradient,BoundingRect:BoundingRect});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var PATH_COLOR=['textStyle','color'];var textStyleMixin={/**
   * Get color property or get color from option.textStyle.color
   * @param {boolean} [isEmphasis]
   * @return {string}
   */getTextColor:function getTextColor(isEmphasis){var ecModel=this.ecModel;return this.getShallow('color')||(!isEmphasis&&ecModel?ecModel.get(PATH_COLOR):null);},/**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */getFont:function getFont(){return _getFont({fontStyle:this.getShallow('fontStyle'),fontWeight:this.getShallow('fontWeight'),fontSize:this.getShallow('fontSize'),fontFamily:this.getShallow('fontFamily')},this.ecModel);},getTextRect:function getTextRect(text){return _getBoundingRect(text,this.getFont(),this.getShallow('align'),this.getShallow('verticalAlign')||this.getShallow('baseline'),this.getShallow('padding'),this.getShallow('rich'),this.getShallow('truncateText'));}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var _getItemStyle=makeStyleMapper([['fill','color'],['stroke','borderColor'],['lineWidth','borderWidth'],['opacity'],['shadowBlur'],['shadowOffsetX'],['shadowOffsetY'],['shadowColor'],['textPosition'],['textAlign']]);var itemStyleMixin={getItemStyle:function getItemStyle(excludes,includes){var style=_getItemStyle(this,excludes,includes);var lineDash=this.getBorderLineDash();lineDash&&(style.lineDash=lineDash);return style;},getBorderLineDash:function getBorderLineDash(){var lineType=this.get('borderType');return lineType==='solid'||lineType==null?null:lineType==='dashed'?[5,5]:[1,1];}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @module echarts/model/Model
 */var mixin$1=mixin;var inner=makeInner();/**
 * @alias module:echarts/model/Model
 * @constructor
 * @param {Object} option
 * @param {module:echarts/model/Model} [parentModel]
 * @param {module:echarts/model/Global} [ecModel]
 */function Model(option,parentModel,ecModel){/**
   * @type {module:echarts/model/Model}
   * @readOnly
   */this.parentModel=parentModel;/**
   * @type {module:echarts/model/Global}
   * @readOnly
   */this.ecModel=ecModel;/**
   * @type {Object}
   * @protected
   */this.option=option;// Simple optimization
// if (this.init) {
//     if (arguments.length <= 4) {
//         this.init(option, parentModel, ecModel, extraOpt);
//     }
//     else {
//         this.init.apply(this, arguments);
//     }
// }
}Model.prototype={constructor:Model,/**
   * Model 的初始化函数
   * @param {Object} option
   */init:null,/**
   * 从新的 Option merge
   */mergeOption:function mergeOption(option){merge(this.option,option,true);},/**
   * @param {string|Array.<string>} path
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */get:function get(path,ignoreParent){if(path==null){return this.option;}return doGet(this.option,this.parsePath(path),!ignoreParent&&getParent(this,path));},/**
   * @param {string} key
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */getShallow:function getShallow(key,ignoreParent){var option=this.option;var val=option==null?option:option[key];var parentModel=!ignoreParent&&getParent(this,key);if(val==null&&parentModel){val=parentModel.getShallow(key);}return val;},/**
   * @param {string|Array.<string>} [path]
   * @param {module:echarts/model/Model} [parentModel]
   * @return {module:echarts/model/Model}
   */getModel:function getModel(path,parentModel){var obj=path==null?this.option:doGet(this.option,path=this.parsePath(path));var thisParentModel;parentModel=parentModel||(thisParentModel=getParent(this,path))&&thisParentModel.getModel(path);return new Model(obj,parentModel,this.ecModel);},/**
   * If model has option
   */isEmpty:function isEmpty(){return this.option==null;},restoreData:function restoreData(){},// Pending
clone:function clone(){var Ctor=this.constructor;return new Ctor(_clone(this.option));},setReadOnly:function setReadOnly(properties){// clazzUtil.setReadOnly(this, properties);
},// If path is null/undefined, return null/undefined.
parsePath:function parsePath(path){if(typeof path==='string'){path=path.split('.');}return path;},/**
   * @param {Function} getParentMethod
   *        param {Array.<string>|string} path
   *        return {module:echarts/model/Model}
   */customizeGetParent:function customizeGetParent(getParentMethod){inner(this).getParent=getParentMethod;},isAnimationEnabled:function isAnimationEnabled(){if(!env$1.node){if(this.option.animation!=null){return!!this.option.animation;}else if(this.parentModel){return this.parentModel.isAnimationEnabled();}}}};function doGet(obj,pathArr,parentModel){for(var i=0;i<pathArr.length;i++){// Ignore empty
if(!pathArr[i]){continue;}// obj could be number/string/... (like 0)
obj=obj&&(typeof obj==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj))==='object'?obj[pathArr[i]]:null;if(obj==null){break;}}if(obj==null&&parentModel){obj=parentModel.get(pathArr);}return obj;}// `path` can be null/undefined
function getParent(model,path){var getParentMethod=inner(model).getParent;return getParentMethod?getParentMethod.call(model,path):model.parentModel;}// Enable Model.extend.
enableClassExtend(Model);enableClassCheck(Model);mixin$1(Model,lineStyleMixin);mixin$1(Model,areaStyleMixin);mixin$1(Model,textStyleMixin);mixin$1(Model,itemStyleMixin);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var base=0;/**
 * @public
 * @param {string} type
 * @return {string}
 */function getUID(type){// Considering the case of crossing js context,
// use Math.random to make id as unique as possible.
return[type||'',base++,Math.random().toFixed(5)].join('_');}/**
 * @inner
 */function enableSubTypeDefaulter(entity){var subTypeDefaulters={};entity.registerSubTypeDefaulter=function(componentType,defaulter){componentType=parseClassType$1(componentType);subTypeDefaulters[componentType.main]=defaulter;};entity.determineSubType=function(componentType,option){var type=option.type;if(!type){var componentTypeMain=parseClassType$1(componentType).main;if(entity.hasSubTypes(componentType)&&subTypeDefaulters[componentTypeMain]){type=subTypeDefaulters[componentTypeMain](option);}}return type;};return entity;}/**
 * Topological travel on Activity Network (Activity On Vertices).
 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
 *
 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
 *
 * If there is circle dependencey, Error will be thrown.
 *
 */function enableTopologicalTravel(entity,dependencyGetter){/**
   * @public
   * @param {Array.<string>} targetNameList Target Component type list.
   *                                           Can be ['aa', 'bb', 'aa.xx']
   * @param {Array.<string>} fullNameList By which we can build dependency graph.
   * @param {Function} callback Params: componentType, dependencies.
   * @param {Object} context Scope of callback.
   */entity.topologicalTravel=function(targetNameList,fullNameList,callback,context){if(!targetNameList.length){return;}var result=makeDepndencyGraph(fullNameList);var graph=result.graph;var stack=result.noEntryList;var targetNameSet={};each$1(targetNameList,function(name){targetNameSet[name]=true;});while(stack.length){var currComponentType=stack.pop();var currVertex=graph[currComponentType];var isInTargetNameSet=!!targetNameSet[currComponentType];if(isInTargetNameSet){callback.call(context,currComponentType,currVertex.originalDeps.slice());delete targetNameSet[currComponentType];}each$1(currVertex.successor,isInTargetNameSet?removeEdgeAndAdd:removeEdge);}each$1(targetNameSet,function(){throw new Error('Circle dependency may exists');});function removeEdge(succComponentType){graph[succComponentType].entryCount--;if(graph[succComponentType].entryCount===0){stack.push(succComponentType);}}// Consider this case: legend depends on series, and we call
// chart.setOption({series: [...]}), where only series is in option.
// If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
// not be called, but only sereis.mergeOption is called. Thus legend
// have no chance to update its local record about series (like which
// name of series is available in legend).
function removeEdgeAndAdd(succComponentType){targetNameSet[succComponentType]=true;removeEdge(succComponentType);}};/**
   * DepndencyGraph: {Object}
   * key: conponentType,
   * value: {
   *     successor: [conponentTypes...],
   *     originalDeps: [conponentTypes...],
   *     entryCount: {number}
   * }
   */function makeDepndencyGraph(fullNameList){var graph={};var noEntryList=[];each$1(fullNameList,function(name){var thisItem=createDependencyGraphItem(graph,name);var originalDeps=thisItem.originalDeps=dependencyGetter(name);var availableDeps=getAvailableDependencies(originalDeps,fullNameList);thisItem.entryCount=availableDeps.length;if(thisItem.entryCount===0){noEntryList.push(name);}each$1(availableDeps,function(dependentName){if(indexOf(thisItem.predecessor,dependentName)<0){thisItem.predecessor.push(dependentName);}var thatItem=createDependencyGraphItem(graph,dependentName);if(indexOf(thatItem.successor,dependentName)<0){thatItem.successor.push(name);}});});return{graph:graph,noEntryList:noEntryList};}function createDependencyGraphItem(graph,name){if(!graph[name]){graph[name]={predecessor:[],successor:[]};}return graph[name];}function getAvailableDependencies(originalDeps,fullNameList){var availableDeps=[];each$1(originalDeps,function(dep){indexOf(fullNameList,dep)>=0&&availableDeps.push(dep);});return availableDeps;}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var RADIAN_EPSILON=1e-4;function _trim(str){return str.replace(/^\s+/,'').replace(/\s+$/,'');}/**
 * Linear mapping a value from domain to range
 * @memberOf module:echarts/util/number
 * @param  {(number|Array.<number>)} val
 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
 * @param  {boolean} clamp
 * @return {(number|Array.<number>}
 */function linearMap(val,domain,range,clamp){var subDomain=domain[1]-domain[0];var subRange=range[1]-range[0];if(subDomain===0){return subRange===0?range[0]:(range[0]+range[1])/2;}// Avoid accuracy problem in edge, such as
// 146.39 - 62.83 === 83.55999999999999.
// See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
// It is a little verbose for efficiency considering this method
// is a hotspot.
if(clamp){if(subDomain>0){if(val<=domain[0]){return range[0];}else if(val>=domain[1]){return range[1];}}else{if(val>=domain[0]){return range[0];}else if(val<=domain[1]){return range[1];}}}else{if(val===domain[0]){return range[0];}if(val===domain[1]){return range[1];}}return(val-domain[0])/subDomain*subRange+range[0];}/**
 * Convert a percent string to absolute number.
 * Returns NaN if percent is not a valid string or number
 * @memberOf module:echarts/util/number
 * @param {string|number} percent
 * @param {number} all
 * @return {number}
 */function parsePercent$1(percent,all){switch(percent){case'center':case'middle':percent='50%';break;case'left':case'top':percent='0%';break;case'right':case'bottom':percent='100%';break;}if(typeof percent==='string'){if(_trim(percent).match(/%$/)){return parseFloat(percent)/100*all;}return parseFloat(percent);}return percent==null?NaN:+percent;}/**
 * (1) Fix rounding error of float numbers.
 * (2) Support return string to avoid scientific notation like '3.5e-7'.
 *
 * @param {number} x
 * @param {number} [precision]
 * @param {boolean} [returnStr]
 * @return {number|string}
 */function round$1(x,precision,returnStr){if(precision==null){precision=10;}// Avoid range error
precision=Math.min(Math.max(0,precision),20);x=(+x).toFixed(precision);return returnStr?x:+x;}function asc(arr){arr.sort(function(a,b){return a-b;});return arr;}/**
 * Get precision
 * @param {number} val
 */function getPrecision(val){val=+val;if(isNaN(val)){return 0;}// It is much faster than methods converting number to string as follows
//      var tmp = val.toString();
//      return tmp.length - 1 - tmp.indexOf('.');
// especially when precision is low
var e=1;var count=0;while(Math.round(val*e)/e!==val){e*=10;count++;}return count;}/**
 * @param {string|number} val
 * @return {number}
 */function getPrecisionSafe(val){var str=val.toString();// Consider scientific notation: '3.4e-12' '3.4e+12'
var eIndex=str.indexOf('e');if(eIndex>0){var precision=+str.slice(eIndex+1);return precision<0?-precision:0;}else{var dotIndex=str.indexOf('.');return dotIndex<0?0:str.length-1-dotIndex;}}/**
 * Minimal dicernible data precisioin according to a single pixel.
 *
 * @param {Array.<number>} dataExtent
 * @param {Array.<number>} pixelExtent
 * @return {number} precision
 */function _getPixelPrecision(dataExtent,pixelExtent){var log=Math.log;var LN10=Math.LN10;var dataQuantity=Math.floor(log(dataExtent[1]-dataExtent[0])/LN10);var sizeQuantity=Math.round(log(Math.abs(pixelExtent[1]-pixelExtent[0]))/LN10);// toFixed() digits argument must be between 0 and 20.
var precision=Math.min(Math.max(-dataQuantity+sizeQuantity,0),20);return!isFinite(precision)?20:precision;}/**
 * Get a data of given precision, assuring the sum of percentages
 * in valueList is 1.
 * The largest remainer method is used.
 * https://en.wikipedia.org/wiki/Largest_remainder_method
 *
 * @param {Array.<number>} valueList a list of all data
 * @param {number} idx index of the data to be processed in valueList
 * @param {number} precision integer number showing digits of precision
 * @return {number} percent ranging from 0 to 100
 */function getPercentWithPrecision(valueList,idx,precision){if(!valueList[idx]){return 0;}var sum=reduce(valueList,function(acc,val){return acc+(isNaN(val)?0:val);},0);if(sum===0){return 0;}var digits=Math.pow(10,precision);var votesPerQuota=map(valueList,function(val){return(isNaN(val)?0:val)/sum*digits*100;});var targetSeats=digits*100;var seats=map(votesPerQuota,function(votes){// Assign automatic seats.
return Math.floor(votes);});var currentSum=reduce(seats,function(acc,val){return acc+val;},0);var remainder=map(votesPerQuota,function(votes,idx){return votes-seats[idx];});// Has remainding votes.
while(currentSum<targetSeats){// Find next largest remainder.
var max=Number.NEGATIVE_INFINITY;var maxId=null;for(var i=0,len=remainder.length;i<len;++i){if(remainder[i]>max){max=remainder[i];maxId=i;}}// Add a vote to max remainder.
++seats[maxId];remainder[maxId]=0;++currentSum;}return seats[idx]/digits;}// Number.MAX_SAFE_INTEGER, ie do not support.
var MAX_SAFE_INTEGER=9007199254740991;/**
 * To 0 - 2 * PI, considering negative radian.
 * @param {number} radian
 * @return {number}
 */function remRadian(radian){var pi2=Math.PI*2;return(radian%pi2+pi2)%pi2;}/**
 * @param {type} radian
 * @return {boolean}
 */function isRadianAroundZero(val){return val>-RADIAN_EPSILON&&val<RADIAN_EPSILON;}var TIME_REG=/^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/;// jshint ignore:line
/**
 * @param {string|Date|number} value These values can be accepted:
 *   + An instance of Date, represent a time in its own time zone.
 *   + Or string in a subset of ISO 8601, only including:
 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
 *     all of which will be treated as local time if time zone is not specified
 *     (see <https://momentjs.com/>).
 *   + Or other string format, including (all of which will be treated as loacal time):
 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
 *   + a timestamp, which represent a time in UTC.
 * @return {Date} date
 */function parseDate(value){if(value instanceof Date){return value;}else if(typeof value==='string'){// Different browsers parse date in different way, so we parse it manually.
// Some other issues:
// new Date('1970-01-01') is UTC,
// new Date('1970/01/01') and new Date('1970-1-01') is local.
// See issue #3623
var match=TIME_REG.exec(value);if(!match){// return Invalid Date.
return new Date(NaN);}// Use local time when no timezone offset specifed.
if(!match[8]){// match[n] can only be string or undefined.
// But take care of '12' + 1 => '121'.
return new Date(+match[1],+(match[2]||1)-1,+match[3]||1,+match[4]||0,+(match[5]||0),+match[6]||0,+match[7]||0);}// Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
// https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
// For example, system timezone is set as "Time Zone: America/Toronto",
// then these code will get different result:
// `new Date(1478411999999).getTimezoneOffset();  // get 240`
// `new Date(1478412000000).getTimezoneOffset();  // get 300`
// So we should not use `new Date`, but use `Date.UTC`.
else{var hour=+match[4]||0;if(match[8].toUpperCase()!=='Z'){hour-=match[8].slice(0,3);}return new Date(Date.UTC(+match[1],+(match[2]||1)-1,+match[3]||1,hour,+(match[5]||0),+match[6]||0,+match[7]||0));}}else if(value==null){return new Date(NaN);}return new Date(Math.round(value));}/**
 * Quantity of a number. e.g. 0.1, 1, 10, 100
 *
 * @param  {number} val
 * @return {number}
 */function quantity(val){return Math.pow(10,quantityExponent(val));}function quantityExponent(val){return Math.floor(Math.log(val)/Math.LN10);}/**
 * find a “nice” number approximately equal to x. Round the number if round = true,
 * take ceiling if round = false. The primary observation is that the “nicest”
 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
 *
 * See "Nice Numbers for Graph Labels" of Graphic Gems.
 *
 * @param  {number} val Non-negative value.
 * @param  {boolean} round
 * @return {number}
 */function nice(val,round){var exponent=quantityExponent(val);var exp10=Math.pow(10,exponent);var f=val/exp10;// 1 <= f < 10
var nf;if(round){if(f<1.5){nf=1;}else if(f<2.5){nf=2;}else if(f<4){nf=3;}else if(f<7){nf=5;}else{nf=10;}}else{if(f<1){nf=1;}else if(f<2){nf=2;}else if(f<3){nf=3;}else if(f<5){nf=5;}else{nf=10;}}val=nf*exp10;// Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
// 20 is the uppper bound of toFixed.
return exponent>=-20?+val.toFixed(exponent<0?-exponent:0):val;}/**
 * Order intervals asc, and split them when overlap.
 * expect(numberUtil.reformIntervals([
 *     {interval: [18, 62], close: [1, 1]},
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [1, 1]},
 *     {interval: [62, 150], close: [1, 1]},
 *     {interval: [106, 150], close: [1, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ])).toEqual([
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [0, 1]},
 *     {interval: [18, 62], close: [0, 1]},
 *     {interval: [62, 150], close: [0, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ]);
 * @param {Array.<Object>} list, where `close` mean open or close
 *        of the interval, and Infinity can be used.
 * @return {Array.<Object>} The origin list, which has been reformed.
 */function reformIntervals(list){list.sort(function(a,b){return littleThan(a,b,0)?-1:1;});var curr=-Infinity;var currClose=1;for(var i=0;i<list.length;){var interval=list[i].interval;var close=list[i].close;for(var lg=0;lg<2;lg++){if(interval[lg]<=curr){interval[lg]=curr;close[lg]=!lg?1-currClose:1;}curr=interval[lg];currClose=close[lg];}if(interval[0]===interval[1]&&close[0]*close[1]!==1){list.splice(i,1);}else{i++;}}return list;function littleThan(a,b,lg){return a.interval[lg]<b.interval[lg]||a.interval[lg]===b.interval[lg]&&(a.close[lg]-b.close[lg]===(!lg?1:-1)||!lg&&littleThan(a,b,1));}}/**
 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
 * subtraction forces infinities to NaN
 *
 * @param {*} v
 * @return {boolean}
 */function isNumeric(v){return v-parseFloat(v)>=0;}var number=(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a||Object)({linearMap:linearMap,parsePercent:parsePercent$1,round:round$1,asc:asc,getPrecision:getPrecision,getPrecisionSafe:getPrecisionSafe,getPixelPrecision:_getPixelPrecision,getPercentWithPrecision:getPercentWithPrecision,MAX_SAFE_INTEGER:MAX_SAFE_INTEGER,remRadian:remRadian,isRadianAroundZero:isRadianAroundZero,parseDate:parseDate,quantity:quantity,nice:nice,reformIntervals:reformIntervals,isNumeric:isNumeric});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * 每三位默认加,格式化
 * @param {string|number} x
 * @return {string}
 */function addCommas(x){if(isNaN(x)){return'-';}x=(x+'').split('.');return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g,'$1,')+(x.length>1?'.'+x[1]:'');}/**
 * @param {string} str
 * @param {boolean} [upperCaseFirst=false]
 * @return {string} str
 */function toCamelCase(str,upperCaseFirst){str=(str||'').toLowerCase().replace(/-(.)/g,function(match,group1){return group1.toUpperCase();});if(upperCaseFirst&&str){str=str.charAt(0).toUpperCase()+str.slice(1);}return str;}var normalizeCssArray$1=normalizeCssArray;var replaceReg=/([&<>"'])/g;var replaceMap={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;'};function encodeHTML(source){return source==null?'':(source+'').replace(replaceReg,function(str,c){return replaceMap[c];});}var TPL_VAR_ALIAS=['a','b','c','d','e','f','g'];var wrapVar=function wrapVar(varName,seriesIdx){return'{'+varName+(seriesIdx==null?'':seriesIdx)+'}';};/**
 * Template formatter
 * @param {string} tpl
 * @param {Array.<Object>|Object} paramsList
 * @param {boolean} [encode=false]
 * @return {string}
 */function formatTpl(tpl,paramsList,encode){if(!isArray(paramsList)){paramsList=[paramsList];}var seriesLen=paramsList.length;if(!seriesLen){return'';}var $vars=paramsList[0].$vars||[];for(var i=0;i<$vars.length;i++){var alias=TPL_VAR_ALIAS[i];tpl=tpl.replace(wrapVar(alias),wrapVar(alias,0));}for(var seriesIdx=0;seriesIdx<seriesLen;seriesIdx++){for(var k=0;k<$vars.length;k++){var val=paramsList[seriesIdx][$vars[k]];tpl=tpl.replace(wrapVar(TPL_VAR_ALIAS[k],seriesIdx),encode?encodeHTML(val):val);}}return tpl;}/**
 * simple Template formatter
 *
 * @param {string} tpl
 * @param {Object} param
 * @param {boolean} [encode=false]
 * @return {string}
 */function formatTplSimple(tpl,param,encode){each$1(param,function(value,key){tpl=tpl.replace('{'+key+'}',encode?encodeHTML(value):value);});return tpl;}/**
 * @param {Object|string} [opt] If string, means color.
 * @param {string} [opt.color]
 * @param {string} [opt.extraCssText]
 * @param {string} [opt.type='item'] 'item' or 'subItem'
 * @return {string}
 */function getTooltipMarker(opt,extraCssText){opt=isString(opt)?{color:opt,extraCssText:extraCssText}:opt||{};var color=opt.color;var type=opt.type;var extraCssText=opt.extraCssText;if(!color){return'';}return type==='subItem'?'<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;'+'border-radius:4px;width:4px;height:4px;background-color:'+encodeHTML(color)+';'+(extraCssText||'')+'"></span>':'<span style="display:inline-block;margin-right:5px;'+'border-radius:10px;width:10px;height:10px;background-color:'+encodeHTML(color)+';'+(extraCssText||'')+'"></span>';}function pad(str,len){str+='';return'0000'.substr(0,len-str.length)+str;}/**
 * ISO Date format
 * @param {string} tpl
 * @param {number} value
 * @param {boolean} [isUTC=false] Default in local time.
 *           see `module:echarts/scale/Time`
 *           and `module:echarts/util/number#parseDate`.
 * @inner
 */function formatTime(tpl,value,isUTC){if(tpl==='week'||tpl==='month'||tpl==='quarter'||tpl==='half-year'||tpl==='year'){tpl='MM-dd\nyyyy';}var date=parseDate(value);var utc=isUTC?'UTC':'';var y=date['get'+utc+'FullYear']();var M=date['get'+utc+'Month']()+1;var d=date['get'+utc+'Date']();var h=date['get'+utc+'Hours']();var m=date['get'+utc+'Minutes']();var s=date['get'+utc+'Seconds']();var S=date['get'+utc+'Milliseconds']();tpl=tpl.replace('MM',pad(M,2)).replace('M',M).replace('yyyy',y).replace('yy',y%100).replace('dd',pad(d,2)).replace('d',d).replace('hh',pad(h,2)).replace('h',h).replace('mm',pad(m,2)).replace('m',m).replace('ss',pad(s,2)).replace('s',s).replace('SSS',pad(S,3));return tpl;}/**
 * Capital first
 * @param {string} str
 * @return {string}
 */function capitalFirst(str){return str?str.charAt(0).toUpperCase()+str.substr(1):str;}var truncateText$1=truncateText;var getTextRect=_getBoundingRect;var format=(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a||Object)({addCommas:addCommas,toCamelCase:toCamelCase,normalizeCssArray:normalizeCssArray$1,encodeHTML:encodeHTML,formatTpl:formatTpl,formatTplSimple:formatTplSimple,getTooltipMarker:getTooltipMarker,formatTime:formatTime,capitalFirst:capitalFirst,truncateText:truncateText$1,getTextRect:getTextRect});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// Layout helpers for each component positioning
var each$3=each$1;/**
 * @public
 */var LOCATION_PARAMS=['left','right','top','bottom','width','height'];/**
 * @public
 */var HV_NAMES=[['width','left','right'],['height','top','bottom']];function boxLayout(orient,group,gap,maxWidth,maxHeight){var x=0;var y=0;if(maxWidth==null){maxWidth=Infinity;}if(maxHeight==null){maxHeight=Infinity;}var currentLineMaxSize=0;group.eachChild(function(child,idx){var position=child.position;var rect=child.getBoundingRect();var nextChild=group.childAt(idx+1);var nextChildRect=nextChild&&nextChild.getBoundingRect();var nextX;var nextY;if(orient==='horizontal'){var moveX=rect.width+(nextChildRect?-nextChildRect.x+rect.x:0);nextX=x+moveX;// Wrap when width exceeds maxWidth or meet a `newline` group
// FIXME compare before adding gap?
if(nextX>maxWidth||child.newline){x=0;nextX=moveX;y+=currentLineMaxSize+gap;currentLineMaxSize=rect.height;}else{// FIXME: consider rect.y is not `0`?
currentLineMaxSize=Math.max(currentLineMaxSize,rect.height);}}else{var moveY=rect.height+(nextChildRect?-nextChildRect.y+rect.y:0);nextY=y+moveY;// Wrap when width exceeds maxHeight or meet a `newline` group
if(nextY>maxHeight||child.newline){x+=currentLineMaxSize+gap;y=0;nextY=moveY;currentLineMaxSize=rect.width;}else{currentLineMaxSize=Math.max(currentLineMaxSize,rect.width);}}if(child.newline){return;}position[0]=x;position[1]=y;orient==='horizontal'?x=nextX+gap:y=nextY+gap;});}/**
 * VBox or HBox layouting
 * @param {string} orient
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */var box=boxLayout;/**
 * VBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */var vbox=curry(boxLayout,'vertical');/**
 * HBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */var hbox=curry(boxLayout,'horizontal');/**
 * If x or x2 is not specified or 'center' 'left' 'right',
 * the width would be as long as possible.
 * If y or y2 is not specified or 'middle' 'top' 'bottom',
 * the height would be as long as possible.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.x]
 * @param {number|string} [positionInfo.y]
 * @param {number|string} [positionInfo.x2]
 * @param {number|string} [positionInfo.y2]
 * @param {Object} containerRect {width, height}
 * @param {string|number} margin
 * @return {Object} {width, height}
 *//**
 * Parse position info.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width]
 * @param {number|string} [positionInfo.height]
 * @param {number|string} [positionInfo.aspect] Aspect is width / height
 * @param {Object} containerRect
 * @param {string|number} [margin]
 *
 * @return {module:zrender/core/BoundingRect}
 */function getLayoutRect(positionInfo,containerRect,margin){margin=normalizeCssArray$1(margin||0);var containerWidth=containerRect.width;var containerHeight=containerRect.height;var left=parsePercent$1(positionInfo.left,containerWidth);var top=parsePercent$1(positionInfo.top,containerHeight);var right=parsePercent$1(positionInfo.right,containerWidth);var bottom=parsePercent$1(positionInfo.bottom,containerHeight);var width=parsePercent$1(positionInfo.width,containerWidth);var height=parsePercent$1(positionInfo.height,containerHeight);var verticalMargin=margin[2]+margin[0];var horizontalMargin=margin[1]+margin[3];var aspect=positionInfo.aspect;// If width is not specified, calculate width from left and right
if(isNaN(width)){width=containerWidth-right-horizontalMargin-left;}if(isNaN(height)){height=containerHeight-bottom-verticalMargin-top;}if(aspect!=null){// If width and height are not given
// 1. Graph should not exceeds the container
// 2. Aspect must be keeped
// 3. Graph should take the space as more as possible
// FIXME
// Margin is not considered, because there is no case that both
// using margin and aspect so far.
if(isNaN(width)&&isNaN(height)){if(aspect>containerWidth/containerHeight){width=containerWidth*0.8;}else{height=containerHeight*0.8;}}// Calculate width or height with given aspect
if(isNaN(width)){width=aspect*height;}if(isNaN(height)){height=width/aspect;}}// If left is not specified, calculate left from right and width
if(isNaN(left)){left=containerWidth-right-width-horizontalMargin;}if(isNaN(top)){top=containerHeight-bottom-height-verticalMargin;}// Align left and top
switch(positionInfo.left||positionInfo.right){case'center':left=containerWidth/2-width/2-margin[3];break;case'right':left=containerWidth-width-horizontalMargin;break;}switch(positionInfo.top||positionInfo.bottom){case'middle':case'center':top=containerHeight/2-height/2-margin[0];break;case'bottom':top=containerHeight-height-verticalMargin;break;}// If something is wrong and left, top, width, height are calculated as NaN
left=left||0;top=top||0;if(isNaN(width)){// Width may be NaN if only one value is given except width
width=containerWidth-horizontalMargin-left-(right||0);}if(isNaN(height)){// Height may be NaN if only one value is given except height
height=containerHeight-verticalMargin-top-(bottom||0);}var rect=new BoundingRect(left+margin[3],top+margin[0],width,height);rect.margin=margin;return rect;}/**
 * Position a zr element in viewport
 *  Group position is specified by either
 *  {left, top}, {right, bottom}
 *  If all properties exists, right and bottom will be igonred.
 *
 * Logic:
 *     1. Scale (against origin point in parent coord)
 *     2. Rotate (against origin point in parent coord)
 *     3. Traslate (with el.position by this method)
 * So this method only fixes the last step 'Traslate', which does not affect
 * scaling and rotating.
 *
 * If be called repeatly with the same input el, the same result will be gotten.
 *
 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
 * @param {Object} containerRect
 * @param {string|number} margin
 * @param {Object} [opt]
 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
 * @param {Array.<number>} [opt.boundingMode='all']
 *        Specify how to calculate boundingRect when locating.
 *        'all': Position the boundingRect that is transformed and uioned
 *               both itself and its descendants.
 *               This mode simplies confine the elements in the bounding
 *               of their container (e.g., using 'right: 0').
 *        'raw': Position the boundingRect that is not transformed and only itself.
 *               This mode is useful when you want a element can overflow its
 *               container. (Consider a rotated circle needs to be located in a corner.)
 *               In this mode positionInfo.width/height can only be number.
 */function positionElement(el,positionInfo,containerRect,margin,opt){var h=!opt||!opt.hv||opt.hv[0];var v=!opt||!opt.hv||opt.hv[1];var boundingMode=opt&&opt.boundingMode||'all';if(!h&&!v){return;}var rect;if(boundingMode==='raw'){rect=el.type==='group'?new BoundingRect(0,0,+positionInfo.width||0,+positionInfo.height||0):el.getBoundingRect();}else{rect=el.getBoundingRect();if(el.needLocalTransform()){var transform=el.getLocalTransform();// Notice: raw rect may be inner object of el,
// which should not be modified.
rect=rect.clone();rect.applyTransform(transform);}}// The real width and height can not be specified but calculated by the given el.
positionInfo=getLayoutRect(defaults({width:rect.width,height:rect.height},positionInfo),containerRect,margin);// Because 'tranlate' is the last step in transform
// (see zrender/core/Transformable#getLocalTransform),
// we can just only modify el.position to get final result.
var elPos=el.position;var dx=h?positionInfo.x-rect.x:0;var dy=v?positionInfo.y-rect.y:0;el.attr('position',boundingMode==='raw'?[dx,dy]:[elPos[0]+dx,elPos[1]+dy]);}/**
 * @param {Object} option Contains some of the properties in HV_NAMES.
 * @param {number} hvIdx 0: horizontal; 1: vertical.
 *//**
 * Consider Case:
 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
 * through setOption or media query, using normal zrUtil.merge will cause
 * {right: 0} does not take effect.
 *
 * @example
 * ComponentModel.extend({
 *     init: function () {
 *         ...
 *         var inputPositionParams = layout.getLayoutParams(option);
 *         this.mergeOption(inputPositionParams);
 *     },
 *     mergeOption: function (newOption) {
 *         newOption && zrUtil.merge(thisOption, newOption, true);
 *         layout.mergeLayoutParam(thisOption, newOption);
 *     }
 * });
 *
 * @param {Object} targetOption
 * @param {Object} newOption
 * @param {Object|string} [opt]
 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
 *  that width (or height) should not be calculated by left and right (or top and bottom).
 */function mergeLayoutParam(targetOption,newOption,opt){!isObject$1(opt)&&(opt={});var ignoreSize=opt.ignoreSize;!isArray(ignoreSize)&&(ignoreSize=[ignoreSize,ignoreSize]);var hResult=merge$$1(HV_NAMES[0],0);var vResult=merge$$1(HV_NAMES[1],1);copy(HV_NAMES[0],targetOption,hResult);copy(HV_NAMES[1],targetOption,vResult);function merge$$1(names,hvIdx){var newParams={};var newValueCount=0;var merged={};var mergedValueCount=0;var enoughParamNumber=2;each$3(names,function(name){merged[name]=targetOption[name];});each$3(names,function(name){// Consider case: newOption.width is null, which is
// set by user for removing width setting.
hasProp(newOption,name)&&(newParams[name]=merged[name]=newOption[name]);hasValue(newParams,name)&&newValueCount++;hasValue(merged,name)&&mergedValueCount++;});if(ignoreSize[hvIdx]){// Only one of left/right is premitted to exist.
if(hasValue(newOption,names[1])){merged[names[2]]=null;}else if(hasValue(newOption,names[2])){merged[names[1]]=null;}return merged;}// Case: newOption: {width: ..., right: ...},
// or targetOption: {right: ...} and newOption: {width: ...},
// There is no conflict when merged only has params count
// little than enoughParamNumber.
if(mergedValueCount===enoughParamNumber||!newValueCount){return merged;}// Case: newOption: {width: ..., right: ...},
// Than we can make sure user only want those two, and ignore
// all origin params in targetOption.
else if(newValueCount>=enoughParamNumber){return newParams;}else{// Chose another param from targetOption by priority.
for(var i=0;i<names.length;i++){var name=names[i];if(!hasProp(newParams,name)&&hasProp(targetOption,name)){newParams[name]=targetOption[name];break;}}return newParams;}}function hasProp(obj,name){return obj.hasOwnProperty(name);}function hasValue(obj,name){return obj[name]!=null&&obj[name]!=='auto';}function copy(names,target,source){each$3(names,function(name){target[name]=source[name];});}}/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */function getLayoutParams(source){return copyLayoutParams({},source);}/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */function copyLayoutParams(target,source){source&&target&&each$3(LOCATION_PARAMS,function(name){source.hasOwnProperty(name)&&(target[name]=source[name]);});return target;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var boxLayoutMixin={getBoxLayoutParams:function getBoxLayoutParams(){return{left:this.get('left'),top:this.get('top'),right:this.get('right'),bottom:this.get('bottom'),width:this.get('width'),height:this.get('height')};}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Component model
 *
 * @module echarts/model/Component
 */var inner$1=makeInner();/**
 * @alias module:echarts/model/Component
 * @constructor
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {module:echarts/model/Model} ecModel
 */var ComponentModel=Model.extend({type:'component',/**
   * @readOnly
   * @type {string}
   */id:'',/**
   * Because simplified concept is probably better, series.name (or component.name)
   * has been having too many resposibilities:
   * (1) Generating id (which requires name in option should not be modified).
   * (2) As an index to mapping series when merging option or calling API (a name
   * can refer to more then one components, which is convinient is some case).
   * (3) Display.
   * @readOnly
   */name:'',/**
   * @readOnly
   * @type {string}
   */mainType:'',/**
   * @readOnly
   * @type {string}
   */subType:'',/**
   * @readOnly
   * @type {number}
   */componentIndex:0,/**
   * @type {Object}
   * @protected
   */defaultOption:null,/**
   * @type {module:echarts/model/Global}
   * @readOnly
   */ecModel:null,/**
   * key: componentType
   * value:  Component model list, can not be null.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @readOnly
   */dependentModels:[],/**
   * @type {string}
   * @readOnly
   */uid:null,/**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */layoutMode:null,$constructor:function $constructor(option,parentModel,ecModel,extraOpt){Model.call(this,option,parentModel,ecModel,extraOpt);this.uid=getUID('ec_cpt_model');},init:function init(option,parentModel,ecModel,extraOpt){this.mergeDefaultAndTheme(option,ecModel);},mergeDefaultAndTheme:function mergeDefaultAndTheme(option,ecModel){var layoutMode=this.layoutMode;var inputPositionParams=layoutMode?getLayoutParams(option):{};var themeModel=ecModel.getTheme();merge(option,themeModel.get(this.mainType));merge(option,this.getDefaultOption());if(layoutMode){mergeLayoutParam(option,inputPositionParams,layoutMode);}},mergeOption:function mergeOption(option,extraOpt){merge(this.option,option,true);var layoutMode=this.layoutMode;if(layoutMode){mergeLayoutParam(this.option,option,layoutMode);}},// Hooker after init or mergeOption
optionUpdated:function optionUpdated(newCptOption,isInit){},getDefaultOption:function getDefaultOption(){var fields=inner$1(this);if(!fields.defaultOption){var optList=[];var Class=this.constructor;while(Class){var opt=Class.prototype.defaultOption;opt&&optList.push(opt);Class=Class.superClass;}var defaultOption={};for(var i=optList.length-1;i>=0;i--){defaultOption=merge(defaultOption,optList[i],true);}fields.defaultOption=defaultOption;}return fields.defaultOption;},getReferringComponents:function getReferringComponents(mainType){return this.ecModel.queryComponents({mainType:mainType,index:this.get(mainType+'Index',true),id:this.get(mainType+'Id',true)});}});// Reset ComponentModel.extend, add preConstruct.
// clazzUtil.enableClassExtend(
//     ComponentModel,
//     function (option, parentModel, ecModel, extraOpt) {
//         // Set dependentModels, componentIndex, name, id, mainType, subType.
//         zrUtil.extend(this, extraOpt);
//         this.uid = componentUtil.getUID('componentModel');
//         // this.setReadOnly([
//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
//         //     'dependentModels', 'componentIndex'
//         // ]);
//     }
// );
// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
enableClassManagement(ComponentModel,{registerWhenExtend:true});enableSubTypeDefaulter(ComponentModel);// Add capability of ComponentModel.topologicalTravel.
enableTopologicalTravel(ComponentModel,getDependencies);function getDependencies(componentType){var deps=[];each$1(ComponentModel.getClassesByMainType(componentType),function(Clazz){deps=deps.concat(Clazz.prototype.dependencies||[]);});// Ensure main type.
deps=map(deps,function(type){return parseClassType$1(type).main;});// Hack dataset for convenience.
if(componentType!=='dataset'&&indexOf(deps,'dataset')<=0){deps.unshift('dataset');}return deps;}mixin(ComponentModel,boxLayoutMixin);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var platform='';// Navigator not exists in node
if(typeof navigator!=='undefined'){platform=navigator.platform||'';}var globalDefault={// backgroundColor: 'rgba(0,0,0,0)',
// https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
// color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
// Light colors:
// color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
// color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
// Dark colors:
color:['#c23531','#2f4554','#61a0a8','#d48265','#91c7ae','#749f83','#ca8622','#bda29a','#6e7074','#546570','#c4ccd3'],gradientColor:['#f6efa6','#d88273','#bf444c'],// If xAxis and yAxis declared, grid is created by default.
// grid: {},
textStyle:{// color: '#000',
// decoration: 'none',
// PENDING
fontFamily:platform.match(/^Win/)?'Microsoft YaHei':'sans-serif',// fontFamily: 'Arial, Verdana, sans-serif',
fontSize:12,fontStyle:'normal',fontWeight:'normal'},// http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
// https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
// Default is source-over
blendMode:null,animation:'auto',animationDuration:1000,animationDurationUpdate:300,animationEasing:'exponentialOut',animationEasingUpdate:'cubicOut',animationThreshold:2000,// Configuration for progressive/incremental rendering
progressiveThreshold:3000,progressive:400,// Threshold of if use single hover layer to optimize.
// It is recommended that `hoverLayerThreshold` is equivalent to or less than
// `progressiveThreshold`, otherwise hover will cause restart of progressive,
// which is unexpected.
// see example <echarts/test/heatmap-large.html>.
hoverLayerThreshold:3000,// See: module:echarts/scale/Time
useUTC:false};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var inner$2=makeInner();function getNearestColorPalette(colors,requestColorNum){var paletteNum=colors.length;// TODO colors must be in order
for(var i=0;i<paletteNum;i++){if(colors[i].length>requestColorNum){return colors[i];}}return colors[paletteNum-1];}var colorPaletteMixin={clearColorPalette:function clearColorPalette(){inner$2(this).colorIdx=0;inner$2(this).colorNameMap={};},/**
   * @param {string} name MUST NOT be null/undefined. Otherwise call this function
   *                 twise with the same parameters will get different result.
   * @param {Object} [scope=this]
   * @param {Object} [requestColorNum]
   * @return {string} color string.
   */getColorFromPalette:function getColorFromPalette(name,scope,requestColorNum){scope=scope||this;var scopeFields=inner$2(scope);var colorIdx=scopeFields.colorIdx||0;var colorNameMap=scopeFields.colorNameMap=scopeFields.colorNameMap||{};// Use `hasOwnProperty` to avoid conflict with Object.prototype.
if(colorNameMap.hasOwnProperty(name)){return colorNameMap[name];}var defaultColorPalette=normalizeToArray(this.get('color',true));var layeredColorPalette=this.get('colorLayer',true);var colorPalette=requestColorNum==null||!layeredColorPalette?defaultColorPalette:getNearestColorPalette(layeredColorPalette,requestColorNum);// In case can't find in layered color palette.
colorPalette=colorPalette||defaultColorPalette;if(!colorPalette||!colorPalette.length){return;}var color=colorPalette[colorIdx];if(name){colorNameMap[name]=color;}scopeFields.colorIdx=(colorIdx+1)%colorPalette.length;return color;}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */// TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".
/**
 * @return {Object} For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // It also indicate that whether there is category axis.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */function getCoordSysDefineBySeries(seriesModel){var coordSysName=seriesModel.get('coordinateSystem');var result={coordSysName:coordSysName,coordSysDims:[],axisMap:createHashMap(),categoryAxisMap:createHashMap()};var fetch=fetchers[coordSysName];if(fetch){fetch(seriesModel,result,result.axisMap,result.categoryAxisMap);return result;}}var fetchers={cartesian2d:function cartesian2d(seriesModel,result,axisMap,categoryAxisMap){var xAxisModel=seriesModel.getReferringComponents('xAxis')[0];var yAxisModel=seriesModel.getReferringComponents('yAxis')[0];result.coordSysDims=['x','y'];axisMap.set('x',xAxisModel);axisMap.set('y',yAxisModel);if(isCategory(xAxisModel)){categoryAxisMap.set('x',xAxisModel);result.firstCategoryDimIndex=0;}if(isCategory(yAxisModel)){categoryAxisMap.set('y',yAxisModel);result.firstCategoryDimIndex=1;}},singleAxis:function singleAxis(seriesModel,result,axisMap,categoryAxisMap){var singleAxisModel=seriesModel.getReferringComponents('singleAxis')[0];result.coordSysDims=['single'];axisMap.set('single',singleAxisModel);if(isCategory(singleAxisModel)){categoryAxisMap.set('single',singleAxisModel);result.firstCategoryDimIndex=0;}},polar:function polar(seriesModel,result,axisMap,categoryAxisMap){var polarModel=seriesModel.getReferringComponents('polar')[0];var radiusAxisModel=polarModel.findAxisModel('radiusAxis');var angleAxisModel=polarModel.findAxisModel('angleAxis');result.coordSysDims=['radius','angle'];axisMap.set('radius',radiusAxisModel);axisMap.set('angle',angleAxisModel);if(isCategory(radiusAxisModel)){categoryAxisMap.set('radius',radiusAxisModel);result.firstCategoryDimIndex=0;}if(isCategory(angleAxisModel)){categoryAxisMap.set('angle',angleAxisModel);result.firstCategoryDimIndex=1;}},geo:function geo(seriesModel,result,axisMap,categoryAxisMap){result.coordSysDims=['lng','lat'];},parallel:function parallel(seriesModel,result,axisMap,categoryAxisMap){var ecModel=seriesModel.ecModel;var parallelModel=ecModel.getComponent('parallel',seriesModel.get('parallelIndex'));var coordSysDims=result.coordSysDims=parallelModel.dimensions.slice();each$1(parallelModel.parallelAxisIndex,function(axisIndex,index){var axisModel=ecModel.getComponent('parallelAxis',axisIndex);var axisDim=coordSysDims[index];axisMap.set(axisDim,axisModel);if(isCategory(axisModel)&&result.firstCategoryDimIndex==null){categoryAxisMap.set(axisDim,axisModel);result.firstCategoryDimIndex=index;}});}};function isCategory(axisModel){return axisModel.get('type')==='category';}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// Avoid typo.
var SOURCE_FORMAT_ORIGINAL='original';var SOURCE_FORMAT_ARRAY_ROWS='arrayRows';var SOURCE_FORMAT_OBJECT_ROWS='objectRows';var SOURCE_FORMAT_KEYED_COLUMNS='keyedColumns';var SOURCE_FORMAT_UNKNOWN='unknown';// ??? CHANGE A NAME
var SOURCE_FORMAT_TYPED_ARRAY='typedArray';var SERIES_LAYOUT_BY_COLUMN='column';var SERIES_LAYOUT_BY_ROW='row';/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * [sourceFormat]
 *
 * + "original":
 * This format is only used in series.data, where
 * itemStyle can be specified in data item.
 *
 * + "arrayRows":
 * [
 *     ['product', 'score', 'amount'],
 *     ['Matcha Latte', 89.3, 95.8],
 *     ['Milk Tea', 92.1, 89.4],
 *     ['Cheese Cocoa', 94.4, 91.2],
 *     ['Walnut Brownie', 85.4, 76.9]
 * ]
 *
 * + "objectRows":
 * [
 *     {product: 'Matcha Latte', score: 89.3, amount: 95.8},
 *     {product: 'Milk Tea', score: 92.1, amount: 89.4},
 *     {product: 'Cheese Cocoa', score: 94.4, amount: 91.2},
 *     {product: 'Walnut Brownie', score: 85.4, amount: 76.9}
 * ]
 *
 * + "keyedColumns":
 * {
 *     'product': ['Matcha Latte', 'Milk Tea', 'Cheese Cocoa', 'Walnut Brownie'],
 *     'count': [823, 235, 1042, 988],
 *     'score': [95.8, 81.4, 91.2, 76.9]
 * }
 *
 * + "typedArray"
 *
 * + "unknown"
 *//**
 * @constructor
 * @param {Object} fields
 * @param {string} fields.sourceFormat
 * @param {Array|Object} fields.fromDataset
 * @param {Array|Object} [fields.data]
 * @param {string} [seriesLayoutBy='column']
 * @param {Array.<Object|string>} [dimensionsDefine]
 * @param {Objet|HashMap} [encodeDefine]
 * @param {number} [startIndex=0]
 * @param {number} [dimensionsDetectCount]
 */function Source(fields){/**
   * @type {boolean}
   */this.fromDataset=fields.fromDataset;/**
   * Not null/undefined.
   * @type {Array|Object}
   */this.data=fields.data||(fields.sourceFormat===SOURCE_FORMAT_KEYED_COLUMNS?{}:[]);/**
   * See also "detectSourceFormat".
   * Not null/undefined.
   * @type {string}
   */this.sourceFormat=fields.sourceFormat||SOURCE_FORMAT_UNKNOWN;/**
   * 'row' or 'column'
   * Not null/undefined.
   * @type {string} seriesLayoutBy
   */this.seriesLayoutBy=fields.seriesLayoutBy||SERIES_LAYOUT_BY_COLUMN;/**
   * dimensions definition in option.
   * can be null/undefined.
   * @type {Array.<Object|string>}
   */this.dimensionsDefine=fields.dimensionsDefine;/**
   * encode definition in option.
   * can be null/undefined.
   * @type {Objet|HashMap}
   */this.encodeDefine=fields.encodeDefine&&createHashMap(fields.encodeDefine);/**
   * Not null/undefined, uint.
   * @type {number}
   */this.startIndex=fields.startIndex||0;/**
   * Can be null/undefined (when unknown), uint.
   * @type {number}
   */this.dimensionsDetectCount=fields.dimensionsDetectCount;}/**
 * Wrap original series data for some compatibility cases.
 */Source.seriesDataToSource=function(data){return new Source({data:data,sourceFormat:isTypedArray(data)?SOURCE_FORMAT_TYPED_ARRAY:SOURCE_FORMAT_ORIGINAL,fromDataset:false});};enableClassCheck(Source);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var inner$3=makeInner();/**
 * @see {module:echarts/data/Source}
 * @param {module:echarts/component/dataset/DatasetModel} datasetModel
 * @return {string} sourceFormat
 */function detectSourceFormat(datasetModel){var data=datasetModel.option.source;var sourceFormat=SOURCE_FORMAT_UNKNOWN;if(isTypedArray(data)){sourceFormat=SOURCE_FORMAT_TYPED_ARRAY;}else if(isArray(data)){// FIXME Whether tolerate null in top level array?
for(var i=0,len=data.length;i<len;i++){var item=data[i];if(item==null){continue;}else if(isArray(item)){sourceFormat=SOURCE_FORMAT_ARRAY_ROWS;break;}else if(isObject$1(item)){sourceFormat=SOURCE_FORMAT_OBJECT_ROWS;break;}}}else if(isObject$1(data)){for(var key in data){if(data.hasOwnProperty(key)&&isArrayLike(data[key])){sourceFormat=SOURCE_FORMAT_KEYED_COLUMNS;break;}}}else if(data!=null){throw new Error('Invalid data');}inner$3(datasetModel).sourceFormat=sourceFormat;}/**
 * [Scenarios]:
 * (1) Provide source data directly:
 *     series: {
 *         encode: {...},
 *         dimensions: [...]
 *         seriesLayoutBy: 'row',
 *         data: [[...]]
 *     }
 * (2) Refer to datasetModel.
 *     series: [{
 *         encode: {...}
 *         // Ignore datasetIndex means `datasetIndex: 0`
 *         // and the dimensions defination in dataset is used
 *     }, {
 *         encode: {...},
 *         seriesLayoutBy: 'column',
 *         datasetIndex: 1
 *     }]
 *
 * Get data from series itself or datset.
 * @return {module:echarts/data/Source} source
 */function _getSource(seriesModel){return inner$3(seriesModel).source;}/**
 * MUST be called before mergeOption of all series.
 * @param {module:echarts/model/Global} ecModel
 */function resetSourceDefaulter(ecModel){// `datasetMap` is used to make default encode.
inner$3(ecModel).datasetMap=createHashMap();}/**
 * [Caution]:
 * MUST be called after series option merged and
 * before "series.getInitailData()" called.
 *
 * [The rule of making default encode]:
 * Category axis (if exists) alway map to the first dimension.
 * Each other axis occupies a subsequent dimension.
 *
 * [Why make default encode]:
 * Simplify the typing of encode in option, avoiding the case like that:
 * series: [{encode: {x: 0, y: 1}}, {encode: {x: 0, y: 2}}, {encode: {x: 0, y: 3}}],
 * where the "y" have to be manually typed as "1, 2, 3, ...".
 *
 * @param {module:echarts/model/Series} seriesModel
 */function prepareSource(seriesModel){var seriesOption=seriesModel.option;var data=seriesOption.data;var sourceFormat=isTypedArray(data)?SOURCE_FORMAT_TYPED_ARRAY:SOURCE_FORMAT_ORIGINAL;var fromDataset=false;var seriesLayoutBy=seriesOption.seriesLayoutBy;var sourceHeader=seriesOption.sourceHeader;var dimensionsDefine=seriesOption.dimensions;var datasetModel=getDatasetModel(seriesModel);if(datasetModel){var datasetOption=datasetModel.option;data=datasetOption.source;sourceFormat=inner$3(datasetModel).sourceFormat;fromDataset=true;// These settings from series has higher priority.
seriesLayoutBy=seriesLayoutBy||datasetOption.seriesLayoutBy;sourceHeader==null&&(sourceHeader=datasetOption.sourceHeader);dimensionsDefine=dimensionsDefine||datasetOption.dimensions;}var completeResult=completeBySourceData(data,sourceFormat,seriesLayoutBy,sourceHeader,dimensionsDefine);// Note: dataset option does not have `encode`.
var encodeDefine=seriesOption.encode;if(!encodeDefine&&datasetModel){encodeDefine=makeDefaultEncode(seriesModel,datasetModel,data,sourceFormat,seriesLayoutBy,completeResult);}inner$3(seriesModel).source=new Source({data:data,fromDataset:fromDataset,seriesLayoutBy:seriesLayoutBy,sourceFormat:sourceFormat,dimensionsDefine:completeResult.dimensionsDefine,startIndex:completeResult.startIndex,dimensionsDetectCount:completeResult.dimensionsDetectCount,encodeDefine:encodeDefine});}// return {startIndex, dimensionsDefine, dimensionsCount}
function completeBySourceData(data,sourceFormat,seriesLayoutBy,sourceHeader,dimensionsDefine){if(!data){return{dimensionsDefine:normalizeDimensionsDefine(dimensionsDefine)};}var dimensionsDetectCount;var startIndex;var findPotentialName;if(sourceFormat===SOURCE_FORMAT_ARRAY_ROWS){// Rule: Most of the first line are string: it is header.
// Caution: consider a line with 5 string and 1 number,
// it still can not be sure it is a head, because the
// 5 string may be 5 values of category columns.
if(sourceHeader==='auto'||sourceHeader==null){arrayRowsTravelFirst(function(val){// '-' is regarded as null/undefined.
if(val!=null&&val!=='-'){if(isString(val)){startIndex==null&&(startIndex=1);}else{startIndex=0;}}// 10 is an experience number, avoid long loop.
},seriesLayoutBy,data,10);}else{startIndex=sourceHeader?1:0;}if(!dimensionsDefine&&startIndex===1){dimensionsDefine=[];arrayRowsTravelFirst(function(val,index){dimensionsDefine[index]=val!=null?val:'';},seriesLayoutBy,data);}dimensionsDetectCount=dimensionsDefine?dimensionsDefine.length:seriesLayoutBy===SERIES_LAYOUT_BY_ROW?data.length:data[0]?data[0].length:null;}else if(sourceFormat===SOURCE_FORMAT_OBJECT_ROWS){if(!dimensionsDefine){dimensionsDefine=objectRowsCollectDimensions(data);findPotentialName=true;}}else if(sourceFormat===SOURCE_FORMAT_KEYED_COLUMNS){if(!dimensionsDefine){dimensionsDefine=[];findPotentialName=true;each$1(data,function(colArr,key){dimensionsDefine.push(key);});}}else if(sourceFormat===SOURCE_FORMAT_ORIGINAL){var value0=getDataItemValue(data[0]);dimensionsDetectCount=isArray(value0)&&value0.length||1;}else if(sourceFormat===SOURCE_FORMAT_TYPED_ARRAY){}var potentialNameDimIndex;if(findPotentialName){each$1(dimensionsDefine,function(dim,idx){if((isObject$1(dim)?dim.name:dim)==='name'){potentialNameDimIndex=idx;}});}return{startIndex:startIndex,dimensionsDefine:normalizeDimensionsDefine(dimensionsDefine),dimensionsDetectCount:dimensionsDetectCount,potentialNameDimIndex:potentialNameDimIndex// TODO: potentialIdDimIdx
};}// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefiend or string.
function normalizeDimensionsDefine(dimensionsDefine){if(!dimensionsDefine){// The meaning of null/undefined is different from empty array.
return;}var nameMap=createHashMap();return map(dimensionsDefine,function(item,index){item=extend({},isObject$1(item)?item:{name:item});// User can set null in dimensions.
// We dont auto specify name, othewise a given name may
// cause it be refered unexpectedly.
if(item.name==null){return item;}// Also consider number form like 2012.
item.name+='';// User may also specify displayName.
// displayName will always exists except user not
// specified or dim name is not specified or detected.
// (A auto generated dim name will not be used as
// displayName).
if(item.displayName==null){item.displayName=item.name;}var exist=nameMap.get(item.name);if(!exist){nameMap.set(item.name,{count:1});}else{item.name+='-'+exist.count++;}return item;});}function arrayRowsTravelFirst(cb,seriesLayoutBy,data,maxLoop){maxLoop==null&&(maxLoop=Infinity);if(seriesLayoutBy===SERIES_LAYOUT_BY_ROW){for(var i=0;i<data.length&&i<maxLoop;i++){cb(data[i]?data[i][0]:null,i);}}else{var value0=data[0]||[];for(var i=0;i<value0.length&&i<maxLoop;i++){cb(value0[i],i);}}}function objectRowsCollectDimensions(data){var firstIndex=0;var obj;while(firstIndex<data.length&&!(obj=data[firstIndex++])){}// jshint ignore: line
if(obj){var dimensions=[];each$1(obj,function(value,key){dimensions.push(key);});return dimensions;}}// ??? TODO merge to completedimensions, where also has
// default encode making logic. And the default rule
// should depends on series? consider 'map'.
function makeDefaultEncode(seriesModel,datasetModel,data,sourceFormat,seriesLayoutBy,completeResult){var coordSysDefine=getCoordSysDefineBySeries(seriesModel);var encode={};// var encodeTooltip = [];
// var encodeLabel = [];
var encodeItemName=[];var encodeSeriesName=[];var seriesType=seriesModel.subType;// ??? TODO refactor: provide by series itself.
// Consider the case: 'map' series is based on geo coordSys,
// 'graph', 'heatmap' can be based on cartesian. But can not
// give default rule simply here.
var nSeriesMap=createHashMap(['pie','map','funnel']);var cSeriesMap=createHashMap(['line','bar','pictorialBar','scatter','effectScatter','candlestick','boxplot']);// Usually in this case series will use the first data
// dimension as the "value" dimension, or other default
// processes respectively.
if(coordSysDefine&&cSeriesMap.get(seriesType)!=null){var ecModel=seriesModel.ecModel;var datasetMap=inner$3(ecModel).datasetMap;var key=datasetModel.uid+'_'+seriesLayoutBy;var datasetRecord=datasetMap.get(key)||datasetMap.set(key,{categoryWayDim:1,valueWayDim:0});// TODO
// Auto detect first time axis and do arrangement.
each$1(coordSysDefine.coordSysDims,function(coordDim){// In value way.
if(coordSysDefine.firstCategoryDimIndex==null){var dataDim=datasetRecord.valueWayDim++;encode[coordDim]=dataDim;// ??? TODO give a better default series name rule?
// especially when encode x y specified.
// consider: when mutiple series share one dimension
// category axis, series name should better use
// the other dimsion name. On the other hand, use
// both dimensions name.
encodeSeriesName.push(dataDim);// encodeTooltip.push(dataDim);
// encodeLabel.push(dataDim);
}// In category way, category axis.
else if(coordSysDefine.categoryAxisMap.get(coordDim)){encode[coordDim]=0;encodeItemName.push(0);}// In category way, non-category axis.
else{var dataDim=datasetRecord.categoryWayDim++;encode[coordDim]=dataDim;// encodeTooltip.push(dataDim);
// encodeLabel.push(dataDim);
encodeSeriesName.push(dataDim);}});}// Do not make a complex rule! Hard to code maintain and not necessary.
// ??? TODO refactor: provide by series itself.
// [{name: ..., value: ...}, ...] like:
else if(nSeriesMap.get(seriesType)!=null){// Find the first not ordinal. (5 is an experience value)
var firstNotOrdinal;for(var i=0;i<5&&firstNotOrdinal==null;i++){if(!doGuessOrdinal(data,sourceFormat,seriesLayoutBy,completeResult.dimensionsDefine,completeResult.startIndex,i)){firstNotOrdinal=i;}}if(firstNotOrdinal!=null){encode.value=firstNotOrdinal;var nameDimIndex=completeResult.potentialNameDimIndex||Math.max(firstNotOrdinal-1,0);// By default, label use itemName in charts.
// So we dont set encodeLabel here.
encodeSeriesName.push(nameDimIndex);encodeItemName.push(nameDimIndex);// encodeTooltip.push(firstNotOrdinal);
}}// encodeTooltip.length && (encode.tooltip = encodeTooltip);
// encodeLabel.length && (encode.label = encodeLabel);
encodeItemName.length&&(encode.itemName=encodeItemName);encodeSeriesName.length&&(encode.seriesName=encodeSeriesName);return encode;}/**
 * If return null/undefined, indicate that should not use datasetModel.
 */function getDatasetModel(seriesModel){var option=seriesModel.option;// Caution: consider the scenario:
// A dataset is declared and a series is not expected to use the dataset,
// and at the beginning `setOption({series: { noData })` (just prepare other
// option but no data), then `setOption({series: {data: [...]}); In this case,
// the user should set an empty array to avoid that dataset is used by default.
var thisData=option.data;if(!thisData){return seriesModel.ecModel.getComponent('dataset',option.datasetIndex||0);}}/**
 * The rule should not be complex, otherwise user might not
 * be able to known where the data is wrong.
 * The code is ugly, but how to make it neat?
 *
 * @param {module:echars/data/Source} source
 * @param {number} dimIndex
 * @return {boolean} Whether ordinal.
 */function guessOrdinal(source,dimIndex){return doGuessOrdinal(source.data,source.sourceFormat,source.seriesLayoutBy,source.dimensionsDefine,source.startIndex,dimIndex);}// dimIndex may be overflow source data.
function doGuessOrdinal(data,sourceFormat,seriesLayoutBy,dimensionsDefine,startIndex,dimIndex){var result;// Experience value.
var maxLoop=5;if(isTypedArray(data)){return false;}// When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
// always exists in source.
var dimName;if(dimensionsDefine){dimName=dimensionsDefine[dimIndex];dimName=isObject$1(dimName)?dimName.name:dimName;}if(sourceFormat===SOURCE_FORMAT_ARRAY_ROWS){if(seriesLayoutBy===SERIES_LAYOUT_BY_ROW){var sample=data[dimIndex];for(var i=0;i<(sample||[]).length&&i<maxLoop;i++){if((result=detectValue(sample[startIndex+i]))!=null){return result;}}}else{for(var i=0;i<data.length&&i<maxLoop;i++){var row=data[startIndex+i];if(row&&(result=detectValue(row[dimIndex]))!=null){return result;}}}}else if(sourceFormat===SOURCE_FORMAT_OBJECT_ROWS){if(!dimName){return;}for(var i=0;i<data.length&&i<maxLoop;i++){var item=data[i];if(item&&(result=detectValue(item[dimName]))!=null){return result;}}}else if(sourceFormat===SOURCE_FORMAT_KEYED_COLUMNS){if(!dimName){return;}var sample=data[dimName];if(!sample||isTypedArray(sample)){return false;}for(var i=0;i<sample.length&&i<maxLoop;i++){if((result=detectValue(sample[i]))!=null){return result;}}}else if(sourceFormat===SOURCE_FORMAT_ORIGINAL){for(var i=0;i<data.length&&i<maxLoop;i++){var item=data[i];var val=getDataItemValue(item);if(!isArray(val)){return false;}if((result=detectValue(val[dimIndex]))!=null){return result;}}}function detectValue(val){// Consider usage convenience, '1', '2' will be treated as "number".
// `isFinit('')` get `true`.
if(val!=null&&isFinite(val)&&val!==''){return false;}else if(isString(val)&&val!=='-'){return true;}}return false;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * ECharts global model
 *
 * @module {echarts/model/Global}
 *//**
 * Caution: If the mechanism should be changed some day, these cases
 * should be considered:
 *
 * (1) In `merge option` mode, if using the same option to call `setOption`
 * many times, the result should be the same (try our best to ensure that).
 * (2) In `merge option` mode, if a component has no id/name specified, it
 * will be merged by index, and the result sequence of the components is
 * consistent to the original sequence.
 * (3) `reset` feature (in toolbox). Find detailed info in comments about
 * `mergeOption` in module:echarts/model/OptionManager.
 */var OPTION_INNER_KEY='\0_ec_inner';/**
 * @alias module:echarts/model/Global
 *
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {Object} theme
 */var GlobalModel=Model.extend({init:function init(option,parentModel,theme,optionManager){theme=theme||{};this.option=null;// Mark as not initialized.
/**
     * @type {module:echarts/model/Model}
     * @private
     */this._theme=new Model(theme);/**
     * @type {module:echarts/model/OptionManager}
     */this._optionManager=optionManager;},setOption:function setOption(option,optionPreprocessorFuncs){assert$1(!(OPTION_INNER_KEY in option),'please use chart.getOption()');this._optionManager.setOption(option,optionPreprocessorFuncs);this.resetOption(null);},/**
   * @param {string} type null/undefined: reset all.
   *                      'recreate': force recreate all.
   *                      'timeline': only reset timeline option
   *                      'media': only reset media query option
   * @return {boolean} Whether option changed.
   */resetOption:function resetOption(type){var optionChanged=false;var optionManager=this._optionManager;if(!type||type==='recreate'){var baseOption=optionManager.mountOption(type==='recreate');if(!this.option||type==='recreate'){initBase.call(this,baseOption);}else{this.restoreData();this.mergeOption(baseOption);}optionChanged=true;}if(type==='timeline'||type==='media'){this.restoreData();}if(!type||type==='recreate'||type==='timeline'){var timelineOption=optionManager.getTimelineOption(this);timelineOption&&(this.mergeOption(timelineOption),optionChanged=true);}if(!type||type==='recreate'||type==='media'){var mediaOptions=optionManager.getMediaOption(this,this._api);if(mediaOptions.length){each$1(mediaOptions,function(mediaOption){this.mergeOption(mediaOption,optionChanged=true);},this);}}return optionChanged;},/**
   * @protected
   */mergeOption:function mergeOption(newOption){var option=this.option;var componentsMap=this._componentsMap;var newCptTypes=[];resetSourceDefaulter(this);// If no component class, merge directly.
// For example: color, animaiton options, etc.
each$1(newOption,function(componentOption,mainType){if(componentOption==null){return;}if(!ComponentModel.hasClass(mainType)){// globalSettingTask.dirty();
option[mainType]=option[mainType]==null?_clone(componentOption):merge(option[mainType],componentOption,true);}else if(mainType){newCptTypes.push(mainType);}});ComponentModel.topologicalTravel(newCptTypes,ComponentModel.getAllClassMainTypes(),visitComponent,this);function visitComponent(mainType,dependencies){var newCptOptionList=normalizeToArray(newOption[mainType]);var mapResult=mappingToExists(componentsMap.get(mainType),newCptOptionList);makeIdAndName(mapResult);// Set mainType and complete subType.
each$1(mapResult,function(item,index){var opt=item.option;if(isObject$1(opt)){item.keyInfo.mainType=mainType;item.keyInfo.subType=determineSubType(mainType,opt,item.exist);}});var dependentModels=getComponentsByTypes(componentsMap,dependencies);option[mainType]=[];componentsMap.set(mainType,[]);each$1(mapResult,function(resultItem,index){var componentModel=resultItem.exist;var newCptOption=resultItem.option;assert$1(isObject$1(newCptOption)||componentModel,'Empty component definition');// Consider where is no new option and should be merged using {},
// see removeEdgeAndAdd in topologicalTravel and
// ComponentModel.getAllClassMainTypes.
if(!newCptOption){componentModel.mergeOption({},this);componentModel.optionUpdated({},false);}else{var ComponentModelClass=ComponentModel.getClass(mainType,resultItem.keyInfo.subType,true);if(componentModel&&componentModel instanceof ComponentModelClass){componentModel.name=resultItem.keyInfo.name;// componentModel.settingTask && componentModel.settingTask.dirty();
componentModel.mergeOption(newCptOption,this);componentModel.optionUpdated(newCptOption,false);}else{// PENDING Global as parent ?
var extraOpt=extend({dependentModels:dependentModels,componentIndex:index},resultItem.keyInfo);componentModel=new ComponentModelClass(newCptOption,this,this,extraOpt);extend(componentModel,extraOpt);componentModel.init(newCptOption,this,this,extraOpt);// Call optionUpdated after init.
// newCptOption has been used as componentModel.option
// and may be merged with theme and default, so pass null
// to avoid confusion.
componentModel.optionUpdated(null,true);}}componentsMap.get(mainType)[index]=componentModel;option[mainType][index]=componentModel.option;},this);// Backup series for filtering.
if(mainType==='series'){createSeriesIndices(this,componentsMap.get('series'));}}this._seriesIndicesMap=createHashMap(this._seriesIndices=this._seriesIndices||[]);},/**
   * Get option for output (cloned option and inner info removed)
   * @public
   * @return {Object}
   */getOption:function getOption(){var option=_clone(this.option);each$1(option,function(opts,mainType){if(ComponentModel.hasClass(mainType)){var opts=normalizeToArray(opts);for(var i=opts.length-1;i>=0;i--){// Remove options with inner id.
if(isIdInner(opts[i])){opts.splice(i,1);}}option[mainType]=opts;}});delete option[OPTION_INNER_KEY];return option;},/**
   * @return {module:echarts/model/Model}
   */getTheme:function getTheme(){return this._theme;},/**
   * @param {string} mainType
   * @param {number} [idx=0]
   * @return {module:echarts/model/Component}
   */getComponent:function getComponent(mainType,idx){var list=this._componentsMap.get(mainType);if(list){return list[idx||0];}},/**
   * If none of index and id and name used, return all components with mainType.
   * @param {Object} condition
   * @param {string} condition.mainType
   * @param {string} [condition.subType] If ignore, only query by mainType
   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
   * @return {Array.<module:echarts/model/Component>}
   */queryComponents:function queryComponents(condition){var mainType=condition.mainType;if(!mainType){return[];}var index=condition.index;var id=condition.id;var name=condition.name;var cpts=this._componentsMap.get(mainType);if(!cpts||!cpts.length){return[];}var result;if(index!=null){if(!isArray(index)){index=[index];}result=filter(map(index,function(idx){return cpts[idx];}),function(val){return!!val;});}else if(id!=null){var isIdArray=isArray(id);result=filter(cpts,function(cpt){return isIdArray&&indexOf(id,cpt.id)>=0||!isIdArray&&cpt.id===id;});}else if(name!=null){var isNameArray=isArray(name);result=filter(cpts,function(cpt){return isNameArray&&indexOf(name,cpt.name)>=0||!isNameArray&&cpt.name===name;});}else{// Return all components with mainType
result=cpts.slice();}return filterBySubType(result,condition);},/**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * var result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series'},
   *     function (model, index) {...}
   * );
   * // result like [component0, componnet1, ...]
   *
   * @param {Object} condition
   * @param {string} condition.mainType Mandatory.
   * @param {string} [condition.subType] Optional.
   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
   *        where xxx is mainType.
   *        If query attribute is null/undefined or has no index/id/name,
   *        do not filtering by query conditions, which is convenient for
   *        no-payload situations or when target of action is global.
   * @param {Function} [condition.filter] parameter: component, return boolean.
   * @return {Array.<module:echarts/model/Component>}
   */findComponents:function findComponents(condition){var query=condition.query;var mainType=condition.mainType;var queryCond=getQueryCond(query);var result=queryCond?this.queryComponents(queryCond):this._componentsMap.get(mainType);return doFilter(filterBySubType(result,condition));function getQueryCond(q){var indexAttr=mainType+'Index';var idAttr=mainType+'Id';var nameAttr=mainType+'Name';return q&&(q[indexAttr]!=null||q[idAttr]!=null||q[nameAttr]!=null)?{mainType:mainType,// subType will be filtered finally.
index:q[indexAttr],id:q[idAttr],name:q[nameAttr]}:null;}function doFilter(res){return condition.filter?filter(res,condition.filter):res;}},/**
   * @usage
   * eachComponent('legend', function (legendModel, index) {
   *     ...
   * });
   * eachComponent(function (componentType, model, index) {
   *     // componentType does not include subType
   *     // (componentType is 'xxx' but not 'xxx.aa')
   * });
   * eachComponent(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
   *     function (model, index) {...}
   * );
   * eachComponent(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
   *     function (model, index) {...}
   * );
   *
   * @param {string|Object=} mainType When mainType is object, the definition
   *                                  is the same as the method 'findComponents'.
   * @param {Function} cb
   * @param {*} context
   */eachComponent:function eachComponent(mainType,cb,context){var componentsMap=this._componentsMap;if(typeof mainType==='function'){context=cb;cb=mainType;componentsMap.each(function(components,componentType){each$1(components,function(component,index){cb.call(context,componentType,component,index);});});}else if(isString(mainType)){each$1(componentsMap.get(mainType),cb,context);}else if(isObject$1(mainType)){var queryResult=this.findComponents(mainType);each$1(queryResult,cb,context);}},/**
   * @param {string} name
   * @return {Array.<module:echarts/model/Series>}
   */getSeriesByName:function getSeriesByName(name){var series=this._componentsMap.get('series');return filter(series,function(oneSeries){return oneSeries.name===name;});},/**
   * @param {number} seriesIndex
   * @return {module:echarts/model/Series}
   */getSeriesByIndex:function getSeriesByIndex(seriesIndex){return this._componentsMap.get('series')[seriesIndex];},/**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   *
   * @param {string} subType
   * @return {Array.<module:echarts/model/Series>}
   */getSeriesByType:function getSeriesByType(subType){var series=this._componentsMap.get('series');return filter(series,function(oneSeries){return oneSeries.subType===subType;});},/**
   * @return {Array.<module:echarts/model/Series>}
   */getSeries:function getSeries(){return this._componentsMap.get('series').slice();},/**
   * @return {number}
   */getSeriesCount:function getSeriesCount(){return this._componentsMap.get('series').length;},/**
   * After filtering, series may be different
   * frome raw series.
   *
   * @param {Function} cb
   * @param {*} context
   */eachSeries:function eachSeries(cb,context){each$1(this._seriesIndices,function(rawSeriesIndex){var series=this._componentsMap.get('series')[rawSeriesIndex];cb.call(context,series,rawSeriesIndex);},this);},/**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */eachRawSeries:function eachRawSeries(cb,context){each$1(this._componentsMap.get('series'),cb,context);},/**
   * After filtering, series may be different.
   * frome raw series.
   *
   * @parma {string} subType
   * @param {Function} cb
   * @param {*} context
   */eachSeriesByType:function eachSeriesByType(subType,cb,context){each$1(this._seriesIndices,function(rawSeriesIndex){var series=this._componentsMap.get('series')[rawSeriesIndex];if(series.subType===subType){cb.call(context,series,rawSeriesIndex);}},this);},/**
   * Iterate raw series before filtered of given type.
   *
   * @parma {string} subType
   * @param {Function} cb
   * @param {*} context
   */eachRawSeriesByType:function eachRawSeriesByType(subType,cb,context){return each$1(this.getSeriesByType(subType),cb,context);},/**
   * @param {module:echarts/model/Series} seriesModel
   */isSeriesFiltered:function isSeriesFiltered(seriesModel){return this._seriesIndicesMap.get(seriesModel.componentIndex)==null;},/**
   * @return {Array.<number>}
   */getCurrentSeriesIndices:function getCurrentSeriesIndices(){return(this._seriesIndices||[]).slice();},/**
   * @param {Function} cb
   * @param {*} context
   */filterSeries:function filterSeries(cb,context){var filteredSeries=filter(this._componentsMap.get('series'),cb,context);createSeriesIndices(this,filteredSeries);},restoreData:function restoreData(payload){var componentsMap=this._componentsMap;createSeriesIndices(this,componentsMap.get('series'));var componentTypes=[];componentsMap.each(function(components,componentType){componentTypes.push(componentType);});ComponentModel.topologicalTravel(componentTypes,ComponentModel.getAllClassMainTypes(),function(componentType,dependencies){each$1(componentsMap.get(componentType),function(component){(componentType!=='series'||!isNotTargetSeries(component,payload))&&component.restoreData();});});}});function isNotTargetSeries(seriesModel,payload){if(payload){var index=payload.seiresIndex;var id=payload.seriesId;var name=payload.seriesName;return index!=null&&seriesModel.componentIndex!==index||id!=null&&seriesModel.id!==id||name!=null&&seriesModel.name!==name;}}/**
 * @inner
 */function mergeTheme(option,theme){// PENDING
// NOT use `colorLayer` in theme if option has `color`
var notMergeColorLayer=option.color&&!option.colorLayer;each$1(theme,function(themeItem,name){if(name==='colorLayer'&&notMergeColorLayer){return;}// 如果有 component model 则把具体的 merge 逻辑交给该 model 处理
if(!ComponentModel.hasClass(name)){if((typeof themeItem==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(themeItem))==='object'){option[name]=!option[name]?_clone(themeItem):merge(option[name],themeItem,false);}else{if(option[name]==null){option[name]=themeItem;}}}});}function initBase(baseOption){baseOption=baseOption;// Using OPTION_INNER_KEY to mark that this option can not be used outside,
// i.e. `chart.setOption(chart.getModel().option);` is forbiden.
this.option={};this.option[OPTION_INNER_KEY]=1;/**
   * Init with series: [], in case of calling findSeries method
   * before series initialized.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @private
   */this._componentsMap=createHashMap({series:[]});/**
   * Mapping between filtered series list and raw series list.
   * key: filtered series indices, value: raw series indices.
   * @type {Array.<nubmer>}
   * @private
   */this._seriesIndices;this._seriesIndicesMap;mergeTheme(baseOption,this._theme.option);// TODO Needs clone when merging to the unexisted property
merge(baseOption,globalDefault,false);this.mergeOption(baseOption);}/**
 * @inner
 * @param {Array.<string>|string} types model types
 * @return {Object} key: {string} type, value: {Array.<Object>} models
 */function getComponentsByTypes(componentsMap,types){if(!isArray(types)){types=types?[types]:[];}var ret={};each$1(types,function(type){ret[type]=(componentsMap.get(type)||[]).slice();});return ret;}/**
 * @inner
 */function determineSubType(mainType,newCptOption,existComponent){var subType=newCptOption.type?newCptOption.type:existComponent?existComponent.subType// Use determineSubType only when there is no existComponent.
:ComponentModel.determineSubType(mainType,newCptOption);// tooltip, markline, markpoint may always has no subType
return subType;}/**
 * @inner
 */function createSeriesIndices(ecModel,seriesModels){ecModel._seriesIndicesMap=createHashMap(ecModel._seriesIndices=map(seriesModels,function(series){return series.componentIndex;})||[]);}/**
 * @inner
 */function filterBySubType(components,condition){// Using hasOwnProperty for restrict. Consider
// subType is undefined in user payload.
return condition.hasOwnProperty('subType')?filter(components,function(cpt){return cpt.subType===condition.subType;}):components;}mixin(GlobalModel,colorPaletteMixin);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var echartsAPIList=['getDom','getZr','getWidth','getHeight','getDevicePixelRatio','dispatchAction','isDisposed','on','off','getDataURL','getConnectedDataURL','getModel','getOption','getViewOfComponentModel','getViewOfSeriesModel'];// And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js
function ExtensionAPI(chartInstance){each$1(echartsAPIList,function(name){this[name]=bind(chartInstance[name],chartInstance);},this);}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var coordinateSystemCreators={};function CoordinateSystemManager(){this._coordinateSystems=[];}CoordinateSystemManager.prototype={constructor:CoordinateSystemManager,create:function create(ecModel,api){var coordinateSystems=[];each$1(coordinateSystemCreators,function(creater,type){var list=creater.create(ecModel,api);coordinateSystems=coordinateSystems.concat(list||[]);});this._coordinateSystems=coordinateSystems;},update:function update(ecModel,api){each$1(this._coordinateSystems,function(coordSys){coordSys.update&&coordSys.update(ecModel,api);});},getCoordinateSystems:function getCoordinateSystems(){return this._coordinateSystems.slice();}};CoordinateSystemManager.register=function(type,coordinateSystemCreator){coordinateSystemCreators[type]=coordinateSystemCreator;};CoordinateSystemManager.get=function(type){return coordinateSystemCreators[type];};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * ECharts option manager
 *
 * @module {echarts/model/OptionManager}
 */var each$4=each$1;var clone$3=_clone;var map$1=map;var merge$1=merge;var QUERY_REG=/^(min|max)?(.+)$/;/**
 * TERM EXPLANATIONS:
 *
 * [option]:
 *
 *     An object that contains definitions of components. For example:
 *     var option = {
 *         title: {...},
 *         legend: {...},
 *         visualMap: {...},
 *         series: [
 *             {data: [...]},
 *             {data: [...]},
 *             ...
 *         ]
 *     };
 *
 * [rawOption]:
 *
 *     An object input to echarts.setOption. 'rawOption' may be an
 *     'option', or may be an object contains multi-options. For example:
 *     var option = {
 *         baseOption: {
 *             title: {...},
 *             legend: {...},
 *             series: [
 *                 {data: [...]},
 *                 {data: [...]},
 *                 ...
 *             ]
 *         },
 *         timeline: {...},
 *         options: [
 *             {title: {...}, series: {data: [...]}},
 *             {title: {...}, series: {data: [...]}},
 *             ...
 *         ],
 *         media: [
 *             {
 *                 query: {maxWidth: 320},
 *                 option: {series: {x: 20}, visualMap: {show: false}}
 *             },
 *             {
 *                 query: {minWidth: 320, maxWidth: 720},
 *                 option: {series: {x: 500}, visualMap: {show: true}}
 *             },
 *             {
 *                 option: {series: {x: 1200}, visualMap: {show: true}}
 *             }
 *         ]
 *     };
 *
 * @alias module:echarts/model/OptionManager
 * @param {module:echarts/ExtensionAPI} api
 */function OptionManager(api){/**
   * @private
   * @type {module:echarts/ExtensionAPI}
   */this._api=api;/**
   * @private
   * @type {Array.<number>}
   */this._timelineOptions=[];/**
   * @private
   * @type {Array.<Object>}
   */this._mediaList=[];/**
   * @private
   * @type {Object}
   */this._mediaDefault;/**
   * -1, means default.
   * empty means no media.
   * @private
   * @type {Array.<number>}
   */this._currentMediaIndices=[];/**
   * @private
   * @type {Object}
   */this._optionBackup;/**
   * @private
   * @type {Object}
   */this._newBaseOption;}// timeline.notMerge is not supported in ec3. Firstly there is rearly
// case that notMerge is needed. Secondly supporting 'notMerge' requires
// rawOption cloned and backuped when timeline changed, which does no
// good to performance. What's more, that both timeline and setOption
// method supply 'notMerge' brings complex and some problems.
// Consider this case:
// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
OptionManager.prototype={constructor:OptionManager,/**
   * @public
   * @param {Object} rawOption Raw option.
   * @param {module:echarts/model/Global} ecModel
   * @param {Array.<Function>} optionPreprocessorFuncs
   * @return {Object} Init option
   */setOption:function setOption(rawOption,optionPreprocessorFuncs){if(rawOption){// That set dat primitive is dangerous if user reuse the data when setOption again.
each$1(normalizeToArray(rawOption.series),function(series){series&&series.data&&isTypedArray(series.data)&&setAsPrimitive(series.data);});}// Caution: some series modify option data, if do not clone,
// it should ensure that the repeat modify correctly
// (create a new object when modify itself).
rawOption=clone$3(rawOption,true);// FIXME
// 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。
var oldOptionBackup=this._optionBackup;var newParsedOption=parseRawOption.call(this,rawOption,optionPreprocessorFuncs,!oldOptionBackup);this._newBaseOption=newParsedOption.baseOption;// For setOption at second time (using merge mode);
if(oldOptionBackup){// Only baseOption can be merged.
mergeOption(oldOptionBackup.baseOption,newParsedOption.baseOption);// For simplicity, timeline options and media options do not support merge,
// that is, if you `setOption` twice and both has timeline options, the latter
// timeline opitons will not be merged to the formers, but just substitude them.
if(newParsedOption.timelineOptions.length){oldOptionBackup.timelineOptions=newParsedOption.timelineOptions;}if(newParsedOption.mediaList.length){oldOptionBackup.mediaList=newParsedOption.mediaList;}if(newParsedOption.mediaDefault){oldOptionBackup.mediaDefault=newParsedOption.mediaDefault;}}else{this._optionBackup=newParsedOption;}},/**
   * @param {boolean} isRecreate
   * @return {Object}
   */mountOption:function mountOption(isRecreate){var optionBackup=this._optionBackup;// TODO
// 如果没有reset功能则不clone。
this._timelineOptions=map$1(optionBackup.timelineOptions,clone$3);this._mediaList=map$1(optionBackup.mediaList,clone$3);this._mediaDefault=clone$3(optionBackup.mediaDefault);this._currentMediaIndices=[];return clone$3(isRecreate// this._optionBackup.baseOption, which is created at the first `setOption`
// called, and is merged into every new option by inner method `mergeOption`
// each time `setOption` called, can be only used in `isRecreate`, because
// its reliability is under suspicion. In other cases option merge is
// performed by `model.mergeOption`.
?optionBackup.baseOption:this._newBaseOption);},/**
   * @param {module:echarts/model/Global} ecModel
   * @return {Object}
   */getTimelineOption:function getTimelineOption(ecModel){var option;var timelineOptions=this._timelineOptions;if(timelineOptions.length){// getTimelineOption can only be called after ecModel inited,
// so we can get currentIndex from timelineModel.
var timelineModel=ecModel.getComponent('timeline');if(timelineModel){option=clone$3(timelineOptions[timelineModel.getCurrentIndex()],true);}}return option;},/**
   * @param {module:echarts/model/Global} ecModel
   * @return {Array.<Object>}
   */getMediaOption:function getMediaOption(ecModel){var ecWidth=this._api.getWidth();var ecHeight=this._api.getHeight();var mediaList=this._mediaList;var mediaDefault=this._mediaDefault;var indices=[];var result=[];// No media defined.
if(!mediaList.length&&!mediaDefault){return result;}// Multi media may be applied, the latter defined media has higher priority.
for(var i=0,len=mediaList.length;i<len;i++){if(applyMediaQuery(mediaList[i].query,ecWidth,ecHeight)){indices.push(i);}}// FIXME
// 是否mediaDefault应该强制用户设置，否则可能修改不能回归。
if(!indices.length&&mediaDefault){indices=[-1];}if(indices.length&&!indicesEquals(indices,this._currentMediaIndices)){result=map$1(indices,function(index){return clone$3(index===-1?mediaDefault.option:mediaList[index].option);});}// Otherwise return nothing.
this._currentMediaIndices=indices;return result;}};function parseRawOption(rawOption,optionPreprocessorFuncs,isNew){var timelineOptions=[];var mediaList=[];var mediaDefault;var baseOption;// Compatible with ec2.
var timelineOpt=rawOption.timeline;if(rawOption.baseOption){baseOption=rawOption.baseOption;}// For timeline
if(timelineOpt||rawOption.options){baseOption=baseOption||{};timelineOptions=(rawOption.options||[]).slice();}// For media query
if(rawOption.media){baseOption=baseOption||{};var media=rawOption.media;each$4(media,function(singleMedia){if(singleMedia&&singleMedia.option){if(singleMedia.query){mediaList.push(singleMedia);}else if(!mediaDefault){// Use the first media default.
mediaDefault=singleMedia;}}});}// For normal option
if(!baseOption){baseOption=rawOption;}// Set timelineOpt to baseOption in ec3,
// which is convenient for merge option.
if(!baseOption.timeline){baseOption.timeline=timelineOpt;}// Preprocess.
each$4([baseOption].concat(timelineOptions).concat(map(mediaList,function(media){return media.option;})),function(option){each$4(optionPreprocessorFuncs,function(preProcess){preProcess(option,isNew);});});return{baseOption:baseOption,timelineOptions:timelineOptions,mediaDefault:mediaDefault,mediaList:mediaList};}/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */function applyMediaQuery(query,ecWidth,ecHeight){var realMap={width:ecWidth,height:ecHeight,aspectratio:ecWidth/ecHeight// lowser case for convenientce.
};var applicatable=true;each$1(query,function(value,attr){var matched=attr.match(QUERY_REG);if(!matched||!matched[1]||!matched[2]){return;}var operator=matched[1];var realAttr=matched[2].toLowerCase();if(!compare(realMap[realAttr],value,operator)){applicatable=false;}});return applicatable;}function compare(real,expect,operator){if(operator==='min'){return real>=expect;}else if(operator==='max'){return real<=expect;}else{// Equals
return real===expect;}}function indicesEquals(indices1,indices2){// indices is always order by asc and has only finite number.
return indices1.join(',')===indices2.join(',');}/**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 */function mergeOption(oldOption,newOption){newOption=newOption||{};each$4(newOption,function(newCptOpt,mainType){if(newCptOpt==null){return;}var oldCptOpt=oldOption[mainType];if(!ComponentModel.hasClass(mainType)){oldOption[mainType]=merge$1(oldCptOpt,newCptOpt,true);}else{newCptOpt=normalizeToArray(newCptOpt);oldCptOpt=normalizeToArray(oldCptOpt);var mapResult=mappingToExists(oldCptOpt,newCptOpt);oldOption[mainType]=map$1(mapResult,function(item){return item.option&&item.exist?merge$1(item.exist,item.option,true):item.exist||item.option;});}});}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var each$5=each$1;var isObject$3=isObject$1;var POSSIBLE_STYLES=['areaStyle','lineStyle','nodeStyle','linkStyle','chordStyle','label','labelLine'];function compatEC2ItemStyle(opt){var itemStyleOpt=opt&&opt.itemStyle;if(!itemStyleOpt){return;}for(var i=0,len=POSSIBLE_STYLES.length;i<len;i++){var styleName=POSSIBLE_STYLES[i];var normalItemStyleOpt=itemStyleOpt.normal;var emphasisItemStyleOpt=itemStyleOpt.emphasis;if(normalItemStyleOpt&&normalItemStyleOpt[styleName]){opt[styleName]=opt[styleName]||{};if(!opt[styleName].normal){opt[styleName].normal=normalItemStyleOpt[styleName];}else{merge(opt[styleName].normal,normalItemStyleOpt[styleName]);}normalItemStyleOpt[styleName]=null;}if(emphasisItemStyleOpt&&emphasisItemStyleOpt[styleName]){opt[styleName]=opt[styleName]||{};if(!opt[styleName].emphasis){opt[styleName].emphasis=emphasisItemStyleOpt[styleName];}else{merge(opt[styleName].emphasis,emphasisItemStyleOpt[styleName]);}emphasisItemStyleOpt[styleName]=null;}}}function convertNormalEmphasis(opt,optType,useExtend){if(opt&&opt[optType]&&(opt[optType].normal||opt[optType].emphasis)){var normalOpt=opt[optType].normal;var emphasisOpt=opt[optType].emphasis;if(normalOpt){// Timeline controlStyle has other properties besides normal and emphasis
if(useExtend){opt[optType].normal=opt[optType].emphasis=null;defaults(opt[optType],normalOpt);}else{opt[optType]=normalOpt;}}if(emphasisOpt){opt.emphasis=opt.emphasis||{};opt.emphasis[optType]=emphasisOpt;}}}function removeEC3NormalStatus(opt){convertNormalEmphasis(opt,'itemStyle');convertNormalEmphasis(opt,'lineStyle');convertNormalEmphasis(opt,'areaStyle');convertNormalEmphasis(opt,'label');convertNormalEmphasis(opt,'labelLine');// treemap
convertNormalEmphasis(opt,'upperLabel');// graph
convertNormalEmphasis(opt,'edgeLabel');}function compatTextStyle(opt,propName){// Check whether is not object (string\null\undefined ...)
var labelOptSingle=isObject$3(opt)&&opt[propName];var textStyle=isObject$3(labelOptSingle)&&labelOptSingle.textStyle;if(textStyle){for(var i=0,len=TEXT_STYLE_OPTIONS.length;i<len;i++){var propName=TEXT_STYLE_OPTIONS[i];if(textStyle.hasOwnProperty(propName)){labelOptSingle[propName]=textStyle[propName];}}}}function compatEC3CommonStyles(opt){if(opt){removeEC3NormalStatus(opt);compatTextStyle(opt,'label');opt.emphasis&&compatTextStyle(opt.emphasis,'label');}}function processSeries(seriesOpt){if(!isObject$3(seriesOpt)){return;}compatEC2ItemStyle(seriesOpt);removeEC3NormalStatus(seriesOpt);compatTextStyle(seriesOpt,'label');// treemap
compatTextStyle(seriesOpt,'upperLabel');// graph
compatTextStyle(seriesOpt,'edgeLabel');if(seriesOpt.emphasis){compatTextStyle(seriesOpt.emphasis,'label');// treemap
compatTextStyle(seriesOpt.emphasis,'upperLabel');// graph
compatTextStyle(seriesOpt.emphasis,'edgeLabel');}var markPoint=seriesOpt.markPoint;if(markPoint){compatEC2ItemStyle(markPoint);compatEC3CommonStyles(markPoint);}var markLine=seriesOpt.markLine;if(markLine){compatEC2ItemStyle(markLine);compatEC3CommonStyles(markLine);}var markArea=seriesOpt.markArea;if(markArea){compatEC3CommonStyles(markArea);}var data=seriesOpt.data;// Break with ec3: if `setOption` again, there may be no `type` in option,
// then the backward compat based on option type will not be performed.
if(seriesOpt.type==='graph'){data=data||seriesOpt.nodes;var edgeData=seriesOpt.links||seriesOpt.edges;if(edgeData&&!isTypedArray(edgeData)){for(var i=0;i<edgeData.length;i++){compatEC3CommonStyles(edgeData[i]);}}each$1(seriesOpt.categories,function(opt){removeEC3NormalStatus(opt);});}if(data&&!isTypedArray(data)){for(var i=0;i<data.length;i++){compatEC3CommonStyles(data[i]);}}// mark point data
var markPoint=seriesOpt.markPoint;if(markPoint&&markPoint.data){var mpData=markPoint.data;for(var i=0;i<mpData.length;i++){compatEC3CommonStyles(mpData[i]);}}// mark line data
var markLine=seriesOpt.markLine;if(markLine&&markLine.data){var mlData=markLine.data;for(var i=0;i<mlData.length;i++){if(isArray(mlData[i])){compatEC3CommonStyles(mlData[i][0]);compatEC3CommonStyles(mlData[i][1]);}else{compatEC3CommonStyles(mlData[i]);}}}// Series
if(seriesOpt.type==='gauge'){compatTextStyle(seriesOpt,'axisLabel');compatTextStyle(seriesOpt,'title');compatTextStyle(seriesOpt,'detail');}else if(seriesOpt.type==='treemap'){convertNormalEmphasis(seriesOpt.breadcrumb,'itemStyle');each$1(seriesOpt.levels,function(opt){removeEC3NormalStatus(opt);});}else if(seriesOpt.type==='tree'){removeEC3NormalStatus(seriesOpt.leaves);}// sunburst starts from ec4, so it does not need to compat levels.
}function toArr(o){return isArray(o)?o:o?[o]:[];}function toObj(o){return(isArray(o)?o[0]:o)||{};}var compatStyle=function compatStyle(option,isTheme){each$5(toArr(option.series),function(seriesOpt){isObject$3(seriesOpt)&&processSeries(seriesOpt);});var axes=['xAxis','yAxis','radiusAxis','angleAxis','singleAxis','parallelAxis','radar'];isTheme&&axes.push('valueAxis','categoryAxis','logAxis','timeAxis');each$5(axes,function(axisName){each$5(toArr(option[axisName]),function(axisOpt){if(axisOpt){compatTextStyle(axisOpt,'axisLabel');compatTextStyle(axisOpt.axisPointer,'label');}});});each$5(toArr(option.parallel),function(parallelOpt){var parallelAxisDefault=parallelOpt&&parallelOpt.parallelAxisDefault;compatTextStyle(parallelAxisDefault,'axisLabel');compatTextStyle(parallelAxisDefault&&parallelAxisDefault.axisPointer,'label');});each$5(toArr(option.calendar),function(calendarOpt){convertNormalEmphasis(calendarOpt,'itemStyle');compatTextStyle(calendarOpt,'dayLabel');compatTextStyle(calendarOpt,'monthLabel');compatTextStyle(calendarOpt,'yearLabel');});// radar.name.textStyle
each$5(toArr(option.radar),function(radarOpt){compatTextStyle(radarOpt,'name');});each$5(toArr(option.geo),function(geoOpt){if(isObject$3(geoOpt)){compatEC3CommonStyles(geoOpt);each$5(toArr(geoOpt.regions),function(regionObj){compatEC3CommonStyles(regionObj);});}});each$5(toArr(option.timeline),function(timelineOpt){compatEC3CommonStyles(timelineOpt);convertNormalEmphasis(timelineOpt,'label');convertNormalEmphasis(timelineOpt,'itemStyle');convertNormalEmphasis(timelineOpt,'controlStyle',true);var data=timelineOpt.data;isArray(data)&&each$1(data,function(item){if(isObject$1(item)){convertNormalEmphasis(item,'label');convertNormalEmphasis(item,'itemStyle');}});});each$5(toArr(option.toolbox),function(toolboxOpt){convertNormalEmphasis(toolboxOpt,'iconStyle');each$5(toolboxOpt.feature,function(featureOpt){convertNormalEmphasis(featureOpt,'iconStyle');});});compatTextStyle(toObj(option.axisPointer),'label');compatTextStyle(toObj(option.tooltip).axisPointer,'label');};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// Compatitable with 2.0
function get(opt,path){path=path.split(',');var obj=opt;for(var i=0;i<path.length;i++){obj=obj&&obj[path[i]];if(obj==null){break;}}return obj;}function set$1(opt,path,val,overwrite){path=path.split(',');var obj=opt;var key;for(var i=0;i<path.length-1;i++){key=path[i];if(obj[key]==null){obj[key]={};}obj=obj[key];}if(overwrite||obj[path[i]]==null){obj[path[i]]=val;}}function compatLayoutProperties(option){each$1(LAYOUT_PROPERTIES,function(prop){if(prop[0]in option&&!(prop[1]in option)){option[prop[1]]=option[prop[0]];}});}var LAYOUT_PROPERTIES=[['x','left'],['y','top'],['x2','right'],['y2','bottom']];var COMPATITABLE_COMPONENTS=['grid','geo','parallel','legend','toolbox','title','visualMap','dataZoom','timeline'];var backwardCompat=function backwardCompat(option,isTheme){compatStyle(option,isTheme);// Make sure series array for model initialization.
option.series=normalizeToArray(option.series);each$1(option.series,function(seriesOpt){if(!isObject$1(seriesOpt)){return;}var seriesType=seriesOpt.type;if(seriesType==='pie'||seriesType==='gauge'){if(seriesOpt.clockWise!=null){seriesOpt.clockwise=seriesOpt.clockWise;}}if(seriesType==='gauge'){var pointerColor=get(seriesOpt,'pointer.color');pointerColor!=null&&set$1(seriesOpt,'itemStyle.normal.color',pointerColor);}compatLayoutProperties(seriesOpt);});// dataRange has changed to visualMap
if(option.dataRange){option.visualMap=option.dataRange;}each$1(COMPATITABLE_COMPONENTS,function(componentName){var options=option[componentName];if(options){if(!isArray(options)){options=[options];}each$1(options,function(option){compatLayoutProperties(option);});}});};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*///     data processing stage is blocked in stream.
//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
// (2) Only register once when import repeatly.
//     Should be executed before after series filtered and before stack calculation.
var dataStack=function dataStack(ecModel){var stackInfoMap=createHashMap();ecModel.eachSeries(function(seriesModel){var stack=seriesModel.get('stack');// Compatibal: when `stack` is set as '', do not stack.
if(stack){var stackInfoList=stackInfoMap.get(stack)||stackInfoMap.set(stack,[]);var data=seriesModel.getData();var stackInfo={// Used for calculate axis extent automatically.
stackResultDimension:data.getCalculationInfo('stackResultDimension'),stackedOverDimension:data.getCalculationInfo('stackedOverDimension'),stackedDimension:data.getCalculationInfo('stackedDimension'),stackedByDimension:data.getCalculationInfo('stackedByDimension'),isStackedByIndex:data.getCalculationInfo('isStackedByIndex'),data:data,seriesModel:seriesModel};// If stacked on axis that do not support data stack.
if(!stackInfo.stackedDimension||!(stackInfo.isStackedByIndex||stackInfo.stackedByDimension)){return;}stackInfoList.length&&data.setCalculationInfo('stackedOnSeries',stackInfoList[stackInfoList.length-1].seriesModel);stackInfoList.push(stackInfo);}});stackInfoMap.each(calculateStack);};function calculateStack(stackInfoList){each$1(stackInfoList,function(targetStackInfo,idxInStack){var resultVal=[];var resultNaN=[NaN,NaN];var dims=[targetStackInfo.stackResultDimension,targetStackInfo.stackedOverDimension];var targetData=targetStackInfo.data;var isStackedByIndex=targetStackInfo.isStackedByIndex;// Should not write on raw data, because stack series model list changes
// depending on legend selection.
var newData=targetData.map(dims,function(v0,v1,dataIndex){var sum=targetData.get(targetStackInfo.stackedDimension,dataIndex);// Consider `connectNulls` of line area, if value is NaN, stackedOver
// should also be NaN, to draw a appropriate belt area.
if(isNaN(sum)){return resultNaN;}var byValue;var stackedDataRawIndex;if(isStackedByIndex){stackedDataRawIndex=targetData.getRawIndex(dataIndex);}else{byValue=targetData.get(targetStackInfo.stackedByDimension,dataIndex);}// If stackOver is NaN, chart view will render point on value start.
var stackedOver=NaN;for(var j=idxInStack-1;j>=0;j--){var stackInfo=stackInfoList[j];// Has been optimized by inverted indices on `stackedByDimension`.
if(!isStackedByIndex){stackedDataRawIndex=stackInfo.data.rawIndexOf(stackInfo.stackedByDimension,byValue);}if(stackedDataRawIndex>=0){var val=stackInfo.data.getByRawIndex(stackInfo.stackResultDimension,stackedDataRawIndex);// Considering positive stack, negative stack and empty data
if(sum>=0&&val>0||// Positive stack
sum<=0&&val<0// Negative stack
){sum+=val;stackedOver=val;break;}}}resultVal[0]=sum;resultVal[1]=stackedOver;return resultVal;});targetData.hostModel.setData(newData);// Update for consequent calculation
targetStackInfo.data=newData;});}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// TODO
// ??? refactor? check the outer usage of data provider.
// merge with defaultDimValueGetter?
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */function DefaultDataProvider(source,dimSize){if(!Source.isInstance(source)){source=Source.seriesDataToSource(source);}this._source=source;var data=this._data=source.data;var sourceFormat=source.sourceFormat;// Typed array. TODO IE10+?
if(sourceFormat===SOURCE_FORMAT_TYPED_ARRAY){this._offset=0;this._dimSize=dimSize;this._data=data;}var methods=providerMethods[sourceFormat===SOURCE_FORMAT_ARRAY_ROWS?sourceFormat+'_'+source.seriesLayoutBy:sourceFormat];extend(this,methods);}var providerProto=DefaultDataProvider.prototype;// If data is pure without style configuration
providerProto.pure=false;// If data is persistent and will not be released after use.
providerProto.persistent=true;// ???! FIXME legacy data provider do not has method getSource
providerProto.getSource=function(){return this._source;};var providerMethods={'arrayRows_column':{pure:true,count:function count(){return Math.max(0,this._data.length-this._source.startIndex);},getItem:function getItem(idx){return this._data[idx+this._source.startIndex];},appendData:appendDataSimply},'arrayRows_row':{pure:true,count:function count(){var row=this._data[0];return row?Math.max(0,row.length-this._source.startIndex):0;},getItem:function getItem(idx){idx+=this._source.startIndex;var item=[];var data=this._data;for(var i=0;i<data.length;i++){var row=data[i];item.push(row?row[idx]:null);}return item;},appendData:function appendData(){throw new Error('Do not support appendData when set seriesLayoutBy: "row".');}},'objectRows':{pure:true,count:countSimply,getItem:getItemSimply,appendData:appendDataSimply},'keyedColumns':{pure:true,count:function count(){var dimName=this._source.dimensionsDefine[0].name;var col=this._data[dimName];return col?col.length:0;},getItem:function getItem(idx){var item=[];var dims=this._source.dimensionsDefine;for(var i=0;i<dims.length;i++){var col=this._data[dims[i].name];item.push(col?col[idx]:null);}return item;},appendData:function appendData(newData){var data=this._data;each$1(newData,function(newCol,key){var oldCol=data[key]||(data[key]=[]);for(var i=0;i<(newCol||[]).length;i++){oldCol.push(newCol[i]);}});}},'original':{count:countSimply,getItem:getItemSimply,appendData:appendDataSimply},'typedArray':{persistent:false,pure:true,count:function count(){return this._data?this._data.length/this._dimSize:0;},getItem:function getItem(idx,out){idx=idx-this._offset;out=out||[];var offset=this._dimSize*idx;for(var i=0;i<this._dimSize;i++){out[i]=this._data[offset+i];}return out;},appendData:function appendData(newData){this._data=newData;},// Clean self if data is already used.
clean:function clean(){// PENDING
this._offset+=this.count();this._data=null;}}};function countSimply(){return this._data.length;}function getItemSimply(idx){return this._data[idx];}function appendDataSimply(newData){for(var i=0;i<newData.length;i++){this._data.push(newData[i]);}}var rawValueGetters={arrayRows:getRawValueSimply,objectRows:function objectRows(dataItem,dataIndex,dimIndex,dimName){return dimIndex!=null?dataItem[dimName]:dataItem;},keyedColumns:getRawValueSimply,original:function original(dataItem,dataIndex,dimIndex,dimName){// FIXME
// In some case (markpoint in geo (geo-map.html)), dataItem
// is {coord: [...]}
var value=getDataItemValue(dataItem);return dimIndex==null||!(value instanceof Array)?value:value[dimIndex];},typedArray:getRawValueSimply};function getRawValueSimply(dataItem,dataIndex,dimIndex,dimName){return dimIndex!=null?dataItem[dimIndex]:dataItem;}var defaultDimValueGetters={arrayRows:getDimValueSimply,objectRows:function objectRows(dataItem,dimName,dataIndex,dimIndex){return converDataValue(dataItem[dimName],this._dimensionInfos[dimName]);},keyedColumns:getDimValueSimply,original:function original(dataItem,dimName,dataIndex,dimIndex){// Performance sensitive, do not use modelUtil.getDataItemValue.
// If dataItem is an plain object with no value field, the var `value`
// will be assigned with the object, but it will be tread correctly
// in the `convertDataValue`.
var value=dataItem&&(dataItem.value==null?dataItem:dataItem.value);// If any dataItem is like { value: 10 }
if(!this._rawData.pure&&isDataItemOption(dataItem)){this.hasItemOption=true;}return converDataValue(value instanceof Array?value[dimIndex]// If value is a single number or something else not array.
:value,this._dimensionInfos[dimName]);},typedArray:function typedArray(dataItem,dimName,dataIndex,dimIndex){return dataItem[dimIndex];}};function getDimValueSimply(dataItem,dimName,dataIndex,dimIndex){return converDataValue(dataItem[dimIndex],this._dimensionInfos[dimName]);}/**
 * This helper method convert value in data.
 * @param {string|number|Date} value
 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
 *        If "dimInfo.ordinalParseAndSave", ordinal value can be parsed.
 */function converDataValue(value,dimInfo){// Performance sensitive.
var dimType=dimInfo&&dimInfo.type;if(dimType==='ordinal'){// If given value is a category string
var ordinalMeta=dimInfo&&dimInfo.ordinalMeta;return ordinalMeta?ordinalMeta.parseAndCollect(value):value;}if(dimType==='time'// spead up when using timestamp
&&typeof value!=='number'&&value!=null&&value!=='-'){value=+parseDate(value);}// dimType defaults 'number'.
// If dimType is not ordinal and value is null or undefined or NaN or '-',
// parse to NaN.
return value==null||value===''?NaN// If string (like '-'), using '+' parse to NaN
// If object, also parse to NaN
:+value;}// ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
// Consider persistent.
// Caution: why use raw value to display on label or tooltip?
// A reason is to avoid format. For example time value we do not know
// how to format is expected. More over, if stack is used, calculated
// value may be 0.91000000001, which have brings trouble to display.
// TODO: consider how to treat null/undefined/NaN when display?
/**
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @param {string|number} [dim] dimName or dimIndex
 * @return {Array.<number>|string|number} can be null/undefined.
 */function retrieveRawValue(data,dataIndex,dim){if(!data){return;}// Consider data may be not persistent.
var dataItem=data.getRawDataItem(dataIndex);if(dataItem==null){return;}var sourceFormat=data.getProvider().getSource().sourceFormat;var dimName;var dimIndex;var dimInfo=data.getDimensionInfo(dim);if(dimInfo){dimName=dimInfo.name;dimIndex=dimInfo.index;}return rawValueGetters[sourceFormat](dataItem,dataIndex,dimIndex,dimName);}/**
 * Compatible with some cases (in pie, map) like:
 * data: [{name: 'xx', value: 5, selected: true}, ...]
 * where only sourceFormat is 'original' and 'objectRows' supported.
 *
 * ??? TODO
 * Supported detail options in data item when using 'arrayRows'.
 *
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @param {string} attr like 'selected'
 *//*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var DIMENSION_LABEL_REG=/\{@(.+?)\}/g;// PENDING A little ugly
var dataFormatMixin={/**
   * Get params for formatter
   * @param {number} dataIndex
   * @param {string} [dataType]
   * @return {Object}
   */getDataParams:function getDataParams(dataIndex,dataType){var data=this.getData(dataType);var rawValue=this.getRawValue(dataIndex,dataType);var rawDataIndex=data.getRawIndex(dataIndex);var name=data.getName(dataIndex);var itemOpt=data.getRawDataItem(dataIndex);var color=data.getItemVisual(dataIndex,'color');return{componentType:this.mainType,componentSubType:this.subType,seriesType:this.mainType==='series'?this.subType:null,seriesIndex:this.seriesIndex,seriesId:this.id,seriesName:this.name,name:name,dataIndex:rawDataIndex,data:itemOpt,dataType:dataType,value:rawValue,color:color,marker:getTooltipMarker(color),// Param name list for mapping `a`, `b`, `c`, `d`, `e`
$vars:['seriesName','name','value']};},/**
   * Format label
   * @param {number} dataIndex
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @param {string} [dataType]
   * @param {number} [dimIndex]
   * @param {string} [labelProp='label']
   * @return {string} If not formatter, return null/undefined
   */getFormattedLabel:function getFormattedLabel(dataIndex,status,dataType,dimIndex,labelProp){status=status||'normal';var data=this.getData(dataType);var itemModel=data.getItemModel(dataIndex);var params=this.getDataParams(dataIndex,dataType);if(dimIndex!=null&&params.value instanceof Array){params.value=params.value[dimIndex];}var formatter=itemModel.get(status==='normal'?[labelProp||'label','formatter']:[status,labelProp||'label','formatter']);if(typeof formatter==='function'){params.status=status;return formatter(params);}else if(typeof formatter==='string'){var str=formatTpl(formatter,params);// Support 'aaa{@[3]}bbb{@product}ccc'.
// Do not support '}' in dim name util have to.
return str.replace(DIMENSION_LABEL_REG,function(origin,dim){var len=dim.length;if(dim.charAt(0)==='['&&dim.charAt(len-1)===']'){dim=+dim.slice(1,len-1);// Also: '[]' => 0
}return retrieveRawValue(data,dataIndex,dim);});}},/**
   * Get raw value in option
   * @param {number} idx
   * @param {string} [dataType]
   * @return {Array|number|string}
   */getRawValue:function getRawValue(idx,dataType){return retrieveRawValue(this.getData(dataType),idx);},/**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   * @return {string} tooltip string
   */formatTooltip:function formatTooltip(){// Empty function
}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @param {Object} define
 * @return See the return of `createTask`.
 */function createTask(define){return new Task(define);}/**
 * @constructor
 * @param {Object} define
 * @param {Function} define.reset Custom reset
 * @param {Function} [define.plan] Returns 'reset' indicate reset immediately.
 * @param {Function} [define.count] count is used to determin data task.
 * @param {Function} [define.onDirty] count is used to determin data task.
 */function Task(define){define=define||{};this._reset=define.reset;this._plan=define.plan;this._count=define.count;this._onDirty=define.onDirty;this._dirty=true;// Context must be specified implicitly, to
// avoid miss update context when model changed.
this.context;}var taskProto=Task.prototype;/**
 * @param {Object} performArgs
 * @param {number} [performArgs.step] Specified step.
 * @param {number} [performArgs.skip] Skip customer perform call.
 * @param {number} [performArgs.modBy] Sampling window size.
 * @param {number} [performArgs.modDataCount] Sampling count.
 */taskProto.perform=function(performArgs){var upTask=this._upstream;var skip=performArgs&&performArgs.skip;// TODO some refactor.
// Pull data. Must pull data each time, because context.data
// may be updated by Series.setData.
if(this._dirty&&upTask){var context=this.context;context.data=context.outputData=upTask.context.outputData;}if(this.__pipeline){this.__pipeline.currentTask=this;}var planResult;if(this._plan&&!skip){planResult=this._plan(this.context);}// Support sharding by mod, which changes the render sequence and makes the rendered graphic
// elements uniformed distributed when progress, especially when moving or zooming.
var lastModBy=normalizeModBy(this._modBy);var lastModDataCount=this._modDataCount||0;var modBy=normalizeModBy(performArgs&&performArgs.modBy);var modDataCount=performArgs&&performArgs.modDataCount||0;if(lastModBy!==modBy||lastModDataCount!==modDataCount){planResult='reset';}function normalizeModBy(val){!(val>=1)&&(val=1);// jshint ignore:line
return val;}var forceFirstProgress;if(this._dirty||planResult==='reset'){this._dirty=false;forceFirstProgress=reset(this,skip);}this._modBy=modBy;this._modDataCount=modDataCount;var step=performArgs&&performArgs.step;if(upTask){this._dueEnd=upTask._outputDueEnd;}// DataTask or overallTask
else{this._dueEnd=this._count?this._count(this.context):Infinity;}// Note: Stubs, that its host overall task let it has progress, has progress.
// If no progress, pass index from upstream to downstream each time plan called.
if(this._progress){var start=this._dueIndex;var end=Math.min(step!=null?this._dueIndex+step:Infinity,this._dueEnd);if(!skip&&(forceFirstProgress||start<end)){var progress=this._progress;if(isArray(progress)){for(var i=0;i<progress.length;i++){doProgress(this,progress[i],start,end,modBy,modDataCount);}}else{doProgress(this,progress,start,end,modBy,modDataCount);}}this._dueIndex=end;// If no `outputDueEnd`, assume that output data and
// input data is the same, so use `dueIndex` as `outputDueEnd`.
var outputDueEnd=this._settedOutputEnd!=null?this._settedOutputEnd:end;this._outputDueEnd=outputDueEnd;}else{// (1) Some overall task has no progress.
// (2) Stubs, that its host overall task do not let it has progress, has no progress.
// This should always be performed so it can be passed to downstream.
this._dueIndex=this._outputDueEnd=this._settedOutputEnd!=null?this._settedOutputEnd:this._dueEnd;}return this.unfinished();};var iterator=function(){var end;var current;var modBy;var modDataCount;var winCount;var it={reset:function reset(s,e,sStep,sCount){current=s;end=e;modBy=sStep;modDataCount=sCount;winCount=Math.ceil(modDataCount/modBy);it.next=modBy>1&&modDataCount>0?modNext:sequentialNext;}};return it;function sequentialNext(){return current<end?current++:null;}function modNext(){var dataIndex=current%winCount*modBy+Math.ceil(current/winCount);var result=current>=end?null:dataIndex<modDataCount?dataIndex// If modDataCount is smaller than data.count() (consider `appendData` case),
// Use normal linear rendering mode.
:current;current++;return result;}}();taskProto.dirty=function(){this._dirty=true;this._onDirty&&this._onDirty(this.context);};function doProgress(taskIns,progress,start,end,modBy,modDataCount){iterator.reset(start,end,modBy,modDataCount);taskIns._callingProgress=progress;taskIns._callingProgress({start:start,end:end,count:end-start,next:iterator.next},taskIns.context);}function reset(taskIns,skip){taskIns._dueIndex=taskIns._outputDueEnd=taskIns._dueEnd=0;taskIns._settedOutputEnd=null;var progress;var forceFirstProgress;if(!skip&&taskIns._reset){progress=taskIns._reset(taskIns.context);if(progress&&progress.progress){forceFirstProgress=progress.forceFirstProgress;progress=progress.progress;}// To simplify no progress checking, array must has item.
if(isArray(progress)&&!progress.length){progress=null;}}taskIns._progress=progress;taskIns._modBy=taskIns._modDataCount=null;var downstream=taskIns._downstream;downstream&&downstream.dirty();return forceFirstProgress;}/**
 * @return {boolean}
 */taskProto.unfinished=function(){return this._progress&&this._dueIndex<this._dueEnd;};/**
 * @param {Object} downTask The downstream task.
 * @return {Object} The downstream task.
 */taskProto.pipe=function(downTask){// If already downstream, do not dirty downTask.
if(this._downstream!==downTask||this._dirty){this._downstream=downTask;downTask._upstream=this;downTask.dirty();}};taskProto.dispose=function(){if(this._disposed){return;}this._upstream&&(this._upstream._downstream=null);this._downstream&&(this._downstream._upstream=null);this._dirty=false;this._disposed=true;};taskProto.getUpstream=function(){return this._upstream;};taskProto.getDownstream=function(){return this._downstream;};taskProto.setOutputEnd=function(end){// This only happend in dataTask, dataZoom, map, currently.
// where dataZoom do not set end each time, but only set
// when reset. So we should record the setted end, in case
// that the stub of dataZoom perform again and earse the
// setted end by upstream.
this._outputDueEnd=this._settedOutputEnd=end;};///////////////////////////////////////////////////////////
// For stream debug (Should be commented out after used!)
// Usage: printTask(this, 'begin');
// Usage: printTask(this, null, {someExtraProp});
// function printTask(task, prefix, extra) {
//     window.ecTaskUID == null && (window.ecTaskUID = 0);
//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
//     var props = [];
//     if (task.__pipeline) {
//         var val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
//         props.push({text: 'idx', value: val});
//     } else {
//         var stubCount = 0;
//         task.agentStubMap.each(() => stubCount++);
//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
//     }
//     props.push({text: 'uid', value: task.uidDebug});
//     if (task.__pipeline) {
//         props.push({text: 'pid', value: task.__pipeline.id});
//         task.agent && props.push(
//             {text: 'stubFor', value: task.agent.uidDebug}
//         );
//     }
//     props.push(
//         {text: 'dirty', value: task._dirty},
//         {text: 'dueIndex', value: task._dueIndex},
//         {text: 'dueEnd', value: task._dueEnd},
//         {text: 'outputDueEnd', value: task._outputDueEnd}
//     );
//     if (extra) {
//         Object.keys(extra).forEach(key => {
//             props.push({text: key, value: extra[key]});
//         });
//     }
//     var args = ['color: blue'];
//     var msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
//         args.push('color: black', 'color: red'),
//         `${item.text}: %c${item.value}`
//     )).join('%c, ');
//     console.log.apply(console, [msg].concat(args));
//     // console.log(this);
// }
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var inner$4=makeInner();var SeriesModel=ComponentModel.extend({type:'series.__base__',/**
   * @readOnly
   */seriesIndex:0,// coodinateSystem will be injected in the echarts/CoordinateSystem
coordinateSystem:null,/**
   * @type {Object}
   * @protected
   */defaultOption:null,/**
   * Data provided for legend
   * @type {Function}
   */// PENDING
legendDataProvider:null,/**
   * Access path of color for visual
   */visualColorAccessPath:'itemStyle.color',/**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */layoutMode:null,init:function init(option,parentModel,ecModel,extraOpt){/**
     * @type {number}
     * @readOnly
     */this.seriesIndex=this.componentIndex;this.dataTask=createTask({count:dataTaskCount,reset:dataTaskReset});this.dataTask.context={model:this};this.mergeDefaultAndTheme(option,ecModel);prepareSource(this);var data=this.getInitialData(option,ecModel);wrapData(data,this);this.dataTask.context.data=data;/**
     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
     * @private
     */inner$4(this).dataBeforeProcessed=data;// If we reverse the order (make data firstly, and then make
// dataBeforeProcessed by cloneShallow), cloneShallow will
// cause data.graph.data !== data when using
// module:echarts/data/Graph or module:echarts/data/Tree.
// See module:echarts/data/helper/linkList
// Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
// init or merge stage, because the data can be restored. So we do not `restoreData`
// and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
// Call `seriesModel.getRawData()` instead.
// this.restoreData();
autoSeriesName(this);},/**
   * Util for merge default and theme to option
   * @param  {Object} option
   * @param  {module:echarts/model/Global} ecModel
   */mergeDefaultAndTheme:function mergeDefaultAndTheme(option,ecModel){var layoutMode=this.layoutMode;var inputPositionParams=layoutMode?getLayoutParams(option):{};// Backward compat: using subType on theme.
// But if name duplicate between series subType
// (for example: parallel) add component mainType,
// add suffix 'Series'.
var themeSubType=this.subType;if(ComponentModel.hasClass(themeSubType)){themeSubType+='Series';}merge(option,ecModel.getTheme().get(this.subType));merge(option,this.getDefaultOption());// Default label emphasis `show`
defaultEmphasis(option,'label',['show']);this.fillDataTextStyle(option.data);if(layoutMode){mergeLayoutParam(option,inputPositionParams,layoutMode);}},mergeOption:function mergeOption(newSeriesOption,ecModel){// this.settingTask.dirty();
newSeriesOption=merge(this.option,newSeriesOption,true);this.fillDataTextStyle(newSeriesOption.data);var layoutMode=this.layoutMode;if(layoutMode){mergeLayoutParam(this.option,newSeriesOption,layoutMode);}prepareSource(this);var data=this.getInitialData(newSeriesOption,ecModel);wrapData(data,this);this.dataTask.dirty();this.dataTask.context.data=data;inner$4(this).dataBeforeProcessed=data;autoSeriesName(this);},fillDataTextStyle:function fillDataTextStyle(data){// Default data label emphasis `show`
// FIXME Tree structure data ?
// FIXME Performance ?
if(data&&!isTypedArray(data)){var props=['show'];for(var i=0;i<data.length;i++){if(data[i]&&data[i].label){defaultEmphasis(data[i],'label',props);}}}},/**
   * Init a data structure from data related option in series
   * Must be overwritten
   */getInitialData:function getInitialData(){},/**
   * Append data to list
   * @param {Object} params
   * @param {Array|TypedArray} params.data
   */appendData:function appendData(params){// FIXME ???
// (1) If data from dataset, forbidden append.
// (2) support append data of dataset.
var data=this.getRawData();data.appendData(params.data);},/**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   * @param {string} [dataType]
   * @return {module:echarts/data/List}
   */getData:function getData(dataType){var task=getCurrentTask(this);if(task){var data=task.context.data;return dataType==null?data:data.getLinkedData(dataType);}else{// When series is not alive (that may happen when click toolbox
// restore or setOption with not merge mode), series data may
// be still need to judge animation or something when graphic
// elements want to know whether fade out.
return inner$4(this).data;}},/**
   * @param {module:echarts/data/List} data
   */setData:function setData(data){var task=getCurrentTask(this);if(task){var context=task.context;// Consider case: filter, data sample.
if(context.data!==data&&task.modifyOutputEnd){task.setOutputEnd(data.count());}context.outputData=data;// Caution: setData should update context.data,
// Because getData may be called multiply in a
// single stage and expect to get the data just
// set. (For example, AxisProxy, x y both call
// getData and setDate sequentially).
// So the context.data should be fetched from
// upstream each time when a stage starts to be
// performed.
if(task!==this.dataTask){context.data=data;}}inner$4(this).data=data;},/**
   * @see {module:echarts/data/helper/sourceHelper#getSource}
   * @return {module:echarts/data/Source} source
   */getSource:function getSource(){return _getSource(this);},/**
   * Get data before processed
   * @return {module:echarts/data/List}
   */getRawData:function getRawData(){return inner$4(this).dataBeforeProcessed;},/**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */getBaseAxis:function getBaseAxis(){var coordSys=this.coordinateSystem;return coordSys&&coordSys.getBaseAxis&&coordSys.getBaseAxis();},// FIXME
/**
   * Default tooltip formatter
   *
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   */formatTooltip:function formatTooltip(dataIndex,multipleSeries,dataType){function formatArrayValue(value){// ??? TODO refactor these logic.
// check: category-no-encode-has-axis-data in dataset.html
var vertially=reduce(value,function(vertially,val,idx){var dimItem=data.getDimensionInfo(idx);return vertially|=dimItem&&dimItem.tooltip!==false&&dimItem.displayName!=null;},0);var result=[];tooltipDims.length?each$1(tooltipDims,function(dim){setEachItem(retrieveRawValue(data,dataIndex,dim),dim);})// By default, all dims is used on tooltip.
:each$1(value,setEachItem);function setEachItem(val,dim){var dimInfo=data.getDimensionInfo(dim);// If `dimInfo.tooltip` is not set, show tooltip.
if(!dimInfo||dimInfo.otherDims.tooltip===false){return;}var dimType=dimInfo.type;var dimHead=getTooltipMarker({color:color,type:'subItem'});var valStr=(vertially?dimHead+encodeHTML(dimInfo.displayName||'-')+': ':'')+// FIXME should not format time for raw data?
encodeHTML(dimType==='ordinal'?val+'':dimType==='time'?multipleSeries?'':formatTime('yyyy/MM/dd hh:mm:ss',val):addCommas(val));valStr&&result.push(valStr);}return(vertially?'<br/>':'')+result.join(vertially?'<br/>':', ');}function formatSingleValue(val){return encodeHTML(addCommas(val));}var data=this.getData();var tooltipDims=data.mapDimension('defaultedTooltip',true);var tooltipDimLen=tooltipDims.length;var value=this.getRawValue(dataIndex);var isValueArr=isArray(value);var color=data.getItemVisual(dataIndex,'color');if(isObject$1(color)&&color.colorStops){color=(color.colorStops[0]||{}).color;}color=color||'transparent';// Complicated rule for pretty tooltip.
var formattedValue=tooltipDimLen>1||isValueArr&&!tooltipDimLen?formatArrayValue(value):tooltipDimLen?formatSingleValue(retrieveRawValue(data,dataIndex,tooltipDims[0])):formatSingleValue(isValueArr?value[0]:value);var colorEl=getTooltipMarker(color);var name=data.getName(dataIndex);var seriesName=this.name;if(!isNameSpecified(this)){seriesName='';}seriesName=seriesName?encodeHTML(seriesName)+(!multipleSeries?'<br/>':': '):'';return!multipleSeries?seriesName+colorEl+(name?encodeHTML(name)+': '+formattedValue:formattedValue):colorEl+seriesName+formattedValue;},/**
   * @return {boolean}
   */isAnimationEnabled:function isAnimationEnabled(){if(env$1.node){return false;}var animationEnabled=this.getShallow('animation');if(animationEnabled){if(this.getData().count()>this.getShallow('animationThreshold')){animationEnabled=false;}}return animationEnabled;},restoreData:function restoreData(){this.dataTask.dirty();},getColorFromPalette:function getColorFromPalette(name,scope,requestColorNum){var ecModel=this.ecModel;// PENDING
var color=colorPaletteMixin.getColorFromPalette.call(this,name,scope,requestColorNum);if(!color){color=ecModel.getColorFromPalette(name,scope,requestColorNum);}return color;},/**
   * Use `data.mapDimension(coordDim, true)` instead.
   * @deprecated
   */coordDimToDataDim:function coordDimToDataDim(coordDim){return this.getRawData().mapDimension(coordDim,true);},/**
   * Get progressive rendering count each step
   * @return {number}
   */getProgressive:function getProgressive(){return this.get('progressive');},/**
   * Get progressive rendering count each step
   * @return {number}
   */getProgressiveThreshold:function getProgressiveThreshold(){return this.get('progressiveThreshold');},/**
   * Get data indices for show tooltip content. See tooltip.
   * @abstract
   * @param {Array.<string>|string} dim
   * @param {Array.<number>} value
   * @param {module:echarts/coord/single/SingleAxis} baseAxis
   * @return {Object} {dataIndices, nestestValue}.
   */getAxisTooltipData:null,/**
   * See tooltip.
   * @abstract
   * @param {number} dataIndex
   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
   */getTooltipPosition:null,/**
   * @see {module:echarts/stream/Scheduler}
   */pipeTask:null,/**
   * Convinient for override in extended class.
   * @protected
   * @type {Function}
   */preventIncremental:null,/**
   * @public
   * @readOnly
   * @type {Object}
   */pipelineContext:null});mixin(SeriesModel,dataFormatMixin);mixin(SeriesModel,colorPaletteMixin);/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */function autoSeriesName(seriesModel){// User specified name has higher priority, otherwise it may cause
// series can not be queried unexpectedly.
var name=seriesModel.name;if(!isNameSpecified(seriesModel)){seriesModel.name=getSeriesAutoName(seriesModel)||name;}}function getSeriesAutoName(seriesModel){var data=seriesModel.getRawData();var dataDims=data.mapDimension('seriesName',true);var nameArr=[];each$1(dataDims,function(dataDim){var dimInfo=data.getDimensionInfo(dataDim);dimInfo.displayName&&nameArr.push(dimInfo.displayName);});return nameArr.join(' ');}function dataTaskCount(context){return context.model.getRawData().count();}function dataTaskReset(context){var seriesModel=context.model;seriesModel.setData(seriesModel.getRawData().cloneShallow());return dataTaskProgress;}function dataTaskProgress(param,context){// Avoid repead cloneShallow when data just created in reset.
if(param.end>context.outputData.count()){context.model.getRawData().cloneShallow(context.outputData);}}// TODO refactor
function wrapData(data,seriesModel){each$1(data.CHANGABLE_METHODS,function(methodName){data.wrapMethod(methodName,curry(onDataSelfChange,seriesModel));});}function onDataSelfChange(seriesModel){var task=getCurrentTask(seriesModel);if(task){// Consider case: filter, selectRange
task.setOutputEnd(this.count());}}function getCurrentTask(seriesModel){var scheduler=(seriesModel.ecModel||{}).scheduler;var pipeline=scheduler&&scheduler.getPipeline(seriesModel.uid);if(pipeline){// When pipline finished, the currrentTask keep the last
// task (renderTask).
var task=pipeline.currentTask;if(task){var agentStubMap=task.agentStubMap;if(agentStubMap){task=agentStubMap.get(seriesModel.uid);}}return task;}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var Component$1=function Component$1(){/**
   * @type {module:zrender/container/Group}
   * @readOnly
   */this.group=new Group();/**
   * @type {string}
   * @readOnly
   */this.uid=getUID('viewComponent');};Component$1.prototype={constructor:Component$1,init:function init(ecModel,api){},render:function render(componentModel,ecModel,api,payload){},dispose:function dispose(){}};var componentProto=Component$1.prototype;componentProto.updateView=componentProto.updateLayout=componentProto.updateVisual=function(seriesModel,ecModel,api,payload){// Do nothing;
};// Enable Component.extend.
enableClassExtend(Component$1);// Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
enableClassManagement(Component$1,{registerWhenExtend:true});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @return {string} If large mode changed, return string 'reset';
 */var createRenderPlanner=function createRenderPlanner(){var inner=makeInner();return function(seriesModel){var fields=inner(seriesModel);var pipelineContext=seriesModel.pipelineContext;var originalLarge=fields.large;var originalProgressive=fields.progressiveRender;var large=fields.large=pipelineContext.large;var progressive=fields.progressiveRender=pipelineContext.progressiveRender;return!!(originalLarge^large||originalProgressive^progressive)&&'reset';};};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var inner$5=makeInner();var renderPlanner=createRenderPlanner();function Chart(){/**
   * @type {module:zrender/container/Group}
   * @readOnly
   */this.group=new Group();/**
   * @type {string}
   * @readOnly
   */this.uid=getUID('viewChart');this.renderTask=createTask({plan:renderTaskPlan,reset:renderTaskReset});this.renderTask.context={view:this};}Chart.prototype={type:'chart',/**
   * Init the chart.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */init:function init(ecModel,api){},/**
   * Render the chart.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */render:function render(seriesModel,ecModel,api,payload){},/**
   * Highlight series or specified data item.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */highlight:function highlight(seriesModel,ecModel,api,payload){toggleHighlight(seriesModel.getData(),payload,'emphasis');},/**
   * Downplay series or specified data item.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */downplay:function downplay(seriesModel,ecModel,api,payload){toggleHighlight(seriesModel.getData(),payload,'normal');},/**
   * Remove self.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */remove:function remove(ecModel,api){this.group.removeAll();},/**
   * Dispose self.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */dispose:function dispose(){},/**
   * Rendering preparation in progressive mode.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */incrementalPrepareRender:null,/**
   * Render in progressive mode.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */incrementalRender:null,/**
   * Update transform directly.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   * @return {Object} {update: true}
   */updateTransform:null/**
   * The view contains the given point.
   * @interface
   * @param {Array.<number>} point
   * @return {boolean}
   */// containPoint: function () {}
};var chartProto=Chart.prototype;chartProto.updateView=chartProto.updateLayout=chartProto.updateVisual=function(seriesModel,ecModel,api,payload){this.render(seriesModel,ecModel,api,payload);};/**
 * Set state of single element
 * @param  {module:zrender/Element} el
 * @param  {string} state
 */function elSetState(el,state){if(el){el.trigger(state);if(el.type==='group'){for(var i=0;i<el.childCount();i++){elSetState(el.childAt(i),state);}}}}/**
 * @param  {module:echarts/data/List} data
 * @param  {Object} payload
 * @param  {string} state 'normal'|'emphasis'
 */function toggleHighlight(data,payload,state){var dataIndex=queryDataIndex(data,payload);if(dataIndex!=null){each$1(normalizeToArray(dataIndex),function(dataIdx){elSetState(data.getItemGraphicEl(dataIdx),state);});}else{data.eachItemGraphicEl(function(el){elSetState(el,state);});}}// Enable Chart.extend.
enableClassExtend(Chart,['dispose']);// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
enableClassManagement(Chart,{registerWhenExtend:true});Chart.markUpdateMethod=function(payload,methodName){inner$5(payload).updateMethod=methodName;};function renderTaskPlan(context){return renderPlanner(context.model);}function renderTaskReset(context){var seriesModel=context.model;var ecModel=context.ecModel;var api=context.api;var payload=context.payload;// ???! remove updateView updateVisual
var progressiveRender=seriesModel.pipelineContext.progressiveRender;var view=context.view;var updateMethod=payload&&inner$5(payload).updateMethod;var methodName=progressiveRender?'incrementalPrepareRender':updateMethod&&view[updateMethod]?updateMethod// `appendData` is also supported when data amount
// is less than progressive threshold.
:'render';if(methodName!=='render'){view[methodName](seriesModel,ecModel,api,payload);}return progressMethodMap[methodName];}var progressMethodMap={incrementalPrepareRender:{progress:function progress(params,context){context.view.incrementalRender(params,context.model,context.ecModel,context.api,context.payload);}},render:{// Put view.render in `progress` to support appendData. But in this case
// view.render should not be called in reset, otherwise it will be called
// twise. Use `forceFirstProgress` to make sure that view.render is called
// in any cases.
forceFirstProgress:true,progress:function progress(params,context){context.view.render(context.model,context.ecModel,context.api,context.payload);}}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var ORIGIN_METHOD='\0__throttleOriginMethod';var RATE='\0__throttleRate';var THROTTLE_TYPE='\0__throttleType';/**
 * @public
 * @param {(Function)} fn
 * @param {number} [delay=0] Unit: ms.
 * @param {boolean} [debounce=false]
 *        true: If call interval less than `delay`, only the last call works.
 *        false: If call interval less than `delay, call works on fixed rate.
 * @return {(Function)} throttled fn.
 */function throttle(fn,delay,debounce){var currCall;var lastCall=0;var lastExec=0;var timer=null;var diff;var scope;var args;var debounceNextCall;delay=delay||0;function exec(){lastExec=new Date().getTime();timer=null;fn.apply(scope,args||[]);}var cb=function cb(){currCall=new Date().getTime();scope=this;args=arguments;var thisDelay=debounceNextCall||delay;var thisDebounce=debounceNextCall||debounce;debounceNextCall=null;diff=currCall-(thisDebounce?lastCall:lastExec)-thisDelay;clearTimeout(timer);// Here we should make sure that: the `exec` SHOULD NOT be called later
// than a new call of `cb`, that is, preserving the command order. Consider
// calculating "scale rate" when roaming as an example. When a call of `cb`
// happens, either the `exec` is called dierectly, or the call is delayed.
// But the delayed call should never be later than next call of `cb`. Under
// this assurance, we can simply update view state each time `dispatchAction`
// triggered by user roaming, but not need to add extra code to avoid the
// state being "rolled-back".
if(thisDebounce){timer=setTimeout(exec,thisDelay);}else{if(diff>=0){exec();}else{timer=setTimeout(exec,-diff);}}lastCall=currCall;};/**
   * Clear throttle.
   * @public
   */cb.clear=function(){if(timer){clearTimeout(timer);timer=null;}};/**
   * Enable debounce once.
   */cb.debounceNextCall=function(debounceDelay){debounceNextCall=debounceDelay;};return cb;}/**
 * Create throttle method or update throttle rate.
 *
 * @example
 * ComponentView.prototype.render = function () {
 *     ...
 *     throttle.createOrUpdate(
 *         this,
 *         '_dispatchAction',
 *         this.model.get('throttle'),
 *         'fixRate'
 *     );
 * };
 * ComponentView.prototype.remove = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 * ComponentView.prototype.dispose = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 * @param {number} [rate]
 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
 * @return {Function} throttled function.
 */function createOrUpdate(obj,fnAttr,rate,throttleType){var fn=obj[fnAttr];if(!fn){return;}var originFn=fn[ORIGIN_METHOD]||fn;var lastThrottleType=fn[THROTTLE_TYPE];var lastRate=fn[RATE];if(lastRate!==rate||lastThrottleType!==throttleType){if(rate==null||!throttleType){return obj[fnAttr]=originFn;}fn=obj[fnAttr]=throttle(originFn,rate,throttleType==='debounce');fn[ORIGIN_METHOD]=originFn;fn[THROTTLE_TYPE]=throttleType;fn[RATE]=rate;}return fn;}/**
 * Clear throttle. Example see throttle.createOrUpdate.
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 */function clear(obj,fnAttr){var fn=obj[fnAttr];if(fn&&fn[ORIGIN_METHOD]){obj[fnAttr]=fn[ORIGIN_METHOD];}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var seriesColor={createOnAllSeries:true,performRawSeries:true,reset:function reset(seriesModel,ecModel){var data=seriesModel.getData();var colorAccessPath=(seriesModel.visualColorAccessPath||'itemStyle.color').split('.');var color=seriesModel.get(colorAccessPath)// Set in itemStyle
||seriesModel.getColorFromPalette(// TODO series count changed.
seriesModel.name,null,ecModel.getSeriesCount());// Default color
// FIXME Set color function or use the platte color
data.setVisual('color',color);// Only visible series has each data be visual encoded
if(!ecModel.isSeriesFiltered(seriesModel)){if(typeof color==='function'&&!(color instanceof Gradient)){data.each(function(idx){data.setItemVisual(idx,'color',color(seriesModel.getDataParams(idx)));});}// itemStyle in each data item
var dataEach=function dataEach(data,idx){var itemModel=data.getItemModel(idx);var color=itemModel.get(colorAccessPath,true);if(color!=null){data.setItemVisual(idx,'color',color);}};return{dataEach:data.hasItemOption?dataEach:null};}}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var lang={toolbox:{brush:{title:{rect:'矩形选择',polygon:'圈选',lineX:'横向选择',lineY:'纵向选择',keep:'保持选择',clear:'清除选择'}},dataView:{title:'数据视图',lang:['数据视图','关闭','刷新']},dataZoom:{title:{zoom:'区域缩放',back:'区域缩放还原'}},magicType:{title:{line:'切换为折线图',bar:'切换为柱状图',stack:'切换为堆叠',tiled:'切换为平铺'}},restore:{title:'还原'},saveAsImage:{title:'保存为图片',lang:['右键另存为图片']}},series:{typeNames:{pie:'饼图',bar:'柱状图',line:'折线图',scatter:'散点图',effectScatter:'涟漪散点图',radar:'雷达图',tree:'树图',treemap:'矩形树图',boxplot:'箱型图',candlestick:'K线图',k:'K线图',heatmap:'热力图',map:'地图',parallel:'平行坐标图',lines:'线图',graph:'关系图',sankey:'桑基图',funnel:'漏斗图',gauge:'仪表盘图',pictorialBar:'象形柱图',themeRiver:'主题河流图',sunburst:'旭日图'}},aria:{general:{withTitle:'这是一个关于“{title}”的图表。',withoutTitle:'这是一个图表，'},series:{single:{prefix:'',withName:'图表类型是{seriesType}，表示{seriesName}。',withoutName:'图表类型是{seriesType}。'},multiple:{prefix:'它由{seriesCount}个图表系列组成。',withName:'第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',withoutName:'第{seriesId}个系列是一个{seriesType}，',separator:{middle:'；',end:'。'}}},data:{allData:'其数据是——',partialData:'其中，前{displayCnt}项是——',withName:'{name}的数据是{value}',withoutName:'{value}',separator:{middle:'，',end:''}}}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var aria=function aria(dom,ecModel){var ariaModel=ecModel.getModel('aria');if(!ariaModel.get('show')){return;}else if(ariaModel.get('description')){dom.setAttribute('aria-label',ariaModel.get('description'));return;}var seriesCnt=0;ecModel.eachSeries(function(seriesModel,idx){++seriesCnt;},this);var maxDataCnt=ariaModel.get('data.maxCount')||10;var maxSeriesCnt=ariaModel.get('series.maxCount')||10;var displaySeriesCnt=Math.min(seriesCnt,maxSeriesCnt);var ariaLabel;if(seriesCnt<1){// No series, no aria label
return;}else{var title=getTitle();if(title){ariaLabel=replace(getConfig('general.withTitle'),{title:title});}else{ariaLabel=getConfig('general.withoutTitle');}var seriesLabels=[];var prefix=seriesCnt>1?'series.multiple.prefix':'series.single.prefix';ariaLabel+=replace(getConfig(prefix),{seriesCount:seriesCnt});ecModel.eachSeries(function(seriesModel,idx){if(idx<displaySeriesCnt){var seriesLabel;var seriesName=seriesModel.get('name');var seriesTpl='series.'+(seriesCnt>1?'multiple':'single')+'.';seriesLabel=getConfig(seriesName?seriesTpl+'withName':seriesTpl+'withoutName');seriesLabel=replace(seriesLabel,{seriesId:seriesModel.seriesIndex,seriesName:seriesModel.get('name'),seriesType:getSeriesTypeName(seriesModel.subType)});var data=seriesModel.getData();window.data=data;if(data.count()>maxDataCnt){// Show part of data
seriesLabel+=replace(getConfig('data.partialData'),{displayCnt:maxDataCnt});}else{seriesLabel+=getConfig('data.allData');}var dataLabels=[];for(var i=0;i<data.count();i++){if(i<maxDataCnt){var name=data.getName(i);var value=retrieveRawValue(data,i);dataLabels.push(replace(name?getConfig('data.withName'):getConfig('data.withoutName'),{name:name,value:value}));}}seriesLabel+=dataLabels.join(getConfig('data.separator.middle'))+getConfig('data.separator.end');seriesLabels.push(seriesLabel);}});ariaLabel+=seriesLabels.join(getConfig('series.multiple.separator.middle'))+getConfig('series.multiple.separator.end');dom.setAttribute('aria-label',ariaLabel);}function replace(str,keyValues){if(typeof str!=='string'){return str;}var result=str;each$1(keyValues,function(value,key){result=result.replace(new RegExp('\\{\\s*'+key+'\\s*\\}','g'),value);});return result;}function getConfig(path){var userConfig=ariaModel.get(path);if(userConfig==null){var pathArr=path.split('.');var result=lang.aria;for(var i=0;i<pathArr.length;++i){result=result[pathArr[i]];}return result;}else{return userConfig;}}function getTitle(){var title=ecModel.getModel('title').option;if(title&&title.length){title=title[0];}return title&&title.text;}function getSeriesTypeName(type){return lang.series.typeNames[type]||'自定义图';}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var PI$1=Math.PI;/**
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} [opts]
 * @param {string} [opts.text]
 * @param {string} [opts.color]
 * @param {string} [opts.textColor]
 * @return {module:zrender/Element}
 */var loadingDefault=function loadingDefault(api,opts){opts=opts||{};defaults(opts,{text:'loading',color:'#c23531',textColor:'#000',maskColor:'rgba(255, 255, 255, 0.8)',zlevel:0});var mask=new Rect({style:{fill:opts.maskColor},zlevel:opts.zlevel,z:10000});var arc=new Arc({shape:{startAngle:-PI$1/2,endAngle:-PI$1/2+0.1,r:10},style:{stroke:opts.color,lineCap:'round',lineWidth:5},zlevel:opts.zlevel,z:10001});var labelRect=new Rect({style:{fill:'none',text:opts.text,textPosition:'right',textDistance:10,textFill:opts.textColor},zlevel:opts.zlevel,z:10001});arc.animateShape(true).when(1000,{endAngle:PI$1*3/2}).start('circularInOut');arc.animateShape(true).when(1000,{startAngle:PI$1*3/2}).delay(300).start('circularInOut');var group=new Group();group.add(arc);group.add(labelRect);group.add(mask);// Inject resize
group.resize=function(){var cx=api.getWidth()/2;var cy=api.getHeight()/2;arc.setShape({cx:cx,cy:cy});var r=arc.shape.r;labelRect.setShape({x:cx-r,y:cy-r,width:r*2,height:r*2});mask.setShape({x:0,y:0,width:api.getWidth(),height:api.getHeight()});};group.resize();return group;};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @module echarts/stream/Scheduler
 *//**
 * @constructor
 */function Scheduler(ecInstance,api,dataProcessorHandlers,visualHandlers){this.ecInstance=ecInstance;this.api=api;this.unfinished;// Fix current processors in case that in some rear cases that
// processors might be registered after echarts instance created.
// Register processors incrementally for a echarts instance is
// not supported by this stream architecture.
var dataProcessorHandlers=this._dataProcessorHandlers=dataProcessorHandlers.slice();var visualHandlers=this._visualHandlers=visualHandlers.slice();this._allHandlers=dataProcessorHandlers.concat(visualHandlers);/**
   * @private
   * @type {
   *     [handlerUID: string]: {
   *         seriesTaskMap?: {
   *             [seriesUID: string]: Task
   *         },
   *         overallTask?: Task
   *     }
   * }
   */this._stageTaskMap=createHashMap();}var proto=Scheduler.prototype;/**
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} payload
 */proto.restoreData=function(ecModel,payload){// TODO: Only restroe needed series and components, but not all components.
// Currently `restoreData` of all of the series and component will be called.
// But some independent components like `title`, `legend`, `graphic`, `toolbox`,
// `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
// and some components like coordinate system, axes, dataZoom, visualMap only
// need their target series refresh.
// (1) If we are implementing this feature some day, we should consider these cases:
// if a data processor depends on a component (e.g., dataZoomProcessor depends
// on the settings of `dataZoom`), it should be re-performed if the component
// is modified by `setOption`.
// (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
// it should be re-performed when the result array of `getTargetSeries` changed.
// We use `dependencies` to cover these issues.
// (3) How to update target series when coordinate system related components modified.
// TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
// and this case all of the tasks will be set as dirty.
ecModel.restoreData(payload);// Theoretically an overall task not only depends on each of its target series, but also
// depends on all of the series.
// The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
// dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
// that the overall task is set as dirty and to be performed, otherwise it probably cause
// state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
// probably cause state chaos (consider `dataZoomProcessor`).
this._stageTaskMap.each(function(taskRecord){var overallTask=taskRecord.overallTask;overallTask&&overallTask.dirty();});};// If seriesModel provided, incremental threshold is check by series data.
proto.getPerformArgs=function(task,isBlock){// For overall task
if(!task.__pipeline){return;}var pipeline=this._pipelineMap.get(task.__pipeline.id);var pCtx=pipeline.context;var incremental=!isBlock&&pipeline.progressiveEnabled&&(!pCtx||pCtx.progressiveRender)&&task.__idxInPipeline>pipeline.blockIndex;var step=incremental?pipeline.step:null;var modDataCount=pCtx&&pCtx.modDataCount;var modBy=modDataCount!=null?Math.ceil(modDataCount/step):null;return{step:step,modBy:modBy,modDataCount:modDataCount};};proto.getPipeline=function(pipelineId){return this._pipelineMap.get(pipelineId);};/**
 * Current, progressive rendering starts from visual and layout.
 * Always detect render mode in the same stage, avoiding that incorrect
 * detection caused by data filtering.
 * Caution:
 * `updateStreamModes` use `seriesModel.getData()`.
 */proto.updateStreamModes=function(seriesModel,view){var pipeline=this._pipelineMap.get(seriesModel.uid);var data=seriesModel.getData();var dataLen=data.count();// `progressiveRender` means that can render progressively in each
// animation frame. Note that some types of series do not provide
// `view.incrementalPrepareRender` but support `chart.appendData`. We
// use the term `incremental` but not `progressive` to describe the
// case that `chart.appendData`.
var progressiveRender=pipeline.progressiveEnabled&&view.incrementalPrepareRender&&dataLen>=pipeline.threshold;var large=seriesModel.get('large')&&dataLen>=seriesModel.get('largeThreshold');// TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
// see `test/candlestick-large3.html`
var modDataCount=seriesModel.get('progressiveChunkMode')==='mod'?dataLen:null;seriesModel.pipelineContext=pipeline.context={progressiveRender:progressiveRender,modDataCount:modDataCount,large:large};};proto.restorePipelines=function(ecModel){var scheduler=this;var pipelineMap=scheduler._pipelineMap=createHashMap();ecModel.eachSeries(function(seriesModel){var progressive=seriesModel.getProgressive();var pipelineId=seriesModel.uid;pipelineMap.set(pipelineId,{id:pipelineId,head:null,tail:null,threshold:seriesModel.getProgressiveThreshold(),progressiveEnabled:progressive&&!(seriesModel.preventIncremental&&seriesModel.preventIncremental()),blockIndex:-1,step:Math.round(progressive||700),count:0});pipe(scheduler,seriesModel,seriesModel.dataTask);});};proto.prepareStageTasks=function(){var stageTaskMap=this._stageTaskMap;var ecModel=this.ecInstance.getModel();var api=this.api;each$1(this._allHandlers,function(handler){var record=stageTaskMap.get(handler.uid)||stageTaskMap.set(handler.uid,[]);handler.reset&&createSeriesStageTask(this,handler,record,ecModel,api);handler.overallReset&&createOverallStageTask(this,handler,record,ecModel,api);},this);};proto.prepareView=function(view,model,ecModel,api){var renderTask=view.renderTask;var context=renderTask.context;context.model=model;context.ecModel=ecModel;context.api=api;renderTask.__block=!view.incrementalPrepareRender;pipe(this,model,renderTask);};proto.performDataProcessorTasks=function(ecModel,payload){// If we do not use `block` here, it should be considered when to update modes.
performStageTasks(this,this._dataProcessorHandlers,ecModel,payload,{block:true});};// opt
// opt.visualType: 'visual' or 'layout'
// opt.setDirty
proto.performVisualTasks=function(ecModel,payload,opt){performStageTasks(this,this._visualHandlers,ecModel,payload,opt);};function performStageTasks(scheduler,stageHandlers,ecModel,payload,opt){opt=opt||{};var unfinished;each$1(stageHandlers,function(stageHandler,idx){if(opt.visualType&&opt.visualType!==stageHandler.visualType){return;}var stageHandlerRecord=scheduler._stageTaskMap.get(stageHandler.uid);var seriesTaskMap=stageHandlerRecord.seriesTaskMap;var overallTask=stageHandlerRecord.overallTask;if(overallTask){var overallNeedDirty;var agentStubMap=overallTask.agentStubMap;agentStubMap.each(function(stub){if(needSetDirty(opt,stub)){stub.dirty();overallNeedDirty=true;}});overallNeedDirty&&overallTask.dirty();updatePayload(overallTask,payload);var performArgs=scheduler.getPerformArgs(overallTask,opt.block);// Execute stubs firstly, which may set the overall task dirty,
// then execute the overall task. And stub will call seriesModel.setData,
// which ensures that in the overallTask seriesModel.getData() will not
// return incorrect data.
agentStubMap.each(function(stub){stub.perform(performArgs);});unfinished|=overallTask.perform(performArgs);}else if(seriesTaskMap){seriesTaskMap.each(function(task,pipelineId){if(needSetDirty(opt,task)){task.dirty();}var performArgs=scheduler.getPerformArgs(task,opt.block);performArgs.skip=!stageHandler.performRawSeries&&ecModel.isSeriesFiltered(task.context.model);updatePayload(task,payload);unfinished|=task.perform(performArgs);});}});function needSetDirty(opt,task){return opt.setDirty&&(!opt.dirtyMap||opt.dirtyMap.get(task.__pipeline.id));}scheduler.unfinished|=unfinished;}proto.performSeriesTasks=function(ecModel){var unfinished;ecModel.eachSeries(function(seriesModel){// Progress to the end for dataInit and dataRestore.
unfinished|=seriesModel.dataTask.perform();});this.unfinished|=unfinished;};proto.plan=function(){// Travel pipelines, check block.
this._pipelineMap.each(function(pipeline){var task=pipeline.tail;do{if(task.__block){pipeline.blockIndex=task.__idxInPipeline;break;}task=task.getUpstream();}while(task);});};var updatePayload=proto.updatePayload=function(task,payload){payload!=='remain'&&(task.context.payload=payload);};function createSeriesStageTask(scheduler,stageHandler,stageHandlerRecord,ecModel,api){var seriesTaskMap=stageHandlerRecord.seriesTaskMap||(stageHandlerRecord.seriesTaskMap=createHashMap());var seriesType=stageHandler.seriesType;var getTargetSeries=stageHandler.getTargetSeries;// If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
// to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
// it works but it may cause other irrelevant charts blocked.
if(stageHandler.createOnAllSeries){ecModel.eachRawSeries(create);}else if(seriesType){ecModel.eachRawSeriesByType(seriesType,create);}else if(getTargetSeries){getTargetSeries(ecModel,api).each(create);}function create(seriesModel){var pipelineId=seriesModel.uid;// Init tasks for each seriesModel only once.
// Reuse original task instance.
var task=seriesTaskMap.get(pipelineId)||seriesTaskMap.set(pipelineId,createTask({plan:seriesTaskPlan,reset:seriesTaskReset,count:seriesTaskCount}));task.context={model:seriesModel,ecModel:ecModel,api:api,useClearVisual:stageHandler.isVisual&&!stageHandler.isLayout,plan:stageHandler.plan,reset:stageHandler.reset,scheduler:scheduler};pipe(scheduler,seriesModel,task);}// Clear unused series tasks.
var pipelineMap=scheduler._pipelineMap;seriesTaskMap.each(function(task,pipelineId){if(!pipelineMap.get(pipelineId)){task.dispose();seriesTaskMap.removeKey(pipelineId);}});}function createOverallStageTask(scheduler,stageHandler,stageHandlerRecord,ecModel,api){var overallTask=stageHandlerRecord.overallTask=stageHandlerRecord.overallTask// For overall task, the function only be called on reset stage.
||createTask({reset:overallTaskReset});overallTask.context={ecModel:ecModel,api:api,overallReset:stageHandler.overallReset,scheduler:scheduler};// Reuse orignal stubs.
var agentStubMap=overallTask.agentStubMap=overallTask.agentStubMap||createHashMap();var seriesType=stageHandler.seriesType;var getTargetSeries=stageHandler.getTargetSeries;var overallProgress=true;var modifyOutputEnd=stageHandler.modifyOutputEnd;// An overall task with seriesType detected or has `getTargetSeries`, we add
// stub in each pipelines, it will set the overall task dirty when the pipeline
// progress. Moreover, to avoid call the overall task each frame (too frequent),
// we set the pipeline block.
if(seriesType){ecModel.eachRawSeriesByType(seriesType,createStub);}else if(getTargetSeries){getTargetSeries(ecModel,api).each(createStub);}// Otherwise, (usually it is legancy case), the overall task will only be
// executed when upstream dirty. Otherwise the progressive rendering of all
// pipelines will be disabled unexpectedly. But it still needs stubs to receive
// dirty info from upsteam.
else{overallProgress=false;each$1(ecModel.getSeries(),createStub);}function createStub(seriesModel){var pipelineId=seriesModel.uid;var stub=agentStubMap.get(pipelineId);if(!stub){stub=agentStubMap.set(pipelineId,createTask({reset:stubReset,onDirty:stubOnDirty}));// When the result of `getTargetSeries` changed, the overallTask
// should be set as dirty and re-performed.
overallTask.dirty();}stub.context={model:seriesModel,overallProgress:overallProgress,modifyOutputEnd:modifyOutputEnd};stub.agent=overallTask;stub.__block=overallProgress;pipe(scheduler,seriesModel,stub);}// Clear unused stubs.
var pipelineMap=scheduler._pipelineMap;agentStubMap.each(function(stub,pipelineId){if(!pipelineMap.get(pipelineId)){stub.dispose();// When the result of `getTargetSeries` changed, the overallTask
// should be set as dirty and re-performed.
overallTask.dirty();agentStubMap.removeKey(pipelineId);}});}function overallTaskReset(context){context.overallReset(context.ecModel,context.api,context.payload);}function stubReset(context,upstreamContext){return context.overallProgress&&stubProgress;}function stubProgress(){this.agent.dirty();this.getDownstream().dirty();}function stubOnDirty(){this.agent&&this.agent.dirty();}function seriesTaskPlan(context){return context.plan&&context.plan(context.model,context.ecModel,context.api,context.payload);}function seriesTaskReset(context){if(context.useClearVisual){context.data.clearAllVisual();}var resetDefines=context.resetDefines=normalizeToArray(context.reset(context.model,context.ecModel,context.api,context.payload));return resetDefines.length>1?map(resetDefines,function(v,idx){return makeSeriesTaskProgress(idx);}):singleSeriesTaskProgress;}var singleSeriesTaskProgress=makeSeriesTaskProgress(0);function makeSeriesTaskProgress(resetDefineIdx){return function(params,context){var data=context.data;var resetDefine=context.resetDefines[resetDefineIdx];if(resetDefine&&resetDefine.dataEach){for(var i=params.start;i<params.end;i++){resetDefine.dataEach(data,i);}}else if(resetDefine&&resetDefine.progress){resetDefine.progress(params,data);}};}function seriesTaskCount(context){return context.data.count();}function pipe(scheduler,seriesModel,task){var pipelineId=seriesModel.uid;var pipeline=scheduler._pipelineMap.get(pipelineId);!pipeline.head&&(pipeline.head=task);pipeline.tail&&pipeline.tail.pipe(task);pipeline.tail=task;task.__idxInPipeline=pipeline.count++;task.__pipeline=pipeline;}Scheduler.wrapStageHandler=function(stageHandler,visualType){if(isFunction$1(stageHandler)){stageHandler={overallReset:stageHandler,seriesType:detectSeriseType(stageHandler)};}stageHandler.uid=getUID('stageHandler');visualType&&(stageHandler.visualType=visualType);return stageHandler;};/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */function detectSeriseType(legacyFunc){seriesType=null;try{// Assume there is no async when calling `eachSeriesByType`.
legacyFunc(ecModelMock,apiMock);}catch(e){}return seriesType;}var ecModelMock={};var apiMock={};var seriesType;mockMethods(ecModelMock,GlobalModel);mockMethods(apiMock,ExtensionAPI);ecModelMock.eachSeriesByType=ecModelMock.eachRawSeriesByType=function(type){seriesType=type;};ecModelMock.eachComponent=function(cond){if(cond.mainType==='series'&&cond.subType){seriesType=cond.subType;}};function mockMethods(target,Clz){for(var name in Clz.prototype){// Do not use hasOwnProperty
target[name]=noop;}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var colorAll=['#37A2DA','#32C5E9','#67E0E3','#9FE6B8','#FFDB5C','#ff9f7f','#fb7293','#E062AE','#E690D1','#e7bcf3','#9d96f5','#8378EA','#96BFFF'];var lightTheme={color:colorAll,colorLayer:[['#37A2DA','#ffd85c','#fd7b5f'],['#37A2DA','#67E0E3','#FFDB5C','#ff9f7f','#E062AE','#9d96f5'],['#37A2DA','#32C5E9','#9FE6B8','#FFDB5C','#ff9f7f','#fb7293','#e7bcf3','#8378EA','#96BFFF'],colorAll]};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var contrastColor='#eee';var axisCommon=function axisCommon(){return{axisLine:{lineStyle:{color:contrastColor}},axisTick:{lineStyle:{color:contrastColor}},axisLabel:{textStyle:{color:contrastColor}},splitLine:{lineStyle:{type:'dashed',color:'#aaa'}},splitArea:{areaStyle:{color:contrastColor}}};};var colorPalette=['#dd6b66','#759aa0','#e69d87','#8dc1a9','#ea7e53','#eedd78','#73a373','#73b9bc','#7289ab','#91ca8c','#f49f42'];var theme={color:colorPalette,backgroundColor:'#333',tooltip:{axisPointer:{lineStyle:{color:contrastColor},crossStyle:{color:contrastColor}}},legend:{textStyle:{color:contrastColor}},textStyle:{color:contrastColor},title:{textStyle:{color:contrastColor}},toolbox:{iconStyle:{normal:{borderColor:contrastColor}}},dataZoom:{textStyle:{color:contrastColor}},visualMap:{textStyle:{color:contrastColor}},timeline:{lineStyle:{color:contrastColor},itemStyle:{normal:{color:colorPalette[1]}},label:{normal:{textStyle:{color:contrastColor}}},controlStyle:{normal:{color:contrastColor,borderColor:contrastColor}}},timeAxis:axisCommon(),logAxis:axisCommon(),valueAxis:axisCommon(),categoryAxis:axisCommon(),line:{symbol:'circle'},graph:{color:colorPalette},gauge:{title:{textStyle:{color:contrastColor}}},candlestick:{itemStyle:{normal:{color:'#FD1050',color0:'#0CF49B',color1:'#fff',borderColor:'#FD1050',borderColor0:'#0CF49B'}}}};theme.categoryAxis.splitLine.show=false;/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * This module is imported by echarts directly.
 *
 * Notice:
 * Always keep this file exists for backward compatibility.
 * Because before 4.1.0, dataset is an optional component,
 * some users may import this module manually.
 */ComponentModel.extend({type:'dataset',/**
   * @protected
   */defaultOption:{// 'row', 'column'
seriesLayoutBy:SERIES_LAYOUT_BY_COLUMN,// null/'auto': auto detect header, see "module:echarts/data/helper/sourceHelper"
sourceHeader:null,dimensions:null,source:null},optionUpdated:function optionUpdated(){detectSourceFormat(this);}});Component$1.extend({type:'dataset'});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var assert=assert$1;var each=each$1;var isFunction=isFunction$1;var isObject=isObject$1;var parseClassType=ComponentModel.parseClassType;var version='4.1.0';var dependencies={zrender:'4.0.4'};var TEST_FRAME_REMAIN_TIME=1;var PRIORITY_PROCESSOR_FILTER=1000;var PRIORITY_PROCESSOR_STATISTIC=5000;var PRIORITY_VISUAL_LAYOUT=1000;var PRIORITY_VISUAL_GLOBAL=2000;var PRIORITY_VISUAL_CHART=3000;var PRIORITY_VISUAL_COMPONENT=4000;// FIXME
// necessary?
var PRIORITY_VISUAL_BRUSH=5000;var PRIORITY={PROCESSOR:{FILTER:PRIORITY_PROCESSOR_FILTER,STATISTIC:PRIORITY_PROCESSOR_STATISTIC},VISUAL:{LAYOUT:PRIORITY_VISUAL_LAYOUT,GLOBAL:PRIORITY_VISUAL_GLOBAL,CHART:PRIORITY_VISUAL_CHART,COMPONENT:PRIORITY_VISUAL_COMPONENT,BRUSH:PRIORITY_VISUAL_BRUSH}};// Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var IN_MAIN_PROCESS='__flagInMainProcess';var OPTION_UPDATED='__optionUpdated';var ACTION_REG=/^[a-zA-Z0-9_]+$/;function createRegisterEventWithLowercaseName(method){return function(eventName,handler,context){// Event name is all lowercase
eventName=eventName&&eventName.toLowerCase();Eventful.prototype[method].call(this,eventName,handler,context);};}/**
 * @module echarts~MessageCenter
 */function MessageCenter(){Eventful.call(this);}MessageCenter.prototype.on=createRegisterEventWithLowercaseName('on');MessageCenter.prototype.off=createRegisterEventWithLowercaseName('off');MessageCenter.prototype.one=createRegisterEventWithLowercaseName('one');mixin(MessageCenter,Eventful);/**
 * @module echarts~ECharts
 */function ECharts(dom,theme$$1,opts){opts=opts||{};// Get theme by name
if(typeof theme$$1==='string'){theme$$1=themeStorage[theme$$1];}/**
   * @type {string}
   */this.id;/**
   * Group id
   * @type {string}
   */this.group;/**
   * @type {HTMLElement}
   * @private
   */this._dom=dom;var defaultRenderer='canvas';/**
   * @type {module:zrender/ZRender}
   * @private
   */var zr=this._zr=init$1(dom,{renderer:opts.renderer||defaultRenderer,devicePixelRatio:opts.devicePixelRatio,width:opts.width,height:opts.height});/**
   * Expect 60 pfs.
   * @type {Function}
   * @private
   */this._throttledZrFlush=throttle(bind(zr.flush,zr),17);var theme$$1=_clone(theme$$1);theme$$1&&backwardCompat(theme$$1,true);/**
   * @type {Object}
   * @private
   */this._theme=theme$$1;/**
   * @type {Array.<module:echarts/view/Chart>}
   * @private
   */this._chartsViews=[];/**
   * @type {Object.<string, module:echarts/view/Chart>}
   * @private
   */this._chartsMap={};/**
   * @type {Array.<module:echarts/view/Component>}
   * @private
   */this._componentsViews=[];/**
   * @type {Object.<string, module:echarts/view/Component>}
   * @private
   */this._componentsMap={};/**
   * @type {module:echarts/CoordinateSystem}
   * @private
   */this._coordSysMgr=new CoordinateSystemManager();/**
   * @type {module:echarts/ExtensionAPI}
   * @private
   */var api=this._api=createExtensionAPI(this);// Sort on demand
function prioritySortFunc(a,b){return a.__prio-b.__prio;}sort(visualFuncs,prioritySortFunc);sort(dataProcessorFuncs,prioritySortFunc);/**
   * @type {module:echarts/stream/Scheduler}
   */this._scheduler=new Scheduler(this,api,dataProcessorFuncs,visualFuncs);Eventful.call(this);/**
   * @type {module:echarts~MessageCenter}
   * @private
   */this._messageCenter=new MessageCenter();// Init mouse events
this._initEvents();// In case some people write `window.onresize = chart.resize`
this.resize=bind(this.resize,this);// Can't dispatch action during rendering procedure
this._pendingActions=[];zr.animation.on('frame',this._onframe,this);bindRenderedEvent(zr,this);// ECharts instance can be used as value.
setAsPrimitive(this);}var echartsProto=ECharts.prototype;echartsProto._onframe=function(){if(this._disposed){return;}var scheduler=this._scheduler;// Lazy update
if(this[OPTION_UPDATED]){var silent=this[OPTION_UPDATED].silent;this[IN_MAIN_PROCESS]=true;prepare(this);updateMethods.update.call(this);this[IN_MAIN_PROCESS]=false;this[OPTION_UPDATED]=false;flushPendingActions.call(this,silent);triggerUpdatedEvent.call(this,silent);}// Avoid do both lazy update and progress in one frame.
else if(scheduler.unfinished){// Stream progress.
var remainTime=TEST_FRAME_REMAIN_TIME;var ecModel=this._model;var api=this._api;scheduler.unfinished=false;do{var startTime=+new Date();scheduler.performSeriesTasks(ecModel);// Currently dataProcessorFuncs do not check threshold.
scheduler.performDataProcessorTasks(ecModel);updateStreamModes(this,ecModel);// Do not update coordinate system here. Because that coord system update in
// each frame is not a good user experience. So we follow the rule that
// the extent of the coordinate system is determin in the first frame (the
// frame is executed immedietely after task reset.
// this._coordSysMgr.update(ecModel, api);
// console.log('--- ec frame visual ---', remainTime);
scheduler.performVisualTasks(ecModel);renderSeries(this,this._model,api,'remain');remainTime-=+new Date()-startTime;}while(remainTime>0&&scheduler.unfinished);// Call flush explicitly for trigger finished event.
if(!scheduler.unfinished){this._zr.flush();}// Else, zr flushing be ensue within the same frame,
// because zr flushing is after onframe event.
}};/**
 * @return {HTMLElement}
 */echartsProto.getDom=function(){return this._dom;};/**
 * @return {module:zrender~ZRender}
 */echartsProto.getZr=function(){return this._zr;};/**
 * Usage:
 * chart.setOption(option, notMerge, lazyUpdate);
 * chart.setOption(option, {
 *     notMerge: ...,
 *     lazyUpdate: ...,
 *     silent: ...
 * });
 *
 * @param {Object} option
 * @param {Object|boolean} [opts] opts or notMerge.
 * @param {boolean} [opts.notMerge=false]
 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
 */echartsProto.setOption=function(option,notMerge,lazyUpdate){var silent;if(isObject(notMerge)){lazyUpdate=notMerge.lazyUpdate;silent=notMerge.silent;notMerge=notMerge.notMerge;}this[IN_MAIN_PROCESS]=true;if(!this._model||notMerge){var optionManager=new OptionManager(this._api);var theme$$1=this._theme;var ecModel=this._model=new GlobalModel(null,null,theme$$1,optionManager);ecModel.scheduler=this._scheduler;ecModel.init(null,null,theme$$1,optionManager);}this._model.setOption(option,optionPreprocessorFuncs);if(lazyUpdate){this[OPTION_UPDATED]={silent:silent};this[IN_MAIN_PROCESS]=false;}else{prepare(this);updateMethods.update.call(this);// Ensure zr refresh sychronously, and then pixel in canvas can be
// fetched after `setOption`.
this._zr.flush();this[OPTION_UPDATED]=false;this[IN_MAIN_PROCESS]=false;flushPendingActions.call(this,silent);triggerUpdatedEvent.call(this,silent);}};/**
 * @DEPRECATED
 */echartsProto.setTheme=function(){console.log('ECharts#setTheme() is DEPRECATED in ECharts 3.0');};/**
 * @return {module:echarts/model/Global}
 */echartsProto.getModel=function(){return this._model;};/**
 * @return {Object}
 */echartsProto.getOption=function(){return this._model&&this._model.getOption();};/**
 * @return {number}
 */echartsProto.getWidth=function(){return this._zr.getWidth();};/**
 * @return {number}
 */echartsProto.getHeight=function(){return this._zr.getHeight();};/**
 * @return {number}
 */echartsProto.getDevicePixelRatio=function(){return this._zr.painter.dpr||window.devicePixelRatio||1;};/**
 * Get canvas which has all thing rendered
 * @param {Object} opts
 * @param {string} [opts.backgroundColor]
 * @return {string}
 */echartsProto.getRenderedCanvas=function(opts){if(!env$1.canvasSupported){return;}opts=opts||{};opts.pixelRatio=opts.pixelRatio||1;opts.backgroundColor=opts.backgroundColor||this._model.get('backgroundColor');var zr=this._zr;// var list = zr.storage.getDisplayList();
// Stop animations
// Never works before in init animation, so remove it.
// zrUtil.each(list, function (el) {
//     el.stopAnimation(true);
// });
return zr.painter.getRenderedCanvas(opts);};/**
 * Get svg data url
 * @return {string}
 */echartsProto.getSvgDataUrl=function(){if(!env$1.svgSupported){return;}var zr=this._zr;var list=zr.storage.getDisplayList();// Stop animations
each$1(list,function(el){el.stopAnimation(true);});return zr.painter.pathToDataUrl();};/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 * @param {string} [opts.excludeComponents]
 */echartsProto.getDataURL=function(opts){opts=opts||{};var excludeComponents=opts.excludeComponents;var ecModel=this._model;var excludesComponentViews=[];var self=this;each(excludeComponents,function(componentType){ecModel.eachComponent({mainType:componentType},function(component){var view=self._componentsMap[component.__viewId];if(!view.group.ignore){excludesComponentViews.push(view);view.group.ignore=true;}});});var url=this._zr.painter.getType()==='svg'?this.getSvgDataUrl():this.getRenderedCanvas(opts).toDataURL('image/'+(opts&&opts.type||'png'));each(excludesComponentViews,function(view){view.group.ignore=false;});return url;};/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 */echartsProto.getConnectedDataURL=function(opts){if(!env$1.canvasSupported){return;}var groupId=this.group;var mathMin=Math.min;var mathMax=Math.max;var MAX_NUMBER=Infinity;if(connectedGroups[groupId]){var left=MAX_NUMBER;var top=MAX_NUMBER;var right=-MAX_NUMBER;var bottom=-MAX_NUMBER;var canvasList=[];var dpr=opts&&opts.pixelRatio||1;each$1(instances,function(chart,id){if(chart.group===groupId){var canvas=chart.getRenderedCanvas(_clone(opts));var boundingRect=chart.getDom().getBoundingClientRect();left=mathMin(boundingRect.left,left);top=mathMin(boundingRect.top,top);right=mathMax(boundingRect.right,right);bottom=mathMax(boundingRect.bottom,bottom);canvasList.push({dom:canvas,left:boundingRect.left,top:boundingRect.top});}});left*=dpr;top*=dpr;right*=dpr;bottom*=dpr;var width=right-left;var height=bottom-top;var targetCanvas=createCanvas();targetCanvas.width=width;targetCanvas.height=height;var zr=init$1(targetCanvas);each(canvasList,function(item){var img=new ZImage({style:{x:item.left*dpr-left,y:item.top*dpr-top,image:item.dom}});zr.add(img);});zr.refreshImmediately();return targetCanvas.toDataURL('image/'+(opts&&opts.type||'png'));}else{return this.getDataURL(opts);}};/**
 * Convert from logical coordinate system to pixel coordinate system.
 * See CoordinateSystem#convertToPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId, geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */echartsProto.convertToPixel=curry(doConvertPixel,'convertToPixel');/**
 * Convert from pixel coordinate system to logical coordinate system.
 * See CoordinateSystem#convertFromPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */echartsProto.convertFromPixel=curry(doConvertPixel,'convertFromPixel');function doConvertPixel(methodName,finder,value){var ecModel=this._model;var coordSysList=this._coordSysMgr.getCoordinateSystems();var result;finder=parseFinder(ecModel,finder);for(var i=0;i<coordSysList.length;i++){var coordSys=coordSysList[i];if(coordSys[methodName]&&(result=coordSys[methodName](ecModel,finder,value))!=null){return result;}}}/**
 * Is the specified coordinate systems or components contain the given pixel point.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {boolean} result
 */echartsProto.containPixel=function(finder,value){var ecModel=this._model;var result;finder=parseFinder(ecModel,finder);each$1(finder,function(models,key){key.indexOf('Models')>=0&&each$1(models,function(model){var coordSys=model.coordinateSystem;if(coordSys&&coordSys.containPoint){result|=!!coordSys.containPoint(value);}else if(key==='seriesModels'){var view=this._chartsMap[model.__viewId];if(view&&view.containPoint){result|=view.containPoint(value,model);}else{}}else{}},this);},this);return!!result;};/**
 * Get visual from series or data.
 * @param {string|Object} finder
 *        If string, e.g., 'series', means {seriesIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            dataIndex / dataIndexInside
 *        }
 *        If dataIndex is not specified, series visual will be fetched,
 *        but not data item visual.
 *        If all of seriesIndex, seriesId, seriesName are not specified,
 *        visual will be fetched from first series.
 * @param {string} visualType 'color', 'symbol', 'symbolSize'
 */echartsProto.getVisual=function(finder,visualType){var ecModel=this._model;finder=parseFinder(ecModel,finder,{defaultMainType:'series'});var seriesModel=finder.seriesModel;var data=seriesModel.getData();var dataIndexInside=finder.hasOwnProperty('dataIndexInside')?finder.dataIndexInside:finder.hasOwnProperty('dataIndex')?data.indexOfRawIndex(finder.dataIndex):null;return dataIndexInside!=null?data.getItemVisual(dataIndexInside,visualType):data.getVisual(visualType);};/**
 * Get view of corresponding component model
 * @param  {module:echarts/model/Component} componentModel
 * @return {module:echarts/view/Component}
 */echartsProto.getViewOfComponentModel=function(componentModel){return this._componentsMap[componentModel.__viewId];};/**
 * Get view of corresponding series model
 * @param  {module:echarts/model/Series} seriesModel
 * @return {module:echarts/view/Chart}
 */echartsProto.getViewOfSeriesModel=function(seriesModel){return this._chartsMap[seriesModel.__viewId];};var updateMethods={prepareAndUpdate:function prepareAndUpdate(payload){prepare(this);updateMethods.update.call(this,payload);},/**
   * @param {Object} payload
   * @private
   */update:function update(payload){// console.profile && console.profile('update');
var ecModel=this._model;var api=this._api;var zr=this._zr;var coordSysMgr=this._coordSysMgr;var scheduler=this._scheduler;// update before setOption
if(!ecModel){return;}scheduler.restoreData(ecModel,payload);scheduler.performSeriesTasks(ecModel);// TODO
// Save total ecModel here for undo/redo (after restoring data and before processing data).
// Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
// Create new coordinate system each update
// In LineView may save the old coordinate system and use it to get the orignal point
coordSysMgr.create(ecModel,api);scheduler.performDataProcessorTasks(ecModel,payload);// Current stream render is not supported in data process. So we can update
// stream modes after data processing, where the filtered data is used to
// deteming whether use progressive rendering.
updateStreamModes(this,ecModel);// We update stream modes before coordinate system updated, then the modes info
// can be fetched when coord sys updating (consider the barGrid extent fix). But
// the drawback is the full coord info can not be fetched. Fortunately this full
// coord is not requied in stream mode updater currently.
coordSysMgr.update(ecModel,api);clearColorPalette(ecModel);scheduler.performVisualTasks(ecModel,payload);render(this,ecModel,api,payload);// Set background
var backgroundColor=ecModel.get('backgroundColor')||'transparent';// In IE8
if(!env$1.canvasSupported){var colorArr=parse(backgroundColor);backgroundColor=stringify(colorArr,'rgb');if(colorArr[3]===0){backgroundColor='transparent';}}else{zr.setBackgroundColor(backgroundColor);}performPostUpdateFuncs(ecModel,api);// console.profile && console.profileEnd('update');
},/**
   * @param {Object} payload
   * @private
   */updateTransform:function updateTransform(payload){var ecModel=this._model;var ecIns=this;var api=this._api;// update before setOption
if(!ecModel){return;}// ChartView.markUpdateMethod(payload, 'updateTransform');
var componentDirtyList=[];ecModel.eachComponent(function(componentType,componentModel){var componentView=ecIns.getViewOfComponentModel(componentModel);if(componentView&&componentView.__alive){if(componentView.updateTransform){var result=componentView.updateTransform(componentModel,ecModel,api,payload);result&&result.update&&componentDirtyList.push(componentView);}else{componentDirtyList.push(componentView);}}});var seriesDirtyMap=createHashMap();ecModel.eachSeries(function(seriesModel){var chartView=ecIns._chartsMap[seriesModel.__viewId];if(chartView.updateTransform){var result=chartView.updateTransform(seriesModel,ecModel,api,payload);result&&result.update&&seriesDirtyMap.set(seriesModel.uid,1);}else{seriesDirtyMap.set(seriesModel.uid,1);}});clearColorPalette(ecModel);// Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
// this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
this._scheduler.performVisualTasks(ecModel,payload,{setDirty:true,dirtyMap:seriesDirtyMap});// Currently, not call render of components. Geo render cost a lot.
// renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
renderSeries(ecIns,ecModel,api,payload,seriesDirtyMap);performPostUpdateFuncs(ecModel,this._api);},/**
   * @param {Object} payload
   * @private
   */updateView:function updateView(payload){var ecModel=this._model;// update before setOption
if(!ecModel){return;}Chart.markUpdateMethod(payload,'updateView');clearColorPalette(ecModel);// Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
this._scheduler.performVisualTasks(ecModel,payload,{setDirty:true});render(this,this._model,this._api,payload);performPostUpdateFuncs(ecModel,this._api);},/**
   * @param {Object} payload
   * @private
   */updateVisual:function updateVisual(payload){updateMethods.update.call(this,payload);// var ecModel = this._model;
// // update before setOption
// if (!ecModel) {
//     return;
// }
// ChartView.markUpdateMethod(payload, 'updateVisual');
// clearColorPalette(ecModel);
// // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
// this._scheduler.performVisualTasks(ecModel, payload, {visualType: 'visual', setDirty: true});
// render(this, this._model, this._api, payload);
// performPostUpdateFuncs(ecModel, this._api);
},/**
   * @param {Object} payload
   * @private
   */updateLayout:function updateLayout(payload){updateMethods.update.call(this,payload);// var ecModel = this._model;
// // update before setOption
// if (!ecModel) {
//     return;
// }
// ChartView.markUpdateMethod(payload, 'updateLayout');
// // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
// // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
// this._scheduler.performVisualTasks(ecModel, payload, {setDirty: true});
// render(this, this._model, this._api, payload);
// performPostUpdateFuncs(ecModel, this._api);
}};function prepare(ecIns){var ecModel=ecIns._model;var scheduler=ecIns._scheduler;scheduler.restorePipelines(ecModel);scheduler.prepareStageTasks();prepareView(ecIns,'component',ecModel,scheduler);prepareView(ecIns,'chart',ecModel,scheduler);scheduler.plan();}/**
 * @private
 */function updateDirectly(ecIns,method,payload,mainType,subType){var ecModel=ecIns._model;// broadcast
if(!mainType){// FIXME
// Chart will not be update directly here, except set dirty.
// But there is no such scenario now.
each(ecIns._componentsViews.concat(ecIns._chartsViews),callView);return;}var query={};query[mainType+'Id']=payload[mainType+'Id'];query[mainType+'Index']=payload[mainType+'Index'];query[mainType+'Name']=payload[mainType+'Name'];var condition={mainType:mainType,query:query};subType&&(condition.subType=subType);// subType may be '' by parseClassType;
var excludeSeriesId=payload.excludeSeriesId;if(excludeSeriesId!=null){excludeSeriesId=createHashMap(normalizeToArray(excludeSeriesId));}// If dispatchAction before setOption, do nothing.
ecModel&&ecModel.eachComponent(condition,function(model){if(!excludeSeriesId||excludeSeriesId.get(model.id)==null){callView(ecIns[mainType==='series'?'_chartsMap':'_componentsMap'][model.__viewId]);}},ecIns);function callView(view){view&&view.__alive&&view[method]&&view[method](view.__model,ecModel,ecIns._api,payload);}}/**
 * Resize the chart
 * @param {Object} opts
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 * @param {boolean} [opts.silent=false]
 */echartsProto.resize=function(opts){this._zr.resize(opts);var ecModel=this._model;// Resize loading effect
this._loadingFX&&this._loadingFX.resize();if(!ecModel){return;}var optionChanged=ecModel.resetOption('media');var silent=opts&&opts.silent;this[IN_MAIN_PROCESS]=true;optionChanged&&prepare(this);updateMethods.update.call(this);this[IN_MAIN_PROCESS]=false;flushPendingActions.call(this,silent);triggerUpdatedEvent.call(this,silent);};function updateStreamModes(ecIns,ecModel){var chartsMap=ecIns._chartsMap;var scheduler=ecIns._scheduler;ecModel.eachSeries(function(seriesModel){scheduler.updateStreamModes(seriesModel,chartsMap[seriesModel.__viewId]);});}/**
 * Show loading effect
 * @param  {string} [name='default']
 * @param  {Object} [cfg]
 */echartsProto.showLoading=function(name,cfg){if(isObject(name)){cfg=name;name='';}name=name||'default';this.hideLoading();if(!loadingEffects[name]){return;}var el=loadingEffects[name](this._api,cfg);var zr=this._zr;this._loadingFX=el;zr.add(el);};/**
 * Hide loading effect
 */echartsProto.hideLoading=function(){this._loadingFX&&this._zr.remove(this._loadingFX);this._loadingFX=null;};/**
 * @param {Object} eventObj
 * @return {Object}
 */echartsProto.makeActionFromEvent=function(eventObj){var payload=extend({},eventObj);payload.type=eventActionMap[eventObj.type];return payload;};/**
 * @pubilc
 * @param {Object} payload
 * @param {string} [payload.type] Action type
 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
 * @param {boolean} [opt.silent=false] Whether trigger events.
 * @param {boolean} [opt.flush=undefined]
 *                  true: Flush immediately, and then pixel in canvas can be fetched
 *                      immediately. Caution: it might affect performance.
 *                  false: Not not flush.
 *                  undefined: Auto decide whether perform flush.
 */echartsProto.dispatchAction=function(payload,opt){if(!isObject(opt)){opt={silent:!!opt};}if(!actions[payload.type]){return;}// Avoid dispatch action before setOption. Especially in `connect`.
if(!this._model){return;}// May dispatchAction in rendering procedure
if(this[IN_MAIN_PROCESS]){this._pendingActions.push(payload);return;}doDispatchAction.call(this,payload,opt.silent);if(opt.flush){this._zr.flush(true);}else if(opt.flush!==false&&env$1.browser.weChat){// In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
// hang when sliding page (on touch event), which cause that zr does not
// refresh util user interaction finished, which is not expected.
// But `dispatchAction` may be called too frequently when pan on touch
// screen, which impacts performance if do not throttle them.
this._throttledZrFlush();}flushPendingActions.call(this,opt.silent);triggerUpdatedEvent.call(this,opt.silent);};function doDispatchAction(payload,silent){var payloadType=payload.type;var escapeConnect=payload.escapeConnect;var actionWrap=actions[payloadType];var actionInfo=actionWrap.actionInfo;var cptType=(actionInfo.update||'update').split(':');var updateMethod=cptType.pop();cptType=cptType[0]!=null&&parseClassType(cptType[0]);this[IN_MAIN_PROCESS]=true;var payloads=[payload];var batched=false;// Batch action
if(payload.batch){batched=true;payloads=map(payload.batch,function(item){item=defaults(extend({},item),payload);item.batch=null;return item;});}var eventObjBatch=[];var eventObj;var isHighDown=payloadType==='highlight'||payloadType==='downplay';each(payloads,function(batchItem){// Action can specify the event by return it.
eventObj=actionWrap.action(batchItem,this._model,this._api);// Emit event outside
eventObj=eventObj||extend({},batchItem);// Convert type to eventType
eventObj.type=actionInfo.event||eventObj.type;eventObjBatch.push(eventObj);// light update does not perform data process, layout and visual.
if(isHighDown){// method, payload, mainType, subType
updateDirectly(this,updateMethod,batchItem,'series');}else if(cptType){updateDirectly(this,updateMethod,batchItem,cptType.main,cptType.sub);}},this);if(updateMethod!=='none'&&!isHighDown&&!cptType){// Still dirty
if(this[OPTION_UPDATED]){// FIXME Pass payload ?
prepare(this);updateMethods.update.call(this,payload);this[OPTION_UPDATED]=false;}else{updateMethods[updateMethod].call(this,payload);}}// Follow the rule of action batch
if(batched){eventObj={type:actionInfo.event||payloadType,escapeConnect:escapeConnect,batch:eventObjBatch};}else{eventObj=eventObjBatch[0];}this[IN_MAIN_PROCESS]=false;!silent&&this._messageCenter.trigger(eventObj.type,eventObj);}function flushPendingActions(silent){var pendingActions=this._pendingActions;while(pendingActions.length){var payload=pendingActions.shift();doDispatchAction.call(this,payload,silent);}}function triggerUpdatedEvent(silent){!silent&&this.trigger('updated');}/**
 * Event `rendered` is triggered when zr
 * rendered. It is useful for realtime
 * snapshot (reflect animation).
 *
 * Event `finished` is triggered when:
 * (1) zrender rendering finished.
 * (2) initial animation finished.
 * (3) progressive rendering finished.
 * (4) no pending action.
 * (5) no delayed setOption needs to be processed.
 */function bindRenderedEvent(zr,ecIns){zr.on('rendered',function(){ecIns.trigger('rendered');// The `finished` event should not be triggered repeatly,
// so it should only be triggered when rendering indeed happend
// in zrender. (Consider the case that dipatchAction is keep
// triggering when mouse move).
if(// Although zr is dirty if initial animation is not finished
// and this checking is called on frame, we also check
// animation finished for robustness.
zr.animation.isFinished()&&!ecIns[OPTION_UPDATED]&&!ecIns._scheduler.unfinished&&!ecIns._pendingActions.length){ecIns.trigger('finished');}});}/**
 * @param {Object} params
 * @param {number} params.seriesIndex
 * @param {Array|TypedArray} params.data
 */echartsProto.appendData=function(params){var seriesIndex=params.seriesIndex;var ecModel=this.getModel();var seriesModel=ecModel.getSeriesByIndex(seriesIndex);seriesModel.appendData(params);// Note: `appendData` does not support that update extent of coordinate
// system, util some scenario require that. In the expected usage of
// `appendData`, the initial extent of coordinate system should better
// be fixed by axis `min`/`max` setting or initial data, otherwise if
// the extent changed while `appendData`, the location of the painted
// graphic elements have to be changed, which make the usage of
// `appendData` meaningless.
this._scheduler.unfinished=true;};/**
 * Register event
 * @method
 */echartsProto.on=createRegisterEventWithLowercaseName('on');echartsProto.off=createRegisterEventWithLowercaseName('off');echartsProto.one=createRegisterEventWithLowercaseName('one');/**
 * Prepare view instances of charts and components
 * @param  {module:echarts/model/Global} ecModel
 * @private
 */function prepareView(ecIns,type,ecModel,scheduler){var isComponent=type==='component';var viewList=isComponent?ecIns._componentsViews:ecIns._chartsViews;var viewMap=isComponent?ecIns._componentsMap:ecIns._chartsMap;var zr=ecIns._zr;var api=ecIns._api;for(var i=0;i<viewList.length;i++){viewList[i].__alive=false;}isComponent?ecModel.eachComponent(function(componentType,model){componentType!=='series'&&doPrepare(model);}):ecModel.eachSeries(doPrepare);function doPrepare(model){// Consider: id same and type changed.
var viewId='_ec_'+model.id+'_'+model.type;var view=viewMap[viewId];if(!view){var classType=parseClassType(model.type);var Clazz=isComponent?Component$1.getClass(classType.main,classType.sub):Chart.getClass(classType.sub);view=new Clazz();view.init(ecModel,api);viewMap[viewId]=view;viewList.push(view);zr.add(view.group);}model.__viewId=view.__id=viewId;view.__alive=true;view.__model=model;view.group.__ecComponentInfo={mainType:model.mainType,index:model.componentIndex};!isComponent&&scheduler.prepareView(view,model,ecModel,api);}for(var i=0;i<viewList.length;){var view=viewList[i];if(!view.__alive){!isComponent&&view.renderTask.dispose();zr.remove(view.group);view.dispose(ecModel,api);viewList.splice(i,1);delete viewMap[view.__id];view.__id=view.group.__ecComponentInfo=null;}else{i++;}}}// /**
//  * Encode visual infomation from data after data processing
//  *
//  * @param {module:echarts/model/Global} ecModel
//  * @param {object} layout
//  * @param {boolean} [layoutFilter] `true`: only layout,
//  *                                 `false`: only not layout,
//  *                                 `null`/`undefined`: all.
//  * @param {string} taskBaseTag
//  * @private
//  */
// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
//     each(visualFuncs, function (visual, index) {
//         var isLayout = visual.isLayout;
//         if (layoutFilter == null
//             || (layoutFilter === false && !isLayout)
//             || (layoutFilter === true && isLayout)
//         ) {
//             visual.func(ecModel, api, payload);
//         }
//     });
// }
function clearColorPalette(ecModel){ecModel.clearColorPalette();ecModel.eachSeries(function(seriesModel){seriesModel.clearColorPalette();});}function render(ecIns,ecModel,api,payload){renderComponents(ecIns,ecModel,api,payload);each(ecIns._chartsViews,function(chart){chart.__alive=false;});renderSeries(ecIns,ecModel,api,payload);// Remove groups of unrendered charts
each(ecIns._chartsViews,function(chart){if(!chart.__alive){chart.remove(ecModel,api);}});}function renderComponents(ecIns,ecModel,api,payload,dirtyList){each(dirtyList||ecIns._componentsViews,function(componentView){var componentModel=componentView.__model;componentView.render(componentModel,ecModel,api,payload);updateZ(componentModel,componentView);});}/**
 * Render each chart and component
 * @private
 */function renderSeries(ecIns,ecModel,api,payload,dirtyMap){// Render all charts
var scheduler=ecIns._scheduler;var unfinished;ecModel.eachSeries(function(seriesModel){var chartView=ecIns._chartsMap[seriesModel.__viewId];chartView.__alive=true;var renderTask=chartView.renderTask;scheduler.updatePayload(renderTask,payload);if(dirtyMap&&dirtyMap.get(seriesModel.uid)){renderTask.dirty();}unfinished|=renderTask.perform(scheduler.getPerformArgs(renderTask));chartView.group.silent=!!seriesModel.get('silent');updateZ(seriesModel,chartView);updateBlend(seriesModel,chartView);});scheduler.unfinished|=unfinished;// If use hover layer
updateHoverLayerStatus(ecIns._zr,ecModel);// Add aria
aria(ecIns._zr.dom,ecModel);}function performPostUpdateFuncs(ecModel,api){each(postUpdateFuncs,function(func){func(ecModel,api);});}var MOUSE_EVENT_NAMES=['click','dblclick','mouseover','mouseout','mousemove','mousedown','mouseup','globalout','contextmenu'];/**
 * @private
 */echartsProto._initEvents=function(){each(MOUSE_EVENT_NAMES,function(eveName){this._zr.on(eveName,function(e){var ecModel=this.getModel();var el=e.target;var params;// no e.target when 'globalout'.
if(eveName==='globalout'){params={};}else if(el&&el.dataIndex!=null){var dataModel=el.dataModel||ecModel.getSeriesByIndex(el.seriesIndex);params=dataModel&&dataModel.getDataParams(el.dataIndex,el.dataType)||{};}// If element has custom eventData of components
else if(el&&el.eventData){params=extend({},el.eventData);}if(params){params.event=e;params.type=eveName;this.trigger(eveName,params);}},this);},this);each(eventActionMap,function(actionType,eventType){this._messageCenter.on(eventType,function(event){this.trigger(eventType,event);},this);},this);};/**
 * @return {boolean}
 */echartsProto.isDisposed=function(){return this._disposed;};/**
 * Clear
 */echartsProto.clear=function(){this.setOption({series:[]},true);};/**
 * Dispose instance
 */echartsProto.dispose=function(){if(this._disposed){return;}this._disposed=true;setAttribute(this.getDom(),DOM_ATTRIBUTE_KEY,'');var api=this._api;var ecModel=this._model;each(this._componentsViews,function(component){component.dispose(ecModel,api);});each(this._chartsViews,function(chart){chart.dispose(ecModel,api);});// Dispose after all views disposed
this._zr.dispose();delete instances[this.id];};mixin(ECharts,Eventful);function updateHoverLayerStatus(zr,ecModel){var storage=zr.storage;var elCount=0;storage.traverse(function(el){if(!el.isGroup){elCount++;}});if(elCount>ecModel.get('hoverLayerThreshold')&&!env$1.node){storage.traverse(function(el){if(!el.isGroup){// Don't switch back.
el.useHoverLayer=true;}});}}/**
 * Update chart progressive and blend.
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */function updateBlend(seriesModel,chartView){var blendMode=seriesModel.get('blendMode')||null;chartView.group.traverse(function(el){// FIXME marker and other components
if(!el.isGroup){// Only set if blendMode is changed. In case element is incremental and don't wan't to rerender.
if(el.style.blend!==blendMode){el.setStyle('blend',blendMode);}}if(el.eachPendingDisplayable){el.eachPendingDisplayable(function(displayable){displayable.setStyle('blend',blendMode);});}});}/**
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */function updateZ(model,view){var z=model.get('z');var zlevel=model.get('zlevel');// Set z and zlevel
view.group.traverse(function(el){if(el.type!=='group'){z!=null&&(el.z=z);zlevel!=null&&(el.zlevel=zlevel);}});}function createExtensionAPI(ecInstance){var coordSysMgr=ecInstance._coordSysMgr;return extend(new ExtensionAPI(ecInstance),{// Inject methods
getCoordinateSystems:bind(coordSysMgr.getCoordinateSystems,coordSysMgr),getComponentByElement:function getComponentByElement(el){while(el){var modelInfo=el.__ecComponentInfo;if(modelInfo!=null){return ecInstance._model.getComponent(modelInfo.mainType,modelInfo.index);}el=el.parent;}}});}/**
 * @type {Object} key: actionType.
 * @inner
 */var actions={};/**
 * Map eventType to actionType
 * @type {Object}
 */var eventActionMap={};/**
 * Data processor functions of each stage
 * @type {Array.<Object.<string, Function>>}
 * @inner
 */var dataProcessorFuncs=[];/**
 * @type {Array.<Function>}
 * @inner
 */var optionPreprocessorFuncs=[];/**
 * @type {Array.<Function>}
 * @inner
 */var postUpdateFuncs=[];/**
 * Visual encoding functions of each stage
 * @type {Array.<Object.<string, Function>>}
 */var visualFuncs=[];/**
 * Theme storage
 * @type {Object.<key, Object>}
 */var themeStorage={};/**
 * Loading effects
 */var loadingEffects={};var instances={};var connectedGroups={};var idBase=new Date()-0;var groupIdBase=new Date()-0;var DOM_ATTRIBUTE_KEY='_echarts_instance_';var mapDataStores={};function enableConnect(chart){var STATUS_PENDING=0;var STATUS_UPDATING=1;var STATUS_UPDATED=2;var STATUS_KEY='__connectUpdateStatus';function updateConnectedChartsStatus(charts,status){for(var i=0;i<charts.length;i++){var otherChart=charts[i];otherChart[STATUS_KEY]=status;}}each(eventActionMap,function(actionType,eventType){chart._messageCenter.on(eventType,function(event){if(connectedGroups[chart.group]&&chart[STATUS_KEY]!==STATUS_PENDING){if(event&&event.escapeConnect){return;}var action=chart.makeActionFromEvent(event);var otherCharts=[];each(instances,function(otherChart){if(otherChart!==chart&&otherChart.group===chart.group){otherCharts.push(otherChart);}});updateConnectedChartsStatus(otherCharts,STATUS_PENDING);each(otherCharts,function(otherChart){if(otherChart[STATUS_KEY]!==STATUS_UPDATING){otherChart.dispatchAction(action);}});updateConnectedChartsStatus(otherCharts,STATUS_UPDATED);}});});}/**
 * @param {HTMLElement} dom
 * @param {Object} [theme]
 * @param {Object} opts
 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
 * @param {string} [opts.renderer] Currently only 'canvas' is supported.
 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
 *                              Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
 *                               Can be 'auto' (the same as null/undefined)
 */function init(dom,theme$$1,opts){var existInstance=getInstanceByDom(dom);if(existInstance){return existInstance;}var chart=new ECharts(dom,theme$$1,opts);chart.id='ec_'+idBase++;instances[chart.id]=chart;setAttribute(dom,DOM_ATTRIBUTE_KEY,chart.id);enableConnect(chart);return chart;}/**
 * @return {string|Array.<module:echarts~ECharts>} groupId
 */function connect(groupId){// Is array of charts
if(isArray(groupId)){var charts=groupId;groupId=null;// If any chart has group
each(charts,function(chart){if(chart.group!=null){groupId=chart.group;}});groupId=groupId||'g_'+groupIdBase++;each(charts,function(chart){chart.group=groupId;});}connectedGroups[groupId]=true;return groupId;}/**
 * @DEPRECATED
 * @return {string} groupId
 */function disConnect(groupId){connectedGroups[groupId]=false;}/**
 * @return {string} groupId
 */var disconnect=disConnect;/**
 * Dispose a chart instance
 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
 */function dispose(chart){if(typeof chart==='string'){chart=instances[chart];}else if(!(chart instanceof ECharts)){// Try to treat as dom
chart=getInstanceByDom(chart);}if(chart instanceof ECharts&&!chart.isDisposed()){chart.dispose();}}/**
 * @param  {HTMLElement} dom
 * @return {echarts~ECharts}
 */function getInstanceByDom(dom){return instances[getAttribute(dom,DOM_ATTRIBUTE_KEY)];}/**
 * @param {string} key
 * @return {echarts~ECharts}
 */function getInstanceById(key){return instances[key];}/**
 * Register theme
 */function registerTheme(name,theme$$1){themeStorage[name]=theme$$1;}/**
 * Register option preprocessor
 * @param {Function} preprocessorFunc
 */function registerPreprocessor(preprocessorFunc){optionPreprocessorFuncs.push(preprocessorFunc);}/**
 * @param {number} [priority=1000]
 * @param {Object|Function} processor
 */function registerProcessor(priority,processor){normalizeRegister(dataProcessorFuncs,priority,processor,PRIORITY_PROCESSOR_FILTER);}/**
 * Register postUpdater
 * @param {Function} postUpdateFunc
 */function registerPostUpdate(postUpdateFunc){postUpdateFuncs.push(postUpdateFunc);}/**
 * Usage:
 * registerAction('someAction', 'someEvent', function () { ... });
 * registerAction('someAction', function () { ... });
 * registerAction(
 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
 *     function () { ... }
 * );
 *
 * @param {(string|Object)} actionInfo
 * @param {string} actionInfo.type
 * @param {string} [actionInfo.event]
 * @param {string} [actionInfo.update]
 * @param {string} [eventName]
 * @param {Function} action
 */function registerAction(actionInfo,eventName,action){if(typeof eventName==='function'){action=eventName;eventName='';}var actionType=isObject(actionInfo)?actionInfo.type:[actionInfo,actionInfo={event:eventName}][0];// Event name is all lowercase
actionInfo.event=(actionInfo.event||actionType).toLowerCase();eventName=actionInfo.event;// Validate action type and event name.
assert(ACTION_REG.test(actionType)&&ACTION_REG.test(eventName));if(!actions[actionType]){actions[actionType]={action:action,actionInfo:actionInfo};}eventActionMap[eventName]=actionType;}/**
 * @param {string} type
 * @param {*} CoordinateSystem
 */function registerCoordinateSystem(type,CoordinateSystem$$1){CoordinateSystemManager.register(type,CoordinateSystem$$1);}/**
 * Get dimensions of specified coordinate system.
 * @param {string} type
 * @return {Array.<string|Object>}
 */function getCoordinateSystemDimensions(type){var coordSysCreator=CoordinateSystemManager.get(type);if(coordSysCreator){return coordSysCreator.getDimensionsInfo?coordSysCreator.getDimensionsInfo():coordSysCreator.dimensions.slice();}}/**
 * Layout is a special stage of visual encoding
 * Most visual encoding like color are common for different chart
 * But each chart has it's own layout algorithm
 *
 * @param {number} [priority=1000]
 * @param {Function} layoutTask
 */function registerLayout(priority,layoutTask){normalizeRegister(visualFuncs,priority,layoutTask,PRIORITY_VISUAL_LAYOUT,'layout');}/**
 * @param {number} [priority=3000]
 * @param {module:echarts/stream/Task} visualTask
 */function registerVisual(priority,visualTask){normalizeRegister(visualFuncs,priority,visualTask,PRIORITY_VISUAL_CHART,'visual');}/**
 * @param {Object|Function} fn: {seriesType, createOnAllSeries, performRawSeries, reset}
 */function normalizeRegister(targetList,priority,fn,defaultPriority,visualType){if(isFunction(priority)||isObject(priority)){fn=priority;priority=defaultPriority;}var stageHandler=Scheduler.wrapStageHandler(fn,visualType);stageHandler.__prio=priority;stageHandler.__raw=fn;targetList.push(stageHandler);return stageHandler;}/**
 * @param {string} name
 */function registerLoading(name,loadingFx){loadingEffects[name]=loadingFx;}/**
 * @param {Object} opts
 * @param {string} [superClass]
 */function extendComponentModel(opts/*, superClass*/){// var Clazz = ComponentModel;
// if (superClass) {
//     var classType = parseClassType(superClass);
//     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
// }
return ComponentModel.extend(opts);}/**
 * @param {Object} opts
 * @param {string} [superClass]
 */function extendComponentView(opts/*, superClass*/){// var Clazz = ComponentView;
// if (superClass) {
//     var classType = parseClassType(superClass);
//     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
// }
return Component$1.extend(opts);}/**
 * @param {Object} opts
 * @param {string} [superClass]
 */function extendSeriesModel(opts/*, superClass*/){// var Clazz = SeriesModel;
// if (superClass) {
//     superClass = 'series.' + superClass.replace('series.', '');
//     var classType = parseClassType(superClass);
//     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
// }
return SeriesModel.extend(opts);}/**
 * @param {Object} opts
 * @param {string} [superClass]
 */function extendChartView(opts/*, superClass*/){// var Clazz = ChartView;
// if (superClass) {
//     superClass = superClass.replace('series.', '');
//     var classType = parseClassType(superClass);
//     Clazz = ChartView.getClass(classType.main, true);
// }
return Chart.extend(opts);}/**
 * ZRender need a canvas context to do measureText.
 * But in node environment canvas may be created by node-canvas.
 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
 *
 * Be careful of using it in the browser.
 *
 * @param {Function} creator
 * @example
 *     var Canvas = require('canvas');
 *     var echarts = require('echarts');
 *     echarts.setCanvasCreator(function () {
 *         // Small size is enough.
 *         return new Canvas(32, 32);
 *     });
 */function setCanvasCreator(creator){$override('createCanvas',creator);}/**
 * @param {string} mapName
 * @param {Object|string} geoJson
 * @param {Object} [specialAreas]
 *
 * @example
 *     $.get('USA.json', function (geoJson) {
 *         echarts.registerMap('USA', geoJson);
 *         // Or
 *         echarts.registerMap('USA', {
 *             geoJson: geoJson,
 *             specialAreas: {}
 *         })
 *     });
 */function registerMap(mapName,geoJson,specialAreas){if(geoJson.geoJson&&!geoJson.features){specialAreas=geoJson.specialAreas;geoJson=geoJson.geoJson;}if(typeof geoJson==='string'){geoJson=typeof JSON!=='undefined'&&JSON.parse?JSON.parse(geoJson):new Function('return ('+geoJson+');')();}mapDataStores[mapName]={geoJson:geoJson,specialAreas:specialAreas};}/**
 * @param {string} mapName
 * @return {Object}
 */function getMap(mapName){return mapDataStores[mapName];}registerVisual(PRIORITY_VISUAL_GLOBAL,seriesColor);registerPreprocessor(backwardCompat);registerProcessor(PRIORITY_PROCESSOR_STATISTIC,dataStack);registerLoading('default',loadingDefault);// Default actions
registerAction({type:'highlight',event:'highlight',update:'highlight'},noop);registerAction({type:'downplay',event:'downplay',update:'downplay'},noop);// Default theme
registerTheme('light',lightTheme);registerTheme('dark',theme);// For backward compatibility, where the namespace `dataTool` will
// be mounted on `echarts` is the extension `dataTool` is imported.
var dataTool={};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/function defaultKeyGetter(item){return item;}/**
 * @param {Array} oldArr
 * @param {Array} newArr
 * @param {Function} oldKeyGetter
 * @param {Function} newKeyGetter
 * @param {Object} [context] Can be visited by this.context in callback.
 */function DataDiffer(oldArr,newArr,oldKeyGetter,newKeyGetter,context){this._old=oldArr;this._new=newArr;this._oldKeyGetter=oldKeyGetter||defaultKeyGetter;this._newKeyGetter=newKeyGetter||defaultKeyGetter;this.context=context;}DataDiffer.prototype={constructor:DataDiffer,/**
   * Callback function when add a data
   */add:function add(func){this._add=func;return this;},/**
   * Callback function when update a data
   */update:function update(func){this._update=func;return this;},/**
   * Callback function when remove a data
   */remove:function remove(func){this._remove=func;return this;},execute:function execute(){var oldArr=this._old;var newArr=this._new;var oldDataIndexMap={};var newDataIndexMap={};var oldDataKeyArr=[];var newDataKeyArr=[];var i;initIndexMap(oldArr,oldDataIndexMap,oldDataKeyArr,'_oldKeyGetter',this);initIndexMap(newArr,newDataIndexMap,newDataKeyArr,'_newKeyGetter',this);// Travel by inverted order to make sure order consistency
// when duplicate keys exists (consider newDataIndex.pop() below).
// For performance consideration, these code below do not look neat.
for(i=0;i<oldArr.length;i++){var key=oldDataKeyArr[i];var idx=newDataIndexMap[key];// idx can never be empty array here. see 'set null' logic below.
if(idx!=null){// Consider there is duplicate key (for example, use dataItem.name as key).
// We should make sure every item in newArr and oldArr can be visited.
var len=idx.length;if(len){len===1&&(newDataIndexMap[key]=null);idx=idx.unshift();}else{newDataIndexMap[key]=null;}this._update&&this._update(idx,i);}else{this._remove&&this._remove(i);}}for(var i=0;i<newDataKeyArr.length;i++){var key=newDataKeyArr[i];if(newDataIndexMap.hasOwnProperty(key)){var idx=newDataIndexMap[key];if(idx==null){continue;}// idx can never be empty array here. see 'set null' logic above.
if(!idx.length){this._add&&this._add(idx);}else{for(var j=0,len=idx.length;j<len;j++){this._add&&this._add(idx[j]);}}}}}};function initIndexMap(arr,map,keyArr,keyGetterName,dataDiffer){for(var i=0;i<arr.length;i++){// Add prefix to avoid conflict with Object.prototype.
var key='_ec_'+dataDiffer[keyGetterName](arr[i],i);var existence=map[key];if(existence==null){keyArr.push(key);map[key]=i;}else{if(!existence.length){map[key]=existence=[existence];}existence.push(i);}}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var OTHER_DIMENSIONS=createHashMap(['tooltip','label','itemName','itemId','seriesName']);function summarizeDimensions(data){var summary={};var encode=summary.encode={};var notExtraCoordDimMap=createHashMap();var defaultedLabel=[];var defaultedTooltip=[];each$1(data.dimensions,function(dimName){var dimItem=data.getDimensionInfo(dimName);var coordDim=dimItem.coordDim;if(coordDim){var coordDimArr=encode[coordDim];if(!encode.hasOwnProperty(coordDim)){coordDimArr=encode[coordDim]=[];}coordDimArr[dimItem.coordDimIndex]=dimName;if(!dimItem.isExtraCoord){notExtraCoordDimMap.set(coordDim,1);// Use the last coord dim (and label friendly) as default label,
// because when dataset is used, it is hard to guess which dimension
// can be value dimension. If both show x, y on label is not look good,
// and conventionally y axis is focused more.
if(mayLabelDimType(dimItem.type)){defaultedLabel[0]=dimName;}}if(dimItem.defaultTooltip){defaultedTooltip.push(dimName);}}OTHER_DIMENSIONS.each(function(v,otherDim){var otherDimArr=encode[otherDim];if(!encode.hasOwnProperty(otherDim)){otherDimArr=encode[otherDim]=[];}var dimIndex=dimItem.otherDims[otherDim];if(dimIndex!=null&&dimIndex!==false){otherDimArr[dimIndex]=dimItem.name;}});});var dataDimsOnCoord=[];var encodeFirstDimNotExtra={};notExtraCoordDimMap.each(function(v,coordDim){var dimArr=encode[coordDim];// ??? FIXME extra coord should not be set in dataDimsOnCoord.
// But should fix the case that radar axes: simplify the logic
// of `completeDimension`, remove `extraPrefix`.
encodeFirstDimNotExtra[coordDim]=dimArr[0];// Not necessary to remove duplicate, because a data
// dim canot on more than one coordDim.
dataDimsOnCoord=dataDimsOnCoord.concat(dimArr);});summary.dataDimsOnCoord=dataDimsOnCoord;summary.encodeFirstDimNotExtra=encodeFirstDimNotExtra;var encodeLabel=encode.label;// FIXME `encode.label` is not recommanded, because formatter can not be set
// in this way. Use label.formatter instead. May be remove this approach someday.
if(encodeLabel&&encodeLabel.length){defaultedLabel=encodeLabel.slice();}var encodeTooltip=encode.tooltip;if(encodeTooltip&&encodeTooltip.length){defaultedTooltip=encodeTooltip.slice();}else if(!defaultedTooltip.length){defaultedTooltip=defaultedLabel.slice();}encode.defaultedLabel=defaultedLabel;encode.defaultedTooltip=defaultedTooltip;return summary;}function getDimensionTypeByAxis(axisType){return axisType==='category'?'ordinal':axisType==='time'?'time':'float';}function mayLabelDimType(dimType){// In most cases, ordinal and time do not suitable for label.
// Ordinal info can be displayed on axis. Time is too long.
return!(dimType==='ordinal'||dimType==='time');}// function findTheLastDimMayLabel(data) {
//     // Get last value dim
//     var dimensions = data.dimensions.slice();
//     var valueType;
//     var valueDim;
//     while (dimensions.length && (
//         valueDim = dimensions.pop(),
//         valueType = data.getDimensionInfo(valueDim).type,
//         valueType === 'ordinal' || valueType === 'time'
//     )) {} // jshint ignore:line
//     return valueDim;
// }
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * List for data storage
 * @module echarts/data/List
 */var isObject$4=isObject$1;var UNDEFINED='undefined';// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird udpate animation.
var ID_PREFIX='e\0\0';var dataCtors={'float':(typeof Float64Array==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Float64Array))===UNDEFINED?Array:Float64Array,'int':(typeof Int32Array==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Int32Array))===UNDEFINED?Array:Int32Array,// Ordinal data type can be string or int
'ordinal':Array,'number':Array,'time':Array};// Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
// different from the Ctor of typed array.
var CtorUint32Array=(typeof Uint32Array==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Uint32Array))===UNDEFINED?Array:Uint32Array;var CtorUint16Array=(typeof Uint16Array==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Uint16Array))===UNDEFINED?Array:Uint16Array;function getIndicesCtor(list){// The possible max value in this._indicies is always this._rawCount despite of filtering.
return list._rawCount>65535?CtorUint32Array:CtorUint16Array;}function cloneChunk(originalChunk){var Ctor=originalChunk.constructor;// Only shallow clone is enough when Array.
return Ctor===Array?originalChunk.slice():new Ctor(originalChunk);}var TRANSFERABLE_PROPERTIES=['hasItemOption','_nameList','_idList','_invertedIndicesMap','_rawData','_chunkSize','_chunkCount','_dimValueGetter','_count','_rawCount','_nameDimIdx','_idDimIdx'];var CLONE_PROPERTIES=['_extent','_approximateExtent','_rawExtent'];function transferProperties(target,source){each$1(TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods||[]),function(propName){if(source.hasOwnProperty(propName)){target[propName]=source[propName];}});target.__wrappedMethods=source.__wrappedMethods;each$1(CLONE_PROPERTIES,function(propName){target[propName]=_clone(source[propName]);});target._calculationInfo=extend(source._calculationInfo);}/**
 * @constructor
 * @alias module:echarts/data/List
 *
 * @param {Array.<string|Object>} dimensions
 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
 *      Spetial fields: {
 *          ordinalMeta: <module:echarts/data/OrdinalMeta>
 *          createInvertedIndices: <boolean>
 *      }
 * @param {module:echarts/model/Model} hostModel
 */var List=function List(dimensions,hostModel){dimensions=dimensions||['x','y'];var dimensionInfos={};var dimensionNames=[];var invertedIndicesMap={};for(var i=0;i<dimensions.length;i++){// Use the original dimensions[i], where other flag props may exists.
var dimensionInfo=dimensions[i];if(isString(dimensionInfo)){dimensionInfo={name:dimensionInfo};}var dimensionName=dimensionInfo.name;dimensionInfo.type=dimensionInfo.type||'float';if(!dimensionInfo.coordDim){dimensionInfo.coordDim=dimensionName;dimensionInfo.coordDimIndex=0;}dimensionInfo.otherDims=dimensionInfo.otherDims||{};dimensionNames.push(dimensionName);dimensionInfos[dimensionName]=dimensionInfo;dimensionInfo.index=i;if(dimensionInfo.createInvertedIndices){invertedIndicesMap[dimensionName]=[];}}/**
   * @readOnly
   * @type {Array.<string>}
   */this.dimensions=dimensionNames;/**
   * Infomation of each data dimension, like data type.
   * @type {Object}
   */this._dimensionInfos=dimensionInfos;/**
   * @type {module:echarts/model/Model}
   */this.hostModel=hostModel;/**
   * @type {module:echarts/model/Model}
   */this.dataType;/**
   * Indices stores the indices of data subset after filtered.
   * This data subset will be used in chart.
   * @type {Array.<number>}
   * @readOnly
   */this._indices=null;this._count=0;this._rawCount=0;/**
   * Data storage
   * @type {Object.<key, Array.<TypedArray|Array>>}
   * @private
   */this._storage={};/**
   * @type {Array.<string>}
   */this._nameList=[];/**
   * @type {Array.<string>}
   */this._idList=[];/**
   * Models of data option is stored sparse for optimizing memory cost
   * @type {Array.<module:echarts/model/Model>}
   * @private
   */this._optionModels=[];/**
   * Global visual properties after visual coding
   * @type {Object}
   * @private
   */this._visual={};/**
   * Globel layout properties.
   * @type {Object}
   * @private
   */this._layout={};/**
   * Item visual properties after visual coding
   * @type {Array.<Object>}
   * @private
   */this._itemVisuals=[];/**
   * Key: visual type, Value: boolean
   * @type {Object}
   * @readOnly
   */this.hasItemVisual={};/**
   * Item layout properties after layout
   * @type {Array.<Object>}
   * @private
   */this._itemLayouts=[];/**
   * Graphic elemnents
   * @type {Array.<module:zrender/Element>}
   * @private
   */this._graphicEls=[];/**
   * Max size of each chunk.
   * @type {number}
   * @private
   */this._chunkSize=1e5;/**
   * @type {number}
   * @private
   */this._chunkCount=0;/**
   * @type {Array.<Array|Object>}
   * @private
   */this._rawData;/**
   * Raw extent will not be cloned, but only transfered.
   * It will not be calculated util needed.
   * key: dim,
   * value: {end: number, extent: Array.<number>}
   * @type {Object}
   * @private
   */this._rawExtent={};/**
   * @type {Object}
   * @private
   */this._extent={};/**
   * key: dim
   * value: extent
   * @type {Object}
   * @private
   */this._approximateExtent={};/**
   * Cache summary info for fast visit. See "dimensionHelper".
   * @type {Object}
   * @private
   */this._dimensionsSummary=summarizeDimensions(this);/**
   * @type {Object.<Array|TypedArray>}
   * @private
   */this._invertedIndicesMap=invertedIndicesMap;/**
   * @type {Object}
   * @private
   */this._calculationInfo={};};var listProto=List.prototype;listProto.type='list';/**
 * If each data item has it's own option
 * @type {boolean}
 */listProto.hasItemOption=true;/**
 * Get dimension name
 * @param {string|number} dim
 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
 * @return {string} Concrete dim name.
 */listProto.getDimension=function(dim){if(!isNaN(dim)){dim=this.dimensions[dim]||dim;}return dim;};/**
 * Get type and calculation info of particular dimension
 * @param {string|number} dim
 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
 */listProto.getDimensionInfo=function(dim){// Do not clone, because there may be categories in dimInfo.
return this._dimensionInfos[this.getDimension(dim)];};/**
 * @return {Array.<string>} concrete dimension name list on coord.
 */listProto.getDimensionsOnCoord=function(){return this._dimensionsSummary.dataDimsOnCoord.slice();};/**
 * @param {string} coordDim
 * @param {number} [idx] A coordDim may map to more than one data dim.
 *        If idx is `true`, return a array of all mapped dims.
 *        If idx is not specified, return the first dim not extra.
 * @return {string|Array.<string>} concrete data dim.
 *        If idx is number, and not found, return null/undefined.
 *        If idx is `true`, and not found, return empty array (always return array).
 */listProto.mapDimension=function(coordDim,idx){var dimensionsSummary=this._dimensionsSummary;if(idx==null){return dimensionsSummary.encodeFirstDimNotExtra[coordDim];}var dims=dimensionsSummary.encode[coordDim];return idx===true// always return array if idx is `true`
?(dims||[]).slice():dims&&dims[idx];};/**
 * Initialize from data
 * @param {Array.<Object|number|Array>} data source or data or data provider.
 * @param {Array.<string>} [nameLIst] The name of a datum is used on data diff and
 *        defualt label/tooltip.
 *        A name can be specified in encode.itemName,
 *        or dataItem.name (only for series option data),
 *        or provided in nameList from outside.
 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
 */listProto.initData=function(data,nameList,dimValueGetter){var notProvider=Source.isInstance(data)||isArrayLike(data);if(notProvider){data=new DefaultDataProvider(data,this.dimensions.length);}this._rawData=data;// Clear
this._storage={};this._indices=null;this._nameList=nameList||[];this._idList=[];this._nameRepeatCount={};if(!dimValueGetter){this.hasItemOption=false;}/**
   * @readOnly
   */this.defaultDimValueGetter=defaultDimValueGetters[this._rawData.getSource().sourceFormat];// Default dim value getter
this._dimValueGetter=dimValueGetter=dimValueGetter||this.defaultDimValueGetter;// Reset raw extent.
this._rawExtent={};this._initDataFromProvider(0,data.count());// If data has no item option.
if(data.pure){this.hasItemOption=false;}};listProto.getProvider=function(){return this._rawData;};listProto.appendData=function(data){var rawData=this._rawData;var start=this.count();rawData.appendData(data);var end=rawData.count();if(!rawData.persistent){end+=start;}this._initDataFromProvider(start,end);};listProto._initDataFromProvider=function(start,end){// Optimize.
if(start>=end){return;}var chunkSize=this._chunkSize;var rawData=this._rawData;var storage=this._storage;var dimensions=this.dimensions;var dimLen=dimensions.length;var dimensionInfoMap=this._dimensionInfos;var nameList=this._nameList;var idList=this._idList;var rawExtent=this._rawExtent;var nameRepeatCount=this._nameRepeatCount={};var nameDimIdx;var chunkCount=this._chunkCount;var lastChunkIndex=chunkCount-1;for(var i=0;i<dimLen;i++){var dim=dimensions[i];if(!rawExtent[dim]){rawExtent[dim]=getInitialExtent();}var dimInfo=dimensionInfoMap[dim];if(dimInfo.otherDims.itemName===0){nameDimIdx=this._nameDimIdx=i;}if(dimInfo.otherDims.itemId===0){this._idDimIdx=i;}var DataCtor=dataCtors[dimInfo.type];if(!storage[dim]){storage[dim]=[];}var resizeChunkArray=storage[dim][lastChunkIndex];if(resizeChunkArray&&resizeChunkArray.length<chunkSize){var newStore=new DataCtor(Math.min(end-lastChunkIndex*chunkSize,chunkSize));// The cost of the copy is probably inconsiderable
// within the initial chunkSize.
for(var j=0;j<resizeChunkArray.length;j++){newStore[j]=resizeChunkArray[j];}storage[dim][lastChunkIndex]=newStore;}// Create new chunks.
for(var k=chunkCount*chunkSize;k<end;k+=chunkSize){storage[dim].push(new DataCtor(Math.min(end-k,chunkSize)));}this._chunkCount=storage[dim].length;}var dataItem=new Array(dimLen);for(var idx=start;idx<end;idx++){// NOTICE: Try not to write things into dataItem
dataItem=rawData.getItem(idx,dataItem);// Each data item is value
// [1, 2]
// 2
// Bar chart, line chart which uses category axis
// only gives the 'y' value. 'x' value is the indices of category
// Use a tempValue to normalize the value to be a (x, y) value
var chunkIndex=Math.floor(idx/chunkSize);var chunkOffset=idx%chunkSize;// Store the data by dimensions
for(var k=0;k<dimLen;k++){var dim=dimensions[k];var dimStorage=storage[dim][chunkIndex];// PENDING NULL is empty or zero
var val=this._dimValueGetter(dataItem,dim,idx,k);dimStorage[chunkOffset]=val;var dimRawExtent=rawExtent[dim];if(val<dimRawExtent[0]){dimRawExtent[0]=val;}if(val>dimRawExtent[1]){dimRawExtent[1]=val;}}// ??? FIXME not check by pure but sourceFormat?
// TODO refactor these logic.
if(!rawData.pure){var name=nameList[idx];if(dataItem&&name==null){// If dataItem is {name: ...}, it has highest priority.
// That is appropriate for many common cases.
if(dataItem.name!=null){// There is no other place to persistent dataItem.name,
// so save it to nameList.
nameList[idx]=name=dataItem.name;}else if(nameDimIdx!=null){var nameDim=dimensions[nameDimIdx];var nameDimChunk=storage[nameDim][chunkIndex];if(nameDimChunk){name=nameDimChunk[chunkOffset];var ordinalMeta=dimensionInfoMap[nameDim].ordinalMeta;if(ordinalMeta&&ordinalMeta.categories.length){name=ordinalMeta.categories[name];}}}}// Try using the id in option
// id or name is used on dynamical data, mapping old and new items.
var id=dataItem==null?null:dataItem.id;if(id==null&&name!=null){// Use name as id and add counter to avoid same name
nameRepeatCount[name]=nameRepeatCount[name]||0;id=name;if(nameRepeatCount[name]>0){id+='__ec__'+nameRepeatCount[name];}nameRepeatCount[name]++;}id!=null&&(idList[idx]=id);}}if(!rawData.persistent&&rawData.clean){// Clean unused data if data source is typed array.
rawData.clean();}this._rawCount=this._count=end;// Reset data extent
this._extent={};prepareInvertedIndex(this);};function prepareInvertedIndex(list){var invertedIndicesMap=list._invertedIndicesMap;each$1(invertedIndicesMap,function(invertedIndices,dim){var dimInfo=list._dimensionInfos[dim];// Currently, only dimensions that has ordinalMeta can create inverted indices.
var ordinalMeta=dimInfo.ordinalMeta;if(ordinalMeta){invertedIndices=invertedIndicesMap[dim]=new CtorUint32Array(ordinalMeta.categories.length);// The default value of TypedArray is 0. To avoid miss
// mapping to 0, we should set it as NaN.
for(var i=0;i<invertedIndices.length;i++){invertedIndices[i]=NaN;}for(var i=0;i<list._count;i++){// Only support the case that all values are distinct.
invertedIndices[list.get(dim,i)]=i;}}});}function getRawValueFromStore(list,dimIndex,rawIndex){var val;if(dimIndex!=null){var chunkSize=list._chunkSize;var chunkIndex=Math.floor(rawIndex/chunkSize);var chunkOffset=rawIndex%chunkSize;var dim=list.dimensions[dimIndex];var chunk=list._storage[dim][chunkIndex];if(chunk){val=chunk[chunkOffset];var ordinalMeta=list._dimensionInfos[dim].ordinalMeta;if(ordinalMeta&&ordinalMeta.categories.length){val=ordinalMeta.categories[val];}}}return val;}/**
 * @return {number}
 */listProto.count=function(){return this._count;};listProto.getIndices=function(){var newIndices;var indices=this._indices;if(indices){var Ctor=indices.constructor;var thisCount=this._count;// `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
if(Ctor===Array){newIndices=new Ctor(thisCount);for(var i=0;i<thisCount;i++){newIndices[i]=indices[i];}}else{newIndices=new Ctor(indices.buffer,0,thisCount);}}else{var Ctor=getIndicesCtor(this);var newIndices=new Ctor(this.count());for(var i=0;i<newIndices.length;i++){newIndices[i]=i;}}return newIndices;};/**
 * Get value. Return NaN if idx is out of range.
 * @param {string} dim Dim must be concrete name.
 * @param {number} idx
 * @param {boolean} stack
 * @return {number}
 */listProto.get=function(dim,idx/*, stack */){if(!(idx>=0&&idx<this._count)){return NaN;}var storage=this._storage;if(!storage[dim]){// TODO Warn ?
return NaN;}idx=this.getRawIndex(idx);var chunkIndex=Math.floor(idx/this._chunkSize);var chunkOffset=idx%this._chunkSize;var chunkStore=storage[dim][chunkIndex];var value=chunkStore[chunkOffset];// FIXME ordinal data type is not stackable
// if (stack) {
//     var dimensionInfo = this._dimensionInfos[dim];
//     if (dimensionInfo && dimensionInfo.stackable) {
//         var stackedOn = this.stackedOn;
//         while (stackedOn) {
//             // Get no stacked data of stacked on
//             var stackedValue = stackedOn.get(dim, idx);
//             // Considering positive stack, negative stack and empty data
//             if ((value >= 0 && stackedValue > 0)  // Positive stack
//                 || (value <= 0 && stackedValue < 0) // Negative stack
//             ) {
//                 value += stackedValue;
//             }
//             stackedOn = stackedOn.stackedOn;
//         }
//     }
// }
return value;};/**
 * @param {string} dim concrete dim
 * @param {number} rawIndex
 * @return {number|string}
 */listProto.getByRawIndex=function(dim,rawIdx){if(!(rawIdx>=0&&rawIdx<this._rawCount)){return NaN;}var dimStore=this._storage[dim];if(!dimStore){// TODO Warn ?
return NaN;}var chunkIndex=Math.floor(rawIdx/this._chunkSize);var chunkOffset=rawIdx%this._chunkSize;var chunkStore=dimStore[chunkIndex];return chunkStore[chunkOffset];};/**
 * FIXME Use `get` on chrome maybe slow(in filterSelf and selectRange).
 * Hack a much simpler _getFast
 * @private
 */listProto._getFast=function(dim,rawIdx){var chunkIndex=Math.floor(rawIdx/this._chunkSize);var chunkOffset=rawIdx%this._chunkSize;var chunkStore=this._storage[dim][chunkIndex];return chunkStore[chunkOffset];};/**
 * Get value for multi dimensions.
 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
 * @param {number} idx
 * @return {number}
 */listProto.getValues=function(dimensions,idx/*, stack */){var values=[];if(!isArray(dimensions)){// stack = idx;
idx=dimensions;dimensions=this.dimensions;}for(var i=0,len=dimensions.length;i<len;i++){values.push(this.get(dimensions[i],idx/*, stack */));}return values;};/**
 * If value is NaN. Inlcuding '-'
 * Only check the coord dimensions.
 * @param {string} dim
 * @param {number} idx
 * @return {number}
 */listProto.hasValue=function(idx){var dataDimsOnCoord=this._dimensionsSummary.dataDimsOnCoord;var dimensionInfos=this._dimensionInfos;for(var i=0,len=dataDimsOnCoord.length;i<len;i++){if(// Ordinal type can be string or number
dimensionInfos[dataDimsOnCoord[i]].type!=='ordinal'// FIXME check ordinal when using index?
&&isNaN(this.get(dataDimsOnCoord[i],idx))){return false;}}return true;};/**
 * Get extent of data in one dimension
 * @param {string} dim
 * @param {boolean} stack
 */listProto.getDataExtent=function(dim/*, stack */){// Make sure use concrete dim as cache name.
dim=this.getDimension(dim);var dimData=this._storage[dim];var initialExtent=getInitialExtent();// stack = !!((stack || false) && this.getCalculationInfo(dim));
if(!dimData){return initialExtent;}// Make more strict checkings to ensure hitting cache.
var currEnd=this.count();// var cacheName = [dim, !!stack].join('_');
// var cacheName = dim;
// Consider the most cases when using data zoom, `getDataExtent`
// happened before filtering. We cache raw extent, which is not
// necessary to be cleared and recalculated when restore data.
var useRaw=!this._indices;// && !stack;
var dimExtent;if(useRaw){return this._rawExtent[dim].slice();}dimExtent=this._extent[dim];if(dimExtent){return dimExtent.slice();}dimExtent=initialExtent;var min=dimExtent[0];var max=dimExtent[1];for(var i=0;i<currEnd;i++){// var value = stack ? this.get(dim, i, true) : this._getFast(dim, this.getRawIndex(i));
var value=this._getFast(dim,this.getRawIndex(i));value<min&&(min=value);value>max&&(max=value);}dimExtent=[min,max];this._extent[dim]=dimExtent;return dimExtent;};/**
 * Optimize for the scenario that data is filtered by a given extent.
 * Consider that if data amount is more than hundreds of thousand,
 * extent calculation will cost more than 10ms and the cache will
 * be erased because of the filtering.
 */listProto.getApproximateExtent=function(dim/*, stack */){dim=this.getDimension(dim);return this._approximateExtent[dim]||this.getDataExtent(dim/*, stack */);};listProto.setApproximateExtent=function(extent,dim/*, stack */){dim=this.getDimension(dim);this._approximateExtent[dim]=extent.slice();};/**
 * @param {string} key
 * @return {*}
 */listProto.getCalculationInfo=function(key){return this._calculationInfo[key];};/**
 * @param {string|Object} key or k-v object
 * @param {*} [value]
 */listProto.setCalculationInfo=function(key,value){isObject$4(key)?extend(this._calculationInfo,key):this._calculationInfo[key]=value;};/**
 * Get sum of data in one dimension
 * @param {string} dim
 */listProto.getSum=function(dim/*, stack */){var dimData=this._storage[dim];var sum=0;if(dimData){for(var i=0,len=this.count();i<len;i++){var value=this.get(dim,i/*, stack */);if(!isNaN(value)){sum+=value;}}}return sum;};/**
 * Get median of data in one dimension
 * @param {string} dim
 */listProto.getMedian=function(dim/*, stack */){var dimDataArray=[];// map all data of one dimension
this.each(dim,function(val,idx){if(!isNaN(val)){dimDataArray.push(val);}});// TODO
// Use quick select?
// immutability & sort
var sortedDimDataArray=[].concat(dimDataArray).sort(function(a,b){return a-b;});var len=this.count();// calculate median
return len===0?0:len%2===1?sortedDimDataArray[(len-1)/2]:(sortedDimDataArray[len/2]+sortedDimDataArray[len/2-1])/2;};// /**
//  * Retreive the index with given value
//  * @param {string} dim Concrete dimension.
//  * @param {number} value
//  * @return {number}
//  */
// Currently incorrect: should return dataIndex but not rawIndex.
// Do not fix it until this method is to be used somewhere.
// FIXME Precision of float value
// listProto.indexOf = function (dim, value) {
//     var storage = this._storage;
//     var dimData = storage[dim];
//     var chunkSize = this._chunkSize;
//     if (dimData) {
//         for (var i = 0, len = this.count(); i < len; i++) {
//             var chunkIndex = Math.floor(i / chunkSize);
//             var chunkOffset = i % chunkSize;
//             if (dimData[chunkIndex][chunkOffset] === value) {
//                 return i;
//             }
//         }
//     }
//     return -1;
// };
/**
 * Only support the dimension which inverted index created.
 * Do not support other cases until required.
 * @param {string} concrete dim
 * @param {number|string} value
 * @return {number} rawIndex
 */listProto.rawIndexOf=function(dim,value){var invertedIndices=dim&&this._invertedIndicesMap[dim];var rawIndex=invertedIndices[value];if(rawIndex==null||isNaN(rawIndex)){return-1;}return rawIndex;};/**
 * Retreive the index with given name
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */listProto.indexOfName=function(name){for(var i=0,len=this.count();i<len;i++){if(this.getName(i)===name){return i;}}return-1;};/**
 * Retreive the index with given raw data index
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */listProto.indexOfRawIndex=function(rawIndex){if(!this._indices){return rawIndex;}if(rawIndex>=this._rawCount||rawIndex<0){return-1;}// Indices are ascending
var indices=this._indices;// If rawIndex === dataIndex
var rawDataIndex=indices[rawIndex];if(rawDataIndex!=null&&rawDataIndex<this._count&&rawDataIndex===rawIndex){return rawIndex;}var left=0;var right=this._count-1;while(left<=right){var mid=(left+right)/2|0;if(indices[mid]<rawIndex){left=mid+1;}else if(indices[mid]>rawIndex){right=mid-1;}else{return mid;}}return-1;};/**
 * Retreive the index of nearest value
 * @param {string} dim
 * @param {number} value
 * @param {number} [maxDistance=Infinity]
 * @return {Array.<number>} Considere multiple points has the same value.
 */listProto.indicesOfNearest=function(dim,value,maxDistance){var storage=this._storage;var dimData=storage[dim];var nearestIndices=[];if(!dimData){return nearestIndices;}if(maxDistance==null){maxDistance=Infinity;}var minDist=Number.MAX_VALUE;var minDiff=-1;for(var i=0,len=this.count();i<len;i++){var diff=value-this.get(dim,i/*, stack */);var dist=Math.abs(diff);if(diff<=maxDistance&&dist<=minDist){// For the case of two data are same on xAxis, which has sequence data.
// Show the nearest index
// https://github.com/ecomfe/echarts/issues/2869
if(dist<minDist||diff>=0&&minDiff<0){minDist=dist;minDiff=diff;nearestIndices.length=0;}nearestIndices.push(i);}}return nearestIndices;};/**
 * Get raw data index
 * @param {number} idx
 * @return {number}
 */listProto.getRawIndex=getRawIndexWithoutIndices;function getRawIndexWithoutIndices(idx){return idx;}function getRawIndexWithIndices(idx){if(idx<this._count&&idx>=0){return this._indices[idx];}return-1;}/**
 * Get raw data item
 * @param {number} idx
 * @return {number}
 */listProto.getRawDataItem=function(idx){if(!this._rawData.persistent){var val=[];for(var i=0;i<this.dimensions.length;i++){var dim=this.dimensions[i];val.push(this.get(dim,idx));}return val;}else{return this._rawData.getItem(this.getRawIndex(idx));}};/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */listProto.getName=function(idx){var rawIndex=this.getRawIndex(idx);return this._nameList[rawIndex]||getRawValueFromStore(this,this._nameDimIdx,rawIndex)||'';};/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */listProto.getId=function(idx){return getId(this,this.getRawIndex(idx));};function getId(list,rawIndex){var id=list._idList[rawIndex];if(id==null){id=getRawValueFromStore(list,list._idDimIdx,rawIndex);}if(id==null){// FIXME Check the usage in graph, should not use prefix.
id=ID_PREFIX+rawIndex;}return id;}function normalizeDimensions(dimensions){if(!isArray(dimensions)){dimensions=[dimensions];}return dimensions;}/**
 * Data iteration
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {*} [context=this]
 *
 * @example
 *  list.each('x', function (x, idx) {});
 *  list.each(['x', 'y'], function (x, y, idx) {});
 *  list.each(function (idx) {})
 */listProto.each=function(dims,cb,context,contextCompat){'use strict';if(!this._count){return;}if(typeof dims==='function'){contextCompat=context;context=cb;cb=dims;dims=[];}// contextCompat just for compat echarts3
context=context||contextCompat||this;dims=map(normalizeDimensions(dims),this.getDimension,this);var dimSize=dims.length;for(var i=0;i<this.count();i++){// Simple optimization
switch(dimSize){case 0:cb.call(context,i);break;case 1:cb.call(context,this.get(dims[0],i),i);break;case 2:cb.call(context,this.get(dims[0],i),this.get(dims[1],i),i);break;default:var k=0;var value=[];for(;k<dimSize;k++){value[k]=this.get(dims[k],i);}// Index
value[k]=i;cb.apply(context,value);}}};/**
 * Data filter
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {*} [context=this]
 */listProto.filterSelf=function(dimensions,cb,context,contextCompat){'use strict';if(!this._count){return;}if(typeof dimensions==='function'){contextCompat=context;context=cb;cb=dimensions;dimensions=[];}// contextCompat just for compat echarts3
context=context||contextCompat||this;dimensions=map(normalizeDimensions(dimensions),this.getDimension,this);var count=this.count();var Ctor=getIndicesCtor(this);var newIndices=new Ctor(count);var value=[];var dimSize=dimensions.length;var offset=0;var dim0=dimensions[0];for(var i=0;i<count;i++){var keep;var rawIdx=this.getRawIndex(i);// Simple optimization
if(dimSize===0){keep=cb.call(context,i);}else if(dimSize===1){var val=this._getFast(dim0,rawIdx);keep=cb.call(context,val,i);}else{for(var k=0;k<dimSize;k++){value[k]=this._getFast(dim0,rawIdx);}value[k]=i;keep=cb.apply(context,value);}if(keep){newIndices[offset++]=rawIdx;}}// Set indices after filtered.
if(offset<count){this._indices=newIndices;}this._count=offset;// Reset data extent
this._extent={};this.getRawIndex=this._indices?getRawIndexWithIndices:getRawIndexWithoutIndices;return this;};/**
 * Select data in range. (For optimization of filter)
 * (Manually inline code, support 5 million data filtering in data zoom.)
 */listProto.selectRange=function(range){'use strict';if(!this._count){return;}var dimensions=[];for(var dim in range){if(range.hasOwnProperty(dim)){dimensions.push(dim);}}var dimSize=dimensions.length;if(!dimSize){return;}var originalCount=this.count();var Ctor=getIndicesCtor(this);var newIndices=new Ctor(originalCount);var offset=0;var dim0=dimensions[0];var min=range[dim0][0];var max=range[dim0][1];var quickFinished=false;if(!this._indices){// Extreme optimization for common case. About 2x faster in chrome.
var idx=0;if(dimSize===1){var dimStorage=this._storage[dimensions[0]];for(var k=0;k<this._chunkCount;k++){var chunkStorage=dimStorage[k];var len=Math.min(this._count-k*this._chunkSize,this._chunkSize);for(var i=0;i<len;i++){var val=chunkStorage[i];// NaN will not be filtered. Consider the case, in line chart, empty
// value indicates the line should be broken. But for the case like
// scatter plot, a data item with empty value will not be rendered,
// but the axis extent may be effected if some other dim of the data
// item has value. Fortunately it is not a significant negative effect.
if(val>=min&&val<=max||isNaN(val)){newIndices[offset++]=idx;}idx++;}}quickFinished=true;}else if(dimSize===2){var dimStorage=this._storage[dim0];var dimStorage2=this._storage[dimensions[1]];var min2=range[dimensions[1]][0];var max2=range[dimensions[1]][1];for(var k=0;k<this._chunkCount;k++){var chunkStorage=dimStorage[k];var chunkStorage2=dimStorage2[k];var len=Math.min(this._count-k*this._chunkSize,this._chunkSize);for(var i=0;i<len;i++){var val=chunkStorage[i];var val2=chunkStorage2[i];// Do not filter NaN, see comment above.
if((val>=min&&val<=max||isNaN(val))&&(val2>=min2&&val2<=max2||isNaN(val2))){newIndices[offset++]=idx;}idx++;}}quickFinished=true;}}if(!quickFinished){if(dimSize===1){for(var i=0;i<originalCount;i++){var rawIndex=this.getRawIndex(i);var val=this._getFast(dim0,rawIndex);// Do not filter NaN, see comment above.
if(val>=min&&val<=max||isNaN(val)){newIndices[offset++]=rawIndex;}}}else{for(var i=0;i<originalCount;i++){var keep=true;var rawIndex=this.getRawIndex(i);for(var k=0;k<dimSize;k++){var dimk=dimensions[k];var val=this._getFast(dim,rawIndex);// Do not filter NaN, see comment above.
if(val<range[dimk][0]||val>range[dimk][1]){keep=false;}}if(keep){newIndices[offset++]=this.getRawIndex(i);}}}}// Set indices after filtered.
if(offset<originalCount){this._indices=newIndices;}this._count=offset;// Reset data extent
this._extent={};this.getRawIndex=this._indices?getRawIndexWithIndices:getRawIndexWithoutIndices;return this;};/**
 * Data mapping to a plain array
 * @param {string|Array.<string>} [dimensions]
 * @param {Function} cb
 * @param {*} [context=this]
 * @return {Array}
 */listProto.mapArray=function(dimensions,cb,context,contextCompat){'use strict';if(typeof dimensions==='function'){contextCompat=context;context=cb;cb=dimensions;dimensions=[];}// contextCompat just for compat echarts3
context=context||contextCompat||this;var result=[];this.each(dimensions,function(){result.push(cb&&cb.apply(this,arguments));},context);return result;};// Data in excludeDimensions is copied, otherwise transfered.
function cloneListForMapAndSample(original,excludeDimensions){var allDimensions=original.dimensions;var list=new List(map(allDimensions,original.getDimensionInfo,original),original.hostModel);// FIXME If needs stackedOn, value may already been stacked
transferProperties(list,original);var storage=list._storage={};var originalStorage=original._storage;// Init storage
for(var i=0;i<allDimensions.length;i++){var dim=allDimensions[i];if(originalStorage[dim]){// Notice that we do not reset invertedIndicesMap here, becuase
// there is no scenario of mapping or sampling ordinal dimension.
if(indexOf(excludeDimensions,dim)>=0){storage[dim]=cloneDimStore(originalStorage[dim]);list._rawExtent[dim]=getInitialExtent();list._extent[dim]=null;}else{// Direct reference for other dimensions
storage[dim]=originalStorage[dim];}}}return list;}function cloneDimStore(originalDimStore){var newDimStore=new Array(originalDimStore.length);for(var j=0;j<originalDimStore.length;j++){newDimStore[j]=cloneChunk(originalDimStore[j]);}return newDimStore;}function getInitialExtent(){return[Infinity,-Infinity];}/**
 * Data mapping to a new List with given dimensions
 * @param {string|Array.<string>} dimensions
 * @param {Function} cb
 * @param {*} [context=this]
 * @return {Array}
 */listProto.map=function(dimensions,cb,context,contextCompat){'use strict';// contextCompat just for compat echarts3
context=context||contextCompat||this;dimensions=map(normalizeDimensions(dimensions),this.getDimension,this);var list=cloneListForMapAndSample(this,dimensions);// Following properties are all immutable.
// So we can reference to the same value
list._indices=this._indices;list.getRawIndex=list._indices?getRawIndexWithIndices:getRawIndexWithoutIndices;var storage=list._storage;var tmpRetValue=[];var chunkSize=this._chunkSize;var dimSize=dimensions.length;var dataCount=this.count();var values=[];var rawExtent=list._rawExtent;for(var dataIndex=0;dataIndex<dataCount;dataIndex++){for(var dimIndex=0;dimIndex<dimSize;dimIndex++){values[dimIndex]=this.get(dimensions[dimIndex],dataIndex/*, stack */);}values[dimSize]=dataIndex;var retValue=cb&&cb.apply(context,values);if(retValue!=null){// a number or string (in oridinal dimension)?
if((typeof retValue==='undefined'?'undefined':__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(retValue))!=='object'){tmpRetValue[0]=retValue;retValue=tmpRetValue;}var rawIndex=this.getRawIndex(dataIndex);var chunkIndex=Math.floor(rawIndex/chunkSize);var chunkOffset=rawIndex%chunkSize;for(var i=0;i<retValue.length;i++){var dim=dimensions[i];var val=retValue[i];var rawExtentOnDim=rawExtent[dim];var dimStore=storage[dim];if(dimStore){dimStore[chunkIndex][chunkOffset]=val;}if(val<rawExtentOnDim[0]){rawExtentOnDim[0]=val;}if(val>rawExtentOnDim[1]){rawExtentOnDim[1]=val;}}}}return list;};/**
 * Large data down sampling on given dimension
 * @param {string} dimension
 * @param {number} rate
 * @param {Function} sampleValue
 * @param {Function} sampleIndex Sample index for name and id
 */listProto.downSample=function(dimension,rate,sampleValue,sampleIndex){var list=cloneListForMapAndSample(this,[dimension]);var targetStorage=list._storage;var frameValues=[];var frameSize=Math.floor(1/rate);var dimStore=targetStorage[dimension];var len=this.count();var chunkSize=this._chunkSize;var rawExtentOnDim=list._rawExtent[dimension];var newIndices=new(getIndicesCtor(this))(len);var offset=0;for(var i=0;i<len;i+=frameSize){// Last frame
if(frameSize>len-i){frameSize=len-i;frameValues.length=frameSize;}for(var k=0;k<frameSize;k++){var dataIdx=this.getRawIndex(i+k);var originalChunkIndex=Math.floor(dataIdx/chunkSize);var originalChunkOffset=dataIdx%chunkSize;frameValues[k]=dimStore[originalChunkIndex][originalChunkOffset];}var value=sampleValue(frameValues);var sampleFrameIdx=this.getRawIndex(Math.min(i+sampleIndex(frameValues,value)||0,len-1));var sampleChunkIndex=Math.floor(sampleFrameIdx/chunkSize);var sampleChunkOffset=sampleFrameIdx%chunkSize;// Only write value on the filtered data
dimStore[sampleChunkIndex][sampleChunkOffset]=value;if(value<rawExtentOnDim[0]){rawExtentOnDim[0]=value;}if(value>rawExtentOnDim[1]){rawExtentOnDim[1]=value;}newIndices[offset++]=sampleFrameIdx;}list._count=offset;list._indices=newIndices;list.getRawIndex=getRawIndexWithIndices;return list;};/**
 * Get model of one data item.
 *
 * @param {number} idx
 */// FIXME Model proxy ?
listProto.getItemModel=function(idx){var hostModel=this.hostModel;return new Model(this.getRawDataItem(idx),hostModel,hostModel&&hostModel.ecModel);};/**
 * Create a data differ
 * @param {module:echarts/data/List} otherList
 * @return {module:echarts/data/DataDiffer}
 */listProto.diff=function(otherList){var thisList=this;return new DataDiffer(otherList?otherList.getIndices():[],this.getIndices(),function(idx){return getId(otherList,idx);},function(idx){return getId(thisList,idx);});};/**
 * Get visual property.
 * @param {string} key
 */listProto.getVisual=function(key){var visual=this._visual;return visual&&visual[key];};/**
 * Set visual property
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setVisual('color', color);
 *  setVisual({
 *      'color': color
 *  });
 */listProto.setVisual=function(key,val){if(isObject$4(key)){for(var name in key){if(key.hasOwnProperty(name)){this.setVisual(name,key[name]);}}return;}this._visual=this._visual||{};this._visual[key]=val;};/**
 * Set layout property.
 * @param {string|Object} key
 * @param {*} [val]
 */listProto.setLayout=function(key,val){if(isObject$4(key)){for(var name in key){if(key.hasOwnProperty(name)){this.setLayout(name,key[name]);}}return;}this._layout[key]=val;};/**
 * Get layout property.
 * @param  {string} key.
 * @return {*}
 */listProto.getLayout=function(key){return this._layout[key];};/**
 * Get layout of single data item
 * @param {number} idx
 */listProto.getItemLayout=function(idx){return this._itemLayouts[idx];};/**
 * Set layout of single data item
 * @param {number} idx
 * @param {Object} layout
 * @param {boolean=} [merge=false]
 */listProto.setItemLayout=function(idx,layout,merge$$1){this._itemLayouts[idx]=merge$$1?extend(this._itemLayouts[idx]||{},layout):layout;};/**
 * Clear all layout of single data item
 */listProto.clearItemLayouts=function(){this._itemLayouts.length=0;};/**
 * Get visual property of single data item
 * @param {number} idx
 * @param {string} key
 * @param {boolean} [ignoreParent=false]
 */listProto.getItemVisual=function(idx,key,ignoreParent){var itemVisual=this._itemVisuals[idx];var val=itemVisual&&itemVisual[key];if(val==null&&!ignoreParent){// Use global visual property
return this.getVisual(key);}return val;};/**
 * Set visual property of single data item
 *
 * @param {number} idx
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setItemVisual(0, 'color', color);
 *  setItemVisual(0, {
 *      'color': color
 *  });
 */listProto.setItemVisual=function(idx,key,value){var itemVisual=this._itemVisuals[idx]||{};var hasItemVisual=this.hasItemVisual;this._itemVisuals[idx]=itemVisual;if(isObject$4(key)){for(var name in key){if(key.hasOwnProperty(name)){itemVisual[name]=key[name];hasItemVisual[name]=true;}}return;}itemVisual[key]=value;hasItemVisual[key]=true;};/**
 * Clear itemVisuals and list visual.
 */listProto.clearAllVisual=function(){this._visual={};this._itemVisuals=[];this.hasItemVisual={};};var setItemDataAndSeriesIndex=function setItemDataAndSeriesIndex(child){child.seriesIndex=this.seriesIndex;child.dataIndex=this.dataIndex;child.dataType=this.dataType;};/**
 * Set graphic element relative to data. It can be set as null
 * @param {number} idx
 * @param {module:zrender/Element} [el]
 */listProto.setItemGraphicEl=function(idx,el){var hostModel=this.hostModel;if(el){// Add data index and series index for indexing the data by element
// Useful in tooltip
el.dataIndex=idx;el.dataType=this.dataType;el.seriesIndex=hostModel&&hostModel.seriesIndex;if(el.type==='group'){el.traverse(setItemDataAndSeriesIndex,el);}}this._graphicEls[idx]=el;};/**
 * @param {number} idx
 * @return {module:zrender/Element}
 */listProto.getItemGraphicEl=function(idx){return this._graphicEls[idx];};/**
 * @param {Function} cb
 * @param {*} context
 */listProto.eachItemGraphicEl=function(cb,context){each$1(this._graphicEls,function(el,idx){if(el){cb&&cb.call(context,el,idx);}});};/**
 * Shallow clone a new list except visual and layout properties, and graph elements.
 * New list only change the indices.
 */listProto.cloneShallow=function(list){if(!list){var dimensionInfoList=map(this.dimensions,this.getDimensionInfo,this);list=new List(dimensionInfoList,this.hostModel);}// FIXME
list._storage=this._storage;transferProperties(list,this);// Clone will not change the data extent and indices
if(this._indices){var Ctor=this._indices.constructor;list._indices=new Ctor(this._indices);}else{list._indices=null;}list.getRawIndex=list._indices?getRawIndexWithIndices:getRawIndexWithoutIndices;return list;};/**
 * Wrap some method to add more feature
 * @param {string} methodName
 * @param {Function} injectFunction
 */listProto.wrapMethod=function(methodName,injectFunction){var originalMethod=this[methodName];if(typeof originalMethod!=='function'){return;}this.__wrappedMethods=this.__wrappedMethods||[];this.__wrappedMethods.push(methodName);this[methodName]=function(){var res=originalMethod.apply(this,arguments);return injectFunction.apply(this,[res].concat(slice(arguments)));};};// Methods that create a new list based on this list should be listed here.
// Notice that those method should `RETURN` the new list.
listProto.TRANSFERABLE_METHODS=['cloneShallow','downSample','map'];// Methods that change indices of this list should be listed here.
listProto.CHANGABLE_METHODS=['filterSelf','selectRange'];/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @deprecated
 * Use `echarts/data/helper/createDimensions` instead.
 *//**
 * @see {module:echarts/test/ut/spec/data/completeDimensions}
 *
 * Complete the dimensions array, by user defined `dimension` and `encode`,
 * and guessing from the data structure.
 * If no 'value' dimension specified, the first no-named dimension will be
 * named as 'value'.
 *
 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
 *      provides not only dim template, but also default order.
 *      properties: 'name', 'type', 'displayName'.
 *      `name` of each item provides default coord name.
 *      [{dimsDef: [string|Object, ...]}, ...] dimsDef of sysDim item provides default dim name, and
 *                                    provide dims count that the sysDim required.
 *      [{ordinalMeta}] can be specified.
 * @param {module:echarts/data/Source|Array|Object} source or data (for compatibal with pervious)
 * @param {Object} [opt]
 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
 *      For example: ['asdf', {name, type}, ...].
 * @param {Object|HashMap} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
 * @param {string} [opt.generateCoord] Generate coord dim with the given name.
 *                 If not specified, extra dim names will be:
 *                 'value', 'value0', 'value1', ...
 * @param {number} [opt.generateCoordCount] By default, the generated dim name is `generateCoord`.
 *                 If `generateCoordCount` specified, the generated dim names will be:
 *                 `generateCoord` + 0, `generateCoord` + 1, ...
 *                 can be Infinity, indicate that use all of the remain columns.
 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
 * @param {number} [opt.encodeDefaulter] If not specified, auto find the next available data dim.
 * @return {Array.<Object>} [{
 *      name: string mandatory,
 *      displayName: string, the origin name in dimsDef, see source helper.
 *                 If displayName given, the tooltip will displayed vertically.
 *      coordDim: string mandatory,
 *      coordDimIndex: number mandatory,
 *      type: string optional,
 *      otherDims: { never null/undefined
 *          tooltip: number optional,
 *          label: number optional,
 *          itemName: number optional,
 *          seriesName: number optional,
 *      },
 *      isExtraCoord: boolean true if coord is generated
 *          (not specified in encode and not series specified)
 *      other props ...
 * }]
 */function completeDimensions(sysDims,source,opt){if(!Source.isInstance(source)){source=Source.seriesDataToSource(source);}opt=opt||{};sysDims=(sysDims||[]).slice();var dimsDef=(opt.dimsDef||[]).slice();var encodeDef=createHashMap(opt.encodeDef);var dataDimNameMap=createHashMap();var coordDimNameMap=createHashMap();// var valueCandidate;
var result=[];var dimCount=getDimCount(source,sysDims,dimsDef,opt.dimCount);// Apply user defined dims (`name` and `type`) and init result.
for(var i=0;i<dimCount;i++){var dimDefItem=dimsDef[i]=extend({},isObject$1(dimsDef[i])?dimsDef[i]:{name:dimsDef[i]});var userDimName=dimDefItem.name;var resultItem=result[i]={otherDims:{}};// Name will be applied later for avoiding duplication.
if(userDimName!=null&&dataDimNameMap.get(userDimName)==null){// Only if `series.dimensions` is defined in option
// displayName, will be set, and dimension will be diplayed vertically in
// tooltip by default.
resultItem.name=resultItem.displayName=userDimName;dataDimNameMap.set(userDimName,i);}dimDefItem.type!=null&&(resultItem.type=dimDefItem.type);dimDefItem.displayName!=null&&(resultItem.displayName=dimDefItem.displayName);}// Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.
encodeDef.each(function(dataDims,coordDim){dataDims=normalizeToArray(dataDims).slice();var validDataDims=encodeDef.set(coordDim,[]);each$1(dataDims,function(resultDimIdx,idx){// The input resultDimIdx can be dim name or index.
isString(resultDimIdx)&&(resultDimIdx=dataDimNameMap.get(resultDimIdx));if(resultDimIdx!=null&&resultDimIdx<dimCount){validDataDims[idx]=resultDimIdx;applyDim(result[resultDimIdx],coordDim,idx);}});});// Apply templetes and default order from `sysDims`.
var availDimIdx=0;each$1(sysDims,function(sysDimItem,sysDimIndex){var coordDim;var sysDimItem;var sysDimItemDimsDef;var sysDimItemOtherDims;if(isString(sysDimItem)){coordDim=sysDimItem;sysDimItem={};}else{coordDim=sysDimItem.name;var ordinalMeta=sysDimItem.ordinalMeta;sysDimItem.ordinalMeta=null;sysDimItem=_clone(sysDimItem);sysDimItem.ordinalMeta=ordinalMeta;// `coordDimIndex` should not be set directly.
sysDimItemDimsDef=sysDimItem.dimsDef;sysDimItemOtherDims=sysDimItem.otherDims;sysDimItem.name=sysDimItem.coordDim=sysDimItem.coordDimIndex=sysDimItem.dimsDef=sysDimItem.otherDims=null;}var dataDims=normalizeToArray(encodeDef.get(coordDim));// dimensions provides default dim sequences.
if(!dataDims.length){for(var i=0;i<(sysDimItemDimsDef&&sysDimItemDimsDef.length||1);i++){while(availDimIdx<result.length&&result[availDimIdx].coordDim!=null){availDimIdx++;}availDimIdx<result.length&&dataDims.push(availDimIdx++);}}// Apply templates.
each$1(dataDims,function(resultDimIdx,coordDimIndex){var resultItem=result[resultDimIdx];applyDim(defaults(resultItem,sysDimItem),coordDim,coordDimIndex);if(resultItem.name==null&&sysDimItemDimsDef){var sysDimItemDimsDefItem=sysDimItemDimsDef[coordDimIndex];!isObject$1(sysDimItemDimsDefItem)&&(sysDimItemDimsDefItem={name:sysDimItemDimsDefItem});resultItem.name=resultItem.displayName=sysDimItemDimsDefItem.name;resultItem.defaultTooltip=sysDimItemDimsDefItem.defaultTooltip;}// FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
sysDimItemOtherDims&&defaults(resultItem.otherDims,sysDimItemOtherDims);});});function applyDim(resultItem,coordDim,coordDimIndex){if(OTHER_DIMENSIONS.get(coordDim)!=null){resultItem.otherDims[coordDim]=coordDimIndex;}else{resultItem.coordDim=coordDim;resultItem.coordDimIndex=coordDimIndex;coordDimNameMap.set(coordDim,true);}}// Make sure the first extra dim is 'value'.
var generateCoord=opt.generateCoord;var generateCoordCount=opt.generateCoordCount;var fromZero=generateCoordCount!=null;generateCoordCount=generateCoord?generateCoordCount||1:0;var extra=generateCoord||'value';// Set dim `name` and other `coordDim` and other props.
for(var resultDimIdx=0;resultDimIdx<dimCount;resultDimIdx++){var resultItem=result[resultDimIdx]=result[resultDimIdx]||{};var coordDim=resultItem.coordDim;if(coordDim==null){resultItem.coordDim=genName(extra,coordDimNameMap,fromZero);resultItem.coordDimIndex=0;if(!generateCoord||generateCoordCount<=0){resultItem.isExtraCoord=true;}generateCoordCount--;}resultItem.name==null&&(resultItem.name=genName(resultItem.coordDim,dataDimNameMap));if(resultItem.type==null&&guessOrdinal(source,resultDimIdx,resultItem.name)){resultItem.type='ordinal';}}return result;}// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calcualte bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in storage?
function getDimCount(source,sysDims,dimsDef,optDimCount){// Note that the result dimCount should not small than columns count
// of data, otherwise `dataDimNameMap` checking will be incorrect.
var dimCount=Math.max(source.dimensionsDetectCount||1,sysDims.length,dimsDef.length,optDimCount||0);each$1(sysDims,function(sysDimItem){var sysDimItemDimsDef=sysDimItem.dimsDef;sysDimItemDimsDef&&(dimCount=Math.max(dimCount,sysDimItemDimsDef.length));});return dimCount;}function genName(name,map$$1,fromZero){if(fromZero||map$$1.get(name)!=null){var i=0;while(map$$1.get(name+i)!=null){i++;}name+=i;}map$$1.set(name,true);return name;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Substitute `completeDimensions`.
 * `completeDimensions` is to be deprecated.
 *//**
 * @param {module:echarts/data/Source|module:echarts/data/List} source or data.
 * @param {Object|Array} [opt]
 * @param {Array.<string|Object>} [opt.coordDimensions=[]]
 * @param {number} [opt.dimensionsCount]
 * @param {string} [opt.generateCoord]
 * @param {string} [opt.generateCoordCount]
 * @param {Array.<string|Object>} [opt.dimensionsDefine=source.dimensionsDefine] Overwrite source define.
 * @param {Object|HashMap} [opt.encodeDefine=source.encodeDefine] Overwrite source define.
 * @return {Array.<Object>} dimensionsInfo
 */var createDimensions=function createDimensions(source,opt){opt=opt||{};return completeDimensions(opt.coordDimensions||[],source,{dimsDef:opt.dimensionsDefine||source.dimensionsDefine,encodeDef:opt.encodeDefine||source.encodeDefine,dimCount:opt.dimensionsCount,generateCoord:opt.generateCoord,generateCoordCount:opt.generateCoordCount});};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Note that it is too complicated to support 3d stack by value
 * (have to create two-dimension inverted index), so in 3d case
 * we just support that stacked by index.
 *
 * @param {module:echarts/model/Series} seriesModel
 * @param {Array.<string|Object>} dimensionInfoList The same as the input of <module:echarts/data/List>.
 *        The input dimensionInfoList will be modified.
 * @param {Object} [opt]
 * @param {boolean} [opt.stackedCoordDimension=''] Specify a coord dimension if needed.
 * @param {boolean} [opt.byIndex=false]
 * @return {Object} calculationInfo
 * {
 *     stackedDimension: string
 *     stackedByDimension: string
 *     isStackedByIndex: boolean
 *     stackedOverDimension: string
 *     stackResultDimension: string
 * }
 */function enableDataStack(seriesModel,dimensionInfoList,opt){opt=opt||{};var byIndex=opt.byIndex;var stackedCoordDimension=opt.stackedCoordDimension;// Compatibal: when `stack` is set as '', do not stack.
var mayStack=!!(seriesModel&&seriesModel.get('stack'));var stackedByDimInfo;var stackedDimInfo;var stackResultDimension;var stackedOverDimension;each$1(dimensionInfoList,function(dimensionInfo,index){if(isString(dimensionInfo)){dimensionInfoList[index]=dimensionInfo={name:dimensionInfo};}if(mayStack&&!dimensionInfo.isExtraCoord){// Find the first ordinal dimension as the stackedByDimInfo.
if(!byIndex&&!stackedByDimInfo&&dimensionInfo.ordinalMeta){stackedByDimInfo=dimensionInfo;}// Find the first stackable dimension as the stackedDimInfo.
if(!stackedDimInfo&&dimensionInfo.type!=='ordinal'&&dimensionInfo.type!=='time'&&(!stackedCoordDimension||stackedCoordDimension===dimensionInfo.coordDim)){stackedDimInfo=dimensionInfo;}}});if(stackedDimInfo&&!byIndex&&!stackedByDimInfo){// Compatible with previous design, value axis (time axis) only stack by index.
// It may make sense if the user provides elaborately constructed data.
byIndex=true;}// Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
// That put stack logic in List is for using conveniently in echarts extensions, but it
// might not be a good way.
if(stackedDimInfo){// Use a weird name that not duplicated with other names.
stackResultDimension='__\0ecstackresult';stackedOverDimension='__\0ecstackedover';// Create inverted index to fast query index by value.
if(stackedByDimInfo){stackedByDimInfo.createInvertedIndices=true;}var stackedDimCoordDim=stackedDimInfo.coordDim;var stackedDimType=stackedDimInfo.type;var stackedDimCoordIndex=0;each$1(dimensionInfoList,function(dimensionInfo){if(dimensionInfo.coordDim===stackedDimCoordDim){stackedDimCoordIndex++;}});dimensionInfoList.push({name:stackResultDimension,coordDim:stackedDimCoordDim,coordDimIndex:stackedDimCoordIndex,type:stackedDimType,isExtraCoord:true,isCalculationCoord:true});stackedDimCoordIndex++;dimensionInfoList.push({name:stackedOverDimension,// This dimension contains stack base (generally, 0), so do not set it as
// `stackedDimCoordDim` to avoid extent calculation, consider log scale.
coordDim:stackedOverDimension,coordDimIndex:stackedDimCoordIndex,type:stackedDimType,isExtraCoord:true,isCalculationCoord:true});}return{stackedDimension:stackedDimInfo&&stackedDimInfo.name,stackedByDimension:stackedByDimInfo&&stackedByDimInfo.name,isStackedByIndex:byIndex,stackedOverDimension:stackedOverDimension,stackResultDimension:stackResultDimension};}/**
 * @param {module:echarts/data/List} data
 * @param {string} stackedDim
 */function isDimensionStacked(data,stackedDim/*, stackedByDim*/){// Each single series only maps to one pair of axis. So we do not need to
// check stackByDim, whatever stacked by a dimension or stacked by index.
return!!stackedDim&&stackedDim===data.getCalculationInfo('stackedDimension');// && (
//     stackedByDim != null
//         ? stackedByDim === data.getCalculationInfo('stackedByDimension')
//         : data.getCalculationInfo('isStackedByIndex')
// );
}/**
 * @param {module:echarts/data/List} data
 * @param {string} targetDim
 * @param {string} [stackedByDim] If not input this parameter, check whether
 *                                stacked by index.
 * @return {string} dimension
 */function getStackedDimension(data,targetDim){return isDimensionStacked(data,targetDim)?data.getCalculationInfo('stackResultDimension'):targetDim;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @param {module:echarts/data/Source|Array} source Or raw data.
 * @param {module:echarts/model/Series} seriesModel
 * @param {Object} [opt]
 * @param {string} [opt.generateCoord]
 */function createListFromArray(source,seriesModel,opt){opt=opt||{};if(!Source.isInstance(source)){source=Source.seriesDataToSource(source);}var coordSysName=seriesModel.get('coordinateSystem');var registeredCoordSys=CoordinateSystemManager.get(coordSysName);var coordSysDefine=getCoordSysDefineBySeries(seriesModel);var coordSysDimDefs;if(coordSysDefine){coordSysDimDefs=map(coordSysDefine.coordSysDims,function(dim){var dimInfo={name:dim};var axisModel=coordSysDefine.axisMap.get(dim);if(axisModel){var axisType=axisModel.get('type');dimInfo.type=getDimensionTypeByAxis(axisType);// dimInfo.stackable = isStackable(axisType);
}return dimInfo;});}if(!coordSysDimDefs){// Get dimensions from registered coordinate system
coordSysDimDefs=registeredCoordSys&&(registeredCoordSys.getDimensionsInfo?registeredCoordSys.getDimensionsInfo():registeredCoordSys.dimensions.slice())||['x','y'];}var dimInfoList=createDimensions(source,{coordDimensions:coordSysDimDefs,generateCoord:opt.generateCoord});var firstCategoryDimIndex;var hasNameEncode;coordSysDefine&&each$1(dimInfoList,function(dimInfo,dimIndex){var coordDim=dimInfo.coordDim;var categoryAxisModel=coordSysDefine.categoryAxisMap.get(coordDim);if(categoryAxisModel){if(firstCategoryDimIndex==null){firstCategoryDimIndex=dimIndex;}dimInfo.ordinalMeta=categoryAxisModel.getOrdinalMeta();}if(dimInfo.otherDims.itemName!=null){hasNameEncode=true;}});if(!hasNameEncode&&firstCategoryDimIndex!=null){dimInfoList[firstCategoryDimIndex].otherDims.itemName=0;}var stackCalculationInfo=enableDataStack(seriesModel,dimInfoList);var list=new List(dimInfoList,seriesModel);list.setCalculationInfo(stackCalculationInfo);var dimValueGetter=firstCategoryDimIndex!=null&&isNeedCompleteOrdinalData(source)?function(itemOpt,dimName,dataIndex,dimIndex){// Use dataIndex as ordinal value in categoryAxis
return dimIndex===firstCategoryDimIndex?dataIndex:this.defaultDimValueGetter(itemOpt,dimName,dataIndex,dimIndex);}:null;list.hasItemOption=false;list.initData(source,null,dimValueGetter);return list;}function isNeedCompleteOrdinalData(source){if(source.sourceFormat===SOURCE_FORMAT_ORIGINAL){var sampleItem=firstDataNotNull(source.data||[]);return sampleItem!=null&&!isArray(getDataItemValue(sampleItem));}}function firstDataNotNull(data){var i=0;while(i<data.length&&data[i]==null){i++;}return data[i];}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * // Scale class management
 * @module echarts/scale/Scale
 *//**
 * @param {Object} [setting]
 */function Scale(setting){this._setting=setting||{};/**
   * Extent
   * @type {Array.<number>}
   * @protected
   */this._extent=[Infinity,-Infinity];/**
   * Step is calculated in adjustExtent
   * @type {Array.<number>}
   * @protected
   */this._interval=0;this.init&&this.init.apply(this,arguments);}/**
 * Parse input val to valid inner number.
 * @param {*} val
 * @return {number}
 */Scale.prototype.parse=function(val){// Notice: This would be a trap here, If the implementation
// of this method depends on extent, and this method is used
// before extent set (like in dataZoom), it would be wrong.
// Nevertheless, parse does not depend on extent generally.
return val;};Scale.prototype.getSetting=function(name){return this._setting[name];};Scale.prototype.contain=function(val){var extent=this._extent;return val>=extent[0]&&val<=extent[1];};/**
 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
 * @param {number} val
 * @return {number}
 */Scale.prototype.normalize=function(val){var extent=this._extent;if(extent[1]===extent[0]){return 0.5;}return(val-extent[0])/(extent[1]-extent[0]);};/**
 * Scale normalized value
 * @param {number} val
 * @return {number}
 */Scale.prototype.scale=function(val){var extent=this._extent;return val*(extent[1]-extent[0])+extent[0];};/**
 * Set extent from data
 * @param {Array.<number>} other
 */Scale.prototype.unionExtent=function(other){var extent=this._extent;other[0]<extent[0]&&(extent[0]=other[0]);other[1]>extent[1]&&(extent[1]=other[1]);// not setExtent because in log axis it may transformed to power
// this.setExtent(extent[0], extent[1]);
};/**
 * Set extent from data
 * @param {module:echarts/data/List} data
 * @param {string} dim
 */Scale.prototype.unionExtentFromData=function(data,dim){this.unionExtent(data.getApproximateExtent(dim));};/**
 * Get extent
 * @return {Array.<number>}
 */Scale.prototype.getExtent=function(){return this._extent.slice();};/**
 * Set extent
 * @param {number} start
 * @param {number} end
 */Scale.prototype.setExtent=function(start,end){var thisExtent=this._extent;if(!isNaN(start)){thisExtent[0]=start;}if(!isNaN(end)){thisExtent[1]=end;}};/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */Scale.prototype.isBlank=function(){return this._isBlank;},/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */Scale.prototype.setBlank=function(isBlank){this._isBlank=isBlank;};/**
 * @abstract
 * @param {*} tick
 * @return {string} label of the tick.
 */Scale.prototype.getLabel=null;enableClassExtend(Scale);enableClassManagement(Scale,{registerWhenExtend:true});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @constructor
 * @param {Object} [opt]
 * @param {Object} [opt.categories=[]]
 * @param {Object} [opt.needCollect=false]
 * @param {Object} [opt.deduplication=false]
 */function OrdinalMeta(opt){/**
   * @readOnly
   * @type {Array.<string>}
   */this.categories=opt.categories||[];/**
   * @private
   * @type {boolean}
   */this._needCollect=opt.needCollect;/**
   * @private
   * @type {boolean}
   */this._deduplication=opt.deduplication;/**
   * @private
   * @type {boolean}
   */this._map;}/**
 * @param {module:echarts/model/Model} axisModel
 * @return {module:echarts/data/OrdinalMeta}
 */OrdinalMeta.createByAxisModel=function(axisModel){var option=axisModel.option;var data=option.data;var categories=data&&map(data,getName);return new OrdinalMeta({categories:categories,needCollect:!categories,// deduplication is default in axis.
deduplication:option.dedplication!==false});};var proto$1=OrdinalMeta.prototype;/**
 * @param {string} category
 * @return {number} ordinal
 */proto$1.getOrdinal=function(category){return getOrCreateMap(this).get(category);};/**
 * @param {*} category
 * @return {number} The ordinal. If not found, return NaN.
 */proto$1.parseAndCollect=function(category){var index;var needCollect=this._needCollect;// The value of category dim can be the index of the given category set.
// This feature is only supported when !needCollect, because we should
// consider a common case: a value is 2017, which is a number but is
// expected to be tread as a category. This case usually happen in dataset,
// where it happent to be no need of the index feature.
if(typeof category!=='string'&&!needCollect){return category;}// Optimize for the scenario:
// category is ['2012-01-01', '2012-01-02', ...], where the input
// data has been ensured not duplicate and is large data.
// Notice, if a dataset dimension provide categroies, usually echarts
// should remove duplication except user tell echarts dont do that
// (set axis.deduplication = false), because echarts do not know whether
// the values in the category dimension has duplication (consider the
// parallel-aqi example)
if(needCollect&&!this._deduplication){index=this.categories.length;this.categories[index]=category;return index;}var map$$1=getOrCreateMap(this);index=map$$1.get(category);if(index==null){if(needCollect){index=this.categories.length;this.categories[index]=category;map$$1.set(category,index);}else{index=NaN;}}return index;};// Consider big data, do not create map until needed.
function getOrCreateMap(ordinalMeta){return ordinalMeta._map||(ordinalMeta._map=createHashMap(ordinalMeta.categories));}function getName(obj){if(isObject$1(obj)&&obj.value!=null){return obj.value;}else{return obj+'';}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Linear continuous scale
 * @module echarts/coord/scale/Ordinal
 *
 * http://en.wikipedia.org/wiki/Level_of_measurement
 */// FIXME only one data
var scaleProto=Scale.prototype;var OrdinalScale=Scale.extend({type:'ordinal',/**
   * @param {module:echarts/data/OrdianlMeta|Array.<string>} ordinalMeta
   */init:function init(ordinalMeta,extent){// Caution: Should not use instanceof, consider ec-extensions using
// import approach to get OrdinalMeta class.
if(!ordinalMeta||isArray(ordinalMeta)){ordinalMeta=new OrdinalMeta({categories:ordinalMeta});}this._ordinalMeta=ordinalMeta;this._extent=extent||[0,ordinalMeta.categories.length-1];},parse:function parse(val){return typeof val==='string'?this._ordinalMeta.getOrdinal(val)// val might be float.
:Math.round(val);},contain:function contain(rank){rank=this.parse(rank);return scaleProto.contain.call(this,rank)&&this._ordinalMeta.categories[rank]!=null;},/**
   * Normalize given rank or name to linear [0, 1]
   * @param {number|string} [val]
   * @return {number}
   */normalize:function normalize(val){return scaleProto.normalize.call(this,this.parse(val));},scale:function scale(val){return Math.round(scaleProto.scale.call(this,val));},/**
   * @return {Array}
   */getTicks:function getTicks(){var ticks=[];var extent=this._extent;var rank=extent[0];while(rank<=extent[1]){ticks.push(rank);rank++;}return ticks;},/**
   * Get item on rank n
   * @param {number} n
   * @return {string}
   */getLabel:function getLabel(n){if(!this.isBlank()){// Note that if no data, ordinalMeta.categories is an empty array.
return this._ordinalMeta.categories[n];}},/**
   * @return {number}
   */count:function count(){return this._extent[1]-this._extent[0]+1;},/**
   * @override
   */unionExtentFromData:function unionExtentFromData(data,dim){this.unionExtent(data.getApproximateExtent(dim));},getOrdinalMeta:function getOrdinalMeta(){return this._ordinalMeta;},niceTicks:noop,niceExtent:noop});/**
 * @return {module:echarts/scale/Time}
 */OrdinalScale.create=function(){return new OrdinalScale();};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * For testable.
 */var roundNumber$1=round$1;/**
 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
 *                                Should be extent[0] < extent[1].
 * @param {number} splitNumber splitNumber should be >= 1.
 * @param {number} [minInterval]
 * @param {number} [maxInterval]
 * @return {Object} {interval, intervalPrecision, niceTickExtent}
 */function intervalScaleNiceTicks(extent,splitNumber,minInterval,maxInterval){var result={};var span=extent[1]-extent[0];var interval=result.interval=nice(span/splitNumber,true);if(minInterval!=null&&interval<minInterval){interval=result.interval=minInterval;}if(maxInterval!=null&&interval>maxInterval){interval=result.interval=maxInterval;}// Tow more digital for tick.
var precision=result.intervalPrecision=getIntervalPrecision(interval);// Niced extent inside original extent
var niceTickExtent=result.niceTickExtent=[roundNumber$1(Math.ceil(extent[0]/interval)*interval,precision),roundNumber$1(Math.floor(extent[1]/interval)*interval,precision)];fixExtent(niceTickExtent,extent);return result;}/**
 * @param {number} interval
 * @return {number} interval precision
 */function getIntervalPrecision(interval){// Tow more digital for tick.
return getPrecisionSafe(interval)+2;}function clamp(niceTickExtent,idx,extent){niceTickExtent[idx]=Math.max(Math.min(niceTickExtent[idx],extent[1]),extent[0]);}// In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
function fixExtent(niceTickExtent,extent){!isFinite(niceTickExtent[0])&&(niceTickExtent[0]=extent[0]);!isFinite(niceTickExtent[1])&&(niceTickExtent[1]=extent[1]);clamp(niceTickExtent,0,extent);clamp(niceTickExtent,1,extent);if(niceTickExtent[0]>niceTickExtent[1]){niceTickExtent[0]=niceTickExtent[1];}}function intervalScaleGetTicks(interval,extent,niceTickExtent,intervalPrecision){var ticks=[];// If interval is 0, return [];
if(!interval){return ticks;}// Consider this case: using dataZoom toolbox, zoom and zoom.
var safeLimit=10000;if(extent[0]<niceTickExtent[0]){ticks.push(extent[0]);}var tick=niceTickExtent[0];while(tick<=niceTickExtent[1]){ticks.push(tick);// Avoid rounding error
tick=roundNumber$1(tick+interval,intervalPrecision);if(tick===ticks[ticks.length-1]){// Consider out of safe float point, e.g.,
// -3711126.9907707 + 2e-10 === -3711126.9907707
break;}if(ticks.length>safeLimit){return[];}}// Consider this case: the last item of ticks is smaller
// than niceTickExtent[1] and niceTickExtent[1] === extent[1].
if(extent[1]>(ticks.length?ticks[ticks.length-1]:niceTickExtent[1])){ticks.push(extent[1]);}return ticks;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Interval scale
 * @module echarts/scale/Interval
 */var roundNumber=round$1;/**
 * @alias module:echarts/coord/scale/Interval
 * @constructor
 */var IntervalScale=Scale.extend({type:'interval',_interval:0,_intervalPrecision:2,setExtent:function setExtent(start,end){var thisExtent=this._extent;//start,end may be a Number like '25',so...
if(!isNaN(start)){thisExtent[0]=parseFloat(start);}if(!isNaN(end)){thisExtent[1]=parseFloat(end);}},unionExtent:function unionExtent(other){var extent=this._extent;other[0]<extent[0]&&(extent[0]=other[0]);other[1]>extent[1]&&(extent[1]=other[1]);// unionExtent may called by it's sub classes
IntervalScale.prototype.setExtent.call(this,extent[0],extent[1]);},/**
   * Get interval
   */getInterval:function getInterval(){return this._interval;},/**
   * Set interval
   */setInterval:function setInterval(interval){this._interval=interval;// Dropped auto calculated niceExtent and use user setted extent
// We assume user wan't to set both interval, min, max to get a better result
this._niceExtent=this._extent.slice();this._intervalPrecision=getIntervalPrecision(interval);},/**
   * @return {Array.<number>}
   */getTicks:function getTicks(){return intervalScaleGetTicks(this._interval,this._extent,this._niceExtent,this._intervalPrecision);},/**
   * @param {number} data
   * @param {Object} [opt]
   * @param {number|string} [opt.precision] If 'auto', use nice presision.
   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
   * @return {string}
   */getLabel:function getLabel(data,opt){if(data==null){return'';}var precision=opt&&opt.precision;if(precision==null){precision=getPrecisionSafe(data)||0;}else if(precision==='auto'){// Should be more precise then tick.
precision=this._intervalPrecision;}// (1) If `precision` is set, 12.005 should be display as '12.00500'.
// (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
data=roundNumber(data,precision,true);return addCommas(data);},/**
   * Update interval and extent of intervals for nice ticks
   *
   * @param {number} [splitNumber = 5] Desired number of ticks
   * @param {number} [minInterval]
   * @param {number} [maxInterval]
   */niceTicks:function niceTicks(splitNumber,minInterval,maxInterval){splitNumber=splitNumber||5;var extent=this._extent;var span=extent[1]-extent[0];if(!isFinite(span)){return;}// User may set axis min 0 and data are all negative
// FIXME If it needs to reverse ?
if(span<0){span=-span;extent.reverse();}var result=intervalScaleNiceTicks(extent,splitNumber,minInterval,maxInterval);this._intervalPrecision=result.intervalPrecision;this._interval=result.interval;this._niceExtent=result.niceTickExtent;},/**
   * Nice extent.
   * @param {Object} opt
   * @param {number} [opt.splitNumber = 5] Given approx tick number
   * @param {boolean} [opt.fixMin=false]
   * @param {boolean} [opt.fixMax=false]
   * @param {boolean} [opt.minInterval]
   * @param {boolean} [opt.maxInterval]
   */niceExtent:function niceExtent(opt){var extent=this._extent;// If extent start and end are same, expand them
if(extent[0]===extent[1]){if(extent[0]!==0){// Expand extent
var expandSize=extent[0];// In the fowllowing case
//      Axis has been fixed max 100
//      Plus data are all 100 and axis extent are [100, 100].
// Extend to the both side will cause expanded max is larger than fixed max.
// So only expand to the smaller side.
if(!opt.fixMax){extent[1]+=expandSize/2;extent[0]-=expandSize/2;}else{extent[0]-=expandSize/2;}}else{extent[1]=1;}}var span=extent[1]-extent[0];// If there are no data and extent are [Infinity, -Infinity]
if(!isFinite(span)){extent[0]=0;extent[1]=1;}this.niceTicks(opt.splitNumber,opt.minInterval,opt.maxInterval);// var extent = this._extent;
var interval=this._interval;if(!opt.fixMin){extent[0]=roundNumber(Math.floor(extent[0]/interval)*interval);}if(!opt.fixMax){extent[1]=roundNumber(Math.ceil(extent[1]/interval)*interval);}}});/**
 * @return {module:echarts/scale/Time}
 */IntervalScale.create=function(){return new IntervalScale();};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var STACK_PREFIX='__ec_stack_';var LARGE_BAR_MIN_WIDTH=0.5;var LargeArr=typeof Float32Array!=='undefined'?Float32Array:Array;function getSeriesStackId(seriesModel){return seriesModel.get('stack')||STACK_PREFIX+seriesModel.seriesIndex;}function getAxisKey(axis){return axis.dim+axis.index;}/**
 * @param {Object} opt
 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
 * @param {number} opt.count Positive interger.
 * @param {number} [opt.barWidth]
 * @param {number} [opt.barMaxWidth]
 * @param {number} [opt.barGap]
 * @param {number} [opt.barCategoryGap]
 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
 */function prepareLayoutBarSeries(seriesType,ecModel){var seriesModels=[];ecModel.eachSeriesByType(seriesType,function(seriesModel){// Check series coordinate, do layout for cartesian2d only
if(isOnCartesian(seriesModel)&&!isInLargeMode(seriesModel)){seriesModels.push(seriesModel);}});return seriesModels;}function makeColumnLayout(barSeries){var seriesInfoList=[];each$1(barSeries,function(seriesModel){var data=seriesModel.getData();var cartesian=seriesModel.coordinateSystem;var baseAxis=cartesian.getBaseAxis();var axisExtent=baseAxis.getExtent();var bandWidth=baseAxis.type==='category'?baseAxis.getBandWidth():Math.abs(axisExtent[1]-axisExtent[0])/data.count();var barWidth=parsePercent$1(seriesModel.get('barWidth'),bandWidth);var barMaxWidth=parsePercent$1(seriesModel.get('barMaxWidth'),bandWidth);var barGap=seriesModel.get('barGap');var barCategoryGap=seriesModel.get('barCategoryGap');seriesInfoList.push({bandWidth:bandWidth,barWidth:barWidth,barMaxWidth:barMaxWidth,barGap:barGap,barCategoryGap:barCategoryGap,axisKey:getAxisKey(baseAxis),stackId:getSeriesStackId(seriesModel)});});return doCalBarWidthAndOffset(seriesInfoList);}function doCalBarWidthAndOffset(seriesInfoList){// Columns info on each category axis. Key is cartesian name
var columnsMap={};each$1(seriesInfoList,function(seriesInfo,idx){var axisKey=seriesInfo.axisKey;var bandWidth=seriesInfo.bandWidth;var columnsOnAxis=columnsMap[axisKey]||{bandWidth:bandWidth,remainedWidth:bandWidth,autoWidthCount:0,categoryGap:'20%',gap:'30%',stacks:{}};var stacks=columnsOnAxis.stacks;columnsMap[axisKey]=columnsOnAxis;var stackId=seriesInfo.stackId;if(!stacks[stackId]){columnsOnAxis.autoWidthCount++;}stacks[stackId]=stacks[stackId]||{width:0,maxWidth:0};// Caution: In a single coordinate system, these barGrid attributes
// will be shared by series. Consider that they have default values,
// only the attributes set on the last series will work.
// Do not change this fact unless there will be a break change.
// TODO
var barWidth=seriesInfo.barWidth;if(barWidth&&!stacks[stackId].width){// See #6312, do not restrict width.
stacks[stackId].width=barWidth;barWidth=Math.min(columnsOnAxis.remainedWidth,barWidth);columnsOnAxis.remainedWidth-=barWidth;}var barMaxWidth=seriesInfo.barMaxWidth;barMaxWidth&&(stacks[stackId].maxWidth=barMaxWidth);var barGap=seriesInfo.barGap;barGap!=null&&(columnsOnAxis.gap=barGap);var barCategoryGap=seriesInfo.barCategoryGap;barCategoryGap!=null&&(columnsOnAxis.categoryGap=barCategoryGap);});var result={};each$1(columnsMap,function(columnsOnAxis,coordSysName){result[coordSysName]={};var stacks=columnsOnAxis.stacks;var bandWidth=columnsOnAxis.bandWidth;var categoryGap=parsePercent$1(columnsOnAxis.categoryGap,bandWidth);var barGapPercent=parsePercent$1(columnsOnAxis.gap,1);var remainedWidth=columnsOnAxis.remainedWidth;var autoWidthCount=columnsOnAxis.autoWidthCount;var autoWidth=(remainedWidth-categoryGap)/(autoWidthCount+(autoWidthCount-1)*barGapPercent);autoWidth=Math.max(autoWidth,0);// Find if any auto calculated bar exceeded maxBarWidth
each$1(stacks,function(column,stack){var maxWidth=column.maxWidth;if(maxWidth&&maxWidth<autoWidth){maxWidth=Math.min(maxWidth,remainedWidth);if(column.width){maxWidth=Math.min(maxWidth,column.width);}remainedWidth-=maxWidth;column.width=maxWidth;autoWidthCount--;}});// Recalculate width again
autoWidth=(remainedWidth-categoryGap)/(autoWidthCount+(autoWidthCount-1)*barGapPercent);autoWidth=Math.max(autoWidth,0);var widthSum=0;var lastColumn;each$1(stacks,function(column,idx){if(!column.width){column.width=autoWidth;}lastColumn=column;widthSum+=column.width*(1+barGapPercent);});if(lastColumn){widthSum-=lastColumn.width*barGapPercent;}var offset=-widthSum/2;each$1(stacks,function(column,stackId){result[coordSysName][stackId]=result[coordSysName][stackId]||{offset:offset,width:column.width};offset+=column.width*(1+barGapPercent);});});return result;}/**
 * @param {Object} barWidthAndOffset The result of makeColumnLayout
 * @param {module:echarts/coord/Axis} axis
 * @param {module:echarts/model/Series} [seriesModel] If not provided, return all.
 * @return {Object} {stackId: {offset, width}} or {offset, width} if seriesModel provided.
 */function retrieveColumnLayout(barWidthAndOffset,axis,seriesModel){if(barWidthAndOffset&&axis){var result=barWidthAndOffset[getAxisKey(axis)];if(result!=null&&seriesModel!=null){result=result[getSeriesStackId(seriesModel)];}return result;}}/**
 * @param {string} seriesType
 * @param {module:echarts/model/Global} ecModel
 */function layout(seriesType,ecModel){var seriesModels=prepareLayoutBarSeries(seriesType,ecModel);var barWidthAndOffset=makeColumnLayout(seriesModels);var lastStackCoords={};each$1(seriesModels,function(seriesModel){var data=seriesModel.getData();var cartesian=seriesModel.coordinateSystem;var baseAxis=cartesian.getBaseAxis();var stackId=getSeriesStackId(seriesModel);var columnLayoutInfo=barWidthAndOffset[getAxisKey(baseAxis)][stackId];var columnOffset=columnLayoutInfo.offset;var columnWidth=columnLayoutInfo.width;var valueAxis=cartesian.getOtherAxis(baseAxis);var barMinHeight=seriesModel.get('barMinHeight')||0;lastStackCoords[stackId]=lastStackCoords[stackId]||[];data.setLayout({offset:columnOffset,size:columnWidth});var valueDim=data.mapDimension(valueAxis.dim);var baseDim=data.mapDimension(baseAxis.dim);var stacked=isDimensionStacked(data,valueDim/*, baseDim*/);var isValueAxisH=valueAxis.isHorizontal();var valueAxisStart=getValueAxisStart(baseAxis,valueAxis,stacked);for(var idx=0,len=data.count();idx<len;idx++){var value=data.get(valueDim,idx);var baseValue=data.get(baseDim,idx);if(isNaN(value)){continue;}var sign=value>=0?'p':'n';var baseCoord=valueAxisStart;// Because of the barMinHeight, we can not use the value in
// stackResultDimension directly.
if(stacked){// Only ordinal axis can be stacked.
if(!lastStackCoords[stackId][baseValue]){lastStackCoords[stackId][baseValue]={p:valueAxisStart,// Positive stack
n:valueAxisStart// Negative stack
};}// Should also consider #4243
baseCoord=lastStackCoords[stackId][baseValue][sign];}var x;var y;var width;var height;if(isValueAxisH){var coord=cartesian.dataToPoint([value,baseValue]);x=baseCoord;y=coord[1]+columnOffset;width=coord[0]-valueAxisStart;height=columnWidth;if(Math.abs(width)<barMinHeight){width=(width<0?-1:1)*barMinHeight;}stacked&&(lastStackCoords[stackId][baseValue][sign]+=width);}else{var coord=cartesian.dataToPoint([baseValue,value]);x=coord[0]+columnOffset;y=baseCoord;width=columnWidth;height=coord[1]-valueAxisStart;if(Math.abs(height)<barMinHeight){// Include zero to has a positive bar
height=(height<=0?-1:1)*barMinHeight;}stacked&&(lastStackCoords[stackId][baseValue][sign]+=height);}data.setItemLayout(idx,{x:x,y:y,width:width,height:height});}},this);}// TODO: Do not support stack in large mode yet.
var largeLayout={seriesType:'bar',plan:createRenderPlanner(),reset:function reset(seriesModel){if(!isOnCartesian(seriesModel)||!isInLargeMode(seriesModel)){return;}var data=seriesModel.getData();var cartesian=seriesModel.coordinateSystem;var baseAxis=cartesian.getBaseAxis();var valueAxis=cartesian.getOtherAxis(baseAxis);var valueDim=data.mapDimension(valueAxis.dim);var baseDim=data.mapDimension(baseAxis.dim);var valueAxisHorizontal=valueAxis.isHorizontal();var valueDimIdx=valueAxisHorizontal?0:1;var barWidth=retrieveColumnLayout(makeColumnLayout([seriesModel]),baseAxis,seriesModel).width;if(!(barWidth>LARGE_BAR_MIN_WIDTH)){// jshint ignore:line
barWidth=LARGE_BAR_MIN_WIDTH;}return{progress:progress};function progress(params,data){var largePoints=new LargeArr(params.count*2);var dataIndex;var coord=[];var valuePair=[];var offset=0;while((dataIndex=params.next())!=null){valuePair[valueDimIdx]=data.get(valueDim,dataIndex);valuePair[1-valueDimIdx]=data.get(baseDim,dataIndex);coord=cartesian.dataToPoint(valuePair,null,coord);largePoints[offset++]=coord[0];largePoints[offset++]=coord[1];}data.setLayout({largePoints:largePoints,barWidth:barWidth,valueAxisStart:getValueAxisStart(baseAxis,valueAxis,false),valueAxisHorizontal:valueAxisHorizontal});}}};function isOnCartesian(seriesModel){return seriesModel.coordinateSystem&&seriesModel.coordinateSystem.type==='cartesian2d';}function isInLargeMode(seriesModel){return seriesModel.pipelineContext&&seriesModel.pipelineContext.large;}function getValueAxisStart(baseAxis,valueAxis,stacked){return indexOf(baseAxis.getAxesOnZeroOf(),valueAxis)>=0||stacked?valueAxis.toGlobalCoord(valueAxis.dataToCoord(0)):valueAxis.getGlobalExtent()[0];}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//*
* The `scaleLevels` references to d3.js. The use of the source
* code of this file is also subject to the terms and consitions
* of its license (BSD-3Clause, see <echarts/src/licenses/LICENSE-d3>).
*/// [About UTC and local time zone]:
// In most cases, `number.parseDate` will treat input data string as local time
// (except time zone is specified in time string). And `format.formateTime` returns
// local time by default. option.useUTC is false by default. This design have
// concidered these common case:
// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
// in local time by default.
// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
// as its original time, without any time difference.
var intervalScaleProto=IntervalScale.prototype;var mathCeil=Math.ceil;var mathFloor=Math.floor;var ONE_SECOND=1000;var ONE_MINUTE=ONE_SECOND*60;var ONE_HOUR=ONE_MINUTE*60;var ONE_DAY=ONE_HOUR*24;// FIXME 公用？
var bisect=function bisect(a,x,lo,hi){while(lo<hi){var mid=lo+hi>>>1;if(a[mid][1]<x){lo=mid+1;}else{hi=mid;}}return lo;};/**
 * @alias module:echarts/coord/scale/Time
 * @constructor
 */var TimeScale=IntervalScale.extend({type:'time',/**
   * @override
   */getLabel:function getLabel(val){var stepLvl=this._stepLvl;var date=new Date(val);return formatTime(stepLvl[0],date,this.getSetting('useUTC'));},/**
   * @override
   */niceExtent:function niceExtent(opt){var extent=this._extent;// If extent start and end are same, expand them
if(extent[0]===extent[1]){// Expand extent
extent[0]-=ONE_DAY;extent[1]+=ONE_DAY;}// If there are no data and extent are [Infinity, -Infinity]
if(extent[1]===-Infinity&&extent[0]===Infinity){var d=new Date();extent[1]=+new Date(d.getFullYear(),d.getMonth(),d.getDate());extent[0]=extent[1]-ONE_DAY;}this.niceTicks(opt.splitNumber,opt.minInterval,opt.maxInterval);// var extent = this._extent;
var interval=this._interval;if(!opt.fixMin){extent[0]=round$1(mathFloor(extent[0]/interval)*interval);}if(!opt.fixMax){extent[1]=round$1(mathCeil(extent[1]/interval)*interval);}},/**
   * @override
   */niceTicks:function niceTicks(approxTickNum,minInterval,maxInterval){approxTickNum=approxTickNum||10;var extent=this._extent;var span=extent[1]-extent[0];var approxInterval=span/approxTickNum;if(minInterval!=null&&approxInterval<minInterval){approxInterval=minInterval;}if(maxInterval!=null&&approxInterval>maxInterval){approxInterval=maxInterval;}var scaleLevelsLen=scaleLevels.length;var idx=bisect(scaleLevels,approxInterval,0,scaleLevelsLen);var level=scaleLevels[Math.min(idx,scaleLevelsLen-1)];var interval=level[1];// Same with interval scale if span is much larger than 1 year
if(level[0]==='year'){var yearSpan=span/interval;// From "Nice Numbers for Graph Labels" of Graphic Gems
// var niceYearSpan = numberUtil.nice(yearSpan, false);
var yearStep=nice(yearSpan/approxTickNum,true);interval*=yearStep;}var timezoneOffset=this.getSetting('useUTC')?0:new Date(+extent[0]||+extent[1]).getTimezoneOffset()*60*1000;var niceExtent=[Math.round(mathCeil((extent[0]-timezoneOffset)/interval)*interval+timezoneOffset),Math.round(mathFloor((extent[1]-timezoneOffset)/interval)*interval+timezoneOffset)];fixExtent(niceExtent,extent);this._stepLvl=level;// Interval will be used in getTicks
this._interval=interval;this._niceExtent=niceExtent;},parse:function parse(val){// val might be float.
return+parseDate(val);}});each$1(['contain','normalize'],function(methodName){TimeScale.prototype[methodName]=function(val){return intervalScaleProto[methodName].call(this,this.parse(val));};});// Steps from d3, see the license statement at the top of this file.
var scaleLevels=[// Format              interval
['hh:mm:ss',ONE_SECOND],// 1s
['hh:mm:ss',ONE_SECOND*5],// 5s
['hh:mm:ss',ONE_SECOND*10],// 10s
['hh:mm:ss',ONE_SECOND*15],// 15s
['hh:mm:ss',ONE_SECOND*30],// 30s
['hh:mm\nMM-dd',ONE_MINUTE],// 1m
['hh:mm\nMM-dd',ONE_MINUTE*5],// 5m
['hh:mm\nMM-dd',ONE_MINUTE*10],// 10m
['hh:mm\nMM-dd',ONE_MINUTE*15],// 15m
['hh:mm\nMM-dd',ONE_MINUTE*30],// 30m
['hh:mm\nMM-dd',ONE_HOUR],// 1h
['hh:mm\nMM-dd',ONE_HOUR*2],// 2h
['hh:mm\nMM-dd',ONE_HOUR*6],// 6h
['hh:mm\nMM-dd',ONE_HOUR*12],// 12h
['MM-dd\nyyyy',ONE_DAY],// 1d
['MM-dd\nyyyy',ONE_DAY*2],// 2d
['MM-dd\nyyyy',ONE_DAY*3],// 3d
['MM-dd\nyyyy',ONE_DAY*4],// 4d
['MM-dd\nyyyy',ONE_DAY*5],// 5d
['MM-dd\nyyyy',ONE_DAY*6],// 6d
['week',ONE_DAY*7],// 7d
['MM-dd\nyyyy',ONE_DAY*10],// 10d
['week',ONE_DAY*14],// 2w
['week',ONE_DAY*21],// 3w
['month',ONE_DAY*31],// 1M
['week',ONE_DAY*42],// 6w
['month',ONE_DAY*62],// 2M
['week',ONE_DAY*42],// 10w
['quarter',ONE_DAY*380/4],// 3M
['month',ONE_DAY*31*4],// 4M
['month',ONE_DAY*31*5],// 5M
['half-year',ONE_DAY*380/2],// 6M
['month',ONE_DAY*31*8],// 8M
['month',ONE_DAY*31*10],// 10M
['year',ONE_DAY*380]// 1Y
];/**
 * @param {module:echarts/model/Model}
 * @return {module:echarts/scale/Time}
 */TimeScale.create=function(model){return new TimeScale({useUTC:model.ecModel.get('useUTC')});};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Log scale
 * @module echarts/scale/Log
 */var scaleProto$1=Scale.prototype;var intervalScaleProto$1=IntervalScale.prototype;var getPrecisionSafe$1=getPrecisionSafe;var roundingErrorFix=round$1;var mathFloor$1=Math.floor;var mathCeil$1=Math.ceil;var mathPow$1=Math.pow;var mathLog=Math.log;var LogScale=Scale.extend({type:'log',base:10,$constructor:function $constructor(){Scale.apply(this,arguments);this._originalScale=new IntervalScale();},/**
   * @return {Array.<number>}
   */getTicks:function getTicks(){var originalScale=this._originalScale;var extent=this._extent;var originalExtent=originalScale.getExtent();return map(intervalScaleProto$1.getTicks.call(this),function(val){var powVal=round$1(mathPow$1(this.base,val));// Fix #4158
powVal=val===extent[0]&&originalScale.__fixMin?fixRoundingError(powVal,originalExtent[0]):powVal;powVal=val===extent[1]&&originalScale.__fixMax?fixRoundingError(powVal,originalExtent[1]):powVal;return powVal;},this);},/**
   * @param {number} val
   * @return {string}
   */getLabel:intervalScaleProto$1.getLabel,/**
   * @param  {number} val
   * @return {number}
   */scale:function scale(val){val=scaleProto$1.scale.call(this,val);return mathPow$1(this.base,val);},/**
   * @param {number} start
   * @param {number} end
   */setExtent:function setExtent(start,end){var base=this.base;start=mathLog(start)/mathLog(base);end=mathLog(end)/mathLog(base);intervalScaleProto$1.setExtent.call(this,start,end);},/**
   * @return {number} end
   */getExtent:function getExtent(){var base=this.base;var extent=scaleProto$1.getExtent.call(this);extent[0]=mathPow$1(base,extent[0]);extent[1]=mathPow$1(base,extent[1]);// Fix #4158
var originalScale=this._originalScale;var originalExtent=originalScale.getExtent();originalScale.__fixMin&&(extent[0]=fixRoundingError(extent[0],originalExtent[0]));originalScale.__fixMax&&(extent[1]=fixRoundingError(extent[1],originalExtent[1]));return extent;},/**
   * @param  {Array.<number>} extent
   */unionExtent:function unionExtent(extent){this._originalScale.unionExtent(extent);var base=this.base;extent[0]=mathLog(extent[0])/mathLog(base);extent[1]=mathLog(extent[1])/mathLog(base);scaleProto$1.unionExtent.call(this,extent);},/**
   * @override
   */unionExtentFromData:function unionExtentFromData(data,dim){// TODO
// filter value that <= 0
this.unionExtent(data.getApproximateExtent(dim));},/**
   * Update interval and extent of intervals for nice ticks
   * @param  {number} [approxTickNum = 10] Given approx tick number
   */niceTicks:function niceTicks(approxTickNum){approxTickNum=approxTickNum||10;var extent=this._extent;var span=extent[1]-extent[0];if(span===Infinity||span<=0){return;}var interval=quantity(span);var err=approxTickNum/span*interval;// Filter ticks to get closer to the desired count.
if(err<=0.5){interval*=10;}// Interval should be integer
while(!isNaN(interval)&&Math.abs(interval)<1&&Math.abs(interval)>0){interval*=10;}var niceExtent=[round$1(mathCeil$1(extent[0]/interval)*interval),round$1(mathFloor$1(extent[1]/interval)*interval)];this._interval=interval;this._niceExtent=niceExtent;},/**
   * Nice extent.
   * @override
   */niceExtent:function niceExtent(opt){intervalScaleProto$1.niceExtent.call(this,opt);var originalScale=this._originalScale;originalScale.__fixMin=opt.fixMin;originalScale.__fixMax=opt.fixMax;}});each$1(['contain','normalize'],function(methodName){LogScale.prototype[methodName]=function(val){val=mathLog(val)/mathLog(this.base);return scaleProto$1[methodName].call(this,val);};});LogScale.create=function(){return new LogScale();};function fixRoundingError(val,originalVal){return roundingErrorFix(val,getPrecisionSafe$1(originalVal));}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Get axis scale extent before niced.
 * Item of returned array can only be number (including Infinity and NaN).
 */function getScaleExtent(scale,model){var scaleType=scale.type;var min=model.getMin();var max=model.getMax();var fixMin=min!=null;var fixMax=max!=null;var originalExtent=scale.getExtent();var axisDataLen;var boundaryGap;var span;if(scaleType==='ordinal'){axisDataLen=model.getCategories().length;}else{boundaryGap=model.get('boundaryGap');if(!isArray(boundaryGap)){boundaryGap=[boundaryGap||0,boundaryGap||0];}if(typeof boundaryGap[0]==='boolean'){boundaryGap=[0,0];}boundaryGap[0]=parsePercent$1(boundaryGap[0],1);boundaryGap[1]=parsePercent$1(boundaryGap[1],1);span=originalExtent[1]-originalExtent[0]||Math.abs(originalExtent[0]);}// Notice: When min/max is not set (that is, when there are null/undefined,
// which is the most common case), these cases should be ensured:
// (1) For 'ordinal', show all axis.data.
// (2) For others:
//      + `boundaryGap` is applied (if min/max set, boundaryGap is
//      disabled).
//      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
//      be the result that originalExtent enlarged by boundaryGap.
// (3) If no data, it should be ensured that `scale.setBlank` is set.
// FIXME
// (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
// (2) When `needCrossZero` and all data is positive/negative, should it be ensured
// that the results processed by boundaryGap are positive/negative?
if(min==null){min=scaleType==='ordinal'?axisDataLen?0:NaN:originalExtent[0]-boundaryGap[0]*span;}if(max==null){max=scaleType==='ordinal'?axisDataLen?axisDataLen-1:NaN:originalExtent[1]+boundaryGap[1]*span;}if(min==='dataMin'){min=originalExtent[0];}else if(typeof min==='function'){min=min({min:originalExtent[0],max:originalExtent[1]});}if(max==='dataMax'){max=originalExtent[1];}else if(typeof max==='function'){max=max({min:originalExtent[0],max:originalExtent[1]});}(min==null||!isFinite(min))&&(min=NaN);(max==null||!isFinite(max))&&(max=NaN);scale.setBlank(eqNaN(min)||eqNaN(max)||scaleType==='ordinal'&&!scale.getOrdinalMeta().categories.length);// Evaluate if axis needs cross zero
if(model.getNeedCrossZero()){// Axis is over zero and min is not set
if(min>0&&max>0&&!fixMin){min=0;}// Axis is under zero and max is not set
if(min<0&&max<0&&!fixMax){max=0;}}// If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
// is base axis
// FIXME
// (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
// (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
//     Should not depend on series type `bar`?
// (3) Fix that might overlap when using dataZoom.
// (4) Consider other chart types using `barGrid`?
// See #6728, #4862, `test/bar-overflow-time-plot.html`
var ecModel=model.ecModel;if(ecModel&&scaleType==='time'/*|| scaleType === 'interval' */){var barSeriesModels=prepareLayoutBarSeries('bar',ecModel);var isBaseAxisAndHasBarSeries;each$1(barSeriesModels,function(seriesModel){isBaseAxisAndHasBarSeries|=seriesModel.getBaseAxis()===model.axis;});if(isBaseAxisAndHasBarSeries){// Calculate placement of bars on axis
var barWidthAndOffset=makeColumnLayout(barSeriesModels);// Adjust axis min and max to account for overflow
var adjustedScale=adjustScaleForOverflow(min,max,model,barWidthAndOffset);min=adjustedScale.min;max=adjustedScale.max;}}return[min,max];}function adjustScaleForOverflow(min,max,model,barWidthAndOffset){// Get Axis Length
var axisExtent=model.axis.getExtent();var axisLength=axisExtent[1]-axisExtent[0];// Get bars on current base axis and calculate min and max overflow
var barsOnCurrentAxis=retrieveColumnLayout(barWidthAndOffset,model.axis);if(barsOnCurrentAxis===undefined){return{min:min,max:max};}var minOverflow=Infinity;each$1(barsOnCurrentAxis,function(item){minOverflow=Math.min(item.offset,minOverflow);});var maxOverflow=-Infinity;each$1(barsOnCurrentAxis,function(item){maxOverflow=Math.max(item.offset+item.width,maxOverflow);});minOverflow=Math.abs(minOverflow);maxOverflow=Math.abs(maxOverflow);var totalOverFlow=minOverflow+maxOverflow;// Calulate required buffer based on old range and overflow
var oldRange=max-min;var oldRangePercentOfNew=1-(minOverflow+maxOverflow)/axisLength;var overflowBuffer=oldRange/oldRangePercentOfNew-oldRange;max+=overflowBuffer*(maxOverflow/totalOverFlow);min-=overflowBuffer*(minOverflow/totalOverFlow);return{min:min,max:max};}function niceScaleExtent(scale,model){var extent=getScaleExtent(scale,model);var fixMin=model.getMin()!=null;var fixMax=model.getMax()!=null;var splitNumber=model.get('splitNumber');if(scale.type==='log'){scale.base=model.get('logBase');}var scaleType=scale.type;scale.setExtent(extent[0],extent[1]);scale.niceExtent({splitNumber:splitNumber,fixMin:fixMin,fixMax:fixMax,minInterval:scaleType==='interval'||scaleType==='time'?model.get('minInterval'):null,maxInterval:scaleType==='interval'||scaleType==='time'?model.get('maxInterval'):null});// If some one specified the min, max. And the default calculated interval
// is not good enough. He can specify the interval. It is often appeared
// in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
// to be 60.
// FIXME
var interval=model.get('interval');if(interval!=null){scale.setInterval&&scale.setInterval(interval);}}/**
 * @param {module:echarts/model/Model} model
 * @param {string} [axisType] Default retrieve from model.type
 * @return {module:echarts/scale/*}
 */function createScaleByModel(model,axisType){axisType=axisType||model.get('type');if(axisType){switch(axisType){// Buildin scale
case'category':return new OrdinalScale(model.getOrdinalMeta?model.getOrdinalMeta():model.getCategories(),[Infinity,-Infinity]);case'value':return new IntervalScale();// Extended scale, like time and log
default:return(Scale.getClass(axisType)||IntervalScale).create(model);}}}/**
 * Check if the axis corss 0
 */function ifAxisCrossZero(axis){var dataExtent=axis.scale.getExtent();var min=dataExtent[0];var max=dataExtent[1];return!(min>0&&max>0||min<0&&max<0);}/**
 * @param {module:echarts/coord/Axis} axis
 * @return {Function} Label formatter function.
 *         param: {number} tickValue,
 *         param: {number} idx, the index in all ticks.
 *                         If category axis, this param is not requied.
 *         return: {string} label string.
 */function makeLabelFormatter(axis){var labelFormatter=axis.getLabelModel().get('formatter');var categoryTickStart=axis.type==='category'?axis.scale.getExtent()[0]:null;if(typeof labelFormatter==='string'){labelFormatter=function(tpl){return function(val){return tpl.replace('{value}',val!=null?val:'');};}(labelFormatter);// Consider empty array
return labelFormatter;}else if(typeof labelFormatter==='function'){return function(tickValue,idx){// The original intention of `idx` is "the index of the tick in all ticks".
// But the previous implementation of category axis do not consider the
// `axisLabel.interval`, which cause that, for example, the `interval` is
// `1`, then the ticks "name5", "name7", "name9" are displayed, where the
// corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
// the definition here for back compatibility.
if(categoryTickStart!=null){idx=tickValue-categoryTickStart;}return labelFormatter(getAxisRawValue(axis,tickValue),idx);};}else{return function(tick){return axis.scale.getLabel(tick);};}}function getAxisRawValue(axis,value){// In category axis with data zoom, tick is not the original
// index of axis.data. So tick should not be exposed to user
// in category axis.
return axis.type==='category'?axis.scale.getLabel(value):value;}/**
 * @param {module:echarts/coord/Axis} axis
 * @return {module:zrender/core/BoundingRect} Be null/undefined if no labels.
 */function estimateLabelUnionRect(axis){var axisModel=axis.model;var scale=axis.scale;if(!axisModel.get('axisLabel.show')||scale.isBlank()){return;}var isCategory=axis.type==='category';var realNumberScaleTicks;var tickCount;var categoryScaleExtent=scale.getExtent();// Optimize for large category data, avoid call `getTicks()`.
if(isCategory){tickCount=scale.count();}else{realNumberScaleTicks=scale.getTicks();tickCount=realNumberScaleTicks.length;}var axisLabelModel=axis.getLabelModel();var labelFormatter=makeLabelFormatter(axis);var rect;var step=1;// Simple optimization for large amount of labels
if(tickCount>40){step=Math.ceil(tickCount/40);}for(var i=0;i<tickCount;i+=step){var tickValue=realNumberScaleTicks?realNumberScaleTicks[i]:categoryScaleExtent[0]+i;var label=labelFormatter(tickValue);var unrotatedSingleRect=axisLabelModel.getTextRect(label);var singleRect=rotateTextRect(unrotatedSingleRect,axisLabelModel.get('rotate')||0);rect?rect.union(singleRect):rect=singleRect;}return rect;}function rotateTextRect(textRect,rotate){var rotateRadians=rotate*Math.PI/180;var boundingBox=textRect.plain();var beforeWidth=boundingBox.width;var beforeHeight=boundingBox.height;var afterWidth=beforeWidth*Math.cos(rotateRadians)+beforeHeight*Math.sin(rotateRadians);var afterHeight=beforeWidth*Math.sin(rotateRadians)+beforeHeight*Math.cos(rotateRadians);var rotatedRect=new BoundingRect(boundingBox.x,boundingBox.y,afterWidth,afterHeight);return rotatedRect;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var axisModelCommonMixin={/**
   * @param {boolean} origin
   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
   */getMin:function getMin(origin){var option=this.option;var min=!origin&&option.rangeStart!=null?option.rangeStart:option.min;if(this.axis&&min!=null&&min!=='dataMin'&&typeof min!=='function'&&!eqNaN(min)){min=this.axis.scale.parse(min);}return min;},/**
   * @param {boolean} origin
   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
   */getMax:function getMax(origin){var option=this.option;var max=!origin&&option.rangeEnd!=null?option.rangeEnd:option.max;if(this.axis&&max!=null&&max!=='dataMax'&&typeof max!=='function'&&!eqNaN(max)){max=this.axis.scale.parse(max);}return max;},/**
   * @return {boolean}
   */getNeedCrossZero:function getNeedCrossZero(){var option=this.option;return option.rangeStart!=null||option.rangeEnd!=null?false:!option.scale;},/**
   * Should be implemented by each axis model if necessary.
   * @return {module:echarts/model/Component} coordinate system model
   */getCoordSysModel:noop,/**
   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
   */setRange:function setRange(rangeStart,rangeEnd){this.option.rangeStart=rangeStart;this.option.rangeEnd=rangeEnd;},/**
   * Reset range
   */resetRange:function resetRange(){// rangeStart and rangeEnd is readonly.
this.option.rangeStart=this.option.rangeEnd=null;}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// Symbol factory
/**
 * Triangle shape
 * @inner
 */var Triangle=extendShape({type:'triangle',shape:{cx:0,cy:0,width:0,height:0},buildPath:function buildPath(path,shape){var cx=shape.cx;var cy=shape.cy;var width=shape.width/2;var height=shape.height/2;path.moveTo(cx,cy-height);path.lineTo(cx+width,cy+height);path.lineTo(cx-width,cy+height);path.closePath();}});/**
 * Diamond shape
 * @inner
 */var Diamond=extendShape({type:'diamond',shape:{cx:0,cy:0,width:0,height:0},buildPath:function buildPath(path,shape){var cx=shape.cx;var cy=shape.cy;var width=shape.width/2;var height=shape.height/2;path.moveTo(cx,cy-height);path.lineTo(cx+width,cy);path.lineTo(cx,cy+height);path.lineTo(cx-width,cy);path.closePath();}});/**
 * Pin shape
 * @inner
 */var Pin=extendShape({type:'pin',shape:{// x, y on the cusp
x:0,y:0,width:0,height:0},buildPath:function buildPath(path,shape){var x=shape.x;var y=shape.y;var w=shape.width/5*3;// Height must be larger than width
var h=Math.max(w,shape.height);var r=w/2;// Dist on y with tangent point and circle center
var dy=r*r/(h-r);var cy=y-h+r+dy;var angle=Math.asin(dy/r);// Dist on x with tangent point and circle center
var dx=Math.cos(angle)*r;var tanX=Math.sin(angle);var tanY=Math.cos(angle);var cpLen=r*0.6;var cpLen2=r*0.7;path.moveTo(x-dx,cy+dy);path.arc(x,cy,r,Math.PI-angle,Math.PI*2+angle);path.bezierCurveTo(x+dx-tanX*cpLen,cy+dy+tanY*cpLen,x,y-cpLen2,x,y);path.bezierCurveTo(x,y-cpLen2,x-dx+tanX*cpLen,cy+dy+tanY*cpLen,x-dx,cy+dy);path.closePath();}});/**
 * Arrow shape
 * @inner
 */var Arrow=extendShape({type:'arrow',shape:{x:0,y:0,width:0,height:0},buildPath:function buildPath(ctx,shape){var height=shape.height;var width=shape.width;var x=shape.x;var y=shape.y;var dx=width/3*2;ctx.moveTo(x,y);ctx.lineTo(x+dx,y+height);ctx.lineTo(x,y+height/4*3);ctx.lineTo(x-dx,y+height);ctx.lineTo(x,y);ctx.closePath();}});/**
 * Map of path contructors
 * @type {Object.<string, module:zrender/graphic/Path>}
 */var symbolCtors={line:Line,rect:Rect,roundRect:Rect,square:Rect,circle:Circle,diamond:Diamond,pin:Pin,arrow:Arrow,triangle:Triangle};var symbolShapeMakers={line:function line(x,y,w,h,shape){// FIXME
shape.x1=x;shape.y1=y+h/2;shape.x2=x+w;shape.y2=y+h/2;},rect:function rect(x,y,w,h,shape){shape.x=x;shape.y=y;shape.width=w;shape.height=h;},roundRect:function roundRect(x,y,w,h,shape){shape.x=x;shape.y=y;shape.width=w;shape.height=h;shape.r=Math.min(w,h)/4;},square:function square(x,y,w,h,shape){var size=Math.min(w,h);shape.x=x;shape.y=y;shape.width=size;shape.height=size;},circle:function circle(x,y,w,h,shape){// Put circle in the center of square
shape.cx=x+w/2;shape.cy=y+h/2;shape.r=Math.min(w,h)/2;},diamond:function diamond(x,y,w,h,shape){shape.cx=x+w/2;shape.cy=y+h/2;shape.width=w;shape.height=h;},pin:function pin(x,y,w,h,shape){shape.x=x+w/2;shape.y=y+h/2;shape.width=w;shape.height=h;},arrow:function arrow(x,y,w,h,shape){shape.x=x+w/2;shape.y=y+h/2;shape.width=w;shape.height=h;},triangle:function triangle(x,y,w,h,shape){shape.cx=x+w/2;shape.cy=y+h/2;shape.width=w;shape.height=h;}};var symbolBuildProxies={};each$1(symbolCtors,function(Ctor,name){symbolBuildProxies[name]=new Ctor();});var SymbolClz=extendShape({type:'symbol',shape:{symbolType:'',x:0,y:0,width:0,height:0},beforeBrush:function beforeBrush(){var style=this.style;var shape=this.shape;// FIXME
if(shape.symbolType==='pin'&&style.textPosition==='inside'){style.textPosition=['50%','40%'];style.textAlign='center';style.textVerticalAlign='middle';}},buildPath:function buildPath(ctx,shape,inBundle){var symbolType=shape.symbolType;var proxySymbol=symbolBuildProxies[symbolType];if(shape.symbolType!=='none'){if(!proxySymbol){// Default rect
symbolType='rect';proxySymbol=symbolBuildProxies[symbolType];}symbolShapeMakers[symbolType](shape.x,shape.y,shape.width,shape.height,proxySymbol.shape);proxySymbol.buildPath(ctx,proxySymbol.shape,inBundle);}}});// Provide setColor helper method to avoid determine if set the fill or stroke outside
function symbolPathSetColor(color,innerColor){if(this.type!=='image'){var symbolStyle=this.style;var symbolShape=this.shape;if(symbolShape&&symbolShape.symbolType==='line'){symbolStyle.stroke=color;}else if(this.__isEmptyBrush){symbolStyle.stroke=color;symbolStyle.fill=innerColor||'#fff';}else{// FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
symbolStyle.fill&&(symbolStyle.fill=color);symbolStyle.stroke&&(symbolStyle.stroke=color);}this.dirty(false);}}/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 * @param {string} symbolType
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {string} color
 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
 *                            for path and image only.
 */function createSymbol(symbolType,x,y,w,h,color,keepAspect){// TODO Support image object, DynamicImage.
var isEmpty=symbolType.indexOf('empty')===0;if(isEmpty){symbolType=symbolType.substr(5,1).toLowerCase()+symbolType.substr(6);}var symbolPath;if(symbolType.indexOf('image://')===0){symbolPath=makeImage(symbolType.slice(8),new BoundingRect(x,y,w,h),keepAspect?'center':'cover');}else if(symbolType.indexOf('path://')===0){symbolPath=makePath(symbolType.slice(7),{},new BoundingRect(x,y,w,h),keepAspect?'center':'cover');}else{symbolPath=new SymbolClz({shape:{symbolType:symbolType,x:x,y:y,width:w,height:h}});}symbolPath.__isEmptyBrush=isEmpty;symbolPath.setColor=symbolPathSetColor;symbolPath.setColor(color);return symbolPath;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Create a muti dimension List structure from seriesModel.
 * @param  {module:echarts/model/Model} seriesModel
 * @return {module:echarts/data/List} list
 */function createList(seriesModel){return createListFromArray(seriesModel.getSource(),seriesModel);}// export function createGraph(seriesModel) {
var dataStack$1={isDimensionStacked:isDimensionStacked,enableDataStack:enableDataStack,getStackedDimension:getStackedDimension};/**
 * Create scale
 * @param {Array.<number>} dataExtent
 * @param {Object|module:echarts/Model} option
 */function createScale(dataExtent,option){var axisModel=option;if(!Model.isInstance(option)){axisModel=new Model(option);mixin(axisModel,axisModelCommonMixin);}var scale=createScaleByModel(axisModel);scale.setExtent(dataExtent[0],dataExtent[1]);niceScaleExtent(scale,axisModel);return scale;}/**
 * Mixin common methods to axis model,
 *
 * Inlcude methods
 * `getFormattedLabels() => Array.<string>`
 * `getCategories() => Array.<string>`
 * `getMin(origin: boolean) => number`
 * `getMax(origin: boolean) => number`
 * `getNeedCrossZero() => boolean`
 * `setRange(start: number, end: number)`
 * `resetRange()`
 */function mixinAxisModelCommonMethods(Model$$1){mixin(Model$$1,axisModelCommonMixin);}var helper=(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a||Object)({createList:createList,getLayoutRect:getLayoutRect,dataStack:dataStack$1,createScale:createScale,mixinAxisModelCommonMethods:mixinAxisModelCommonMethods,completeDimensions:completeDimensions,createDimensions:createDimensions,createSymbol:createSymbol});var EPSILON$3=1e-8;function isAroundEqual$1(a,b){return Math.abs(a-b)<EPSILON$3;}function contain$1(points,x,y){var w=0;var p=points[0];if(!p){return false;}for(var i=1;i<points.length;i++){var p2=points[i];w+=windingLine(p[0],p[1],p2[0],p2[1],x,y);p=p2;}// Close polygon
var p0=points[0];if(!isAroundEqual$1(p[0],p0[0])||!isAroundEqual$1(p[1],p0[1])){w+=windingLine(p[0],p[1],p0[0],p0[1],x,y);}return w!==0;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @module echarts/coord/geo/Region
 *//**
 * @param {string} name
 * @param {Array} geometries
 * @param {Array.<number>} cp
 */function Region(name,geometries,cp){/**
   * @type {string}
   * @readOnly
   */this.name=name;/**
   * @type {Array.<Array>}
   * @readOnly
   */this.geometries=geometries;if(!cp){var rect=this.getBoundingRect();cp=[rect.x+rect.width/2,rect.y+rect.height/2];}else{cp=[cp[0],cp[1]];}/**
   * @type {Array.<number>}
   */this.center=cp;}Region.prototype={constructor:Region,properties:null,/**
   * @return {module:zrender/core/BoundingRect}
   */getBoundingRect:function getBoundingRect(){var rect=this._rect;if(rect){return rect;}var MAX_NUMBER=Number.MAX_VALUE;var min$$1=[MAX_NUMBER,MAX_NUMBER];var max$$1=[-MAX_NUMBER,-MAX_NUMBER];var min2=[];var max2=[];var geometries=this.geometries;for(var i=0;i<geometries.length;i++){// Only support polygon
if(geometries[i].type!=='polygon'){continue;}// Doesn't consider hole
var exterior=geometries[i].exterior;fromPoints(exterior,min2,max2);min(min$$1,min$$1,min2);max(max$$1,max$$1,max2);}// No data
if(i===0){min$$1[0]=min$$1[1]=max$$1[0]=max$$1[1]=0;}return this._rect=new BoundingRect(min$$1[0],min$$1[1],max$$1[0]-min$$1[0],max$$1[1]-min$$1[1]);},/**
   * @param {<Array.<number>} coord
   * @return {boolean}
   */contain:function contain(coord){var rect=this.getBoundingRect();var geometries=this.geometries;if(!rect.contain(coord[0],coord[1])){return false;}loopGeo:for(var i=0,len$$1=geometries.length;i<len$$1;i++){// Only support polygon.
if(geometries[i].type!=='polygon'){continue;}var exterior=geometries[i].exterior;var interiors=geometries[i].interiors;if(contain$1(exterior,coord[0],coord[1])){// Not in the region if point is in the hole.
for(var k=0;k<(interiors?interiors.length:0);k++){if(contain$1(interiors[k])){continue loopGeo;}}return true;}}return false;},transformTo:function transformTo(x,y,width,height){var rect=this.getBoundingRect();var aspect=rect.width/rect.height;if(!width){width=aspect*height;}else if(!height){height=width/aspect;}var target=new BoundingRect(x,y,width,height);var transform=rect.calculateTransform(target);var geometries=this.geometries;for(var i=0;i<geometries.length;i++){// Only support polygon.
if(geometries[i].type!=='polygon'){continue;}var exterior=geometries[i].exterior;var interiors=geometries[i].interiors;for(var p=0;p<exterior.length;p++){applyTransform(exterior[p],exterior[p],transform);}for(var h=0;h<(interiors?interiors.length:0);h++){for(var p=0;p<interiors[h].length;p++){applyTransform(interiors[h][p],interiors[h][p],transform);}}}rect=this._rect;rect.copy(target);// Update center
this.center=[rect.x+rect.width/2,rect.y+rect.height/2];}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Parse and decode geo json
 * @module echarts/coord/geo/parseGeoJson
 */function decode(json){if(!json.UTF8Encoding){return json;}var encodeScale=json.UTF8Scale;if(encodeScale==null){encodeScale=1024;}var features=json.features;for(var f=0;f<features.length;f++){var feature=features[f];var geometry=feature.geometry;var coordinates=geometry.coordinates;var encodeOffsets=geometry.encodeOffsets;for(var c=0;c<coordinates.length;c++){var coordinate=coordinates[c];if(geometry.type==='Polygon'){coordinates[c]=decodePolygon(coordinate,encodeOffsets[c],encodeScale);}else if(geometry.type==='MultiPolygon'){for(var c2=0;c2<coordinate.length;c2++){var polygon=coordinate[c2];coordinate[c2]=decodePolygon(polygon,encodeOffsets[c][c2],encodeScale);}}}}// Has been decoded
json.UTF8Encoding=false;return json;}function decodePolygon(coordinate,encodeOffsets,encodeScale){var result=[];var prevX=encodeOffsets[0];var prevY=encodeOffsets[1];for(var i=0;i<coordinate.length;i+=2){var x=coordinate.charCodeAt(i)-64;var y=coordinate.charCodeAt(i+1)-64;// ZigZag decoding
x=x>>1^-(x&1);y=y>>1^-(y&1);// Delta deocding
x+=prevX;y+=prevY;prevX=x;prevY=y;// Dequantize
result.push([x/encodeScale,y/encodeScale]);}return result;}/**
 * @alias module:echarts/coord/geo/parseGeoJson
 * @param {Object} geoJson
 * @return {module:zrender/container/Group}
 */var parseGeoJSON=function parseGeoJSON(geoJson){decode(geoJson);return map(filter(geoJson.features,function(featureObj){// Output of mapshaper may have geometry null
return featureObj.geometry&&featureObj.properties&&featureObj.geometry.coordinates.length>0;}),function(featureObj){var properties=featureObj.properties;var geo=featureObj.geometry;var coordinates=geo.coordinates;var geometries=[];if(geo.type==='Polygon'){geometries.push({type:'polygon',// According to the GeoJSON specification.
// First must be exterior, and the rest are all interior(holes).
exterior:coordinates[0],interiors:coordinates.slice(1)});}if(geo.type==='MultiPolygon'){each$1(coordinates,function(item){if(item[0]){geometries.push({type:'polygon',exterior:item[0],interiors:item.slice(1)});}});}var region=new Region(properties.name,geometries,properties.cp);region.properties=properties;return region;});};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var inner$6=makeInner();/**
 * @param {module:echats/coord/Axis} axis
 * @return {Object} {
 *     labels: [{
 *         formattedLabel: string,
 *         rawLabel: string,
 *         tickValue: number
 *     }, ...],
 *     labelCategoryInterval: number
 * }
 */function createAxisLabels(axis){// Only ordinal scale support tick interval
return axis.type==='category'?makeCategoryLabels(axis):makeRealNumberLabels(axis);}/**
 * @param {module:echats/coord/Axis} axis
 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
 * @return {Object} {
 *     ticks: Array.<number>
 *     tickCategoryInterval: number
 * }
 */function createAxisTicks(axis,tickModel){// Only ordinal scale support tick interval
return axis.type==='category'?makeCategoryTicks(axis,tickModel):{ticks:axis.scale.getTicks()};}function makeCategoryLabels(axis){var labelModel=axis.getLabelModel();var result=makeCategoryLabelsActually(axis,labelModel);return!labelModel.get('show')||axis.scale.isBlank()?{labels:[],labelCategoryInterval:result.labelCategoryInterval}:result;}function makeCategoryLabelsActually(axis,labelModel){var labelsCache=getListCache(axis,'labels');var optionLabelInterval=getOptionCategoryInterval(labelModel);var result=listCacheGet(labelsCache,optionLabelInterval);if(result){return result;}var labels;var numericLabelInterval;if(isFunction$1(optionLabelInterval)){labels=makeLabelsByCustomizedCategoryInterval(axis,optionLabelInterval);}else{numericLabelInterval=optionLabelInterval==='auto'?makeAutoCategoryInterval(axis):optionLabelInterval;labels=makeLabelsByNumericCategoryInterval(axis,numericLabelInterval);}// Cache to avoid calling interval function repeatly.
return listCacheSet(labelsCache,optionLabelInterval,{labels:labels,labelCategoryInterval:numericLabelInterval});}function makeCategoryTicks(axis,tickModel){var ticksCache=getListCache(axis,'ticks');var optionTickInterval=getOptionCategoryInterval(tickModel);var result=listCacheGet(ticksCache,optionTickInterval);if(result){return result;}var ticks;var tickCategoryInterval;// Optimize for the case that large category data and no label displayed,
// we should not return all ticks.
if(!tickModel.get('show')||axis.scale.isBlank()){ticks=[];}if(isFunction$1(optionTickInterval)){ticks=makeLabelsByCustomizedCategoryInterval(axis,optionTickInterval,true);}// Always use label interval by default despite label show. Consider this
// scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
// labels. `splitLine` and `axisTick` should be consistent in this case.
else if(optionTickInterval==='auto'){var labelsResult=makeCategoryLabelsActually(axis,axis.getLabelModel());tickCategoryInterval=labelsResult.labelCategoryInterval;ticks=map(labelsResult.labels,function(labelItem){return labelItem.tickValue;});}else{tickCategoryInterval=optionTickInterval;ticks=makeLabelsByNumericCategoryInterval(axis,tickCategoryInterval,true);}// Cache to avoid calling interval function repeatly.
return listCacheSet(ticksCache,optionTickInterval,{ticks:ticks,tickCategoryInterval:tickCategoryInterval});}function makeRealNumberLabels(axis){var ticks=axis.scale.getTicks();var labelFormatter=makeLabelFormatter(axis);return{labels:map(ticks,function(tickValue,idx){return{formattedLabel:labelFormatter(tickValue,idx),rawLabel:axis.scale.getLabel(tickValue),tickValue:tickValue};})};}// Large category data calculation is performence sensitive, and ticks and label
// probably be fetched by multiple times. So we cache the result.
// axis is created each time during a ec process, so we do not need to clear cache.
function getListCache(axis,prop){// Because key can be funciton, and cache size always be small, we use array cache.
return inner$6(axis)[prop]||(inner$6(axis)[prop]=[]);}function listCacheGet(cache,key){for(var i=0;i<cache.length;i++){if(cache[i].key===key){return cache[i].value;}}}function listCacheSet(cache,key,value){cache.push({key:key,value:value});return value;}function makeAutoCategoryInterval(axis){var result=inner$6(axis).autoInterval;return result!=null?result:inner$6(axis).autoInterval=axis.calculateCategoryInterval();}/**
 * Calculate interval for category axis ticks and labels.
 * To get precise result, at least one of `getRotate` and `isHorizontal`
 * should be implemented in axis.
 */function _calculateCategoryInterval(axis){var params=fetchAutoCategoryIntervalCalculationParams(axis);var labelFormatter=makeLabelFormatter(axis);var rotation=(params.axisRotate-params.labelRotate)/180*Math.PI;var ordinalScale=axis.scale;var ordinalExtent=ordinalScale.getExtent();// Providing this method is for optimization:
// avoid generating a long array by `getTicks`
// in large category data case.
var tickCount=ordinalScale.count();if(ordinalExtent[1]-ordinalExtent[0]<1){return 0;}var step=1;// Simple optimization. Empirical value: tick count should less than 40.
if(tickCount>40){step=Math.max(1,Math.floor(tickCount/40));}var tickValue=ordinalExtent[0];var unitSpan=axis.dataToCoord(tickValue+1)-axis.dataToCoord(tickValue);var unitW=Math.abs(unitSpan*Math.cos(rotation));var unitH=Math.abs(unitSpan*Math.sin(rotation));var maxW=0;var maxH=0;// Caution: Performance sensitive for large category data.
// Consider dataZoom, we should make appropriate step to avoid O(n) loop.
for(;tickValue<=ordinalExtent[1];tickValue+=step){var width=0;var height=0;// Polar is also calculated in assumptive linear layout here.
// Not precise, do not consider align and vertical align
// and each distance from axis line yet.
var rect=_getBoundingRect(labelFormatter(tickValue),params.font,'center','top');// Magic number
width=rect.width*1.3;height=rect.height*1.3;// Min size, void long loop.
maxW=Math.max(maxW,width,7);maxH=Math.max(maxH,height,7);}var dw=maxW/unitW;var dh=maxH/unitH;// 0/0 is NaN, 1/0 is Infinity.
isNaN(dw)&&(dw=Infinity);isNaN(dh)&&(dh=Infinity);var interval=Math.max(0,Math.floor(Math.min(dw,dh)));var cache=inner$6(axis.model);var lastAutoInterval=cache.lastAutoInterval;var lastTickCount=cache.lastTickCount;// Use cache to keep interval stable while moving zoom window,
// otherwise the calculated interval might jitter when the zoom
// window size is close to the interval-changing size.
if(lastAutoInterval!=null&&lastTickCount!=null&&Math.abs(lastAutoInterval-interval)<=1&&Math.abs(lastTickCount-tickCount)<=1// Always choose the bigger one, otherwise the critical
// point is not the same when zooming in or zooming out.
&&lastAutoInterval>interval){interval=lastAutoInterval;}// Only update cache if cache not used, otherwise the
// changing of interval is too insensitive.
else{cache.lastTickCount=tickCount;cache.lastAutoInterval=interval;}return interval;}function fetchAutoCategoryIntervalCalculationParams(axis){var labelModel=axis.getLabelModel();return{axisRotate:axis.getRotate?axis.getRotate():axis.isHorizontal&&!axis.isHorizontal()?90:0,labelRotate:labelModel.get('rotate')||0,font:labelModel.getFont()};}function makeLabelsByNumericCategoryInterval(axis,categoryInterval,onlyTick){var labelFormatter=makeLabelFormatter(axis);var ordinalScale=axis.scale;var ordinalExtent=ordinalScale.getExtent();var labelModel=axis.getLabelModel();var result=[];// TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
var step=Math.max((categoryInterval||0)+1,1);var startTick=ordinalExtent[0];var tickCount=ordinalScale.count();// Calculate start tick based on zero if possible to keep label consistent
// while zooming and moving while interval > 0. Otherwise the selection
// of displayable ticks and symbols probably keep changing.
// 3 is empirical value.
if(startTick!==0&&step>1&&tickCount/step>2){startTick=Math.round(Math.ceil(startTick/step)*step);}// (1) Only add min max label here but leave overlap checking
// to render stage, which also ensure the returned list
// suitable for splitLine and splitArea rendering.
// (2) Scales except category always contain min max label so
// do not need to perform this process.
var showMinMax={min:labelModel.get('showMinLabel'),max:labelModel.get('showMaxLabel')};if(showMinMax.min&&startTick!==ordinalExtent[0]){addItem(ordinalExtent[0]);}// Optimize: avoid generating large array by `ordinalScale.getTicks()`.
var tickValue=startTick;for(;tickValue<=ordinalExtent[1];tickValue+=step){addItem(tickValue);}if(showMinMax.max&&tickValue!==ordinalExtent[1]){addItem(ordinalExtent[1]);}function addItem(tVal){result.push(onlyTick?tVal:{formattedLabel:labelFormatter(tVal),rawLabel:ordinalScale.getLabel(tVal),tickValue:tVal});}return result;}// When interval is function, the result `false` means ignore the tick.
// It is time consuming for large category data.
function makeLabelsByCustomizedCategoryInterval(axis,categoryInterval,onlyTick){var ordinalScale=axis.scale;var labelFormatter=makeLabelFormatter(axis);var result=[];each$1(ordinalScale.getTicks(),function(tickValue){var rawLabel=ordinalScale.getLabel(tickValue);if(categoryInterval(tickValue,rawLabel)){result.push(onlyTick?tickValue:{formattedLabel:labelFormatter(tickValue),rawLabel:rawLabel,tickValue:tickValue});}});return result;}// Can be null|'auto'|number|function
function getOptionCategoryInterval(model){var interval=model.get('interval');return interval==null?'auto':interval;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var NORMALIZED_EXTENT=[0,1];/**
 * Base class of Axis.
 * @constructor
 */var Axis=function Axis(dim,scale,extent){/**
   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'.
   * @type {string}
   */this.dim=dim;/**
   * Axis scale
   * @type {module:echarts/coord/scale/*}
   */this.scale=scale;/**
   * @type {Array.<number>}
   * @private
   */this._extent=extent||[0,0];/**
   * @type {boolean}
   */this.inverse=false;/**
   * Usually true when axis has a ordinal scale
   * @type {boolean}
   */this.onBand=false;};Axis.prototype={constructor:Axis,/**
   * If axis extent contain given coord
   * @param {number} coord
   * @return {boolean}
   */contain:function contain(coord){var extent=this._extent;var min=Math.min(extent[0],extent[1]);var max=Math.max(extent[0],extent[1]);return coord>=min&&coord<=max;},/**
   * If axis extent contain given data
   * @param {number} data
   * @return {boolean}
   */containData:function containData(data){return this.contain(this.dataToCoord(data));},/**
   * Get coord extent.
   * @return {Array.<number>}
   */getExtent:function getExtent(){return this._extent.slice();},/**
   * Get precision used for formatting
   * @param {Array.<number>} [dataExtent]
   * @return {number}
   */getPixelPrecision:function getPixelPrecision(dataExtent){return _getPixelPrecision(dataExtent||this.scale.getExtent(),this._extent);},/**
   * Set coord extent
   * @param {number} start
   * @param {number} end
   */setExtent:function setExtent(start,end){var extent=this._extent;extent[0]=start;extent[1]=end;},/**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   * @param {number} data
   * @param  {boolean} clamp
   * @return {number}
   */dataToCoord:function dataToCoord(data,clamp){var extent=this._extent;var scale=this.scale;data=scale.normalize(data);if(this.onBand&&scale.type==='ordinal'){extent=extent.slice();fixExtentWithBands(extent,scale.count());}return linearMap(data,NORMALIZED_EXTENT,extent,clamp);},/**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   * @param {number} coord
   * @param  {boolean} clamp
   * @return {number}
   */coordToData:function coordToData(coord,clamp){var extent=this._extent;var scale=this.scale;if(this.onBand&&scale.type==='ordinal'){extent=extent.slice();fixExtentWithBands(extent,scale.count());}var t=linearMap(coord,extent,NORMALIZED_EXTENT,clamp);return this.scale.scale(t);},/**
   * Convert pixel point to data in axis
   * @param {Array.<number>} point
   * @param  {boolean} clamp
   * @return {number} data
   */pointToData:function pointToData(point,clamp){// Should be implemented in derived class if necessary.
},/**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param {Object} [opt]
   * @param {number} [opt.tickModel=axis.model.getModel('axisTick')]
   * @param {boolean} [opt.clamp] If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   * @return {Array.<Object>} [{
   *     coord: ...,
   *     tickValue: ...
   * }, ...]
   */getTicksCoords:function getTicksCoords(opt){opt=opt||{};var tickModel=opt.tickModel||this.getTickModel();var result=createAxisTicks(this,tickModel);var ticks=result.ticks;var ticksCoords=map(ticks,function(tickValue){return{coord:this.dataToCoord(tickValue),tickValue:tickValue};},this);var alignWithLabel=tickModel.get('alignWithLabel');fixOnBandTicksCoords(this,ticksCoords,result.tickCategoryInterval,alignWithLabel,opt.clamp);return ticksCoords;},/**
   * @return {Array.<Object>} [{
   *     formattedLabel: string,
   *     rawLabel: axis.scale.getLabel(tickValue)
   *     tickValue: number
   * }, ...]
   */getViewLabels:function getViewLabels(){return createAxisLabels(this).labels;},/**
   * @return {module:echarts/coord/model/Model}
   */getLabelModel:function getLabelModel(){return this.model.getModel('axisLabel');},/**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overrided to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   * @return {module:echarts/coord/model/Model}
   */getTickModel:function getTickModel(){return this.model.getModel('axisTick');},/**
   * Get width of band
   * @return {number}
   */getBandWidth:function getBandWidth(){var axisExtent=this._extent;var dataExtent=this.scale.getExtent();var len=dataExtent[1]-dataExtent[0]+(this.onBand?1:0);// Fix #2728, avoid NaN when only one data.
len===0&&(len=1);var size=Math.abs(axisExtent[1]-axisExtent[0]);return Math.abs(size)/len;},/**
   * @abstract
   * @return {boolean} Is horizontal
   */isHorizontal:null,/**
   * @abstract
   * @return {number} Get axis rotate, by degree.
   */getRotate:null,/**
   * Only be called in category axis.
   * Can be overrided, consider other axes like in 3D.
   * @return {number} Auto interval for cateogry axis tick and label
   */calculateCategoryInterval:function calculateCategoryInterval(){return _calculateCategoryInterval(this);}};function fixExtentWithBands(extent,nTick){var size=extent[1]-extent[0];var len=nTick;var margin=size/len/2;extent[0]+=margin;extent[1]-=margin;}// If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function fixOnBandTicksCoords(axis,ticksCoords,tickCategoryInterval,alignWithLabel,clamp){var ticksLen=ticksCoords.length;if(!axis.onBand||alignWithLabel||!ticksLen){return;}var axisExtent=axis.getExtent();var last;if(ticksLen===1){ticksCoords[0].coord=axisExtent[0];last=ticksCoords[1]={coord:axisExtent[0]};}else{var shift=ticksCoords[1].coord-ticksCoords[0].coord;each$1(ticksCoords,function(ticksItem){ticksItem.coord-=shift/2;var tickCategoryInterval=tickCategoryInterval||0;// Avoid split a single data item when odd interval.
if(tickCategoryInterval%2>0){ticksItem.coord-=shift/((tickCategoryInterval+1)*2);}});last={coord:ticksCoords[ticksLen-1].coord+shift};ticksCoords.push(last);}var inverse=axisExtent[0]>axisExtent[1];if(littleThan(ticksCoords[0].coord,axisExtent[0])){clamp?ticksCoords[0].coord=axisExtent[0]:ticksCoords.shift();}if(clamp&&littleThan(axisExtent[0],ticksCoords[0].coord)){ticksCoords.unshift({coord:axisExtent[0]});}if(littleThan(axisExtent[1],last.coord)){clamp?last.coord=axisExtent[1]:ticksCoords.pop();}if(clamp&&littleThan(last.coord,axisExtent[1])){ticksCoords.push({coord:axisExtent[1]});}function littleThan(a,b){return inverse?a>b:a<b;}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Do not mount those modules on 'src/echarts' for better tree shaking.
 */var parseGeoJson=parseGeoJSON;var ecUtil={};each$1(['map','each','filter','indexOf','inherits','reduce','filter','bind','curry','isArray','isString','isObject','isFunction','extend','defaults','clone','merge'],function(name){ecUtil[name]=zrUtil[name];});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Cartesian coordinate system
 * @module  echarts/coord/Cartesian
 *
 */function dimAxisMapper(dim){return this._axes[dim];}/**
 * @alias module:echarts/coord/Cartesian
 * @constructor
 */var Cartesian=function Cartesian(name){this._axes={};this._dimList=[];/**
   * @type {string}
   */this.name=name||'';};Cartesian.prototype={constructor:Cartesian,type:'cartesian',/**
   * Get axis
   * @param  {number|string} dim
   * @return {module:echarts/coord/Cartesian~Axis}
   */getAxis:function getAxis(dim){return this._axes[dim];},/**
   * Get axes list
   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
   */getAxes:function getAxes(){return map(this._dimList,dimAxisMapper,this);},/**
   * Get axes list by given scale type
   */getAxesByScale:function getAxesByScale(scaleType){scaleType=scaleType.toLowerCase();return filter(this.getAxes(),function(axis){return axis.scale.type===scaleType;});},/**
   * Add axis
   * @param {module:echarts/coord/Cartesian.Axis}
   */addAxis:function addAxis(axis){var dim=axis.dim;this._axes[dim]=axis;this._dimList.push(dim);},/**
   * Convert data to coord in nd space
   * @param {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */dataToCoord:function dataToCoord(val){return this._dataCoordConvert(val,'dataToCoord');},/**
   * Convert coord in nd space to data
   * @param  {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */coordToData:function coordToData(val){return this._dataCoordConvert(val,'coordToData');},_dataCoordConvert:function _dataCoordConvert(input,method){var dimList=this._dimList;var output=input instanceof Array?[]:{};for(var i=0;i<dimList.length;i++){var dim=dimList[i];var axis=this._axes[dim];output[dim]=axis[method](input[dim]);}return output;}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/function Cartesian2D(name){Cartesian.call(this,name);}Cartesian2D.prototype={constructor:Cartesian2D,type:'cartesian2d',/**
   * @type {Array.<string>}
   * @readOnly
   */dimensions:['x','y'],/**
   * Base axis will be used on stacking.
   *
   * @return {module:echarts/coord/cartesian/Axis2D}
   */getBaseAxis:function getBaseAxis(){return this.getAxesByScale('ordinal')[0]||this.getAxesByScale('time')[0]||this.getAxis('x');},/**
   * If contain point
   * @param {Array.<number>} point
   * @return {boolean}
   */containPoint:function containPoint(point){var axisX=this.getAxis('x');var axisY=this.getAxis('y');return axisX.contain(axisX.toLocalCoord(point[0]))&&axisY.contain(axisY.toLocalCoord(point[1]));},/**
   * If contain data
   * @param {Array.<number>} data
   * @return {boolean}
   */containData:function containData(data){return this.getAxis('x').containData(data[0])&&this.getAxis('y').containData(data[1]);},/**
   * @param {Array.<number>} data
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */dataToPoint:function dataToPoint(data,reserved,out){var xAxis=this.getAxis('x');var yAxis=this.getAxis('y');out=out||[];out[0]=xAxis.toGlobalCoord(xAxis.dataToCoord(data[0]));out[1]=yAxis.toGlobalCoord(yAxis.dataToCoord(data[1]));return out;},/**
   * @param {Array.<number>} data
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */clampData:function clampData(data,out){var xScale=this.getAxis('x').scale;var yScale=this.getAxis('y').scale;var xAxisExtent=xScale.getExtent();var yAxisExtent=yScale.getExtent();var x=xScale.parse(data[0]);var y=yScale.parse(data[1]);out=out||[];out[0]=Math.min(Math.max(Math.min(xAxisExtent[0],xAxisExtent[1]),x),Math.max(xAxisExtent[0],xAxisExtent[1]));out[1]=Math.min(Math.max(Math.min(yAxisExtent[0],yAxisExtent[1]),y),Math.max(yAxisExtent[0],yAxisExtent[1]));return out;},/**
   * @param {Array.<number>} point
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */pointToData:function pointToData(point,out){var xAxis=this.getAxis('x');var yAxis=this.getAxis('y');out=out||[];out[0]=xAxis.coordToData(xAxis.toLocalCoord(point[0]));out[1]=yAxis.coordToData(yAxis.toLocalCoord(point[1]));return out;},/**
   * Get other axis
   * @param {module:echarts/coord/cartesian/Axis2D} axis
   */getOtherAxis:function getOtherAxis(axis){return this.getAxis(axis.dim==='x'?'y':'x');}};inherits(Cartesian2D,Cartesian);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Extend axis 2d
 * @constructor module:echarts/coord/cartesian/Axis2D
 * @extends {module:echarts/coord/cartesian/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */var Axis2D=function Axis2D(dim,scale,coordExtent,axisType,position){Axis.call(this,dim,scale,coordExtent);/**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */this.type=axisType||'value';/**
   * Axis position
   *  - 'top'
   *  - 'bottom'
   *  - 'left'
   *  - 'right'
   */this.position=position||'bottom';};Axis2D.prototype={constructor:Axis2D,/**
   * Index of axis, can be used as key
   */index:0,/**
   * Implemented in <module:echarts/coord/cartesian/Grid>.
   * @return {Array.<module:echarts/coord/cartesian/Axis2D>}
   *         If not on zero of other axis, return null/undefined.
   *         If no axes, return an empty array.
   */getAxesOnZeroOf:null,/**
   * Axis model
   * @param {module:echarts/coord/cartesian/AxisModel}
   */model:null,isHorizontal:function isHorizontal(){var position=this.position;return position==='top'||position==='bottom';},/**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */getGlobalExtent:function getGlobalExtent(asc){var ret=this.getExtent();ret[0]=this.toGlobalCoord(ret[0]);ret[1]=this.toGlobalCoord(ret[1]);asc&&ret[0]>ret[1]&&ret.reverse();return ret;},getOtherAxis:function getOtherAxis(){this.grid.getOtherAxis();},/**
   * @override
   */pointToData:function pointToData(point,clamp){return this.coordToData(this.toLocalCoord(point[this.dim==='x'?0:1]),clamp);},/**
   * Transform global coord to local coord,
   * i.e. var localCoord = axis.toLocalCoord(80);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */toLocalCoord:null,/**
   * Transform global coord to local coord,
   * i.e. var globalCoord = axis.toLocalCoord(40);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */toGlobalCoord:null};inherits(Axis2D,Axis);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var defaultOption={show:true,zlevel:0,z:0,// Inverse the axis.
inverse:false,// Axis name displayed.
name:'',// 'start' | 'middle' | 'end'
nameLocation:'end',// By degree. By defualt auto rotate by nameLocation.
nameRotate:null,nameTruncate:{maxWidth:null,ellipsis:'...',placeholder:'.'},// Use global text style by default.
nameTextStyle:{},// The gap between axisName and axisLine.
nameGap:15,// Default `false` to support tooltip.
silent:false,// Default `false` to avoid legacy user event listener fail.
triggerEvent:false,tooltip:{show:false},axisPointer:{},axisLine:{show:true,onZero:true,onZeroAxisIndex:null,lineStyle:{color:'#333',width:1,type:'solid'},// The arrow at both ends the the axis.
symbol:['none','none'],symbolSize:[10,15]},axisTick:{show:true,// Whether axisTick is inside the grid or outside the grid.
inside:false,// The length of axisTick.
length:5,lineStyle:{width:1}},axisLabel:{show:true,// Whether axisLabel is inside the grid or outside the grid.
inside:false,rotate:0,// true | false | null/undefined (auto)
showMinLabel:null,// true | false | null/undefined (auto)
showMaxLabel:null,margin:8,// formatter: null,
fontSize:12},splitLine:{show:true,lineStyle:{color:['#ccc'],width:1,type:'solid'}},splitArea:{show:false,areaStyle:{color:['rgba(250,250,250,0.3)','rgba(200,200,200,0.3)']}}};var axisDefault={};axisDefault.categoryAxis=merge({// The gap at both ends of the axis. For categoryAxis, boolean.
boundaryGap:true,// Set false to faster category collection.
// Only usefull in the case like: category is
// ['2012-01-01', '2012-01-02', ...], where the input
// data has been ensured not duplicate and is large data.
// null means "auto":
// if axis.data provided, do not deduplication,
// else do deduplication.
deduplication:null,// splitArea: {
// show: false
// },
splitLine:{show:false},axisTick:{// If tick is align with label when boundaryGap is true
alignWithLabel:false,interval:'auto'},axisLabel:{interval:'auto'}},defaultOption);axisDefault.valueAxis=merge({// The gap at both ends of the axis. For value axis, [GAP, GAP], where
// `GAP` can be an absolute pixel number (like `35`), or percent (like `'30%'`)
boundaryGap:[0,0],// TODO
// min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
// Min value of the axis. can be:
// + a number
// + 'dataMin': use the min value in data.
// + null/undefined: auto decide min value (consider pretty look and boundaryGap).
// min: null,
// Max value of the axis. can be:
// + a number
// + 'dataMax': use the max value in data.
// + null/undefined: auto decide max value (consider pretty look and boundaryGap).
// max: null,
// Readonly prop, specifies start value of the range when using data zoom.
// rangeStart: null
// Readonly prop, specifies end value of the range when using data zoom.
// rangeEnd: null
// Optional value can be:
// + `false`: always include value 0.
// + `true`: the extent do not consider value 0.
// scale: false,
// AxisTick and axisLabel and splitLine are caculated based on splitNumber.
splitNumber:5// Interval specifies the span of the ticks is mandatorily.
// interval: null
// Specify min interval when auto calculate tick interval.
// minInterval: null
// Specify max interval when auto calculate tick interval.
// maxInterval: null
},defaultOption);axisDefault.timeAxis=defaults({scale:true,min:'dataMin',max:'dataMax'},axisDefault.valueAxis);axisDefault.logAxis=defaults({scale:true,logBase:10},axisDefault.valueAxis);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var AXIS_TYPES=['value','category','time','log'];/**
 * Generate sub axis model class
 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
 * @param {module:echarts/model/Component} BaseAxisModelClass
 * @param {Function} axisTypeDefaulter
 * @param {Object} [extraDefaultOption]
 */var axisModelCreator=function axisModelCreator(axisName,BaseAxisModelClass,axisTypeDefaulter,extraDefaultOption){each$1(AXIS_TYPES,function(axisType){BaseAxisModelClass.extend({/**
       * @readOnly
       */type:axisName+'Axis.'+axisType,mergeDefaultAndTheme:function mergeDefaultAndTheme(option,ecModel){var layoutMode=this.layoutMode;var inputPositionParams=layoutMode?getLayoutParams(option):{};var themeModel=ecModel.getTheme();merge(option,themeModel.get(axisType+'Axis'));merge(option,this.getDefaultOption());option.type=axisTypeDefaulter(axisName,option);if(layoutMode){mergeLayoutParam(option,inputPositionParams,layoutMode);}},/**
       * @override
       */optionUpdated:function optionUpdated(){var thisOption=this.option;if(thisOption.type==='category'){this.__ordinalMeta=OrdinalMeta.createByAxisModel(this);}},/**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */getCategories:function getCategories(rawData){var option=this.option;// FIXME
// warning if called before all of 'getInitailData' finished.
if(option.type==='category'){if(rawData){return option.data;}return this.__ordinalMeta.categories;}},getOrdinalMeta:function getOrdinalMeta(){return this.__ordinalMeta;},defaultOption:mergeAll([{},axisDefault[axisType+'Axis'],extraDefaultOption],true)});});ComponentModel.registerSubTypeDefaulter(axisName+'Axis',curry(axisTypeDefaulter,axisName));};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var AxisModel=ComponentModel.extend({type:'cartesian2dAxis',/**
   * @type {module:echarts/coord/cartesian/Axis2D}
   */axis:null,/**
   * @override
   */init:function init(){AxisModel.superApply(this,'init',arguments);this.resetRange();},/**
   * @override
   */mergeOption:function mergeOption(){AxisModel.superApply(this,'mergeOption',arguments);this.resetRange();},/**
   * @override
   */restoreData:function restoreData(){AxisModel.superApply(this,'restoreData',arguments);this.resetRange();},/**
   * @override
   * @return {module:echarts/model/Component}
   */getCoordSysModel:function getCoordSysModel(){return this.ecModel.queryComponents({mainType:'grid',index:this.option.gridIndex,id:this.option.gridId})[0];}});function getAxisType(axisDim,option){// Default axis with data is category axis
return option.type||(option.data?'category':'value');}merge(AxisModel.prototype,axisModelCommonMixin);var extraOption={// gridIndex: 0,
// gridId: '',
// Offset is for multiple axis on the same position
offset:0};axisModelCreator('x',AxisModel,getAxisType,extraOption);axisModelCreator('y',AxisModel,getAxisType,extraOption);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// Grid 是在有直角坐标系的时候必须要存在的
// 所以这里也要被 Cartesian2D 依赖
ComponentModel.extend({type:'grid',dependencies:['xAxis','yAxis'],layoutMode:'box',/**
   * @type {module:echarts/coord/cartesian/Grid}
   */coordinateSystem:null,defaultOption:{show:false,zlevel:0,z:0,left:'10%',top:60,right:'10%',bottom:60,// If grid size contain label
containLabel:false,// width: {totalWidth} - left - right,
// height: {totalHeight} - top - bottom,
backgroundColor:'rgba(0,0,0,0)',borderWidth:1,borderColor:'#ccc'}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 *//**
 * Check if the axis is used in the specified grid
 * @inner
 */function isAxisUsedInTheGrid(axisModel,gridModel,ecModel){return axisModel.getCoordSysModel()===gridModel;}function Grid(gridModel,ecModel,api){/**
   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
   * @private
   */this._coordsMap={};/**
   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
   * @private
   */this._coordsList=[];/**
   * @type {Object.<string, module:echarts/coord/cartesian/Axis2D>}
   * @private
   */this._axesMap={};/**
   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
   * @private
   */this._axesList=[];this._initCartesian(gridModel,ecModel,api);this.model=gridModel;}var gridProto=Grid.prototype;gridProto.type='grid';gridProto.axisPointerEnabled=true;gridProto.getRect=function(){return this._rect;};gridProto.update=function(ecModel,api){var axesMap=this._axesMap;this._updateScale(ecModel,this.model);each$1(axesMap.x,function(xAxis){niceScaleExtent(xAxis.scale,xAxis.model);});each$1(axesMap.y,function(yAxis){niceScaleExtent(yAxis.scale,yAxis.model);});each$1(axesMap.x,function(xAxis){fixAxisOnZero(axesMap,'y',xAxis);});each$1(axesMap.y,function(yAxis){fixAxisOnZero(axesMap,'x',yAxis);});// Resize again if containLabel is enabled
// FIXME It may cause getting wrong grid size in data processing stage
this.resize(this.model,api);};function fixAxisOnZero(axesMap,otherAxisDim,axis){axis.getAxesOnZeroOf=function(){// TODO: onZero of multiple axes.
return otherAxis?[otherAxis]:[];};// onZero can not be enabled in these two situations:
// 1. When any other axis is a category axis.
// 2. When no axis is cross 0 point.
var otherAxes=axesMap[otherAxisDim];var otherAxis;var axisModel=axis.model;var onZero=axisModel.get('axisLine.onZero');var onZeroAxisIndex=axisModel.get('axisLine.onZeroAxisIndex');if(!onZero){return;}// If target axis is specified.
if(onZeroAxisIndex!=null){if(canOnZeroToAxis(otherAxes[onZeroAxisIndex])){otherAxis=otherAxes[onZeroAxisIndex];}return;}// Find the first available other axis.
for(var idx in otherAxes){if(otherAxes.hasOwnProperty(idx)&&canOnZeroToAxis(otherAxes[idx])){otherAxis=otherAxes[idx];break;}}}function canOnZeroToAxis(axis){return axis&&axis.type!=='category'&&axis.type!=='time'&&ifAxisCrossZero(axis);}/**
 * Resize the grid
 * @param {module:echarts/coord/cartesian/GridModel} gridModel
 * @param {module:echarts/ExtensionAPI} api
 */gridProto.resize=function(gridModel,api,ignoreContainLabel){var gridRect=getLayoutRect(gridModel.getBoxLayoutParams(),{width:api.getWidth(),height:api.getHeight()});this._rect=gridRect;var axesList=this._axesList;adjustAxes();// Minus label size
if(!ignoreContainLabel&&gridModel.get('containLabel')){each$1(axesList,function(axis){if(!axis.model.get('axisLabel.inside')){var labelUnionRect=estimateLabelUnionRect(axis);if(labelUnionRect){var dim=axis.isHorizontal()?'height':'width';var margin=axis.model.get('axisLabel.margin');gridRect[dim]-=labelUnionRect[dim]+margin;if(axis.position==='top'){gridRect.y+=labelUnionRect.height+margin;}else if(axis.position==='left'){gridRect.x+=labelUnionRect.width+margin;}}}});adjustAxes();}function adjustAxes(){each$1(axesList,function(axis){var isHorizontal=axis.isHorizontal();var extent=isHorizontal?[0,gridRect.width]:[0,gridRect.height];var idx=axis.inverse?1:0;axis.setExtent(extent[idx],extent[1-idx]);updateAxisTransform(axis,isHorizontal?gridRect.x:gridRect.y);});}};/**
 * @param {string} axisType
 * @param {number} [axisIndex]
 */gridProto.getAxis=function(axisType,axisIndex){var axesMapOnDim=this._axesMap[axisType];if(axesMapOnDim!=null){if(axisIndex==null){// Find first axis
for(var name in axesMapOnDim){if(axesMapOnDim.hasOwnProperty(name)){return axesMapOnDim[name];}}}return axesMapOnDim[axisIndex];}};/**
 * @return {Array.<module:echarts/coord/Axis>}
 */gridProto.getAxes=function(){return this._axesList.slice();};/**
 * Usage:
 *      grid.getCartesian(xAxisIndex, yAxisIndex);
 *      grid.getCartesian(xAxisIndex);
 *      grid.getCartesian(null, yAxisIndex);
 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
 *
 * @param {number|Object} [xAxisIndex]
 * @param {number} [yAxisIndex]
 */gridProto.getCartesian=function(xAxisIndex,yAxisIndex){if(xAxisIndex!=null&&yAxisIndex!=null){var key='x'+xAxisIndex+'y'+yAxisIndex;return this._coordsMap[key];}if(isObject$1(xAxisIndex)){yAxisIndex=xAxisIndex.yAxisIndex;xAxisIndex=xAxisIndex.xAxisIndex;}// When only xAxisIndex or yAxisIndex given, find its first cartesian.
for(var i=0,coordList=this._coordsList;i<coordList.length;i++){if(coordList[i].getAxis('x').index===xAxisIndex||coordList[i].getAxis('y').index===yAxisIndex){return coordList[i];}}};gridProto.getCartesians=function(){return this._coordsList.slice();};/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */gridProto.convertToPixel=function(ecModel,finder,value){var target=this._findConvertTarget(ecModel,finder);return target.cartesian?target.cartesian.dataToPoint(value):target.axis?target.axis.toGlobalCoord(target.axis.dataToCoord(value)):null;};/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */gridProto.convertFromPixel=function(ecModel,finder,value){var target=this._findConvertTarget(ecModel,finder);return target.cartesian?target.cartesian.pointToData(value):target.axis?target.axis.coordToData(target.axis.toLocalCoord(value)):null;};/**
 * @inner
 */gridProto._findConvertTarget=function(ecModel,finder){var seriesModel=finder.seriesModel;var xAxisModel=finder.xAxisModel||seriesModel&&seriesModel.getReferringComponents('xAxis')[0];var yAxisModel=finder.yAxisModel||seriesModel&&seriesModel.getReferringComponents('yAxis')[0];var gridModel=finder.gridModel;var coordsList=this._coordsList;var cartesian;var axis;if(seriesModel){cartesian=seriesModel.coordinateSystem;indexOf(coordsList,cartesian)<0&&(cartesian=null);}else if(xAxisModel&&yAxisModel){cartesian=this.getCartesian(xAxisModel.componentIndex,yAxisModel.componentIndex);}else if(xAxisModel){axis=this.getAxis('x',xAxisModel.componentIndex);}else if(yAxisModel){axis=this.getAxis('y',yAxisModel.componentIndex);}// Lowest priority.
else if(gridModel){var grid=gridModel.coordinateSystem;if(grid===this){cartesian=this._coordsList[0];}}return{cartesian:cartesian,axis:axis};};/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */gridProto.containPoint=function(point){var coord=this._coordsList[0];if(coord){return coord.containPoint(point);}};/**
 * Initialize cartesian coordinate systems
 * @private
 */gridProto._initCartesian=function(gridModel,ecModel,api){var axisPositionUsed={left:false,right:false,top:false,bottom:false};var axesMap={x:{},y:{}};var axesCount={x:0,y:0};/// Create axis
ecModel.eachComponent('xAxis',createAxisCreator('x'),this);ecModel.eachComponent('yAxis',createAxisCreator('y'),this);if(!axesCount.x||!axesCount.y){// Roll back when there no either x or y axis
this._axesMap={};this._axesList=[];return;}this._axesMap=axesMap;/// Create cartesian2d
each$1(axesMap.x,function(xAxis,xAxisIndex){each$1(axesMap.y,function(yAxis,yAxisIndex){var key='x'+xAxisIndex+'y'+yAxisIndex;var cartesian=new Cartesian2D(key);cartesian.grid=this;cartesian.model=gridModel;this._coordsMap[key]=cartesian;this._coordsList.push(cartesian);cartesian.addAxis(xAxis);cartesian.addAxis(yAxis);},this);},this);function createAxisCreator(axisType){return function(axisModel,idx){if(!isAxisUsedInTheGrid(axisModel,gridModel,ecModel)){return;}var axisPosition=axisModel.get('position');if(axisType==='x'){// Fix position
if(axisPosition!=='top'&&axisPosition!=='bottom'){// Default bottom of X
axisPosition='bottom';if(axisPositionUsed[axisPosition]){axisPosition=axisPosition==='top'?'bottom':'top';}}}else{// Fix position
if(axisPosition!=='left'&&axisPosition!=='right'){// Default left of Y
axisPosition='left';if(axisPositionUsed[axisPosition]){axisPosition=axisPosition==='left'?'right':'left';}}}axisPositionUsed[axisPosition]=true;var axis=new Axis2D(axisType,createScaleByModel(axisModel),[0,0],axisModel.get('type'),axisPosition);var isCategory=axis.type==='category';axis.onBand=isCategory&&axisModel.get('boundaryGap');axis.inverse=axisModel.get('inverse');// Inject axis into axisModel
axisModel.axis=axis;// Inject axisModel into axis
axis.model=axisModel;// Inject grid info axis
axis.grid=this;// Index of axis, can be used as key
axis.index=idx;this._axesList.push(axis);axesMap[axisType][idx]=axis;axesCount[axisType]++;};}};/**
 * Update cartesian properties from series
 * @param  {module:echarts/model/Option} option
 * @private
 */gridProto._updateScale=function(ecModel,gridModel){// Reset scale
each$1(this._axesList,function(axis){axis.scale.setExtent(Infinity,-Infinity);});ecModel.eachSeries(function(seriesModel){if(isCartesian2D(seriesModel)){var axesModels=findAxesModels(seriesModel,ecModel);var xAxisModel=axesModels[0];var yAxisModel=axesModels[1];if(!isAxisUsedInTheGrid(xAxisModel,gridModel,ecModel)||!isAxisUsedInTheGrid(yAxisModel,gridModel,ecModel)){return;}var cartesian=this.getCartesian(xAxisModel.componentIndex,yAxisModel.componentIndex);var data=seriesModel.getData();var xAxis=cartesian.getAxis('x');var yAxis=cartesian.getAxis('y');if(data.type==='list'){unionExtent(data,xAxis,seriesModel);unionExtent(data,yAxis,seriesModel);}}},this);function unionExtent(data,axis,seriesModel){each$1(data.mapDimension(axis.dim,true),function(dim){axis.scale.unionExtentFromData(// For example, the extent of the orginal dimension
// is [0.1, 0.5], the extent of the `stackResultDimension`
// is [7, 9], the final extent should not include [0.1, 0.5].
data,getStackedDimension(data,dim));});}};/**
 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
 * @return {Object} {baseAxes: [], otherAxes: []}
 */gridProto.getTooltipAxes=function(dim){var baseAxes=[];var otherAxes=[];each$1(this.getCartesians(),function(cartesian){var baseAxis=dim!=null&&dim!=='auto'?cartesian.getAxis(dim):cartesian.getBaseAxis();var otherAxis=cartesian.getOtherAxis(baseAxis);indexOf(baseAxes,baseAxis)<0&&baseAxes.push(baseAxis);indexOf(otherAxes,otherAxis)<0&&otherAxes.push(otherAxis);});return{baseAxes:baseAxes,otherAxes:otherAxes};};/**
 * @inner
 */function updateAxisTransform(axis,coordBase){var axisExtent=axis.getExtent();var axisExtentSum=axisExtent[0]+axisExtent[1];// Fast transform
axis.toGlobalCoord=axis.dim==='x'?function(coord){return coord+coordBase;}:function(coord){return axisExtentSum-coord+coordBase;};axis.toLocalCoord=axis.dim==='x'?function(coord){return coord-coordBase;}:function(coord){return axisExtentSum-coord+coordBase;};}var axesTypes=['xAxis','yAxis'];/**
 * @inner
 */function findAxesModels(seriesModel,ecModel){return map(axesTypes,function(axisType){var axisModel=seriesModel.getReferringComponents(axisType)[0];return axisModel;});}/**
 * @inner
 */function isCartesian2D(seriesModel){return seriesModel.get('coordinateSystem')==='cartesian2d';}Grid.create=function(ecModel,api){var grids=[];ecModel.eachComponent('grid',function(gridModel,idx){var grid=new Grid(gridModel,ecModel,api);grid.name='grid_'+idx;// dataSampling requires axis extent, so resize
// should be performed in create stage.
grid.resize(gridModel,api,true);gridModel.coordinateSystem=grid;grids.push(grid);});// Inject the coordinateSystems into seriesModel
ecModel.eachSeries(function(seriesModel){if(!isCartesian2D(seriesModel)){return;}var axesModels=findAxesModels(seriesModel,ecModel);var xAxisModel=axesModels[0];var yAxisModel=axesModels[1];var gridModel=xAxisModel.getCoordSysModel();var grid=gridModel.coordinateSystem;seriesModel.coordinateSystem=grid.getCartesian(xAxisModel.componentIndex,yAxisModel.componentIndex);});return grids;};// For deciding which dimensions to use when creating list data
Grid.dimensions=Grid.prototype.dimensions=Cartesian2D.prototype.dimensions;CoordinateSystemManager.register('cartesian2d',Grid);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var BaseBarSeries=SeriesModel.extend({type:'series.__base_bar__',getInitialData:function getInitialData(option,ecModel){return createListFromArray(this.getSource(),this);},getMarkerPosition:function getMarkerPosition(value){var coordSys=this.coordinateSystem;if(coordSys){// PENDING if clamp ?
var pt=coordSys.dataToPoint(coordSys.clampData(value));var data=this.getData();var offset=data.getLayout('offset');var size=data.getLayout('size');var offsetIndex=coordSys.getBaseAxis().isHorizontal()?0:1;pt[offsetIndex]+=offset+size/2;return pt;}return[NaN,NaN];},defaultOption:{zlevel:0,// 一级层叠
z:2,// 二级层叠
coordinateSystem:'cartesian2d',legendHoverLink:true,// stack: null
// Cartesian coordinate system
// xAxisIndex: 0,
// yAxisIndex: 0,
// 最小高度改为0
barMinHeight:0,// 最小角度为0，仅对极坐标系下的柱状图有效
barMinAngle:0,// cursor: null,
large:false,largeThreshold:400,progressive:3e3,progressiveChunkMode:'mod',// barMaxWidth: null,
// 默认自适应
// barWidth: null,
// 柱间距离，默认为柱形宽度的30%，可设固定值
// barGap: '30%',
// 类目间柱形距离，默认为类目间距的20%，可设固定值
// barCategoryGap: '20%',
// label: {
//      show: false
// },
itemStyle:{},emphasis:{}}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/BaseBarSeries.extend({type:'series.bar',dependencies:['grid','polar'],brushSelector:'rect',/**
   * @override
   */getProgressive:function getProgressive(){// Do not support progressive in normal mode.
return this.get('large')?this.get('progressive'):false;},/**
   * @override
   */getProgressiveThreshold:function getProgressiveThreshold(){// Do not support progressive in normal mode.
var progressiveThreshold=this.get('progressiveThreshold');var largeThreshold=this.get('largeThreshold');if(largeThreshold>progressiveThreshold){progressiveThreshold=largeThreshold;}return progressiveThreshold;}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @return {string} label string. Not null/undefined
 */function getDefaultLabel(data,dataIndex){var labelDims=data.mapDimension('defaultedLabel',true);var len=labelDims.length;// Simple optimization (in lots of cases, label dims length is 1)
if(len===1){return retrieveRawValue(data,dataIndex,labelDims[0]);}else if(len){var vals=[];for(var i=0;i<labelDims.length;i++){var val=retrieveRawValue(data,dataIndex,labelDims[i]);vals.push(val);}return vals.join(' ');}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/function setLabel(normalStyle,hoverStyle,itemModel,color,seriesModel,dataIndex,labelPositionOutside){var labelModel=itemModel.getModel('label');var hoverLabelModel=itemModel.getModel('emphasis.label');setLabelStyle(normalStyle,hoverStyle,labelModel,hoverLabelModel,{labelFetcher:seriesModel,labelDataIndex:dataIndex,defaultText:getDefaultLabel(seriesModel.getData(),dataIndex),isRectText:true,autoColor:color});fixPosition(normalStyle);fixPosition(hoverStyle);}function fixPosition(style,labelPositionOutside){if(style.textPosition==='outside'){style.textPosition=labelPositionOutside;}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var _getBarItemStyle=makeStyleMapper([['fill','color'],['stroke','borderColor'],['lineWidth','borderWidth'],// Compatitable with 2
['stroke','barBorderColor'],['lineWidth','barBorderWidth'],['opacity'],['shadowBlur'],['shadowOffsetX'],['shadowOffsetY'],['shadowColor']]);var barItemStyle={getBarItemStyle:function getBarItemStyle(excludes){var style=_getBarItemStyle(this,excludes);if(this.getBorderLineDash){var lineDash=this.getBorderLineDash();lineDash&&(style.lineDash=lineDash);}return style;}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var BAR_BORDER_WIDTH_QUERY=['itemStyle','barBorderWidth'];// FIXME
// Just for compatible with ec2.
extend(Model.prototype,barItemStyle);extendChartView({type:'bar',render:function render(seriesModel,ecModel,api){this._updateDrawMode(seriesModel);var coordinateSystemType=seriesModel.get('coordinateSystem');if(coordinateSystemType==='cartesian2d'||coordinateSystemType==='polar'){this._isLargeDraw?this._renderLarge(seriesModel,ecModel,api):this._renderNormal(seriesModel,ecModel,api);}else{}return this.group;},incrementalPrepareRender:function incrementalPrepareRender(seriesModel,ecModel,api){this._clear();this._updateDrawMode(seriesModel);},incrementalRender:function incrementalRender(params,seriesModel,ecModel,api){// Do not support progressive in normal mode.
this._incrementalRenderLarge(params,seriesModel);},_updateDrawMode:function _updateDrawMode(seriesModel){var isLargeDraw=seriesModel.pipelineContext.large;if(this._isLargeDraw==null||isLargeDraw^this._isLargeDraw){this._isLargeDraw=isLargeDraw;this._clear();}},_renderNormal:function _renderNormal(seriesModel,ecModel,api){var group=this.group;var data=seriesModel.getData();var oldData=this._data;var coord=seriesModel.coordinateSystem;var baseAxis=coord.getBaseAxis();var isHorizontalOrRadial;if(coord.type==='cartesian2d'){isHorizontalOrRadial=baseAxis.isHorizontal();}else if(coord.type==='polar'){isHorizontalOrRadial=baseAxis.dim==='angle';}var animationModel=seriesModel.isAnimationEnabled()?seriesModel:null;data.diff(oldData).add(function(dataIndex){if(!data.hasValue(dataIndex)){return;}var itemModel=data.getItemModel(dataIndex);var layout=getLayout[coord.type](data,dataIndex,itemModel);var el=elementCreator[coord.type](data,dataIndex,itemModel,layout,isHorizontalOrRadial,animationModel);data.setItemGraphicEl(dataIndex,el);group.add(el);updateStyle(el,data,dataIndex,itemModel,layout,seriesModel,isHorizontalOrRadial,coord.type==='polar');}).update(function(newIndex,oldIndex){var el=oldData.getItemGraphicEl(oldIndex);if(!data.hasValue(newIndex)){group.remove(el);return;}var itemModel=data.getItemModel(newIndex);var layout=getLayout[coord.type](data,newIndex,itemModel);if(el){updateProps(el,{shape:layout},animationModel,newIndex);}else{el=elementCreator[coord.type](data,newIndex,itemModel,layout,isHorizontalOrRadial,animationModel,true);}data.setItemGraphicEl(newIndex,el);// Add back
group.add(el);updateStyle(el,data,newIndex,itemModel,layout,seriesModel,isHorizontalOrRadial,coord.type==='polar');}).remove(function(dataIndex){var el=oldData.getItemGraphicEl(dataIndex);if(coord.type==='cartesian2d'){el&&removeRect(dataIndex,animationModel,el);}else{el&&removeSector(dataIndex,animationModel,el);}}).execute();this._data=data;},_renderLarge:function _renderLarge(seriesModel,ecModel,api){this._clear();createLarge(seriesModel,this.group);},_incrementalRenderLarge:function _incrementalRenderLarge(params,seriesModel){createLarge(seriesModel,this.group,true);},dispose:noop,remove:function remove(ecModel){this._clear(ecModel);},_clear:function _clear(ecModel){var group=this.group;var data=this._data;if(ecModel&&ecModel.get('animation')&&data&&!this._isLargeDraw){data.eachItemGraphicEl(function(el){if(el.type==='sector'){removeSector(el.dataIndex,ecModel,el);}else{removeRect(el.dataIndex,ecModel,el);}});}else{group.removeAll();}this._data=null;}});var elementCreator={cartesian2d:function cartesian2d(data,dataIndex,itemModel,layout,isHorizontal,animationModel,isUpdate){var rect=new Rect({shape:extend({},layout)});// Animation
if(animationModel){var rectShape=rect.shape;var animateProperty=isHorizontal?'height':'width';var animateTarget={};rectShape[animateProperty]=0;animateTarget[animateProperty]=layout[animateProperty];graphic[isUpdate?'updateProps':'initProps'](rect,{shape:animateTarget},animationModel,dataIndex);}return rect;},polar:function polar(data,dataIndex,itemModel,layout,isRadial,animationModel,isUpdate){// Keep the same logic with bar in catesion: use end value to control
// direction. Notice that if clockwise is true (by default), the sector
// will always draw clockwisely, no matter whether endAngle is greater
// or less than startAngle.
var clockwise=layout.startAngle<layout.endAngle;var sector=new Sector({shape:defaults({clockwise:clockwise},layout)});// Animation
if(animationModel){var sectorShape=sector.shape;var animateProperty=isRadial?'r':'endAngle';var animateTarget={};sectorShape[animateProperty]=isRadial?0:layout.startAngle;animateTarget[animateProperty]=layout[animateProperty];graphic[isUpdate?'updateProps':'initProps'](sector,{shape:animateTarget},animationModel,dataIndex);}return sector;}};function removeRect(dataIndex,animationModel,el){// Not show text when animating
el.style.text=null;updateProps(el,{shape:{width:0}},animationModel,dataIndex,function(){el.parent&&el.parent.remove(el);});}function removeSector(dataIndex,animationModel,el){// Not show text when animating
el.style.text=null;updateProps(el,{shape:{r:el.shape.r0}},animationModel,dataIndex,function(){el.parent&&el.parent.remove(el);});}var getLayout={cartesian2d:function cartesian2d(data,dataIndex,itemModel){var layout=data.getItemLayout(dataIndex);var fixedLineWidth=getLineWidth(itemModel,layout);// fix layout with lineWidth
var signX=layout.width>0?1:-1;var signY=layout.height>0?1:-1;return{x:layout.x+signX*fixedLineWidth/2,y:layout.y+signY*fixedLineWidth/2,width:layout.width-signX*fixedLineWidth,height:layout.height-signY*fixedLineWidth};},polar:function polar(data,dataIndex,itemModel){var layout=data.getItemLayout(dataIndex);return{cx:layout.cx,cy:layout.cy,r0:layout.r0,r:layout.r,startAngle:layout.startAngle,endAngle:layout.endAngle};}};function updateStyle(el,data,dataIndex,itemModel,layout,seriesModel,isHorizontal,isPolar){var color=data.getItemVisual(dataIndex,'color');var opacity=data.getItemVisual(dataIndex,'opacity');var itemStyleModel=itemModel.getModel('itemStyle');var hoverStyle=itemModel.getModel('emphasis.itemStyle').getBarItemStyle();if(!isPolar){el.setShape('r',itemStyleModel.get('barBorderRadius')||0);}el.useStyle(defaults({fill:color,opacity:opacity},itemStyleModel.getBarItemStyle()));var cursorStyle=itemModel.getShallow('cursor');cursorStyle&&el.attr('cursor',cursorStyle);var labelPositionOutside=isHorizontal?layout.height>0?'bottom':'top':layout.width>0?'left':'right';if(!isPolar){setLabel(el.style,hoverStyle,itemModel,color,seriesModel,dataIndex,labelPositionOutside);}setHoverStyle(el,hoverStyle);}// In case width or height are too small.
function getLineWidth(itemModel,rawLayout){var lineWidth=itemModel.get(BAR_BORDER_WIDTH_QUERY)||0;return Math.min(lineWidth,Math.abs(rawLayout.width),Math.abs(rawLayout.height));}var LargePath=Path.extend({type:'largeBar',shape:{points:[]},buildPath:function buildPath(ctx,shape){// Drawing lines is more efficient than drawing
// a whole line or drawing rects.
var points=shape.points;var startPoint=this.__startPoint;var valueIdx=this.__valueIdx;for(var i=0;i<points.length;i+=2){startPoint[this.__valueIdx]=points[i+valueIdx];ctx.moveTo(startPoint[0],startPoint[1]);ctx.lineTo(points[i],points[i+1]);}}});function createLarge(seriesModel,group,incremental){// TODO support polar
var data=seriesModel.getData();var startPoint=[];var valueIdx=data.getLayout('valueAxisHorizontal')?1:0;startPoint[1-valueIdx]=data.getLayout('valueAxisStart');var el=new LargePath({shape:{points:data.getLayout('largePoints')},incremental:!!incremental,__startPoint:startPoint,__valueIdx:valueIdx});group.add(el);setLargeStyle(el,seriesModel,data);}function setLargeStyle(el,seriesModel,data){var borderColor=data.getVisual('borderColor')||data.getVisual('color');var itemStyle=seriesModel.getModel('itemStyle').getItemStyle(['color','borderColor']);el.useStyle(itemStyle);el.style.fill=null;el.style.stroke=borderColor;el.style.lineWidth=data.getLayout('barWidth');}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var PI$2=Math.PI;function makeAxisEventDataBase(axisModel){var eventData={componentType:axisModel.mainType};eventData[axisModel.mainType+'Index']=axisModel.componentIndex;return eventData;}/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 *
 * @param {module:zrender/container/Group} group
 * @param {Object} axisModel
 * @param {Object} opt Standard axis parameters.
 * @param {Array.<number>} opt.position [x, y]
 * @param {number} opt.rotation by radian
 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
 * @param {number} [opt.tickDirection=1] 1 or -1
 * @param {number} [opt.labelDirection=1] 1 or -1
 * @param {number} [opt.labelOffset=0] Usefull when onZero.
 * @param {string} [opt.axisLabelShow] default get from axisModel.
 * @param {string} [opt.axisName] default get from axisModel.
 * @param {number} [opt.axisNameAvailableWidth]
 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
 * @param {number} [opt.strokeContainThreshold] Default label interval when label
 * @param {number} [opt.nameTruncateMaxWidth]
 */var AxisBuilder=function AxisBuilder(axisModel,opt){/**
   * @readOnly
   */this.opt=opt;/**
   * @readOnly
   */this.axisModel=axisModel;// Default value
defaults(opt,{labelOffset:0,nameDirection:1,tickDirection:1,labelDirection:1,silent:true});/**
   * @readOnly
   */this.group=new Group();// FIXME Not use a seperate text group?
var dumbGroup=new Group({position:opt.position.slice(),rotation:opt.rotation});// this.group.add(dumbGroup);
// this._dumbGroup = dumbGroup;
dumbGroup.updateTransform();this._transform=dumbGroup.transform;this._dumbGroup=dumbGroup;};AxisBuilder.prototype={constructor:AxisBuilder,hasBuilder:function hasBuilder(name){return!!builders[name];},add:function add(name){builders[name].call(this);},getGroup:function getGroup(){return this.group;}};var builders={/**
   * @private
   */axisLine:function axisLine(){var opt=this.opt;var axisModel=this.axisModel;if(!axisModel.get('axisLine.show')){return;}var extent=this.axisModel.axis.getExtent();var matrix=this._transform;var pt1=[extent[0],0];var pt2=[extent[1],0];if(matrix){applyTransform(pt1,pt1,matrix);applyTransform(pt2,pt2,matrix);}var lineStyle=extend({lineCap:'round'},axisModel.getModel('axisLine.lineStyle').getLineStyle());this.group.add(new Line(subPixelOptimizeLine({// Id for animation
anid:'line',shape:{x1:pt1[0],y1:pt1[1],x2:pt2[0],y2:pt2[1]},style:lineStyle,strokeContainThreshold:opt.strokeContainThreshold||5,silent:true,z2:1})));var arrows=axisModel.get('axisLine.symbol');var arrowSize=axisModel.get('axisLine.symbolSize');var arrowOffset=axisModel.get('axisLine.symbolOffset')||0;if(typeof arrowOffset==='number'){arrowOffset=[arrowOffset,arrowOffset];}if(arrows!=null){if(typeof arrows==='string'){// Use the same arrow for start and end point
arrows=[arrows,arrows];}if(typeof arrowSize==='string'||typeof arrowSize==='number'){// Use the same size for width and height
arrowSize=[arrowSize,arrowSize];}var symbolWidth=arrowSize[0];var symbolHeight=arrowSize[1];each$1([{rotate:opt.rotation+Math.PI/2,offset:arrowOffset[0],r:0},{rotate:opt.rotation-Math.PI/2,offset:arrowOffset[1],r:Math.sqrt((pt1[0]-pt2[0])*(pt1[0]-pt2[0])+(pt1[1]-pt2[1])*(pt1[1]-pt2[1]))}],function(point,index){if(arrows[index]!=='none'&&arrows[index]!=null){var symbol=createSymbol(arrows[index],-symbolWidth/2,-symbolHeight/2,symbolWidth,symbolHeight,lineStyle.stroke,true);// Calculate arrow position with offset
var r=point.r+point.offset;var pos=[pt1[0]+r*Math.cos(opt.rotation),pt1[1]-r*Math.sin(opt.rotation)];symbol.attr({rotation:point.rotate,position:pos,silent:true});this.group.add(symbol);}},this);}},/**
   * @private
   */axisTickLabel:function axisTickLabel(){var axisModel=this.axisModel;var opt=this.opt;var tickEls=buildAxisTick(this,axisModel,opt);var labelEls=buildAxisLabel(this,axisModel,opt);fixMinMaxLabelShow(axisModel,labelEls,tickEls);},/**
   * @private
   */axisName:function axisName(){var opt=this.opt;var axisModel=this.axisModel;var name=retrieve(opt.axisName,axisModel.get('name'));if(!name){return;}var nameLocation=axisModel.get('nameLocation');var nameDirection=opt.nameDirection;var textStyleModel=axisModel.getModel('nameTextStyle');var gap=axisModel.get('nameGap')||0;var extent=this.axisModel.axis.getExtent();var gapSignal=extent[0]>extent[1]?-1:1;var pos=[nameLocation==='start'?extent[0]-gapSignal*gap:nameLocation==='end'?extent[1]+gapSignal*gap:(extent[0]+extent[1])/2,// 'middle'
// Reuse labelOffset.
isNameLocationCenter(nameLocation)?opt.labelOffset+nameDirection*gap:0];var labelLayout;var nameRotation=axisModel.get('nameRotate');if(nameRotation!=null){nameRotation=nameRotation*PI$2/180;// To radian.
}var axisNameAvailableWidth;if(isNameLocationCenter(nameLocation)){labelLayout=innerTextLayout(opt.rotation,nameRotation!=null?nameRotation:opt.rotation,// Adapt to axis.
nameDirection);}else{labelLayout=endTextLayout(opt,nameLocation,nameRotation||0,extent);axisNameAvailableWidth=opt.axisNameAvailableWidth;if(axisNameAvailableWidth!=null){axisNameAvailableWidth=Math.abs(axisNameAvailableWidth/Math.sin(labelLayout.rotation));!isFinite(axisNameAvailableWidth)&&(axisNameAvailableWidth=null);}}var textFont=textStyleModel.getFont();var truncateOpt=axisModel.get('nameTruncate',true)||{};var ellipsis=truncateOpt.ellipsis;var maxWidth=retrieve(opt.nameTruncateMaxWidth,truncateOpt.maxWidth,axisNameAvailableWidth);// FIXME
// truncate rich text? (consider performance)
var truncatedText=ellipsis!=null&&maxWidth!=null?truncateText$1(name,maxWidth,textFont,ellipsis,{minChar:2,placeholder:truncateOpt.placeholder}):name;var tooltipOpt=axisModel.get('tooltip',true);var mainType=axisModel.mainType;var formatterParams={componentType:mainType,name:name,$vars:['name']};formatterParams[mainType+'Index']=axisModel.componentIndex;var textEl=new Text({// Id for animation
anid:'name',__fullText:name,__truncatedText:truncatedText,position:pos,rotation:labelLayout.rotation,silent:isSilent(axisModel),z2:1,tooltip:tooltipOpt&&tooltipOpt.show?extend({content:name,formatter:function formatter(){return name;},formatterParams:formatterParams},tooltipOpt):null});setTextStyle(textEl.style,textStyleModel,{text:truncatedText,textFont:textFont,textFill:textStyleModel.getTextColor()||axisModel.get('axisLine.lineStyle.color'),textAlign:labelLayout.textAlign,textVerticalAlign:labelLayout.textVerticalAlign});if(axisModel.get('triggerEvent')){textEl.eventData=makeAxisEventDataBase(axisModel);textEl.eventData.targetType='axisName';textEl.eventData.name=name;}// FIXME
this._dumbGroup.add(textEl);textEl.updateTransform();this.group.add(textEl);textEl.decomposeTransform();}};/**
 * @public
 * @static
 * @param {Object} opt
 * @param {number} axisRotation in radian
 * @param {number} textRotation in radian
 * @param {number} direction
 * @return {Object} {
 *  rotation, // according to axis
 *  textAlign,
 *  textVerticalAlign
 * }
 */var innerTextLayout=AxisBuilder.innerTextLayout=function(axisRotation,textRotation,direction){var rotationDiff=remRadian(textRotation-axisRotation);var textAlign;var textVerticalAlign;if(isRadianAroundZero(rotationDiff)){// Label is parallel with axis line.
textVerticalAlign=direction>0?'top':'bottom';textAlign='center';}else if(isRadianAroundZero(rotationDiff-PI$2)){// Label is inverse parallel with axis line.
textVerticalAlign=direction>0?'bottom':'top';textAlign='center';}else{textVerticalAlign='middle';if(rotationDiff>0&&rotationDiff<PI$2){textAlign=direction>0?'right':'left';}else{textAlign=direction>0?'left':'right';}}return{rotation:rotationDiff,textAlign:textAlign,textVerticalAlign:textVerticalAlign};};function endTextLayout(opt,textPosition,textRotate,extent){var rotationDiff=remRadian(textRotate-opt.rotation);var textAlign;var textVerticalAlign;var inverse=extent[0]>extent[1];var onLeft=textPosition==='start'&&!inverse||textPosition!=='start'&&inverse;if(isRadianAroundZero(rotationDiff-PI$2/2)){textVerticalAlign=onLeft?'bottom':'top';textAlign='center';}else if(isRadianAroundZero(rotationDiff-PI$2*1.5)){textVerticalAlign=onLeft?'top':'bottom';textAlign='center';}else{textVerticalAlign='middle';if(rotationDiff<PI$2*1.5&&rotationDiff>PI$2/2){textAlign=onLeft?'left':'right';}else{textAlign=onLeft?'right':'left';}}return{rotation:rotationDiff,textAlign:textAlign,textVerticalAlign:textVerticalAlign};}function isSilent(axisModel){var tooltipOpt=axisModel.get('tooltip');return axisModel.get('silent')// Consider mouse cursor, add these restrictions.
||!(axisModel.get('triggerEvent')||tooltipOpt&&tooltipOpt.show);}function fixMinMaxLabelShow(axisModel,labelEls,tickEls){// If min or max are user set, we need to check
// If the tick on min(max) are overlap on their neighbour tick
// If they are overlapped, we need to hide the min(max) tick label
var showMinLabel=axisModel.get('axisLabel.showMinLabel');var showMaxLabel=axisModel.get('axisLabel.showMaxLabel');// FIXME
// Have not consider onBand yet, where tick els is more than label els.
labelEls=labelEls||[];tickEls=tickEls||[];var firstLabel=labelEls[0];var nextLabel=labelEls[1];var lastLabel=labelEls[labelEls.length-1];var prevLabel=labelEls[labelEls.length-2];var firstTick=tickEls[0];var nextTick=tickEls[1];var lastTick=tickEls[tickEls.length-1];var prevTick=tickEls[tickEls.length-2];if(showMinLabel===false){ignoreEl(firstLabel);ignoreEl(firstTick);}else if(isTwoLabelOverlapped(firstLabel,nextLabel)){if(showMinLabel){ignoreEl(nextLabel);ignoreEl(nextTick);}else{ignoreEl(firstLabel);ignoreEl(firstTick);}}if(showMaxLabel===false){ignoreEl(lastLabel);ignoreEl(lastTick);}else if(isTwoLabelOverlapped(prevLabel,lastLabel)){if(showMaxLabel){ignoreEl(prevLabel);ignoreEl(prevTick);}else{ignoreEl(lastLabel);ignoreEl(lastTick);}}}function ignoreEl(el){el&&(el.ignore=true);}function isTwoLabelOverlapped(current,next,labelLayout){// current and next has the same rotation.
var firstRect=current&&current.getBoundingRect().clone();var nextRect=next&&next.getBoundingRect().clone();if(!firstRect||!nextRect){return;}// When checking intersect of two rotated labels, we use mRotationBack
// to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
var mRotationBack=identity([]);rotate(mRotationBack,mRotationBack,-current.rotation);firstRect.applyTransform(mul$1([],mRotationBack,current.getLocalTransform()));nextRect.applyTransform(mul$1([],mRotationBack,next.getLocalTransform()));return firstRect.intersect(nextRect);}function isNameLocationCenter(nameLocation){return nameLocation==='middle'||nameLocation==='center';}function buildAxisTick(axisBuilder,axisModel,opt){var axis=axisModel.axis;if(!axisModel.get('axisTick.show')||axis.scale.isBlank()){return;}var tickModel=axisModel.getModel('axisTick');var lineStyleModel=tickModel.getModel('lineStyle');var tickLen=tickModel.get('length');var ticksCoords=axis.getTicksCoords();var pt1=[];var pt2=[];var matrix=axisBuilder._transform;var tickEls=[];for(var i=0;i<ticksCoords.length;i++){var tickCoord=ticksCoords[i].coord;pt1[0]=tickCoord;pt1[1]=0;pt2[0]=tickCoord;pt2[1]=opt.tickDirection*tickLen;if(matrix){applyTransform(pt1,pt1,matrix);applyTransform(pt2,pt2,matrix);}// Tick line, Not use group transform to have better line draw
var tickEl=new Line(subPixelOptimizeLine({// Id for animation
anid:'tick_'+ticksCoords[i].tickValue,shape:{x1:pt1[0],y1:pt1[1],x2:pt2[0],y2:pt2[1]},style:defaults(lineStyleModel.getLineStyle(),{stroke:axisModel.get('axisLine.lineStyle.color')}),z2:2,silent:true}));axisBuilder.group.add(tickEl);tickEls.push(tickEl);}return tickEls;}function buildAxisLabel(axisBuilder,axisModel,opt){var axis=axisModel.axis;var show=retrieve(opt.axisLabelShow,axisModel.get('axisLabel.show'));if(!show||axis.scale.isBlank()){return;}var labelModel=axisModel.getModel('axisLabel');var labelMargin=labelModel.get('margin');var labels=axis.getViewLabels();// Special label rotate.
var labelRotation=(retrieve(opt.labelRotate,labelModel.get('rotate'))||0)*PI$2/180;var labelLayout=innerTextLayout(opt.rotation,labelRotation,opt.labelDirection);var rawCategoryData=axisModel.getCategories(true);var labelEls=[];var silent=isSilent(axisModel);var triggerEvent=axisModel.get('triggerEvent');each$1(labels,function(labelItem,index){var tickValue=labelItem.tickValue;var formattedLabel=labelItem.formattedLabel;var rawLabel=labelItem.rawLabel;var itemLabelModel=labelModel;if(rawCategoryData&&rawCategoryData[tickValue]&&rawCategoryData[tickValue].textStyle){itemLabelModel=new Model(rawCategoryData[tickValue].textStyle,labelModel,axisModel.ecModel);}var textColor=itemLabelModel.getTextColor()||axisModel.get('axisLine.lineStyle.color');var tickCoord=axis.dataToCoord(tickValue);var pos=[tickCoord,opt.labelOffset+opt.labelDirection*labelMargin];var textEl=new Text({// Id for animation
anid:'label_'+tickValue,position:pos,rotation:labelLayout.rotation,silent:silent,z2:10});setTextStyle(textEl.style,itemLabelModel,{text:formattedLabel,textAlign:itemLabelModel.getShallow('align',true)||labelLayout.textAlign,textVerticalAlign:itemLabelModel.getShallow('verticalAlign',true)||itemLabelModel.getShallow('baseline',true)||labelLayout.textVerticalAlign,textFill:typeof textColor==='function'?textColor(// (1) In category axis with data zoom, tick is not the original
// index of axis.data. So tick should not be exposed to user
// in category axis.
// (2) Compatible with previous version, which always use formatted label as
// input. But in interval scale the formatted label is like '223,445', which
// maked user repalce ','. So we modify it to return original val but remain
// it as 'string' to avoid error in replacing.
axis.type==='category'?rawLabel:axis.type==='value'?tickValue+'':tickValue,index):textColor});// Pack data for mouse event
if(triggerEvent){textEl.eventData=makeAxisEventDataBase(axisModel);textEl.eventData.targetType='axisLabel';textEl.eventData.value=rawLabel;}// FIXME
axisBuilder._dumbGroup.add(textEl);textEl.updateTransform();labelEls.push(textEl);axisBuilder.group.add(textEl);textEl.decomposeTransform();});return labelEls;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var each$6=each$1;var curry$1=curry;// Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
// allAxesInfo should be updated when setOption performed.
function collect(ecModel,api){var result={/**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */axesInfo:{},seriesInvolved:false,/**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */coordSysAxesInfo:{},coordSysMap:{}};collectAxesInfo(result,ecModel,api);// Check seriesInvolved for performance, in case too many series in some chart.
result.seriesInvolved&&collectSeriesInfo(result,ecModel);return result;}function collectAxesInfo(result,ecModel,api){var globalTooltipModel=ecModel.getComponent('tooltip');var globalAxisPointerModel=ecModel.getComponent('axisPointer');// links can only be set on global.
var linksOption=globalAxisPointerModel.get('link',true)||[];var linkGroups=[];// Collect axes info.
each$6(api.getCoordinateSystems(),function(coordSys){// Some coordinate system do not support axes, like geo.
if(!coordSys.axisPointerEnabled){return;}var coordSysKey=makeKey(coordSys.model);var axesInfoInCoordSys=result.coordSysAxesInfo[coordSysKey]={};result.coordSysMap[coordSysKey]=coordSys;// Set tooltip (like 'cross') is a convienent way to show axisPointer
// for user. So we enable seting tooltip on coordSys model.
var coordSysModel=coordSys.model;var baseTooltipModel=coordSysModel.getModel('tooltip',globalTooltipModel);each$6(coordSys.getAxes(),curry$1(saveTooltipAxisInfo,false,null));// If axis tooltip used, choose tooltip axis for each coordSys.
// Notice this case: coordSys is `grid` but not `cartesian2D` here.
if(coordSys.getTooltipAxes&&globalTooltipModel// If tooltip.showContent is set as false, tooltip will not
// show but axisPointer will show as normal.
&&baseTooltipModel.get('show')){// Compatible with previous logic. But series.tooltip.trigger: 'axis'
// or series.data[n].tooltip.trigger: 'axis' are not support any more.
var triggerAxis=baseTooltipModel.get('trigger')==='axis';var cross=baseTooltipModel.get('axisPointer.type')==='cross';var tooltipAxes=coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));if(triggerAxis||cross){each$6(tooltipAxes.baseAxes,curry$1(saveTooltipAxisInfo,cross?'cross':true,triggerAxis));}if(cross){each$6(tooltipAxes.otherAxes,curry$1(saveTooltipAxisInfo,'cross',false));}}// fromTooltip: true | false | 'cross'
// triggerTooltip: true | false | null
function saveTooltipAxisInfo(fromTooltip,triggerTooltip,axis){var axisPointerModel=axis.model.getModel('axisPointer',globalAxisPointerModel);var axisPointerShow=axisPointerModel.get('show');if(!axisPointerShow||axisPointerShow==='auto'&&!fromTooltip&&!isHandleTrigger(axisPointerModel)){return;}if(triggerTooltip==null){triggerTooltip=axisPointerModel.get('triggerTooltip');}axisPointerModel=fromTooltip?makeAxisPointerModel(axis,baseTooltipModel,globalAxisPointerModel,ecModel,fromTooltip,triggerTooltip):axisPointerModel;var snap=axisPointerModel.get('snap');var key=makeKey(axis.model);var involveSeries=triggerTooltip||snap||axis.type==='category';// If result.axesInfo[key] exist, override it (tooltip has higher priority).
var axisInfo=result.axesInfo[key]={key:key,axis:axis,coordSys:coordSys,axisPointerModel:axisPointerModel,triggerTooltip:triggerTooltip,involveSeries:involveSeries,snap:snap,useHandle:isHandleTrigger(axisPointerModel),seriesModels:[]};axesInfoInCoordSys[key]=axisInfo;result.seriesInvolved|=involveSeries;var groupIndex=getLinkGroupIndex(linksOption,axis);if(groupIndex!=null){var linkGroup=linkGroups[groupIndex]||(linkGroups[groupIndex]={axesInfo:{}});linkGroup.axesInfo[key]=axisInfo;linkGroup.mapper=linksOption[groupIndex].mapper;axisInfo.linkGroup=linkGroup;}}});}function makeAxisPointerModel(axis,baseTooltipModel,globalAxisPointerModel,ecModel,fromTooltip,triggerTooltip){var tooltipAxisPointerModel=baseTooltipModel.getModel('axisPointer');var volatileOption={};each$6(['type','snap','lineStyle','shadowStyle','label','animation','animationDurationUpdate','animationEasingUpdate','z'],function(field){volatileOption[field]=_clone(tooltipAxisPointerModel.get(field));});// category axis do not auto snap, otherwise some tick that do not
// has value can not be hovered. value/time/log axis default snap if
// triggered from tooltip and trigger tooltip.
volatileOption.snap=axis.type!=='category'&&!!triggerTooltip;// Compatibel with previous behavior, tooltip axis do not show label by default.
// Only these properties can be overrided from tooltip to axisPointer.
if(tooltipAxisPointerModel.get('type')==='cross'){volatileOption.type='line';}var labelOption=volatileOption.label||(volatileOption.label={});// Follow the convention, do not show label when triggered by tooltip by default.
labelOption.show==null&&(labelOption.show=false);if(fromTooltip==='cross'){// When 'cross', both axes show labels.
var tooltipAxisPointerLabelShow=tooltipAxisPointerModel.get('label.show');labelOption.show=tooltipAxisPointerLabelShow!=null?tooltipAxisPointerLabelShow:true;// If triggerTooltip, this is a base axis, which should better not use cross style
// (cross style is dashed by default)
if(!triggerTooltip){var crossStyle=volatileOption.lineStyle=tooltipAxisPointerModel.get('crossStyle');crossStyle&&defaults(labelOption,crossStyle.textStyle);}}return axis.model.getModel('axisPointer',new Model(volatileOption,globalAxisPointerModel,ecModel));}function collectSeriesInfo(result,ecModel){// Prepare data for axis trigger
ecModel.eachSeries(function(seriesModel){// Notice this case: this coordSys is `cartesian2D` but not `grid`.
var coordSys=seriesModel.coordinateSystem;var seriesTooltipTrigger=seriesModel.get('tooltip.trigger',true);var seriesTooltipShow=seriesModel.get('tooltip.show',true);if(!coordSys||seriesTooltipTrigger==='none'||seriesTooltipTrigger===false||seriesTooltipTrigger==='item'||seriesTooltipShow===false||seriesModel.get('axisPointer.show',true)===false){return;}each$6(result.coordSysAxesInfo[makeKey(coordSys.model)],function(axisInfo){var axis=axisInfo.axis;if(coordSys.getAxis(axis.dim)===axis){axisInfo.seriesModels.push(seriesModel);axisInfo.seriesDataCount==null&&(axisInfo.seriesDataCount=0);axisInfo.seriesDataCount+=seriesModel.getData().count();}});},this);}/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */function getLinkGroupIndex(linksOption,axis){var axisModel=axis.model;var dim=axis.dim;for(var i=0;i<linksOption.length;i++){var linkOption=linksOption[i]||{};if(checkPropInLink(linkOption[dim+'AxisId'],axisModel.id)||checkPropInLink(linkOption[dim+'AxisIndex'],axisModel.componentIndex)||checkPropInLink(linkOption[dim+'AxisName'],axisModel.name)){return i;}}}function checkPropInLink(linkPropValue,axisPropValue){return linkPropValue==='all'||isArray(linkPropValue)&&indexOf(linkPropValue,axisPropValue)>=0||linkPropValue===axisPropValue;}function fixValue(axisModel){var axisInfo=getAxisInfo(axisModel);if(!axisInfo){return;}var axisPointerModel=axisInfo.axisPointerModel;var scale=axisInfo.axis.scale;var option=axisPointerModel.option;var status=axisPointerModel.get('status');var value=axisPointerModel.get('value');// Parse init value for category and time axis.
if(value!=null){value=scale.parse(value);}var useHandle=isHandleTrigger(axisPointerModel);// If `handle` used, `axisPointer` will always be displayed, so value
// and status should be initialized.
if(status==null){option.status=useHandle?'show':'hide';}var extent=scale.getExtent().slice();extent[0]>extent[1]&&extent.reverse();if(// Pick a value on axis when initializing.
value==null// If both `handle` and `dataZoom` are used, value may be out of axis extent,
// where we should re-pick a value to keep `handle` displaying normally.
||value>extent[1]){// Make handle displayed on the end of the axis when init, which looks better.
value=extent[1];}if(value<extent[0]){value=extent[0];}option.value=value;if(useHandle){option.status=axisInfo.axis.scale.isBlank()?'hide':'show';}}function getAxisInfo(axisModel){var coordSysAxesInfo=(axisModel.ecModel.getComponent('axisPointer')||{}).coordSysAxesInfo;return coordSysAxesInfo&&coordSysAxesInfo.axesInfo[makeKey(axisModel)];}function getAxisPointerModel(axisModel){var axisInfo=getAxisInfo(axisModel);return axisInfo&&axisInfo.axisPointerModel;}function isHandleTrigger(axisPointerModel){return!!axisPointerModel.get('handle.show');}/**
 * @param {module:echarts/model/Model} model
 * @return {string} unique key
 */function makeKey(model){return model.type+'||'+model.id;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Base class of AxisView.
 */var AxisView=extendComponentView({type:'axis',/**
   * @private
   */_axisPointer:null,/**
   * @protected
   * @type {string}
   */axisPointerClass:null,/**
   * @override
   */render:function render(axisModel,ecModel,api,payload){// FIXME
// This process should proformed after coordinate systems updated
// (axis scale updated), and should be performed each time update.
// So put it here temporarily, although it is not appropriate to
// put a model-writing procedure in `view`.
this.axisPointerClass&&fixValue(axisModel);AxisView.superApply(this,'render',arguments);_updateAxisPointer(this,axisModel,ecModel,api,payload,true);},/**
   * Action handler.
   * @public
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/model/Global} ecModel
   * @param {module:echarts/ExtensionAPI} api
   * @param {Object} payload
   */updateAxisPointer:function updateAxisPointer(axisModel,ecModel,api,payload,force){_updateAxisPointer(this,axisModel,ecModel,api,payload,false);},/**
   * @override
   */remove:function remove(ecModel,api){var axisPointer=this._axisPointer;axisPointer&&axisPointer.remove(api);AxisView.superApply(this,'remove',arguments);},/**
   * @override
   */dispose:function dispose(ecModel,api){disposeAxisPointer(this,api);AxisView.superApply(this,'dispose',arguments);}});function _updateAxisPointer(axisView,axisModel,ecModel,api,payload,forceRender){var Clazz=AxisView.getAxisPointerClass(axisView.axisPointerClass);if(!Clazz){return;}var axisPointerModel=getAxisPointerModel(axisModel);axisPointerModel?(axisView._axisPointer||(axisView._axisPointer=new Clazz())).render(axisModel,axisPointerModel,api,forceRender):disposeAxisPointer(axisView,api);}function disposeAxisPointer(axisView,ecModel,api){var axisPointer=axisView._axisPointer;axisPointer&&axisPointer.dispose(ecModel,api);axisView._axisPointer=null;}var axisPointerClazz=[];AxisView.registerAxisPointerClass=function(type,clazz){axisPointerClazz[type]=clazz;};AxisView.getAxisPointerClass=function(type){return type&&axisPointerClazz[type];};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Can only be called after coordinate system creation stage.
 * (Can be called before coordinate system update stage).
 *
 * @param {Object} opt {labelInside}
 * @return {Object} {
 *  position, rotation, labelDirection, labelOffset,
 *  tickDirection, labelRotate, z2
 * }
 */function layout$1(gridModel,axisModel,opt){opt=opt||{};var grid=gridModel.coordinateSystem;var axis=axisModel.axis;var layout={};var otherAxisOnZeroOf=axis.getAxesOnZeroOf()[0];var rawAxisPosition=axis.position;var axisPosition=otherAxisOnZeroOf?'onZero':rawAxisPosition;var axisDim=axis.dim;var rect=grid.getRect();var rectBound=[rect.x,rect.x+rect.width,rect.y,rect.y+rect.height];var idx={left:0,right:1,top:0,bottom:1,onZero:2};var axisOffset=axisModel.get('offset')||0;var posBound=axisDim==='x'?[rectBound[2]-axisOffset,rectBound[3]+axisOffset]:[rectBound[0]-axisOffset,rectBound[1]+axisOffset];if(otherAxisOnZeroOf){var onZeroCoord=otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));posBound[idx['onZero']]=Math.max(Math.min(onZeroCoord,posBound[1]),posBound[0]);}// Axis position
layout.position=[axisDim==='y'?posBound[idx[axisPosition]]:rectBound[0],axisDim==='x'?posBound[idx[axisPosition]]:rectBound[3]];// Axis rotation
layout.rotation=Math.PI/2*(axisDim==='x'?0:1);// Tick and label direction, x y is axisDim
var dirMap={top:-1,bottom:1,left:-1,right:1};layout.labelDirection=layout.tickDirection=layout.nameDirection=dirMap[rawAxisPosition];layout.labelOffset=otherAxisOnZeroOf?posBound[idx[rawAxisPosition]]-posBound[idx['onZero']]:0;if(axisModel.get('axisTick.inside')){layout.tickDirection=-layout.tickDirection;}if(retrieve(opt.labelInside,axisModel.get('axisLabel.inside'))){layout.labelDirection=-layout.labelDirection;}// Special label rotation
var labelRotate=axisModel.get('axisLabel.rotate');layout.labelRotate=axisPosition==='top'?-labelRotate:labelRotate;// Over splitLine and splitArea
layout.z2=1;return layout;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var axisBuilderAttrs=['axisLine','axisTickLabel','axisName'];var selfBuilderAttrs=['splitArea','splitLine'];// function getAlignWithLabel(model, axisModel) {
//     var alignWithLabel = model.get('alignWithLabel');
//     if (alignWithLabel === 'auto') {
//         alignWithLabel = axisModel.get('axisTick.alignWithLabel');
//     }
//     return alignWithLabel;
// }
var CartesianAxisView=AxisView.extend({type:'cartesianAxis',axisPointerClass:'CartesianAxisPointer',/**
   * @override
   */render:function render(axisModel,ecModel,api,payload){this.group.removeAll();var oldAxisGroup=this._axisGroup;this._axisGroup=new Group();this.group.add(this._axisGroup);if(!axisModel.get('show')){return;}var gridModel=axisModel.getCoordSysModel();var layout=layout$1(gridModel,axisModel);var axisBuilder=new AxisBuilder(axisModel,layout);each$1(axisBuilderAttrs,axisBuilder.add,axisBuilder);this._axisGroup.add(axisBuilder.getGroup());each$1(selfBuilderAttrs,function(name){if(axisModel.get(name+'.show')){this['_'+name](axisModel,gridModel);}},this);groupTransition(oldAxisGroup,this._axisGroup,axisModel);CartesianAxisView.superCall(this,'render',axisModel,ecModel,api,payload);},remove:function remove(){this._splitAreaColors=null;},/**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */_splitLine:function _splitLine(axisModel,gridModel){var axis=axisModel.axis;if(axis.scale.isBlank()){return;}var splitLineModel=axisModel.getModel('splitLine');var lineStyleModel=splitLineModel.getModel('lineStyle');var lineColors=lineStyleModel.get('color');lineColors=isArray(lineColors)?lineColors:[lineColors];var gridRect=gridModel.coordinateSystem.getRect();var isHorizontal=axis.isHorizontal();var lineCount=0;var ticksCoords=axis.getTicksCoords({tickModel:splitLineModel});var p1=[];var p2=[];// Simple optimization
// Batching the lines if color are the same
var lineStyle=lineStyleModel.getLineStyle();for(var i=0;i<ticksCoords.length;i++){var tickCoord=axis.toGlobalCoord(ticksCoords[i].coord);if(isHorizontal){p1[0]=tickCoord;p1[1]=gridRect.y;p2[0]=tickCoord;p2[1]=gridRect.y+gridRect.height;}else{p1[0]=gridRect.x;p1[1]=tickCoord;p2[0]=gridRect.x+gridRect.width;p2[1]=tickCoord;}var colorIndex=lineCount++%lineColors.length;var tickValue=ticksCoords[i].tickValue;this._axisGroup.add(new Line(subPixelOptimizeLine({anid:tickValue!=null?'line_'+ticksCoords[i].tickValue:null,shape:{x1:p1[0],y1:p1[1],x2:p2[0],y2:p2[1]},style:defaults({stroke:lineColors[colorIndex]},lineStyle),silent:true})));}},/**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */_splitArea:function _splitArea(axisModel,gridModel){var axis=axisModel.axis;if(axis.scale.isBlank()){return;}var splitAreaModel=axisModel.getModel('splitArea');var areaStyleModel=splitAreaModel.getModel('areaStyle');var areaColors=areaStyleModel.get('color');var gridRect=gridModel.coordinateSystem.getRect();var ticksCoords=axis.getTicksCoords({tickModel:splitAreaModel,clamp:true});if(!ticksCoords.length){return;}// For Making appropriate splitArea animation, the color and anid
// should be corresponding to previous one if possible.
var areaColorsLen=areaColors.length;var lastSplitAreaColors=this._splitAreaColors;var newSplitAreaColors=createHashMap();var colorIndex=0;if(lastSplitAreaColors){for(var i=0;i<ticksCoords.length;i++){var cIndex=lastSplitAreaColors.get(ticksCoords[i].tickValue);if(cIndex!=null){colorIndex=(cIndex+(areaColorsLen-1)*i)%areaColorsLen;break;}}}var prev=axis.toGlobalCoord(ticksCoords[0].coord);var areaStyle=areaStyleModel.getAreaStyle();areaColors=isArray(areaColors)?areaColors:[areaColors];for(var i=1;i<ticksCoords.length;i++){var tickCoord=axis.toGlobalCoord(ticksCoords[i].coord);var x;var y;var width;var height;if(axis.isHorizontal()){x=prev;y=gridRect.y;width=tickCoord-x;height=gridRect.height;prev=x+width;}else{x=gridRect.x;y=prev;width=gridRect.width;height=tickCoord-y;prev=y+height;}var tickValue=ticksCoords[i-1].tickValue;tickValue!=null&&newSplitAreaColors.set(tickValue,colorIndex);this._axisGroup.add(new Rect({anid:tickValue!=null?'area_'+tickValue:null,shape:{x:x,y:y,width:width,height:height},style:defaults({fill:areaColors[colorIndex]},areaStyle),silent:true}));colorIndex=(colorIndex+1)%areaColorsLen;}this._splitAreaColors=newSplitAreaColors;}});CartesianAxisView.extend({type:'xAxis'});CartesianAxisView.extend({type:'yAxis'});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/extendComponentView({type:'grid',render:function render(gridModel,ecModel){this.group.removeAll();if(gridModel.get('show')){this.group.add(new Rect({shape:gridModel.coordinateSystem.getRect(),style:defaults({fill:gridModel.get('backgroundColor')},gridModel.getItemStyle()),silent:true,z2:-1}));}}});registerPreprocessor(function(option){// Only create grid when need
if(option.xAxis&&option.yAxis&&!option.grid){option.grid={};}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/registerLayout(curry(layout,'bar'));// Should after normal bar layout, otherwise it is blocked by normal bar layout.
registerLayout(largeLayout);registerVisual({seriesType:'bar',reset:function reset(seriesModel){// Visual coding for legend
seriesModel.getData().setVisual('legendSymbol','roundRect');}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/SeriesModel.extend({type:'series.line',dependencies:['grid','polar'],getInitialData:function getInitialData(option,ecModel){return createListFromArray(this.getSource(),this);},defaultOption:{zlevel:0,z:2,coordinateSystem:'cartesian2d',legendHoverLink:true,hoverAnimation:true,// stack: null
// xAxisIndex: 0,
// yAxisIndex: 0,
// polarIndex: 0,
// If clip the overflow value
clipOverflow:true,// cursor: null,
label:{position:'top'},// itemStyle: {
// },
lineStyle:{width:2,type:'solid'},// areaStyle: {
// origin of areaStyle. Valid values:
// `'auto'/null/undefined`: from axisLine to data
// `'start'`: from min to data
// `'end'`: from data to max
// origin: 'auto'
// },
// false, 'start', 'end', 'middle'
step:false,// Disabled if step is true
smooth:false,smoothMonotone:null,symbol:'emptyCircle',symbolSize:4,symbolRotate:null,showSymbol:true,// `false`: follow the label interval strategy.
// `true`: show all symbols.
// `'auto'`: If possible, show all symbols, otherwise
//           follow the label interval strategy.
showAllSymbol:'auto',// Whether to connect break point.
connectNulls:false,// Sampling for large data. Can be: 'average', 'max', 'min', 'sum'.
sampling:'none',animationEasing:'linear',// Disable progressive
progressive:0,hoverLayerThreshold:Infinity}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @module echarts/chart/helper/Symbol
 *//**
 * @constructor
 * @alias {module:echarts/chart/helper/Symbol}
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @extends {module:zrender/graphic/Group}
 */function SymbolClz$1(data,idx,seriesScope){Group.call(this);this.updateData(data,idx,seriesScope);}var symbolProto=SymbolClz$1.prototype;/**
 * @public
 * @static
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @return {Array.<number>} [width, height]
 */var getSymbolSize=SymbolClz$1.getSymbolSize=function(data,idx){var symbolSize=data.getItemVisual(idx,'symbolSize');return symbolSize instanceof Array?symbolSize.slice():[+symbolSize,+symbolSize];};function getScale(symbolSize){return[symbolSize[0]/2,symbolSize[1]/2];}function driftSymbol(dx,dy){this.parent.drift(dx,dy);}symbolProto._createSymbol=function(symbolType,data,idx,symbolSize,keepAspect){// Remove paths created before
this.removeAll();var color=data.getItemVisual(idx,'color');// var symbolPath = createSymbol(
//     symbolType, -0.5, -0.5, 1, 1, color
// );
// If width/height are set too small (e.g., set to 1) on ios10
// and macOS Sierra, a circle stroke become a rect, no matter what
// the scale is set. So we set width/height as 2. See #4150.
var symbolPath=createSymbol(symbolType,-1,-1,2,2,color,keepAspect);symbolPath.attr({z2:100,culling:true,scale:getScale(symbolSize)});// Rewrite drift method
symbolPath.drift=driftSymbol;this._symbolType=symbolType;this.add(symbolPath);};/**
 * Stop animation
 * @param {boolean} toLastFrame
 */symbolProto.stopSymbolAnimation=function(toLastFrame){this.childAt(0).stopAnimation(toLastFrame);};/**
 * FIXME:
 * Caution: This method breaks the encapsulation of this module,
 * but it indeed brings convenience. So do not use the method
 * unless you detailedly know all the implements of `Symbol`,
 * especially animation.
 *
 * Get symbol path element.
 */symbolProto.getSymbolPath=function(){return this.childAt(0);};/**
 * Get scale(aka, current symbol size).
 * Including the change caused by animation
 */symbolProto.getScale=function(){return this.childAt(0).scale;};/**
 * Highlight symbol
 */symbolProto.highlight=function(){this.childAt(0).trigger('emphasis');};/**
 * Downplay symbol
 */symbolProto.downplay=function(){this.childAt(0).trigger('normal');};/**
 * @param {number} zlevel
 * @param {number} z
 */symbolProto.setZ=function(zlevel,z){var symbolPath=this.childAt(0);symbolPath.zlevel=zlevel;symbolPath.z=z;};symbolProto.setDraggable=function(draggable){var symbolPath=this.childAt(0);symbolPath.draggable=draggable;symbolPath.cursor=draggable?'move':'pointer';};/**
 * Update symbol properties
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Object} [seriesScope]
 * @param {Object} [seriesScope.itemStyle]
 * @param {Object} [seriesScope.hoverItemStyle]
 * @param {Object} [seriesScope.symbolRotate]
 * @param {Object} [seriesScope.symbolOffset]
 * @param {module:echarts/model/Model} [seriesScope.labelModel]
 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
 * @param {boolean} [seriesScope.hoverAnimation]
 * @param {Object} [seriesScope.cursorStyle]
 * @param {module:echarts/model/Model} [seriesScope.itemModel]
 * @param {string} [seriesScope.symbolInnerColor]
 * @param {Object} [seriesScope.fadeIn=false]
 */symbolProto.updateData=function(data,idx,seriesScope){this.silent=false;var symbolType=data.getItemVisual(idx,'symbol')||'circle';var seriesModel=data.hostModel;var symbolSize=getSymbolSize(data,idx);var isInit=symbolType!==this._symbolType;if(isInit){var keepAspect=data.getItemVisual(idx,'symbolKeepAspect');this._createSymbol(symbolType,data,idx,symbolSize,keepAspect);}else{var symbolPath=this.childAt(0);symbolPath.silent=false;updateProps(symbolPath,{scale:getScale(symbolSize)},seriesModel,idx);}this._updateCommon(data,idx,symbolSize,seriesScope);if(isInit){var symbolPath=this.childAt(0);var fadeIn=seriesScope&&seriesScope.fadeIn;var target={scale:symbolPath.scale.slice()};fadeIn&&(target.style={opacity:symbolPath.style.opacity});symbolPath.scale=[0,0];fadeIn&&(symbolPath.style.opacity=0);initProps(symbolPath,target,seriesModel,idx);}this._seriesModel=seriesModel;};// Update common properties
var normalStyleAccessPath=['itemStyle'];var emphasisStyleAccessPath=['emphasis','itemStyle'];var normalLabelAccessPath=['label'];var emphasisLabelAccessPath=['emphasis','label'];/**
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Array.<number>} symbolSize
 * @param {Object} [seriesScope]
 */symbolProto._updateCommon=function(data,idx,symbolSize,seriesScope){var symbolPath=this.childAt(0);var seriesModel=data.hostModel;var color=data.getItemVisual(idx,'color');// Reset style
if(symbolPath.type!=='image'){symbolPath.useStyle({strokeNoScale:true});}var itemStyle=seriesScope&&seriesScope.itemStyle;var hoverItemStyle=seriesScope&&seriesScope.hoverItemStyle;var symbolRotate=seriesScope&&seriesScope.symbolRotate;var symbolOffset=seriesScope&&seriesScope.symbolOffset;var labelModel=seriesScope&&seriesScope.labelModel;var hoverLabelModel=seriesScope&&seriesScope.hoverLabelModel;var hoverAnimation=seriesScope&&seriesScope.hoverAnimation;var cursorStyle=seriesScope&&seriesScope.cursorStyle;if(!seriesScope||data.hasItemOption){var itemModel=seriesScope&&seriesScope.itemModel?seriesScope.itemModel:data.getItemModel(idx);// Color must be excluded.
// Because symbol provide setColor individually to set fill and stroke
itemStyle=itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);hoverItemStyle=itemModel.getModel(emphasisStyleAccessPath).getItemStyle();symbolRotate=itemModel.getShallow('symbolRotate');symbolOffset=itemModel.getShallow('symbolOffset');labelModel=itemModel.getModel(normalLabelAccessPath);hoverLabelModel=itemModel.getModel(emphasisLabelAccessPath);hoverAnimation=itemModel.getShallow('hoverAnimation');cursorStyle=itemModel.getShallow('cursor');}else{hoverItemStyle=extend({},hoverItemStyle);}var elStyle=symbolPath.style;symbolPath.attr('rotation',(symbolRotate||0)*Math.PI/180||0);if(symbolOffset){symbolPath.attr('position',[parsePercent$1(symbolOffset[0],symbolSize[0]),parsePercent$1(symbolOffset[1],symbolSize[1])]);}cursorStyle&&symbolPath.attr('cursor',cursorStyle);// PENDING setColor before setStyle!!!
symbolPath.setColor(color,seriesScope&&seriesScope.symbolInnerColor);symbolPath.setStyle(itemStyle);var opacity=data.getItemVisual(idx,'opacity');if(opacity!=null){elStyle.opacity=opacity;}var liftZ=data.getItemVisual(idx,'liftZ');var z2Origin=symbolPath.__z2Origin;if(liftZ!=null){if(z2Origin==null){symbolPath.__z2Origin=symbolPath.z2;symbolPath.z2+=liftZ;}}else if(z2Origin!=null){symbolPath.z2=z2Origin;symbolPath.__z2Origin=null;}var useNameLabel=seriesScope&&seriesScope.useNameLabel;setLabelStyle(elStyle,hoverItemStyle,labelModel,hoverLabelModel,{labelFetcher:seriesModel,labelDataIndex:idx,defaultText:getLabelDefaultText,isRectText:true,autoColor:color});// Do not execute util needed.
function getLabelDefaultText(idx,opt){return useNameLabel?data.getName(idx):getDefaultLabel(data,idx);}symbolPath.off('mouseover').off('mouseout').off('emphasis').off('normal');symbolPath.hoverStyle=hoverItemStyle;// FIXME
// Do not use symbol.trigger('emphasis'), but use symbol.highlight() instead.
setHoverStyle(symbolPath);var scale=getScale(symbolSize);if(hoverAnimation&&seriesModel.isAnimationEnabled()){var onEmphasis=function onEmphasis(){// Do not support this hover animation util some scenario required.
// Animation can only be supported in hover layer when using `el.incremetal`.
if(this.incremental){return;}var ratio=scale[1]/scale[0];this.animateTo({scale:[Math.max(scale[0]*1.1,scale[0]+3),Math.max(scale[1]*1.1,scale[1]+3*ratio)]},400,'elasticOut');};var onNormal=function onNormal(){if(this.incremental){return;}this.animateTo({scale:scale},400,'elasticOut');};symbolPath.on('mouseover',onEmphasis).on('mouseout',onNormal).on('emphasis',onEmphasis).on('normal',onNormal);}};/**
 * @param {Function} cb
 * @param {Object} [opt]
 * @param {Object} [opt.keepLabel=true]
 */symbolProto.fadeOut=function(cb,opt){var symbolPath=this.childAt(0);// Avoid mistaken hover when fading out
this.silent=symbolPath.silent=true;// Not show text when animating
!(opt&&opt.keepLabel)&&(symbolPath.style.text=null);updateProps(symbolPath,{style:{opacity:0},scale:[0,0]},this._seriesModel,this.dataIndex,cb);};inherits(SymbolClz$1,Group);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @module echarts/chart/helper/SymbolDraw
 *//**
 * @constructor
 * @alias module:echarts/chart/helper/SymbolDraw
 * @param {module:zrender/graphic/Group} [symbolCtor]
 */function SymbolDraw(symbolCtor){this.group=new Group();this._symbolCtor=symbolCtor||SymbolClz$1;}var symbolDrawProto=SymbolDraw.prototype;function symbolNeedsDraw(data,point,idx,opt){return point&&!isNaN(point[0])&&!isNaN(point[1])&&!(opt.isIgnore&&opt.isIgnore(idx))// We do not set clipShape on group, because it will cut part of
// the symbol element shape. We use the same clip shape here as
// the line clip.
&&!(opt.clipShape&&!opt.clipShape.contain(point[0],point[1]))&&data.getItemVisual(idx,'symbol')!=='none';}/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Object} [opt] Or isIgnore
 * @param {Function} [opt.isIgnore]
 * @param {Object} [opt.clipShape]
 */symbolDrawProto.updateData=function(data,opt){opt=normalizeUpdateOpt(opt);var group=this.group;var seriesModel=data.hostModel;var oldData=this._data;var SymbolCtor=this._symbolCtor;var seriesScope=makeSeriesScope(data);// There is no oldLineData only when first rendering or switching from
// stream mode to normal mode, where previous elements should be removed.
if(!oldData){group.removeAll();}data.diff(oldData).add(function(newIdx){var point=data.getItemLayout(newIdx);if(symbolNeedsDraw(data,point,newIdx,opt)){var symbolEl=new SymbolCtor(data,newIdx,seriesScope);symbolEl.attr('position',point);data.setItemGraphicEl(newIdx,symbolEl);group.add(symbolEl);}}).update(function(newIdx,oldIdx){var symbolEl=oldData.getItemGraphicEl(oldIdx);var point=data.getItemLayout(newIdx);if(!symbolNeedsDraw(data,point,newIdx,opt)){group.remove(symbolEl);return;}if(!symbolEl){symbolEl=new SymbolCtor(data,newIdx);symbolEl.attr('position',point);}else{symbolEl.updateData(data,newIdx,seriesScope);updateProps(symbolEl,{position:point},seriesModel);}// Add back
group.add(symbolEl);data.setItemGraphicEl(newIdx,symbolEl);}).remove(function(oldIdx){var el=oldData.getItemGraphicEl(oldIdx);el&&el.fadeOut(function(){group.remove(el);});}).execute();this._data=data;};symbolDrawProto.isPersistent=function(){return true;};symbolDrawProto.updateLayout=function(){var data=this._data;if(data){// Not use animation
data.eachItemGraphicEl(function(el,idx){var point=data.getItemLayout(idx);el.attr('position',point);});}};symbolDrawProto.incrementalPrepareUpdate=function(data){this._seriesScope=makeSeriesScope(data);this._data=null;this.group.removeAll();};/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Object} [opt] Or isIgnore
 * @param {Function} [opt.isIgnore]
 * @param {Object} [opt.clipShape]
 */symbolDrawProto.incrementalUpdate=function(taskParams,data,opt){opt=normalizeUpdateOpt(opt);function updateIncrementalAndHover(el){if(!el.isGroup){el.incremental=el.useHoverLayer=true;}}for(var idx=taskParams.start;idx<taskParams.end;idx++){var point=data.getItemLayout(idx);if(symbolNeedsDraw(data,point,idx,opt)){var el=new this._symbolCtor(data,idx,this._seriesScope);el.traverse(updateIncrementalAndHover);el.attr('position',point);this.group.add(el);data.setItemGraphicEl(idx,el);}}};function normalizeUpdateOpt(opt){if(opt!=null&&!isObject$1(opt)){opt={isIgnore:opt};}return opt||{};}symbolDrawProto.remove=function(enableAnimation){var group=this.group;var data=this._data;// Incremental model do not have this._data.
if(data&&enableAnimation){data.eachItemGraphicEl(function(el){el.fadeOut(function(){group.remove(el);});});}else{group.removeAll();}};function makeSeriesScope(data){var seriesModel=data.hostModel;return{itemStyle:seriesModel.getModel('itemStyle').getItemStyle(['color']),hoverItemStyle:seriesModel.getModel('emphasis.itemStyle').getItemStyle(),symbolRotate:seriesModel.get('symbolRotate'),symbolOffset:seriesModel.get('symbolOffset'),hoverAnimation:seriesModel.get('hoverAnimation'),labelModel:seriesModel.getModel('label'),hoverLabelModel:seriesModel.getModel('emphasis.label'),cursorStyle:seriesModel.get('cursor')};}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @param {Object} coordSys
 * @param {module:echarts/data/List} data
 * @param {string} valueOrigin lineSeries.option.areaStyle.origin
 */function prepareDataCoordInfo(coordSys,data,valueOrigin){var baseAxis=coordSys.getBaseAxis();var valueAxis=coordSys.getOtherAxis(baseAxis);var valueStart=getValueStart(valueAxis,valueOrigin);var baseAxisDim=baseAxis.dim;var valueAxisDim=valueAxis.dim;var valueDim=data.mapDimension(valueAxisDim);var baseDim=data.mapDimension(baseAxisDim);var baseDataOffset=valueAxisDim==='x'||valueAxisDim==='radius'?1:0;var dims=map(coordSys.dimensions,function(coordDim){return data.mapDimension(coordDim);});var stacked;var stackResultDim=data.getCalculationInfo('stackResultDimension');if(stacked|=isDimensionStacked(data,dims[0]/*, dims[1]*/)){// jshint ignore:line
dims[0]=stackResultDim;}if(stacked|=isDimensionStacked(data,dims[1]/*, dims[0]*/)){// jshint ignore:line
dims[1]=stackResultDim;}return{dataDimsForPoint:dims,valueStart:valueStart,valueAxisDim:valueAxisDim,baseAxisDim:baseAxisDim,stacked:!!stacked,valueDim:valueDim,baseDim:baseDim,baseDataOffset:baseDataOffset,stackedOverDimension:data.getCalculationInfo('stackedOverDimension')};}function getValueStart(valueAxis,valueOrigin){var valueStart=0;var extent=valueAxis.scale.getExtent();if(valueOrigin==='start'){valueStart=extent[0];}else if(valueOrigin==='end'){valueStart=extent[1];}// auto
else{// Both positive
if(extent[0]>0){valueStart=extent[0];}// Both negative
else if(extent[1]<0){valueStart=extent[1];}// If is one positive, and one negative, onZero shall be true
}return valueStart;}function getStackedOnPoint(dataCoordInfo,coordSys,data,idx){var value=NaN;if(dataCoordInfo.stacked){value=data.get(data.getCalculationInfo('stackedOverDimension'),idx);}if(isNaN(value)){value=dataCoordInfo.valueStart;}var baseDataOffset=dataCoordInfo.baseDataOffset;var stackedData=[];stackedData[baseDataOffset]=data.get(dataCoordInfo.baseDim,idx);stackedData[1-baseDataOffset]=value;return coordSys.dataToPoint(stackedData);}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// 'zrender/src/core/arrayDiff' has been used before, but it did
// not do well in performance when roam with fixed dataZoom window.
// function convertToIntId(newIdList, oldIdList) {
//     // Generate int id instead of string id.
//     // Compare string maybe slow in score function of arrDiff
//     // Assume id in idList are all unique
//     var idIndicesMap = {};
//     var idx = 0;
//     for (var i = 0; i < newIdList.length; i++) {
//         idIndicesMap[newIdList[i]] = idx;
//         newIdList[i] = idx++;
//     }
//     for (var i = 0; i < oldIdList.length; i++) {
//         var oldId = oldIdList[i];
//         // Same with newIdList
//         if (idIndicesMap[oldId]) {
//             oldIdList[i] = idIndicesMap[oldId];
//         }
//         else {
//             oldIdList[i] = idx++;
//         }
//     }
// }
function diffData(oldData,newData){var diffResult=[];newData.diff(oldData).add(function(idx){diffResult.push({cmd:'+',idx:idx});}).update(function(newIdx,oldIdx){diffResult.push({cmd:'=',idx:oldIdx,idx1:newIdx});}).remove(function(idx){diffResult.push({cmd:'-',idx:idx});}).execute();return diffResult;}var lineAnimationDiff=function lineAnimationDiff(oldData,newData,oldStackedOnPoints,newStackedOnPoints,oldCoordSys,newCoordSys,oldValueOrigin,newValueOrigin){var diff=diffData(oldData,newData);// var newIdList = newData.mapArray(newData.getId);
// var oldIdList = oldData.mapArray(oldData.getId);
// convertToIntId(newIdList, oldIdList);
// // FIXME One data ?
// diff = arrayDiff(oldIdList, newIdList);
var currPoints=[];var nextPoints=[];// Points for stacking base line
var currStackedPoints=[];var nextStackedPoints=[];var status=[];var sortedIndices=[];var rawIndices=[];var newDataOldCoordInfo=prepareDataCoordInfo(oldCoordSys,newData,oldValueOrigin);var oldDataNewCoordInfo=prepareDataCoordInfo(newCoordSys,oldData,newValueOrigin);for(var i=0;i<diff.length;i++){var diffItem=diff[i];var pointAdded=true;// FIXME, animation is not so perfect when dataZoom window moves fast
// Which is in case remvoing or add more than one data in the tail or head
switch(diffItem.cmd){case'=':var currentPt=oldData.getItemLayout(diffItem.idx);var nextPt=newData.getItemLayout(diffItem.idx1);// If previous data is NaN, use next point directly
if(isNaN(currentPt[0])||isNaN(currentPt[1])){currentPt=nextPt.slice();}currPoints.push(currentPt);nextPoints.push(nextPt);currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);rawIndices.push(newData.getRawIndex(diffItem.idx1));break;case'+':var idx=diffItem.idx;currPoints.push(oldCoordSys.dataToPoint([newData.get(newDataOldCoordInfo.dataDimsForPoint[0],idx),newData.get(newDataOldCoordInfo.dataDimsForPoint[1],idx)]));nextPoints.push(newData.getItemLayout(idx).slice());currStackedPoints.push(getStackedOnPoint(newDataOldCoordInfo,oldCoordSys,newData,idx));nextStackedPoints.push(newStackedOnPoints[idx]);rawIndices.push(newData.getRawIndex(idx));break;case'-':var idx=diffItem.idx;var rawIndex=oldData.getRawIndex(idx);// Data is replaced. In the case of dynamic data queue
// FIXME FIXME FIXME
if(rawIndex!==idx){currPoints.push(oldData.getItemLayout(idx));nextPoints.push(newCoordSys.dataToPoint([oldData.get(oldDataNewCoordInfo.dataDimsForPoint[0],idx),oldData.get(oldDataNewCoordInfo.dataDimsForPoint[1],idx)]));currStackedPoints.push(oldStackedOnPoints[idx]);nextStackedPoints.push(getStackedOnPoint(oldDataNewCoordInfo,newCoordSys,oldData,idx));rawIndices.push(rawIndex);}else{pointAdded=false;}}// Original indices
if(pointAdded){status.push(diffItem);sortedIndices.push(sortedIndices.length);}}// Diff result may be crossed if all items are changed
// Sort by data index
sortedIndices.sort(function(a,b){return rawIndices[a]-rawIndices[b];});var sortedCurrPoints=[];var sortedNextPoints=[];var sortedCurrStackedPoints=[];var sortedNextStackedPoints=[];var sortedStatus=[];for(var i=0;i<sortedIndices.length;i++){var idx=sortedIndices[i];sortedCurrPoints[i]=currPoints[idx];sortedNextPoints[i]=nextPoints[idx];sortedCurrStackedPoints[i]=currStackedPoints[idx];sortedNextStackedPoints[i]=nextStackedPoints[idx];sortedStatus[i]=status[idx];}return{current:sortedCurrPoints,next:sortedNextPoints,stackedOnCurrent:sortedCurrStackedPoints,stackedOnNext:sortedNextStackedPoints,status:sortedStatus};};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// Poly path support NaN point
var vec2Min=min;var vec2Max=max;var scaleAndAdd$1=scaleAndAdd;var v2Copy=copy;// Temporary variable
var v=[];var cp0=[];var cp1=[];function isPointNull(p){return isNaN(p[0])||isNaN(p[1]);}function drawSegment(ctx,points,start,segLen,allLen,dir,smoothMin,smoothMax,smooth,smoothMonotone,connectNulls){// if (smoothMonotone == null) {
//     if (isMono(points, 'x')) {
//         return drawMono(ctx, points, start, segLen, allLen,
//             dir, smoothMin, smoothMax, smooth, 'x', connectNulls);
//     }
//     else if (isMono(points, 'y')) {
//         return drawMono(ctx, points, start, segLen, allLen,
//             dir, smoothMin, smoothMax, smooth, 'y', connectNulls);
//     }
//     else {
//         return drawNonMono.apply(this, arguments);
//     }
// }
// else if (smoothMonotone !== 'none' && isMono(points, smoothMonotone)) {
//     return drawMono.apply(this, arguments);
// }
// else {
//     return drawNonMono.apply(this, arguments);
// }
if(smoothMonotone==='none'||!smoothMonotone){return drawNonMono.apply(this,arguments);}else{return drawMono.apply(this,arguments);}}/**
 * Check if points is in monotone.
 *
 * @param {number[][]} points         Array of points which is in [x, y] form
 * @param {string}     smoothMonotone 'x', 'y', or 'none', stating for which
 *                                    dimension that is checking.
 *                                    If is 'none', `drawNonMono` should be
 *                                    called.
 *                                    If is undefined, either being monotone
 *                                    in 'x' or 'y' will call `drawMono`.
 */// function isMono(points, smoothMonotone) {
//     if (points.length <= 1) {
//         return true;
//     }
//     var dim = smoothMonotone === 'x' ? 0 : 1;
//     var last = points[0][dim];
//     var lastDiff = 0;
//     for (var i = 1; i < points.length; ++i) {
//         var diff = points[i][dim] - last;
//         if (!isNaN(diff) && !isNaN(lastDiff)
//             && diff !== 0 && lastDiff !== 0
//             && ((diff >= 0) !== (lastDiff >= 0))
//         ) {
//             return false;
//         }
//         if (!isNaN(diff) && diff !== 0) {
//             lastDiff = diff;
//             last = points[i][dim];
//         }
//     }
//     return true;
// }
/**
 * Draw smoothed line in monotone, in which only vertical or horizontal bezier
 * control points will be used. This should be used when points are monotone
 * either in x or y dimension.
 */function drawMono(ctx,points,start,segLen,allLen,dir,smoothMin,smoothMax,smooth,smoothMonotone,connectNulls){var prevIdx=0;var idx=start;for(var k=0;k<segLen;k++){var p=points[idx];if(idx>=allLen||idx<0){break;}if(isPointNull(p)){if(connectNulls){idx+=dir;continue;}break;}if(idx===start){ctx[dir>0?'moveTo':'lineTo'](p[0],p[1]);}else{if(smooth>0){var prevP=points[prevIdx];var dim=smoothMonotone==='y'?1:0;// Length of control point to p, either in x or y, but not both
var ctrlLen=(p[dim]-prevP[dim])*smooth;v2Copy(cp0,prevP);cp0[dim]=prevP[dim]+ctrlLen;v2Copy(cp1,p);cp1[dim]=p[dim]-ctrlLen;ctx.bezierCurveTo(cp0[0],cp0[1],cp1[0],cp1[1],p[0],p[1]);}else{ctx.lineTo(p[0],p[1]);}}prevIdx=idx;idx+=dir;}return k;}/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */function drawNonMono(ctx,points,start,segLen,allLen,dir,smoothMin,smoothMax,smooth,smoothMonotone,connectNulls){var prevIdx=0;var idx=start;for(var k=0;k<segLen;k++){var p=points[idx];if(idx>=allLen||idx<0){break;}if(isPointNull(p)){if(connectNulls){idx+=dir;continue;}break;}if(idx===start){ctx[dir>0?'moveTo':'lineTo'](p[0],p[1]);v2Copy(cp0,p);}else{if(smooth>0){var nextIdx=idx+dir;var nextP=points[nextIdx];if(connectNulls){// Find next point not null
while(nextP&&isPointNull(points[nextIdx])){nextIdx+=dir;nextP=points[nextIdx];}}var ratioNextSeg=0.5;var prevP=points[prevIdx];var nextP=points[nextIdx];// Last point
if(!nextP||isPointNull(nextP)){v2Copy(cp1,p);}else{// If next data is null in not connect case
if(isPointNull(nextP)&&!connectNulls){nextP=p;}sub(v,nextP,prevP);var lenPrevSeg;var lenNextSeg;if(smoothMonotone==='x'||smoothMonotone==='y'){var dim=smoothMonotone==='x'?0:1;lenPrevSeg=Math.abs(p[dim]-prevP[dim]);lenNextSeg=Math.abs(p[dim]-nextP[dim]);}else{lenPrevSeg=dist(p,prevP);lenNextSeg=dist(p,nextP);}// Use ratio of seg length
ratioNextSeg=lenNextSeg/(lenNextSeg+lenPrevSeg);scaleAndAdd$1(cp1,p,v,-smooth*(1-ratioNextSeg));}// Smooth constraint
vec2Min(cp0,cp0,smoothMax);vec2Max(cp0,cp0,smoothMin);vec2Min(cp1,cp1,smoothMax);vec2Max(cp1,cp1,smoothMin);ctx.bezierCurveTo(cp0[0],cp0[1],cp1[0],cp1[1],p[0],p[1]);// cp0 of next segment
scaleAndAdd$1(cp0,p,v,smooth*ratioNextSeg);}else{ctx.lineTo(p[0],p[1]);}}prevIdx=idx;idx+=dir;}return k;}function getBoundingBox(points,smoothConstraint){var ptMin=[Infinity,Infinity];var ptMax=[-Infinity,-Infinity];if(smoothConstraint){for(var i=0;i<points.length;i++){var pt=points[i];if(pt[0]<ptMin[0]){ptMin[0]=pt[0];}if(pt[1]<ptMin[1]){ptMin[1]=pt[1];}if(pt[0]>ptMax[0]){ptMax[0]=pt[0];}if(pt[1]>ptMax[1]){ptMax[1]=pt[1];}}}return{min:smoothConstraint?ptMin:ptMax,max:smoothConstraint?ptMax:ptMin};}var Polyline$1=Path.extend({type:'ec-polyline',shape:{points:[],smooth:0,smoothConstraint:true,smoothMonotone:null,connectNulls:false},style:{fill:null,stroke:'#000'},brush:fixClipWithShadow(Path.prototype.brush),buildPath:function buildPath(ctx,shape){var points=shape.points;var i=0;var len$$1=points.length;var result=getBoundingBox(points,shape.smoothConstraint);if(shape.connectNulls){// Must remove first and last null values avoid draw error in polygon
for(;len$$1>0;len$$1--){if(!isPointNull(points[len$$1-1])){break;}}for(;i<len$$1;i++){if(!isPointNull(points[i])){break;}}}while(i<len$$1){i+=drawSegment(ctx,points,i,len$$1,len$$1,1,result.min,result.max,shape.smooth,shape.smoothMonotone,shape.connectNulls)+1;}}});var Polygon$1=Path.extend({type:'ec-polygon',shape:{points:[],// Offset between stacked base points and points
stackedOnPoints:[],smooth:0,stackedOnSmooth:0,smoothConstraint:true,smoothMonotone:null,connectNulls:false},brush:fixClipWithShadow(Path.prototype.brush),buildPath:function buildPath(ctx,shape){var points=shape.points;var stackedOnPoints=shape.stackedOnPoints;var i=0;var len$$1=points.length;var smoothMonotone=shape.smoothMonotone;var bbox=getBoundingBox(points,shape.smoothConstraint);var stackedOnBBox=getBoundingBox(stackedOnPoints,shape.smoothConstraint);if(shape.connectNulls){// Must remove first and last null values avoid draw error in polygon
for(;len$$1>0;len$$1--){if(!isPointNull(points[len$$1-1])){break;}}for(;i<len$$1;i++){if(!isPointNull(points[i])){break;}}}while(i<len$$1){var k=drawSegment(ctx,points,i,len$$1,len$$1,1,bbox.min,bbox.max,shape.smooth,smoothMonotone,shape.connectNulls);drawSegment(ctx,stackedOnPoints,i+k-1,k,len$$1,-1,stackedOnBBox.min,stackedOnBBox.max,shape.stackedOnSmooth,smoothMonotone,shape.connectNulls);i+=k+1;ctx.closePath();}}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// FIXME step not support polar
function isPointsSame(points1,points2){if(points1.length!==points2.length){return;}for(var i=0;i<points1.length;i++){var p1=points1[i];var p2=points2[i];if(p1[0]!==p2[0]||p1[1]!==p2[1]){return;}}return true;}function getSmooth(smooth){return typeof smooth==='number'?smooth:smooth?0.5:0;}function getAxisExtentWithGap(axis){var extent=axis.getGlobalExtent();if(axis.onBand){// Remove extra 1px to avoid line miter in clipped edge
var halfBandWidth=axis.getBandWidth()/2-1;var dir=extent[1]>extent[0]?1:-1;extent[0]+=dir*halfBandWidth;extent[1]-=dir*halfBandWidth;}return extent;}/**
 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
 * @param {module:echarts/data/List} data
 * @param {Object} dataCoordInfo
 * @param {Array.<Array.<number>>} points
 */function getStackedOnPoints(coordSys,data,dataCoordInfo){if(!dataCoordInfo.valueDim){return[];}var points=[];for(var idx=0,len=data.count();idx<len;idx++){points.push(getStackedOnPoint(dataCoordInfo,coordSys,data,idx));}return points;}function createGridClipShape(cartesian,hasAnimation,forSymbol,seriesModel){var xExtent=getAxisExtentWithGap(cartesian.getAxis('x'));var yExtent=getAxisExtentWithGap(cartesian.getAxis('y'));var isHorizontal=cartesian.getBaseAxis().isHorizontal();var x=Math.min(xExtent[0],xExtent[1]);var y=Math.min(yExtent[0],yExtent[1]);var width=Math.max(xExtent[0],xExtent[1])-x;var height=Math.max(yExtent[0],yExtent[1])-y;// Avoid float number rounding error for symbol on the edge of axis extent.
// See #7913 and `test/dataZoom-clip.html`.
if(forSymbol){x-=0.5;width+=0.5;y-=0.5;height+=0.5;}else{var lineWidth=seriesModel.get('lineStyle.width')||2;// Expand clip shape to avoid clipping when line value exceeds axis
var expandSize=seriesModel.get('clipOverflow')?lineWidth/2:Math.max(width,height);if(isHorizontal){y-=expandSize;height+=expandSize*2;}else{x-=expandSize;width+=expandSize*2;}}var clipPath=new Rect({shape:{x:x,y:y,width:width,height:height}});if(hasAnimation){clipPath.shape[isHorizontal?'width':'height']=0;initProps(clipPath,{shape:{width:width,height:height}},seriesModel);}return clipPath;}function createPolarClipShape(polar,hasAnimation,forSymbol,seriesModel){var angleAxis=polar.getAngleAxis();var radiusAxis=polar.getRadiusAxis();var radiusExtent=radiusAxis.getExtent().slice();radiusExtent[0]>radiusExtent[1]&&radiusExtent.reverse();var angleExtent=angleAxis.getExtent();var RADIAN=Math.PI/180;// Avoid float number rounding error for symbol on the edge of axis extent.
if(forSymbol){radiusExtent[0]-=0.5;radiusExtent[1]+=0.5;}var clipPath=new Sector({shape:{cx:round$1(polar.cx,1),cy:round$1(polar.cy,1),r0:round$1(radiusExtent[0],1),r:round$1(radiusExtent[1],1),startAngle:-angleExtent[0]*RADIAN,endAngle:-angleExtent[1]*RADIAN,clockwise:angleAxis.inverse}});if(hasAnimation){clipPath.shape.endAngle=-angleExtent[0]*RADIAN;initProps(clipPath,{shape:{endAngle:-angleExtent[1]*RADIAN}},seriesModel);}return clipPath;}function createClipShape(coordSys,hasAnimation,forSymbol,seriesModel){return coordSys.type==='polar'?createPolarClipShape(coordSys,hasAnimation,forSymbol,seriesModel):createGridClipShape(coordSys,hasAnimation,forSymbol,seriesModel);}function turnPointsIntoStep(points,coordSys,stepTurnAt){var baseAxis=coordSys.getBaseAxis();var baseIndex=baseAxis.dim==='x'||baseAxis.dim==='radius'?0:1;var stepPoints=[];for(var i=0;i<points.length-1;i++){var nextPt=points[i+1];var pt=points[i];stepPoints.push(pt);var stepPt=[];switch(stepTurnAt){case'end':stepPt[baseIndex]=nextPt[baseIndex];stepPt[1-baseIndex]=pt[1-baseIndex];// default is start
stepPoints.push(stepPt);break;case'middle':// default is start
var middle=(pt[baseIndex]+nextPt[baseIndex])/2;var stepPt2=[];stepPt[baseIndex]=stepPt2[baseIndex]=middle;stepPt[1-baseIndex]=pt[1-baseIndex];stepPt2[1-baseIndex]=nextPt[1-baseIndex];stepPoints.push(stepPt);stepPoints.push(stepPt2);break;default:stepPt[baseIndex]=pt[baseIndex];stepPt[1-baseIndex]=nextPt[1-baseIndex];// default is start
stepPoints.push(stepPt);}}// Last points
points[i]&&stepPoints.push(points[i]);return stepPoints;}function getVisualGradient(data,coordSys){var visualMetaList=data.getVisual('visualMeta');if(!visualMetaList||!visualMetaList.length||!data.count()){// When data.count() is 0, gradient range can not be calculated.
return;}if(coordSys.type!=='cartesian2d'){return;}var coordDim;var visualMeta;for(var i=visualMetaList.length-1;i>=0;i--){var dimIndex=visualMetaList[i].dimension;var dimName=data.dimensions[dimIndex];var dimInfo=data.getDimensionInfo(dimName);coordDim=dimInfo&&dimInfo.coordDim;// Can only be x or y
if(coordDim==='x'||coordDim==='y'){visualMeta=visualMetaList[i];break;}}if(!visualMeta){return;}// If the area to be rendered is bigger than area defined by LinearGradient,
// the canvas spec prescribes that the color of the first stop and the last
// stop should be used. But if two stops are added at offset 0, in effect
// browsers use the color of the second stop to render area outside
// LinearGradient. So we can only infinitesimally extend area defined in
// LinearGradient to render `outerColors`.
var axis=coordSys.getAxis(coordDim);// dataToCoor mapping may not be linear, but must be monotonic.
var colorStops=map(visualMeta.stops,function(stop){return{coord:axis.toGlobalCoord(axis.dataToCoord(stop.value)),color:stop.color};});var stopLen=colorStops.length;var outerColors=visualMeta.outerColors.slice();if(stopLen&&colorStops[0].coord>colorStops[stopLen-1].coord){colorStops.reverse();outerColors.reverse();}var tinyExtent=10;// Arbitrary value: 10px
var minCoord=colorStops[0].coord-tinyExtent;var maxCoord=colorStops[stopLen-1].coord+tinyExtent;var coordSpan=maxCoord-minCoord;if(coordSpan<1e-3){return'transparent';}each$1(colorStops,function(stop){stop.offset=(stop.coord-minCoord)/coordSpan;});colorStops.push({offset:stopLen?colorStops[stopLen-1].offset:0.5,color:outerColors[1]||'transparent'});colorStops.unshift({// notice colorStops.length have been changed.
offset:stopLen?colorStops[0].offset:0.5,color:outerColors[0]||'transparent'});// zrUtil.each(colorStops, function (colorStop) {
//     // Make sure each offset has rounded px to avoid not sharp edge
//     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
// });
var gradient=new LinearGradient(0,0,0,0,colorStops,true);gradient[coordDim]=minCoord;gradient[coordDim+'2']=maxCoord;return gradient;}function getIsIgnoreFunc(seriesModel,data,coordSys){var showAllSymbol=seriesModel.get('showAllSymbol');var isAuto=showAllSymbol==='auto';if(showAllSymbol&&!isAuto){return;}var categoryAxis=coordSys.getAxesByScale('ordinal')[0];if(!categoryAxis){return;}// Note that category label interval strategy might bring some weird effect
// in some scenario: users may wonder why some of the symbols are not
// displayed. So we show all symbols as possible as we can.
if(isAuto// Simplify the logic, do not determine label overlap here.
&&canShowAllSymbolForCategory(categoryAxis,data)){return;}// Otherwise follow the label interval strategy on category axis.
var categoryDataDim=data.mapDimension(categoryAxis.dim);var labelMap={};each$1(categoryAxis.getViewLabels(),function(labelItem){labelMap[labelItem.tickValue]=1;});return function(dataIndex){return!labelMap.hasOwnProperty(data.get(categoryDataDim,dataIndex));};}function canShowAllSymbolForCategory(categoryAxis,data){// In mose cases, line is monotonous on category axis, and the label size
// is close with each other. So we check the symbol size and some of the
// label size alone with the category axis to estimate whether all symbol
// can be shown without overlap.
var axisExtent=categoryAxis.getExtent();var availSize=Math.abs(axisExtent[1]-axisExtent[0])/categoryAxis.scale.count();isNaN(availSize)&&(availSize=0);// 0/0 is NaN.
// Sampling some points, max 5.
var dataLen=data.count();var step=Math.max(1,Math.round(dataLen/5));for(var dataIndex=0;dataIndex<dataLen;dataIndex+=step){if(SymbolClz$1.getSymbolSize(data,dataIndex// Only for cartesian, where `isHorizontal` exists.
)[categoryAxis.isHorizontal()?1:0]// Empirical number
*1.5>availSize){return false;}}return true;}Chart.extend({type:'line',init:function init(){var lineGroup=new Group();var symbolDraw=new SymbolDraw();this.group.add(symbolDraw.group);this._symbolDraw=symbolDraw;this._lineGroup=lineGroup;},render:function render(seriesModel,ecModel,api){var coordSys=seriesModel.coordinateSystem;var group=this.group;var data=seriesModel.getData();var lineStyleModel=seriesModel.getModel('lineStyle');var areaStyleModel=seriesModel.getModel('areaStyle');var points=data.mapArray(data.getItemLayout);var isCoordSysPolar=coordSys.type==='polar';var prevCoordSys=this._coordSys;var symbolDraw=this._symbolDraw;var polyline=this._polyline;var polygon=this._polygon;var lineGroup=this._lineGroup;var hasAnimation=seriesModel.get('animation');var isAreaChart=!areaStyleModel.isEmpty();var valueOrigin=areaStyleModel.get('origin');var dataCoordInfo=prepareDataCoordInfo(coordSys,data,valueOrigin);var stackedOnPoints=getStackedOnPoints(coordSys,data,dataCoordInfo);var showSymbol=seriesModel.get('showSymbol');var isIgnoreFunc=showSymbol&&!isCoordSysPolar&&getIsIgnoreFunc(seriesModel,data,coordSys);// Remove temporary symbols
var oldData=this._data;oldData&&oldData.eachItemGraphicEl(function(el,idx){if(el.__temp){group.remove(el);oldData.setItemGraphicEl(idx,null);}});// Remove previous created symbols if showSymbol changed to false
if(!showSymbol){symbolDraw.remove();}group.add(lineGroup);// FIXME step not support polar
var step=!isCoordSysPolar&&seriesModel.get('step');// Initialization animation or coordinate system changed
if(!(polyline&&prevCoordSys.type===coordSys.type&&step===this._step)){showSymbol&&symbolDraw.updateData(data,{isIgnore:isIgnoreFunc,clipShape:createClipShape(coordSys,false,true,seriesModel)});if(step){// TODO If stacked series is not step
points=turnPointsIntoStep(points,coordSys,step);stackedOnPoints=turnPointsIntoStep(stackedOnPoints,coordSys,step);}polyline=this._newPolyline(points,coordSys,hasAnimation);if(isAreaChart){polygon=this._newPolygon(points,stackedOnPoints,coordSys,hasAnimation);}lineGroup.setClipPath(createClipShape(coordSys,true,false,seriesModel));}else{if(isAreaChart&&!polygon){// If areaStyle is added
polygon=this._newPolygon(points,stackedOnPoints,coordSys,hasAnimation);}else if(polygon&&!isAreaChart){// If areaStyle is removed
lineGroup.remove(polygon);polygon=this._polygon=null;}// Update clipPath
lineGroup.setClipPath(createClipShape(coordSys,false,false,seriesModel));// Always update, or it is wrong in the case turning on legend
// because points are not changed
showSymbol&&symbolDraw.updateData(data,{isIgnore:isIgnoreFunc,clipShape:createClipShape(coordSys,false,true,seriesModel)});// Stop symbol animation and sync with line points
// FIXME performance?
data.eachItemGraphicEl(function(el){el.stopAnimation(true);});// In the case data zoom triggerred refreshing frequently
// Data may not change if line has a category axis. So it should animate nothing
if(!isPointsSame(this._stackedOnPoints,stackedOnPoints)||!isPointsSame(this._points,points)){if(hasAnimation){this._updateAnimation(data,stackedOnPoints,coordSys,api,step,valueOrigin);}else{// Not do it in update with animation
if(step){// TODO If stacked series is not step
points=turnPointsIntoStep(points,coordSys,step);stackedOnPoints=turnPointsIntoStep(stackedOnPoints,coordSys,step);}polyline.setShape({points:points});polygon&&polygon.setShape({points:points,stackedOnPoints:stackedOnPoints});}}}var visualColor=getVisualGradient(data,coordSys)||data.getVisual('color');polyline.useStyle(defaults(// Use color in lineStyle first
lineStyleModel.getLineStyle(),{fill:'none',stroke:visualColor,lineJoin:'bevel'}));var smooth=seriesModel.get('smooth');smooth=getSmooth(seriesModel.get('smooth'));polyline.setShape({smooth:smooth,smoothMonotone:seriesModel.get('smoothMonotone'),connectNulls:seriesModel.get('connectNulls')});if(polygon){var stackedOnSeries=data.getCalculationInfo('stackedOnSeries');var stackedOnSmooth=0;polygon.useStyle(defaults(areaStyleModel.getAreaStyle(),{fill:visualColor,opacity:0.7,lineJoin:'bevel'}));if(stackedOnSeries){stackedOnSmooth=getSmooth(stackedOnSeries.get('smooth'));}polygon.setShape({smooth:smooth,stackedOnSmooth:stackedOnSmooth,smoothMonotone:seriesModel.get('smoothMonotone'),connectNulls:seriesModel.get('connectNulls')});}this._data=data;// Save the coordinate system for transition animation when data changed
this._coordSys=coordSys;this._stackedOnPoints=stackedOnPoints;this._points=points;this._step=step;this._valueOrigin=valueOrigin;},dispose:function dispose(){},highlight:function highlight(seriesModel,ecModel,api,payload){var data=seriesModel.getData();var dataIndex=queryDataIndex(data,payload);if(!(dataIndex instanceof Array)&&dataIndex!=null&&dataIndex>=0){var symbol=data.getItemGraphicEl(dataIndex);if(!symbol){// Create a temporary symbol if it is not exists
var pt=data.getItemLayout(dataIndex);if(!pt){// Null data
return;}symbol=new SymbolClz$1(data,dataIndex);symbol.position=pt;symbol.setZ(seriesModel.get('zlevel'),seriesModel.get('z'));symbol.ignore=isNaN(pt[0])||isNaN(pt[1]);symbol.__temp=true;data.setItemGraphicEl(dataIndex,symbol);// Stop scale animation
symbol.stopSymbolAnimation(true);this.group.add(symbol);}symbol.highlight();}else{// Highlight whole series
Chart.prototype.highlight.call(this,seriesModel,ecModel,api,payload);}},downplay:function downplay(seriesModel,ecModel,api,payload){var data=seriesModel.getData();var dataIndex=queryDataIndex(data,payload);if(dataIndex!=null&&dataIndex>=0){var symbol=data.getItemGraphicEl(dataIndex);if(symbol){if(symbol.__temp){data.setItemGraphicEl(dataIndex,null);this.group.remove(symbol);}else{symbol.downplay();}}}else{// FIXME
// can not downplay completely.
// Downplay whole series
Chart.prototype.downplay.call(this,seriesModel,ecModel,api,payload);}},/**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} points
   * @private
   */_newPolyline:function _newPolyline(points){var polyline=this._polyline;// Remove previous created polyline
if(polyline){this._lineGroup.remove(polyline);}polyline=new Polyline$1({shape:{points:points},silent:true,z2:10});this._lineGroup.add(polyline);this._polyline=polyline;return polyline;},/**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} stackedOnPoints
   * @param {Array.<Array.<number>>} points
   * @private
   */_newPolygon:function _newPolygon(points,stackedOnPoints){var polygon=this._polygon;// Remove previous created polygon
if(polygon){this._lineGroup.remove(polygon);}polygon=new Polygon$1({shape:{points:points,stackedOnPoints:stackedOnPoints},silent:true});this._lineGroup.add(polygon);this._polygon=polygon;return polygon;},/**
   * @private
   */// FIXME Two value axis
_updateAnimation:function _updateAnimation(data,stackedOnPoints,coordSys,api,step,valueOrigin){var polyline=this._polyline;var polygon=this._polygon;var seriesModel=data.hostModel;var diff=lineAnimationDiff(this._data,data,this._stackedOnPoints,stackedOnPoints,this._coordSys,coordSys,this._valueOrigin,valueOrigin);var current=diff.current;var stackedOnCurrent=diff.stackedOnCurrent;var next=diff.next;var stackedOnNext=diff.stackedOnNext;if(step){// TODO If stacked series is not step
current=turnPointsIntoStep(diff.current,coordSys,step);stackedOnCurrent=turnPointsIntoStep(diff.stackedOnCurrent,coordSys,step);next=turnPointsIntoStep(diff.next,coordSys,step);stackedOnNext=turnPointsIntoStep(diff.stackedOnNext,coordSys,step);}// `diff.current` is subset of `current` (which should be ensured by
// turnPointsIntoStep), so points in `__points` can be updated when
// points in `current` are update during animation.
polyline.shape.__points=diff.current;polyline.shape.points=current;updateProps(polyline,{shape:{points:next}},seriesModel);if(polygon){polygon.setShape({points:current,stackedOnPoints:stackedOnCurrent});updateProps(polygon,{shape:{points:next,stackedOnPoints:stackedOnNext}},seriesModel);}var updatedDataInfo=[];var diffStatus=diff.status;for(var i=0;i<diffStatus.length;i++){var cmd=diffStatus[i].cmd;if(cmd==='='){var el=data.getItemGraphicEl(diffStatus[i].idx1);if(el){updatedDataInfo.push({el:el,ptIdx:i// Index of points
});}}}if(polyline.animators&&polyline.animators.length){polyline.animators[0].during(function(){for(var i=0;i<updatedDataInfo.length;i++){var el=updatedDataInfo[i].el;el.attr('position',polyline.shape.__points[updatedDataInfo[i].ptIdx]);}});}},remove:function remove(ecModel){var group=this.group;var oldData=this._data;this._lineGroup.removeAll();this._symbolDraw.remove(true);// Remove temporary created elements when highlighting
oldData&&oldData.eachItemGraphicEl(function(el,idx){if(el.__temp){group.remove(el);oldData.setItemGraphicEl(idx,null);}});this._polyline=this._polygon=this._coordSys=this._points=this._stackedOnPoints=this._data=null;}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var visualSymbol=function visualSymbol(seriesType,defaultSymbolType,legendSymbol){// Encoding visual for all series include which is filtered for legend drawing
return{seriesType:seriesType,// For legend.
performRawSeries:true,reset:function reset(seriesModel,ecModel,api){var data=seriesModel.getData();var symbolType=seriesModel.get('symbol')||defaultSymbolType;var symbolSize=seriesModel.get('symbolSize');var keepAspect=seriesModel.get('symbolKeepAspect');data.setVisual({legendSymbol:legendSymbol||symbolType,symbol:symbolType,symbolSize:symbolSize,symbolKeepAspect:keepAspect});// Only visible series has each data be visual encoded
if(ecModel.isSeriesFiltered(seriesModel)){return;}var hasCallback=typeof symbolSize==='function';function dataEach(data,idx){if(typeof symbolSize==='function'){var rawValue=seriesModel.getRawValue(idx);// FIXME
var params=seriesModel.getDataParams(idx);data.setItemVisual(idx,'symbolSize',symbolSize(rawValue,params));}if(data.hasItemOption){var itemModel=data.getItemModel(idx);var itemSymbolType=itemModel.getShallow('symbol',true);var itemSymbolSize=itemModel.getShallow('symbolSize',true);var itemSymbolKeepAspect=itemModel.getShallow('symbolKeepAspect',true);// If has item symbol
if(itemSymbolType!=null){data.setItemVisual(idx,'symbol',itemSymbolType);}if(itemSymbolSize!=null){// PENDING Transform symbolSize ?
data.setItemVisual(idx,'symbolSize',itemSymbolSize);}if(itemSymbolKeepAspect!=null){data.setItemVisual(idx,'symbolKeepAspect',itemSymbolKeepAspect);}}}return{dataEach:data.hasItemOption||hasCallback?dataEach:null};}};};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var layoutPoints=function layoutPoints(seriesType){return{seriesType:seriesType,plan:createRenderPlanner(),reset:function reset(seriesModel){var data=seriesModel.getData();var coordSys=seriesModel.coordinateSystem;var pipelineContext=seriesModel.pipelineContext;var isLargeRender=pipelineContext.large;if(!coordSys){return;}var dims=map(coordSys.dimensions,function(dim){return data.mapDimension(dim);}).slice(0,2);var dimLen=dims.length;var stackResultDim=data.getCalculationInfo('stackResultDimension');if(isDimensionStacked(data,dims[0]/*, dims[1]*/)){dims[0]=stackResultDim;}if(isDimensionStacked(data,dims[1]/*, dims[0]*/)){dims[1]=stackResultDim;}function progress(params,data){var segCount=params.end-params.start;var points=isLargeRender&&new Float32Array(segCount*dimLen);for(var i=params.start,offset=0,tmpIn=[],tmpOut=[];i<params.end;i++){var point;if(dimLen===1){var x=data.get(dims[0],i);point=!isNaN(x)&&coordSys.dataToPoint(x,null,tmpOut);}else{var x=tmpIn[0]=data.get(dims[0],i);var y=tmpIn[1]=data.get(dims[1],i);// Also {Array.<number>}, not undefined to avoid if...else... statement
point=!isNaN(x)&&!isNaN(y)&&coordSys.dataToPoint(tmpIn,null,tmpOut);}if(isLargeRender){points[offset++]=point?point[0]:NaN;points[offset++]=point?point[1]:NaN;}else{data.setItemLayout(i,point&&point.slice()||[NaN,NaN]);}}isLargeRender&&data.setLayout('symbolPoints',points);}return dimLen&&{progress:progress};}};};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var samplers={average:function average(frame){var sum=0;var count=0;for(var i=0;i<frame.length;i++){if(!isNaN(frame[i])){sum+=frame[i];count++;}}// Return NaN if count is 0
return count===0?NaN:sum/count;},sum:function sum(frame){var sum=0;for(var i=0;i<frame.length;i++){// Ignore NaN
sum+=frame[i]||0;}return sum;},max:function max(frame){var max=-Infinity;for(var i=0;i<frame.length;i++){frame[i]>max&&(max=frame[i]);}// NaN will cause illegal axis extent.
return isFinite(max)?max:NaN;},min:function min(frame){var min=Infinity;for(var i=0;i<frame.length;i++){frame[i]<min&&(min=frame[i]);}// NaN will cause illegal axis extent.
return isFinite(min)?min:NaN;},// TODO
// Median
nearest:function nearest(frame){return frame[0];}};var indexSampler=function indexSampler(frame,value){return Math.round(frame.length/2);};var dataSample=function dataSample(seriesType){return{seriesType:seriesType,modifyOutputEnd:true,reset:function reset(seriesModel,ecModel,api){var data=seriesModel.getData();var sampling=seriesModel.get('sampling');var coordSys=seriesModel.coordinateSystem;// Only cartesian2d support down sampling
if(coordSys.type==='cartesian2d'&&sampling){var baseAxis=coordSys.getBaseAxis();var valueAxis=coordSys.getOtherAxis(baseAxis);var extent=baseAxis.getExtent();// Coordinste system has been resized
var size=extent[1]-extent[0];var rate=Math.round(data.count()/size);if(rate>1){var sampler;if(typeof sampling==='string'){sampler=samplers[sampling];}else if(typeof sampling==='function'){sampler=sampling;}if(sampler){// Only support sample the first dim mapped from value axis.
seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim),1/rate,sampler,indexSampler));}}}}};};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/registerVisual(visualSymbol('line','circle','line'));registerLayout(layoutPoints('line'));// Down sample after filter
registerProcessor(PRIORITY.PROCESSOR.STATISTIC,dataSample('line'));/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * [Usage]:
 * (1)
 * createListSimply(seriesModel, ['value']);
 * (2)
 * createListSimply(seriesModel, {
 *     coordDimensions: ['value'],
 *     dimensionsCount: 5
 * });
 *
 * @param {module:echarts/model/Series} seriesModel
 * @param {Object|Array.<string|Object>} opt opt or coordDimensions
 *        The options in opt, see `echarts/data/helper/createDimensions`
 * @param {Array.<string>} [nameList]
 * @return {module:echarts/data/List}
 */var createListSimply=function createListSimply(seriesModel,opt,nameList){opt=isArray(opt)&&{coordDimensions:opt}||extend({},opt);var source=seriesModel.getSource();var dimensionsInfo=createDimensions(source,opt);var list=new List(dimensionsInfo,seriesModel);list.initData(source,nameList);return list;};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var seriesModelMixin={/**
   * @private
   * @type {string}
   */_baseAxisDim:null,/**
   * @override
   */getInitialData:function getInitialData(option,ecModel){// When both types of xAxis and yAxis are 'value', layout is
// needed to be specified by user. Otherwise, layout can be
// judged by which axis is category.
var ordinalMeta;var xAxisModel=ecModel.getComponent('xAxis',this.get('xAxisIndex'));var yAxisModel=ecModel.getComponent('yAxis',this.get('yAxisIndex'));var xAxisType=xAxisModel.get('type');var yAxisType=yAxisModel.get('type');var addOrdinal;// FIXME
// 考虑时间轴
if(xAxisType==='category'){option.layout='horizontal';ordinalMeta=xAxisModel.getOrdinalMeta();addOrdinal=true;}else if(yAxisType==='category'){option.layout='vertical';ordinalMeta=yAxisModel.getOrdinalMeta();addOrdinal=true;}else{option.layout=option.layout||'horizontal';}var coordDims=['x','y'];var baseAxisDimIndex=option.layout==='horizontal'?0:1;var baseAxisDim=this._baseAxisDim=coordDims[baseAxisDimIndex];var otherAxisDim=coordDims[1-baseAxisDimIndex];var axisModels=[xAxisModel,yAxisModel];var baseAxisType=axisModels[baseAxisDimIndex].get('type');var otherAxisType=axisModels[1-baseAxisDimIndex].get('type');var data=option.data;// ??? FIXME make a stage to perform data transfrom.
// MUST create a new data, consider setOption({}) again.
if(data&&addOrdinal){var newOptionData=[];each$1(data,function(item,index){var newItem;if(item.value&&isArray(item.value)){newItem=item.value.slice();item.value.unshift(index);}else if(isArray(item)){newItem=item.slice();item.unshift(index);}else{newItem=item;}newOptionData.push(newItem);});option.data=newOptionData;}var defaultValueDimensions=this.defaultValueDimensions;return createListSimply(this,{coordDimensions:[{name:baseAxisDim,type:getDimensionTypeByAxis(baseAxisType),ordinalMeta:ordinalMeta,otherDims:{tooltip:false,itemName:0},dimsDef:['base']},{name:otherAxisDim,type:getDimensionTypeByAxis(otherAxisType),dimsDef:defaultValueDimensions.slice()}],dimensionsCount:defaultValueDimensions.length+1});},/**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */getBaseAxis:function getBaseAxis(){var dim=this._baseAxisDim;return this.ecModel.getComponent(dim+'Axis',this.get(dim+'AxisIndex')).axis;}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var CandlestickSeries=SeriesModel.extend({type:'series.candlestick',dependencies:['xAxis','yAxis','grid'],/**
   * @readOnly
   */defaultValueDimensions:[{name:'open',defaultTooltip:true},{name:'close',defaultTooltip:true},{name:'lowest',defaultTooltip:true},{name:'highest',defaultTooltip:true}],/**
   * @type {Array.<string>}
   * @readOnly
   */dimensions:null,/**
   * @override
   */defaultOption:{zlevel:0,z:2,coordinateSystem:'cartesian2d',legendHoverLink:true,hoverAnimation:true,// xAxisIndex: 0,
// yAxisIndex: 0,
layout:null,// 'horizontal' or 'vertical'
itemStyle:{color:'#c23531',// 阳线 positive
color0:'#314656',// 阴线 negative     '#c23531', '#314656'
color1:'#fff',borderWidth:1,// FIXME
// ec2中使用的是lineStyle.color 和 lineStyle.color0
borderColor:'#c23531',borderColor0:'#314656'},emphasis:{itemStyle:{borderWidth:2}},barMaxWidth:null,barMinWidth:null,barWidth:null,large:true,largeThreshold:600,progressive:3e3,progressiveThreshold:1e4,progressiveChunkMode:'mod',animationUpdate:false,animationEasing:'linear',animationDuration:300},/**
   * Get dimension for shadow in dataZoom
   * @return {string} dimension name
   */getShadowDim:function getShadowDim(){return'open';},brushSelector:function brushSelector(dataIndex,data,selectors){var itemLayout=data.getItemLayout(dataIndex);return itemLayout&&selectors.rect(itemLayout.brushRect);}});mixin(CandlestickSeries,seriesModelMixin,true);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var NORMAL_ITEM_STYLE_PATH=['itemStyle'];var EMPHASIS_ITEM_STYLE_PATH=['emphasis','itemStyle'];var SKIP_PROPS=['color','color0','color1','borderColor','borderColor0'];var CandlestickView=Chart.extend({type:'candlestick',render:function render(seriesModel,ecModel,api){this._updateDrawMode(seriesModel);this._isLargeDraw?this._renderLarge(seriesModel):this._renderNormal(seriesModel);},incrementalPrepareRender:function incrementalPrepareRender(seriesModel,ecModel,api){this._clear();this._updateDrawMode(seriesModel);},incrementalRender:function incrementalRender(params,seriesModel,ecModel,api){this._isLargeDraw?this._incrementalRenderLarge(params,seriesModel):this._incrementalRenderNormal(params,seriesModel);},_updateDrawMode:function _updateDrawMode(seriesModel){var isLargeDraw=seriesModel.pipelineContext.large;if(this._isLargeDraw==null||isLargeDraw^this._isLargeDraw){this._isLargeDraw=isLargeDraw;this._clear();}},_renderNormal:function _renderNormal(seriesModel){var data=seriesModel.getData();var oldData=this._data;var group=this.group;var isSimpleBox=data.getLayout('isSimpleBox');// There is no old data only when first rendering or switching from
// stream mode to normal mode, where previous elements should be removed.
if(!this._data){group.removeAll();}data.diff(oldData).add(function(newIdx){if(data.hasValue(newIdx)){var el;var itemLayout=data.getItemLayout(newIdx);el=createNormalBox(itemLayout,newIdx,true);initProps(el,{shape:{points:itemLayout.ends}},seriesModel,newIdx);setBoxCommon(el,data,newIdx,isSimpleBox);group.add(el);data.setItemGraphicEl(newIdx,el);}}).update(function(newIdx,oldIdx){var el=oldData.getItemGraphicEl(oldIdx);// Empty data
if(!data.hasValue(newIdx)){group.remove(el);return;}var itemLayout=data.getItemLayout(newIdx);if(!el){el=createNormalBox(itemLayout,newIdx);}else{updateProps(el,{shape:{points:itemLayout.ends}},seriesModel,newIdx);}setBoxCommon(el,data,newIdx,isSimpleBox);group.add(el);data.setItemGraphicEl(newIdx,el);}).remove(function(oldIdx){var el=oldData.getItemGraphicEl(oldIdx);el&&group.remove(el);}).execute();this._data=data;},_renderLarge:function _renderLarge(seriesModel){this._clear();createLarge$1(seriesModel,this.group);},_incrementalRenderNormal:function _incrementalRenderNormal(params,seriesModel){var data=seriesModel.getData();var isSimpleBox=data.getLayout('isSimpleBox');var dataIndex;while((dataIndex=params.next())!=null){var el;var itemLayout=data.getItemLayout(dataIndex);el=createNormalBox(itemLayout,dataIndex);setBoxCommon(el,data,dataIndex,isSimpleBox);el.incremental=true;this.group.add(el);}},_incrementalRenderLarge:function _incrementalRenderLarge(params,seriesModel){createLarge$1(seriesModel,this.group,true);},remove:function remove(ecModel){this._clear();},_clear:function _clear(){this.group.removeAll();this._data=null;},dispose:noop});var NormalBoxPath=Path.extend({type:'normalCandlestickBox',shape:{},buildPath:function buildPath(ctx,shape){var ends=shape.points;if(this.__simpleBox){ctx.moveTo(ends[4][0],ends[4][1]);ctx.lineTo(ends[6][0],ends[6][1]);}else{ctx.moveTo(ends[0][0],ends[0][1]);ctx.lineTo(ends[1][0],ends[1][1]);ctx.lineTo(ends[2][0],ends[2][1]);ctx.lineTo(ends[3][0],ends[3][1]);ctx.closePath();ctx.moveTo(ends[4][0],ends[4][1]);ctx.lineTo(ends[5][0],ends[5][1]);ctx.moveTo(ends[6][0],ends[6][1]);ctx.lineTo(ends[7][0],ends[7][1]);}}});function createNormalBox(itemLayout,dataIndex,isInit){var ends=itemLayout.ends;return new NormalBoxPath({shape:{points:isInit?transInit(ends,itemLayout):ends},z2:100});}function setBoxCommon(el,data,dataIndex,isSimpleBox){var itemModel=data.getItemModel(dataIndex);var normalItemStyleModel=itemModel.getModel(NORMAL_ITEM_STYLE_PATH);var color=data.getItemVisual(dataIndex,'color');var borderColor=data.getItemVisual(dataIndex,'borderColor')||color;// Color must be excluded.
// Because symbol provide setColor individually to set fill and stroke
var itemStyle=normalItemStyleModel.getItemStyle(SKIP_PROPS);el.useStyle(itemStyle);el.style.strokeNoScale=true;el.style.fill=color;el.style.stroke=borderColor;el.__simpleBox=isSimpleBox;var hoverStyle=itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();setHoverStyle(el,hoverStyle);}function transInit(points,itemLayout){return map(points,function(point){point=point.slice();point[1]=itemLayout.initBaseline;return point;});}var LargeBoxPath=Path.extend({type:'largeCandlestickBox',shape:{},buildPath:function buildPath(ctx,shape){// Drawing lines is more efficient than drawing
// a whole line or drawing rects.
var points=shape.points;for(var i=0;i<points.length;){if(this.__sign===points[i++]){var x=points[i++];ctx.moveTo(x,points[i++]);ctx.lineTo(x,points[i++]);}else{i+=3;}}}});function createLarge$1(seriesModel,group,incremental){var data=seriesModel.getData();var largePoints=data.getLayout('largePoints');var elP=new LargeBoxPath({shape:{points:largePoints},__sign:1});group.add(elP);var elN=new LargeBoxPath({shape:{points:largePoints},__sign:-1});group.add(elN);setLargeStyle$1(1,elP,seriesModel,data);setLargeStyle$1(-1,elN,seriesModel,data);if(incremental){elP.incremental=true;elN.incremental=true;}}function setLargeStyle$1(sign,el,seriesModel,data){var suffix=sign>0?'P':'N';var borderColor=data.getVisual('borderColor'+suffix)||data.getVisual('color'+suffix);// Color must be excluded.
// Because symbol provide setColor individually to set fill and stroke
var itemStyle=seriesModel.getModel(NORMAL_ITEM_STYLE_PATH).getItemStyle(SKIP_PROPS);el.useStyle(itemStyle);el.style.fill=null;el.style.stroke=borderColor;// No different
// el.style.lineWidth = .5;
}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var preprocessor=function preprocessor(option){if(!option||!isArray(option.series)){return;}// Translate 'k' to 'candlestick'.
each$1(option.series,function(seriesItem){if(isObject$1(seriesItem)&&seriesItem.type==='k'){seriesItem.type='candlestick';}});};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var positiveBorderColorQuery=['itemStyle','borderColor'];var negativeBorderColorQuery=['itemStyle','borderColor0'];var positiveColorQuery=['itemStyle','color'];var negativeColorQuery=['itemStyle','color0'];var zeroColorQuery=['itemStyle','color1'];var candlestickVisual={seriesType:'candlestick',plan:createRenderPlanner(),// For legend.
performRawSeries:true,reset:function reset(seriesModel,ecModel){var data=seriesModel.getData();var isLargeRender=seriesModel.pipelineContext.large;data.setVisual({legendSymbol:'roundRect',colorP:getColor(1,seriesModel),colorN:getColor(-1,seriesModel),borderColorP:getBorderColor(1,seriesModel),borderColorN:getBorderColor(-1,seriesModel)});// Only visible series has each data be visual encoded
if(ecModel.isSeriesFiltered(seriesModel)){return;}return!isLargeRender&&{progress:progress};function progress(params,data){var dataIndex;while((dataIndex=params.next())!=null){var itemModel=data.getItemModel(dataIndex);var sign=data.getItemLayout(dataIndex).sign;data.setItemVisual(dataIndex,{color:getColor(sign,itemModel),borderColor:getBorderColor(sign,itemModel)});}}function getColor(sign,model){if(sign>0){return model.get(positiveColorQuery);}else if(sign<0){return model.get(negativeColorQuery);}else if(sign==0){return model.get(zeroColorQuery);};// return model.get(sign > 0 ? positiveColorQuery : negativeColorQuery);
}function getBorderColor(sign,model){return model.get(sign>0?positiveBorderColorQuery:negativeBorderColorQuery);}}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var LargeArr$1=typeof Float32Array!=='undefined'?Float32Array:Array;var candlestickLayout={seriesType:'candlestick',plan:createRenderPlanner(),reset:function reset(seriesModel){var coordSys=seriesModel.coordinateSystem;var data=seriesModel.getData();var candleWidth=calculateCandleWidth(seriesModel,data);var cDimIdx=0;var vDimIdx=1;var coordDims=['x','y'];var cDim=data.mapDimension(coordDims[cDimIdx]);var vDims=data.mapDimension(coordDims[vDimIdx],true);var openDim=vDims[0];var closeDim=vDims[1];var lowestDim=vDims[2];var highestDim=vDims[3];data.setLayout({candleWidth:candleWidth,// The value is experimented visually.
isSimpleBox:candleWidth<=1.3});if(cDim==null||vDims.length<4){return;}return{progress:seriesModel.pipelineContext.large?largeProgress:normalProgress};function normalProgress(params,data){var dataIndex;while((dataIndex=params.next())!=null){var axisDimVal=data.get(cDim,dataIndex);var openVal=data.get(openDim,dataIndex);var closeVal=data.get(closeDim,dataIndex);var lowestVal=data.get(lowestDim,dataIndex);var highestVal=data.get(highestDim,dataIndex);var ocLow=Math.min(openVal,closeVal);var ocHigh=Math.max(openVal,closeVal);var ocLowPoint=getPoint(ocLow,axisDimVal);var ocHighPoint=getPoint(ocHigh,axisDimVal);var lowestPoint=getPoint(lowestVal,axisDimVal);var highestPoint=getPoint(highestVal,axisDimVal);var ends=[];addBodyEnd(ends,ocHighPoint,0);addBodyEnd(ends,ocLowPoint,1);ends.push(subPixelOptimizePoint(highestPoint),subPixelOptimizePoint(ocHighPoint),subPixelOptimizePoint(lowestPoint),subPixelOptimizePoint(ocLowPoint));data.setItemLayout(dataIndex,{sign:getSign(data,dataIndex,openVal,closeVal,closeDim),initBaseline:openVal>closeVal?ocHighPoint[vDimIdx]:ocLowPoint[vDimIdx],// open point.
ends:ends,brushRect:makeBrushRect(lowestVal,highestVal,axisDimVal)});}function getPoint(val,axisDimVal){var p=[];p[cDimIdx]=axisDimVal;p[vDimIdx]=val;return isNaN(axisDimVal)||isNaN(val)?[NaN,NaN]:coordSys.dataToPoint(p);}function addBodyEnd(ends,point,start){var point1=point.slice();var point2=point.slice();point1[cDimIdx]=subPixelOptimize(point1[cDimIdx]+candleWidth/2,1,false);point2[cDimIdx]=subPixelOptimize(point2[cDimIdx]-candleWidth/2,1,true);start?ends.push(point1,point2):ends.push(point2,point1);}function makeBrushRect(lowestVal,highestVal,axisDimVal){var pmin=getPoint(lowestVal,axisDimVal);var pmax=getPoint(highestVal,axisDimVal);pmin[cDimIdx]-=candleWidth/2;pmax[cDimIdx]-=candleWidth/2;return{x:pmin[0],y:pmin[1],width:vDimIdx?candleWidth:pmax[0]-pmin[0],height:vDimIdx?pmax[1]-pmin[1]:candleWidth};}function subPixelOptimizePoint(point){point[cDimIdx]=subPixelOptimize(point[cDimIdx],1);return point;}}function largeProgress(params,data){// Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
var points=new LargeArr$1(params.count*5);var offset=0;var point;var tmpIn=[];var tmpOut=[];var dataIndex;while((dataIndex=params.next())!=null){var axisDimVal=data.get(cDim,dataIndex);var openVal=data.get(openDim,dataIndex);var closeVal=data.get(closeDim,dataIndex);var lowestVal=data.get(lowestDim,dataIndex);var highestVal=data.get(highestDim,dataIndex);if(isNaN(axisDimVal)||isNaN(lowestVal)||isNaN(highestVal)){points[offset++]=NaN;offset+=4;continue;}points[offset++]=getSign(data,dataIndex,openVal,closeVal,closeDim);tmpIn[cDimIdx]=axisDimVal;tmpIn[vDimIdx]=lowestVal;point=coordSys.dataToPoint(tmpIn,null,tmpOut);points[offset++]=point?point[0]:NaN;points[offset++]=point?point[1]:NaN;tmpIn[vDimIdx]=highestVal;point=coordSys.dataToPoint(tmpIn,null,tmpOut);points[offset++]=point?point[1]:NaN;}data.setLayout('largePoints',points);}}};function getSign(data,dataIndex,openVal,closeVal,closeDim){var sign;if(openVal>closeVal){sign=-1;}else if(openVal<closeVal){sign=1;}else if(openVal==closeVal){sign=0;}else{sign=dataIndex>0// If close === open, compare with close of last record
?data.get(closeDim,dataIndex-1)<=closeVal?1:-1:// No record of previous, set to be positive
1;}// if (openVal > closeVal) {
//   sign = -1;
// } else if (openVal < closeVal) {
//   sign = 1;
// } else {
//   sign = dataIndex > 0 // If close === open, compare with close of last record
//   ? data.get(closeDim, dataIndex - 1) <= closeVal ? 1 : -1 : // No record of previous, set to be positive
//   1;
// }
return sign;}function calculateCandleWidth(seriesModel,data){var baseAxis=seriesModel.getBaseAxis();var extent;var bandWidth=baseAxis.type==='category'?baseAxis.getBandWidth():(extent=baseAxis.getExtent(),Math.abs(extent[1]-extent[0])/data.count());var barMaxWidth=parsePercent$1(retrieve2(seriesModel.get('barMaxWidth'),bandWidth),bandWidth);var barMinWidth=parsePercent$1(retrieve2(seriesModel.get('barMinWidth'),1),bandWidth);var barWidth=seriesModel.get('barWidth');return barWidth!=null?parsePercent$1(barWidth,bandWidth)// Put max outer to ensure bar visible in spite of overlap.
:Math.max(Math.min(bandWidth/2,barMaxWidth),barMinWidth);}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/registerPreprocessor(preprocessor);registerVisual(candlestickVisual);registerLayout(candlestickLayout);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/extendComponentModel({type:'title',layoutMode:{type:'box',ignoreSize:true},defaultOption:{// 一级层叠
zlevel:0,// 二级层叠
z:6,show:true,text:'',// 超链接跳转
// link: null,
// 仅支持self | blank
target:'blank',subtext:'',// 超链接跳转
// sublink: null,
// 仅支持self | blank
subtarget:'blank',// 'center' ¦ 'left' ¦ 'right'
// ¦ {number}（x坐标，单位px）
left:0,// 'top' ¦ 'bottom' ¦ 'center'
// ¦ {number}（y坐标，单位px）
top:0,// 水平对齐
// 'auto' | 'left' | 'right' | 'center'
// 默认根据 left 的位置判断是左对齐还是右对齐
// textAlign: null
//
// 垂直对齐
// 'auto' | 'top' | 'bottom' | 'middle'
// 默认根据 top 位置判断是上对齐还是下对齐
// textBaseline: null
backgroundColor:'rgba(0,0,0,0)',// 标题边框颜色
borderColor:'#ccc',// 标题边框线宽，单位px，默认为0（无边框）
borderWidth:0,// 标题内边距，单位px，默认各方向内边距为5，
// 接受数组分别设定上右下左边距，同css
padding:5,// 主副标题纵向间隔，单位px，默认为10，
itemGap:10,textStyle:{fontSize:18,fontWeight:'bolder',color:'#333'},subtextStyle:{color:'#aaa'}}});// View
extendComponentView({type:'title',render:function render(titleModel,ecModel,api){this.group.removeAll();if(!titleModel.get('show')){return;}var group=this.group;var textStyleModel=titleModel.getModel('textStyle');var subtextStyleModel=titleModel.getModel('subtextStyle');var textAlign=titleModel.get('textAlign');var textBaseline=titleModel.get('textBaseline');var textEl=new Text({style:setTextStyle({},textStyleModel,{text:titleModel.get('text'),textFill:textStyleModel.getTextColor()},{disableBox:true}),z2:10});var textRect=textEl.getBoundingRect();var subText=titleModel.get('subtext');var subTextEl=new Text({style:setTextStyle({},subtextStyleModel,{text:subText,textFill:subtextStyleModel.getTextColor(),y:textRect.height+titleModel.get('itemGap'),textVerticalAlign:'top'},{disableBox:true}),z2:10});var link=titleModel.get('link');var sublink=titleModel.get('sublink');textEl.silent=!link;subTextEl.silent=!sublink;if(link){textEl.on('click',function(){window.open(link,'_'+titleModel.get('target'));});}if(sublink){subTextEl.on('click',function(){window.open(sublink,'_'+titleModel.get('subtarget'));});}group.add(textEl);subText&&group.add(subTextEl);// If no subText, but add subTextEl, there will be an empty line.
var groupRect=group.getBoundingRect();var layoutOption=titleModel.getBoxLayoutParams();layoutOption.width=groupRect.width;layoutOption.height=groupRect.height;var layoutRect=getLayoutRect(layoutOption,{width:api.getWidth(),height:api.getHeight()},titleModel.get('padding'));// Adjust text align based on position
if(!textAlign){// Align left if title is on the left. center and right is same
textAlign=titleModel.get('left')||titleModel.get('right');if(textAlign==='middle'){textAlign='center';}// Adjust layout by text align
if(textAlign==='right'){layoutRect.x+=layoutRect.width;}else if(textAlign==='center'){layoutRect.x+=layoutRect.width/2;}}if(!textBaseline){textBaseline=titleModel.get('top')||titleModel.get('bottom');if(textBaseline==='center'){textBaseline='middle';}if(textBaseline==='bottom'){layoutRect.y+=layoutRect.height;}else if(textBaseline==='middle'){layoutRect.y+=layoutRect.height/2;}textBaseline=textBaseline||'top';}group.attr('position',[layoutRect.x,layoutRect.y]);var alignStyle={textAlign:textAlign,textVerticalAlign:textBaseline};textEl.setStyle(alignStyle);subTextEl.setStyle(alignStyle);// Render background
// Get groupRect again because textAlign has been changed
groupRect=group.getBoundingRect();var padding=layoutRect.margin;var style=titleModel.getItemStyle(['color','opacity']);style.fill=titleModel.get('backgroundColor');var rect=new Rect({shape:{x:groupRect.x-padding[3],y:groupRect.y-padding[0],width:groupRect.width+padding[1]+padding[3],height:groupRect.height+padding[0]+padding[2],r:titleModel.get('borderRadius')},style:style,silent:true});subPixelOptimizeRect(rect);group.add(rect);}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var LegendModel=extendComponentModel({type:'legend.plain',dependencies:['series'],layoutMode:{type:'box',// legend.width/height are maxWidth/maxHeight actually,
// whereas realy width/height is calculated by its content.
// (Setting {left: 10, right: 10} does not make sense).
// So consider the case:
// `setOption({legend: {left: 10});`
// then `setOption({legend: {right: 10});`
// The previous `left` should be cleared by setting `ignoreSize`.
ignoreSize:true},init:function init(option,parentModel,ecModel){this.mergeDefaultAndTheme(option,ecModel);option.selected=option.selected||{};},mergeOption:function mergeOption(option){LegendModel.superCall(this,'mergeOption',option);},optionUpdated:function optionUpdated(){this._updateData(this.ecModel);var legendData=this._data;// If selectedMode is single, try to select one
if(legendData[0]&&this.get('selectedMode')==='single'){var hasSelected=false;// If has any selected in option.selected
for(var i=0;i<legendData.length;i++){var name=legendData[i].get('name');if(this.isSelected(name)){// Force to unselect others
this.select(name);hasSelected=true;break;}}// Try select the first if selectedMode is single
!hasSelected&&this.select(legendData[0].get('name'));}},_updateData:function _updateData(ecModel){var potentialData=[];var availableNames=[];ecModel.eachRawSeries(function(seriesModel){var seriesName=seriesModel.name;availableNames.push(seriesName);var isPotential;if(seriesModel.legendDataProvider){var data=seriesModel.legendDataProvider();var names=data.mapArray(data.getName);if(!ecModel.isSeriesFiltered(seriesModel)){availableNames=availableNames.concat(names);}if(names.length){potentialData=potentialData.concat(names);}else{isPotential=true;}}else{isPotential=true;}if(isPotential&&isNameSpecified(seriesModel)){potentialData.push(seriesModel.name);}});/**
     * @type {Array.<string>}
     * @private
     */this._availableNames=availableNames;// If legend.data not specified in option, use availableNames as data,
// which is convinient for user preparing option.
var rawData=this.get('data')||potentialData;var legendData=map(rawData,function(dataItem){// Can be string or number
if(typeof dataItem==='string'||typeof dataItem==='number'){dataItem={name:dataItem};}return new Model(dataItem,this,this.ecModel);},this);/**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */this._data=legendData;},/**
   * @return {Array.<module:echarts/model/Model>}
   */getData:function getData(){return this._data;},/**
   * @param {string} name
   */select:function select(name){var selected=this.option.selected;var selectedMode=this.get('selectedMode');if(selectedMode==='single'){var data=this._data;each$1(data,function(dataItem){selected[dataItem.get('name')]=false;});}selected[name]=true;},/**
   * @param {string} name
   */unSelect:function unSelect(name){if(this.get('selectedMode')!=='single'){this.option.selected[name]=false;}},/**
   * @param {string} name
   */toggleSelected:function toggleSelected(name){var selected=this.option.selected;// Default is true
if(!selected.hasOwnProperty(name)){selected[name]=true;}this[selected[name]?'unSelect':'select'](name);},/**
   * @param {string} name
   */isSelected:function isSelected(name){var selected=this.option.selected;return!(selected.hasOwnProperty(name)&&!selected[name])&&indexOf(this._availableNames,name)>=0;},defaultOption:{// 一级层叠
zlevel:0,// 二级层叠
z:4,show:true,// 布局方式，默认为水平布局，可选为：
// 'horizontal' | 'vertical'
orient:'horizontal',left:'center',// right: 'center',
top:0,// bottom: null,
// 水平对齐
// 'auto' | 'left' | 'right'
// 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
align:'auto',backgroundColor:'rgba(0,0,0,0)',// 图例边框颜色
borderColor:'#ccc',borderRadius:0,// 图例边框线宽，单位px，默认为0（无边框）
borderWidth:0,// 图例内边距，单位px，默认各方向内边距为5，
// 接受数组分别设定上右下左边距，同css
padding:5,// 各个item之间的间隔，单位px，默认为10，
// 横向布局时为水平间隔，纵向布局时为纵向间隔
itemGap:10,// 图例图形宽度
itemWidth:25,// 图例图形高度
itemHeight:14,// 图例关闭时候的颜色
inactiveColor:'#ccc',textStyle:{// 图例文字颜色
color:'#333'},// formatter: '',
// 选择模式，默认开启图例开关
selectedMode:true,// 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
// selected: null,
// 图例内容（详见legend.data，数组中每一项代表一个item
// data: [],
// Tooltip 相关配置
tooltip:{show:false}}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/function legendSelectActionHandler(methodName,payload,ecModel){var selectedMap={};var isToggleSelect=methodName==='toggleSelected';var isSelected;// Update all legend components
ecModel.eachComponent('legend',function(legendModel){if(isToggleSelect&&isSelected!=null){// Force other legend has same selected status
// Or the first is toggled to true and other are toggled to false
// In the case one legend has some item unSelected in option. And if other legend
// doesn't has the item, they will assume it is selected.
legendModel[isSelected?'select':'unSelect'](payload.name);}else{legendModel[methodName](payload.name);isSelected=legendModel.isSelected(payload.name);}var legendData=legendModel.getData();each$1(legendData,function(model){var name=model.get('name');// Wrap element
if(name==='\n'||name===''){return;}var isItemSelected=legendModel.isSelected(name);if(selectedMap.hasOwnProperty(name)){// Unselected if any legend is unselected
selectedMap[name]=selectedMap[name]&&isItemSelected;}else{selectedMap[name]=isItemSelected;}});});// Return the event explicitly
return{name:payload.name,selected:selectedMap};}/**
 * @event legendToggleSelect
 * @type {Object}
 * @property {string} type 'legendToggleSelect'
 * @property {string} [from]
 * @property {string} name Series name or data item name
 */registerAction('legendToggleSelect','legendselectchanged',curry(legendSelectActionHandler,'toggleSelected'));/**
 * @event legendSelect
 * @type {Object}
 * @property {string} type 'legendSelect'
 * @property {string} name Series name or data item name
 */registerAction('legendSelect','legendselected',curry(legendSelectActionHandler,'select'));/**
 * @event legendUnSelect
 * @type {Object}
 * @property {string} type 'legendUnSelect'
 * @property {string} name Series name or data item name
 */registerAction('legendUnSelect','legendunselected',curry(legendSelectActionHandler,'unSelect'));/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Layout list like component.
 * It will box layout each items in group of component and then position the whole group in the viewport
 * @param {module:zrender/group/Group} group
 * @param {module:echarts/model/Component} componentModel
 * @param {module:echarts/ExtensionAPI}
 */function makeBackground(rect,componentModel){var padding=normalizeCssArray$1(componentModel.get('padding'));var style=componentModel.getItemStyle(['color','opacity']);style.fill=componentModel.get('backgroundColor');var rect=new Rect({shape:{x:rect.x-padding[3],y:rect.y-padding[0],width:rect.width+padding[1]+padding[3],height:rect.height+padding[0]+padding[2],r:componentModel.get('borderRadius')},style:style,silent:true,z2:-1});// FIXME
// `subPixelOptimizeRect` may bring some gap between edge of viewpart
// and background rect when setting like `left: 0`, `top: 0`.
// graphic.subPixelOptimizeRect(rect);
return rect;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var curry$2=curry;var each$7=each$1;var Group$2=Group;var LegendView=extendComponentView({type:'legend.plain',newlineDisabled:false,/**
   * @override
   */init:function init(){/**
     * @private
     * @type {module:zrender/container/Group}
     */this.group.add(this._contentGroup=new Group$2());/**
     * @private
     * @type {module:zrender/Element}
     */this._backgroundEl;},/**
   * @protected
   */getContentGroup:function getContentGroup(){return this._contentGroup;},/**
   * @override
   */render:function render(legendModel,ecModel,api){this.resetInner();if(!legendModel.get('show',true)){return;}var itemAlign=legendModel.get('align');if(!itemAlign||itemAlign==='auto'){itemAlign=legendModel.get('left')==='right'&&legendModel.get('orient')==='vertical'?'right':'left';}this.renderInner(itemAlign,legendModel,ecModel,api);// Perform layout.
var positionInfo=legendModel.getBoxLayoutParams();var viewportSize={width:api.getWidth(),height:api.getHeight()};var padding=legendModel.get('padding');var maxSize=getLayoutRect(positionInfo,viewportSize,padding);var mainRect=this.layoutInner(legendModel,itemAlign,maxSize);// Place mainGroup, based on the calculated `mainRect`.
var layoutRect=getLayoutRect(defaults({width:mainRect.width,height:mainRect.height},positionInfo),viewportSize,padding);this.group.attr('position',[layoutRect.x-mainRect.x,layoutRect.y-mainRect.y]);// Render background after group is layout.
this.group.add(this._backgroundEl=makeBackground(mainRect,legendModel));},/**
   * @protected
   */resetInner:function resetInner(){this.getContentGroup().removeAll();this._backgroundEl&&this.group.remove(this._backgroundEl);},/**
   * @protected
   */renderInner:function renderInner(itemAlign,legendModel,ecModel,api){var contentGroup=this.getContentGroup();var legendDrawnMap=createHashMap();var selectMode=legendModel.get('selectedMode');var excludeSeriesId=[];ecModel.eachRawSeries(function(seriesModel){!seriesModel.get('legendHoverLink')&&excludeSeriesId.push(seriesModel.id);});each$7(legendModel.getData(),function(itemModel,dataIndex){var name=itemModel.get('name');// Use empty string or \n as a newline string
if(!this.newlineDisabled&&(name===''||name==='\n')){contentGroup.add(new Group$2({newline:true}));return;}// Representitive series.
var seriesModel=ecModel.getSeriesByName(name)[0];if(legendDrawnMap.get(name)){// Have been drawed
return;}// Series legend
if(seriesModel){var data=seriesModel.getData();var color=data.getVisual('color');// If color is a callback function
if(typeof color==='function'){// Use the first data
color=color(seriesModel.getDataParams(0));}// Using rect symbol defaultly
var legendSymbolType=data.getVisual('legendSymbol')||'roundRect';var symbolType=data.getVisual('symbol');var itemGroup=this._createItem(name,dataIndex,itemModel,legendModel,legendSymbolType,symbolType,itemAlign,color,selectMode);itemGroup.on('click',curry$2(dispatchSelectAction,name,api)).on('mouseover',curry$2(dispatchHighlightAction,seriesModel,null,api,excludeSeriesId)).on('mouseout',curry$2(dispatchDownplayAction,seriesModel,null,api,excludeSeriesId));legendDrawnMap.set(name,true);}else{// Data legend of pie, funnel
ecModel.eachRawSeries(function(seriesModel){// In case multiple series has same data name
if(legendDrawnMap.get(name)){return;}if(seriesModel.legendDataProvider){var data=seriesModel.legendDataProvider();var idx=data.indexOfName(name);if(idx<0){return;}var color=data.getItemVisual(idx,'color');var legendSymbolType='roundRect';var itemGroup=this._createItem(name,dataIndex,itemModel,legendModel,legendSymbolType,null,itemAlign,color,selectMode);// FIXME: consider different series has items with the same name.
itemGroup.on('click',curry$2(dispatchSelectAction,name,api))// FIXME Should not specify the series name
.on('mouseover',curry$2(dispatchHighlightAction,seriesModel,name,api,excludeSeriesId)).on('mouseout',curry$2(dispatchDownplayAction,seriesModel,name,api,excludeSeriesId));legendDrawnMap.set(name,true);}},this);}},this);},_createItem:function _createItem(name,dataIndex,itemModel,legendModel,legendSymbolType,symbolType,itemAlign,color,selectMode){var itemWidth=legendModel.get('itemWidth');var itemHeight=legendModel.get('itemHeight');var inactiveColor=legendModel.get('inactiveColor');var symbolKeepAspect=legendModel.get('symbolKeepAspect');var isSelected=legendModel.isSelected(name);var itemGroup=new Group$2();var textStyleModel=itemModel.getModel('textStyle');var itemIcon=itemModel.get('icon');var tooltipModel=itemModel.getModel('tooltip');var legendGlobalTooltipModel=tooltipModel.parentModel;// Use user given icon first
legendSymbolType=itemIcon||legendSymbolType;itemGroup.add(createSymbol(legendSymbolType,0,0,itemWidth,itemHeight,isSelected?color:inactiveColor,// symbolKeepAspect default true for legend
symbolKeepAspect==null?true:symbolKeepAspect));// Compose symbols
// PENDING
if(!itemIcon&&symbolType// At least show one symbol, can't be all none
&&(symbolType!==legendSymbolType||symbolType=='none')){var size=itemHeight*0.8;if(symbolType==='none'){symbolType='circle';}// Put symbol in the center
itemGroup.add(createSymbol(symbolType,(itemWidth-size)/2,(itemHeight-size)/2,size,size,isSelected?color:inactiveColor,// symbolKeepAspect default true for legend
symbolKeepAspect==null?true:symbolKeepAspect));}var textX=itemAlign==='left'?itemWidth+5:-5;var textAlign=itemAlign;var formatter=legendModel.get('formatter');var content=name;if(typeof formatter==='string'&&formatter){content=formatter.replace('{name}',name!=null?name:'');}else if(typeof formatter==='function'){content=formatter(name);}itemGroup.add(new Text({style:setTextStyle({},textStyleModel,{text:content,x:textX,y:itemHeight/2,textFill:isSelected?textStyleModel.getTextColor():inactiveColor,textAlign:textAlign,textVerticalAlign:'middle'})}));// Add a invisible rect to increase the area of mouse hover
var hitRect=new Rect({shape:itemGroup.getBoundingRect(),invisible:true,tooltip:tooltipModel.get('show')?extend({content:name,// Defaul formatter
formatter:legendGlobalTooltipModel.get('formatter',true)||function(){return name;},formatterParams:{componentType:'legend',legendIndex:legendModel.componentIndex,name:name,$vars:['name']}},tooltipModel.option):null});itemGroup.add(hitRect);itemGroup.eachChild(function(child){child.silent=true;});hitRect.silent=!selectMode;this.getContentGroup().add(itemGroup);setHoverStyle(itemGroup);itemGroup.__legendDataIndex=dataIndex;return itemGroup;},/**
   * @protected
   */layoutInner:function layoutInner(legendModel,itemAlign,maxSize){var contentGroup=this.getContentGroup();// Place items in contentGroup.
box(legendModel.get('orient'),contentGroup,legendModel.get('itemGap'),maxSize.width,maxSize.height);var contentRect=contentGroup.getBoundingRect();contentGroup.attr('position',[-contentRect.x,-contentRect.y]);return this.group.getBoundingRect();}});function dispatchSelectAction(name,api){api.dispatchAction({type:'legendToggleSelect',name:name});}function dispatchHighlightAction(seriesModel,dataName,api,excludeSeriesId){// If element hover will move to a hoverLayer.
var el=api.getZr().storage.getDisplayList()[0];if(!(el&&el.useHoverLayer)){api.dispatchAction({type:'highlight',seriesName:seriesModel.name,name:dataName,excludeSeriesId:excludeSeriesId});}}function dispatchDownplayAction(seriesModel,dataName,api,excludeSeriesId){// If element hover will move to a hoverLayer.
var el=api.getZr().storage.getDisplayList()[0];if(!(el&&el.useHoverLayer)){api.dispatchAction({type:'downplay',seriesName:seriesModel.name,name:dataName,excludeSeriesId:excludeSeriesId});}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var legendFilter=function legendFilter(ecModel){var legendModels=ecModel.findComponents({mainType:'legend'});if(legendModels&&legendModels.length){ecModel.filterSeries(function(series){// If in any legend component the status is not selected.
// Because in legend series is assumed selected when it is not in the legend data.
for(var i=0;i<legendModels.length;i++){if(!legendModels[i].isSelected(series.name)){return false;}}return true;});}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// Do not contain scrollable legend, for sake of file size.
registerProcessor(legendFilter);ComponentModel.registerSubTypeDefaulter('legend',function(){// Default 'plain' when no type specified.
return'plain';});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var ScrollableLegendModel=LegendModel.extend({type:'legend.scroll',/**
   * @param {number} scrollDataIndex
   */setScrollDataIndex:function setScrollDataIndex(scrollDataIndex){this.option.scrollDataIndex=scrollDataIndex;},defaultOption:{scrollDataIndex:0,pageButtonItemGap:5,pageButtonGap:null,pageButtonPosition:'end',// 'start' or 'end'
pageFormatter:'{current}/{total}',// If null/undefined, do not show page.
pageIcons:{horizontal:['M0,0L12,-10L12,10z','M0,0L-12,-10L-12,10z'],vertical:['M0,0L20,0L10,-20z','M0,0L20,0L10,20z']},pageIconColor:'#2f4554',pageIconInactiveColor:'#aaa',pageIconSize:15,// Can be [10, 3], which represents [width, height]
pageTextStyle:{color:'#333'},animationDurationUpdate:800},/**
   * @override
   */init:function init(option,parentModel,ecModel,extraOpt){var inputPositionParams=getLayoutParams(option);ScrollableLegendModel.superCall(this,'init',option,parentModel,ecModel,extraOpt);mergeAndNormalizeLayoutParams(this,option,inputPositionParams);},/**
   * @override
   */mergeOption:function mergeOption(option,extraOpt){ScrollableLegendModel.superCall(this,'mergeOption',option,extraOpt);mergeAndNormalizeLayoutParams(this,this.option,option);},getOrient:function getOrient(){return this.get('orient')==='vertical'?{index:1,name:'vertical'}:{index:0,name:'horizontal'};}});// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function mergeAndNormalizeLayoutParams(legendModel,target,raw){var orient=legendModel.getOrient();var ignoreSize=[1,1];ignoreSize[orient.index]=0;mergeLayoutParam(target,raw,{type:'box',ignoreSize:ignoreSize});}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Separate legend and scrollable legend to reduce package size.
 */var Group$3=Group;var WH=['width','height'];var XY=['x','y'];var ScrollableLegendView=LegendView.extend({type:'legend.scroll',newlineDisabled:true,init:function init(){ScrollableLegendView.superCall(this,'init');/**
     * @private
     * @type {number} For `scroll`.
     */this._currentIndex=0;/**
     * @private
     * @type {module:zrender/container/Group}
     */this.group.add(this._containerGroup=new Group$3());this._containerGroup.add(this.getContentGroup());/**
     * @private
     * @type {module:zrender/container/Group}
     */this.group.add(this._controllerGroup=new Group$3());/**
     *
     * @private
     */this._showController;},/**
   * @override
   */resetInner:function resetInner(){ScrollableLegendView.superCall(this,'resetInner');this._controllerGroup.removeAll();this._containerGroup.removeClipPath();this._containerGroup.__rectSize=null;},/**
   * @override
   */renderInner:function renderInner(itemAlign,legendModel,ecModel,api){var me=this;// Render content items.
ScrollableLegendView.superCall(this,'renderInner',itemAlign,legendModel,ecModel,api);var controllerGroup=this._controllerGroup;var pageIconSize=legendModel.get('pageIconSize',true);if(!isArray(pageIconSize)){pageIconSize=[pageIconSize,pageIconSize];}createPageButton('pagePrev',0);var pageTextStyleModel=legendModel.getModel('pageTextStyle');controllerGroup.add(new Text({name:'pageText',style:{textFill:pageTextStyleModel.getTextColor(),font:pageTextStyleModel.getFont(),textVerticalAlign:'middle',textAlign:'center'},silent:true}));createPageButton('pageNext',1);function createPageButton(name,iconIdx){var pageDataIndexName=name+'DataIndex';var icon=createIcon(legendModel.get('pageIcons',true)[legendModel.getOrient().name][iconIdx],{// Buttons will be created in each render, so we do not need
// to worry about avoiding using legendModel kept in scope.
onclick:bind(me._pageGo,me,pageDataIndexName,legendModel,api)},{x:-pageIconSize[0]/2,y:-pageIconSize[1]/2,width:pageIconSize[0],height:pageIconSize[1]});icon.name=name;controllerGroup.add(icon);}},/**
   * @override
   */layoutInner:function layoutInner(legendModel,itemAlign,maxSize){var contentGroup=this.getContentGroup();var containerGroup=this._containerGroup;var controllerGroup=this._controllerGroup;var orientIdx=legendModel.getOrient().index;var wh=WH[orientIdx];var hw=WH[1-orientIdx];var yx=XY[1-orientIdx];// Place items in contentGroup.
box(legendModel.get('orient'),contentGroup,legendModel.get('itemGap'),!orientIdx?null:maxSize.width,orientIdx?null:maxSize.height);box(// Buttons in controller are layout always horizontally.
'horizontal',controllerGroup,legendModel.get('pageButtonItemGap',true));var contentRect=contentGroup.getBoundingRect();var controllerRect=controllerGroup.getBoundingRect();var showController=this._showController=contentRect[wh]>maxSize[wh];var contentPos=[-contentRect.x,-contentRect.y];// Remain contentPos when scroll animation perfroming.
contentPos[orientIdx]=contentGroup.position[orientIdx];// Layout container group based on 0.
var containerPos=[0,0];var controllerPos=[-controllerRect.x,-controllerRect.y];var pageButtonGap=retrieve2(legendModel.get('pageButtonGap',true),legendModel.get('itemGap',true));// Place containerGroup and controllerGroup and contentGroup.
if(showController){var pageButtonPosition=legendModel.get('pageButtonPosition',true);// controller is on the right / bottom.
if(pageButtonPosition==='end'){controllerPos[orientIdx]+=maxSize[wh]-controllerRect[wh];}// controller is on the left / top.
else{containerPos[orientIdx]+=controllerRect[wh]+pageButtonGap;}}// Always align controller to content as 'middle'.
controllerPos[1-orientIdx]+=contentRect[hw]/2-controllerRect[hw]/2;contentGroup.attr('position',contentPos);containerGroup.attr('position',containerPos);controllerGroup.attr('position',controllerPos);// Calculate `mainRect` and set `clipPath`.
// mainRect should not be calculated by `this.group.getBoundingRect()`
// for sake of the overflow.
var mainRect=this.group.getBoundingRect();var mainRect={x:0,y:0};// Consider content may be overflow (should be clipped).
mainRect[wh]=showController?maxSize[wh]:contentRect[wh];mainRect[hw]=Math.max(contentRect[hw],controllerRect[hw]);// `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
mainRect[yx]=Math.min(0,controllerRect[yx]+controllerPos[1-orientIdx]);containerGroup.__rectSize=maxSize[wh];if(showController){var clipShape={x:0,y:0};clipShape[wh]=Math.max(maxSize[wh]-controllerRect[wh]-pageButtonGap,0);clipShape[hw]=mainRect[hw];containerGroup.setClipPath(new Rect({shape:clipShape}));// Consider content may be larger than container, container rect
// can not be obtained from `containerGroup.getBoundingRect()`.
containerGroup.__rectSize=clipShape[wh];}else{// Do not remove or ignore controller. Keep them set as place holders.
controllerGroup.eachChild(function(child){child.attr({invisible:true,silent:true});});}// Content translate animation.
var pageInfo=this._getPageInfo(legendModel);pageInfo.pageIndex!=null&&updateProps(contentGroup,{position:pageInfo.contentPosition},// When switch from "show controller" to "not show controller", view should be
// updated immediately without animation, otherwise causes weird efffect.
showController?legendModel:false);this._updatePageInfoView(legendModel,pageInfo);return mainRect;},_pageGo:function _pageGo(to,legendModel,api){var scrollDataIndex=this._getPageInfo(legendModel)[to];scrollDataIndex!=null&&api.dispatchAction({type:'legendScroll',scrollDataIndex:scrollDataIndex,legendId:legendModel.id});},_updatePageInfoView:function _updatePageInfoView(legendModel,pageInfo){var controllerGroup=this._controllerGroup;each$1(['pagePrev','pageNext'],function(name){var canJump=pageInfo[name+'DataIndex']!=null;var icon=controllerGroup.childOfName(name);if(icon){icon.setStyle('fill',canJump?legendModel.get('pageIconColor',true):legendModel.get('pageIconInactiveColor',true));icon.cursor=canJump?'pointer':'default';}});var pageText=controllerGroup.childOfName('pageText');var pageFormatter=legendModel.get('pageFormatter');var pageIndex=pageInfo.pageIndex;var current=pageIndex!=null?pageIndex+1:0;var total=pageInfo.pageCount;pageText&&pageFormatter&&pageText.setStyle('text',isString(pageFormatter)?pageFormatter.replace('{current}',current).replace('{total}',total):pageFormatter({current:current,total:total}));},/**
   * @param {module:echarts/model/Model} legendModel
   * @return {Object} {
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no next page.
   *  pageNextDataIndex: number, null when no previous page.
   * }
   */_getPageInfo:function _getPageInfo(legendModel){// Align left or top by the current dataIndex.
var currDataIndex=legendModel.get('scrollDataIndex',true);var contentGroup=this.getContentGroup();var contentRect=contentGroup.getBoundingRect();var containerRectSize=this._containerGroup.__rectSize;var orientIdx=legendModel.getOrient().index;var wh=WH[orientIdx];var hw=WH[1-orientIdx];var xy=XY[orientIdx];var contentPos=contentGroup.position.slice();var pageIndex;var pagePrevDataIndex;var pageNextDataIndex;var targetItemGroup;if(this._showController){contentGroup.eachChild(function(child){if(child.__legendDataIndex===currDataIndex){targetItemGroup=child;}});}else{targetItemGroup=contentGroup.childAt(0);}var pageCount=containerRectSize?Math.ceil(contentRect[wh]/containerRectSize):0;if(targetItemGroup){var itemRect=targetItemGroup.getBoundingRect();var itemLoc=targetItemGroup.position[orientIdx]+itemRect[xy];contentPos[orientIdx]=-itemLoc-contentRect[xy];pageIndex=Math.floor(pageCount*(itemLoc+itemRect[xy]+containerRectSize/2)/contentRect[wh]);pageIndex=contentRect[wh]&&pageCount?Math.max(0,Math.min(pageCount-1,pageIndex)):-1;var winRect={x:0,y:0};winRect[wh]=containerRectSize;winRect[hw]=contentRect[hw];winRect[xy]=-contentPos[orientIdx]-contentRect[xy];var startIdx;var children=contentGroup.children();contentGroup.eachChild(function(child,index){var itemRect=getItemRect(child);if(itemRect.intersect(winRect)){startIdx==null&&(startIdx=index);// It is user-friendly that the last item shown in the
// current window is shown at the begining of next window.
pageNextDataIndex=child.__legendDataIndex;}// If the last item is shown entirely, no next page.
if(index===children.length-1&&itemRect[xy]+itemRect[wh]<=winRect[xy]+winRect[wh]){pageNextDataIndex=null;}});// Always align based on the left/top most item, so the left/top most
// item in the previous window is needed to be found here.
if(startIdx!=null){var startItem=children[startIdx];var startRect=getItemRect(startItem);winRect[xy]=startRect[xy]+startRect[wh]-winRect[wh];// If the first item is shown entirely, no previous page.
if(startIdx<=0&&startRect[xy]>=winRect[xy]){pagePrevDataIndex=null;}else{while(startIdx>0&&getItemRect(children[startIdx-1]).intersect(winRect)){startIdx--;}pagePrevDataIndex=children[startIdx].__legendDataIndex;}}}return{contentPosition:contentPos,pageIndex:pageIndex,pageCount:pageCount,pagePrevDataIndex:pagePrevDataIndex,pageNextDataIndex:pageNextDataIndex};function getItemRect(el){var itemRect=el.getBoundingRect().clone();itemRect[xy]+=el.position[orientIdx];return itemRect;}}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @event legendScroll
 * @type {Object}
 * @property {string} type 'legendScroll'
 * @property {string} scrollDataIndex
 */registerAction('legendScroll','legendscroll',function(payload,ecModel){var scrollDataIndex=payload.scrollDataIndex;scrollDataIndex!=null&&ecModel.eachComponent({mainType:'legend',subType:'scroll',query:payload},function(legendModel){legendModel.setScrollDataIndex(scrollDataIndex);});});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Legend component entry file8
 *//*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
 * @param {module:echarts/model/Global} ecModel
 * @return {Object} {point: [x, y], el: ...} point Will not be null.
 */var findPointFromSeries=function findPointFromSeries(finder,ecModel){var point=[];var seriesIndex=finder.seriesIndex;var seriesModel;if(seriesIndex==null||!(seriesModel=ecModel.getSeriesByIndex(seriesIndex))){return{point:[]};}var data=seriesModel.getData();var dataIndex=queryDataIndex(data,finder);if(dataIndex==null||dataIndex<0||isArray(dataIndex)){return{point:[]};}var el=data.getItemGraphicEl(dataIndex);var coordSys=seriesModel.coordinateSystem;if(seriesModel.getTooltipPosition){point=seriesModel.getTooltipPosition(dataIndex)||[];}else if(coordSys&&coordSys.dataToPoint){point=coordSys.dataToPoint(data.getValues(map(coordSys.dimensions,function(dim){return data.mapDimension(dim);}),dataIndex,true))||[];}else if(el){// Use graphic bounding rect
var rect=el.getBoundingRect().clone();rect.applyTransform(el.transform);point=[rect.x+rect.width/2,rect.y+rect.height/2];}return{point:point,el:el};};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var each$8=each$1;var curry$3=curry;var inner$7=makeInner();/**
 * Basic logic: check all axis, if they do not demand show/highlight,
 * then hide/downplay them.
 *
 * @param {Object} coordSysAxesInfo
 * @param {Object} payload
 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
 * @param {Object} [payload.dataIndex] finder, restrict target axes.
 * @param {Object} [payload.axesInfo] finder, restrict target axes.
 *        [{
 *          axisDim: 'x'|'y'|'angle'|...,
 *          axisIndex: ...,
 *          value: ...
 *        }, ...]
 * @param {Function} [payload.dispatchAction]
 * @param {Object} [payload.tooltipOption]
 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
 *        which can be specified in dispatchAction
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 * @return {Object} content of event obj for echarts.connect.
 */var axisTrigger=function axisTrigger(payload,ecModel,api){var currTrigger=payload.currTrigger;var point=[payload.x,payload.y];var finder=payload;var dispatchAction=payload.dispatchAction||bind(api.dispatchAction,api);var coordSysAxesInfo=ecModel.getComponent('axisPointer').coordSysAxesInfo;// Pending
// See #6121. But we are not able to reproduce it yet.
if(!coordSysAxesInfo){return;}if(illegalPoint(point)){// Used in the default behavior of `connection`: use the sample seriesIndex
// and dataIndex. And also used in the tooltipView trigger.
point=findPointFromSeries({seriesIndex:finder.seriesIndex,// Do not use dataIndexInside from other ec instance.
// FIXME: auto detect it?
dataIndex:finder.dataIndex},ecModel).point;}var isIllegalPoint=illegalPoint(point);// Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
// Notice: In this case, it is difficult to get the `point` (which is necessary to show
// tooltip, so if point is not given, we just use the point found by sample seriesIndex
// and dataIndex.
var inputAxesInfo=finder.axesInfo;var axesInfo=coordSysAxesInfo.axesInfo;var shouldHide=currTrigger==='leave'||illegalPoint(point);var outputFinder={};var showValueMap={};var dataByCoordSys={list:[],map:{}};var updaters={showPointer:curry$3(showPointer,showValueMap),showTooltip:curry$3(showTooltip,dataByCoordSys)};// Process for triggered axes.
each$8(coordSysAxesInfo.coordSysMap,function(coordSys,coordSysKey){// If a point given, it must be contained by the coordinate system.
var coordSysContainsPoint=isIllegalPoint||coordSys.containPoint(point);each$8(coordSysAxesInfo.coordSysAxesInfo[coordSysKey],function(axisInfo,key){var axis=axisInfo.axis;var inputAxisInfo=findInputAxisInfo(inputAxesInfo,axisInfo);// If no inputAxesInfo, no axis is restricted.
if(!shouldHide&&coordSysContainsPoint&&(!inputAxesInfo||inputAxisInfo)){var val=inputAxisInfo&&inputAxisInfo.value;if(val==null&&!isIllegalPoint){val=axis.pointToData(point);}val!=null&&processOnAxis(axisInfo,val,updaters,false,outputFinder);}});});// Process for linked axes.
var linkTriggers={};each$8(axesInfo,function(tarAxisInfo,tarKey){var linkGroup=tarAxisInfo.linkGroup;// If axis has been triggered in the previous stage, it should not be triggered by link.
if(linkGroup&&!showValueMap[tarKey]){each$8(linkGroup.axesInfo,function(srcAxisInfo,srcKey){var srcValItem=showValueMap[srcKey];// If srcValItem exist, source axis is triggered, so link to target axis.
if(srcAxisInfo!==tarAxisInfo&&srcValItem){var val=srcValItem.value;linkGroup.mapper&&(val=tarAxisInfo.axis.scale.parse(linkGroup.mapper(val,makeMapperParam(srcAxisInfo),makeMapperParam(tarAxisInfo))));linkTriggers[tarAxisInfo.key]=val;}});}});each$8(linkTriggers,function(val,tarKey){processOnAxis(axesInfo[tarKey],val,updaters,true,outputFinder);});updateModelActually(showValueMap,axesInfo,outputFinder);dispatchTooltipActually(dataByCoordSys,point,payload,dispatchAction);dispatchHighDownActually(axesInfo,dispatchAction,api);return outputFinder;};function processOnAxis(axisInfo,newValue,updaters,dontSnap,outputFinder){var axis=axisInfo.axis;if(axis.scale.isBlank()||!axis.containData(newValue)){return;}if(!axisInfo.involveSeries){updaters.showPointer(axisInfo,newValue);return;}// Heavy calculation. So put it after axis.containData checking.
var payloadInfo=buildPayloadsBySeries(newValue,axisInfo);var payloadBatch=payloadInfo.payloadBatch;var snapToValue=payloadInfo.snapToValue;// Fill content of event obj for echarts.connect.
// By defualt use the first involved series data as a sample to connect.
if(payloadBatch[0]&&outputFinder.seriesIndex==null){extend(outputFinder,payloadBatch[0]);}// If no linkSource input, this process is for collecting link
// target, where snap should not be accepted.
if(!dontSnap&&axisInfo.snap){if(axis.containData(snapToValue)&&snapToValue!=null){newValue=snapToValue;}}updaters.showPointer(axisInfo,newValue,payloadBatch,outputFinder);// Tooltip should always be snapToValue, otherwise there will be
// incorrect "axis value ~ series value" mapping displayed in tooltip.
updaters.showTooltip(axisInfo,payloadInfo,snapToValue);}function buildPayloadsBySeries(value,axisInfo){var axis=axisInfo.axis;var dim=axis.dim;var snapToValue=value;var payloadBatch=[];var minDist=Number.MAX_VALUE;var minDiff=-1;each$8(axisInfo.seriesModels,function(series,idx){var dataDim=series.getData().mapDimension(dim,true);var seriesNestestValue;var dataIndices;if(series.getAxisTooltipData){var result=series.getAxisTooltipData(dataDim,value,axis);dataIndices=result.dataIndices;seriesNestestValue=result.nestestValue;}else{dataIndices=series.getData().indicesOfNearest(dataDim[0],value,// Add a threshold to avoid find the wrong dataIndex
// when data length is not same.
// false,
axis.type==='category'?0.5:null);if(!dataIndices.length){return;}seriesNestestValue=series.getData().get(dataDim[0],dataIndices[0]);}if(seriesNestestValue==null||!isFinite(seriesNestestValue)){return;}var diff=value-seriesNestestValue;var dist=Math.abs(diff);// Consider category case
if(dist<=minDist){if(dist<minDist||diff>=0&&minDiff<0){minDist=dist;minDiff=diff;snapToValue=seriesNestestValue;payloadBatch.length=0;}each$8(dataIndices,function(dataIndex){payloadBatch.push({seriesIndex:series.seriesIndex,dataIndexInside:dataIndex,dataIndex:series.getData().getRawIndex(dataIndex)});});}});return{payloadBatch:payloadBatch,snapToValue:snapToValue};}function showPointer(showValueMap,axisInfo,value,payloadBatch){showValueMap[axisInfo.key]={value:value,payloadBatch:payloadBatch};}function showTooltip(dataByCoordSys,axisInfo,payloadInfo,value){var payloadBatch=payloadInfo.payloadBatch;var axis=axisInfo.axis;var axisModel=axis.model;var axisPointerModel=axisInfo.axisPointerModel;// If no data, do not create anything in dataByCoordSys,
// whose length will be used to judge whether dispatch action.
if(!axisInfo.triggerTooltip||!payloadBatch.length){return;}var coordSysModel=axisInfo.coordSys.model;var coordSysKey=makeKey(coordSysModel);var coordSysItem=dataByCoordSys.map[coordSysKey];if(!coordSysItem){coordSysItem=dataByCoordSys.map[coordSysKey]={coordSysId:coordSysModel.id,coordSysIndex:coordSysModel.componentIndex,coordSysType:coordSysModel.type,coordSysMainType:coordSysModel.mainType,dataByAxis:[]};dataByCoordSys.list.push(coordSysItem);}coordSysItem.dataByAxis.push({axisDim:axis.dim,axisIndex:axisModel.componentIndex,axisType:axisModel.type,axisId:axisModel.id,value:value,// Caustion: viewHelper.getValueLabel is actually on "view stage", which
// depends that all models have been updated. So it should not be performed
// here. Considering axisPointerModel used here is volatile, which is hard
// to be retrieve in TooltipView, we prepare parameters here.
valueLabelOpt:{precision:axisPointerModel.get('label.precision'),formatter:axisPointerModel.get('label.formatter')},seriesDataIndices:payloadBatch.slice()});}function updateModelActually(showValueMap,axesInfo,outputFinder){var outputAxesInfo=outputFinder.axesInfo=[];// Basic logic: If no 'show' required, 'hide' this axisPointer.
each$8(axesInfo,function(axisInfo,key){var option=axisInfo.axisPointerModel.option;var valItem=showValueMap[key];if(valItem){!axisInfo.useHandle&&(option.status='show');option.value=valItem.value;// For label formatter param and highlight.
option.seriesDataIndices=(valItem.payloadBatch||[]).slice();}// When always show (e.g., handle used), remain
// original value and status.
else{// If hide, value still need to be set, consider
// click legend to toggle axis blank.
!axisInfo.useHandle&&(option.status='hide');}// If status is 'hide', should be no info in payload.
option.status==='show'&&outputAxesInfo.push({axisDim:axisInfo.axis.dim,axisIndex:axisInfo.axis.model.componentIndex,value:option.value});});}function dispatchTooltipActually(dataByCoordSys,point,payload,dispatchAction){// Basic logic: If no showTip required, hideTip will be dispatched.
if(illegalPoint(point)||!dataByCoordSys.list.length){dispatchAction({type:'hideTip'});return;}// In most case only one axis (or event one series is used). It is
// convinient to fetch payload.seriesIndex and payload.dataIndex
// dirtectly. So put the first seriesIndex and dataIndex of the first
// axis on the payload.
var sampleItem=((dataByCoordSys.list[0].dataByAxis[0]||{}).seriesDataIndices||[])[0]||{};dispatchAction({type:'showTip',escapeConnect:true,x:point[0],y:point[1],tooltipOption:payload.tooltipOption,position:payload.position,dataIndexInside:sampleItem.dataIndexInside,dataIndex:sampleItem.dataIndex,seriesIndex:sampleItem.seriesIndex,dataByCoordSys:dataByCoordSys.list});}function dispatchHighDownActually(axesInfo,dispatchAction,api){// FIXME
// highlight status modification shoule be a stage of main process?
// (Consider confilct (e.g., legend and axisPointer) and setOption)
var zr=api.getZr();var highDownKey='axisPointerLastHighlights';var lastHighlights=inner$7(zr)[highDownKey]||{};var newHighlights=inner$7(zr)[highDownKey]={};// Update highlight/downplay status according to axisPointer model.
// Build hash map and remove duplicate incidentally.
each$8(axesInfo,function(axisInfo,key){var option=axisInfo.axisPointerModel.option;option.status==='show'&&each$8(option.seriesDataIndices,function(batchItem){var key=batchItem.seriesIndex+' | '+batchItem.dataIndex;newHighlights[key]=batchItem;});});// Diff.
var toHighlight=[];var toDownplay=[];each$1(lastHighlights,function(batchItem,key){!newHighlights[key]&&toDownplay.push(batchItem);});each$1(newHighlights,function(batchItem,key){!lastHighlights[key]&&toHighlight.push(batchItem);});toDownplay.length&&api.dispatchAction({type:'downplay',escapeConnect:true,batch:toDownplay});toHighlight.length&&api.dispatchAction({type:'highlight',escapeConnect:true,batch:toHighlight});}function findInputAxisInfo(inputAxesInfo,axisInfo){for(var i=0;i<(inputAxesInfo||[]).length;i++){var inputAxisInfo=inputAxesInfo[i];if(axisInfo.axis.dim===inputAxisInfo.axisDim&&axisInfo.axis.model.componentIndex===inputAxisInfo.axisIndex){return inputAxisInfo;}}}function makeMapperParam(axisInfo){var axisModel=axisInfo.axis.model;var item={};var dim=item.axisDim=axisInfo.axis.dim;item.axisIndex=item[dim+'AxisIndex']=axisModel.componentIndex;item.axisName=item[dim+'AxisName']=axisModel.name;item.axisId=item[dim+'AxisId']=axisModel.id;return item;}function illegalPoint(point){return!point||point[0]==null||isNaN(point[0])||point[1]==null||isNaN(point[1]);}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var AxisPointerModel=extendComponentModel({type:'axisPointer',coordSysAxesInfo:null,defaultOption:{// 'auto' means that show when triggered by tooltip or handle.
show:'auto',// 'click' | 'mousemove' | 'none'
triggerOn:null,// set default in AxisPonterView.js
zlevel:0,z:50,type:'line',// axispointer triggered by tootip determine snap automatically,
// see `modelHelper`.
snap:false,triggerTooltip:true,value:null,status:null,// Init value depends on whether handle is used.
// [group0, group1, ...]
// Each group can be: {
//      mapper: function () {},
//      singleTooltip: 'multiple',  // 'multiple' or 'single'
//      xAxisId: ...,
//      yAxisName: ...,
//      angleAxisIndex: ...
// }
// mapper: can be ignored.
//      input: {axisInfo, value}
//      output: {axisInfo, value}
link:[],// Do not set 'auto' here, otherwise global animation: false
// will not effect at this axispointer.
animation:null,animationDurationUpdate:200,lineStyle:{color:'#aaa',width:1,type:'solid'},shadowStyle:{color:'rgba(150,150,150,0.3)'},label:{show:true,formatter:null,// string | Function
precision:'auto',// Or a number like 0, 1, 2 ...
margin:3,color:'#fff',padding:[5,7,5,7],backgroundColor:'auto',// default: axis line color
borderColor:null,borderWidth:0,shadowBlur:3,shadowColor:'#aaa'// Considering applicability, common style should
// better not have shadowOffset.
// shadowOffsetX: 0,
// shadowOffsetY: 2
},handle:{show:false,icon:'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',// jshint ignore:line
size:45,// handle margin is from symbol center to axis, which is stable when circular move.
margin:50,// color: '#1b8bbd'
// color: '#2f4554'
color:'#333',shadowBlur:3,shadowColor:'#aaa',shadowOffsetX:0,shadowOffsetY:2,// For mobile performance
throttle:40}}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var inner$8=makeInner();var each$9=each$1;/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 * @param {Function} handler
 *      param: {string} currTrigger
 *      param: {Array.<number>} point
 */function register(key,api,handler){if(env$1.node){return;}var zr=api.getZr();inner$8(zr).records||(inner$8(zr).records={});initGlobalListeners(zr,api);var record=inner$8(zr).records[key]||(inner$8(zr).records[key]={});record.handler=handler;}function initGlobalListeners(zr,api){if(inner$8(zr).initialized){return;}inner$8(zr).initialized=true;useHandler('click',curry(doEnter,'click'));useHandler('mousemove',curry(doEnter,'mousemove'));// useHandler('mouseout', onLeave);
useHandler('globalout',onLeave);function useHandler(eventType,cb){zr.on(eventType,function(e){var dis=makeDispatchAction(api);each$9(inner$8(zr).records,function(record){record&&cb(record,e,dis.dispatchAction);});dispatchTooltipFinally(dis.pendings,api);});}}function dispatchTooltipFinally(pendings,api){var showLen=pendings.showTip.length;var hideLen=pendings.hideTip.length;var actuallyPayload;if(showLen){actuallyPayload=pendings.showTip[showLen-1];}else if(hideLen){actuallyPayload=pendings.hideTip[hideLen-1];}if(actuallyPayload){actuallyPayload.dispatchAction=null;api.dispatchAction(actuallyPayload);}}function onLeave(record,e,dispatchAction){record.handler('leave',null,dispatchAction);}function doEnter(currTrigger,record,e,dispatchAction){record.handler(currTrigger,e,dispatchAction);}function makeDispatchAction(api){var pendings={showTip:[],hideTip:[]};// FIXME
// better approach?
// 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
// which may be conflict, (axisPointer call showTip but tooltip call hideTip);
// So we have to add "final stage" to merge those dispatched actions.
var dispatchAction=function dispatchAction(payload){var pendingList=pendings[payload.type];if(pendingList){pendingList.push(payload);}else{payload.dispatchAction=dispatchAction;api.dispatchAction(payload);}};return{dispatchAction:dispatchAction,pendings:pendings};}/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 */function unregister(key,api){if(env$1.node){return;}var zr=api.getZr();var record=(inner$8(zr).records||{})[key];if(record){inner$8(zr).records[key]=null;}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var AxisPointerView=extendComponentView({type:'axisPointer',render:function render(globalAxisPointerModel,ecModel,api){var globalTooltipModel=ecModel.getComponent('tooltip');var triggerOn=globalAxisPointerModel.get('triggerOn')||globalTooltipModel&&globalTooltipModel.get('triggerOn')||'mousemove|click';// Register global listener in AxisPointerView to enable
// AxisPointerView to be independent to Tooltip.
register('axisPointer',api,function(currTrigger,e,dispatchAction){// If 'none', it is not controlled by mouse totally.
if(triggerOn!=='none'&&(currTrigger==='leave'||triggerOn.indexOf(currTrigger)>=0)){dispatchAction({type:'updateAxisPointer',currTrigger:currTrigger,x:e&&e.offsetX,y:e&&e.offsetY});}});},/**
   * @override
   */remove:function remove(ecModel,api){unregister(api.getZr(),'axisPointer');AxisPointerView.superApply(this._model,'remove',arguments);},/**
   * @override
   */dispose:function dispose(ecModel,api){unregister('axisPointer',api);AxisPointerView.superApply(this._model,'dispose',arguments);}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var inner$9=makeInner();var clone$4=_clone;var bind$1=bind;/**
 * Base axis pointer class in 2D.
 * Implemenents {module:echarts/component/axis/IAxisPointer}.
 */function BaseAxisPointer(){}BaseAxisPointer.prototype={/**
   * @private
   */_group:null,/**
   * @private
   */_lastGraphicKey:null,/**
   * @private
   */_handle:null,/**
   * @private
   */_dragging:false,/**
   * @private
   */_lastValue:null,/**
   * @private
   */_lastStatus:null,/**
   * @private
   */_payloadInfo:null,/**
   * In px, arbitrary value. Do not set too small,
   * no animation is ok for most cases.
   * @protected
   */animationThreshold:15,/**
   * @implement
   */render:function render(axisModel,axisPointerModel,api,forceRender){var value=axisPointerModel.get('value');var status=axisPointerModel.get('status');// Bind them to `this`, not in closure, otherwise they will not
// be replaced when user calling setOption in not merge mode.
this._axisModel=axisModel;this._axisPointerModel=axisPointerModel;this._api=api;// Optimize: `render` will be called repeatly during mouse move.
// So it is power consuming if performing `render` each time,
// especially on mobile device.
if(!forceRender&&this._lastValue===value&&this._lastStatus===status){return;}this._lastValue=value;this._lastStatus=status;var group=this._group;var handle=this._handle;if(!status||status==='hide'){// Do not clear here, for animation better.
group&&group.hide();handle&&handle.hide();return;}group&&group.show();handle&&handle.show();// Otherwise status is 'show'
var elOption={};this.makeElOption(elOption,value,axisModel,axisPointerModel,api);// Enable change axis pointer type.
var graphicKey=elOption.graphicKey;if(graphicKey!==this._lastGraphicKey){this.clear(api);}this._lastGraphicKey=graphicKey;var moveAnimation=this._moveAnimation=this.determineAnimation(axisModel,axisPointerModel);if(!group){group=this._group=new Group();this.createPointerEl(group,elOption,axisModel,axisPointerModel);this.createLabelEl(group,elOption,axisModel,axisPointerModel);api.getZr().add(group);}else{var doUpdateProps=curry(updateProps$1,axisPointerModel,moveAnimation);this.updatePointerEl(group,elOption,doUpdateProps,axisPointerModel);this.updateLabelEl(group,elOption,doUpdateProps,axisPointerModel);}updateMandatoryProps(group,axisPointerModel,true);this._renderHandle(value);},/**
   * @implement
   */remove:function remove(api){this.clear(api);},/**
   * @implement
   */dispose:function dispose(api){this.clear(api);},/**
   * @protected
   */determineAnimation:function determineAnimation(axisModel,axisPointerModel){var animation=axisPointerModel.get('animation');var axis=axisModel.axis;var isCategoryAxis=axis.type==='category';var useSnap=axisPointerModel.get('snap');// Value axis without snap always do not snap.
if(!useSnap&&!isCategoryAxis){return false;}if(animation==='auto'||animation==null){var animationThreshold=this.animationThreshold;if(isCategoryAxis&&axis.getBandWidth()>animationThreshold){return true;}// It is important to auto animation when snap used. Consider if there is
// a dataZoom, animation will be disabled when too many points exist, while
// it will be enabled for better visual effect when little points exist.
if(useSnap){var seriesDataCount=getAxisInfo(axisModel).seriesDataCount;var axisExtent=axis.getExtent();// Approximate band width
return Math.abs(axisExtent[0]-axisExtent[1])/seriesDataCount>animationThreshold;}return false;}return animation===true;},/**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */makeElOption:function makeElOption(elOption,value,axisModel,axisPointerModel,api){// Shoule be implemenented by sub-class.
},/**
   * @protected
   */createPointerEl:function createPointerEl(group,elOption,axisModel,axisPointerModel){var pointerOption=elOption.pointer;if(pointerOption){var pointerEl=inner$9(group).pointerEl=new graphic[pointerOption.type](clone$4(elOption.pointer));group.add(pointerEl);}},/**
   * @protected
   */createLabelEl:function createLabelEl(group,elOption,axisModel,axisPointerModel){if(elOption.label){var labelEl=inner$9(group).labelEl=new Rect(clone$4(elOption.label));group.add(labelEl);updateLabelShowHide(labelEl,axisPointerModel);}},/**
   * @protected
   */updatePointerEl:function updatePointerEl(group,elOption,updateProps$$1){var pointerEl=inner$9(group).pointerEl;if(pointerEl){pointerEl.setStyle(elOption.pointer.style);updateProps$$1(pointerEl,{shape:elOption.pointer.shape});}},/**
   * @protected
   */updateLabelEl:function updateLabelEl(group,elOption,updateProps$$1,axisPointerModel){var labelEl=inner$9(group).labelEl;if(labelEl){labelEl.setStyle(elOption.label.style);updateProps$$1(labelEl,{// Consider text length change in vertical axis, animation should
// be used on shape, otherwise the effect will be weird.
shape:elOption.label.shape,position:elOption.label.position});updateLabelShowHide(labelEl,axisPointerModel);}},/**
   * @private
   */_renderHandle:function _renderHandle(value){if(this._dragging||!this.updateHandleTransform){return;}var axisPointerModel=this._axisPointerModel;var zr=this._api.getZr();var handle=this._handle;var handleModel=axisPointerModel.getModel('handle');var status=axisPointerModel.get('status');if(!handleModel.get('show')||!status||status==='hide'){handle&&zr.remove(handle);this._handle=null;return;}var isInit;if(!this._handle){isInit=true;handle=this._handle=createIcon(handleModel.get('icon'),{cursor:'move',draggable:true,onmousemove:function onmousemove(e){// Fot mobile devicem, prevent screen slider on the button.
stop(e.event);},onmousedown:bind$1(this._onHandleDragMove,this,0,0),drift:bind$1(this._onHandleDragMove,this),ondragend:bind$1(this._onHandleDragEnd,this)});zr.add(handle);}updateMandatoryProps(handle,axisPointerModel,false);// update style
var includeStyles=['color','borderColor','borderWidth','opacity','shadowColor','shadowBlur','shadowOffsetX','shadowOffsetY'];handle.setStyle(handleModel.getItemStyle(null,includeStyles));// update position
var handleSize=handleModel.get('size');if(!isArray(handleSize)){handleSize=[handleSize,handleSize];}handle.attr('scale',[handleSize[0]/2,handleSize[1]/2]);createOrUpdate(this,'_doDispatchAxisPointer',handleModel.get('throttle')||0,'fixRate');this._moveHandleToValue(value,isInit);},/**
   * @private
   */_moveHandleToValue:function _moveHandleToValue(value,isInit){updateProps$1(this._axisPointerModel,!isInit&&this._moveAnimation,this._handle,getHandleTransProps(this.getHandleTransform(value,this._axisModel,this._axisPointerModel)));},/**
   * @private
   */_onHandleDragMove:function _onHandleDragMove(dx,dy){var handle=this._handle;if(!handle){return;}this._dragging=true;// Persistent for throttle.
var trans=this.updateHandleTransform(getHandleTransProps(handle),[dx,dy],this._axisModel,this._axisPointerModel);this._payloadInfo=trans;handle.stopAnimation();handle.attr(getHandleTransProps(trans));inner$9(handle).lastProp=null;this._doDispatchAxisPointer();},/**
   * Throttled method.
   * @private
   */_doDispatchAxisPointer:function _doDispatchAxisPointer(){var handle=this._handle;if(!handle){return;}var payloadInfo=this._payloadInfo;var axisModel=this._axisModel;this._api.dispatchAction({type:'updateAxisPointer',x:payloadInfo.cursorPoint[0],y:payloadInfo.cursorPoint[1],tooltipOption:payloadInfo.tooltipOption,axesInfo:[{axisDim:axisModel.axis.dim,axisIndex:axisModel.componentIndex}]});},/**
   * @private
   */_onHandleDragEnd:function _onHandleDragEnd(moveAnimation){this._dragging=false;var handle=this._handle;if(!handle){return;}var value=this._axisPointerModel.get('value');// Consider snap or categroy axis, handle may be not consistent with
// axisPointer. So move handle to align the exact value position when
// drag ended.
this._moveHandleToValue(value);// For the effect: tooltip will be shown when finger holding on handle
// button, and will be hidden after finger left handle button.
this._api.dispatchAction({type:'hideTip'});},/**
   * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {number} value
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0}
   */getHandleTransform:null,/**
   * * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {Object} transform {position, rotation}
   * @param {Array.<number>} delta [dx, dy]
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
   */updateHandleTransform:null,/**
   * @private
   */clear:function clear(api){this._lastValue=null;this._lastStatus=null;var zr=api.getZr();var group=this._group;var handle=this._handle;if(zr&&group){this._lastGraphicKey=null;group&&zr.remove(group);handle&&zr.remove(handle);this._group=null;this._handle=null;this._payloadInfo=null;}},/**
   * @protected
   */doClear:function doClear(){// Implemented by sub-class if necessary.
},/**
   * @protected
   * @param {Array.<number>} xy
   * @param {Array.<number>} wh
   * @param {number} [xDimIndex=0] or 1
   */buildLabel:function buildLabel(xy,wh,xDimIndex){xDimIndex=xDimIndex||0;return{x:xy[xDimIndex],y:xy[1-xDimIndex],width:wh[xDimIndex],height:wh[1-xDimIndex]};}};BaseAxisPointer.prototype.constructor=BaseAxisPointer;function updateProps$1(animationModel,moveAnimation,el,props){// Animation optimize.
if(!propsEqual(inner$9(el).lastProp,props)){inner$9(el).lastProp=props;moveAnimation?updateProps(el,props,animationModel):(el.stopAnimation(),el.attr(props));}}function propsEqual(lastProps,newProps){if(isObject$1(lastProps)&&isObject$1(newProps)){var equals=true;each$1(newProps,function(item,key){equals=equals&&propsEqual(lastProps[key],item);});return!!equals;}else{return lastProps===newProps;}}function updateLabelShowHide(labelEl,axisPointerModel){labelEl[axisPointerModel.get('label.show')?'show':'hide']();}function getHandleTransProps(trans){return{position:trans.position.slice(),rotation:trans.rotation||0};}function updateMandatoryProps(group,axisPointerModel,silent){var z=axisPointerModel.get('z');var zlevel=axisPointerModel.get('zlevel');group&&group.traverse(function(el){if(el.type!=='group'){z!=null&&(el.z=z);zlevel!=null&&(el.zlevel=zlevel);el.silent=silent;}});}enableClassExtend(BaseAxisPointer);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @param {module:echarts/model/Model} axisPointerModel
 */function buildElStyle(axisPointerModel){var axisPointerType=axisPointerModel.get('type');var styleModel=axisPointerModel.getModel(axisPointerType+'Style');var style;if(axisPointerType==='line'){style=styleModel.getLineStyle();style.fill=null;}else if(axisPointerType==='shadow'){style=styleModel.getAreaStyle();style.stroke=null;}return style;}/**
 * @param {Function} labelPos {align, verticalAlign, position}
 */function buildLabelElOption(elOption,axisModel,axisPointerModel,api,labelPos){var value=axisPointerModel.get('value');var text=getValueLabel(value,axisModel.axis,axisModel.ecModel,axisPointerModel.get('seriesDataIndices'),{precision:axisPointerModel.get('label.precision'),formatter:axisPointerModel.get('label.formatter')});var labelModel=axisPointerModel.getModel('label');var paddings=normalizeCssArray$1(labelModel.get('padding')||0);var font=labelModel.getFont();var textRect=_getBoundingRect(text,font);var position=labelPos.position;var width=textRect.width+paddings[1]+paddings[3];var height=textRect.height+paddings[0]+paddings[2];// Adjust by align.
var align=labelPos.align;align==='right'&&(position[0]-=width);align==='center'&&(position[0]-=width/2);var verticalAlign=labelPos.verticalAlign;verticalAlign==='bottom'&&(position[1]-=height);verticalAlign==='middle'&&(position[1]-=height/2);// Not overflow ec container
confineInContainer(position,width,height,api);var bgColor=labelModel.get('backgroundColor');if(!bgColor||bgColor==='auto'){bgColor=axisModel.get('axisLine.lineStyle.color');}elOption.label={shape:{x:0,y:0,width:width,height:height,r:labelModel.get('borderRadius')},position:position.slice(),// TODO: rich
style:{text:text,textFont:font,textFill:labelModel.getTextColor(),textPosition:'inside',fill:bgColor,stroke:labelModel.get('borderColor')||'transparent',lineWidth:labelModel.get('borderWidth')||0,shadowBlur:labelModel.get('shadowBlur'),shadowColor:labelModel.get('shadowColor'),shadowOffsetX:labelModel.get('shadowOffsetX'),shadowOffsetY:labelModel.get('shadowOffsetY')},// Lable should be over axisPointer.
z2:10};}// Do not overflow ec container
function confineInContainer(position,width,height,api){var viewWidth=api.getWidth();var viewHeight=api.getHeight();position[0]=Math.min(position[0]+width,viewWidth)-width;position[1]=Math.min(position[1]+height,viewHeight)-height;position[0]=Math.max(position[0],0);position[1]=Math.max(position[1],0);}/**
 * @param {number} value
 * @param {module:echarts/coord/Axis} axis
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} opt
 * @param {Array.<Object>} seriesDataIndices
 * @param {number|string} opt.precision 'auto' or a number
 * @param {string|Function} opt.formatter label formatter
 */function getValueLabel(value,axis,ecModel,seriesDataIndices,opt){value=axis.scale.parse(value);var text=axis.scale.getLabel(// If `precision` is set, width can be fixed (like '12.00500'), which
// helps to debounce when when moving label.
value,{precision:opt.precision});var formatter=opt.formatter;if(formatter){var params={value:getAxisRawValue(axis,value),seriesData:[]};each$1(seriesDataIndices,function(idxItem){var series=ecModel.getSeriesByIndex(idxItem.seriesIndex);var dataIndex=idxItem.dataIndexInside;var dataParams=series&&series.getDataParams(dataIndex);dataParams&&params.seriesData.push(dataParams);});if(isString(formatter)){text=formatter.replace('{value}',text);}else if(isFunction$1(formatter)){text=formatter(params);}}return text;}/**
 * @param {module:echarts/coord/Axis} axis
 * @param {number} value
 * @param {Object} layoutInfo {
 *  rotation, position, labelOffset, labelDirection, labelMargin
 * }
 */function getTransformedPosition(axis,value,layoutInfo){var transform=create$1();rotate(transform,transform,layoutInfo.rotation);translate(transform,transform,layoutInfo.position);return applyTransform$1([axis.dataToCoord(value),(layoutInfo.labelOffset||0)+(layoutInfo.labelDirection||1)*(layoutInfo.labelMargin||0)],transform);}function buildCartesianSingleLabelElOption(value,elOption,layoutInfo,axisModel,axisPointerModel,api){var textLayout=AxisBuilder.innerTextLayout(layoutInfo.rotation,0,layoutInfo.labelDirection);layoutInfo.labelMargin=axisPointerModel.get('label.margin');buildLabelElOption(elOption,axisModel,axisPointerModel,api,{position:getTransformedPosition(axisModel.axis,value,layoutInfo),align:textLayout.textAlign,verticalAlign:textLayout.textVerticalAlign});}/**
 * @param {Array.<number>} p1
 * @param {Array.<number>} p2
 * @param {number} [xDimIndex=0] or 1
 */function makeLineShape(p1,p2,xDimIndex){xDimIndex=xDimIndex||0;return{x1:p1[xDimIndex],y1:p1[1-xDimIndex],x2:p2[xDimIndex],y2:p2[1-xDimIndex]};}/**
 * @param {Array.<number>} xy
 * @param {Array.<number>} wh
 * @param {number} [xDimIndex=0] or 1
 */function makeRectShape(xy,wh,xDimIndex){xDimIndex=xDimIndex||0;return{x:xy[xDimIndex],y:xy[1-xDimIndex],width:wh[xDimIndex],height:wh[1-xDimIndex]};}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var CartesianAxisPointer=BaseAxisPointer.extend({/**
   * @override
   */makeElOption:function makeElOption(elOption,value,axisModel,axisPointerModel,api){var axis=axisModel.axis;var grid=axis.grid;var axisPointerType=axisPointerModel.get('type');var otherExtent=getCartesian(grid,axis).getOtherAxis(axis).getGlobalExtent();var pixelValue=axis.toGlobalCoord(axis.dataToCoord(value,true));if(axisPointerType&&axisPointerType!=='none'){var elStyle=buildElStyle(axisPointerModel);var pointerOption=pointerShapeBuilder[axisPointerType](axis,pixelValue,otherExtent,elStyle);pointerOption.style=elStyle;elOption.graphicKey=pointerOption.type;elOption.pointer=pointerOption;}var layoutInfo=layout$1(grid.model,axisModel);buildCartesianSingleLabelElOption(value,elOption,layoutInfo,axisModel,axisPointerModel,api);},/**
   * @override
   */getHandleTransform:function getHandleTransform(value,axisModel,axisPointerModel){var layoutInfo=layout$1(axisModel.axis.grid.model,axisModel,{labelInside:false});layoutInfo.labelMargin=axisPointerModel.get('handle.margin');return{position:getTransformedPosition(axisModel.axis,value,layoutInfo),rotation:layoutInfo.rotation+(layoutInfo.labelDirection<0?Math.PI:0)};},/**
   * @override
   */updateHandleTransform:function updateHandleTransform(transform,delta,axisModel,axisPointerModel){var axis=axisModel.axis;var grid=axis.grid;var axisExtent=axis.getGlobalExtent(true);var otherExtent=getCartesian(grid,axis).getOtherAxis(axis).getGlobalExtent();var dimIndex=axis.dim==='x'?0:1;var currPosition=transform.position;currPosition[dimIndex]+=delta[dimIndex];currPosition[dimIndex]=Math.min(axisExtent[1],currPosition[dimIndex]);currPosition[dimIndex]=Math.max(axisExtent[0],currPosition[dimIndex]);var cursorOtherValue=(otherExtent[1]+otherExtent[0])/2;var cursorPoint=[cursorOtherValue,cursorOtherValue];cursorPoint[dimIndex]=currPosition[dimIndex];// Make tooltip do not overlap axisPointer and in the middle of the grid.
var tooltipOptions=[{verticalAlign:'middle'},{align:'center'}];return{position:currPosition,rotation:transform.rotation,cursorPoint:cursorPoint,tooltipOption:tooltipOptions[dimIndex]};}});function getCartesian(grid,axis){var opt={};opt[axis.dim+'AxisIndex']=axis.index;return grid.getCartesian(opt);}var pointerShapeBuilder={line:function line(axis,pixelValue,otherExtent,elStyle){var targetShape=makeLineShape([pixelValue,otherExtent[0]],[pixelValue,otherExtent[1]],getAxisDimIndex(axis));subPixelOptimizeLine({shape:targetShape,style:elStyle});return{type:'Line',shape:targetShape};},shadow:function shadow(axis,pixelValue,otherExtent,elStyle){var bandWidth=Math.max(1,axis.getBandWidth());var span=otherExtent[1]-otherExtent[0];return{type:'Rect',shape:makeRectShape([pixelValue-bandWidth/2,otherExtent[0]],[bandWidth,span],getAxisDimIndex(axis))};}};function getAxisDimIndex(axis){return axis.dim==='x'?0:1;}AxisView.registerAxisPointerClass('CartesianAxisPointer',CartesianAxisPointer);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// echarts.simple.js and online build tooltip, which only require gridSimple,
// CartesianAxisPointer should be able to required somewhere.
registerPreprocessor(function(option){// Always has a global axisPointerModel for default setting.
if(option){(!option.axisPointer||option.axisPointer.length===0)&&(option.axisPointer={});var link=option.axisPointer.link;// Normalize to array to avoid object mergin. But if link
// is not set, remain null/undefined, otherwise it will
// override existent link setting.
if(link&&!isArray(link)){option.axisPointer.link=[link];}}});// This process should proformed after coordinate systems created
// and series data processed. So put it on statistic processing stage.
registerProcessor(PRIORITY.PROCESSOR.STATISTIC,function(ecModel,api){// Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
// allAxesInfo should be updated when setOption performed.
ecModel.getComponent('axisPointer').coordSysAxesInfo=collect(ecModel,api);});// Broadcast to all views.
registerAction({type:'updateAxisPointer',event:'updateAxisPointer',update:':updateAxisPointer'},axisTrigger);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/extendComponentModel({type:'tooltip',dependencies:['axisPointer'],defaultOption:{zlevel:0,z:8,show:true,// tooltip主体内容
showContent:true,// 'trigger' only works on coordinate system.
// 'item' | 'axis' | 'none'
trigger:'item',// 'click' | 'mousemove' | 'none'
triggerOn:'mousemove|click',alwaysShowContent:false,displayMode:'single',// 'single' | 'multipleByCoordSys'
// 位置 {Array} | {Function}
// position: null
// Consider triggered from axisPointer handle, verticalAlign should be 'middle'
// align: null,
// verticalAlign: null,
// 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
confine:false,// 内容格式器：{string}（Template） ¦ {Function}
// formatter: null
showDelay:0,// 隐藏延迟，单位ms
hideDelay:100,// 动画变换时间，单位s
transitionDuration:0.4,enterable:false,// 提示背景颜色，默认为透明度为0.7的黑色
backgroundColor:'rgba(50,50,50,0.7)',// 提示边框颜色
borderColor:'#333',// 提示边框圆角，单位px，默认为4
borderRadius:4,// 提示边框线宽，单位px，默认为0（无边框）
borderWidth:0,// 提示内边距，单位px，默认各方向内边距为5，
// 接受数组分别设定上右下左边距，同css
padding:5,// Extra css text
extraCssText:'',// 坐标轴指示器，坐标轴触发有效
axisPointer:{// 默认为直线
// 可选为：'line' | 'shadow' | 'cross'
type:'line',// type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
// 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
// 默认 'auto'，会选择类型为 category 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
// 极坐标系会默认选择 angle 轴
axis:'auto',animation:'auto',animationDurationUpdate:200,animationEasingUpdate:'exponentialOut',crossStyle:{color:'#999',width:1,type:'dashed',// TODO formatter
textStyle:{}// lineStyle and shadowStyle should not be specified here,
// otherwise it will always override those styles on option.axisPointer.
}},textStyle:{color:'#fff',fontSize:14}}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var each$11=each$1;var toCamelCase$1=toCamelCase;var vendors=['','-webkit-','-moz-','-o-'];var gCssText='position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';/**
 * @param {number} duration
 * @return {string}
 * @inner
 */function assembleTransition(duration){var transitionCurve='cubic-bezier(0.23, 1, 0.32, 1)';var transitionText='left '+duration+'s '+transitionCurve+','+'top '+duration+'s '+transitionCurve;return map(vendors,function(vendorPrefix){return vendorPrefix+'transition:'+transitionText;}).join(';');}/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */function assembleFont(textStyleModel){var cssText=[];var fontSize=textStyleModel.get('fontSize');var color=textStyleModel.getTextColor();color&&cssText.push('color:'+color);cssText.push('font:'+textStyleModel.getFont());fontSize&&cssText.push('line-height:'+Math.round(fontSize*3/2)+'px');each$11(['decoration','align'],function(name){var val=textStyleModel.get(name);val&&cssText.push('text-'+name+':'+val);});return cssText.join(';');}/**
 * @param {Object} tooltipModel
 * @return {string}
 * @inner
 */function assembleCssText(tooltipModel){var cssText=[];var transitionDuration=tooltipModel.get('transitionDuration');var backgroundColor=tooltipModel.get('backgroundColor');var textStyleModel=tooltipModel.getModel('textStyle');var padding=tooltipModel.get('padding');// Animation transition. Do not animate when transitionDuration is 0.
transitionDuration&&cssText.push(assembleTransition(transitionDuration));if(backgroundColor){if(env$1.canvasSupported){cssText.push('background-Color:'+backgroundColor);}else{// for ie
cssText.push('background-Color:#'+toHex(backgroundColor));cssText.push('filter:alpha(opacity=70)');}}// Border style
each$11(['width','color','radius'],function(name){var borderName='border-'+name;var camelCase=toCamelCase$1(borderName);var val=tooltipModel.get(camelCase);val!=null&&cssText.push(borderName+':'+val+(name==='color'?'':'px'));});// Text style
cssText.push(assembleFont(textStyleModel));// Padding
if(padding!=null){cssText.push('padding:'+normalizeCssArray$1(padding).join('px ')+'px');}return cssText.join(';')+';';}/**
 * @alias module:echarts/component/tooltip/TooltipContent
 * @constructor
 */function TooltipContent(container,api){if(env$1.wxa){return null;}var el=document.createElement('div');var zr=this._zr=api.getZr();this.el=el;this._x=api.getWidth()/2;this._y=api.getHeight()/2;container.appendChild(el);this._container=container;this._show=false;/**
   * @private
   */this._hideTimeout;var self=this;el.onmouseenter=function(){// clear the timeout in hideLater and keep showing tooltip
if(self._enterable){clearTimeout(self._hideTimeout);self._show=true;}self._inContent=true;};el.onmousemove=function(e){e=e||window.event;if(!self._enterable){// Try trigger zrender event to avoid mouse
// in and out shape too frequently
var handler=zr.handler;normalizeEvent(container,e,true);handler.dispatch('mousemove',e);}};el.onmouseleave=function(){if(self._enterable){if(self._show){self.hideLater(self._hideDelay);}}self._inContent=false;};}TooltipContent.prototype={constructor:TooltipContent,/**
   * @private
   * @type {boolean}
   */_enterable:true,/**
   * Update when tooltip is rendered
   */update:function update(){// FIXME
// Move this logic to ec main?
var container=this._container;var stl=container.currentStyle||document.defaultView.getComputedStyle(container);var domStyle=container.style;if(domStyle.position!=='absolute'&&stl.position!=='absolute'){domStyle.position='relative';}// Hide the tooltip
// PENDING
// this.hide();
},show:function show(tooltipModel){clearTimeout(this._hideTimeout);var el=this.el;el.style.cssText=gCssText+assembleCssText(tooltipModel)// http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
+';left:'+this._x+'px;top:'+this._y+'px;'+(tooltipModel.get('extraCssText')||'');el.style.display=el.innerHTML?'block':'none';this._show=true;},setContent:function setContent(content){this.el.innerHTML=content==null?'':content;},setEnterable:function setEnterable(enterable){this._enterable=enterable;},getSize:function getSize(){var el=this.el;return[el.clientWidth,el.clientHeight];},moveTo:function moveTo(x,y){// xy should be based on canvas root. But tooltipContent is
// the sibling of canvas root. So padding of ec container
// should be considered here.
var zr=this._zr;var viewportRootOffset;if(zr&&zr.painter&&(viewportRootOffset=zr.painter.getViewportRootOffset())){x+=viewportRootOffset.offsetLeft;y+=viewportRootOffset.offsetTop;}var style=this.el.style;style.left=x+'px';style.top=y+'px';this._x=x;this._y=y;},hide:function hide(){this.el.style.display='none';this._show=false;},hideLater:function hideLater(time){if(this._show&&!(this._inContent&&this._enterable)){if(time){this._hideDelay=time;// Set show false to avoid invoke hideLater mutiple times
this._show=false;this._hideTimeout=setTimeout(bind(this.hide,this),time);}else{this.hide();}}},isShow:function isShow(){return this._show;}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var bind$2=bind;var each$10=each$1;var parsePercent$2=parsePercent$1;var proxyRect=new Rect({shape:{x:-1,y:-1,width:2,height:2}});extendComponentView({type:'tooltip',init:function init(ecModel,api){if(env$1.node){return;}var tooltipContent=new TooltipContent(api.getDom(),api);this._tooltipContent=tooltipContent;},render:function render(tooltipModel,ecModel,api){if(env$1.node||env$1.wxa){return;}// Reset
this.group.removeAll();/**
     * @private
     * @type {module:echarts/component/tooltip/TooltipModel}
     */this._tooltipModel=tooltipModel;/**
     * @private
     * @type {module:echarts/model/Global}
     */this._ecModel=ecModel;/**
     * @private
     * @type {module:echarts/ExtensionAPI}
     */this._api=api;/**
     * Should be cleaned when render.
     * @private
     * @type {Array.<Array.<Object>>}
     */this._lastDataByCoordSys=null;/**
     * @private
     * @type {boolean}
     */this._alwaysShowContent=tooltipModel.get('alwaysShowContent');var tooltipContent=this._tooltipContent;tooltipContent.update();tooltipContent.setEnterable(tooltipModel.get('enterable'));this._initGlobalListener();this._keepShow();},_initGlobalListener:function _initGlobalListener(){var tooltipModel=this._tooltipModel;var triggerOn=tooltipModel.get('triggerOn');register('itemTooltip',this._api,bind$2(function(currTrigger,e,dispatchAction){// If 'none', it is not controlled by mouse totally.
if(triggerOn!=='none'){if(triggerOn.indexOf(currTrigger)>=0){this._tryShow(e,dispatchAction);}else if(currTrigger==='leave'){this._hide(dispatchAction);}}},this));},_keepShow:function _keepShow(){var tooltipModel=this._tooltipModel;var ecModel=this._ecModel;var api=this._api;// Try to keep the tooltip show when refreshing
if(this._lastX!=null&&this._lastY!=null// When user is willing to control tooltip totally using API,
// self.manuallyShowTip({x, y}) might cause tooltip hide,
// which is not expected.
&&tooltipModel.get('triggerOn')!=='none'){var self=this;clearTimeout(this._refreshUpdateTimeout);this._refreshUpdateTimeout=setTimeout(function(){// Show tip next tick after other charts are rendered
// In case highlight action has wrong result
// FIXME
self.manuallyShowTip(tooltipModel,ecModel,api,{x:self._lastX,y:self._lastY});});}},/**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */manuallyShowTip:function manuallyShowTip(tooltipModel,ecModel,api,payload){if(payload.from===this.uid||env$1.node){return;}var dispatchAction=makeDispatchAction$1(payload,api);// Reset ticket
this._ticket='';// When triggered from axisPointer.
var dataByCoordSys=payload.dataByCoordSys;if(payload.tooltip&&payload.x!=null&&payload.y!=null){var el=proxyRect;el.position=[payload.x,payload.y];el.update();el.tooltip=payload.tooltip;// Manually show tooltip while view is not using zrender elements.
this._tryShow({offsetX:payload.x,offsetY:payload.y,target:el},dispatchAction);}else if(dataByCoordSys){this._tryShow({offsetX:payload.x,offsetY:payload.y,position:payload.position,event:{},dataByCoordSys:payload.dataByCoordSys,tooltipOption:payload.tooltipOption},dispatchAction);}else if(payload.seriesIndex!=null){if(this._manuallyAxisShowTip(tooltipModel,ecModel,api,payload)){return;}var pointInfo=findPointFromSeries(payload,ecModel);var cx=pointInfo.point[0];var cy=pointInfo.point[1];if(cx!=null&&cy!=null){this._tryShow({offsetX:cx,offsetY:cy,position:payload.position,target:pointInfo.el,event:{}},dispatchAction);}}else if(payload.x!=null&&payload.y!=null){// FIXME
// should wrap dispatchAction like `axisPointer/globalListener` ?
api.dispatchAction({type:'updateAxisPointer',x:payload.x,y:payload.y});this._tryShow({offsetX:payload.x,offsetY:payload.y,position:payload.position,target:api.getZr().findHover(payload.x,payload.y).target,event:{}},dispatchAction);}},manuallyHideTip:function manuallyHideTip(tooltipModel,ecModel,api,payload){var tooltipContent=this._tooltipContent;if(!this._alwaysShowContent&&this._tooltipModel){tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));}this._lastX=this._lastY=null;if(payload.from!==this.uid){this._hide(makeDispatchAction$1(payload,api));}},// Be compatible with previous design, that is, when tooltip.type is 'axis' and
// dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
// and tooltip.
_manuallyAxisShowTip:function _manuallyAxisShowTip(tooltipModel,ecModel,api,payload){var seriesIndex=payload.seriesIndex;var dataIndex=payload.dataIndex;var coordSysAxesInfo=ecModel.getComponent('axisPointer').coordSysAxesInfo;if(seriesIndex==null||dataIndex==null||coordSysAxesInfo==null){return;}var seriesModel=ecModel.getSeriesByIndex(seriesIndex);if(!seriesModel){return;}var data=seriesModel.getData();var tooltipModel=buildTooltipModel([data.getItemModel(dataIndex),seriesModel,(seriesModel.coordinateSystem||{}).model,tooltipModel]);if(tooltipModel.get('trigger')!=='axis'){return;}api.dispatchAction({type:'updateAxisPointer',seriesIndex:seriesIndex,dataIndex:dataIndex,position:payload.position});return true;},_tryShow:function _tryShow(e,dispatchAction){var el=e.target;var tooltipModel=this._tooltipModel;if(!tooltipModel){return;}// Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
this._lastX=e.offsetX;this._lastY=e.offsetY;var dataByCoordSys=e.dataByCoordSys;if(dataByCoordSys&&dataByCoordSys.length){this._showAxisTooltip(dataByCoordSys,e);}// Always show item tooltip if mouse is on the element with dataIndex
else if(el&&el.dataIndex!=null){this._lastDataByCoordSys=null;this._showSeriesItemTooltip(e,el,dispatchAction);}// Tooltip provided directly. Like legend.
else if(el&&el.tooltip){this._lastDataByCoordSys=null;this._showComponentItemTooltip(e,el,dispatchAction);}else{this._lastDataByCoordSys=null;this._hide(dispatchAction);}},_showOrMove:function _showOrMove(tooltipModel,cb){// showDelay is used in this case: tooltip.enterable is set
// as true. User intent to move mouse into tooltip and click
// something. `showDelay` makes it easyer to enter the content
// but tooltip do not move immediately.
var delay=tooltipModel.get('showDelay');cb=bind(cb,this);clearTimeout(this._showTimout);delay>0?this._showTimout=setTimeout(cb,delay):cb();},_showAxisTooltip:function _showAxisTooltip(dataByCoordSys,e){var ecModel=this._ecModel;var globalTooltipModel=this._tooltipModel;var point=[e.offsetX,e.offsetY];var singleDefaultHTML=[];var singleParamsList=[];var singleTooltipModel=buildTooltipModel([e.tooltipOption,globalTooltipModel]);each$10(dataByCoordSys,function(itemCoordSys){// var coordParamList = [];
// var coordDefaultHTML = [];
// var coordTooltipModel = buildTooltipModel([
//     e.tooltipOption,
//     itemCoordSys.tooltipOption,
//     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
//     globalTooltipModel
// ]);
// var displayMode = coordTooltipModel.get('displayMode');
// var paramsList = displayMode === 'single' ? singleParamsList : [];
each$10(itemCoordSys.dataByAxis,function(item){var axisModel=ecModel.getComponent(item.axisDim+'Axis',item.axisIndex);var axisValue=item.value;var seriesDefaultHTML=[];if(!axisModel||axisValue==null){return;}var valueLabel=getValueLabel(axisValue,axisModel.axis,ecModel,item.seriesDataIndices,item.valueLabelOpt);each$1(item.seriesDataIndices,function(idxItem){var series=ecModel.getSeriesByIndex(idxItem.seriesIndex);var dataIndex=idxItem.dataIndexInside;var dataParams=series&&series.getDataParams(dataIndex);dataParams.axisDim=item.axisDim;dataParams.axisIndex=item.axisIndex;dataParams.axisType=item.axisType;dataParams.axisId=item.axisId;dataParams.axisValue=getAxisRawValue(axisModel.axis,axisValue);dataParams.axisValueLabel=valueLabel;if(dataParams){singleParamsList.push(dataParams);seriesDefaultHTML.push(series.formatTooltip(dataIndex,true));}});// Default tooltip content
// FIXME
// (1) shold be the first data which has name?
// (2) themeRiver, firstDataIndex is array, and first line is unnecessary.
var firstLine=valueLabel;singleDefaultHTML.push((firstLine?encodeHTML(firstLine)+'<br />':'')+seriesDefaultHTML.join('<br />'));});},this);// In most case, the second axis is shown upper than the first one.
singleDefaultHTML.reverse();singleDefaultHTML=singleDefaultHTML.join('<br /><br />');var positionExpr=e.position;this._showOrMove(singleTooltipModel,function(){if(this._updateContentNotChangedOnAxis(dataByCoordSys)){this._updatePosition(singleTooltipModel,positionExpr,point[0],point[1],this._tooltipContent,singleParamsList);}else{this._showTooltipContent(singleTooltipModel,singleDefaultHTML,singleParamsList,Math.random(),point[0],point[1],positionExpr);}});// Do not trigger events here, because this branch only be entered
// from dispatchAction.
},_showSeriesItemTooltip:function _showSeriesItemTooltip(e,el,dispatchAction){var ecModel=this._ecModel;// Use dataModel in element if possible
// Used when mouseover on a element like markPoint or edge
// In which case, the data is not main data in series.
var seriesIndex=el.seriesIndex;var seriesModel=ecModel.getSeriesByIndex(seriesIndex);// For example, graph link.
var dataModel=el.dataModel||seriesModel;var dataIndex=el.dataIndex;var dataType=el.dataType;var data=dataModel.getData();var tooltipModel=buildTooltipModel([data.getItemModel(dataIndex),dataModel,seriesModel&&(seriesModel.coordinateSystem||{}).model,this._tooltipModel]);var tooltipTrigger=tooltipModel.get('trigger');if(tooltipTrigger!=null&&tooltipTrigger!=='item'){return;}var params=dataModel.getDataParams(dataIndex,dataType);var defaultHtml=dataModel.formatTooltip(dataIndex,false,dataType);var asyncTicket='item_'+dataModel.name+'_'+dataIndex;this._showOrMove(tooltipModel,function(){this._showTooltipContent(tooltipModel,defaultHtml,params,asyncTicket,e.offsetX,e.offsetY,e.position,e.target);});// FIXME
// duplicated showtip if manuallyShowTip is called from dispatchAction.
dispatchAction({type:'showTip',dataIndexInside:dataIndex,dataIndex:data.getRawIndex(dataIndex),seriesIndex:seriesIndex,from:this.uid});},_showComponentItemTooltip:function _showComponentItemTooltip(e,el,dispatchAction){var tooltipOpt=el.tooltip;if(typeof tooltipOpt==='string'){var content=tooltipOpt;tooltipOpt={content:content,// Fixed formatter
formatter:content};}var subTooltipModel=new Model(tooltipOpt,this._tooltipModel,this._ecModel);var defaultHtml=subTooltipModel.get('content');var asyncTicket=Math.random();// Do not check whether `trigger` is 'none' here, because `trigger`
// only works on cooridinate system. In fact, we have not found case
// that requires setting `trigger` nothing on component yet.
this._showOrMove(subTooltipModel,function(){this._showTooltipContent(subTooltipModel,defaultHtml,subTooltipModel.get('formatterParams')||{},asyncTicket,e.offsetX,e.offsetY,e.position,el);});// If not dispatch showTip, tip may be hide triggered by axis.
dispatchAction({type:'showTip',from:this.uid});},_showTooltipContent:function _showTooltipContent(tooltipModel,defaultHtml,params,asyncTicket,x,y,positionExpr,el){// Reset ticket
this._ticket='';if(!tooltipModel.get('showContent')||!tooltipModel.get('show')){return;}var tooltipContent=this._tooltipContent;var formatter=tooltipModel.get('formatter');positionExpr=positionExpr||tooltipModel.get('position');var html=defaultHtml;if(formatter&&typeof formatter==='string'){html=formatTpl(formatter,params,true);}else if(typeof formatter==='function'){var callback=bind$2(function(cbTicket,html){if(cbTicket===this._ticket){tooltipContent.setContent(html);this._updatePosition(tooltipModel,positionExpr,x,y,tooltipContent,params,el);}},this);this._ticket=asyncTicket;html=formatter(params,asyncTicket,callback);}tooltipContent.setContent(html);tooltipContent.show(tooltipModel);this._updatePosition(tooltipModel,positionExpr,x,y,tooltipContent,params,el);},/**
   * @param  {string|Function|Array.<number>|Object} positionExpr
   * @param  {number} x Mouse x
   * @param  {number} y Mouse y
   * @param  {boolean} confine Whether confine tooltip content in view rect.
   * @param  {Object|<Array.<Object>} params
   * @param  {module:zrender/Element} el target element
   * @param  {module:echarts/ExtensionAPI} api
   * @return {Array.<number>}
   */_updatePosition:function _updatePosition(tooltipModel,positionExpr,x,y,content,params,el){var viewWidth=this._api.getWidth();var viewHeight=this._api.getHeight();positionExpr=positionExpr||tooltipModel.get('position');var contentSize=content.getSize();var align=tooltipModel.get('align');var vAlign=tooltipModel.get('verticalAlign');var rect=el&&el.getBoundingRect().clone();el&&rect.applyTransform(el.transform);if(typeof positionExpr==='function'){// Callback of position can be an array or a string specify the position
positionExpr=positionExpr([x,y],params,content.el,rect,{viewSize:[viewWidth,viewHeight],contentSize:contentSize.slice()});}if(isArray(positionExpr)){x=parsePercent$2(positionExpr[0],viewWidth);y=parsePercent$2(positionExpr[1],viewHeight);}else if(isObject$1(positionExpr)){positionExpr.width=contentSize[0];positionExpr.height=contentSize[1];var layoutRect=getLayoutRect(positionExpr,{width:viewWidth,height:viewHeight});x=layoutRect.x;y=layoutRect.y;align=null;// When positionExpr is left/top/right/bottom,
// align and verticalAlign will not work.
vAlign=null;}// Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
else if(typeof positionExpr==='string'&&el){var pos=calcTooltipPosition(positionExpr,rect,contentSize);x=pos[0];y=pos[1];}else{var pos=refixTooltipPosition(x,y,content.el,viewWidth,viewHeight,align?null:20,vAlign?null:20);x=pos[0];y=pos[1];}align&&(x-=isCenterAlign(align)?contentSize[0]/2:align==='right'?contentSize[0]:0);vAlign&&(y-=isCenterAlign(vAlign)?contentSize[1]/2:vAlign==='bottom'?contentSize[1]:0);if(tooltipModel.get('confine')){var pos=confineTooltipPosition(x,y,content.el,viewWidth,viewHeight);x=pos[0];y=pos[1];}content.moveTo(x,y);},// FIXME
// Should we remove this but leave this to user?
_updateContentNotChangedOnAxis:function _updateContentNotChangedOnAxis(dataByCoordSys){var lastCoordSys=this._lastDataByCoordSys;var contentNotChanged=!!lastCoordSys&&lastCoordSys.length===dataByCoordSys.length;contentNotChanged&&each$10(lastCoordSys,function(lastItemCoordSys,indexCoordSys){var lastDataByAxis=lastItemCoordSys.dataByAxis||{};var thisItemCoordSys=dataByCoordSys[indexCoordSys]||{};var thisDataByAxis=thisItemCoordSys.dataByAxis||[];contentNotChanged&=lastDataByAxis.length===thisDataByAxis.length;contentNotChanged&&each$10(lastDataByAxis,function(lastItem,indexAxis){var thisItem=thisDataByAxis[indexAxis]||{};var lastIndices=lastItem.seriesDataIndices||[];var newIndices=thisItem.seriesDataIndices||[];contentNotChanged&=lastItem.value===thisItem.value&&lastItem.axisType===thisItem.axisType&&lastItem.axisId===thisItem.axisId&&lastIndices.length===newIndices.length;contentNotChanged&&each$10(lastIndices,function(lastIdxItem,j){var newIdxItem=newIndices[j];contentNotChanged&=lastIdxItem.seriesIndex===newIdxItem.seriesIndex&&lastIdxItem.dataIndex===newIdxItem.dataIndex;});});});this._lastDataByCoordSys=dataByCoordSys;return!!contentNotChanged;},_hide:function _hide(dispatchAction){// Do not directly hideLater here, because this behavior may be prevented
// in dispatchAction when showTip is dispatched.
// FIXME
// duplicated hideTip if manuallyHideTip is called from dispatchAction.
this._lastDataByCoordSys=null;dispatchAction({type:'hideTip',from:this.uid});},dispose:function dispose(ecModel,api){if(env$1.node||env$1.wxa){return;}this._tooltipContent.hide();unregister('itemTooltip',api);}});/**
 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
 * From top to bottom. (the last one should be globalTooltipModel);
 */function buildTooltipModel(modelCascade){var resultModel=modelCascade.pop();while(modelCascade.length){var tooltipOpt=modelCascade.pop();if(tooltipOpt){if(Model.isInstance(tooltipOpt)){tooltipOpt=tooltipOpt.get('tooltip',true);}// In each data item tooltip can be simply write:
// {
//  value: 10,
//  tooltip: 'Something you need to know'
// }
if(typeof tooltipOpt==='string'){tooltipOpt={formatter:tooltipOpt};}resultModel=new Model(tooltipOpt,resultModel,resultModel.ecModel);}}return resultModel;}function makeDispatchAction$1(payload,api){return payload.dispatchAction||bind(api.dispatchAction,api);}function refixTooltipPosition(x,y,el,viewWidth,viewHeight,gapH,gapV){var size=getOuterSize(el);var width=size.width;var height=size.height;if(gapH!=null){if(x+width+gapH>viewWidth){x-=width+gapH;}else{x+=gapH;}}if(gapV!=null){if(y+height+gapV>viewHeight){y-=height+gapV;}else{y+=gapV;}}return[x,y];}function confineTooltipPosition(x,y,el,viewWidth,viewHeight){var size=getOuterSize(el);var width=size.width;var height=size.height;x=Math.min(x+width,viewWidth)-width;y=Math.min(y+height,viewHeight)-height;x=Math.max(x,0);y=Math.max(y,0);return[x,y];}function getOuterSize(el){var width=el.clientWidth;var height=el.clientHeight;// Consider browser compatibility.
// IE8 does not support getComputedStyle.
if(document.defaultView&&document.defaultView.getComputedStyle){var stl=document.defaultView.getComputedStyle(el);if(stl){width+=parseInt(stl.paddingLeft,10)+parseInt(stl.paddingRight,10)+parseInt(stl.borderLeftWidth,10)+parseInt(stl.borderRightWidth,10);height+=parseInt(stl.paddingTop,10)+parseInt(stl.paddingBottom,10)+parseInt(stl.borderTopWidth,10)+parseInt(stl.borderBottomWidth,10);}}return{width:width,height:height};}function calcTooltipPosition(position,rect,contentSize){var domWidth=contentSize[0];var domHeight=contentSize[1];var gap=5;var x=0;var y=0;var rectWidth=rect.width;var rectHeight=rect.height;switch(position){case'inside':x=rect.x+rectWidth/2-domWidth/2;y=rect.y+rectHeight/2-domHeight/2;break;case'top':x=rect.x+rectWidth/2-domWidth/2;y=rect.y-domHeight-gap;break;case'bottom':x=rect.x+rectWidth/2-domWidth/2;y=rect.y+rectHeight+gap;break;case'left':x=rect.x-domWidth-gap;y=rect.y+rectHeight/2-domHeight/2;break;case'right':x=rect.x+rectWidth+gap;y=rect.y+rectHeight/2-domHeight/2;}return[x,y];}function isCenterAlign(align){return align==='center'||align==='middle';}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// FIXME Better way to pack data in graphic element
/**
 * @action
 * @property {string} type
 * @property {number} seriesIndex
 * @property {number} dataIndex
 * @property {number} [x]
 * @property {number} [y]
 */registerAction({type:'showTip',event:'showTip',update:'tooltip:manuallyShowTip'},// noop
function(){});registerAction({type:'hideTip',event:'hideTip',update:'tooltip:manuallyHideTip'},// noop
function(){});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var addCommas$1=addCommas;var encodeHTML$1=encodeHTML;function fillLabel(opt){defaultEmphasis(opt,'label',['show']);}var MarkerModel=extendComponentModel({type:'marker',dependencies:['series','grid','polar','geo'],/**
   * @overrite
   */init:function init(option,parentModel,ecModel,extraOpt){this.mergeDefaultAndTheme(option,ecModel);this.mergeOption(option,ecModel,extraOpt.createdBySelf,true);},/**
   * @return {boolean}
   */isAnimationEnabled:function isAnimationEnabled(){if(env$1.node){return false;}var hostSeries=this.__hostSeries;return this.getShallow('animation')&&hostSeries&&hostSeries.isAnimationEnabled();},mergeOption:function mergeOption(newOpt,ecModel,createdBySelf,isInit){var MarkerModel=this.constructor;var modelPropName=this.mainType+'Model';if(!createdBySelf){ecModel.eachSeries(function(seriesModel){var markerOpt=seriesModel.get(this.mainType,true);var markerModel=seriesModel[modelPropName];if(!markerOpt||!markerOpt.data){seriesModel[modelPropName]=null;return;}if(!markerModel){if(isInit){// Default label emphasis `position` and `show`
fillLabel(markerOpt);}each$1(markerOpt.data,function(item){// FIXME Overwrite fillLabel method ?
if(item instanceof Array){fillLabel(item[0]);fillLabel(item[1]);}else{fillLabel(item);}});markerModel=new MarkerModel(markerOpt,this,ecModel);extend(markerModel,{mainType:this.mainType,// Use the same series index and name
seriesIndex:seriesModel.seriesIndex,name:seriesModel.name,createdBySelf:true});markerModel.__hostSeries=seriesModel;}else{markerModel.mergeOption(markerOpt,ecModel,true);}seriesModel[modelPropName]=markerModel;},this);}},formatTooltip:function formatTooltip(dataIndex){var data=this.getData();var value=this.getRawValue(dataIndex);var formattedValue=isArray(value)?map(value,addCommas$1).join(', '):addCommas$1(value);var name=data.getName(dataIndex);var html=encodeHTML$1(this.name);if(value!=null||name){html+='<br />';}if(name){html+=encodeHTML$1(name);if(value!=null){html+=' : ';}}if(value!=null){html+=encodeHTML$1(formattedValue);}return html;},getData:function getData(){return this._data;},setData:function setData(data){this._data=data;}});mixin(MarkerModel,dataFormatMixin);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/MarkerModel.extend({type:'markPoint',defaultOption:{zlevel:0,z:5,symbol:'pin',symbolSize:50,//symbolRotate: 0,
//symbolOffset: [0, 0]
tooltip:{trigger:'item'},label:{show:true,position:'inside'},itemStyle:{borderWidth:2},emphasis:{label:{show:true}}}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var indexOf$1=indexOf;function hasXOrY(item){return!(isNaN(parseFloat(item.x))&&isNaN(parseFloat(item.y)));}function hasXAndY(item){return!isNaN(parseFloat(item.x))&&!isNaN(parseFloat(item.y));}// Make it simple, do not visit all stacked value to count precision.
// function getPrecision(data, valueAxisDim, dataIndex) {
//     var precision = -1;
//     var stackedDim = data.mapDimension(valueAxisDim);
//     do {
//         precision = Math.max(
//             numberUtil.getPrecision(data.get(stackedDim, dataIndex)),
//             precision
//         );
//         var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
//         if (stackedOnSeries) {
//             var byValue = data.get(data.getCalculationInfo('stackedByDimension'), dataIndex);
//             data = stackedOnSeries.getData();
//             dataIndex = data.indexOf(data.getCalculationInfo('stackedByDimension'), byValue);
//             stackedDim = data.getCalculationInfo('stackedDimension');
//         }
//         else {
//             data = null;
//         }
//     } while (data);
//     return precision;
// }
function markerTypeCalculatorWithExtent(mlType,data,otherDataDim,targetDataDim,otherCoordIndex,targetCoordIndex){var coordArr=[];var stacked=isDimensionStacked(data,targetDataDim/*, otherDataDim*/);var calcDataDim=stacked?data.getCalculationInfo('stackResultDimension'):targetDataDim;var value=numCalculate(data,calcDataDim,mlType);var dataIndex=data.indicesOfNearest(calcDataDim,value)[0];coordArr[otherCoordIndex]=data.get(otherDataDim,dataIndex);coordArr[targetCoordIndex]=data.get(targetDataDim,dataIndex);// Make it simple, do not visit all stacked value to count precision.
var precision=getPrecision(data.get(targetDataDim,dataIndex));precision=Math.min(precision,20);if(precision>=0){coordArr[targetCoordIndex]=+coordArr[targetCoordIndex].toFixed(precision);}return coordArr;}var curry$4=curry;// TODO Specified percent
var markerTypeCalculator={/**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */min:curry$4(markerTypeCalculatorWithExtent,'min'),/**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */max:curry$4(markerTypeCalculatorWithExtent,'max'),/**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */average:curry$4(markerTypeCalculatorWithExtent,'average')};/**
 * Transform markPoint data item to format used in List by do the following
 * 1. Calculate statistic like `max`, `min`, `average`
 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
 * @param  {module:echarts/model/Series} seriesModel
 * @param  {module:echarts/coord/*} [coordSys]
 * @param  {Object} item
 * @return {Object}
 */function dataTransform(seriesModel,item){var data=seriesModel.getData();var coordSys=seriesModel.coordinateSystem;// 1. If not specify the position with pixel directly
// 2. If `coord` is not a data array. Which uses `xAxis`,
// `yAxis` to specify the coord on each dimension
// parseFloat first because item.x and item.y can be percent string like '20%'
if(item&&!hasXAndY(item)&&!isArray(item.coord)&&coordSys){var dims=coordSys.dimensions;var axisInfo=getAxisInfo$1(item,data,coordSys,seriesModel);// Clone the option
// Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
item=_clone(item);if(item.type&&markerTypeCalculator[item.type]&&axisInfo.baseAxis&&axisInfo.valueAxis){var otherCoordIndex=indexOf$1(dims,axisInfo.baseAxis.dim);var targetCoordIndex=indexOf$1(dims,axisInfo.valueAxis.dim);item.coord=markerTypeCalculator[item.type](data,axisInfo.baseDataDim,axisInfo.valueDataDim,otherCoordIndex,targetCoordIndex);// Force to use the value of calculated value.
item.value=item.coord[targetCoordIndex];}else{// FIXME Only has one of xAxis and yAxis.
var coord=[item.xAxis!=null?item.xAxis:item.radiusAxis,item.yAxis!=null?item.yAxis:item.angleAxis];// Each coord support max, min, average
for(var i=0;i<2;i++){if(markerTypeCalculator[coord[i]]){coord[i]=numCalculate(data,data.mapDimension(dims[i]),coord[i]);}}item.coord=coord;}}return item;}function getAxisInfo$1(item,data,coordSys,seriesModel){var ret={};if(item.valueIndex!=null||item.valueDim!=null){ret.valueDataDim=item.valueIndex!=null?data.getDimension(item.valueIndex):item.valueDim;ret.valueAxis=coordSys.getAxis(dataDimToCoordDim(seriesModel,ret.valueDataDim));ret.baseAxis=coordSys.getOtherAxis(ret.valueAxis);ret.baseDataDim=data.mapDimension(ret.baseAxis.dim);}else{ret.baseAxis=seriesModel.getBaseAxis();ret.valueAxis=coordSys.getOtherAxis(ret.baseAxis);ret.baseDataDim=data.mapDimension(ret.baseAxis.dim);ret.valueDataDim=data.mapDimension(ret.valueAxis.dim);}return ret;}function dataDimToCoordDim(seriesModel,dataDim){var data=seriesModel.getData();var dimensions=data.dimensions;dataDim=data.getDimension(dataDim);for(var i=0;i<dimensions.length;i++){var dimItem=data.getDimensionInfo(dimensions[i]);if(dimItem.name===dataDim){return dimItem.coordDim;}}}/**
 * Filter data which is out of coordinateSystem range
 * [dataFilter description]
 * @param  {module:echarts/coord/*} [coordSys]
 * @param  {Object} item
 * @return {boolean}
 */function dataFilter(coordSys,item){// Alwalys return true if there is no coordSys
return coordSys&&coordSys.containData&&item.coord&&!hasXOrY(item)?coordSys.containData(item.coord):true;}function dimValueGetter(item,dimName,dataIndex,dimIndex){// x, y, radius, angle
if(dimIndex<2){return item.coord&&item.coord[dimIndex];}return item.value;}function numCalculate(data,valueDataDim,type){if(type==='average'){var sum=0;var count=0;data.each(valueDataDim,function(val,idx){if(!isNaN(val)){sum+=val;count++;}});return sum/count;}else if(type==='median'){return data.getMedian(valueDataDim);}else{// max & min
return data.getDataExtent(valueDataDim,true)[type==='max'?1:0];}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var MarkerView=extendComponentView({type:'marker',init:function init(){/**
     * Markline grouped by series
     * @private
     * @type {module:zrender/core/util.HashMap}
     */this.markerGroupMap=createHashMap();},render:function render(markerModel,ecModel,api){var markerGroupMap=this.markerGroupMap;markerGroupMap.each(function(item){item.__keep=false;});var markerModelKey=this.type+'Model';ecModel.eachSeries(function(seriesModel){var markerModel=seriesModel[markerModelKey];markerModel&&this.renderSeries(seriesModel,markerModel,ecModel,api);},this);markerGroupMap.each(function(item){!item.__keep&&this.group.remove(item.group);},this);},renderSeries:function renderSeries(){}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/function updateMarkerLayout(mpData,seriesModel,api){var coordSys=seriesModel.coordinateSystem;mpData.each(function(idx){var itemModel=mpData.getItemModel(idx);var point;var xPx=parsePercent$1(itemModel.get('x'),api.getWidth());var yPx=parsePercent$1(itemModel.get('y'),api.getHeight());if(!isNaN(xPx)&&!isNaN(yPx)){point=[xPx,yPx];}// Chart like bar may have there own marker positioning logic
else if(seriesModel.getMarkerPosition){// Use the getMarkerPoisition
point=seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions,idx));}else if(coordSys){var x=mpData.get(coordSys.dimensions[0],idx);var y=mpData.get(coordSys.dimensions[1],idx);point=coordSys.dataToPoint([x,y]);}// Use x, y if has any
if(!isNaN(xPx)){point[0]=xPx;}if(!isNaN(yPx)){point[1]=yPx;}mpData.setItemLayout(idx,point);});}MarkerView.extend({type:'markPoint',// updateLayout: function (markPointModel, ecModel, api) {
//     ecModel.eachSeries(function (seriesModel) {
//         var mpModel = seriesModel.markPointModel;
//         if (mpModel) {
//             updateMarkerLayout(mpModel.getData(), seriesModel, api);
//             this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
//         }
//     }, this);
// },
updateTransform:function updateTransform(markPointModel,ecModel,api){ecModel.eachSeries(function(seriesModel){var mpModel=seriesModel.markPointModel;if(mpModel){updateMarkerLayout(mpModel.getData(),seriesModel,api);this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);}},this);},renderSeries:function renderSeries(seriesModel,mpModel,ecModel,api){var coordSys=seriesModel.coordinateSystem;var seriesId=seriesModel.id;var seriesData=seriesModel.getData();var symbolDrawMap=this.markerGroupMap;var symbolDraw=symbolDrawMap.get(seriesId)||symbolDrawMap.set(seriesId,new SymbolDraw());var mpData=createList$1(coordSys,seriesModel,mpModel);// FIXME
mpModel.setData(mpData);updateMarkerLayout(mpModel.getData(),seriesModel,api);mpData.each(function(idx){var itemModel=mpData.getItemModel(idx);var symbolSize=itemModel.getShallow('symbolSize');if(typeof symbolSize==='function'){// FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
symbolSize=symbolSize(mpModel.getRawValue(idx),mpModel.getDataParams(idx));}mpData.setItemVisual(idx,{symbolSize:symbolSize,color:itemModel.get('itemStyle.color')||seriesData.getVisual('color'),symbol:itemModel.getShallow('symbol')});});// TODO Text are wrong
symbolDraw.updateData(mpData);this.group.add(symbolDraw.group);// Set host model for tooltip
// FIXME
mpData.eachItemGraphicEl(function(el){el.traverse(function(child){child.dataModel=mpModel;});});symbolDraw.__keep=true;symbolDraw.group.silent=mpModel.get('silent')||seriesModel.get('silent');}});/**
 * @inner
 * @param {module:echarts/coord/*} [coordSys]
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */function createList$1(coordSys,seriesModel,mpModel){var coordDimsInfos;if(coordSys){coordDimsInfos=map(coordSys&&coordSys.dimensions,function(coordDim){var info=seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim))||{};// In map series data don't have lng and lat dimension. Fallback to same with coordSys
return defaults({name:coordDim},info);});}else{coordDimsInfos=[{name:'value',type:'float'}];}var mpData=new List(coordDimsInfos,mpModel);var dataOpt=map(mpModel.get('data'),curry(dataTransform,seriesModel));if(coordSys){dataOpt=filter(dataOpt,curry(dataFilter,coordSys));}mpData.initData(dataOpt,null,coordSys?dimValueGetter:function(item){return item.value;});return mpData;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// HINT Markpoint can't be used too much
registerPreprocessor(function(opt){// Make sure markPoint component is enabled
opt.markPoint=opt.markPoint||{};});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/MarkerModel.extend({type:'markLine',defaultOption:{zlevel:0,z:5,symbol:['circle','arrow'],symbolSize:[8,16],//symbolRotate: 0,
precision:2,tooltip:{trigger:'item'},label:{show:true,position:'end'},lineStyle:{type:'dashed'},emphasis:{label:{show:true},lineStyle:{width:3}},animationEasing:'linear'}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Line path for bezier and straight line draw
 */var straightLineProto=Line.prototype;var bezierCurveProto=BezierCurve.prototype;function isLine(shape){return isNaN(+shape.cpx1)||isNaN(+shape.cpy1);}var LinePath=extendShape({type:'ec-line',style:{stroke:'#000',fill:null},shape:{x1:0,y1:0,x2:0,y2:0,percent:1,cpx1:null,cpy1:null},buildPath:function buildPath(ctx,shape){(isLine(shape)?straightLineProto:bezierCurveProto).buildPath(ctx,shape);},pointAt:function pointAt(t){return isLine(this.shape)?straightLineProto.pointAt.call(this,t):bezierCurveProto.pointAt.call(this,t);},tangentAt:function tangentAt(t){var shape=this.shape;var p=isLine(shape)?[shape.x2-shape.x1,shape.y2-shape.y1]:bezierCurveProto.tangentAt.call(this,t);return normalize(p,p);}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @module echarts/chart/helper/Line
 */var SYMBOL_CATEGORIES=['fromSymbol','toSymbol'];function makeSymbolTypeKey(symbolCategory){return'_'+symbolCategory+'Type';}/**
 * @inner
 */function createSymbol$1(name,lineData,idx){var color=lineData.getItemVisual(idx,'color');var symbolType=lineData.getItemVisual(idx,name);var symbolSize=lineData.getItemVisual(idx,name+'Size');if(!symbolType||symbolType==='none'){return;}if(!isArray(symbolSize)){symbolSize=[symbolSize,symbolSize];}var symbolPath=createSymbol(symbolType,-symbolSize[0]/2,-symbolSize[1]/2,symbolSize[0],symbolSize[1],color);symbolPath.name=name;return symbolPath;}function createLine(points){var line=new LinePath({name:'line'});setLinePoints(line.shape,points);return line;}function setLinePoints(targetShape,points){var p1=points[0];var p2=points[1];var cp1=points[2];targetShape.x1=p1[0];targetShape.y1=p1[1];targetShape.x2=p2[0];targetShape.y2=p2[1];targetShape.percent=1;if(cp1){targetShape.cpx1=cp1[0];targetShape.cpy1=cp1[1];}else{targetShape.cpx1=NaN;targetShape.cpy1=NaN;}}function updateSymbolAndLabelBeforeLineUpdate(){var lineGroup=this;var symbolFrom=lineGroup.childOfName('fromSymbol');var symbolTo=lineGroup.childOfName('toSymbol');var label=lineGroup.childOfName('label');// Quick reject
if(!symbolFrom&&!symbolTo&&label.ignore){return;}var invScale=1;var parentNode=this.parent;while(parentNode){if(parentNode.scale){invScale/=parentNode.scale[0];}parentNode=parentNode.parent;}var line=lineGroup.childOfName('line');// If line not changed
// FIXME Parent scale changed
if(!this.__dirty&&!line.__dirty){return;}var percent=line.shape.percent;var fromPos=line.pointAt(0);var toPos=line.pointAt(percent);var d=sub([],toPos,fromPos);normalize(d,d);if(symbolFrom){symbolFrom.attr('position',fromPos);var tangent=line.tangentAt(0);symbolFrom.attr('rotation',Math.PI/2-Math.atan2(tangent[1],tangent[0]));symbolFrom.attr('scale',[invScale*percent,invScale*percent]);}if(symbolTo){symbolTo.attr('position',toPos);var tangent=line.tangentAt(1);symbolTo.attr('rotation',-Math.PI/2-Math.atan2(tangent[1],tangent[0]));symbolTo.attr('scale',[invScale*percent,invScale*percent]);}if(!label.ignore){label.attr('position',toPos);var textPosition;var textAlign;var textVerticalAlign;var distance$$1=5*invScale;// End
if(label.__position==='end'){textPosition=[d[0]*distance$$1+toPos[0],d[1]*distance$$1+toPos[1]];textAlign=d[0]>0.8?'left':d[0]<-0.8?'right':'center';textVerticalAlign=d[1]>0.8?'top':d[1]<-0.8?'bottom':'middle';}// Middle
else if(label.__position==='middle'){var halfPercent=percent/2;var tangent=line.tangentAt(halfPercent);var n=[tangent[1],-tangent[0]];var cp=line.pointAt(halfPercent);if(n[1]>0){n[0]=-n[0];n[1]=-n[1];}textPosition=[cp[0]+n[0]*distance$$1,cp[1]+n[1]*distance$$1];textAlign='center';textVerticalAlign='bottom';var rotation=-Math.atan2(tangent[1],tangent[0]);if(toPos[0]<fromPos[0]){rotation=Math.PI+rotation;}label.attr('rotation',rotation);}// Start
else{textPosition=[-d[0]*distance$$1+fromPos[0],-d[1]*distance$$1+fromPos[1]];textAlign=d[0]>0.8?'right':d[0]<-0.8?'left':'center';textVerticalAlign=d[1]>0.8?'bottom':d[1]<-0.8?'top':'middle';}label.attr({style:{// Use the user specified text align and baseline first
textVerticalAlign:label.__verticalAlign||textVerticalAlign,textAlign:label.__textAlign||textAlign},position:textPosition,scale:[invScale,invScale]});}}/**
 * @constructor
 * @extends {module:zrender/graphic/Group}
 * @alias {module:echarts/chart/helper/Line}
 */function Line$1(lineData,idx,seriesScope){Group.call(this);this._createLine(lineData,idx,seriesScope);}var lineProto=Line$1.prototype;// Update symbol position and rotation
lineProto.beforeUpdate=updateSymbolAndLabelBeforeLineUpdate;lineProto._createLine=function(lineData,idx,seriesScope){var seriesModel=lineData.hostModel;var linePoints=lineData.getItemLayout(idx);var line=createLine(linePoints);line.shape.percent=0;initProps(line,{shape:{percent:1}},seriesModel,idx);this.add(line);var label=new Text({name:'label'});this.add(label);each$1(SYMBOL_CATEGORIES,function(symbolCategory){var symbol=createSymbol$1(symbolCategory,lineData,idx);// symbols must added after line to make sure
// it will be updated after line#update.
// Or symbol position and rotation update in line#beforeUpdate will be one frame slow
this.add(symbol);this[makeSymbolTypeKey(symbolCategory)]=lineData.getItemVisual(idx,symbolCategory);},this);this._updateCommonStl(lineData,idx,seriesScope);};lineProto.updateData=function(lineData,idx,seriesScope){var seriesModel=lineData.hostModel;var line=this.childOfName('line');var linePoints=lineData.getItemLayout(idx);var target={shape:{}};setLinePoints(target.shape,linePoints);updateProps(line,target,seriesModel,idx);each$1(SYMBOL_CATEGORIES,function(symbolCategory){var symbolType=lineData.getItemVisual(idx,symbolCategory);var key=makeSymbolTypeKey(symbolCategory);// Symbol changed
if(this[key]!==symbolType){this.remove(this.childOfName(symbolCategory));var symbol=createSymbol$1(symbolCategory,lineData,idx);this.add(symbol);}this[key]=symbolType;},this);this._updateCommonStl(lineData,idx,seriesScope);};lineProto._updateCommonStl=function(lineData,idx,seriesScope){var seriesModel=lineData.hostModel;var line=this.childOfName('line');var lineStyle=seriesScope&&seriesScope.lineStyle;var hoverLineStyle=seriesScope&&seriesScope.hoverLineStyle;var labelModel=seriesScope&&seriesScope.labelModel;var hoverLabelModel=seriesScope&&seriesScope.hoverLabelModel;// Optimization for large dataset
if(!seriesScope||lineData.hasItemOption){var itemModel=lineData.getItemModel(idx);lineStyle=itemModel.getModel('lineStyle').getLineStyle();hoverLineStyle=itemModel.getModel('emphasis.lineStyle').getLineStyle();labelModel=itemModel.getModel('label');hoverLabelModel=itemModel.getModel('emphasis.label');}var visualColor=lineData.getItemVisual(idx,'color');var visualOpacity=retrieve3(lineData.getItemVisual(idx,'opacity'),lineStyle.opacity,1);line.useStyle(defaults({strokeNoScale:true,fill:'none',stroke:visualColor,opacity:visualOpacity},lineStyle));line.hoverStyle=hoverLineStyle;// Update symbol
each$1(SYMBOL_CATEGORIES,function(symbolCategory){var symbol=this.childOfName(symbolCategory);if(symbol){symbol.setColor(visualColor);symbol.setStyle({opacity:visualOpacity});}},this);var showLabel=labelModel.getShallow('show');var hoverShowLabel=hoverLabelModel.getShallow('show');var label=this.childOfName('label');var defaultLabelColor;var baseText;// FIXME: the logic below probably should be merged to `graphic.setLabelStyle`.
if(showLabel||hoverShowLabel){defaultLabelColor=visualColor||'#000';baseText=seriesModel.getFormattedLabel(idx,'normal',lineData.dataType);if(baseText==null){var rawVal=seriesModel.getRawValue(idx);baseText=rawVal==null?lineData.getName(idx):isFinite(rawVal)?round$1(rawVal):rawVal;}}var normalText=showLabel?baseText:null;var emphasisText=hoverShowLabel?retrieve2(seriesModel.getFormattedLabel(idx,'emphasis',lineData.dataType),baseText):null;var labelStyle=label.style;// Always set `textStyle` even if `normalStyle.text` is null, because default
// values have to be set on `normalStyle`.
if(normalText!=null||emphasisText!=null){setTextStyle(label.style,labelModel,{text:normalText},{autoColor:defaultLabelColor});label.__textAlign=labelStyle.textAlign;label.__verticalAlign=labelStyle.textVerticalAlign;// 'start', 'middle', 'end'
label.__position=labelModel.get('position')||'middle';}if(emphasisText!=null){// Only these properties supported in this emphasis style here.
label.hoverStyle={text:emphasisText,textFill:hoverLabelModel.getTextColor(true),// For merging hover style to normal style, do not use
// `hoverLabelModel.getFont()` here.
fontStyle:hoverLabelModel.getShallow('fontStyle'),fontWeight:hoverLabelModel.getShallow('fontWeight'),fontSize:hoverLabelModel.getShallow('fontSize'),fontFamily:hoverLabelModel.getShallow('fontFamily')};}else{label.hoverStyle={text:null};}label.ignore=!showLabel&&!hoverShowLabel;setHoverStyle(this);};lineProto.highlight=function(){this.trigger('emphasis');};lineProto.downplay=function(){this.trigger('normal');};lineProto.updateLayout=function(lineData,idx){this.setLinePoints(lineData.getItemLayout(idx));};lineProto.setLinePoints=function(points){var linePath=this.childOfName('line');setLinePoints(linePath.shape,points);linePath.dirty();};inherits(Line$1,Group);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @module echarts/chart/helper/LineDraw
 *//**
 * @alias module:echarts/component/marker/LineDraw
 * @constructor
 */function LineDraw(ctor){this._ctor=ctor||Line$1;this.group=new Group();}var lineDrawProto=LineDraw.prototype;lineDrawProto.isPersistent=function(){return true;};/**
 * @param {module:echarts/data/List} lineData
 */lineDrawProto.updateData=function(lineData){var lineDraw=this;var group=lineDraw.group;var oldLineData=lineDraw._lineData;lineDraw._lineData=lineData;// There is no oldLineData only when first rendering or switching from
// stream mode to normal mode, where previous elements should be removed.
if(!oldLineData){group.removeAll();}var seriesScope=makeSeriesScope$1(lineData);lineData.diff(oldLineData).add(function(idx){doAdd(lineDraw,lineData,idx,seriesScope);}).update(function(newIdx,oldIdx){doUpdate(lineDraw,oldLineData,lineData,oldIdx,newIdx,seriesScope);}).remove(function(idx){group.remove(oldLineData.getItemGraphicEl(idx));}).execute();};function doAdd(lineDraw,lineData,idx,seriesScope){var itemLayout=lineData.getItemLayout(idx);if(!lineNeedsDraw(itemLayout)){return;}var el=new lineDraw._ctor(lineData,idx,seriesScope);lineData.setItemGraphicEl(idx,el);lineDraw.group.add(el);}function doUpdate(lineDraw,oldLineData,newLineData,oldIdx,newIdx,seriesScope){var itemEl=oldLineData.getItemGraphicEl(oldIdx);if(!lineNeedsDraw(newLineData.getItemLayout(newIdx))){lineDraw.group.remove(itemEl);return;}if(!itemEl){itemEl=new lineDraw._ctor(newLineData,newIdx,seriesScope);}else{itemEl.updateData(newLineData,newIdx,seriesScope);}newLineData.setItemGraphicEl(newIdx,itemEl);lineDraw.group.add(itemEl);}lineDrawProto.updateLayout=function(){var lineData=this._lineData;// Do not support update layout in incremental mode.
if(!lineData){return;}lineData.eachItemGraphicEl(function(el,idx){el.updateLayout(lineData,idx);},this);};lineDrawProto.incrementalPrepareUpdate=function(lineData){this._seriesScope=makeSeriesScope$1(lineData);this._lineData=null;this.group.removeAll();};lineDrawProto.incrementalUpdate=function(taskParams,lineData){function updateIncrementalAndHover(el){if(!el.isGroup){el.incremental=el.useHoverLayer=true;}}for(var idx=taskParams.start;idx<taskParams.end;idx++){var itemLayout=lineData.getItemLayout(idx);if(lineNeedsDraw(itemLayout)){var el=new this._ctor(lineData,idx,this._seriesScope);el.traverse(updateIncrementalAndHover);this.group.add(el);lineData.setItemGraphicEl(idx,el);}}};function makeSeriesScope$1(lineData){var hostModel=lineData.hostModel;return{lineStyle:hostModel.getModel('lineStyle').getLineStyle(),hoverLineStyle:hostModel.getModel('emphasis.lineStyle').getLineStyle(),labelModel:hostModel.getModel('label'),hoverLabelModel:hostModel.getModel('emphasis.label')};}lineDrawProto.remove=function(){this._clearIncremental();this._incremental=null;this.group.removeAll();};lineDrawProto._clearIncremental=function(){var incremental=this._incremental;if(incremental){incremental.clearDisplaybles();}};function isPointNaN(pt){return isNaN(pt[0])||isNaN(pt[1]);}function lineNeedsDraw(pts){return!isPointNaN(pts[0])&&!isPointNaN(pts[1]);}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var markLineTransform=function markLineTransform(seriesModel,coordSys,mlModel,item){var data=seriesModel.getData();// Special type markLine like 'min', 'max', 'average', 'median'
var mlType=item.type;if(!isArray(item)&&(mlType==='min'||mlType==='max'||mlType==='average'||mlType==='median'// In case
// data: [{
//   yAxis: 10
// }]
||item.xAxis!=null||item.yAxis!=null)){var valueAxis;var valueDataDim;var value;if(item.yAxis!=null||item.xAxis!=null){valueDataDim=item.yAxis!=null?'y':'x';valueAxis=coordSys.getAxis(valueDataDim);value=retrieve(item.yAxis,item.xAxis);}else{var axisInfo=getAxisInfo$1(item,data,coordSys,seriesModel);valueDataDim=axisInfo.valueDataDim;valueAxis=axisInfo.valueAxis;value=numCalculate(data,valueDataDim,mlType);}var valueIndex=valueDataDim==='x'?0:1;var baseIndex=1-valueIndex;var mlFrom=_clone(item);var mlTo={};mlFrom.type=null;mlFrom.coord=[];mlTo.coord=[];mlFrom.coord[baseIndex]=-Infinity;mlTo.coord[baseIndex]=Infinity;var precision=mlModel.get('precision');if(precision>=0&&typeof value==='number'){value=+value.toFixed(Math.min(precision,20));}mlFrom.coord[valueIndex]=mlTo.coord[valueIndex]=value;item=[mlFrom,mlTo,{// Extra option for tooltip and label
type:mlType,valueIndex:item.valueIndex,// Force to use the value of calculated value.
value:value}];}item=[dataTransform(seriesModel,item[0]),dataTransform(seriesModel,item[1]),extend({},item[2])];// Avoid line data type is extended by from(to) data type
item[2].type=item[2].type||'';// Merge from option and to option into line option
merge(item[2],item[0]);merge(item[2],item[1]);return item;};function isInifinity(val){return!isNaN(val)&&!isFinite(val);}// If a markLine has one dim
function ifMarkLineHasOnlyDim(dimIndex,fromCoord,toCoord,coordSys){var otherDimIndex=1-dimIndex;var dimName=coordSys.dimensions[dimIndex];return isInifinity(fromCoord[otherDimIndex])&&isInifinity(toCoord[otherDimIndex])&&fromCoord[dimIndex]===toCoord[dimIndex]&&coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);}function markLineFilter(coordSys,item){if(coordSys.type==='cartesian2d'){var fromCoord=item[0].coord;var toCoord=item[1].coord;// In case
// {
//  markLine: {
//    data: [{ yAxis: 2 }]
//  }
// }
if(fromCoord&&toCoord&&(ifMarkLineHasOnlyDim(1,fromCoord,toCoord,coordSys)||ifMarkLineHasOnlyDim(0,fromCoord,toCoord,coordSys))){return true;}}return dataFilter(coordSys,item[0])&&dataFilter(coordSys,item[1]);}function updateSingleMarkerEndLayout(data,idx,isFrom,seriesModel,api){var coordSys=seriesModel.coordinateSystem;var itemModel=data.getItemModel(idx);var point;var xPx=parsePercent$1(itemModel.get('x'),api.getWidth());var yPx=parsePercent$1(itemModel.get('y'),api.getHeight());if(!isNaN(xPx)&&!isNaN(yPx)){point=[xPx,yPx];}else{// Chart like bar may have there own marker positioning logic
if(seriesModel.getMarkerPosition){// Use the getMarkerPoisition
point=seriesModel.getMarkerPosition(data.getValues(data.dimensions,idx));}else{var dims=coordSys.dimensions;var x=data.get(dims[0],idx);var y=data.get(dims[1],idx);point=coordSys.dataToPoint([x,y]);}// Expand line to the edge of grid if value on one axis is Inifnity
// In case
//  markLine: {
//    data: [{
//      yAxis: 2
//      // or
//      type: 'average'
//    }]
//  }
if(coordSys.type==='cartesian2d'){var xAxis=coordSys.getAxis('x');var yAxis=coordSys.getAxis('y');var dims=coordSys.dimensions;if(isInifinity(data.get(dims[0],idx))){point[0]=xAxis.toGlobalCoord(xAxis.getExtent()[isFrom?0:1]);}else if(isInifinity(data.get(dims[1],idx))){point[1]=yAxis.toGlobalCoord(yAxis.getExtent()[isFrom?0:1]);}}// Use x, y if has any
if(!isNaN(xPx)){point[0]=xPx;}if(!isNaN(yPx)){point[1]=yPx;}}data.setItemLayout(idx,point);}MarkerView.extend({type:'markLine',// updateLayout: function (markLineModel, ecModel, api) {
//     ecModel.eachSeries(function (seriesModel) {
//         var mlModel = seriesModel.markLineModel;
//         if (mlModel) {
//             var mlData = mlModel.getData();
//             var fromData = mlModel.__from;
//             var toData = mlModel.__to;
//             // Update visual and layout of from symbol and to symbol
//             fromData.each(function (idx) {
//                 updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
//                 updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
//             });
//             // Update layout of line
//             mlData.each(function (idx) {
//                 mlData.setItemLayout(idx, [
//                     fromData.getItemLayout(idx),
//                     toData.getItemLayout(idx)
//                 ]);
//             });
//             this.markerGroupMap.get(seriesModel.id).updateLayout();
//         }
//     }, this);
// },
updateTransform:function updateTransform(markLineModel,ecModel,api){ecModel.eachSeries(function(seriesModel){var mlModel=seriesModel.markLineModel;if(mlModel){var mlData=mlModel.getData();var fromData=mlModel.__from;var toData=mlModel.__to;// Update visual and layout of from symbol and to symbol
fromData.each(function(idx){updateSingleMarkerEndLayout(fromData,idx,true,seriesModel,api);updateSingleMarkerEndLayout(toData,idx,false,seriesModel,api);});// Update layout of line
mlData.each(function(idx){mlData.setItemLayout(idx,[fromData.getItemLayout(idx),toData.getItemLayout(idx)]);});this.markerGroupMap.get(seriesModel.id).updateLayout();}},this);},renderSeries:function renderSeries(seriesModel,mlModel,ecModel,api){var coordSys=seriesModel.coordinateSystem;var seriesId=seriesModel.id;var seriesData=seriesModel.getData();var lineDrawMap=this.markerGroupMap;var lineDraw=lineDrawMap.get(seriesId)||lineDrawMap.set(seriesId,new LineDraw());this.group.add(lineDraw.group);var mlData=createList$2(coordSys,seriesModel,mlModel);var fromData=mlData.from;var toData=mlData.to;var lineData=mlData.line;mlModel.__from=fromData;mlModel.__to=toData;// Line data for tooltip and formatter
mlModel.setData(lineData);var symbolType=mlModel.get('symbol');var symbolSize=mlModel.get('symbolSize');if(!isArray(symbolType)){symbolType=[symbolType,symbolType];}if(typeof symbolSize==='number'){symbolSize=[symbolSize,symbolSize];}// Update visual and layout of from symbol and to symbol
mlData.from.each(function(idx){updateDataVisualAndLayout(fromData,idx,true);updateDataVisualAndLayout(toData,idx,false);});// Update visual and layout of line
lineData.each(function(idx){var lineColor=lineData.getItemModel(idx).get('lineStyle.color');lineData.setItemVisual(idx,{color:lineColor||fromData.getItemVisual(idx,'color')});lineData.setItemLayout(idx,[fromData.getItemLayout(idx),toData.getItemLayout(idx)]);lineData.setItemVisual(idx,{'fromSymbolSize':fromData.getItemVisual(idx,'symbolSize'),'fromSymbol':fromData.getItemVisual(idx,'symbol'),'toSymbolSize':toData.getItemVisual(idx,'symbolSize'),'toSymbol':toData.getItemVisual(idx,'symbol')});});lineDraw.updateData(lineData);// Set host model for tooltip
// FIXME
mlData.line.eachItemGraphicEl(function(el,idx){el.traverse(function(child){child.dataModel=mlModel;});});function updateDataVisualAndLayout(data,idx,isFrom){var itemModel=data.getItemModel(idx);updateSingleMarkerEndLayout(data,idx,isFrom,seriesModel,api);data.setItemVisual(idx,{symbolSize:itemModel.get('symbolSize')||symbolSize[isFrom?0:1],symbol:itemModel.get('symbol',true)||symbolType[isFrom?0:1],color:itemModel.get('itemStyle.color')||seriesData.getVisual('color')});}lineDraw.__keep=true;lineDraw.group.silent=mlModel.get('silent')||seriesModel.get('silent');}});/**
 * @inner
 * @param {module:echarts/coord/*} coordSys
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */function createList$2(coordSys,seriesModel,mlModel){var coordDimsInfos;if(coordSys){coordDimsInfos=map(coordSys&&coordSys.dimensions,function(coordDim){var info=seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim))||{};// In map series data don't have lng and lat dimension. Fallback to same with coordSys
return defaults({name:coordDim},info);});}else{coordDimsInfos=[{name:'value',type:'float'}];}var fromData=new List(coordDimsInfos,mlModel);var toData=new List(coordDimsInfos,mlModel);// No dimensions
var lineData=new List([],mlModel);var optData=map(mlModel.get('data'),curry(markLineTransform,seriesModel,coordSys,mlModel));if(coordSys){optData=filter(optData,curry(markLineFilter,coordSys));}var dimValueGetter$$1=coordSys?dimValueGetter:function(item){return item.value;};fromData.initData(map(optData,function(item){return item[0];}),null,dimValueGetter$$1);toData.initData(map(optData,function(item){return item[1];}),null,dimValueGetter$$1);lineData.initData(map(optData,function(item){return item[2];}));lineData.hasItemOption=true;return{from:fromData,to:toData,line:lineData};}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/registerPreprocessor(function(opt){// Make sure markLine component is enabled
opt.markLine=opt.markLine||{};});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ComponentModel.registerSubTypeDefaulter('dataZoom',function(){// Default 'slider' when no type specified.
return'slider';});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var AXIS_DIMS=['x','y','z','radius','angle','single'];// Supported coords.
var COORDS=['cartesian2d','polar','singleAxis'];/**
 * @param {string} coordType
 * @return {boolean}
 */function isCoordSupported(coordType){return indexOf(COORDS,coordType)>=0;}/**
 * Create "each" method to iterate names.
 *
 * @pubilc
 * @param  {Array.<string>} names
 * @param  {Array.<string>=} attrs
 * @return {Function}
 */function createNameEach(names,attrs){names=names.slice();var capitalNames=map(names,capitalFirst);attrs=(attrs||[]).slice();var capitalAttrs=map(attrs,capitalFirst);return function(callback,context){each$1(names,function(name,index){var nameObj={name:name,capital:capitalNames[index]};for(var j=0;j<attrs.length;j++){nameObj[attrs[j]]=name+capitalAttrs[j];}callback.call(context,nameObj);});};}/**
 * Iterate each dimension name.
 *
 * @public
 * @param {Function} callback The parameter is like:
 *                            {
 *                                name: 'angle',
 *                                capital: 'Angle',
 *                                axis: 'angleAxis',
 *                                axisIndex: 'angleAixs',
 *                                index: 'angleIndex'
 *                            }
 * @param {Object} context
 */var eachAxisDim$1=createNameEach(AXIS_DIMS,['axisIndex','axis','index','id']);/**
 * If tow dataZoomModels has the same axis controlled, we say that they are 'linked'.
 * dataZoomModels and 'links' make up one or more graphics.
 * This function finds the graphic where the source dataZoomModel is in.
 *
 * @public
 * @param {Function} forEachNode Node iterator.
 * @param {Function} forEachEdgeType edgeType iterator
 * @param {Function} edgeIdGetter Giving node and edgeType, return an array of edge id.
 * @return {Function} Input: sourceNode, Output: Like {nodes: [], dims: {}}
 */function createLinkedNodesFinder(forEachNode,forEachEdgeType,edgeIdGetter){return function(sourceNode){var result={nodes:[],records:{}// key: edgeType.name, value: Object (key: edge id, value: boolean).
};forEachEdgeType(function(edgeType){result.records[edgeType.name]={};});if(!sourceNode){return result;}absorb(sourceNode,result);var existsLink;do{existsLink=false;forEachNode(processSingleNode);}while(existsLink);function processSingleNode(node){if(!isNodeAbsorded(node,result)&&isLinked(node,result)){absorb(node,result);existsLink=true;}}return result;};function isNodeAbsorded(node,result){return indexOf(result.nodes,node)>=0;}function isLinked(node,result){var hasLink=false;forEachEdgeType(function(edgeType){each$1(edgeIdGetter(node,edgeType)||[],function(edgeId){result.records[edgeType.name][edgeId]&&(hasLink=true);});});return hasLink;}function absorb(node,result){result.nodes.push(node);forEachEdgeType(function(edgeType){each$1(edgeIdGetter(node,edgeType)||[],function(edgeId){result.records[edgeType.name][edgeId]=true;});});}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var each$13=each$1;var asc$1=asc;/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 *
 * @class
 */var AxisProxy=function AxisProxy(dimName,axisIndex,dataZoomModel,ecModel){/**
   * @private
   * @type {string}
   */this._dimName=dimName;/**
   * @private
   */this._axisIndex=axisIndex;/**
   * @private
   * @type {Array.<number>}
   */this._valueWindow;/**
   * @private
   * @type {Array.<number>}
   */this._percentWindow;/**
   * @private
   * @type {Array.<number>}
   */this._dataExtent;/**
   * {minSpan, maxSpan, minValueSpan, maxValueSpan}
   * @private
   * @type {Object}
   */this._minMaxSpan;/**
   * @readOnly
   * @type {module: echarts/model/Global}
   */this.ecModel=ecModel;/**
   * @private
   * @type {module: echarts/component/dataZoom/DataZoomModel}
   */this._dataZoomModel=dataZoomModel;// /**
//  * @readOnly
//  * @private
//  */
// this.hasSeriesStacked;
};AxisProxy.prototype={constructor:AxisProxy,/**
   * Whether the axisProxy is hosted by dataZoomModel.
   *
   * @public
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   * @return {boolean}
   */hostedBy:function hostedBy(dataZoomModel){return this._dataZoomModel===dataZoomModel;},/**
   * @return {Array.<number>} Value can only be NaN or finite value.
   */getDataValueWindow:function getDataValueWindow(){return this._valueWindow.slice();},/**
   * @return {Array.<number>}
   */getDataPercentWindow:function getDataPercentWindow(){return this._percentWindow.slice();},/**
   * @public
   * @param {number} axisIndex
   * @return {Array} seriesModels
   */getTargetSeriesModels:function getTargetSeriesModels(){var seriesModels=[];var ecModel=this.ecModel;ecModel.eachSeries(function(seriesModel){if(isCoordSupported(seriesModel.get('coordinateSystem'))){var dimName=this._dimName;var axisModel=ecModel.queryComponents({mainType:dimName+'Axis',index:seriesModel.get(dimName+'AxisIndex'),id:seriesModel.get(dimName+'AxisId')})[0];if(this._axisIndex===(axisModel&&axisModel.componentIndex)){seriesModels.push(seriesModel);}}},this);return seriesModels;},getAxisModel:function getAxisModel(){return this.ecModel.getComponent(this._dimName+'Axis',this._axisIndex);},getOtherAxisModel:function getOtherAxisModel(){var axisDim=this._dimName;var ecModel=this.ecModel;var axisModel=this.getAxisModel();var isCartesian=axisDim==='x'||axisDim==='y';var otherAxisDim;var coordSysIndexName;if(isCartesian){coordSysIndexName='gridIndex';otherAxisDim=axisDim==='x'?'y':'x';}else{coordSysIndexName='polarIndex';otherAxisDim=axisDim==='angle'?'radius':'angle';}var foundOtherAxisModel;ecModel.eachComponent(otherAxisDim+'Axis',function(otherAxisModel){if((otherAxisModel.get(coordSysIndexName)||0)===(axisModel.get(coordSysIndexName)||0)){foundOtherAxisModel=otherAxisModel;}});return foundOtherAxisModel;},getMinMaxSpan:function getMinMaxSpan(){return _clone(this._minMaxSpan);},/**
   * Only calculate by given range and this._dataExtent, do not change anything.
   *
   * @param {Object} opt
   * @param {number} [opt.start]
   * @param {number} [opt.end]
   * @param {number} [opt.startValue]
   * @param {number} [opt.endValue]
   */calculateDataWindow:function calculateDataWindow(opt){var dataExtent=this._dataExtent;var axisModel=this.getAxisModel();var scale=axisModel.axis.scale;var rangePropMode=this._dataZoomModel.getRangePropMode();var percentExtent=[0,100];var percentWindow=[opt.start,opt.end];var valueWindow=[];each$13(['startValue','endValue'],function(prop){valueWindow.push(opt[prop]!=null?scale.parse(opt[prop]):null);});// Normalize bound.
each$13([0,1],function(idx){var boundValue=valueWindow[idx];var boundPercent=percentWindow[idx];// Notice: dataZoom is based either on `percentProp` ('start', 'end') or
// on `valueProp` ('startValue', 'endValue'). The former one is suitable
// for cases that a dataZoom component controls multiple axes with different
// unit or extent, and the latter one is suitable for accurate zoom by pixel
// (e.g., in dataZoomSelect). `valueProp` can be calculated from `percentProp`,
// but it is awkward that `percentProp` can not be obtained from `valueProp`
// accurately (because all of values that are overflow the `dataExtent` will
// be calculated to percent '100%'). So we have to use
// `dataZoom.getRangePropMode()` to mark which prop is used.
// `rangePropMode` is updated only when setOption or dispatchAction, otherwise
// it remains its original value.
if(rangePropMode[idx]==='percent'){if(boundPercent==null){boundPercent=percentExtent[idx];}// Use scale.parse to math round for category or time axis.
boundValue=scale.parse(linearMap(boundPercent,percentExtent,dataExtent,true));}else{// Calculating `percent` from `value` may be not accurate, because
// This calculation can not be inversed, because all of values that
// are overflow the `dataExtent` will be calculated to percent '100%'
boundPercent=linearMap(boundValue,dataExtent,percentExtent,true);}// valueWindow[idx] = round(boundValue);
// percentWindow[idx] = round(boundPercent);
valueWindow[idx]=boundValue;percentWindow[idx]=boundPercent;});return{valueWindow:asc$1(valueWindow),percentWindow:asc$1(percentWindow)};},/**
   * Notice: reset should not be called before series.restoreData() called,
   * so it is recommanded to be called in "process stage" but not "model init
   * stage".
   *
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */reset:function reset(dataZoomModel){if(dataZoomModel!==this._dataZoomModel){return;}var targetSeries=this.getTargetSeriesModels();// Culculate data window and data extent, and record them.
this._dataExtent=calculateDataExtent(this,this._dimName,targetSeries);// this.hasSeriesStacked = false;
// each(targetSeries, function (series) {
// var data = series.getData();
// var dataDim = data.mapDimension(this._dimName);
// var stackedDimension = data.getCalculationInfo('stackedDimension');
// if (stackedDimension && stackedDimension === dataDim) {
// this.hasSeriesStacked = true;
// }
// }, this);
var dataWindow=this.calculateDataWindow(dataZoomModel.option);this._valueWindow=dataWindow.valueWindow;this._percentWindow=dataWindow.percentWindow;setMinMaxSpan(this);// Update axis setting then.
setAxisModel(this);},/**
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */restore:function restore(dataZoomModel){if(dataZoomModel!==this._dataZoomModel){return;}this._valueWindow=this._percentWindow=null;setAxisModel(this,true);},/**
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */filterData:function filterData(dataZoomModel,api){if(dataZoomModel!==this._dataZoomModel){return;}var axisDim=this._dimName;var seriesModels=this.getTargetSeriesModels();var filterMode=dataZoomModel.get('filterMode');var valueWindow=this._valueWindow;if(filterMode==='none'){return;}// FIXME
// Toolbox may has dataZoom injected. And if there are stacked bar chart
// with NaN data, NaN will be filtered and stack will be wrong.
// So we need to force the mode to be set empty.
// In fect, it is not a big deal that do not support filterMode-'filter'
// when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
// selection" some day, which might need "adapt to data extent on the
// otherAxis", which is disabled by filterMode-'empty'.
// But currently, stack has been fixed to based on value but not index,
// so this is not an issue any more.
// var otherAxisModel = this.getOtherAxisModel();
// if (dataZoomModel.get('$fromToolbox')
//     && otherAxisModel
//     && otherAxisModel.hasSeriesStacked
// ) {
//     filterMode = 'empty';
// }
// TODO
// filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
// Process series data
each$13(seriesModels,function(seriesModel){var seriesData=seriesModel.getData();var dataDims=seriesData.mapDimension(axisDim,true);if(filterMode==='weakFilter'){seriesData.filterSelf(function(dataIndex){var leftOut;var rightOut;var hasValue;for(var i=0;i<dataDims.length;i++){var value=seriesData.get(dataDims[i],dataIndex);var thisHasValue=!isNaN(value);var thisLeftOut=value<valueWindow[0];var thisRightOut=value>valueWindow[1];if(thisHasValue&&!thisLeftOut&&!thisRightOut){return true;}thisHasValue&&(hasValue=true);thisLeftOut&&(leftOut=true);thisRightOut&&(rightOut=true);}// If both left out and right out, do not filter.
return hasValue&&leftOut&&rightOut;});}else{each$13(dataDims,function(dim){if(filterMode==='empty'){seriesModel.setData(seriesData.map(dim,function(value){return!isInWindow(value)?NaN:value;}));}else{var range={};range[dim]=valueWindow;// console.time('select');
seriesData.selectRange(range);// console.timeEnd('select');
}});}each$13(dataDims,function(dim){seriesData.setApproximateExtent(valueWindow,dim);});});function isInWindow(value){return value>=valueWindow[0]&&value<=valueWindow[1];}}};function calculateDataExtent(axisProxy,axisDim,seriesModels){var dataExtent=[Infinity,-Infinity];each$13(seriesModels,function(seriesModel){var seriesData=seriesModel.getData();if(seriesData){each$13(seriesData.mapDimension(axisDim,true),function(dim){var seriesExtent=seriesData.getApproximateExtent(dim);seriesExtent[0]<dataExtent[0]&&(dataExtent[0]=seriesExtent[0]);seriesExtent[1]>dataExtent[1]&&(dataExtent[1]=seriesExtent[1]);});}});if(dataExtent[1]<dataExtent[0]){dataExtent=[NaN,NaN];}// It is important to get "consistent" extent when more then one axes is
// controlled by a `dataZoom`, otherwise those axes will not be synchronized
// when zooming. But it is difficult to know what is "consistent", considering
// axes have different type or even different meanings (For example, two
// time axes are used to compare data of the same date in different years).
// So basically dataZoom just obtains extent by series.data (in category axis
// extent can be obtained from axis.data).
// Nevertheless, user can set min/max/scale on axes to make extent of axes
// consistent.
fixExtentByAxis(axisProxy,dataExtent);return dataExtent;}function fixExtentByAxis(axisProxy,dataExtent){var axisModel=axisProxy.getAxisModel();var min=axisModel.getMin(true);// For category axis, if min/max/scale are not set, extent is determined
// by axis.data by default.
var isCategoryAxis=axisModel.get('type')==='category';var axisDataLen=isCategoryAxis&&axisModel.getCategories().length;if(min!=null&&min!=='dataMin'&&typeof min!=='function'){dataExtent[0]=min;}else if(isCategoryAxis){dataExtent[0]=axisDataLen>0?0:NaN;}var max=axisModel.getMax(true);if(max!=null&&max!=='dataMax'&&typeof max!=='function'){dataExtent[1]=max;}else if(isCategoryAxis){dataExtent[1]=axisDataLen>0?axisDataLen-1:NaN;}if(!axisModel.get('scale',true)){dataExtent[0]>0&&(dataExtent[0]=0);dataExtent[1]<0&&(dataExtent[1]=0);}// For value axis, if min/max/scale are not set, we just use the extent obtained
// by series data, which may be a little different from the extent calculated by
// `axisHelper.getScaleExtent`. But the different just affects the experience a
// little when zooming. So it will not be fixed until some users require it strongly.
return dataExtent;}function setAxisModel(axisProxy,isRestore){var axisModel=axisProxy.getAxisModel();var percentWindow=axisProxy._percentWindow;var valueWindow=axisProxy._valueWindow;if(!percentWindow){return;}// [0, 500]: arbitrary value, guess axis extent.
var precision=_getPixelPrecision(valueWindow,[0,500]);precision=Math.min(precision,20);// isRestore or isFull
var useOrigin=isRestore||percentWindow[0]===0&&percentWindow[1]===100;axisModel.setRange(useOrigin?null:+valueWindow[0].toFixed(precision),useOrigin?null:+valueWindow[1].toFixed(precision));}function setMinMaxSpan(axisProxy){var minMaxSpan=axisProxy._minMaxSpan={};var dataZoomModel=axisProxy._dataZoomModel;each$13(['min','max'],function(minMax){minMaxSpan[minMax+'Span']=dataZoomModel.get(minMax+'Span');// minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
var valueSpan=dataZoomModel.get(minMax+'ValueSpan');if(valueSpan!=null){minMaxSpan[minMax+'ValueSpan']=valueSpan;valueSpan=axisProxy.getAxisModel().axis.scale.parse(valueSpan);if(valueSpan!=null){var dataExtent=axisProxy._dataExtent;minMaxSpan[minMax+'Span']=linearMap(dataExtent[0]+valueSpan,dataExtent,[0,100],true);}}});}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var each$12=each$1;var eachAxisDim=eachAxisDim$1;var DataZoomModel=extendComponentModel({type:'dataZoom',dependencies:['xAxis','yAxis','zAxis','radiusAxis','angleAxis','singleAxis','series'],/**
   * @protected
   */defaultOption:{zlevel:0,z:4,// Higher than normal component (z: 2).
orient:null,// Default auto by axisIndex. Possible value: 'horizontal', 'vertical'.
xAxisIndex:null,// Default the first horizontal category axis.
yAxisIndex:null,// Default the first vertical category axis.
filterMode:'filter',// Possible values: 'filter' or 'empty' or 'weakFilter'.
// 'filter': data items which are out of window will be removed. This option is
//          applicable when filtering outliers. For each data item, it will be
//          filtered if one of the relevant dimensions is out of the window.
// 'weakFilter': data items which are out of window will be removed. This option
//          is applicable when filtering outliers. For each data item, it will be
//          filtered only if all  of the relevant dimensions are out of the same
//          side of the window.
// 'empty': data items which are out of window will be set to empty.
//          This option is applicable when user should not neglect
//          that there are some data items out of window.
// 'none': Do not filter.
// Taking line chart as an example, line will be broken in
// the filtered points when filterModel is set to 'empty', but
// be connected when set to 'filter'.
throttle:null,// Dispatch action by the fixed rate, avoid frequency.
// default 100. Do not throttle when use null/undefined.
// If animation === true and animationDurationUpdate > 0,
// default value is 100, otherwise 20.
start:0,// Start percent. 0 ~ 100
end:100,// End percent. 0 ~ 100
startValue:null,// Start value. If startValue specified, start is ignored.
endValue:null,// End value. If endValue specified, end is ignored.
minSpan:null,// 0 ~ 100
maxSpan:null,// 0 ~ 100
minValueSpan:null,// The range of dataZoom can not be smaller than that.
maxValueSpan:null,// The range of dataZoom can not be larger than that.
rangeMode:null// Array, can be 'value' or 'percent'.
},/**
   * @override
   */init:function init(option,parentModel,ecModel){/**
     * key like x_0, y_1
     * @private
     * @type {Object}
     */this._dataIntervalByAxis={};/**
     * @private
     */this._dataInfo={};/**
     * key like x_0, y_1
     * @private
     */this._axisProxies={};/**
     * @readOnly
     */this.textStyleModel;/**
     * @private
     */this._autoThrottle=true;/**
     * 'percent' or 'value'
     * @private
     */this._rangePropMode=['percent','percent'];var rawOption=retrieveRaw(option);this.mergeDefaultAndTheme(option,ecModel);this.doInit(rawOption);},/**
   * @override
   */mergeOption:function mergeOption(newOption){var rawOption=retrieveRaw(newOption);//FIX #2591
merge(this.option,newOption,true);this.doInit(rawOption);},/**
   * @protected
   */doInit:function doInit(rawOption){var thisOption=this.option;// Disable realtime view update if canvas is not supported.
if(!env$1.canvasSupported){thisOption.realtime=false;}this._setDefaultThrottle(rawOption);updateRangeUse(this,rawOption);each$12([['start','startValue'],['end','endValue']],function(names,index){// start/end has higher priority over startValue/endValue if they
// both set, but we should make chart.setOption({endValue: 1000})
// effective, rather than chart.setOption({endValue: 1000, end: null}).
if(this._rangePropMode[index]==='value'){thisOption[names[0]]=null;}// Otherwise do nothing and use the merge result.
},this);this.textStyleModel=this.getModel('textStyle');this._resetTarget();this._giveAxisProxies();},/**
   * @private
   */_giveAxisProxies:function _giveAxisProxies(){var axisProxies=this._axisProxies;this.eachTargetAxis(function(dimNames,axisIndex,dataZoomModel,ecModel){var axisModel=this.dependentModels[dimNames.axis][axisIndex];// If exists, share axisProxy with other dataZoomModels.
var axisProxy=axisModel.__dzAxisProxy||(// Use the first dataZoomModel as the main model of axisProxy.
axisModel.__dzAxisProxy=new AxisProxy(dimNames.name,axisIndex,this,ecModel));// FIXME
// dispose __dzAxisProxy
axisProxies[dimNames.name+'_'+axisIndex]=axisProxy;},this);},/**
   * @private
   */_resetTarget:function _resetTarget(){var thisOption=this.option;var autoMode=this._judgeAutoMode();eachAxisDim(function(dimNames){var axisIndexName=dimNames.axisIndex;thisOption[axisIndexName]=normalizeToArray(thisOption[axisIndexName]);},this);if(autoMode==='axisIndex'){this._autoSetAxisIndex();}else if(autoMode==='orient'){this._autoSetOrient();}},/**
   * @private
   */_judgeAutoMode:function _judgeAutoMode(){// Auto set only works for setOption at the first time.
// The following is user's reponsibility. So using merged
// option is OK.
var thisOption=this.option;var hasIndexSpecified=false;eachAxisDim(function(dimNames){// When user set axisIndex as a empty array, we think that user specify axisIndex
// but do not want use auto mode. Because empty array may be encountered when
// some error occured.
if(thisOption[dimNames.axisIndex]!=null){hasIndexSpecified=true;}},this);var orient=thisOption.orient;if(orient==null&&hasIndexSpecified){return'orient';}else if(!hasIndexSpecified){if(orient==null){thisOption.orient='horizontal';}return'axisIndex';}},/**
   * @private
   */_autoSetAxisIndex:function _autoSetAxisIndex(){var autoAxisIndex=true;var orient=this.get('orient',true);var thisOption=this.option;var dependentModels=this.dependentModels;if(autoAxisIndex){// Find axis that parallel to dataZoom as default.
var dimName=orient==='vertical'?'y':'x';if(dependentModels[dimName+'Axis'].length){thisOption[dimName+'AxisIndex']=[0];autoAxisIndex=false;}else{each$12(dependentModels.singleAxis,function(singleAxisModel){if(autoAxisIndex&&singleAxisModel.get('orient',true)===orient){thisOption.singleAxisIndex=[singleAxisModel.componentIndex];autoAxisIndex=false;}});}}if(autoAxisIndex){// Find the first category axis as default. (consider polar)
eachAxisDim(function(dimNames){if(!autoAxisIndex){return;}var axisIndices=[];var axisModels=this.dependentModels[dimNames.axis];if(axisModels.length&&!axisIndices.length){for(var i=0,len=axisModels.length;i<len;i++){if(axisModels[i].get('type')==='category'){axisIndices.push(i);}}}thisOption[dimNames.axisIndex]=axisIndices;if(axisIndices.length){autoAxisIndex=false;}},this);}if(autoAxisIndex){// FIXME
// 这里是兼容ec2的写法（没指定xAxisIndex和yAxisIndex时把scatter和双数值轴折柱纳入dataZoom控制），
// 但是实际是否需要Grid.js#getScaleByOption来判断（考虑time，log等axis type）？
// If both dataZoom.xAxisIndex and dataZoom.yAxisIndex is not specified,
// dataZoom component auto adopts series that reference to
// both xAxis and yAxis which type is 'value'.
this.ecModel.eachSeries(function(seriesModel){if(this._isSeriesHasAllAxesTypeOf(seriesModel,'value')){eachAxisDim(function(dimNames){var axisIndices=thisOption[dimNames.axisIndex];var axisIndex=seriesModel.get(dimNames.axisIndex);var axisId=seriesModel.get(dimNames.axisId);var axisModel=seriesModel.ecModel.queryComponents({mainType:dimNames.axis,index:axisIndex,id:axisId})[0];axisIndex=axisModel.componentIndex;if(indexOf(axisIndices,axisIndex)<0){axisIndices.push(axisIndex);}});}},this);}},/**
   * @private
   */_autoSetOrient:function _autoSetOrient(){var dim;// Find the first axis
this.eachTargetAxis(function(dimNames){!dim&&(dim=dimNames.name);},this);this.option.orient=dim==='y'?'vertical':'horizontal';},/**
   * @private
   */_isSeriesHasAllAxesTypeOf:function _isSeriesHasAllAxesTypeOf(seriesModel,axisType){// FIXME
// 需要series的xAxisIndex和yAxisIndex都首先自动设置上。
// 例如series.type === scatter时。
var is=true;eachAxisDim(function(dimNames){var seriesAxisIndex=seriesModel.get(dimNames.axisIndex);var axisModel=this.dependentModels[dimNames.axis][seriesAxisIndex];if(!axisModel||axisModel.get('type')!==axisType){is=false;}},this);return is;},/**
   * @private
   */_setDefaultThrottle:function _setDefaultThrottle(rawOption){// When first time user set throttle, auto throttle ends.
if(rawOption.hasOwnProperty('throttle')){this._autoThrottle=false;}if(this._autoThrottle){var globalOption=this.ecModel.option;this.option.throttle=globalOption.animation&&globalOption.animationDurationUpdate>0?100:20;}},/**
   * @public
   */getFirstTargetAxisModel:function getFirstTargetAxisModel(){var firstAxisModel;eachAxisDim(function(dimNames){if(firstAxisModel==null){var indices=this.get(dimNames.axisIndex);if(indices.length){firstAxisModel=this.dependentModels[dimNames.axis][indices[0]];}}},this);return firstAxisModel;},/**
   * @public
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */eachTargetAxis:function eachTargetAxis(callback,context){var ecModel=this.ecModel;eachAxisDim(function(dimNames){each$12(this.get(dimNames.axisIndex),function(axisIndex){callback.call(context,dimNames,axisIndex,this,ecModel);},this);},this);},/**
   * @param {string} dimName
   * @param {number} axisIndex
   * @return {module:echarts/component/dataZoom/AxisProxy} If not found, return null/undefined.
   */getAxisProxy:function getAxisProxy(dimName,axisIndex){return this._axisProxies[dimName+'_'+axisIndex];},/**
   * @param {string} dimName
   * @param {number} axisIndex
   * @return {module:echarts/model/Model} If not found, return null/undefined.
   */getAxisModel:function getAxisModel(dimName,axisIndex){var axisProxy=this.getAxisProxy(dimName,axisIndex);return axisProxy&&axisProxy.getAxisModel();},/**
   * If not specified, set to undefined.
   *
   * @public
   * @param {Object} opt
   * @param {number} [opt.start]
   * @param {number} [opt.end]
   * @param {number} [opt.startValue]
   * @param {number} [opt.endValue]
   * @param {boolean} [ignoreUpdateRangeUsg=false]
   */setRawRange:function setRawRange(opt,ignoreUpdateRangeUsg){var option=this.option;each$12([['start','startValue'],['end','endValue']],function(names){// If only one of 'start' and 'startValue' is not null/undefined, the other
// should be cleared, which enable clear the option.
// If both of them are not set, keep option with the original value, which
// enable use only set start but not set end when calling `dispatchAction`.
// The same as 'end' and 'endValue'.
if(opt[names[0]]!=null||opt[names[1]]!=null){option[names[0]]=opt[names[0]];option[names[1]]=opt[names[1]];}},this);!ignoreUpdateRangeUsg&&updateRangeUse(this,opt);},/**
   * @public
   * @return {Array.<number>} [startPercent, endPercent]
   */getPercentRange:function getPercentRange(){var axisProxy=this.findRepresentativeAxisProxy();if(axisProxy){return axisProxy.getDataPercentWindow();}},/**
   * @public
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @param {string} [axisDimName]
   * @param {number} [axisIndex]
   * @return {Array.<number>} [startValue, endValue] value can only be '-' or finite number.
   */getValueRange:function getValueRange(axisDimName,axisIndex){if(axisDimName==null&&axisIndex==null){var axisProxy=this.findRepresentativeAxisProxy();if(axisProxy){return axisProxy.getDataValueWindow();}}else{return this.getAxisProxy(axisDimName,axisIndex).getDataValueWindow();}},/**
   * @public
   * @param {module:echarts/model/Model} [axisModel] If axisModel given, find axisProxy
   *      corresponding to the axisModel
   * @return {module:echarts/component/dataZoom/AxisProxy}
   */findRepresentativeAxisProxy:function findRepresentativeAxisProxy(axisModel){if(axisModel){return axisModel.__dzAxisProxy;}// Find the first hosted axisProxy
var axisProxies=this._axisProxies;for(var key in axisProxies){if(axisProxies.hasOwnProperty(key)&&axisProxies[key].hostedBy(this)){return axisProxies[key];}}// If no hosted axis find not hosted axisProxy.
// Consider this case: dataZoomModel1 and dataZoomModel2 control the same axis,
// and the option.start or option.end settings are different. The percentRange
// should follow axisProxy.
// (We encounter this problem in toolbox data zoom.)
for(var key in axisProxies){if(axisProxies.hasOwnProperty(key)&&!axisProxies[key].hostedBy(this)){return axisProxies[key];}}},/**
   * @return {Array.<string>}
   */getRangePropMode:function getRangePropMode(){return this._rangePropMode.slice();}});function retrieveRaw(option){var ret={};each$12(['start','end','startValue','endValue','throttle'],function(name){option.hasOwnProperty(name)&&(ret[name]=option[name]);});return ret;}function updateRangeUse(dataZoomModel,rawOption){var rangePropMode=dataZoomModel._rangePropMode;var rangeModeInOption=dataZoomModel.get('rangeMode');each$12([['start','startValue'],['end','endValue']],function(names,index){var percentSpecified=rawOption[names[0]]!=null;var valueSpecified=rawOption[names[1]]!=null;if(percentSpecified&&!valueSpecified){rangePropMode[index]='percent';}else if(!percentSpecified&&valueSpecified){rangePropMode[index]='value';}else if(rangeModeInOption){rangePropMode[index]=rangeModeInOption[index];}else if(percentSpecified){// percentSpecified && valueSpecified
rangePropMode[index]='percent';}// else remain its original setting.
});}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var DataZoomView=Component$1.extend({type:'dataZoom',render:function render(dataZoomModel,ecModel,api,payload){this.dataZoomModel=dataZoomModel;this.ecModel=ecModel;this.api=api;},/**
   * Find the first target coordinate system.
   *
   * @protected
   * @return {Object} {
   *                   grid: [
   *                       {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
   *                       {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
   *                       ...
   *                   ],  // cartesians must not be null/undefined.
   *                   polar: [
   *                       {model: coord0, axisModels: [axis4], coordIndex: 0},
   *                       ...
   *                   ],  // polars must not be null/undefined.
   *                   singleAxis: [
   *                       {model: coord0, axisModels: [], coordIndex: 0}
   *                   ]
   */getTargetCoordInfo:function getTargetCoordInfo(){var dataZoomModel=this.dataZoomModel;var ecModel=this.ecModel;var coordSysLists={};dataZoomModel.eachTargetAxis(function(dimNames,axisIndex){var axisModel=ecModel.getComponent(dimNames.axis,axisIndex);if(axisModel){var coordModel=axisModel.getCoordSysModel();coordModel&&save(coordModel,axisModel,coordSysLists[coordModel.mainType]||(coordSysLists[coordModel.mainType]=[]),coordModel.componentIndex);}},this);function save(coordModel,axisModel,store,coordIndex){var item;for(var i=0;i<store.length;i++){if(store[i].model===coordModel){item=store[i];break;}}if(!item){store.push(item={model:coordModel,axisModels:[],coordIndex:coordIndex});}item.axisModels.push(axisModel);}return coordSysLists;}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var SliderZoomModel=DataZoomModel.extend({type:'dataZoom.slider',layoutMode:'box',/**
   * @protected
   */defaultOption:{show:true,// ph => placeholder. Using placehoder here because
// deault value can only be drived in view stage.
right:'ph',// Default align to grid rect.
top:'ph',// Default align to grid rect.
width:'ph',// Default align to grid rect.
height:'ph',// Default align to grid rect.
left:null,// Default align to grid rect.
bottom:null,// Default align to grid rect.
backgroundColor:'rgba(47,69,84,0)',// Background of slider zoom component.
// dataBackgroundColor: '#ddd',         // Background coor of data shadow and border of box,
// highest priority, remain for compatibility of
// previous version, but not recommended any more.
dataBackground:{lineStyle:{color:'#2f4554',width:0.5,opacity:0.3},areaStyle:{color:'rgba(47,69,84,0.3)',opacity:0.3}},borderColor:'#ddd',// border color of the box. For compatibility,
// if dataBackgroundColor is set, borderColor
// is ignored.
fillerColor:'rgba(167,183,204,0.4)',// Color of selected area.
// handleColor: 'rgba(89,170,216,0.95)',     // Color of handle.
// handleIcon: 'path://M4.9,17.8c0-1.4,4.5-10.5,5.5-12.4c0-0.1,0.6-1.1,0.9-1.1c0.4,0,0.9,1,0.9,1.1c1.1,2.2,5.4,11,5.4,12.4v17.8c0,1.5-0.6,2.1-1.3,2.1H6.1c-0.7,0-1.3-0.6-1.3-2.1V17.8z',
handleIcon:'M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z',// Percent of the slider height
handleSize:'100%',handleStyle:{color:'#a7b7cc'},labelPrecision:null,labelFormatter:null,showDetail:true,showDataShadow:'auto',// Default auto decision.
realtime:true,zoomLock:false,// Whether disable zoom.
textStyle:{color:'#333'}}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param {number} delta Move length.
 * @param {Array.<number>} handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param {Array.<number>} extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param {number|string} handleIndex Can be 'all', means that both move the two handleEnds,
 *              where the input minSpan and maxSpan will not work.
 * @param {number} [minSpan] The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param {number} [maxSpan] The range of dataZoom can not be larger than that.
 * @return {Array.<number>} The input handleEnds.
 */var sliderMove=function sliderMove(delta,handleEnds,extent,handleIndex,minSpan,maxSpan){// Normalize firstly.
handleEnds[0]=restrict(handleEnds[0],extent);handleEnds[1]=restrict(handleEnds[1],extent);delta=delta||0;var extentSpan=extent[1]-extent[0];// Notice maxSpan and minSpan can be null/undefined.
if(minSpan!=null){minSpan=restrict(minSpan,[0,extentSpan]);}if(maxSpan!=null){maxSpan=Math.max(maxSpan,minSpan!=null?minSpan:0);}if(handleIndex==='all'){minSpan=maxSpan=Math.abs(handleEnds[1]-handleEnds[0]);handleIndex=0;}var originalDistSign=getSpanSign(handleEnds,handleIndex);handleEnds[handleIndex]+=delta;// Restrict in extent.
var extentMinSpan=minSpan||0;var realExtent=extent.slice();originalDistSign.sign<0?realExtent[0]+=extentMinSpan:realExtent[1]-=extentMinSpan;handleEnds[handleIndex]=restrict(handleEnds[handleIndex],realExtent);// Expand span.
var currDistSign=getSpanSign(handleEnds,handleIndex);if(minSpan!=null&&(currDistSign.sign!==originalDistSign.sign||currDistSign.span<minSpan)){// If minSpan exists, 'cross' is forbinden.
handleEnds[1-handleIndex]=handleEnds[handleIndex]+originalDistSign.sign*minSpan;}// Shrink span.
var currDistSign=getSpanSign(handleEnds,handleIndex);if(maxSpan!=null&&currDistSign.span>maxSpan){handleEnds[1-handleIndex]=handleEnds[handleIndex]+currDistSign.sign*maxSpan;}return handleEnds;};function getSpanSign(handleEnds,handleIndex){var dist=handleEnds[handleIndex]-handleEnds[1-handleIndex];// If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
// is at left of handleEnds[1] for non-cross case.
return{span:Math.abs(dist),sign:dist>0?-1:dist<0?1:handleIndex?-1:1};}function restrict(value,extend){return Math.min(extend[1],Math.max(extend[0],value));}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var Rect$1=Rect;var linearMap$1=linearMap;var asc$2=asc;var bind$3=bind;var each$14=each$1;// Constants
var DEFAULT_LOCATION_EDGE_GAP=7;var DEFAULT_FRAME_BORDER_WIDTH=1;var DEFAULT_FILLER_SIZE=30;var HORIZONTAL='horizontal';var VERTICAL='vertical';var LABEL_GAP=5;var SHOW_DATA_SHADOW_SERIES_TYPE=['line','bar','candlestick','scatter'];var SliderZoomView=DataZoomView.extend({type:'dataZoom.slider',init:function init(ecModel,api){/**
     * @private
     * @type {Object}
     */this._displayables={};/**
     * @private
     * @type {string}
     */this._orient;/**
     * [0, 100]
     * @private
     */this._range;/**
     * [coord of the first handle, coord of the second handle]
     * @private
     */this._handleEnds;/**
     * [length, thick]
     * @private
     * @type {Array.<number>}
     */this._size;/**
     * @private
     * @type {number}
     */this._handleWidth;/**
     * @private
     * @type {number}
     */this._handleHeight;/**
     * @private
     */this._location;/**
     * @private
     */this._dragging;/**
     * @private
     */this._dataShadowInfo;this.api=api;},/**
   * @override
   */render:function render(dataZoomModel,ecModel,api,payload){SliderZoomView.superApply(this,'render',arguments);createOrUpdate(this,'_dispatchZoomAction',this.dataZoomModel.get('throttle'),'fixRate');this._orient=dataZoomModel.get('orient');if(this.dataZoomModel.get('show')===false){this.group.removeAll();return;}// Notice: this._resetInterval() should not be executed when payload.type
// is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
// or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
if(!payload||payload.type!=='dataZoom'||payload.from!==this.uid){this._buildView();}this._updateView();},/**
   * @override
   */remove:function remove(){SliderZoomView.superApply(this,'remove',arguments);clear(this,'_dispatchZoomAction');},/**
   * @override
   */dispose:function dispose(){SliderZoomView.superApply(this,'dispose',arguments);clear(this,'_dispatchZoomAction');},_buildView:function _buildView(){var thisGroup=this.group;thisGroup.removeAll();this._resetLocation();this._resetInterval();var barGroup=this._displayables.barGroup=new Group();this._renderBackground();this._renderHandle();this._renderDataShadow();thisGroup.add(barGroup);this._positionGroup();},/**
   * @private
   */_resetLocation:function _resetLocation(){var dataZoomModel=this.dataZoomModel;var api=this.api;// If some of x/y/width/height are not specified,
// auto-adapt according to target grid.
var coordRect=this._findCoordRect();var ecSize={width:api.getWidth(),height:api.getHeight()};// Default align by coordinate system rect.
var positionInfo=this._orient===HORIZONTAL?{// Why using 'right', because right should be used in vertical,
// and it is better to be consistent for dealing with position param merge.
right:ecSize.width-coordRect.x-coordRect.width,top:ecSize.height-DEFAULT_FILLER_SIZE-DEFAULT_LOCATION_EDGE_GAP,width:coordRect.width,height:DEFAULT_FILLER_SIZE}:{// vertical
right:DEFAULT_LOCATION_EDGE_GAP,top:coordRect.y,width:DEFAULT_FILLER_SIZE,height:coordRect.height};// Do not write back to option and replace value 'ph', because
// the 'ph' value should be recalculated when resize.
var layoutParams=getLayoutParams(dataZoomModel.option);// Replace the placeholder value.
each$1(['right','top','width','height'],function(name){if(layoutParams[name]==='ph'){layoutParams[name]=positionInfo[name];}});var layoutRect=getLayoutRect(layoutParams,ecSize,dataZoomModel.padding);this._location={x:layoutRect.x,y:layoutRect.y};this._size=[layoutRect.width,layoutRect.height];this._orient===VERTICAL&&this._size.reverse();},/**
   * @private
   */_positionGroup:function _positionGroup(){var thisGroup=this.group;var location=this._location;var orient=this._orient;// Just use the first axis to determine mapping.
var targetAxisModel=this.dataZoomModel.getFirstTargetAxisModel();var inverse=targetAxisModel&&targetAxisModel.get('inverse');var barGroup=this._displayables.barGroup;var otherAxisInverse=(this._dataShadowInfo||{}).otherAxisInverse;// Transform barGroup.
barGroup.attr(orient===HORIZONTAL&&!inverse?{scale:otherAxisInverse?[1,1]:[1,-1]}:orient===HORIZONTAL&&inverse?{scale:otherAxisInverse?[-1,1]:[-1,-1]}:orient===VERTICAL&&!inverse?{scale:otherAxisInverse?[1,-1]:[1,1],rotation:Math.PI/2// Dont use Math.PI, considering shadow direction.
}:{scale:otherAxisInverse?[-1,-1]:[-1,1],rotation:Math.PI/2});// Position barGroup
var rect=thisGroup.getBoundingRect([barGroup]);thisGroup.attr('position',[location.x-rect.x,location.y-rect.y]);},/**
   * @private
   */_getViewExtent:function _getViewExtent(){return[0,this._size[0]];},_renderBackground:function _renderBackground(){var dataZoomModel=this.dataZoomModel;var size=this._size;var barGroup=this._displayables.barGroup;barGroup.add(new Rect$1({silent:true,shape:{x:0,y:0,width:size[0],height:size[1]},style:{fill:dataZoomModel.get('backgroundColor')},z2:-40}));// Click panel, over shadow, below handles.
barGroup.add(new Rect$1({shape:{x:0,y:0,width:size[0],height:size[1]},style:{fill:'transparent'},z2:0,onclick:bind(this._onClickPanelClick,this)}));},_renderDataShadow:function _renderDataShadow(){var info=this._dataShadowInfo=this._prepareDataShadowInfo();if(!info){return;}var size=this._size;var seriesModel=info.series;var data=seriesModel.getRawData();var otherDim=seriesModel.getShadowDim?seriesModel.getShadowDim()// @see candlestick
:info.otherDim;if(otherDim==null){return;}var otherDataExtent=data.getDataExtent(otherDim);// Nice extent.
var otherOffset=(otherDataExtent[1]-otherDataExtent[0])*0.3;otherDataExtent=[otherDataExtent[0]-otherOffset,otherDataExtent[1]+otherOffset];var otherShadowExtent=[0,size[1]];var thisShadowExtent=[0,size[0]];var areaPoints=[[size[0],0],[0,0]];var linePoints=[];var step=thisShadowExtent[1]/(data.count()-1);var thisCoord=0;// Optimize for large data shadow
var stride=Math.round(data.count()/size[0]);var lastIsEmpty;data.each([otherDim],function(value,index){if(stride>0&&index%stride){thisCoord+=step;return;}// FIXME
// Should consider axis.min/axis.max when drawing dataShadow.
// FIXME
// 应该使用统一的空判断？还是在list里进行空判断？
var isEmpty=value==null||isNaN(value)||value==='';// See #4235.
var otherCoord=isEmpty?0:linearMap$1(value,otherDataExtent,otherShadowExtent,true);// Attempt to draw data shadow precisely when there are empty value.
if(isEmpty&&!lastIsEmpty&&index){areaPoints.push([areaPoints[areaPoints.length-1][0],0]);linePoints.push([linePoints[linePoints.length-1][0],0]);}else if(!isEmpty&&lastIsEmpty){areaPoints.push([thisCoord,0]);linePoints.push([thisCoord,0]);}areaPoints.push([thisCoord,otherCoord]);linePoints.push([thisCoord,otherCoord]);thisCoord+=step;lastIsEmpty=isEmpty;});var dataZoomModel=this.dataZoomModel;// var dataBackgroundModel = dataZoomModel.getModel('dataBackground');
this._displayables.barGroup.add(new Polygon({shape:{points:areaPoints},style:defaults({fill:dataZoomModel.get('dataBackgroundColor')},dataZoomModel.getModel('dataBackground.areaStyle').getAreaStyle()),silent:true,z2:-20}));this._displayables.barGroup.add(new Polyline({shape:{points:linePoints},style:dataZoomModel.getModel('dataBackground.lineStyle').getLineStyle(),silent:true,z2:-19}));},_prepareDataShadowInfo:function _prepareDataShadowInfo(){var dataZoomModel=this.dataZoomModel;var showDataShadow=dataZoomModel.get('showDataShadow');if(showDataShadow===false){return;}// Find a representative series.
var result;var ecModel=this.ecModel;dataZoomModel.eachTargetAxis(function(dimNames,axisIndex){var seriesModels=dataZoomModel.getAxisProxy(dimNames.name,axisIndex).getTargetSeriesModels();each$1(seriesModels,function(seriesModel){if(result){return;}if(showDataShadow!==true&&indexOf(SHOW_DATA_SHADOW_SERIES_TYPE,seriesModel.get('type'))<0){return;}var thisAxis=ecModel.getComponent(dimNames.axis,axisIndex).axis;var otherDim=getOtherDim(dimNames.name);var otherAxisInverse;var coordSys=seriesModel.coordinateSystem;if(otherDim!=null&&coordSys.getOtherAxis){otherAxisInverse=coordSys.getOtherAxis(thisAxis).inverse;}otherDim=seriesModel.getData().mapDimension(otherDim);result={thisAxis:thisAxis,series:seriesModel,thisDim:dimNames.name,otherDim:otherDim,otherAxisInverse:otherAxisInverse};},this);},this);return result;},_renderHandle:function _renderHandle(){var displaybles=this._displayables;var handles=displaybles.handles=[];var handleLabels=displaybles.handleLabels=[];var barGroup=this._displayables.barGroup;var size=this._size;var dataZoomModel=this.dataZoomModel;barGroup.add(displaybles.filler=new Rect$1({draggable:true,cursor:getCursor(this._orient),drift:bind$3(this._onDragMove,this,'all'),onmousemove:function onmousemove(e){// Fot mobile devicem, prevent screen slider on the button.
stop(e.event);},ondragstart:bind$3(this._showDataInfo,this,true),ondragend:bind$3(this._onDragEnd,this),onmouseover:bind$3(this._showDataInfo,this,true),onmouseout:bind$3(this._showDataInfo,this,false),style:{fill:dataZoomModel.get('fillerColor'),textPosition:'inside'}}));// Frame border.
barGroup.add(new Rect$1(subPixelOptimizeRect({silent:true,shape:{x:0,y:0,width:size[0],height:size[1]},style:{stroke:dataZoomModel.get('dataBackgroundColor')||dataZoomModel.get('borderColor'),lineWidth:DEFAULT_FRAME_BORDER_WIDTH,fill:'rgba(0,0,0,0)'}})));each$14([0,1],function(handleIndex){var path=createIcon(dataZoomModel.get('handleIcon'),{cursor:getCursor(this._orient),draggable:true,drift:bind$3(this._onDragMove,this,handleIndex),onmousemove:function onmousemove(e){// Fot mobile devicem, prevent screen slider on the button.
stop(e.event);},ondragend:bind$3(this._onDragEnd,this),onmouseover:bind$3(this._showDataInfo,this,true),onmouseout:bind$3(this._showDataInfo,this,false)},{x:-1,y:0,width:2,height:2});var bRect=path.getBoundingRect();this._handleHeight=parsePercent$1(dataZoomModel.get('handleSize'),this._size[1]);this._handleWidth=bRect.width/bRect.height*this._handleHeight;path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());var handleColor=dataZoomModel.get('handleColor');// Compatitable with previous version
if(handleColor!=null){path.style.fill=handleColor;}barGroup.add(handles[handleIndex]=path);var textStyleModel=dataZoomModel.textStyleModel;this.group.add(handleLabels[handleIndex]=new Text({silent:true,invisible:true,style:{x:0,y:0,text:'',textVerticalAlign:'middle',textAlign:'center',textFill:textStyleModel.getTextColor(),textFont:textStyleModel.getFont()},z2:10}));},this);},/**
   * @private
   */_resetInterval:function _resetInterval(){var range=this._range=this.dataZoomModel.getPercentRange();var viewExtent=this._getViewExtent();this._handleEnds=[linearMap$1(range[0],[0,100],viewExtent,true),linearMap$1(range[1],[0,100],viewExtent,true)];},/**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} delta
   * @return {boolean} changed
   */_updateInterval:function _updateInterval(handleIndex,delta){var dataZoomModel=this.dataZoomModel;var handleEnds=this._handleEnds;var viewExtend=this._getViewExtent();var minMaxSpan=dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();var percentExtent=[0,100];sliderMove(delta,handleEnds,viewExtend,dataZoomModel.get('zoomLock')?'all':handleIndex,minMaxSpan.minSpan!=null?linearMap$1(minMaxSpan.minSpan,percentExtent,viewExtend,true):null,minMaxSpan.maxSpan!=null?linearMap$1(minMaxSpan.maxSpan,percentExtent,viewExtend,true):null);var lastRange=this._range;var range=this._range=asc$2([linearMap$1(handleEnds[0],viewExtend,percentExtent,true),linearMap$1(handleEnds[1],viewExtend,percentExtent,true)]);return!lastRange||lastRange[0]!==range[0]||lastRange[1]!==range[1];},/**
   * @private
   */_updateView:function _updateView(nonRealtime){var displaybles=this._displayables;var handleEnds=this._handleEnds;var handleInterval=asc$2(handleEnds.slice());var size=this._size;each$14([0,1],function(handleIndex){// Handles
var handle=displaybles.handles[handleIndex];var handleHeight=this._handleHeight;handle.attr({scale:[handleHeight/2,handleHeight/2],position:[handleEnds[handleIndex],size[1]/2-handleHeight/2]});},this);// Filler
displaybles.filler.setShape({x:handleInterval[0],y:0,width:handleInterval[1]-handleInterval[0],height:size[1]});this._updateDataInfo(nonRealtime);},/**
   * @private
   */_updateDataInfo:function _updateDataInfo(nonRealtime){var dataZoomModel=this.dataZoomModel;var displaybles=this._displayables;var handleLabels=displaybles.handleLabels;var orient=this._orient;var labelTexts=['',''];// FIXME
// date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
if(dataZoomModel.get('showDetail')){var axisProxy=dataZoomModel.findRepresentativeAxisProxy();if(axisProxy){var axis=axisProxy.getAxisModel().axis;var range=this._range;var dataInterval=nonRealtime// See #4434, data and axis are not processed and reset yet in non-realtime mode.
?axisProxy.calculateDataWindow({start:range[0],end:range[1]}).valueWindow:axisProxy.getDataValueWindow();labelTexts=[this._formatLabel(dataInterval[0],axis),this._formatLabel(dataInterval[1],axis)];}}var orderedHandleEnds=asc$2(this._handleEnds.slice());setLabel.call(this,0);setLabel.call(this,1);function setLabel(handleIndex){// Label
// Text should not transform by barGroup.
// Ignore handlers transform
var barTransform=getTransform(displaybles.handles[handleIndex].parent,this.group);var direction=transformDirection(handleIndex===0?'right':'left',barTransform);var offset=this._handleWidth/2+LABEL_GAP;var textPoint=applyTransform$1([orderedHandleEnds[handleIndex]+(handleIndex===0?-offset:offset),this._size[1]/2],barTransform);handleLabels[handleIndex].setStyle({x:textPoint[0],y:textPoint[1],textVerticalAlign:orient===HORIZONTAL?'middle':direction,textAlign:orient===HORIZONTAL?direction:'center',text:labelTexts[handleIndex]});}},/**
   * @private
   */_formatLabel:function _formatLabel(value,axis){var dataZoomModel=this.dataZoomModel;var labelFormatter=dataZoomModel.get('labelFormatter');var labelPrecision=dataZoomModel.get('labelPrecision');if(labelPrecision==null||labelPrecision==='auto'){labelPrecision=axis.getPixelPrecision();}var valueStr=value==null||isNaN(value)?''// FIXME Glue code
:axis.type==='category'||axis.type==='time'?axis.scale.getLabel(Math.round(value))// param of toFixed should less then 20.
:value.toFixed(Math.min(labelPrecision,20));return isFunction$1(labelFormatter)?labelFormatter(value,valueStr):isString(labelFormatter)?labelFormatter.replace('{value}',valueStr):valueStr;},/**
   * @private
   * @param {boolean} showOrHide true: show, false: hide
   */_showDataInfo:function _showDataInfo(showOrHide){// Always show when drgging.
showOrHide=this._dragging||showOrHide;var handleLabels=this._displayables.handleLabels;handleLabels[0].attr('invisible',!showOrHide);handleLabels[1].attr('invisible',!showOrHide);},_onDragMove:function _onDragMove(handleIndex,dx,dy){this._dragging=true;// Transform dx, dy to bar coordination.
var barTransform=this._displayables.barGroup.getLocalTransform();var vertex=applyTransform$1([dx,dy],barTransform,true);var changed=this._updateInterval(handleIndex,vertex[0]);var realtime=this.dataZoomModel.get('realtime');this._updateView(!realtime);// Avoid dispatch dataZoom repeatly but range not changed,
// which cause bad visual effect when progressive enabled.
changed&&realtime&&this._dispatchZoomAction();},_onDragEnd:function _onDragEnd(){this._dragging=false;this._showDataInfo(false);// While in realtime mode and stream mode, dispatch action when
// drag end will cause the whole view rerender, which is unnecessary.
var realtime=this.dataZoomModel.get('realtime');!realtime&&this._dispatchZoomAction();},_onClickPanelClick:function _onClickPanelClick(e){var size=this._size;var localPoint=this._displayables.barGroup.transformCoordToLocal(e.offsetX,e.offsetY);if(localPoint[0]<0||localPoint[0]>size[0]||localPoint[1]<0||localPoint[1]>size[1]){return;}var handleEnds=this._handleEnds;var center=(handleEnds[0]+handleEnds[1])/2;var changed=this._updateInterval('all',localPoint[0]-center);this._updateView();changed&&this._dispatchZoomAction();},/**
   * This action will be throttled.
   * @private
   */_dispatchZoomAction:function _dispatchZoomAction(){var range=this._range;this.api.dispatchAction({type:'dataZoom',from:this.uid,dataZoomId:this.dataZoomModel.id,start:range[0],end:range[1]});},/**
   * @private
   */_findCoordRect:function _findCoordRect(){// Find the grid coresponding to the first axis referred by dataZoom.
var rect;each$14(this.getTargetCoordInfo(),function(coordInfoList){if(!rect&&coordInfoList.length){var coordSys=coordInfoList[0].model.coordinateSystem;rect=coordSys.getRect&&coordSys.getRect();}});if(!rect){var width=this.api.getWidth();var height=this.api.getHeight();rect={x:width*0.2,y:height*0.2,width:width*0.6,height:height*0.6};}return rect;}});function getOtherDim(thisDim){// FIXME
// 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
var map$$1={x:'y',y:'x',radius:'angle',angle:'radius'};return map$$1[thisDim];}function getCursor(orient){return orient==='vertical'?'ns-resize':'ew-resize';}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/DataZoomModel.extend({type:'dataZoom.inside',/**
   * @protected
   */defaultOption:{disabled:false,// Whether disable this inside zoom.
zoomLock:false,// Whether disable zoom but only pan.
zoomOnMouseWheel:true,// Can be: true / false / 'shift' / 'ctrl' / 'alt'.
moveOnMouseMove:true,// Can be: true / false / 'shift' / 'ctrl' / 'alt'.
preventDefaultMouseMove:true}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var ATTR$1='\0_ec_interaction_mutex';function isTaken(zr,resourceKey){return!!getStore(zr)[resourceKey];}function getStore(zr){return zr[ATTR$1]||(zr[ATTR$1]={});}/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */registerAction({type:'takeGlobalCursor',event:'globalCursorTaken',update:'update'},function(){});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @alias module:echarts/component/helper/RoamController
 * @constructor
 * @mixin {module:zrender/mixin/Eventful}
 *
 * @param {module:zrender/zrender~ZRender} zr
 */function RoamController(zr){/**
   * @type {Function}
   */this.pointerChecker;/**
   * @type {module:zrender}
   */this._zr=zr;/**
   * @type {Object}
   */this._opt={};// Avoid two roamController bind the same handler
var bind$$1=bind;var mousedownHandler=bind$$1(mousedown,this);var mousemoveHandler=bind$$1(mousemove,this);var mouseupHandler=bind$$1(mouseup,this);var mousewheelHandler=bind$$1(mousewheel,this);var pinchHandler=bind$$1(pinch,this);Eventful.call(this);/**
   * @param {Function} pointerChecker
   *                   input: x, y
   *                   output: boolean
   */this.setPointerChecker=function(pointerChecker){this.pointerChecker=pointerChecker;};/**
   * Notice: only enable needed types. For example, if 'zoom'
   * is not needed, 'zoom' should not be enabled, otherwise
   * default mousewheel behaviour (scroll page) will be disabled.
   *
   * @param  {boolean|string} [controlType=true] Specify the control type,
   *                          which can be null/undefined or true/false
   *                          or 'pan/move' or 'zoom'/'scale'
   * @param {Object} [opt]
   * @param {Object} [opt.zoomOnMouseWheel=true]
   * @param {Object} [opt.moveOnMouseMove=true]
   * @param {Object} [opt.preventDefaultMouseMove=true] When pan.
   */this.enable=function(controlType,opt){// Disable previous first
this.disable();this._opt=defaults(_clone(opt)||{},{zoomOnMouseWheel:true,moveOnMouseMove:true,preventDefaultMouseMove:true});if(controlType==null){controlType=true;}if(controlType===true||controlType==='move'||controlType==='pan'){zr.on('mousedown',mousedownHandler);zr.on('mousemove',mousemoveHandler);zr.on('mouseup',mouseupHandler);}if(controlType===true||controlType==='scale'||controlType==='zoom'){zr.on('mousewheel',mousewheelHandler);zr.on('pinch',pinchHandler);}};this.disable=function(){zr.off('mousedown',mousedownHandler);zr.off('mousemove',mousemoveHandler);zr.off('mouseup',mouseupHandler);zr.off('mousewheel',mousewheelHandler);zr.off('pinch',pinchHandler);};this.dispose=this.disable;this.isDragging=function(){return this._dragging;};this.isPinching=function(){return this._pinching;};}mixin(RoamController,Eventful);function mousedown(e){if(notLeftMouse(e)||e.target&&e.target.draggable){return;}var x=e.offsetX;var y=e.offsetY;// Only check on mosedown, but not mousemove.
// Mouse can be out of target when mouse moving.
if(this.pointerChecker&&this.pointerChecker(e,x,y)){this._x=x;this._y=y;this._dragging=true;}}function mousemove(e){if(notLeftMouse(e)||!checkKeyBinding(this,'moveOnMouseMove',e)||!this._dragging||e.gestureEvent==='pinch'||isTaken(this._zr,'globalPan')){return;}var x=e.offsetX;var y=e.offsetY;var oldX=this._x;var oldY=this._y;var dx=x-oldX;var dy=y-oldY;this._x=x;this._y=y;this._opt.preventDefaultMouseMove&&stop(e.event);this.trigger('pan',dx,dy,oldX,oldY,x,y);}function mouseup(e){if(!notLeftMouse(e)){this._dragging=false;}}function mousewheel(e){// wheelDelta maybe -0 in chrome mac.
if(!checkKeyBinding(this,'zoomOnMouseWheel',e)||e.wheelDelta===0){return;}// Convenience:
// Mac and VM Windows on Mac: scroll up: zoom out.
// Windows: scroll up: zoom in.
var zoomDelta=e.wheelDelta>0?1.1:1/1.1;zoom.call(this,e,zoomDelta,e.offsetX,e.offsetY);}function pinch(e){if(isTaken(this._zr,'globalPan')){return;}var zoomDelta=e.pinchScale>1?1.1:1/1.1;zoom.call(this,e,zoomDelta,e.pinchX,e.pinchY);}function zoom(e,zoomDelta,zoomX,zoomY){if(this.pointerChecker&&this.pointerChecker(e,zoomX,zoomY)){// When mouse is out of roamController rect,
// default befavoius should not be be disabled, otherwise
// page sliding is disabled, contrary to expectation.
stop(e.event);this.trigger('zoom',zoomDelta,zoomX,zoomY);}}function checkKeyBinding(roamController,prop,e){var setting=roamController._opt[prop];return setting&&(!isString(setting)||e.event[setting+'Key']);}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/// Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.
var curry$5=curry;var ATTR='\0_ec_dataZoom_roams';/**
 * @public
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} dataZoomInfo
 * @param {string} dataZoomInfo.coordId
 * @param {Function} dataZoomInfo.containsPoint
 * @param {Array.<string>} dataZoomInfo.allCoordIds
 * @param {string} dataZoomInfo.dataZoomId
 * @param {number} dataZoomInfo.throttleRate
 * @param {Function} dataZoomInfo.panGetRange
 * @param {Function} dataZoomInfo.zoomGetRange
 * @param {boolean} [dataZoomInfo.zoomLock]
 * @param {boolean} [dataZoomInfo.disabled]
 */function register$1(api,dataZoomInfo){var store=giveStore(api);var theDataZoomId=dataZoomInfo.dataZoomId;var theCoordId=dataZoomInfo.coordId;// Do clean when a dataZoom changes its target coordnate system.
// Avoid memory leak, dispose all not-used-registered.
each$1(store,function(record,coordId){var dataZoomInfos=record.dataZoomInfos;if(dataZoomInfos[theDataZoomId]&&indexOf(dataZoomInfo.allCoordIds,theCoordId)<0){delete dataZoomInfos[theDataZoomId];record.count--;}});cleanStore(store);var record=store[theCoordId];// Create if needed.
if(!record){record=store[theCoordId]={coordId:theCoordId,dataZoomInfos:{},count:0};record.controller=createController(api,record);record.dispatchAction=curry(dispatchAction,api);}// Update reference of dataZoom.
!record.dataZoomInfos[theDataZoomId]&&record.count++;record.dataZoomInfos[theDataZoomId]=dataZoomInfo;var controllerParams=mergeControllerParams(record.dataZoomInfos);record.controller.enable(controllerParams.controlType,controllerParams.opt);// Consider resize, area should be always updated.
record.controller.setPointerChecker(dataZoomInfo.containsPoint);// Update throttle.
createOrUpdate(record,'dispatchAction',dataZoomInfo.throttleRate,'fixRate');}/**
 * @public
 * @param {module:echarts/ExtensionAPI} api
 * @param {string} dataZoomId
 */function unregister$1(api,dataZoomId){var store=giveStore(api);each$1(store,function(record){record.controller.dispose();var dataZoomInfos=record.dataZoomInfos;if(dataZoomInfos[dataZoomId]){delete dataZoomInfos[dataZoomId];record.count--;}});cleanStore(store);}/**
 * @public
 */function generateCoordId(coordModel){return coordModel.type+'\0_'+coordModel.id;}/**
 * Key: coordId, value: {dataZoomInfos: [], count, controller}
 * @type {Array.<Object>}
 */function giveStore(api){// Mount store on zrender instance, so that we do not
// need to worry about dispose.
var zr=api.getZr();return zr[ATTR]||(zr[ATTR]={});}function createController(api,newRecord){var controller=new RoamController(api.getZr());controller.on('pan',curry$5(onPan,newRecord));controller.on('zoom',curry$5(onZoom,newRecord));return controller;}function cleanStore(store){each$1(store,function(record,coordId){if(!record.count){record.controller.dispose();delete store[coordId];}});}function onPan(record,dx,dy,oldX,oldY,newX,newY){wrapAndDispatch(record,function(info){return info.panGetRange(record.controller,dx,dy,oldX,oldY,newX,newY);});}function onZoom(record,scale,mouseX,mouseY){wrapAndDispatch(record,function(info){return info.zoomGetRange(record.controller,scale,mouseX,mouseY);});}function wrapAndDispatch(record,getRange){var batch=[];each$1(record.dataZoomInfos,function(info){var range=getRange(info);!info.disabled&&range&&batch.push({dataZoomId:info.dataZoomId,start:range[0],end:range[1]});});batch.length&&record.dispatchAction(batch);}/**
 * This action will be throttled.
 */function dispatchAction(api,batch){api.dispatchAction({type:'dataZoom',batch:batch});}/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */function mergeControllerParams(dataZoomInfos){var controlType;var opt={};// DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
// as string, it is probably revert to reserved word by compress tool. See #7411.
var prefix='type_';var typePriority={'type_true':2,'type_move':1,'type_false':0,'type_undefined':-1};each$1(dataZoomInfos,function(dataZoomInfo){var oneType=dataZoomInfo.disabled?false:dataZoomInfo.zoomLock?'move':true;if(typePriority[prefix+oneType]>typePriority[prefix+controlType]){controlType=oneType;}// Do not support that different 'shift'/'ctrl'/'alt' setting used in one coord sys.
extend(opt,dataZoomInfo.roamControllerOpt);});return{controlType:controlType,opt:opt};}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var bind$4=bind;var InsideZoomView=DataZoomView.extend({type:'dataZoom.inside',/**
   * @override
   */init:function init(ecModel,api){/**
     * 'throttle' is used in this.dispatchAction, so we save range
     * to avoid missing some 'pan' info.
     * @private
     * @type {Array.<number>}
     */this._range;},/**
   * @override
   */render:function render(dataZoomModel,ecModel,api,payload){InsideZoomView.superApply(this,'render',arguments);// Hance the `throttle` util ensures to preserve command order,
// here simply updating range all the time will not cause missing
// any of the the roam change.
this._range=dataZoomModel.getPercentRange();// Reset controllers.
each$1(this.getTargetCoordInfo(),function(coordInfoList,coordSysName){var allCoordIds=map(coordInfoList,function(coordInfo){return generateCoordId(coordInfo.model);});each$1(coordInfoList,function(coordInfo){var coordModel=coordInfo.model;var dataZoomOption=dataZoomModel.option;register$1(api,{coordId:generateCoordId(coordModel),allCoordIds:allCoordIds,containsPoint:function containsPoint(e,x,y){return coordModel.coordinateSystem.containPoint([x,y]);},dataZoomId:dataZoomModel.id,throttleRate:dataZoomModel.get('throttle',true),panGetRange:bind$4(this._onPan,this,coordInfo,coordSysName),zoomGetRange:bind$4(this._onZoom,this,coordInfo,coordSysName),zoomLock:dataZoomOption.zoomLock,disabled:dataZoomOption.disabled,roamControllerOpt:{zoomOnMouseWheel:dataZoomOption.zoomOnMouseWheel,moveOnMouseMove:dataZoomOption.moveOnMouseMove,preventDefaultMouseMove:dataZoomOption.preventDefaultMouseMove}});},this);},this);},/**
   * @override
   */dispose:function dispose(){unregister$1(this.api,this.dataZoomModel.id);InsideZoomView.superApply(this,'dispose',arguments);this._range=null;},/**
   * @private
   */_onPan:function _onPan(coordInfo,coordSysName,controller,dx,dy,oldX,oldY,newX,newY){var lastRange=this._range;var range=lastRange.slice();// Calculate transform by the first axis.
var axisModel=coordInfo.axisModels[0];if(!axisModel){return;}var directionInfo=getDirectionInfo[coordSysName]([oldX,oldY],[newX,newY],axisModel,controller,coordInfo);var percentDelta=directionInfo.signal*(range[1]-range[0])*directionInfo.pixel/directionInfo.pixelLength;sliderMove(percentDelta,range,[0,100],'all');this._range=range;if(lastRange[0]!==range[0]||lastRange[1]!==range[1]){return range;}},/**
   * @private
   */_onZoom:function _onZoom(coordInfo,coordSysName,controller,scale,mouseX,mouseY){var lastRange=this._range;var range=lastRange.slice();// Calculate transform by the first axis.
var axisModel=coordInfo.axisModels[0];if(!axisModel){return;}var directionInfo=getDirectionInfo[coordSysName](null,[mouseX,mouseY],axisModel,controller,coordInfo);var percentPoint=(directionInfo.signal>0?directionInfo.pixelStart+directionInfo.pixelLength-directionInfo.pixel:directionInfo.pixel-directionInfo.pixelStart)/directionInfo.pixelLength*(range[1]-range[0])+range[0];scale=Math.max(1/scale,0);range[0]=(range[0]-percentPoint)*scale+percentPoint;range[1]=(range[1]-percentPoint)*scale+percentPoint;// Restrict range.
var minMaxSpan=this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();sliderMove(0,range,[0,100],0,minMaxSpan.minSpan,minMaxSpan.maxSpan);this._range=range;if(lastRange[0]!==range[0]||lastRange[1]!==range[1]){return range;}}});var getDirectionInfo={grid:function grid(oldPoint,newPoint,axisModel,controller,coordInfo){var axis=axisModel.axis;var ret={};var rect=coordInfo.model.coordinateSystem.getRect();oldPoint=oldPoint||[0,0];if(axis.dim==='x'){ret.pixel=newPoint[0]-oldPoint[0];ret.pixelLength=rect.width;ret.pixelStart=rect.x;ret.signal=axis.inverse?1:-1;}else{// axis.dim === 'y'
ret.pixel=newPoint[1]-oldPoint[1];ret.pixelLength=rect.height;ret.pixelStart=rect.y;ret.signal=axis.inverse?-1:1;}return ret;},polar:function polar(oldPoint,newPoint,axisModel,controller,coordInfo){var axis=axisModel.axis;var ret={};var polar=coordInfo.model.coordinateSystem;var radiusExtent=polar.getRadiusAxis().getExtent();var angleExtent=polar.getAngleAxis().getExtent();oldPoint=oldPoint?polar.pointToCoord(oldPoint):[0,0];newPoint=polar.pointToCoord(newPoint);if(axisModel.mainType==='radiusAxis'){ret.pixel=newPoint[0]-oldPoint[0];// ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
// ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
ret.pixelLength=radiusExtent[1]-radiusExtent[0];ret.pixelStart=radiusExtent[0];ret.signal=axis.inverse?1:-1;}else{// 'angleAxis'
ret.pixel=newPoint[1]-oldPoint[1];// ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
// ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
ret.pixelLength=angleExtent[1]-angleExtent[0];ret.pixelStart=angleExtent[0];ret.signal=axis.inverse?-1:1;}return ret;},singleAxis:function singleAxis(oldPoint,newPoint,axisModel,controller,coordInfo){var axis=axisModel.axis;var rect=coordInfo.model.coordinateSystem.getRect();var ret={};oldPoint=oldPoint||[0,0];if(axis.orient==='horizontal'){ret.pixel=newPoint[0]-oldPoint[0];ret.pixelLength=rect.width;ret.pixelStart=rect.x;ret.signal=axis.inverse?1:-1;}else{// 'vertical'
ret.pixel=newPoint[1]-oldPoint[1];ret.pixelLength=rect.height;ret.pixelStart=rect.y;ret.signal=axis.inverse?-1:1;}return ret;}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/registerProcessor({// `dataZoomProcessor` will only be performed in needed series. Consider if
// there is a line series and a pie series, it is better not to update the
// line series if only pie series is needed to be updated.
getTargetSeries:function getTargetSeries(ecModel){var seriesModelMap=createHashMap();ecModel.eachComponent('dataZoom',function(dataZoomModel){dataZoomModel.eachTargetAxis(function(dimNames,axisIndex,dataZoomModel){var axisProxy=dataZoomModel.getAxisProxy(dimNames.name,axisIndex);each$1(axisProxy.getTargetSeriesModels(),function(seriesModel){seriesModelMap.set(seriesModel.uid,seriesModel);});});});return seriesModelMap;},modifyOutputEnd:true,// Consider appendData, where filter should be performed. Because data process is
// in block mode currently, it is not need to worry about that the overallProgress
// execute every frame.
overallReset:function overallReset(ecModel,api){ecModel.eachComponent('dataZoom',function(dataZoomModel){// We calculate window and reset axis here but not in model
// init stage and not after action dispatch handler, because
// reset should be called after seriesData.restoreData.
dataZoomModel.eachTargetAxis(function(dimNames,axisIndex,dataZoomModel){dataZoomModel.getAxisProxy(dimNames.name,axisIndex).reset(dataZoomModel,api);});// Caution: data zoom filtering is order sensitive when using
// percent range and no min/max/scale set on axis.
// For example, we have dataZoom definition:
// [
//      {xAxisIndex: 0, start: 30, end: 70},
//      {yAxisIndex: 0, start: 20, end: 80}
// ]
// In this case, [20, 80] of y-dataZoom should be based on data
// that have filtered by x-dataZoom using range of [30, 70],
// but should not be based on full raw data. Thus sliding
// x-dataZoom will change both ranges of xAxis and yAxis,
// while sliding y-dataZoom will only change the range of yAxis.
// So we should filter x-axis after reset x-axis immediately,
// and then reset y-axis and filter y-axis.
dataZoomModel.eachTargetAxis(function(dimNames,axisIndex,dataZoomModel){dataZoomModel.getAxisProxy(dimNames.name,axisIndex).filterData(dataZoomModel,api);});});ecModel.eachComponent('dataZoom',function(dataZoomModel){// Fullfill all of the range props so that user
// is able to get them from chart.getOption().
var axisProxy=dataZoomModel.findRepresentativeAxisProxy();var percentRange=axisProxy.getDataPercentWindow();var valueRange=axisProxy.getDataValueWindow();dataZoomModel.setRawRange({start:percentRange[0],end:percentRange[1],startValue:valueRange[0],endValue:valueRange[1]},true);});}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/registerAction('dataZoom',function(payload,ecModel){var linkedNodesFinder=createLinkedNodesFinder(bind(ecModel.eachComponent,ecModel,'dataZoom'),eachAxisDim$1,function(model,dimNames){return model.get(dimNames.axisIndex);});var effectedModels=[];ecModel.eachComponent({mainType:'dataZoom',query:payload},function(model,index){effectedModels.push.apply(effectedModels,linkedNodesFinder(model).nodes);});each$1(effectedModels,function(dataZoomModel,index){dataZoomModel.setRawRange({start:payload.start,end:payload.end,startValue:payload.startValue,endValue:payload.endValue});});});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * DataZoom component entry
 *//*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var each$15=each$1;var preprocessor$1=function preprocessor$1(option){var visualMap=option&&option.visualMap;if(!isArray(visualMap)){visualMap=visualMap?[visualMap]:[];}each$15(visualMap,function(opt){if(!opt){return;}// rename splitList to pieces
if(has$1(opt,'splitList')&&!has$1(opt,'pieces')){opt.pieces=opt.splitList;delete opt.splitList;}var pieces=opt.pieces;if(pieces&&isArray(pieces)){each$15(pieces,function(piece){if(isObject$1(piece)){if(has$1(piece,'start')&&!has$1(piece,'min')){piece.min=piece.start;}if(has$1(piece,'end')&&!has$1(piece,'max')){piece.max=piece.end;}}});}});};function has$1(obj,name){return obj&&obj.hasOwnProperty&&obj.hasOwnProperty(name);}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ComponentModel.registerSubTypeDefaulter('visualMap',function(option){// Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
return!option.categories&&(!(option.pieces?option.pieces.length>0:option.splitNumber>0)||option.calculable)?'continuous':'piecewise';});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var each$17=each$1;var isObject$5=isObject$1;var CATEGORY_DEFAULT_VISUAL_INDEX=-1;/**
 * @param {Object} option
 * @param {string} [option.type] See visualHandlers.
 * @param {string} [option.mappingMethod] 'linear' or 'piecewise' or 'category' or 'fixed'
 * @param {Array.<number>=} [option.dataExtent] [minExtent, maxExtent],
 *                                              required when mappingMethod is 'linear'
 * @param {Array.<Object>=} [option.pieceList] [
 *                                             {value: someValue},
 *                                             {interval: [min1, max1], visual: {...}},
 *                                             {interval: [min2, max2]}
 *                                             ],
 *                                            required when mappingMethod is 'piecewise'.
 *                                            Visual for only each piece can be specified.
 * @param {Array.<string|Object>=} [option.categories] ['cate1', 'cate2']
 *                                            required when mappingMethod is 'category'.
 *                                            If no option.categories, categories is set
 *                                            as [0, 1, 2, ...].
 * @param {boolean} [option.loop=false] Whether loop mapping when mappingMethod is 'category'.
 * @param {(Array|Object|*)} [option.visual]  Visual data.
 *                                            when mappingMethod is 'category',
 *                                            visual data can be array or object
 *                                            (like: {cate1: '#222', none: '#fff'})
 *                                            or primary types (which represents
 *                                            defualt category visual), otherwise visual
 *                                            can be array or primary (which will be
 *                                            normalized to array).
 *
 */var VisualMapping=function VisualMapping(option){var mappingMethod=option.mappingMethod;var visualType=option.type;/**
   * @readOnly
   * @type {Object}
   */var thisOption=this.option=_clone(option);/**
   * @readOnly
   * @type {string}
   */this.type=visualType;/**
   * @readOnly
   * @type {string}
   */this.mappingMethod=mappingMethod;/**
   * @private
   * @type {Function}
   */this._normalizeData=normalizers[mappingMethod];var visualHandler=visualHandlers[visualType];/**
   * @public
   * @type {Function}
   */this.applyVisual=visualHandler.applyVisual;/**
   * @public
   * @type {Function}
   */this.getColorMapper=visualHandler.getColorMapper;/**
   * @private
   * @type {Function}
   */this._doMap=visualHandler._doMap[mappingMethod];if(mappingMethod==='piecewise'){normalizeVisualRange(thisOption);preprocessForPiecewise(thisOption);}else if(mappingMethod==='category'){thisOption.categories?preprocessForSpecifiedCategory(thisOption)// categories is ordinal when thisOption.categories not specified,
// which need no more preprocess except normalize visual.
:normalizeVisualRange(thisOption,true);}else{// mappingMethod === 'linear' or 'fixed'
assert$1(mappingMethod!=='linear'||thisOption.dataExtent);normalizeVisualRange(thisOption);}};VisualMapping.prototype={constructor:VisualMapping,mapValueToVisual:function mapValueToVisual(value){var normalized=this._normalizeData(value);return this._doMap(normalized,value);},getNormalizer:function getNormalizer(){return bind(this._normalizeData,this);}};var visualHandlers=VisualMapping.visualHandlers={color:{applyVisual:makeApplyVisual('color'),/**
     * Create a mapper function
     * @return {Function}
     */getColorMapper:function getColorMapper(){var thisOption=this.option;return bind(thisOption.mappingMethod==='category'?function(value,isNormalized){!isNormalized&&(value=this._normalizeData(value));return doMapCategory.call(this,value);}:function(value,isNormalized,out){// If output rgb array
// which will be much faster and useful in pixel manipulation
var returnRGBArray=!!out;!isNormalized&&(value=this._normalizeData(value));out=fastLerp(value,thisOption.parsedVisual,out);return returnRGBArray?out:stringify(out,'rgba');},this);},_doMap:{linear:function linear(normalized){return stringify(fastLerp(normalized,this.option.parsedVisual),'rgba');},category:doMapCategory,piecewise:function piecewise(normalized,value){var result=getSpecifiedVisual.call(this,value);if(result==null){result=stringify(fastLerp(normalized,this.option.parsedVisual),'rgba');}return result;},fixed:doMapFixed}},colorHue:makePartialColorVisualHandler(function(color,value){return modifyHSL(color,value);}),colorSaturation:makePartialColorVisualHandler(function(color,value){return modifyHSL(color,null,value);}),colorLightness:makePartialColorVisualHandler(function(color,value){return modifyHSL(color,null,null,value);}),colorAlpha:makePartialColorVisualHandler(function(color,value){return modifyAlpha(color,value);}),opacity:{applyVisual:makeApplyVisual('opacity'),_doMap:makeDoMap([0,1])},liftZ:{applyVisual:makeApplyVisual('liftZ'),_doMap:{linear:doMapFixed,category:doMapFixed,piecewise:doMapFixed,fixed:doMapFixed}},symbol:{applyVisual:function applyVisual(value,getter,setter){var symbolCfg=this.mapValueToVisual(value);if(isString(symbolCfg)){setter('symbol',symbolCfg);}else if(isObject$5(symbolCfg)){for(var name in symbolCfg){if(symbolCfg.hasOwnProperty(name)){setter(name,symbolCfg[name]);}}}},_doMap:{linear:doMapToArray,category:doMapCategory,piecewise:function piecewise(normalized,value){var result=getSpecifiedVisual.call(this,value);if(result==null){result=doMapToArray.call(this,normalized);}return result;},fixed:doMapFixed}},symbolSize:{applyVisual:makeApplyVisual('symbolSize'),_doMap:makeDoMap([0,1])}};function preprocessForPiecewise(thisOption){var pieceList=thisOption.pieceList;thisOption.hasSpecialVisual=false;each$1(pieceList,function(piece,index){piece.originIndex=index;// piece.visual is "result visual value" but not
// a visual range, so it does not need to be normalized.
if(piece.visual!=null){thisOption.hasSpecialVisual=true;}});}function preprocessForSpecifiedCategory(thisOption){// Hash categories.
var categories=thisOption.categories;var visual=thisOption.visual;var categoryMap=thisOption.categoryMap={};each$17(categories,function(cate,index){categoryMap[cate]=index;});// Process visual map input.
if(!isArray(visual)){var visualArr=[];if(isObject$1(visual)){each$17(visual,function(v,cate){var index=categoryMap[cate];visualArr[index!=null?index:CATEGORY_DEFAULT_VISUAL_INDEX]=v;});}else{// Is primary type, represents default visual.
visualArr[CATEGORY_DEFAULT_VISUAL_INDEX]=visual;}visual=setVisualToOption(thisOption,visualArr);}// Remove categories that has no visual,
// then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
for(var i=categories.length-1;i>=0;i--){if(visual[i]==null){delete categoryMap[categories[i]];categories.pop();}}}function normalizeVisualRange(thisOption,isCategory){var visual=thisOption.visual;var visualArr=[];if(isObject$1(visual)){each$17(visual,function(v){visualArr.push(v);});}else if(visual!=null){visualArr.push(visual);}var doNotNeedPair={color:1,symbol:1};if(!isCategory&&visualArr.length===1&&!doNotNeedPair.hasOwnProperty(thisOption.type)){// Do not care visualArr.length === 0, which is illegal.
visualArr[1]=visualArr[0];}setVisualToOption(thisOption,visualArr);}function makePartialColorVisualHandler(applyValue){return{applyVisual:function applyVisual(value,getter,setter){value=this.mapValueToVisual(value);// Must not be array value
setter('color',applyValue(getter('color'),value));},_doMap:makeDoMap([0,1])};}function doMapToArray(normalized){var visual=this.option.visual;return visual[Math.round(linearMap(normalized,[0,1],[0,visual.length-1],true))]||{};}function makeApplyVisual(visualType){return function(value,getter,setter){setter(visualType,this.mapValueToVisual(value));};}function doMapCategory(normalized){var visual=this.option.visual;return visual[this.option.loop&&normalized!==CATEGORY_DEFAULT_VISUAL_INDEX?normalized%visual.length:normalized];}function doMapFixed(){return this.option.visual[0];}function makeDoMap(sourceExtent){return{linear:function linear(normalized){return linearMap(normalized,sourceExtent,this.option.visual,true);},category:doMapCategory,piecewise:function piecewise(normalized,value){var result=getSpecifiedVisual.call(this,value);if(result==null){result=linearMap(normalized,sourceExtent,this.option.visual,true);}return result;},fixed:doMapFixed};}function getSpecifiedVisual(value){var thisOption=this.option;var pieceList=thisOption.pieceList;if(thisOption.hasSpecialVisual){var pieceIndex=VisualMapping.findPieceIndex(value,pieceList);var piece=pieceList[pieceIndex];if(piece&&piece.visual){return piece.visual[this.type];}}}function setVisualToOption(thisOption,visualArr){thisOption.visual=visualArr;if(thisOption.type==='color'){thisOption.parsedVisual=map(visualArr,function(item){return parse(item);});}return visualArr;}/**
 * Normalizers by mapping methods.
 */var normalizers={linear:function linear(value){return linearMap(value,this.option.dataExtent,[0,1],true);},piecewise:function piecewise(value){var pieceList=this.option.pieceList;var pieceIndex=VisualMapping.findPieceIndex(value,pieceList,true);if(pieceIndex!=null){return linearMap(pieceIndex,[0,pieceList.length-1],[0,1],true);}},category:function category(value){var index=this.option.categories?this.option.categoryMap[value]:value;// ordinal
return index==null?CATEGORY_DEFAULT_VISUAL_INDEX:index;},fixed:noop};/**
 * List available visual types.
 *
 * @public
 * @return {Array.<string>}
 */VisualMapping.listVisualTypes=function(){var visualTypes=[];each$1(visualHandlers,function(handler,key){visualTypes.push(key);});return visualTypes;};/**
 * @public
 */VisualMapping.addVisualHandler=function(name,handler){visualHandlers[name]=handler;};/**
 * @public
 */VisualMapping.isValidType=function(visualType){return visualHandlers.hasOwnProperty(visualType);};/**
 * Convinent method.
 * Visual can be Object or Array or primary type.
 *
 * @public
 */VisualMapping.eachVisual=function(visual,callback,context){if(isObject$1(visual)){each$1(visual,callback,context);}else{callback.call(context,visual);}};VisualMapping.mapVisual=function(visual,callback,context){var isPrimary;var newVisual=isArray(visual)?[]:isObject$1(visual)?{}:(isPrimary=true,null);VisualMapping.eachVisual(visual,function(v,key){var newVal=callback.call(context,v,key);isPrimary?newVisual=newVal:newVisual[key]=newVal;});return newVisual;};/**
 * @public
 * @param {Object} obj
 * @return {Object} new object containers visual values.
 *                 If no visuals, return null.
 */VisualMapping.retrieveVisuals=function(obj){var ret={};var hasVisual;obj&&each$17(visualHandlers,function(h,visualType){if(obj.hasOwnProperty(visualType)){ret[visualType]=obj[visualType];hasVisual=true;}});return hasVisual?ret:null;};/**
 * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
 *
 * @public
 * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
 *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
 * @return {Array.<string>} Sorted visual types.
 */VisualMapping.prepareVisualTypes=function(visualTypes){if(isObject$5(visualTypes)){var types=[];each$17(visualTypes,function(item,type){types.push(type);});visualTypes=types;}else if(isArray(visualTypes)){visualTypes=visualTypes.slice();}else{return[];}visualTypes.sort(function(type1,type2){// color should be front of colorSaturation, colorAlpha, ...
// symbol and symbolSize do not matter.
return type2==='color'&&type1!=='color'&&type1.indexOf('color')===0?1:-1;});return visualTypes;};/**
 * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
 * Other visuals are only depends on themself.
 *
 * @public
 * @param {string} visualType1
 * @param {string} visualType2
 * @return {boolean}
 */VisualMapping.dependsOn=function(visualType1,visualType2){return visualType2==='color'?!!(visualType1&&visualType1.indexOf(visualType2)===0):visualType1===visualType2;};/**
 * @param {number} value
 * @param {Array.<Object>} pieceList [{value: ..., interval: [min, max]}, ...]
 *                         Always from small to big.
 * @param {boolean} [findClosestWhenOutside=false]
 * @return {number} index
 */VisualMapping.findPieceIndex=function(value,pieceList,findClosestWhenOutside){var possibleI;var abs=Infinity;// value has the higher priority.
for(var i=0,len=pieceList.length;i<len;i++){var pieceValue=pieceList[i].value;if(pieceValue!=null){if(pieceValue===value// FIXME
// It is supposed to compare value according to value type of dimension,
// but currently value type can exactly be string or number.
// Compromise for numeric-like string (like '12'), especially
// in the case that visualMap.categories is ['22', '33'].
||typeof pieceValue==='string'&&pieceValue===value+''){return i;}findClosestWhenOutside&&updatePossible(pieceValue,i);}}for(var i=0,len=pieceList.length;i<len;i++){var piece=pieceList[i];var interval=piece.interval;var close=piece.close;if(interval){if(interval[0]===-Infinity){if(littleThan(close[1],value,interval[1])){return i;}}else if(interval[1]===Infinity){if(littleThan(close[0],interval[0],value)){return i;}}else if(littleThan(close[0],interval[0],value)&&littleThan(close[1],value,interval[1])){return i;}findClosestWhenOutside&&updatePossible(interval[0],i);findClosestWhenOutside&&updatePossible(interval[1],i);}}if(findClosestWhenOutside){return value===Infinity?pieceList.length-1:value===-Infinity?0:possibleI;}function updatePossible(val,index){var newAbs=Math.abs(val-value);if(newAbs<abs){abs=newAbs;possibleI=index;}}};function littleThan(close,a,b){return close?a<=b:a<b;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @file Visual solution, for consistent option specification.
 */var each$16=each$1;function hasKeys(obj){if(obj){for(var name in obj){if(obj.hasOwnProperty(name)){return true;}}}}/**
 * @param {Object} option
 * @param {Array.<string>} stateList
 * @param {Function} [supplementVisualOption]
 * @return {Object} visualMappings <state, <visualType, module:echarts/visual/VisualMapping>>
 */function createVisualMappings(option,stateList,supplementVisualOption){var visualMappings={};each$16(stateList,function(state){var mappings=visualMappings[state]=createMappings();each$16(option[state],function(visualData,visualType){if(!VisualMapping.isValidType(visualType)){return;}var mappingOption={type:visualType,visual:visualData};supplementVisualOption&&supplementVisualOption(mappingOption,state);mappings[visualType]=new VisualMapping(mappingOption);// Prepare a alpha for opacity, for some case that opacity
// is not supported, such as rendering using gradient color.
if(visualType==='opacity'){mappingOption=_clone(mappingOption);mappingOption.type='colorAlpha';mappings.__hidden.__alphaForOpacity=new VisualMapping(mappingOption);}});});return visualMappings;function createMappings(){var Creater=function Creater(){};// Make sure hidden fields will not be visited by
// object iteration (with hasOwnProperty checking).
Creater.prototype.__hidden=Creater.prototype;var obj=new Creater();return obj;}}/**
 * @param {Object} thisOption
 * @param {Object} newOption
 * @param {Array.<string>} keys
 */function replaceVisualOption(thisOption,newOption,keys){// Visual attributes merge is not supported, otherwise it
// brings overcomplicated merge logic. See #2853. So if
// newOption has anyone of these keys, all of these keys
// will be reset. Otherwise, all keys remain.
var has;each$1(keys,function(key){if(newOption.hasOwnProperty(key)&&hasKeys(newOption[key])){has=true;}});has&&each$1(keys,function(key){if(newOption.hasOwnProperty(key)&&hasKeys(newOption[key])){thisOption[key]=_clone(newOption[key]);}else{delete thisOption[key];}});}/**
 * @param {Array.<string>} stateList
 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
 * @param {module:echarts/data/List} list
 * @param {Function} getValueState param: valueOrIndex, return: state.
 * @param {object} [scope] Scope for getValueState
 * @param {string} [dimension] Concrete dimension, if used.
 */// ???! handle brush?
/**
 * @param {module:echarts/data/List} data
 * @param {Array.<string>} stateList
 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
 * @param {Function} getValueState param: valueOrIndex, return: state.
 * @param {number} [dim] dimension or dimension index.
 */function incrementalApplyVisual(stateList,visualMappings,getValueState,dim){var visualTypesMap={};each$1(stateList,function(state){var visualTypes=VisualMapping.prepareVisualTypes(visualMappings[state]);visualTypesMap[state]=visualTypes;});function progress(params,data){if(dim!=null){dim=data.getDimension(dim);}function getVisual(key){return data.getItemVisual(dataIndex,key);}function setVisual(key,value){data.setItemVisual(dataIndex,key,value);}var dataIndex;while((dataIndex=params.next())!=null){var rawDataItem=data.getRawDataItem(dataIndex);// Consider performance
if(rawDataItem&&rawDataItem.visualMap===false){return;}var value=dim!=null?data.get(dim,dataIndex,true):dataIndex;var valueState=getValueState(value);var mappings=visualMappings[valueState];var visualTypes=visualTypesMap[valueState];for(var i=0,len=visualTypes.length;i<len;i++){var type=visualTypes[i];mappings[type]&&mappings[type].applyVisual(value,getVisual,setVisual);}}}return{progress:progress};}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var VISUAL_PRIORITY=PRIORITY.VISUAL.COMPONENT;registerVisual(VISUAL_PRIORITY,{createOnAllSeries:true,reset:function reset(seriesModel,ecModel){var resetDefines=[];ecModel.eachComponent('visualMap',function(visualMapModel){var pipelineContext=seriesModel.pipelineContext;if(!visualMapModel.isTargetSeries(seriesModel)||pipelineContext&&pipelineContext.large){return;}resetDefines.push(incrementalApplyVisual(visualMapModel.stateList,visualMapModel.targetVisuals,bind(visualMapModel.getValueState,visualMapModel),visualMapModel.getDataDimension(seriesModel.getData())));});return resetDefines;}});// Only support color.
registerVisual(VISUAL_PRIORITY,{createOnAllSeries:true,reset:function reset(seriesModel,ecModel){var data=seriesModel.getData();var visualMetaList=[];ecModel.eachComponent('visualMap',function(visualMapModel){if(visualMapModel.isTargetSeries(seriesModel)){var visualMeta=visualMapModel.getVisualMeta(bind(getColorVisual,null,seriesModel,visualMapModel))||{stops:[],outerColors:[]};var concreteDim=visualMapModel.getDataDimension(data);var dimInfo=data.getDimensionInfo(concreteDim);if(dimInfo!=null){// visualMeta.dimension should be dimension index, but not concrete dimension.
visualMeta.dimension=dimInfo.index;visualMetaList.push(visualMeta);}}});// console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
seriesModel.getData().setVisual('visualMeta',visualMetaList);}});// FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity
function getColorVisual(seriesModel,visualMapModel,value,valueState){var mappings=visualMapModel.targetVisuals[valueState];var visualTypes=VisualMapping.prepareVisualTypes(mappings);var resultVisual={color:seriesModel.getData().getVisual('color')// default color.
};for(var i=0,len=visualTypes.length;i<len;i++){var type=visualTypes[i];var mapping=mappings[type==='opacity'?'__alphaForOpacity':type];mapping&&mapping.applyVisual(value,getVisual,setVisual);}return resultVisual.color;function getVisual(key){return resultVisual[key];}function setVisual(key,value){resultVisual[key]=value;}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @file Visual mapping.
 */var visualDefault={/**
   * @public
   */get:function get(visualType,key,isCategory){var value=_clone((defaultOption$1[visualType]||{})[key]);return isCategory?isArray(value)?value[value.length-1]:value:value;}};var defaultOption$1={color:{active:['#006edd','#e0ffff'],inactive:['rgba(0,0,0,0)']},colorHue:{active:[0,360],inactive:[0,0]},colorSaturation:{active:[0.3,1],inactive:[0,0]},colorLightness:{active:[0.9,0.5],inactive:[0,0]},colorAlpha:{active:[0.3,1],inactive:[0,0]},opacity:{active:[0.3,1],inactive:[0,0]},symbol:{active:['circle','roundRect','diamond'],inactive:['none']},symbolSize:{active:[10,50],inactive:[0,0]}};/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var mapVisual=VisualMapping.mapVisual;var eachVisual=VisualMapping.eachVisual;var isArray$2=isArray;var each$18=each$1;var asc$3=asc;var linearMap$2=linearMap;var noop$1=noop;var VisualMapModel=extendComponentModel({type:'visualMap',dependencies:['series'],/**
   * @readOnly
   * @type {Array.<string>}
   */stateList:['inRange','outOfRange'],/**
   * @readOnly
   * @type {Array.<string>}
   */replacableOptionKeys:['inRange','outOfRange','target','controller','color'],/**
   * [lowerBound, upperBound]
   *
   * @readOnly
   * @type {Array.<number>}
   */dataBound:[-Infinity,Infinity],/**
   * @readOnly
   * @type {string|Object}
   */layoutMode:{type:'box',ignoreSize:true},/**
   * @protected
   */defaultOption:{show:true,zlevel:0,z:4,seriesIndex:'all',// 'all' or null/undefined: all series.
// A number or an array of number: the specified series.
// set min: 0, max: 200, only for campatible with ec2.
// In fact min max should not have default value.
min:0,// min value, must specified if pieces is not specified.
max:200,// max value, must specified if pieces is not specified.
dimension:null,inRange:null,// 'color', 'colorHue', 'colorSaturation', 'colorLightness', 'colorAlpha',
// 'symbol', 'symbolSize'
outOfRange:null,// 'color', 'colorHue', 'colorSaturation',
// 'colorLightness', 'colorAlpha',
// 'symbol', 'symbolSize'
left:0,// 'center' ¦ 'left' ¦ 'right' ¦ {number} (px)
right:null,// The same as left.
top:null,// 'top' ¦ 'bottom' ¦ 'center' ¦ {number} (px)
bottom:0,// The same as top.
itemWidth:null,itemHeight:null,inverse:false,orient:'vertical',// 'horizontal' ¦ 'vertical'
backgroundColor:'rgba(0,0,0,0)',borderColor:'#ccc',// 值域边框颜色
contentColor:'#5793f3',inactiveColor:'#aaa',borderWidth:0,// 值域边框线宽，单位px，默认为0（无边框）
padding:5,// 值域内边距，单位px，默认各方向内边距为5，
// 接受数组分别设定上右下左边距，同css
textGap:10,//
precision:0,// 小数精度，默认为0，无小数点
color:null,//颜色（deprecated，兼容ec2，顺序同pieces，不同于inRange/outOfRange）
formatter:null,text:null,// 文本，如['高', '低']，兼容ec2，text[0]对应高值，text[1]对应低值
textStyle:{color:'#333'// 值域文字颜色
}},/**
   * @protected
   */init:function init(option,parentModel,ecModel){/**
     * @private
     * @type {Array.<number>}
     */this._dataExtent;/**
     * @readOnly
     */this.targetVisuals={};/**
     * @readOnly
     */this.controllerVisuals={};/**
     * @readOnly
     */this.textStyleModel;/**
     * [width, height]
     * @readOnly
     * @type {Array.<number>}
     */this.itemSize;this.mergeDefaultAndTheme(option,ecModel);},/**
   * @protected
   */optionUpdated:function optionUpdated(newOption,isInit){var thisOption=this.option;// FIXME
// necessary?
// Disable realtime view update if canvas is not supported.
if(!env$1.canvasSupported){thisOption.realtime=false;}!isInit&&replaceVisualOption(thisOption,newOption,this.replacableOptionKeys);this.textStyleModel=this.getModel('textStyle');this.resetItemSize();this.completeVisualOption();},/**
   * @protected
   */resetVisual:function resetVisual(supplementVisualOption){var stateList=this.stateList;supplementVisualOption=bind(supplementVisualOption,this);this.controllerVisuals=createVisualMappings(this.option.controller,stateList,supplementVisualOption);this.targetVisuals=createVisualMappings(this.option.target,stateList,supplementVisualOption);},/**
   * @protected
   * @return {Array.<number>} An array of series indices.
   */getTargetSeriesIndices:function getTargetSeriesIndices(){var optionSeriesIndex=this.option.seriesIndex;var seriesIndices=[];if(optionSeriesIndex==null||optionSeriesIndex==='all'){this.ecModel.eachSeries(function(seriesModel,index){seriesIndices.push(index);});}else{seriesIndices=normalizeToArray(optionSeriesIndex);}return seriesIndices;},/**
   * @public
   */eachTargetSeries:function eachTargetSeries(callback,context){each$1(this.getTargetSeriesIndices(),function(seriesIndex){callback.call(context,this.ecModel.getSeriesByIndex(seriesIndex));},this);},/**
   * @pubilc
   */isTargetSeries:function isTargetSeries(seriesModel){var is=false;this.eachTargetSeries(function(model){model===seriesModel&&(is=true);});return is;},/**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param {number|Array.<number>} value Real value, or this.dataBound[0 or 1].
   * @param {boolean} [isCategory=false] Only available when value is number.
   * @param {Array.<string>} edgeSymbols Open-close symbol when value is interval.
   * @return {string}
   * @protected
   */formatValueText:function formatValueText(value,isCategory,edgeSymbols){var option=this.option;var precision=option.precision;var dataBound=this.dataBound;var formatter=option.formatter;var isMinMax;var textValue;edgeSymbols=edgeSymbols||['<','>'];if(isArray(value)){value=value.slice();isMinMax=true;}textValue=isCategory?value:isMinMax?[toFixed(value[0]),toFixed(value[1])]:toFixed(value);if(isString(formatter)){return formatter.replace('{value}',isMinMax?textValue[0]:textValue).replace('{value2}',isMinMax?textValue[1]:textValue);}else if(isFunction$1(formatter)){return isMinMax?formatter(value[0],value[1]):formatter(value);}if(isMinMax){if(value[0]===dataBound[0]){return edgeSymbols[0]+' '+textValue[1];}else if(value[1]===dataBound[1]){return edgeSymbols[1]+' '+textValue[0];}else{return textValue[0]+' - '+textValue[1];}}else{// Format single value (includes category case).
return textValue;}function toFixed(val){return val===dataBound[0]?'min':val===dataBound[1]?'max':(+val).toFixed(Math.min(precision,20));}},/**
   * @protected
   */resetExtent:function resetExtent(){var thisOption=this.option;// Can not calculate data extent by data here.
// Because series and data may be modified in processing stage.
// So we do not support the feature "auto min/max".
var extent=asc$3([thisOption.min,thisOption.max]);this._dataExtent=extent;},/**
   * @public
   * @param {module:echarts/data/List} list
   * @return {string} Concrete dimention. If return null/undefined,
   *                  no dimension used.
   */getDataDimension:function getDataDimension(list){var optDim=this.option.dimension;var listDimensions=list.dimensions;if(optDim==null&&!listDimensions.length){return;}if(optDim!=null){return list.getDimension(optDim);}var dimNames=list.dimensions;for(var i=dimNames.length-1;i>=0;i--){var dimName=dimNames[i];var dimInfo=list.getDimensionInfo(dimName);if(!dimInfo.isCalculationCoord){return dimName;}}},/**
   * @public
   * @override
   */getExtent:function getExtent(){return this._dataExtent.slice();},/**
   * @protected
   */completeVisualOption:function completeVisualOption(){var ecModel=this.ecModel;var thisOption=this.option;var base={inRange:thisOption.inRange,outOfRange:thisOption.outOfRange};var target=thisOption.target||(thisOption.target={});var controller=thisOption.controller||(thisOption.controller={});merge(target,base);// Do not override
merge(controller,base);// Do not override
var isCategory=this.isCategory();completeSingle.call(this,target);completeSingle.call(this,controller);completeInactive.call(this,target,'inRange','outOfRange');// completeInactive.call(this, target, 'outOfRange', 'inRange');
completeController.call(this,controller);function completeSingle(base){// Compatible with ec2 dataRange.color.
// The mapping order of dataRange.color is: [high value, ..., low value]
// whereas inRange.color and outOfRange.color is [low value, ..., high value]
// Notice: ec2 has no inverse.
if(isArray$2(thisOption.color)// If there has been inRange: {symbol: ...}, adding color is a mistake.
// So adding color only when no inRange defined.
&&!base.inRange){base.inRange={color:thisOption.color.slice().reverse()};}// Compatible with previous logic, always give a defautl color, otherwise
// simple config with no inRange and outOfRange will not work.
// Originally we use visualMap.color as the default color, but setOption at
// the second time the default color will be erased. So we change to use
// constant DEFAULT_COLOR.
// If user do not want the defualt color, set inRange: {color: null}.
base.inRange=base.inRange||{color:ecModel.get('gradientColor')};// If using shortcut like: {inRange: 'symbol'}, complete default value.
each$18(this.stateList,function(state){var visualType=base[state];if(isString(visualType)){var defa=visualDefault.get(visualType,'active',isCategory);if(defa){base[state]={};base[state][visualType]=defa;}else{// Mark as not specified.
delete base[state];}}},this);}function completeInactive(base,stateExist,stateAbsent){var optExist=base[stateExist];var optAbsent=base[stateAbsent];if(optExist&&!optAbsent){optAbsent=base[stateAbsent]={};each$18(optExist,function(visualData,visualType){if(!VisualMapping.isValidType(visualType)){return;}var defa=visualDefault.get(visualType,'inactive',isCategory);if(defa!=null){optAbsent[visualType]=defa;// Compatibable with ec2:
// Only inactive color to rgba(0,0,0,0) can not
// make label transparent, so use opacity also.
if(visualType==='color'&&!optAbsent.hasOwnProperty('opacity')&&!optAbsent.hasOwnProperty('colorAlpha')){optAbsent.opacity=[0,0];}}});}}function completeController(controller){var symbolExists=(controller.inRange||{}).symbol||(controller.outOfRange||{}).symbol;var symbolSizeExists=(controller.inRange||{}).symbolSize||(controller.outOfRange||{}).symbolSize;var inactiveColor=this.get('inactiveColor');each$18(this.stateList,function(state){var itemSize=this.itemSize;var visuals=controller[state];// Set inactive color for controller if no other color
// attr (like colorAlpha) specified.
if(!visuals){visuals=controller[state]={color:isCategory?inactiveColor:[inactiveColor]};}// Consistent symbol and symbolSize if not specified.
if(visuals.symbol==null){visuals.symbol=symbolExists&&_clone(symbolExists)||(isCategory?'roundRect':['roundRect']);}if(visuals.symbolSize==null){visuals.symbolSize=symbolSizeExists&&_clone(symbolSizeExists)||(isCategory?itemSize[0]:[itemSize[0],itemSize[0]]);}// Filter square and none.
visuals.symbol=mapVisual(visuals.symbol,function(symbol){return symbol==='none'||symbol==='square'?'roundRect':symbol;});// Normalize symbolSize
var symbolSize=visuals.symbolSize;if(symbolSize!=null){var max=-Infinity;// symbolSize can be object when categories defined.
eachVisual(symbolSize,function(value){value>max&&(max=value);});visuals.symbolSize=mapVisual(symbolSize,function(value){return linearMap$2(value,[0,max],[0,itemSize[0]],true);});}},this);}},/**
   * @protected
   */resetItemSize:function resetItemSize(){this.itemSize=[parseFloat(this.get('itemWidth')),parseFloat(this.get('itemHeight'))];},/**
   * @public
   */isCategory:function isCategory(){return!!this.option.categories;},/**
   * @public
   * @abstract
   */setSelected:noop$1,/**
   * @public
   * @abstract
   * @param {*|module:echarts/data/List} valueOrData
   * @param {number} dataIndex
   * @return {string} state See this.stateList
   */getValueState:noop$1,/**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param {Function} getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */getVisualMeta:noop$1});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var DEFAULT_BAR_BOUND=[20,140];var ContinuousModel=VisualMapModel.extend({type:'visualMap.continuous',/**
   * @protected
   */defaultOption:{align:'auto',// 'auto', 'left', 'right', 'top', 'bottom'
calculable:false,// This prop effect default component type determine,
// See echarts/component/visualMap/typeDefaulter.
range:null,// selected range. In default case `range` is [min, max]
// and can auto change along with modification of min max,
// util use specifid a range.
realtime:true,// Whether realtime update.
itemHeight:null,// The length of the range control edge.
itemWidth:null,// The length of the other side.
hoverLink:true,// Enable hover highlight.
hoverLinkDataSize:null,// The size of hovered data.
hoverLinkOnHandle:null// Whether trigger hoverLink when hover handle.
// If not specified, follow the value of `realtime`.
},/**
   * @override
   */optionUpdated:function optionUpdated(newOption,isInit){ContinuousModel.superApply(this,'optionUpdated',arguments);this.resetExtent();this.resetVisual(function(mappingOption){mappingOption.mappingMethod='linear';mappingOption.dataExtent=this.getExtent();});this._resetRange();},/**
   * @protected
   * @override
   */resetItemSize:function resetItemSize(){ContinuousModel.superApply(this,'resetItemSize',arguments);var itemSize=this.itemSize;this._orient==='horizontal'&&itemSize.reverse();(itemSize[0]==null||isNaN(itemSize[0]))&&(itemSize[0]=DEFAULT_BAR_BOUND[0]);(itemSize[1]==null||isNaN(itemSize[1]))&&(itemSize[1]=DEFAULT_BAR_BOUND[1]);},/**
   * @private
   */_resetRange:function _resetRange(){var dataExtent=this.getExtent();var range=this.option.range;if(!range||range.auto){// `range` should always be array (so we dont use other
// value like 'auto') for user-friend. (consider getOption).
dataExtent.auto=1;this.option.range=dataExtent;}else if(isArray(range)){if(range[0]>range[1]){range.reverse();}range[0]=Math.max(range[0],dataExtent[0]);range[1]=Math.min(range[1],dataExtent[1]);}},/**
   * @protected
   * @override
   */completeVisualOption:function completeVisualOption(){VisualMapModel.prototype.completeVisualOption.apply(this,arguments);each$1(this.stateList,function(state){var symbolSize=this.option.controller[state].symbolSize;if(symbolSize&&symbolSize[0]!==symbolSize[1]){symbolSize[0]=0;// For good looking.
}},this);},/**
   * @override
   */setSelected:function setSelected(selected){this.option.range=selected.slice();this._resetRange();},/**
   * @public
   */getSelected:function getSelected(){var dataExtent=this.getExtent();var dataInterval=asc((this.get('range')||[]).slice());// Clamp
dataInterval[0]>dataExtent[1]&&(dataInterval[0]=dataExtent[1]);dataInterval[1]>dataExtent[1]&&(dataInterval[1]=dataExtent[1]);dataInterval[0]<dataExtent[0]&&(dataInterval[0]=dataExtent[0]);dataInterval[1]<dataExtent[0]&&(dataInterval[1]=dataExtent[0]);return dataInterval;},/**
   * @override
   */getValueState:function getValueState(value){var range=this.option.range;var dataExtent=this.getExtent();// When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
// range[1] is processed likewise.
return(range[0]<=dataExtent[0]||range[0]<=value)&&(range[1]>=dataExtent[1]||value<=range[1])?'inRange':'outOfRange';},/**
   * @params {Array.<number>} range target value: range[0] <= value && value <= range[1]
   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
   */findTargetDataIndices:function findTargetDataIndices(range){var result=[];this.eachTargetSeries(function(seriesModel){var dataIndices=[];var data=seriesModel.getData();data.each(this.getDataDimension(data),function(value,dataIndex){range[0]<=value&&value<=range[1]&&dataIndices.push(dataIndex);},this);result.push({seriesId:seriesModel.id,dataIndex:dataIndices});},this);return result;},/**
   * @implement
   */getVisualMeta:function getVisualMeta(getColorVisual){var oVals=getColorStopValues(this,'outOfRange',this.getExtent());var iVals=getColorStopValues(this,'inRange',this.option.range.slice());var stops=[];function setStop(value,valueState){stops.push({value:value,color:getColorVisual(value,valueState)});}// Format to: outOfRange -- inRange -- outOfRange.
var iIdx=0;var oIdx=0;var iLen=iVals.length;var oLen=oVals.length;for(;oIdx<oLen&&(!iVals.length||oVals[oIdx]<=iVals[0]);oIdx++){// If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
if(oVals[oIdx]<iVals[iIdx]){setStop(oVals[oIdx],'outOfRange');}}for(var first=1;iIdx<iLen;iIdx++,first=0){// If range is full, value beyond min, max will be clamped.
// make a singularity
first&&stops.length&&setStop(iVals[iIdx],'outOfRange');setStop(iVals[iIdx],'inRange');}for(var first=1;oIdx<oLen;oIdx++){if(!iVals.length||iVals[iVals.length-1]<oVals[oIdx]){// make a singularity
if(first){stops.length&&setStop(stops[stops.length-1].value,'outOfRange');first=0;}setStop(oVals[oIdx],'outOfRange');}}var stopsLen=stops.length;return{stops:stops,outerColors:[stopsLen?stops[0].color:'transparent',stopsLen?stops[stopsLen-1].color:'transparent']};}});function getColorStopValues(visualMapModel,valueState,dataExtent){if(dataExtent[0]===dataExtent[1]){return dataExtent.slice();}// When using colorHue mapping, it is not linear color any more.
// Moreover, canvas gradient seems not to be accurate linear.
// FIXME
// Should be arbitrary value 100? or based on pixel size?
var count=200;var step=(dataExtent[1]-dataExtent[0])/count;var value=dataExtent[0];var stopValues=[];for(var i=0;i<=count&&value<dataExtent[1];i++){stopValues.push(value);value+=step;}stopValues.push(dataExtent[1]);return stopValues;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var VisualMapView=extendComponentView({type:'visualMap',/**
   * @readOnly
   * @type {Object}
   */autoPositionValues:{left:1,right:1,top:1,bottom:1},init:function init(ecModel,api){/**
     * @readOnly
     * @type {module:echarts/model/Global}
     */this.ecModel=ecModel;/**
     * @readOnly
     * @type {module:echarts/ExtensionAPI}
     */this.api=api;/**
     * @readOnly
     * @type {module:echarts/component/visualMap/visualMapModel}
     */this.visualMapModel;},/**
   * @protected
   */render:function render(visualMapModel,ecModel,api,payload){this.visualMapModel=visualMapModel;if(visualMapModel.get('show')===false){this.group.removeAll();return;}this.doRender.apply(this,arguments);},/**
   * @protected
   */renderBackground:function renderBackground(group){var visualMapModel=this.visualMapModel;var padding=normalizeCssArray$1(visualMapModel.get('padding')||0);var rect=group.getBoundingRect();group.add(new Rect({z2:-1,// Lay background rect on the lowest layer.
silent:true,shape:{x:rect.x-padding[3],y:rect.y-padding[0],width:rect.width+padding[3]+padding[1],height:rect.height+padding[0]+padding[2]},style:{fill:visualMapModel.get('backgroundColor'),stroke:visualMapModel.get('borderColor'),lineWidth:visualMapModel.get('borderWidth')}}));},/**
   * @protected
   * @param {number} targetValue can be Infinity or -Infinity
   * @param {string=} visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param {Object} [opts]
   * @param {string=} [opts.forceState] Specify state, instead of using getValueState method.
   * @param {string=} [opts.convertOpacityToAlpha=false] For color gradient in controller widget.
   * @return {*} Visual value.
   */getControllerVisual:function getControllerVisual(targetValue,visualCluster,opts){opts=opts||{};var forceState=opts.forceState;var visualMapModel=this.visualMapModel;var visualObj={};// Default values.
if(visualCluster==='symbol'){visualObj.symbol=visualMapModel.get('itemSymbol');}if(visualCluster==='color'){var defaultColor=visualMapModel.get('contentColor');visualObj.color=defaultColor;}function getter(key){return visualObj[key];}function setter(key,value){visualObj[key]=value;}var mappings=visualMapModel.controllerVisuals[forceState||visualMapModel.getValueState(targetValue)];var visualTypes=VisualMapping.prepareVisualTypes(mappings);each$1(visualTypes,function(type){var visualMapping=mappings[type];if(opts.convertOpacityToAlpha&&type==='opacity'){type='colorAlpha';visualMapping=mappings.__alphaForOpacity;}if(VisualMapping.dependsOn(type,visualCluster)){visualMapping&&visualMapping.applyVisual(targetValue,getter,setter);}});return visualObj[visualCluster];},/**
   * @protected
   */positionGroup:function positionGroup(group){var model=this.visualMapModel;var api=this.api;positionElement(group,model.getBoxLayoutParams(),{width:api.getWidth(),height:api.getHeight()});},/**
   * @protected
   * @abstract
   */doRender:noop});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * @param {module:echarts/component/visualMap/VisualMapModel} visualMapModel\
 * @param {module:echarts/ExtensionAPI} api
 * @param {Array.<number>} itemSize always [short, long]
 * @return {string} 'left' or 'right' or 'top' or 'bottom'
 */function getItemAlign(visualMapModel,api,itemSize){var modelOption=visualMapModel.option;var itemAlign=modelOption.align;if(itemAlign!=null&&itemAlign!=='auto'){return itemAlign;}// Auto decision align.
var ecSize={width:api.getWidth(),height:api.getHeight()};var realIndex=modelOption.orient==='horizontal'?1:0;var paramsSet=[['left','right','width'],['top','bottom','height']];var reals=paramsSet[realIndex];var fakeValue=[0,null,10];var layoutInput={};for(var i=0;i<3;i++){layoutInput[paramsSet[1-realIndex][i]]=fakeValue[i];layoutInput[reals[i]]=i===2?itemSize[0]:modelOption[reals[i]];}var rParam=[['x','width',3],['y','height',0]][realIndex];var rect=getLayoutRect(layoutInput,ecSize,modelOption.padding);return reals[(rect.margin[rParam[2]]||0)+rect[rParam[0]]+rect[rParam[1]]*0.5<ecSize[rParam[1]]*0.5?0:1];}/**
 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
 * dataIndexInside means filtered index.
 */function convertDataIndex(batch){each$1(batch||[],function(batchItem){if(batch.dataIndex!=null){batch.dataIndexInside=batch.dataIndex;batch.dataIndex=null;}});return batch;}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var linearMap$3=linearMap;var each$19=each$1;var mathMin$4=Math.min;var mathMax$4=Math.max;// Arbitrary value
var HOVER_LINK_SIZE=12;var HOVER_LINK_OUT=6;// Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.
var ContinuousView=VisualMapView.extend({type:'visualMap.continuous',/**
   * @override
   */init:function init(){ContinuousView.superApply(this,'init',arguments);/**
     * @private
     */this._shapes={};/**
     * @private
     */this._dataInterval=[];/**
     * @private
     */this._handleEnds=[];/**
     * @private
     */this._orient;/**
     * @private
     */this._useHandle;/**
     * @private
     */this._hoverLinkDataIndices=[];/**
     * @private
     */this._dragging;/**
     * @private
     */this._hovering;},/**
   * @protected
   * @override
   */doRender:function doRender(visualMapModel,ecModel,api,payload){if(!payload||payload.type!=='selectDataRange'||payload.from!==this.uid){this._buildView();}},/**
   * @private
   */_buildView:function _buildView(){this.group.removeAll();var visualMapModel=this.visualMapModel;var thisGroup=this.group;this._orient=visualMapModel.get('orient');this._useHandle=visualMapModel.get('calculable');this._resetInterval();this._renderBar(thisGroup);var dataRangeText=visualMapModel.get('text');this._renderEndsText(thisGroup,dataRangeText,0);this._renderEndsText(thisGroup,dataRangeText,1);// Do this for background size calculation.
this._updateView(true);// After updating view, inner shapes is built completely,
// and then background can be rendered.
this.renderBackground(thisGroup);// Real update view
this._updateView();this._enableHoverLinkToSeries();this._enableHoverLinkFromSeries();this.positionGroup(thisGroup);},/**
   * @private
   */_renderEndsText:function _renderEndsText(group,dataRangeText,endsIndex){if(!dataRangeText){return;}// Compatible with ec2, text[0] map to high value, text[1] map low value.
var text=dataRangeText[1-endsIndex];text=text!=null?text+'':'';var visualMapModel=this.visualMapModel;var textGap=visualMapModel.get('textGap');var itemSize=visualMapModel.itemSize;var barGroup=this._shapes.barGroup;var position=this._applyTransform([itemSize[0]/2,endsIndex===0?-textGap:itemSize[1]+textGap],barGroup);var align=this._applyTransform(endsIndex===0?'bottom':'top',barGroup);var orient=this._orient;var textStyleModel=this.visualMapModel.textStyleModel;this.group.add(new Text({style:{x:position[0],y:position[1],textVerticalAlign:orient==='horizontal'?'middle':align,textAlign:orient==='horizontal'?align:'center',text:text,textFont:textStyleModel.getFont(),textFill:textStyleModel.getTextColor()}}));},/**
   * @private
   */_renderBar:function _renderBar(targetGroup){var visualMapModel=this.visualMapModel;var shapes=this._shapes;var itemSize=visualMapModel.itemSize;var orient=this._orient;var useHandle=this._useHandle;var itemAlign=getItemAlign(visualMapModel,this.api,itemSize);var barGroup=shapes.barGroup=this._createBarGroup(itemAlign);// Bar
barGroup.add(shapes.outOfRange=createPolygon());barGroup.add(shapes.inRange=createPolygon(null,useHandle?getCursor$1(this._orient):null,bind(this._dragHandle,this,'all',false),bind(this._dragHandle,this,'all',true)));var textRect=visualMapModel.textStyleModel.getTextRect('国');var textSize=mathMax$4(textRect.width,textRect.height);// Handle
if(useHandle){shapes.handleThumbs=[];shapes.handleLabels=[];shapes.handleLabelPoints=[];this._createHandle(barGroup,0,itemSize,textSize,orient,itemAlign);this._createHandle(barGroup,1,itemSize,textSize,orient,itemAlign);}this._createIndicator(barGroup,itemSize,textSize,orient);targetGroup.add(barGroup);},/**
   * @private
   */_createHandle:function _createHandle(barGroup,handleIndex,itemSize,textSize,orient){var onDrift=bind(this._dragHandle,this,handleIndex,false);var onDragEnd=bind(this._dragHandle,this,handleIndex,true);var handleThumb=createPolygon(createHandlePoints(handleIndex,textSize),getCursor$1(this._orient),onDrift,onDragEnd);handleThumb.position[0]=itemSize[0];barGroup.add(handleThumb);// Text is always horizontal layout but should not be effected by
// transform (orient/inverse). So label is built separately but not
// use zrender/graphic/helper/RectText, and is located based on view
// group (according to handleLabelPoint) but not barGroup.
var textStyleModel=this.visualMapModel.textStyleModel;var handleLabel=new Text({draggable:true,drift:onDrift,onmousemove:function onmousemove(e){// Fot mobile devicem, prevent screen slider on the button.
stop(e.event);},ondragend:onDragEnd,style:{x:0,y:0,text:'',textFont:textStyleModel.getFont(),textFill:textStyleModel.getTextColor()}});this.group.add(handleLabel);var handleLabelPoint=[orient==='horizontal'?textSize/2:textSize*1.5,orient==='horizontal'?handleIndex===0?-(textSize*1.5):textSize*1.5:handleIndex===0?-textSize/2:textSize/2];var shapes=this._shapes;shapes.handleThumbs[handleIndex]=handleThumb;shapes.handleLabelPoints[handleIndex]=handleLabelPoint;shapes.handleLabels[handleIndex]=handleLabel;},/**
   * @private
   */_createIndicator:function _createIndicator(barGroup,itemSize,textSize,orient){var indicator=createPolygon([[0,0]],'move');indicator.position[0]=itemSize[0];indicator.attr({invisible:true,silent:true});barGroup.add(indicator);var textStyleModel=this.visualMapModel.textStyleModel;var indicatorLabel=new Text({silent:true,invisible:true,style:{x:0,y:0,text:'',textFont:textStyleModel.getFont(),textFill:textStyleModel.getTextColor()}});this.group.add(indicatorLabel);var indicatorLabelPoint=[orient==='horizontal'?textSize/2:HOVER_LINK_OUT+3,0];var shapes=this._shapes;shapes.indicator=indicator;shapes.indicatorLabel=indicatorLabel;shapes.indicatorLabelPoint=indicatorLabelPoint;},/**
   * @private
   */_dragHandle:function _dragHandle(handleIndex,isEnd,dx,dy){if(!this._useHandle){return;}this._dragging=!isEnd;if(!isEnd){// Transform dx, dy to bar coordination.
var vertex=this._applyTransform([dx,dy],this._shapes.barGroup,true);this._updateInterval(handleIndex,vertex[1]);// Considering realtime, update view should be executed
// before dispatch action.
this._updateView();}// dragEnd do not dispatch action when realtime.
if(isEnd===!this.visualMapModel.get('realtime')){// jshint ignore:line
this.api.dispatchAction({type:'selectDataRange',from:this.uid,visualMapId:this.visualMapModel.id,selected:this._dataInterval.slice()});}if(isEnd){!this._hovering&&this._clearHoverLinkToSeries();}else if(useHoverLinkOnHandle(this.visualMapModel)){this._doHoverLinkToSeries(this._handleEnds[handleIndex],false);}},/**
   * @private
   */_resetInterval:function _resetInterval(){var visualMapModel=this.visualMapModel;var dataInterval=this._dataInterval=visualMapModel.getSelected();var dataExtent=visualMapModel.getExtent();var sizeExtent=[0,visualMapModel.itemSize[1]];this._handleEnds=[linearMap$3(dataInterval[0],dataExtent,sizeExtent,true),linearMap$3(dataInterval[1],dataExtent,sizeExtent,true)];},/**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */_updateInterval:function _updateInterval(handleIndex,delta){delta=delta||0;var visualMapModel=this.visualMapModel;var handleEnds=this._handleEnds;var sizeExtent=[0,visualMapModel.itemSize[1]];sliderMove(delta,handleEnds,sizeExtent,handleIndex,// cross is forbiden
0);var dataExtent=visualMapModel.getExtent();// Update data interval.
this._dataInterval=[linearMap$3(handleEnds[0],sizeExtent,dataExtent,true),linearMap$3(handleEnds[1],sizeExtent,dataExtent,true)];},/**
   * @private
   */_updateView:function _updateView(forSketch){var visualMapModel=this.visualMapModel;var dataExtent=visualMapModel.getExtent();var shapes=this._shapes;var outOfRangeHandleEnds=[0,visualMapModel.itemSize[1]];var inRangeHandleEnds=forSketch?outOfRangeHandleEnds:this._handleEnds;var visualInRange=this._createBarVisual(this._dataInterval,dataExtent,inRangeHandleEnds,'inRange');var visualOutOfRange=this._createBarVisual(dataExtent,dataExtent,outOfRangeHandleEnds,'outOfRange');shapes.inRange.setStyle({fill:visualInRange.barColor,opacity:visualInRange.opacity}).setShape('points',visualInRange.barPoints);shapes.outOfRange.setStyle({fill:visualOutOfRange.barColor,opacity:visualOutOfRange.opacity}).setShape('points',visualOutOfRange.barPoints);this._updateHandle(inRangeHandleEnds,visualInRange);},/**
   * @private
   */_createBarVisual:function _createBarVisual(dataInterval,dataExtent,handleEnds,forceState){var opts={forceState:forceState,convertOpacityToAlpha:true};var colorStops=this._makeColorGradient(dataInterval,opts);var symbolSizes=[this.getControllerVisual(dataInterval[0],'symbolSize',opts),this.getControllerVisual(dataInterval[1],'symbolSize',opts)];var barPoints=this._createBarPoints(handleEnds,symbolSizes);return{barColor:new LinearGradient(0,0,0,1,colorStops),barPoints:barPoints,handlesColor:[colorStops[0].color,colorStops[colorStops.length-1].color]};},/**
   * @private
   */_makeColorGradient:function _makeColorGradient(dataInterval,opts){// Considering colorHue, which is not linear, so we have to sample
// to calculate gradient color stops, but not only caculate head
// and tail.
var sampleNumber=100;// Arbitrary value.
var colorStops=[];var step=(dataInterval[1]-dataInterval[0])/sampleNumber;colorStops.push({color:this.getControllerVisual(dataInterval[0],'color',opts),offset:0});for(var i=1;i<sampleNumber;i++){var currValue=dataInterval[0]+step*i;if(currValue>dataInterval[1]){break;}colorStops.push({color:this.getControllerVisual(currValue,'color',opts),offset:i/sampleNumber});}colorStops.push({color:this.getControllerVisual(dataInterval[1],'color',opts),offset:1});return colorStops;},/**
   * @private
   */_createBarPoints:function _createBarPoints(handleEnds,symbolSizes){var itemSize=this.visualMapModel.itemSize;return[[itemSize[0]-symbolSizes[0],handleEnds[0]],[itemSize[0],handleEnds[0]],[itemSize[0],handleEnds[1]],[itemSize[0]-symbolSizes[1],handleEnds[1]]];},/**
   * @private
   */_createBarGroup:function _createBarGroup(itemAlign){var orient=this._orient;var inverse=this.visualMapModel.get('inverse');return new Group(orient==='horizontal'&&!inverse?{scale:itemAlign==='bottom'?[1,1]:[-1,1],rotation:Math.PI/2}:orient==='horizontal'&&inverse?{scale:itemAlign==='bottom'?[-1,1]:[1,1],rotation:-Math.PI/2}:orient==='vertical'&&!inverse?{scale:itemAlign==='left'?[1,-1]:[-1,-1]}:{scale:itemAlign==='left'?[1,1]:[-1,1]});},/**
   * @private
   */_updateHandle:function _updateHandle(handleEnds,visualInRange){if(!this._useHandle){return;}var shapes=this._shapes;var visualMapModel=this.visualMapModel;var handleThumbs=shapes.handleThumbs;var handleLabels=shapes.handleLabels;each$19([0,1],function(handleIndex){var handleThumb=handleThumbs[handleIndex];handleThumb.setStyle('fill',visualInRange.handlesColor[handleIndex]);handleThumb.position[1]=handleEnds[handleIndex];// Update handle label position.
var textPoint=applyTransform$1(shapes.handleLabelPoints[handleIndex],getTransform(handleThumb,this.group));handleLabels[handleIndex].setStyle({x:textPoint[0],y:textPoint[1],text:visualMapModel.formatValueText(this._dataInterval[handleIndex]),textVerticalAlign:'middle',textAlign:this._applyTransform(this._orient==='horizontal'?handleIndex===0?'bottom':'top':'left',shapes.barGroup)});},this);},/**
   * @private
   * @param {number} cursorValue
   * @param {number} textValue
   * @param {string} [rangeSymbol]
   * @param {number} [halfHoverLinkSize]
   */_showIndicator:function _showIndicator(cursorValue,textValue,rangeSymbol,halfHoverLinkSize){var visualMapModel=this.visualMapModel;var dataExtent=visualMapModel.getExtent();var itemSize=visualMapModel.itemSize;var sizeExtent=[0,itemSize[1]];var pos=linearMap$3(cursorValue,dataExtent,sizeExtent,true);var shapes=this._shapes;var indicator=shapes.indicator;if(!indicator){return;}indicator.position[1]=pos;indicator.attr('invisible',false);indicator.setShape('points',createIndicatorPoints(!!rangeSymbol,halfHoverLinkSize,pos,itemSize[1]));var opts={convertOpacityToAlpha:true};var color=this.getControllerVisual(cursorValue,'color',opts);indicator.setStyle('fill',color);// Update handle label position.
var textPoint=applyTransform$1(shapes.indicatorLabelPoint,getTransform(indicator,this.group));var indicatorLabel=shapes.indicatorLabel;indicatorLabel.attr('invisible',false);var align=this._applyTransform('left',shapes.barGroup);var orient=this._orient;indicatorLabel.setStyle({text:(rangeSymbol?rangeSymbol:'')+visualMapModel.formatValueText(textValue),textVerticalAlign:orient==='horizontal'?align:'middle',textAlign:orient==='horizontal'?'center':align,x:textPoint[0],y:textPoint[1]});},/**
   * @private
   */_enableHoverLinkToSeries:function _enableHoverLinkToSeries(){var self=this;this._shapes.barGroup.on('mousemove',function(e){self._hovering=true;if(!self._dragging){var itemSize=self.visualMapModel.itemSize;var pos=self._applyTransform([e.offsetX,e.offsetY],self._shapes.barGroup,true,true);// For hover link show when hover handle, which might be
// below or upper than sizeExtent.
pos[1]=mathMin$4(mathMax$4(0,pos[1]),itemSize[1]);self._doHoverLinkToSeries(pos[1],0<=pos[0]&&pos[0]<=itemSize[0]);}}).on('mouseout',function(){// When mouse is out of handle, hoverLink still need
// to be displayed when realtime is set as false.
self._hovering=false;!self._dragging&&self._clearHoverLinkToSeries();});},/**
   * @private
   */_enableHoverLinkFromSeries:function _enableHoverLinkFromSeries(){var zr=this.api.getZr();if(this.visualMapModel.option.hoverLink){zr.on('mouseover',this._hoverLinkFromSeriesMouseOver,this);zr.on('mouseout',this._hideIndicator,this);}else{this._clearHoverLinkFromSeries();}},/**
   * @private
   */_doHoverLinkToSeries:function _doHoverLinkToSeries(cursorPos,hoverOnBar){var visualMapModel=this.visualMapModel;var itemSize=visualMapModel.itemSize;if(!visualMapModel.option.hoverLink){return;}var sizeExtent=[0,itemSize[1]];var dataExtent=visualMapModel.getExtent();// For hover link show when hover handle, which might be below or upper than sizeExtent.
cursorPos=mathMin$4(mathMax$4(sizeExtent[0],cursorPos),sizeExtent[1]);var halfHoverLinkSize=getHalfHoverLinkSize(visualMapModel,dataExtent,sizeExtent);var hoverRange=[cursorPos-halfHoverLinkSize,cursorPos+halfHoverLinkSize];var cursorValue=linearMap$3(cursorPos,sizeExtent,dataExtent,true);var valueRange=[linearMap$3(hoverRange[0],sizeExtent,dataExtent,true),linearMap$3(hoverRange[1],sizeExtent,dataExtent,true)];// Consider data range is out of visualMap range, see test/visualMap-continuous.html,
// where china and india has very large population.
hoverRange[0]<sizeExtent[0]&&(valueRange[0]=-Infinity);hoverRange[1]>sizeExtent[1]&&(valueRange[1]=Infinity);// Do not show indicator when mouse is over handle,
// otherwise labels overlap, especially when dragging.
if(hoverOnBar){if(valueRange[0]===-Infinity){this._showIndicator(cursorValue,valueRange[1],'< ',halfHoverLinkSize);}else if(valueRange[1]===Infinity){this._showIndicator(cursorValue,valueRange[0],'> ',halfHoverLinkSize);}else{this._showIndicator(cursorValue,cursorValue,'≈ ',halfHoverLinkSize);}}// When realtime is set as false, handles, which are in barGroup,
// also trigger hoverLink, which help user to realize where they
// focus on when dragging. (see test/heatmap-large.html)
// When realtime is set as true, highlight will not show when hover
// handle, because the label on handle, which displays a exact value
// but not range, might mislead users.
var oldBatch=this._hoverLinkDataIndices;var newBatch=[];if(hoverOnBar||useHoverLinkOnHandle(visualMapModel)){newBatch=this._hoverLinkDataIndices=visualMapModel.findTargetDataIndices(valueRange);}var resultBatches=compressBatches(oldBatch,newBatch);this._dispatchHighDown('downplay',convertDataIndex(resultBatches[0]));this._dispatchHighDown('highlight',convertDataIndex(resultBatches[1]));},/**
   * @private
   */_hoverLinkFromSeriesMouseOver:function _hoverLinkFromSeriesMouseOver(e){var el=e.target;var visualMapModel=this.visualMapModel;if(!el||el.dataIndex==null){return;}var dataModel=this.ecModel.getSeriesByIndex(el.seriesIndex);if(!visualMapModel.isTargetSeries(dataModel)){return;}var data=dataModel.getData(el.dataType);var value=data.get(visualMapModel.getDataDimension(data),el.dataIndex,true);if(!isNaN(value)){this._showIndicator(value,value);}},/**
   * @private
   */_hideIndicator:function _hideIndicator(){var shapes=this._shapes;shapes.indicator&&shapes.indicator.attr('invisible',true);shapes.indicatorLabel&&shapes.indicatorLabel.attr('invisible',true);},/**
   * @private
   */_clearHoverLinkToSeries:function _clearHoverLinkToSeries(){this._hideIndicator();var indices=this._hoverLinkDataIndices;this._dispatchHighDown('downplay',convertDataIndex(indices));indices.length=0;},/**
   * @private
   */_clearHoverLinkFromSeries:function _clearHoverLinkFromSeries(){this._hideIndicator();var zr=this.api.getZr();zr.off('mouseover',this._hoverLinkFromSeriesMouseOver);zr.off('mouseout',this._hideIndicator);},/**
   * @private
   */_applyTransform:function _applyTransform(vertex,element,inverse,global){var transform=getTransform(element,global?null:this.group);return graphic[isArray(vertex)?'applyTransform':'transformDirection'](vertex,transform,inverse);},/**
   * @private
   */_dispatchHighDown:function _dispatchHighDown(type,batch){batch&&batch.length&&this.api.dispatchAction({type:type,batch:batch});},/**
   * @override
   */dispose:function dispose(){this._clearHoverLinkFromSeries();this._clearHoverLinkToSeries();},/**
   * @override
   */remove:function remove(){this._clearHoverLinkFromSeries();this._clearHoverLinkToSeries();}});function createPolygon(points,cursor,onDrift,onDragEnd){return new Polygon({shape:{points:points},draggable:!!onDrift,cursor:cursor,drift:onDrift,onmousemove:function onmousemove(e){// Fot mobile devicem, prevent screen slider on the button.
stop(e.event);},ondragend:onDragEnd});}function createHandlePoints(handleIndex,textSize){return handleIndex===0?[[0,0],[textSize,0],[textSize,-textSize]]:[[0,0],[textSize,0],[textSize,textSize]];}function createIndicatorPoints(isRange,halfHoverLinkSize,pos,extentMax){return isRange?[// indicate range
[0,-mathMin$4(halfHoverLinkSize,mathMax$4(pos,0))],[HOVER_LINK_OUT,0],[0,mathMin$4(halfHoverLinkSize,mathMax$4(extentMax-pos,0))]]:[// indicate single value
[0,0],[5,-5],[5,5]];}function getHalfHoverLinkSize(visualMapModel,dataExtent,sizeExtent){var halfHoverLinkSize=HOVER_LINK_SIZE/2;var hoverLinkDataSize=visualMapModel.get('hoverLinkDataSize');if(hoverLinkDataSize){halfHoverLinkSize=linearMap$3(hoverLinkDataSize,dataExtent,sizeExtent,true)/2;}return halfHoverLinkSize;}function useHoverLinkOnHandle(visualMapModel){var hoverLinkOnHandle=visualMapModel.get('hoverLinkOnHandle');return!!(hoverLinkOnHandle==null?visualMapModel.get('realtime'):hoverLinkOnHandle);}function getCursor$1(orient){return orient==='vertical'?'ns-resize':'ew-resize';}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var actionInfo={type:'selectDataRange',event:'dataRangeSelected',// FIXME use updateView appears wrong
update:'update'};registerAction(actionInfo,function(payload,ecModel){ecModel.eachComponent({mainType:'visualMap',query:payload},function(model){model.setSelected(payload.selected);});});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * DataZoom component entry
 */registerPreprocessor(preprocessor$1);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var PiecewiseModel=VisualMapModel.extend({type:'visualMap.piecewise',/**
   * Order Rule:
   *
   * option.categories / option.pieces / option.text / option.selected:
   *     If !option.inverse,
   *     Order when vertical: ['top', ..., 'bottom'].
   *     Order when horizontal: ['left', ..., 'right'].
   *     If option.inverse, the meaning of
   *     the order should be reversed.
   *
   * this._pieceList:
   *     The order is always [low, ..., high].
   *
   * Mapping from location to low-high:
   *     If !option.inverse
   *     When vertical, top is high.
   *     When horizontal, right is high.
   *     If option.inverse, reverse.
   *//**
   * @protected
   */defaultOption:{selected:null,// Object. If not specified, means selected.
// When pieces and splitNumber: {'0': true, '5': true}
// When categories: {'cate1': false, 'cate3': true}
// When selected === false, means all unselected.
minOpen:false,// Whether include values that smaller than `min`.
maxOpen:false,// Whether include values that bigger than `max`.
align:'auto',// 'auto', 'left', 'right'
itemWidth:20,// When put the controller vertically, it is the length of
// horizontal side of each item. Otherwise, vertical side.
itemHeight:14,// When put the controller vertically, it is the length of
// vertical side of each item. Otherwise, horizontal side.
itemSymbol:'roundRect',pieceList:null,// Each item is Object, with some of those attrs:
// {min, max, lt, gt, lte, gte, value,
// color, colorSaturation, colorAlpha, opacity,
// symbol, symbolSize}, which customize the range or visual
// coding of the certain piece. Besides, see "Order Rule".
categories:null,// category names, like: ['some1', 'some2', 'some3'].
// Attr min/max are ignored when categories set. See "Order Rule"
splitNumber:5,// If set to 5, auto split five pieces equally.
// If set to 0 and component type not set, component type will be
// determined as "continuous". (It is less reasonable but for ec2
// compatibility, see echarts/component/visualMap/typeDefaulter)
selectedMode:'multiple',// Can be 'multiple' or 'single'.
itemGap:10,// The gap between two items, in px.
hoverLink:true,// Enable hover highlight.
showLabel:null// By default, when text is used, label will hide (the logic
// is remained for compatibility reason)
},/**
   * @override
   */optionUpdated:function optionUpdated(newOption,isInit){PiecewiseModel.superApply(this,'optionUpdated',arguments);/**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     * @private
     * @type {Array.<Object>}
     */this._pieceList=[];this.resetExtent();/**
     * 'pieces', 'categories', 'splitNumber'
     * @type {string}
     */var mode=this._mode=this._determineMode();resetMethods[this._mode].call(this);this._resetSelected(newOption,isInit);var categories=this.option.categories;this.resetVisual(function(mappingOption,state){if(mode==='categories'){mappingOption.mappingMethod='category';mappingOption.categories=_clone(categories);}else{mappingOption.dataExtent=this.getExtent();mappingOption.mappingMethod='piecewise';mappingOption.pieceList=map(this._pieceList,function(piece){var piece=_clone(piece);if(state!=='inRange'){// FIXME
// outOfRange do not support special visual in pieces.
piece.visual=null;}return piece;});}});},/**
   * @protected
   * @override
   */completeVisualOption:function completeVisualOption(){// Consider this case:
// visualMap: {
//      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
// }
// where no inRange/outOfRange set but only pieces. So we should make
// default inRange/outOfRange for this case, otherwise visuals that only
// appear in `pieces` will not be taken into account in visual encoding.
var option=this.option;var visualTypesInPieces={};var visualTypes=VisualMapping.listVisualTypes();var isCategory=this.isCategory();each$1(option.pieces,function(piece){each$1(visualTypes,function(visualType){if(piece.hasOwnProperty(visualType)){visualTypesInPieces[visualType]=1;}});});each$1(visualTypesInPieces,function(v,visualType){var exists=0;each$1(this.stateList,function(state){exists|=has(option,state,visualType)||has(option.target,state,visualType);},this);!exists&&each$1(this.stateList,function(state){(option[state]||(option[state]={}))[visualType]=visualDefault.get(visualType,state==='inRange'?'active':'inactive',isCategory);});},this);function has(obj,state,visualType){return obj&&obj[state]&&(isObject$1(obj[state])?obj[state].hasOwnProperty(visualType):obj[state]===visualType// e.g., inRange: 'symbol'
);}VisualMapModel.prototype.completeVisualOption.apply(this,arguments);},_resetSelected:function _resetSelected(newOption,isInit){var thisOption=this.option;var pieceList=this._pieceList;// Selected do not merge but all override.
var selected=(isInit?thisOption:newOption).selected||{};thisOption.selected=selected;// Consider 'not specified' means true.
each$1(pieceList,function(piece,index){var key=this.getSelectedMapKey(piece);if(!selected.hasOwnProperty(key)){selected[key]=true;}},this);if(thisOption.selectedMode==='single'){// Ensure there is only one selected.
var hasSel=false;each$1(pieceList,function(piece,index){var key=this.getSelectedMapKey(piece);if(selected[key]){hasSel?selected[key]=false:hasSel=true;}},this);}// thisOption.selectedMode === 'multiple', default: all selected.
},/**
   * @public
   */getSelectedMapKey:function getSelectedMapKey(piece){return this._mode==='categories'?piece.value+'':piece.index+'';},/**
   * @public
   */getPieceList:function getPieceList(){return this._pieceList;},/**
   * @private
   * @return {string}
   */_determineMode:function _determineMode(){var option=this.option;return option.pieces&&option.pieces.length>0?'pieces':this.option.categories?'categories':'splitNumber';},/**
   * @public
   * @override
   */setSelected:function setSelected(selected){this.option.selected=_clone(selected);},/**
   * @public
   * @override
   */getValueState:function getValueState(value){var index=VisualMapping.findPieceIndex(value,this._pieceList);return index!=null?this.option.selected[this.getSelectedMapKey(this._pieceList[index])]?'inRange':'outOfRange':'outOfRange';},/**
   * @public
   * @params {number} pieceIndex piece index in visualMapModel.getPieceList()
   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
   */findTargetDataIndices:function findTargetDataIndices(pieceIndex){var result=[];this.eachTargetSeries(function(seriesModel){var dataIndices=[];var data=seriesModel.getData();data.each(this.getDataDimension(data),function(value,dataIndex){// Should always base on model pieceList, because it is order sensitive.
var pIdx=VisualMapping.findPieceIndex(value,this._pieceList);pIdx===pieceIndex&&dataIndices.push(dataIndex);},this);result.push({seriesId:seriesModel.id,dataIndex:dataIndices});},this);return result;},/**
   * @private
   * @param {Object} piece piece.value or piece.interval is required.
   * @return {number} Can be Infinity or -Infinity
   */getRepresentValue:function getRepresentValue(piece){var representValue;if(this.isCategory()){representValue=piece.value;}else{if(piece.value!=null){representValue=piece.value;}else{var pieceInterval=piece.interval||[];representValue=pieceInterval[0]===-Infinity&&pieceInterval[1]===Infinity?0:(pieceInterval[0]+pieceInterval[1])/2;}}return representValue;},getVisualMeta:function getVisualMeta(getColorVisual){// Do not support category. (category axis is ordinal, numerical)
if(this.isCategory()){return;}var stops=[];var outerColors=[];var visualMapModel=this;function setStop(interval,valueState){var representValue=visualMapModel.getRepresentValue({interval:interval});if(!valueState){valueState=visualMapModel.getValueState(representValue);}var color=getColorVisual(representValue,valueState);if(interval[0]===-Infinity){outerColors[0]=color;}else if(interval[1]===Infinity){outerColors[1]=color;}else{stops.push({value:interval[0],color:color},{value:interval[1],color:color});}}// Suplement
var pieceList=this._pieceList.slice();if(!pieceList.length){pieceList.push({interval:[-Infinity,Infinity]});}else{var edge=pieceList[0].interval[0];edge!==-Infinity&&pieceList.unshift({interval:[-Infinity,edge]});edge=pieceList[pieceList.length-1].interval[1];edge!==Infinity&&pieceList.push({interval:[edge,Infinity]});}var curr=-Infinity;each$1(pieceList,function(piece){var interval=piece.interval;if(interval){// Fulfill gap.
interval[0]>curr&&setStop([curr,interval[0]],'outOfRange');setStop(interval.slice());curr=interval[1];}},this);return{stops:stops,outerColors:outerColors};}});/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */var resetMethods={splitNumber:function splitNumber(){var thisOption=this.option;var pieceList=this._pieceList;var precision=Math.min(thisOption.precision,20);var dataExtent=this.getExtent();var splitNumber=thisOption.splitNumber;splitNumber=Math.max(parseInt(splitNumber,10),1);thisOption.splitNumber=splitNumber;var splitStep=(dataExtent[1]-dataExtent[0])/splitNumber;// Precision auto-adaption
while(+splitStep.toFixed(precision)!==splitStep&&precision<5){precision++;}thisOption.precision=precision;splitStep=+splitStep.toFixed(precision);var index=0;if(thisOption.minOpen){pieceList.push({index:index++,interval:[-Infinity,dataExtent[0]],close:[0,0]});}for(var curr=dataExtent[0],len=index+splitNumber;index<len;curr+=splitStep){var max=index===splitNumber-1?dataExtent[1]:curr+splitStep;pieceList.push({index:index++,interval:[curr,max],close:[1,1]});}if(thisOption.maxOpen){pieceList.push({index:index++,interval:[dataExtent[1],Infinity],close:[0,0]});}reformIntervals(pieceList);each$1(pieceList,function(piece){piece.text=this.formatValueText(piece.interval);},this);},categories:function categories(){var thisOption=this.option;each$1(thisOption.categories,function(cate){// FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
// 是否改一致。
this._pieceList.push({text:this.formatValueText(cate,true),value:cate});},this);// See "Order Rule".
normalizeReverse(thisOption,this._pieceList);},pieces:function pieces(){var thisOption=this.option;var pieceList=this._pieceList;each$1(thisOption.pieces,function(pieceListItem,index){if(!isObject$1(pieceListItem)){pieceListItem={value:pieceListItem};}var item={text:'',index:index};if(pieceListItem.label!=null){item.text=pieceListItem.label;}if(pieceListItem.hasOwnProperty('value')){var value=item.value=pieceListItem.value;item.interval=[value,value];item.close=[1,1];}else{// `min` `max` is legacy option.
// `lt` `gt` `lte` `gte` is recommanded.
var interval=item.interval=[];var close=item.close=[0,0];var closeList=[1,0,1];var infinityList=[-Infinity,Infinity];var useMinMax=[];for(var lg=0;lg<2;lg++){var names=[['gte','gt','min'],['lte','lt','max']][lg];for(var i=0;i<3&&interval[lg]==null;i++){interval[lg]=pieceListItem[names[i]];close[lg]=closeList[i];useMinMax[lg]=i===2;}interval[lg]==null&&(interval[lg]=infinityList[lg]);}useMinMax[0]&&interval[1]===Infinity&&(close[0]=0);useMinMax[1]&&interval[0]===-Infinity&&(close[1]=0);if(interval[0]===interval[1]&&close[0]&&close[1]){// Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
// we use value to lift the priority when min === max
item.value=interval[0];}}item.visual=VisualMapping.retrieveVisuals(pieceListItem);pieceList.push(item);},this);// See "Order Rule".
normalizeReverse(thisOption,pieceList);// Only pieces
reformIntervals(pieceList);each$1(pieceList,function(piece){var close=piece.close;var edgeSymbols=[['<','≤'][close[1]],['>','≥'][close[0]]];piece.text=piece.text||this.formatValueText(piece.value!=null?piece.value:piece.interval,false,edgeSymbols);},this);}};function normalizeReverse(thisOption,pieceList){var inverse=thisOption.inverse;if(thisOption.orient==='vertical'?!inverse:inverse){pieceList.reverse();}}/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/var PiecewiseVisualMapView=VisualMapView.extend({type:'visualMap.piecewise',/**
   * @protected
   * @override
   */doRender:function doRender(){var thisGroup=this.group;thisGroup.removeAll();var visualMapModel=this.visualMapModel;var textGap=visualMapModel.get('textGap');var textStyleModel=visualMapModel.textStyleModel;var textFont=textStyleModel.getFont();var textFill=textStyleModel.getTextColor();var itemAlign=this._getItemAlign();var itemSize=visualMapModel.itemSize;var viewData=this._getViewData();var endsText=viewData.endsText;var showLabel=retrieve(visualMapModel.get('showLabel',true),!endsText);endsText&&this._renderEndsText(thisGroup,endsText[0],itemSize,showLabel,itemAlign);each$1(viewData.viewPieceList,renderItem,this);endsText&&this._renderEndsText(thisGroup,endsText[1],itemSize,showLabel,itemAlign);box(visualMapModel.get('orient'),thisGroup,visualMapModel.get('itemGap'));this.renderBackground(thisGroup);this.positionGroup(thisGroup);function renderItem(item){var piece=item.piece;var itemGroup=new Group();itemGroup.onclick=bind(this._onItemClick,this,piece);this._enableHoverLink(itemGroup,item.indexInModelPieceList);var representValue=visualMapModel.getRepresentValue(piece);this._createItemSymbol(itemGroup,representValue,[0,0,itemSize[0],itemSize[1]]);if(showLabel){var visualState=this.visualMapModel.getValueState(representValue);itemGroup.add(new Text({style:{x:itemAlign==='right'?-textGap:itemSize[0]+textGap,y:itemSize[1]/2,text:piece.text,textVerticalAlign:'middle',textAlign:itemAlign,textFont:textFont,textFill:textFill,opacity:visualState==='outOfRange'?0.5:1}}));}thisGroup.add(itemGroup);}},/**
   * @private
   */_enableHoverLink:function _enableHoverLink(itemGroup,pieceIndex){itemGroup.on('mouseover',bind(onHoverLink,this,'highlight')).on('mouseout',bind(onHoverLink,this,'downplay'));function onHoverLink(method){var visualMapModel=this.visualMapModel;visualMapModel.option.hoverLink&&this.api.dispatchAction({type:method,batch:convertDataIndex(visualMapModel.findTargetDataIndices(pieceIndex))});}},/**
   * @private
   */_getItemAlign:function _getItemAlign(){var visualMapModel=this.visualMapModel;var modelOption=visualMapModel.option;if(modelOption.orient==='vertical'){return getItemAlign(visualMapModel,this.api,visualMapModel.itemSize);}else{// horizontal, most case left unless specifying right.
var align=modelOption.align;if(!align||align==='auto'){align='left';}return align;}},/**
   * @private
   */_renderEndsText:function _renderEndsText(group,text,itemSize,showLabel,itemAlign){if(!text){return;}var itemGroup=new Group();var textStyleModel=this.visualMapModel.textStyleModel;itemGroup.add(new Text({style:{x:showLabel?itemAlign==='right'?itemSize[0]:0:itemSize[0]/2,y:itemSize[1]/2,textVerticalAlign:'middle',textAlign:showLabel?itemAlign:'center',text:text,textFont:textStyleModel.getFont(),textFill:textStyleModel.getTextColor()}}));group.add(itemGroup);},/**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */_getViewData:function _getViewData(){var visualMapModel=this.visualMapModel;var viewPieceList=map(visualMapModel.getPieceList(),function(piece,index){return{piece:piece,indexInModelPieceList:index};});var endsText=visualMapModel.get('text');// Consider orient and inverse.
var orient=visualMapModel.get('orient');var inverse=visualMapModel.get('inverse');// Order of model pieceList is always [low, ..., high]
if(orient==='horizontal'?inverse:!inverse){viewPieceList.reverse();}// Origin order of endsText is [high, low]
else if(endsText){endsText=endsText.slice().reverse();}return{viewPieceList:viewPieceList,endsText:endsText};},/**
   * @private
   */_createItemSymbol:function _createItemSymbol(group,representValue,shapeParam){group.add(createSymbol(this.getControllerVisual(representValue,'symbol'),shapeParam[0],shapeParam[1],shapeParam[2],shapeParam[3],this.getControllerVisual(representValue,'color')));},/**
   * @private
   */_onItemClick:function _onItemClick(piece){var visualMapModel=this.visualMapModel;var option=visualMapModel.option;var selected=_clone(option.selected);var newKey=visualMapModel.getSelectedMapKey(piece);if(option.selectedMode==='single'){selected[newKey]=true;each$1(selected,function(o,key){selected[key]=key===newKey;});}else{selected[newKey]=!selected[newKey];}this.api.dispatchAction({type:'selectDataRange',from:this.uid,visualMapId:this.visualMapModel.id,selected:selected});}});/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * DataZoom component entry
 */registerPreprocessor(preprocessor$1);/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*//**
 * visualMap component entry
 */var svgURI='http://www.w3.org/2000/svg';function createElement(name){return document.createElementNS(svgURI,name);}// TODO
// 1. shadow
// 2. Image: sx, sy, sw, sh
var CMD$3=PathProxy.CMD;var arrayJoin=Array.prototype.join;var NONE='none';var mathRound=Math.round;var mathSin$3=Math.sin;var mathCos$3=Math.cos;var PI$3=Math.PI;var PI2$4=Math.PI*2;var degree=180/PI$3;var EPSILON$4=1e-4;function round4(val){return mathRound(val*1e4)/1e4;}function isAroundZero$1(val){return val<EPSILON$4&&val>-EPSILON$4;}function pathHasFill(style,isText){var fill=isText?style.textFill:style.fill;return fill!=null&&fill!==NONE;}function pathHasStroke(style,isText){var stroke=isText?style.textStroke:style.stroke;return stroke!=null&&stroke!==NONE;}function setTransform(svgEl,m){if(m){attr(svgEl,'transform','matrix('+arrayJoin.call(m,',')+')');}}function attr(el,key,val){if(!val||val.type!=='linear'&&val.type!=='radial'){// Don't set attribute for gradient, since it need new dom nodes
if(typeof val==='string'&&val.indexOf('NaN')>-1){console.log(val);}el.setAttribute(key,val);}}function attrXLink(el,key,val){el.setAttributeNS('http://www.w3.org/1999/xlink',key,val);}function bindStyle(svgEl,style,isText){if(pathHasFill(style,isText)){var fill=isText?style.textFill:style.fill;fill=fill==='transparent'?NONE:fill;/**
     * FIXME:
     * This is a temporary fix for Chrome's clipping bug
     * that happens when a clip-path is referring another one.
     * This fix should be used before Chrome's bug is fixed.
     * For an element that has clip-path, and fill is none,
     * set it to be "rgba(0, 0, 0, 0.002)" will hide the element.
     * Otherwise, it will show black fill color.
     * 0.002 is used because this won't work for alpha values smaller
     * than 0.002.
     *
     * See
     * https://bugs.chromium.org/p/chromium/issues/detail?id=659790
     * for more information.
     */if(svgEl.getAttribute('clip-path')!=='none'&&fill===NONE){fill='rgba(0, 0, 0, 0.002)';}attr(svgEl,'fill',fill);attr(svgEl,'fill-opacity',style.opacity);}else{attr(svgEl,'fill',NONE);}if(pathHasStroke(style,isText)){var stroke=isText?style.textStroke:style.stroke;stroke=stroke==='transparent'?NONE:stroke;attr(svgEl,'stroke',stroke);var strokeWidth=isText?style.textStrokeWidth:style.lineWidth;var strokeScale=!isText&&style.strokeNoScale?style.host.getLineScale():1;attr(svgEl,'stroke-width',strokeWidth/strokeScale);// stroke then fill for text; fill then stroke for others
attr(svgEl,'paint-order',isText?'stroke':'fill');attr(svgEl,'stroke-opacity',style.opacity);var lineDash=style.lineDash;if(lineDash){attr(svgEl,'stroke-dasharray',style.lineDash.join(','));attr(svgEl,'stroke-dashoffset',mathRound(style.lineDashOffset||0));}else{attr(svgEl,'stroke-dasharray','');}// PENDING
style.lineCap&&attr(svgEl,'stroke-linecap',style.lineCap);style.lineJoin&&attr(svgEl,'stroke-linejoin',style.lineJoin);style.miterLimit&&attr(svgEl,'stroke-miterlimit',style.miterLimit);}else{attr(svgEl,'stroke',NONE);}}/***************************************************
 * PATH
 **************************************************/function pathDataToString(path){var str=[];var data=path.data;var dataLength=path.len();for(var i=0;i<dataLength;){var cmd=data[i++];var cmdStr='';var nData=0;switch(cmd){case CMD$3.M:cmdStr='M';nData=2;break;case CMD$3.L:cmdStr='L';nData=2;break;case CMD$3.Q:cmdStr='Q';nData=4;break;case CMD$3.C:cmdStr='C';nData=6;break;case CMD$3.A:var cx=data[i++];var cy=data[i++];var rx=data[i++];var ry=data[i++];var theta=data[i++];var dTheta=data[i++];var psi=data[i++];var clockwise=data[i++];var dThetaPositive=Math.abs(dTheta);var isCircle=isAroundZero$1(dThetaPositive-PI2$4)&&!isAroundZero$1(dThetaPositive);var large=false;if(dThetaPositive>=PI2$4){large=true;}else if(isAroundZero$1(dThetaPositive)){large=false;}else{large=(dTheta>-PI$3&&dTheta<0||dTheta>PI$3)===!!clockwise;}var x0=round4(cx+rx*mathCos$3(theta));var y0=round4(cy+ry*mathSin$3(theta));// It will not draw if start point and end point are exactly the same
// We need to shift the end point with a small value
// FIXME A better way to draw circle ?
if(isCircle){if(clockwise){dTheta=PI2$4-1e-4;}else{dTheta=-PI2$4+1e-4;}large=true;if(i===9){// Move to (x0, y0) only when CMD.A comes at the
// first position of a shape.
// For instance, when drawing a ring, CMD.A comes
// after CMD.M, so it's unnecessary to move to
// (x0, y0).
str.push('M',x0,y0);}}var x=round4(cx+rx*mathCos$3(theta+dTheta));var y=round4(cy+ry*mathSin$3(theta+dTheta));// FIXME Ellipse
str.push('A',round4(rx),round4(ry),mathRound(psi*degree),+large,+clockwise,x,y);break;case CMD$3.Z:cmdStr='Z';break;case CMD$3.R:var x=round4(data[i++]);var y=round4(data[i++]);var w=round4(data[i++]);var h=round4(data[i++]);str.push('M',x,y,'L',x+w,y,'L',x+w,y+h,'L',x,y+h,'L',x,y);break;}cmdStr&&str.push(cmdStr);for(var j=0;j<nData;j++){// PENDING With scale
str.push(round4(data[i++]));}}return str.join(' ');}var svgPath={};svgPath.brush=function(el){var style=el.style;var svgEl=el.__svgEl;if(!svgEl){svgEl=createElement('path');el.__svgEl=svgEl;}if(!el.path){el.createPathProxy();}var path=el.path;if(el.__dirtyPath){path.beginPath();el.buildPath(path,el.shape);el.__dirtyPath=false;var pathStr=pathDataToString(path);if(pathStr.indexOf('NaN')<0){// Ignore illegal path, which may happen such in out-of-range
// data in Calendar series.
attr(svgEl,'d',pathStr);}}bindStyle(svgEl,style);setTransform(svgEl,el.transform);if(style.text!=null){svgTextDrawRectText(el,el.getBoundingRect());}};/***************************************************
 * IMAGE
 **************************************************/var svgImage={};svgImage.brush=function(el){var style=el.style;var image=style.image;if(image instanceof HTMLImageElement){var src=image.src;image=src;}if(!image){return;}var x=style.x||0;var y=style.y||0;var dw=style.width;var dh=style.height;var svgEl=el.__svgEl;if(!svgEl){svgEl=createElement('image');el.__svgEl=svgEl;}if(image!==el.__imageSrc){attrXLink(svgEl,'href',image);// Caching image src
el.__imageSrc=image;}attr(svgEl,'width',dw);attr(svgEl,'height',dh);attr(svgEl,'x',x);attr(svgEl,'y',y);setTransform(svgEl,el.transform);if(style.text!=null){svgTextDrawRectText(el,el.getBoundingRect());}};/***************************************************
 * TEXT
 **************************************************/var svgText={};var tmpRect$2=new BoundingRect();var svgTextDrawRectText=function svgTextDrawRectText(el,rect,textRect){var style=el.style;el.__dirty&&normalizeTextStyle(style,true);var text=style.text;// Convert to string
if(text==null){// Draw no text only when text is set to null, but not ''
return;}else{text+='';}var textSvgEl=el.__textSvgEl;if(!textSvgEl){textSvgEl=createElement('text');el.__textSvgEl=textSvgEl;}var x;var y;var textPosition=style.textPosition;var distance=style.textDistance;var align=style.textAlign||'left';if(typeof style.fontSize==='number'){style.fontSize+='px';}var font=style.font||[style.fontStyle||'',style.fontWeight||'',style.fontSize||'',style.fontFamily||''].join(' ')||DEFAULT_FONT;var verticalAlign=getVerticalAlignForSvg(style.textVerticalAlign);textRect=_getBoundingRect(text,font,align,verticalAlign);var lineHeight=textRect.lineHeight;// Text position represented by coord
if(textPosition instanceof Array){x=rect.x+textPosition[0];y=rect.y+textPosition[1];}else{var newPos=adjustTextPositionOnRect(textPosition,rect,distance);x=newPos.x;y=newPos.y;verticalAlign=getVerticalAlignForSvg(newPos.textVerticalAlign);align=newPos.textAlign;}attr(textSvgEl,'alignment-baseline',verticalAlign);if(font){textSvgEl.style.font=font;}var textPadding=style.textPadding;// Make baseline top
attr(textSvgEl,'x',x);attr(textSvgEl,'y',y);bindStyle(textSvgEl,style,true);if(el instanceof Text||el.style.transformText){// Transform text with element
setTransform(textSvgEl,el.transform);}else{if(el.transform){tmpRect$2.copy(rect);tmpRect$2.applyTransform(el.transform);rect=tmpRect$2;}else{var pos=el.transformCoordToGlobal(rect.x,rect.y);rect.x=pos[0];rect.y=pos[1];}// Text rotation, but no element transform
var origin=style.textOrigin;if(origin==='center'){x=textRect.width/2+x;y=textRect.height/2+y;}else if(origin){x=origin[0]+x;y=origin[1]+y;}var rotate$$1=-style.textRotation||0;var transform=create$1();// Apply textRotate to element matrix
rotate(transform,el.transform,rotate$$1);setTransform(textSvgEl,transform);}var textLines=text.split('\n');var nTextLines=textLines.length;var textAnchor=align;// PENDING
if(textAnchor==='left'){textAnchor='start';textPadding&&(x+=textPadding[3]);}else if(textAnchor==='right'){textAnchor='end';textPadding&&(x-=textPadding[1]);}else if(textAnchor==='center'){textAnchor='middle';textPadding&&(x+=(textPadding[3]-textPadding[1])/2);}var dy=0;if(verticalAlign==='baseline'){dy=-textRect.height+lineHeight;textPadding&&(dy-=textPadding[2]);}else if(verticalAlign==='middle'){dy=(-textRect.height+lineHeight)/2;textPadding&&(y+=(textPadding[0]-textPadding[2])/2);}else{textPadding&&(dy+=textPadding[0]);}// Font may affect position of each tspan elements
if(el.__text!==text||el.__textFont!==font){var tspanList=el.__tspanList||[];el.__tspanList=tspanList;for(var i=0;i<nTextLines;i++){// Using cached tspan elements
var tspan=tspanList[i];if(!tspan){tspan=tspanList[i]=createElement('tspan');textSvgEl.appendChild(tspan);attr(tspan,'alignment-baseline',verticalAlign);attr(tspan,'text-anchor',textAnchor);}else{tspan.innerHTML='';}attr(tspan,'x',x);attr(tspan,'y',y+i*lineHeight+dy);tspan.appendChild(document.createTextNode(textLines[i]));}// Remove unsed tspan elements
for(;i<tspanList.length;i++){textSvgEl.removeChild(tspanList[i]);}tspanList.length=nTextLines;el.__text=text;el.__textFont=font;}else if(el.__tspanList.length){// Update span x and y
var len=el.__tspanList.length;for(var i=0;i<len;++i){var tspan=el.__tspanList[i];if(tspan){attr(tspan,'x',x);attr(tspan,'y',y+i*lineHeight+dy);}}}};function getVerticalAlignForSvg(verticalAlign){if(verticalAlign==='middle'){return'middle';}else if(verticalAlign==='bottom'){return'baseline';}else{return'hanging';}}svgText.drawRectText=svgTextDrawRectText;svgText.brush=function(el){var style=el.style;if(style.text!=null){// 强制设置 textPosition
style.textPosition=[0,0];svgTextDrawRectText(el,{x:style.x||0,y:style.y||0,width:0,height:0},el.getBoundingRect());}};// Myers' Diff Algorithm
// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
function Diff(){}Diff.prototype={diff:function diff(oldArr,newArr,equals){if(!equals){equals=function equals(a,b){return a===b;};}this.equals=equals;var self=this;oldArr=oldArr.slice();newArr=newArr.slice();// Allow subclasses to massage the input prior to running
var newLen=newArr.length;var oldLen=oldArr.length;var editLength=1;var maxEditLength=newLen+oldLen;var bestPath=[{newPos:-1,components:[]}];// Seed editLength = 0, i.e. the content starts with the same values
var oldPos=this.extractCommon(bestPath[0],newArr,oldArr,0);if(bestPath[0].newPos+1>=newLen&&oldPos+1>=oldLen){var indices=[];for(var i=0;i<newArr.length;i++){indices.push(i);}// Identity per the equality and tokenizer
return[{indices:indices,count:newArr.length}];}// Main worker method. checks all permutations of a given edit length for acceptance.
function execEditLength(){for(var diagonalPath=-1*editLength;diagonalPath<=editLength;diagonalPath+=2){var basePath;var addPath=bestPath[diagonalPath-1];var removePath=bestPath[diagonalPath+1];var oldPos=(removePath?removePath.newPos:0)-diagonalPath;if(addPath){// No one else is going to attempt to use this value, clear it
bestPath[diagonalPath-1]=undefined;}var canAdd=addPath&&addPath.newPos+1<newLen;var canRemove=removePath&&0<=oldPos&&oldPos<oldLen;if(!canAdd&&!canRemove){// If this path is a terminal then prune
bestPath[diagonalPath]=undefined;continue;}// Select the diagonal that we want to branch from. We select the prior
// path whose position in the new string is the farthest from the origin
// and does not pass the bounds of the diff graph
if(!canAdd||canRemove&&addPath.newPos<removePath.newPos){basePath=clonePath(removePath);self.pushComponent(basePath.components,undefined,true);}else{basePath=addPath;// No need to clone, we've pulled it from the list
basePath.newPos++;self.pushComponent(basePath.components,true,undefined);}oldPos=self.extractCommon(basePath,newArr,oldArr,diagonalPath);// If we have hit the end of both strings, then we are done
if(basePath.newPos+1>=newLen&&oldPos+1>=oldLen){return buildValues(self,basePath.components,newArr,oldArr);}else{// Otherwise track this path as a potential candidate and continue.
bestPath[diagonalPath]=basePath;}}editLength++;}while(editLength<=maxEditLength){var ret=execEditLength();if(ret){return ret;}}},pushComponent:function pushComponent(components,added,removed){var last=components[components.length-1];if(last&&last.added===added&&last.removed===removed){// We need to clone here as the component clone operation is just
// as shallow array clone
components[components.length-1]={count:last.count+1,added:added,removed:removed};}else{components.push({count:1,added:added,removed:removed});}},extractCommon:function extractCommon(basePath,newArr,oldArr,diagonalPath){var newLen=newArr.length;var oldLen=oldArr.length;var newPos=basePath.newPos;var oldPos=newPos-diagonalPath;var commonCount=0;while(newPos+1<newLen&&oldPos+1<oldLen&&this.equals(newArr[newPos+1],oldArr[oldPos+1])){newPos++;oldPos++;commonCount++;}if(commonCount){basePath.components.push({count:commonCount});}basePath.newPos=newPos;return oldPos;},tokenize:function tokenize(value){return value.slice();},join:function join(value){return value.slice();}};function buildValues(diff,components,newArr,oldArr){var componentPos=0;var componentLen=components.length;var newPos=0;var oldPos=0;for(;componentPos<componentLen;componentPos++){var component=components[componentPos];if(!component.removed){var indices=[];for(var i=newPos;i<newPos+component.count;i++){indices.push(i);}component.indices=indices;newPos+=component.count;// Common case
if(!component.added){oldPos+=component.count;}}else{var indices=[];for(var i=oldPos;i<oldPos+component.count;i++){indices.push(i);}component.indices=indices;oldPos+=component.count;}}return components;}function clonePath(path){return{newPos:path.newPos,components:path.components.slice(0)};}var arrayDiff=new Diff();var arrayDiff$1=function arrayDiff$1(oldArr,newArr,callback){return arrayDiff.diff(oldArr,newArr,callback);};/**
 * @file Manages elements that can be defined in <defs> in SVG,
 *       e.g., gradients, clip path, etc.
 * @author Zhang Wenli
 */var MARK_UNUSED='0';var MARK_USED='1';/**
 * Manages elements that can be defined in <defs> in SVG,
 * e.g., gradients, clip path, etc.
 *
 * @class
 * @param {number}          zrId      zrender instance id
 * @param {SVGElement}      svgRoot   root of SVG document
 * @param {string|string[]} tagNames  possible tag names
 * @param {string}          markLabel label name to make if the element
 *                                    is used
 */function Definable(zrId,svgRoot,tagNames,markLabel,domName){this._zrId=zrId;this._svgRoot=svgRoot;this._tagNames=typeof tagNames==='string'?[tagNames]:tagNames;this._markLabel=markLabel;this._domName=domName||'_dom';this.nextId=0;}Definable.prototype.createElement=createElement;/**
 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
 *
 * @param {boolean} isForceCreating if need to create when not exists
 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
 * exist and isForceCreating is false
 */Definable.prototype.getDefs=function(isForceCreating){var svgRoot=this._svgRoot;var defs=this._svgRoot.getElementsByTagName('defs');if(defs.length===0){// Not exist
if(isForceCreating){defs=svgRoot.insertBefore(this.createElement('defs'),// Create new tag
svgRoot.firstChild// Insert in the front of svg
);if(!defs.contains){// IE doesn't support contains method
defs.contains=function(el){var children=defs.children;if(!children){return false;}for(var i=children.length-1;i>=0;--i){if(children[i]===el){return true;}}return false;};}return defs;}else{return null;}}else{return defs[0];}};/**
 * Update DOM element if necessary.
 *
 * @param {Object|string} element style element. e.g., for gradient,
 *                                it may be '#ccc' or {type: 'linear', ...}
 * @param {Function|undefined} onUpdate update callback
 */Definable.prototype.update=function(element,onUpdate){if(!element){return;}var defs=this.getDefs(false);if(element[this._domName]&&defs.contains(element[this._domName])){// Update DOM
if(typeof onUpdate==='function'){onUpdate(element);}}else{// No previous dom, create new
var dom=this.add(element);if(dom){element[this._domName]=dom;}}};/**
 * Add gradient dom to defs
 *
 * @param {SVGElement} dom DOM to be added to <defs>
 */Definable.prototype.addDom=function(dom){var defs=this.getDefs(true);defs.appendChild(dom);};/**
 * Remove DOM of a given element.
 *
 * @param {SVGElement} element element to remove dom
 */Definable.prototype.removeDom=function(element){var defs=this.getDefs(false);if(defs&&element[this._domName]){defs.removeChild(element[this._domName]);element[this._domName]=null;}};/**
 * Get DOMs of this element.
 *
 * @return {HTMLDomElement} doms of this defineable elements in <defs>
 */Definable.prototype.getDoms=function(){var defs=this.getDefs(false);if(!defs){// No dom when defs is not defined
return[];}var doms=[];each$1(this._tagNames,function(tagName){var tags=defs.getElementsByTagName(tagName);// Note that tags is HTMLCollection, which is array-like
// rather than real array.
// So `doms.concat(tags)` add tags as one object.
doms=doms.concat([].slice.call(tags));});return doms;};/**
 * Mark DOMs to be unused before painting, and clear unused ones at the end
 * of the painting.
 */Definable.prototype.markAllUnused=function(){var doms=this.getDoms();var that=this;each$1(doms,function(dom){dom[that._markLabel]=MARK_UNUSED;});};/**
 * Mark a single DOM to be used.
 *
 * @param {SVGElement} dom DOM to mark
 */Definable.prototype.markUsed=function(dom){if(dom){dom[this._markLabel]=MARK_USED;}};/**
 * Remove unused DOMs defined in <defs>
 */Definable.prototype.removeUnused=function(){var defs=this.getDefs(false);if(!defs){// Nothing to remove
return;}var doms=this.getDoms();var that=this;each$1(doms,function(dom){if(dom[that._markLabel]!==MARK_USED){// Remove gradient
defs.removeChild(dom);}});};/**
 * Get SVG proxy.
 *
 * @param {Displayable} displayable displayable element
 * @return {Path|Image|Text} svg proxy of given element
 */Definable.prototype.getSvgProxy=function(displayable){if(displayable instanceof Path){return svgPath;}else if(displayable instanceof ZImage){return svgImage;}else if(displayable instanceof Text){return svgText;}else{return svgPath;}};/**
 * Get text SVG element.
 *
 * @param {Displayable} displayable displayable element
 * @return {SVGElement} SVG element of text
 */Definable.prototype.getTextSvgElement=function(displayable){return displayable.__textSvgEl;};/**
 * Get SVG element.
 *
 * @param {Displayable} displayable displayable element
 * @return {SVGElement} SVG element
 */Definable.prototype.getSvgElement=function(displayable){return displayable.__svgEl;};/**
 * @file Manages SVG gradient elements.
 * @author Zhang Wenli
 *//**
 * Manages SVG gradient elements.
 *
 * @class
 * @extends Definable
 * @param   {number}     zrId    zrender instance id
 * @param   {SVGElement} svgRoot root of SVG document
 */function GradientManager(zrId,svgRoot){Definable.call(this,zrId,svgRoot,['linearGradient','radialGradient'],'__gradient_in_use__');}inherits(GradientManager,Definable);/**
 * Create new gradient DOM for fill or stroke if not exist,
 * but will not update gradient if exists.
 *
 * @param {SvgElement}  svgElement   SVG element to paint
 * @param {Displayable} displayable  zrender displayable element
 */GradientManager.prototype.addWithoutUpdate=function(svgElement,displayable){if(displayable&&displayable.style){var that=this;each$1(['fill','stroke'],function(fillOrStroke){if(displayable.style[fillOrStroke]&&(displayable.style[fillOrStroke].type==='linear'||displayable.style[fillOrStroke].type==='radial')){var gradient=displayable.style[fillOrStroke];var defs=that.getDefs(true);// Create dom in <defs> if not exists
var dom;if(gradient._dom){// Gradient exists
dom=gradient._dom;if(!defs.contains(gradient._dom)){// _dom is no longer in defs, recreate
that.addDom(dom);}}else{// New dom
dom=that.add(gradient);}that.markUsed(displayable);var id=dom.getAttribute('id');svgElement.setAttribute(fillOrStroke,'url(#'+id+')');}});}};/**
 * Add a new gradient tag in <defs>
 *
 * @param   {Gradient} gradient zr gradient instance
 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
 *                            created DOM
 */GradientManager.prototype.add=function(gradient){var dom;if(gradient.type==='linear'){dom=this.createElement('linearGradient');}else if(gradient.type==='radial'){dom=this.createElement('radialGradient');}else{zrLog('Illegal gradient type.');return null;}// Set dom id with gradient id, since each gradient instance
// will have no more than one dom element.
// id may exists before for those dirty elements, in which case
// id should remain the same, and other attributes should be
// updated.
gradient.id=gradient.id||this.nextId++;dom.setAttribute('id','zr'+this._zrId+'-gradient-'+gradient.id);this.updateDom(gradient,dom);this.addDom(dom);return dom;};/**
 * Update gradient.
 *
 * @param {Gradient} gradient zr gradient instance
 */GradientManager.prototype.update=function(gradient){var that=this;Definable.prototype.update.call(this,gradient,function(){var type=gradient.type;var tagName=gradient._dom.tagName;if(type==='linear'&&tagName==='linearGradient'||type==='radial'&&tagName==='radialGradient'){// Gradient type is not changed, update gradient
that.updateDom(gradient,gradient._dom);}else{// Remove and re-create if type is changed
that.removeDom(gradient);that.add(gradient);}});};/**
 * Update gradient dom
 *
 * @param {Gradient} gradient zr gradient instance
 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
 *                            DOM to update
 */GradientManager.prototype.updateDom=function(gradient,dom){if(gradient.type==='linear'){dom.setAttribute('x1',gradient.x);dom.setAttribute('y1',gradient.y);dom.setAttribute('x2',gradient.x2);dom.setAttribute('y2',gradient.y2);}else if(gradient.type==='radial'){dom.setAttribute('cx',gradient.x);dom.setAttribute('cy',gradient.y);dom.setAttribute('r',gradient.r);}else{zrLog('Illegal gradient type.');return;}if(gradient.global){// x1, x2, y1, y2 in range of 0 to canvas width or height
dom.setAttribute('gradientUnits','userSpaceOnUse');}else{// x1, x2, y1, y2 in range of 0 to 1
dom.setAttribute('gradientUnits','objectBoundingBox');}// Remove color stops if exists
dom.innerHTML='';// Add color stops
var colors=gradient.colorStops;for(var i=0,len=colors.length;i<len;++i){var stop=this.createElement('stop');stop.setAttribute('offset',colors[i].offset*100+'%');stop.setAttribute('stop-color',colors[i].color);dom.appendChild(stop);}// Store dom element in gradient, to avoid creating multiple
// dom instances for the same gradient element
gradient._dom=dom;};/**
 * Mark a single gradient to be used
 *
 * @param {Displayable} displayable displayable element
 */GradientManager.prototype.markUsed=function(displayable){if(displayable.style){var gradient=displayable.style.fill;if(gradient&&gradient._dom){Definable.prototype.markUsed.call(this,gradient._dom);}gradient=displayable.style.stroke;if(gradient&&gradient._dom){Definable.prototype.markUsed.call(this,gradient._dom);}}};/**
 * @file Manages SVG clipPath elements.
 * @author Zhang Wenli
 *//**
 * Manages SVG clipPath elements.
 *
 * @class
 * @extends Definable
 * @param   {number}     zrId    zrender instance id
 * @param   {SVGElement} svgRoot root of SVG document
 */function ClippathManager(zrId,svgRoot){Definable.call(this,zrId,svgRoot,'clipPath','__clippath_in_use__');}inherits(ClippathManager,Definable);/**
 * Update clipPath.
 *
 * @param {Displayable} displayable displayable element
 */ClippathManager.prototype.update=function(displayable){var svgEl=this.getSvgElement(displayable);if(svgEl){this.updateDom(svgEl,displayable.__clipPaths,false);}var textEl=this.getTextSvgElement(displayable);if(textEl){// Make another clipPath for text, since it's transform
// matrix is not the same with svgElement
this.updateDom(textEl,displayable.__clipPaths,true);}this.markUsed(displayable);};/**
 * Create an SVGElement of displayable and create a <clipPath> of its
 * clipPath
 *
 * @param {Displayable} parentEl  parent element
 * @param {ClipPath[]}  clipPaths clipPaths of parent element
 * @param {boolean}     isText    if parent element is Text
 */ClippathManager.prototype.updateDom=function(parentEl,clipPaths,isText){if(clipPaths&&clipPaths.length>0){// Has clipPath, create <clipPath> with the first clipPath
var defs=this.getDefs(true);var clipPath=clipPaths[0];var clipPathEl;var id;var dom=isText?'_textDom':'_dom';if(clipPath[dom]){// Use a dom that is already in <defs>
id=clipPath[dom].getAttribute('id');clipPathEl=clipPath[dom];// Use a dom that is already in <defs>
if(!defs.contains(clipPathEl)){// This happens when set old clipPath that has
// been previously removed
defs.appendChild(clipPathEl);}}else{// New <clipPath>
id='zr'+this._zrId+'-clip-'+this.nextId;++this.nextId;clipPathEl=this.createElement('clipPath');clipPathEl.setAttribute('id',id);defs.appendChild(clipPathEl);clipPath[dom]=clipPathEl;}// Build path and add to <clipPath>
var svgProxy=this.getSvgProxy(clipPath);if(clipPath.transform&&clipPath.parent.invTransform&&!isText){/**
       * If a clipPath has a parent with transform, the transform
       * of parent should not be considered when setting transform
       * of clipPath. So we need to transform back from parent's
       * transform, which is done by multiplying parent's inverse
       * transform.
       */// Store old transform
var transform=Array.prototype.slice.call(clipPath.transform);// Transform back from parent, and brush path
mul$1(clipPath.transform,clipPath.parent.invTransform,clipPath.transform);svgProxy.brush(clipPath);// Set back transform of clipPath
clipPath.transform=transform;}else{svgProxy.brush(clipPath);}var pathEl=this.getSvgElement(clipPath);clipPathEl.innerHTML='';/**
     * Use `cloneNode()` here to appendChild to multiple parents,
     * which may happend when Text and other shapes are using the same
     * clipPath. Since Text will create an extra clipPath DOM due to
     * different transform rules.
     */clipPathEl.appendChild(pathEl.cloneNode());parentEl.setAttribute('clip-path','url(#'+id+')');if(clipPaths.length>1){// Make the other clipPaths recursively
this.updateDom(clipPathEl,clipPaths.slice(1),isText);}}else{// No clipPath
if(parentEl){parentEl.setAttribute('clip-path','none');}}};/**
 * Mark a single clipPath to be used
 *
 * @param {Displayable} displayable displayable element
 */ClippathManager.prototype.markUsed=function(displayable){var that=this;if(displayable.__clipPaths&&displayable.__clipPaths.length>0){each$1(displayable.__clipPaths,function(clipPath){if(clipPath._dom){Definable.prototype.markUsed.call(that,clipPath._dom);}if(clipPath._textDom){Definable.prototype.markUsed.call(that,clipPath._textDom);}});}};/**
 * @file Manages SVG shadow elements.
 * @author Zhang Wenli
 *//**
 * Manages SVG shadow elements.
 *
 * @class
 * @extends Definable
 * @param   {number}     zrId    zrender instance id
 * @param   {SVGElement} svgRoot root of SVG document
 */function ShadowManager(zrId,svgRoot){Definable.call(this,zrId,svgRoot,['filter'],'__filter_in_use__','_shadowDom');}inherits(ShadowManager,Definable);/**
 * Create new shadow DOM for fill or stroke if not exist,
 * but will not update shadow if exists.
 *
 * @param {SvgElement}  svgElement   SVG element to paint
 * @param {Displayable} displayable  zrender displayable element
 */ShadowManager.prototype.addWithoutUpdate=function(svgElement,displayable){if(displayable&&hasShadow(displayable.style)){var style=displayable.style;// Create dom in <defs> if not exists
var dom;if(style._shadowDom){// Gradient exists
dom=style._shadowDom;var defs=this.getDefs(true);if(!defs.contains(style._shadowDom)){// _shadowDom is no longer in defs, recreate
this.addDom(dom);}}else{// New dom
dom=this.add(displayable);}this.markUsed(displayable);var id=dom.getAttribute('id');svgElement.style.filter='url(#'+id+')';}};/**
 * Add a new shadow tag in <defs>
 *
 * @param {Displayable} displayable  zrender displayable element
 * @return {SVGFilterElement} created DOM
 */ShadowManager.prototype.add=function(displayable){var dom=this.createElement('filter');var style=displayable.style;// Set dom id with shadow id, since each shadow instance
// will have no more than one dom element.
// id may exists before for those dirty elements, in which case
// id should remain the same, and other attributes should be
// updated.
style._shadowDomId=style._shadowDomId||this.nextId++;dom.setAttribute('id','zr'+this._zrId+'-shadow-'+style._shadowDomId);this.updateDom(displayable,dom);this.addDom(dom);return dom;};/**
 * Update shadow.
 *
 * @param {Displayable} displayable  zrender displayable element
 */ShadowManager.prototype.update=function(svgElement,displayable){var style=displayable.style;if(hasShadow(style)){var that=this;Definable.prototype.update.call(this,displayable,function(style){that.updateDom(displayable,style._shadowDom);});}else{// Remove shadow
this.remove(svgElement,style);}};/**
 * Remove DOM and clear parent filter
 */ShadowManager.prototype.remove=function(svgElement,style){if(style._shadowDomId!=null){this.removeDom(style);svgElement.style.filter='';}};/**
 * Update shadow dom
 *
 * @param {Displayable} displayable  zrender displayable element
 * @param {SVGFilterElement} dom DOM to update
 */ShadowManager.prototype.updateDom=function(displayable,dom){var domChild=dom.getElementsByTagName('feDropShadow');if(domChild.length===0){domChild=this.createElement('feDropShadow');}else{domChild=domChild[0];}var style=displayable.style;var scaleX=displayable.scale?displayable.scale[0]||1:1;var scaleY=displayable.scale?displayable.scale[1]||1:1;// TODO: textBoxShadowBlur is not supported yet
var offsetX,offsetY,blur,color;if(style.shadowBlur||style.shadowOffsetX||style.shadowOffsetY){offsetX=style.shadowOffsetX||0;offsetY=style.shadowOffsetY||0;blur=style.shadowBlur;color=style.shadowColor;}else if(style.textShadowBlur){offsetX=style.textShadowOffsetX||0;offsetY=style.textShadowOffsetY||0;blur=style.textShadowBlur;color=style.textShadowColor;}else{// Remove shadow
this.removeDom(dom,style);return;}domChild.setAttribute('dx',offsetX/scaleX);domChild.setAttribute('dy',offsetY/scaleY);domChild.setAttribute('flood-color',color);// Divide by two here so that it looks the same as in canvas
// See: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-shadowblur
var stdDx=blur/2/scaleX;var stdDy=blur/2/scaleY;var stdDeviation=stdDx+' '+stdDy;domChild.setAttribute('stdDeviation',stdDeviation);// Fix filter clipping problem
dom.setAttribute('x','-100%');dom.setAttribute('y','-100%');dom.setAttribute('width',Math.ceil(blur/2*200)+'%');dom.setAttribute('height',Math.ceil(blur/2*200)+'%');dom.appendChild(domChild);// Store dom element in shadow, to avoid creating multiple
// dom instances for the same shadow element
style._shadowDom=dom;};/**
 * Mark a single shadow to be used
 *
 * @param {Displayable} displayable displayable element
 */ShadowManager.prototype.markUsed=function(displayable){var style=displayable.style;if(style&&style._shadowDom){Definable.prototype.markUsed.call(this,style._shadowDom);}};function hasShadow(style){// TODO: textBoxShadowBlur is not supported yet
return style&&(style.shadowBlur||style.shadowOffsetX||style.shadowOffsetY||style.textShadowBlur||style.textShadowOffsetX||style.textShadowOffsetY);}/**
 * SVG Painter
 * @module zrender/svg/Painter
 */function parseInt10$1(val){return parseInt(val,10);}function getSvgProxy(el){if(el instanceof Path){return svgPath;}else if(el instanceof ZImage){return svgImage;}else if(el instanceof Text){return svgText;}else{return svgPath;}}function checkParentAvailable(parent,child){return child&&parent&&child.parentNode!==parent;}function insertAfter(parent,child,prevSibling){if(checkParentAvailable(parent,child)&&prevSibling){var nextSibling=prevSibling.nextSibling;nextSibling?parent.insertBefore(child,nextSibling):parent.appendChild(child);}}function prepend(parent,child){if(checkParentAvailable(parent,child)){var firstChild=parent.firstChild;firstChild?parent.insertBefore(child,firstChild):parent.appendChild(child);}}function remove(parent,child){if(child&&parent&&child.parentNode===parent){parent.removeChild(child);}}function getTextSvgElement(displayable){return displayable.__textSvgEl;}function getSvgElement(displayable){return displayable.__svgEl;}/**
 * @alias module:zrender/svg/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */var SVGPainter=function SVGPainter(root,storage,opts,zrId){this.root=root;this.storage=storage;this._opts=opts=extend({},opts||{});var svgRoot=createElement('svg');svgRoot.setAttribute('xmlns','http://www.w3.org/2000/svg');svgRoot.setAttribute('version','1.1');svgRoot.setAttribute('baseProfile','full');svgRoot.style.cssText='user-select:none;position:absolute;left:0;top:0;';this.gradientManager=new GradientManager(zrId,svgRoot);this.clipPathManager=new ClippathManager(zrId,svgRoot);this.shadowManager=new ShadowManager(zrId,svgRoot);var viewport=document.createElement('div');viewport.style.cssText='overflow:hidden;position:relative';this._svgRoot=svgRoot;this._viewport=viewport;root.appendChild(viewport);viewport.appendChild(svgRoot);this.resize(opts.width,opts.height);this._visibleList=[];};SVGPainter.prototype={constructor:SVGPainter,getType:function getType(){return'svg';},getViewportRoot:function getViewportRoot(){return this._viewport;},getViewportRootOffset:function getViewportRootOffset(){var viewportRoot=this.getViewportRoot();if(viewportRoot){return{offsetLeft:viewportRoot.offsetLeft||0,offsetTop:viewportRoot.offsetTop||0};}},refresh:function refresh(){var list=this.storage.getDisplayList(true);this._paintList(list);},setBackgroundColor:function setBackgroundColor(backgroundColor){// TODO gradient
this._viewport.style.background=backgroundColor;},_paintList:function _paintList(list){this.gradientManager.markAllUnused();this.clipPathManager.markAllUnused();this.shadowManager.markAllUnused();var svgRoot=this._svgRoot;var visibleList=this._visibleList;var listLen=list.length;var newVisibleList=[];var i;for(i=0;i<listLen;i++){var displayable=list[i];var svgProxy=getSvgProxy(displayable);var svgElement=getSvgElement(displayable)||getTextSvgElement(displayable);if(!displayable.invisible){if(displayable.__dirty){svgProxy&&svgProxy.brush(displayable);// Update clipPath
this.clipPathManager.update(displayable);// Update gradient and shadow
if(displayable.style){this.gradientManager.update(displayable.style.fill);this.gradientManager.update(displayable.style.stroke);this.shadowManager.update(svgElement,displayable);}displayable.__dirty=false;}newVisibleList.push(displayable);}}var diff=arrayDiff$1(visibleList,newVisibleList);var prevSvgElement;// First do remove, in case element moved to the head and do remove
// after add
for(i=0;i<diff.length;i++){var item=diff[i];if(item.removed){for(var k=0;k<item.count;k++){var displayable=visibleList[item.indices[k]];var svgElement=getSvgElement(displayable);var textSvgElement=getTextSvgElement(displayable);remove(svgRoot,svgElement);remove(svgRoot,textSvgElement);}}}for(i=0;i<diff.length;i++){var item=diff[i];if(item.added){for(var k=0;k<item.count;k++){var displayable=newVisibleList[item.indices[k]];var svgElement=getSvgElement(displayable);var textSvgElement=getTextSvgElement(displayable);prevSvgElement?insertAfter(svgRoot,svgElement,prevSvgElement):prepend(svgRoot,svgElement);if(svgElement){insertAfter(svgRoot,textSvgElement,svgElement);}else if(prevSvgElement){insertAfter(svgRoot,textSvgElement,prevSvgElement);}else{prepend(svgRoot,textSvgElement);}// Insert text
insertAfter(svgRoot,textSvgElement,svgElement);prevSvgElement=textSvgElement||svgElement||prevSvgElement;this.gradientManager.addWithoutUpdate(svgElement,displayable);this.shadowManager.addWithoutUpdate(prevSvgElement,displayable);this.clipPathManager.markUsed(displayable);}}else if(!item.removed){for(var k=0;k<item.count;k++){var displayable=newVisibleList[item.indices[k]];prevSvgElement=svgElement=getTextSvgElement(displayable)||getSvgElement(displayable)||prevSvgElement;this.gradientManager.markUsed(displayable);this.gradientManager.addWithoutUpdate(svgElement,displayable);this.shadowManager.markUsed(displayable);this.shadowManager.addWithoutUpdate(svgElement,displayable);this.clipPathManager.markUsed(displayable);}}}this.gradientManager.removeUnused();this.clipPathManager.removeUnused();this.shadowManager.removeUnused();this._visibleList=newVisibleList;},_getDefs:function _getDefs(isForceCreating){var svgRoot=this._svgRoot;var defs=this._svgRoot.getElementsByTagName('defs');if(defs.length===0){// Not exist
if(isForceCreating){var defs=svgRoot.insertBefore(createElement('defs'),// Create new tag
svgRoot.firstChild// Insert in the front of svg
);if(!defs.contains){// IE doesn't support contains method
defs.contains=function(el){var children=defs.children;if(!children){return false;}for(var i=children.length-1;i>=0;--i){if(children[i]===el){return true;}}return false;};}return defs;}else{return null;}}else{return defs[0];}},resize:function resize(width,height){var viewport=this._viewport;// FIXME Why ?
viewport.style.display='none';// Save input w/h
var opts=this._opts;width!=null&&(opts.width=width);height!=null&&(opts.height=height);width=this._getSize(0);height=this._getSize(1);viewport.style.display='';if(this._width!==width||this._height!==height){this._width=width;this._height=height;var viewportStyle=viewport.style;viewportStyle.width=width+'px';viewportStyle.height=height+'px';var svgRoot=this._svgRoot;// Set width by 'svgRoot.width = width' is invalid
svgRoot.setAttribute('width',width);svgRoot.setAttribute('height',height);}},/**
   * 获取绘图区域宽度
   */getWidth:function getWidth(){return this._width;},/**
   * 获取绘图区域高度
   */getHeight:function getHeight(){return this._height;},_getSize:function _getSize(whIdx){var opts=this._opts;var wh=['width','height'][whIdx];var cwh=['clientWidth','clientHeight'][whIdx];var plt=['paddingLeft','paddingTop'][whIdx];var prb=['paddingRight','paddingBottom'][whIdx];if(opts[wh]!=null&&opts[wh]!=='auto'){return parseFloat(opts[wh]);}var root=this.root;// IE8 does not support getComputedStyle, but it use VML.
var stl=document.defaultView.getComputedStyle(root);return(root[cwh]||parseInt10$1(stl[wh])||parseInt10$1(root.style[wh]))-(parseInt10$1(stl[plt])||0)-(parseInt10$1(stl[prb])||0)|0;},dispose:function dispose(){this.root.innerHTML='';this._svgRoot=this._viewport=this.storage=null;},clear:function clear(){if(this._viewport){this.root.removeChild(this._viewport);}},pathToDataUrl:function pathToDataUrl(){this.refresh();var html=this._svgRoot.outerHTML;return'data:image/svg+xml;charset=UTF-8,'+html;}};// Not supported methods
function createMethodNotSupport(method){return function(){zrLog('In SVG mode painter not support method "'+method+'"');};}// Unsuppoted methods
each$1(['getLayer','insertLayer','eachLayer','eachBuiltinLayer','eachOtherLayer','getLayers','modLayer','delLayer','clearLayer','toDataURL','pathToImage'],function(name){SVGPainter.prototype[name]=createMethodNotSupport(name);});registerPainter('svg',SVGPainter);exports.version=version;exports.dependencies=dependencies;exports.PRIORITY=PRIORITY;exports.init=init;exports.connect=connect;exports.disConnect=disConnect;exports.disconnect=disconnect;exports.dispose=dispose;exports.getInstanceByDom=getInstanceByDom;exports.getInstanceById=getInstanceById;exports.registerTheme=registerTheme;exports.registerPreprocessor=registerPreprocessor;exports.registerProcessor=registerProcessor;exports.registerPostUpdate=registerPostUpdate;exports.registerAction=registerAction;exports.registerCoordinateSystem=registerCoordinateSystem;exports.getCoordinateSystemDimensions=getCoordinateSystemDimensions;exports.registerLayout=registerLayout;exports.registerVisual=registerVisual;exports.registerLoading=registerLoading;exports.extendComponentModel=extendComponentModel;exports.extendComponentView=extendComponentView;exports.extendSeriesModel=extendSeriesModel;exports.extendChartView=extendChartView;exports.setCanvasCreator=setCanvasCreator;exports.registerMap=registerMap;exports.getMap=getMap;exports.dataTool=dataTool;exports.zrender=zrender;exports.graphic=graphic;exports.number=number;exports.format=format;exports.throttle=throttle;exports.helper=helper;exports.matrix=matrix;exports.vector=vector;exports.color=color;exports.parseGeoJSON=parseGeoJSON;exports.parseGeoJson=parseGeoJson;exports.util=ecUtil;exports.List=List;exports.Model=Model;exports.Axis=Axis;exports.env=env$1;});

/***/ }),

/***/ "ScpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var TradeSearch = (function (_super) {
    __extends(TradeSearch, _super);
    function TradeSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableTitle = [
            {
                text: '合约',
                width: '2rem',
                name: 'targetId',
            },
            {
                text: '开平',
                width: '1.5rem',
                name: 'offset',
            },
            {
                text: '成交价格',
                width: '2rem',
                name: 'price',
            },
            {
                text: '成交手数',
                width: '2rem',
                name: 'tradedVolume',
            },
            {
                text: '成交时间',
                width: '3rem',
                name: 'insertTime',
            },
        ];
        return _this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], TradeSearch.prototype, "tableData", void 0);
    TradeSearch = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], TradeSearch);
    return TradeSearch;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (TradeSearch);


/***/ }),

/***/ "SjAb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_setPage_vue__ = __webpack_require__("QcJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4926d1b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_setPage_vue__ = __webpack_require__("9a+G");
function injectStyle (ssrContext) {
  __webpack_require__("2Ip2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4926d1b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_setPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4926d1b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_setPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TsbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U9Gh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debugout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/*
    debugout.js
    by @inorganik

*/

// save all the console.logs
function debugout() {
  var self = this;

  // OPTIONS
  self.realTimeLoggingOn = true; // log in real time (forwards to console.log)
  self.useTimestamps = false; // insert a timestamp in front of each log
  self.useLocalStorage = false; // store the output using window.localStorage() and continuously add to the same log each session
  self.recordLogs = true; // set to false after you're done debugging to avoid the log eating up memory
  self.autoTrim = true; // to avoid the log eating up potentially endless memory
  self.maxLines = 2500; // if autoTrim is true, this many most recent lines are saved
  self.tailNumLines = 100; // how many lines tail() will retrieve
  self.logFilename = 'debugout.txt'; // filename of log downloaded with downloadLog()
  self.maxDepth = 25; // max recursion depth for logged objects

  // vars
  self.depth = 0;
  self.parentSizes = [0];
  self.currentResult = '';
  self.startTime = new Date();
  self.output = '';

  this.version = function () {
    return '0.5.0';
  };

  /*
  	USER METHODS
  */
  this.getLog = function () {
    var retrievalTime = new Date();
    // if recording is off, so dev knows why they don't have any logs
    if (!self.recordLogs) {
      self.log('[debugout.js] log recording is off.');
    }
    // if using local storage, get values
    if (self.useLocalStorage) {
      var saved = window.localStorage.getItem('debugout.js');
      if (saved) {
        saved = JSON.parse(saved);
        self.startTime = new Date(saved.startTime);
        self.output = saved.log;
        retrievalTime = new Date(saved.lastLog);
      }
    }
    return self.output;
  };
  // accepts optional number or uses the default for number of lines
  this.tail = function (numLines) {
    var numLines = numLines || self.tailLines;
    return self.trimLog(self.getLog(), numLines);
  };
  // accepts a string to search for
  this.search = function (string) {
    var lines = self.output.split('\n');
    var rgx = new RegExp(string);
    var matched = [];
    // can't use a simple Array.prototype.filter() here
    // because we need to add the line number
    for (var i = 0; i < lines.length; i++) {
      var addr = '[' + i + '] ';
      if (lines[i].match(rgx)) {
        matched.push(addr + lines[i]);
      }
    }
    var result = matched.join('\n');
    if (result.length == 0) result = 'Nothing found for "' + string + '".';
    return result;
  };
  // accepts the starting line and how many lines after the starting line you want
  this.getSlice = function (lineNumber, numLines) {
    var lines = self.output.split('\n');
    var segment = lines.slice(lineNumber, lineNumber + numLines);
    return segment.join('\n');
  };
  // immediately downloads the log - for desktop browser use
  this.downloadLog = function () {
    var file = "data:text/plain;charset=utf-8,";
    var logFile = self.getLog();
    var encoded = encodeURIComponent(logFile);
    file += encoded;
    var a = document.createElement('a');
    a.href = file;
    a.target = '_blank';
    a.download = self.logFilename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };
  // clears the log
  this.clear = function () {
    var clearTime = new Date();
    self.output = '';
    if (self.useLocalStorage) {
      // local storage
      var saveObject = {
        startTime: self.startTime,
        log: self.output,
        lastLog: clearTime
      };
      saveObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(saveObject);
      window.localStorage.setItem('debugout.js', saveObject);
    }
  };
  // records a log
  this.log = function (obj) {
    // log in real time
    if (self.realTimeLoggingOn) console.log(obj);
    // record log
    var type = self.determineType(obj);
    if (type != null && self.recordLogs) {
      var addition = self.formatType(type, obj);
      // timestamp, formatted for brevity
      if (self.useTimestamps) {
        var logTime = new Date();
        self.output += self.formatTimestamp(logTime);
      }
      self.output += addition + '\n';
      if (self.autoTrim) self.output = self.trimLog(self.output, self.maxLines);
      // local storage
      if (self.useLocalStorage) {
        var last = new Date();
        var saveObject = {
          startTime: self.startTime,
          log: self.output,
          lastLog: last
        };
        saveObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(saveObject);
        window.localStorage.setItem('debugout.js', saveObject);
      }
    }
    self.depth = 0;
    self.parentSizes = [0];
    self.currentResult = '';
  };
  /*
  	METHODS FOR CONSTRUCTING THE LOG
  */

  // like typeof but classifies objects of type 'object'
  // kept separate from formatType() so you can use at your convenience!
  this.determineType = function (object) {
    if (object != null) {
      var typeResult;
      var type = typeof object === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(object);
      if (type == 'object') {
        var len = object.length;
        if (len == null) {
          if (typeof object.getTime == 'function') {
            typeResult = 'Date';
          } else if (typeof object.test == 'function') {
            typeResult = 'RegExp';
          } else {
            typeResult = 'Object';
          }
        } else {
          typeResult = 'Array';
        }
      } else {
        typeResult = type;
      }
      return typeResult;
    } else {
      return null;
    }
  };
  // format type accordingly, recursively if necessary
  this.formatType = function (type, obj) {
    if (self.maxDepth && self.depth >= self.maxDepth) {
      return '... (max-depth reached)';
    }

    switch (type) {
      case 'Object':
        self.currentResult += '{\n';
        self.depth++;
        self.parentSizes.push(self.objectSize(obj));
        var i = 0;
        for (var prop in obj) {
          self.currentResult += self.indentsForDepth(self.depth);
          self.currentResult += prop + ': ';
          var subtype = self.determineType(obj[prop]);
          var subresult = self.formatType(subtype, obj[prop]);
          if (subresult) {
            self.currentResult += subresult;
            if (i != self.parentSizes[self.depth] - 1) self.currentResult += ',';
            self.currentResult += '\n';
          } else {
            if (i != self.parentSizes[self.depth] - 1) self.currentResult += ',';
            self.currentResult += '\n';
          }
          i++;
        }
        self.depth--;
        self.parentSizes.pop();
        self.currentResult += self.indentsForDepth(self.depth);
        self.currentResult += '}';
        if (self.depth == 0) return self.currentResult;
        break;
      case 'Array':
        self.currentResult += '[';
        self.depth++;
        self.parentSizes.push(obj.length);
        for (var i = 0; i < obj.length; i++) {
          var subtype = self.determineType(obj[i]);
          if (subtype == 'Object' || subtype == 'Array') self.currentResult += '\n' + self.indentsForDepth(self.depth);
          var subresult = self.formatType(subtype, obj[i]);
          if (subresult) {
            self.currentResult += subresult;
            if (i != self.parentSizes[self.depth] - 1) self.currentResult += ', ';
            if (subtype == 'Array') self.currentResult += '\n';
          } else {
            if (i != self.parentSizes[self.depth] - 1) self.currentResult += ', ';
            if (subtype != 'Object') self.currentResult += '\n';else if (i == self.parentSizes[self.depth] - 1) self.currentResult += '\n';
          }
        }
        self.depth--;
        self.parentSizes.pop();
        self.currentResult += ']';
        if (self.depth == 0) return self.currentResult;
        break;
      case 'function':
        obj += '';
        var lines = obj.split('\n');
        for (var i = 0; i < lines.length; i++) {
          if (lines[i].match(/\}/)) self.depth--;
          self.currentResult += self.indentsForDepth(self.depth);
          if (lines[i].match(/\{/)) self.depth++;
          self.currentResult += lines[i] + '\n';
        }
        return self.currentResult;
        break;
      case 'RegExp':
        return '/' + obj.source + '/';
        break;
      case 'Date':
      case 'string':
        if (self.depth > 0 || obj.length == 0) {
          return '"' + obj + '"';
        } else {
          return obj;
        }
      case 'boolean':
        if (obj) return 'true';else return 'false';
      case 'number':
        return obj + '';
        break;
    }
  };
  this.indentsForDepth = function (depth) {
    var str = '';
    for (var i = 0; i < depth; i++) {
      str += '\t';
    }
    return str;
  };
  this.trimLog = function (log, maxLines) {
    var lines = log.split('\n');
    if (lines.length > maxLines) {
      lines = lines.slice(lines.length - maxLines);
    }
    return lines.join('\n');
  };
  this.lines = function () {
    return self.output.split('\n').length;
  };
  // calculate testing time
  this.formatSessionDuration = function (startTime, endTime) {
    var msec = endTime - startTime;
    var hh = Math.floor(msec / 1000 / 60 / 60);
    var hrs = ('0' + hh).slice(-2);
    msec -= hh * 1000 * 60 * 60;
    var mm = Math.floor(msec / 1000 / 60);
    var mins = ('0' + mm).slice(-2);
    msec -= mm * 1000 * 60;
    var ss = Math.floor(msec / 1000);
    var secs = ('0' + ss).slice(-2);
    msec -= ss * 1000;
    return '---- Session duration: ' + hrs + ':' + mins + ':' + secs + ' ----';
  };
  this.formatTimestamp = function (timestamp) {
    var year = timestamp.getFullYear();
    var date = timestamp.getDate();
    var month = ('0' + (timestamp.getMonth() + 1)).slice(-2);
    var hrs = Number(timestamp.getHours());
    var mins = ('0' + timestamp.getMinutes()).slice(-2);
    var secs = ('0' + timestamp.getSeconds()).slice(-2);
    return '[' + year + '-' + month + '-' + date + ' ' + hrs + ':' + mins + ':' + secs + ']: ';
  };
  this.objectSize = function (obj) {
    var size = 0,
        key;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) size++;
    }
    return size;
  };

  /*
  	START/RESUME LOG
  */
  if (self.useLocalStorage) {
    var saved = window.localStorage.getItem('debugout.js');
    if (saved) {
      saved = JSON.parse(saved);
      self.output = saved.log;
    }
  }
}

/***/ }),

/***/ "UG9+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VnN9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_BankCar_ts__ = __webpack_require__("RIHn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fbad369_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankCar_vue__ = __webpack_require__("Ly19");
function injectStyle (ssrContext) {
  __webpack_require__("cYrQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fbad369"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_BankCar_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fbad369_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankCar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VnZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"two-title"},_vm._l((_vm.titleData2),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('ul',{staticClass:"order_content"},_vm._l((_vm.arrData),function(item,index){return _c('li',{key:index,on:{"click":function($event){_vm.linkDeatil(item)}}},[_c('span',{staticClass:"targetId"},[_vm._v(_vm._s(_vm.getTarget(item)))]),_vm._v(" "),_c('span',{class:{'latestPrice-up':item.latestPrice>item.lastSettlementPrice,'latestPrice-down':item.latestPrice<item.lastSettlementPrice}},[_vm._v(_vm._s(item.latestPrice))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.volume))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"li-three-span",class:{'background-grey':item.latestPrice==item.lastSettlementPrice,'background-red':item.latestPrice>item.lastSettlementPrice,'background-green':item.latestPrice<item.lastSettlementPrice},on:{"click":_vm.changeShowData}},[_vm._v(" "+_vm._s(_vm.percent?item.rangeRate: item.range))])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W2nU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("muBx"))(15);

/***/ }),

/***/ "Wbkn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('ul',_vm._l((_vm.menuData),function(item,index){return _c('li',{directives:[{name:"tap",rawName:"v-tap"}],key:index,class:{liActive:_vm.isActive==index},on:{"tap":function($event){_vm.link(index)}}},[_c('i',{staticClass:"icon iconfont",domProps:{"innerHTML":_vm._s(item.tobarIcon)}}),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.tobarContent))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WhMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_TradeKeyboard_ts__ = __webpack_require__("FbIn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b6d2f06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TradeKeyboard_vue__ = __webpack_require__("RftC");
function injectStyle (ssrContext) {
  __webpack_require__("3ZfC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b6d2f06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_TradeKeyboard_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b6d2f06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TradeKeyboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WvhM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

////////////////////////////////////////////////////////////////////////////////
// 命名空间："me"通用函数封装

var me = {};
var he = {};
/* harmony default export */ __webpack_exports__["a"] = (me);

//##############################################################################
//##############################################################################
// [基础数据]

// 元数据时间戳值
me.meta = {};
me.meta.stamp_insert = 0;
me.meta.stamp_update = 1;
me.meta.stamp_remove = 2;
me.meta.stamp_clean = 3;

// Topic元素类型
me.content_head = 1;
me.content_last = 2;
me.content_snap = 4;
me.content_new = 8;

////////////////////////////////////////////////////////////////////////////////
// 字节操作：用于网络二进制传输
// 将数字转换为字节数组
me.setBytes = function (buffer, pos, type, value) {
    // 涉及网路字节序（BIG-ENDIAN），使用DataView默认BIG-ENDIAN。
    var view = new DataView(buffer);
    if (type == 1) {
        view.setUint8(pos, value);
    } else if (type == 2) {
        view.setUint16(pos, value);
    } else if (type == 4) {
        view.setUint32(pos, value);
    } else if (type == 8) {
        view.setFloat64(pos, value);
    }
    return pos + type;
};

////////////////////////////////////////////////////////////////////////////////
// 拷贝字节数组
me.copyBytes = function (dest, pos, sour) {
    var dest_v = new Uint8Array(dest, pos);
    for (var i = 0; i < sour.byteLength; ++i) {
        dest_v[i] = sour[i];
    }
    return pos + sour.byteLength;
};

////////////////////////////////////////////////////////////////////////////////
// ProtoBuf对象字段是否存在
me.hasField = function (proto_field) {
    return proto_field !== undefined && proto_field.length > 0;
};

//##############################################################################
// [数值操作：常用数值函数封装]

// 位操作符：是否包含。
me.hasValue = function (data, flag) {
    return (data & flag) > 0;
};

////////////////////////////////////////////////////////////////////////////////
// 生成[min-max]之间的随机数
me.random = function (min, max) {
    var range = max - min;
    var value = min + Math.round(Math.random() * range);
    return value;
};

////////////////////////////////////////////////////////////////////////////////
// 取小数位数
me.digit = function (v) {
    if (v == 0.0) return 0;

    // 特殊场景：A50的最小变动数2.5
    var x = v - parseInt(v);
    if (x > 0.0) v = x;

    var bit = 0;
    for (; v < 1.0; v *= 10, ++bit) {}
    return bit;
};

////////////////////////////////////////////////////////////////////////////////
// 判断字符串是否是小数
me.isNumeric = function (strVal, precision) {
    if (strVal.length == 0) return false; // 空字符串

    var dotCount = 0;
    var numPrecision = 0;
    for (var i = 0; i < strVal.length; ++i) {
        if (strVal[i] <= '9' && strVal[i] >= '0') {
            // 数字字符
            if (dotCount > 0) ++numPrecision;
        } else if (strVal[i] == '-' && i == 0) {
            // 负数-1
            continue;
        } else if (strVal[i] == '.' && i != 0) {
            // 小数
            if (++dotCount > 1) return false;
        } else {
            return false;
        } // 非数字字符
    }
    return precision === undefined || precision == numPrecision;
};

//##############################################################################
//##############################################################################
// [面向对象操作：对ES5语言的补充与封装]
// 绑定(this)上下文环境，形成闭包函数。
me.bind = function (context, fn) {
    return function () {
        return fn.apply(context, arguments);
    };
};

// 根据父类原型链得到子类的原型链，用于extend。
me.getExtend = function (supPrototype) {
    function F() {};
    F.prototype = supPrototype;
    return new F();
};

// ES5的继承类的函数
me.extend = function (subType, supType) {
    var prototype = me.getExtend(supType.prototype);
    prototype.constructor = subType;
    subType.prototype = prototype;
};

////////////////////////////////////////////////////////////////////////////////
// [对象与数据结构操作：快速访问与操作容器]
// 检查对象是否为空
me.empty = function (obj) {
    for (var key in obj) {
        return false;
    };
    return true;
};

// 统计对象属性个数
me.propertySize = function (obj) {
    var size = 0;
    for (var key in obj) {
        ++size;
    }
    return size;
};

// 获取数组中指定属性的值。
me.find = function (array, value, property) {
    for (var index = 0; index < array.length; ++index) {
        var data = array[index];
        if (property === undefined) {
            if (data == value) return { index: index, data: data };
        } else {
            if (data[property] == value) return { index: index, data: data };
        }
    }
};

// 清空对象/数组
me.clear = function (obj) {
    if (obj instanceof Array) {
        obj.splice(0, obj.length);
    } else if (obj instanceof Object) {
        for (var key in obj) {
            delete obj[key];
        }
    }
};

////////////////////////////////////////////////////////////////////////////////
// 删除数组/对象中的元素
me.erase = function (obj, id, prop) {
    if (obj instanceof Array) {
        he.erase_array(obj, id, prop);
    } else if (obj instanceof Object) {
        he.erase_object(obj, id);
    }
};

// 删除数组元素
he.erase_array = function (obj, map, prop) {
    if (map instanceof Array) {
        for (var i = 0; i < map.length; ++i) {
            var item = me.find(obj, map[i], prop);
            if (item) {
                obj.splice(item.index, 1);
            }
        }
    } else if (map instanceof Object) {
        for (var id in map) {
            var item = me.find(obj, id, prop);
            if (item) {
                obj.splice(item.index, 1);
            }
        }
    } else {
        var item = me.find(obj, map, prop);
        if (item) {
            obj.splice(item.index, 1);
        }
    }
};

// 删除对象元素
he.erase_object = function (obj, map) {
    if (map instanceof Array) {
        for (var i = 0; i < map.length; ++i) {
            var id = map[i];
            if (obj[id] !== undefined) {
                delete obj[id];
            }
        }
    } else if (map instanceof Object) {
        for (var id in map) {
            if (obj[id] !== undefined) {
                delete obj[id];
            }
        }
    } else {
        if (obj[map] !== undefined) {
            delete obj[map];
        }
    }
};

//##############################################################################
//##############################################################################
// [测试操作：用于辅助测试]

// 打印日志
me.log = function (title, error, obj) {
    if (error) {
        console.error(title);
        if (obj !== undefined) {
            console.error(obj);
        }
    } else {
        if (false) console.log(title);
        if (obj !== undefined) {
            if (false) console.log(obj);
        }
    }
};

////////////////////////////////////////////////////////////////////////////////
// 计时器
me.Timer = function () {
    this.startt = 0;
    this.endt = 0;
};
me.Timer.prototype.start = function () {
    var date = new Date();
    this.startt = date.getTime();
};
me.Timer.prototype.timeup = function () {
    var date = new Date();
    this.endt = date.getTime();
    return this;
};
me.Timer.prototype.seconds = function () {
    return Math.round(this.milliseconds() / 1000);
};
me.Timer.prototype.milliseconds = function () {
    return this.endt - this.startt;
};

////////////////////////////////////////////////////////////////////////////////
/* [接口流量控制]
调用方法时检查时间间隔：
大于流量控制间隔：直接调用方法（不控制）。
小于流量控制间隔：则使用定时器延迟发送（时控）。
*/
// @para.interval：设置接口调用的时间控制间隔，接口调用的频率必须小于该间隔。
me.Flow = function (interval) {
    me.Timer.call(this);
    this.interval = interval;
    this.lastSend = 0;
    this.timerMap = {};
};
me.extend(me.Flow, me.Timer);

////////////////////////////////////////////////////////////////////////////////
// @para.interval：设置当前接口的调用间隔，若不设置则使用构造函数中指定间隔。
// @para.discard：如果超出间隔时间，当前接口是否可丢弃不执行。
me.Flow.prototype.run = function (func, taskName, discard, interval) {
    var that = this;
    var date = new Date();
    var current = date.getTime();
    if (interval === undefined) {
        interval = that.interval;
    }
    if (interval < 0) {
        interval = 0;
    }
    var timeout = that.lastSend + interval - current;
    //me.log("Flow timeout: " + timeout);
    if (timeout <= 0) {
        func();
        that.lastSend = current;
    } else if (!discard) {
        // 不能丢弃的接口，加入定时器。
        // 如果当前任务未重复，则加入任务定时器（作为任务重复依据）中。
        var timer = that.timerMap[taskName];
        if (!timer) {
            timer = setTimeout(function () {
                that.timerMap[taskName] = null;
                func();
            }, timeout);
            that.lastSend = current + timeout;
            that.timerMap[taskName] = timer;
        }
    } else {
        //me.logt("Flow discard.");
    }
};

/***/ }),

/***/ "Wwpx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-wrapper",on:{"touchstart":_vm.handleChange}},[_c('span',{staticClass:"price-charact",style:(_vm.current.cls)},[_vm._v(_vm._s(_vm.current.text)+"\n  ")]),_vm._v(" "),_c('i',{staticClass:"icon condition-iconfont price-triangel"},[_vm._v("")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xi9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_Details_ts__ = __webpack_require__("iLQf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d2042a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__("kjWq");
function injectStyle (ssrContext) {
  __webpack_require__("7S4n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d2042a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_Details_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d2042a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xo8I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorEnum; });
/* unused harmony export CreditReqStateEnum */
/* unused harmony export PaymentChannelTypeEnum */
/* unused harmony export ProfitStateEnum */
/* unused harmony export RegAuditStateEnum */
/* unused harmony export RemindTypeEnum */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ServiceChargeTypeEnum; });
/* unused harmony export SignalrSubEnum */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TransferInStateEnum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TransferOutStateEnum; });
/* unused harmony export UserStateEnum */
/* unused harmony export UserTypeEnum */
/* unused harmony export PayChannelCategoryEnum */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PayTypeEnum; });
var ErrorEnum;
(function (ErrorEnum) {
    ErrorEnum[ErrorEnum["Non"] = -1] = "Non";
    ErrorEnum[ErrorEnum["Suc"] = 0] = "Suc";
    ErrorEnum[ErrorEnum["PwdErr"] = 1] = "PwdErr";
    ErrorEnum[ErrorEnum["NoFoundUser"] = 2] = "NoFoundUser";
    ErrorEnum[ErrorEnum["NoLogin"] = 3] = "NoLogin";
    ErrorEnum[ErrorEnum["NoAction"] = 4] = "NoAction";
    ErrorEnum[ErrorEnum["SystemInit"] = 5] = "SystemInit";
    ErrorEnum[ErrorEnum["DataValid"] = 6] = "DataValid";
    ErrorEnum[ErrorEnum["DataNoFound"] = 7] = "DataNoFound";
    ErrorEnum[ErrorEnum["DataError"] = 8] = "DataError";
})(ErrorEnum || (ErrorEnum = {}));
var CreditReqStateEnum;
(function (CreditReqStateEnum) {
    CreditReqStateEnum[CreditReqStateEnum["Non"] = 1] = "Non";
    CreditReqStateEnum[CreditReqStateEnum["Accept"] = 2] = "Accept";
    CreditReqStateEnum[CreditReqStateEnum["Reject"] = 3] = "Reject";
})(CreditReqStateEnum || (CreditReqStateEnum = {}));
var PaymentChannelTypeEnum;
(function (PaymentChannelTypeEnum) {
    PaymentChannelTypeEnum[PaymentChannelTypeEnum["Bank"] = 1] = "Bank";
    PaymentChannelTypeEnum[PaymentChannelTypeEnum["Qrcode"] = 2] = "Qrcode";
})(PaymentChannelTypeEnum || (PaymentChannelTypeEnum = {}));
var ProfitStateEnum;
(function (ProfitStateEnum) {
    ProfitStateEnum[ProfitStateEnum["Non"] = 1] = "Non";
    ProfitStateEnum[ProfitStateEnum["DistributeByParent"] = 2] = "DistributeByParent";
    ProfitStateEnum[ProfitStateEnum["Complete"] = 3] = "Complete";
})(ProfitStateEnum || (ProfitStateEnum = {}));
var RegAuditStateEnum;
(function (RegAuditStateEnum) {
    RegAuditStateEnum[RegAuditStateEnum["Non"] = 1] = "Non";
    RegAuditStateEnum[RegAuditStateEnum["Accept"] = 2] = "Accept";
    RegAuditStateEnum[RegAuditStateEnum["Reject"] = 3] = "Reject";
    RegAuditStateEnum[RegAuditStateEnum["Cancel"] = 4] = "Cancel";
})(RegAuditStateEnum || (RegAuditStateEnum = {}));
var RemindTypeEnum;
(function (RemindTypeEnum) {
    RemindTypeEnum[RemindTypeEnum["Remind"] = 1000] = "Remind";
    RemindTypeEnum[RemindTypeEnum["TransferInRemind"] = 1001] = "TransferInRemind";
    RemindTypeEnum[RemindTypeEnum["TransferOutRemind"] = 1002] = "TransferOutRemind";
    RemindTypeEnum[RemindTypeEnum["CreditReqRemind"] = 1003] = "CreditReqRemind";
    RemindTypeEnum[RemindTypeEnum["RegRemindReject"] = 1004] = "RegRemindReject";
    RemindTypeEnum[RemindTypeEnum["RegRemindAccept"] = 1005] = "RegRemindAccept";
    RemindTypeEnum[RemindTypeEnum["Audit"] = 2000] = "Audit";
    RemindTypeEnum[RemindTypeEnum["TransferInAudit"] = 2001] = "TransferInAudit";
    RemindTypeEnum[RemindTypeEnum["TransferOutAudit"] = 2002] = "TransferOutAudit";
    RemindTypeEnum[RemindTypeEnum["CreditReqAudit"] = 2003] = "CreditReqAudit";
    RemindTypeEnum[RemindTypeEnum["RegAudit"] = 2004] = "RegAudit";
})(RemindTypeEnum || (RemindTypeEnum = {}));
var ServiceChargeTypeEnum;
(function (ServiceChargeTypeEnum) {
    ServiceChargeTypeEnum[ServiceChargeTypeEnum["Fixed"] = 0] = "Fixed";
    ServiceChargeTypeEnum[ServiceChargeTypeEnum["Rate"] = 1] = "Rate";
})(ServiceChargeTypeEnum || (ServiceChargeTypeEnum = {}));
var SignalrSubEnum;
(function (SignalrSubEnum) {
    SignalrSubEnum[SignalrSubEnum["Remind"] = 100] = "Remind";
    SignalrSubEnum[SignalrSubEnum["PaySuc"] = 101] = "PaySuc";
    SignalrSubEnum[SignalrSubEnum["PaySucButAccountError"] = 102] = "PaySucButAccountError";
})(SignalrSubEnum || (SignalrSubEnum = {}));
var TransferInStateEnum;
(function (TransferInStateEnum) {
    TransferInStateEnum[TransferInStateEnum["Non"] = 1] = "Non";
    TransferInStateEnum[TransferInStateEnum["Accept"] = 2] = "Accept";
    TransferInStateEnum[TransferInStateEnum["Reject"] = 3] = "Reject";
    TransferInStateEnum[TransferInStateEnum["Paying"] = 4] = "Paying";
    TransferInStateEnum[TransferInStateEnum["PaySuc"] = 5] = "PaySuc";
    TransferInStateEnum[TransferInStateEnum["PayCancel"] = 6] = "PayCancel";
    TransferInStateEnum[TransferInStateEnum["PaySucButAccountError"] = 7] = "PaySucButAccountError";
})(TransferInStateEnum || (TransferInStateEnum = {}));
var TransferOutStateEnum;
(function (TransferOutStateEnum) {
    TransferOutStateEnum[TransferOutStateEnum["Non"] = 1] = "Non";
    TransferOutStateEnum[TransferOutStateEnum["Accept"] = 2] = "Accept";
    TransferOutStateEnum[TransferOutStateEnum["Reject"] = 3] = "Reject";
})(TransferOutStateEnum || (TransferOutStateEnum = {}));
var UserStateEnum;
(function (UserStateEnum) {
    UserStateEnum[UserStateEnum["Enable"] = 1] = "Enable";
    UserStateEnum[UserStateEnum["Disable"] = 2] = "Disable";
    UserStateEnum[UserStateEnum["Audit"] = 3] = "Audit";
    UserStateEnum[UserStateEnum["AuditReject"] = 4] = "AuditReject";
    UserStateEnum[UserStateEnum["AuditNon"] = 5] = "AuditNon";
})(UserStateEnum || (UserStateEnum = {}));
var UserTypeEnum;
(function (UserTypeEnum) {
    UserTypeEnum[UserTypeEnum["Customer"] = 1] = "Customer";
    UserTypeEnum[UserTypeEnum["Broker"] = 2] = "Broker";
    UserTypeEnum[UserTypeEnum["SuperAdmin"] = 3] = "SuperAdmin";
    UserTypeEnum[UserTypeEnum["Admin"] = 4] = "Admin";
    UserTypeEnum[UserTypeEnum["AuditAdmin"] = 5] = "AuditAdmin";
})(UserTypeEnum || (UserTypeEnum = {}));
var PayChannelCategoryEnum;
(function (PayChannelCategoryEnum) {
    PayChannelCategoryEnum[PayChannelCategoryEnum["Platform"] = 1] = "Platform";
    PayChannelCategoryEnum[PayChannelCategoryEnum["Bank"] = 2] = "Bank";
})(PayChannelCategoryEnum || (PayChannelCategoryEnum = {}));
var PayTypeEnum;
(function (PayTypeEnum) {
    PayTypeEnum[PayTypeEnum["Qr"] = 1] = "Qr";
    PayTypeEnum[PayTypeEnum["OpenUrl"] = 2] = "OpenUrl";
    PayTypeEnum[PayTypeEnum["AliCall"] = 3] = "AliCall";
    PayTypeEnum[PayTypeEnum["WeixinPublic"] = 4] = "WeixinPublic";
})(PayTypeEnum || (PayTypeEnum = {}));

/***/ }),

/***/ "Xq6T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_Recharge_ts__ = __webpack_require__("Hnga");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc68ceac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recharge_vue__ = __webpack_require__("A96H");
function injectStyle (ssrContext) {
  __webpack_require__("2aQn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc68ceac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_Recharge_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc68ceac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YMbQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_yjheader__ = __webpack_require__("eR8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_proto_art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_Model_js__ = __webpack_require__("O0G5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_SubUtils__ = __webpack_require__("FcK3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "trade",
  components: {
    yjheader: __WEBPACK_IMPORTED_MODULE_0__components_common_yjheader__["a" /* default */]
  },
  data: function data() {
    return {
      userName: '',
      pageData: {
        account: { title: "账号", value: localStorage.accountNum },
        rights: {
          title: "权益",
          value: "0.00"
        },
        usable: {
          title: "可用",
          value: "0.00"
        },
        profitAloss: {
          title: "盈亏",
          value: "-0.00"
        },
        desirable: {
          title: "可取",
          value: "0.00"
        }
      },
      menuData: [{
        tobarLink: "/home/order",
        tobarIcon: "&#xe624;",
        tobarContent: "下单"
      }, {
        tobarLink: "/home/store",
        tobarIcon: "&#xe7b9;",
        tobarContent: "持仓"
      }, {
        tobarLink: "/home/cancel",
        tobarIcon: "&#xe609;",
        tobarContent: "撤单"
      }, {
        tobarLink: "/home/capital",
        tobarIcon: "&#xe60a;",
        tobarContent: "资金"
      }, {
        tobarLink: "/home/query",
        tobarIcon: "&#xe603;",
        tobarContent: "查询"
      }],
      isActive: 12
    };
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  activated: function activated() {
    this.userName = localStorage.userName;
    __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront_js__["a" /* default */].autoMount(__WEBPACK_IMPORTED_MODULE_1__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.load));
    this.$store.commit("selectIndex", 2);
  },
  deactivated: function deactivated() {
    __WEBPACK_IMPORTED_MODULE_2__static_js_proto_Model_js__["a" /* default */].trader.queryCapital.stop();
  },


  methods: {
    load: function load(onFail) {
      __WEBPACK_IMPORTED_MODULE_2__static_js_proto_Model_js__["a" /* default */].capital.attach("trade", __WEBPACK_IMPORTED_MODULE_1__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.onUpdateCapital));
      __WEBPACK_IMPORTED_MODULE_2__static_js_proto_Model_js__["a" /* default */].trader.queryCapital.start();
      // 自动重连后切回交易页面
      if (onFail instanceof Function) {
        this.$router.push({ path: "/home/trade" });
      }
    },
    onUpdateCapital: function onUpdateCapital(capital) {
      if (capital === undefined) {
        this.pageData.rights.value = 0.0;
        this.pageData.usable.value = 0.0;
        this.pageData.profitAloss.value = 0.0;
        this.pageData.desirable.value = 0.0;
        this.pageData.account.value = 0.0;
        return;
      }
      this.pageData.rights.value = capital["balance"].toFixed(2);
      this.pageData.usable.value = capital["available"].toFixed(2);
      this.pageData.profitAloss.value = (Number(capital["positionProfit"]) + Number(capital["closeProfit"])).toFixed(2);
      this.pageData.desirable.value = capital["withdrawQuota"].toFixed(2);
      this.pageData.account.value = capital["account"];
    },
    go_login: function go_login() {
      __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront_js__["a" /* default */].close();
      __WEBPACK_IMPORTED_MODULE_4__store_SubUtils__["a" /* clearAll */]();
      footerIndex = 0;
      this.$router.push({ path: "/" });
      this.$store.commit("selectLoad"); // 清空自选合约
    },
    link: function link(index) {
      this.isActive = index;
      this.$router.push({ path: "/tradeDetail/" + index });
    },
    goSet: function goSet() {
      this.$router.push('/setPage');
    }
  }
});

/***/ }),

/***/ "YSrX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YZGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_vue__ = __webpack_require__("vE1z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f7bac16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_vue__ = __webpack_require__("pj7B");
function injectStyle (ssrContext) {
  __webpack_require__("lAzR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f7bac16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f7bac16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_yj_login__ = __webpack_require__("y59h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_yj_home__ = __webpack_require__("FBY2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_yj_trade__ = __webpack_require__("YsUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_yj_market__ = __webpack_require__("YZGk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_TradeDetail_TradeDetail__ = __webpack_require__("9AAL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_condition_condition_vue__ = __webpack_require__("LkVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Person_Person__ = __webpack_require__("Bfqg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Person_Recharge_Recharge__ = __webpack_require__("Xq6T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Person_DrawMoney_DrawMoney__ = __webpack_require__("ntvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Person_DrawMoney_BankCar_BankCar__ = __webpack_require__("VnN9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Person_RechargeRecord_RechargeRecord__ = __webpack_require__("PeJA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Person_DrawMoneyRecord_DrawMoneyRecord__ = __webpack_require__("mB49");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Person_DrawMoneyRecord_Details_Details__ = __webpack_require__("Xi9B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_kLine__ = __webpack_require__("baG1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_yj_marketDetail__ = __webpack_require__("/5SE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_yj_userProtocol__ = __webpack_require__("bp3a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_yj_targetSelected__ = __webpack_require__("6Cg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_yj_setPage__ = __webpack_require__("SjAb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_os__ = __webpack_require__("gAs1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_os___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_os__);














// import record from '@/views/Person/Record/Record';












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

function yourCallbackFunction() {

  // window.close();
  var url = window.location.href;
  // alert(url);
  if (url == "file:///android_asset/www/index.html#/") {
    __WEBPACK_IMPORTED_MODULE_20_mint_ui__["MessageBox"].confirm('确认退出应用?').then(function (action) {
      if (action == 'confirm') {

        navigator.app.exitApp();
      }
    });
  } else {
    window.history.back();
  }
};
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({

  routes: [{
    path: '/',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_yj_login__["a" /* default */]
    // redirect: '/home/trade'
  }, {
    path: '/test',
    name: 'test',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "ETsz"));
    }
    // redirect: '/home/trade'
  },
  // {
  //   path: '/test1',
  //   name: 'test1',
  //   component: ()=>import('@/components/test/condition_test.vue'),
  //   // redirect: '/home/trade'
  // },
  {
    path: '/home',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_yj_home__["a" /* default */],
    // redirect: '/home/trade',
    children: [{
      path: 'trade',
      name: 'trade',
      component: __WEBPACK_IMPORTED_MODULE_4__components_yj_trade__["a" /* default */]
    }, {
      path: 'market',
      name: 'market',
      component: __WEBPACK_IMPORTED_MODULE_5__components_yj_market__["a" /* default */]
    }, {
      path: 'select',
      name: 'select',
      component: __WEBPACK_IMPORTED_MODULE_18__components_yj_targetSelected__["a" /* default */]
    }, {
      path: 'condition',
      name: 'condition',
      component: __WEBPACK_IMPORTED_MODULE_7__views_condition_condition_vue__["a" /* default */]
    }, {
      path: 'person',
      name: 'person',
      component: __WEBPACK_IMPORTED_MODULE_8__views_Person_Person__["a" /* default */]
    }]
  }, {
    path: '/tradeDetail/:tableId',
    name: 'tradeDetail',
    component: __WEBPACK_IMPORTED_MODULE_6__views_TradeDetail_TradeDetail__["a" /* default */]
  }, {
    path: '/recharge',
    name: 'recharge',
    component: __WEBPACK_IMPORTED_MODULE_9__views_Person_Recharge_Recharge__["a" /* default */]
  }, {
    path: '/drawmoney/:availablemoney?',
    name: 'drawmoney',
    component: __WEBPACK_IMPORTED_MODULE_10__views_Person_DrawMoney_DrawMoney__["a" /* default */]
  }, {
    path: '/bankCar',
    name: 'bankCar',
    component: __WEBPACK_IMPORTED_MODULE_11__views_Person_DrawMoney_BankCar_BankCar__["a" /* default */]
  }, {
    path: '/rechargerecord',
    name: 'rechargerecord',
    component: __WEBPACK_IMPORTED_MODULE_12__views_Person_RechargeRecord_RechargeRecord__["a" /* default */]
  }, {
    path: '/drawmoneyrecord',
    name: 'drawmoneyrecord',
    component: __WEBPACK_IMPORTED_MODULE_13__views_Person_DrawMoneyRecord_DrawMoneyRecord__["a" /* default */]
  }, {
    path: '/details',
    name: 'details',
    component: __WEBPACK_IMPORTED_MODULE_14__views_Person_DrawMoneyRecord_Details_Details__["a" /* default */]
  }, {
    path: '/ChangeWord',
    name: 'ChangeWord',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "+CLo"));
    }
  }, {
    path: '/kLine',
    name: 'kLine',
    component: __WEBPACK_IMPORTED_MODULE_15__components_common_kLine__["a" /* default */]
  }, {
    path: '/marketDetail/:contract',
    name: 'marketDetail',
    component: __WEBPACK_IMPORTED_MODULE_16__components_yj_marketDetail__["a" /* default */]
  }, {
    path: '/userProtocol',
    name: 'userProtocol',
    component: __WEBPACK_IMPORTED_MODULE_17__components_yj_userProtocol__["a" /* default */]
  }, {
    path: '/setPage',
    name: 'setPage',
    component: __WEBPACK_IMPORTED_MODULE_19__components_yj_setPage__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_21_os__["platform"].name == "android") {
    document.addEventListener("backbutton", yourCallbackFunction, false);
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yblz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ynm1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_yjheader__ = __webpack_require__("eR8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_proto_art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import kLine from "@/components/common/kLine";
// import * as echarts from "echarts";


var echarts = __webpack_require__("SEXj");
echarts = echarts.echarts;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "market-detail",
  components: {
    yjheader: __WEBPACK_IMPORTED_MODULE_3__components_common_yjheader__["a" /* default */]
    // kLine
  },
  data: function data() {
    return {
      //切换RSI.MACD.KDJ
      targetflage: true,
      targetType: "bar",
      targetColor: function targetColor(params) {
        var colorList;
        if (params.data >= 0) {
          colorList = "#B61332";
        } else {
          colorList = "#54FFFF";
        }
        return colorList;
      },
      targetMR: "MACD",
      targetDR: "DIF",
      targetER: "DEA",
      targetSR: "STICK",
      targetData: "(12,26,9)",
      normLine: 0,
      // loading
      showLoading: false,
      // K线上控制滑动变数据,或推送变数据
      dataflage: false,
      //K图
      twoFingers: true,
      categoryData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40],
      values: "",
      volumes: [],
      macds: "",
      difs: "",
      deas: "",
      Loop: "",
      num1: "0.00",
      num2: "0.00",
      num3: "0.00",
      num4: "0.00",
      num5: "0.00",
      num6: "0.00",
      handIcap: true,
      save_num1: 0,
      save_num2: 0,
      minute: "1m",
      week: "周",
      dLink: "MACD",
      seleIcon_m: "&#xe718;",
      seleIcon_z: "&#xe718;",
      seleIcon_D: "&#xe718;",
      appear_share: false,
      appear_shareMACD: false,
      share: [],
      shareMACD: ["MACD", "RSI", "KDJ"],
      MACD_index: 0,
      MacdFlage: false,
      c_index: "-1",
      select_k: 1,
      numMACD: "0.00",
      numDIF: "0.00",
      numDEA: "0.00",
      startValues: 0,
      de_flage: false,
      kType: "",
      typeNum: 0,
      toolArrs: [],
      forty: "",
      fortyX: null,
      fortyEnd: null,
      fortyendValue: null,
      //分时图
      ma_flage: true,
      valueAxis: 0,
      control: true,
      dataLoad: false,
      // allArr: [],
      tooltipArr: [],
      xdata: [],
      optionSer1: [],
      optionSer2: [],
      averagePrice: [],
      flage_s: true,
      xLabel: "",
      compare: "",
      Ymin: 0,
      Ymax: 0,
      Yinterval: 0,
      downLowpro: "",
      downColse: "",
      downHight: "",
      errorMessage: "",
      //数据颜色变化
      //>最高价,最低价
      c_red: false,
      c_green: false,
      c_grey: false,
      h_color: false,
      l_color: false,
      hColor: false,
      lColor: false,
      //>开盘价
      open_color: false,
      open_color2: false,
      //>申买价,申卖价
      br_color: false,
      bg_color: false,
      sr_color: false,
      sg_color: false,
      //>涨停价,跌停价
      stop_colorg: false,
      stop_colorr: false,
      down_colorg: false,
      down_colorr: false,
      timeImfor: {
        yesterday: {
          tit: "昨收盘",
          pro: "0.00"
        },
        range: {
          tit: "振 幅",
          pro: "0.00"
        },
        position: {
          tit: "",
          pro: ""
        }
      },
      timeImfor_bottom: {
        sellPro: {
          tit: "卖一",
          pro: "0.00",
          buy: 0
        },
        hightPro: {
          tit: "最高",
          pro: "0.00"
        },
        limitStop: {
          tit: "涨停",
          pro: "0.00"
        },
        buyPro: {
          tit: "买一",
          pro: "0.00",
          buy: 0
        },
        lowPro: {
          tit: "最低",
          pro: "0.00"
        },
        limitDown: {
          tit: "跌停",
          pro: "0.00"
        }
      },
      timeImforFlag: true,
      flage: false,
      open: "0.00",
      turnover: "0",
      close: "0.00",
      number: 0,
      newPrice: "0.00",
      ranges: 0,
      limit: "0.00",
      oldPrice: 0,
      title: this.$route.params.contract,
      nowIcon: "&#xe719;",
      nowType: 1,
      rowData: [],
      selfContract2: "",

      // 懒加载
      lazyLoad: false,
      showLazyLoad: false,
      nonData: false,
      lazyType: "",
      lazyMinute: "",
      startTime: "",
      endPercent: "",
      // oldNum: '',
      // 保留小数点处理
      decimals: 0
    };
  },

  computed: {
    targetSelected: function targetSelected() {
      return this.$store.state.targetSelected;
    },
    data: function data() {
      // console.log(this.rowData)
      return this.rowData.map(function (item) {
        return [+item[1], +item[2], +item[5], +item[6]];
      });
    },
    option1: function option1() {
      var _this = this;

      return {
        backgroundColor: "#1B1C2E",
        title: {
          text: this.errorMessage,
          top: "30%",
          left: "30%"
        },
        xAxis: [{
          data: this.xdata,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              fontSize: 9
            },
            color: "#ccc",
            formatter: this.xLabel
          },
          axisPointer: {
            label: {
              show: false
            }
          }
        },
        //柱
        {
          data: this.xdata,
          gridIndex: 1,
          axisLabel: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisPointer: {
            label: {
              show: false
            }
          }
        },
        //折线
        // {
        //   data: [],
        //   show: false,
        //   gridIndex: 1,
        //   axisLabel: { show: false },
        //   axisTick: { show: false },
        //   splitLine: { show: false },
        //   axisPointer: {
        //     label: {
        //       show: false
        //     }
        //   }
        // },
        // 均线
        {
          data: this.xdata,
          gridIndex: 1,
          axisLabel: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisPointer: {
            label: {
              show: false
            }
          }
        }],
        yAxis: [{
          type: "value",
          scale: true,
          // splitNumber: 3,
          interval: this.Yinterval,
          min: this.Ymin,
          max: this.Ymax,
          // interval:8,
          // min: 3726,
          // max:3750,
          splitArea: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#555",
              type: "dashed",
              opacity: 0.8
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisPointer: {
            label: {
              show: false
            }
          },
          axisLabel: {
            inside: true,
            padding: [0, 0, 15, -5],
            fontSize: 10,
            color: "#999",
            formatter: function formatter(val) {
              var num = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].getTargetPrecision(_this.title);
              return val.toFixed(num);
            },
            textStyle: {
              color: function color(val) {
                if (Number(val).toFixed(2) > _this.downColse) {
                  return "red";
                } else if (Number(val).toFixed(2) == _this.downColse) {
                  return "#888";
                } else if (Number(val).toFixed(2) < _this.downColse) {
                  return "green";
                }
              }
            }
          }
        },
        //柱
        {
          type: "value",
          splitNumber: 2,
          scale: true,
          splitArea: {
            show: false
          },
          gridIndex: 1,
          axisLabel: {
            inside: true,
            padding: [0, 0, 15, -5],
            fontSize: 10,
            color: "#aaa",
            textStyle: {
              color: "#888"
            }
          },
          axisLine: { show: true },
          axisTick: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#555",
              type: "dashed",
              opacity: 0.8
            }
          }
        },
        //折线
        // {
        //   type: "value",
        //   show: false,
        //   scale: true,
        //   splitArea: {
        //     show: false
        //   },
        //   gridIndex: 1,
        //   axisLabel: { show: false },
        //   axisLine: { show: true },
        //   axisTick: { show: false },
        //   splitLine: { show: false }
        // },
        // 均线
        {
          type: "value",
          show: false,
          scale: true,
          splitArea: {
            show: false
          },
          gridIndex: 0,
          axisLabel: { show: false },
          axisLine: { show: true },
          axisTick: { show: false },
          splitLine: { show: false }
        }],
        //两个图的位置
        grid: [{
          top: "10%",
          height: "50%",
          width: "100%",
          x: 0,
          x2: 0,
          borderWidth: 1
        },
        //柱
        {
          top: "75%",
          height: "18%",
          width: "100%",
          x: 0,
          x2: 0
        },
        //折线
        {
          top: "10%",
          height: "50%",
          width: "100%",
          x: 0,
          x2: 0,
          borderWidth: 1
        }],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          },
          formatter: function formatter(val) {
            // console.log(val)
            // var val = val[0];
            for (var i = 0; i < _this.tooltipArr.length; i++) {
              if (val[0].data[0] == _this.tooltipArr[i].num) {
                return _this.tooltipArr[i].time + "<br/> " + val[0].data[1] + "<br/>均价: " + val[1].data[1];
              }
            }
          }
        },
        axisPointer: {
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777"
          }
        },
        series: [{
          animation: false,
          data: this.optionSer1,
          type: "line",
          symbol: "none",
          itemStyle: {
            normal: {
              lineStyle: {
                color: "#fff",
                width: 1
              }
            }
          }
        },
        //柱
        {
          animation: false,
          name: "Volume",
          type: "bar",
          xAxisIndex: 1,
          yAxisIndex: 1,
          data: this.optionSer2,
          barWidth: 0.3
        },
        //折线
        // {
        //   name: "Line",
        //   type: "line",
        //   xAxisIndex: 1,
        //   yAxisIndex: 1,
        //   data: [],
        //   lineStyle: {
        //     width: 1
        //   },
        //   symbol: "none"
        // },
        // 均线
        {
          animation: false,
          name: "Line",
          type: "line",
          xAxisIndex: 0,
          yAxisIndex: 0,
          // data: [[20,4000],[30,4050],[100,4000]],
          data: this.averagePrice,
          lineStyle: {
            color: "#DCDC0A",
            width: 1
          },
          symbol: "none"
        }]
      };
    },
    option3: function option3() {
      var _this2 = this,
          _ref;

      return {
        backgroundColor: "#1B1C2E",
        animation: false,
        animationDuration: 0,
        animationDelay: 0,
        animationDurationUpdate: 0,
        animationDelayUpdate: 0,
        title: {
          text: this.errorMessage,
          top: "30%",
          left: "30%"
        },
        legend: [{
          animation: false,
          top: 0,
          left: "left",
          itemWidth: 0,
          formatter: function formatter(name) {
            if (name == "MA5") {
              return name + ":" + Number(_this2.num1).toFixed(1);
            } else if (name == "MA10") {
              return name + ":" + Number(_this2.num2).toFixed(1);
            } else if (name == "MA20") {
              return name + ":" + Number(_this2.num3).toFixed(1);
            } else if (name == "MA60") {
              return name + ":" + Number(_this2.num4).toFixed(1);
            }
          },
          data: [{
            name: "MA5",
            icon: "none",
            textStyle: {
              color: "#fff"
            }
          }, {
            name: "MA10",
            icon: "none",
            textStyle: {
              color: "#2B65EA"
            }
          }, {
            name: "MA20",
            icon: "none",
            textStyle: {
              color: "#42A668"
            }
          }, {
            name: "MA60",
            icon: "none",
            textStyle: {
              color: "#A13BCB"
            }
          }]
        }, {
          // 显示Volume
          formatter: function formatter(name) {
            if (name == "Volume") {
              // return name + ":" + this.num5;
              // 柱状折线
              // } else if (name == "Line") {
              //   return name + ":" + this.num6;
            }
          },
          animation: false,
          left: "left",
          itemWidth: 0,
          top: "54%",
          data: [{
            name: "Volume",
            icon: "none",
            textStyle: {
              color: "#ddd"
            }
          }, {
            name: "Line",
            icon: "none",
            textStyle: {
              color: "green"
            }
          }]
        }, (_ref = {
          formatter: function formatter(name) {
            if (name == _this2.targetMR) {
              return name + ":" + _this2.targetData;
            } else if (name == _this2.targetDR) {
              return name + ":" + Number(_this2.numDIF).toFixed(2);
            } else if (name == _this2.targetER) {
              return name + ":" + Number(_this2.numDEA).toFixed(2);
            } else if (name == _this2.targetSR) {
              // return name + ":" + this.numSTICK;
              return name + ":" + Number(_this2.numMACD).toFixed(2);
            }
          },
          left: "left",
          itemWidth: 0,
          top: "78%"
        }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "left", "3%"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "data", [{
          name: this.targetMR,
          icon: "none",
          textStyle: {
            color: "#9a9a9a"
          }
        }, {
          name: this.targetDR,
          icon: "none",
          textStyle: {
            color: "#fff"
          }
        }, {
          name: this.targetER,
          icon: "none",
          textStyle: {
            color: "yellow"
          }
        }, {
          name: this.targetSR,
          icon: "none",
          textStyle: {
            color: "#FF00FF"
          }
        }]), _ref)],
        axisPointer: {
          type: "line",
          show: true,
          link: { xAxisIndex: "all" },
          label: {
            show: true,
            backgroundColor: "#777"
          },
          lineStyle: {
            color: "transparent"
          }
        },
        tooltip: {
          // showContent: false,
          trigger: "axis",
          formatter: function formatter(param, ticket, callback) {
            // console.log(param)
            //判断手指在哪个图标上滑动
            if (_this2.de_flage) {
              if (param[0].axisIndex == 0) {
                // K线上滑动
                if (param[1].data != "-") {
                  _this2.num1 = param[1].data;
                } else {
                  _this2.num1 = "0.00";
                }
                if (param[2].data != "-") {
                  _this2.num2 = param[2].data;
                } else {
                  _this2.num2 = "0.00";
                }
                if (param[3].data != "-") {
                  _this2.num3 = param[3].data;
                } else {
                  _this2.num3 = "0.00";
                }
                if (param[4].data != "-") {
                  _this2.num4 = param[4].data;
                } else {
                  _this2.num4 = "0.00";
                }
                _this2.num5 = param[5].data[1];
                //   // 柱状折线
                // if (param[6].data[1] != "-") {
                //   this.num6 = param[6].data[1];
                // }
                _this2.numMACD = param[6].data;
                _this2.numDIF = param[7].data;
                _this2.numDEA = param[8].data;
              } else if (param[0].axisIndex == 3) {
                // 指标图上滑动
                if (param[4].data != "-") {
                  _this2.num1 = param[4].data;
                } else {
                  _this2.num1 = "0.00";
                }
                if (param[5].data != "-") {
                  _this2.num2 = param[5].data;
                } else {
                  _this2.num2 = "0.00";
                }
                if (param[6].data != "-") {
                  _this2.num3 = param[6].data;
                } else {
                  _this2.num3 = "0.00";
                }
                if (param[7].data != "-") {
                  _this2.num4 = param[7].data;
                } else {
                  _this2.num4 = "0.00";
                }
                _this2.num5 = param[8].data[1];
                //   // 柱状折线
                // if (param[6].data[1] != "-") {
                //   this.num6 = param[6].data[1];
                // }
                _this2.numMACD = param[0].data;
                _this2.numDIF = param[1].data;
                _this2.numDEA = param[2].data;
              } else if (param[0].axisIndex == 1) {
                // 柱状图上滑动
                if (param[2].data != "-") {
                  _this2.num1 = param[2].data;
                } else {
                  _this2.num1 = "0.00";
                }
                if (param[3].data != "-") {
                  _this2.num2 = param[3].data;
                } else {
                  _this2.num2 = "0.00";
                }
                if (param[4].data != "-") {
                  _this2.num3 = param[4].data;
                } else {
                  _this2.num3 = "0.00";
                }
                if (param[5].data != "-") {
                  _this2.num4 = param[5].data;
                } else {
                  _this2.num4 = "0.00";
                }
                _this2.num5 = param[0].data[1];
                // this.num6 = param[2].data[1];
                _this2.numMACD = param[6].data;
                _this2.numDIF = param[7].data;
                _this2.numDEA = param[8].data;
              }
              echarts.init(document.getElementById("main3")).setOption({});
              for (var i = 0; i < _this2.toolArrs.length; i++) {
                if (param[0].dataIndex == i) {
                  return "时间:  " + _this2.toolArrs[i].time + "<br />" + "开盘:  " + Number(_this2.toolArrs[i].priceOpen).toFixed(_this2.decimals) + "<br />" + "最高:  " + Number(_this2.toolArrs[i].priceHigh).toFixed(_this2.decimals) + "<br />" + "最低:  " + Number(_this2.toolArrs[i].priceLow).toFixed(_this2.decimals) + "<br />" + "收盘:  " + Number(_this2.toolArrs[i].priceClose).toFixed(_this2.decimals) + "<br />" + "成交量:  " + _this2.toolArrs[i].volume + "<br />" + "振幅:  " + ((_this2.toolArrs[i].priceHigh - _this2.toolArrs[i].priceLow) * 100 / _this2.close).toFixed(2) + "% <br />" + "持仓量:  " + _this2.toolArrs[i].position;
                }
              }
            }
          },
          alwaysShowContent: true,
          axisPointer: {
            // snap: true,
            type: "cross",
            label: {
              show: false
            },
            crossStyle: {
              color: "transparent"
            }
          },
          position: function position(pos, params, el, elRect, size) {
            var obj = { top: 20 };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 10;
            return obj;
          }
        },
        toolbox: {
          show: false
        },
        visualMap: {
          realtime: false,
          show: false,
          seriesIndex: 5,
          dimension: 2,
          pieces: [{
            value: 1,
            color: "#54FFFF"
          }, {
            value: -1,
            color: "#B61332"
          }]
        },
        grid: [{
          height: "40%",
          width: "98%",
          left: "1%",
          right: "1%",
          x: 0,
          x2: 0,
          borderWidth: 1
        }, {
          top: "60%",
          height: "18%",
          width: "98%",
          left: "1%",
          right: "1%",
          x: 0,
          x2: 0
        }, {
          top: "83%",
          height: "15%",
          width: "98%",
          left: "1%",
          right: "1%",
          x: 0,
          x2: 0
        }],
        xAxis: [{
          boundaryGap: false,
          type: "category",
          data: this.categoryData,
          scale: true,
          splitLine: { show: false },
          axisPointer: {
            z: 100,
            snap: false,
            label: {
              show: false
            }
          },
          axisLine: {
            onZero: false,
            lineStyle: {
              color: "#ccc",
              opacity: 0.4
            }
          },
          axisLabel: {
            interval: 999999,
            showMinLabel: true,
            showMaxLabel: true,
            formatter: this.forty,
            color: "#aaa",
            margin: 2,
            fontsize: 10
          },
          axisTick: {
            show: false
          },
          triggerEvent: true
        }, {
          type: "category",
          gridIndex: 1,
          data: this.categoryData,
          scale: true,
          axisLine: { onZero: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: { show: false },
          axisPointer: {
            snap: false,
            label: {
              show: false //X轴指示器
            }
          },
          min: "dataMin",
          max: "dataMax"
        }, {
          type: "category",
          gridIndex: 1,
          data: this.categoryData,
          axisLine: { onZero: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: { show: false },
          axisPointer: {
            snap: false
          },
          min: "dataMin",
          max: "dataMax"
        }, {
          type: "category",
          gridIndex: 2,
          data: this.categoryData,
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: { show: false },
          axisPointer: {
            label: {
              formatter: this.fortyX
            }
          }
        }],
        yAxis: [{
          scale: true,
          splitNumber: 2,
          min: "dataMin",
          // min: function(val) {
          //   return Math.floor(Number(val.min));
          // },
          max: "dataMax",
          // max: function(val) {
          // return Math.ceil(Number(val.max));
          // },
          splitArea: {
            show: false
          },
          axisPointer: {
            snap: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#333",
              type: "dashed",
              opacity: 0.8
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            inside: true,
            padding: [0, 0, 15, -5],
            fontSize: 10,
            color: "#666",
            formatter: function formatter(value, index) {
              var val = (value * 1000).toFixed(0) / 1000;
              return val;
            }
          }
        }, {
          scale: true,
          gridIndex: 1,
          splitNumber: 2,
          legendHoverLink: false,
          axisLabel: {
            inside: true,
            padding: [0, 0, 15, -5],
            fontSize: 10,
            color: "#666"
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#333",
              type: "dashed",
              opacity: 0.8
            }
          },
          axisPointer: {
            snap: false
          }
        }, {
          type: "value",
          scale: true,
          legendHoverLink: false,
          axisLabel: { show: false },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisPointer: {
            snap: false
          }
        }, {
          gridIndex: 2,
          scale: true,
          legendHoverLink: false,
          splitNumber: 2,
          min: "dataMin",
          max: "dataMax",
          splitArea: {
            show: false
          },
          axisPointer: {
            snap: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#333",
              type: "dashed",
              opacity: 0.8
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: function formatter(val, index) {
              return val.toFixed(0);
            },
            inside: true,
            padding: [0, 0, 15, -5],
            fontSize: 10,
            color: "#666"
          }
        }],
        dataZoom: [{
          type: "inside",
          filterMode: "filter",
          xAxisIndex: [0, 1, 3],
          endValue: this.fortyendValue, // 初始化显示的根数
          startValue: this.startValues,
          end: this.fortyEnd,
          throttle: 0,
          animation: false,
          // animationDurationUpdate: 0,
          maxSpan: 100, //缩放到最小时能看到的百分比
          minValueSpan: 16, // 缩放到最大时的根数, (参考广发证券)
          preventDefaultMouseMove: true,
          left: "20%"
        }, {
          show: false
        }],
        series: [{
          animation: false,
          name: "Dow-Jones index",
          type: "candlestick",
          data: this.data,
          // barMaxWidth: 20,
          legendHoverLink: false,
          hoverAnimation: false,
          showSymbol: false,
          itemStyle: {
            normal: {
              color: "#B61332",
              color0: "#54FFFF",
              color1: "#fff",
              borderColor: null,
              borderColor0: null
            }
          },
          large: true,
          largeThreshold: 1000,
          progressive: 10,
          progressiveThreshold: 1000
        }, {
          name: "MA5",
          type: "line",
          data: this.calculateMA(5, this.data),
          smooth: true,
          symbol: "none",
          hoverAnimation: false,
          legendHoverLink: false,
          animation: false,
          lineStyle: {
            normal: { opacity: 0.5, color: "#fff", width: 2 }
          }
        }, {
          name: "MA10",
          type: "line",
          symbol: "none",
          data: this.calculateMA(10, this.data),
          smooth: true,
          hoverAnimation: false,
          legendHoverLink: false,
          animation: false,
          lineStyle: {
            normal: { opacity: 0.5, color: "#2B65EA", width: 2 }
          }
        }, {
          name: "MA20",
          type: "line",
          symbol: "none",
          data: this.calculateMA(20, this.data),
          smooth: true,
          hoverAnimation: false,
          legendHoverLink: false,
          animation: false,
          lineStyle: {
            normal: { opacity: 0.5, color: "#42A668", width: 2 }
          }
        }, {
          name: "MA60",
          type: "line",
          symbol: "none",
          data: this.calculateMA(60, this.data),
          smooth: true,
          hoverAnimation: false,
          legendHoverLink: false,
          animation: false,
          lineStyle: {
            normal: { opacity: 0.5, color: "#A13BCB", width: 2 }
          }
        }, {
          name: "Volume",
          type: "bar",
          xAxisIndex: 1,
          yAxisIndex: 1,
          data: this.volumes,
          // barMaxWidth: 20,
          animation: false,
          large: true
        },
        //   // 柱状折线
        // {
        //   name: "Line",
        //   type: "line",
        //   symbol: "none",
        //   hoverAnimation: false,
        // legendHoverLink: false,
        //   animation: false,
        //   xAxisIndex: 1,
        //   yAxisIndex: 1,
        //   // data: this.volumes
        // },
        {
          name: this.targetMR,
          type: this.targetType,
          // symbol:'none',
          xAxisIndex: 3,
          yAxisIndex: 3,
          // barMaxWidth: 2,
          data: this.macds,
          itemStyle: {
            normal: {
              color: this.targetColor
            }
          }
        }, {
          name: this.targetDR,
          type: "line",
          symbol: "none",
          xAxisIndex: 3,
          yAxisIndex: 3,
          data: this.difs,
          smooth: false,
          itemStyle: {
            normal: {
              color: "#fff"
            }
          },
          lineStyle: {
            width: 1
          }
        }, {
          name: this.targetER,
          type: "line",
          symbol: "none",
          xAxisIndex: 3,
          yAxisIndex: 3,
          data: this.deas,
          smooth: false,
          itemStyle: {
            normal: {
              color: "yellow"
            }
          },
          lineStyle: {
            width: 1
          }
        }, {
          name: this.targetSR,
          type: "line",
          symbol: "none",
          xAxisIndex: 3,
          yAxisIndex: 3,
          data: [],
          smooth: true
        }]
      };
    }
  },

  beforeDestroy: function beforeDestroy() {
    echarts.init(document.getElementById("main3")).clear();
    echarts.init(document.getElementById("main1")).clear();
  },


  methods: {
    goBack: function goBack() {
      this.appear_shareMACD = false;
      this.seleIcon_D = "&#xe718;";
      this.MacdFlage = false;
      window.history.back();
    },
    order: function order() {
      this.$router.push({ path: "/tradeDetail/0" });
      localStorage.contractorNo = this.title;
    },
    // 自选合约
    select: function select(item) {
      var _this3 = this;

      // 添加自选合约
      if (this.selfContract2 == "&#xe63c;") {
        __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].selectedTargetAdd(item, function (resolve) {
          _this3.$toast("添加自选成功");
          _this3.selfContract2 = "&#xe617;";
        }, function (reject) {
          if (reject.id == __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].e_network) {
            _this3.$toast("添加自选失败，网络异常");
          } else if (reject.id == __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].e_selected_repeated) {
            _this3.$toast("添加自选重复");
          } else {
            _this3.$toast("添加自选失败");
          }
        });
        return;
      }
      // 删除自选合约
      if (this.selfContract2 == "&#xe617;") {
        __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].selectedTargetRemove(item, function (resolve) {
          _this3.selfContract2 = "&#xe63c;";
          _this3.$toast("删除自选成功");
        }, function (reject) {
          if (reject.id == __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].e_network) {
            _this3.$toast("删除自选失败，网络异常");
          } else if (reject.id == __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].e_selected_removed) {
            _this3.$toast("删除自选重复");
          } else {
            _this3.$toast("删除自选失败");
          }
        });
      }
    },

    //点击选择不同分时图
    option_k: function option_k(index) {
      this.showLazyLoad = false;
      //切换分时,K线图
      this.appear_share = index == 1 || index == 3 ? false : true;
      if (index == 1) {
        this.appear_shareMACD = false;
        this.seleIcon_D = "&#xe718;";
        this.showLoading = false;
        this.select_k = 1;
        this.cancel(this.title, this.kType, this.typeNum);
        this.nowType = 1;
        this.handIcap = true;
        echarts.init(document.getElementById("main1")).setOption(this.option1);
        this.MacdFlage = false;
      } else {
        var orderTick = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].subTick(this.title, 'trade-detail');
        this.decimals = __WEBPACK_IMPORTED_MODULE_4__static_js_proto_art_Art_js__["a" /* default */].digit(orderTick.priceTick);
        this.MacdFlage = true;
        var kreq = {
          targetId: this.title,
          ktype: __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute,
          kunit: 1
        };
        __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].unsubKbar2(kreq, "market-flash");
        // front.unsubTick(title, "market-datail");
        // this.callOf(this.title);
        if (this.nowType != 3) {
          this.nowType = 3;
          this.handIcap = false;
          this.splitData3(this.rowData);
          echarts.init(document.getElementById("main3")).setOption(this.option3);
        }
      }

      if (index == 2) {
        if (this.select_k == 2) {
          this.appear_shareMACD = false;
          this.seleIcon_D = "&#xe718;";
          this.seleIcon_m = this.seleIcon_m == "&#xe718;" ? "&#xe719;" : "&#xe718;";
          this.appear_share = this.seleIcon_m == "&#xe718;" ? false : true;
          this.share = ["1m", "3m", "5m", "10m", "30m", "1h", "2h", "4h"];
          this.c_index = this.save_num1;
        } else {
          this.select_k = 2;
          this.showLoading = true;
          this.appear_share = false;
          this.cancel(this.title, this.kType, this.typeNum);
          this.minuteK(this.save_num1);
        }
      } else {
        this.seleIcon_m = "&#xe718;";
        this.seleIcon_D = "&#xe718;";
      }
      if (index == 3) {
        this.select_k = 3;
        if (false) console.log("日K线图");
        this.cancel(this.title, this.kType, this.typeNum);
        this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_day, 1);
        this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_day;
        this.typeNum = 1;
      }
      if (index == 4) {
        if (this.select_k == 4) {
          this.appear_shareMACD = false;
          this.seleIcon_D = "&#xe718;";
          this.seleIcon_z = this.seleIcon_z == "&#xe718;" ? "&#xe719;" : "&#xe718;";
          this.appear_share = this.seleIcon_z == "&#xe718;" ? false : true;
          this.share = ["周", "月", "季", "年"];
          this.c_index = this.save_num2;
        } else {
          this.appear_share = false;
          this.cancel(this.title, this.kType, this.typeNum);
          this.weekK(this.save_num2);
        }
        this.select_k = 4;
      } else {
        this.seleIcon_z = "&#xe718;";
        this.seleIcon_D = "&#xe718;";
      }
    },

    // 切换不同的分时K线图
    minuteK: function minuteK(index) {
      switch (index) {
        case 0:
          if (false) console.log("这是一分钟K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute, 1);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute;
          this.typeNum = 1;
          break;
        case 1:
          if (false) console.log("这是三分钟K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute, 3);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute;
          this.typeNum = 3;
          break;
        case 2:
          if (false) console.log("这是五分钟K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute, 5);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute;
          this.typeNum = 5;
          break;
        case 3:
          if (false) console.log("这是10分钟K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute, 10);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute;
          this.typeNum = 10;
          break;
        case 4:
          if (false) console.log("这是30分钟K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute, 30);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute;
          this.typeNum = 30;
          break;
        case 5:
          if (false) console.log("这是1小时K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_hour, 1);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_hour;
          this.typeNum = 1;
          break;
        case 6:
          if (false) console.log("这是2小时K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_hour, 2);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_hour;
          this.typeNum = 2;
          break;
        case 7:
          if (false) console.log("这是4小时K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_hour, 4);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_hour;
          this.typeNum = 4;
          break;
      }
    },

    // 切换不同周K线图
    weekK: function weekK(index) {
      switch (index) {
        case 0:
          if (false) console.log("这是周K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_week, 1);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_week;
          this.typeNum = 1;
          break;
        case 1:
          if (false) console.log("这是月K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_month, 1);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_month;
          this.typeNum = 1;
          break;
        case 2:
          if (false) console.log("这是季K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_season, 1);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_season;
          this.typeNum = 1;
          break;
        case 3:
          if (false) console.log("这是年K线");
          this.oneLine(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_year, 1);
          this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_year;
          this.typeNum = 1;
          break;
      }
    },

    //选择不同的分时图,周图
    cutM: function cutM(item, index) {
      // 取消订阅上一个
      this.cancel(this.title, this.kType, this.typeNum);
      //点击变换背景颜色,切换字体
      this.c_index = index;
      if (this.select_k == 2) {
        this.minute = item;
        this.save_num1 = index;
      } else if (this.select_k == 4) {
        this.week = item;
        this.save_num2 = index;
      }
      if (this.seleIcon_m == "&#xe719;") {
        this.minuteK(index);
      } else if (this.seleIcon_z == "&#xe719;") {
        this.weekK(index);
      }
    },
    cutMACD: function cutMACD(item, index) {
      var _this4 = this;

      this.MACD_index = index;
      this.dLink = item;
      var u_dif = unescape("_ec_%00DIF%000_series.line");
      var u_dea = unescape("_ec_%00DEA%000_series.line");
      var data = echarts.init(document.getElementById("main3"))._chartsMap;
      var exDifs = data[u_dif].__model.option.data[data[u_dif].__model.parentModel.option.dataZoom[1].endValue];
      var exDeas = exDeas;
      switch (index) {
        case 0:
          console.log("这是MACD线");
          this.targetType = "bar";
          this.targetflage = true;
          this.normLine = 0;
          this.targetMR = "MACD", this.targetDR = "DIF", this.targetER = "DEA", this.targetSR = "STICK", this.sargetData = "(12,26,9)", this.targetColor = function (params) {
            var colorList;
            if (params.data >= 0) {
              colorList = "#B61332";
            } else {
              colorList = "#54FFFF";
            }
            return colorList;
          }, this.splitData3(this.rowData);
          var u_macd = unescape("_ec_%00MACD%000_series.bar");
          echarts.init(document.getElementById("main3")).setOption({
            series: [{}, {}, {}, {}, {}, {}, {
              name: this.targetMR,
              type: this.targetType,
              xAxisIndex: 3,
              yAxisIndex: 3,
              data: this.macds,
              itemStyle: {
                normal: {
                  color: this.targetColor
                }
              }
            }, {
              data: this.difs,
              name: this.targetDR
            }, {
              data: this.deas,
              name: this.targetER
            }, {
              name: this.targetSR
            }]
          });
          if (!isNaN(data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue])) {
            this.numMACD = data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue];
          }
          if (!isNaN(exDifs)) {
            this.numDIF = exDifs;
          }
          if (!isNaN(exDeas)) {
            this.numDEA = exDeas;
          }
          echarts.init(document.getElementById("main3")).setOption({
            legend: [{}, {}, {
              formatter: function formatter(name) {
                if (name == _this4.targetMR) {
                  return name + ":" + _this4.sargetData;
                } else if (name == _this4.targetDR) {
                  return name + ":" + Number(_this4.numDIF).toFixed(2);
                } else if (name == _this4.targetER) {
                  return name + ":" + Number(_this4.numDEA).toFixed(2);
                } else if (name == _this4.targetSR) {
                  return name + ":" + Number(_this4.numMACD).toFixed(2);
                }
              },
              data: [{
                name: this.targetMR,
                icon: "none",
                textStyle: {
                  color: "#9a9a9a"
                }
              }, {
                name: this.targetDR,
                icon: "none",
                textStyle: {
                  color: "#fff"
                }
              }, {
                name: this.targetER,
                icon: "none",
                textStyle: {
                  color: "yellow"
                }
              }, {
                name: this.targetSR,
                icon: "none",
                textStyle: {
                  color: "#FF00FF"
                }
              }]
            }]
          });
          break;
        case 1:
          this.targetType = "line";
          this.targetflage = false;
          this.normLine = 1;
          this.targetColor = "#ff00ff";
          this.targetMR = "RSI";
          this.targetDR = "RSI1";
          this.targetER = "RSI2";
          this.targetSR = "RSI3";
          this.sargetData = "(6,12,24)";
          console.log("这是RSI线");
          this.splitData3(this.rowData);
          var u_macd = unescape("_ec_%00MACD%000_series.line");
          echarts.init(document.getElementById("main3")).setOption({
            series: [{}, {}, {}, {}, {}, {}, {
              name: this.targetMR,
              type: this.targetType,
              symbol: "none",
              xAxisIndex: 3,
              yAxisIndex: 3,
              data: this.macds,
              smooth: false,
              itemStyle: {
                normal: {
                  color: this.targetColor
                }
              },
              lineStyle: {
                width: 1
              }
            }, {
              data: this.difs,
              name: this.targetDR
            }, {
              data: this.deas,
              name: this.targetER
            }, {
              name: this.targetSR
            }]
          });
          if (!isNaN(data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue])) {
            this.numMACD = data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue];
          }
          if (!isNaN(exDifs)) {
            this.numDIF = exDifs;
          }
          if (!isNaN(exDeas)) {
            this.numDEA = exDeas;
          }
          echarts.init(document.getElementById("main3")).setOption({
            legend: [{}, {}, {
              formatter: function formatter(name) {
                if (name == _this4.targetMR) {
                  return name + ":" + _this4.sargetData;
                } else if (name == _this4.targetDR) {
                  return name + ":" + Number(_this4.numDIF).toFixed(2);
                } else if (name == _this4.targetER) {
                  return name + ":" + Number(_this4.numDEA).toFixed(2);
                } else if (name == _this4.targetSR) {
                  return name + ":" + Number(_this4.numMACD).toFixed(2);
                }
              },
              data: [{
                name: this.targetMR,
                icon: "none",
                textStyle: {
                  color: "#9a9a9a"
                }
              }, {
                name: this.targetDR,
                icon: "none",
                textStyle: {
                  color: "#fff"
                }
              }, {
                name: this.targetER,
                icon: "none",
                textStyle: {
                  color: "yellow"
                }
              }, {
                name: this.targetSR,
                icon: "none",
                textStyle: {
                  color: "#FF00FF"
                }
              }]
            }]
          });
          break;
        case 2:
          this.targetType = "line";
          this.targetflage = false;
          this.normLine = 2;
          this.targetColor = "#ff00ff";
          this.targetMR = "KDJ";
          this.targetDR = "K";
          this.targetER = "D";
          this.targetSR = "J";
          this.sargetData = "(9,3,3)";
          console.log("这是KDJ线");
          this.splitData3(this.rowData);
          var u_macd = unescape("_ec_%00MACD%000_series.line");
          echarts.init(document.getElementById("main3")).setOption({
            series: [{}, {}, {}, {}, {}, {}, {
              name: this.targetMR,
              type: this.targetType,
              symbol: "none",
              xAxisIndex: 3,
              yAxisIndex: 3,
              data: this.macds,
              smooth: false,
              itemStyle: {
                normal: {
                  color: this.targetColor
                }
              },
              lineStyle: {
                width: 1
              }
            }, {
              data: this.difs,
              name: this.targetDR
            }, {
              data: this.deas,
              name: this.targetER
            }, {
              name: this.targetSR
            }]
          });
          if (!isNaN(data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue])) {
            this.numMACD = data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue];
          }
          if (!isNaN(exDifs)) {
            this.numDIF = exDifs;
          }
          if (!isNaN(exDeas)) {
            this.numDEA = exDeas;
          }
          echarts.init(document.getElementById("main3")).setOption({
            legend: [{}, {}, {
              formatter: function formatter(name) {
                if (name == _this4.targetMR) {
                  return name + ":" + _this4.sargetData;
                } else if (name == _this4.targetDR) {
                  return name + ":" + Number(_this4.numDIF).toFixed(2);
                } else if (name == _this4.targetER) {
                  return name + ":" + Number(_this4.numDEA).toFixed(2);
                } else if (name == _this4.targetSR) {
                  return name + ":" + Number(_this4.numMACD).toFixed(2);
                }
              },
              data: [{
                name: this.targetMR,
                icon: "none",
                textStyle: {
                  color: "#9a9a9a"
                }
              }, {
                name: this.targetDR,
                icon: "none",
                textStyle: {
                  color: "#fff"
                }
              }, {
                name: this.targetER,
                icon: "none",
                textStyle: {
                  color: "yellow"
                }
              }, {
                name: this.targetSR,
                icon: "none",
                textStyle: {
                  color: "#FF00FF"
                }
              }]
            }]
          });
          break;
      }
    },

    //选择MACD.RSI
    seleMACD: function seleMACD() {
      if (this.nowType == 3) {
        // console.log(this.select_k);
        // this.select_k = "-1";
        this.seleIcon_D = this.seleIcon_D == "&#xe718;" ? "&#xe719;" : "&#xe718;";
        this.appear_shareMACD = this.seleIcon_D == "&#xe718;" ? false : true;
        this.seleIcon_m = "&#xe718;";
        this.seleIcon_z = "&#xe718;";
        this.appear_share = false;
        console.log("切换MACD");
      }
    },

    // 点击屏幕事件
    showShare: function showShare() {
      this.appear_share = false;
      this.appear_shareMACD = false;
      this.seleIcon_m = "&#xe718;";
      this.seleIcon_z = "&#xe718;";
      this.seleIcon_D = "&#xe718;";
    },

    //屏幕长按事件
    longtouch: function longtouch(e) {
      var _this5 = this;

      e.stopPropagation();
      this.twoFingers = true;
      clearTimeout(this.Loop);
      this.Loop = setTimeout(function () {
        if (_this5.twoFingers) {
          echarts.init(document.getElementById("main3")).setOption({ tooltip: { axisPointer: { label: { show: true } } } });
          echarts.init(document.getElementById("main3")).setOption({
            tooltip: { axisPointer: { crossStyle: { color: "#999" } } }
          });
          echarts.init(document.getElementById("main3")).setOption({ axisPointer: { lineStyle: { color: "#999" } } });
          echarts.init(document.getElementById("main3")).setOption({
            dataZoom: { moveOnMouseMove: false },
            tooltip: { alwaysShowContent: true }
          });
          _this5.de_flage = true;
          _this5.dataflage = true;
        }
      }, 1000);
    },
    clearLoop: function clearLoop() {
      var _this6 = this;

      clearTimeout(this.Loop);
      echarts.init(document.getElementById("main3")).setOption({
        tooltip: {
          axisPointer: {
            label: { show: false },
            crossStyle: { color: "transparent" }
          },
          alwaysShowContent: false
        },
        axisPointer: { lineStyle: { color: "transparent" } },
        dataZoom: { moveOnMouseMove: true }
      });
      this.de_flage = false;
      this.dataflage = false;
      // 继续右滑加载更多数据
      if (this.lazyLoad) {
        if (this.showLazyLoad) return;
        this.showLazyLoad = true;
        this.startTime = this.rowData[0][0];
        // console.log('加载数据中.................................................................................')
        var kReq = {
          targetId: this.title,
          ktype: this.lazyType,
          kunit: this.lazyMinute,
          kquery: __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].kquery_size,
          ksize: 100,
          endTime: this.startTime
        };
        __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].getKbar2(kReq, function (kbar, last) {
          if (kbar.length == 0) {
            _this6.showLazyLoad = false;
            _this6.nonData = true;
            setTimeout(function () {
              _this6.nonData = false;
            }, 1500);
          } else {
            var arr = kbar.reverse();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(kbar), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var i = _step.value;

                _this6.rowData.unshift([i.time, i.priceOpen, i.priceClose, "-", "-", i.priceLow, i.priceHigh, i.volume]);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(arr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _i = _step2.value;

                _this6.toolArrs.unshift(_i);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            _this6.splitData3(_this6.rowData);
            // 重算视图开始位置的比例: 加载根数/现在共有根数
            var start = kbar.length / _this6.rowData.length * 100;
            // 重算视图结束位置的比例: 原结束比例*原总根数+加载根数/现共有根数
            var end = (_this6.endPercent / 100 * (_this6.rowData.length - kbar.length) + kbar.length) / _this6.rowData.length * 100;
            echarts.init(document.getElementById("main3")).setOption({
              title: {},
              series: [{
                data: _this6.data
              }, {
                data: _this6.calculateMA(5, _this6.data)
              }, {
                data: _this6.calculateMA(10, _this6.data)
              }, {
                data: _this6.calculateMA(20, _this6.data)
              }, {
                data: _this6.calculateMA(60, _this6.data)
              }, {
                data: _this6.volumes
              },
              //指标图
              {
                data: _this6.macds
              }, {
                data: _this6.difs
              }, {
                data: _this6.deas
              }],
              xAxis: [{
                data: _this6.categoryData,
                axisLine: {
                  onZero: true
                }
              }, {
                data: _this6.categoryData
              }, {
                data: _this6.categoryData
              }, {
                data: _this6.categoryData
              }],
              dataZoom: [{
                type: "inside",
                start: start,
                end: end
              }, {}]
            });
            _this6.showLazyLoad = false;
          }
          _this6.showLazyLoad = false;
        }, function (error) {
          suber.reject(error);
          console.log(error);
          this.showLazyLoad = false;
        });
      }
    },
    move: function move(e) {
      e.stopPropagation();
      this.twoFingers = false;
      if (this.de_flage) {
        e.preventDefault();
      }
      clearTimeout(this.Loop);
    },
    changeIcon: function changeIcon() {
      if (this.nowIcon == "&#xe719;") {
        this.nowIcon = "&#xe718;";
      } else if (this.nowIcon == "&#xe718;") {
        this.nowIcon = "&#xe719;";
      }
    },

    //取消订阅1分K线图
    cancel: function cancel(title, ktype, mins) {
      var kreq = { targetId: title, ktype: ktype, kunit: mins };
      __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].unsubKbar2(kreq, "market-kbar");
    },

    // K线图
    oneLine: function oneLine(title, ktype, minute) {
      this.lazyType = ktype;
      this.lazyMinute = minute;
      this.rowData = [];
      this.volumes = [];
      this.macds = [];
      this.difs = [];
      this.deas = [];
      this.toolArrs = [];
      this.showLoading = true;
      this.dataLoad = false;
      echarts.init(document.getElementById("main3")).setOption(this.option3);
      var that = this;
      var kreq = {
        targetId: title,
        ktype: ktype,
        kunit: minute,
        kquery: __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].kquery_size,
        ksize: 50
      };
      __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].subKbar2(kreq, {
        suberId: "market-kbar",
        reject: function reject(error) {
          if (error) {
            that.showLoading = false;
            console.log(error);
            that.errorMessage = error.message;
            echarts.init(document.getElementById("main3")).setOption(that.option3);
          }
        },
        publish: function publish(kbar, type) {
          // console.log(type);
          // console.log(kbar);
          // let hour1 = kbar.updateDate.substr(0, 4);
          // let hour2 = kbar.updateDate.substr(4, 2);
          // let hour3 = kbar.updateDate.substr(6, 2);
          // let hour4 = kbar.time;

          // let time = hour1 + "-" + hour2 + "-" + hour3 + " " + hour4;
          if (kbar.stamp == 1) {
            that.rowData.splice(that.rowData.length - 1, 1, [kbar.time, kbar.priceOpen, kbar.priceClose, "-", "-", kbar.priceLow, kbar.priceHigh, kbar.volume]);
          } else {
            that.rowData.push([kbar.time, kbar.priceOpen, kbar.priceClose, "-", "-", kbar.priceLow, kbar.priceHigh, kbar.volume]);
            that.toolArrs.push(kbar);
          }
          // that.oldNum = that.rowData.length;
          if (that.ma_flage) {
            that.splitData3(that.rowData);
            if (that.option3.series[1].data[that.option3.series[1].data.length - 1] != "-") {
              that.num1 = that.option3.series[1].data[that.option3.series[1].data.length - 1];
            }
            if (that.option3.series[2].data[that.option3.series[2].data.length - 1] != "-") {
              that.num2 = that.option3.series[2].data[that.option3.series[2].data.length - 1];
            }
            if (that.option3.series[3].data[that.option3.series[3].data.length - 1] != "-") {
              that.num3 = that.option3.series[3].data[that.option3.series[3].data.length - 1];
            }
            if (that.option3.series[4].data[that.option3.series[4].data.length - 1] != "-") {
              that.num4 = that.option3.series[4].data[that.option3.series[4].data.length - 1];
            }
            if (that.option3.series[5].data[that.option3.series[5].data.length - 1][1] != "-") {
              that.num5 = that.option3.series[5].data[that.option3.series[5].data.length - 1][1];
            }
            if (that.option3.series[6].data[that.option3.series[6].data.length - 1] != "-") {
              that.numMACD = that.option3.series[6].data[that.option3.series[6].data.length - 1];
            }
            if (that.option3.series[7].data[that.option3.series[7].data.length - 1] != "-") {
              that.numDIF = that.option3.series[7].data[that.option3.series[7].data.length - 1];
            }
            if (that.option3.series[8].data[that.option3.series[8].data.length - 1] != "-") {
              that.numDEA = that.option3.series[8].data[that.option3.series[8].data.length - 1];
            }
            // 柱状折线
            // if (that.option3.series[6].data[ that.option3.series[6].data.length - 1][1] != '-') {
            //   that.num6 = that.option3.series[6].data[ that.option3.series[6].data.length - 1][1];
            // }
          }
          if (that.dataLoad) {
            that.splitData3(that.rowData);
            //每次推送,重新载入数据
            echarts.init(document.getElementById("main3")).setOption({
              title: {},
              series: [{
                data: that.data
              }, {
                data: that.calculateMA(5, that.data)
              }, {
                data: that.calculateMA(10, that.data)
              }, {
                data: that.calculateMA(20, that.data)
              }, {
                data: that.calculateMA(60, that.data)
              }, {
                data: that.volumes
              },
              //指标图
              {
                data: that.macds
              }, {
                data: that.difs
              }, {
                data: that.deas
              }],
              xAxis: [{
                data: that.categoryData,
                axisLabel: {
                  showMinLabel: true,
                  showMaxLabel: true,
                  formatter: that.forty
                }
              }, {
                data: that.categoryData,
                min: "dataMin",
                max: "dataMax"
              }, {
                data: that.categoryData,
                min: "dataMin",
                max: "dataMax"
              }],
              yAxis: [{
                min: "dataMin",
                max: "dataMax"
              }]
            });
          }
          if (__WEBPACK_IMPORTED_MODULE_4__static_js_proto_art_Art_js__["a" /* default */].hasValue(type, __WEBPACK_IMPORTED_MODULE_4__static_js_proto_art_Art_js__["a" /* default */].content_last)) {
            that.startTime = that.rowData[0][0];
            that.errorMessage = "", that.dataLoad = true;
            that.showLoading = false;
            that.startValues = that.data.length - 40;
            that.splitData3(that.rowData);
            echarts.init(document.getElementById("main3")).setOption(that.option3);
          }
        }
      });
    },
    splitData3: function splitData3(rawData) {
      var rawDatas = [];
      for (var i = 0; i < rawData.length; i++) {
        rawDatas.push([]);
        for (var j = 0; j < rawData[i].length; j++) {
          rawDatas[i].push(rawData[i][j]);
        }
      }
      var categoryData = [];
      var values = [];
      var volumes = [];
      var input = [];
      var macd, kdj;
      var rsi1, rsi2, rsi3;
      var flageX = true;
      for (var i = 0; i < rawDatas.length; i++) {
        categoryData.push(rawDatas[i].splice(0, 1)[0]);
        // 判断是否大于40根K线,改变X轴刻度标签和提示值
        if (categoryData.length >= 40) {
          flageX = true;
          this.forty = function (val, index) {
            return val + "  " + val;
          };
          this.fortyX = null;
        } else {
          flageX = false;
          this.forty = function () {
            var num = categoryData.length - 1;
            return categoryData[num] + "  " + categoryData[0];
          };
          this.fortyX = function (val) {
            return categoryData[val.value - 1];
          };
        }
        values.push(rawDatas[i]);
        volumes.push([i, rawDatas[i][6], rawDatas[i][0] > rawDatas[i][1] ? 1 : -1]);
        input.push({
          open: rawDatas[i][0],
          close: rawDatas[i][1],
          low: rawDatas[i][4],
          high: rawDatas[i][5]
        });
      }
      // 判断是否大于40根K线 改变X轴
      if (flageX) {
        this.fortyEnd = 100;
        this.fortyendValue = null;
        this.categoryData = categoryData;
      } else {
        this.fortyEnd = null;
        this.fortyendValue = 40;
        this.startValues = 0;
        this.categoryData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40];
      }
      this.values = values;
      this.volumes = volumes;
      if (input.length > 0) {
        macd = this.calcMACD(12, 26, 9, input, "close");
        kdj = this.calcKDJ(9, 3, 3, input);
        rsi1 = this.calcRSI(6, input, "close");
        rsi2 = this.calcRSI(12, input, "close");
        rsi3 = this.calcRSI(24, input, "close");
        if (this.normLine == 0) {
          this.macds = macd.macd;
          this.difs = macd.dif;
          this.deas = macd.dea;
        } else if (this.normLine == 1) {
          this.macds = rsi3;
          this.difs = rsi1;
          this.deas = rsi2;
        } else if (this.normLine == 2) {
          this.macds = kdj.j;
          this.difs = kdj.k;
          this.deas = kdj.d;
        }
      }
    },
    calculateMA: function calculateMA(dayCount, data) {
      var result = [];
      for (var i = 0, len = data.length; i < len; i++) {
        if (i < dayCount) {
          result.push("-");
          continue;
        }
        var sum = 0;
        for (var j = 0; j < dayCount; j++) {
          sum += data[i - j][1];
        }
        result.push((sum / dayCount).toFixed(3));
      }
      return result;
    },


    //分时图坐标轴
    datumAxis: function datumAxis(target) {
      var that = this;
      that.xdata = [];
      __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].getKbarTimeSeq2({
        targetId: target,
        ktype: __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute,
        kunit: 1,
        resolve: function resolve(rsp) {
          that.valueAxis = rsp.timeSeqList[rsp.timeSeqList.length - 1].seq;
          if (that.control) {
            that.xLabel = function (val) {
              for (var i = 0; i < rsp.timeSeqList.length; i++) {
                if (val == rsp.timeSeqList[i].seq) {
                  if (i == 0 || i == rsp.timeSeqList.length - 1) {
                    return rsp.timeSeqList[i].time + "  " + rsp.timeSeqList[i].time;
                  } else {
                    return rsp.timeSeqList[i].time;
                  }
                }
              }
            };
            for (var i = -1; i < that.valueAxis + 2; i++) {
              // that.option1.xAxis[0].data.push(i);
              that.xdata.push(i);
            }
            // that.option1.xAxis[1].data = that.option1.xAxis[0].data;
            echarts.init(document.getElementById("main1")).setOption(that.option1);
            that.control = false;
          }
        }
      });
    },


    //取消订阅分时图
    callOf: function callOf(title) {
      var kreq = { targetId: title, ktype: __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute, kunit: 1 };
      __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].unsubKbar2(kreq, "market-flash");
      __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].unsubTick(title, "market-datail");
    },


    //分时图
    loadingData: function loadingData(title, ktype, minute) {
      var that = this;
      that.showLoading = true;
      that.dataLoad = false;
      var kreq = {
        targetId: title,
        ktype: ktype,
        kunit: minute,
        kquery: __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].kquery_days,
        ksize: 1
      };
      //改变上面数据和下拉数据的颜色
      __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].subTick(title, {
        suberId: "market-datail",
        publish: function publish(quote) {
          // console.log(quote);

          if (that.flage_s) {
            that.downLowpro = Number(quote.lowPrice);
            that.downColse = Number(quote.lastSettlementPrice);
            that.downHight = that.downColse + (that.downColse - that.downLowpro);
            that.Ymax = Number(that.downHight);
            that.Ymin = that.downLowpro;
            that.Yinterval = (that.Ymax - that.downColse) / 2;
            that.flage_s = false;
            // console.log(that.Ymax)
          }
          that.oldPrice = that.newPrice; //保存前一个最新价
          // 下拉数据
          that.timeImforFlag = false;
          that.timeImfor_bottom.buyPro.pro = quote.bidPrice1;
          that.timeImfor_bottom.limitStop.pro = quote.highStopPrice;
          that.timeImfor_bottom.limitDown.pro = quote.lowStopPrice;
          that.timeImfor_bottom.hightPro.pro = quote.highPrice;
          that.timeImfor_bottom.sellPro.pro = quote.askPrice1;
          that.timeImfor_bottom.lowPro.pro = quote.lowPrice;
          // that.timeImfor_bottom.buyNum.pro = quote.bidVolume1;
          that.timeImfor_bottom.buyPro.buy = quote.bidVolume1;
          that.timeImfor_bottom.sellPro.buy = quote.askVolume1;
          // that.timeImfor_bottom.sellNum.pro = quote.askVolume1;
          // that.timeImfor.hand.pro = '--%';
          // that.timeImfor.position.pro = quote.position;
          if ((quote.highPrice - quote.lowPrice) / quote.lowPrice * 100) {
            that.timeImfor.range.pro = ((quote.highPrice - quote.lowPrice) / quote.lowPrice * 100).toFixed(2) + "%";
          } else {
            that.timeImfor.range.pro = "0.00%";
          }
          that.timeImfor.yesterday.pro = quote.lastClosePrice;
          // console.log(quote)
          //顶部数据
          // console.log(quote.latestPrice,quote.lastSettlementPrice*100,((quote.latestPrice*100).toFixed(0)-(quote.lastSettlementPrice*100).toFixed(0))/100)
          that.ranges = ((quote.latestPrice * 100).toFixed(0) - (quote.lastSettlementPrice * 100).toFixed(0)) / 100 > 0 ? "+" + ((quote.latestPrice * 100).toFixed(0) - (quote.lastSettlementPrice * 100).toFixed(0)) / 100 : ((quote.latestPrice * 100).toFixed(0) - (quote.lastSettlementPrice * 100).toFixed(0)) / 100;
          that.limit = (quote.latestPrice - quote.lastSettlementPrice) * 100 / quote.lastSettlementPrice > 0 ? "+" + ((quote.latestPrice - quote.lastSettlementPrice) * 100 / quote.lastSettlementPrice).toFixed(2) : ((quote.latestPrice - quote.lastSettlementPrice) * 100 / quote.lastSettlementPrice).toFixed(2);
          if (!that.dataflage) {
            that.open = quote.openPrice;
            that.turnover = quote.volume;
            that.number = quote.position;
          }
          that.newPrice = quote.latestPrice;
          that.close = quote.lastSettlementPrice;

          // 涨停价颜色变化
          if (quote.highStopPrice == quote.lastSettlementPrice) {
            that.stop_colorg = false;
            that.stop_colorr = false;
          } else if (quote.highStopPrice > quote.lastSettlementPrice) {
            that.stop_colorg = false;
            that.stop_colorr = true;
          } else if (quote.highStopPrice < quote.lastSettlementPrice) {
            that.stop_colorg = true;
            that.stop_colorr = false;
          }

          // 跌停价颜色变化
          if (quote.lowStopPrice == quote.lastSettlementPrice) {
            that.down_colorg = false;
            that.down_colorr = false;
          } else if (quote.lowStopPrice > quote.lastSettlementPrice) {
            that.down_colorg = false;
            that.down_colorr = true;
          } else if (quote.lowStopPrice < quote.lastSettlementPrice) {
            that.down_colorg = true;
            that.down_colorr = false;
          }

          //申买价颜色变化
          if (quote.bidPrice1 == quote.lastSettlementPrice) {
            that.br_color = false;
            that.bg_color = false;
          } else if (quote.bidPrice1 > quote.lastSettlementPrice) {
            that.br_color = true;
            that.bg_color = false;
          } else if (quote.bidPrice1 < quote.lastSettlementPrice) {
            that.br_color = false;
            that.bg_color = true;
          }

          //申卖价颜色变化
          if (quote.askPrice1 == quote.lastSettlementPrice) {
            that.sr_color = false;
            that.sg_color = false;
          } else if (quote.askPrice1 > quote.lastSettlementPrice) {
            that.sr_color = true;
            that.sg_color = false;
          } else if (quote.askPrice1 < quote.lastSettlementPrice) {
            that.sr_color = false;
            that.sg_color = true;
          }

          //最高价颜色变化
          if (quote.highPrice == quote.lastSettlementPrice) {
            that.h_color = false;
            that.hColor = false;
          } else if (quote.highPrice > quote.lastSettlementPrice) {
            that.h_color = true;
            that.hColor = false;
          } else if (quote.highPrice < quote.lastSettlementPrice) {
            that.h_color = false;
            that.hColor = true;
          }

          //最低价颜色变化
          if (quote.lowPrice == quote.lastSettlementPrice) {
            that.l_color = false;
            that.lColor = false;
          } else if (quote.lowPrice > quote.lastSettlementPrice) {
            that.l_color = true;
            that.lColor = false;
          } else if (quote.lowPrice < quote.lastSettlementPrice) {
            that.l_color = false;
            that.lColor = true;
          }

          //开盘价颜色变化
          if (that.open == quote.lastSettlementPrice) {
            that.open_color = false;
            that.open_color2 = false;
          } else if (that.open > quote.lastSettlementPrice) {
            that.open_color = true;
            that.open_color2 = false;
          } else if (that.open < quote.lastSettlementPrice) {
            that.open_color = false;
            that.open_color2 = true;
          }

          //判断行情,更换顶部字体颜色
          if (quote.latestPrice == quote.lastSettlementPrice) {
            that.c_red = false;
            that.c_green = false;
            that.c_grey = true;
          } else if (quote.latestPrice > quote.lastSettlementPrice) {
            that.c_red = true;
            that.c_green = false;
            that.c_grey = false;
          } else if (quote.latestPrice < quote.lastSettlementPrice) {
            that.c_red = false;
            that.c_green = true;
            that.c_grey = false;
          }
          // @huang.z.d 去除到闪烁的效果，晃眼
          //顶部最新价变化颜色
          // if (that.newPrice > that.oldPrice) {
          //   that.$refs.back.style.backgroundColor = "#ac2929";
          //   setTimeout(() => {
          //     that.$refs.back.style.backgroundColor = "";
          //   }, 1000);
          // } else if (that.newPrice < that.oldPrice) {
          //   that.$refs.back.style.backgroundColor = "#0eca1d";
          //   setTimeout(() => {
          //     that.$refs.back.style.backgroundColor = "";
          //   }, 1000);
          // } else {
          //   that.$refs.back.style.backgroundColor = "";
          // }
        }
      });
      __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].subKbar2(kreq, {
        suberId: "market-flash",
        reject: function reject(error) {
          if (error) {
            that.showLoading = false;
            // console.log(error);
            // console.log("error");
            that.errorMessage = error.message;
            echarts.init(document.getElementById("main1")).setOption(that.option1);
          }
        },
        publish: function publish(pub, type) {
          if (pub.kseq != that.compare) {
            // that.allArr.push(pub);
            that.optionSer1.push([pub.kseq, pub.priceClose]);
            that.averagePrice.push([pub.kseq, pub.priceAverage]);
            that.tooltipArr.push({ num: pub.kseq, time: pub.time });
            that.optionSer2.push({
              value: [pub.kseq, pub.volume],
              itemStyle: { color: "red" }
            });
            // that.option1.series[2].data.push([pub.kseq,pub.priceClose]);//暂时折线图数据, 具体算法未知
          } else {
            // that.allArr.splice(that.allArr.length - 1, 1, pub);
            that.optionSer1.splice(that.optionSer1.length - 1, 1, [pub.kseq, pub.priceClose]);
            that.averagePrice.splice(that.averagePrice.length - 1, 1, [pub.kseq, pub.priceAverage]);
            that.tooltipArr.splice(that.tooltipArr.length - 1, 1, {
              num: pub.kseq,
              time: pub.time
            });
            that.optionSer2.splice(that.optionSer2.length - 1, 1, {
              value: [pub.kseq, pub.volume],
              itemStyle: { color: "red" }
            });
          }

          // Y轴坐标
          var priceClose = Number(pub.priceClose);
          if (priceClose < that.downLowpro) {
            that.downLowpro = priceClose;
            that.downHight = that.downColse + (that.downColse - that.downLowpro);
          } else if (priceClose > that.downHight) {
            that.downHight = priceClose;
            that.downLowpro = that.downColse - (that.downHight - that.downColse);
          }

          that.Ymax = Number(that.downHight);
          that.Ymin = Number(that.downLowpro);
          that.Yinterval = (that.Ymax - that.downColse) / 2;
          // console.log(that.Ymax)
          if (that.optionSer2.length > 1) {
            if (that.optionSer2[that.optionSer2.length - 1].value[1] > that.optionSer2[that.optionSer2.length - 2].value[1]) {
              that.optionSer2[that.optionSer2.length - 1].itemStyle.color = "red";
            } else {
              that.optionSer2[that.optionSer2.length - 1].itemStyle.color = "#2AE1FF";
            }
          }
          if (that.dataLoad) {
            echarts.init(document.getElementById("main1")).setOption(that.option1);
          }
          that.compare = pub.kseq;
          if (__WEBPACK_IMPORTED_MODULE_4__static_js_proto_art_Art_js__["a" /* default */].hasValue(type, __WEBPACK_IMPORTED_MODULE_4__static_js_proto_art_Art_js__["a" /* default */].content_last)) {
            that.errorMessage = "", that.dataLoad = true;
            echarts.init(document.getElementById("main1")).setOption(that.option1);
            setTimeout(function () {
              that.showLoading = false;
            }, 10);
          }
          // that.option1.tooltip.formatter = function(param) {
          //   var param = param[0];
          //   for (var i = 0; i < that.tooltipArr.length; i++) {
          //     if (param.data[0] == that.tooltipArr[i].num) {
          //       return that.tooltipArr[i].time + "<br/> " + param.data[1];
          //     }
          //   }
          // };
        }
      });
    },


    //计算MACD , DIF , DEA
    calcEMA: function calcEMA(n, data, field) {
      var i, l, ema, a;
      a = 2 / (n + 1);
      if (field) {
        ema = [data[0][field]];
        for (i = 1, l = data.length; i < l; i++) {
          ema.push(a * data[i][field] + (1 - a) * ema[i - 1]);
        }
      } else {
        ema = [data[0]];
        for (i = 1, l = data.length; i < l; i++) {
          ema.push(a * data[i] + (1 - a) * ema[i - 1]);
        }
      }
      return ema;
    },

    // * 计算DIF快线，用于MACD
    calcDIF: function calcDIF(short, long, data, field) {
      var i, l, dif, emaShort, emaLong;
      dif = [];
      emaShort = this.calcEMA(short, data, field);
      emaLong = this.calcEMA(long, data, field);
      for (i = 0, l = data.length; i < l; i++) {
        dif.push(emaShort[i] - emaLong[i]);
      }
      return dif;
    },

    // 计算DEA慢线，用于MACD
    calcDEA: function calcDEA(mid, dif) {
      return this.calcEMA(mid, dif);
    },

    //* 计算MACD
    calcMACD: function calcMACD(short, long, mid, data, field) {
      var i, l, dif, dea, macd, result;
      result = {};
      macd = [];
      dif = this.calcDIF(short, long, data, field);
      dea = this.calcDEA(mid, dif);
      for (i = 0, l = data.length; i < l; i++) {
        macd.push((dif[i] - dea[i]) * 2);
      }
      result.dif = dif;
      result.dea = dea;
      result.macd = macd;
      return result;
    },


    // RSI
    calcRSI: function calcRSI(n, data, field) {
      var arr = [0];
      var num1 = 0,
          num2 = 0,
          a = 0,
          b = 0;
      for (var i = 1; i < data.length; i++) {
        var RS = 0;
        if (data[i][field] < data[i - 1][field]) {
          a = num1 * (n - 1) / n + (data[i - 1][field] - data[i][field]) / n;
          b = num2 * (n - 1) / n;
        } else {
          b = num2 * (n - 1) / n + (data[i][field] - data[i - 1][field]) / n;
          a = num1 * (n - 1) / n;
        }
        num1 = a;
        num2 = b;
        RS = b / a;
        if (RS === Infinity) {
          RS = 1;
        }
        arr.push(RS / (1 + RS) * 100);
      }
      return arr;
    },


    //   计算KDJ值;;;;;;;;;;;;;;;;;;
    calcLLV: function calcLLV(pos, n, data, field) {
      var i, l, min;
      n--;
      min = data[pos][field];
      l = pos - n;
      l < 0 ? l = 0 : 1;
      for (i = pos; i >= l; i--) {
        if (min > data[i][field]) {
          min = data[i][field];
        }
      }
      return min;
    },

    // 计算最大值
    calcHHV: function calcHHV(pos, n, data, field) {
      var i, l, max;
      n--;
      max = data[pos][field];
      l = pos - n;
      l < 0 ? l = 0 : 1;
      for (i = pos; i >= l; i--) {
        if (max < data[i][field]) {
          max = data[i][field];
        }
      }
      return max;
    },

    // 计算SMA，加权移动平均指标
    calcSMA: function calcSMA(n, m, data) {
      var i, l, sma;
      sma = [100];
      for (i = 1, l = data.length; i < l; i++) {
        sma.push((data[i] * m + sma[i - 1] * (n - m)) / n);
      }
      return sma;
    },

    // 计算RSV，未成熟随机值指标
    calcRSV: function calcRSV(n, data) {
      var i, l, rsv, low, tempValue;
      rsv = [];
      for (i = 0, l = data.length; i < l; i++) {
        low = this.calcLLV(i, n, data, "low");
        tempValue = 100 * (data[i].close - low) / (this.calcHHV(i, n, data, "high") - low);
        if (isNaN(tempValue)) {
          if (i === 0) {
            tempValue = 100;
          } else {
            tempValue = rsv[i - 1];
          }
        }
        rsv.push(tempValue);
      }
      return rsv;
    },

    // 计算KDJ
    calcKDJ: function calcKDJ(n, m1, m2, data) {
      var i, l, rsv, k, d, j;
      rsv = this.calcRSV(n, data);
      k = this.calcSMA(m1, 1, rsv);
      d = this.calcSMA(m2, 1, k);
      j = [];
      for (i = 0, l = k.length; i < l; i++) {
        j.push(3 * k[i] - 2 * d[i]);
      }
      return {
        k: k,
        d: d,
        j: j
      };
    }
  },
  mounted: function mounted() {
    document.getElementById("main3").style.width = window.innerWidth + "px";
    document.getElementById("main3").style.height = this.$refs.two_top.offsetHeight * 0.89 + "px";

    ///K线图拖动,缩放 数据变化
    echarts.init(document.getElementById("main3")).on("datazoom", function (val) {
      // 滑动到最左, 懒加载
      if (val.batch[0].start == 0) {
        this.lazyLoad = true;
        this.endPercent = val.batch[0].end;
      } else {
        this.lazyLoad = false;
      }
      // console.log(val)
      // console.log(echarts.init(document.getElementById('main3')));

      //控制两指缩放时触发坐标轴标线
      this.twoFingers = false;

      //控制MA值的值是根据拖动变化还是根据数据更新变化
      this.ma_flage = false;
      if (val.batch[0].end == 100) {
        this.ma_flage = true;
      }
      var data = echarts.init(document.getElementById("main3"))._chartsMap;
      var u_ma5 = unescape("_ec_%00MA5%000_series.line");
      var u_ma10 = unescape("_ec_%00MA10%000_series.line");
      var u_ma20 = unescape("_ec_%00MA20%000_series.line");
      var u_ma60 = unescape("_ec_%00MA60%000_series.line");
      var u_volume = unescape("_ec_%00Volume%000_series.bar");
      var u_dif = unescape("_ec_%00DIF%000_series.line");
      var u_dea = unescape("_ec_%00DEA%000_series.line");
      var u_macd = void 0;
      if (this.targetflage) {
        u_macd = unescape("_ec_%00MACD%000_series.bar");
      } else {
        u_macd = unescape("_ec_%00MACD%000_series.line");
      }
      //   // 柱状折线
      // let u_line = unescape("_ec_%00Line%000_series.line");
      // console.log(data);
      this.num1 = "0.00";
      this.num2 = "0.00";
      this.num3 = "0.00";
      this.num4 = "0.00";
      this.num5 = "0.00";
      this.num6 = "0.00";
      this.numMACD = "0.00";
      this.numDIF = "0.00";
      this.numDEA = "0.00";
      // console.log(data[u_ma5].__model.parentModel.option.dataZoom[1].endValue);
      // console.log(data[u_ma5].__model.option.data[data[u_ma5].__model.parentModel.option.dataZoom[1].endValue])
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(data[u_ma5]._data._extent.y[1]) && !isNaN(data[u_ma5].__model.option.data[data[u_ma5].__model.parentModel.option.dataZoom[1].endValue])) {
        this.num1 = data[u_ma5].__model.option.data[data[u_ma5].__model.parentModel.option.dataZoom[1].endValue];
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(data[u_ma10]._data._extent.y[1]) && !isNaN(data[u_ma10].__model.option.data[data[u_ma10].__model.parentModel.option.dataZoom[1].endValue])) {
        this.num2 = data[u_ma10].__model.option.data[data[u_ma10].__model.parentModel.option.dataZoom[1].endValue];
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(data[u_ma20]._data._extent.y[1]) && !isNaN(data[u_ma20].__model.option.data[data[u_ma20].__model.parentModel.option.dataZoom[1].endValue])) {
        this.num3 = data[u_ma20].__model.option.data[data[u_ma20].__model.parentModel.option.dataZoom[1].endValue];
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(data[u_ma60]._data._extent.y[1]) && !isNaN(data[u_ma60].__model.option.data[data[u_ma60].__model.parentModel.option.dataZoom[1].endValue])) {
        this.num4 = data[u_ma60].__model.option.data[data[u_ma60].__model.parentModel.option.dataZoom[1].endValue];
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(data[u_volume]._data._extent.y[1])) {
        this.num5 = data[u_volume].__model.option.data[data[u_volume].__model.parentModel.option.dataZoom[1].endValue][1];
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(data[u_dif]._data._extent.y[1])) {
        this.numDIF = data[u_dif].__model.option.data[data[u_dif].__model.parentModel.option.dataZoom[1].endValue];
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(data[u_dea]._data._extent.y[1])) {
        this.numDEA = data[u_dea].__model.option.data[data[u_dea].__model.parentModel.option.dataZoom[1].endValue];
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(data[u_macd]._data._extent.y[1])) {
        this.numMACD = data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue];
      }
      //   // 柱状折线
      // if (data[u_line]._data._extent.y[1] != "-Infinity") {
      //   this.num6 =
      //     data[u_line].__model.option.data[
      //       data[u_line].__model.parentModel.option.dataZoom[1].endValue
      //     ][1];
      // }
    }.bind(this));
  },
  activated: function activated() {
    this.showLazyLoad = false;
    this.flage_s = true;
    this.appear_share = false;
    this.nowType = 1;
    this.nowTypes = 1;
    this.flage = true;
    this.select_k = 1;
    this.handIcap = true;
    this.title = this.$route.params.contract;
    if (this.targetSelected[this.title] != undefined) {
      this.selfContract2 = true;
      this.selfContract2 = "&#xe617;";
    } else {
      this.selfContract2 = false;
      this.selfContract2 = "&#xe63c;";
    }
    //分割分时图X轴
    this.control = true;
    this.datumAxis(this.title);
    this.kType = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute;
    // 调用分时图数据
    this.loadingData(this.title, __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront_js__["a" /* default */].ktype_minute, 1);
  },

  //退出定阅页面事件
  deactivated: function deactivated() {
    this.cancel(this.title, this.kType, this.typeNum);
    this.callOf(this.title);
    this.rowData = [];
    this.volumes = [];
    this.optionSer1 = [];
    this.averagePrice = [];
    this.optionSer2 = [];
    this.option1.series[2].data = [];
    this.toolArrs = [];
    this.showLoading = false;
    this.tooltipArr = [];
    // front.unsubTick(this.title, "market-detail");
    // 数据还原
    this.open = '0';
    this.turnover = '0';
    this.number = '0';
    this.newPrice = '0';
    this.close = '0';
    this.ranges = '0';
    this.limit = '0.00';
    this.timeImfor_bottom = {
      sellPro: {
        tit: "卖一",
        pro: "0.00",
        buy: 0
      },
      hightPro: {
        tit: "最高",
        pro: "0.00"
      },
      limitStop: {
        tit: "涨停",
        pro: "0.00"
      },
      buyPro: {
        tit: "买一",
        pro: "0.00",
        buy: 0
      },
      lowPro: {
        tit: "最低",
        pro: "0.00"
      },
      limitDown: {
        tit: "跌停",
        pro: "0.00"
      }
    }, this.Yinterval = 0;
    this.Ymin = 0;
    this.Ymax = 0;
    // 颜色还原
    //>最高价,最低价
    this.c_red = false;
    this.c_green = false;
    this.c_grey = false;
    this.h_color = false;
    this.l_color = false;
    this.hColor = false;
    this.lColor = false;
    //>开盘价
    this.open_color = false;
    this.open_color2 = false;
    //>申买价,申卖价
    this.br_color = false;
    this.bg_color = false;
    this.sr_color = false;
    this.sg_color = false;
    //>涨停价,跌停价
    this.stop_colorg = false;
    this.stop_colorr = false;
    this.down_colorg = false;
    this.down_colorr = false;
  }
});

/***/ }),

/***/ "YsUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trade_vue__ = __webpack_require__("YMbQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84fa6e8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trade_vue__ = __webpack_require__("j+M0");
function injectStyle (ssrContext) {
  __webpack_require__("rYmX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84fa6e8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84fa6e8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZCTx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var OnOff = (function (_super) {
    __extends(OnOff, _super);
    function OnOff() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.flage = true;
        _this.type = '关闭';
        return _this;
    }
    OnOff.prototype.handleonOff = function () {
        this.flage = !this.flage;
        this.type =
            this.flage === true ? '开启' : '关闭';
        localStorage.flage = this.flage + '';
    };
    OnOff.prototype.mounted = function () {
        if (localStorage.flage !== undefined) {
            this.flage =
                localStorage.flage === 'true' ? true : false;
        }
        else {
            localStorage.flage = this.flage + '';
        }
        this.type =
            this.flage === true ? '开启' : '关闭';
    };
    OnOff = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], OnOff);
    return OnOff;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (OnOff);


/***/ }),

/***/ "a7nu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b1B+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_SelectButton_ts__ = __webpack_require__("Lm3I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_993f3ec2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectButton_vue__ = __webpack_require__("Wwpx");
function injectStyle (ssrContext) {
  __webpack_require__("uGI/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-993f3ec2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_SelectButton_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_993f3ec2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b7XU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nengyuan.55e1068.png";

/***/ }),

/***/ "b8US":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_yjheader__ = __webpack_require__("eR8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_tradeList__ = __webpack_require__("3hyP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");
//
//
//
//
//
//
//







// ---------------------------------------------------------------------------
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "selected",
  components: {
    yjheader: __WEBPACK_IMPORTED_MODULE_1__components_common_yjheader__["a" /* default */],
    tradeList: __WEBPACK_IMPORTED_MODULE_2__components_common_tradeList__["a" /* default */]
  },

  ////////////////////////////////////////////////////////////////////////////
  data: function data() {
    return {
      vmSelected: []
    };
  },


  ////////////////////////////////////////////////////////////////////////////
  mounted: function mounted() {},
  activated: function activated() {
    footerIndex = 0;
    __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_js__["a" /* default */].autoMount(__WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.subscribe));
  },
  deactivated: function deactivated() {
    this.unsubscribe();
    beferFooterIndex = 0;
  },


  ////////////////////////////////////////////////////////////////////////////
  computed: {
    targetSelected: function targetSelected() {
      return this.$store.state.targetSelected;
    },
    name: function name() {
      return this.$options.name;
    }
  },
  watch: {
    vmSelected: function vmSelected(news, old) {
      this.$store.commit('upDataSelect', this.vmSelected);
    }
  },

  ////////////////////////////////////////////////////////////////////////////
  methods: {
    // 订阅自选列表
    subscribe: function subscribe(reject) {
      var _this = this;

      // 1.已经订阅自选列表，则只需要订阅自选行情。
      var subTick = function subTick(targetId) {
        return __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_js__["a" /* default */].subTick(targetId, {
          suberId: _this.name,
          publish: function publish(tick) {
            return _this.onTick(tick);
          }
        });
      };
      if (!__WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__["a" /* default */].empty(this.targetSelected)) {
        for (var targetId in this.targetSelected) {
          subTick(targetId);
        }
        return;
      }

      // 2.未订阅自选列表：订阅自选列表，再订阅行情。
      // 只添加自选列表：自选合约不存在更新。
      var addTarget = function addTarget(targetId) {
        if (!__WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__["a" /* default */].find(_this.vmSelected, targetId, "targetId")) {
          var target = __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_js__["a" /* default */].targetSet[targetId];
          if (target) {
            _this.vmSelected.push({
              volume: 0,
              latestPrice: 0,
              lastSettlementPrice: 0,
              targetId: targetId,
              targetName: target.targetName
            });
          }
        } // endif
      };

      // 接收推送信息
      var publish = function publish(target) {
        if (!target.targetId) {
          return;
        }
        // 删除自选
        if (target.stamp == __WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__["a" /* default */].meta.stamp_remove) {
          __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_js__["a" /* default */].unsubTick(target.targetId, _this.name);
          __WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__["a" /* default */].erase(_this.vmSelected, target.targetId, "targetId");
          return;
        }
        // 添加自选
        addTarget(target.targetId);
        subTick(target.targetId);
      };

      // 订阅自选列表
      __WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__["a" /* default */].clear(this.vmSelected);
      var sub = __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_js__["a" /* default */].selectedTargetSub({
        suberId: this.name,
        publish: publish,
        reject: reject
      });
      this.$store.commit("selectLoad", sub);
      // console.log(this.vmSelected)
    },


    //////////////////////////////////////////////////////////////////////////
    // 取消订阅自选列表
    unsubscribe: function unsubscribe() {
      if (this.targetSelected) {
        for (var targetId in this.targetSelected) {
          __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_js__["a" /* default */].unsubTick(targetId, this.name);
        }
      }
    },


    //////////////////////////////////////////////////////////////////////////
    // 合约行情信息
    onTick: function onTick(tick) {
      // 只更新行情列表：添加由subscribe负责。
      var vm = __WEBPACK_IMPORTED_MODULE_3__static_js_proto_art_Art_js__["a" /* default */].find(this.vmSelected, tick.targetId, "targetId");
      if (vm) {
        var data = this.vmSelected[vm.index];
        data.volume = tick.volume;
        data.latestPrice = tick.latestPrice;
        data.lastSettlementPrice = tick.lastSettlementPrice;
        return;
      }
      console.error("warn" + tick.targetId);
    }

    //////////////////////////////////////////////////////////////////////////

  } // VUE.METHODS
}); // VUE.

/***/ }),

/***/ "baG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kLine_vue__ = __webpack_require__("EsUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d45e16a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kLine_vue__ = __webpack_require__("u/H+");
function injectStyle (ssrContext) {
  __webpack_require__("o0jF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d45e16a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d45e16a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bp3a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userProtocol_vue__ = __webpack_require__("RGDD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f73e08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userProtocol_vue__ = __webpack_require__("CVC6");
function injectStyle (ssrContext) {
  __webpack_require__("oRu+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11f73e08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userProtocol_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f73e08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userProtocol_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "btb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_better_scroll__ = __webpack_require__("GQaK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif__ = __webpack_require__("SBPU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_CrmHttp__ = __webpack_require__("n20g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_crm_enums__ = __webpack_require__("Xo8I");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var DrawMoneyRecord = (function (_super) {
    __extends(DrawMoneyRecord, _super);
    function DrawMoneyRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.refer = '下拉刷新';
        _this.referMeg = '已刷新';
        _this.msgShow = false;
        _this.UpLoad = '上拉加载更多';
        _this.uploadHint = true;
        _this.referHint = true;
        _this.listLength = '0';
        _this.load = __WEBPACK_IMPORTED_MODULE_3__assets_images_upLoading_gif___default.a;
        _this.flage = true;
        _this.datas = [];
        return _this;
    }
    DrawMoneyRecord.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2];
            });
        });
    };
    DrawMoneyRecord.prototype.getData = function (start, end, flage) {
        return __awaiter(this, void 0, void 0, function () {
            var data, _i, _a, i, obj, a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_4__utils_CrmHttp__["a" /* postForm */])('/api/transfer-in/query', {
                                Start: start,
                                Limit: end,
                            })];
                    case 1:
                        data = _b.sent();
                        if (flage) {
                            this.datas = [];
                        }
                        if (data.Data.length === 0) {
                            this.UpLoad = '没有更多数据';
                            return [2];
                        }
                        for (_i = 0, _a = data.Data; _i < _a.length; _i++) {
                            i = _a[_i];
                            obj = {};
                            for (a in i) {
                                obj[a] = i[a];
                            }
                            this.datas.push(obj);
                        }
                        this.listLength = this.datas.length;
                        this.referMeg = '已刷新';
                        return [3, 3];
                    case 2:
                        e_1 = _b.sent();
                        this.referMeg = '刷新失败';
                        console.error(e_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    DrawMoneyRecord.prototype.activated = function () {
        var _this = this;
        this.loading = true;
        this.datas = [];
        this.getData(0, 20, true)
            .then(function () { return _this.loading = false; })
            .catch(function () { return _this.loading = false; });
        this.refer = '下拉刷新';
        this.$nextTick(function () {
            if (!_this.scroll) {
                var wrapper = _this.$refs.wrapper;
                var heig_1 = _this.$refs.fristD.offsetHeight;
                var heig2_1 = _this.$refs.wrapper.offsetHeight -
                    _this.$refs.list.offsetHeight;
                _this.scroll = new __WEBPACK_IMPORTED_MODULE_2_better_scroll__["a" /* default */](wrapper, {
                    startY: -heig_1,
                    click: true,
                    scrollY: true,
                    probeType: 3,
                });
                _this.scroll.on('scroll', function (req) {
                    if (req.y > -heig_1 - 5 || req.y < heig2_1) {
                        if (_this.flage) {
                            _this.scroll.stop();
                            _this.flage = false;
                        }
                    }
                    else {
                        _this.flage = true;
                        _this.refer = '下拉刷新';
                        _this.UpLoad = '上拉加载更多记录';
                    }
                    if (req.y - 20 > 0) {
                        if (_this.referHint) {
                            _this.refer = '松开立即刷新';
                        }
                    }
                    else if (req.y < heig2_1 - 20 && heig2_1 < 0) {
                        if (_this.uploadHint) {
                            _this.UpLoad = '松开立即加载';
                        }
                    }
                });
                _this.scroll.on('touchEnd', function (req) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(req.y > 0)) return [3, 2];
                                this.referHint = false;
                                this.refer = '正在刷新.....';
                                this.flage = true;
                                this.scroll.scrollTo(0, 0, 100);
                                return [4, this.getData(0, 20, true)];
                            case 1:
                                _a.sent();
                                this.flage = false;
                                this.msgShow = true;
                                setTimeout(function () {
                                    _this.msgShow = false;
                                }, 2000);
                                this.refer = '下拉刷新';
                                this.referHint = true;
                                setTimeout(function () {
                                    _this.scroll.scrollTo(0, -heig_1, 100);
                                }, 1);
                                return [3, 5];
                            case 2:
                                if (!(req.y > -heig_1 && req.y < 0)) return [3, 3];
                                setTimeout(function () {
                                    _this.scroll.scrollTo(0, -heig_1, 100);
                                }, 1);
                                return [3, 5];
                            case 3:
                                if (!(req.y < heig2_1 - 20 && heig2_1 < 0)) return [3, 5];
                                this.uploadHint = false;
                                this.UpLoad = '正在加载.....';
                                this.flage = true;
                                this.scroll.scrollTo(0, heig2_1, 100);
                                return [4, this.getData(this.listLength, 10, false)];
                            case 4:
                                _a.sent();
                                if (this.UpLoad != '没有更多数据') {
                                    this.UpLoad = '上拉加载更多记录';
                                }
                                this.uploadHint = true;
                                this.scroll.refresh();
                                _a.label = 5;
                            case 5:
                                heig_1 = this.$refs.fristD.offsetHeight;
                                heig2_1 = this.$refs.wrapper.offsetHeight -
                                    this.$refs.list.offsetHeight;
                                this.scroll.stop();
                                return [2];
                        }
                    });
                }); });
            }
            else {
                _this.scroll.refresh();
            }
        });
    };
    DrawMoneyRecord.prototype.handleMessage = function (item, index) {
        this.$router.push({
            path: '/details',
            name: 'details',
            params: Object.assign({}, item),
        });
    };
    DrawMoneyRecord.prototype.goback = function () {
        this.$router.go(-1);
    };
    DrawMoneyRecord.prototype.realMoney = function (item) {
        switch (item.State) {
            case __WEBPACK_IMPORTED_MODULE_5__types_crm_enums__["d" /* TransferInStateEnum */].Accept:
            case __WEBPACK_IMPORTED_MODULE_5__types_crm_enums__["d" /* TransferInStateEnum */].PaySuc:
                return item.Money;
            default:
                return item.StateStr;
        }
    };
    DrawMoneyRecord = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], DrawMoneyRecord);
    return DrawMoneyRecord;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (DrawMoneyRecord);


/***/ }),

/***/ "bxcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.upgrade.display),expression:"upgrade.display"}],staticClass:"isSuccess_bg",on:{"touchmove":function($event){$event.preventDefault();}}},[(_vm.platformName === 'android')?_c('div',{staticClass:"isSuccess clearfix"},[_c('p',[_vm._v("版本升级"+_vm._s(_vm.upgrade.version))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n      "+_vm._s(_vm.upgrade.content)+"\n    ")]),_vm._v(" "),_c('mt-progress',{staticClass:"progress",attrs:{"value":_vm.progress,"bar-height":2}}),_vm._v(" "),_c('div',{staticClass:"btn-upgrade",on:{"click":function($event){_vm.handleUpdateVersion()}}},[_vm._v("立即升级")])],1):_vm._e(),_vm._v(" "),(_vm.platformName === 'ios')?_c('div',{staticClass:"isSuccess clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n      "+_vm._s(_vm.upgrade.content)+"\n    ")]),_vm._v(" "),_c('mt-progress',{staticClass:"progress",attrs:{"value":_vm.progress,"bar-height":2}}),_vm._v(" "),_c('div',{staticClass:"btn-upgrade",on:{"click":function($event){_vm.handleUpdateVersion()}}},[_vm._v("立即升级")]),_vm._v(" "),_c('div',{staticClass:"btn-upgrade",on:{"click":function($event){_vm.handleLaterUp()}}},[_vm._v("稍后升级")])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("AppStore有新版本发布"),_c('br'),_vm._v("是否立即前往更新?")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cYrQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cdCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_proto_Model_js__ = __webpack_require__("O0G5");


var unSubFuns = {
    conditionNotTriggerList: function conditionNotTriggerList(list) {
        list.splice(0, list.length);
        __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].conditionOrderUnsub('condition_order');
    },
    capital: function capital(obj) {
        obj.rights = 0.0;
        obj.usable = 0.0;
        obj.profitAloss = 0.0;
        obj.desirable = 0.0;
        obj.account = 0.0;
        __WEBPACK_IMPORTED_MODULE_1__static_js_proto_Model_js__["a" /* default */].trader.queryCapital.stop();
    }
};
/* harmony default export */ __webpack_exports__["a"] = (unSubFuns);

/***/ }),

/***/ "cdwa":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = __webpack_require__("LkYP");
var goog = jspb;
var global = Function('return this')();

var Object_pb = __webpack_require__("zSVF");
goog.exportSymbol('proto.vision.market.proto.GetBaseKbar', null, global);
goog.exportSymbol('proto.vision.market.proto.GetKbarRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.GetLastDayKbar', null, global);
goog.exportSymbol('proto.vision.market.proto.GetProduct', null, global);
goog.exportSymbol('proto.vision.market.proto.GetProductRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.GetTarget', null, global);
goog.exportSymbol('proto.vision.market.proto.GetTargetRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.GetTick', null, global);
goog.exportSymbol('proto.vision.market.proto.GetTickRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.Kbar', null, global);
goog.exportSymbol('proto.vision.market.proto.MarketLogin', null, global);
goog.exportSymbol('proto.vision.market.proto.MarketLoginReq', null, global);
goog.exportSymbol('proto.vision.market.proto.MarketLoginRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.Product', null, global);
goog.exportSymbol('proto.vision.market.proto.SubKbar', null, global);
goog.exportSymbol('proto.vision.market.proto.SubKbarRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTarget', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTargetRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTick', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTickAll', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTickAllRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.SubTickRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.Target', null, global);
goog.exportSymbol('proto.vision.market.proto.Tick', null, global);
goog.exportSymbol('proto.vision.market.proto.TickDelta', null, global);
goog.exportSymbol('proto.vision.market.proto.TimeSeq', null, global);
goog.exportSymbol('proto.vision.market.proto.TimeSeqReq', null, global);
goog.exportSymbol('proto.vision.market.proto.TimeSeqRsp', null, global);
goog.exportSymbol('proto.vision.market.proto.TimeSeqSet', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.MarketLoginReq = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.MarketLoginReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.MarketLoginReq.displayName = 'proto.vision.market.proto.MarketLoginReq';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.MarketLoginReq.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.MarketLoginReq.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.MarketLoginReq} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.MarketLoginReq.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      broker: jspb.Message.getFieldWithDefault(msg, 1, ""),
      account: jspb.Message.getFieldWithDefault(msg, 2, ""),
      password: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.MarketLoginReq}
 */
proto.vision.market.proto.MarketLoginReq.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.MarketLoginReq();
  return proto.vision.market.proto.MarketLoginReq.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.MarketLoginReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.MarketLoginReq}
 */
proto.vision.market.proto.MarketLoginReq.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setBroker(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setAccount(value);
        break;
      case 3:
        var value = /** @type {string} */reader.readString();
        msg.setPassword(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.MarketLoginReq.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.MarketLoginReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.MarketLoginReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.MarketLoginReq.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
};

/**
 * optional string broker = 1;
 * @return {string}
 */
proto.vision.market.proto.MarketLoginReq.prototype.getBroker = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.MarketLoginReq.prototype.setBroker = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string account = 2;
 * @return {string}
 */
proto.vision.market.proto.MarketLoginReq.prototype.getAccount = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.MarketLoginReq.prototype.setAccount = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string password = 3;
 * @return {string}
 */
proto.vision.market.proto.MarketLoginReq.prototype.getPassword = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 3, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.MarketLoginReq.prototype.setPassword = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.MarketLogin = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.MarketLogin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.MarketLogin.displayName = 'proto.vision.market.proto.MarketLogin';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.MarketLogin.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.MarketLogin.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.MarketLogin} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.MarketLogin.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      broker: jspb.Message.getFieldWithDefault(msg, 10, ""),
      account: jspb.Message.getFieldWithDefault(msg, 11, ""),
      password: jspb.Message.getFieldWithDefault(msg, 12, ""),
      tradingDay: jspb.Message.getFieldWithDefault(msg, 13, ""),
      loginTime: jspb.Message.getFieldWithDefault(msg, 15, ""),
      userName: jspb.Message.getFieldWithDefault(msg, 16, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.MarketLogin}
 */
proto.vision.market.proto.MarketLogin.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.MarketLogin();
  return proto.vision.market.proto.MarketLogin.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.MarketLogin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.MarketLogin}
 */
proto.vision.market.proto.MarketLogin.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 10:
        var value = /** @type {string} */reader.readString();
        msg.setBroker(value);
        break;
      case 11:
        var value = /** @type {string} */reader.readString();
        msg.setAccount(value);
        break;
      case 12:
        var value = /** @type {string} */reader.readString();
        msg.setPassword(value);
        break;
      case 13:
        var value = /** @type {string} */reader.readString();
        msg.setTradingDay(value);
        break;
      case 15:
        var value = /** @type {string} */reader.readString();
        msg.setLoginTime(value);
        break;
      case 16:
        var value = /** @type {string} */reader.readString();
        msg.setUserName(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.MarketLogin.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.MarketLogin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.MarketLogin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.MarketLogin.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getTradingDay();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getLoginTime();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
};

/**
 * optional string broker = 10;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getBroker = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 10, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setBroker = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string account = 11;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getAccount = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 11, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setAccount = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string password = 12;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getPassword = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 12, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setPassword = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string trading_day = 13;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getTradingDay = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 13, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setTradingDay = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string login_time = 15;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getLoginTime = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 15, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setLoginTime = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional string user_name = 16;
 * @return {string}
 */
proto.vision.market.proto.MarketLogin.prototype.getUserName = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 16, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.MarketLogin.prototype.setUserName = function (value) {
  jspb.Message.setProto3StringField(this, 16, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.MarketLoginRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.MarketLoginRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.MarketLoginRsp.displayName = 'proto.vision.market.proto.MarketLoginRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.MarketLoginRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.MarketLoginRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.MarketLoginRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.MarketLoginRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
      data: (f = msg.getData()) && proto.vision.market.proto.MarketLogin.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.MarketLoginRsp}
 */
proto.vision.market.proto.MarketLoginRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.MarketLoginRsp();
  return proto.vision.market.proto.MarketLoginRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.MarketLoginRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.MarketLoginRsp}
 */
proto.vision.market.proto.MarketLoginRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 2:
        var value = new Object_pb.Error();
        reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = new proto.vision.market.proto.MarketLogin();
        reader.readMessage(value, proto.vision.market.proto.MarketLogin.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.MarketLoginRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.MarketLoginRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.MarketLoginRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(2, f, Object_pb.Error.serializeBinaryToWriter);
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(10, f, proto.vision.market.proto.MarketLogin.serializeBinaryToWriter);
  }
};

/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, Object_pb.Error, 2)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.MarketLoginRsp.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

proto.vision.market.proto.MarketLoginRsp.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.hasError = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional MarketLogin data = 10;
 * @return {?proto.vision.market.proto.MarketLogin}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.getData = function () {
  return (/** @type{?proto.vision.market.proto.MarketLogin} */jspb.Message.getWrapperField(this, proto.vision.market.proto.MarketLogin, 10)
  );
};

/** @param {?proto.vision.market.proto.MarketLogin|undefined} value */
proto.vision.market.proto.MarketLoginRsp.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

proto.vision.market.proto.MarketLoginRsp.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.MarketLoginRsp.prototype.hasData = function () {
  return jspb.Message.getField(this, 10) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.Product = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.Product.displayName = 'proto.vision.market.proto.Product';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.Product.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.Product.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.Product} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.Product.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      identity: jspb.Message.getFieldWithDefault(msg, 18, 0),
      productCode: jspb.Message.getFieldWithDefault(msg, 17, ""),
      productId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      productName: jspb.Message.getFieldWithDefault(msg, 2, ""),
      productClass: jspb.Message.getFieldWithDefault(msg, 3, 0),
      exchangeId: jspb.Message.getFieldWithDefault(msg, 4, 0),
      currencyId: jspb.Message.getFieldWithDefault(msg, 5, 0),
      orderMarketMax: jspb.Message.getFieldWithDefault(msg, 6, 0),
      orderMarketMin: jspb.Message.getFieldWithDefault(msg, 7, 0),
      orderLimitMax: jspb.Message.getFieldWithDefault(msg, 8, 0),
      orderLimitMin: jspb.Message.getFieldWithDefault(msg, 9, 0),
      positionType: jspb.Message.getFieldWithDefault(msg, 10, 0),
      positionDateType: jspb.Message.getFieldWithDefault(msg, 11, 0),
      multiple: jspb.Message.getFieldWithDefault(msg, 12, 0),
      priceTick: +jspb.Message.getFieldWithDefault(msg, 13, 0.0),
      stamp: jspb.Message.getFieldWithDefault(msg, 14, 0),
      productView: jspb.Message.getFieldWithDefault(msg, 15, ""),
      dst: jspb.Message.getFieldWithDefault(msg, 16, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.Product}
 */
proto.vision.market.proto.Product.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.Product();
  return proto.vision.market.proto.Product.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.Product}
 */
proto.vision.market.proto.Product.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 18:
        var value = /** @type {number} */reader.readUint32();
        msg.setIdentity(value);
        break;
      case 17:
        var value = /** @type {string} */reader.readString();
        msg.setProductCode(value);
        break;
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setProductId(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setProductName(value);
        break;
      case 3:
        var value = /** @type {number} */reader.readUint32();
        msg.setProductClass(value);
        break;
      case 4:
        var value = /** @type {number} */reader.readUint32();
        msg.setExchangeId(value);
        break;
      case 5:
        var value = /** @type {number} */reader.readUint32();
        msg.setCurrencyId(value);
        break;
      case 6:
        var value = /** @type {number} */reader.readUint32();
        msg.setOrderMarketMax(value);
        break;
      case 7:
        var value = /** @type {number} */reader.readUint32();
        msg.setOrderMarketMin(value);
        break;
      case 8:
        var value = /** @type {number} */reader.readUint32();
        msg.setOrderLimitMax(value);
        break;
      case 9:
        var value = /** @type {number} */reader.readUint32();
        msg.setOrderLimitMin(value);
        break;
      case 10:
        var value = /** @type {number} */reader.readUint32();
        msg.setPositionType(value);
        break;
      case 11:
        var value = /** @type {number} */reader.readUint32();
        msg.setPositionDateType(value);
        break;
      case 12:
        var value = /** @type {number} */reader.readUint32();
        msg.setMultiple(value);
        break;
      case 13:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceTick(value);
        break;
      case 14:
        var value = /** @type {number} */reader.readUint32();
        msg.setStamp(value);
        break;
      case 15:
        var value = /** @type {string} */reader.readString();
        msg.setProductView(value);
        break;
      case 16:
        var value = /** @type {boolean} */reader.readBool();
        msg.setDst(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.Product.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Product.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getIdentity();
  if (f !== 0) {
    writer.writeUint32(18, f);
  }
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getProductClass();
  if (f !== 0) {
    writer.writeUint32(3, f);
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(4, f);
  }
  f = message.getCurrencyId();
  if (f !== 0) {
    writer.writeUint32(5, f);
  }
  f = message.getOrderMarketMax();
  if (f !== 0) {
    writer.writeUint32(6, f);
  }
  f = message.getOrderMarketMin();
  if (f !== 0) {
    writer.writeUint32(7, f);
  }
  f = message.getOrderLimitMax();
  if (f !== 0) {
    writer.writeUint32(8, f);
  }
  f = message.getOrderLimitMin();
  if (f !== 0) {
    writer.writeUint32(9, f);
  }
  f = message.getPositionType();
  if (f !== 0) {
    writer.writeUint32(10, f);
  }
  f = message.getPositionDateType();
  if (f !== 0) {
    writer.writeUint32(11, f);
  }
  f = message.getMultiple();
  if (f !== 0) {
    writer.writeUint32(12, f);
  }
  f = message.getPriceTick();
  if (f !== 0.0) {
    writer.writeDouble(13, f);
  }
  f = message.getStamp();
  if (f !== 0) {
    writer.writeUint32(14, f);
  }
  f = message.getProductView();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getDst();
  if (f) {
    writer.writeBool(16, f);
  }
};

/**
 * optional uint32 identity = 18;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getIdentity = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 18, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setIdentity = function (value) {
  jspb.Message.setProto3IntField(this, 18, value);
};

/**
 * optional string product_code = 17;
 * @return {string}
 */
proto.vision.market.proto.Product.prototype.getProductCode = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 17, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Product.prototype.setProductCode = function (value) {
  jspb.Message.setProto3StringField(this, 17, value);
};

/**
 * optional string product_id = 1;
 * @return {string}
 */
proto.vision.market.proto.Product.prototype.getProductId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Product.prototype.setProductId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string product_name = 2;
 * @return {string}
 */
proto.vision.market.proto.Product.prototype.getProductName = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Product.prototype.setProductName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional uint32 product_class = 3;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getProductClass = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setProductClass = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional uint32 exchange_id = 4;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getExchangeId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setExchangeId = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional uint32 currency_id = 5;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getCurrencyId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setCurrencyId = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional uint32 order_market_max = 6;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getOrderMarketMax = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setOrderMarketMax = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional uint32 order_market_min = 7;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getOrderMarketMin = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setOrderMarketMin = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};

/**
 * optional uint32 order_limit_max = 8;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getOrderLimitMax = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 8, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setOrderLimitMax = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};

/**
 * optional uint32 order_limit_min = 9;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getOrderLimitMin = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 9, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setOrderLimitMin = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};

/**
 * optional uint32 position_type = 10;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getPositionType = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setPositionType = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional uint32 position_date_type = 11;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getPositionDateType = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 11, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setPositionDateType = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * optional uint32 multiple = 12;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getMultiple = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 12, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setMultiple = function (value) {
  jspb.Message.setProto3IntField(this, 12, value);
};

/**
 * optional double price_tick = 13;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getPriceTick = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 13, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setPriceTick = function (value) {
  jspb.Message.setProto3FloatField(this, 13, value);
};

/**
 * optional uint32 stamp = 14;
 * @return {number}
 */
proto.vision.market.proto.Product.prototype.getStamp = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 14, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Product.prototype.setStamp = function (value) {
  jspb.Message.setProto3IntField(this, 14, value);
};

/**
 * optional string product_view = 15;
 * @return {string}
 */
proto.vision.market.proto.Product.prototype.getProductView = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 15, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Product.prototype.setProductView = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional bool dst = 16;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.vision.market.proto.Product.prototype.getDst = function () {
  return (/** @type {boolean} */jspb.Message.getFieldWithDefault(this, 16, false)
  );
};

/** @param {boolean} value */
proto.vision.market.proto.Product.prototype.setDst = function (value) {
  jspb.Message.setProto3BooleanField(this, 16, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.Target = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.Target, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.Target.displayName = 'proto.vision.market.proto.Target';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.Target.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.Target.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.Target} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.Target.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      identity: jspb.Message.getFieldWithDefault(msg, 10, 0),
      targetCode: jspb.Message.getFieldWithDefault(msg, 8, ""),
      targetView: jspb.Message.getFieldWithDefault(msg, 9, ""),
      targetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      targetName: jspb.Message.getFieldWithDefault(msg, 2, ""),
      dateCreate: jspb.Message.getFieldWithDefault(msg, 3, ""),
      dateOpen: jspb.Message.getFieldWithDefault(msg, 4, ""),
      statePhase: jspb.Message.getFieldWithDefault(msg, 5, 0),
      stateTrading: jspb.Message.getFieldWithDefault(msg, 6, false),
      stamp: jspb.Message.getFieldWithDefault(msg, 7, 0),
      dateExpire: jspb.Message.getFieldWithDefault(msg, 21, ""),
      dateDeliveryStart: jspb.Message.getFieldWithDefault(msg, 22, ""),
      dateDeliveryEnd: jspb.Message.getFieldWithDefault(msg, 23, ""),
      deliveryMonth: jspb.Message.getFieldWithDefault(msg, 24, 0),
      marginSideAlgor: jspb.Message.getFieldWithDefault(msg, 25, false),
      marginLong: +jspb.Message.getFieldWithDefault(msg, 26, 0.0),
      marginShort: +jspb.Message.getFieldWithDefault(msg, 27, 0.0),
      productId: jspb.Message.getFieldWithDefault(msg, 29, ""),
      productClass: jspb.Message.getFieldWithDefault(msg, 30, 0),
      exchangeId: jspb.Message.getFieldWithDefault(msg, 31, 0),
      multiple: jspb.Message.getFieldWithDefault(msg, 32, 0),
      priceTick: +jspb.Message.getFieldWithDefault(msg, 33, 0.0),
      marginLongValue: +jspb.Message.getFieldWithDefault(msg, 34, 0.0),
      marginShortValue: +jspb.Message.getFieldWithDefault(msg, 35, 0.0),
      commissionLong: +jspb.Message.getFieldWithDefault(msg, 36, 0.0),
      commissionShort: +jspb.Message.getFieldWithDefault(msg, 37, 0.0),
      commissionLongValue: +jspb.Message.getFieldWithDefault(msg, 38, 0.0),
      commissionShortValue: +jspb.Message.getFieldWithDefault(msg, 39, 0.0),
      priceStrick: +jspb.Message.getFieldWithDefault(msg, 41, 0.0),
      optionType: jspb.Message.getFieldWithDefault(msg, 42, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.Target}
 */
proto.vision.market.proto.Target.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.Target();
  return proto.vision.market.proto.Target.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.Target} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.Target}
 */
proto.vision.market.proto.Target.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 10:
        var value = /** @type {number} */reader.readUint64();
        msg.setIdentity(value);
        break;
      case 8:
        var value = /** @type {string} */reader.readString();
        msg.setTargetCode(value);
        break;
      case 9:
        var value = /** @type {string} */reader.readString();
        msg.setTargetView(value);
        break;
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setTargetId(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setTargetName(value);
        break;
      case 3:
        var value = /** @type {string} */reader.readString();
        msg.setDateCreate(value);
        break;
      case 4:
        var value = /** @type {string} */reader.readString();
        msg.setDateOpen(value);
        break;
      case 5:
        var value = /** @type {number} */reader.readUint32();
        msg.setStatePhase(value);
        break;
      case 6:
        var value = /** @type {boolean} */reader.readBool();
        msg.setStateTrading(value);
        break;
      case 7:
        var value = /** @type {number} */reader.readUint32();
        msg.setStamp(value);
        break;
      case 21:
        var value = /** @type {string} */reader.readString();
        msg.setDateExpire(value);
        break;
      case 22:
        var value = /** @type {string} */reader.readString();
        msg.setDateDeliveryStart(value);
        break;
      case 23:
        var value = /** @type {string} */reader.readString();
        msg.setDateDeliveryEnd(value);
        break;
      case 24:
        var value = /** @type {number} */reader.readUint32();
        msg.setDeliveryMonth(value);
        break;
      case 25:
        var value = /** @type {boolean} */reader.readBool();
        msg.setMarginSideAlgor(value);
        break;
      case 26:
        var value = /** @type {number} */reader.readDouble();
        msg.setMarginLong(value);
        break;
      case 27:
        var value = /** @type {number} */reader.readDouble();
        msg.setMarginShort(value);
        break;
      case 29:
        var value = /** @type {string} */reader.readString();
        msg.setProductId(value);
        break;
      case 30:
        var value = /** @type {number} */reader.readUint32();
        msg.setProductClass(value);
        break;
      case 31:
        var value = /** @type {number} */reader.readUint32();
        msg.setExchangeId(value);
        break;
      case 32:
        var value = /** @type {number} */reader.readUint32();
        msg.setMultiple(value);
        break;
      case 33:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceTick(value);
        break;
      case 34:
        var value = /** @type {number} */reader.readDouble();
        msg.setMarginLongValue(value);
        break;
      case 35:
        var value = /** @type {number} */reader.readDouble();
        msg.setMarginShortValue(value);
        break;
      case 36:
        var value = /** @type {number} */reader.readDouble();
        msg.setCommissionLong(value);
        break;
      case 37:
        var value = /** @type {number} */reader.readDouble();
        msg.setCommissionShort(value);
        break;
      case 38:
        var value = /** @type {number} */reader.readDouble();
        msg.setCommissionLongValue(value);
        break;
      case 39:
        var value = /** @type {number} */reader.readDouble();
        msg.setCommissionShortValue(value);
        break;
      case 41:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceStrick(value);
        break;
      case 42:
        var value = /** @type {boolean} */reader.readBool();
        msg.setOptionType(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.Target.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.Target.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.Target} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Target.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getIdentity();
  if (f !== 0) {
    writer.writeUint64(10, f);
  }
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getTargetView();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getTargetName();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getDateCreate();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getDateOpen();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatePhase();
  if (f !== 0) {
    writer.writeUint32(5, f);
  }
  f = message.getStateTrading();
  if (f) {
    writer.writeBool(6, f);
  }
  f = message.getStamp();
  if (f !== 0) {
    writer.writeUint32(7, f);
  }
  f = message.getDateExpire();
  if (f.length > 0) {
    writer.writeString(21, f);
  }
  f = message.getDateDeliveryStart();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
  f = message.getDateDeliveryEnd();
  if (f.length > 0) {
    writer.writeString(23, f);
  }
  f = message.getDeliveryMonth();
  if (f !== 0) {
    writer.writeUint32(24, f);
  }
  f = message.getMarginSideAlgor();
  if (f) {
    writer.writeBool(25, f);
  }
  f = message.getMarginLong();
  if (f !== 0.0) {
    writer.writeDouble(26, f);
  }
  f = message.getMarginShort();
  if (f !== 0.0) {
    writer.writeDouble(27, f);
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(29, f);
  }
  f = message.getProductClass();
  if (f !== 0) {
    writer.writeUint32(30, f);
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(31, f);
  }
  f = message.getMultiple();
  if (f !== 0) {
    writer.writeUint32(32, f);
  }
  f = message.getPriceTick();
  if (f !== 0.0) {
    writer.writeDouble(33, f);
  }
  f = message.getMarginLongValue();
  if (f !== 0.0) {
    writer.writeDouble(34, f);
  }
  f = message.getMarginShortValue();
  if (f !== 0.0) {
    writer.writeDouble(35, f);
  }
  f = message.getCommissionLong();
  if (f !== 0.0) {
    writer.writeDouble(36, f);
  }
  f = message.getCommissionShort();
  if (f !== 0.0) {
    writer.writeDouble(37, f);
  }
  f = message.getCommissionLongValue();
  if (f !== 0.0) {
    writer.writeDouble(38, f);
  }
  f = message.getCommissionShortValue();
  if (f !== 0.0) {
    writer.writeDouble(39, f);
  }
  f = message.getPriceStrick();
  if (f !== 0.0) {
    writer.writeDouble(41, f);
  }
  f = message.getOptionType();
  if (f) {
    writer.writeBool(42, f);
  }
};

/**
 * optional uint64 identity = 10;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getIdentity = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setIdentity = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional string target_code = 8;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getTargetCode = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 8, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Target.prototype.setTargetCode = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string target_view = 9;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getTargetView = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 9, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Target.prototype.setTargetView = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string target_id = 1;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getTargetId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Target.prototype.setTargetId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string target_name = 2;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getTargetName = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Target.prototype.setTargetName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string date_create = 3;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getDateCreate = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 3, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Target.prototype.setDateCreate = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string date_open = 4;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getDateOpen = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 4, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Target.prototype.setDateOpen = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional uint32 state_phase = 5;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getStatePhase = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setStatePhase = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional bool state_trading = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.vision.market.proto.Target.prototype.getStateTrading = function () {
  return (/** @type {boolean} */jspb.Message.getFieldWithDefault(this, 6, false)
  );
};

/** @param {boolean} value */
proto.vision.market.proto.Target.prototype.setStateTrading = function (value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};

/**
 * optional uint32 stamp = 7;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getStamp = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setStamp = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};

/**
 * optional string date_expire = 21;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getDateExpire = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 21, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Target.prototype.setDateExpire = function (value) {
  jspb.Message.setProto3StringField(this, 21, value);
};

/**
 * optional string date_delivery_start = 22;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getDateDeliveryStart = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 22, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Target.prototype.setDateDeliveryStart = function (value) {
  jspb.Message.setProto3StringField(this, 22, value);
};

/**
 * optional string date_delivery_end = 23;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getDateDeliveryEnd = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 23, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Target.prototype.setDateDeliveryEnd = function (value) {
  jspb.Message.setProto3StringField(this, 23, value);
};

/**
 * optional uint32 delivery_month = 24;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getDeliveryMonth = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 24, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setDeliveryMonth = function (value) {
  jspb.Message.setProto3IntField(this, 24, value);
};

/**
 * optional bool margin_side_algor = 25;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.vision.market.proto.Target.prototype.getMarginSideAlgor = function () {
  return (/** @type {boolean} */jspb.Message.getFieldWithDefault(this, 25, false)
  );
};

/** @param {boolean} value */
proto.vision.market.proto.Target.prototype.setMarginSideAlgor = function (value) {
  jspb.Message.setProto3BooleanField(this, 25, value);
};

/**
 * optional double margin_long = 26;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getMarginLong = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 26, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setMarginLong = function (value) {
  jspb.Message.setProto3FloatField(this, 26, value);
};

/**
 * optional double margin_short = 27;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getMarginShort = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 27, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setMarginShort = function (value) {
  jspb.Message.setProto3FloatField(this, 27, value);
};

/**
 * optional string product_id = 29;
 * @return {string}
 */
proto.vision.market.proto.Target.prototype.getProductId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 29, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Target.prototype.setProductId = function (value) {
  jspb.Message.setProto3StringField(this, 29, value);
};

/**
 * optional uint32 product_class = 30;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getProductClass = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 30, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setProductClass = function (value) {
  jspb.Message.setProto3IntField(this, 30, value);
};

/**
 * optional uint32 exchange_id = 31;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getExchangeId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 31, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setExchangeId = function (value) {
  jspb.Message.setProto3IntField(this, 31, value);
};

/**
 * optional uint32 multiple = 32;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getMultiple = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 32, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setMultiple = function (value) {
  jspb.Message.setProto3IntField(this, 32, value);
};

/**
 * optional double price_tick = 33;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getPriceTick = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 33, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setPriceTick = function (value) {
  jspb.Message.setProto3FloatField(this, 33, value);
};

/**
 * optional double margin_long_value = 34;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getMarginLongValue = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 34, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setMarginLongValue = function (value) {
  jspb.Message.setProto3FloatField(this, 34, value);
};

/**
 * optional double margin_short_value = 35;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getMarginShortValue = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 35, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setMarginShortValue = function (value) {
  jspb.Message.setProto3FloatField(this, 35, value);
};

/**
 * optional double commission_long = 36;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getCommissionLong = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 36, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setCommissionLong = function (value) {
  jspb.Message.setProto3FloatField(this, 36, value);
};

/**
 * optional double commission_short = 37;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getCommissionShort = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 37, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setCommissionShort = function (value) {
  jspb.Message.setProto3FloatField(this, 37, value);
};

/**
 * optional double commission_long_value = 38;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getCommissionLongValue = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 38, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setCommissionLongValue = function (value) {
  jspb.Message.setProto3FloatField(this, 38, value);
};

/**
 * optional double commission_short_value = 39;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getCommissionShortValue = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 39, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setCommissionShortValue = function (value) {
  jspb.Message.setProto3FloatField(this, 39, value);
};

/**
 * optional double price_strick = 41;
 * @return {number}
 */
proto.vision.market.proto.Target.prototype.getPriceStrick = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 41, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Target.prototype.setPriceStrick = function (value) {
  jspb.Message.setProto3FloatField(this, 41, value);
};

/**
 * optional bool option_type = 42;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.vision.market.proto.Target.prototype.getOptionType = function () {
  return (/** @type {boolean} */jspb.Message.getFieldWithDefault(this, 42, false)
  );
};

/** @param {boolean} value */
proto.vision.market.proto.Target.prototype.setOptionType = function (value) {
  jspb.Message.setProto3BooleanField(this, 42, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetProduct = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetProduct.displayName = 'proto.vision.market.proto.GetProduct';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.GetProduct.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.GetProduct.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.GetProduct} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.GetProduct.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      productId: jspb.Message.getFieldWithDefault(msg, 10, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetProduct}
 */
proto.vision.market.proto.GetProduct.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetProduct();
  return proto.vision.market.proto.GetProduct.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetProduct}
 */
proto.vision.market.proto.GetProduct.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 10:
        var value = /** @type {string} */reader.readString();
        msg.setProductId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetProduct.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetProduct.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(1, f);
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
};

/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.GetProduct.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.GetProduct.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string product_id = 10;
 * @return {string}
 */
proto.vision.market.proto.GetProduct.prototype.getProductId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 10, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.GetProduct.prototype.setProductId = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetProductRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetProductRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetProductRsp.displayName = 'proto.vision.market.proto.GetProductRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.GetProductRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.GetProductRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.GetProductRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.GetProductRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
      data: (f = msg.getData()) && proto.vision.market.proto.Product.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetProductRsp}
 */
proto.vision.market.proto.GetProductRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetProductRsp();
  return proto.vision.market.proto.GetProductRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetProductRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetProductRsp}
 */
proto.vision.market.proto.GetProductRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 2:
        var value = new Object_pb.Error();
        reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = new proto.vision.market.proto.Product();
        reader.readMessage(value, proto.vision.market.proto.Product.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetProductRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetProductRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetProductRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetProductRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(2, f, Object_pb.Error.serializeBinaryToWriter);
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(10, f, proto.vision.market.proto.Product.serializeBinaryToWriter);
  }
};

/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.GetProductRsp.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, Object_pb.Error, 2)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.GetProductRsp.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

proto.vision.market.proto.GetProductRsp.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetProductRsp.prototype.hasError = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional Product data = 10;
 * @return {?proto.vision.market.proto.Product}
 */
proto.vision.market.proto.GetProductRsp.prototype.getData = function () {
  return (/** @type{?proto.vision.market.proto.Product} */jspb.Message.getWrapperField(this, proto.vision.market.proto.Product, 10)
  );
};

/** @param {?proto.vision.market.proto.Product|undefined} value */
proto.vision.market.proto.GetProductRsp.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

proto.vision.market.proto.GetProductRsp.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetProductRsp.prototype.hasData = function () {
  return jspb.Message.getField(this, 10) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetTarget = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetTarget, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetTarget.displayName = 'proto.vision.market.proto.GetTarget';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.GetTarget.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.GetTarget.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.GetTarget} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.GetTarget.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      targetId: jspb.Message.getFieldWithDefault(msg, 10, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetTarget}
 */
proto.vision.market.proto.GetTarget.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetTarget();
  return proto.vision.market.proto.GetTarget.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetTarget} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetTarget}
 */
proto.vision.market.proto.GetTarget.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 10:
        var value = /** @type {string} */reader.readString();
        msg.setTargetId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetTarget.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetTarget.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetTarget} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTarget.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
};

/**
 * optional string target_id = 10;
 * @return {string}
 */
proto.vision.market.proto.GetTarget.prototype.getTargetId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 10, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.GetTarget.prototype.setTargetId = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetTargetRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetTargetRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetTargetRsp.displayName = 'proto.vision.market.proto.GetTargetRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.GetTargetRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.GetTargetRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.GetTargetRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.GetTargetRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
      data: (f = msg.getData()) && proto.vision.market.proto.Target.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetTargetRsp}
 */
proto.vision.market.proto.GetTargetRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetTargetRsp();
  return proto.vision.market.proto.GetTargetRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetTargetRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetTargetRsp}
 */
proto.vision.market.proto.GetTargetRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 2:
        var value = new Object_pb.Error();
        reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = new proto.vision.market.proto.Target();
        reader.readMessage(value, proto.vision.market.proto.Target.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetTargetRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetTargetRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetTargetRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTargetRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(2, f, Object_pb.Error.serializeBinaryToWriter);
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(10, f, proto.vision.market.proto.Target.serializeBinaryToWriter);
  }
};

/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.GetTargetRsp.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, Object_pb.Error, 2)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.GetTargetRsp.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

proto.vision.market.proto.GetTargetRsp.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetTargetRsp.prototype.hasError = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional Target data = 10;
 * @return {?proto.vision.market.proto.Target}
 */
proto.vision.market.proto.GetTargetRsp.prototype.getData = function () {
  return (/** @type{?proto.vision.market.proto.Target} */jspb.Message.getWrapperField(this, proto.vision.market.proto.Target, 10)
  );
};

/** @param {?proto.vision.market.proto.Target|undefined} value */
proto.vision.market.proto.GetTargetRsp.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

proto.vision.market.proto.GetTargetRsp.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetTargetRsp.prototype.hasData = function () {
  return jspb.Message.getField(this, 10) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTarget = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubTarget, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTarget.displayName = 'proto.vision.market.proto.SubTarget';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.SubTarget.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.SubTarget.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.SubTarget} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.SubTarget.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      productClass: jspb.Message.getFieldWithDefault(msg, 10, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTarget}
 */
proto.vision.market.proto.SubTarget.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTarget();
  return proto.vision.market.proto.SubTarget.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTarget} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTarget}
 */
proto.vision.market.proto.SubTarget.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 10:
        var value = /** @type {number} */reader.readUint32();
        msg.setProductClass(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTarget.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTarget.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTarget} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTarget.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(1, f);
  }
  f = message.getProductClass();
  if (f !== 0) {
    writer.writeUint32(10, f);
  }
};

/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.SubTarget.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubTarget.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional uint32 product_class = 10;
 * @return {number}
 */
proto.vision.market.proto.SubTarget.prototype.getProductClass = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubTarget.prototype.setProductClass = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTargetRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubTargetRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTargetRsp.displayName = 'proto.vision.market.proto.SubTargetRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.SubTargetRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.SubTargetRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.SubTargetRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.SubTargetRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
      data: (f = msg.getData()) && proto.vision.market.proto.SubTarget.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTargetRsp}
 */
proto.vision.market.proto.SubTargetRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTargetRsp();
  return proto.vision.market.proto.SubTargetRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTargetRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTargetRsp}
 */
proto.vision.market.proto.SubTargetRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 2:
        var value = new Object_pb.Error();
        reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = new proto.vision.market.proto.SubTarget();
        reader.readMessage(value, proto.vision.market.proto.SubTarget.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTargetRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTargetRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTargetRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTargetRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(2, f, Object_pb.Error.serializeBinaryToWriter);
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(10, f, proto.vision.market.proto.SubTarget.serializeBinaryToWriter);
  }
};

/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.SubTargetRsp.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, Object_pb.Error, 2)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.SubTargetRsp.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

proto.vision.market.proto.SubTargetRsp.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTargetRsp.prototype.hasError = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional SubTarget data = 10;
 * @return {?proto.vision.market.proto.SubTarget}
 */
proto.vision.market.proto.SubTargetRsp.prototype.getData = function () {
  return (/** @type{?proto.vision.market.proto.SubTarget} */jspb.Message.getWrapperField(this, proto.vision.market.proto.SubTarget, 10)
  );
};

/** @param {?proto.vision.market.proto.SubTarget|undefined} value */
proto.vision.market.proto.SubTargetRsp.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

proto.vision.market.proto.SubTargetRsp.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTargetRsp.prototype.hasData = function () {
  return jspb.Message.getField(this, 10) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.Tick = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.Tick, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.Tick.displayName = 'proto.vision.market.proto.Tick';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.Tick.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.Tick.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.Tick} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.Tick.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      volumeAsk1: jspb.Message.getFieldWithDefault(msg, 1, 0),
      volumeAsk2: jspb.Message.getFieldWithDefault(msg, 2, 0),
      volumeAsk3: jspb.Message.getFieldWithDefault(msg, 3, 0),
      volumeAsk4: jspb.Message.getFieldWithDefault(msg, 4, 0),
      volumeAsk5: jspb.Message.getFieldWithDefault(msg, 5, 0),
      volumeBid1: jspb.Message.getFieldWithDefault(msg, 6, 0),
      volumeBid2: jspb.Message.getFieldWithDefault(msg, 7, 0),
      volumeBid3: jspb.Message.getFieldWithDefault(msg, 8, 0),
      volumeBid4: jspb.Message.getFieldWithDefault(msg, 9, 0),
      volumeBid5: jspb.Message.getFieldWithDefault(msg, 10, 0),
      priceAsk1: +jspb.Message.getFieldWithDefault(msg, 21, 0.0),
      priceAsk2: +jspb.Message.getFieldWithDefault(msg, 22, 0.0),
      priceAsk3: +jspb.Message.getFieldWithDefault(msg, 23, 0.0),
      priceAsk4: +jspb.Message.getFieldWithDefault(msg, 24, 0.0),
      priceAsk5: +jspb.Message.getFieldWithDefault(msg, 25, 0.0),
      priceBid1: +jspb.Message.getFieldWithDefault(msg, 26, 0.0),
      priceBid2: +jspb.Message.getFieldWithDefault(msg, 27, 0.0),
      priceBid3: +jspb.Message.getFieldWithDefault(msg, 28, 0.0),
      priceBid4: +jspb.Message.getFieldWithDefault(msg, 29, 0.0),
      priceBid5: +jspb.Message.getFieldWithDefault(msg, 30, 0.0),
      priceLast: +jspb.Message.getFieldWithDefault(msg, 51, 0.0),
      priceOpen: +jspb.Message.getFieldWithDefault(msg, 52, 0.0),
      priceClose: +jspb.Message.getFieldWithDefault(msg, 53, 0.0),
      priceLow: +jspb.Message.getFieldWithDefault(msg, 54, 0.0),
      priceHigh: +jspb.Message.getFieldWithDefault(msg, 55, 0.0),
      priceLowLimit: +jspb.Message.getFieldWithDefault(msg, 56, 0.0),
      priceHighLimit: +jspb.Message.getFieldWithDefault(msg, 57, 0.0),
      priceCloseLast: +jspb.Message.getFieldWithDefault(msg, 58, 0.0),
      priceAverage: +jspb.Message.getFieldWithDefault(msg, 59, 0.0),
      priceSettlement: +jspb.Message.getFieldWithDefault(msg, 65, 0.0),
      priceSettlementLast: +jspb.Message.getFieldWithDefault(msg, 66, 0.0),
      targetId: jspb.Message.getFieldWithDefault(msg, 71, ""),
      exchangeId: jspb.Message.getFieldWithDefault(msg, 72, 0),
      tradingDay: jspb.Message.getFieldWithDefault(msg, 73, ""),
      updateDate: jspb.Message.getFieldWithDefault(msg, 74, ""),
      updateTime: jspb.Message.getFieldWithDefault(msg, 75, ""),
      updateMilli: jspb.Message.getFieldWithDefault(msg, 76, 0),
      position: jspb.Message.getFieldWithDefault(msg, 77, 0),
      volume: jspb.Message.getFieldWithDefault(msg, 78, 0),
      volumeDelta: jspb.Message.getFieldWithDefault(msg, 79, 0),
      amount: +jspb.Message.getFieldWithDefault(msg, 80, 0.0),
      amountDelta: +jspb.Message.getFieldWithDefault(msg, 81, 0.0),
      productClass: jspb.Message.getFieldWithDefault(msg, 82, 0),
      targetCode: jspb.Message.getFieldWithDefault(msg, 83, ""),
      stamp: jspb.Message.getFieldWithDefault(msg, 88, 0),
      source: jspb.Message.getFieldWithDefault(msg, 89, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.Tick}
 */
proto.vision.market.proto.Tick.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.Tick();
  return proto.vision.market.proto.Tick.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.Tick} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.Tick}
 */
proto.vision.market.proto.Tick.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeAsk1(value);
        break;
      case 2:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeAsk2(value);
        break;
      case 3:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeAsk3(value);
        break;
      case 4:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeAsk4(value);
        break;
      case 5:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeAsk5(value);
        break;
      case 6:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeBid1(value);
        break;
      case 7:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeBid2(value);
        break;
      case 8:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeBid3(value);
        break;
      case 9:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeBid4(value);
        break;
      case 10:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeBid5(value);
        break;
      case 21:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceAsk1(value);
        break;
      case 22:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceAsk2(value);
        break;
      case 23:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceAsk3(value);
        break;
      case 24:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceAsk4(value);
        break;
      case 25:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceAsk5(value);
        break;
      case 26:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceBid1(value);
        break;
      case 27:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceBid2(value);
        break;
      case 28:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceBid3(value);
        break;
      case 29:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceBid4(value);
        break;
      case 30:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceBid5(value);
        break;
      case 51:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceLast(value);
        break;
      case 52:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceOpen(value);
        break;
      case 53:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceClose(value);
        break;
      case 54:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceLow(value);
        break;
      case 55:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceHigh(value);
        break;
      case 56:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceLowLimit(value);
        break;
      case 57:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceHighLimit(value);
        break;
      case 58:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceCloseLast(value);
        break;
      case 59:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceAverage(value);
        break;
      case 65:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceSettlement(value);
        break;
      case 66:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceSettlementLast(value);
        break;
      case 71:
        var value = /** @type {string} */reader.readString();
        msg.setTargetId(value);
        break;
      case 72:
        var value = /** @type {number} */reader.readUint32();
        msg.setExchangeId(value);
        break;
      case 73:
        var value = /** @type {string} */reader.readString();
        msg.setTradingDay(value);
        break;
      case 74:
        var value = /** @type {string} */reader.readString();
        msg.setUpdateDate(value);
        break;
      case 75:
        var value = /** @type {string} */reader.readString();
        msg.setUpdateTime(value);
        break;
      case 76:
        var value = /** @type {number} */reader.readUint32();
        msg.setUpdateMilli(value);
        break;
      case 77:
        var value = /** @type {number} */reader.readUint64();
        msg.setPosition(value);
        break;
      case 78:
        var value = /** @type {number} */reader.readUint64();
        msg.setVolume(value);
        break;
      case 79:
        var value = /** @type {number} */reader.readUint32();
        msg.setVolumeDelta(value);
        break;
      case 80:
        var value = /** @type {number} */reader.readDouble();
        msg.setAmount(value);
        break;
      case 81:
        var value = /** @type {number} */reader.readDouble();
        msg.setAmountDelta(value);
        break;
      case 82:
        var value = /** @type {number} */reader.readUint32();
        msg.setProductClass(value);
        break;
      case 83:
        var value = /** @type {string} */reader.readString();
        msg.setTargetCode(value);
        break;
      case 88:
        var value = /** @type {number} */reader.readUint32();
        msg.setStamp(value);
        break;
      case 89:
        var value = /** @type {number} */reader.readUint32();
        msg.setSource(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.Tick.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.Tick.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.Tick} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Tick.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getVolumeAsk1();
  if (f !== 0) {
    writer.writeUint32(1, f);
  }
  f = message.getVolumeAsk2();
  if (f !== 0) {
    writer.writeUint32(2, f);
  }
  f = message.getVolumeAsk3();
  if (f !== 0) {
    writer.writeUint32(3, f);
  }
  f = message.getVolumeAsk4();
  if (f !== 0) {
    writer.writeUint32(4, f);
  }
  f = message.getVolumeAsk5();
  if (f !== 0) {
    writer.writeUint32(5, f);
  }
  f = message.getVolumeBid1();
  if (f !== 0) {
    writer.writeUint32(6, f);
  }
  f = message.getVolumeBid2();
  if (f !== 0) {
    writer.writeUint32(7, f);
  }
  f = message.getVolumeBid3();
  if (f !== 0) {
    writer.writeUint32(8, f);
  }
  f = message.getVolumeBid4();
  if (f !== 0) {
    writer.writeUint32(9, f);
  }
  f = message.getVolumeBid5();
  if (f !== 0) {
    writer.writeUint32(10, f);
  }
  f = message.getPriceAsk1();
  if (f !== 0.0) {
    writer.writeDouble(21, f);
  }
  f = message.getPriceAsk2();
  if (f !== 0.0) {
    writer.writeDouble(22, f);
  }
  f = message.getPriceAsk3();
  if (f !== 0.0) {
    writer.writeDouble(23, f);
  }
  f = message.getPriceAsk4();
  if (f !== 0.0) {
    writer.writeDouble(24, f);
  }
  f = message.getPriceAsk5();
  if (f !== 0.0) {
    writer.writeDouble(25, f);
  }
  f = message.getPriceBid1();
  if (f !== 0.0) {
    writer.writeDouble(26, f);
  }
  f = message.getPriceBid2();
  if (f !== 0.0) {
    writer.writeDouble(27, f);
  }
  f = message.getPriceBid3();
  if (f !== 0.0) {
    writer.writeDouble(28, f);
  }
  f = message.getPriceBid4();
  if (f !== 0.0) {
    writer.writeDouble(29, f);
  }
  f = message.getPriceBid5();
  if (f !== 0.0) {
    writer.writeDouble(30, f);
  }
  f = message.getPriceLast();
  if (f !== 0.0) {
    writer.writeDouble(51, f);
  }
  f = message.getPriceOpen();
  if (f !== 0.0) {
    writer.writeDouble(52, f);
  }
  f = message.getPriceClose();
  if (f !== 0.0) {
    writer.writeDouble(53, f);
  }
  f = message.getPriceLow();
  if (f !== 0.0) {
    writer.writeDouble(54, f);
  }
  f = message.getPriceHigh();
  if (f !== 0.0) {
    writer.writeDouble(55, f);
  }
  f = message.getPriceLowLimit();
  if (f !== 0.0) {
    writer.writeDouble(56, f);
  }
  f = message.getPriceHighLimit();
  if (f !== 0.0) {
    writer.writeDouble(57, f);
  }
  f = message.getPriceCloseLast();
  if (f !== 0.0) {
    writer.writeDouble(58, f);
  }
  f = message.getPriceAverage();
  if (f !== 0.0) {
    writer.writeDouble(59, f);
  }
  f = message.getPriceSettlement();
  if (f !== 0.0) {
    writer.writeDouble(65, f);
  }
  f = message.getPriceSettlementLast();
  if (f !== 0.0) {
    writer.writeDouble(66, f);
  }
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(71, f);
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(72, f);
  }
  f = message.getTradingDay();
  if (f.length > 0) {
    writer.writeString(73, f);
  }
  f = message.getUpdateDate();
  if (f.length > 0) {
    writer.writeString(74, f);
  }
  f = message.getUpdateTime();
  if (f.length > 0) {
    writer.writeString(75, f);
  }
  f = message.getUpdateMilli();
  if (f !== 0) {
    writer.writeUint32(76, f);
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeUint64(77, f);
  }
  f = message.getVolume();
  if (f !== 0) {
    writer.writeUint64(78, f);
  }
  f = message.getVolumeDelta();
  if (f !== 0) {
    writer.writeUint32(79, f);
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(80, f);
  }
  f = message.getAmountDelta();
  if (f !== 0.0) {
    writer.writeDouble(81, f);
  }
  f = message.getProductClass();
  if (f !== 0) {
    writer.writeUint32(82, f);
  }
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(83, f);
  }
  f = message.getStamp();
  if (f !== 0) {
    writer.writeUint32(88, f);
  }
  f = message.getSource();
  if (f !== 0) {
    writer.writeUint32(89, f);
  }
};

/**
 * optional uint32 volume_ask1 = 1;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeAsk1 = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeAsk1 = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional uint32 volume_ask2 = 2;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeAsk2 = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeAsk2 = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional uint32 volume_ask3 = 3;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeAsk3 = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeAsk3 = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional uint32 volume_ask4 = 4;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeAsk4 = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeAsk4 = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional uint32 volume_ask5 = 5;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeAsk5 = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeAsk5 = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional uint32 volume_bid1 = 6;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeBid1 = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeBid1 = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional uint32 volume_bid2 = 7;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeBid2 = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeBid2 = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};

/**
 * optional uint32 volume_bid3 = 8;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeBid3 = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 8, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeBid3 = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};

/**
 * optional uint32 volume_bid4 = 9;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeBid4 = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 9, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeBid4 = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};

/**
 * optional uint32 volume_bid5 = 10;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeBid5 = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeBid5 = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional double price_ask1 = 21;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAsk1 = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 21, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAsk1 = function (value) {
  jspb.Message.setProto3FloatField(this, 21, value);
};

/**
 * optional double price_ask2 = 22;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAsk2 = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 22, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAsk2 = function (value) {
  jspb.Message.setProto3FloatField(this, 22, value);
};

/**
 * optional double price_ask3 = 23;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAsk3 = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 23, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAsk3 = function (value) {
  jspb.Message.setProto3FloatField(this, 23, value);
};

/**
 * optional double price_ask4 = 24;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAsk4 = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 24, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAsk4 = function (value) {
  jspb.Message.setProto3FloatField(this, 24, value);
};

/**
 * optional double price_ask5 = 25;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAsk5 = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 25, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAsk5 = function (value) {
  jspb.Message.setProto3FloatField(this, 25, value);
};

/**
 * optional double price_bid1 = 26;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceBid1 = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 26, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceBid1 = function (value) {
  jspb.Message.setProto3FloatField(this, 26, value);
};

/**
 * optional double price_bid2 = 27;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceBid2 = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 27, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceBid2 = function (value) {
  jspb.Message.setProto3FloatField(this, 27, value);
};

/**
 * optional double price_bid3 = 28;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceBid3 = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 28, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceBid3 = function (value) {
  jspb.Message.setProto3FloatField(this, 28, value);
};

/**
 * optional double price_bid4 = 29;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceBid4 = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 29, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceBid4 = function (value) {
  jspb.Message.setProto3FloatField(this, 29, value);
};

/**
 * optional double price_bid5 = 30;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceBid5 = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 30, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceBid5 = function (value) {
  jspb.Message.setProto3FloatField(this, 30, value);
};

/**
 * optional double price_last = 51;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceLast = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 51, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceLast = function (value) {
  jspb.Message.setProto3FloatField(this, 51, value);
};

/**
 * optional double price_open = 52;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceOpen = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 52, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceOpen = function (value) {
  jspb.Message.setProto3FloatField(this, 52, value);
};

/**
 * optional double price_close = 53;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceClose = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 53, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceClose = function (value) {
  jspb.Message.setProto3FloatField(this, 53, value);
};

/**
 * optional double price_low = 54;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceLow = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 54, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceLow = function (value) {
  jspb.Message.setProto3FloatField(this, 54, value);
};

/**
 * optional double price_high = 55;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceHigh = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 55, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceHigh = function (value) {
  jspb.Message.setProto3FloatField(this, 55, value);
};

/**
 * optional double price_low_limit = 56;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceLowLimit = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 56, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceLowLimit = function (value) {
  jspb.Message.setProto3FloatField(this, 56, value);
};

/**
 * optional double price_high_limit = 57;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceHighLimit = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 57, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceHighLimit = function (value) {
  jspb.Message.setProto3FloatField(this, 57, value);
};

/**
 * optional double price_close_last = 58;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceCloseLast = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 58, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceCloseLast = function (value) {
  jspb.Message.setProto3FloatField(this, 58, value);
};

/**
 * optional double price_average = 59;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceAverage = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 59, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceAverage = function (value) {
  jspb.Message.setProto3FloatField(this, 59, value);
};

/**
 * optional double price_settlement = 65;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceSettlement = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 65, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceSettlement = function (value) {
  jspb.Message.setProto3FloatField(this, 65, value);
};

/**
 * optional double price_settlement_last = 66;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPriceSettlementLast = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 66, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPriceSettlementLast = function (value) {
  jspb.Message.setProto3FloatField(this, 66, value);
};

/**
 * optional string target_id = 71;
 * @return {string}
 */
proto.vision.market.proto.Tick.prototype.getTargetId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 71, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Tick.prototype.setTargetId = function (value) {
  jspb.Message.setProto3StringField(this, 71, value);
};

/**
 * optional uint32 exchange_id = 72;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getExchangeId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 72, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setExchangeId = function (value) {
  jspb.Message.setProto3IntField(this, 72, value);
};

/**
 * optional string trading_day = 73;
 * @return {string}
 */
proto.vision.market.proto.Tick.prototype.getTradingDay = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 73, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Tick.prototype.setTradingDay = function (value) {
  jspb.Message.setProto3StringField(this, 73, value);
};

/**
 * optional string update_date = 74;
 * @return {string}
 */
proto.vision.market.proto.Tick.prototype.getUpdateDate = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 74, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Tick.prototype.setUpdateDate = function (value) {
  jspb.Message.setProto3StringField(this, 74, value);
};

/**
 * optional string update_time = 75;
 * @return {string}
 */
proto.vision.market.proto.Tick.prototype.getUpdateTime = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 75, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Tick.prototype.setUpdateTime = function (value) {
  jspb.Message.setProto3StringField(this, 75, value);
};

/**
 * optional uint32 update_milli = 76;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getUpdateMilli = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 76, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setUpdateMilli = function (value) {
  jspb.Message.setProto3IntField(this, 76, value);
};

/**
 * optional uint64 position = 77;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getPosition = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 77, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setPosition = function (value) {
  jspb.Message.setProto3IntField(this, 77, value);
};

/**
 * optional uint64 volume = 78;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolume = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 78, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolume = function (value) {
  jspb.Message.setProto3IntField(this, 78, value);
};

/**
 * optional uint32 volume_delta = 79;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getVolumeDelta = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 79, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setVolumeDelta = function (value) {
  jspb.Message.setProto3IntField(this, 79, value);
};

/**
 * optional double amount = 80;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getAmount = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 80, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 80, value);
};

/**
 * optional double amount_delta = 81;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getAmountDelta = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 81, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setAmountDelta = function (value) {
  jspb.Message.setProto3FloatField(this, 81, value);
};

/**
 * optional uint32 product_class = 82;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getProductClass = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 82, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setProductClass = function (value) {
  jspb.Message.setProto3IntField(this, 82, value);
};

/**
 * optional string target_code = 83;
 * @return {string}
 */
proto.vision.market.proto.Tick.prototype.getTargetCode = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 83, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Tick.prototype.setTargetCode = function (value) {
  jspb.Message.setProto3StringField(this, 83, value);
};

/**
 * optional uint32 stamp = 88;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getStamp = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 88, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setStamp = function (value) {
  jspb.Message.setProto3IntField(this, 88, value);
};

/**
 * optional uint32 source = 89;
 * @return {number}
 */
proto.vision.market.proto.Tick.prototype.getSource = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 89, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Tick.prototype.setSource = function (value) {
  jspb.Message.setProto3IntField(this, 89, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.TickDelta = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.TickDelta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.TickDelta.displayName = 'proto.vision.market.proto.TickDelta';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.TickDelta.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.TickDelta.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.TickDelta} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.TickDelta.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.TickDelta}
 */
proto.vision.market.proto.TickDelta.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.TickDelta();
  return proto.vision.market.proto.TickDelta.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.TickDelta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.TickDelta}
 */
proto.vision.market.proto.TickDelta.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.TickDelta.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.TickDelta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.TickDelta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TickDelta.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.Kbar = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.Kbar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.Kbar.displayName = 'proto.vision.market.proto.Kbar';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.Kbar.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.Kbar.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.Kbar} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.Kbar.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      targetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      exchangeId: jspb.Message.getFieldWithDefault(msg, 2, 0),
      ktype: jspb.Message.getFieldWithDefault(msg, 3, 0),
      kunit: jspb.Message.getFieldWithDefault(msg, 4, 0),
      koption: jspb.Message.getFieldWithDefault(msg, 5, 0),
      kseq: jspb.Message.getFieldWithDefault(msg, 6, 0),
      stamp: jspb.Message.getFieldWithDefault(msg, 7, 0),
      time: jspb.Message.getFieldWithDefault(msg, 8, ""),
      tradingDay: jspb.Message.getFieldWithDefault(msg, 9, ""),
      updateDate: jspb.Message.getFieldWithDefault(msg, 10, ""),
      updateTime: jspb.Message.getFieldWithDefault(msg, 11, ""),
      priceOpen: +jspb.Message.getFieldWithDefault(msg, 12, 0.0),
      priceClose: +jspb.Message.getFieldWithDefault(msg, 13, 0.0),
      priceLow: +jspb.Message.getFieldWithDefault(msg, 14, 0.0),
      priceHigh: +jspb.Message.getFieldWithDefault(msg, 15, 0.0),
      priceSettlement: +jspb.Message.getFieldWithDefault(msg, 16, 0.0),
      priceAverage: +jspb.Message.getFieldWithDefault(msg, 17, 0.0),
      amount: +jspb.Message.getFieldWithDefault(msg, 18, 0.0),
      volume: jspb.Message.getFieldWithDefault(msg, 19, 0),
      volumeTick: jspb.Message.getFieldWithDefault(msg, 20, 0),
      position: jspb.Message.getFieldWithDefault(msg, 21, 0),
      targetCode: jspb.Message.getFieldWithDefault(msg, 22, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.Kbar}
 */
proto.vision.market.proto.Kbar.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.Kbar();
  return proto.vision.market.proto.Kbar.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.Kbar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.Kbar}
 */
proto.vision.market.proto.Kbar.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setTargetId(value);
        break;
      case 2:
        var value = /** @type {number} */reader.readUint32();
        msg.setExchangeId(value);
        break;
      case 3:
        var value = /** @type {number} */reader.readUint32();
        msg.setKtype(value);
        break;
      case 4:
        var value = /** @type {number} */reader.readUint32();
        msg.setKunit(value);
        break;
      case 5:
        var value = /** @type {number} */reader.readUint32();
        msg.setKoption(value);
        break;
      case 6:
        var value = /** @type {number} */reader.readUint32();
        msg.setKseq(value);
        break;
      case 7:
        var value = /** @type {number} */reader.readUint32();
        msg.setStamp(value);
        break;
      case 8:
        var value = /** @type {string} */reader.readString();
        msg.setTime(value);
        break;
      case 9:
        var value = /** @type {string} */reader.readString();
        msg.setTradingDay(value);
        break;
      case 10:
        var value = /** @type {string} */reader.readString();
        msg.setUpdateDate(value);
        break;
      case 11:
        var value = /** @type {string} */reader.readString();
        msg.setUpdateTime(value);
        break;
      case 12:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceOpen(value);
        break;
      case 13:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceClose(value);
        break;
      case 14:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceLow(value);
        break;
      case 15:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceHigh(value);
        break;
      case 16:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceSettlement(value);
        break;
      case 17:
        var value = /** @type {number} */reader.readDouble();
        msg.setPriceAverage(value);
        break;
      case 18:
        var value = /** @type {number} */reader.readDouble();
        msg.setAmount(value);
        break;
      case 19:
        var value = /** @type {number} */reader.readUint64();
        msg.setVolume(value);
        break;
      case 20:
        var value = /** @type {number} */reader.readUint64();
        msg.setVolumeTick(value);
        break;
      case 21:
        var value = /** @type {number} */reader.readUint64();
        msg.setPosition(value);
        break;
      case 22:
        var value = /** @type {string} */reader.readString();
        msg.setTargetCode(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.Kbar.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.Kbar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.Kbar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.Kbar.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(2, f);
  }
  f = message.getKtype();
  if (f !== 0) {
    writer.writeUint32(3, f);
  }
  f = message.getKunit();
  if (f !== 0) {
    writer.writeUint32(4, f);
  }
  f = message.getKoption();
  if (f !== 0) {
    writer.writeUint32(5, f);
  }
  f = message.getKseq();
  if (f !== 0) {
    writer.writeUint32(6, f);
  }
  f = message.getStamp();
  if (f !== 0) {
    writer.writeUint32(7, f);
  }
  f = message.getTime();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getTradingDay();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getUpdateDate();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getUpdateTime();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getPriceOpen();
  if (f !== 0.0) {
    writer.writeDouble(12, f);
  }
  f = message.getPriceClose();
  if (f !== 0.0) {
    writer.writeDouble(13, f);
  }
  f = message.getPriceLow();
  if (f !== 0.0) {
    writer.writeDouble(14, f);
  }
  f = message.getPriceHigh();
  if (f !== 0.0) {
    writer.writeDouble(15, f);
  }
  f = message.getPriceSettlement();
  if (f !== 0.0) {
    writer.writeDouble(16, f);
  }
  f = message.getPriceAverage();
  if (f !== 0.0) {
    writer.writeDouble(17, f);
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(18, f);
  }
  f = message.getVolume();
  if (f !== 0) {
    writer.writeUint64(19, f);
  }
  f = message.getVolumeTick();
  if (f !== 0) {
    writer.writeUint64(20, f);
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeUint64(21, f);
  }
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
};

/**
 * optional string target_id = 1;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getTargetId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setTargetId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional uint32 exchange_id = 2;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getExchangeId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setExchangeId = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional uint32 ktype = 3;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getKtype = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setKtype = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional uint32 kunit = 4;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getKunit = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setKunit = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional uint32 koption = 5;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getKoption = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setKoption = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional uint32 kseq = 6;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getKseq = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setKseq = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional uint32 stamp = 7;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getStamp = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setStamp = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};

/**
 * optional string time = 8;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getTime = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 8, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setTime = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string trading_day = 9;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getTradingDay = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 9, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setTradingDay = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string update_date = 10;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getUpdateDate = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 10, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setUpdateDate = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string update_time = 11;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getUpdateTime = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 11, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setUpdateTime = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional double price_open = 12;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceOpen = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 12, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceOpen = function (value) {
  jspb.Message.setProto3FloatField(this, 12, value);
};

/**
 * optional double price_close = 13;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceClose = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 13, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceClose = function (value) {
  jspb.Message.setProto3FloatField(this, 13, value);
};

/**
 * optional double price_low = 14;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceLow = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 14, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceLow = function (value) {
  jspb.Message.setProto3FloatField(this, 14, value);
};

/**
 * optional double price_high = 15;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceHigh = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 15, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceHigh = function (value) {
  jspb.Message.setProto3FloatField(this, 15, value);
};

/**
 * optional double price_settlement = 16;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceSettlement = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 16, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceSettlement = function (value) {
  jspb.Message.setProto3FloatField(this, 16, value);
};

/**
 * optional double price_average = 17;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPriceAverage = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 17, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPriceAverage = function (value) {
  jspb.Message.setProto3FloatField(this, 17, value);
};

/**
 * optional double amount = 18;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getAmount = function () {
  return (/** @type {number} */+jspb.Message.getFieldWithDefault(this, 18, 0.0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setAmount = function (value) {
  jspb.Message.setProto3FloatField(this, 18, value);
};

/**
 * optional uint64 volume = 19;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getVolume = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 19, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setVolume = function (value) {
  jspb.Message.setProto3IntField(this, 19, value);
};

/**
 * optional uint64 volume_tick = 20;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getVolumeTick = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 20, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setVolumeTick = function (value) {
  jspb.Message.setProto3IntField(this, 20, value);
};

/**
 * optional uint64 position = 21;
 * @return {number}
 */
proto.vision.market.proto.Kbar.prototype.getPosition = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 21, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.Kbar.prototype.setPosition = function (value) {
  jspb.Message.setProto3IntField(this, 21, value);
};

/**
 * optional string target_code = 22;
 * @return {string}
 */
proto.vision.market.proto.Kbar.prototype.getTargetCode = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 22, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.Kbar.prototype.setTargetCode = function (value) {
  jspb.Message.setProto3StringField(this, 22, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetTick = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetTick, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetTick.displayName = 'proto.vision.market.proto.GetTick';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.GetTick.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.GetTick.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.GetTick} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.GetTick.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      targetId: jspb.Message.getFieldWithDefault(msg, 10, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetTick}
 */
proto.vision.market.proto.GetTick.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetTick();
  return proto.vision.market.proto.GetTick.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetTick} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetTick}
 */
proto.vision.market.proto.GetTick.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 10:
        var value = /** @type {string} */reader.readString();
        msg.setTargetId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetTick.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetTick.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetTick} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTick.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(1, f);
  }
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
};

/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.GetTick.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.GetTick.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string target_id = 10;
 * @return {string}
 */
proto.vision.market.proto.GetTick.prototype.getTargetId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 10, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.GetTick.prototype.setTargetId = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetTickRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetTickRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetTickRsp.displayName = 'proto.vision.market.proto.GetTickRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.GetTickRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.GetTickRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.GetTickRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.GetTickRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
      data: (f = msg.getData()) && proto.vision.market.proto.Tick.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetTickRsp}
 */
proto.vision.market.proto.GetTickRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetTickRsp();
  return proto.vision.market.proto.GetTickRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetTickRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetTickRsp}
 */
proto.vision.market.proto.GetTickRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 2:
        var value = new Object_pb.Error();
        reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = new proto.vision.market.proto.Tick();
        reader.readMessage(value, proto.vision.market.proto.Tick.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetTickRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetTickRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetTickRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetTickRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(1, f);
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(2, f, Object_pb.Error.serializeBinaryToWriter);
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(10, f, proto.vision.market.proto.Tick.serializeBinaryToWriter);
  }
};

/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.GetTickRsp.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.GetTickRsp.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional proto.Error error = 2;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.GetTickRsp.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, Object_pb.Error, 2)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.GetTickRsp.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

proto.vision.market.proto.GetTickRsp.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetTickRsp.prototype.hasError = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional Tick data = 10;
 * @return {?proto.vision.market.proto.Tick}
 */
proto.vision.market.proto.GetTickRsp.prototype.getData = function () {
  return (/** @type{?proto.vision.market.proto.Tick} */jspb.Message.getWrapperField(this, proto.vision.market.proto.Tick, 10)
  );
};

/** @param {?proto.vision.market.proto.Tick|undefined} value */
proto.vision.market.proto.GetTickRsp.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

proto.vision.market.proto.GetTickRsp.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetTickRsp.prototype.hasData = function () {
  return jspb.Message.getField(this, 10) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTick = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vision.market.proto.SubTick.repeatedFields_, null);
};
goog.inherits(proto.vision.market.proto.SubTick, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTick.displayName = 'proto.vision.market.proto.SubTick';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vision.market.proto.SubTick.repeatedFields_ = [4];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.SubTick.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.SubTick.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.SubTick} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.SubTick.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      exchangeId: jspb.Message.getFieldWithDefault(msg, 2, 0),
      productId: jspb.Message.getFieldWithDefault(msg, 3, ""),
      targetIdList: jspb.Message.getRepeatedField(msg, 4)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTick}
 */
proto.vision.market.proto.SubTick.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTick();
  return proto.vision.market.proto.SubTick.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTick} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTick}
 */
proto.vision.market.proto.SubTick.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 2:
        var value = /** @type {number} */reader.readUint32();
        msg.setExchangeId(value);
        break;
      case 3:
        var value = /** @type {string} */reader.readString();
        msg.setProductId(value);
        break;
      case 4:
        var value = /** @type {string} */reader.readString();
        msg.addTargetId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTick.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTick.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTick} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTick.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(1, f);
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(2, f);
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getTargetIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(4, f);
  }
};

/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.SubTick.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubTick.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional uint32 exchange_id = 2;
 * @return {number}
 */
proto.vision.market.proto.SubTick.prototype.getExchangeId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubTick.prototype.setExchangeId = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string product_id = 3;
 * @return {string}
 */
proto.vision.market.proto.SubTick.prototype.getProductId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 3, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.SubTick.prototype.setProductId = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * repeated string target_id = 4;
 * @return {!Array.<string>}
 */
proto.vision.market.proto.SubTick.prototype.getTargetIdList = function () {
  return (/** @type {!Array.<string>} */jspb.Message.getRepeatedField(this, 4)
  );
};

/** @param {!Array.<string>} value */
proto.vision.market.proto.SubTick.prototype.setTargetIdList = function (value) {
  jspb.Message.setField(this, 4, value || []);
};

/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.vision.market.proto.SubTick.prototype.addTargetId = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};

proto.vision.market.proto.SubTick.prototype.clearTargetIdList = function () {
  this.setTargetIdList([]);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTickRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubTickRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTickRsp.displayName = 'proto.vision.market.proto.SubTickRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.SubTickRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.SubTickRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.SubTickRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.SubTickRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
      data: (f = msg.getData()) && proto.vision.market.proto.SubTick.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTickRsp}
 */
proto.vision.market.proto.SubTickRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTickRsp();
  return proto.vision.market.proto.SubTickRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTickRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTickRsp}
 */
proto.vision.market.proto.SubTickRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new Object_pb.Error();
        reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = new proto.vision.market.proto.SubTick();
        reader.readMessage(value, proto.vision.market.proto.SubTick.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTickRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTickRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTickRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTickRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(10, f, proto.vision.market.proto.SubTick.serializeBinaryToWriter);
  }
};

/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.SubTickRsp.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, Object_pb.Error, 1)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.SubTickRsp.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.vision.market.proto.SubTickRsp.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTickRsp.prototype.hasError = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional SubTick data = 10;
 * @return {?proto.vision.market.proto.SubTick}
 */
proto.vision.market.proto.SubTickRsp.prototype.getData = function () {
  return (/** @type{?proto.vision.market.proto.SubTick} */jspb.Message.getWrapperField(this, proto.vision.market.proto.SubTick, 10)
  );
};

/** @param {?proto.vision.market.proto.SubTick|undefined} value */
proto.vision.market.proto.SubTickRsp.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

proto.vision.market.proto.SubTickRsp.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTickRsp.prototype.hasData = function () {
  return jspb.Message.getField(this, 10) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTickAll = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubTickAll, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTickAll.displayName = 'proto.vision.market.proto.SubTickAll';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.SubTickAll.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.SubTickAll.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.SubTickAll} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.SubTickAll.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      productClass: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTickAll}
 */
proto.vision.market.proto.SubTickAll.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTickAll();
  return proto.vision.market.proto.SubTickAll.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTickAll} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTickAll}
 */
proto.vision.market.proto.SubTickAll.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 2:
        var value = /** @type {number} */reader.readUint32();
        msg.setProductClass(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTickAll.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTickAll.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTickAll} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTickAll.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(1, f);
  }
  f = message.getProductClass();
  if (f !== 0) {
    writer.writeUint32(2, f);
  }
};

/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.SubTickAll.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubTickAll.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional uint32 product_class = 2;
 * @return {number}
 */
proto.vision.market.proto.SubTickAll.prototype.getProductClass = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubTickAll.prototype.setProductClass = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubTickAllRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubTickAllRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubTickAllRsp.displayName = 'proto.vision.market.proto.SubTickAllRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.SubTickAllRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.SubTickAllRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.SubTickAllRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.SubTickAllRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
      data: (f = msg.getData()) && proto.vision.market.proto.SubTickAll.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubTickAllRsp}
 */
proto.vision.market.proto.SubTickAllRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubTickAllRsp();
  return proto.vision.market.proto.SubTickAllRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubTickAllRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubTickAllRsp}
 */
proto.vision.market.proto.SubTickAllRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new Object_pb.Error();
        reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = new proto.vision.market.proto.SubTickAll();
        reader.readMessage(value, proto.vision.market.proto.SubTickAll.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubTickAllRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubTickAllRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubTickAllRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(10, f, proto.vision.market.proto.SubTickAll.serializeBinaryToWriter);
  }
};

/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, Object_pb.Error, 1)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.SubTickAllRsp.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.vision.market.proto.SubTickAllRsp.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.hasError = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional SubTickAll data = 10;
 * @return {?proto.vision.market.proto.SubTickAll}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.getData = function () {
  return (/** @type{?proto.vision.market.proto.SubTickAll} */jspb.Message.getWrapperField(this, proto.vision.market.proto.SubTickAll, 10)
  );
};

/** @param {?proto.vision.market.proto.SubTickAll|undefined} value */
proto.vision.market.proto.SubTickAllRsp.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

proto.vision.market.proto.SubTickAllRsp.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubTickAllRsp.prototype.hasData = function () {
  return jspb.Message.getField(this, 10) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubKbar = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubKbar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubKbar.displayName = 'proto.vision.market.proto.SubKbar';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.SubKbar.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.SubKbar.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.SubKbar} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.SubKbar.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
      targetId: jspb.Message.getFieldWithDefault(msg, 2, ""),
      exchangeId: jspb.Message.getFieldWithDefault(msg, 3, 0),
      ktype: jspb.Message.getFieldWithDefault(msg, 4, 0),
      kunit: jspb.Message.getFieldWithDefault(msg, 5, 0),
      koption: jspb.Message.getFieldWithDefault(msg, 6, 0),
      kquery: jspb.Message.getFieldWithDefault(msg, 7, 0),
      ksize: jspb.Message.getFieldWithDefault(msg, 8, 0),
      startTime: jspb.Message.getFieldWithDefault(msg, 9, ""),
      endTime: jspb.Message.getFieldWithDefault(msg, 10, ""),
      targetCode: jspb.Message.getFieldWithDefault(msg, 11, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubKbar}
 */
proto.vision.market.proto.SubKbar.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubKbar();
  return proto.vision.market.proto.SubKbar.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubKbar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubKbar}
 */
proto.vision.market.proto.SubKbar.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setTargetId(value);
        break;
      case 3:
        var value = /** @type {number} */reader.readUint32();
        msg.setExchangeId(value);
        break;
      case 4:
        var value = /** @type {number} */reader.readUint32();
        msg.setKtype(value);
        break;
      case 5:
        var value = /** @type {number} */reader.readUint32();
        msg.setKunit(value);
        break;
      case 6:
        var value = /** @type {number} */reader.readUint32();
        msg.setKoption(value);
        break;
      case 7:
        var value = /** @type {number} */reader.readUint32();
        msg.setKquery(value);
        break;
      case 8:
        var value = /** @type {number} */reader.readUint32();
        msg.setKsize(value);
        break;
      case 9:
        var value = /** @type {string} */reader.readString();
        msg.setStartTime(value);
        break;
      case 10:
        var value = /** @type {string} */reader.readString();
        msg.setEndTime(value);
        break;
      case 11:
        var value = /** @type {string} */reader.readString();
        msg.setTargetCode(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubKbar.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubKbar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubKbar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubKbar.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(1, f);
  }
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(3, f);
  }
  f = message.getKtype();
  if (f !== 0) {
    writer.writeUint32(4, f);
  }
  f = message.getKunit();
  if (f !== 0) {
    writer.writeUint32(5, f);
  }
  f = message.getKoption();
  if (f !== 0) {
    writer.writeUint32(6, f);
  }
  f = message.getKquery();
  if (f !== 0) {
    writer.writeUint32(7, f);
  }
  f = message.getKsize();
  if (f !== 0) {
    writer.writeUint32(8, f);
  }
  f = message.getStartTime();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getEndTime();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
};

/**
 * optional uint64 user_id = 1;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string target_id = 2;
 * @return {string}
 */
proto.vision.market.proto.SubKbar.prototype.getTargetId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.SubKbar.prototype.setTargetId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional uint32 exchange_id = 3;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getExchangeId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setExchangeId = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional uint32 ktype = 4;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getKtype = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setKtype = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional uint32 kunit = 5;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getKunit = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setKunit = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional uint32 koption = 6;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getKoption = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setKoption = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional uint32 kquery = 7;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getKquery = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setKquery = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};

/**
 * optional uint32 ksize = 8;
 * @return {number}
 */
proto.vision.market.proto.SubKbar.prototype.getKsize = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 8, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.SubKbar.prototype.setKsize = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};

/**
 * optional string start_time = 9;
 * @return {string}
 */
proto.vision.market.proto.SubKbar.prototype.getStartTime = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 9, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.SubKbar.prototype.setStartTime = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string end_time = 10;
 * @return {string}
 */
proto.vision.market.proto.SubKbar.prototype.getEndTime = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 10, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.SubKbar.prototype.setEndTime = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string target_code = 11;
 * @return {string}
 */
proto.vision.market.proto.SubKbar.prototype.getTargetCode = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 11, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.SubKbar.prototype.setTargetCode = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.SubKbarRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.SubKbarRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.SubKbarRsp.displayName = 'proto.vision.market.proto.SubKbarRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.SubKbarRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.SubKbarRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.SubKbarRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.SubKbarRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
      data: (f = msg.getData()) && proto.vision.market.proto.SubKbar.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.SubKbarRsp}
 */
proto.vision.market.proto.SubKbarRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.SubKbarRsp();
  return proto.vision.market.proto.SubKbarRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.SubKbarRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.SubKbarRsp}
 */
proto.vision.market.proto.SubKbarRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new Object_pb.Error();
        reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = new proto.vision.market.proto.SubKbar();
        reader.readMessage(value, proto.vision.market.proto.SubKbar.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.SubKbarRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.SubKbarRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.SubKbarRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.SubKbarRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(10, f, proto.vision.market.proto.SubKbar.serializeBinaryToWriter);
  }
};

/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.SubKbarRsp.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, Object_pb.Error, 1)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.SubKbarRsp.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.vision.market.proto.SubKbarRsp.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubKbarRsp.prototype.hasError = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional SubKbar data = 10;
 * @return {?proto.vision.market.proto.SubKbar}
 */
proto.vision.market.proto.SubKbarRsp.prototype.getData = function () {
  return (/** @type{?proto.vision.market.proto.SubKbar} */jspb.Message.getWrapperField(this, proto.vision.market.proto.SubKbar, 10)
  );
};

/** @param {?proto.vision.market.proto.SubKbar|undefined} value */
proto.vision.market.proto.SubKbarRsp.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

proto.vision.market.proto.SubKbarRsp.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.SubKbarRsp.prototype.hasData = function () {
  return jspb.Message.getField(this, 10) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetBaseKbar = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetBaseKbar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetBaseKbar.displayName = 'proto.vision.market.proto.GetBaseKbar';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.GetBaseKbar.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.GetBaseKbar.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.GetBaseKbar} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.GetBaseKbar.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      targetCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
      ktype: jspb.Message.getFieldWithDefault(msg, 2, 0),
      startTime: jspb.Message.getFieldWithDefault(msg, 3, ""),
      endTime: jspb.Message.getFieldWithDefault(msg, 4, ""),
      timeCond: jspb.Message.getFieldWithDefault(msg, 5, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetBaseKbar}
 */
proto.vision.market.proto.GetBaseKbar.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetBaseKbar();
  return proto.vision.market.proto.GetBaseKbar.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetBaseKbar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetBaseKbar}
 */
proto.vision.market.proto.GetBaseKbar.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setTargetCode(value);
        break;
      case 2:
        var value = /** @type {number} */reader.readUint32();
        msg.setKtype(value);
        break;
      case 3:
        var value = /** @type {string} */reader.readString();
        msg.setStartTime(value);
        break;
      case 4:
        var value = /** @type {string} */reader.readString();
        msg.setEndTime(value);
        break;
      case 5:
        var value = /** @type {number} */reader.readUint32();
        msg.setTimeCond(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetBaseKbar.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetBaseKbar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetBaseKbar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetBaseKbar.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getKtype();
  if (f !== 0) {
    writer.writeUint32(2, f);
  }
  f = message.getStartTime();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getEndTime();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getTimeCond();
  if (f !== 0) {
    writer.writeUint32(5, f);
  }
};

/**
 * optional string target_code = 1;
 * @return {string}
 */
proto.vision.market.proto.GetBaseKbar.prototype.getTargetCode = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.GetBaseKbar.prototype.setTargetCode = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional uint32 ktype = 2;
 * @return {number}
 */
proto.vision.market.proto.GetBaseKbar.prototype.getKtype = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.GetBaseKbar.prototype.setKtype = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string start_time = 3;
 * @return {string}
 */
proto.vision.market.proto.GetBaseKbar.prototype.getStartTime = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 3, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.GetBaseKbar.prototype.setStartTime = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string end_time = 4;
 * @return {string}
 */
proto.vision.market.proto.GetBaseKbar.prototype.getEndTime = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 4, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.GetBaseKbar.prototype.setEndTime = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional uint32 time_cond = 5;
 * @return {number}
 */
proto.vision.market.proto.GetBaseKbar.prototype.getTimeCond = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.GetBaseKbar.prototype.setTimeCond = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetLastDayKbar = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetLastDayKbar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetLastDayKbar.displayName = 'proto.vision.market.proto.GetLastDayKbar';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.GetLastDayKbar.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.GetLastDayKbar.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.GetLastDayKbar} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.GetLastDayKbar.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      targetCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
      ktype: jspb.Message.getFieldWithDefault(msg, 2, 0),
      volume: jspb.Message.getFieldWithDefault(msg, 3, 0),
      endTime: jspb.Message.getFieldWithDefault(msg, 4, ""),
      tradingDay: jspb.Message.getFieldWithDefault(msg, 5, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetLastDayKbar}
 */
proto.vision.market.proto.GetLastDayKbar.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetLastDayKbar();
  return proto.vision.market.proto.GetLastDayKbar.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetLastDayKbar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetLastDayKbar}
 */
proto.vision.market.proto.GetLastDayKbar.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setTargetCode(value);
        break;
      case 2:
        var value = /** @type {number} */reader.readUint32();
        msg.setKtype(value);
        break;
      case 3:
        var value = /** @type {number} */reader.readUint64();
        msg.setVolume(value);
        break;
      case 4:
        var value = /** @type {string} */reader.readString();
        msg.setEndTime(value);
        break;
      case 5:
        var value = /** @type {string} */reader.readString();
        msg.setTradingDay(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetLastDayKbar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetLastDayKbar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetLastDayKbar.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getKtype();
  if (f !== 0) {
    writer.writeUint32(2, f);
  }
  f = message.getVolume();
  if (f !== 0) {
    writer.writeUint64(3, f);
  }
  f = message.getEndTime();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getTradingDay();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
};

/**
 * optional string target_code = 1;
 * @return {string}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.getTargetCode = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.GetLastDayKbar.prototype.setTargetCode = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional uint32 ktype = 2;
 * @return {number}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.getKtype = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.GetLastDayKbar.prototype.setKtype = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional uint64 volume = 3;
 * @return {number}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.getVolume = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.GetLastDayKbar.prototype.setVolume = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional string end_time = 4;
 * @return {string}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.getEndTime = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 4, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.GetLastDayKbar.prototype.setEndTime = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string trading_day = 5;
 * @return {string}
 */
proto.vision.market.proto.GetLastDayKbar.prototype.getTradingDay = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 5, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.GetLastDayKbar.prototype.setTradingDay = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.GetKbarRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.GetKbarRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.GetKbarRsp.displayName = 'proto.vision.market.proto.GetKbarRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.GetKbarRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.GetKbarRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.GetKbarRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.GetKbarRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
      data: (f = msg.getData()) && proto.vision.market.proto.Kbar.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.GetKbarRsp}
 */
proto.vision.market.proto.GetKbarRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.GetKbarRsp();
  return proto.vision.market.proto.GetKbarRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.GetKbarRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.GetKbarRsp}
 */
proto.vision.market.proto.GetKbarRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new Object_pb.Error();
        reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = new proto.vision.market.proto.Kbar();
        reader.readMessage(value, proto.vision.market.proto.Kbar.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.GetKbarRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.GetKbarRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.GetKbarRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.GetKbarRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(10, f, proto.vision.market.proto.Kbar.serializeBinaryToWriter);
  }
};

/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.GetKbarRsp.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, Object_pb.Error, 1)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.GetKbarRsp.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.vision.market.proto.GetKbarRsp.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetKbarRsp.prototype.hasError = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional Kbar data = 10;
 * @return {?proto.vision.market.proto.Kbar}
 */
proto.vision.market.proto.GetKbarRsp.prototype.getData = function () {
  return (/** @type{?proto.vision.market.proto.Kbar} */jspb.Message.getWrapperField(this, proto.vision.market.proto.Kbar, 10)
  );
};

/** @param {?proto.vision.market.proto.Kbar|undefined} value */
proto.vision.market.proto.GetKbarRsp.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

proto.vision.market.proto.GetKbarRsp.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.GetKbarRsp.prototype.hasData = function () {
  return jspb.Message.getField(this, 10) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.TimeSeq = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.TimeSeq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.TimeSeq.displayName = 'proto.vision.market.proto.TimeSeq';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.TimeSeq.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.TimeSeq.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.TimeSeq} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.TimeSeq.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      time: jspb.Message.getFieldWithDefault(msg, 1, ""),
      seq: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.TimeSeq}
 */
proto.vision.market.proto.TimeSeq.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.TimeSeq();
  return proto.vision.market.proto.TimeSeq.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.TimeSeq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.TimeSeq}
 */
proto.vision.market.proto.TimeSeq.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setTime(value);
        break;
      case 2:
        var value = /** @type {number} */reader.readUint32();
        msg.setSeq(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.TimeSeq.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.TimeSeq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.TimeSeq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeq.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTime();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getSeq();
  if (f !== 0) {
    writer.writeUint32(2, f);
  }
};

/**
 * optional string time = 1;
 * @return {string}
 */
proto.vision.market.proto.TimeSeq.prototype.getTime = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.TimeSeq.prototype.setTime = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional uint32 seq = 2;
 * @return {number}
 */
proto.vision.market.proto.TimeSeq.prototype.getSeq = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.TimeSeq.prototype.setSeq = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.TimeSeqReq = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.TimeSeqReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.TimeSeqReq.displayName = 'proto.vision.market.proto.TimeSeqReq';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.TimeSeqReq.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.TimeSeqReq.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.TimeSeqReq} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.TimeSeqReq.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      targetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      tradingDay: jspb.Message.getFieldWithDefault(msg, 2, ""),
      ktype: jspb.Message.getFieldWithDefault(msg, 3, 0),
      kunit: jspb.Message.getFieldWithDefault(msg, 4, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.TimeSeqReq}
 */
proto.vision.market.proto.TimeSeqReq.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.TimeSeqReq();
  return proto.vision.market.proto.TimeSeqReq.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.TimeSeqReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.TimeSeqReq}
 */
proto.vision.market.proto.TimeSeqReq.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setTargetId(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setTradingDay(value);
        break;
      case 3:
        var value = /** @type {number} */reader.readUint32();
        msg.setKtype(value);
        break;
      case 4:
        var value = /** @type {number} */reader.readUint32();
        msg.setKunit(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.TimeSeqReq.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.TimeSeqReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.TimeSeqReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeqReq.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTargetId();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getTradingDay();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getKtype();
  if (f !== 0) {
    writer.writeUint32(3, f);
  }
  f = message.getKunit();
  if (f !== 0) {
    writer.writeUint32(4, f);
  }
};

/**
 * optional string target_id = 1;
 * @return {string}
 */
proto.vision.market.proto.TimeSeqReq.prototype.getTargetId = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.TimeSeqReq.prototype.setTargetId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string trading_day = 2;
 * @return {string}
 */
proto.vision.market.proto.TimeSeqReq.prototype.getTradingDay = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.vision.market.proto.TimeSeqReq.prototype.setTradingDay = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional uint32 ktype = 3;
 * @return {number}
 */
proto.vision.market.proto.TimeSeqReq.prototype.getKtype = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.TimeSeqReq.prototype.setKtype = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional uint32 kunit = 4;
 * @return {number}
 */
proto.vision.market.proto.TimeSeqReq.prototype.getKunit = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};

/** @param {number} value */
proto.vision.market.proto.TimeSeqReq.prototype.setKunit = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.TimeSeqSet = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vision.market.proto.TimeSeqSet.repeatedFields_, null);
};
goog.inherits(proto.vision.market.proto.TimeSeqSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.TimeSeqSet.displayName = 'proto.vision.market.proto.TimeSeqSet';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vision.market.proto.TimeSeqSet.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.TimeSeqSet.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.TimeSeqSet.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.TimeSeqSet} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.TimeSeqSet.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      req: (f = msg.getReq()) && proto.vision.market.proto.TimeSeqReq.toObject(includeInstance, f),
      timeSeqList: jspb.Message.toObjectList(msg.getTimeSeqList(), proto.vision.market.proto.TimeSeq.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.TimeSeqSet}
 */
proto.vision.market.proto.TimeSeqSet.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.TimeSeqSet();
  return proto.vision.market.proto.TimeSeqSet.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.TimeSeqSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.TimeSeqSet}
 */
proto.vision.market.proto.TimeSeqSet.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.vision.market.proto.TimeSeqReq();
        reader.readMessage(value, proto.vision.market.proto.TimeSeqReq.deserializeBinaryFromReader);
        msg.setReq(value);
        break;
      case 2:
        var value = new proto.vision.market.proto.TimeSeq();
        reader.readMessage(value, proto.vision.market.proto.TimeSeq.deserializeBinaryFromReader);
        msg.addTimeSeq(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.TimeSeqSet.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.TimeSeqSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.TimeSeqSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeqSet.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getReq();
  if (f != null) {
    writer.writeMessage(1, f, proto.vision.market.proto.TimeSeqReq.serializeBinaryToWriter);
  }
  f = message.getTimeSeqList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.vision.market.proto.TimeSeq.serializeBinaryToWriter);
  }
};

/**
 * optional TimeSeqReq req = 1;
 * @return {?proto.vision.market.proto.TimeSeqReq}
 */
proto.vision.market.proto.TimeSeqSet.prototype.getReq = function () {
  return (/** @type{?proto.vision.market.proto.TimeSeqReq} */jspb.Message.getWrapperField(this, proto.vision.market.proto.TimeSeqReq, 1)
  );
};

/** @param {?proto.vision.market.proto.TimeSeqReq|undefined} value */
proto.vision.market.proto.TimeSeqSet.prototype.setReq = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.vision.market.proto.TimeSeqSet.prototype.clearReq = function () {
  this.setReq(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.TimeSeqSet.prototype.hasReq = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * repeated TimeSeq time_seq = 2;
 * @return {!Array.<!proto.vision.market.proto.TimeSeq>}
 */
proto.vision.market.proto.TimeSeqSet.prototype.getTimeSeqList = function () {
  return (/** @type{!Array.<!proto.vision.market.proto.TimeSeq>} */jspb.Message.getRepeatedWrapperField(this, proto.vision.market.proto.TimeSeq, 2)
  );
};

/** @param {!Array.<!proto.vision.market.proto.TimeSeq>} value */
proto.vision.market.proto.TimeSeqSet.prototype.setTimeSeqList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};

/**
 * @param {!proto.vision.market.proto.TimeSeq=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vision.market.proto.TimeSeq}
 */
proto.vision.market.proto.TimeSeqSet.prototype.addTimeSeq = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vision.market.proto.TimeSeq, opt_index);
};

proto.vision.market.proto.TimeSeqSet.prototype.clearTimeSeqList = function () {
  this.setTimeSeqList([]);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vision.market.proto.TimeSeqRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vision.market.proto.TimeSeqRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.vision.market.proto.TimeSeqRsp.displayName = 'proto.vision.market.proto.TimeSeqRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.vision.market.proto.TimeSeqRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.vision.market.proto.TimeSeqRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.vision.market.proto.TimeSeqRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.vision.market.proto.TimeSeqRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      error: (f = msg.getError()) && Object_pb.Error.toObject(includeInstance, f),
      data: (f = msg.getData()) && proto.vision.market.proto.TimeSeqSet.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vision.market.proto.TimeSeqRsp}
 */
proto.vision.market.proto.TimeSeqRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vision.market.proto.TimeSeqRsp();
  return proto.vision.market.proto.TimeSeqRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vision.market.proto.TimeSeqRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vision.market.proto.TimeSeqRsp}
 */
proto.vision.market.proto.TimeSeqRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new Object_pb.Error();
        reader.readMessage(value, Object_pb.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = new proto.vision.market.proto.TimeSeqSet();
        reader.readMessage(value, proto.vision.market.proto.TimeSeqSet.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.vision.market.proto.TimeSeqRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vision.market.proto.TimeSeqRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vision.market.proto.TimeSeqRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(1, f, Object_pb.Error.serializeBinaryToWriter);
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(10, f, proto.vision.market.proto.TimeSeqSet.serializeBinaryToWriter);
  }
};

/**
 * optional proto.Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, Object_pb.Error, 1)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.vision.market.proto.TimeSeqRsp.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.vision.market.proto.TimeSeqRsp.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.hasError = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional TimeSeqSet data = 10;
 * @return {?proto.vision.market.proto.TimeSeqSet}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.getData = function () {
  return (/** @type{?proto.vision.market.proto.TimeSeqSet} */jspb.Message.getWrapperField(this, proto.vision.market.proto.TimeSeqSet, 10)
  );
};

/** @param {?proto.vision.market.proto.TimeSeqSet|undefined} value */
proto.vision.market.proto.TimeSeqRsp.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

proto.vision.market.proto.TimeSeqRsp.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.vision.market.proto.TimeSeqRsp.prototype.hasData = function () {
  return jspb.Message.getField(this, 10) != null;
};

goog.object.extend(exports, proto.vision.market.proto);

/***/ }),

/***/ "d8/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dmkh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_UpgradeApp_ts__ = __webpack_require__("Lgiq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66bf584b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpgradeApp_vue__ = __webpack_require__("bxcY");
function injectStyle (ssrContext) {
  __webpack_require__("x972")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66bf584b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_UpgradeApp_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66bf584b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpgradeApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dntY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_ConditionUpdate_ts__ = __webpack_require__("H2+n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79190c69_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConditionUpdate_vue__ = __webpack_require__("mCAP");
function injectStyle (ssrContext) {
  __webpack_require__("6Oe5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79190c69"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_ConditionUpdate_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79190c69_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConditionUpdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eR8I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_yjheader_vue__ = __webpack_require__("4jC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67051f3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_yjheader_vue__ = __webpack_require__("REf1");
function injectStyle (ssrContext) {
  __webpack_require__("qztD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67051f3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_yjheader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67051f3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_yjheader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f0wD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_proto_Model_js__ = __webpack_require__("O0G5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__version_js__ = __webpack_require__("kB8h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_SubUtils__ = __webpack_require__("FcK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ipcoder__ = __webpack_require__("K6os");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_components_UpgradeApp_UpgradeApp_vue__ = __webpack_require__("dmkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jsonp__ = __webpack_require__("hU7x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jsonp__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "login",
  props: ["loginState"],
  components: {
    UpgradeApp: __WEBPACK_IMPORTED_MODULE_6__views_components_UpgradeApp_UpgradeApp_vue__["a" /* default */]
  },
  data: function data() {
    return {
      headerImgSrc: "logo_header.jpg",
      // ipNum: localStorage.ipNum, // 默认授权码
      ipNum: "fwy0za", // 固定授权码
      isIpNumDisabled: true, // 是否禁用ip授权码编辑
      accountNum: localStorage.accountNum,
      passwordNum: localStorage.passwordNum,
      loginText: "登录",
      loading: false,
      showFlag: true,
      passShow: "password",
      version2: __WEBPACK_IMPORTED_MODULE_3__version_js__["b" /* version */],
      remePass: localStorage.remePass,

      // 升级信息
      upgrade: {
        address: "",
        version: "",
        content: "",
        display: false
      }
    };
  },

  computed: {
    //log2 登录状态控制
    log2Disable: function log2Disable() {
      if (this.accountNum == "" || this.passwordNum == "" || this.loading) {
        return true;
      } else {
        return false;
      }
    },
    //log2 登录样式控制
    classObject2: function classObject2() {
      if (this.accountNum != "" && this.passwordNum != "" && !this.loading) {
        return {
          dis_btn: false,
          click_btn: true
        };
      } else {
        return {
          dis_btn: true,
          click_btn: false
        };
      }
    }
  },

  methods: {
    prepare: function prepare() {
      this.loading = false;
      this.loginText = "登录";
      this.upgrade.display = false;
    },
    logining: function logining() {
      this.loading = true;
      this.loginText = "登录中";
    },
    handleReme: function handleReme() {
      this.remePass = !this.remePass;
    },
    accountLogin: function accountLogin() {
      var that = this;
      // 如果正在登录，则不能点击。
      if (this.loading) return;

      // 检查IP地址
      // const r = /^(([1-9]|([1-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\.)(([0-9]|([0-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\.){2}([0-9]|([0-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))$/;
      var testIp = this.ipNum;
      testIp = this.trims(testIp, "g"); // 去除所有空格
      var ip = Object(__WEBPACK_IMPORTED_MODULE_5__utils_ipcoder__["a" /* getIp */])(testIp); // 将jn62or转换为'47.242.183.99'

      // 检查授权码，账号，密码
      if (that.ipNum == "") {
        this.$toast("授权码不能为空");
        return;
      }
      if (that.accountNum == "") {
        this.$toast("账号不能为空");
        return;
      }
      if (that.passwordNum == "") {
        this.$toast("密码不能为空");
        return;
      }

      that.logining();
      __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_js__["a" /* default */].setEvent(
      // 网络连接事件
      function () {
        that.$toast("网络已自动重连");
        that.$store.commit("autoClose", false);
        __WEBPACK_IMPORTED_MODULE_4__store_SubUtils__["a" /* clearAll */]();
        that.$store.commit("selectLoad"); // 清空自选合约
      },
      // 网络断开事件
      function (activeClose) {
        console.error("autoClose " + !activeClose);
        if (!activeClose) {
          that.$toast("网络已断开，请检查网络连接");
          that.$store.commit("autoClose", true);
        }
      });

      var option = {
        upgrade: function upgrade(user) {
          // console.log(user);
          crmAddress = user.crmAddress;
          helpAddress = user.helpAddress;
          localStorage.ipNum = testIp;
          localStorage.userName = user.userName;
          localStorage.accountNum = that.accountNum;
          localStorage.passwordNum = that.remePass ? that.passwordNum : "";
          localStorage.remePass = that.remePass;
          // 苹果Ios环境
          /////////////////////////////////////////////////////////////////////////
          if (platform.name == "ios") {
            that.upgrade.version = user.versionIos;
            that.upgrade.address = user.addressIos;
            that.upgrade.content = user.contentIos;
          } else if (platform.name == "android") {
            // Android环境
            that.upgrade.version = user.version;
            that.upgrade.address = user.address;
            that.upgrade.content = user.content;
          } else if (platform.name == "") {
            /////////////////////////////////////////////////////////////////////
            // 测试环境
            that.upgrade.version = user.version;
            that.upgrade.address = user.address;
            that.upgrade.content = user.content;
          }

          // 检查是否需要升级
          that.upgrade.display = false;
          ////// //////////////////////////////////////
          if (platform.isNeedAutoUpdate && __WEBPACK_IMPORTED_MODULE_3__version_js__["b" /* version */] != that.upgrade.version) {
            that.upgrade.display = true;
          }
          ////// ////////////////////////////////
          return that.upgrade.display;
        },
        resolve: function resolve(user) {
          localStorage.ipNum = testIp;
          localStorage.accountNum = that.accountNum;
          localStorage.passwordNum = that.remePass ? that.passwordNum : "";
          localStorage.remePass = that.remePass;
          that.$router.push({ path: "home/select" });
          __WEBPACK_IMPORTED_MODULE_4__store_SubUtils__["b" /* reSub */]();
          __WEBPACK_IMPORTED_MODULE_4__store_SubUtils__["a" /* clearAll */]();
        },
        reject: function reject(error) {
          // console.error(error);
          if (error.id == __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_js__["a" /* default */].e_network) {
            Object(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"])("登录失败", "网络错误：请检查授权码是否正确，网络是否正常。");
          } else if (error.id == __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_js__["a" /* default */].e_account_invalid || error.id == __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_js__["a" /* default */].e_password_invalid) {
            Object(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"])("登录失败", "您输入的账号或密码错误！" + "<br />您输入的账号为：" + that.accountNum + "<br />您输入的密码为：" + that.passwordNum);
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"])("登录失败", error.message);
          }
          that.prepare();
        }
      };
      // console.log("ip", ip);
      __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront_js__["a" /* default */].login(ip, that.accountNum, that.passwordNum, option);
    },


    //点击显示隐藏密码
    show_h: function show_h() {
      this.showFlag = !this.showFlag;
      this.passShow = this.passShow == "password" ? "text" : "password";
    },


    //拨打电话
    mobileCall: function mobileCall() {
      window.location.href = "tel://400-100-1382";
    },


    //账号不存在
    altNonentity: function altNonentity() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"])({
        title: "账号不存在",
        message: "此手机号未被激活",
        confirmButtonText: "激活",
        cancelButtonText: "取消",
        showCancelButton: true
      }).then(function (_ref) {
        var value = _ref.value,
            action = _ref.action;

        _this.mobileCall();
      });
    },

    //密码错误
    altPwdError: function altPwdError() {
      Object(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["MessageBox"])({
        title: "密码错误",
        message: "是否找回密码",
        confirmButtonText: "是",
        cancelButtonText: "否",
        showCancelButton: true
      });
    },
    focusinMethod: function focusinMethod() {
      this.headerImgSrc = "logo_header_small.jpg";
    },
    focusoutMethod: function focusoutMethod() {
      this.headerImgSrc = "header.jpeg";
    },
    userProtocol: function userProtocol() {
      this.$router.push("userProtocol");
    },
    trims: function trims(str, is_global) {
      var result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },

    // 取消升级
    handleLaterUp: function handleLaterUp() {
      this.upgrade.display = false;
    }
  },
  beforeCreate: function beforeCreate() {
    // document.body.style.backgroundColor="#fff";
  },
  beforeDestroy: function beforeDestroy() {
    document.body.style.backgroundColor = "";
  },
  activated: function activated() {
    // this.ipNum = localStorage.ipNum; // 授权码固定，不从localStorage读取

    if (!localStorage.passwordNum) {
      this.remePass = false;
      this.passwordNum = "";
    } else {
      this.remePass = true;
      this.passwordNum = localStorage.passwordNum;
    }

    this.prepare();
    // 登录页面，不显示自动断开。
    this.$store.commit("autoClose", false);
  },
  mounted: function mounted() {
    var _this2 = this;

    if (platform.name == "ios") {
      this.$nextTick(function () {
        // this.$jsonp('https://itunes.apple.com/cn/lookup?id=1463572015', null, (err, res) => {
        //       console.log(res);
        // });
        __WEBPACK_IMPORTED_MODULE_7_jsonp__("https://itunes.apple.com/cn/lookup?id=1448458716", null, function (err, res) {
          var arr1 = res.results[0].version.split(".").join("");
          var arr2 = __WEBPACK_IMPORTED_MODULE_3__version_js__["a" /* appstoreVersion */].split(".").join("");
          // console.log(arr1, arr2);
          if (Number(arr1) - Number(arr2) > 0) {
            _this2.upgrade.display = true;
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "f4w4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var OrderPriceKeyboard = (function (_super) {
    __extends(OrderPriceKeyboard, _super);
    function OrderPriceKeyboard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderPriceKeyboard.prototype.handleClose = function () {
        this.$emit('close');
    };
    OrderPriceKeyboard.prototype.orderInput = function (n) {
        this.$store.commit('keyBoard/changePriceFlage', false);
        var o = {
            1: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_opponent_price,
            2: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_last_price,
            3: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_market_price,
            4: __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_plusone_tick_price,
        };
        this.$emit('update:orderPriceType', o[n]);
    };
    OrderPriceKeyboard.prototype.onPriceChange = function (v) {
        this.$emit('update:orderPriceType', __WEBPACK_IMPORTED_MODULE_3__static_js_proto_CtpFront__["a" /* default */].con_limit_price);
        this.$emit('update:orderPrice', v);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], OrderPriceKeyboard.prototype, "orderPrice", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], OrderPriceKeyboard.prototype, "orderPriceType", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], OrderPriceKeyboard.prototype, "exclude", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], OrderPriceKeyboard.prototype, "boardPrice", void 0);
    OrderPriceKeyboard = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'TargetKeyboard',
        })
    ], OrderPriceKeyboard);
    return OrderPriceKeyboard;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (OrderPriceKeyboard);


/***/ }),

/***/ "fhqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_socket_io_client__ = __webpack_require__("EaLy");






var current = 1;

var CustomWebSocket = function () {
    function CustomWebSocket(url) {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CustomWebSocket);

        this.url = url;
        this.id = current++;
        this.readyState = CustomWebSocket.CONNECTING;

        // Emulate WebSocket events
        this.onopen = null;
        this.onclose = null;
        this.onerror = null;
        this.onmessage = null;

        var websocketUrl = url.replace("ws", "http");
        this.socket = Object(__WEBPACK_IMPORTED_MODULE_4_socket_io_client__["a" /* default */])(websocketUrl, {
            transports: ['polling'], // Simulate "not using websocket connection" as requested
            reconnection: false // Disable auto-reconnect to behave like native WebSocket
        });

        this.socket.on('connect', function () {
            console.log('Connected to middleware, waiting for backend...');
        });

        this.socket.on('backend_connected', function () {
            console.log('Backend connected confirmed');
            _this.readyState = CustomWebSocket.OPEN;
            if (_this.onopen) {
                _this.onopen({ type: 'open' });
            }
        });

        this.socket.on('disconnect', function (reason) {
            _this.socket.disconnect();
            console.log('CustomWebSocket ' + _this.id + ' disconnected:', reason);
            if (_this.readyState === CustomWebSocket.CLOSED) return;

            _this.readyState = CustomWebSocket.CLOSED;
            if (_this.onclose) {
                // WebSocket onClose event usually has code, reason, wasClean
                // reason from socket.io might be "transport close", "ping timeout", etc.
                _this.onclose({
                    type: 'close',
                    code: 1000,
                    reason: reason,
                    wasClean: reason === 'io client disconnect'
                });
            }
        });

        this.socket.on('connect_error', function (error) {
            console.error('CustomWebSocket ' + _this.id + ' connection error:', error);
            _this.socket.disconnect();
            if (_this.onerror) {
                _this.onerror({ type: 'error', error: error });
            }

            if (_this.readyState === CustomWebSocket.CLOSED) return;

            // Native WebSocket triggers onClose after onError if connection fails
            _this.readyState = CustomWebSocket.CLOSED;
            if (_this.onclose) {
                _this.onclose({
                    type: 'close',
                    code: 1006, // 1006 indicates abnormal closure (e.g. connection failure)
                    reason: error.message || 'Connection failed',
                    wasClean: false
                });
            }
        });

        this.socket.on('message', function (data) {
            console.log('CustomWebSocket received message:', data);
            if (_this.onmessage) {
                var blobData = data;
                // Ensure data is a Blob as expected by the consumer
                if (!(data instanceof Blob)) {
                    if (data instanceof ArrayBuffer || ArrayBuffer.isView(data)) {
                        blobData = new Blob([data]);
                    } else if ((typeof data === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object') {
                        // Attempt to serialize object to JSON blob if it's not binary
                        try {
                            blobData = new Blob([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)]);
                        } catch (e) {
                            console.error("Failed to convert message to Blob", e);
                        }
                    } else {
                        blobData = new Blob([String(data)]);
                    }
                }
                _this.onmessage({ data: blobData });
            }
        });
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CustomWebSocket, [{
        key: "send",
        value: function send(data) {
            console.log('Sending message to middleware:', data);
            if (this.readyState === CustomWebSocket.OPEN) {
                // socket.io usually handles objects/strings/buffers directly.
                // If data is a typed array or buffer, it sends as binary.
                this.socket.emit('message', data);
            }
        }
    }, {
        key: "close",
        value: function close() {
            this.socket.close();
            this.readyState = CustomWebSocket.CLOSED;
        }
    }]);

    return CustomWebSocket;
}();

/* harmony default export */ __webpack_exports__["a"] = (CustomWebSocket);


CustomWebSocket.CONNECTING = 0;
CustomWebSocket.OPEN = 1;
CustomWebSocket.CLOSING = 2;
CustomWebSocket.CLOSED = 3;

/***/ }),

/***/ "gFNx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gGAs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_OnOff_ts__ = __webpack_require__("ZCTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f170861_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnOff_vue__ = __webpack_require__("xJkX");
function injectStyle (ssrContext) {
  __webpack_require__("yHwS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f170861"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_OnOff_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f170861_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnOff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gSyU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gWs1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_LogList_ts__ = __webpack_require__("vvyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_318d5b16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogList_vue__ = __webpack_require__("5G3I");
function injectStyle (ssrContext) {
  __webpack_require__("TsbK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-318d5b16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_LogList_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_318d5b16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hEAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return con_operation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return offset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return direct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return validTime; });
/* harmony export (immutable) */ __webpack_exports__["b"] = con_active_state;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return con; });
/* harmony export (immutable) */ __webpack_exports__["i"] = getText;
/* harmony export (immutable) */ __webpack_exports__["g"] = getOrder;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCondition;
/* harmony export (immutable) */ __webpack_exports__["f"] = getConditions;
/* harmony export (immutable) */ __webpack_exports__["h"] = getState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_format__ = __webpack_require__("FirM");


var con_operation = [{
    text: '>=',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_operation_ge
}, {
    text: '<',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_operation_lt
}, {
    text: '>',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_operation_gt
}, {
    text: '<=',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_operation_le
}];
var offset = [{
    text: '开',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].offset_open
}, {
    text: '平',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].offset_close
}];
var direct = [{
    text: '买',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].direct_buy,
    cls: {
        background: '#ee3f44'
    }
}, {
    text: '卖',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].direct_sell,
    cls: {
        background: '#409f5f'
    }
}];
var validTime = [{
    text: '当前交易日',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_validity_gfd
}, {
    text: '永久有效',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_validity_all
}];
function con_active_state() {
    return [{
        text: '运行中',
        value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_order_run
    }, {
        text: '暂停',
        value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_order_stop
    }, {
        text: '已触发',
        value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_order_trigger
    }, {
        text: '已删除',
        value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_order_delete
    }, {
        text: '已结算',
        value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_order_settlement
    }];
}
var con = [{
    text: '限价',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_limit_price
}, {
    text: '对手价',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_opponent_price
}, {
    text: '最新价',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_last_price
}, {
    text: '市价',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_market_price
}, {
    text: '超一价',
    value: __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_plusone_tick_price
}];
function getText(arr, value) {
    var find = arr.filter(function (r) {
        return r.value === value;
    });
    if (find && find.length) {
        return find[0].text;
    }
    return '';
}
function getOrder(item) {
    var ret = '';
    ret += getText(direct, item.direction);
    ret += getText(offset, item.offset);
    ret += ',';
    if (item.orderPriceType === __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront__["a" /* default */].con_limit_price) {
        ret += __WEBPACK_IMPORTED_MODULE_1__utils_format__["b" /* toDoubleDigits */](item.orderPrice);
    } else {
        ret += getText(con, item.orderPriceType);
    }
    ret += ',';
    ret += item.volume + '手';
    return ret;
}
function getCondition(item) {
    if (item.orderType === 0) {
        return getText(con_operation, item.operationType) + ' ' + item.price;
    } else if (item.orderType === 1) {
        var obj = {
            sl: '>' + ' ' + item.slPrice,
            tp: '<' + ' ' + item.tpPrice
        };
        return obj;
    }
}
function getConditions(item) {
    if (item.orderType === 0) {
        return getText(con_operation, item.operationType) + ' ' + item.price;
    } else if (item.orderType === 1) {
        var obj = {
            sl: '<' + ' ' + item.slPrice,
            tp: '>' + ' ' + item.tpPrice
        };
        return obj;
    }
}
function getState(item) {
    return getText(con_active_state(), item.state);
}

/***/ }),

/***/ "hEPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-trigger"},[_c('FixedTable',{staticClass:"container2",attrs:{"title":_vm.tableTitle,"isOp":true,"dataKey":"id","tableData":_vm.tableData},scopedSlots:_vm._u([{key:"op",fn:function(slotProps){return _c('div',{staticClass:"op-container"},[_c('span',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"btn-operation btn-operation-del",on:{"tap":function($event){_vm.handleDel(slotProps.data)}}},[_vm._v("删除")]),_vm._v(" "),_c('span',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"btn-operation btn-operation-del",on:{"tap":function($event){_vm.handleUpdate(slotProps.data)}}},[_vm._v("修改")]),_vm._v(" "),_c('span',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"btn-operation btn-operation-del",on:{"tap":function($event){_vm.handleStop(slotProps.data)}}},[_vm._v("\n        "+_vm._s(slotProps.data.stopText)+"\n      ")])])}}])}),_vm._v(" "),(_vm.isShowUpdate)?_c('ConditionUpdate',{attrs:{"priceTicks":_vm.priceTickN,"condition":_vm.currentSelect},on:{"close":function($event){_vm.isShowUpdate=false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hK71":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hXji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_FixedTable_ts__ = __webpack_require__("571A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_511eb8e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FixedTable_vue__ = __webpack_require__("qKe+");
function injectStyle (ssrContext) {
  __webpack_require__("p7F6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-511eb8e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_FixedTable_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_511eb8e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FixedTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iLQf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_crm_enums__ = __webpack_require__("Xo8I");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Details = (function (_super) {
    __extends(Details, _super);
    function Details() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data1 = [];
        return _this;
    }
    Details.prototype.goback = function () {
        this.$router.go(-1);
    };
    Details.prototype.activated = function () {
        this.data1 = [];
        if (false)
            console.log(this.$route.params);
        if (this.$route.params.PayChannel) {
            var data = this.$route.params;
            this.data1.push({ label: '时间', value: data.Indate });
            this.data1.push({ label: '总金额', value: data.TotalMoney });
            this.data1.push({ label: '服务费', value: data.ServiceCharge });
            this.data1.push({ label: '到账金额', value: this.inRealMoney(data) });
            this.data1.push({ label: '支付方式', value: data.PayType });
            this.data1.push({ label: '支付渠道', value: data.PayChannel });
            this.data1.push({ label: '流水号', value: data.PayNo });
            this.data1.push({ label: '状态', value: data.StateStr });
        }
        else {
            var data = this.$route.params;
            this.data1.push({ label: '时间', value: data.Indate });
            this.data1.push({ label: '姓名', value: data.Name });
            this.data1.push({ label: '银行', value: data.Bank });
            this.data1.push({ label: '支行', value: data.BankBranch });
            this.data1.push({ label: '银行卡号', value: data.BankNo });
            this.data1.push({ label: '流水号', value: data.PayNo });
            this.data1.push({ label: '提款金额', value: data.TotalMoney });
            this.data1.push({ label: '手续费', value: data.ServiceCharge });
            this.data1.push({ label: '实际到账', value: this.outRealMoney(data) });
            this.data1.push({ label: '状态', value: data.StateStr });
        }
    };
    Details.prototype.outRealMoney = function (item) {
        switch (item.State) {
            case __WEBPACK_IMPORTED_MODULE_2__types_crm_enums__["e" /* TransferOutStateEnum */].Accept:
                return item.Money;
            default:
                return '0';
        }
    };
    Details.prototype.inRealMoney = function (item) {
        switch (item.State) {
            case __WEBPACK_IMPORTED_MODULE_2__types_crm_enums__["d" /* TransferInStateEnum */].Accept:
            case __WEBPACK_IMPORTED_MODULE_2__types_crm_enums__["d" /* TransferInStateEnum */].PaySuc:
                return item.Money;
            default:
                return '0';
        }
    };
    Details = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], Details);
    return Details;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Details);


/***/ }),

/***/ "irye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "order-menu",
  data: function data() {
    return {
      isActive: "",

      menuData: [{
        tobarLink: "/home/order",
        tobarIcon: "&#xe624;",
        tobarContent: "下单"
      }, {
        tobarLink: "/home/store",
        tobarIcon: "&#xe7b9;",
        tobarContent: "持仓"
      }, {
        tobarLink: "/home/cancel",
        tobarIcon: "&#xe609;",
        tobarContent: "撤单"
      }, {
        tobarLink: "/home/capital",
        tobarIcon: "&#xe60a;",
        tobarContent: "资金"
      }, {
        tobarLink: "/home/query",
        tobarIcon: "&#xe603;",
        tobarContent: "查询"
      }]
    };
  },

  methods: {
    isActiveValue: function isActiveValue() {
      this.isActive = this.$route.params.tableId;
      // console.log(this.isActive);
      // console.log(222);
    },
    link: function link(index) {
      this.isActive = index;
      if (index == 3) {
        // 查询资金信息：proto.ctpfront.proto.Capital
        front.queryCapital(function (capital, error) {
          if (error !== undefined) {
            console.error(error.getMessage());
            return;
          }
          console.log("capital: " + capital.getBalance() + " " + capital.getAvailable());
        });
      } else if (index == 4) {
        // 委托下单：回报推送函数
        // proto.ctpfront.proto.Order
        var on_order = function on_order(order) {
          // 委托回报on_order
          console.log("on_order: " + order.getOrderRef() + " " + detail.getTargetId() + " " + detail.getOffset() + " " + detail.getDirection() + " " + detail.getState() + " " + detail.getStateDetail() + " " + detail.getInsertTime() + " " + detail.getTradedVolume());
        };
        // proto.ctpfront.proto.Trade
        var on_trade = function on_trade(trade) {
          // 成交回报on_trade
          console.log("on_trade: " + trade.getTradeId() + " " + detail.getTargetId() + " " + detail.getOffset() + " " + detail.getDirection() + " " + detail.getVolume() + " " + detail.getPrice() + " " + detail.getOrderId());
        };
        front.subscribe(on_order, on_trade);
      }
    }
  },
  mounted: function mounted() {
    this.isActiveValue();
  }
});

/***/ }),

/***/ "j+M0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"headerWrapper"},[_vm._v("\n    交易\n    "),_c('i',{staticClass:"icon iconfont install",on:{"click":_vm.goSet}},[_vm._v("")])]),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"account-wrapper"},[_c('p',{staticClass:"accout-title"},[_vm._v(_vm._s(_vm.pageData.account.title))]),_vm._v(" "),_c('p',{staticClass:"accout-num"},[_vm._v(_vm._s(_vm.pageData.account.value)),(_vm.userName)?_c('span',[_vm._v("("+_vm._s(_vm.userName)+")")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"capital-wrapper"},[_c('div',{staticClass:"capital-w-left"},[_c('span',{staticClass:"span-title"},[_vm._v(_vm._s(_vm.pageData.rights.title))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"span-value"},[_vm._v(_vm._s(_vm.pageData.rights.value))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"span-title"},[_vm._v(_vm._s(_vm.pageData.usable.title))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.pageData.usable.value))]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"capital-w-rigth"},[_c('span',{staticClass:"span-title"},[_vm._v(_vm._s(_vm.pageData.profitAloss.title))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"span-value",class:{gain:_vm.pageData.profitAloss.value>=0,lose:_vm.pageData.profitAloss.value<0}},[_vm._v(_vm._s(_vm.pageData.profitAloss.value))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"span-title"},[_vm._v(_vm._s(_vm.pageData.desirable.title))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.pageData.desirable.value))]),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('ul',_vm._l((_vm.menuData),function(item,index){return _c('li',{directives:[{name:"tap",rawName:"v-tap"}],key:index,class:{liActive:_vm.isActive==index},on:{"tap":function($event){_vm.link(index)}}},[_c('i',{staticClass:"icon iconfont",domProps:{"innerHTML":_vm._s(item.tobarIcon)}}),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.tobarContent))])])}))]),_vm._v(" "),_c('div',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"btn_div_d",on:{"tap":_vm.go_login}},[_c('div',{staticClass:"btn"},[_vm._v("\n        退出\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jAd7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

////////////////////////////////////////////////////////////////////////////////
// 命名空间："art"通用函数封装

var tmi = {};
/* harmony default export */ __webpack_exports__["a"] = (tmi);

//##############################################################################
// [交易合约]
// 检查是否是合约品种（商品）。
tmi.isProduct = function (productId) {
    for (var i = 0; i < productId.length; ++i) {
        if (productId[i] <= '9' && productId[i] >= '0') {
            return false;
        }
    }
    return true;
};

////////////////////////////////////////////////////////////////////////////////
// 检查是否是合约品种（商品）。
tmi.productId = function (targetId) {
    for (var i = 0; i < targetId.length; ++i) {
        if (targetId[i] <= '9' && targetId[i] >= '0') {
            return targetId.substr(0, i);
        }
    }
    return "";
};

/***/ }),

/***/ "jQeE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"logo_main"},[_c('form',{on:{"focusin":_vm.focusinMethod,"focusout":_vm.focusoutMethod}},[_c('div',{staticClass:"big-wrapper"},[_c('div',{staticClass:"man"},[_c('div',{staticClass:"icon-left"},[_c('i',{staticClass:"iconfont",class:{ 'iconfont-color': _vm.ipNum != '' }},[_vm._v("")])]),_vm._v(" "),_c('div',{staticClass:"icon-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ipNum),expression:"ipNum"}],staticClass:"form-control ip-input",attrs:{"name":"username","disabled":_vm.isIpNumDisabled,"type":"text","maxlength":"15","minlength":"1","placeholder":"请输入接入授权码"},domProps:{"value":(_vm.ipNum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ipNum=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"big-wrapper"},[_c('div',{staticClass:"man"},[_c('div',{staticClass:"icon-left"},[_c('i',{staticClass:"icon iconfont",class:{ 'iconfont-color': _vm.accountNum != '' }},[_vm._v("")])]),_vm._v(" "),_c('div',{staticClass:"icon-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.accountNum),expression:"accountNum"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"15","minlength":"1","name":"username","placeholder":"请输入账号"},domProps:{"value":(_vm.accountNum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.accountNum=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"big-wrapper"},[_c('div',{staticClass:"man"},[_c('div',{staticClass:"icon-left"},[_c('i',{staticClass:"icon iconfont",class:{ 'iconfont-color': _vm.passwordNum != '' }},[_vm._v("")])]),_vm._v(" "),_c('div',{staticClass:"icon-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordNum),expression:"passwordNum"}],staticClass:"form-control",attrs:{"type":"password","maxlength":"15","minlength":"1","name":"username","placeholder":"请输入密码"},domProps:{"value":(_vm.passwordNum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordNum=$event.target.value}}})]),_vm._v(" "),_c('span',{staticClass:"reme-pass-wrap",on:{"click":_vm.handleReme}},[(_vm.remePass)?_c('i',{staticClass:"icon iconfont"},[_vm._v("")]):_c('i',{staticClass:"icon iconfont"},[_vm._v("")]),_vm._v(" "),_c('span',{staticClass:"dsRemePass"},[_vm._v("记住密码")])])])]),_vm._v(" "),_c('div',{staticClass:"btn_div_d"},[_c('div',{staticClass:"btn",class:_vm.classObject2,attrs:{"disabled":_vm.log2Disable,"id":"log2_dl"},on:{"click":_vm.accountLogin}},[_vm._v("\n          "+_vm._s(this.loginText)+"\n          "),_c('span',{class:['dot-ani', { showLoading: _vm.loginText == '登录中' }]})])]),_vm._v(" "),_c('p',{staticClass:"deal_div"},[_vm._v("\n        当前版本: "+_vm._s(_vm.version2)+"\n        ")])])]),_vm._v(" "),(_vm.upgrade.display)?_c('upgrade-app',{attrs:{"upgrade":_vm.upgrade},on:{"laterUp":_vm.handleLaterUp}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('img',{attrs:{"src":"static/logo.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jbfd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_ConditionInsert_ts__ = __webpack_require__("2ZJW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428b5049_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConditionInsert_vue__ = __webpack_require__("p+6w");
function injectStyle (ssrContext) {
  __webpack_require__("4J9r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-428b5049"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_ConditionInsert_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428b5049_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConditionInsert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kB8h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appstoreVersion; });
/* unused harmony export versionCode */

var version = '5.2'; // 上一版本号3.4.3
var appstoreVersion = '1.1.9';
var versionCode = 1;

/***/ }),

/***/ "kGcR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var OrderSearch = (function (_super) {
    __extends(OrderSearch, _super);
    function OrderSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableTitle = [
            {
                text: '合约',
                width: '2rem',
                name: 'targetId',
            },
            {
                text: '开平',
                width: '1.5rem',
                name: 'offset',
            },
            {
                text: '报单价格',
                width: '2rem',
                name: 'price',
            },
            {
                text: '报单手数',
                width: '2rem',
                name: 'volume',
            },
            {
                text: '未成交数',
                width: '2rem',
                name: 'unvolume',
            },
            {
                text: '报单时间',
                width: '3rem',
                name: 'insertTime',
            },
            {
                text: '报单状态',
                width: '2rem',
                name: 'state',
            },
        ];
        return _this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], OrderSearch.prototype, "tableData", void 0);
    OrderSearch = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], OrderSearch);
    return OrderSearch;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (OrderSearch);


/***/ }),

/***/ "kjWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"header"},[_c('span',{on:{"click":_vm.goback}},[_c('i',{staticClass:"icon iconfont left"},[_vm._v("")]),_vm._v("\n      返回\n    ")]),_vm._v("\n    详情")]),_vm._v(" "),_c('ul',{staticClass:"list"},_vm._l((_vm.data1),function(item){return _c('li',{key:item.label},[_c('span',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.value))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lAzR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ljv1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mB49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_DrawMoneyRecord_ts__ = __webpack_require__("EBaY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbdfca6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawMoneyRecord_vue__ = __webpack_require__("802T");
function injectStyle (ssrContext) {
  __webpack_require__("0L1t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bbdfca6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_DrawMoneyRecord_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbdfca6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawMoneyRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mCAP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"items header"},[_vm._v("\n      修改条件单\n    ")]),_vm._v(" "),_c('div',{staticClass:"items"},[_c('span',{staticClass:"title"},[_vm._v("合约")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.targetId),expression:"formData.targetId"}],ref:"targetSelect",staticClass:"contract",attrs:{"type":"text","readonly":"true","disabled":""},domProps:{"value":(_vm.formData.targetId)},on:{"touchstart":function($event){$event.stopPropagation();_vm.showTargetSelectedKeyboard=true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "targetId", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"items"},[_c('span',{staticClass:"title"},[_vm._v("价格")]),_vm._v(" "),_c('SelectButton',{staticClass:"priceButton",attrs:{"arr":_vm.arrOperation},model:{value:(_vm.formData.operationType),callback:function ($$v) {_vm.$set(_vm.formData, "operationType", $$v)},expression:"formData.operationType"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.price),expression:"formData.price"}],ref:"price",staticClass:"price-input price-value",attrs:{"readonly":"true","type":"text"},domProps:{"value":(_vm.formData.price)},on:{"focus":function($event){_vm.showPriceKeyboard=true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "price", $event.target.value)}}}),_vm._v(" "),(_vm.showPriceKeyboard)?_c('NumKeyboard',{attrs:{"title":"价格","boardPrice":0,"priceTickss":_vm.priceTicks,"exclude":[_vm.$refs.price]},on:{"close":function($event){_vm.showPriceKeyboard=false}},model:{value:(_vm.formData.price),callback:function ($$v) {_vm.$set(_vm.formData, "price", $$v)},expression:"formData.price"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"items"},[_c('span',{staticClass:"title"},[_vm._v("操作")]),_vm._v(" "),_c('SelectButton',{staticClass:"operation1",attrs:{"arr":_vm.arrDirect},model:{value:(_vm.formData.direction),callback:function ($$v) {_vm.$set(_vm.formData, "direction", $$v)},expression:"formData.direction"}}),_vm._v(" "),_c('SelectButton',{staticClass:"operation1",attrs:{"arr":_vm.arrOffset},model:{value:(_vm.formData.offset),callback:function ($$v) {_vm.$set(_vm.formData, "offset", $$v)},expression:"formData.offset"}}),_vm._v(" "),_c('input',{ref:"orderPrice",staticClass:"price-input operation opponent",attrs:{"type":"text","readonly":"true","placeholder":"报单价"},domProps:{"value":_vm.orderPrice},on:{"focus":function($event){_vm.showOrderPriceKeyboard=true}}}),_vm._v(" "),(_vm.showOrderPriceKeyboard)?_c('OrderPriceKeyboard',{attrs:{"title":"价格","exclude":[_vm.$refs.orderPrice],"isInteger":true,"orderPrice":_vm.formData.orderPrice,"priceTickss":_vm.priceTicks,"boardPrice":_vm.boardPrice,"orderPriceType":_vm.formData.orderPriceType},on:{"update:orderPrice":function($event){_vm.$set(_vm.formData, "orderPrice", $event)},"update:orderPriceType":function($event){_vm.$set(_vm.formData, "orderPriceType", $event)},"close":function($event){_vm.showOrderPriceKeyboard=false}}}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.volume),expression:"formData.volume"}],ref:"volume",staticClass:"price-input operation",attrs:{"type":"text","readonly":"true","placeholder":"手数"},domProps:{"value":(_vm.formData.volume)},on:{"focus":function($event){_vm.showVolumeKeyboard=true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "volume", $event.target.value)}}}),_vm._v(" "),(_vm.showVolumeKeyboard)?_c('NumKeyboard',{attrs:{"title":"手数","exclude":[_vm.$refs.volume],"isInteger":true},on:{"close":function($event){_vm.showVolumeKeyboard=false}},model:{value:(_vm.formData.volume),callback:function ($$v) {_vm.$set(_vm.formData, "volume", $$v)},expression:"formData.volume"}}):_vm._e()],1),_vm._v(" "),_c('radio-button',{staticClass:"items",attrs:{"label":"有效","arr":_vm.arrValidTime},model:{value:(_vm.formData.validTime),callback:function ($$v) {_vm.$set(_vm.formData, "validTime", $$v)},expression:"formData.validTime"}}),_vm._v(" "),_c('div',{staticClass:"items confirm"},[_c('input',{staticClass:"effective cancel",attrs:{"type":"button","value":"取消"},on:{"touchstart":_vm.handleCancel}}),_vm._v(" "),_c('input',{staticClass:"effective done",attrs:{"type":"button","value":"确定"},on:{"touchstart":_vm.addCondition}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mGxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__ = __webpack_require__("n20g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_crm_enums__ = __webpack_require__("Xo8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_proto_art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_js_proto_Model_js__ = __webpack_require__("O0G5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};








var DrawMoney = (function (_super) {
    __extends(DrawMoney, _super);
    function DrawMoney() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorMsg = '';
        _this.hintMsg = false;
        _this.setting = {};
        _this.availablemoney = '0.0';
        _this.formData = {
            name: '',
            bank: '',
            bankBranch: '',
            bankNo: '',
            money: '',
        };
        _this.selectBackCar = '';
        _this.bankCardArr = [];
        return _this;
    }
    DrawMoney.prototype.handleSelect = function () {
        this.formData.name = this.selectBackCar.name;
        this.formData.bank = this.selectBackCar.bankName;
        this.formData.bankBranch = this.selectBackCar.branchName;
        this.formData.bankNo = this.selectBackCar.bankNo;
    };
    DrawMoney.prototype.handleClickBank = function () {
        if (!this.bankCardArr.length) {
            Object(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])({
                position: 'bottom',
                message: '未添加银行卡，无法提现，请到【我的银行卡】中添加银行卡。',
            });
        }
    };
    DrawMoney.prototype.handleBankCar = function () {
        this.$router.push('/bankCar');
    };
    DrawMoney.prototype.mounted = function () {
        this.loadSetting();
    };
    DrawMoney.prototype.activated = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.selectBackCar = '';
                if (localStorage.drawMoney) {
                    this.formData = JSON.parse(localStorage.drawMoney);
                }
                this.formData.money = '';
                this.loadBank();
                __WEBPACK_IMPORTED_MODULE_7__static_js_proto_CtpFront_js__["a" /* default */].autoMount(__WEBPACK_IMPORTED_MODULE_5__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.loadMoney));
                return [2];
            });
        });
    };
    DrawMoney.prototype.loadMoney = function (onFail) {
        __WEBPACK_IMPORTED_MODULE_6__static_js_proto_Model_js__["a" /* default */].capital.attach('person', __WEBPACK_IMPORTED_MODULE_5__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.onUpdateCapital));
        __WEBPACK_IMPORTED_MODULE_6__static_js_proto_Model_js__["a" /* default */].trader.queryCapital.start();
    };
    DrawMoney.prototype.onUpdateCapital = function (capital) {
        console.log('onUpdateCapital', capital);
        if (capital === undefined) {
            this.availablemoney = '0.0';
            return;
        }
        this.availablemoney = capital.available.toFixed(2);
    };
    DrawMoney.prototype.loadBank = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, _i, data_1, i, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_4_mint_ui__["Indicator"].open();
                        this.bankCardArr = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__["a" /* postForm */])('/api/user-bank/query')];
                    case 2:
                        data = _a.sent();
                        for (_i = 0, data_1 = data; _i < data_1.length; _i++) {
                            i = data_1[_i];
                            this.bankCardArr.push({
                                id: i.Id,
                                cont: i.BankName + '(' + i.BankNo.substr(i.BankNo.length - 4) + ')',
                                bankName: i.BankName,
                                bankNo: i.BankNo,
                                branchName: i.BranchName,
                                name: i.Name,
                            });
                        }
                        return [3, 5];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3, 5];
                    case 4:
                        __WEBPACK_IMPORTED_MODULE_4_mint_ui__["Indicator"].close();
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    Object.defineProperty(DrawMoney.prototype, "serviceCharge", {
        get: function () {
            switch (this.setting.TransferOutServiceChargeType) {
                case __WEBPACK_IMPORTED_MODULE_3__types_crm_enums__["c" /* ServiceChargeTypeEnum */].Fixed:
                    return this.setting.TransferOutServiceCharge + '元';
                case __WEBPACK_IMPORTED_MODULE_3__types_crm_enums__["c" /* ServiceChargeTypeEnum */].Rate:
                    return this.setting.TransferOutServiceCharge + '%';
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DrawMoney.prototype, "serviceChargeMoney", {
        get: function () {
            switch (this.setting.TransferOutServiceChargeType) {
                case __WEBPACK_IMPORTED_MODULE_3__types_crm_enums__["c" /* ServiceChargeTypeEnum */].Fixed:
                    return this.setting.TransferOutServiceCharge;
                case __WEBPACK_IMPORTED_MODULE_3__types_crm_enums__["c" /* ServiceChargeTypeEnum */].Rate:
                    var m = this.setting.TransferOutServiceCharge *
                        parseFloat(this.formData.money) / 100;
                    if (isNaN(m)) {
                        return '0';
                    }
                    return m.toFixed(2);
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    DrawMoney.prototype.loadSetting = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__["a" /* postForm */])('/api/system/system-setting')];
                    case 1:
                        _a.setting = _b.sent();
                        return [2];
                }
            });
        });
    };
    DrawMoney.prototype.deactivated = function () {
        __WEBPACK_IMPORTED_MODULE_6__static_js_proto_Model_js__["a" /* default */].trader.queryCapital.stop();
    };
    DrawMoney.prototype.validForm = function () {
        if (!this.selectBackCar) {
            this.errorMsg = '请选择银行卡';
            this.hintMsg = true;
            this.vanish();
            return false;
        }
        var money = parseFloat(this.formData.money);
        money = isNaN(money) ? 0 : money;
        if (money <= 0) {
            this.errorMsg = '请正确填写提现金额';
            this.hintMsg = true;
            this.vanish();
            return false;
        }
        if (money > parseFloat(this.availablemoney)) {
            this.errorMsg = '请正确填写提现金额';
            this.hintMsg = true;
            this.vanish();
            return false;
        }
        if (money <= this.serviceChargeMoney) {
            this.errorMsg = '提现金额应大于手续费';
            this.hintMsg = true;
            this.vanish();
            return false;
        }
        return true;
    };
    DrawMoney.prototype.handleSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ret, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localStorage.drawMoney = JSON.stringify(this.formData);
                        if (!this.validForm()) {
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_2__utils_CrmHttp__["a" /* postForm */])('/api/transfer-out/req', {
                                TotalMoney: this.formData.money,
                                Remark: '',
                                Bank: this.formData.bank,
                                BankBranch: this.formData.bankBranch,
                                Name: this.formData.name,
                                BankNo: this.formData.bankNo,
                            })];
                    case 2:
                        ret = _a.sent();
                        Object(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])({
                            message: '操作成功',
                        });
                        this.$router.go(-1);
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        Object(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])({
                            position: 'bottom',
                            message: '失败:' + error_1.msg,
                        });
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    DrawMoney.prototype.vanish = function () {
        var _this = this;
        setTimeout(function () {
            _this.hintMsg = false;
        }, 1500);
    };
    DrawMoney.prototype.goback = function () {
        this.$router.go(-1);
    };
    DrawMoney = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], DrawMoney);
    return DrawMoney;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (DrawMoney);


/***/ }),

/***/ "mUAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_vm._l((_vm.arr),function(item){return _c('input',{key:item.value,staticClass:"effective",class:{'confirm-active':_vm.value==item.value},attrs:{"type":"button","value":item.text},on:{"touchstart":function($event){_vm.handleClick(item)}}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "moUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_TargetKeyboard_ts__ = __webpack_require__("Q1OM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62433a2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TargetKeyboard_vue__ = __webpack_require__("681v");
function injectStyle (ssrContext) {
  __webpack_require__("gFNx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62433a2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_TargetKeyboard_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62433a2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TargetKeyboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "muBx":
/***/ (function(module, exports) {

module.exports = dll;

/***/ }),

/***/ "n20g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = postForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_crm_enums__ = __webpack_require__("Xo8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonp__ = __webpack_require__("hU7x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jsonp__);




function getUrl(url, data) {
    url = crmAddress + url;
    data = data || {};
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(data, {
        chdaccountid: localStorage.accountNum,
        chdaccountpwd: localStorage.passwordNum
    });
    var params = '';
    for (var it in data) {
        if (true) {
            params += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
    }
    return url + '?' + params.replace(/&$/, '');
}
function postForm(url, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log(url);
        return __WEBPACK_IMPORTED_MODULE_3_jsonp__(getUrl(url, data), null, function (err, res) {
            console.log(err);
            console.log(res);
            if (err) {
                reject({
                    success: false,
                    errid: __WEBPACK_IMPORTED_MODULE_2__types_crm_enums__["a" /* ErrorEnum */].DataError,
                    msg: '服务器错误'
                });
            } else {
                if (res.success) {
                    resolve(res.data);
                } else {
                    reject({
                        success: false,
                        errid: res.errid,
                        msg: res.msg
                    });
                }
            }
        });
    });
}

/***/ }),

/***/ "n2GC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var TargetSelectedKeyboard = (function (_super) {
    __extends(TargetSelectedKeyboard, _super);
    function TargetSelectedKeyboard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TargetSelectedKeyboard.prototype.mounted = function () {
    };
    TargetSelectedKeyboard.prototype.handleClose = function () {
        this.$emit('close');
    };
    TargetSelectedKeyboard.prototype.handleClick = function (targetId) {
        this.$emit('submit', targetId);
        this.$emit('close');
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], TargetSelectedKeyboard.prototype, "exclude", void 0);
    TargetSelectedKeyboard = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            computed: __assign({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapState"])({
                targetSelected: 'targetSelected',
            })),
        })
    ], TargetSelectedKeyboard);
    return TargetSelectedKeyboard;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (TargetSelectedKeyboard);


/***/ }),

/***/ "nBw5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('yjheader',{attrs:{"title":"自选合约"}}),_vm._v(" "),_c('tradeList',{attrs:{"contentData":_vm.vmSelected}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nl0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseKeyboard',{attrs:{"title":"从自选中选择合约","exclude":_vm.exclude},on:{"close":_vm.handleClose}},[_c('ul',{staticClass:"target-container"},_vm._l((_vm.targetSelected),function(value,key){return _c('li',{directives:[{name:"tap",rawName:"v-tap"}],key:key,staticClass:"item",on:{"tap":function($event){_vm.handleClick(key)}}},[_vm._v("\n      "+_vm._s(key)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ntvY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_DrawMoney_ts__ = __webpack_require__("mGxc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2615bb04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawMoney_vue__ = __webpack_require__("Le4Q");
function injectStyle (ssrContext) {
  __webpack_require__("wCM4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2615bb04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_DrawMoney_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2615bb04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawMoney_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nymR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubUtils__ = __webpack_require__("FcK3");

var Params = {
    namespaced: true,
    state: {
        conditionNotTriggerList: [],
        capital: {}
    },
    getters: {
        conditionNotTriggerList: function conditionNotTriggerList(state) {
            __WEBPACK_IMPORTED_MODULE_0__SubUtils__["c" /* sub */]('conditionNotTriggerList', state.conditionNotTriggerList);
            return state.conditionNotTriggerList;
        },
        capital: function capital(state) {
            __WEBPACK_IMPORTED_MODULE_0__SubUtils__["c" /* sub */]('capital', state.capital);
            return state.capital;
        }
    },
    mutations: {
        clearAll: function clearAll(state) {
            state.conditionNotTriggerList = [];
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (Params);

/***/ }),

/***/ "o+Lj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_ConditionTriggered_ts__ = __webpack_require__("t/dn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7a05c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConditionTriggered_vue__ = __webpack_require__("G5+T");
function injectStyle (ssrContext) {
  __webpack_require__("IYy8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f7a05c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_ConditionTriggered_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7a05c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConditionTriggered_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o0jF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oRu+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p+6w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"items"},[_c('span',{staticClass:"title"},[_vm._v("合约")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.targetId),expression:"formData.targetId"}],ref:"target",staticClass:"contract",attrs:{"type":"text","readonly":"true"},domProps:{"value":(_vm.formData.targetId)},on:{"touchstart":function($event){$event.stopPropagation();_vm.showTargetKeyboard=true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "targetId", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"items"},[_c('span',{staticClass:"title"},[_vm._v("价格")]),_vm._v(" "),_c('SelectButton',{staticClass:"priceButton",attrs:{"arr":_vm.arrOperation},model:{value:(_vm.formData.operationType),callback:function ($$v) {_vm.$set(_vm.formData, "operationType", $$v)},expression:"formData.operationType"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.price),expression:"formData.price"}],ref:"price",staticClass:"price-input price-value",attrs:{"readonly":"true","type":"text"},domProps:{"value":(_vm.formData.price)},on:{"touchstart":function($event){$event.stopPropagation();_vm.showPriceKeyboard=true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "price", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"newPrice"},[_c('span',[_vm._v("最新价")]),_vm._v(" "),_c('span',{class:{'red': _vm.f_red, 'green': _vm.f_green, 'grey': _vm.f_grey}},[_vm._v(_vm._s(_vm.latestPrice))])])],1),_vm._v(" "),_c('div',{staticClass:"items"},[_c('span',{staticClass:"title"},[_vm._v("操作")]),_vm._v(" "),_c('SelectButton',{staticClass:"operation1",attrs:{"arr":_vm.arrDirect},model:{value:(_vm.formData.direction),callback:function ($$v) {_vm.$set(_vm.formData, "direction", $$v)},expression:"formData.direction"}}),_vm._v(" "),_c('SelectButton',{staticClass:"operation2",attrs:{"arr":_vm.arrOffset},model:{value:(_vm.formData.offset),callback:function ($$v) {_vm.$set(_vm.formData, "offset", $$v)},expression:"formData.offset"}}),_vm._v(" "),_c('input',{ref:"orderPrice",staticClass:"price-input operation",attrs:{"type":"text","readonly":"true","placeholder":"报单价"},domProps:{"value":_vm.orderPrice},on:{"touchstart":function($event){$event.stopPropagation();_vm.showOrderPriceKeyboard=true}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.volume),expression:"formData.volume"}],ref:"volume",staticClass:"price-input operation",attrs:{"type":"text","readonly":"true","placeholder":"手数"},domProps:{"value":(_vm.formData.volume)},on:{"touchstart":function($event){$event.stopPropagation();_vm.showVolumeKeyboard=true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "volume", $event.target.value)}}})],1),_vm._v(" "),_c('radio-button',{staticClass:"items font",attrs:{"label":"有效","arr":_vm.arrValidTime},model:{value:(_vm.formData.validTime),callback:function ($$v) {_vm.$set(_vm.formData, "validTime", $$v)},expression:"formData.validTime"}}),_vm._v(" "),_c('div',{staticClass:"items confirm"},[_c('input',{staticClass:"effective cancel",attrs:{"type":"button","value":"取消"},on:{"touchstart":_vm.handleCancel}}),_vm._v(" "),_c('input',{staticClass:"effective done",attrs:{"type":"button","value":"确定"},on:{"touchstart":_vm.addCondition}})]),_vm._v(" "),(_vm.showTargetSelectedKeyboard)?_c('TargetSelectedKeyboard',{attrs:{"exclude":[_vm.$refs.targetSelect]},on:{"submit":_vm.choiceTargetId,"close":function($event){_vm.showTargetSelectedKeyboard=false}}}):_vm._e(),_vm._v(" "),(_vm.showTargetKeyboard)?_c('TargetKeyboard',{attrs:{"exclude":[_vm.$refs.target,_vm.$refs.targetSelect]},on:{"submit":function (value){ return _vm.choiceTargetId(value); },"close":function($event){_vm.showTargetKeyboard=false}}}):_vm._e(),_vm._v(" "),(_vm.showVolumeKeyboard)?_c('NumKeyboard',{attrs:{"title":"手数","exclude":[_vm.$refs.volume],"isInteger":true},on:{"close":function($event){_vm.showVolumeKeyboard=false}},model:{value:(_vm.formData.volume),callback:function ($$v) {_vm.$set(_vm.formData, "volume", $$v)},expression:"formData.volume"}}):_vm._e(),_vm._v(" "),(_vm.showPriceKeyboard)?_c('NumKeyboard',{attrs:{"title":"价格","boardPrice":0,"exclude":[_vm.$refs.price]},on:{"close":function($event){_vm.showPriceKeyboard=false}},model:{value:(_vm.formData.price),callback:function ($$v) {_vm.$set(_vm.formData, "price", $$v)},expression:"formData.price"}}):_vm._e(),_vm._v(" "),(_vm.showOrderPriceKeyboard)?_c('OrderPriceKeyboard',{attrs:{"title":"价格","exclude":[_vm.$refs.orderPrice],"isInteger":true,"boardPrice":_vm.boardPrice,"orderPrice":_vm.formData.orderPrice,"orderPriceType":_vm.formData.orderPriceType},on:{"update:orderPrice":function($event){_vm.$set(_vm.formData, "orderPrice", $event)},"update:orderPriceType":function($event){_vm.$set(_vm.formData, "orderPriceType", $event)},"close":function($event){_vm.showOrderPriceKeyboard=false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p7F6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pID5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"goBack",on:{"click":function($event){$event.stopPropagation();return _vm.handleGoBack($event)}}},[_c('i',{staticClass:"iconfont",staticStyle:{"color":"#fff"}},[_vm._v("")]),_vm._v(" "),_c('span',[_vm._v("返回")])]),_vm._v(" "),_c('p',{staticClass:"targetName"},[_vm._v(_vm._s(_vm.titles))])]),_vm._v(" "),_c('div',{staticClass:"runDown"},[_c('p',[_c('span',[_vm._v("开仓均价")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.datas.money))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("最新价")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.newPrice))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("持仓方向")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.datas.type))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("手数")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.positions))])])]),_vm._v(" "),_c('div',{staticClass:"buts"},[_c('span',[_c('button',{on:{"click":function($event){_vm.handleClose(false)}}},[_c('i',{staticClass:"iconfont",staticStyle:{"color":"#cdcdcd","margin-right":"0.2rem"}},[_vm._v("")]),_vm._v("增加条件单")])])]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('div',{staticClass:"titleT",on:{"touchstart":_vm.handletouchT}},[_c('div',{staticClass:"planceholder"}),_vm._v(" "),_c('div',{ref:"contentScroll",staticClass:"titleList",on:{"scroll":_vm.handleMoveC}},[_c('ul',{staticClass:"titleContent"},_vm._l((_vm.listTitle),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item))])}))])]),_vm._v(" "),_c('div',{staticClass:"contentBox"},[_c('ul',{staticClass:"leftTable"},_vm._l((_vm.listData),function(item,index){return _c('li',{key:index},[_c('p',{on:{"click":function($event){_vm.handleSelectList(item, index)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.nums==index),expression:"nums==index"}]},[_c('span',{staticClass:"optionButtons"},[_c('button',{on:{"click":function($event){_vm.handleStopOrder(item)}}},[_vm._v(_vm._s(item.buttonTxt))]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.handleEditOrder(item)}}},[_vm._v("修改")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.handleDeleOrder(item)}}},[_vm._v("删除")])])])])})),_vm._v(" "),_c('div',{ref:"titleScroll",staticClass:"rightTable",on:{"scroll":_vm.handleMoveT,"touchstart":_vm.handletouchC}},[_c('ul',{staticClass:"rightTableList"},_vm._l((_vm.listData),function(item,index){return _c('li',{key:index},[_c('p',{class:['listData', {selectBg: _vm.nums==index}],on:{"click":function($event){_vm.handleSelectList(item, index)}}},[_c('span',[_vm._v(_vm._s(item.date))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.num))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.lossPrice))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.profitPrice))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.effective))])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.nums==index),expression:"nums==index"}]})])}))])])]),_vm._v(" "),_c('div',{class:['addCondition', {hiddenPopup: _vm.popupFlage}]},[_c('ul',{staticClass:"addBox"},[_c('li',[_c('span',{staticClass:"fontSize"},[_vm._v("止损价")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lossPrice),expression:"lossPrice"}],ref:"Lmoneys",attrs:{"type":"text","readonly":"readonly","maxlength":"13"},domProps:{"value":(_vm.lossPrice)},on:{"focus":function($event){_vm.priceFlage2=true},"input":function($event){if($event.target.composing){ return; }_vm.lossPrice=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"fontSize"},[_vm._v("止盈价")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profitPrice),expression:"profitPrice"}],ref:"Pmoneys",attrs:{"type":"text","readonly":"readonly","maxlength":"13"},domProps:{"value":(_vm.profitPrice)},on:{"focus":function($event){_vm.priceFlage=true},"input":function($event){if($event.target.composing){ return; }_vm.profitPrice=$event.target.value}}})]),_vm._v(" "),_c('li',[_c('span',{staticClass:"fontSize"},[_vm._v("手数")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lossNum),expression:"lossNum"}],ref:"Lnums",attrs:{"type":"text","readonly":"readonly","maxlength":"10"},domProps:{"value":(_vm.lossNum)},on:{"focus":function($event){_vm.numFlage2=true},"input":function($event){if($event.target.composing){ return; }_vm.lossNum=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"fontSize"},[_vm._v("有效期")]),_vm._v(" "),_c('div',{staticClass:"period",on:{"click":_vm.handleSelectOption}},[_c('p',[_vm._v(_vm._s(_vm.showTxt))]),_vm._v(" "),_c('i',{class:['iconfont', {tranforms: _vm.validityFlage}]},[_vm._v("")]),_vm._v(" "),_c('ul',{class:['options', {optionsShow: _vm.validityFlage}]},_vm._l((_vm.validity),function(item,index){return _c('li',{key:index,on:{"click":function($event){$event.stopPropagation();_vm.handleSelectValidity(item, index)}}},[_vm._v(_vm._s(item))])}))])]),_vm._v(" "),_c('li',{staticClass:"selectButs"},[_c('button',{on:{"click":_vm.handleEnterAdd}},[_vm._v(_vm._s(_vm.enterTxt))]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.handleClose(true)}}},[_vm._v("取消")])])])]),_vm._v(" "),(_vm.numFlage2)?_c('NumKeyboard',{attrs:{"isInteger":true,"exclude":[_vm.$refs.Lnums]},on:{"close":_vm.handleNumCloseKey2},model:{value:(_vm.lossNum),callback:function ($$v) {_vm.lossNum=$$v},expression:"lossNum"}}):_vm._e(),_vm._v(" "),(_vm.priceFlage)?_c('TradeKeyboard',{attrs:{"tick":_vm.tick,"isInteger":false,"exclude":[_vm.$refs.Pmoneys],"priceTicks":_vm.priceTicks,"price":_vm.profitPrice,"showPriceType":false},on:{"update:price":function($event){_vm.profitPrice=$event},"close":_vm.handleMoneyCloseKey1}}):_vm._e(),_vm._v(" "),(_vm.priceFlage2)?_c('TradeKeyboard',{attrs:{"tick":_vm.tick,"isInteger":false,"exclude":[_vm.$refs.Lmoneys],"priceTicks":_vm.priceTicks,"price":_vm.lossPrice,"showPriceType":false},on:{"update:price":function($event){_vm.lossPrice=$event},"close":_vm.handleMoneyCloseKey2}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pTVg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.autoClosed)?_c('div',{staticClass:"network-prompt"},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_vm._v("当前网络不可用，请检查您的网络设置!")]):_vm._e(),_vm._v(" "),_c('keep-alive',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pj7B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"headerWrapper"},[_c('i',{staticClass:"icon iconfont",on:{"click":_vm.showMenu}},[_vm._v("")]),_vm._v("\n    "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{class:['left-menu',{'exchange-menu-next':!_vm.isShowExchangeMenu}]},_vm._l((_vm.menuData),function(item,index){return _c('div',{key:index,staticClass:"menu-content-wrapper",class:{'checked-menu':_vm.checkedMenu==index},on:{"click":function($event){_vm.link(index,item.title)}}},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":item.titleIcon,"alt":item.title}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])])})),_vm._v(" "),(_vm.isShowExchangeMenu)?_c('div',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"exchange-menu-right",on:{"tap":_vm.hiddenExchange}}):_vm._e(),_vm._v(" "),_c('div',[(_vm.title!='主力合约')?_c('div',{ref:"oneTitle",staticClass:"one-title"},_vm._l((_vm._.uniqBy(_vm.contractData,'productId')),function(item,index){return (item.exchangeName == _vm.currentExchangeName)?_c('span',{directives:[{name:"tap",rawName:"v-tap"}],key:index,class:{'title1-active':_vm.checkedTitle1Text==item.productName},on:{"tap":function($event){_vm.title1Link(index,item)}}},[_vm._v(_vm._s(item.productName))]):_vm._e()})):_vm._e(),_vm._v(" "),_c('div',{staticClass:"two-title",class:{'two-title2':_vm.title=='主力合约'}},_vm._l((_vm.titleData2),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('ul',{staticClass:"order_content",class:{'order_content2':_vm.title=='主力合约'}},[_vm._l((_vm.contentData),function(item,index){return (_vm.title!='主力合约')?_c('li',{key:index,on:{"click":function($event){_vm.linkDeatil(item)}}},[_c('span',{staticClass:"targetId"},[_vm._v(_vm._s(item.targetId))]),_vm._v(" "),_c('span',{class:{ 'latestPrice-up':Number(item.latestPrice)>Number(item.lastSettlementPrice),
                        'latestPrice-down':Number(item.latestPrice)<Number(item.lastSettlementPrice)}},[_vm._v(_vm._s(item.latestPrice))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.volume))]),_vm._v(" "),_c('span',[_c('i',{class:[ 'li-three-span', { 'background-grey':Number(item.latestPrice)==Number(item.lastSettlementPrice),
                      'background-red':Number(item.latestPrice) > Number(item.lastSettlementPrice),
                      'background-green':Number(item.latestPrice) < Number(item.lastSettlementPrice)}],on:{"click":_vm.changeShowData}},[_vm._v("\n                      "+_vm._s(_vm.percent?
                      ((Number(item.latestPrice)-Number(item.lastSettlementPrice))*100/Number(item.lastSettlementPrice)).toFixed(2)+'%':
                      (Number(item.latestPrice)-Number(item.lastSettlementPrice) > 0?'+' + (Number(item.latestPrice)-Number(item.lastSettlementPrice)).toFixed(0):
                      (Number(item.latestPrice)-Number(item.lastSettlementPrice)).toFixed(0))))])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm._.orderBy(_vm.contentData2, ['exchangeId','targetId'], ['desc','desc'])),function(item,index){return (_vm.title=='主力合约')?_c('li',{key:index,on:{"click":function($event){_vm.linkDeatil(item)}}},[_c('span',{staticClass:"targetId"},[_vm._v(_vm._s(_vm.getTargetId(item)))]),_vm._v(" "),_c('span',{class:{ 'latestPrice-up':Number(item.latestPrice)>Number(item.lastSettlementPrice),
                        'latestPrice-down':Number(item.latestPrice)<Number(item.lastSettlementPrice)}},[_vm._v(_vm._s(item.latestPrice))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.volume))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"li-three-span",class:{ 'background-grey':Number(item.latestPrice)==Number(item.lastSettlementPrice),
                      'background-red':Number(item.latestPrice)>Number(item.lastSettlementPrice),
                      'background-green':Number(item.latestPrice)<Number(item.lastSettlementPrice)},on:{"click":_vm.changeShowData}},[_vm._v(" "+_vm._s(_vm.percent?
                                    ((Number(item.latestPrice)-Number(item.lastSettlementPrice))*100/Number(item.lastSettlementPrice)).toFixed(2)+'%':
                                    (Number(item.latestPrice)-Number(item.lastSettlementPrice) > 0?'+' + (Number(item.latestPrice)-Number(item.lastSettlementPrice)).toFixed(0):
                                    (Number(item.latestPrice)-Number(item.lastSettlementPrice)).toFixed(0))))])])]):_vm._e()})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qKe+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-table"},[_c('div',{staticClass:"title-contanier",on:{"touchstart":_vm.handleTouchTitle}},[_c('span',{class:{'fixed-title':true,'fixed-shadow':_vm.scrollLeft>0},style:({width:_vm.title[0].width})},[_vm._v("\n      "+_vm._s(_vm.title[0].text)+"\n    ")]),_vm._v(" "),_c('ul',{ref:"scrollTit",class:{'common-title':true,'common-shadow':_vm.scrollLeft>0},on:{"scroll":_vm.handleScrollTitle}},_vm._l((_vm.commonTitle),function(item){return _c('li',{key:item.name,staticClass:"common-title-cell",style:({width:item.width})},[_vm._v(_vm._s(item.text)+"\n      ")])}))]),_vm._v(" "),_c('div',{staticClass:"content-container",on:{"touchstart":_vm.handleTouchContent}},[_c('ul',{class:{'content-fixed':true,'fixed-shadow':_vm.scrollLeft>0},style:({width:_vm.title[0].width})},_vm._l((_vm.tableData),function(item,index){return _c('li',{key:index,class:_vm.isActive(item[_vm.dataKey]) ? 'row-active':'row'},[_c('div',{directives:[{name:"tap",rawName:"v-tap"}],staticClass:"text",on:{"tap":function($event){_vm.handleActive(item,index)}}},[_vm._v("\n          "+_vm._s(item[_vm.title[0].name])+"\n        ")]),_vm._v(" "),(_vm.isActive(item[_vm.dataKey]) )?_c('div',{staticClass:"op"},[_vm._t("op",null,{data:item})],2):_vm._e()])})),_vm._v(" "),_c('div',{ref:"scrollContent",class:{'content-common':true,'common-shadow':_vm.scrollLeft>0},style:({left:_vm.title[0].width}),on:{"scroll":_vm.handleScrollContent}},[_c('ul',{},_vm._l((_vm.tableData),function(item,index){return _c('li',{directives:[{name:"tap",rawName:"v-tap"}],key:item.id,class:_vm.activeIndex===item[_vm.dataKey] ? 'row-active':'row',on:{"tap":function($event){_vm.handleActive(item,index)}}},_vm._l((_vm.commonTitle),function(titleItem){return _c('p',{key:titleItem.name,staticClass:"cell text",style:({width:titleItem.width})},[((item[titleItem.name].constructor === Object))?_c('span',{staticClass:"ifObj"},_vm._l((item[titleItem.name]),function(x,y){return _c('p',{key:y},[_vm._v(_vm._s(x))])})):_c('span',[_vm._v(_vm._s(item[titleItem.name]))])])}))}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qXIy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseKeyboard',{attrs:{"exclude":_vm.exclude},on:{"close":_vm.handleClose}},[_c('template',{slot:"title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('table',{staticClass:"numkeyboard",attrs:{"width":"100%","height":"84%","align":"center","cellpadding":"0","cellspacing":"0"}},[(_vm.showPriceType)?_vm._t("header"):_vm._e(),_vm._v(" "),_c('tr',[_c('th',{on:{"touchstart":function($event){_vm.orderInput(1)}}},[_vm._v("1")]),_vm._v(" "),_c('th',{on:{"touchstart":function($event){_vm.orderInput(2)}}},[_vm._v("2")]),_vm._v(" "),_c('th',{on:{"touchstart":function($event){_vm.orderInput(3)}}},[_vm._v("3")]),_vm._v(" "),_c('th',{staticClass:"character",attrs:{"rowspan":"2"},on:{"touchstart":function($event){_vm.orderInput('add')}}},[_vm._v("+")])]),_vm._v(" "),_c('tr',[_c('th',{on:{"touchstart":function($event){_vm.orderInput(4)}}},[_vm._v("4")]),_vm._v(" "),_c('th',{on:{"touchstart":function($event){_vm.orderInput(5)}}},[_vm._v("5")]),_vm._v(" "),_c('th',{on:{"touchstart":function($event){_vm.orderInput(6)}}},[_vm._v("6")])]),_vm._v(" "),_c('tr',[_c('th',{on:{"touchstart":function($event){_vm.orderInput(7)}}},[_vm._v("7")]),_vm._v(" "),_c('th',{on:{"touchstart":function($event){_vm.orderInput(8)}}},[_vm._v("8")]),_vm._v(" "),_c('th',{on:{"touchstart":function($event){_vm.orderInput(9)}}},[_vm._v("9")]),_vm._v(" "),_c('th',{staticClass:"character",attrs:{"rowspan":"2"},on:{"touchstart":function($event){_vm.orderInput('reduce')}}},[_vm._v("-")])]),_vm._v(" "),_c('tr',[(!_vm.isInteger)?_c('th',{staticClass:"character",on:{"touchstart":function($event){_vm.orderInput('.')}}},[_vm._v(".")]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"colspan":_vm.isInteger?2:1},on:{"touchstart":function($event){_vm.orderInput(0)}}},[_vm._v("0")]),_vm._v(" "),_c('th',{staticClass:"character",on:{"touchstart":function($event){_vm.orderInput('delete')}}},[_c('i',{staticClass:"del iconfont"},[_vm._v("")])])])],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qqZH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_ConditionNotTrigger_ts__ = __webpack_require__("Ikte");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeefbbbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConditionNotTrigger_vue__ = __webpack_require__("hEPj");
function injectStyle (ssrContext) {
  __webpack_require__("133K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aeefbbbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_ConditionNotTrigger_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeefbbbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConditionNotTrigger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qztD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rYmX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sKYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var component = {
    namespaced: true,
    state: {
        shortcutOpen: false
    },
    mutations: {
        shortcutOpen: function shortcutOpen(state) {
            state.shortcutOpen = !state.shortcutOpen;
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (component);

/***/ }),

/***/ "sV0S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RadioButton_RadioButton_vue__ = __webpack_require__("C84v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseKeyboard_BaseKeyboard_vue__ = __webpack_require__("GOPK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_NumKeyboard_NumKeyboard_vue__ = __webpack_require__("6hYj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_FixedTable_FixedTable_vue__ = __webpack_require__("hXji");





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('RadioButton', __WEBPACK_IMPORTED_MODULE_0__RadioButton_RadioButton_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('BaseKeyboard', __WEBPACK_IMPORTED_MODULE_2__BaseKeyboard_BaseKeyboard_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('NumKeyboard', __WEBPACK_IMPORTED_MODULE_3__components_common_NumKeyboard_NumKeyboard_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('FixedTable', __WEBPACK_IMPORTED_MODULE_4__components_common_FixedTable_FixedTable_vue__["a" /* default */]);

/***/ }),

/***/ "szfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"headerWrapper"},[_vm._v("\n    个人中心\n    "),_c('i',{staticClass:"icon iconfont install",on:{"click":_vm.goSet}},[_vm._v("")])]),_vm._v(" "),_c('div',{staticClass:"tops"},[_c('div',{staticClass:"moneyMsg"},[_c('p',[_vm._v("账户余额:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.balance))])]),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('button',{on:{"click":_vm.handleRecharge}},[_vm._v("充值")]),_vm._v(" "),_c('button',{on:{"click":_vm.handleDrawMoney}},[_vm._v("提现")])])]),_vm._v(" "),_c('div',{staticClass:"moneyInfor"},[_c('div',{staticClass:"usable"},[_c('p',[_vm._v("可用余额")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.available))])]),_vm._v(" "),_c('div',{staticClass:"deposit"},[_c('p',[_vm._v("占用保证金")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.currMargin))])])]),_vm._v(" "),_c('ul',{staticClass:"tab"},[_c('li',{on:{"click":_vm.handleRechargeRecord}},[_vm._v("充值记录")]),_vm._v(" "),_c('li',{on:{"click":_vm.handleDrawMoneyRecord}},[_vm._v("提款记录")]),_vm._v(" "),(this.setting.CustomerServiceTel)?_c('li',[_vm._v("客服电话:\n      "),_c('a',{staticClass:"tel",attrs:{"href":'tel:'+this.setting.CustomerServiceTel}},[_vm._v(_vm._s(this.setting.CustomerServiceTel))])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t+Gu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t/dn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConditionData__ = __webpack_require__("hEAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_format__ = __webpack_require__("FirM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_utils__ = __webpack_require__("7C6s");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ConditionTriggered = (function (_super) {
    __extends(ConditionTriggered, _super);
    function ConditionTriggered() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.conditionTriggeredList = [];
        _this.formFind = {
            start: (new Date()),
            end: (new Date()),
        };
        _this.selectedState = __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].con_order_trigger;
        _this.tabState = {
            已触发: __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].con_order_trigger,
            已删除: __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].con_order_delete,
            已结算: __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].con_order_settlement,
        };
        _this.tableData = [];
        _this.tableTitle = [
            {
                text: '合约',
                width: '2rem',
                name: 'contract',
            },
            {
                text: '触发时间',
                width: '3.5rem',
                name: 'triggerTime',
            },
            {
                text: '状态',
                width: '1.5rem',
                name: 'state',
            },
            {
                text: '条件',
                width: '1.5rem',
                name: 'condition',
            },
            {
                text: '下单',
                width: '3rem',
                name: 'order',
            },
            {
                text: 'ID',
                width: '6rem',
                name: 'id',
            }
        ];
        _this.sheetVisible = false;
        _this.typeData = '全部';
        _this.filtFlage = true;
        _this.orderType = 0;
        _this.actionData = [
            {
                name: '全部',
                font: '&#xe623;',
                font02: '&#xe626;',
            }, {
                name: '云条件单',
                font: '&#xe623;',
                font02: '&#xe626;',
            }, {
                name: '止盈止损单',
                font: '&#xe623;',
                font02: '&#xe626;',
            }
        ];
        _this.selectIndex = '0';
        return _this;
    }
    Object.defineProperty(ConditionTriggered.prototype, "findStart", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_4__utils_format__["a" /* formatDate */](this.formFind.start);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionTriggered.prototype, "findEnd", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_4__utils_format__["a" /* formatDate */](this.formFind.end);
        },
        enumerable: true,
        configurable: true
    });
    ConditionTriggered.prototype.deactivated = function () {
        this.conditionTriggeredList = [];
        this.tableData = [];
        __WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* closeIndicator */]();
    };
    ConditionTriggered.prototype.mounted = function () {
        this.queryData();
    };
    ConditionTriggered.prototype.activated = function () {
        this.queryData();
    };
    ConditionTriggered.prototype.queryData = function () {
        var _this = this;
        this.tableData = [];
        console.log('query', this.findStart, this.findEnd);
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__static_js_proto_CtpFront__["a" /* default */].conditionOrderQry('', '', _this.findStart.replace(/[\-]/g, ''), _this.findEnd.replace(/[\-]/g, ''), function (data) {
                var conditionData = '';
                if (data.orderType === 0) {
                    conditionData = __WEBPACK_IMPORTED_MODULE_3__ConditionData__["e" /* getCondition */](data);
                }
                else {
                    if (data.direction === 1) {
                        conditionData = __WEBPACK_IMPORTED_MODULE_3__ConditionData__["e" /* getCondition */](data);
                    }
                    else {
                        conditionData = __WEBPACK_IMPORTED_MODULE_3__ConditionData__["f" /* getConditions */](data);
                    }
                }
                console.log('triggered', data, data.state);
                if (_this.filtFlage) {
                    _this.tableData.push({
                        contract: data.targetId,
                        state: __WEBPACK_IMPORTED_MODULE_3__ConditionData__["i" /* getText */](__WEBPACK_IMPORTED_MODULE_3__ConditionData__["b" /* con_active_state */](), data.state),
                        condition: conditionData,
                        order: __WEBPACK_IMPORTED_MODULE_3__ConditionData__["g" /* getOrder */](data),
                        id: data.id,
                        triggerTime: (data.updateDate + '').
                            replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + ' '
                            + (data.updateTime + '').replace(/\..*/, ''),
                    });
                }
                else {
                    if (data.orderType === _this.orderType) {
                        _this.tableData.push({
                            contract: data.targetId,
                            state: __WEBPACK_IMPORTED_MODULE_3__ConditionData__["i" /* getText */](__WEBPACK_IMPORTED_MODULE_3__ConditionData__["b" /* con_active_state */](), data.state),
                            condition: conditionData,
                            order: __WEBPACK_IMPORTED_MODULE_3__ConditionData__["g" /* getOrder */](data),
                            id: data.id,
                            triggerTime: (data.updateDate + '').
                                replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + ' '
                                + (data.updateTime + '').replace(/\..*/, ''),
                        });
                    }
                }
                _this.tableData.sort(function (a, b) {
                    return b.triggerTime > a.triggerTime ? 1 : -1;
                });
                resolve();
            }, function (err) {
                if (err.message === '查询返回为空. ecmsg:成功') {
                    __WEBPACK_IMPORTED_MODULE_5__utils_utils__["f" /* toast */]('查询列表为空');
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5__utils_utils__["f" /* toast */]('错误:' + err.message);
                }
                reject();
            });
        });
    };
    ConditionTriggered.prototype.handleQuery = function () {
        __WEBPACK_IMPORTED_MODULE_5__utils_utils__["c" /* indicator */]('正在查询');
        this.queryData()
            .then(function () { return __WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* closeIndicator */](); })
            .catch(function () { return __WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* closeIndicator */](); });
    };
    ConditionTriggered.prototype.handleSelectType = function (index) {
        this.selectIndex = index;
        if (index === 0) {
            this.filtFlage = true;
        }
        else if (index === 1) {
            this.filtFlage = false;
            this.orderType = 0;
        }
        else if (index === 2) {
            this.filtFlage = false;
            this.orderType = 1;
        }
    };
    ConditionTriggered = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], ConditionTriggered);
    return ConditionTriggered;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (ConditionTriggered);


/***/ }),

/***/ "tEWD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tKjY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tradekeyboard_TradeKeyboard__ = __webpack_require__("WhMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_condition_ConditionData__ = __webpack_require__("hEAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_proto_CtpFront_pb__ = __webpack_require__("NNz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_proto_CtpFront_pb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_js_proto_CtpFront_pb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__("7C6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LogList_LogList__ = __webpack_require__("gWs1");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};










var CheckFullStop = (function (_super) {
    __extends(CheckFullStop, _super);
    function CheckFullStop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listTitle = ['添加日期', '数量', '止损价', '止盈价', '状态', '有效期'];
        _this.touchFlage = false;
        _this.listData = [];
        _this.nums = -1;
        _this.popupFlage = true;
        _this.priceFlage = false;
        _this.priceFlage2 = false;
        _this.numFlage2 = false;
        _this.lossPrice = '';
        _this.profitPrice = '';
        _this.lossNum = 1;
        _this.period = '0';
        _this.errorMsg = '';
        _this.itemData = '';
        _this.enterTxt = '添加';
        _this.hasNum = 0;
        _this.thisNum = 0;
        _this.ChectData = '';
        _this.newPrice = '';
        _this.validity = ['当日', '永久'];
        _this.validityFlage = false;
        _this.showTxt = '当日';
        return _this;
    }
    CheckFullStop.prototype.handleSelectList = function (item, index) {
        if (this.nums === index) {
            this.nums = -1;
            return;
        }
        this.nums = index;
    };
    CheckFullStop.prototype.handleMoveT = function () {
        if (!this.touchFlage) {
            this.$refs.contentScroll.scrollLeft =
                this.$refs.titleScroll.scrollLeft;
        }
    };
    CheckFullStop.prototype.handleMoveC = function () {
        if (this.touchFlage) {
            this.$refs.titleScroll.scrollLeft =
                this.$refs.contentScroll.scrollLeft;
        }
    };
    CheckFullStop.prototype.handletouchC = function () {
        this.touchFlage = false;
    };
    CheckFullStop.prototype.handletouchT = function () {
        this.touchFlage = true;
    };
    CheckFullStop.prototype.handleGoBack = function () {
        __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].unsubTick(this.tids, 'CheckFullStop');
        this.$emit('hiddenPage');
        __WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* closeIndicator */]();
    };
    CheckFullStop.prototype.handleClose = function (flage, data) {
        if (data === void 0) { data = ''; }
        if (!flage) {
            if (data) {
                this.profitPrice = data.profitPrice;
                this.lossPrice = data.lossPrice;
                this.lossNum = data.num;
                this.period = data.validTime;
                this.showTxt = this.validity[this.period];
            }
            else {
                this.profitPrice = this.ChectData.latestPrice;
                this.lossPrice = this.ChectData.latestPrice;
                this.lossNum = 1;
                this.period = '0';
                this.showTxt = '当日';
            }
        }
        else {
            this.enterTxt = '增加条件单';
        }
        this.popupFlage = flage;
        this.validityFlage = false;
    };
    CheckFullStop.prototype.handleEnterAdd = function () {
        if (this.enterTxt === '增加条件单') {
            this.addEdit();
        }
        else {
            this.addEdit(this.itemData);
        }
        this.validityFlage = false;
    };
    CheckFullStop.prototype.direction = function (type) {
        if (type === '买') {
            return 1;
        }
        else if (type === '卖') {
            return 2;
        }
    };
    CheckFullStop.prototype.handleNumCloseKey2 = function () {
        this.$refs.Lnums.blur();
        this.numFlage2 = false;
    };
    CheckFullStop.prototype.handleMoneyCloseKey1 = function () {
        this.$refs.Pmoneys.blur();
        this.priceFlage = false;
    };
    CheckFullStop.prototype.handleMoneyCloseKey2 = function () {
        this.$refs.Lmoneys.blur();
        this.priceFlage2 = false;
    };
    CheckFullStop.prototype.changeList = function (news, old) {
        this.popupFlage = true;
        this.getData();
    };
    CheckFullStop.prototype.changeTarget = function (news, old) {
        if (news) {
            this.ChectData = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].subTick(this.tids, 'CheckFullStop');
            this.getData();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].unsubTick(this.tids, 'CheckFullStop');
        }
    };
    CheckFullStop.prototype.watchChectData = function (news, old) {
        this.newPrice = news.latestPrice;
    };
    CheckFullStop.prototype.subTickData = function () {
        __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].unsubTick(this.tids, 'CheckFullStop');
        this.ChectData = __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].subTick(this.tids, 'CheckFullStop');
    };
    CheckFullStop.prototype.activated = function () {
        this.getData();
        this.showTxt = '当日';
        this.validity = [
            '当日',
            '永久',
        ];
        this.enterTxt = '增加条件单';
        this.listTitle = [
            '日期',
            '手数',
            '止损价',
            '止盈价',
            '状态',
            '有效期',
        ];
    };
    CheckFullStop.prototype.getData = function () {
        var arr = [];
        this.hasNum = 0;
        for (var _i = 0, _a = this.conditionNotTriggerList; _i < _a.length; _i++) {
            var item = _a[_i];
            var lossPrice = Number(item.slPrice) === 0 ? '' : item.slPrice;
            var profitPrice = Number(item.tpPrice) === 0 ? '' : item.tpPrice;
            if (item.orderType === 1 &&
                item.targetId === this.titles &&
                item.posDirection === this.direction(this.datas.type)) {
                this.hasNum += Number(item.volume);
                arr.push({
                    date: item.insertDate ?
                        item.insertDate + ' '
                            + item.insertTime.substring(0, 8) :
                        item.updateDate + ' '
                            + item.updateTime.substring(0, 8),
                    num: item.volume,
                    lossPrice: lossPrice,
                    profitPrice: profitPrice,
                    type: item.state === __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].con_order_run ?
                        '启动' : '暂停',
                    effective: __WEBPACK_IMPORTED_MODULE_4__views_condition_ConditionData__["i" /* getText */](__WEBPACK_IMPORTED_MODULE_4__views_condition_ConditionData__["k" /* validTime */], item.validTime),
                    conditionPriceType: item.conditionPriceType,
                    direction: item.direction,
                    id: item.id,
                    offset: item.offset,
                    operationType: item.operationType,
                    orderPrice: item.orderPrice,
                    orderPriceType: item.orderPriceType,
                    orderType: item.orderType,
                    posDirection: item.posDirection,
                    state: item.state,
                    targetId: item.targetId,
                    validTime: item.validTime,
                    buttonTxt: item.state === __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].con_order_run ?
                        '暂停' : '启动',
                });
            }
        }
        this.listData = arr;
    };
    CheckFullStop.prototype.addEdit = function (item) {
        var _this = this;
        if (item === void 0) { item = ''; }
        if (Number(this.lossNum) === 0) {
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('请输入止盈止损单数量');
            return;
        }
        var nums = this.hasNum - this.thisNum;
        if (this.positions < (Number(this.lossNum) + nums)) {
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('止盈止损单总数量大于持仓数量');
            return;
        }
        if (this.lossPrice === '' || Number(this.lossPrice) === 0) {
            if (this.profitPrice === '' || Number(this.profitPrice) === 0) {
                __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('运行中');
                return;
            }
        }
        if ((this.lossPrice * 100000000).toFixed(0) % (this.priceTicks * 100000000).toFixed(0) !== 0) {
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('止盈价格不符合该合约的最小变动价');
            return;
        }
        if ((this.profitPrice * 100000000).toFixed(0) % (this.priceTicks * 100000000).toFixed(0) !== 0) {
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('止损价格不符合该合约的最小变动价');
            return;
        }
        var cond = new __WEBPACK_IMPORTED_MODULE_7__static_js_proto_CtpFront_pb__["OrderConditional"]();
        cond.setTargetId(this.titles);
        cond.setVolume(this.lossNum);
        cond.setSlPrice(this.lossPrice);
        cond.setTpPrice(this.profitPrice);
        cond.setOrderType(1);
        cond.setValidTime(Number(this.period));
        cond.setOrderPriceType(17);
        if (item) {
            cond.setId(item.id);
            cond.setPosDirection(item.posDirection);
            cond.setState(item.state);
            cond.setOffset(item.offset);
            cond.setDirection(item.direction);
        }
        else {
            var num = 0;
            for (var _i = 0, _a = this.listData; _i < _a.length; _i++) {
                var items = _a[_i];
                num += items.num;
            }
            if (num >= this.positions) {
                __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('止盈止损单总数量大于持仓数量');
                return;
            }
            cond.setPosDirection(this.direction(this.datas.type));
        }
        __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].conditionOrderSave(cond, function (resolve) {
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* closeIndicator */]();
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('成功');
            if (false)
                console.log(resolve);
            _this.handleClose(true);
            _this.thisNum = 0;
        }, function (reject) {
            console.error(reject);
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('失败' + ': ' + reject.message);
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* closeIndicator */]();
        });
    };
    CheckFullStop.prototype.handleStopOrder = function (item) {
        if (false)
            console.log(item);
        var cond = new __WEBPACK_IMPORTED_MODULE_7__static_js_proto_CtpFront_pb__["OrderConditional"]();
        cond.setId(item.id);
        cond.setTargetId(item.targetId);
        cond.setVolume(item.num);
        cond.setSlPrice(item.lossPrice);
        cond.setTpPrice(item.profitPrice);
        cond.setConditionPriceType(__WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].con_last_price);
        cond.setOperationType(item.operationType);
        cond.setPosDirection(item.posDirection);
        cond.setOffset(item.offset);
        cond.setValidTime(item.validTime);
        cond.setOrderPriceType(17);
        cond.setOrderType(1);
        if (item.state === __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].con_order_run) {
            cond.setState(__WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].con_order_stop);
        }
        else {
            cond.setState(__WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].con_order_run);
        }
        __WEBPACK_IMPORTED_MODULE_8__utils_utils__["c" /* indicator */]('正在处理');
        __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].conditionOrderSave(cond, function (resolve) {
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* closeIndicator */]();
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('成功');
            if (false)
                console.log(resolve);
        }, function (reject) {
            console.error(reject);
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('失败' + ': ' + reject.message);
            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* closeIndicator */]();
        });
    };
    CheckFullStop.prototype.handleDeleOrder = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, __WEBPACK_IMPORTED_MODULE_8__utils_utils__["b" /* confirm */]('确认删除吗', '删除', '确定', '取消')];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [2];
                    case 3:
                        __WEBPACK_IMPORTED_MODULE_8__utils_utils__["c" /* indicator */]('正在处理....');
                        __WEBPACK_IMPORTED_MODULE_5__static_js_proto_CtpFront__["a" /* default */].conditionOrderRemove('', '', item.id, function (resolve) {
                            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* closeIndicator */]();
                            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('删除成功');
                        }, function (reject) {
                            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* toast */]('失败' + ': ' + reject.message);
                            __WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* closeIndicator */]();
                        });
                        return [2];
                }
            });
        });
    };
    CheckFullStop.prototype.handleEditOrder = function (item) {
        this.enterTxt = '修改';
        this.handleClose(false, { lossPrice: item.lossPrice,
            profitPrice: item.profitPrice,
            num: item.num,
            validTime: item.validTime });
        this.itemData = item;
        this.thisNum = item.num;
    };
    CheckFullStop.prototype.handleSelectOption = function () {
        this.validityFlage = !this.validityFlage;
    };
    CheckFullStop.prototype.handleSelectValidity = function (item, index) {
        this.validityFlage = false;
        this.period = index;
        this.showTxt = item;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], CheckFullStop.prototype, "datas", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], CheckFullStop.prototype, "tids", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], CheckFullStop.prototype, "titles", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], CheckFullStop.prototype, "positions", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], CheckFullStop.prototype, "showFlage", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], CheckFullStop.prototype, "tick", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], CheckFullStop.prototype, "priceTicks", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["b" /* Watch */])('conditionNotTriggerList', { deep: true })
    ], CheckFullStop.prototype, "changeList", null);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["b" /* Watch */])('showFlage', { deep: true })
    ], CheckFullStop.prototype, "changeTarget", null);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["b" /* Watch */])('ChectData', { deep: true })
    ], CheckFullStop.prototype, "watchChectData", null);
    CheckFullStop = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            components: {
                TradeKeyboard: __WEBPACK_IMPORTED_MODULE_3__Tradekeyboard_TradeKeyboard__["a" /* default */],
                logList: __WEBPACK_IMPORTED_MODULE_9__LogList_LogList__["a" /* default */],
            },
            computed: __assign({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])({
                conditionNotTriggerList: 'Params/conditionNotTriggerList',
            })),
        })
    ], CheckFullStop);
    return CheckFullStop;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (CheckFullStop);


/***/ }),

/***/ "tx1i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('dyfooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u/H+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"378px","height":"378px","margin-left":"12px"},attrs:{"id":"main"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u9e+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uGI/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uOF0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLazyLoad)?_c('div',{staticClass:"showLazyLoad"},[_vm._v("正在加载数据...")]):_vm._e(),_vm._v(" "),(_vm.nonData)?_c('div',{staticClass:"nonData"},[_vm._v("暂时没有更多数据")]):_vm._e(),_vm._v(" "),(_vm.showLoading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"headerWrapper"},[_c('i',{staticClass:"icon iconfont left",on:{"click":function($event){_vm.goBack()}}},[_vm._v("")]),_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_c('i',{staticClass:"icon iconfont right",on:{"click":_vm.order}},[_vm._v("")]),_vm._v(" "),_c('i',{staticClass:"icon iconfont right2",domProps:{"innerHTML":_vm._s(_vm.selfContract2)},on:{"click":function($event){_vm.select(_vm.title)}}})]),_vm._v(" "),_c('div',{ref:"two_top",staticClass:"top-wrapper"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"top-left"},[_c('i',{staticClass:"icon iconfont",domProps:{"innerHTML":_vm._s(_vm.nowIcon)},on:{"click":_vm.changeIcon}})]),_vm._v(" "),_c('div',{ref:"back",staticClass:"top-middle",class:{'c_grey':_vm.c_grey,'c_red':_vm.c_red,'c_green':_vm.c_green}},[_c('div',{staticClass:"middle-first"},[_vm._v("\n          "+_vm._s(_vm.newPrice)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"middle-two"},[_c('p',[_vm._v("\n            "+_vm._s(_vm.ranges)+"\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.limit)+"%\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"top-right"},[_c('div',{staticClass:"right-content"},[_c('span',[_vm._v("今开")]),_vm._v(" "),_c('span',{class:{openColor:_vm.open_color,openColor2:_vm.open_color2}},[_vm._v(_vm._s(_vm.open))])]),_vm._v(" "),_c('div',{staticClass:"right-content"},[_c('span',[_vm._v("成交量")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.turnover))])]),_vm._v(" "),_c('div',{staticClass:"right-content"},[_c('span',[_vm._v("昨结")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.close))])]),_vm._v(" "),_c('div',{staticClass:"right-content"},[_c('span',[_vm._v("持仓量")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.number))])])])]),_vm._v(" "),(_vm.nowIcon=='&#xe718;')?_c('div',{staticClass:"two-top"},_vm._l((_vm.timeImfor),function(item,index){return _c('div',{key:index},[_c('span',[_vm._v(_vm._s(item.tit))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.pro))])])})):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.nowType==1),expression:"nowType==1"}],staticClass:"k-wrapper1",attrs:{"id":"main1"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.nowType==3),expression:"nowType==3"}],staticClass:"k-wrapper2",attrs:{"id":"main3"},on:{"touchstart":_vm.longtouch,"touchmove":_vm.move,"touchend":_vm.clearLoop,"click":_vm.showShare}}),_vm._v(" "),(_vm.handIcap)?_c('div',{staticClass:"handicap"},_vm._l((_vm.timeImfor_bottom),function(item,index){return _c('div',{key:index,class:['bottom-data',{tcolor:_vm.h_color&&index == 'hightPro',
                                tcolor2:_vm.l_color&&index == 'lowPro',
                                tcolor3:_vm.hColor&&index == 'hightPro',
                                tcolor4:_vm.lColor&&index == 'lowPro',
                                srcolor:_vm.sr_color&&index == 'sellPro',
                                sgcolor:_vm.sg_color&&index == 'sellPro',
                                bgcolor:_vm.bg_color&&index == 'buyPro',
                                brcolor:_vm.br_color&&index == 'buyPro',
                                stopColorg:_vm.stop_colorg&&index == 'limitStop',
                                stopColorr:_vm.stop_colorr&&index == 'limitStop',
                                downColorg:_vm.down_colorg&&index == 'limitDown',
                                downColorr:_vm.down_colorr&&index == 'limitDown',}]},[_c('span',[_vm._v(_vm._s(item.tit))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.pro))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.buy))])])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"middle"},[(_vm.appear_share)?_c('div',{staticClass:"popus"},[_c('div',_vm._l((_vm.share),function(item,index){return _c('span',{key:index,class:{"clickBackground": index == _vm.c_index},on:{"click":function($event){_vm.cutM(item,index)}}},[_vm._v(_vm._s(item))])}))]):_vm._e(),_vm._v(" "),(_vm.appear_shareMACD)?_c('div',{staticClass:"MACDpopus"},[_c('div',_vm._l((_vm.shareMACD),function(item,index){return _c('span',{key:index,class:{"clickBackground": index == _vm.MACD_index},on:{"click":function($event){_vm.cutMACD(item,index)}}},[_vm._v(_vm._s(item))])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pardon"},[_c('span',{class:{'slect_k': _vm.select_k == 1},on:{"click":function($event){_vm.option_k(1)}}},[_vm._v("分时")]),_vm._v(" "),_c('span',{class:{'slect_k': _vm.select_k == 2},on:{"click":function($event){_vm.option_k(2)}}},[_vm._v(_vm._s(_vm.minute)+"\n        "),_c('i',{staticClass:"icon iconfont font_icon",domProps:{"innerHTML":_vm._s(_vm.seleIcon_m)}})]),_vm._v(" "),_c('span',{class:{'slect_k': _vm.select_k == 3},on:{"click":function($event){_vm.option_k(3)}}},[_vm._v("日")]),_vm._v(" "),_c('span',{class:{'slect_k': _vm.select_k == 4},on:{"click":function($event){_vm.option_k(4)}}},[_vm._v(_vm._s(_vm.week)+"\n        "),_c('i',{staticClass:"icon iconfont font_icon",domProps:{"innerHTML":_vm._s(_vm.seleIcon_z)}})])]),_vm._v(" "),_c('div',{staticStyle:{"color":"#ccc","width":"1.5rem"},on:{"click":_vm.seleMACD}},[(_vm.MacdFlage)?_c('span',[_vm._v(_vm._s(_vm.dLink)+"\n        "),_c('i',{staticClass:"icon iconfont font_icon",domProps:{"innerHTML":_vm._s(_vm.seleIcon_D)}})]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__("F7NO"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vE1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_yjheader__ = __webpack_require__("eR8I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_market_shangqi_png__ = __webpack_require__("HWOL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_market_shangqi_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_market_shangqi_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_market_dashuang_png__ = __webpack_require__("JcpO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_market_dashuang_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_market_dashuang_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_market_zhenshuang_png__ = __webpack_require__("45ek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_market_zhenshuang_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_market_zhenshuang_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_market_zhongjin_png__ = __webpack_require__("3P7H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_market_zhongjin_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_market_zhongjin_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_market_nengyuan_png__ = __webpack_require__("b7XU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_market_nengyuan_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_market_nengyuan_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_market_guangqi_png__ = __webpack_require__("IbXa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_market_guangqi_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_market_guangqi_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_market_zhuli_png__ = __webpack_require__("9LER");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_market_zhuli_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_market_zhuli_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_js_proto_Model_js__ = __webpack_require__("O0G5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_js_proto_art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_js_proto_tmi_Tmi_js__ = __webpack_require__("jAd7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "market",
  components: {
    yjheader: __WEBPACK_IMPORTED_MODULE_3__components_common_yjheader__["a" /* default */]
  },
  data: function data() {
    return {
      name: "market",
      currentExchangeName: "上期所",
      currentProductId: "",
      lastProductId: "",
      contentDataSeconds: [],
      title: "上期所",
      menuData: [{
        title: "上期所",
        titleIcon: __WEBPACK_IMPORTED_MODULE_4__assets_images_market_shangqi_png___default.a,
        link: "shfe"
      }, {
        title: "大商所",
        titleIcon: __WEBPACK_IMPORTED_MODULE_5__assets_images_market_dashuang_png___default.a,
        link: "shfe"
      }, {
        title: "郑商所",
        titleIcon: __WEBPACK_IMPORTED_MODULE_6__assets_images_market_zhenshuang_png___default.a,
        link: "shfe"
      }, {
        title: "中金所",
        titleIcon: __WEBPACK_IMPORTED_MODULE_7__assets_images_market_zhongjin_png___default.a,
        link: "shfe"
      }, {
        title: "能源中心",
        titleIcon: __WEBPACK_IMPORTED_MODULE_8__assets_images_market_nengyuan_png___default.a,
        link: "nengyuan"
      }, {
        title: "广期所",
        titleIcon: __WEBPACK_IMPORTED_MODULE_9__assets_images_market_guangqi_png___default.a,
        link: "shfe"
      }, {
        title: "主力合约",
        titleIcon: __WEBPACK_IMPORTED_MODULE_10__assets_images_market_zhuli_png___default.a,
        link: "zhuli"
      }],
      titleData1: ["黄金", "石油沥青", "沪铜", "燃油", "热轧卷板", "沪铅", "螺纹钢", "像胶", "线材", "沪锌", "像胶", "线材"],
      titleData2: ["合约", "最新价", "成交量", "涨跌幅"],
      contentData: [],
      checkedMenu: 0,
      // checkedTitle1: 0,
      checkedTitle1Text: "",
      percent: true,
      contractData: [],
      contentData2: [],
      mainList: [],
      dominant_view: "dominant_view",
      isShowExchangeMenu: false // 是否“显示交易所导航菜单”
    };
  },

  computed: {},
  watch: {
    currentProductId: function currentProductId(curVal, oldVal) {
      if (curVal == "") {
        return;
      }
      this.subTick(curVal);
    }
  },
  mounted: function mounted() {
    this.contractData = __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].targetList;
    this.link(0, this.title);
    this.checkedTitle1Text = "沪银";
    // this.checkedTitle1 = "";
    this.title = "上期所";
  },
  beforeDestroy: function beforeDestroy() {},


  // 进入行情页面
  activated: function activated() {
    this.$store.commit("selectIndex", 1);
    __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].autoMount(__WEBPACK_IMPORTED_MODULE_13__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.load));
  },


  // 切出行情页面
  deactivated: function deactivated() {
    __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].unsubTick(this.currentProductId, this.name);
    this.domiantUnsub();
    beferFooterIndex = 1;
  },


  methods: {
    getTargetId: function getTargetId(item) {
      // return item.targetName.length <= 8 ? item.targetName : item.targetId;
      return item.targetName;
    },

    // 初始化页面数据：用于切入页面与恢复页面数据。
    load: function load(onFail) {
      this.contractData = __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].targetList;
      if (this.checkedMenu == 6) {
        this.domiantSub();
      } else {
        this.subTick(this.currentProductId);
      }
    },


    // 主力合约订阅与反订阅
    domiantSub: function domiantSub() {
      var _this = this;

      var subTick = function subTick(targetId) {
        return __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].subTick(targetId, {
          suberId: _this.dominant_view,
          publish: function publish(tick) {
            return _this.onDominantTick(tick);
          }
        });
      };
      if (!__WEBPACK_IMPORTED_MODULE_12__static_js_proto_Model_js__["a" /* default */].dominantSet) {
        __WEBPACK_IMPORTED_MODULE_12__static_js_proto_Model_js__["a" /* default */].dominantSet = __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].dominantTargetSub({
          suberId: this.dominant_view,
          publish: function publish(target) {
            return subTick(target.targetId);
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_15_lodash__["forEach"](__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__static_js_proto_Model_js__["a" /* default */].dominantSet), subTick);
      }
    },
    domiantUnsub: function domiantUnsub() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_12__static_js_proto_Model_js__["a" /* default */].dominantSet) {
        __WEBPACK_IMPORTED_MODULE_15_lodash__["forEach"](__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__static_js_proto_Model_js__["a" /* default */].dominantSet), function (targetId) {
          return __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].unsubTick(targetId, _this2.dominant_view);
        });
      }
    },


    // 主力合约行情信息
    onDominantTick: function onDominantTick(tick) {
      var that = this;
      if (tick.targetId === undefined) {
        return;
      }
      var target = __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].targetSet[tick.targetId];
      if (target === undefined) return;

      // #.查找主力合约是否存在
      var productId = __WEBPACK_IMPORTED_MODULE_14__static_js_proto_tmi_Tmi_js__["a" /* default */].productId(tick.targetId);
      var find = __WEBPACK_IMPORTED_MODULE_15_lodash__(that.contentData2).findIndex(function (r) {
        return r.productId == productId;
      });
      // 1.添加主力合约
      if (find === -1) {
        var data = {};
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(data, tick);
        data.productId = productId;
        data.targetName = target.targetName;
        that.contentData2.push(data);
        return;
      }

      // 2.更新主力合约
      var oldTargetId = that.contentData2[find].targetId;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(that.contentData2[find], tick);
      that.contentData2[find].targetName = target.targetName;
      // 取消订阅被替换的主力合约
      if (tick.targetId != oldTargetId) {
        __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].unsubTick(oldTargetId, that.dominant_view);
      }
    },


    // 订阅品种的行情信息
    subTick: function subTick(productId) {
      var that = this;
      that.contentData = [];
      for (var i = 0; i < that.contractData.length; ++i) {
        var elem = that.contractData[i];
        if (elem.productId == productId) {
          that.contentData.push({
            targetId: elem.targetId,
            lastSettlementPrice: 1,
            latestPrice: 1,
            volume: 0
          });
        }
      }
      if (that.lastProductId !== that.currentTargetId) {
        // 订阅合约品种
        __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].subTick(productId, {
          suberId: "market",
          publish: function publish(tick) {
            for (var i = 0; i < that.contentData.length; ++i) {
              var elem = that.contentData[i];
              if (elem.targetId == tick.targetId) {
                elem.lastSettlementPrice = tick.lastSettlementPrice;
                elem.latestPrice = tick.latestPrice;
                elem.volume = tick.volume;
                elem.askPrice1 = tick.askPrice1;
                elem.bidPrice1 = tick.bidPrice1;
                elem.highPrice = tick.highPrice;
                elem.highStopPrice = tick.highStopPrice;
                elem.lastClosePrice = tick.lastClosePrice;
                elem.lowPrice = tick.lowPrice;
                elem.lowStopPrice = tick.lowStopPrice;
                elem.openPrice = tick.openPrice;
                elem.bidVolume1 = tick.bidVolume1;
                elem.askVolume1 = tick.askVolume1;
                elem.position = tick.position;
                that.contentData[i] = elem;
              }
            }
          }
        });
        // 取消订阅切换前的品种
        if (that.lastProductId !== productId) {
          __WEBPACK_IMPORTED_MODULE_11__static_js_proto_CtpFront_js__["a" /* default */].unsubTick(that.lastProductId, this.name);
        }
      }
      that.lastProductId = productId;
    },
    link: function link(i, title) {
      this.checkedMenu = i;
      this.title = title;
      if (i == 0) {
        this.currentExchangeName = "上期所";
        this.currentProductId = "ag";
        this.checkedTitle1Text = "沪银";
        this.domiantUnsub();
      } else if (i == 1) {
        this.currentExchangeName = "大商所";
        this.currentProductId = "a";
        this.checkedTitle1Text = "豆一";
        this.domiantUnsub();
      } else if (i == 2) {
        this.currentExchangeName = "郑商所";
        this.currentProductId = "AP";
        this.checkedTitle1Text = "苹果";
        this.domiantUnsub();
      } else if (i == 3) {
        this.currentExchangeName = "中金所";
        this.currentProductId = "IC";
        this.checkedTitle1Text = "中证500";
        this.domiantUnsub();
      } else if (i == 4) {
        this.currentExchangeName = "上期能源";
        this.currentProductId = "sc";
        this.checkedTitle1Text = "原油";
        this.domiantUnsub();
      } else if (i == 5) {
        this.currentExchangeName = "广期所";
        this.currentProductId = "si";
        this.checkedTitle1Text = "工业硅";
        this.domiantUnsub();
      } else if (i == 6) {
        this.domiantSub();
      }
      this.isShowExchangeMenu = false;
    },

    // 点击隐藏交易所选项
    hiddenExchange: function hiddenExchange() {
      this.isShowExchangeMenu = false;
    },
    showMenu: function showMenu() {
      this.isShowExchangeMenu = !this.isShowExchangeMenu;
      // window.scrollTo(0,0);
      if (this.title !== "主力合约") {
        this.$refs.oneTitle.scrollTo(0, 0); //this.$refs.input1  减少获取dom节点的消耗
      }
    },
    title1Link: function title1Link(index, item) {
      if (item.productId == this.currentProductId) {
        return;
      }
      // this.$toast(11);
      this.currentProductId = item.productId;
      this.checkedTitle1Text = item.productName;
      // this.checkedTitle1 = index;
      // this.$toast(index);
      // prompt('输入你的名字：', '默认名字');
    },
    changeShowData: function changeShowData(e) {
      e.stopPropagation();
      this.percent = !this.percent;
      if (this.percent == true) {
        this.titleData2[3] = "涨跌幅";
      } else if (this.percent == false) {
        this.titleData2[3] = "涨跌";
      }
    },
    unique: function unique(arr, key, obj) {
      var res = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      return arr.filter(function (key) {
        return !res.has(key) && res.push(obj);
      });
    },
    linkDeatil: function linkDeatil(item) {
      this.$router.push({ path: "/marketDetail/" + item.targetId });
      // this.$router.push({path:'/marketDeatil'});
    }
  }
});

/***/ }),

/***/ "vL01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__ = __webpack_require__("WvhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_proto_Model_js__ = __webpack_require__("O0G5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_CrmHttp__ = __webpack_require__("n20g");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var Person = (function (_super) {
    __extends(Person, _super);
    function Person() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.balance = '0.00';
        _this.available = '0.00';
        _this.currMargin = '0.00';
        _this.setting = {};
        return _this;
    }
    Person.prototype.activated = function () {
        __WEBPACK_IMPORTED_MODULE_4__static_js_proto_CtpFront_js__["a" /* default */].autoMount(__WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.load));
        this.$store.commit('selectIndex', 4);
        if (!this.setting.CustomerServiceTel) {
            this.loadSetting();
        }
    };
    Person.prototype.deactivated = function () {
        __WEBPACK_IMPORTED_MODULE_3__static_js_proto_Model_js__["a" /* default */].trader.queryCapital.stop();
    };
    Person.prototype.goSet = function () {
        this.$router.push('/setPage');
    };
    Person.prototype.handleRecharge = function () {
        this.$router.push({ path: '/recharge' });
    };
    Person.prototype.handleDrawMoney = function () {
        this.$router.push({ path: '/drawmoney/' + this.available });
    };
    Person.prototype.handleRechargeRecord = function () {
        this.$router.push({ path: '/rechargerecord' });
    };
    Person.prototype.handleDrawMoneyRecord = function () {
        this.$router.push({ path: '/drawmoneyrecord' });
    };
    Person.prototype.load = function (onFail) {
        __WEBPACK_IMPORTED_MODULE_3__static_js_proto_Model_js__["a" /* default */].capital.attach('person', __WEBPACK_IMPORTED_MODULE_2__static_js_proto_art_Art_js__["a" /* default */].bind(this, this.onUpdateCapital));
        __WEBPACK_IMPORTED_MODULE_3__static_js_proto_Model_js__["a" /* default */].trader.queryCapital.start();
    };
    Person.prototype.loadSetting = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4, Object(__WEBPACK_IMPORTED_MODULE_5__utils_CrmHttp__["a" /* postForm */])('/api/system/system-setting')];
                    case 1:
                        _a.setting = _c.sent();
                        return [3, 3];
                    case 2:
                        _b = _c.sent();
                        this.setting = {};
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Person.prototype.onUpdateCapital = function (capital) {
        if (capital === undefined) {
            this.balance = '0.0';
            this.available = '0.0';
            this.currMargin = '0.0';
            return;
        }
        this.balance = capital.balance.toFixed(2);
        this.available = capital.available.toFixed(2);
        this.currMargin = capital.currMargin.toFixed(2);
    };
    Person = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
    ], Person);
    return Person;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Person);


/***/ }),

/***/ "vblW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_debugout__ = __webpack_require__("U9Gh");

var bugout = new __WEBPACK_IMPORTED_MODULE_0__assets_js_debugout__["a" /* default */]();
bugout.realTimeLoggingOn = false;
bugout.useTimestamps = true;
bugout.useLocalStorage = true;
var Log = function () {
    function Log() {
        this.isStart = false;
    }
    Log.prototype.log = function (obj) {
        console.log(obj);
        bugout.log(obj);
        var text = bugout.getLog();
        console.log('text', text);
        bugout.clear();
    };
    Log.prototype.log1 = function (obj) {
        console.log(obj);
        bugout.log(obj);
    };
    Log.prototype.getLog = function () {
        bugout.getLog();
    };
    return Log;
}();
/* harmony default export */ __webpack_exports__["a"] = (new Log());

/***/ }),

/***/ "vvyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__("c+8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__("443i");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var LogList = (function (_super) {
    __extends(LogList, _super);
    function LogList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableTitle = [
            {
                text: '合约',
                width: '2rem',
                name: 'targetId',
            },
            {
                text: '合约ID',
                width: '6rem',
                name: 'ID',
            },
            {
                text: '操作类型',
                width: '3rem',
                name: 'optionType',
            },
            {
                text: '运行状态',
                width: '2rem',
                name: 'runState',
            },
            {
                text: '机器Mac地址',
                width: '3rem',
                name: 'computedMac',
            },
            {
                text: '操作时间',
                width: '4rem',
                name: 'optionTime',
            },
            {
                text: '描述',
                width: '9rem',
                name: 'describe',
            }
        ];
        return _this;
    }
    LogList.prototype.handleGoBack = function () {
        this.$emit('goBack');
    };
    LogList.prototype.activated = function () {
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["a" /* Prop */])()
    ], LogList.prototype, "data", void 0);
    LogList = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            components: {},
        })
    ], LogList);
    return LogList;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (LogList);


/***/ }),

/***/ "wCM4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x8Zw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x972":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_proto_CtpFront_js__ = __webpack_require__("6uOh");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {};
  },

  computed: {
    autoClosed: function autoClosed() {
      return this.$store.state.autoClosed;
    }
  }
});

/***/ }),

/***/ "xJkX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"warp",on:{"click":_vm.handleonOff}},[_c('span',{class:['text', {texts:_vm.flage}]},[_vm._v(_vm._s(_vm.type))]),_vm._v(" "),_c('span',{class:['circle', {circles:_vm.flage}]})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xpwS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xruU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('span',{on:{"click":_vm.goback}},[_c('i',{staticClass:"icon iconfont left"},[_vm._v("")]),_vm._v("\n      返回\n    ")]),_vm._v("\n    云条件单")]),_vm._v(" "),_c('div',{staticClass:"navbar"},[_c('mt-navbar',{model:{value:(_vm.spanState),callback:function ($$v) {_vm.spanState=$$v},expression:"spanState"}},[_c('mt-tab-item',{attrs:{"id":"1"}},[_vm._v("未触发条件单")]),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"2"}},[_vm._v("已触发条件单")]),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"3"}},[_vm._v("增加条件单")])],1)],1),_vm._v(" "),_c('div',{staticClass:"main"},[(_vm.spanState==1)?_c('ConditionNotTrigger'):(_vm.spanState==2)?_c('ConditionTriggered'):_c('ConditionInsert',{attrs:{"targentId":this.$route.query.targetId,"type":this.$route.query.type,"closeOut":this.$route.query.closeOut,"money":this.$route.query.money,"priceTicks":this.$route.query.priceTicks}})],1),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('div',{staticClass:"prefix"},[_vm._v("提示：")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n      1. 云端服务器只保证触发不保证成交。"),_c('br')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xu5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "tradeList",
  props: ["contentData"],
  data: function data() {
    return {
      titleData2: ["合约", "最新价", "成交量", "涨跌幅"],
      percent: true
    };
  },

  computed: {
    arrData: function arrData() {
      var arrDatas = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.contentData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          if (i.lastSettlementPrice == 0) {
            var temporary = '0.00%';
          } else {
            var temporary = ((i.latestPrice - i.lastSettlementPrice) * 100 / i.lastSettlementPrice).toFixed(2) + '%';
          }
          arrDatas.push({
            lastSettlementPrice: i.lastSettlementPrice,
            latestPrice: i.latestPrice,
            targetId: i.targetId,
            targetName: i.targetName,
            volume: i.volume,
            rangeRate: temporary,
            range: i.latestPrice - i.lastSettlementPrice > 0 ? '+' + (i.latestPrice - i.lastSettlementPrice).toFixed(0) : (i.latestPrice - i.lastSettlementPrice).toFixed(0)
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return arrDatas;
    }
  },
  mounted: function mounted() {
    // console.log(this.arrData);
  },

  methods: {
    getTarget: function getTarget(item) {
      // return item.targetName.length <= 7 ? item.targetName : item.targetId;
      return item.targetName;
    },
    linkDeatil: function linkDeatil(item) {
      // this.$router.push({path:'/marketDetail/'+contract});
      this.$router.push({ path: "/marketDetail/" + item.targetId });
      // this.$router.push({path:'/marketDeatil'});
    },
    changeShowData: function changeShowData(e) {
      e.stopPropagation();
      this.percent = !this.percent;
      if (this.percent == true) {
        this.titleData2[3] = "涨跌幅";
      } else if (this.percent == false) {
        this.titleData2[3] = "涨跌";
      }
    }
  }
});

/***/ }),

/***/ "y59h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("f0wD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a283c40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("jQeE");
function injectStyle (ssrContext) {
  __webpack_require__("IUrU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a283c40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a283c40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yHwS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zLbt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zSVF":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = __webpack_require__("LkYP");
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.proto.Error', null, global);
goog.exportSymbol('proto.proto.File', null, global);
goog.exportSymbol('proto.proto.Property', null, global);
goog.exportSymbol('proto.proto.Remove', null, global);
goog.exportSymbol('proto.proto.Request', null, global);
goog.exportSymbol('proto.proto.Response', null, global);
goog.exportSymbol('proto.proto.Subscribe', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Error = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Error, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Error.displayName = 'proto.proto.Error';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.Error.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.Error.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.Error} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.Error.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, 0),
      message: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Error}
 */
proto.proto.Error.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Error();
  return proto.proto.Error.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Error} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Error}
 */
proto.proto.Error.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readInt32();
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setMessage(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Error.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.Error.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Error} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Error.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
};

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.proto.Error.prototype.getId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.proto.Error.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string message = 2;
 * @return {string}
 */
proto.proto.Error.prototype.getMessage = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.proto.Error.prototype.setMessage = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Request = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Request.displayName = 'proto.proto.Request';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.Request.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.Request.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.Request} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.Request.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 10, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Request}
 */
proto.proto.Request.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Request();
  return proto.proto.Request.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Request}
 */
proto.proto.Request.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 10:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Request.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Request.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(10, f);
  }
};

/**
 * optional uint64 user_id = 10;
 * @return {number}
 */
proto.proto.Request.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};

/** @param {number} value */
proto.proto.Request.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Response = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Response.displayName = 'proto.proto.Response';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.Response.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.Response.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.Response} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.Response.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      error: (f = msg.getError()) && proto.proto.Error.toObject(includeInstance, f),
      userId: jspb.Message.getFieldWithDefault(msg, 10, 0),
      objectId: jspb.Message.getFieldWithDefault(msg, 11, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Response}
 */
proto.proto.Response.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Response();
  return proto.proto.Response.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Response}
 */
proto.proto.Response.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.proto.Error();
        reader.readMessage(value, proto.proto.Error.deserializeBinaryFromReader);
        msg.setError(value);
        break;
      case 10:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 11:
        var value = /** @type {number} */reader.readUint64();
        msg.setObjectId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Response.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Response.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(1, f, proto.proto.Error.serializeBinaryToWriter);
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(10, f);
  }
  f = message.getObjectId();
  if (f !== 0) {
    writer.writeUint64(11, f);
  }
};

/**
 * optional Error error = 1;
 * @return {?proto.proto.Error}
 */
proto.proto.Response.prototype.getError = function () {
  return (/** @type{?proto.proto.Error} */jspb.Message.getWrapperField(this, proto.proto.Error, 1)
  );
};

/** @param {?proto.proto.Error|undefined} value */
proto.proto.Response.prototype.setError = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.proto.Response.prototype.clearError = function () {
  this.setError(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.Response.prototype.hasError = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional uint64 user_id = 10;
 * @return {number}
 */
proto.proto.Response.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};

/** @param {number} value */
proto.proto.Response.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional uint64 object_id = 11;
 * @return {number}
 */
proto.proto.Response.prototype.getObjectId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 11, 0)
  );
};

/** @param {number} value */
proto.proto.Response.prototype.setObjectId = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Subscribe = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Subscribe, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Subscribe.displayName = 'proto.proto.Subscribe';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.Subscribe.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.Subscribe.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.Subscribe} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.Subscribe.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 10, 0),
      prop: jspb.Message.getFieldWithDefault(msg, 11, 0),
      value: jspb.Message.getFieldWithDefault(msg, 12, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Subscribe}
 */
proto.proto.Subscribe.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Subscribe();
  return proto.proto.Subscribe.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Subscribe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Subscribe}
 */
proto.proto.Subscribe.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 10:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 11:
        var value = /** @type {number} */reader.readUint32();
        msg.setProp(value);
        break;
      case 12:
        var value = /** @type {number} */reader.readUint64();
        msg.setValue(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Subscribe.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.Subscribe.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Subscribe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Subscribe.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(10, f);
  }
  f = message.getProp();
  if (f !== 0) {
    writer.writeUint32(11, f);
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint64(12, f);
  }
};

/**
 * optional uint64 user_id = 10;
 * @return {number}
 */
proto.proto.Subscribe.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};

/** @param {number} value */
proto.proto.Subscribe.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional uint32 prop = 11;
 * @return {number}
 */
proto.proto.Subscribe.prototype.getProp = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 11, 0)
  );
};

/** @param {number} value */
proto.proto.Subscribe.prototype.setProp = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * optional uint64 value = 12;
 * @return {number}
 */
proto.proto.Subscribe.prototype.getValue = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 12, 0)
  );
};

/** @param {number} value */
proto.proto.Subscribe.prototype.setValue = function (value) {
  jspb.Message.setProto3IntField(this, 12, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Remove = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Remove, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Remove.displayName = 'proto.proto.Remove';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.Remove.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.Remove.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.Remove} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.Remove.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 10, 0),
      objectId: jspb.Message.getFieldWithDefault(msg, 11, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Remove}
 */
proto.proto.Remove.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Remove();
  return proto.proto.Remove.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Remove} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Remove}
 */
proto.proto.Remove.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 10:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 11:
        var value = /** @type {number} */reader.readUint64();
        msg.setObjectId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Remove.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.Remove.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Remove} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Remove.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(10, f);
  }
  f = message.getObjectId();
  if (f !== 0) {
    writer.writeUint64(11, f);
  }
};

/**
 * optional uint64 user_id = 10;
 * @return {number}
 */
proto.proto.Remove.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};

/** @param {number} value */
proto.proto.Remove.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional uint64 object_id = 11;
 * @return {number}
 */
proto.proto.Remove.prototype.getObjectId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 11, 0)
  );
};

/** @param {number} value */
proto.proto.Remove.prototype.setObjectId = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Property = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Property, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.Property.displayName = 'proto.proto.Property';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.Property.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.Property.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.Property} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.Property.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 10, 0),
      objectId: jspb.Message.getFieldWithDefault(msg, 11, 0),
      name: jspb.Message.getFieldWithDefault(msg, 12, ""),
      value: jspb.Message.getFieldWithDefault(msg, 13, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Property}
 */
proto.proto.Property.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Property();
  return proto.proto.Property.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Property} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Property}
 */
proto.proto.Property.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 10:
        var value = /** @type {number} */reader.readUint64();
        msg.setUserId(value);
        break;
      case 11:
        var value = /** @type {number} */reader.readUint64();
        msg.setObjectId(value);
        break;
      case 12:
        var value = /** @type {string} */reader.readString();
        msg.setName(value);
        break;
      case 13:
        var value = /** @type {string} */reader.readString();
        msg.setValue(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Property.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.Property.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Property} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Property.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(10, f);
  }
  f = message.getObjectId();
  if (f !== 0) {
    writer.writeUint64(11, f);
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
};

/**
 * optional uint64 user_id = 10;
 * @return {number}
 */
proto.proto.Property.prototype.getUserId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};

/** @param {number} value */
proto.proto.Property.prototype.setUserId = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional uint64 object_id = 11;
 * @return {number}
 */
proto.proto.Property.prototype.getObjectId = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 11, 0)
  );
};

/** @param {number} value */
proto.proto.Property.prototype.setObjectId = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * optional string name = 12;
 * @return {string}
 */
proto.proto.Property.prototype.getName = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 12, "")
  );
};

/** @param {string} value */
proto.proto.Property.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string value = 13;
 * @return {string}
 */
proto.proto.Property.prototype.getValue = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 13, "")
  );
};

/** @param {string} value */
proto.proto.Property.prototype.setValue = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.File = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.File, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.File.displayName = 'proto.proto.File';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.File.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.File.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.File} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.File.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.File}
 */
proto.proto.File.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.File();
  return proto.proto.File.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.File} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.File}
 */
proto.proto.File.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.File.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.File.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.File} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.File.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

goog.object.extend(exports, proto.proto);

/***/ }),

/***/ "zTqT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NumKeyboard',{attrs:{"title":"价格","exclude":_vm.exclude,"value":_vm.orderPrice,"boardPrice":_vm.boardPrice},on:{"input":_vm.onPriceChange,"close":_vm.handleClose}},[_c('template',{slot:"header"},[_c('tr',[_c('th',{on:{"touchstart":function($event){_vm.orderInput(1)}}},[_vm._v("对手价")]),_vm._v(" "),_c('th',{on:{"touchstart":function($event){_vm.orderInput(2)}}},[_vm._v("最新价")]),_vm._v(" "),_c('th',{on:{"touchstart":function($event){_vm.orderInput(3)}}},[_vm._v("市价")]),_vm._v(" "),_c('th',{on:{"touchstart":function($event){_vm.orderInput(4)}}},[_vm._v("超一价")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.68e62dcde090443a16b9.js